var xee = Object.defineProperty;
var bee = (e, t, r) => t in e ? xee(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var wee = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports);
var ft = (e, t, r) => bee(e, typeof t != "symbol" ? t + "" : t, r);
var qTe = wee((eAe, uN) => {
  function fU(e, t) {
    for (var r = 0; r < t.length; r++) {
      const n = t[r];
      if (typeof n != "string" && !Array.isArray(n)) {
        for (const i in n)
          if (i !== "default" && !(i in e)) {
            const u = Object.getOwnPropertyDescriptor(n, i);
            u && Object.defineProperty(e, i, u.get ? u : {
              enumerable: !0,
              get: () => n[i]
            });
          }
      }
    }
    return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
  }
  var Sp = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
  function Zr(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }
  function Eee(e) {
    if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
    var t = e.default;
    if (typeof t == "function") {
      var r = function n() {
        return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
      };
      r.prototype = t.prototype;
    } else r = {};
    return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
      var i = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(r, n, i.get ? i : {
        enumerable: !0,
        get: function() {
          return e[n];
        }
      });
    }), r;
  }
  var Uw = { exports: {} }, tr = {};
  /**
   * @license React
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var q8;
  function See() {
    if (q8) return tr;
    q8 = 1;
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), h = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.iterator;
    function x(z) {
      return z === null || typeof z != "object" ? null : (z = y && z[y] || z["@@iterator"], typeof z == "function" ? z : null);
    }
    var w = { isMounted: function() {
      return !1;
    }, enqueueForceUpdate: function() {
    }, enqueueReplaceState: function() {
    }, enqueueSetState: function() {
    } }, E = Object.assign, C = {};
    function S(z, Y, te) {
      this.props = z, this.context = Y, this.refs = C, this.updater = te || w;
    }
    S.prototype.isReactComponent = {}, S.prototype.setState = function(z, Y) {
      if (typeof z != "object" && typeof z != "function" && z != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
      this.updater.enqueueSetState(this, z, Y, "setState");
    }, S.prototype.forceUpdate = function(z) {
      this.updater.enqueueForceUpdate(this, z, "forceUpdate");
    };
    function k() {
    }
    k.prototype = S.prototype;
    function D(z, Y, te) {
      this.props = z, this.context = Y, this.refs = C, this.updater = te || w;
    }
    var A = D.prototype = new k();
    A.constructor = D, E(A, S.prototype), A.isPureReactComponent = !0;
    var R = Array.isArray, T = Object.prototype.hasOwnProperty, M = { current: null }, F = { key: !0, ref: !0, __self: !0, __source: !0 };
    function B(z, Y, te) {
      var ae, De = {}, ke = null, Re = null;
      if (Y != null) for (ae in Y.ref !== void 0 && (Re = Y.ref), Y.key !== void 0 && (ke = "" + Y.key), Y) T.call(Y, ae) && !F.hasOwnProperty(ae) && (De[ae] = Y[ae]);
      var Te = arguments.length - 2;
      if (Te === 1) De.children = te;
      else if (1 < Te) {
        for (var we = Array(Te), Fe = 0; Fe < Te; Fe++) we[Fe] = arguments[Fe + 2];
        De.children = we;
      }
      if (z && z.defaultProps) for (ae in Te = z.defaultProps, Te) De[ae] === void 0 && (De[ae] = Te[ae]);
      return { $$typeof: e, type: z, key: ke, ref: Re, props: De, _owner: M.current };
    }
    function V(z, Y) {
      return { $$typeof: e, type: z.type, key: Y, ref: z.ref, props: z.props, _owner: z._owner };
    }
    function H(z) {
      return typeof z == "object" && z !== null && z.$$typeof === e;
    }
    function q(z) {
      var Y = { "=": "=0", ":": "=2" };
      return "$" + z.replace(/[=:]/g, function(te) {
        return Y[te];
      });
    }
    var Q = /\/+/g;
    function W(z, Y) {
      return typeof z == "object" && z !== null && z.key != null ? q("" + z.key) : Y.toString(36);
    }
    function J(z, Y, te, ae, De) {
      var ke = typeof z;
      (ke === "undefined" || ke === "boolean") && (z = null);
      var Re = !1;
      if (z === null) Re = !0;
      else switch (ke) {
        case "string":
        case "number":
          Re = !0;
          break;
        case "object":
          switch (z.$$typeof) {
            case e:
            case t:
              Re = !0;
          }
      }
      if (Re) return Re = z, De = De(Re), z = ae === "" ? "." + W(Re, 0) : ae, R(De) ? (te = "", z != null && (te = z.replace(Q, "$&/") + "/"), J(De, Y, te, "", function(Fe) {
        return Fe;
      })) : De != null && (H(De) && (De = V(De, te + (!De.key || Re && Re.key === De.key ? "" : ("" + De.key).replace(Q, "$&/") + "/") + z)), Y.push(De)), 1;
      if (Re = 0, ae = ae === "" ? "." : ae + ":", R(z)) for (var Te = 0; Te < z.length; Te++) {
        ke = z[Te];
        var we = ae + W(ke, Te);
        Re += J(ke, Y, te, we, De);
      }
      else if (we = x(z), typeof we == "function") for (z = we.call(z), Te = 0; !(ke = z.next()).done; ) ke = ke.value, we = ae + W(ke, Te++), Re += J(ke, Y, te, we, De);
      else if (ke === "object") throw Y = String(z), Error("Objects are not valid as a React child (found: " + (Y === "[object Object]" ? "object with keys {" + Object.keys(z).join(", ") + "}" : Y) + "). If you meant to render a collection of children, use an array instead.");
      return Re;
    }
    function ne(z, Y, te) {
      if (z == null) return z;
      var ae = [], De = 0;
      return J(z, ae, "", "", function(ke) {
        return Y.call(te, ke, De++);
      }), ae;
    }
    function ie(z) {
      if (z._status === -1) {
        var Y = z._result;
        Y = Y(), Y.then(function(te) {
          (z._status === 0 || z._status === -1) && (z._status = 1, z._result = te);
        }, function(te) {
          (z._status === 0 || z._status === -1) && (z._status = 2, z._result = te);
        }), z._status === -1 && (z._status = 0, z._result = Y);
      }
      if (z._status === 1) return z._result.default;
      throw z._result;
    }
    var se = { current: null }, X = { transition: null }, fe = { ReactCurrentDispatcher: se, ReactCurrentBatchConfig: X, ReactCurrentOwner: M };
    function Z() {
      throw Error("act(...) is not supported in production builds of React.");
    }
    return tr.Children = { map: ne, forEach: function(z, Y, te) {
      ne(z, function() {
        Y.apply(this, arguments);
      }, te);
    }, count: function(z) {
      var Y = 0;
      return ne(z, function() {
        Y++;
      }), Y;
    }, toArray: function(z) {
      return ne(z, function(Y) {
        return Y;
      }) || [];
    }, only: function(z) {
      if (!H(z)) throw Error("React.Children.only expected to receive a single React element child.");
      return z;
    } }, tr.Component = S, tr.Fragment = r, tr.Profiler = i, tr.PureComponent = D, tr.StrictMode = n, tr.Suspense = p, tr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = fe, tr.act = Z, tr.cloneElement = function(z, Y, te) {
      if (z == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + z + ".");
      var ae = E({}, z.props), De = z.key, ke = z.ref, Re = z._owner;
      if (Y != null) {
        if (Y.ref !== void 0 && (ke = Y.ref, Re = M.current), Y.key !== void 0 && (De = "" + Y.key), z.type && z.type.defaultProps) var Te = z.type.defaultProps;
        for (we in Y) T.call(Y, we) && !F.hasOwnProperty(we) && (ae[we] = Y[we] === void 0 && Te !== void 0 ? Te[we] : Y[we]);
      }
      var we = arguments.length - 2;
      if (we === 1) ae.children = te;
      else if (1 < we) {
        Te = Array(we);
        for (var Fe = 0; Fe < we; Fe++) Te[Fe] = arguments[Fe + 2];
        ae.children = Te;
      }
      return { $$typeof: e, type: z.type, key: De, ref: ke, props: ae, _owner: Re };
    }, tr.createContext = function(z) {
      return z = { $$typeof: s, _currentValue: z, _currentValue2: z, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, z.Provider = { $$typeof: u, _context: z }, z.Consumer = z;
    }, tr.createElement = B, tr.createFactory = function(z) {
      var Y = B.bind(null, z);
      return Y.type = z, Y;
    }, tr.createRef = function() {
      return { current: null };
    }, tr.forwardRef = function(z) {
      return { $$typeof: c, render: z };
    }, tr.isValidElement = H, tr.lazy = function(z) {
      return { $$typeof: v, _payload: { _status: -1, _result: z }, _init: ie };
    }, tr.memo = function(z, Y) {
      return { $$typeof: h, type: z, compare: Y === void 0 ? null : Y };
    }, tr.startTransition = function(z) {
      var Y = X.transition;
      X.transition = {};
      try {
        z();
      } finally {
        X.transition = Y;
      }
    }, tr.unstable_act = Z, tr.useCallback = function(z, Y) {
      return se.current.useCallback(z, Y);
    }, tr.useContext = function(z) {
      return se.current.useContext(z);
    }, tr.useDebugValue = function() {
    }, tr.useDeferredValue = function(z) {
      return se.current.useDeferredValue(z);
    }, tr.useEffect = function(z, Y) {
      return se.current.useEffect(z, Y);
    }, tr.useId = function() {
      return se.current.useId();
    }, tr.useImperativeHandle = function(z, Y, te) {
      return se.current.useImperativeHandle(z, Y, te);
    }, tr.useInsertionEffect = function(z, Y) {
      return se.current.useInsertionEffect(z, Y);
    }, tr.useLayoutEffect = function(z, Y) {
      return se.current.useLayoutEffect(z, Y);
    }, tr.useMemo = function(z, Y) {
      return se.current.useMemo(z, Y);
    }, tr.useReducer = function(z, Y, te) {
      return se.current.useReducer(z, Y, te);
    }, tr.useRef = function(z) {
      return se.current.useRef(z);
    }, tr.useState = function(z) {
      return se.current.useState(z);
    }, tr.useSyncExternalStore = function(z, Y, te) {
      return se.current.useSyncExternalStore(z, Y, te);
    }, tr.useTransition = function() {
      return se.current.useTransition();
    }, tr.version = "18.3.1", tr;
  }
  var Ag = { exports: {} };
  /**
   * @license React
   * react.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  Ag.exports;
  var U8;
  function _ee() {
    return U8 || (U8 = 1, function(e, t) {
      process.env.NODE_ENV !== "production" && function() {
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
        var r = "18.3.1", n = Symbol.for("react.element"), i = Symbol.for("react.portal"), u = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), p = Symbol.for("react.provider"), h = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), x = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), C = Symbol.for("react.offscreen"), S = Symbol.iterator, k = "@@iterator";
        function D($) {
          if ($ === null || typeof $ != "object")
            return null;
          var oe = S && $[S] || $[k];
          return typeof oe == "function" ? oe : null;
        }
        var A = {
          /**
           * @internal
           * @type {ReactComponent}
           */
          current: null
        }, R = {
          transition: null
        }, T = {
          current: null,
          // Used to reproduce behavior of `batchedUpdates` in legacy mode.
          isBatchingLegacy: !1,
          didScheduleLegacyUpdate: !1
        }, M = {
          /**
           * @internal
           * @type {ReactComponent}
           */
          current: null
        }, F = {}, B = null;
        function V($) {
          B = $;
        }
        F.setExtraStackFrame = function($) {
          B = $;
        }, F.getCurrentStack = null, F.getStackAddendum = function() {
          var $ = "";
          B && ($ += B);
          var oe = F.getCurrentStack;
          return oe && ($ += oe() || ""), $;
        };
        var H = !1, q = !1, Q = !1, W = !1, J = !1, ne = {
          ReactCurrentDispatcher: A,
          ReactCurrentBatchConfig: R,
          ReactCurrentOwner: M
        };
        ne.ReactDebugCurrentFrame = F, ne.ReactCurrentActQueue = T;
        function ie($) {
          {
            for (var oe = arguments.length, _e = new Array(oe > 1 ? oe - 1 : 0), Ae = 1; Ae < oe; Ae++)
              _e[Ae - 1] = arguments[Ae];
            X("warn", $, _e);
          }
        }
        function se($) {
          {
            for (var oe = arguments.length, _e = new Array(oe > 1 ? oe - 1 : 0), Ae = 1; Ae < oe; Ae++)
              _e[Ae - 1] = arguments[Ae];
            X("error", $, _e);
          }
        }
        function X($, oe, _e) {
          {
            var Ae = ne.ReactDebugCurrentFrame, We = Ae.getStackAddendum();
            We !== "" && (oe += "%s", _e = _e.concat([We]));
            var _t = _e.map(function(Xe) {
              return String(Xe);
            });
            _t.unshift("Warning: " + oe), Function.prototype.apply.call(console[$], console, _t);
          }
        }
        var fe = {};
        function Z($, oe) {
          {
            var _e = $.constructor, Ae = _e && (_e.displayName || _e.name) || "ReactClass", We = Ae + "." + oe;
            if (fe[We])
              return;
            se("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", oe, Ae), fe[We] = !0;
          }
        }
        var z = {
          /**
           * Checks whether or not this composite component is mounted.
           * @param {ReactClass} publicInstance The instance we want to test.
           * @return {boolean} True if mounted, false otherwise.
           * @protected
           * @final
           */
          isMounted: function($) {
            return !1;
          },
          /**
           * Forces an update. This should only be invoked when it is known with
           * certainty that we are **not** in a DOM transaction.
           *
           * You may want to call this when you know that some deeper aspect of the
           * component's state has changed but `setState` was not called.
           *
           * This will not invoke `shouldComponentUpdate`, but it will invoke
           * `componentWillUpdate` and `componentDidUpdate`.
           *
           * @param {ReactClass} publicInstance The instance that should rerender.
           * @param {?function} callback Called after component is updated.
           * @param {?string} callerName name of the calling function in the public API.
           * @internal
           */
          enqueueForceUpdate: function($, oe, _e) {
            Z($, "forceUpdate");
          },
          /**
           * Replaces all of the state. Always use this or `setState` to mutate state.
           * You should treat `this.state` as immutable.
           *
           * There is no guarantee that `this.state` will be immediately updated, so
           * accessing `this.state` after calling this method may return the old value.
           *
           * @param {ReactClass} publicInstance The instance that should rerender.
           * @param {object} completeState Next state.
           * @param {?function} callback Called after component is updated.
           * @param {?string} callerName name of the calling function in the public API.
           * @internal
           */
          enqueueReplaceState: function($, oe, _e, Ae) {
            Z($, "replaceState");
          },
          /**
           * Sets a subset of the state. This only exists because _pendingState is
           * internal. This provides a merging strategy that is not available to deep
           * properties which is confusing. TODO: Expose pendingState or don't use it
           * during the merge.
           *
           * @param {ReactClass} publicInstance The instance that should rerender.
           * @param {object} partialState Next partial state to be merged with state.
           * @param {?function} callback Called after component is updated.
           * @param {?string} Name of the calling function in the public API.
           * @internal
           */
          enqueueSetState: function($, oe, _e, Ae) {
            Z($, "setState");
          }
        }, Y = Object.assign, te = {};
        Object.freeze(te);
        function ae($, oe, _e) {
          this.props = $, this.context = oe, this.refs = te, this.updater = _e || z;
        }
        ae.prototype.isReactComponent = {}, ae.prototype.setState = function($, oe) {
          if (typeof $ != "object" && typeof $ != "function" && $ != null)
            throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
          this.updater.enqueueSetState(this, $, oe, "setState");
        }, ae.prototype.forceUpdate = function($) {
          this.updater.enqueueForceUpdate(this, $, "forceUpdate");
        };
        {
          var De = {
            isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
            replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
          }, ke = function($, oe) {
            Object.defineProperty(ae.prototype, $, {
              get: function() {
                ie("%s(...) is deprecated in plain JavaScript React classes. %s", oe[0], oe[1]);
              }
            });
          };
          for (var Re in De)
            De.hasOwnProperty(Re) && ke(Re, De[Re]);
        }
        function Te() {
        }
        Te.prototype = ae.prototype;
        function we($, oe, _e) {
          this.props = $, this.context = oe, this.refs = te, this.updater = _e || z;
        }
        var Fe = we.prototype = new Te();
        Fe.constructor = we, Y(Fe, ae.prototype), Fe.isPureReactComponent = !0;
        function Ye() {
          var $ = {
            current: null
          };
          return Object.seal($), $;
        }
        var de = Array.isArray;
        function Ze($) {
          return de($);
        }
        function Ne($) {
          {
            var oe = typeof Symbol == "function" && Symbol.toStringTag, _e = oe && $[Symbol.toStringTag] || $.constructor.name || "Object";
            return _e;
          }
        }
        function Ot($) {
          try {
            return At($), !1;
          } catch {
            return !0;
          }
        }
        function At($) {
          return "" + $;
        }
        function Qt($) {
          if (Ot($))
            return se("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ne($)), At($);
        }
        function Wr($, oe, _e) {
          var Ae = $.displayName;
          if (Ae)
            return Ae;
          var We = oe.displayName || oe.name || "";
          return We !== "" ? _e + "(" + We + ")" : _e;
        }
        function Ar($) {
          return $.displayName || "Context";
        }
        function Dr($) {
          if ($ == null)
            return null;
          if (typeof $.tag == "number" && se("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof $ == "function")
            return $.displayName || $.name || null;
          if (typeof $ == "string")
            return $;
          switch ($) {
            case u:
              return "Fragment";
            case i:
              return "Portal";
            case c:
              return "Profiler";
            case s:
              return "StrictMode";
            case y:
              return "Suspense";
            case x:
              return "SuspenseList";
          }
          if (typeof $ == "object")
            switch ($.$$typeof) {
              case h:
                var oe = $;
                return Ar(oe) + ".Consumer";
              case p:
                var _e = $;
                return Ar(_e._context) + ".Provider";
              case v:
                return Wr($, $.render, "ForwardRef");
              case w:
                var Ae = $.displayName || null;
                return Ae !== null ? Ae : Dr($.type) || "Memo";
              case E: {
                var We = $, _t = We._payload, Xe = We._init;
                try {
                  return Dr(Xe(_t));
                } catch {
                  return null;
                }
              }
            }
          return null;
        }
        var Vt = Object.prototype.hasOwnProperty, Ut = {
          key: !0,
          ref: !0,
          __self: !0,
          __source: !0
        }, kr, Pn, Yr;
        Yr = {};
        function Jr($) {
          if (Vt.call($, "ref")) {
            var oe = Object.getOwnPropertyDescriptor($, "ref").get;
            if (oe && oe.isReactWarning)
              return !1;
          }
          return $.ref !== void 0;
        }
        function xn($) {
          if (Vt.call($, "key")) {
            var oe = Object.getOwnPropertyDescriptor($, "key").get;
            if (oe && oe.isReactWarning)
              return !1;
          }
          return $.key !== void 0;
        }
        function ka($, oe) {
          var _e = function() {
            kr || (kr = !0, se("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", oe));
          };
          _e.isReactWarning = !0, Object.defineProperty($, "key", {
            get: _e,
            configurable: !0
          });
        }
        function Ra($, oe) {
          var _e = function() {
            Pn || (Pn = !0, se("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", oe));
          };
          _e.isReactWarning = !0, Object.defineProperty($, "ref", {
            get: _e,
            configurable: !0
          });
        }
        function Ge($) {
          if (typeof $.ref == "string" && M.current && $.__self && M.current.stateNode !== $.__self) {
            var oe = Dr(M.current.type);
            Yr[oe] || (se('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', oe, $.ref), Yr[oe] = !0);
          }
        }
        var ct = function($, oe, _e, Ae, We, _t, Xe) {
          var Dt = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: n,
            // Built-in properties that belong on the element
            type: $,
            key: oe,
            ref: _e,
            props: Xe,
            // Record the component responsible for creating this element.
            _owner: _t
          };
          return Dt._store = {}, Object.defineProperty(Dt._store, "validated", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: !1
          }), Object.defineProperty(Dt, "_self", {
            configurable: !1,
            enumerable: !1,
            writable: !1,
            value: Ae
          }), Object.defineProperty(Dt, "_source", {
            configurable: !1,
            enumerable: !1,
            writable: !1,
            value: We
          }), Object.freeze && (Object.freeze(Dt.props), Object.freeze(Dt)), Dt;
        };
        function jt($, oe, _e) {
          var Ae, We = {}, _t = null, Xe = null, Dt = null, Xt = null;
          if (oe != null) {
            Jr(oe) && (Xe = oe.ref, Ge(oe)), xn(oe) && (Qt(oe.key), _t = "" + oe.key), Dt = oe.__self === void 0 ? null : oe.__self, Xt = oe.__source === void 0 ? null : oe.__source;
            for (Ae in oe)
              Vt.call(oe, Ae) && !Ut.hasOwnProperty(Ae) && (We[Ae] = oe[Ae]);
          }
          var ur = arguments.length - 2;
          if (ur === 1)
            We.children = _e;
          else if (ur > 1) {
            for (var rn = Array(ur), jr = 0; jr < ur; jr++)
              rn[jr] = arguments[jr + 2];
            Object.freeze && Object.freeze(rn), We.children = rn;
          }
          if ($ && $.defaultProps) {
            var Wt = $.defaultProps;
            for (Ae in Wt)
              We[Ae] === void 0 && (We[Ae] = Wt[Ae]);
          }
          if (_t || Xe) {
            var Fr = typeof $ == "function" ? $.displayName || $.name || "Unknown" : $;
            _t && ka(We, Fr), Xe && Ra(We, Fr);
          }
          return ct($, _t, Xe, Dt, Xt, M.current, We);
        }
        function cr($, oe) {
          var _e = ct($.type, oe, $.ref, $._self, $._source, $._owner, $.props);
          return _e;
        }
        function Rr($, oe, _e) {
          if ($ == null)
            throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + $ + ".");
          var Ae, We = Y({}, $.props), _t = $.key, Xe = $.ref, Dt = $._self, Xt = $._source, ur = $._owner;
          if (oe != null) {
            Jr(oe) && (Xe = oe.ref, ur = M.current), xn(oe) && (Qt(oe.key), _t = "" + oe.key);
            var rn;
            $.type && $.type.defaultProps && (rn = $.type.defaultProps);
            for (Ae in oe)
              Vt.call(oe, Ae) && !Ut.hasOwnProperty(Ae) && (oe[Ae] === void 0 && rn !== void 0 ? We[Ae] = rn[Ae] : We[Ae] = oe[Ae]);
          }
          var jr = arguments.length - 2;
          if (jr === 1)
            We.children = _e;
          else if (jr > 1) {
            for (var Wt = Array(jr), Fr = 0; Fr < jr; Fr++)
              Wt[Fr] = arguments[Fr + 2];
            We.children = Wt;
          }
          return ct($.type, _t, Xe, Dt, Xt, ur, We);
        }
        function en($) {
          return typeof $ == "object" && $ !== null && $.$$typeof === n;
        }
        var Gr = ".", Mn = ":";
        function Pr($) {
          var oe = /[=:]/g, _e = {
            "=": "=0",
            ":": "=2"
          }, Ae = $.replace(oe, function(We) {
            return _e[We];
          });
          return "$" + Ae;
        }
        var _r = !1, Er = /\/+/g;
        function $i($) {
          return $.replace(Er, "$&/");
        }
        function Yn($, oe) {
          return typeof $ == "object" && $ !== null && $.key != null ? (Qt($.key), Pr("" + $.key)) : oe.toString(36);
        }
        function ua($, oe, _e, Ae, We) {
          var _t = typeof $;
          (_t === "undefined" || _t === "boolean") && ($ = null);
          var Xe = !1;
          if ($ === null)
            Xe = !0;
          else
            switch (_t) {
              case "string":
              case "number":
                Xe = !0;
                break;
              case "object":
                switch ($.$$typeof) {
                  case n:
                  case i:
                    Xe = !0;
                }
            }
          if (Xe) {
            var Dt = $, Xt = We(Dt), ur = Ae === "" ? Gr + Yn(Dt, 0) : Ae;
            if (Ze(Xt)) {
              var rn = "";
              ur != null && (rn = $i(ur) + "/"), ua(Xt, oe, rn, "", function(um) {
                return um;
              });
            } else Xt != null && (en(Xt) && (Xt.key && (!Dt || Dt.key !== Xt.key) && Qt(Xt.key), Xt = cr(
              Xt,
              // Keep both the (mapped) and old keys if they differ, just as
              // traverseAllChildren used to do for objects as children
              _e + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
              (Xt.key && (!Dt || Dt.key !== Xt.key) ? (
                // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
                // eslint-disable-next-line react-internal/safe-string-coercion
                $i("" + Xt.key) + "/"
              ) : "") + ur
            )), oe.push(Xt));
            return 1;
          }
          var jr, Wt, Fr = 0, hn = Ae === "" ? Gr : Ae + Mn;
          if (Ze($))
            for (var Os = 0; Os < $.length; Os++)
              jr = $[Os], Wt = hn + Yn(jr, Os), Fr += ua(jr, oe, _e, Wt, We);
          else {
            var id = D($);
            if (typeof id == "function") {
              var Pu = $;
              id === Pu.entries && (_r || ie("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), _r = !0);
              for (var ad = id.call(Pu), El, om = 0; !(El = ad.next()).done; )
                jr = El.value, Wt = hn + Yn(jr, om++), Fr += ua(jr, oe, _e, Wt, We);
            } else if (_t === "object") {
              var Kp = String($);
              throw new Error("Objects are not valid as a React child (found: " + (Kp === "[object Object]" ? "object with keys {" + Object.keys($).join(", ") + "}" : Kp) + "). If you meant to render a collection of children, use an array instead.");
            }
          }
          return Fr;
        }
        function bo($, oe, _e) {
          if ($ == null)
            return $;
          var Ae = [], We = 0;
          return ua($, Ae, "", "", function(_t) {
            return oe.call(_e, _t, We++);
          }), Ae;
        }
        function Du($) {
          var oe = 0;
          return bo($, function() {
            oe++;
          }), oe;
        }
        function Vo($, oe, _e) {
          bo($, function() {
            oe.apply(this, arguments);
          }, _e);
        }
        function Wo($) {
          return bo($, function(oe) {
            return oe;
          }) || [];
        }
        function Yo($) {
          if (!en($))
            throw new Error("React.Children.only expected to receive a single React element child.");
          return $;
        }
        function Go($) {
          var oe = {
            $$typeof: h,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: $,
            _currentValue2: $,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null,
            // Add these to use same hidden class in VM as ServerContext
            _defaultValue: null,
            _globalName: null
          };
          oe.Provider = {
            $$typeof: p,
            _context: oe
          };
          var _e = !1, Ae = !1, We = !1;
          {
            var _t = {
              $$typeof: h,
              _context: oe
            };
            Object.defineProperties(_t, {
              Provider: {
                get: function() {
                  return Ae || (Ae = !0, se("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), oe.Provider;
                },
                set: function(Xe) {
                  oe.Provider = Xe;
                }
              },
              _currentValue: {
                get: function() {
                  return oe._currentValue;
                },
                set: function(Xe) {
                  oe._currentValue = Xe;
                }
              },
              _currentValue2: {
                get: function() {
                  return oe._currentValue2;
                },
                set: function(Xe) {
                  oe._currentValue2 = Xe;
                }
              },
              _threadCount: {
                get: function() {
                  return oe._threadCount;
                },
                set: function(Xe) {
                  oe._threadCount = Xe;
                }
              },
              Consumer: {
                get: function() {
                  return _e || (_e = !0, se("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), oe.Consumer;
                }
              },
              displayName: {
                get: function() {
                  return oe.displayName;
                },
                set: function(Xe) {
                  We || (ie("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", Xe), We = !0);
                }
              }
            }), oe.Consumer = _t;
          }
          return oe._currentRenderer = null, oe._currentRenderer2 = null, oe;
        }
        var pi = -1, ni = 0, Sr = 1, Gn = 2;
        function sa($) {
          if ($._status === pi) {
            var oe = $._result, _e = oe();
            if (_e.then(function(_t) {
              if ($._status === ni || $._status === pi) {
                var Xe = $;
                Xe._status = Sr, Xe._result = _t;
              }
            }, function(_t) {
              if ($._status === ni || $._status === pi) {
                var Xe = $;
                Xe._status = Gn, Xe._result = _t;
              }
            }), $._status === pi) {
              var Ae = $;
              Ae._status = ni, Ae._result = _e;
            }
          }
          if ($._status === Sr) {
            var We = $._result;
            return We === void 0 && se(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, We), "default" in We || se(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, We), We.default;
          } else
            throw $._result;
        }
        function Qa($) {
          var oe = {
            // We use these fields to store the result.
            _status: pi,
            _result: $
          }, _e = {
            $$typeof: E,
            _payload: oe,
            _init: sa
          };
          {
            var Ae, We;
            Object.defineProperties(_e, {
              defaultProps: {
                configurable: !0,
                get: function() {
                  return Ae;
                },
                set: function(_t) {
                  se("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), Ae = _t, Object.defineProperty(_e, "defaultProps", {
                    enumerable: !0
                  });
                }
              },
              propTypes: {
                configurable: !0,
                get: function() {
                  return We;
                },
                set: function(_t) {
                  se("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), We = _t, Object.defineProperty(_e, "propTypes", {
                    enumerable: !0
                  });
                }
              }
            });
          }
          return _e;
        }
        function Qo($) {
          $ != null && $.$$typeof === w ? se("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof $ != "function" ? se("forwardRef requires a render function but was given %s.", $ === null ? "null" : typeof $) : $.length !== 0 && $.length !== 2 && se("forwardRef render functions accept exactly two parameters: props and ref. %s", $.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), $ != null && ($.defaultProps != null || $.propTypes != null) && se("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
          var oe = {
            $$typeof: v,
            render: $
          };
          {
            var _e;
            Object.defineProperty(oe, "displayName", {
              enumerable: !1,
              configurable: !0,
              get: function() {
                return _e;
              },
              set: function(Ae) {
                _e = Ae, !$.name && !$.displayName && ($.displayName = Ae);
              }
            });
          }
          return oe;
        }
        var ue;
        ue = Symbol.for("react.module.reference");
        function Le($) {
          return !!(typeof $ == "string" || typeof $ == "function" || $ === u || $ === c || J || $ === s || $ === y || $ === x || W || $ === C || H || q || Q || typeof $ == "object" && $ !== null && ($.$$typeof === E || $.$$typeof === w || $.$$typeof === p || $.$$typeof === h || $.$$typeof === v || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          $.$$typeof === ue || $.getModuleId !== void 0));
        }
        function Je($, oe) {
          Le($) || se("memo: The first argument must be a component. Instead received: %s", $ === null ? "null" : typeof $);
          var _e = {
            $$typeof: w,
            type: $,
            compare: oe === void 0 ? null : oe
          };
          {
            var Ae;
            Object.defineProperty(_e, "displayName", {
              enumerable: !1,
              configurable: !0,
              get: function() {
                return Ae;
              },
              set: function(We) {
                Ae = We, !$.name && !$.displayName && ($.displayName = We);
              }
            });
          }
          return _e;
        }
        function lt() {
          var $ = A.current;
          return $ === null && se(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), $;
        }
        function $t($) {
          var oe = lt();
          if ($._context !== void 0) {
            var _e = $._context;
            _e.Consumer === $ ? se("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : _e.Provider === $ && se("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
          }
          return oe.useContext($);
        }
        function It($) {
          var oe = lt();
          return oe.useState($);
        }
        function Kt($, oe, _e) {
          var Ae = lt();
          return Ae.useReducer($, oe, _e);
        }
        function Yt($) {
          var oe = lt();
          return oe.useRef($);
        }
        function En($, oe) {
          var _e = lt();
          return _e.useEffect($, oe);
        }
        function tn($, oe) {
          var _e = lt();
          return _e.useInsertionEffect($, oe);
        }
        function on($, oe) {
          var _e = lt();
          return _e.useLayoutEffect($, oe);
        }
        function hi($, oe) {
          var _e = lt();
          return _e.useCallback($, oe);
        }
        function wo($, oe) {
          var _e = lt();
          return _e.useMemo($, oe);
        }
        function Eo($, oe, _e) {
          var Ae = lt();
          return Ae.useImperativeHandle($, oe, _e);
        }
        function zt($, oe) {
          {
            var _e = lt();
            return _e.useDebugValue($, oe);
          }
        }
        function Ht() {
          var $ = lt();
          return $.useTransition();
        }
        function So($) {
          var oe = lt();
          return oe.useDeferredValue($);
        }
        function ml() {
          var $ = lt();
          return $.useId();
        }
        function yl($, oe, _e) {
          var Ae = lt();
          return Ae.useSyncExternalStore($, oe, _e);
        }
        var xs = 0, Dc, bs, la, ed, zi, Gp, Qp;
        function kc() {
        }
        kc.__reactDisabledLog = !0;
        function ws() {
          {
            if (xs === 0) {
              Dc = console.log, bs = console.info, la = console.warn, ed = console.error, zi = console.group, Gp = console.groupCollapsed, Qp = console.groupEnd;
              var $ = {
                configurable: !0,
                enumerable: !0,
                value: kc,
                writable: !0
              };
              Object.defineProperties(console, {
                info: $,
                log: $,
                warn: $,
                error: $,
                group: $,
                groupCollapsed: $,
                groupEnd: $
              });
            }
            xs++;
          }
        }
        function Pa() {
          {
            if (xs--, xs === 0) {
              var $ = {
                configurable: !0,
                enumerable: !0,
                writable: !0
              };
              Object.defineProperties(console, {
                log: Y({}, $, {
                  value: Dc
                }),
                info: Y({}, $, {
                  value: bs
                }),
                warn: Y({}, $, {
                  value: la
                }),
                error: Y({}, $, {
                  value: ed
                }),
                group: Y({}, $, {
                  value: zi
                }),
                groupCollapsed: Y({}, $, {
                  value: Gp
                }),
                groupEnd: Y({}, $, {
                  value: Qp
                })
              });
            }
            xs < 0 && se("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
        var _o = ne.ReactCurrentDispatcher, Co;
        function Rc($, oe, _e) {
          {
            if (Co === void 0)
              try {
                throw Error();
              } catch (We) {
                var Ae = We.stack.trim().match(/\n( *(at )?)/);
                Co = Ae && Ae[1] || "";
              }
            return `
` + Co + $;
          }
        }
        var gl = !1, Es;
        {
          var Pc = typeof WeakMap == "function" ? WeakMap : Map;
          Es = new Pc();
        }
        function Mc($, oe) {
          if (!$ || gl)
            return "";
          {
            var _e = Es.get($);
            if (_e !== void 0)
              return _e;
          }
          var Ae;
          gl = !0;
          var We = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          var _t;
          _t = _o.current, _o.current = null, ws();
          try {
            if (oe) {
              var Xe = function() {
                throw Error();
              };
              if (Object.defineProperty(Xe.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(Xe, []);
                } catch (hn) {
                  Ae = hn;
                }
                Reflect.construct($, [], Xe);
              } else {
                try {
                  Xe.call();
                } catch (hn) {
                  Ae = hn;
                }
                $.call(Xe.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (hn) {
                Ae = hn;
              }
              $();
            }
          } catch (hn) {
            if (hn && Ae && typeof hn.stack == "string") {
              for (var Dt = hn.stack.split(`
`), Xt = Ae.stack.split(`
`), ur = Dt.length - 1, rn = Xt.length - 1; ur >= 1 && rn >= 0 && Dt[ur] !== Xt[rn]; )
                rn--;
              for (; ur >= 1 && rn >= 0; ur--, rn--)
                if (Dt[ur] !== Xt[rn]) {
                  if (ur !== 1 || rn !== 1)
                    do
                      if (ur--, rn--, rn < 0 || Dt[ur] !== Xt[rn]) {
                        var jr = `
` + Dt[ur].replace(" at new ", " at ");
                        return $.displayName && jr.includes("<anonymous>") && (jr = jr.replace("<anonymous>", $.displayName)), typeof $ == "function" && Es.set($, jr), jr;
                      }
                    while (ur >= 1 && rn >= 0);
                  break;
                }
            }
          } finally {
            gl = !1, _o.current = _t, Pa(), Error.prepareStackTrace = We;
          }
          var Wt = $ ? $.displayName || $.name : "", Fr = Wt ? Rc(Wt) : "";
          return typeof $ == "function" && Es.set($, Fr), Fr;
        }
        function ku($, oe, _e) {
          return Mc($, !1);
        }
        function im($) {
          var oe = $.prototype;
          return !!(oe && oe.isReactComponent);
        }
        function Ru($, oe, _e) {
          if ($ == null)
            return "";
          if (typeof $ == "function")
            return Mc($, im($));
          if (typeof $ == "string")
            return Rc($);
          switch ($) {
            case y:
              return Rc("Suspense");
            case x:
              return Rc("SuspenseList");
          }
          if (typeof $ == "object")
            switch ($.$$typeof) {
              case v:
                return ku($.render);
              case w:
                return Ru($.type, oe, _e);
              case E: {
                var Ae = $, We = Ae._payload, _t = Ae._init;
                try {
                  return Ru(_t(We), oe, _e);
                } catch {
                }
              }
            }
          return "";
        }
        var mr = {}, Nc = ne.ReactDebugCurrentFrame;
        function or($) {
          if ($) {
            var oe = $._owner, _e = Ru($.type, $._source, oe ? oe.type : null);
            Nc.setExtraStackFrame(_e);
          } else
            Nc.setExtraStackFrame(null);
        }
        function td($, oe, _e, Ae, We) {
          {
            var _t = Function.call.bind(Vt);
            for (var Xe in $)
              if (_t($, Xe)) {
                var Dt = void 0;
                try {
                  if (typeof $[Xe] != "function") {
                    var Xt = Error((Ae || "React class") + ": " + _e + " type `" + Xe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof $[Xe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    throw Xt.name = "Invariant Violation", Xt;
                  }
                  Dt = $[Xe](oe, Xe, Ae, _e, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
                } catch (ur) {
                  Dt = ur;
                }
                Dt && !(Dt instanceof Error) && (or(We), se("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ae || "React class", _e, Xe, typeof Dt), or(null)), Dt instanceof Error && !(Dt.message in mr) && (mr[Dt.message] = !0, or(We), se("Failed %s type: %s", _e, Dt.message), or(null));
              }
          }
        }
        function Ko($) {
          if ($) {
            var oe = $._owner, _e = Ru($.type, $._source, oe ? oe.type : null);
            V(_e);
          } else
            V(null);
        }
        var Ft;
        Ft = !1;
        function jc() {
          if (M.current) {
            var $ = Dr(M.current.type);
            if ($)
              return `

Check the render method of \`` + $ + "`.";
          }
          return "";
        }
        function vi($) {
          if ($ !== void 0) {
            var oe = $.fileName.replace(/^.*[\\\/]/, ""), _e = $.lineNumber;
            return `

Check your code at ` + oe + ":" + _e + ".";
          }
          return "";
        }
        function Xo($) {
          return $ != null ? vi($.__source) : "";
        }
        var qi = {};
        function Zo($) {
          var oe = jc();
          if (!oe) {
            var _e = typeof $ == "string" ? $ : $.displayName || $.name;
            _e && (oe = `

Check the top-level render call using <` + _e + ">.");
          }
          return oe;
        }
        function un($, oe) {
          if (!(!$._store || $._store.validated || $.key != null)) {
            $._store.validated = !0;
            var _e = Zo(oe);
            if (!qi[_e]) {
              qi[_e] = !0;
              var Ae = "";
              $ && $._owner && $._owner !== M.current && (Ae = " It was passed a child from " + Dr($._owner.type) + "."), Ko($), se('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', _e, Ae), Ko(null);
            }
          }
        }
        function Nr($, oe) {
          if (typeof $ == "object") {
            if (Ze($))
              for (var _e = 0; _e < $.length; _e++) {
                var Ae = $[_e];
                en(Ae) && un(Ae, oe);
              }
            else if (en($))
              $._store && ($._store.validated = !0);
            else if ($) {
              var We = D($);
              if (typeof We == "function" && We !== $.entries)
                for (var _t = We.call($), Xe; !(Xe = _t.next()).done; )
                  en(Xe.value) && un(Xe.value, oe);
            }
          }
        }
        function Ss($) {
          {
            var oe = $.type;
            if (oe == null || typeof oe == "string")
              return;
            var _e;
            if (typeof oe == "function")
              _e = oe.propTypes;
            else if (typeof oe == "object" && (oe.$$typeof === v || // Note: Memo only checks outer props here.
            // Inner props are checked in the reconciler.
            oe.$$typeof === w))
              _e = oe.propTypes;
            else
              return;
            if (_e) {
              var Ae = Dr(oe);
              td(_e, $.props, "prop", Ae, $);
            } else if (oe.PropTypes !== void 0 && !Ft) {
              Ft = !0;
              var We = Dr(oe);
              se("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", We || "Unknown");
            }
            typeof oe.getDefaultProps == "function" && !oe.getDefaultProps.isReactClassApproved && se("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
        function Qn($) {
          {
            for (var oe = Object.keys($.props), _e = 0; _e < oe.length; _e++) {
              var Ae = oe[_e];
              if (Ae !== "children" && Ae !== "key") {
                Ko($), se("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ae), Ko(null);
                break;
              }
            }
            $.ref !== null && (Ko($), se("Invalid attribute `ref` supplied to `React.Fragment`."), Ko(null));
          }
        }
        function Ui($, oe, _e) {
          var Ae = Le($);
          if (!Ae) {
            var We = "";
            ($ === void 0 || typeof $ == "object" && $ !== null && Object.keys($).length === 0) && (We += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var _t = Xo(oe);
            _t ? We += _t : We += jc();
            var Xe;
            $ === null ? Xe = "null" : Ze($) ? Xe = "array" : $ !== void 0 && $.$$typeof === n ? (Xe = "<" + (Dr($.type) || "Unknown") + " />", We = " Did you accidentally export a JSX literal instead of a component?") : Xe = typeof $, se("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Xe, We);
          }
          var Dt = jt.apply(this, arguments);
          if (Dt == null)
            return Dt;
          if (Ae)
            for (var Xt = 2; Xt < arguments.length; Xt++)
              Nr(arguments[Xt], $);
          return $ === u ? Qn(Dt) : Ss(Dt), Dt;
        }
        var Ka = !1;
        function xl($) {
          var oe = Ui.bind(null, $);
          return oe.type = $, Ka || (Ka = !0, ie("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(oe, "type", {
            enumerable: !1,
            get: function() {
              return ie("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
                value: $
              }), $;
            }
          }), oe;
        }
        function rd($, oe, _e) {
          for (var Ae = Rr.apply(this, arguments), We = 2; We < arguments.length; We++)
            Nr(arguments[We], Ae.type);
          return Ss(Ae), Ae;
        }
        function nd($, oe) {
          var _e = R.transition;
          R.transition = {};
          var Ae = R.transition;
          R.transition._updatedFibers = /* @__PURE__ */ new Set();
          try {
            $();
          } finally {
            if (R.transition = _e, _e === null && Ae._updatedFibers) {
              var We = Ae._updatedFibers.size;
              We > 10 && ie("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), Ae._updatedFibers.clear();
            }
          }
        }
        var _s = !1, bl = null;
        function am($) {
          if (bl === null)
            try {
              var oe = ("require" + Math.random()).slice(0, 7), _e = e && e[oe];
              bl = _e.call(e, "timers").setImmediate;
            } catch {
              bl = function(We) {
                _s === !1 && (_s = !0, typeof MessageChannel > "u" && se("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
                var _t = new MessageChannel();
                _t.port1.onmessage = We, _t.port2.postMessage(void 0);
              };
            }
          return bl($);
        }
        var Xa = 0, Oo = !1;
        function Jo($) {
          {
            var oe = Xa;
            Xa++, T.current === null && (T.current = []);
            var _e = T.isBatchingLegacy, Ae;
            try {
              if (T.isBatchingLegacy = !0, Ae = $(), !_e && T.didScheduleLegacyUpdate) {
                var We = T.current;
                We !== null && (T.didScheduleLegacyUpdate = !1, Cs(We));
              }
            } catch (Wt) {
              throw Za(oe), Wt;
            } finally {
              T.isBatchingLegacy = _e;
            }
            if (Ae !== null && typeof Ae == "object" && typeof Ae.then == "function") {
              var _t = Ae, Xe = !1, Dt = {
                then: function(Wt, Fr) {
                  Xe = !0, _t.then(function(hn) {
                    Za(oe), Xa === 0 ? Fc(hn, Wt, Fr) : Wt(hn);
                  }, function(hn) {
                    Za(oe), Fr(hn);
                  });
                }
              };
              return !Oo && typeof Promise < "u" && Promise.resolve().then(function() {
              }).then(function() {
                Xe || (Oo = !0, se("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
              }), Dt;
            } else {
              var Xt = Ae;
              if (Za(oe), Xa === 0) {
                var ur = T.current;
                ur !== null && (Cs(ur), T.current = null);
                var rn = {
                  then: function(Wt, Fr) {
                    T.current === null ? (T.current = [], Fc(Xt, Wt, Fr)) : Wt(Xt);
                  }
                };
                return rn;
              } else {
                var jr = {
                  then: function(Wt, Fr) {
                    Wt(Xt);
                  }
                };
                return jr;
              }
            }
          }
        }
        function Za($) {
          $ !== Xa - 1 && se("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), Xa = $;
        }
        function Fc($, oe, _e) {
          {
            var Ae = T.current;
            if (Ae !== null)
              try {
                Cs(Ae), am(function() {
                  Ae.length === 0 ? (T.current = null, oe($)) : Fc($, oe, _e);
                });
              } catch (We) {
                _e(We);
              }
            else
              oe($);
          }
        }
        var Ic = !1;
        function Cs($) {
          if (!Ic) {
            Ic = !0;
            var oe = 0;
            try {
              for (; oe < $.length; oe++) {
                var _e = $[oe];
                do
                  _e = _e(!0);
                while (_e !== null);
              }
              $.length = 0;
            } catch (Ae) {
              throw $ = $.slice(oe + 1), Ae;
            } finally {
              Ic = !1;
            }
          }
        }
        var wl = Ui, Bc = rd, Lc = xl, To = {
          map: bo,
          forEach: Vo,
          count: Du,
          toArray: Wo,
          only: Yo
        };
        t.Children = To, t.Component = ae, t.Fragment = u, t.Profiler = c, t.PureComponent = we, t.StrictMode = s, t.Suspense = y, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ne, t.act = Jo, t.cloneElement = Bc, t.createContext = Go, t.createElement = wl, t.createFactory = Lc, t.createRef = Ye, t.forwardRef = Qo, t.isValidElement = en, t.lazy = Qa, t.memo = Je, t.startTransition = nd, t.unstable_act = Jo, t.useCallback = hi, t.useContext = $t, t.useDebugValue = zt, t.useDeferredValue = So, t.useEffect = En, t.useId = ml, t.useImperativeHandle = Eo, t.useInsertionEffect = tn, t.useLayoutEffect = on, t.useMemo = wo, t.useReducer = Kt, t.useRef = Yt, t.useState = It, t.useSyncExternalStore = yl, t.useTransition = Ht, t.version = r, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }();
    }(Ag, Ag.exports)), Ag.exports;
  }
  var H8;
  function F0() {
    return H8 || (H8 = 1, process.env.NODE_ENV === "production" ? Uw.exports = See() : Uw.exports = _ee()), Uw.exports;
  }
  var ee = F0();
  const ce = /* @__PURE__ */ Zr(ee), dU = /* @__PURE__ */ fU({
    __proto__: null,
    default: ce
  }, [ee]);
  var Mv = {}, Hw = { exports: {} }, vo = {}, Vw = { exports: {} }, RA = {};
  /**
   * @license React
   * scheduler.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var V8;
  function Cee() {
    return V8 || (V8 = 1, function(e) {
      function t(X, fe) {
        var Z = X.length;
        X.push(fe);
        e: for (; 0 < Z; ) {
          var z = Z - 1 >>> 1, Y = X[z];
          if (0 < i(Y, fe)) X[z] = fe, X[Z] = Y, Z = z;
          else break e;
        }
      }
      function r(X) {
        return X.length === 0 ? null : X[0];
      }
      function n(X) {
        if (X.length === 0) return null;
        var fe = X[0], Z = X.pop();
        if (Z !== fe) {
          X[0] = Z;
          e: for (var z = 0, Y = X.length, te = Y >>> 1; z < te; ) {
            var ae = 2 * (z + 1) - 1, De = X[ae], ke = ae + 1, Re = X[ke];
            if (0 > i(De, Z)) ke < Y && 0 > i(Re, De) ? (X[z] = Re, X[ke] = Z, z = ke) : (X[z] = De, X[ae] = Z, z = ae);
            else if (ke < Y && 0 > i(Re, Z)) X[z] = Re, X[ke] = Z, z = ke;
            else break e;
          }
        }
        return fe;
      }
      function i(X, fe) {
        var Z = X.sortIndex - fe.sortIndex;
        return Z !== 0 ? Z : X.id - fe.id;
      }
      if (typeof performance == "object" && typeof performance.now == "function") {
        var u = performance;
        e.unstable_now = function() {
          return u.now();
        };
      } else {
        var s = Date, c = s.now();
        e.unstable_now = function() {
          return s.now() - c;
        };
      }
      var p = [], h = [], v = 1, y = null, x = 3, w = !1, E = !1, C = !1, S = typeof setTimeout == "function" ? setTimeout : null, k = typeof clearTimeout == "function" ? clearTimeout : null, D = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function A(X) {
        for (var fe = r(h); fe !== null; ) {
          if (fe.callback === null) n(h);
          else if (fe.startTime <= X) n(h), fe.sortIndex = fe.expirationTime, t(p, fe);
          else break;
          fe = r(h);
        }
      }
      function R(X) {
        if (C = !1, A(X), !E) if (r(p) !== null) E = !0, ie(T);
        else {
          var fe = r(h);
          fe !== null && se(R, fe.startTime - X);
        }
      }
      function T(X, fe) {
        E = !1, C && (C = !1, k(B), B = -1), w = !0;
        var Z = x;
        try {
          for (A(fe), y = r(p); y !== null && (!(y.expirationTime > fe) || X && !q()); ) {
            var z = y.callback;
            if (typeof z == "function") {
              y.callback = null, x = y.priorityLevel;
              var Y = z(y.expirationTime <= fe);
              fe = e.unstable_now(), typeof Y == "function" ? y.callback = Y : y === r(p) && n(p), A(fe);
            } else n(p);
            y = r(p);
          }
          if (y !== null) var te = !0;
          else {
            var ae = r(h);
            ae !== null && se(R, ae.startTime - fe), te = !1;
          }
          return te;
        } finally {
          y = null, x = Z, w = !1;
        }
      }
      var M = !1, F = null, B = -1, V = 5, H = -1;
      function q() {
        return !(e.unstable_now() - H < V);
      }
      function Q() {
        if (F !== null) {
          var X = e.unstable_now();
          H = X;
          var fe = !0;
          try {
            fe = F(!0, X);
          } finally {
            fe ? W() : (M = !1, F = null);
          }
        } else M = !1;
      }
      var W;
      if (typeof D == "function") W = function() {
        D(Q);
      };
      else if (typeof MessageChannel < "u") {
        var J = new MessageChannel(), ne = J.port2;
        J.port1.onmessage = Q, W = function() {
          ne.postMessage(null);
        };
      } else W = function() {
        S(Q, 0);
      };
      function ie(X) {
        F = X, M || (M = !0, W());
      }
      function se(X, fe) {
        B = S(function() {
          X(e.unstable_now());
        }, fe);
      }
      e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(X) {
        X.callback = null;
      }, e.unstable_continueExecution = function() {
        E || w || (E = !0, ie(T));
      }, e.unstable_forceFrameRate = function(X) {
        0 > X || 125 < X ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : V = 0 < X ? Math.floor(1e3 / X) : 5;
      }, e.unstable_getCurrentPriorityLevel = function() {
        return x;
      }, e.unstable_getFirstCallbackNode = function() {
        return r(p);
      }, e.unstable_next = function(X) {
        switch (x) {
          case 1:
          case 2:
          case 3:
            var fe = 3;
            break;
          default:
            fe = x;
        }
        var Z = x;
        x = fe;
        try {
          return X();
        } finally {
          x = Z;
        }
      }, e.unstable_pauseExecution = function() {
      }, e.unstable_requestPaint = function() {
      }, e.unstable_runWithPriority = function(X, fe) {
        switch (X) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
          default:
            X = 3;
        }
        var Z = x;
        x = X;
        try {
          return fe();
        } finally {
          x = Z;
        }
      }, e.unstable_scheduleCallback = function(X, fe, Z) {
        var z = e.unstable_now();
        switch (typeof Z == "object" && Z !== null ? (Z = Z.delay, Z = typeof Z == "number" && 0 < Z ? z + Z : z) : Z = z, X) {
          case 1:
            var Y = -1;
            break;
          case 2:
            Y = 250;
            break;
          case 5:
            Y = 1073741823;
            break;
          case 4:
            Y = 1e4;
            break;
          default:
            Y = 5e3;
        }
        return Y = Z + Y, X = { id: v++, callback: fe, priorityLevel: X, startTime: Z, expirationTime: Y, sortIndex: -1 }, Z > z ? (X.sortIndex = Z, t(h, X), r(p) === null && X === r(h) && (C ? (k(B), B = -1) : C = !0, se(R, Z - z))) : (X.sortIndex = Y, t(p, X), E || w || (E = !0, ie(T))), X;
      }, e.unstable_shouldYield = q, e.unstable_wrapCallback = function(X) {
        var fe = x;
        return function() {
          var Z = x;
          x = fe;
          try {
            return X.apply(this, arguments);
          } finally {
            x = Z;
          }
        };
      };
    }(RA)), RA;
  }
  var PA = {};
  /**
   * @license React
   * scheduler.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var W8;
  function Oee() {
    return W8 || (W8 = 1, function(e) {
      process.env.NODE_ENV !== "production" && function() {
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
        var t = !1, r = 5;
        function n(Ge, ct) {
          var jt = Ge.length;
          Ge.push(ct), s(Ge, ct, jt);
        }
        function i(Ge) {
          return Ge.length === 0 ? null : Ge[0];
        }
        function u(Ge) {
          if (Ge.length === 0)
            return null;
          var ct = Ge[0], jt = Ge.pop();
          return jt !== ct && (Ge[0] = jt, c(Ge, jt, 0)), ct;
        }
        function s(Ge, ct, jt) {
          for (var cr = jt; cr > 0; ) {
            var Rr = cr - 1 >>> 1, en = Ge[Rr];
            if (p(en, ct) > 0)
              Ge[Rr] = ct, Ge[cr] = en, cr = Rr;
            else
              return;
          }
        }
        function c(Ge, ct, jt) {
          for (var cr = jt, Rr = Ge.length, en = Rr >>> 1; cr < en; ) {
            var Gr = (cr + 1) * 2 - 1, Mn = Ge[Gr], Pr = Gr + 1, _r = Ge[Pr];
            if (p(Mn, ct) < 0)
              Pr < Rr && p(_r, Mn) < 0 ? (Ge[cr] = _r, Ge[Pr] = ct, cr = Pr) : (Ge[cr] = Mn, Ge[Gr] = ct, cr = Gr);
            else if (Pr < Rr && p(_r, ct) < 0)
              Ge[cr] = _r, Ge[Pr] = ct, cr = Pr;
            else
              return;
          }
        }
        function p(Ge, ct) {
          var jt = Ge.sortIndex - ct.sortIndex;
          return jt !== 0 ? jt : Ge.id - ct.id;
        }
        var h = 1, v = 2, y = 3, x = 4, w = 5;
        function E(Ge, ct) {
        }
        var C = typeof performance == "object" && typeof performance.now == "function";
        if (C) {
          var S = performance;
          e.unstable_now = function() {
            return S.now();
          };
        } else {
          var k = Date, D = k.now();
          e.unstable_now = function() {
            return k.now() - D;
          };
        }
        var A = 1073741823, R = -1, T = 250, M = 5e3, F = 1e4, B = A, V = [], H = [], q = 1, Q = null, W = y, J = !1, ne = !1, ie = !1, se = typeof setTimeout == "function" ? setTimeout : null, X = typeof clearTimeout == "function" ? clearTimeout : null, fe = typeof setImmediate < "u" ? setImmediate : null;
        typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
        function Z(Ge) {
          for (var ct = i(H); ct !== null; ) {
            if (ct.callback === null)
              u(H);
            else if (ct.startTime <= Ge)
              u(H), ct.sortIndex = ct.expirationTime, n(V, ct);
            else
              return;
            ct = i(H);
          }
        }
        function z(Ge) {
          if (ie = !1, Z(Ge), !ne)
            if (i(V) !== null)
              ne = !0, Yr(Y);
            else {
              var ct = i(H);
              ct !== null && Jr(z, ct.startTime - Ge);
            }
        }
        function Y(Ge, ct) {
          ne = !1, ie && (ie = !1, xn()), J = !0;
          var jt = W;
          try {
            var cr;
            if (!t) return te(Ge, ct);
          } finally {
            Q = null, W = jt, J = !1;
          }
        }
        function te(Ge, ct) {
          var jt = ct;
          for (Z(jt), Q = i(V); Q !== null && !(Q.expirationTime > jt && (!Ge || Wr())); ) {
            var cr = Q.callback;
            if (typeof cr == "function") {
              Q.callback = null, W = Q.priorityLevel;
              var Rr = Q.expirationTime <= jt, en = cr(Rr);
              jt = e.unstable_now(), typeof en == "function" ? Q.callback = en : Q === i(V) && u(V), Z(jt);
            } else
              u(V);
            Q = i(V);
          }
          if (Q !== null)
            return !0;
          var Gr = i(H);
          return Gr !== null && Jr(z, Gr.startTime - jt), !1;
        }
        function ae(Ge, ct) {
          switch (Ge) {
            case h:
            case v:
            case y:
            case x:
            case w:
              break;
            default:
              Ge = y;
          }
          var jt = W;
          W = Ge;
          try {
            return ct();
          } finally {
            W = jt;
          }
        }
        function De(Ge) {
          var ct;
          switch (W) {
            case h:
            case v:
            case y:
              ct = y;
              break;
            default:
              ct = W;
              break;
          }
          var jt = W;
          W = ct;
          try {
            return Ge();
          } finally {
            W = jt;
          }
        }
        function ke(Ge) {
          var ct = W;
          return function() {
            var jt = W;
            W = ct;
            try {
              return Ge.apply(this, arguments);
            } finally {
              W = jt;
            }
          };
        }
        function Re(Ge, ct, jt) {
          var cr = e.unstable_now(), Rr;
          if (typeof jt == "object" && jt !== null) {
            var en = jt.delay;
            typeof en == "number" && en > 0 ? Rr = cr + en : Rr = cr;
          } else
            Rr = cr;
          var Gr;
          switch (Ge) {
            case h:
              Gr = R;
              break;
            case v:
              Gr = T;
              break;
            case w:
              Gr = B;
              break;
            case x:
              Gr = F;
              break;
            case y:
            default:
              Gr = M;
              break;
          }
          var Mn = Rr + Gr, Pr = {
            id: q++,
            callback: ct,
            priorityLevel: Ge,
            startTime: Rr,
            expirationTime: Mn,
            sortIndex: -1
          };
          return Rr > cr ? (Pr.sortIndex = Rr, n(H, Pr), i(V) === null && Pr === i(H) && (ie ? xn() : ie = !0, Jr(z, Rr - cr))) : (Pr.sortIndex = Mn, n(V, Pr), !ne && !J && (ne = !0, Yr(Y))), Pr;
        }
        function Te() {
        }
        function we() {
          !ne && !J && (ne = !0, Yr(Y));
        }
        function Fe() {
          return i(V);
        }
        function Ye(Ge) {
          Ge.callback = null;
        }
        function de() {
          return W;
        }
        var Ze = !1, Ne = null, Ot = -1, At = r, Qt = -1;
        function Wr() {
          var Ge = e.unstable_now() - Qt;
          return !(Ge < At);
        }
        function Ar() {
        }
        function Dr(Ge) {
          if (Ge < 0 || Ge > 125) {
            console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
          }
          Ge > 0 ? At = Math.floor(1e3 / Ge) : At = r;
        }
        var Vt = function() {
          if (Ne !== null) {
            var Ge = e.unstable_now();
            Qt = Ge;
            var ct = !0, jt = !0;
            try {
              jt = Ne(ct, Ge);
            } finally {
              jt ? Ut() : (Ze = !1, Ne = null);
            }
          } else
            Ze = !1;
        }, Ut;
        if (typeof fe == "function")
          Ut = function() {
            fe(Vt);
          };
        else if (typeof MessageChannel < "u") {
          var kr = new MessageChannel(), Pn = kr.port2;
          kr.port1.onmessage = Vt, Ut = function() {
            Pn.postMessage(null);
          };
        } else
          Ut = function() {
            se(Vt, 0);
          };
        function Yr(Ge) {
          Ne = Ge, Ze || (Ze = !0, Ut());
        }
        function Jr(Ge, ct) {
          Ot = se(function() {
            Ge(e.unstable_now());
          }, ct);
        }
        function xn() {
          X(Ot), Ot = -1;
        }
        var ka = Ar, Ra = null;
        e.unstable_IdlePriority = w, e.unstable_ImmediatePriority = h, e.unstable_LowPriority = x, e.unstable_NormalPriority = y, e.unstable_Profiling = Ra, e.unstable_UserBlockingPriority = v, e.unstable_cancelCallback = Ye, e.unstable_continueExecution = we, e.unstable_forceFrameRate = Dr, e.unstable_getCurrentPriorityLevel = de, e.unstable_getFirstCallbackNode = Fe, e.unstable_next = De, e.unstable_pauseExecution = Te, e.unstable_requestPaint = ka, e.unstable_runWithPriority = ae, e.unstable_scheduleCallback = Re, e.unstable_shouldYield = Wr, e.unstable_wrapCallback = ke, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }();
    }(PA)), PA;
  }
  var Y8;
  function pU() {
    return Y8 || (Y8 = 1, process.env.NODE_ENV === "production" ? Vw.exports = Cee() : Vw.exports = Oee()), Vw.exports;
  }
  /**
   * @license React
   * react-dom.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var G8;
  function Tee() {
    if (G8) return vo;
    G8 = 1;
    var e = F0(), t = pU();
    function r(l) {
      for (var f = "https://reactjs.org/docs/error-decoder.html?invariant=" + l, g = 1; g < arguments.length; g++) f += "&args[]=" + encodeURIComponent(arguments[g]);
      return "Minified React error #" + l + "; visit " + f + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var n = /* @__PURE__ */ new Set(), i = {};
    function u(l, f) {
      s(l, f), s(l + "Capture", f);
    }
    function s(l, f) {
      for (i[l] = f, l = 0; l < f.length; l++) n.add(f[l]);
    }
    var c = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), p = Object.prototype.hasOwnProperty, h = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, v = {}, y = {};
    function x(l) {
      return p.call(y, l) ? !0 : p.call(v, l) ? !1 : h.test(l) ? y[l] = !0 : (v[l] = !0, !1);
    }
    function w(l, f, g, _) {
      if (g !== null && g.type === 0) return !1;
      switch (typeof f) {
        case "function":
        case "symbol":
          return !0;
        case "boolean":
          return _ ? !1 : g !== null ? !g.acceptsBooleans : (l = l.toLowerCase().slice(0, 5), l !== "data-" && l !== "aria-");
        default:
          return !1;
      }
    }
    function E(l, f, g, _) {
      if (f === null || typeof f > "u" || w(l, f, g, _)) return !0;
      if (_) return !1;
      if (g !== null) switch (g.type) {
        case 3:
          return !f;
        case 4:
          return f === !1;
        case 5:
          return isNaN(f);
        case 6:
          return isNaN(f) || 1 > f;
      }
      return !1;
    }
    function C(l, f, g, _, P, j, U) {
      this.acceptsBooleans = f === 2 || f === 3 || f === 4, this.attributeName = _, this.attributeNamespace = P, this.mustUseProperty = g, this.propertyName = l, this.type = f, this.sanitizeURL = j, this.removeEmptyString = U;
    }
    var S = {};
    "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(l) {
      S[l] = new C(l, 0, !1, l, null, !1, !1);
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(l) {
      var f = l[0];
      S[f] = new C(f, 1, !1, l[1], null, !1, !1);
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(l) {
      S[l] = new C(l, 2, !1, l.toLowerCase(), null, !1, !1);
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(l) {
      S[l] = new C(l, 2, !1, l, null, !1, !1);
    }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(l) {
      S[l] = new C(l, 3, !1, l.toLowerCase(), null, !1, !1);
    }), ["checked", "multiple", "muted", "selected"].forEach(function(l) {
      S[l] = new C(l, 3, !0, l, null, !1, !1);
    }), ["capture", "download"].forEach(function(l) {
      S[l] = new C(l, 4, !1, l, null, !1, !1);
    }), ["cols", "rows", "size", "span"].forEach(function(l) {
      S[l] = new C(l, 6, !1, l, null, !1, !1);
    }), ["rowSpan", "start"].forEach(function(l) {
      S[l] = new C(l, 5, !1, l.toLowerCase(), null, !1, !1);
    });
    var k = /[\-:]([a-z])/g;
    function D(l) {
      return l[1].toUpperCase();
    }
    "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(l) {
      var f = l.replace(
        k,
        D
      );
      S[f] = new C(f, 1, !1, l, null, !1, !1);
    }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(l) {
      var f = l.replace(k, D);
      S[f] = new C(f, 1, !1, l, "http://www.w3.org/1999/xlink", !1, !1);
    }), ["xml:base", "xml:lang", "xml:space"].forEach(function(l) {
      var f = l.replace(k, D);
      S[f] = new C(f, 1, !1, l, "http://www.w3.org/XML/1998/namespace", !1, !1);
    }), ["tabIndex", "crossOrigin"].forEach(function(l) {
      S[l] = new C(l, 1, !1, l.toLowerCase(), null, !1, !1);
    }), S.xlinkHref = new C("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(l) {
      S[l] = new C(l, 1, !1, l.toLowerCase(), null, !0, !0);
    });
    function A(l, f, g, _) {
      var P = S.hasOwnProperty(f) ? S[f] : null;
      (P !== null ? P.type !== 0 : _ || !(2 < f.length) || f[0] !== "o" && f[0] !== "O" || f[1] !== "n" && f[1] !== "N") && (E(f, g, P, _) && (g = null), _ || P === null ? x(f) && (g === null ? l.removeAttribute(f) : l.setAttribute(f, "" + g)) : P.mustUseProperty ? l[P.propertyName] = g === null ? P.type === 3 ? !1 : "" : g : (f = P.attributeName, _ = P.attributeNamespace, g === null ? l.removeAttribute(f) : (P = P.type, g = P === 3 || P === 4 && g === !0 ? "" : "" + g, _ ? l.setAttributeNS(_, f, g) : l.setAttribute(f, g))));
    }
    var R = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, T = Symbol.for("react.element"), M = Symbol.for("react.portal"), F = Symbol.for("react.fragment"), B = Symbol.for("react.strict_mode"), V = Symbol.for("react.profiler"), H = Symbol.for("react.provider"), q = Symbol.for("react.context"), Q = Symbol.for("react.forward_ref"), W = Symbol.for("react.suspense"), J = Symbol.for("react.suspense_list"), ne = Symbol.for("react.memo"), ie = Symbol.for("react.lazy"), se = Symbol.for("react.offscreen"), X = Symbol.iterator;
    function fe(l) {
      return l === null || typeof l != "object" ? null : (l = X && l[X] || l["@@iterator"], typeof l == "function" ? l : null);
    }
    var Z = Object.assign, z;
    function Y(l) {
      if (z === void 0) try {
        throw Error();
      } catch (g) {
        var f = g.stack.trim().match(/\n( *(at )?)/);
        z = f && f[1] || "";
      }
      return `
` + z + l;
    }
    var te = !1;
    function ae(l, f) {
      if (!l || te) return "";
      te = !0;
      var g = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      try {
        if (f) if (f = function() {
          throw Error();
        }, Object.defineProperty(f.prototype, "props", { set: function() {
          throw Error();
        } }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(f, []);
          } catch (Ce) {
            var _ = Ce;
          }
          Reflect.construct(l, [], f);
        } else {
          try {
            f.call();
          } catch (Ce) {
            _ = Ce;
          }
          l.call(f.prototype);
        }
        else {
          try {
            throw Error();
          } catch (Ce) {
            _ = Ce;
          }
          l();
        }
      } catch (Ce) {
        if (Ce && _ && typeof Ce.stack == "string") {
          for (var P = Ce.stack.split(`
`), j = _.stack.split(`
`), U = P.length - 1, re = j.length - 1; 1 <= U && 0 <= re && P[U] !== j[re]; ) re--;
          for (; 1 <= U && 0 <= re; U--, re--) if (P[U] !== j[re]) {
            if (U !== 1 || re !== 1)
              do
                if (U--, re--, 0 > re || P[U] !== j[re]) {
                  var le = `
` + P[U].replace(" at new ", " at ");
                  return l.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", l.displayName)), le;
                }
              while (1 <= U && 0 <= re);
            break;
          }
        }
      } finally {
        te = !1, Error.prepareStackTrace = g;
      }
      return (l = l ? l.displayName || l.name : "") ? Y(l) : "";
    }
    function De(l) {
      switch (l.tag) {
        case 5:
          return Y(l.type);
        case 16:
          return Y("Lazy");
        case 13:
          return Y("Suspense");
        case 19:
          return Y("SuspenseList");
        case 0:
        case 2:
        case 15:
          return l = ae(l.type, !1), l;
        case 11:
          return l = ae(l.type.render, !1), l;
        case 1:
          return l = ae(l.type, !0), l;
        default:
          return "";
      }
    }
    function ke(l) {
      if (l == null) return null;
      if (typeof l == "function") return l.displayName || l.name || null;
      if (typeof l == "string") return l;
      switch (l) {
        case F:
          return "Fragment";
        case M:
          return "Portal";
        case V:
          return "Profiler";
        case B:
          return "StrictMode";
        case W:
          return "Suspense";
        case J:
          return "SuspenseList";
      }
      if (typeof l == "object") switch (l.$$typeof) {
        case q:
          return (l.displayName || "Context") + ".Consumer";
        case H:
          return (l._context.displayName || "Context") + ".Provider";
        case Q:
          var f = l.render;
          return l = l.displayName, l || (l = f.displayName || f.name || "", l = l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef"), l;
        case ne:
          return f = l.displayName || null, f !== null ? f : ke(l.type) || "Memo";
        case ie:
          f = l._payload, l = l._init;
          try {
            return ke(l(f));
          } catch {
          }
      }
      return null;
    }
    function Re(l) {
      var f = l.type;
      switch (l.tag) {
        case 24:
          return "Cache";
        case 9:
          return (f.displayName || "Context") + ".Consumer";
        case 10:
          return (f._context.displayName || "Context") + ".Provider";
        case 18:
          return "DehydratedFragment";
        case 11:
          return l = f.render, l = l.displayName || l.name || "", f.displayName || (l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 5:
          return f;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return ke(f);
        case 8:
          return f === B ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
          if (typeof f == "function") return f.displayName || f.name || null;
          if (typeof f == "string") return f;
      }
      return null;
    }
    function Te(l) {
      switch (typeof l) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return l;
        case "object":
          return l;
        default:
          return "";
      }
    }
    function we(l) {
      var f = l.type;
      return (l = l.nodeName) && l.toLowerCase() === "input" && (f === "checkbox" || f === "radio");
    }
    function Fe(l) {
      var f = we(l) ? "checked" : "value", g = Object.getOwnPropertyDescriptor(l.constructor.prototype, f), _ = "" + l[f];
      if (!l.hasOwnProperty(f) && typeof g < "u" && typeof g.get == "function" && typeof g.set == "function") {
        var P = g.get, j = g.set;
        return Object.defineProperty(l, f, { configurable: !0, get: function() {
          return P.call(this);
        }, set: function(U) {
          _ = "" + U, j.call(this, U);
        } }), Object.defineProperty(l, f, { enumerable: g.enumerable }), { getValue: function() {
          return _;
        }, setValue: function(U) {
          _ = "" + U;
        }, stopTracking: function() {
          l._valueTracker = null, delete l[f];
        } };
      }
    }
    function Ye(l) {
      l._valueTracker || (l._valueTracker = Fe(l));
    }
    function de(l) {
      if (!l) return !1;
      var f = l._valueTracker;
      if (!f) return !0;
      var g = f.getValue(), _ = "";
      return l && (_ = we(l) ? l.checked ? "true" : "false" : l.value), l = _, l !== g ? (f.setValue(l), !0) : !1;
    }
    function Ze(l) {
      if (l = l || (typeof document < "u" ? document : void 0), typeof l > "u") return null;
      try {
        return l.activeElement || l.body;
      } catch {
        return l.body;
      }
    }
    function Ne(l, f) {
      var g = f.checked;
      return Z({}, f, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: g ?? l._wrapperState.initialChecked });
    }
    function Ot(l, f) {
      var g = f.defaultValue == null ? "" : f.defaultValue, _ = f.checked != null ? f.checked : f.defaultChecked;
      g = Te(f.value != null ? f.value : g), l._wrapperState = { initialChecked: _, initialValue: g, controlled: f.type === "checkbox" || f.type === "radio" ? f.checked != null : f.value != null };
    }
    function At(l, f) {
      f = f.checked, f != null && A(l, "checked", f, !1);
    }
    function Qt(l, f) {
      At(l, f);
      var g = Te(f.value), _ = f.type;
      if (g != null) _ === "number" ? (g === 0 && l.value === "" || l.value != g) && (l.value = "" + g) : l.value !== "" + g && (l.value = "" + g);
      else if (_ === "submit" || _ === "reset") {
        l.removeAttribute("value");
        return;
      }
      f.hasOwnProperty("value") ? Ar(l, f.type, g) : f.hasOwnProperty("defaultValue") && Ar(l, f.type, Te(f.defaultValue)), f.checked == null && f.defaultChecked != null && (l.defaultChecked = !!f.defaultChecked);
    }
    function Wr(l, f, g) {
      if (f.hasOwnProperty("value") || f.hasOwnProperty("defaultValue")) {
        var _ = f.type;
        if (!(_ !== "submit" && _ !== "reset" || f.value !== void 0 && f.value !== null)) return;
        f = "" + l._wrapperState.initialValue, g || f === l.value || (l.value = f), l.defaultValue = f;
      }
      g = l.name, g !== "" && (l.name = ""), l.defaultChecked = !!l._wrapperState.initialChecked, g !== "" && (l.name = g);
    }
    function Ar(l, f, g) {
      (f !== "number" || Ze(l.ownerDocument) !== l) && (g == null ? l.defaultValue = "" + l._wrapperState.initialValue : l.defaultValue !== "" + g && (l.defaultValue = "" + g));
    }
    var Dr = Array.isArray;
    function Vt(l, f, g, _) {
      if (l = l.options, f) {
        f = {};
        for (var P = 0; P < g.length; P++) f["$" + g[P]] = !0;
        for (g = 0; g < l.length; g++) P = f.hasOwnProperty("$" + l[g].value), l[g].selected !== P && (l[g].selected = P), P && _ && (l[g].defaultSelected = !0);
      } else {
        for (g = "" + Te(g), f = null, P = 0; P < l.length; P++) {
          if (l[P].value === g) {
            l[P].selected = !0, _ && (l[P].defaultSelected = !0);
            return;
          }
          f !== null || l[P].disabled || (f = l[P]);
        }
        f !== null && (f.selected = !0);
      }
    }
    function Ut(l, f) {
      if (f.dangerouslySetInnerHTML != null) throw Error(r(91));
      return Z({}, f, { value: void 0, defaultValue: void 0, children: "" + l._wrapperState.initialValue });
    }
    function kr(l, f) {
      var g = f.value;
      if (g == null) {
        if (g = f.children, f = f.defaultValue, g != null) {
          if (f != null) throw Error(r(92));
          if (Dr(g)) {
            if (1 < g.length) throw Error(r(93));
            g = g[0];
          }
          f = g;
        }
        f == null && (f = ""), g = f;
      }
      l._wrapperState = { initialValue: Te(g) };
    }
    function Pn(l, f) {
      var g = Te(f.value), _ = Te(f.defaultValue);
      g != null && (g = "" + g, g !== l.value && (l.value = g), f.defaultValue == null && l.defaultValue !== g && (l.defaultValue = g)), _ != null && (l.defaultValue = "" + _);
    }
    function Yr(l) {
      var f = l.textContent;
      f === l._wrapperState.initialValue && f !== "" && f !== null && (l.value = f);
    }
    function Jr(l) {
      switch (l) {
        case "svg":
          return "http://www.w3.org/2000/svg";
        case "math":
          return "http://www.w3.org/1998/Math/MathML";
        default:
          return "http://www.w3.org/1999/xhtml";
      }
    }
    function xn(l, f) {
      return l == null || l === "http://www.w3.org/1999/xhtml" ? Jr(f) : l === "http://www.w3.org/2000/svg" && f === "foreignObject" ? "http://www.w3.org/1999/xhtml" : l;
    }
    var ka, Ra = function(l) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(f, g, _, P) {
        MSApp.execUnsafeLocalFunction(function() {
          return l(f, g, _, P);
        });
      } : l;
    }(function(l, f) {
      if (l.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in l) l.innerHTML = f;
      else {
        for (ka = ka || document.createElement("div"), ka.innerHTML = "<svg>" + f.valueOf().toString() + "</svg>", f = ka.firstChild; l.firstChild; ) l.removeChild(l.firstChild);
        for (; f.firstChild; ) l.appendChild(f.firstChild);
      }
    });
    function Ge(l, f) {
      if (f) {
        var g = l.firstChild;
        if (g && g === l.lastChild && g.nodeType === 3) {
          g.nodeValue = f;
          return;
        }
      }
      l.textContent = f;
    }
    var ct = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    }, jt = ["Webkit", "ms", "Moz", "O"];
    Object.keys(ct).forEach(function(l) {
      jt.forEach(function(f) {
        f = f + l.charAt(0).toUpperCase() + l.substring(1), ct[f] = ct[l];
      });
    });
    function cr(l, f, g) {
      return f == null || typeof f == "boolean" || f === "" ? "" : g || typeof f != "number" || f === 0 || ct.hasOwnProperty(l) && ct[l] ? ("" + f).trim() : f + "px";
    }
    function Rr(l, f) {
      l = l.style;
      for (var g in f) if (f.hasOwnProperty(g)) {
        var _ = g.indexOf("--") === 0, P = cr(g, f[g], _);
        g === "float" && (g = "cssFloat"), _ ? l.setProperty(g, P) : l[g] = P;
      }
    }
    var en = Z({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
    function Gr(l, f) {
      if (f) {
        if (en[l] && (f.children != null || f.dangerouslySetInnerHTML != null)) throw Error(r(137, l));
        if (f.dangerouslySetInnerHTML != null) {
          if (f.children != null) throw Error(r(60));
          if (typeof f.dangerouslySetInnerHTML != "object" || !("__html" in f.dangerouslySetInnerHTML)) throw Error(r(61));
        }
        if (f.style != null && typeof f.style != "object") throw Error(r(62));
      }
    }
    function Mn(l, f) {
      if (l.indexOf("-") === -1) return typeof f.is == "string";
      switch (l) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Pr = null;
    function _r(l) {
      return l = l.target || l.srcElement || window, l.correspondingUseElement && (l = l.correspondingUseElement), l.nodeType === 3 ? l.parentNode : l;
    }
    var Er = null, $i = null, Yn = null;
    function ua(l) {
      if (l = Et(l)) {
        if (typeof Er != "function") throw Error(r(280));
        var f = l.stateNode;
        f && (f = Sn(f), Er(l.stateNode, l.type, f));
      }
    }
    function bo(l) {
      $i ? Yn ? Yn.push(l) : Yn = [l] : $i = l;
    }
    function Du() {
      if ($i) {
        var l = $i, f = Yn;
        if (Yn = $i = null, ua(l), f) for (l = 0; l < f.length; l++) ua(f[l]);
      }
    }
    function Vo(l, f) {
      return l(f);
    }
    function Wo() {
    }
    var Yo = !1;
    function Go(l, f, g) {
      if (Yo) return l(f, g);
      Yo = !0;
      try {
        return Vo(l, f, g);
      } finally {
        Yo = !1, ($i !== null || Yn !== null) && (Wo(), Du());
      }
    }
    function pi(l, f) {
      var g = l.stateNode;
      if (g === null) return null;
      var _ = Sn(g);
      if (_ === null) return null;
      g = _[f];
      e: switch (f) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (_ = !_.disabled) || (l = l.type, _ = !(l === "button" || l === "input" || l === "select" || l === "textarea")), l = !_;
          break e;
        default:
          l = !1;
      }
      if (l) return null;
      if (g && typeof g != "function") throw Error(r(231, f, typeof g));
      return g;
    }
    var ni = !1;
    if (c) try {
      var Sr = {};
      Object.defineProperty(Sr, "passive", { get: function() {
        ni = !0;
      } }), window.addEventListener("test", Sr, Sr), window.removeEventListener("test", Sr, Sr);
    } catch {
      ni = !1;
    }
    function Gn(l, f, g, _, P, j, U, re, le) {
      var Ce = Array.prototype.slice.call(arguments, 3);
      try {
        f.apply(g, Ce);
      } catch (qe) {
        this.onError(qe);
      }
    }
    var sa = !1, Qa = null, Qo = !1, ue = null, Le = { onError: function(l) {
      sa = !0, Qa = l;
    } };
    function Je(l, f, g, _, P, j, U, re, le) {
      sa = !1, Qa = null, Gn.apply(Le, arguments);
    }
    function lt(l, f, g, _, P, j, U, re, le) {
      if (Je.apply(this, arguments), sa) {
        if (sa) {
          var Ce = Qa;
          sa = !1, Qa = null;
        } else throw Error(r(198));
        Qo || (Qo = !0, ue = Ce);
      }
    }
    function $t(l) {
      var f = l, g = l;
      if (l.alternate) for (; f.return; ) f = f.return;
      else {
        l = f;
        do
          f = l, (f.flags & 4098) !== 0 && (g = f.return), l = f.return;
        while (l);
      }
      return f.tag === 3 ? g : null;
    }
    function It(l) {
      if (l.tag === 13) {
        var f = l.memoizedState;
        if (f === null && (l = l.alternate, l !== null && (f = l.memoizedState)), f !== null) return f.dehydrated;
      }
      return null;
    }
    function Kt(l) {
      if ($t(l) !== l) throw Error(r(188));
    }
    function Yt(l) {
      var f = l.alternate;
      if (!f) {
        if (f = $t(l), f === null) throw Error(r(188));
        return f !== l ? null : l;
      }
      for (var g = l, _ = f; ; ) {
        var P = g.return;
        if (P === null) break;
        var j = P.alternate;
        if (j === null) {
          if (_ = P.return, _ !== null) {
            g = _;
            continue;
          }
          break;
        }
        if (P.child === j.child) {
          for (j = P.child; j; ) {
            if (j === g) return Kt(P), l;
            if (j === _) return Kt(P), f;
            j = j.sibling;
          }
          throw Error(r(188));
        }
        if (g.return !== _.return) g = P, _ = j;
        else {
          for (var U = !1, re = P.child; re; ) {
            if (re === g) {
              U = !0, g = P, _ = j;
              break;
            }
            if (re === _) {
              U = !0, _ = P, g = j;
              break;
            }
            re = re.sibling;
          }
          if (!U) {
            for (re = j.child; re; ) {
              if (re === g) {
                U = !0, g = j, _ = P;
                break;
              }
              if (re === _) {
                U = !0, _ = j, g = P;
                break;
              }
              re = re.sibling;
            }
            if (!U) throw Error(r(189));
          }
        }
        if (g.alternate !== _) throw Error(r(190));
      }
      if (g.tag !== 3) throw Error(r(188));
      return g.stateNode.current === g ? l : f;
    }
    function En(l) {
      return l = Yt(l), l !== null ? tn(l) : null;
    }
    function tn(l) {
      if (l.tag === 5 || l.tag === 6) return l;
      for (l = l.child; l !== null; ) {
        var f = tn(l);
        if (f !== null) return f;
        l = l.sibling;
      }
      return null;
    }
    var on = t.unstable_scheduleCallback, hi = t.unstable_cancelCallback, wo = t.unstable_shouldYield, Eo = t.unstable_requestPaint, zt = t.unstable_now, Ht = t.unstable_getCurrentPriorityLevel, So = t.unstable_ImmediatePriority, ml = t.unstable_UserBlockingPriority, yl = t.unstable_NormalPriority, xs = t.unstable_LowPriority, Dc = t.unstable_IdlePriority, bs = null, la = null;
    function ed(l) {
      if (la && typeof la.onCommitFiberRoot == "function") try {
        la.onCommitFiberRoot(bs, l, void 0, (l.current.flags & 128) === 128);
      } catch {
      }
    }
    var zi = Math.clz32 ? Math.clz32 : kc, Gp = Math.log, Qp = Math.LN2;
    function kc(l) {
      return l >>>= 0, l === 0 ? 32 : 31 - (Gp(l) / Qp | 0) | 0;
    }
    var ws = 64, Pa = 4194304;
    function _o(l) {
      switch (l & -l) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return l & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          return l & 130023424;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 1073741824;
        default:
          return l;
      }
    }
    function Co(l, f) {
      var g = l.pendingLanes;
      if (g === 0) return 0;
      var _ = 0, P = l.suspendedLanes, j = l.pingedLanes, U = g & 268435455;
      if (U !== 0) {
        var re = U & ~P;
        re !== 0 ? _ = _o(re) : (j &= U, j !== 0 && (_ = _o(j)));
      } else U = g & ~P, U !== 0 ? _ = _o(U) : j !== 0 && (_ = _o(j));
      if (_ === 0) return 0;
      if (f !== 0 && f !== _ && (f & P) === 0 && (P = _ & -_, j = f & -f, P >= j || P === 16 && (j & 4194240) !== 0)) return f;
      if ((_ & 4) !== 0 && (_ |= g & 16), f = l.entangledLanes, f !== 0) for (l = l.entanglements, f &= _; 0 < f; ) g = 31 - zi(f), P = 1 << g, _ |= l[g], f &= ~P;
      return _;
    }
    function Rc(l, f) {
      switch (l) {
        case 1:
        case 2:
        case 4:
          return f + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return f + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return -1;
      }
    }
    function gl(l, f) {
      for (var g = l.suspendedLanes, _ = l.pingedLanes, P = l.expirationTimes, j = l.pendingLanes; 0 < j; ) {
        var U = 31 - zi(j), re = 1 << U, le = P[U];
        le === -1 ? ((re & g) === 0 || (re & _) !== 0) && (P[U] = Rc(re, f)) : le <= f && (l.expiredLanes |= re), j &= ~re;
      }
    }
    function Es(l) {
      return l = l.pendingLanes & -1073741825, l !== 0 ? l : l & 1073741824 ? 1073741824 : 0;
    }
    function Pc() {
      var l = ws;
      return ws <<= 1, (ws & 4194240) === 0 && (ws = 64), l;
    }
    function Mc(l) {
      for (var f = [], g = 0; 31 > g; g++) f.push(l);
      return f;
    }
    function ku(l, f, g) {
      l.pendingLanes |= f, f !== 536870912 && (l.suspendedLanes = 0, l.pingedLanes = 0), l = l.eventTimes, f = 31 - zi(f), l[f] = g;
    }
    function im(l, f) {
      var g = l.pendingLanes & ~f;
      l.pendingLanes = f, l.suspendedLanes = 0, l.pingedLanes = 0, l.expiredLanes &= f, l.mutableReadLanes &= f, l.entangledLanes &= f, f = l.entanglements;
      var _ = l.eventTimes;
      for (l = l.expirationTimes; 0 < g; ) {
        var P = 31 - zi(g), j = 1 << P;
        f[P] = 0, _[P] = -1, l[P] = -1, g &= ~j;
      }
    }
    function Ru(l, f) {
      var g = l.entangledLanes |= f;
      for (l = l.entanglements; g; ) {
        var _ = 31 - zi(g), P = 1 << _;
        P & f | l[_] & f && (l[_] |= f), g &= ~P;
      }
    }
    var mr = 0;
    function Nc(l) {
      return l &= -l, 1 < l ? 4 < l ? (l & 268435455) !== 0 ? 16 : 536870912 : 4 : 1;
    }
    var or, td, Ko, Ft, jc, vi = !1, Xo = [], qi = null, Zo = null, un = null, Nr = /* @__PURE__ */ new Map(), Ss = /* @__PURE__ */ new Map(), Qn = [], Ui = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
    function Ka(l, f) {
      switch (l) {
        case "focusin":
        case "focusout":
          qi = null;
          break;
        case "dragenter":
        case "dragleave":
          Zo = null;
          break;
        case "mouseover":
        case "mouseout":
          un = null;
          break;
        case "pointerover":
        case "pointerout":
          Nr.delete(f.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          Ss.delete(f.pointerId);
      }
    }
    function xl(l, f, g, _, P, j) {
      return l === null || l.nativeEvent !== j ? (l = { blockedOn: f, domEventName: g, eventSystemFlags: _, nativeEvent: j, targetContainers: [P] }, f !== null && (f = Et(f), f !== null && td(f)), l) : (l.eventSystemFlags |= _, f = l.targetContainers, P !== null && f.indexOf(P) === -1 && f.push(P), l);
    }
    function rd(l, f, g, _, P) {
      switch (f) {
        case "focusin":
          return qi = xl(qi, l, f, g, _, P), !0;
        case "dragenter":
          return Zo = xl(Zo, l, f, g, _, P), !0;
        case "mouseover":
          return un = xl(un, l, f, g, _, P), !0;
        case "pointerover":
          var j = P.pointerId;
          return Nr.set(j, xl(Nr.get(j) || null, l, f, g, _, P)), !0;
        case "gotpointercapture":
          return j = P.pointerId, Ss.set(j, xl(Ss.get(j) || null, l, f, g, _, P)), !0;
      }
      return !1;
    }
    function nd(l) {
      var f = Al(l.target);
      if (f !== null) {
        var g = $t(f);
        if (g !== null) {
          if (f = g.tag, f === 13) {
            if (f = It(g), f !== null) {
              l.blockedOn = f, jc(l.priority, function() {
                Ko(g);
              });
              return;
            }
          } else if (f === 3 && g.stateNode.current.memoizedState.isDehydrated) {
            l.blockedOn = g.tag === 3 ? g.stateNode.containerInfo : null;
            return;
          }
        }
      }
      l.blockedOn = null;
    }
    function _s(l) {
      if (l.blockedOn !== null) return !1;
      for (var f = l.targetContainers; 0 < f.length; ) {
        var g = Bc(l.domEventName, l.eventSystemFlags, f[0], l.nativeEvent);
        if (g === null) {
          g = l.nativeEvent;
          var _ = new g.constructor(g.type, g);
          Pr = _, g.target.dispatchEvent(_), Pr = null;
        } else return f = Et(g), f !== null && td(f), l.blockedOn = g, !1;
        f.shift();
      }
      return !0;
    }
    function bl(l, f, g) {
      _s(l) && g.delete(f);
    }
    function am() {
      vi = !1, qi !== null && _s(qi) && (qi = null), Zo !== null && _s(Zo) && (Zo = null), un !== null && _s(un) && (un = null), Nr.forEach(bl), Ss.forEach(bl);
    }
    function Xa(l, f) {
      l.blockedOn === f && (l.blockedOn = null, vi || (vi = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, am)));
    }
    function Oo(l) {
      function f(P) {
        return Xa(P, l);
      }
      if (0 < Xo.length) {
        Xa(Xo[0], l);
        for (var g = 1; g < Xo.length; g++) {
          var _ = Xo[g];
          _.blockedOn === l && (_.blockedOn = null);
        }
      }
      for (qi !== null && Xa(qi, l), Zo !== null && Xa(Zo, l), un !== null && Xa(un, l), Nr.forEach(f), Ss.forEach(f), g = 0; g < Qn.length; g++) _ = Qn[g], _.blockedOn === l && (_.blockedOn = null);
      for (; 0 < Qn.length && (g = Qn[0], g.blockedOn === null); ) nd(g), g.blockedOn === null && Qn.shift();
    }
    var Jo = R.ReactCurrentBatchConfig, Za = !0;
    function Fc(l, f, g, _) {
      var P = mr, j = Jo.transition;
      Jo.transition = null;
      try {
        mr = 1, Cs(l, f, g, _);
      } finally {
        mr = P, Jo.transition = j;
      }
    }
    function Ic(l, f, g, _) {
      var P = mr, j = Jo.transition;
      Jo.transition = null;
      try {
        mr = 4, Cs(l, f, g, _);
      } finally {
        mr = P, Jo.transition = j;
      }
    }
    function Cs(l, f, g, _) {
      if (Za) {
        var P = Bc(l, f, g, _);
        if (P === null) uh(l, f, _, wl, g), Ka(l, _);
        else if (rd(P, l, f, g, _)) _.stopPropagation();
        else if (Ka(l, _), f & 4 && -1 < Ui.indexOf(l)) {
          for (; P !== null; ) {
            var j = Et(P);
            if (j !== null && or(j), j = Bc(l, f, g, _), j === null && uh(l, f, _, wl, g), j === P) break;
            P = j;
          }
          P !== null && _.stopPropagation();
        } else uh(l, f, _, null, g);
      }
    }
    var wl = null;
    function Bc(l, f, g, _) {
      if (wl = null, l = _r(_), l = Al(l), l !== null) if (f = $t(l), f === null) l = null;
      else if (g = f.tag, g === 13) {
        if (l = It(f), l !== null) return l;
        l = null;
      } else if (g === 3) {
        if (f.stateNode.current.memoizedState.isDehydrated) return f.tag === 3 ? f.stateNode.containerInfo : null;
        l = null;
      } else f !== l && (l = null);
      return wl = l, null;
    }
    function Lc(l) {
      switch (l) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return 4;
        case "message":
          switch (Ht()) {
            case So:
              return 1;
            case ml:
              return 4;
            case yl:
            case xs:
              return 16;
            case Dc:
              return 536870912;
            default:
              return 16;
          }
        default:
          return 16;
      }
    }
    var To = null, $ = null, oe = null;
    function _e() {
      if (oe) return oe;
      var l, f = $, g = f.length, _, P = "value" in To ? To.value : To.textContent, j = P.length;
      for (l = 0; l < g && f[l] === P[l]; l++) ;
      var U = g - l;
      for (_ = 1; _ <= U && f[g - _] === P[j - _]; _++) ;
      return oe = P.slice(l, 1 < _ ? 1 - _ : void 0);
    }
    function Ae(l) {
      var f = l.keyCode;
      return "charCode" in l ? (l = l.charCode, l === 0 && f === 13 && (l = 13)) : l = f, l === 10 && (l = 13), 32 <= l || l === 13 ? l : 0;
    }
    function We() {
      return !0;
    }
    function _t() {
      return !1;
    }
    function Xe(l) {
      function f(g, _, P, j, U) {
        this._reactName = g, this._targetInst = P, this.type = _, this.nativeEvent = j, this.target = U, this.currentTarget = null;
        for (var re in l) l.hasOwnProperty(re) && (g = l[re], this[re] = g ? g(j) : j[re]);
        return this.isDefaultPrevented = (j.defaultPrevented != null ? j.defaultPrevented : j.returnValue === !1) ? We : _t, this.isPropagationStopped = _t, this;
      }
      return Z(f.prototype, { preventDefault: function() {
        this.defaultPrevented = !0;
        var g = this.nativeEvent;
        g && (g.preventDefault ? g.preventDefault() : typeof g.returnValue != "unknown" && (g.returnValue = !1), this.isDefaultPrevented = We);
      }, stopPropagation: function() {
        var g = this.nativeEvent;
        g && (g.stopPropagation ? g.stopPropagation() : typeof g.cancelBubble != "unknown" && (g.cancelBubble = !0), this.isPropagationStopped = We);
      }, persist: function() {
      }, isPersistent: We }), f;
    }
    var Dt = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(l) {
      return l.timeStamp || Date.now();
    }, defaultPrevented: 0, isTrusted: 0 }, Xt = Xe(Dt), ur = Z({}, Dt, { view: 0, detail: 0 }), rn = Xe(ur), jr, Wt, Fr, hn = Z({}, ur, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: cm, button: 0, buttons: 0, relatedTarget: function(l) {
      return l.relatedTarget === void 0 ? l.fromElement === l.srcElement ? l.toElement : l.fromElement : l.relatedTarget;
    }, movementX: function(l) {
      return "movementX" in l ? l.movementX : (l !== Fr && (Fr && l.type === "mousemove" ? (jr = l.screenX - Fr.screenX, Wt = l.screenY - Fr.screenY) : Wt = jr = 0, Fr = l), jr);
    }, movementY: function(l) {
      return "movementY" in l ? l.movementY : Wt;
    } }), Os = Xe(hn), id = Z({}, hn, { dataTransfer: 0 }), Pu = Xe(id), ad = Z({}, ur, { relatedTarget: 0 }), El = Xe(ad), om = Z({}, Dt, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Kp = Xe(om), um = Z({}, Dt, { clipboardData: function(l) {
      return "clipboardData" in l ? l.clipboardData : window.clipboardData;
    } }), Zx = Xe(um), sm = Z({}, Dt, { data: 0 }), lm = Xe(sm), Jx = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, eb = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    }, vC = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
    function Mu(l) {
      var f = this.nativeEvent;
      return f.getModifierState ? f.getModifierState(l) : (l = vC[l]) ? !!f[l] : !1;
    }
    function cm() {
      return Mu;
    }
    var fm = Z({}, ur, { key: function(l) {
      if (l.key) {
        var f = Jx[l.key] || l.key;
        if (f !== "Unidentified") return f;
      }
      return l.type === "keypress" ? (l = Ae(l), l === 13 ? "Enter" : String.fromCharCode(l)) : l.type === "keydown" || l.type === "keyup" ? eb[l.keyCode] || "Unidentified" : "";
    }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: cm, charCode: function(l) {
      return l.type === "keypress" ? Ae(l) : 0;
    }, keyCode: function(l) {
      return l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    }, which: function(l) {
      return l.type === "keypress" ? Ae(l) : l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    } }), dm = Xe(fm), pm = Z({}, hn, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), tb = Xe(pm), Xp = Z({}, ur, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: cm }), rb = Xe(Xp), ca = Z({}, Dt, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Nu = Xe(ca), Nn = Z({}, hn, {
      deltaX: function(l) {
        return "deltaX" in l ? l.deltaX : "wheelDeltaX" in l ? -l.wheelDeltaX : 0;
      },
      deltaY: function(l) {
        return "deltaY" in l ? l.deltaY : "wheelDeltaY" in l ? -l.wheelDeltaY : "wheelDelta" in l ? -l.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }), ju = Xe(Nn), hm = [9, 13, 27, 32], $c = c && "CompositionEvent" in window, od = null;
    c && "documentMode" in document && (od = document.documentMode);
    var ud = c && "TextEvent" in window && !od, nb = c && (!$c || od && 8 < od && 11 >= od), ib = " ", Zp = !1;
    function ab(l, f) {
      switch (l) {
        case "keyup":
          return hm.indexOf(f.keyCode) !== -1;
        case "keydown":
          return f.keyCode !== 229;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function ob(l) {
      return l = l.detail, typeof l == "object" && "data" in l ? l.data : null;
    }
    var zc = !1;
    function ub(l, f) {
      switch (l) {
        case "compositionend":
          return ob(f);
        case "keypress":
          return f.which !== 32 ? null : (Zp = !0, ib);
        case "textInput":
          return l = f.data, l === ib && Zp ? null : l;
        default:
          return null;
      }
    }
    function mC(l, f) {
      if (zc) return l === "compositionend" || !$c && ab(l, f) ? (l = _e(), oe = $ = To = null, zc = !1, l) : null;
      switch (l) {
        case "paste":
          return null;
        case "keypress":
          if (!(f.ctrlKey || f.altKey || f.metaKey) || f.ctrlKey && f.altKey) {
            if (f.char && 1 < f.char.length) return f.char;
            if (f.which) return String.fromCharCode(f.which);
          }
          return null;
        case "compositionend":
          return nb && f.locale !== "ko" ? null : f.data;
        default:
          return null;
      }
    }
    var yC = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
    function sb(l) {
      var f = l && l.nodeName && l.nodeName.toLowerCase();
      return f === "input" ? !!yC[l.type] : f === "textarea";
    }
    function vm(l, f, g, _) {
      bo(_), f = pd(f, "onChange"), 0 < f.length && (g = new Xt("onChange", "change", null, g, _), l.push({ event: g, listeners: f }));
    }
    var eu = null, Sl = null;
    function lb(l) {
      Ol(l, 0);
    }
    function sd(l) {
      var f = Do(l);
      if (de(f)) return l;
    }
    function gC(l, f) {
      if (l === "change") return f;
    }
    var cb = !1;
    if (c) {
      var mm;
      if (c) {
        var ym = "oninput" in document;
        if (!ym) {
          var fb = document.createElement("div");
          fb.setAttribute("oninput", "return;"), ym = typeof fb.oninput == "function";
        }
        mm = ym;
      } else mm = !1;
      cb = mm && (!document.documentMode || 9 < document.documentMode);
    }
    function db() {
      eu && (eu.detachEvent("onpropertychange", pb), Sl = eu = null);
    }
    function pb(l) {
      if (l.propertyName === "value" && sd(Sl)) {
        var f = [];
        vm(f, Sl, l, _r(l)), Go(lb, f);
      }
    }
    function xC(l, f, g) {
      l === "focusin" ? (db(), eu = f, Sl = g, eu.attachEvent("onpropertychange", pb)) : l === "focusout" && db();
    }
    function hb(l) {
      if (l === "selectionchange" || l === "keyup" || l === "keydown") return sd(Sl);
    }
    function bC(l, f) {
      if (l === "click") return sd(f);
    }
    function vb(l, f) {
      if (l === "input" || l === "change") return sd(f);
    }
    function wC(l, f) {
      return l === f && (l !== 0 || 1 / l === 1 / f) || l !== l && f !== f;
    }
    var Ao = typeof Object.is == "function" ? Object.is : wC;
    function ld(l, f) {
      if (Ao(l, f)) return !0;
      if (typeof l != "object" || l === null || typeof f != "object" || f === null) return !1;
      var g = Object.keys(l), _ = Object.keys(f);
      if (g.length !== _.length) return !1;
      for (_ = 0; _ < g.length; _++) {
        var P = g[_];
        if (!p.call(f, P) || !Ao(l[P], f[P])) return !1;
      }
      return !0;
    }
    function mb(l) {
      for (; l && l.firstChild; ) l = l.firstChild;
      return l;
    }
    function Jp(l, f) {
      var g = mb(l);
      l = 0;
      for (var _; g; ) {
        if (g.nodeType === 3) {
          if (_ = l + g.textContent.length, l <= f && _ >= f) return { node: g, offset: f - l };
          l = _;
        }
        e: {
          for (; g; ) {
            if (g.nextSibling) {
              g = g.nextSibling;
              break e;
            }
            g = g.parentNode;
          }
          g = void 0;
        }
        g = mb(g);
      }
    }
    function Ts(l, f) {
      return l && f ? l === f ? !0 : l && l.nodeType === 3 ? !1 : f && f.nodeType === 3 ? Ts(l, f.parentNode) : "contains" in l ? l.contains(f) : l.compareDocumentPosition ? !!(l.compareDocumentPosition(f) & 16) : !1 : !1;
    }
    function cd() {
      for (var l = window, f = Ze(); f instanceof l.HTMLIFrameElement; ) {
        try {
          var g = typeof f.contentWindow.location.href == "string";
        } catch {
          g = !1;
        }
        if (g) l = f.contentWindow;
        else break;
        f = Ze(l.document);
      }
      return f;
    }
    function eh(l) {
      var f = l && l.nodeName && l.nodeName.toLowerCase();
      return f && (f === "input" && (l.type === "text" || l.type === "search" || l.type === "tel" || l.type === "url" || l.type === "password") || f === "textarea" || l.contentEditable === "true");
    }
    function qc(l) {
      var f = cd(), g = l.focusedElem, _ = l.selectionRange;
      if (f !== g && g && g.ownerDocument && Ts(g.ownerDocument.documentElement, g)) {
        if (_ !== null && eh(g)) {
          if (f = _.start, l = _.end, l === void 0 && (l = f), "selectionStart" in g) g.selectionStart = f, g.selectionEnd = Math.min(l, g.value.length);
          else if (l = (f = g.ownerDocument || document) && f.defaultView || window, l.getSelection) {
            l = l.getSelection();
            var P = g.textContent.length, j = Math.min(_.start, P);
            _ = _.end === void 0 ? j : Math.min(_.end, P), !l.extend && j > _ && (P = _, _ = j, j = P), P = Jp(g, j);
            var U = Jp(
              g,
              _
            );
            P && U && (l.rangeCount !== 1 || l.anchorNode !== P.node || l.anchorOffset !== P.offset || l.focusNode !== U.node || l.focusOffset !== U.offset) && (f = f.createRange(), f.setStart(P.node, P.offset), l.removeAllRanges(), j > _ ? (l.addRange(f), l.extend(U.node, U.offset)) : (f.setEnd(U.node, U.offset), l.addRange(f)));
          }
        }
        for (f = [], l = g; l = l.parentNode; ) l.nodeType === 1 && f.push({ element: l, left: l.scrollLeft, top: l.scrollTop });
        for (typeof g.focus == "function" && g.focus(), g = 0; g < f.length; g++) l = f[g], l.element.scrollLeft = l.left, l.element.scrollTop = l.top;
      }
    }
    var EC = c && "documentMode" in document && 11 >= document.documentMode, Uc = null, gm = null, fd = null, xm = !1;
    function bm(l, f, g) {
      var _ = g.window === g ? g.document : g.nodeType === 9 ? g : g.ownerDocument;
      xm || Uc == null || Uc !== Ze(_) || (_ = Uc, "selectionStart" in _ && eh(_) ? _ = { start: _.selectionStart, end: _.selectionEnd } : (_ = (_.ownerDocument && _.ownerDocument.defaultView || window).getSelection(), _ = { anchorNode: _.anchorNode, anchorOffset: _.anchorOffset, focusNode: _.focusNode, focusOffset: _.focusOffset }), fd && ld(fd, _) || (fd = _, _ = pd(gm, "onSelect"), 0 < _.length && (f = new Xt("onSelect", "select", null, f, g), l.push({ event: f, listeners: _ }), f.target = Uc)));
    }
    function th(l, f) {
      var g = {};
      return g[l.toLowerCase()] = f.toLowerCase(), g["Webkit" + l] = "webkit" + f, g["Moz" + l] = "moz" + f, g;
    }
    var _l = { animationend: th("Animation", "AnimationEnd"), animationiteration: th("Animation", "AnimationIteration"), animationstart: th("Animation", "AnimationStart"), transitionend: th("Transition", "TransitionEnd") }, mi = {}, wm = {};
    c && (wm = document.createElement("div").style, "AnimationEvent" in window || (delete _l.animationend.animation, delete _l.animationiteration.animation, delete _l.animationstart.animation), "TransitionEvent" in window || delete _l.transitionend.transition);
    function rh(l) {
      if (mi[l]) return mi[l];
      if (!_l[l]) return l;
      var f = _l[l], g;
      for (g in f) if (f.hasOwnProperty(g) && g in wm) return mi[l] = f[g];
      return l;
    }
    var yb = rh("animationend"), gb = rh("animationiteration"), xb = rh("animationstart"), bb = rh("transitionend"), Em = /* @__PURE__ */ new Map(), nh = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
    function Ja(l, f) {
      Em.set(l, f), u(f, [l]);
    }
    for (var Sm = 0; Sm < nh.length; Sm++) {
      var Cl = nh[Sm], SC = Cl.toLowerCase(), _C = Cl[0].toUpperCase() + Cl.slice(1);
      Ja(SC, "on" + _C);
    }
    Ja(yb, "onAnimationEnd"), Ja(gb, "onAnimationIteration"), Ja(xb, "onAnimationStart"), Ja("dblclick", "onDoubleClick"), Ja("focusin", "onFocus"), Ja("focusout", "onBlur"), Ja(bb, "onTransitionEnd"), s("onMouseEnter", ["mouseout", "mouseover"]), s("onMouseLeave", ["mouseout", "mouseover"]), s("onPointerEnter", ["pointerout", "pointerover"]), s("onPointerLeave", ["pointerout", "pointerover"]), u("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), u("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), u("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), u("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), u("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), u("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
    var dd = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), _m = new Set("cancel close invalid load scroll toggle".split(" ").concat(dd));
    function ih(l, f, g) {
      var _ = l.type || "unknown-event";
      l.currentTarget = g, lt(_, f, void 0, l), l.currentTarget = null;
    }
    function Ol(l, f) {
      f = (f & 4) !== 0;
      for (var g = 0; g < l.length; g++) {
        var _ = l[g], P = _.event;
        _ = _.listeners;
        e: {
          var j = void 0;
          if (f) for (var U = _.length - 1; 0 <= U; U--) {
            var re = _[U], le = re.instance, Ce = re.currentTarget;
            if (re = re.listener, le !== j && P.isPropagationStopped()) break e;
            ih(P, re, Ce), j = le;
          }
          else for (U = 0; U < _.length; U++) {
            if (re = _[U], le = re.instance, Ce = re.currentTarget, re = re.listener, le !== j && P.isPropagationStopped()) break e;
            ih(P, re, Ce), j = le;
          }
        }
      }
      if (Qo) throw l = ue, Qo = !1, ue = null, l;
    }
    function Cr(l, f) {
      var g = f[md];
      g === void 0 && (g = f[md] = /* @__PURE__ */ new Set());
      var _ = l + "__bubble";
      g.has(_) || (wb(f, l, 2, !1), g.add(_));
    }
    function ah(l, f, g) {
      var _ = 0;
      f && (_ |= 4), wb(g, l, _, f);
    }
    var oh = "_reactListening" + Math.random().toString(36).slice(2);
    function Hc(l) {
      if (!l[oh]) {
        l[oh] = !0, n.forEach(function(g) {
          g !== "selectionchange" && (_m.has(g) || ah(g, !1, l), ah(g, !0, l));
        });
        var f = l.nodeType === 9 ? l : l.ownerDocument;
        f === null || f[oh] || (f[oh] = !0, ah("selectionchange", !1, f));
      }
    }
    function wb(l, f, g, _) {
      switch (Lc(f)) {
        case 1:
          var P = Fc;
          break;
        case 4:
          P = Ic;
          break;
        default:
          P = Cs;
      }
      g = P.bind(null, f, g, l), P = void 0, !ni || f !== "touchstart" && f !== "touchmove" && f !== "wheel" || (P = !0), _ ? P !== void 0 ? l.addEventListener(f, g, { capture: !0, passive: P }) : l.addEventListener(f, g, !0) : P !== void 0 ? l.addEventListener(f, g, { passive: P }) : l.addEventListener(f, g, !1);
    }
    function uh(l, f, g, _, P) {
      var j = _;
      if ((f & 1) === 0 && (f & 2) === 0 && _ !== null) e: for (; ; ) {
        if (_ === null) return;
        var U = _.tag;
        if (U === 3 || U === 4) {
          var re = _.stateNode.containerInfo;
          if (re === P || re.nodeType === 8 && re.parentNode === P) break;
          if (U === 4) for (U = _.return; U !== null; ) {
            var le = U.tag;
            if ((le === 3 || le === 4) && (le = U.stateNode.containerInfo, le === P || le.nodeType === 8 && le.parentNode === P)) return;
            U = U.return;
          }
          for (; re !== null; ) {
            if (U = Al(re), U === null) return;
            if (le = U.tag, le === 5 || le === 6) {
              _ = j = U;
              continue e;
            }
            re = re.parentNode;
          }
        }
        _ = _.return;
      }
      Go(function() {
        var Ce = j, qe = _r(g), He = [];
        e: {
          var ze = Em.get(l);
          if (ze !== void 0) {
            var nt = Xt, dt = l;
            switch (l) {
              case "keypress":
                if (Ae(g) === 0) break e;
              case "keydown":
              case "keyup":
                nt = dm;
                break;
              case "focusin":
                dt = "focus", nt = El;
                break;
              case "focusout":
                dt = "blur", nt = El;
                break;
              case "beforeblur":
              case "afterblur":
                nt = El;
                break;
              case "click":
                if (g.button === 2) break e;
              case "auxclick":
              case "dblclick":
              case "mousedown":
              case "mousemove":
              case "mouseup":
              case "mouseout":
              case "mouseover":
              case "contextmenu":
                nt = Os;
                break;
              case "drag":
              case "dragend":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "dragstart":
              case "drop":
                nt = Pu;
                break;
              case "touchcancel":
              case "touchend":
              case "touchmove":
              case "touchstart":
                nt = rb;
                break;
              case yb:
              case gb:
              case xb:
                nt = Kp;
                break;
              case bb:
                nt = Nu;
                break;
              case "scroll":
                nt = rn;
                break;
              case "wheel":
                nt = ju;
                break;
              case "copy":
              case "cut":
              case "paste":
                nt = Zx;
                break;
              case "gotpointercapture":
              case "lostpointercapture":
              case "pointercancel":
              case "pointerdown":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "pointerup":
                nt = tb;
            }
            var mt = (f & 4) !== 0, An = !mt && l === "scroll", ge = mt ? ze !== null ? ze + "Capture" : null : ze;
            mt = [];
            for (var he = Ce, Ee; he !== null; ) {
              Ee = he;
              var Ue = Ee.stateNode;
              if (Ee.tag === 5 && Ue !== null && (Ee = Ue, ge !== null && (Ue = pi(he, ge), Ue != null && mt.push(Vc(he, Ue, Ee)))), An) break;
              he = he.return;
            }
            0 < mt.length && (ze = new nt(ze, dt, null, g, qe), He.push({ event: ze, listeners: mt }));
          }
        }
        if ((f & 7) === 0) {
          e: {
            if (ze = l === "mouseover" || l === "pointerover", nt = l === "mouseout" || l === "pointerout", ze && g !== Pr && (dt = g.relatedTarget || g.fromElement) && (Al(dt) || dt[Fu])) break e;
            if ((nt || ze) && (ze = qe.window === qe ? qe : (ze = qe.ownerDocument) ? ze.defaultView || ze.parentWindow : window, nt ? (dt = g.relatedTarget || g.toElement, nt = Ce, dt = dt ? Al(dt) : null, dt !== null && (An = $t(dt), dt !== An || dt.tag !== 5 && dt.tag !== 6) && (dt = null)) : (nt = null, dt = Ce), nt !== dt)) {
              if (mt = Os, Ue = "onMouseLeave", ge = "onMouseEnter", he = "mouse", (l === "pointerout" || l === "pointerover") && (mt = tb, Ue = "onPointerLeave", ge = "onPointerEnter", he = "pointer"), An = nt == null ? ze : Do(nt), Ee = dt == null ? ze : Do(dt), ze = new mt(Ue, he + "leave", nt, g, qe), ze.target = An, ze.relatedTarget = Ee, Ue = null, Al(qe) === Ce && (mt = new mt(ge, he + "enter", dt, g, qe), mt.target = Ee, mt.relatedTarget = An, Ue = mt), An = Ue, nt && dt) t: {
                for (mt = nt, ge = dt, he = 0, Ee = mt; Ee; Ee = As(Ee)) he++;
                for (Ee = 0, Ue = ge; Ue; Ue = As(Ue)) Ee++;
                for (; 0 < he - Ee; ) mt = As(mt), he--;
                for (; 0 < Ee - he; ) ge = As(ge), Ee--;
                for (; he--; ) {
                  if (mt === ge || ge !== null && mt === ge.alternate) break t;
                  mt = As(mt), ge = As(ge);
                }
                mt = null;
              }
              else mt = null;
              nt !== null && Eb(He, ze, nt, mt, !1), dt !== null && An !== null && Eb(He, An, dt, mt, !0);
            }
          }
          e: {
            if (ze = Ce ? Do(Ce) : window, nt = ze.nodeName && ze.nodeName.toLowerCase(), nt === "select" || nt === "input" && ze.type === "file") var pt = gC;
            else if (sb(ze)) if (cb) pt = vb;
            else {
              pt = hb;
              var Tt = xC;
            }
            else (nt = ze.nodeName) && nt.toLowerCase() === "input" && (ze.type === "checkbox" || ze.type === "radio") && (pt = bC);
            if (pt && (pt = pt(l, Ce))) {
              vm(He, pt, g, qe);
              break e;
            }
            Tt && Tt(l, ze, Ce), l === "focusout" && (Tt = ze._wrapperState) && Tt.controlled && ze.type === "number" && Ar(ze, "number", ze.value);
          }
          switch (Tt = Ce ? Do(Ce) : window, l) {
            case "focusin":
              (sb(Tt) || Tt.contentEditable === "true") && (Uc = Tt, gm = Ce, fd = null);
              break;
            case "focusout":
              fd = gm = Uc = null;
              break;
            case "mousedown":
              xm = !0;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              xm = !1, bm(He, g, qe);
              break;
            case "selectionchange":
              if (EC) break;
            case "keydown":
            case "keyup":
              bm(He, g, qe);
          }
          var kt;
          if ($c) e: {
            switch (l) {
              case "compositionstart":
                var Mt = "onCompositionStart";
                break e;
              case "compositionend":
                Mt = "onCompositionEnd";
                break e;
              case "compositionupdate":
                Mt = "onCompositionUpdate";
                break e;
            }
            Mt = void 0;
          }
          else zc ? ab(l, g) && (Mt = "onCompositionEnd") : l === "keydown" && g.keyCode === 229 && (Mt = "onCompositionStart");
          Mt && (nb && g.locale !== "ko" && (zc || Mt !== "onCompositionStart" ? Mt === "onCompositionEnd" && zc && (kt = _e()) : (To = qe, $ = "value" in To ? To.value : To.textContent, zc = !0)), Tt = pd(Ce, Mt), 0 < Tt.length && (Mt = new lm(Mt, l, null, g, qe), He.push({ event: Mt, listeners: Tt }), kt ? Mt.data = kt : (kt = ob(g), kt !== null && (Mt.data = kt)))), (kt = ud ? ub(l, g) : mC(l, g)) && (Ce = pd(Ce, "onBeforeInput"), 0 < Ce.length && (qe = new lm("onBeforeInput", "beforeinput", null, g, qe), He.push({ event: qe, listeners: Ce }), qe.data = kt));
        }
        Ol(He, f);
      });
    }
    function Vc(l, f, g) {
      return { instance: l, listener: f, currentTarget: g };
    }
    function pd(l, f) {
      for (var g = f + "Capture", _ = []; l !== null; ) {
        var P = l, j = P.stateNode;
        P.tag === 5 && j !== null && (P = j, j = pi(l, g), j != null && _.unshift(Vc(l, j, P)), j = pi(l, f), j != null && _.push(Vc(l, j, P))), l = l.return;
      }
      return _;
    }
    function As(l) {
      if (l === null) return null;
      do
        l = l.return;
      while (l && l.tag !== 5);
      return l || null;
    }
    function Eb(l, f, g, _, P) {
      for (var j = f._reactName, U = []; g !== null && g !== _; ) {
        var re = g, le = re.alternate, Ce = re.stateNode;
        if (le !== null && le === _) break;
        re.tag === 5 && Ce !== null && (re = Ce, P ? (le = pi(g, j), le != null && U.unshift(Vc(g, le, re))) : P || (le = pi(g, j), le != null && U.push(Vc(g, le, re)))), g = g.return;
      }
      U.length !== 0 && l.push({ event: f, listeners: U });
    }
    var Sb = /\r\n?/g, CC = /\u0000|\uFFFD/g;
    function _b(l) {
      return (typeof l == "string" ? l : "" + l).replace(Sb, `
`).replace(CC, "");
    }
    function sh(l, f, g) {
      if (f = _b(f), _b(l) !== f && g) throw Error(r(425));
    }
    function Ds() {
    }
    var hd = null, Tl = null;
    function lh(l, f) {
      return l === "textarea" || l === "noscript" || typeof f.children == "string" || typeof f.children == "number" || typeof f.dangerouslySetInnerHTML == "object" && f.dangerouslySetInnerHTML !== null && f.dangerouslySetInnerHTML.__html != null;
    }
    var ch = typeof setTimeout == "function" ? setTimeout : void 0, Cm = typeof clearTimeout == "function" ? clearTimeout : void 0, Cb = typeof Promise == "function" ? Promise : void 0, Wc = typeof queueMicrotask == "function" ? queueMicrotask : typeof Cb < "u" ? function(l) {
      return Cb.resolve(null).then(l).catch(fh);
    } : ch;
    function fh(l) {
      setTimeout(function() {
        throw l;
      });
    }
    function Yc(l, f) {
      var g = f, _ = 0;
      do {
        var P = g.nextSibling;
        if (l.removeChild(g), P && P.nodeType === 8) if (g = P.data, g === "/$") {
          if (_ === 0) {
            l.removeChild(P), Oo(f);
            return;
          }
          _--;
        } else g !== "$" && g !== "$?" && g !== "$!" || _++;
        g = P;
      } while (g);
      Oo(f);
    }
    function tu(l) {
      for (; l != null; l = l.nextSibling) {
        var f = l.nodeType;
        if (f === 1 || f === 3) break;
        if (f === 8) {
          if (f = l.data, f === "$" || f === "$!" || f === "$?") break;
          if (f === "/$") return null;
        }
      }
      return l;
    }
    function Ob(l) {
      l = l.previousSibling;
      for (var f = 0; l; ) {
        if (l.nodeType === 8) {
          var g = l.data;
          if (g === "$" || g === "$!" || g === "$?") {
            if (f === 0) return l;
            f--;
          } else g === "/$" && f++;
        }
        l = l.previousSibling;
      }
      return null;
    }
    var ks = Math.random().toString(36).slice(2), ru = "__reactFiber$" + ks, vd = "__reactProps$" + ks, Fu = "__reactContainer$" + ks, md = "__reactEvents$" + ks, Gc = "__reactListeners$" + ks, OC = "__reactHandles$" + ks;
    function Al(l) {
      var f = l[ru];
      if (f) return f;
      for (var g = l.parentNode; g; ) {
        if (f = g[Fu] || g[ru]) {
          if (g = f.alternate, f.child !== null || g !== null && g.child !== null) for (l = Ob(l); l !== null; ) {
            if (g = l[ru]) return g;
            l = Ob(l);
          }
          return f;
        }
        l = g, g = l.parentNode;
      }
      return null;
    }
    function Et(l) {
      return l = l[ru] || l[Fu], !l || l.tag !== 5 && l.tag !== 6 && l.tag !== 13 && l.tag !== 3 ? null : l;
    }
    function Do(l) {
      if (l.tag === 5 || l.tag === 6) return l.stateNode;
      throw Error(r(33));
    }
    function Sn(l) {
      return l[vd] || null;
    }
    var rr = [], eo = -1;
    function ko(l) {
      return { current: l };
    }
    function nn(l) {
      0 > eo || (l.current = rr[eo], rr[eo] = null, eo--);
    }
    function wt(l, f) {
      eo++, rr[eo] = l.current, l.current = f;
    }
    var fa = {}, bn = ko(fa), Kn = ko(!1), da = fa;
    function to(l, f) {
      var g = l.type.contextTypes;
      if (!g) return fa;
      var _ = l.stateNode;
      if (_ && _.__reactInternalMemoizedUnmaskedChildContext === f) return _.__reactInternalMemoizedMaskedChildContext;
      var P = {}, j;
      for (j in g) P[j] = f[j];
      return _ && (l = l.stateNode, l.__reactInternalMemoizedUnmaskedChildContext = f, l.__reactInternalMemoizedMaskedChildContext = P), P;
    }
    function jn(l) {
      return l = l.childContextTypes, l != null;
    }
    function Qc() {
      nn(Kn), nn(bn);
    }
    function Tb(l, f, g) {
      if (bn.current !== fa) throw Error(r(168));
      wt(bn, f), wt(Kn, g);
    }
    function yd(l, f, g) {
      var _ = l.stateNode;
      if (f = f.childContextTypes, typeof _.getChildContext != "function") return g;
      _ = _.getChildContext();
      for (var P in _) if (!(P in f)) throw Error(r(108, Re(l) || "Unknown", P));
      return Z({}, g, _);
    }
    function pa(l) {
      return l = (l = l.stateNode) && l.__reactInternalMemoizedMergedChildContext || fa, da = bn.current, wt(bn, l), wt(Kn, Kn.current), !0;
    }
    function dh(l, f, g) {
      var _ = l.stateNode;
      if (!_) throw Error(r(169));
      g ? (l = yd(l, f, da), _.__reactInternalMemoizedMergedChildContext = l, nn(Kn), nn(bn), wt(bn, l)) : nn(Kn), wt(Kn, g);
    }
    var nu = null, Kc = !1, Iu = !1;
    function ph(l) {
      nu === null ? nu = [l] : nu.push(l);
    }
    function Rs(l) {
      Kc = !0, ph(l);
    }
    function iu() {
      if (!Iu && nu !== null) {
        Iu = !0;
        var l = 0, f = mr;
        try {
          var g = nu;
          for (mr = 1; l < g.length; l++) {
            var _ = g[l];
            do
              _ = _(!0);
            while (_ !== null);
          }
          nu = null, Kc = !1;
        } catch (P) {
          throw nu !== null && (nu = nu.slice(l + 1)), on(So, iu), P;
        } finally {
          mr = f, Iu = !1;
        }
      }
      return null;
    }
    var Ps = [], Ms = 0, Ns = null, Bu = 0, Fn = [], ro = 0, Ma = null, au = 1, ou = "";
    function Dl(l, f) {
      Ps[Ms++] = Bu, Ps[Ms++] = Ns, Ns = l, Bu = f;
    }
    function Ab(l, f, g) {
      Fn[ro++] = au, Fn[ro++] = ou, Fn[ro++] = Ma, Ma = l;
      var _ = au;
      l = ou;
      var P = 32 - zi(_) - 1;
      _ &= ~(1 << P), g += 1;
      var j = 32 - zi(f) + P;
      if (30 < j) {
        var U = P - P % 5;
        j = (_ & (1 << U) - 1).toString(32), _ >>= U, P -= U, au = 1 << 32 - zi(f) + P | g << P | _, ou = j + l;
      } else au = 1 << j | g << P | _, ou = l;
    }
    function hh(l) {
      l.return !== null && (Dl(l, 1), Ab(l, 1, 0));
    }
    function vh(l) {
      for (; l === Ns; ) Ns = Ps[--Ms], Ps[Ms] = null, Bu = Ps[--Ms], Ps[Ms] = null;
      for (; l === Ma; ) Ma = Fn[--ro], Fn[ro] = null, ou = Fn[--ro], Fn[ro] = null, au = Fn[--ro], Fn[ro] = null;
    }
    var ha = null, va = null, cn = !1, no = null;
    function Om(l, f) {
      var g = so(5, null, null, 0);
      g.elementType = "DELETED", g.stateNode = f, g.return = l, f = l.deletions, f === null ? (l.deletions = [g], l.flags |= 16) : f.push(g);
    }
    function Db(l, f) {
      switch (l.tag) {
        case 5:
          var g = l.type;
          return f = f.nodeType !== 1 || g.toLowerCase() !== f.nodeName.toLowerCase() ? null : f, f !== null ? (l.stateNode = f, ha = l, va = tu(f.firstChild), !0) : !1;
        case 6:
          return f = l.pendingProps === "" || f.nodeType !== 3 ? null : f, f !== null ? (l.stateNode = f, ha = l, va = null, !0) : !1;
        case 13:
          return f = f.nodeType !== 8 ? null : f, f !== null ? (g = Ma !== null ? { id: au, overflow: ou } : null, l.memoizedState = { dehydrated: f, treeContext: g, retryLane: 1073741824 }, g = so(18, null, null, 0), g.stateNode = f, g.return = l, l.child = g, ha = l, va = null, !0) : !1;
        default:
          return !1;
      }
    }
    function Tm(l) {
      return (l.mode & 1) !== 0 && (l.flags & 128) === 0;
    }
    function Am(l) {
      if (cn) {
        var f = va;
        if (f) {
          var g = f;
          if (!Db(l, f)) {
            if (Tm(l)) throw Error(r(418));
            f = tu(g.nextSibling);
            var _ = ha;
            f && Db(l, f) ? Om(_, g) : (l.flags = l.flags & -4097 | 2, cn = !1, ha = l);
          }
        } else {
          if (Tm(l)) throw Error(r(418));
          l.flags = l.flags & -4097 | 2, cn = !1, ha = l;
        }
      }
    }
    function Xn(l) {
      for (l = l.return; l !== null && l.tag !== 5 && l.tag !== 3 && l.tag !== 13; ) l = l.return;
      ha = l;
    }
    function mh(l) {
      if (l !== ha) return !1;
      if (!cn) return Xn(l), cn = !0, !1;
      var f;
      if ((f = l.tag !== 3) && !(f = l.tag !== 5) && (f = l.type, f = f !== "head" && f !== "body" && !lh(l.type, l.memoizedProps)), f && (f = va)) {
        if (Tm(l)) throw gd(), Error(r(418));
        for (; f; ) Om(l, f), f = tu(f.nextSibling);
      }
      if (Xn(l), l.tag === 13) {
        if (l = l.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(r(317));
        e: {
          for (l = l.nextSibling, f = 0; l; ) {
            if (l.nodeType === 8) {
              var g = l.data;
              if (g === "/$") {
                if (f === 0) {
                  va = tu(l.nextSibling);
                  break e;
                }
                f--;
              } else g !== "$" && g !== "$!" && g !== "$?" || f++;
            }
            l = l.nextSibling;
          }
          va = null;
        }
      } else va = ha ? tu(l.stateNode.nextSibling) : null;
      return !0;
    }
    function gd() {
      for (var l = va; l; ) l = tu(l.nextSibling);
    }
    function js() {
      va = ha = null, cn = !1;
    }
    function Lu(l) {
      no === null ? no = [l] : no.push(l);
    }
    var TC = R.ReactCurrentBatchConfig;
    function kl(l, f, g) {
      if (l = g.ref, l !== null && typeof l != "function" && typeof l != "object") {
        if (g._owner) {
          if (g = g._owner, g) {
            if (g.tag !== 1) throw Error(r(309));
            var _ = g.stateNode;
          }
          if (!_) throw Error(r(147, l));
          var P = _, j = "" + l;
          return f !== null && f.ref !== null && typeof f.ref == "function" && f.ref._stringRef === j ? f.ref : (f = function(U) {
            var re = P.refs;
            U === null ? delete re[j] : re[j] = U;
          }, f._stringRef = j, f);
        }
        if (typeof l != "string") throw Error(r(284));
        if (!g._owner) throw Error(r(290, l));
      }
      return l;
    }
    function yh(l, f) {
      throw l = Object.prototype.toString.call(f), Error(r(31, l === "[object Object]" ? "object with keys {" + Object.keys(f).join(", ") + "}" : l));
    }
    function kb(l) {
      var f = l._init;
      return f(l._payload);
    }
    function Rl(l) {
      function f(ge, he) {
        if (l) {
          var Ee = ge.deletions;
          Ee === null ? (ge.deletions = [he], ge.flags |= 16) : Ee.push(he);
        }
      }
      function g(ge, he) {
        if (!l) return null;
        for (; he !== null; ) f(ge, he), he = he.sibling;
        return null;
      }
      function _(ge, he) {
        for (ge = /* @__PURE__ */ new Map(); he !== null; ) he.key !== null ? ge.set(he.key, he) : ge.set(he.index, he), he = he.sibling;
        return ge;
      }
      function P(ge, he) {
        return ge = Us(ge, he), ge.index = 0, ge.sibling = null, ge;
      }
      function j(ge, he, Ee) {
        return ge.index = Ee, l ? (Ee = ge.alternate, Ee !== null ? (Ee = Ee.index, Ee < he ? (ge.flags |= 2, he) : Ee) : (ge.flags |= 2, he)) : (ge.flags |= 1048576, he);
      }
      function U(ge) {
        return l && ge.alternate === null && (ge.flags |= 2), ge;
      }
      function re(ge, he, Ee, Ue) {
        return he === null || he.tag !== 6 ? (he = ay(Ee, ge.mode, Ue), he.return = ge, he) : (he = P(he, Ee), he.return = ge, he);
      }
      function le(ge, he, Ee, Ue) {
        var pt = Ee.type;
        return pt === F ? qe(ge, he, Ee.props.children, Ue, Ee.key) : he !== null && (he.elementType === pt || typeof pt == "object" && pt !== null && pt.$$typeof === ie && kb(pt) === he.type) ? (Ue = P(he, Ee.props), Ue.ref = kl(ge, he, Ee), Ue.return = ge, Ue) : (Ue = Gd(Ee.type, Ee.key, Ee.props, null, ge.mode, Ue), Ue.ref = kl(ge, he, Ee), Ue.return = ge, Ue);
      }
      function Ce(ge, he, Ee, Ue) {
        return he === null || he.tag !== 4 || he.stateNode.containerInfo !== Ee.containerInfo || he.stateNode.implementation !== Ee.implementation ? (he = Kh(Ee, ge.mode, Ue), he.return = ge, he) : (he = P(he, Ee.children || []), he.return = ge, he);
      }
      function qe(ge, he, Ee, Ue, pt) {
        return he === null || he.tag !== 7 ? (he = Vu(Ee, ge.mode, Ue, pt), he.return = ge, he) : (he = P(he, Ee), he.return = ge, he);
      }
      function He(ge, he, Ee) {
        if (typeof he == "string" && he !== "" || typeof he == "number") return he = ay("" + he, ge.mode, Ee), he.return = ge, he;
        if (typeof he == "object" && he !== null) {
          switch (he.$$typeof) {
            case T:
              return Ee = Gd(he.type, he.key, he.props, null, ge.mode, Ee), Ee.ref = kl(ge, null, he), Ee.return = ge, Ee;
            case M:
              return he = Kh(he, ge.mode, Ee), he.return = ge, he;
            case ie:
              var Ue = he._init;
              return He(ge, Ue(he._payload), Ee);
          }
          if (Dr(he) || fe(he)) return he = Vu(he, ge.mode, Ee, null), he.return = ge, he;
          yh(ge, he);
        }
        return null;
      }
      function ze(ge, he, Ee, Ue) {
        var pt = he !== null ? he.key : null;
        if (typeof Ee == "string" && Ee !== "" || typeof Ee == "number") return pt !== null ? null : re(ge, he, "" + Ee, Ue);
        if (typeof Ee == "object" && Ee !== null) {
          switch (Ee.$$typeof) {
            case T:
              return Ee.key === pt ? le(ge, he, Ee, Ue) : null;
            case M:
              return Ee.key === pt ? Ce(ge, he, Ee, Ue) : null;
            case ie:
              return pt = Ee._init, ze(
                ge,
                he,
                pt(Ee._payload),
                Ue
              );
          }
          if (Dr(Ee) || fe(Ee)) return pt !== null ? null : qe(ge, he, Ee, Ue, null);
          yh(ge, Ee);
        }
        return null;
      }
      function nt(ge, he, Ee, Ue, pt) {
        if (typeof Ue == "string" && Ue !== "" || typeof Ue == "number") return ge = ge.get(Ee) || null, re(he, ge, "" + Ue, pt);
        if (typeof Ue == "object" && Ue !== null) {
          switch (Ue.$$typeof) {
            case T:
              return ge = ge.get(Ue.key === null ? Ee : Ue.key) || null, le(he, ge, Ue, pt);
            case M:
              return ge = ge.get(Ue.key === null ? Ee : Ue.key) || null, Ce(he, ge, Ue, pt);
            case ie:
              var Tt = Ue._init;
              return nt(ge, he, Ee, Tt(Ue._payload), pt);
          }
          if (Dr(Ue) || fe(Ue)) return ge = ge.get(Ee) || null, qe(he, ge, Ue, pt, null);
          yh(he, Ue);
        }
        return null;
      }
      function dt(ge, he, Ee, Ue) {
        for (var pt = null, Tt = null, kt = he, Mt = he = 0, oi = null; kt !== null && Mt < Ee.length; Mt++) {
          kt.index > Mt ? (oi = kt, kt = null) : oi = kt.sibling;
          var xr = ze(ge, kt, Ee[Mt], Ue);
          if (xr === null) {
            kt === null && (kt = oi);
            break;
          }
          l && kt && xr.alternate === null && f(ge, kt), he = j(xr, he, Mt), Tt === null ? pt = xr : Tt.sibling = xr, Tt = xr, kt = oi;
        }
        if (Mt === Ee.length) return g(ge, kt), cn && Dl(ge, Mt), pt;
        if (kt === null) {
          for (; Mt < Ee.length; Mt++) kt = He(ge, Ee[Mt], Ue), kt !== null && (he = j(kt, he, Mt), Tt === null ? pt = kt : Tt.sibling = kt, Tt = kt);
          return cn && Dl(ge, Mt), pt;
        }
        for (kt = _(ge, kt); Mt < Ee.length; Mt++) oi = nt(kt, ge, Mt, Ee[Mt], Ue), oi !== null && (l && oi.alternate !== null && kt.delete(oi.key === null ? Mt : oi.key), he = j(oi, he, Mt), Tt === null ? pt = oi : Tt.sibling = oi, Tt = oi);
        return l && kt.forEach(function(Ws) {
          return f(ge, Ws);
        }), cn && Dl(ge, Mt), pt;
      }
      function mt(ge, he, Ee, Ue) {
        var pt = fe(Ee);
        if (typeof pt != "function") throw Error(r(150));
        if (Ee = pt.call(Ee), Ee == null) throw Error(r(151));
        for (var Tt = pt = null, kt = he, Mt = he = 0, oi = null, xr = Ee.next(); kt !== null && !xr.done; Mt++, xr = Ee.next()) {
          kt.index > Mt ? (oi = kt, kt = null) : oi = kt.sibling;
          var Ws = ze(ge, kt, xr.value, Ue);
          if (Ws === null) {
            kt === null && (kt = oi);
            break;
          }
          l && kt && Ws.alternate === null && f(ge, kt), he = j(Ws, he, Mt), Tt === null ? pt = Ws : Tt.sibling = Ws, Tt = Ws, kt = oi;
        }
        if (xr.done) return g(
          ge,
          kt
        ), cn && Dl(ge, Mt), pt;
        if (kt === null) {
          for (; !xr.done; Mt++, xr = Ee.next()) xr = He(ge, xr.value, Ue), xr !== null && (he = j(xr, he, Mt), Tt === null ? pt = xr : Tt.sibling = xr, Tt = xr);
          return cn && Dl(ge, Mt), pt;
        }
        for (kt = _(ge, kt); !xr.done; Mt++, xr = Ee.next()) xr = nt(kt, ge, Mt, xr.value, Ue), xr !== null && (l && xr.alternate !== null && kt.delete(xr.key === null ? Mt : xr.key), he = j(xr, he, Mt), Tt === null ? pt = xr : Tt.sibling = xr, Tt = xr);
        return l && kt.forEach(function(d1) {
          return f(ge, d1);
        }), cn && Dl(ge, Mt), pt;
      }
      function An(ge, he, Ee, Ue) {
        if (typeof Ee == "object" && Ee !== null && Ee.type === F && Ee.key === null && (Ee = Ee.props.children), typeof Ee == "object" && Ee !== null) {
          switch (Ee.$$typeof) {
            case T:
              e: {
                for (var pt = Ee.key, Tt = he; Tt !== null; ) {
                  if (Tt.key === pt) {
                    if (pt = Ee.type, pt === F) {
                      if (Tt.tag === 7) {
                        g(ge, Tt.sibling), he = P(Tt, Ee.props.children), he.return = ge, ge = he;
                        break e;
                      }
                    } else if (Tt.elementType === pt || typeof pt == "object" && pt !== null && pt.$$typeof === ie && kb(pt) === Tt.type) {
                      g(ge, Tt.sibling), he = P(Tt, Ee.props), he.ref = kl(ge, Tt, Ee), he.return = ge, ge = he;
                      break e;
                    }
                    g(ge, Tt);
                    break;
                  } else f(ge, Tt);
                  Tt = Tt.sibling;
                }
                Ee.type === F ? (he = Vu(Ee.props.children, ge.mode, Ue, Ee.key), he.return = ge, ge = he) : (Ue = Gd(Ee.type, Ee.key, Ee.props, null, ge.mode, Ue), Ue.ref = kl(ge, he, Ee), Ue.return = ge, ge = Ue);
              }
              return U(ge);
            case M:
              e: {
                for (Tt = Ee.key; he !== null; ) {
                  if (he.key === Tt) if (he.tag === 4 && he.stateNode.containerInfo === Ee.containerInfo && he.stateNode.implementation === Ee.implementation) {
                    g(ge, he.sibling), he = P(he, Ee.children || []), he.return = ge, ge = he;
                    break e;
                  } else {
                    g(ge, he);
                    break;
                  }
                  else f(ge, he);
                  he = he.sibling;
                }
                he = Kh(Ee, ge.mode, Ue), he.return = ge, ge = he;
              }
              return U(ge);
            case ie:
              return Tt = Ee._init, An(ge, he, Tt(Ee._payload), Ue);
          }
          if (Dr(Ee)) return dt(ge, he, Ee, Ue);
          if (fe(Ee)) return mt(ge, he, Ee, Ue);
          yh(ge, Ee);
        }
        return typeof Ee == "string" && Ee !== "" || typeof Ee == "number" ? (Ee = "" + Ee, he !== null && he.tag === 6 ? (g(ge, he.sibling), he = P(he, Ee), he.return = ge, ge = he) : (g(ge, he), he = ay(Ee, ge.mode, Ue), he.return = ge, ge = he), U(ge)) : g(ge, he);
      }
      return An;
    }
    var _n = Rl(!0), et = Rl(!1), Na = ko(null), ma = null, Xc = null, Dm = null;
    function km() {
      Dm = Xc = ma = null;
    }
    function Rm(l) {
      var f = Na.current;
      nn(Na), l._currentValue = f;
    }
    function Pm(l, f, g) {
      for (; l !== null; ) {
        var _ = l.alternate;
        if ((l.childLanes & f) !== f ? (l.childLanes |= f, _ !== null && (_.childLanes |= f)) : _ !== null && (_.childLanes & f) !== f && (_.childLanes |= f), l === g) break;
        l = l.return;
      }
    }
    function vn(l, f) {
      ma = l, Dm = Xc = null, l = l.dependencies, l !== null && l.firstContext !== null && ((l.lanes & f) !== 0 && (Bn = !0), l.firstContext = null);
    }
    function io(l) {
      var f = l._currentValue;
      if (Dm !== l) if (l = { context: l, memoizedValue: f, next: null }, Xc === null) {
        if (ma === null) throw Error(r(308));
        Xc = l, ma.dependencies = { lanes: 0, firstContext: l };
      } else Xc = Xc.next = l;
      return f;
    }
    var Pl = null;
    function Mm(l) {
      Pl === null ? Pl = [l] : Pl.push(l);
    }
    function Nm(l, f, g, _) {
      var P = f.interleaved;
      return P === null ? (g.next = g, Mm(f)) : (g.next = P.next, P.next = g), f.interleaved = g, ja(l, _);
    }
    function ja(l, f) {
      l.lanes |= f;
      var g = l.alternate;
      for (g !== null && (g.lanes |= f), g = l, l = l.return; l !== null; ) l.childLanes |= f, g = l.alternate, g !== null && (g.childLanes |= f), g = l, l = l.return;
      return g.tag === 3 ? g.stateNode : null;
    }
    var Fa = !1;
    function jm(l) {
      l.updateQueue = { baseState: l.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
    }
    function Rb(l, f) {
      l = l.updateQueue, f.updateQueue === l && (f.updateQueue = { baseState: l.baseState, firstBaseUpdate: l.firstBaseUpdate, lastBaseUpdate: l.lastBaseUpdate, shared: l.shared, effects: l.effects });
    }
    function $u(l, f) {
      return { eventTime: l, lane: f, tag: 0, payload: null, callback: null, next: null };
    }
    function Fs(l, f, g) {
      var _ = l.updateQueue;
      if (_ === null) return null;
      if (_ = _.shared, (nr & 2) !== 0) {
        var P = _.pending;
        return P === null ? f.next = f : (f.next = P.next, P.next = f), _.pending = f, ja(l, g);
      }
      return P = _.interleaved, P === null ? (f.next = f, Mm(_)) : (f.next = P.next, P.next = f), _.interleaved = f, ja(l, g);
    }
    function gh(l, f, g) {
      if (f = f.updateQueue, f !== null && (f = f.shared, (g & 4194240) !== 0)) {
        var _ = f.lanes;
        _ &= l.pendingLanes, g |= _, f.lanes = g, Ru(l, g);
      }
    }
    function Pb(l, f) {
      var g = l.updateQueue, _ = l.alternate;
      if (_ !== null && (_ = _.updateQueue, g === _)) {
        var P = null, j = null;
        if (g = g.firstBaseUpdate, g !== null) {
          do {
            var U = { eventTime: g.eventTime, lane: g.lane, tag: g.tag, payload: g.payload, callback: g.callback, next: null };
            j === null ? P = j = U : j = j.next = U, g = g.next;
          } while (g !== null);
          j === null ? P = j = f : j = j.next = f;
        } else P = j = f;
        g = { baseState: _.baseState, firstBaseUpdate: P, lastBaseUpdate: j, shared: _.shared, effects: _.effects }, l.updateQueue = g;
        return;
      }
      l = g.lastBaseUpdate, l === null ? g.firstBaseUpdate = f : l.next = f, g.lastBaseUpdate = f;
    }
    function xd(l, f, g, _) {
      var P = l.updateQueue;
      Fa = !1;
      var j = P.firstBaseUpdate, U = P.lastBaseUpdate, re = P.shared.pending;
      if (re !== null) {
        P.shared.pending = null;
        var le = re, Ce = le.next;
        le.next = null, U === null ? j = Ce : U.next = Ce, U = le;
        var qe = l.alternate;
        qe !== null && (qe = qe.updateQueue, re = qe.lastBaseUpdate, re !== U && (re === null ? qe.firstBaseUpdate = Ce : re.next = Ce, qe.lastBaseUpdate = le));
      }
      if (j !== null) {
        var He = P.baseState;
        U = 0, qe = Ce = le = null, re = j;
        do {
          var ze = re.lane, nt = re.eventTime;
          if ((_ & ze) === ze) {
            qe !== null && (qe = qe.next = {
              eventTime: nt,
              lane: 0,
              tag: re.tag,
              payload: re.payload,
              callback: re.callback,
              next: null
            });
            e: {
              var dt = l, mt = re;
              switch (ze = f, nt = g, mt.tag) {
                case 1:
                  if (dt = mt.payload, typeof dt == "function") {
                    He = dt.call(nt, He, ze);
                    break e;
                  }
                  He = dt;
                  break e;
                case 3:
                  dt.flags = dt.flags & -65537 | 128;
                case 0:
                  if (dt = mt.payload, ze = typeof dt == "function" ? dt.call(nt, He, ze) : dt, ze == null) break e;
                  He = Z({}, He, ze);
                  break e;
                case 2:
                  Fa = !0;
              }
            }
            re.callback !== null && re.lane !== 0 && (l.flags |= 64, ze = P.effects, ze === null ? P.effects = [re] : ze.push(re));
          } else nt = { eventTime: nt, lane: ze, tag: re.tag, payload: re.payload, callback: re.callback, next: null }, qe === null ? (Ce = qe = nt, le = He) : qe = qe.next = nt, U |= ze;
          if (re = re.next, re === null) {
            if (re = P.shared.pending, re === null) break;
            ze = re, re = ze.next, ze.next = null, P.lastBaseUpdate = ze, P.shared.pending = null;
          }
        } while (!0);
        if (qe === null && (le = He), P.baseState = le, P.firstBaseUpdate = Ce, P.lastBaseUpdate = qe, f = P.shared.interleaved, f !== null) {
          P = f;
          do
            U |= P.lane, P = P.next;
          while (P !== f);
        } else j === null && (P.shared.lanes = 0);
        fu |= U, l.lanes = U, l.memoizedState = He;
      }
    }
    function Fm(l, f, g) {
      if (l = f.effects, f.effects = null, l !== null) for (f = 0; f < l.length; f++) {
        var _ = l[f], P = _.callback;
        if (P !== null) {
          if (_.callback = null, _ = g, typeof P != "function") throw Error(r(191, P));
          P.call(_);
        }
      }
    }
    var bd = {}, uu = ko(bd), wd = ko(bd), Ed = ko(bd);
    function Ml(l) {
      if (l === bd) throw Error(r(174));
      return l;
    }
    function Im(l, f) {
      switch (wt(Ed, f), wt(wd, l), wt(uu, bd), l = f.nodeType, l) {
        case 9:
        case 11:
          f = (f = f.documentElement) ? f.namespaceURI : xn(null, "");
          break;
        default:
          l = l === 8 ? f.parentNode : f, f = l.namespaceURI || null, l = l.tagName, f = xn(f, l);
      }
      nn(uu), wt(uu, f);
    }
    function Nl() {
      nn(uu), nn(wd), nn(Ed);
    }
    function Mb(l) {
      Ml(Ed.current);
      var f = Ml(uu.current), g = xn(f, l.type);
      f !== g && (wt(wd, l), wt(uu, g));
    }
    function xh(l) {
      wd.current === l && (nn(uu), nn(wd));
    }
    var mn = ko(0);
    function bh(l) {
      for (var f = l; f !== null; ) {
        if (f.tag === 13) {
          var g = f.memoizedState;
          if (g !== null && (g = g.dehydrated, g === null || g.data === "$?" || g.data === "$!")) return f;
        } else if (f.tag === 19 && f.memoizedProps.revealOrder !== void 0) {
          if ((f.flags & 128) !== 0) return f;
        } else if (f.child !== null) {
          f.child.return = f, f = f.child;
          continue;
        }
        if (f === l) break;
        for (; f.sibling === null; ) {
          if (f.return === null || f.return === l) return null;
          f = f.return;
        }
        f.sibling.return = f.return, f = f.sibling;
      }
      return null;
    }
    var Sd = [];
    function St() {
      for (var l = 0; l < Sd.length; l++) Sd[l]._workInProgressVersionPrimary = null;
      Sd.length = 0;
    }
    var Gt = R.ReactCurrentDispatcher, yr = R.ReactCurrentBatchConfig, Ir = 0, gr = null, In = null, ii = null, wh = !1, _d = !1, jl = 0, $e = 0;
    function fr() {
      throw Error(r(321));
    }
    function Rt(l, f) {
      if (f === null) return !1;
      for (var g = 0; g < f.length && g < l.length; g++) if (!Ao(l[g], f[g])) return !1;
      return !0;
    }
    function Is(l, f, g, _, P, j) {
      if (Ir = j, gr = f, f.memoizedState = null, f.updateQueue = null, f.lanes = 0, Gt.current = l === null || l.memoizedState === null ? Fh : kd, l = g(_, P), _d) {
        j = 0;
        do {
          if (_d = !1, jl = 0, 25 <= j) throw Error(r(301));
          j += 1, ii = In = null, f.updateQueue = null, Gt.current = Ih, l = g(_, P);
        } while (_d);
      }
      if (Gt.current = $l, f = In !== null && In.next !== null, Ir = 0, ii = In = gr = null, wh = !1, f) throw Error(r(300));
      return l;
    }
    function Ro() {
      var l = jl !== 0;
      return jl = 0, l;
    }
    function Pi() {
      var l = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
      return ii === null ? gr.memoizedState = ii = l : ii = ii.next = l, ii;
    }
    function Cn() {
      if (In === null) {
        var l = gr.alternate;
        l = l !== null ? l.memoizedState : null;
      } else l = In.next;
      var f = ii === null ? gr.memoizedState : ii.next;
      if (f !== null) ii = f, In = l;
      else {
        if (l === null) throw Error(r(310));
        In = l, l = { memoizedState: In.memoizedState, baseState: In.baseState, baseQueue: In.baseQueue, queue: In.queue, next: null }, ii === null ? gr.memoizedState = ii = l : ii = ii.next = l;
      }
      return ii;
    }
    function zu(l, f) {
      return typeof f == "function" ? f(l) : f;
    }
    function Bs(l) {
      var f = Cn(), g = f.queue;
      if (g === null) throw Error(r(311));
      g.lastRenderedReducer = l;
      var _ = In, P = _.baseQueue, j = g.pending;
      if (j !== null) {
        if (P !== null) {
          var U = P.next;
          P.next = j.next, j.next = U;
        }
        _.baseQueue = P = j, g.pending = null;
      }
      if (P !== null) {
        j = P.next, _ = _.baseState;
        var re = U = null, le = null, Ce = j;
        do {
          var qe = Ce.lane;
          if ((Ir & qe) === qe) le !== null && (le = le.next = { lane: 0, action: Ce.action, hasEagerState: Ce.hasEagerState, eagerState: Ce.eagerState, next: null }), _ = Ce.hasEagerState ? Ce.eagerState : l(_, Ce.action);
          else {
            var He = {
              lane: qe,
              action: Ce.action,
              hasEagerState: Ce.hasEagerState,
              eagerState: Ce.eagerState,
              next: null
            };
            le === null ? (re = le = He, U = _) : le = le.next = He, gr.lanes |= qe, fu |= qe;
          }
          Ce = Ce.next;
        } while (Ce !== null && Ce !== j);
        le === null ? U = _ : le.next = re, Ao(_, f.memoizedState) || (Bn = !0), f.memoizedState = _, f.baseState = U, f.baseQueue = le, g.lastRenderedState = _;
      }
      if (l = g.interleaved, l !== null) {
        P = l;
        do
          j = P.lane, gr.lanes |= j, fu |= j, P = P.next;
        while (P !== l);
      } else P === null && (g.lanes = 0);
      return [f.memoizedState, g.dispatch];
    }
    function Fl(l) {
      var f = Cn(), g = f.queue;
      if (g === null) throw Error(r(311));
      g.lastRenderedReducer = l;
      var _ = g.dispatch, P = g.pending, j = f.memoizedState;
      if (P !== null) {
        g.pending = null;
        var U = P = P.next;
        do
          j = l(j, U.action), U = U.next;
        while (U !== P);
        Ao(j, f.memoizedState) || (Bn = !0), f.memoizedState = j, f.baseQueue === null && (f.baseState = j), g.lastRenderedState = j;
      }
      return [j, _];
    }
    function Eh() {
    }
    function Sh(l, f) {
      var g = gr, _ = Cn(), P = f(), j = !Ao(_.memoizedState, P);
      if (j && (_.memoizedState = P, Bn = !0), _ = _.queue, Cd(Oh.bind(null, g, _, l), [l]), _.getSnapshot !== f || j || ii !== null && ii.memoizedState.tag & 1) {
        if (g.flags |= 2048, Il(9, Ch.bind(null, g, _, P, f), void 0, null), Zn === null) throw Error(r(349));
        (Ir & 30) !== 0 || _h(g, f, P);
      }
      return P;
    }
    function _h(l, f, g) {
      l.flags |= 16384, l = { getSnapshot: f, value: g }, f = gr.updateQueue, f === null ? (f = { lastEffect: null, stores: null }, gr.updateQueue = f, f.stores = [l]) : (g = f.stores, g === null ? f.stores = [l] : g.push(l));
    }
    function Ch(l, f, g, _) {
      f.value = g, f.getSnapshot = _, Th(f) && Ah(l);
    }
    function Oh(l, f, g) {
      return g(function() {
        Th(f) && Ah(l);
      });
    }
    function Th(l) {
      var f = l.getSnapshot;
      l = l.value;
      try {
        var g = f();
        return !Ao(l, g);
      } catch {
        return !0;
      }
    }
    function Ah(l) {
      var f = ja(l, 1);
      f !== null && Yi(f, l, 1, -1);
    }
    function Dh(l) {
      var f = Pi();
      return typeof l == "function" && (l = l()), f.memoizedState = f.baseState = l, l = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: zu, lastRenderedState: l }, f.queue = l, l = l.dispatch = Ll.bind(null, gr, l), [f.memoizedState, l];
    }
    function Il(l, f, g, _) {
      return l = { tag: l, create: f, destroy: g, deps: _, next: null }, f = gr.updateQueue, f === null ? (f = { lastEffect: null, stores: null }, gr.updateQueue = f, f.lastEffect = l.next = l) : (g = f.lastEffect, g === null ? f.lastEffect = l.next = l : (_ = g.next, g.next = l, l.next = _, f.lastEffect = l)), l;
    }
    function kh() {
      return Cn().memoizedState;
    }
    function Zc(l, f, g, _) {
      var P = Pi();
      gr.flags |= l, P.memoizedState = Il(1 | f, g, void 0, _ === void 0 ? null : _);
    }
    function Jc(l, f, g, _) {
      var P = Cn();
      _ = _ === void 0 ? null : _;
      var j = void 0;
      if (In !== null) {
        var U = In.memoizedState;
        if (j = U.destroy, _ !== null && Rt(_, U.deps)) {
          P.memoizedState = Il(f, g, j, _);
          return;
        }
      }
      gr.flags |= l, P.memoizedState = Il(1 | f, g, j, _);
    }
    function Rh(l, f) {
      return Zc(8390656, 8, l, f);
    }
    function Cd(l, f) {
      return Jc(2048, 8, l, f);
    }
    function Ph(l, f) {
      return Jc(4, 2, l, f);
    }
    function Od(l, f) {
      return Jc(4, 4, l, f);
    }
    function Bl(l, f) {
      if (typeof f == "function") return l = l(), f(l), function() {
        f(null);
      };
      if (f != null) return l = l(), f.current = l, function() {
        f.current = null;
      };
    }
    function Mh(l, f, g) {
      return g = g != null ? g.concat([l]) : null, Jc(4, 4, Bl.bind(null, f, l), g);
    }
    function Td() {
    }
    function Nh(l, f) {
      var g = Cn();
      f = f === void 0 ? null : f;
      var _ = g.memoizedState;
      return _ !== null && f !== null && Rt(f, _[1]) ? _[0] : (g.memoizedState = [l, f], l);
    }
    function jh(l, f) {
      var g = Cn();
      f = f === void 0 ? null : f;
      var _ = g.memoizedState;
      return _ !== null && f !== null && Rt(f, _[1]) ? _[0] : (l = l(), g.memoizedState = [l, f], l);
    }
    function Bm(l, f, g) {
      return (Ir & 21) === 0 ? (l.baseState && (l.baseState = !1, Bn = !0), l.memoizedState = g) : (Ao(g, f) || (g = Pc(), gr.lanes |= g, fu |= g, l.baseState = !0), f);
    }
    function Ad(l, f) {
      var g = mr;
      mr = g !== 0 && 4 > g ? g : 4, l(!0);
      var _ = yr.transition;
      yr.transition = {};
      try {
        l(!1), f();
      } finally {
        mr = g, yr.transition = _;
      }
    }
    function Lm() {
      return Cn().memoizedState;
    }
    function Dd(l, f, g) {
      var _ = du(l);
      if (g = { lane: _, action: g, hasEagerState: !1, eagerState: null, next: null }, Ia(l)) Nb(f, g);
      else if (g = Nm(l, f, g, _), g !== null) {
        var P = zn();
        Yi(g, l, _, P), Qr(g, f, _);
      }
    }
    function Ll(l, f, g) {
      var _ = du(l), P = { lane: _, action: g, hasEagerState: !1, eagerState: null, next: null };
      if (Ia(l)) Nb(f, P);
      else {
        var j = l.alternate;
        if (l.lanes === 0 && (j === null || j.lanes === 0) && (j = f.lastRenderedReducer, j !== null)) try {
          var U = f.lastRenderedState, re = j(U, g);
          if (P.hasEagerState = !0, P.eagerState = re, Ao(re, U)) {
            var le = f.interleaved;
            le === null ? (P.next = P, Mm(f)) : (P.next = le.next, le.next = P), f.interleaved = P;
            return;
          }
        } catch {
        } finally {
        }
        g = Nm(l, f, P, _), g !== null && (P = zn(), Yi(g, l, _, P), Qr(g, f, _));
      }
    }
    function Ia(l) {
      var f = l.alternate;
      return l === gr || f !== null && f === gr;
    }
    function Nb(l, f) {
      _d = wh = !0;
      var g = l.pending;
      g === null ? f.next = f : (f.next = g.next, g.next = f), l.pending = f;
    }
    function Qr(l, f, g) {
      if ((g & 4194240) !== 0) {
        var _ = f.lanes;
        _ &= l.pendingLanes, g |= _, f.lanes = g, Ru(l, g);
      }
    }
    var $l = { readContext: io, useCallback: fr, useContext: fr, useEffect: fr, useImperativeHandle: fr, useInsertionEffect: fr, useLayoutEffect: fr, useMemo: fr, useReducer: fr, useRef: fr, useState: fr, useDebugValue: fr, useDeferredValue: fr, useTransition: fr, useMutableSource: fr, useSyncExternalStore: fr, useId: fr, unstable_isNewReconciler: !1 }, Fh = { readContext: io, useCallback: function(l, f) {
      return Pi().memoizedState = [l, f === void 0 ? null : f], l;
    }, useContext: io, useEffect: Rh, useImperativeHandle: function(l, f, g) {
      return g = g != null ? g.concat([l]) : null, Zc(
        4194308,
        4,
        Bl.bind(null, f, l),
        g
      );
    }, useLayoutEffect: function(l, f) {
      return Zc(4194308, 4, l, f);
    }, useInsertionEffect: function(l, f) {
      return Zc(4, 2, l, f);
    }, useMemo: function(l, f) {
      var g = Pi();
      return f = f === void 0 ? null : f, l = l(), g.memoizedState = [l, f], l;
    }, useReducer: function(l, f, g) {
      var _ = Pi();
      return f = g !== void 0 ? g(f) : f, _.memoizedState = _.baseState = f, l = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: l, lastRenderedState: f }, _.queue = l, l = l.dispatch = Dd.bind(null, gr, l), [_.memoizedState, l];
    }, useRef: function(l) {
      var f = Pi();
      return l = { current: l }, f.memoizedState = l;
    }, useState: Dh, useDebugValue: Td, useDeferredValue: function(l) {
      return Pi().memoizedState = l;
    }, useTransition: function() {
      var l = Dh(!1), f = l[0];
      return l = Ad.bind(null, l[1]), Pi().memoizedState = l, [f, l];
    }, useMutableSource: function() {
    }, useSyncExternalStore: function(l, f, g) {
      var _ = gr, P = Pi();
      if (cn) {
        if (g === void 0) throw Error(r(407));
        g = g();
      } else {
        if (g = f(), Zn === null) throw Error(r(349));
        (Ir & 30) !== 0 || _h(_, f, g);
      }
      P.memoizedState = g;
      var j = { value: g, getSnapshot: f };
      return P.queue = j, Rh(Oh.bind(
        null,
        _,
        j,
        l
      ), [l]), _.flags |= 2048, Il(9, Ch.bind(null, _, j, g, f), void 0, null), g;
    }, useId: function() {
      var l = Pi(), f = Zn.identifierPrefix;
      if (cn) {
        var g = ou, _ = au;
        g = (_ & ~(1 << 32 - zi(_) - 1)).toString(32) + g, f = ":" + f + "R" + g, g = jl++, 0 < g && (f += "H" + g.toString(32)), f += ":";
      } else g = $e++, f = ":" + f + "r" + g.toString(32) + ":";
      return l.memoizedState = f;
    }, unstable_isNewReconciler: !1 }, kd = {
      readContext: io,
      useCallback: Nh,
      useContext: io,
      useEffect: Cd,
      useImperativeHandle: Mh,
      useInsertionEffect: Ph,
      useLayoutEffect: Od,
      useMemo: jh,
      useReducer: Bs,
      useRef: kh,
      useState: function() {
        return Bs(zu);
      },
      useDebugValue: Td,
      useDeferredValue: function(l) {
        var f = Cn();
        return Bm(f, In.memoizedState, l);
      },
      useTransition: function() {
        var l = Bs(zu)[0], f = Cn().memoizedState;
        return [l, f];
      },
      useMutableSource: Eh,
      useSyncExternalStore: Sh,
      useId: Lm,
      unstable_isNewReconciler: !1
    }, Ih = { readContext: io, useCallback: Nh, useContext: io, useEffect: Cd, useImperativeHandle: Mh, useInsertionEffect: Ph, useLayoutEffect: Od, useMemo: jh, useReducer: Fl, useRef: kh, useState: function() {
      return Fl(zu);
    }, useDebugValue: Td, useDeferredValue: function(l) {
      var f = Cn();
      return In === null ? f.memoizedState = l : Bm(f, In.memoizedState, l);
    }, useTransition: function() {
      var l = Fl(zu)[0], f = Cn().memoizedState;
      return [l, f];
    }, useMutableSource: Eh, useSyncExternalStore: Sh, useId: Lm, unstable_isNewReconciler: !1 };
    function Po(l, f) {
      if (l && l.defaultProps) {
        f = Z({}, f), l = l.defaultProps;
        for (var g in l) f[g] === void 0 && (f[g] = l[g]);
        return f;
      }
      return f;
    }
    function $m(l, f, g, _) {
      f = l.memoizedState, g = g(_, f), g = g == null ? f : Z({}, f, g), l.memoizedState = g, l.lanes === 0 && (l.updateQueue.baseState = g);
    }
    var Bh = { isMounted: function(l) {
      return (l = l._reactInternals) ? $t(l) === l : !1;
    }, enqueueSetState: function(l, f, g) {
      l = l._reactInternals;
      var _ = zn(), P = du(l), j = $u(_, P);
      j.payload = f, g != null && (j.callback = g), f = Fs(l, j, P), f !== null && (Yi(f, l, P, _), gh(f, l, P));
    }, enqueueReplaceState: function(l, f, g) {
      l = l._reactInternals;
      var _ = zn(), P = du(l), j = $u(_, P);
      j.tag = 1, j.payload = f, g != null && (j.callback = g), f = Fs(l, j, P), f !== null && (Yi(f, l, P, _), gh(f, l, P));
    }, enqueueForceUpdate: function(l, f) {
      l = l._reactInternals;
      var g = zn(), _ = du(l), P = $u(g, _);
      P.tag = 2, f != null && (P.callback = f), f = Fs(l, P, _), f !== null && (Yi(f, l, _, g), gh(f, l, _));
    } };
    function jb(l, f, g, _, P, j, U) {
      return l = l.stateNode, typeof l.shouldComponentUpdate == "function" ? l.shouldComponentUpdate(_, j, U) : f.prototype && f.prototype.isPureReactComponent ? !ld(g, _) || !ld(P, j) : !0;
    }
    function Lh(l, f, g) {
      var _ = !1, P = fa, j = f.contextType;
      return typeof j == "object" && j !== null ? j = io(j) : (P = jn(f) ? da : bn.current, _ = f.contextTypes, j = (_ = _ != null) ? to(l, P) : fa), f = new f(g, j), l.memoizedState = f.state !== null && f.state !== void 0 ? f.state : null, f.updater = Bh, l.stateNode = f, f._reactInternals = l, _ && (l = l.stateNode, l.__reactInternalMemoizedUnmaskedChildContext = P, l.__reactInternalMemoizedMaskedChildContext = j), f;
    }
    function Fb(l, f, g, _) {
      l = f.state, typeof f.componentWillReceiveProps == "function" && f.componentWillReceiveProps(g, _), typeof f.UNSAFE_componentWillReceiveProps == "function" && f.UNSAFE_componentWillReceiveProps(g, _), f.state !== l && Bh.enqueueReplaceState(f, f.state, null);
    }
    function Rd(l, f, g, _) {
      var P = l.stateNode;
      P.props = g, P.state = l.memoizedState, P.refs = {}, jm(l);
      var j = f.contextType;
      typeof j == "object" && j !== null ? P.context = io(j) : (j = jn(f) ? da : bn.current, P.context = to(l, j)), P.state = l.memoizedState, j = f.getDerivedStateFromProps, typeof j == "function" && ($m(l, f, j, g), P.state = l.memoizedState), typeof f.getDerivedStateFromProps == "function" || typeof P.getSnapshotBeforeUpdate == "function" || typeof P.UNSAFE_componentWillMount != "function" && typeof P.componentWillMount != "function" || (f = P.state, typeof P.componentWillMount == "function" && P.componentWillMount(), typeof P.UNSAFE_componentWillMount == "function" && P.UNSAFE_componentWillMount(), f !== P.state && Bh.enqueueReplaceState(P, P.state, null), xd(l, g, P, _), P.state = l.memoizedState), typeof P.componentDidMount == "function" && (l.flags |= 4194308);
    }
    function zl(l, f) {
      try {
        var g = "", _ = f;
        do
          g += De(_), _ = _.return;
        while (_);
        var P = g;
      } catch (j) {
        P = `
Error generating stack: ` + j.message + `
` + j.stack;
      }
      return { value: l, source: f, stack: P, digest: null };
    }
    function zm(l, f, g) {
      return { value: l, source: null, stack: g ?? null, digest: f ?? null };
    }
    function qm(l, f) {
      try {
        console.error(f.value);
      } catch (g) {
        setTimeout(function() {
          throw g;
        });
      }
    }
    var $h = typeof WeakMap == "function" ? WeakMap : Map;
    function Ib(l, f, g) {
      g = $u(-1, g), g.tag = 3, g.payload = { element: null };
      var _ = f.value;
      return g.callback = function() {
        of || (of = !0, Hl = _), qm(l, f);
      }, g;
    }
    function Um(l, f, g) {
      g = $u(-1, g), g.tag = 3;
      var _ = l.type.getDerivedStateFromError;
      if (typeof _ == "function") {
        var P = f.value;
        g.payload = function() {
          return _(P);
        }, g.callback = function() {
          qm(l, f);
        };
      }
      var j = l.stateNode;
      return j !== null && typeof j.componentDidCatch == "function" && (g.callback = function() {
        qm(l, f), typeof _ != "function" && (zs === null ? zs = /* @__PURE__ */ new Set([this]) : zs.add(this));
        var U = f.stack;
        this.componentDidCatch(f.value, { componentStack: U !== null ? U : "" });
      }), g;
    }
    function Hm(l, f, g) {
      var _ = l.pingCache;
      if (_ === null) {
        _ = l.pingCache = new $h();
        var P = /* @__PURE__ */ new Set();
        _.set(f, P);
      } else P = _.get(f), P === void 0 && (P = /* @__PURE__ */ new Set(), _.set(f, P));
      P.has(g) || (P.add(g), l = NC.bind(null, l, f, g), f.then(l, l));
    }
    function Bb(l) {
      do {
        var f;
        if ((f = l.tag === 13) && (f = l.memoizedState, f = f !== null ? f.dehydrated !== null : !0), f) return l;
        l = l.return;
      } while (l !== null);
      return null;
    }
    function Ls(l, f, g, _, P) {
      return (l.mode & 1) === 0 ? (l === f ? l.flags |= 65536 : (l.flags |= 128, g.flags |= 131072, g.flags &= -52805, g.tag === 1 && (g.alternate === null ? g.tag = 17 : (f = $u(-1, 1), f.tag = 2, Fs(g, f, 1))), g.lanes |= 1), l) : (l.flags |= 65536, l.lanes = P, l);
    }
    var Pd = R.ReactCurrentOwner, Bn = !1;
    function yi(l, f, g, _) {
      f.child = l === null ? et(f, null, g, _) : _n(f, l.child, g, _);
    }
    function ya(l, f, g, _, P) {
      g = g.render;
      var j = f.ref;
      return vn(f, P), _ = Is(l, f, g, _, j, P), g = Ro(), l !== null && !Bn ? (f.updateQueue = l.updateQueue, f.flags &= -2053, l.lanes &= ~P, oo(l, f, P)) : (cn && g && hh(f), f.flags |= 1, yi(l, f, _, P), f.child);
    }
    function ql(l, f, g, _, P) {
      if (l === null) {
        var j = g.type;
        return typeof j == "function" && !iy(j) && j.defaultProps === void 0 && g.compare === null && g.defaultProps === void 0 ? (f.tag = 15, f.type = j, qt(l, f, j, _, P)) : (l = Gd(g.type, null, _, f, f.mode, P), l.ref = f.ref, l.return = f, f.child = l);
      }
      if (j = l.child, (l.lanes & P) === 0) {
        var U = j.memoizedProps;
        if (g = g.compare, g = g !== null ? g : ld, g(U, _) && l.ref === f.ref) return oo(l, f, P);
      }
      return f.flags |= 1, l = Us(j, _), l.ref = f.ref, l.return = f, f.child = l;
    }
    function qt(l, f, g, _, P) {
      if (l !== null) {
        var j = l.memoizedProps;
        if (ld(j, _) && l.ref === f.ref) if (Bn = !1, f.pendingProps = _ = j, (l.lanes & P) !== 0) (l.flags & 131072) !== 0 && (Bn = !0);
        else return f.lanes = l.lanes, oo(l, f, P);
      }
      return Lb(l, f, g, _, P);
    }
    function Md(l, f, g) {
      var _ = f.pendingProps, P = _.children, j = l !== null ? l.memoizedState : null;
      if (_.mode === "hidden") if ((f.mode & 1) === 0) f.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, wt(rf, Ba), Ba |= g;
      else {
        if ((g & 1073741824) === 0) return l = j !== null ? j.baseLanes | g : g, f.lanes = f.childLanes = 1073741824, f.memoizedState = { baseLanes: l, cachePool: null, transitions: null }, f.updateQueue = null, wt(rf, Ba), Ba |= l, null;
        f.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, _ = j !== null ? j.baseLanes : g, wt(rf, Ba), Ba |= _;
      }
      else j !== null ? (_ = j.baseLanes | g, f.memoizedState = null) : _ = g, wt(rf, Ba), Ba |= _;
      return yi(l, f, P, g), f.child;
    }
    function Vm(l, f) {
      var g = f.ref;
      (l === null && g !== null || l !== null && l.ref !== g) && (f.flags |= 512, f.flags |= 2097152);
    }
    function Lb(l, f, g, _, P) {
      var j = jn(g) ? da : bn.current;
      return j = to(f, j), vn(f, P), g = Is(l, f, g, _, j, P), _ = Ro(), l !== null && !Bn ? (f.updateQueue = l.updateQueue, f.flags &= -2053, l.lanes &= ~P, oo(l, f, P)) : (cn && _ && hh(f), f.flags |= 1, yi(l, f, g, P), f.child);
    }
    function $b(l, f, g, _, P) {
      if (jn(g)) {
        var j = !0;
        pa(f);
      } else j = !1;
      if (vn(f, P), f.stateNode === null) ao(l, f), Lh(f, g, _), Rd(f, g, _, P), _ = !0;
      else if (l === null) {
        var U = f.stateNode, re = f.memoizedProps;
        U.props = re;
        var le = U.context, Ce = g.contextType;
        typeof Ce == "object" && Ce !== null ? Ce = io(Ce) : (Ce = jn(g) ? da : bn.current, Ce = to(f, Ce));
        var qe = g.getDerivedStateFromProps, He = typeof qe == "function" || typeof U.getSnapshotBeforeUpdate == "function";
        He || typeof U.UNSAFE_componentWillReceiveProps != "function" && typeof U.componentWillReceiveProps != "function" || (re !== _ || le !== Ce) && Fb(f, U, _, Ce), Fa = !1;
        var ze = f.memoizedState;
        U.state = ze, xd(f, _, U, P), le = f.memoizedState, re !== _ || ze !== le || Kn.current || Fa ? (typeof qe == "function" && ($m(f, g, qe, _), le = f.memoizedState), (re = Fa || jb(f, g, re, _, ze, le, Ce)) ? (He || typeof U.UNSAFE_componentWillMount != "function" && typeof U.componentWillMount != "function" || (typeof U.componentWillMount == "function" && U.componentWillMount(), typeof U.UNSAFE_componentWillMount == "function" && U.UNSAFE_componentWillMount()), typeof U.componentDidMount == "function" && (f.flags |= 4194308)) : (typeof U.componentDidMount == "function" && (f.flags |= 4194308), f.memoizedProps = _, f.memoizedState = le), U.props = _, U.state = le, U.context = Ce, _ = re) : (typeof U.componentDidMount == "function" && (f.flags |= 4194308), _ = !1);
      } else {
        U = f.stateNode, Rb(l, f), re = f.memoizedProps, Ce = f.type === f.elementType ? re : Po(f.type, re), U.props = Ce, He = f.pendingProps, ze = U.context, le = g.contextType, typeof le == "object" && le !== null ? le = io(le) : (le = jn(g) ? da : bn.current, le = to(f, le));
        var nt = g.getDerivedStateFromProps;
        (qe = typeof nt == "function" || typeof U.getSnapshotBeforeUpdate == "function") || typeof U.UNSAFE_componentWillReceiveProps != "function" && typeof U.componentWillReceiveProps != "function" || (re !== He || ze !== le) && Fb(f, U, _, le), Fa = !1, ze = f.memoizedState, U.state = ze, xd(f, _, U, P);
        var dt = f.memoizedState;
        re !== He || ze !== dt || Kn.current || Fa ? (typeof nt == "function" && ($m(f, g, nt, _), dt = f.memoizedState), (Ce = Fa || jb(f, g, Ce, _, ze, dt, le) || !1) ? (qe || typeof U.UNSAFE_componentWillUpdate != "function" && typeof U.componentWillUpdate != "function" || (typeof U.componentWillUpdate == "function" && U.componentWillUpdate(_, dt, le), typeof U.UNSAFE_componentWillUpdate == "function" && U.UNSAFE_componentWillUpdate(_, dt, le)), typeof U.componentDidUpdate == "function" && (f.flags |= 4), typeof U.getSnapshotBeforeUpdate == "function" && (f.flags |= 1024)) : (typeof U.componentDidUpdate != "function" || re === l.memoizedProps && ze === l.memoizedState || (f.flags |= 4), typeof U.getSnapshotBeforeUpdate != "function" || re === l.memoizedProps && ze === l.memoizedState || (f.flags |= 1024), f.memoizedProps = _, f.memoizedState = dt), U.props = _, U.state = dt, U.context = le, _ = Ce) : (typeof U.componentDidUpdate != "function" || re === l.memoizedProps && ze === l.memoizedState || (f.flags |= 4), typeof U.getSnapshotBeforeUpdate != "function" || re === l.memoizedProps && ze === l.memoizedState || (f.flags |= 1024), _ = !1);
      }
      return Nd(l, f, g, _, j, P);
    }
    function Nd(l, f, g, _, P, j) {
      Vm(l, f);
      var U = (f.flags & 128) !== 0;
      if (!_ && !U) return P && dh(f, g, !1), oo(l, f, j);
      _ = f.stateNode, Pd.current = f;
      var re = U && typeof g.getDerivedStateFromError != "function" ? null : _.render();
      return f.flags |= 1, l !== null && U ? (f.child = _n(f, l.child, null, j), f.child = _n(f, null, re, j)) : yi(l, f, re, j), f.memoizedState = _.state, P && dh(f, g, !0), f.child;
    }
    function ef(l) {
      var f = l.stateNode;
      f.pendingContext ? Tb(l, f.pendingContext, f.pendingContext !== f.context) : f.context && Tb(l, f.context, !1), Im(l, f.containerInfo);
    }
    function zb(l, f, g, _, P) {
      return js(), Lu(P), f.flags |= 256, yi(l, f, g, _), f.child;
    }
    var zh = { dehydrated: null, treeContext: null, retryLane: 0 };
    function Wm(l) {
      return { baseLanes: l, cachePool: null, transitions: null };
    }
    function qh(l, f, g) {
      var _ = f.pendingProps, P = mn.current, j = !1, U = (f.flags & 128) !== 0, re;
      if ((re = U) || (re = l !== null && l.memoizedState === null ? !1 : (P & 2) !== 0), re ? (j = !0, f.flags &= -129) : (l === null || l.memoizedState !== null) && (P |= 1), wt(mn, P & 1), l === null)
        return Am(f), l = f.memoizedState, l !== null && (l = l.dehydrated, l !== null) ? ((f.mode & 1) === 0 ? f.lanes = 1 : l.data === "$!" ? f.lanes = 8 : f.lanes = 1073741824, null) : (U = _.children, l = _.fallback, j ? (_ = f.mode, j = f.child, U = { mode: "hidden", children: U }, (_ & 1) === 0 && j !== null ? (j.childLanes = 0, j.pendingProps = U) : j = Hs(U, _, 0, null), l = Vu(l, _, g, null), j.return = f, l.return = f, j.sibling = l, f.child = j, f.child.memoizedState = Wm(g), f.memoizedState = zh, l) : Ym(f, U));
      if (P = l.memoizedState, P !== null && (re = P.dehydrated, re !== null)) return qb(l, f, U, _, re, P, g);
      if (j) {
        j = _.fallback, U = f.mode, P = l.child, re = P.sibling;
        var le = { mode: "hidden", children: _.children };
        return (U & 1) === 0 && f.child !== P ? (_ = f.child, _.childLanes = 0, _.pendingProps = le, f.deletions = null) : (_ = Us(P, le), _.subtreeFlags = P.subtreeFlags & 14680064), re !== null ? j = Us(re, j) : (j = Vu(j, U, g, null), j.flags |= 2), j.return = f, _.return = f, _.sibling = j, f.child = _, _ = j, j = f.child, U = l.child.memoizedState, U = U === null ? Wm(g) : { baseLanes: U.baseLanes | g, cachePool: null, transitions: U.transitions }, j.memoizedState = U, j.childLanes = l.childLanes & ~g, f.memoizedState = zh, _;
      }
      return j = l.child, l = j.sibling, _ = Us(j, { mode: "visible", children: _.children }), (f.mode & 1) === 0 && (_.lanes = g), _.return = f, _.sibling = null, l !== null && (g = f.deletions, g === null ? (f.deletions = [l], f.flags |= 16) : g.push(l)), f.child = _, f.memoizedState = null, _;
    }
    function Ym(l, f) {
      return f = Hs({ mode: "visible", children: f }, l.mode, 0, null), f.return = l, l.child = f;
    }
    function jd(l, f, g, _) {
      return _ !== null && Lu(_), _n(f, l.child, null, g), l = Ym(f, f.pendingProps.children), l.flags |= 2, f.memoizedState = null, l;
    }
    function qb(l, f, g, _, P, j, U) {
      if (g)
        return f.flags & 256 ? (f.flags &= -257, _ = zm(Error(r(422))), jd(l, f, U, _)) : f.memoizedState !== null ? (f.child = l.child, f.flags |= 128, null) : (j = _.fallback, P = f.mode, _ = Hs({ mode: "visible", children: _.children }, P, 0, null), j = Vu(j, P, U, null), j.flags |= 2, _.return = f, j.return = f, _.sibling = j, f.child = _, (f.mode & 1) !== 0 && _n(f, l.child, null, U), f.child.memoizedState = Wm(U), f.memoizedState = zh, j);
      if ((f.mode & 1) === 0) return jd(l, f, U, null);
      if (P.data === "$!") {
        if (_ = P.nextSibling && P.nextSibling.dataset, _) var re = _.dgst;
        return _ = re, j = Error(r(419)), _ = zm(j, _, void 0), jd(l, f, U, _);
      }
      if (re = (U & l.childLanes) !== 0, Bn || re) {
        if (_ = Zn, _ !== null) {
          switch (U & -U) {
            case 4:
              P = 2;
              break;
            case 16:
              P = 8;
              break;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              P = 32;
              break;
            case 536870912:
              P = 268435456;
              break;
            default:
              P = 0;
          }
          P = (P & (_.suspendedLanes | U)) !== 0 ? 0 : P, P !== 0 && P !== j.retryLane && (j.retryLane = P, ja(l, P), Yi(_, l, P, -1));
        }
        return ny(), _ = zm(Error(r(421))), jd(l, f, U, _);
      }
      return P.data === "$?" ? (f.flags |= 128, f.child = l.child, f = jC.bind(null, l), P._reactRetry = f, null) : (l = j.treeContext, va = tu(P.nextSibling), ha = f, cn = !0, no = null, l !== null && (Fn[ro++] = au, Fn[ro++] = ou, Fn[ro++] = Ma, au = l.id, ou = l.overflow, Ma = f), f = Ym(f, _.children), f.flags |= 4096, f);
    }
    function Gm(l, f, g) {
      l.lanes |= f;
      var _ = l.alternate;
      _ !== null && (_.lanes |= f), Pm(l.return, f, g);
    }
    function Hi(l, f, g, _, P) {
      var j = l.memoizedState;
      j === null ? l.memoizedState = { isBackwards: f, rendering: null, renderingStartTime: 0, last: _, tail: g, tailMode: P } : (j.isBackwards = f, j.rendering = null, j.renderingStartTime = 0, j.last = _, j.tail = g, j.tailMode = P);
    }
    function su(l, f, g) {
      var _ = f.pendingProps, P = _.revealOrder, j = _.tail;
      if (yi(l, f, _.children, g), _ = mn.current, (_ & 2) !== 0) _ = _ & 1 | 2, f.flags |= 128;
      else {
        if (l !== null && (l.flags & 128) !== 0) e: for (l = f.child; l !== null; ) {
          if (l.tag === 13) l.memoizedState !== null && Gm(l, g, f);
          else if (l.tag === 19) Gm(l, g, f);
          else if (l.child !== null) {
            l.child.return = l, l = l.child;
            continue;
          }
          if (l === f) break e;
          for (; l.sibling === null; ) {
            if (l.return === null || l.return === f) break e;
            l = l.return;
          }
          l.sibling.return = l.return, l = l.sibling;
        }
        _ &= 1;
      }
      if (wt(mn, _), (f.mode & 1) === 0) f.memoizedState = null;
      else switch (P) {
        case "forwards":
          for (g = f.child, P = null; g !== null; ) l = g.alternate, l !== null && bh(l) === null && (P = g), g = g.sibling;
          g = P, g === null ? (P = f.child, f.child = null) : (P = g.sibling, g.sibling = null), Hi(f, !1, P, g, j);
          break;
        case "backwards":
          for (g = null, P = f.child, f.child = null; P !== null; ) {
            if (l = P.alternate, l !== null && bh(l) === null) {
              f.child = P;
              break;
            }
            l = P.sibling, P.sibling = g, g = P, P = l;
          }
          Hi(f, !0, g, null, j);
          break;
        case "together":
          Hi(f, !1, null, null, void 0);
          break;
        default:
          f.memoizedState = null;
      }
      return f.child;
    }
    function ao(l, f) {
      (f.mode & 1) === 0 && l !== null && (l.alternate = null, f.alternate = null, f.flags |= 2);
    }
    function oo(l, f, g) {
      if (l !== null && (f.dependencies = l.dependencies), fu |= f.lanes, (g & f.childLanes) === 0) return null;
      if (l !== null && f.child !== l.child) throw Error(r(153));
      if (f.child !== null) {
        for (l = f.child, g = Us(l, l.pendingProps), f.child = g, g.return = f; l.sibling !== null; ) l = l.sibling, g = g.sibling = Us(l, l.pendingProps), g.return = f;
        g.sibling = null;
      }
      return f.child;
    }
    function Fd(l, f, g) {
      switch (f.tag) {
        case 3:
          ef(f), js();
          break;
        case 5:
          Mb(f);
          break;
        case 1:
          jn(f.type) && pa(f);
          break;
        case 4:
          Im(f, f.stateNode.containerInfo);
          break;
        case 10:
          var _ = f.type._context, P = f.memoizedProps.value;
          wt(Na, _._currentValue), _._currentValue = P;
          break;
        case 13:
          if (_ = f.memoizedState, _ !== null)
            return _.dehydrated !== null ? (wt(mn, mn.current & 1), f.flags |= 128, null) : (g & f.child.childLanes) !== 0 ? qh(l, f, g) : (wt(mn, mn.current & 1), l = oo(l, f, g), l !== null ? l.sibling : null);
          wt(mn, mn.current & 1);
          break;
        case 19:
          if (_ = (g & f.childLanes) !== 0, (l.flags & 128) !== 0) {
            if (_) return su(l, f, g);
            f.flags |= 128;
          }
          if (P = f.memoizedState, P !== null && (P.rendering = null, P.tail = null, P.lastEffect = null), wt(mn, mn.current), _) break;
          return null;
        case 22:
        case 23:
          return f.lanes = 0, Md(l, f, g);
      }
      return oo(l, f, g);
    }
    var uo, Ln, Ub, Hb;
    uo = function(l, f) {
      for (var g = f.child; g !== null; ) {
        if (g.tag === 5 || g.tag === 6) l.appendChild(g.stateNode);
        else if (g.tag !== 4 && g.child !== null) {
          g.child.return = g, g = g.child;
          continue;
        }
        if (g === f) break;
        for (; g.sibling === null; ) {
          if (g.return === null || g.return === f) return;
          g = g.return;
        }
        g.sibling.return = g.return, g = g.sibling;
      }
    }, Ln = function() {
    }, Ub = function(l, f, g, _) {
      var P = l.memoizedProps;
      if (P !== _) {
        l = f.stateNode, Ml(uu.current);
        var j = null;
        switch (g) {
          case "input":
            P = Ne(l, P), _ = Ne(l, _), j = [];
            break;
          case "select":
            P = Z({}, P, { value: void 0 }), _ = Z({}, _, { value: void 0 }), j = [];
            break;
          case "textarea":
            P = Ut(l, P), _ = Ut(l, _), j = [];
            break;
          default:
            typeof P.onClick != "function" && typeof _.onClick == "function" && (l.onclick = Ds);
        }
        Gr(g, _);
        var U;
        g = null;
        for (Ce in P) if (!_.hasOwnProperty(Ce) && P.hasOwnProperty(Ce) && P[Ce] != null) if (Ce === "style") {
          var re = P[Ce];
          for (U in re) re.hasOwnProperty(U) && (g || (g = {}), g[U] = "");
        } else Ce !== "dangerouslySetInnerHTML" && Ce !== "children" && Ce !== "suppressContentEditableWarning" && Ce !== "suppressHydrationWarning" && Ce !== "autoFocus" && (i.hasOwnProperty(Ce) ? j || (j = []) : (j = j || []).push(Ce, null));
        for (Ce in _) {
          var le = _[Ce];
          if (re = P != null ? P[Ce] : void 0, _.hasOwnProperty(Ce) && le !== re && (le != null || re != null)) if (Ce === "style") if (re) {
            for (U in re) !re.hasOwnProperty(U) || le && le.hasOwnProperty(U) || (g || (g = {}), g[U] = "");
            for (U in le) le.hasOwnProperty(U) && re[U] !== le[U] && (g || (g = {}), g[U] = le[U]);
          } else g || (j || (j = []), j.push(
            Ce,
            g
          )), g = le;
          else Ce === "dangerouslySetInnerHTML" ? (le = le ? le.__html : void 0, re = re ? re.__html : void 0, le != null && re !== le && (j = j || []).push(Ce, le)) : Ce === "children" ? typeof le != "string" && typeof le != "number" || (j = j || []).push(Ce, "" + le) : Ce !== "suppressContentEditableWarning" && Ce !== "suppressHydrationWarning" && (i.hasOwnProperty(Ce) ? (le != null && Ce === "onScroll" && Cr("scroll", l), j || re === le || (j = [])) : (j = j || []).push(Ce, le));
        }
        g && (j = j || []).push("style", g);
        var Ce = j;
        (f.updateQueue = Ce) && (f.flags |= 4);
      }
    }, Hb = function(l, f, g, _) {
      g !== _ && (f.flags |= 4);
    };
    function Id(l, f) {
      if (!cn) switch (l.tailMode) {
        case "hidden":
          f = l.tail;
          for (var g = null; f !== null; ) f.alternate !== null && (g = f), f = f.sibling;
          g === null ? l.tail = null : g.sibling = null;
          break;
        case "collapsed":
          g = l.tail;
          for (var _ = null; g !== null; ) g.alternate !== null && (_ = g), g = g.sibling;
          _ === null ? f || l.tail === null ? l.tail = null : l.tail.sibling = null : _.sibling = null;
      }
    }
    function ai(l) {
      var f = l.alternate !== null && l.alternate.child === l.child, g = 0, _ = 0;
      if (f) for (var P = l.child; P !== null; ) g |= P.lanes | P.childLanes, _ |= P.subtreeFlags & 14680064, _ |= P.flags & 14680064, P.return = l, P = P.sibling;
      else for (P = l.child; P !== null; ) g |= P.lanes | P.childLanes, _ |= P.subtreeFlags, _ |= P.flags, P.return = l, P = P.sibling;
      return l.subtreeFlags |= _, l.childLanes = g, f;
    }
    function Vb(l, f, g) {
      var _ = f.pendingProps;
      switch (vh(f), f.tag) {
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return ai(f), null;
        case 1:
          return jn(f.type) && Qc(), ai(f), null;
        case 3:
          return _ = f.stateNode, Nl(), nn(Kn), nn(bn), St(), _.pendingContext && (_.context = _.pendingContext, _.pendingContext = null), (l === null || l.child === null) && (mh(f) ? f.flags |= 4 : l === null || l.memoizedState.isDehydrated && (f.flags & 256) === 0 || (f.flags |= 1024, no !== null && (Vl(no), no = null))), Ln(l, f), ai(f), null;
        case 5:
          xh(f);
          var P = Ml(Ed.current);
          if (g = f.type, l !== null && f.stateNode != null) Ub(l, f, g, _, P), l.ref !== f.ref && (f.flags |= 512, f.flags |= 2097152);
          else {
            if (!_) {
              if (f.stateNode === null) throw Error(r(166));
              return ai(f), null;
            }
            if (l = Ml(uu.current), mh(f)) {
              _ = f.stateNode, g = f.type;
              var j = f.memoizedProps;
              switch (_[ru] = f, _[vd] = j, l = (f.mode & 1) !== 0, g) {
                case "dialog":
                  Cr("cancel", _), Cr("close", _);
                  break;
                case "iframe":
                case "object":
                case "embed":
                  Cr("load", _);
                  break;
                case "video":
                case "audio":
                  for (P = 0; P < dd.length; P++) Cr(dd[P], _);
                  break;
                case "source":
                  Cr("error", _);
                  break;
                case "img":
                case "image":
                case "link":
                  Cr(
                    "error",
                    _
                  ), Cr("load", _);
                  break;
                case "details":
                  Cr("toggle", _);
                  break;
                case "input":
                  Ot(_, j), Cr("invalid", _);
                  break;
                case "select":
                  _._wrapperState = { wasMultiple: !!j.multiple }, Cr("invalid", _);
                  break;
                case "textarea":
                  kr(_, j), Cr("invalid", _);
              }
              Gr(g, j), P = null;
              for (var U in j) if (j.hasOwnProperty(U)) {
                var re = j[U];
                U === "children" ? typeof re == "string" ? _.textContent !== re && (j.suppressHydrationWarning !== !0 && sh(_.textContent, re, l), P = ["children", re]) : typeof re == "number" && _.textContent !== "" + re && (j.suppressHydrationWarning !== !0 && sh(
                  _.textContent,
                  re,
                  l
                ), P = ["children", "" + re]) : i.hasOwnProperty(U) && re != null && U === "onScroll" && Cr("scroll", _);
              }
              switch (g) {
                case "input":
                  Ye(_), Wr(_, j, !0);
                  break;
                case "textarea":
                  Ye(_), Yr(_);
                  break;
                case "select":
                case "option":
                  break;
                default:
                  typeof j.onClick == "function" && (_.onclick = Ds);
              }
              _ = P, f.updateQueue = _, _ !== null && (f.flags |= 4);
            } else {
              U = P.nodeType === 9 ? P : P.ownerDocument, l === "http://www.w3.org/1999/xhtml" && (l = Jr(g)), l === "http://www.w3.org/1999/xhtml" ? g === "script" ? (l = U.createElement("div"), l.innerHTML = "<script><\/script>", l = l.removeChild(l.firstChild)) : typeof _.is == "string" ? l = U.createElement(g, { is: _.is }) : (l = U.createElement(g), g === "select" && (U = l, _.multiple ? U.multiple = !0 : _.size && (U.size = _.size))) : l = U.createElementNS(l, g), l[ru] = f, l[vd] = _, uo(l, f, !1, !1), f.stateNode = l;
              e: {
                switch (U = Mn(g, _), g) {
                  case "dialog":
                    Cr("cancel", l), Cr("close", l), P = _;
                    break;
                  case "iframe":
                  case "object":
                  case "embed":
                    Cr("load", l), P = _;
                    break;
                  case "video":
                  case "audio":
                    for (P = 0; P < dd.length; P++) Cr(dd[P], l);
                    P = _;
                    break;
                  case "source":
                    Cr("error", l), P = _;
                    break;
                  case "img":
                  case "image":
                  case "link":
                    Cr(
                      "error",
                      l
                    ), Cr("load", l), P = _;
                    break;
                  case "details":
                    Cr("toggle", l), P = _;
                    break;
                  case "input":
                    Ot(l, _), P = Ne(l, _), Cr("invalid", l);
                    break;
                  case "option":
                    P = _;
                    break;
                  case "select":
                    l._wrapperState = { wasMultiple: !!_.multiple }, P = Z({}, _, { value: void 0 }), Cr("invalid", l);
                    break;
                  case "textarea":
                    kr(l, _), P = Ut(l, _), Cr("invalid", l);
                    break;
                  default:
                    P = _;
                }
                Gr(g, P), re = P;
                for (j in re) if (re.hasOwnProperty(j)) {
                  var le = re[j];
                  j === "style" ? Rr(l, le) : j === "dangerouslySetInnerHTML" ? (le = le ? le.__html : void 0, le != null && Ra(l, le)) : j === "children" ? typeof le == "string" ? (g !== "textarea" || le !== "") && Ge(l, le) : typeof le == "number" && Ge(l, "" + le) : j !== "suppressContentEditableWarning" && j !== "suppressHydrationWarning" && j !== "autoFocus" && (i.hasOwnProperty(j) ? le != null && j === "onScroll" && Cr("scroll", l) : le != null && A(l, j, le, U));
                }
                switch (g) {
                  case "input":
                    Ye(l), Wr(l, _, !1);
                    break;
                  case "textarea":
                    Ye(l), Yr(l);
                    break;
                  case "option":
                    _.value != null && l.setAttribute("value", "" + Te(_.value));
                    break;
                  case "select":
                    l.multiple = !!_.multiple, j = _.value, j != null ? Vt(l, !!_.multiple, j, !1) : _.defaultValue != null && Vt(
                      l,
                      !!_.multiple,
                      _.defaultValue,
                      !0
                    );
                    break;
                  default:
                    typeof P.onClick == "function" && (l.onclick = Ds);
                }
                switch (g) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    _ = !!_.autoFocus;
                    break e;
                  case "img":
                    _ = !0;
                    break e;
                  default:
                    _ = !1;
                }
              }
              _ && (f.flags |= 4);
            }
            f.ref !== null && (f.flags |= 512, f.flags |= 2097152);
          }
          return ai(f), null;
        case 6:
          if (l && f.stateNode != null) Hb(l, f, l.memoizedProps, _);
          else {
            if (typeof _ != "string" && f.stateNode === null) throw Error(r(166));
            if (g = Ml(Ed.current), Ml(uu.current), mh(f)) {
              if (_ = f.stateNode, g = f.memoizedProps, _[ru] = f, (j = _.nodeValue !== g) && (l = ha, l !== null)) switch (l.tag) {
                case 3:
                  sh(_.nodeValue, g, (l.mode & 1) !== 0);
                  break;
                case 5:
                  l.memoizedProps.suppressHydrationWarning !== !0 && sh(_.nodeValue, g, (l.mode & 1) !== 0);
              }
              j && (f.flags |= 4);
            } else _ = (g.nodeType === 9 ? g : g.ownerDocument).createTextNode(_), _[ru] = f, f.stateNode = _;
          }
          return ai(f), null;
        case 13:
          if (nn(mn), _ = f.memoizedState, l === null || l.memoizedState !== null && l.memoizedState.dehydrated !== null) {
            if (cn && va !== null && (f.mode & 1) !== 0 && (f.flags & 128) === 0) gd(), js(), f.flags |= 98560, j = !1;
            else if (j = mh(f), _ !== null && _.dehydrated !== null) {
              if (l === null) {
                if (!j) throw Error(r(318));
                if (j = f.memoizedState, j = j !== null ? j.dehydrated : null, !j) throw Error(r(317));
                j[ru] = f;
              } else js(), (f.flags & 128) === 0 && (f.memoizedState = null), f.flags |= 4;
              ai(f), j = !1;
            } else no !== null && (Vl(no), no = null), j = !0;
            if (!j) return f.flags & 65536 ? f : null;
          }
          return (f.flags & 128) !== 0 ? (f.lanes = g, f) : (_ = _ !== null, _ !== (l !== null && l.memoizedState !== null) && _ && (f.child.flags |= 8192, (f.mode & 1) !== 0 && (l === null || (mn.current & 1) !== 0 ? Tn === 0 && (Tn = 3) : ny())), f.updateQueue !== null && (f.flags |= 4), ai(f), null);
        case 4:
          return Nl(), Ln(l, f), l === null && Hc(f.stateNode.containerInfo), ai(f), null;
        case 10:
          return Rm(f.type._context), ai(f), null;
        case 17:
          return jn(f.type) && Qc(), ai(f), null;
        case 19:
          if (nn(mn), j = f.memoizedState, j === null) return ai(f), null;
          if (_ = (f.flags & 128) !== 0, U = j.rendering, U === null) if (_) Id(j, !1);
          else {
            if (Tn !== 0 || l !== null && (l.flags & 128) !== 0) for (l = f.child; l !== null; ) {
              if (U = bh(l), U !== null) {
                for (f.flags |= 128, Id(j, !1), _ = U.updateQueue, _ !== null && (f.updateQueue = _, f.flags |= 4), f.subtreeFlags = 0, _ = g, g = f.child; g !== null; ) j = g, l = _, j.flags &= 14680066, U = j.alternate, U === null ? (j.childLanes = 0, j.lanes = l, j.child = null, j.subtreeFlags = 0, j.memoizedProps = null, j.memoizedState = null, j.updateQueue = null, j.dependencies = null, j.stateNode = null) : (j.childLanes = U.childLanes, j.lanes = U.lanes, j.child = U.child, j.subtreeFlags = 0, j.deletions = null, j.memoizedProps = U.memoizedProps, j.memoizedState = U.memoizedState, j.updateQueue = U.updateQueue, j.type = U.type, l = U.dependencies, j.dependencies = l === null ? null : { lanes: l.lanes, firstContext: l.firstContext }), g = g.sibling;
                return wt(mn, mn.current & 1 | 2), f.child;
              }
              l = l.sibling;
            }
            j.tail !== null && zt() > af && (f.flags |= 128, _ = !0, Id(j, !1), f.lanes = 4194304);
          }
          else {
            if (!_) if (l = bh(U), l !== null) {
              if (f.flags |= 128, _ = !0, g = l.updateQueue, g !== null && (f.updateQueue = g, f.flags |= 4), Id(j, !0), j.tail === null && j.tailMode === "hidden" && !U.alternate && !cn) return ai(f), null;
            } else 2 * zt() - j.renderingStartTime > af && g !== 1073741824 && (f.flags |= 128, _ = !0, Id(j, !1), f.lanes = 4194304);
            j.isBackwards ? (U.sibling = f.child, f.child = U) : (g = j.last, g !== null ? g.sibling = U : f.child = U, j.last = U);
          }
          return j.tail !== null ? (f = j.tail, j.rendering = f, j.tail = f.sibling, j.renderingStartTime = zt(), f.sibling = null, g = mn.current, wt(mn, _ ? g & 1 | 2 : g & 1), f) : (ai(f), null);
        case 22:
        case 23:
          return ry(), _ = f.memoizedState !== null, l !== null && l.memoizedState !== null !== _ && (f.flags |= 8192), _ && (f.mode & 1) !== 0 ? (Ba & 1073741824) !== 0 && (ai(f), f.subtreeFlags & 6 && (f.flags |= 8192)) : ai(f), null;
        case 24:
          return null;
        case 25:
          return null;
      }
      throw Error(r(156, f.tag));
    }
    function Uh(l, f) {
      switch (vh(f), f.tag) {
        case 1:
          return jn(f.type) && Qc(), l = f.flags, l & 65536 ? (f.flags = l & -65537 | 128, f) : null;
        case 3:
          return Nl(), nn(Kn), nn(bn), St(), l = f.flags, (l & 65536) !== 0 && (l & 128) === 0 ? (f.flags = l & -65537 | 128, f) : null;
        case 5:
          return xh(f), null;
        case 13:
          if (nn(mn), l = f.memoizedState, l !== null && l.dehydrated !== null) {
            if (f.alternate === null) throw Error(r(340));
            js();
          }
          return l = f.flags, l & 65536 ? (f.flags = l & -65537 | 128, f) : null;
        case 19:
          return nn(mn), null;
        case 4:
          return Nl(), null;
        case 10:
          return Rm(f.type._context), null;
        case 22:
        case 23:
          return ry(), null;
        case 24:
          return null;
        default:
          return null;
      }
    }
    var Bd = !1, Mi = !1, AC = typeof WeakSet == "function" ? WeakSet : Set, ut = null;
    function tf(l, f) {
      var g = l.ref;
      if (g !== null) if (typeof g == "function") try {
        g(null);
      } catch (_) {
        fn(l, f, _);
      }
      else g.current = null;
    }
    function Hh(l, f, g) {
      try {
        g();
      } catch (_) {
        fn(l, f, _);
      }
    }
    var Wb = !1;
    function Yb(l, f) {
      if (hd = Za, l = cd(), eh(l)) {
        if ("selectionStart" in l) var g = { start: l.selectionStart, end: l.selectionEnd };
        else e: {
          g = (g = l.ownerDocument) && g.defaultView || window;
          var _ = g.getSelection && g.getSelection();
          if (_ && _.rangeCount !== 0) {
            g = _.anchorNode;
            var P = _.anchorOffset, j = _.focusNode;
            _ = _.focusOffset;
            try {
              g.nodeType, j.nodeType;
            } catch {
              g = null;
              break e;
            }
            var U = 0, re = -1, le = -1, Ce = 0, qe = 0, He = l, ze = null;
            t: for (; ; ) {
              for (var nt; He !== g || P !== 0 && He.nodeType !== 3 || (re = U + P), He !== j || _ !== 0 && He.nodeType !== 3 || (le = U + _), He.nodeType === 3 && (U += He.nodeValue.length), (nt = He.firstChild) !== null; )
                ze = He, He = nt;
              for (; ; ) {
                if (He === l) break t;
                if (ze === g && ++Ce === P && (re = U), ze === j && ++qe === _ && (le = U), (nt = He.nextSibling) !== null) break;
                He = ze, ze = He.parentNode;
              }
              He = nt;
            }
            g = re === -1 || le === -1 ? null : { start: re, end: le };
          } else g = null;
        }
        g = g || { start: 0, end: 0 };
      } else g = null;
      for (Tl = { focusedElem: l, selectionRange: g }, Za = !1, ut = f; ut !== null; ) if (f = ut, l = f.child, (f.subtreeFlags & 1028) !== 0 && l !== null) l.return = f, ut = l;
      else for (; ut !== null; ) {
        f = ut;
        try {
          var dt = f.alternate;
          if ((f.flags & 1024) !== 0) switch (f.tag) {
            case 0:
            case 11:
            case 15:
              break;
            case 1:
              if (dt !== null) {
                var mt = dt.memoizedProps, An = dt.memoizedState, ge = f.stateNode, he = ge.getSnapshotBeforeUpdate(f.elementType === f.type ? mt : Po(f.type, mt), An);
                ge.__reactInternalSnapshotBeforeUpdate = he;
              }
              break;
            case 3:
              var Ee = f.stateNode.containerInfo;
              Ee.nodeType === 1 ? Ee.textContent = "" : Ee.nodeType === 9 && Ee.documentElement && Ee.removeChild(Ee.documentElement);
              break;
            case 5:
            case 6:
            case 4:
            case 17:
              break;
            default:
              throw Error(r(163));
          }
        } catch (Ue) {
          fn(f, f.return, Ue);
        }
        if (l = f.sibling, l !== null) {
          l.return = f.return, ut = l;
          break;
        }
        ut = f.return;
      }
      return dt = Wb, Wb = !1, dt;
    }
    function Ld(l, f, g) {
      var _ = f.updateQueue;
      if (_ = _ !== null ? _.lastEffect : null, _ !== null) {
        var P = _ = _.next;
        do {
          if ((P.tag & l) === l) {
            var j = P.destroy;
            P.destroy = void 0, j !== void 0 && Hh(f, g, j);
          }
          P = P.next;
        } while (P !== _);
      }
    }
    function $d(l, f) {
      if (f = f.updateQueue, f = f !== null ? f.lastEffect : null, f !== null) {
        var g = f = f.next;
        do {
          if ((g.tag & l) === l) {
            var _ = g.create;
            g.destroy = _();
          }
          g = g.next;
        } while (g !== f);
      }
    }
    function Qm(l) {
      var f = l.ref;
      if (f !== null) {
        var g = l.stateNode;
        switch (l.tag) {
          case 5:
            l = g;
            break;
          default:
            l = g;
        }
        typeof f == "function" ? f(l) : f.current = l;
      }
    }
    function Vh(l) {
      var f = l.alternate;
      f !== null && (l.alternate = null, Vh(f)), l.child = null, l.deletions = null, l.sibling = null, l.tag === 5 && (f = l.stateNode, f !== null && (delete f[ru], delete f[vd], delete f[md], delete f[Gc], delete f[OC])), l.stateNode = null, l.return = null, l.dependencies = null, l.memoizedProps = null, l.memoizedState = null, l.pendingProps = null, l.stateNode = null, l.updateQueue = null;
    }
    function zd(l) {
      return l.tag === 5 || l.tag === 3 || l.tag === 4;
    }
    function qu(l) {
      e: for (; ; ) {
        for (; l.sibling === null; ) {
          if (l.return === null || zd(l.return)) return null;
          l = l.return;
        }
        for (l.sibling.return = l.return, l = l.sibling; l.tag !== 5 && l.tag !== 6 && l.tag !== 18; ) {
          if (l.flags & 2 || l.child === null || l.tag === 4) continue e;
          l.child.return = l, l = l.child;
        }
        if (!(l.flags & 2)) return l.stateNode;
      }
    }
    function lu(l, f, g) {
      var _ = l.tag;
      if (_ === 5 || _ === 6) l = l.stateNode, f ? g.nodeType === 8 ? g.parentNode.insertBefore(l, f) : g.insertBefore(l, f) : (g.nodeType === 8 ? (f = g.parentNode, f.insertBefore(l, g)) : (f = g, f.appendChild(l)), g = g._reactRootContainer, g != null || f.onclick !== null || (f.onclick = Ds));
      else if (_ !== 4 && (l = l.child, l !== null)) for (lu(l, f, g), l = l.sibling; l !== null; ) lu(l, f, g), l = l.sibling;
    }
    function cu(l, f, g) {
      var _ = l.tag;
      if (_ === 5 || _ === 6) l = l.stateNode, f ? g.insertBefore(l, f) : g.appendChild(l);
      else if (_ !== 4 && (l = l.child, l !== null)) for (cu(l, f, g), l = l.sibling; l !== null; ) cu(l, f, g), l = l.sibling;
    }
    var On = null, Vi = !1;
    function Wi(l, f, g) {
      for (g = g.child; g !== null; ) Gb(l, f, g), g = g.sibling;
    }
    function Gb(l, f, g) {
      if (la && typeof la.onCommitFiberUnmount == "function") try {
        la.onCommitFiberUnmount(bs, g);
      } catch {
      }
      switch (g.tag) {
        case 5:
          Mi || tf(g, f);
        case 6:
          var _ = On, P = Vi;
          On = null, Wi(l, f, g), On = _, Vi = P, On !== null && (Vi ? (l = On, g = g.stateNode, l.nodeType === 8 ? l.parentNode.removeChild(g) : l.removeChild(g)) : On.removeChild(g.stateNode));
          break;
        case 18:
          On !== null && (Vi ? (l = On, g = g.stateNode, l.nodeType === 8 ? Yc(l.parentNode, g) : l.nodeType === 1 && Yc(l, g), Oo(l)) : Yc(On, g.stateNode));
          break;
        case 4:
          _ = On, P = Vi, On = g.stateNode.containerInfo, Vi = !0, Wi(l, f, g), On = _, Vi = P;
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          if (!Mi && (_ = g.updateQueue, _ !== null && (_ = _.lastEffect, _ !== null))) {
            P = _ = _.next;
            do {
              var j = P, U = j.destroy;
              j = j.tag, U !== void 0 && ((j & 2) !== 0 || (j & 4) !== 0) && Hh(g, f, U), P = P.next;
            } while (P !== _);
          }
          Wi(l, f, g);
          break;
        case 1:
          if (!Mi && (tf(g, f), _ = g.stateNode, typeof _.componentWillUnmount == "function")) try {
            _.props = g.memoizedProps, _.state = g.memoizedState, _.componentWillUnmount();
          } catch (re) {
            fn(g, f, re);
          }
          Wi(l, f, g);
          break;
        case 21:
          Wi(l, f, g);
          break;
        case 22:
          g.mode & 1 ? (Mi = (_ = Mi) || g.memoizedState !== null, Wi(l, f, g), Mi = _) : Wi(l, f, g);
          break;
        default:
          Wi(l, f, g);
      }
    }
    function Qb(l) {
      var f = l.updateQueue;
      if (f !== null) {
        l.updateQueue = null;
        var g = l.stateNode;
        g === null && (g = l.stateNode = new AC()), f.forEach(function(_) {
          var P = i1.bind(null, l, _);
          g.has(_) || (g.add(_), _.then(P, P));
        });
      }
    }
    function Mo(l, f) {
      var g = f.deletions;
      if (g !== null) for (var _ = 0; _ < g.length; _++) {
        var P = g[_];
        try {
          var j = l, U = f, re = U;
          e: for (; re !== null; ) {
            switch (re.tag) {
              case 5:
                On = re.stateNode, Vi = !1;
                break e;
              case 3:
                On = re.stateNode.containerInfo, Vi = !0;
                break e;
              case 4:
                On = re.stateNode.containerInfo, Vi = !0;
                break e;
            }
            re = re.return;
          }
          if (On === null) throw Error(r(160));
          Gb(j, U, P), On = null, Vi = !1;
          var le = P.alternate;
          le !== null && (le.return = null), P.return = null;
        } catch (Ce) {
          fn(P, f, Ce);
        }
      }
      if (f.subtreeFlags & 12854) for (f = f.child; f !== null; ) Km(f, l), f = f.sibling;
    }
    function Km(l, f) {
      var g = l.alternate, _ = l.flags;
      switch (l.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          if (Mo(f, l), ga(l), _ & 4) {
            try {
              Ld(3, l, l.return), $d(3, l);
            } catch (mt) {
              fn(l, l.return, mt);
            }
            try {
              Ld(5, l, l.return);
            } catch (mt) {
              fn(l, l.return, mt);
            }
          }
          break;
        case 1:
          Mo(f, l), ga(l), _ & 512 && g !== null && tf(g, g.return);
          break;
        case 5:
          if (Mo(f, l), ga(l), _ & 512 && g !== null && tf(g, g.return), l.flags & 32) {
            var P = l.stateNode;
            try {
              Ge(P, "");
            } catch (mt) {
              fn(l, l.return, mt);
            }
          }
          if (_ & 4 && (P = l.stateNode, P != null)) {
            var j = l.memoizedProps, U = g !== null ? g.memoizedProps : j, re = l.type, le = l.updateQueue;
            if (l.updateQueue = null, le !== null) try {
              re === "input" && j.type === "radio" && j.name != null && At(P, j), Mn(re, U);
              var Ce = Mn(re, j);
              for (U = 0; U < le.length; U += 2) {
                var qe = le[U], He = le[U + 1];
                qe === "style" ? Rr(P, He) : qe === "dangerouslySetInnerHTML" ? Ra(P, He) : qe === "children" ? Ge(P, He) : A(P, qe, He, Ce);
              }
              switch (re) {
                case "input":
                  Qt(P, j);
                  break;
                case "textarea":
                  Pn(P, j);
                  break;
                case "select":
                  var ze = P._wrapperState.wasMultiple;
                  P._wrapperState.wasMultiple = !!j.multiple;
                  var nt = j.value;
                  nt != null ? Vt(P, !!j.multiple, nt, !1) : ze !== !!j.multiple && (j.defaultValue != null ? Vt(
                    P,
                    !!j.multiple,
                    j.defaultValue,
                    !0
                  ) : Vt(P, !!j.multiple, j.multiple ? [] : "", !1));
              }
              P[vd] = j;
            } catch (mt) {
              fn(l, l.return, mt);
            }
          }
          break;
        case 6:
          if (Mo(f, l), ga(l), _ & 4) {
            if (l.stateNode === null) throw Error(r(162));
            P = l.stateNode, j = l.memoizedProps;
            try {
              P.nodeValue = j;
            } catch (mt) {
              fn(l, l.return, mt);
            }
          }
          break;
        case 3:
          if (Mo(f, l), ga(l), _ & 4 && g !== null && g.memoizedState.isDehydrated) try {
            Oo(f.containerInfo);
          } catch (mt) {
            fn(l, l.return, mt);
          }
          break;
        case 4:
          Mo(f, l), ga(l);
          break;
        case 13:
          Mo(f, l), ga(l), P = l.child, P.flags & 8192 && (j = P.memoizedState !== null, P.stateNode.isHidden = j, !j || P.alternate !== null && P.alternate.memoizedState !== null || (Jm = zt())), _ & 4 && Qb(l);
          break;
        case 22:
          if (qe = g !== null && g.memoizedState !== null, l.mode & 1 ? (Mi = (Ce = Mi) || qe, Mo(f, l), Mi = Ce) : Mo(f, l), ga(l), _ & 8192) {
            if (Ce = l.memoizedState !== null, (l.stateNode.isHidden = Ce) && !qe && (l.mode & 1) !== 0) for (ut = l, qe = l.child; qe !== null; ) {
              for (He = ut = qe; ut !== null; ) {
                switch (ze = ut, nt = ze.child, ze.tag) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    Ld(4, ze, ze.return);
                    break;
                  case 1:
                    tf(ze, ze.return);
                    var dt = ze.stateNode;
                    if (typeof dt.componentWillUnmount == "function") {
                      _ = ze, g = ze.return;
                      try {
                        f = _, dt.props = f.memoizedProps, dt.state = f.memoizedState, dt.componentWillUnmount();
                      } catch (mt) {
                        fn(_, g, mt);
                      }
                    }
                    break;
                  case 5:
                    tf(ze, ze.return);
                    break;
                  case 22:
                    if (ze.memoizedState !== null) {
                      qd(He);
                      continue;
                    }
                }
                nt !== null ? (nt.return = ze, ut = nt) : qd(He);
              }
              qe = qe.sibling;
            }
            e: for (qe = null, He = l; ; ) {
              if (He.tag === 5) {
                if (qe === null) {
                  qe = He;
                  try {
                    P = He.stateNode, Ce ? (j = P.style, typeof j.setProperty == "function" ? j.setProperty("display", "none", "important") : j.display = "none") : (re = He.stateNode, le = He.memoizedProps.style, U = le != null && le.hasOwnProperty("display") ? le.display : null, re.style.display = cr("display", U));
                  } catch (mt) {
                    fn(l, l.return, mt);
                  }
                }
              } else if (He.tag === 6) {
                if (qe === null) try {
                  He.stateNode.nodeValue = Ce ? "" : He.memoizedProps;
                } catch (mt) {
                  fn(l, l.return, mt);
                }
              } else if ((He.tag !== 22 && He.tag !== 23 || He.memoizedState === null || He === l) && He.child !== null) {
                He.child.return = He, He = He.child;
                continue;
              }
              if (He === l) break e;
              for (; He.sibling === null; ) {
                if (He.return === null || He.return === l) break e;
                qe === He && (qe = null), He = He.return;
              }
              qe === He && (qe = null), He.sibling.return = He.return, He = He.sibling;
            }
          }
          break;
        case 19:
          Mo(f, l), ga(l), _ & 4 && Qb(l);
          break;
        case 21:
          break;
        default:
          Mo(
            f,
            l
          ), ga(l);
      }
    }
    function ga(l) {
      var f = l.flags;
      if (f & 2) {
        try {
          e: {
            for (var g = l.return; g !== null; ) {
              if (zd(g)) {
                var _ = g;
                break e;
              }
              g = g.return;
            }
            throw Error(r(160));
          }
          switch (_.tag) {
            case 5:
              var P = _.stateNode;
              _.flags & 32 && (Ge(P, ""), _.flags &= -33);
              var j = qu(l);
              cu(l, j, P);
              break;
            case 3:
            case 4:
              var U = _.stateNode.containerInfo, re = qu(l);
              lu(l, re, U);
              break;
            default:
              throw Error(r(161));
          }
        } catch (le) {
          fn(l, l.return, le);
        }
        l.flags &= -3;
      }
      f & 4096 && (l.flags &= -4097);
    }
    function DC(l, f, g) {
      ut = l, Xm(l);
    }
    function Xm(l, f, g) {
      for (var _ = (l.mode & 1) !== 0; ut !== null; ) {
        var P = ut, j = P.child;
        if (P.tag === 22 && _) {
          var U = P.memoizedState !== null || Bd;
          if (!U) {
            var re = P.alternate, le = re !== null && re.memoizedState !== null || Mi;
            re = Bd;
            var Ce = Mi;
            if (Bd = U, (Mi = le) && !Ce) for (ut = P; ut !== null; ) U = ut, le = U.child, U.tag === 22 && U.memoizedState !== null ? Zm(P) : le !== null ? (le.return = U, ut = le) : Zm(P);
            for (; j !== null; ) ut = j, Xm(j), j = j.sibling;
            ut = P, Bd = re, Mi = Ce;
          }
          Kb(l);
        } else (P.subtreeFlags & 8772) !== 0 && j !== null ? (j.return = P, ut = j) : Kb(l);
      }
    }
    function Kb(l) {
      for (; ut !== null; ) {
        var f = ut;
        if ((f.flags & 8772) !== 0) {
          var g = f.alternate;
          try {
            if ((f.flags & 8772) !== 0) switch (f.tag) {
              case 0:
              case 11:
              case 15:
                Mi || $d(5, f);
                break;
              case 1:
                var _ = f.stateNode;
                if (f.flags & 4 && !Mi) if (g === null) _.componentDidMount();
                else {
                  var P = f.elementType === f.type ? g.memoizedProps : Po(f.type, g.memoizedProps);
                  _.componentDidUpdate(P, g.memoizedState, _.__reactInternalSnapshotBeforeUpdate);
                }
                var j = f.updateQueue;
                j !== null && Fm(f, j, _);
                break;
              case 3:
                var U = f.updateQueue;
                if (U !== null) {
                  if (g = null, f.child !== null) switch (f.child.tag) {
                    case 5:
                      g = f.child.stateNode;
                      break;
                    case 1:
                      g = f.child.stateNode;
                  }
                  Fm(f, U, g);
                }
                break;
              case 5:
                var re = f.stateNode;
                if (g === null && f.flags & 4) {
                  g = re;
                  var le = f.memoizedProps;
                  switch (f.type) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      le.autoFocus && g.focus();
                      break;
                    case "img":
                      le.src && (g.src = le.src);
                  }
                }
                break;
              case 6:
                break;
              case 4:
                break;
              case 12:
                break;
              case 13:
                if (f.memoizedState === null) {
                  var Ce = f.alternate;
                  if (Ce !== null) {
                    var qe = Ce.memoizedState;
                    if (qe !== null) {
                      var He = qe.dehydrated;
                      He !== null && Oo(He);
                    }
                  }
                }
                break;
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break;
              default:
                throw Error(r(163));
            }
            Mi || f.flags & 512 && Qm(f);
          } catch (ze) {
            fn(f, f.return, ze);
          }
        }
        if (f === l) {
          ut = null;
          break;
        }
        if (g = f.sibling, g !== null) {
          g.return = f.return, ut = g;
          break;
        }
        ut = f.return;
      }
    }
    function qd(l) {
      for (; ut !== null; ) {
        var f = ut;
        if (f === l) {
          ut = null;
          break;
        }
        var g = f.sibling;
        if (g !== null) {
          g.return = f.return, ut = g;
          break;
        }
        ut = f.return;
      }
    }
    function Zm(l) {
      for (; ut !== null; ) {
        var f = ut;
        try {
          switch (f.tag) {
            case 0:
            case 11:
            case 15:
              var g = f.return;
              try {
                $d(4, f);
              } catch (le) {
                fn(f, g, le);
              }
              break;
            case 1:
              var _ = f.stateNode;
              if (typeof _.componentDidMount == "function") {
                var P = f.return;
                try {
                  _.componentDidMount();
                } catch (le) {
                  fn(f, P, le);
                }
              }
              var j = f.return;
              try {
                Qm(f);
              } catch (le) {
                fn(f, j, le);
              }
              break;
            case 5:
              var U = f.return;
              try {
                Qm(f);
              } catch (le) {
                fn(f, U, le);
              }
          }
        } catch (le) {
          fn(f, f.return, le);
        }
        if (f === l) {
          ut = null;
          break;
        }
        var re = f.sibling;
        if (re !== null) {
          re.return = f.return, ut = re;
          break;
        }
        ut = f.return;
      }
    }
    var kC = Math.ceil, $s = R.ReactCurrentDispatcher, Ul = R.ReactCurrentOwner, gi = R.ReactCurrentBatchConfig, nr = 0, Zn = null, $n = null, xi = 0, Ba = 0, rf = ko(0), Tn = 0, Ud = null, fu = 0, nf = 0, Wh = 0, Hd = null, xa = null, Jm = 0, af = 1 / 0, La = null, of = !1, Hl = null, zs = null, Yh = !1, Uu = null, Vd = 0, qs = 0, uf = null, Wd = -1, Ni = 0;
    function zn() {
      return (nr & 6) !== 0 ? zt() : Wd !== -1 ? Wd : Wd = zt();
    }
    function du(l) {
      return (l.mode & 1) === 0 ? 1 : (nr & 2) !== 0 && xi !== 0 ? xi & -xi : TC.transition !== null ? (Ni === 0 && (Ni = Pc()), Ni) : (l = mr, l !== 0 || (l = window.event, l = l === void 0 ? 16 : Lc(l.type)), l);
    }
    function Yi(l, f, g, _) {
      if (50 < qs) throw qs = 0, uf = null, Error(r(185));
      ku(l, g, _), ((nr & 2) === 0 || l !== Zn) && (l === Zn && ((nr & 2) === 0 && (nf |= g), Tn === 4 && No(l, xi)), ba(l, _), g === 1 && nr === 0 && (f.mode & 1) === 0 && (af = zt() + 500, Kc && iu()));
    }
    function ba(l, f) {
      var g = l.callbackNode;
      gl(l, f);
      var _ = Co(l, l === Zn ? xi : 0);
      if (_ === 0) g !== null && hi(g), l.callbackNode = null, l.callbackPriority = 0;
      else if (f = _ & -_, l.callbackPriority !== f) {
        if (g != null && hi(g), f === 1) l.tag === 0 ? Rs(ey.bind(null, l)) : ph(ey.bind(null, l)), Wc(function() {
          (nr & 6) === 0 && iu();
        }), g = null;
        else {
          switch (Nc(_)) {
            case 1:
              g = So;
              break;
            case 4:
              g = ml;
              break;
            case 16:
              g = yl;
              break;
            case 536870912:
              g = Dc;
              break;
            default:
              g = yl;
          }
          g = o1(g, Gh.bind(null, l));
        }
        l.callbackPriority = f, l.callbackNode = g;
      }
    }
    function Gh(l, f) {
      if (Wd = -1, Ni = 0, (nr & 6) !== 0) throw Error(r(327));
      var g = l.callbackNode;
      if (sf() && l.callbackNode !== g) return null;
      var _ = Co(l, l === Zn ? xi : 0);
      if (_ === 0) return null;
      if ((_ & 30) !== 0 || (_ & l.expiredLanes) !== 0 || f) f = Qh(l, _);
      else {
        f = _;
        var P = nr;
        nr |= 2;
        var j = Zb();
        (Zn !== l || xi !== f) && (La = null, af = zt() + 500, Hu(l, f));
        do
          try {
            Jb();
            break;
          } catch (re) {
            Xb(l, re);
          }
        while (!0);
        km(), $s.current = j, nr = P, $n !== null ? f = 0 : (Zn = null, xi = 0, f = Tn);
      }
      if (f !== 0) {
        if (f === 2 && (P = Es(l), P !== 0 && (_ = P, f = Yd(l, P))), f === 1) throw g = Ud, Hu(l, 0), No(l, _), ba(l, zt()), g;
        if (f === 6) No(l, _);
        else {
          if (P = l.current.alternate, (_ & 30) === 0 && !RC(P) && (f = Qh(l, _), f === 2 && (j = Es(l), j !== 0 && (_ = j, f = Yd(l, j))), f === 1)) throw g = Ud, Hu(l, 0), No(l, _), ba(l, zt()), g;
          switch (l.finishedWork = P, l.finishedLanes = _, f) {
            case 0:
            case 1:
              throw Error(r(345));
            case 2:
              Yl(l, xa, La);
              break;
            case 3:
              if (No(l, _), (_ & 130023424) === _ && (f = Jm + 500 - zt(), 10 < f)) {
                if (Co(l, 0) !== 0) break;
                if (P = l.suspendedLanes, (P & _) !== _) {
                  zn(), l.pingedLanes |= l.suspendedLanes & P;
                  break;
                }
                l.timeoutHandle = ch(Yl.bind(null, l, xa, La), f);
                break;
              }
              Yl(l, xa, La);
              break;
            case 4:
              if (No(l, _), (_ & 4194240) === _) break;
              for (f = l.eventTimes, P = -1; 0 < _; ) {
                var U = 31 - zi(_);
                j = 1 << U, U = f[U], U > P && (P = U), _ &= ~j;
              }
              if (_ = P, _ = zt() - _, _ = (120 > _ ? 120 : 480 > _ ? 480 : 1080 > _ ? 1080 : 1920 > _ ? 1920 : 3e3 > _ ? 3e3 : 4320 > _ ? 4320 : 1960 * kC(_ / 1960)) - _, 10 < _) {
                l.timeoutHandle = ch(Yl.bind(null, l, xa, La), _);
                break;
              }
              Yl(l, xa, La);
              break;
            case 5:
              Yl(l, xa, La);
              break;
            default:
              throw Error(r(329));
          }
        }
      }
      return ba(l, zt()), l.callbackNode === g ? Gh.bind(null, l) : null;
    }
    function Yd(l, f) {
      var g = Hd;
      return l.current.memoizedState.isDehydrated && (Hu(l, f).flags |= 256), l = Qh(l, f), l !== 2 && (f = xa, xa = g, f !== null && Vl(f)), l;
    }
    function Vl(l) {
      xa === null ? xa = l : xa.push.apply(xa, l);
    }
    function RC(l) {
      for (var f = l; ; ) {
        if (f.flags & 16384) {
          var g = f.updateQueue;
          if (g !== null && (g = g.stores, g !== null)) for (var _ = 0; _ < g.length; _++) {
            var P = g[_], j = P.getSnapshot;
            P = P.value;
            try {
              if (!Ao(j(), P)) return !1;
            } catch {
              return !1;
            }
          }
        }
        if (g = f.child, f.subtreeFlags & 16384 && g !== null) g.return = f, f = g;
        else {
          if (f === l) break;
          for (; f.sibling === null; ) {
            if (f.return === null || f.return === l) return !0;
            f = f.return;
          }
          f.sibling.return = f.return, f = f.sibling;
        }
      }
      return !0;
    }
    function No(l, f) {
      for (f &= ~Wh, f &= ~nf, l.suspendedLanes |= f, l.pingedLanes &= ~f, l = l.expirationTimes; 0 < f; ) {
        var g = 31 - zi(f), _ = 1 << g;
        l[g] = -1, f &= ~_;
      }
    }
    function ey(l) {
      if ((nr & 6) !== 0) throw Error(r(327));
      sf();
      var f = Co(l, 0);
      if ((f & 1) === 0) return ba(l, zt()), null;
      var g = Qh(l, f);
      if (l.tag !== 0 && g === 2) {
        var _ = Es(l);
        _ !== 0 && (f = _, g = Yd(l, _));
      }
      if (g === 1) throw g = Ud, Hu(l, 0), No(l, f), ba(l, zt()), g;
      if (g === 6) throw Error(r(345));
      return l.finishedWork = l.current.alternate, l.finishedLanes = f, Yl(l, xa, La), ba(l, zt()), null;
    }
    function ty(l, f) {
      var g = nr;
      nr |= 1;
      try {
        return l(f);
      } finally {
        nr = g, nr === 0 && (af = zt() + 500, Kc && iu());
      }
    }
    function Wl(l) {
      Uu !== null && Uu.tag === 0 && (nr & 6) === 0 && sf();
      var f = nr;
      nr |= 1;
      var g = gi.transition, _ = mr;
      try {
        if (gi.transition = null, mr = 1, l) return l();
      } finally {
        mr = _, gi.transition = g, nr = f, (nr & 6) === 0 && iu();
      }
    }
    function ry() {
      Ba = rf.current, nn(rf);
    }
    function Hu(l, f) {
      l.finishedWork = null, l.finishedLanes = 0;
      var g = l.timeoutHandle;
      if (g !== -1 && (l.timeoutHandle = -1, Cm(g)), $n !== null) for (g = $n.return; g !== null; ) {
        var _ = g;
        switch (vh(_), _.tag) {
          case 1:
            _ = _.type.childContextTypes, _ != null && Qc();
            break;
          case 3:
            Nl(), nn(Kn), nn(bn), St();
            break;
          case 5:
            xh(_);
            break;
          case 4:
            Nl();
            break;
          case 13:
            nn(mn);
            break;
          case 19:
            nn(mn);
            break;
          case 10:
            Rm(_.type._context);
            break;
          case 22:
          case 23:
            ry();
        }
        g = g.return;
      }
      if (Zn = l, $n = l = Us(l.current, null), xi = Ba = f, Tn = 0, Ud = null, Wh = nf = fu = 0, xa = Hd = null, Pl !== null) {
        for (f = 0; f < Pl.length; f++) if (g = Pl[f], _ = g.interleaved, _ !== null) {
          g.interleaved = null;
          var P = _.next, j = g.pending;
          if (j !== null) {
            var U = j.next;
            j.next = P, _.next = U;
          }
          g.pending = _;
        }
        Pl = null;
      }
      return l;
    }
    function Xb(l, f) {
      do {
        var g = $n;
        try {
          if (km(), Gt.current = $l, wh) {
            for (var _ = gr.memoizedState; _ !== null; ) {
              var P = _.queue;
              P !== null && (P.pending = null), _ = _.next;
            }
            wh = !1;
          }
          if (Ir = 0, ii = In = gr = null, _d = !1, jl = 0, Ul.current = null, g === null || g.return === null) {
            Tn = 1, Ud = f, $n = null;
            break;
          }
          e: {
            var j = l, U = g.return, re = g, le = f;
            if (f = xi, re.flags |= 32768, le !== null && typeof le == "object" && typeof le.then == "function") {
              var Ce = le, qe = re, He = qe.tag;
              if ((qe.mode & 1) === 0 && (He === 0 || He === 11 || He === 15)) {
                var ze = qe.alternate;
                ze ? (qe.updateQueue = ze.updateQueue, qe.memoizedState = ze.memoizedState, qe.lanes = ze.lanes) : (qe.updateQueue = null, qe.memoizedState = null);
              }
              var nt = Bb(U);
              if (nt !== null) {
                nt.flags &= -257, Ls(nt, U, re, j, f), nt.mode & 1 && Hm(j, Ce, f), f = nt, le = Ce;
                var dt = f.updateQueue;
                if (dt === null) {
                  var mt = /* @__PURE__ */ new Set();
                  mt.add(le), f.updateQueue = mt;
                } else dt.add(le);
                break e;
              } else {
                if ((f & 1) === 0) {
                  Hm(j, Ce, f), ny();
                  break e;
                }
                le = Error(r(426));
              }
            } else if (cn && re.mode & 1) {
              var An = Bb(U);
              if (An !== null) {
                (An.flags & 65536) === 0 && (An.flags |= 256), Ls(An, U, re, j, f), Lu(zl(le, re));
                break e;
              }
            }
            j = le = zl(le, re), Tn !== 4 && (Tn = 2), Hd === null ? Hd = [j] : Hd.push(j), j = U;
            do {
              switch (j.tag) {
                case 3:
                  j.flags |= 65536, f &= -f, j.lanes |= f;
                  var ge = Ib(j, le, f);
                  Pb(j, ge);
                  break e;
                case 1:
                  re = le;
                  var he = j.type, Ee = j.stateNode;
                  if ((j.flags & 128) === 0 && (typeof he.getDerivedStateFromError == "function" || Ee !== null && typeof Ee.componentDidCatch == "function" && (zs === null || !zs.has(Ee)))) {
                    j.flags |= 65536, f &= -f, j.lanes |= f;
                    var Ue = Um(j, re, f);
                    Pb(j, Ue);
                    break e;
                  }
              }
              j = j.return;
            } while (j !== null);
          }
          t1(g);
        } catch (pt) {
          f = pt, $n === g && g !== null && ($n = g = g.return);
          continue;
        }
        break;
      } while (!0);
    }
    function Zb() {
      var l = $s.current;
      return $s.current = $l, l === null ? $l : l;
    }
    function ny() {
      (Tn === 0 || Tn === 3 || Tn === 2) && (Tn = 4), Zn === null || (fu & 268435455) === 0 && (nf & 268435455) === 0 || No(Zn, xi);
    }
    function Qh(l, f) {
      var g = nr;
      nr |= 2;
      var _ = Zb();
      (Zn !== l || xi !== f) && (La = null, Hu(l, f));
      do
        try {
          PC();
          break;
        } catch (P) {
          Xb(l, P);
        }
      while (!0);
      if (km(), nr = g, $s.current = _, $n !== null) throw Error(r(261));
      return Zn = null, xi = 0, Tn;
    }
    function PC() {
      for (; $n !== null; ) e1($n);
    }
    function Jb() {
      for (; $n !== null && !wo(); ) e1($n);
    }
    function e1(l) {
      var f = a1(l.alternate, l, Ba);
      l.memoizedProps = l.pendingProps, f === null ? t1(l) : $n = f, Ul.current = null;
    }
    function t1(l) {
      var f = l;
      do {
        var g = f.alternate;
        if (l = f.return, (f.flags & 32768) === 0) {
          if (g = Vb(g, f, Ba), g !== null) {
            $n = g;
            return;
          }
        } else {
          if (g = Uh(g, f), g !== null) {
            g.flags &= 32767, $n = g;
            return;
          }
          if (l !== null) l.flags |= 32768, l.subtreeFlags = 0, l.deletions = null;
          else {
            Tn = 6, $n = null;
            return;
          }
        }
        if (f = f.sibling, f !== null) {
          $n = f;
          return;
        }
        $n = f = l;
      } while (f !== null);
      Tn === 0 && (Tn = 5);
    }
    function Yl(l, f, g) {
      var _ = mr, P = gi.transition;
      try {
        gi.transition = null, mr = 1, MC(l, f, g, _);
      } finally {
        gi.transition = P, mr = _;
      }
      return null;
    }
    function MC(l, f, g, _) {
      do
        sf();
      while (Uu !== null);
      if ((nr & 6) !== 0) throw Error(r(327));
      g = l.finishedWork;
      var P = l.finishedLanes;
      if (g === null) return null;
      if (l.finishedWork = null, l.finishedLanes = 0, g === l.current) throw Error(r(177));
      l.callbackNode = null, l.callbackPriority = 0;
      var j = g.lanes | g.childLanes;
      if (im(l, j), l === Zn && ($n = Zn = null, xi = 0), (g.subtreeFlags & 2064) === 0 && (g.flags & 2064) === 0 || Yh || (Yh = !0, o1(yl, function() {
        return sf(), null;
      })), j = (g.flags & 15990) !== 0, (g.subtreeFlags & 15990) !== 0 || j) {
        j = gi.transition, gi.transition = null;
        var U = mr;
        mr = 1;
        var re = nr;
        nr |= 4, Ul.current = null, Yb(l, g), Km(g, l), qc(Tl), Za = !!hd, Tl = hd = null, l.current = g, DC(g), Eo(), nr = re, mr = U, gi.transition = j;
      } else l.current = g;
      if (Yh && (Yh = !1, Uu = l, Vd = P), j = l.pendingLanes, j === 0 && (zs = null), ed(g.stateNode), ba(l, zt()), f !== null) for (_ = l.onRecoverableError, g = 0; g < f.length; g++) P = f[g], _(P.value, { componentStack: P.stack, digest: P.digest });
      if (of) throw of = !1, l = Hl, Hl = null, l;
      return (Vd & 1) !== 0 && l.tag !== 0 && sf(), j = l.pendingLanes, (j & 1) !== 0 ? l === uf ? qs++ : (qs = 0, uf = l) : qs = 0, iu(), null;
    }
    function sf() {
      if (Uu !== null) {
        var l = Nc(Vd), f = gi.transition, g = mr;
        try {
          if (gi.transition = null, mr = 16 > l ? 16 : l, Uu === null) var _ = !1;
          else {
            if (l = Uu, Uu = null, Vd = 0, (nr & 6) !== 0) throw Error(r(331));
            var P = nr;
            for (nr |= 4, ut = l.current; ut !== null; ) {
              var j = ut, U = j.child;
              if ((ut.flags & 16) !== 0) {
                var re = j.deletions;
                if (re !== null) {
                  for (var le = 0; le < re.length; le++) {
                    var Ce = re[le];
                    for (ut = Ce; ut !== null; ) {
                      var qe = ut;
                      switch (qe.tag) {
                        case 0:
                        case 11:
                        case 15:
                          Ld(8, qe, j);
                      }
                      var He = qe.child;
                      if (He !== null) He.return = qe, ut = He;
                      else for (; ut !== null; ) {
                        qe = ut;
                        var ze = qe.sibling, nt = qe.return;
                        if (Vh(qe), qe === Ce) {
                          ut = null;
                          break;
                        }
                        if (ze !== null) {
                          ze.return = nt, ut = ze;
                          break;
                        }
                        ut = nt;
                      }
                    }
                  }
                  var dt = j.alternate;
                  if (dt !== null) {
                    var mt = dt.child;
                    if (mt !== null) {
                      dt.child = null;
                      do {
                        var An = mt.sibling;
                        mt.sibling = null, mt = An;
                      } while (mt !== null);
                    }
                  }
                  ut = j;
                }
              }
              if ((j.subtreeFlags & 2064) !== 0 && U !== null) U.return = j, ut = U;
              else e: for (; ut !== null; ) {
                if (j = ut, (j.flags & 2048) !== 0) switch (j.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Ld(9, j, j.return);
                }
                var ge = j.sibling;
                if (ge !== null) {
                  ge.return = j.return, ut = ge;
                  break e;
                }
                ut = j.return;
              }
            }
            var he = l.current;
            for (ut = he; ut !== null; ) {
              U = ut;
              var Ee = U.child;
              if ((U.subtreeFlags & 2064) !== 0 && Ee !== null) Ee.return = U, ut = Ee;
              else e: for (U = he; ut !== null; ) {
                if (re = ut, (re.flags & 2048) !== 0) try {
                  switch (re.tag) {
                    case 0:
                    case 11:
                    case 15:
                      $d(9, re);
                  }
                } catch (pt) {
                  fn(re, re.return, pt);
                }
                if (re === U) {
                  ut = null;
                  break e;
                }
                var Ue = re.sibling;
                if (Ue !== null) {
                  Ue.return = re.return, ut = Ue;
                  break e;
                }
                ut = re.return;
              }
            }
            if (nr = P, iu(), la && typeof la.onPostCommitFiberRoot == "function") try {
              la.onPostCommitFiberRoot(bs, l);
            } catch {
            }
            _ = !0;
          }
          return _;
        } finally {
          mr = g, gi.transition = f;
        }
      }
      return !1;
    }
    function r1(l, f, g) {
      f = zl(g, f), f = Ib(l, f, 1), l = Fs(l, f, 1), f = zn(), l !== null && (ku(l, 1, f), ba(l, f));
    }
    function fn(l, f, g) {
      if (l.tag === 3) r1(l, l, g);
      else for (; f !== null; ) {
        if (f.tag === 3) {
          r1(f, l, g);
          break;
        } else if (f.tag === 1) {
          var _ = f.stateNode;
          if (typeof f.type.getDerivedStateFromError == "function" || typeof _.componentDidCatch == "function" && (zs === null || !zs.has(_))) {
            l = zl(g, l), l = Um(f, l, 1), f = Fs(f, l, 1), l = zn(), f !== null && (ku(f, 1, l), ba(f, l));
            break;
          }
        }
        f = f.return;
      }
    }
    function NC(l, f, g) {
      var _ = l.pingCache;
      _ !== null && _.delete(f), f = zn(), l.pingedLanes |= l.suspendedLanes & g, Zn === l && (xi & g) === g && (Tn === 4 || Tn === 3 && (xi & 130023424) === xi && 500 > zt() - Jm ? Hu(l, 0) : Wh |= g), ba(l, f);
    }
    function n1(l, f) {
      f === 0 && ((l.mode & 1) === 0 ? f = 1 : (f = Pa, Pa <<= 1, (Pa & 130023424) === 0 && (Pa = 4194304)));
      var g = zn();
      l = ja(l, f), l !== null && (ku(l, f, g), ba(l, g));
    }
    function jC(l) {
      var f = l.memoizedState, g = 0;
      f !== null && (g = f.retryLane), n1(l, g);
    }
    function i1(l, f) {
      var g = 0;
      switch (l.tag) {
        case 13:
          var _ = l.stateNode, P = l.memoizedState;
          P !== null && (g = P.retryLane);
          break;
        case 19:
          _ = l.stateNode;
          break;
        default:
          throw Error(r(314));
      }
      _ !== null && _.delete(f), n1(l, g);
    }
    var a1;
    a1 = function(l, f, g) {
      if (l !== null) if (l.memoizedProps !== f.pendingProps || Kn.current) Bn = !0;
      else {
        if ((l.lanes & g) === 0 && (f.flags & 128) === 0) return Bn = !1, Fd(l, f, g);
        Bn = (l.flags & 131072) !== 0;
      }
      else Bn = !1, cn && (f.flags & 1048576) !== 0 && Ab(f, Bu, f.index);
      switch (f.lanes = 0, f.tag) {
        case 2:
          var _ = f.type;
          ao(l, f), l = f.pendingProps;
          var P = to(f, bn.current);
          vn(f, g), P = Is(null, f, _, l, P, g);
          var j = Ro();
          return f.flags |= 1, typeof P == "object" && P !== null && typeof P.render == "function" && P.$$typeof === void 0 ? (f.tag = 1, f.memoizedState = null, f.updateQueue = null, jn(_) ? (j = !0, pa(f)) : j = !1, f.memoizedState = P.state !== null && P.state !== void 0 ? P.state : null, jm(f), P.updater = Bh, f.stateNode = P, P._reactInternals = f, Rd(f, _, l, g), f = Nd(null, f, _, !0, j, g)) : (f.tag = 0, cn && j && hh(f), yi(null, f, P, g), f = f.child), f;
        case 16:
          _ = f.elementType;
          e: {
            switch (ao(l, f), l = f.pendingProps, P = _._init, _ = P(_._payload), f.type = _, P = f.tag = IC(_), l = Po(_, l), P) {
              case 0:
                f = Lb(null, f, _, l, g);
                break e;
              case 1:
                f = $b(null, f, _, l, g);
                break e;
              case 11:
                f = ya(null, f, _, l, g);
                break e;
              case 14:
                f = ql(null, f, _, Po(_.type, l), g);
                break e;
            }
            throw Error(r(
              306,
              _,
              ""
            ));
          }
          return f;
        case 0:
          return _ = f.type, P = f.pendingProps, P = f.elementType === _ ? P : Po(_, P), Lb(l, f, _, P, g);
        case 1:
          return _ = f.type, P = f.pendingProps, P = f.elementType === _ ? P : Po(_, P), $b(l, f, _, P, g);
        case 3:
          e: {
            if (ef(f), l === null) throw Error(r(387));
            _ = f.pendingProps, j = f.memoizedState, P = j.element, Rb(l, f), xd(f, _, null, g);
            var U = f.memoizedState;
            if (_ = U.element, j.isDehydrated) if (j = { element: _, isDehydrated: !1, cache: U.cache, pendingSuspenseBoundaries: U.pendingSuspenseBoundaries, transitions: U.transitions }, f.updateQueue.baseState = j, f.memoizedState = j, f.flags & 256) {
              P = zl(Error(r(423)), f), f = zb(l, f, _, g, P);
              break e;
            } else if (_ !== P) {
              P = zl(Error(r(424)), f), f = zb(l, f, _, g, P);
              break e;
            } else for (va = tu(f.stateNode.containerInfo.firstChild), ha = f, cn = !0, no = null, g = et(f, null, _, g), f.child = g; g; ) g.flags = g.flags & -3 | 4096, g = g.sibling;
            else {
              if (js(), _ === P) {
                f = oo(l, f, g);
                break e;
              }
              yi(l, f, _, g);
            }
            f = f.child;
          }
          return f;
        case 5:
          return Mb(f), l === null && Am(f), _ = f.type, P = f.pendingProps, j = l !== null ? l.memoizedProps : null, U = P.children, lh(_, P) ? U = null : j !== null && lh(_, j) && (f.flags |= 32), Vm(l, f), yi(l, f, U, g), f.child;
        case 6:
          return l === null && Am(f), null;
        case 13:
          return qh(l, f, g);
        case 4:
          return Im(f, f.stateNode.containerInfo), _ = f.pendingProps, l === null ? f.child = _n(f, null, _, g) : yi(l, f, _, g), f.child;
        case 11:
          return _ = f.type, P = f.pendingProps, P = f.elementType === _ ? P : Po(_, P), ya(l, f, _, P, g);
        case 7:
          return yi(l, f, f.pendingProps, g), f.child;
        case 8:
          return yi(l, f, f.pendingProps.children, g), f.child;
        case 12:
          return yi(l, f, f.pendingProps.children, g), f.child;
        case 10:
          e: {
            if (_ = f.type._context, P = f.pendingProps, j = f.memoizedProps, U = P.value, wt(Na, _._currentValue), _._currentValue = U, j !== null) if (Ao(j.value, U)) {
              if (j.children === P.children && !Kn.current) {
                f = oo(l, f, g);
                break e;
              }
            } else for (j = f.child, j !== null && (j.return = f); j !== null; ) {
              var re = j.dependencies;
              if (re !== null) {
                U = j.child;
                for (var le = re.firstContext; le !== null; ) {
                  if (le.context === _) {
                    if (j.tag === 1) {
                      le = $u(-1, g & -g), le.tag = 2;
                      var Ce = j.updateQueue;
                      if (Ce !== null) {
                        Ce = Ce.shared;
                        var qe = Ce.pending;
                        qe === null ? le.next = le : (le.next = qe.next, qe.next = le), Ce.pending = le;
                      }
                    }
                    j.lanes |= g, le = j.alternate, le !== null && (le.lanes |= g), Pm(
                      j.return,
                      g,
                      f
                    ), re.lanes |= g;
                    break;
                  }
                  le = le.next;
                }
              } else if (j.tag === 10) U = j.type === f.type ? null : j.child;
              else if (j.tag === 18) {
                if (U = j.return, U === null) throw Error(r(341));
                U.lanes |= g, re = U.alternate, re !== null && (re.lanes |= g), Pm(U, g, f), U = j.sibling;
              } else U = j.child;
              if (U !== null) U.return = j;
              else for (U = j; U !== null; ) {
                if (U === f) {
                  U = null;
                  break;
                }
                if (j = U.sibling, j !== null) {
                  j.return = U.return, U = j;
                  break;
                }
                U = U.return;
              }
              j = U;
            }
            yi(l, f, P.children, g), f = f.child;
          }
          return f;
        case 9:
          return P = f.type, _ = f.pendingProps.children, vn(f, g), P = io(P), _ = _(P), f.flags |= 1, yi(l, f, _, g), f.child;
        case 14:
          return _ = f.type, P = Po(_, f.pendingProps), P = Po(_.type, P), ql(l, f, _, P, g);
        case 15:
          return qt(l, f, f.type, f.pendingProps, g);
        case 17:
          return _ = f.type, P = f.pendingProps, P = f.elementType === _ ? P : Po(_, P), ao(l, f), f.tag = 1, jn(_) ? (l = !0, pa(f)) : l = !1, vn(f, g), Lh(f, _, P), Rd(f, _, P, g), Nd(null, f, _, !0, l, g);
        case 19:
          return su(l, f, g);
        case 22:
          return Md(l, f, g);
      }
      throw Error(r(156, f.tag));
    };
    function o1(l, f) {
      return on(l, f);
    }
    function FC(l, f, g, _) {
      this.tag = l, this.key = g, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = f, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = _, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
    }
    function so(l, f, g, _) {
      return new FC(l, f, g, _);
    }
    function iy(l) {
      return l = l.prototype, !(!l || !l.isReactComponent);
    }
    function IC(l) {
      if (typeof l == "function") return iy(l) ? 1 : 0;
      if (l != null) {
        if (l = l.$$typeof, l === Q) return 11;
        if (l === ne) return 14;
      }
      return 2;
    }
    function Us(l, f) {
      var g = l.alternate;
      return g === null ? (g = so(l.tag, f, l.key, l.mode), g.elementType = l.elementType, g.type = l.type, g.stateNode = l.stateNode, g.alternate = l, l.alternate = g) : (g.pendingProps = f, g.type = l.type, g.flags = 0, g.subtreeFlags = 0, g.deletions = null), g.flags = l.flags & 14680064, g.childLanes = l.childLanes, g.lanes = l.lanes, g.child = l.child, g.memoizedProps = l.memoizedProps, g.memoizedState = l.memoizedState, g.updateQueue = l.updateQueue, f = l.dependencies, g.dependencies = f === null ? null : { lanes: f.lanes, firstContext: f.firstContext }, g.sibling = l.sibling, g.index = l.index, g.ref = l.ref, g;
    }
    function Gd(l, f, g, _, P, j) {
      var U = 2;
      if (_ = l, typeof l == "function") iy(l) && (U = 1);
      else if (typeof l == "string") U = 5;
      else e: switch (l) {
        case F:
          return Vu(g.children, P, j, f);
        case B:
          U = 8, P |= 8;
          break;
        case V:
          return l = so(12, g, f, P | 2), l.elementType = V, l.lanes = j, l;
        case W:
          return l = so(13, g, f, P), l.elementType = W, l.lanes = j, l;
        case J:
          return l = so(19, g, f, P), l.elementType = J, l.lanes = j, l;
        case se:
          return Hs(g, P, j, f);
        default:
          if (typeof l == "object" && l !== null) switch (l.$$typeof) {
            case H:
              U = 10;
              break e;
            case q:
              U = 9;
              break e;
            case Q:
              U = 11;
              break e;
            case ne:
              U = 14;
              break e;
            case ie:
              U = 16, _ = null;
              break e;
          }
          throw Error(r(130, l == null ? l : typeof l, ""));
      }
      return f = so(U, g, f, P), f.elementType = l, f.type = _, f.lanes = j, f;
    }
    function Vu(l, f, g, _) {
      return l = so(7, l, _, f), l.lanes = g, l;
    }
    function Hs(l, f, g, _) {
      return l = so(22, l, _, f), l.elementType = se, l.lanes = g, l.stateNode = { isHidden: !1 }, l;
    }
    function ay(l, f, g) {
      return l = so(6, l, null, f), l.lanes = g, l;
    }
    function Kh(l, f, g) {
      return f = so(4, l.children !== null ? l.children : [], l.key, f), f.lanes = g, f.stateNode = { containerInfo: l.containerInfo, pendingChildren: null, implementation: l.implementation }, f;
    }
    function u1(l, f, g, _, P) {
      this.tag = f, this.containerInfo = l, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Mc(0), this.expirationTimes = Mc(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Mc(0), this.identifierPrefix = _, this.onRecoverableError = P, this.mutableSourceEagerHydrationData = null;
    }
    function Xh(l, f, g, _, P, j, U, re, le) {
      return l = new u1(l, f, g, re, le), f === 1 ? (f = 1, j === !0 && (f |= 8)) : f = 0, j = so(3, null, null, f), l.current = j, j.stateNode = l, j.memoizedState = { element: _, isDehydrated: g, cache: null, transitions: null, pendingSuspenseBoundaries: null }, jm(j), l;
    }
    function BC(l, f, g) {
      var _ = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
      return { $$typeof: M, key: _ == null ? null : "" + _, children: l, containerInfo: f, implementation: g };
    }
    function oy(l) {
      if (!l) return fa;
      l = l._reactInternals;
      e: {
        if ($t(l) !== l || l.tag !== 1) throw Error(r(170));
        var f = l;
        do {
          switch (f.tag) {
            case 3:
              f = f.stateNode.context;
              break e;
            case 1:
              if (jn(f.type)) {
                f = f.stateNode.__reactInternalMemoizedMergedChildContext;
                break e;
              }
          }
          f = f.return;
        } while (f !== null);
        throw Error(r(171));
      }
      if (l.tag === 1) {
        var g = l.type;
        if (jn(g)) return yd(l, g, f);
      }
      return f;
    }
    function s1(l, f, g, _, P, j, U, re, le) {
      return l = Xh(g, _, !0, l, P, j, U, re, le), l.context = oy(null), g = l.current, _ = zn(), P = du(g), j = $u(_, P), j.callback = f ?? null, Fs(g, j, P), l.current.lanes = P, ku(l, P, _), ba(l, _), l;
    }
    function Zh(l, f, g, _) {
      var P = f.current, j = zn(), U = du(P);
      return g = oy(g), f.context === null ? f.context = g : f.pendingContext = g, f = $u(j, U), f.payload = { element: l }, _ = _ === void 0 ? null : _, _ !== null && (f.callback = _), l = Fs(P, f, U), l !== null && (Yi(l, P, U, j), gh(l, P, U)), U;
    }
    function Jh(l) {
      if (l = l.current, !l.child) return null;
      switch (l.child.tag) {
        case 5:
          return l.child.stateNode;
        default:
          return l.child.stateNode;
      }
    }
    function uy(l, f) {
      if (l = l.memoizedState, l !== null && l.dehydrated !== null) {
        var g = l.retryLane;
        l.retryLane = g !== 0 && g < f ? g : f;
      }
    }
    function ev(l, f) {
      uy(l, f), (l = l.alternate) && uy(l, f);
    }
    function l1() {
      return null;
    }
    var Gl = typeof reportError == "function" ? reportError : function(l) {
      console.error(l);
    };
    function sy(l) {
      this._internalRoot = l;
    }
    tv.prototype.render = sy.prototype.render = function(l) {
      var f = this._internalRoot;
      if (f === null) throw Error(r(409));
      Zh(l, f, null, null);
    }, tv.prototype.unmount = sy.prototype.unmount = function() {
      var l = this._internalRoot;
      if (l !== null) {
        this._internalRoot = null;
        var f = l.containerInfo;
        Wl(function() {
          Zh(null, l, null, null);
        }), f[Fu] = null;
      }
    };
    function tv(l) {
      this._internalRoot = l;
    }
    tv.prototype.unstable_scheduleHydration = function(l) {
      if (l) {
        var f = Ft();
        l = { blockedOn: null, target: l, priority: f };
        for (var g = 0; g < Qn.length && f !== 0 && f < Qn[g].priority; g++) ;
        Qn.splice(g, 0, l), g === 0 && nd(l);
      }
    };
    function ly(l) {
      return !(!l || l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11);
    }
    function rv(l) {
      return !(!l || l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11 && (l.nodeType !== 8 || l.nodeValue !== " react-mount-point-unstable "));
    }
    function c1() {
    }
    function LC(l, f, g, _, P) {
      if (P) {
        if (typeof _ == "function") {
          var j = _;
          _ = function() {
            var Ce = Jh(U);
            j.call(Ce);
          };
        }
        var U = s1(f, _, l, 0, null, !1, !1, "", c1);
        return l._reactRootContainer = U, l[Fu] = U.current, Hc(l.nodeType === 8 ? l.parentNode : l), Wl(), U;
      }
      for (; P = l.lastChild; ) l.removeChild(P);
      if (typeof _ == "function") {
        var re = _;
        _ = function() {
          var Ce = Jh(le);
          re.call(Ce);
        };
      }
      var le = Xh(l, 0, !1, null, null, !1, !1, "", c1);
      return l._reactRootContainer = le, l[Fu] = le.current, Hc(l.nodeType === 8 ? l.parentNode : l), Wl(function() {
        Zh(f, le, g, _);
      }), le;
    }
    function Qd(l, f, g, _, P) {
      var j = g._reactRootContainer;
      if (j) {
        var U = j;
        if (typeof P == "function") {
          var re = P;
          P = function() {
            var le = Jh(U);
            re.call(le);
          };
        }
        Zh(f, U, l, P);
      } else U = LC(g, f, l, P, _);
      return Jh(U);
    }
    or = function(l) {
      switch (l.tag) {
        case 3:
          var f = l.stateNode;
          if (f.current.memoizedState.isDehydrated) {
            var g = _o(f.pendingLanes);
            g !== 0 && (Ru(f, g | 1), ba(f, zt()), (nr & 6) === 0 && (af = zt() + 500, iu()));
          }
          break;
        case 13:
          Wl(function() {
            var _ = ja(l, 1);
            if (_ !== null) {
              var P = zn();
              Yi(_, l, 1, P);
            }
          }), ev(l, 1);
      }
    }, td = function(l) {
      if (l.tag === 13) {
        var f = ja(l, 134217728);
        if (f !== null) {
          var g = zn();
          Yi(f, l, 134217728, g);
        }
        ev(l, 134217728);
      }
    }, Ko = function(l) {
      if (l.tag === 13) {
        var f = du(l), g = ja(l, f);
        if (g !== null) {
          var _ = zn();
          Yi(g, l, f, _);
        }
        ev(l, f);
      }
    }, Ft = function() {
      return mr;
    }, jc = function(l, f) {
      var g = mr;
      try {
        return mr = l, f();
      } finally {
        mr = g;
      }
    }, Er = function(l, f, g) {
      switch (f) {
        case "input":
          if (Qt(l, g), f = g.name, g.type === "radio" && f != null) {
            for (g = l; g.parentNode; ) g = g.parentNode;
            for (g = g.querySelectorAll("input[name=" + JSON.stringify("" + f) + '][type="radio"]'), f = 0; f < g.length; f++) {
              var _ = g[f];
              if (_ !== l && _.form === l.form) {
                var P = Sn(_);
                if (!P) throw Error(r(90));
                de(_), Qt(_, P);
              }
            }
          }
          break;
        case "textarea":
          Pn(l, g);
          break;
        case "select":
          f = g.value, f != null && Vt(l, !!g.multiple, f, !1);
      }
    }, Vo = ty, Wo = Wl;
    var $C = { usingClientEntryPoint: !1, Events: [Et, Do, Sn, bo, Du, ty] }, Kd = { findFiberByHostInstance: Al, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, f1 = { bundleType: Kd.bundleType, version: Kd.version, rendererPackageName: Kd.rendererPackageName, rendererConfig: Kd.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: R.ReactCurrentDispatcher, findHostInstanceByFiber: function(l) {
      return l = En(l), l === null ? null : l.stateNode;
    }, findFiberByHostInstance: Kd.findFiberByHostInstance || l1, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
      var Vs = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (!Vs.isDisabled && Vs.supportsFiber) try {
        bs = Vs.inject(f1), la = Vs;
      } catch {
      }
    }
    return vo.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $C, vo.createPortal = function(l, f) {
      var g = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      if (!ly(f)) throw Error(r(200));
      return BC(l, f, null, g);
    }, vo.createRoot = function(l, f) {
      if (!ly(l)) throw Error(r(299));
      var g = !1, _ = "", P = Gl;
      return f != null && (f.unstable_strictMode === !0 && (g = !0), f.identifierPrefix !== void 0 && (_ = f.identifierPrefix), f.onRecoverableError !== void 0 && (P = f.onRecoverableError)), f = Xh(l, 1, !1, null, null, g, !1, _, P), l[Fu] = f.current, Hc(l.nodeType === 8 ? l.parentNode : l), new sy(f);
    }, vo.findDOMNode = function(l) {
      if (l == null) return null;
      if (l.nodeType === 1) return l;
      var f = l._reactInternals;
      if (f === void 0)
        throw typeof l.render == "function" ? Error(r(188)) : (l = Object.keys(l).join(","), Error(r(268, l)));
      return l = En(f), l = l === null ? null : l.stateNode, l;
    }, vo.flushSync = function(l) {
      return Wl(l);
    }, vo.hydrate = function(l, f, g) {
      if (!rv(f)) throw Error(r(200));
      return Qd(null, l, f, !0, g);
    }, vo.hydrateRoot = function(l, f, g) {
      if (!ly(l)) throw Error(r(405));
      var _ = g != null && g.hydratedSources || null, P = !1, j = "", U = Gl;
      if (g != null && (g.unstable_strictMode === !0 && (P = !0), g.identifierPrefix !== void 0 && (j = g.identifierPrefix), g.onRecoverableError !== void 0 && (U = g.onRecoverableError)), f = s1(f, null, l, 1, g ?? null, P, !1, j, U), l[Fu] = f.current, Hc(l), _) for (l = 0; l < _.length; l++) g = _[l], P = g._getVersion, P = P(g._source), f.mutableSourceEagerHydrationData == null ? f.mutableSourceEagerHydrationData = [g, P] : f.mutableSourceEagerHydrationData.push(
        g,
        P
      );
      return new tv(f);
    }, vo.render = function(l, f, g) {
      if (!rv(f)) throw Error(r(200));
      return Qd(null, l, f, !1, g);
    }, vo.unmountComponentAtNode = function(l) {
      if (!rv(l)) throw Error(r(40));
      return l._reactRootContainer ? (Wl(function() {
        Qd(null, null, l, !1, function() {
          l._reactRootContainer = null, l[Fu] = null;
        });
      }), !0) : !1;
    }, vo.unstable_batchedUpdates = ty, vo.unstable_renderSubtreeIntoContainer = function(l, f, g, _) {
      if (!rv(g)) throw Error(r(200));
      if (l == null || l._reactInternals === void 0) throw Error(r(38));
      return Qd(l, f, g, !1, _);
    }, vo.version = "18.3.1-next-f1338f8080-20240426", vo;
  }
  var mo = {};
  /**
   * @license React
   * react-dom.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var Q8;
  function Aee() {
    return Q8 || (Q8 = 1, process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var e = F0(), t = pU(), r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, n = !1;
      function i(a) {
        n = a;
      }
      function u(a) {
        if (!n) {
          for (var o = arguments.length, d = new Array(o > 1 ? o - 1 : 0), m = 1; m < o; m++)
            d[m - 1] = arguments[m];
          c("warn", a, d);
        }
      }
      function s(a) {
        if (!n) {
          for (var o = arguments.length, d = new Array(o > 1 ? o - 1 : 0), m = 1; m < o; m++)
            d[m - 1] = arguments[m];
          c("error", a, d);
        }
      }
      function c(a, o, d) {
        {
          var m = r.ReactDebugCurrentFrame, b = m.getStackAddendum();
          b !== "" && (o += "%s", d = d.concat([b]));
          var O = d.map(function(N) {
            return String(N);
          });
          O.unshift("Warning: " + o), Function.prototype.apply.call(console[a], console, O);
        }
      }
      var p = 0, h = 1, v = 2, y = 3, x = 4, w = 5, E = 6, C = 7, S = 8, k = 9, D = 10, A = 11, R = 12, T = 13, M = 14, F = 15, B = 16, V = 17, H = 18, q = 19, Q = 21, W = 22, J = 23, ne = 24, ie = 25, se = !0, X = !1, fe = !1, Z = !1, z = !1, Y = !0, te = !0, ae = !0, De = !0, ke = /* @__PURE__ */ new Set(), Re = {}, Te = {};
      function we(a, o) {
        Fe(a, o), Fe(a + "Capture", o);
      }
      function Fe(a, o) {
        Re[a] && s("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", a), Re[a] = o;
        {
          var d = a.toLowerCase();
          Te[d] = a, a === "onDoubleClick" && (Te.ondblclick = a);
        }
        for (var m = 0; m < o.length; m++)
          ke.add(o[m]);
      }
      var Ye = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", de = Object.prototype.hasOwnProperty;
      function Ze(a) {
        {
          var o = typeof Symbol == "function" && Symbol.toStringTag, d = o && a[Symbol.toStringTag] || a.constructor.name || "Object";
          return d;
        }
      }
      function Ne(a) {
        try {
          return Ot(a), !1;
        } catch {
          return !0;
        }
      }
      function Ot(a) {
        return "" + a;
      }
      function At(a, o) {
        if (Ne(a))
          return s("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", o, Ze(a)), Ot(a);
      }
      function Qt(a) {
        if (Ne(a))
          return s("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ze(a)), Ot(a);
      }
      function Wr(a, o) {
        if (Ne(a))
          return s("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", o, Ze(a)), Ot(a);
      }
      function Ar(a, o) {
        if (Ne(a))
          return s("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", o, Ze(a)), Ot(a);
      }
      function Dr(a) {
        if (Ne(a))
          return s("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", Ze(a)), Ot(a);
      }
      function Vt(a) {
        if (Ne(a))
          return s("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", Ze(a)), Ot(a);
      }
      var Ut = 0, kr = 1, Pn = 2, Yr = 3, Jr = 4, xn = 5, ka = 6, Ra = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Ge = Ra + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", ct = new RegExp("^[" + Ra + "][" + Ge + "]*$"), jt = {}, cr = {};
      function Rr(a) {
        return de.call(cr, a) ? !0 : de.call(jt, a) ? !1 : ct.test(a) ? (cr[a] = !0, !0) : (jt[a] = !0, s("Invalid attribute name: `%s`", a), !1);
      }
      function en(a, o, d) {
        return o !== null ? o.type === Ut : d ? !1 : a.length > 2 && (a[0] === "o" || a[0] === "O") && (a[1] === "n" || a[1] === "N");
      }
      function Gr(a, o, d, m) {
        if (d !== null && d.type === Ut)
          return !1;
        switch (typeof o) {
          case "function":
          // $FlowIssue symbol is perfectly valid here
          case "symbol":
            return !0;
          case "boolean": {
            if (m)
              return !1;
            if (d !== null)
              return !d.acceptsBooleans;
            var b = a.toLowerCase().slice(0, 5);
            return b !== "data-" && b !== "aria-";
          }
          default:
            return !1;
        }
      }
      function Mn(a, o, d, m) {
        if (o === null || typeof o > "u" || Gr(a, o, d, m))
          return !0;
        if (m)
          return !1;
        if (d !== null)
          switch (d.type) {
            case Yr:
              return !o;
            case Jr:
              return o === !1;
            case xn:
              return isNaN(o);
            case ka:
              return isNaN(o) || o < 1;
          }
        return !1;
      }
      function Pr(a) {
        return Er.hasOwnProperty(a) ? Er[a] : null;
      }
      function _r(a, o, d, m, b, O, N) {
        this.acceptsBooleans = o === Pn || o === Yr || o === Jr, this.attributeName = m, this.attributeNamespace = b, this.mustUseProperty = d, this.propertyName = a, this.type = o, this.sanitizeURL = O, this.removeEmptyString = N;
      }
      var Er = {}, $i = [
        "children",
        "dangerouslySetInnerHTML",
        // TODO: This prevents the assignment of defaultValue to regular
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
      ];
      $i.forEach(function(a) {
        Er[a] = new _r(
          a,
          Ut,
          !1,
          // mustUseProperty
          a,
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a) {
        var o = a[0], d = a[1];
        Er[o] = new _r(
          o,
          kr,
          !1,
          // mustUseProperty
          d,
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a) {
        Er[a] = new _r(
          a,
          Pn,
          !1,
          // mustUseProperty
          a.toLowerCase(),
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a) {
        Er[a] = new _r(
          a,
          Pn,
          !1,
          // mustUseProperty
          a,
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), [
        "allowFullScreen",
        "async",
        // Note: there is a special case that prevents it from being written to the DOM
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "disableRemotePlayback",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        // Microdata
        "itemScope"
      ].forEach(function(a) {
        Er[a] = new _r(
          a,
          Yr,
          !1,
          // mustUseProperty
          a.toLowerCase(),
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), [
        "checked",
        // Note: `option.selected` is not updated if `select.multiple` is
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected"
        // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
      ].forEach(function(a) {
        Er[a] = new _r(
          a,
          Yr,
          !0,
          // mustUseProperty
          a,
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), [
        "capture",
        "download"
        // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
      ].forEach(function(a) {
        Er[a] = new _r(
          a,
          Jr,
          !1,
          // mustUseProperty
          a,
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), [
        "cols",
        "rows",
        "size",
        "span"
        // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
      ].forEach(function(a) {
        Er[a] = new _r(
          a,
          ka,
          !1,
          // mustUseProperty
          a,
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), ["rowSpan", "start"].forEach(function(a) {
        Er[a] = new _r(
          a,
          xn,
          !1,
          // mustUseProperty
          a.toLowerCase(),
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      });
      var Yn = /[\-\:]([a-z])/g, ua = function(a) {
        return a[1].toUpperCase();
      };
      [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height"
        // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
      ].forEach(function(a) {
        var o = a.replace(Yn, ua);
        Er[o] = new _r(
          o,
          kr,
          !1,
          // mustUseProperty
          a,
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type"
        // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
      ].forEach(function(a) {
        var o = a.replace(Yn, ua);
        Er[o] = new _r(
          o,
          kr,
          !1,
          // mustUseProperty
          a,
          "http://www.w3.org/1999/xlink",
          !1,
          // sanitizeURL
          !1
        );
      }), [
        "xml:base",
        "xml:lang",
        "xml:space"
        // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
      ].forEach(function(a) {
        var o = a.replace(Yn, ua);
        Er[o] = new _r(
          o,
          kr,
          !1,
          // mustUseProperty
          a,
          "http://www.w3.org/XML/1998/namespace",
          !1,
          // sanitizeURL
          !1
        );
      }), ["tabIndex", "crossOrigin"].forEach(function(a) {
        Er[a] = new _r(
          a,
          kr,
          !1,
          // mustUseProperty
          a.toLowerCase(),
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      });
      var bo = "xlinkHref";
      Er[bo] = new _r(
        "xlinkHref",
        kr,
        !1,
        // mustUseProperty
        "xlink:href",
        "http://www.w3.org/1999/xlink",
        !0,
        // sanitizeURL
        !1
      ), ["src", "href", "action", "formAction"].forEach(function(a) {
        Er[a] = new _r(
          a,
          kr,
          !1,
          // mustUseProperty
          a.toLowerCase(),
          // attributeName
          null,
          // attributeNamespace
          !0,
          // sanitizeURL
          !0
        );
      });
      var Du = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Vo = !1;
      function Wo(a) {
        !Vo && Du.test(a) && (Vo = !0, s("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(a)));
      }
      function Yo(a, o, d, m) {
        if (m.mustUseProperty) {
          var b = m.propertyName;
          return a[b];
        } else {
          At(d, o), m.sanitizeURL && Wo("" + d);
          var O = m.attributeName, N = null;
          if (m.type === Jr) {
            if (a.hasAttribute(O)) {
              var I = a.getAttribute(O);
              return I === "" ? !0 : Mn(o, d, m, !1) ? I : I === "" + d ? d : I;
            }
          } else if (a.hasAttribute(O)) {
            if (Mn(o, d, m, !1))
              return a.getAttribute(O);
            if (m.type === Yr)
              return d;
            N = a.getAttribute(O);
          }
          return Mn(o, d, m, !1) ? N === null ? d : N : N === "" + d ? d : N;
        }
      }
      function Go(a, o, d, m) {
        {
          if (!Rr(o))
            return;
          if (!a.hasAttribute(o))
            return d === void 0 ? void 0 : null;
          var b = a.getAttribute(o);
          return At(d, o), b === "" + d ? d : b;
        }
      }
      function pi(a, o, d, m) {
        var b = Pr(o);
        if (!en(o, b, m)) {
          if (Mn(o, d, b, m) && (d = null), m || b === null) {
            if (Rr(o)) {
              var O = o;
              d === null ? a.removeAttribute(O) : (At(d, o), a.setAttribute(O, "" + d));
            }
            return;
          }
          var N = b.mustUseProperty;
          if (N) {
            var I = b.propertyName;
            if (d === null) {
              var L = b.type;
              a[I] = L === Yr ? !1 : "";
            } else
              a[I] = d;
            return;
          }
          var G = b.attributeName, K = b.attributeNamespace;
          if (d === null)
            a.removeAttribute(G);
          else {
            var ve = b.type, pe;
            ve === Yr || ve === Jr && d === !0 ? pe = "" : (At(d, G), pe = "" + d, b.sanitizeURL && Wo(pe.toString())), K ? a.setAttributeNS(K, G, pe) : a.setAttribute(G, pe);
          }
        }
      }
      var ni = Symbol.for("react.element"), Sr = Symbol.for("react.portal"), Gn = Symbol.for("react.fragment"), sa = Symbol.for("react.strict_mode"), Qa = Symbol.for("react.profiler"), Qo = Symbol.for("react.provider"), ue = Symbol.for("react.context"), Le = Symbol.for("react.forward_ref"), Je = Symbol.for("react.suspense"), lt = Symbol.for("react.suspense_list"), $t = Symbol.for("react.memo"), It = Symbol.for("react.lazy"), Kt = Symbol.for("react.scope"), Yt = Symbol.for("react.debug_trace_mode"), En = Symbol.for("react.offscreen"), tn = Symbol.for("react.legacy_hidden"), on = Symbol.for("react.cache"), hi = Symbol.for("react.tracing_marker"), wo = Symbol.iterator, Eo = "@@iterator";
      function zt(a) {
        if (a === null || typeof a != "object")
          return null;
        var o = wo && a[wo] || a[Eo];
        return typeof o == "function" ? o : null;
      }
      var Ht = Object.assign, So = 0, ml, yl, xs, Dc, bs, la, ed;
      function zi() {
      }
      zi.__reactDisabledLog = !0;
      function Gp() {
        {
          if (So === 0) {
            ml = console.log, yl = console.info, xs = console.warn, Dc = console.error, bs = console.group, la = console.groupCollapsed, ed = console.groupEnd;
            var a = {
              configurable: !0,
              enumerable: !0,
              value: zi,
              writable: !0
            };
            Object.defineProperties(console, {
              info: a,
              log: a,
              warn: a,
              error: a,
              group: a,
              groupCollapsed: a,
              groupEnd: a
            });
          }
          So++;
        }
      }
      function Qp() {
        {
          if (So--, So === 0) {
            var a = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: Ht({}, a, {
                value: ml
              }),
              info: Ht({}, a, {
                value: yl
              }),
              warn: Ht({}, a, {
                value: xs
              }),
              error: Ht({}, a, {
                value: Dc
              }),
              group: Ht({}, a, {
                value: bs
              }),
              groupCollapsed: Ht({}, a, {
                value: la
              }),
              groupEnd: Ht({}, a, {
                value: ed
              })
            });
          }
          So < 0 && s("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var kc = r.ReactCurrentDispatcher, ws;
      function Pa(a, o, d) {
        {
          if (ws === void 0)
            try {
              throw Error();
            } catch (b) {
              var m = b.stack.trim().match(/\n( *(at )?)/);
              ws = m && m[1] || "";
            }
          return `
` + ws + a;
        }
      }
      var _o = !1, Co;
      {
        var Rc = typeof WeakMap == "function" ? WeakMap : Map;
        Co = new Rc();
      }
      function gl(a, o) {
        if (!a || _o)
          return "";
        {
          var d = Co.get(a);
          if (d !== void 0)
            return d;
        }
        var m;
        _o = !0;
        var b = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var O;
        O = kc.current, kc.current = null, Gp();
        try {
          if (o) {
            var N = function() {
              throw Error();
            };
            if (Object.defineProperty(N.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(N, []);
              } catch (Oe) {
                m = Oe;
              }
              Reflect.construct(a, [], N);
            } else {
              try {
                N.call();
              } catch (Oe) {
                m = Oe;
              }
              a.call(N.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Oe) {
              m = Oe;
            }
            a();
          }
        } catch (Oe) {
          if (Oe && m && typeof Oe.stack == "string") {
            for (var I = Oe.stack.split(`
`), L = m.stack.split(`
`), G = I.length - 1, K = L.length - 1; G >= 1 && K >= 0 && I[G] !== L[K]; )
              K--;
            for (; G >= 1 && K >= 0; G--, K--)
              if (I[G] !== L[K]) {
                if (G !== 1 || K !== 1)
                  do
                    if (G--, K--, K < 0 || I[G] !== L[K]) {
                      var ve = `
` + I[G].replace(" at new ", " at ");
                      return a.displayName && ve.includes("<anonymous>") && (ve = ve.replace("<anonymous>", a.displayName)), typeof a == "function" && Co.set(a, ve), ve;
                    }
                  while (G >= 1 && K >= 0);
                break;
              }
          }
        } finally {
          _o = !1, kc.current = O, Qp(), Error.prepareStackTrace = b;
        }
        var pe = a ? a.displayName || a.name : "", Se = pe ? Pa(pe) : "";
        return typeof a == "function" && Co.set(a, Se), Se;
      }
      function Es(a, o, d) {
        return gl(a, !0);
      }
      function Pc(a, o, d) {
        return gl(a, !1);
      }
      function Mc(a) {
        var o = a.prototype;
        return !!(o && o.isReactComponent);
      }
      function ku(a, o, d) {
        if (a == null)
          return "";
        if (typeof a == "function")
          return gl(a, Mc(a));
        if (typeof a == "string")
          return Pa(a);
        switch (a) {
          case Je:
            return Pa("Suspense");
          case lt:
            return Pa("SuspenseList");
        }
        if (typeof a == "object")
          switch (a.$$typeof) {
            case Le:
              return Pc(a.render);
            case $t:
              return ku(a.type, o, d);
            case It: {
              var m = a, b = m._payload, O = m._init;
              try {
                return ku(O(b), o, d);
              } catch {
              }
            }
          }
        return "";
      }
      function im(a) {
        switch (a._debugOwner && a._debugOwner.type, a._debugSource, a.tag) {
          case w:
            return Pa(a.type);
          case B:
            return Pa("Lazy");
          case T:
            return Pa("Suspense");
          case q:
            return Pa("SuspenseList");
          case p:
          case v:
          case F:
            return Pc(a.type);
          case A:
            return Pc(a.type.render);
          case h:
            return Es(a.type);
          default:
            return "";
        }
      }
      function Ru(a) {
        try {
          var o = "", d = a;
          do
            o += im(d), d = d.return;
          while (d);
          return o;
        } catch (m) {
          return `
Error generating stack: ` + m.message + `
` + m.stack;
        }
      }
      function mr(a, o, d) {
        var m = a.displayName;
        if (m)
          return m;
        var b = o.displayName || o.name || "";
        return b !== "" ? d + "(" + b + ")" : d;
      }
      function Nc(a) {
        return a.displayName || "Context";
      }
      function or(a) {
        if (a == null)
          return null;
        if (typeof a.tag == "number" && s("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
          return a.displayName || a.name || null;
        if (typeof a == "string")
          return a;
        switch (a) {
          case Gn:
            return "Fragment";
          case Sr:
            return "Portal";
          case Qa:
            return "Profiler";
          case sa:
            return "StrictMode";
          case Je:
            return "Suspense";
          case lt:
            return "SuspenseList";
        }
        if (typeof a == "object")
          switch (a.$$typeof) {
            case ue:
              var o = a;
              return Nc(o) + ".Consumer";
            case Qo:
              var d = a;
              return Nc(d._context) + ".Provider";
            case Le:
              return mr(a, a.render, "ForwardRef");
            case $t:
              var m = a.displayName || null;
              return m !== null ? m : or(a.type) || "Memo";
            case It: {
              var b = a, O = b._payload, N = b._init;
              try {
                return or(N(O));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      function td(a, o, d) {
        var m = o.displayName || o.name || "";
        return a.displayName || (m !== "" ? d + "(" + m + ")" : d);
      }
      function Ko(a) {
        return a.displayName || "Context";
      }
      function Ft(a) {
        var o = a.tag, d = a.type;
        switch (o) {
          case ne:
            return "Cache";
          case k:
            var m = d;
            return Ko(m) + ".Consumer";
          case D:
            var b = d;
            return Ko(b._context) + ".Provider";
          case H:
            return "DehydratedFragment";
          case A:
            return td(d, d.render, "ForwardRef");
          case C:
            return "Fragment";
          case w:
            return d;
          case x:
            return "Portal";
          case y:
            return "Root";
          case E:
            return "Text";
          case B:
            return or(d);
          case S:
            return d === sa ? "StrictMode" : "Mode";
          case W:
            return "Offscreen";
          case R:
            return "Profiler";
          case Q:
            return "Scope";
          case T:
            return "Suspense";
          case q:
            return "SuspenseList";
          case ie:
            return "TracingMarker";
          // The display name for this tags come from the user-provided type:
          case h:
          case p:
          case V:
          case v:
          case M:
          case F:
            if (typeof d == "function")
              return d.displayName || d.name || null;
            if (typeof d == "string")
              return d;
            break;
        }
        return null;
      }
      var jc = r.ReactDebugCurrentFrame, vi = null, Xo = !1;
      function qi() {
        {
          if (vi === null)
            return null;
          var a = vi._debugOwner;
          if (a !== null && typeof a < "u")
            return Ft(a);
        }
        return null;
      }
      function Zo() {
        return vi === null ? "" : Ru(vi);
      }
      function un() {
        jc.getCurrentStack = null, vi = null, Xo = !1;
      }
      function Nr(a) {
        jc.getCurrentStack = a === null ? null : Zo, vi = a, Xo = !1;
      }
      function Ss() {
        return vi;
      }
      function Qn(a) {
        Xo = a;
      }
      function Ui(a) {
        return "" + a;
      }
      function Ka(a) {
        switch (typeof a) {
          case "boolean":
          case "number":
          case "string":
          case "undefined":
            return a;
          case "object":
            return Vt(a), a;
          default:
            return "";
        }
      }
      var xl = {
        button: !0,
        checkbox: !0,
        image: !0,
        hidden: !0,
        radio: !0,
        reset: !0,
        submit: !0
      };
      function rd(a, o) {
        xl[o.type] || o.onChange || o.onInput || o.readOnly || o.disabled || o.value == null || s("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), o.onChange || o.readOnly || o.disabled || o.checked == null || s("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
      }
      function nd(a) {
        var o = a.type, d = a.nodeName;
        return d && d.toLowerCase() === "input" && (o === "checkbox" || o === "radio");
      }
      function _s(a) {
        return a._valueTracker;
      }
      function bl(a) {
        a._valueTracker = null;
      }
      function am(a) {
        var o = "";
        return a && (nd(a) ? o = a.checked ? "true" : "false" : o = a.value), o;
      }
      function Xa(a) {
        var o = nd(a) ? "checked" : "value", d = Object.getOwnPropertyDescriptor(a.constructor.prototype, o);
        Vt(a[o]);
        var m = "" + a[o];
        if (!(a.hasOwnProperty(o) || typeof d > "u" || typeof d.get != "function" || typeof d.set != "function")) {
          var b = d.get, O = d.set;
          Object.defineProperty(a, o, {
            configurable: !0,
            get: function() {
              return b.call(this);
            },
            set: function(I) {
              Vt(I), m = "" + I, O.call(this, I);
            }
          }), Object.defineProperty(a, o, {
            enumerable: d.enumerable
          });
          var N = {
            getValue: function() {
              return m;
            },
            setValue: function(I) {
              Vt(I), m = "" + I;
            },
            stopTracking: function() {
              bl(a), delete a[o];
            }
          };
          return N;
        }
      }
      function Oo(a) {
        _s(a) || (a._valueTracker = Xa(a));
      }
      function Jo(a) {
        if (!a)
          return !1;
        var o = _s(a);
        if (!o)
          return !0;
        var d = o.getValue(), m = am(a);
        return m !== d ? (o.setValue(m), !0) : !1;
      }
      function Za(a) {
        if (a = a || (typeof document < "u" ? document : void 0), typeof a > "u")
          return null;
        try {
          return a.activeElement || a.body;
        } catch {
          return a.body;
        }
      }
      var Fc = !1, Ic = !1, Cs = !1, wl = !1;
      function Bc(a) {
        var o = a.type === "checkbox" || a.type === "radio";
        return o ? a.checked != null : a.value != null;
      }
      function Lc(a, o) {
        var d = a, m = o.checked, b = Ht({}, o, {
          defaultChecked: void 0,
          defaultValue: void 0,
          value: void 0,
          checked: m ?? d._wrapperState.initialChecked
        });
        return b;
      }
      function To(a, o) {
        rd("input", o), o.checked !== void 0 && o.defaultChecked !== void 0 && !Ic && (s("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", qi() || "A component", o.type), Ic = !0), o.value !== void 0 && o.defaultValue !== void 0 && !Fc && (s("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", qi() || "A component", o.type), Fc = !0);
        var d = a, m = o.defaultValue == null ? "" : o.defaultValue;
        d._wrapperState = {
          initialChecked: o.checked != null ? o.checked : o.defaultChecked,
          initialValue: Ka(o.value != null ? o.value : m),
          controlled: Bc(o)
        };
      }
      function $(a, o) {
        var d = a, m = o.checked;
        m != null && pi(d, "checked", m, !1);
      }
      function oe(a, o) {
        var d = a;
        {
          var m = Bc(o);
          !d._wrapperState.controlled && m && !wl && (s("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), wl = !0), d._wrapperState.controlled && !m && !Cs && (s("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Cs = !0);
        }
        $(a, o);
        var b = Ka(o.value), O = o.type;
        if (b != null)
          O === "number" ? (b === 0 && d.value === "" || // We explicitly want to coerce to number here if possible.
          // eslint-disable-next-line
          d.value != b) && (d.value = Ui(b)) : d.value !== Ui(b) && (d.value = Ui(b));
        else if (O === "submit" || O === "reset") {
          d.removeAttribute("value");
          return;
        }
        o.hasOwnProperty("value") ? _t(d, o.type, b) : o.hasOwnProperty("defaultValue") && _t(d, o.type, Ka(o.defaultValue)), o.checked == null && o.defaultChecked != null && (d.defaultChecked = !!o.defaultChecked);
      }
      function _e(a, o, d) {
        var m = a;
        if (o.hasOwnProperty("value") || o.hasOwnProperty("defaultValue")) {
          var b = o.type, O = b === "submit" || b === "reset";
          if (O && (o.value === void 0 || o.value === null))
            return;
          var N = Ui(m._wrapperState.initialValue);
          d || N !== m.value && (m.value = N), m.defaultValue = N;
        }
        var I = m.name;
        I !== "" && (m.name = ""), m.defaultChecked = !m.defaultChecked, m.defaultChecked = !!m._wrapperState.initialChecked, I !== "" && (m.name = I);
      }
      function Ae(a, o) {
        var d = a;
        oe(d, o), We(d, o);
      }
      function We(a, o) {
        var d = o.name;
        if (o.type === "radio" && d != null) {
          for (var m = a; m.parentNode; )
            m = m.parentNode;
          At(d, "name");
          for (var b = m.querySelectorAll("input[name=" + JSON.stringify("" + d) + '][type="radio"]'), O = 0; O < b.length; O++) {
            var N = b[O];
            if (!(N === a || N.form !== a.form)) {
              var I = D1(N);
              if (!I)
                throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
              Jo(N), oe(N, I);
            }
          }
        }
      }
      function _t(a, o, d) {
        // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
        (o !== "number" || Za(a.ownerDocument) !== a) && (d == null ? a.defaultValue = Ui(a._wrapperState.initialValue) : a.defaultValue !== Ui(d) && (a.defaultValue = Ui(d)));
      }
      var Xe = !1, Dt = !1, Xt = !1;
      function ur(a, o) {
        o.value == null && (typeof o.children == "object" && o.children !== null ? e.Children.forEach(o.children, function(d) {
          d != null && (typeof d == "string" || typeof d == "number" || Dt || (Dt = !0, s("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
        }) : o.dangerouslySetInnerHTML != null && (Xt || (Xt = !0, s("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), o.selected != null && !Xe && (s("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Xe = !0);
      }
      function rn(a, o) {
        o.value != null && a.setAttribute("value", Ui(Ka(o.value)));
      }
      var jr = Array.isArray;
      function Wt(a) {
        return jr(a);
      }
      var Fr;
      Fr = !1;
      function hn() {
        var a = qi();
        return a ? `

Check the render method of \`` + a + "`." : "";
      }
      var Os = ["value", "defaultValue"];
      function id(a) {
        {
          rd("select", a);
          for (var o = 0; o < Os.length; o++) {
            var d = Os[o];
            if (a[d] != null) {
              var m = Wt(a[d]);
              a.multiple && !m ? s("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", d, hn()) : !a.multiple && m && s("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", d, hn());
            }
          }
        }
      }
      function Pu(a, o, d, m) {
        var b = a.options;
        if (o) {
          for (var O = d, N = {}, I = 0; I < O.length; I++)
            N["$" + O[I]] = !0;
          for (var L = 0; L < b.length; L++) {
            var G = N.hasOwnProperty("$" + b[L].value);
            b[L].selected !== G && (b[L].selected = G), G && m && (b[L].defaultSelected = !0);
          }
        } else {
          for (var K = Ui(Ka(d)), ve = null, pe = 0; pe < b.length; pe++) {
            if (b[pe].value === K) {
              b[pe].selected = !0, m && (b[pe].defaultSelected = !0);
              return;
            }
            ve === null && !b[pe].disabled && (ve = b[pe]);
          }
          ve !== null && (ve.selected = !0);
        }
      }
      function ad(a, o) {
        return Ht({}, o, {
          value: void 0
        });
      }
      function El(a, o) {
        var d = a;
        id(o), d._wrapperState = {
          wasMultiple: !!o.multiple
        }, o.value !== void 0 && o.defaultValue !== void 0 && !Fr && (s("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Fr = !0);
      }
      function om(a, o) {
        var d = a;
        d.multiple = !!o.multiple;
        var m = o.value;
        m != null ? Pu(d, !!o.multiple, m, !1) : o.defaultValue != null && Pu(d, !!o.multiple, o.defaultValue, !0);
      }
      function Kp(a, o) {
        var d = a, m = d._wrapperState.wasMultiple;
        d._wrapperState.wasMultiple = !!o.multiple;
        var b = o.value;
        b != null ? Pu(d, !!o.multiple, b, !1) : m !== !!o.multiple && (o.defaultValue != null ? Pu(d, !!o.multiple, o.defaultValue, !0) : Pu(d, !!o.multiple, o.multiple ? [] : "", !1));
      }
      function um(a, o) {
        var d = a, m = o.value;
        m != null && Pu(d, !!o.multiple, m, !1);
      }
      var Zx = !1;
      function sm(a, o) {
        var d = a;
        if (o.dangerouslySetInnerHTML != null)
          throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
        var m = Ht({}, o, {
          value: void 0,
          defaultValue: void 0,
          children: Ui(d._wrapperState.initialValue)
        });
        return m;
      }
      function lm(a, o) {
        var d = a;
        rd("textarea", o), o.value !== void 0 && o.defaultValue !== void 0 && !Zx && (s("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", qi() || "A component"), Zx = !0);
        var m = o.value;
        if (m == null) {
          var b = o.children, O = o.defaultValue;
          if (b != null) {
            s("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
            {
              if (O != null)
                throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
              if (Wt(b)) {
                if (b.length > 1)
                  throw new Error("<textarea> can only have at most one child.");
                b = b[0];
              }
              O = b;
            }
          }
          O == null && (O = ""), m = O;
        }
        d._wrapperState = {
          initialValue: Ka(m)
        };
      }
      function Jx(a, o) {
        var d = a, m = Ka(o.value), b = Ka(o.defaultValue);
        if (m != null) {
          var O = Ui(m);
          O !== d.value && (d.value = O), o.defaultValue == null && d.defaultValue !== O && (d.defaultValue = O);
        }
        b != null && (d.defaultValue = Ui(b));
      }
      function eb(a, o) {
        var d = a, m = d.textContent;
        m === d._wrapperState.initialValue && m !== "" && m !== null && (d.value = m);
      }
      function vC(a, o) {
        Jx(a, o);
      }
      var Mu = "http://www.w3.org/1999/xhtml", cm = "http://www.w3.org/1998/Math/MathML", fm = "http://www.w3.org/2000/svg";
      function dm(a) {
        switch (a) {
          case "svg":
            return fm;
          case "math":
            return cm;
          default:
            return Mu;
        }
      }
      function pm(a, o) {
        return a == null || a === Mu ? dm(o) : a === fm && o === "foreignObject" ? Mu : a;
      }
      var tb = function(a) {
        return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(o, d, m, b) {
          MSApp.execUnsafeLocalFunction(function() {
            return a(o, d, m, b);
          });
        } : a;
      }, Xp, rb = tb(function(a, o) {
        if (a.namespaceURI === fm && !("innerHTML" in a)) {
          Xp = Xp || document.createElement("div"), Xp.innerHTML = "<svg>" + o.valueOf().toString() + "</svg>";
          for (var d = Xp.firstChild; a.firstChild; )
            a.removeChild(a.firstChild);
          for (; d.firstChild; )
            a.appendChild(d.firstChild);
          return;
        }
        a.innerHTML = o;
      }), ca = 1, Nu = 3, Nn = 8, ju = 9, hm = 11, $c = function(a, o) {
        if (o) {
          var d = a.firstChild;
          if (d && d === a.lastChild && d.nodeType === Nu) {
            d.nodeValue = o;
            return;
          }
        }
        a.textContent = o;
      }, od = {
        animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
        background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
        backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
        border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
        borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
        borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
        borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
        borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
        borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
        borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
        borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
        borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
        borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
        borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
        borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
        borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
        borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
        columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
        columns: ["columnCount", "columnWidth"],
        flex: ["flexBasis", "flexGrow", "flexShrink"],
        flexFlow: ["flexDirection", "flexWrap"],
        font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
        fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
        gap: ["columnGap", "rowGap"],
        grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
        gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
        gridColumn: ["gridColumnEnd", "gridColumnStart"],
        gridColumnGap: ["columnGap"],
        gridGap: ["columnGap", "rowGap"],
        gridRow: ["gridRowEnd", "gridRowStart"],
        gridRowGap: ["rowGap"],
        gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
        listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
        margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
        marker: ["markerEnd", "markerMid", "markerStart"],
        mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
        maskPosition: ["maskPositionX", "maskPositionY"],
        outline: ["outlineColor", "outlineStyle", "outlineWidth"],
        overflow: ["overflowX", "overflowY"],
        padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
        placeContent: ["alignContent", "justifyContent"],
        placeItems: ["alignItems", "justifyItems"],
        placeSelf: ["alignSelf", "justifySelf"],
        textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
        textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
        transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
        wordWrap: ["overflowWrap"]
      }, ud = {
        animationIterationCount: !0,
        aspectRatio: !0,
        borderImageOutset: !0,
        borderImageSlice: !0,
        borderImageWidth: !0,
        boxFlex: !0,
        boxFlexGroup: !0,
        boxOrdinalGroup: !0,
        columnCount: !0,
        columns: !0,
        flex: !0,
        flexGrow: !0,
        flexPositive: !0,
        flexShrink: !0,
        flexNegative: !0,
        flexOrder: !0,
        gridArea: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowSpan: !0,
        gridRowStart: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnSpan: !0,
        gridColumnStart: !0,
        fontWeight: !0,
        lineClamp: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        tabSize: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        // SVG-related properties
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeDasharray: !0,
        strokeDashoffset: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0,
        strokeWidth: !0
      };
      function nb(a, o) {
        return a + o.charAt(0).toUpperCase() + o.substring(1);
      }
      var ib = ["Webkit", "ms", "Moz", "O"];
      Object.keys(ud).forEach(function(a) {
        ib.forEach(function(o) {
          ud[nb(o, a)] = ud[a];
        });
      });
      function Zp(a, o, d) {
        var m = o == null || typeof o == "boolean" || o === "";
        return m ? "" : !d && typeof o == "number" && o !== 0 && !(ud.hasOwnProperty(a) && ud[a]) ? o + "px" : (Ar(o, a), ("" + o).trim());
      }
      var ab = /([A-Z])/g, ob = /^ms-/;
      function zc(a) {
        return a.replace(ab, "-$1").toLowerCase().replace(ob, "-ms-");
      }
      var ub = function() {
      };
      {
        var mC = /^(?:webkit|moz|o)[A-Z]/, yC = /^-ms-/, sb = /-(.)/g, vm = /;\s*$/, eu = {}, Sl = {}, lb = !1, sd = !1, gC = function(a) {
          return a.replace(sb, function(o, d) {
            return d.toUpperCase();
          });
        }, cb = function(a) {
          eu.hasOwnProperty(a) && eu[a] || (eu[a] = !0, s(
            "Unsupported style property %s. Did you mean %s?",
            a,
            // As Andi Smith suggests
            // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
            // is converted to lowercase `ms`.
            gC(a.replace(yC, "ms-"))
          ));
        }, mm = function(a) {
          eu.hasOwnProperty(a) && eu[a] || (eu[a] = !0, s("Unsupported vendor-prefixed style property %s. Did you mean %s?", a, a.charAt(0).toUpperCase() + a.slice(1)));
        }, ym = function(a, o) {
          Sl.hasOwnProperty(o) && Sl[o] || (Sl[o] = !0, s(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, a, o.replace(vm, "")));
        }, fb = function(a, o) {
          lb || (lb = !0, s("`NaN` is an invalid value for the `%s` css style property.", a));
        }, db = function(a, o) {
          sd || (sd = !0, s("`Infinity` is an invalid value for the `%s` css style property.", a));
        };
        ub = function(a, o) {
          a.indexOf("-") > -1 ? cb(a) : mC.test(a) ? mm(a) : vm.test(o) && ym(a, o), typeof o == "number" && (isNaN(o) ? fb(a, o) : isFinite(o) || db(a, o));
        };
      }
      var pb = ub;
      function xC(a) {
        {
          var o = "", d = "";
          for (var m in a)
            if (a.hasOwnProperty(m)) {
              var b = a[m];
              if (b != null) {
                var O = m.indexOf("--") === 0;
                o += d + (O ? m : zc(m)) + ":", o += Zp(m, b, O), d = ";";
              }
            }
          return o || null;
        }
      }
      function hb(a, o) {
        var d = a.style;
        for (var m in o)
          if (o.hasOwnProperty(m)) {
            var b = m.indexOf("--") === 0;
            b || pb(m, o[m]);
            var O = Zp(m, o[m], b);
            m === "float" && (m = "cssFloat"), b ? d.setProperty(m, O) : d[m] = O;
          }
      }
      function bC(a) {
        return a == null || typeof a == "boolean" || a === "";
      }
      function vb(a) {
        var o = {};
        for (var d in a)
          for (var m = od[d] || [d], b = 0; b < m.length; b++)
            o[m[b]] = d;
        return o;
      }
      function wC(a, o) {
        {
          if (!o)
            return;
          var d = vb(a), m = vb(o), b = {};
          for (var O in d) {
            var N = d[O], I = m[O];
            if (I && N !== I) {
              var L = N + "," + I;
              if (b[L])
                continue;
              b[L] = !0, s("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", bC(a[N]) ? "Removing" : "Updating", N, I);
            }
          }
        }
      }
      var Ao = {
        area: !0,
        base: !0,
        br: !0,
        col: !0,
        embed: !0,
        hr: !0,
        img: !0,
        input: !0,
        keygen: !0,
        link: !0,
        meta: !0,
        param: !0,
        source: !0,
        track: !0,
        wbr: !0
        // NOTE: menuitem's close tag should be omitted, but that causes problems.
      }, ld = Ht({
        menuitem: !0
      }, Ao), mb = "__html";
      function Jp(a, o) {
        if (o) {
          if (ld[a] && (o.children != null || o.dangerouslySetInnerHTML != null))
            throw new Error(a + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
          if (o.dangerouslySetInnerHTML != null) {
            if (o.children != null)
              throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (typeof o.dangerouslySetInnerHTML != "object" || !(mb in o.dangerouslySetInnerHTML))
              throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
          }
          if (!o.suppressContentEditableWarning && o.contentEditable && o.children != null && s("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), o.style != null && typeof o.style != "object")
            throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
        }
      }
      function Ts(a, o) {
        if (a.indexOf("-") === -1)
          return typeof o.is == "string";
        switch (a) {
          // These are reserved SVG and MathML elements.
          // We don't mind this list too much because we expect it to never grow.
          // The alternative is to track the namespace in a few places which is convoluted.
          // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
          case "annotation-xml":
          case "color-profile":
          case "font-face":
          case "font-face-src":
          case "font-face-uri":
          case "font-face-format":
          case "font-face-name":
          case "missing-glyph":
            return !1;
          default:
            return !0;
        }
      }
      var cd = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
      }, eh = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
      }, qc = {}, EC = new RegExp("^(aria)-[" + Ge + "]*$"), Uc = new RegExp("^(aria)[A-Z][" + Ge + "]*$");
      function gm(a, o) {
        {
          if (de.call(qc, o) && qc[o])
            return !0;
          if (Uc.test(o)) {
            var d = "aria-" + o.slice(4).toLowerCase(), m = eh.hasOwnProperty(d) ? d : null;
            if (m == null)
              return s("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", o), qc[o] = !0, !0;
            if (o !== m)
              return s("Invalid ARIA attribute `%s`. Did you mean `%s`?", o, m), qc[o] = !0, !0;
          }
          if (EC.test(o)) {
            var b = o.toLowerCase(), O = eh.hasOwnProperty(b) ? b : null;
            if (O == null)
              return qc[o] = !0, !1;
            if (o !== O)
              return s("Unknown ARIA attribute `%s`. Did you mean `%s`?", o, O), qc[o] = !0, !0;
          }
        }
        return !0;
      }
      function fd(a, o) {
        {
          var d = [];
          for (var m in o) {
            var b = gm(a, m);
            b || d.push(m);
          }
          var O = d.map(function(N) {
            return "`" + N + "`";
          }).join(", ");
          d.length === 1 ? s("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", O, a) : d.length > 1 && s("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", O, a);
        }
      }
      function xm(a, o) {
        Ts(a, o) || fd(a, o);
      }
      var bm = !1;
      function th(a, o) {
        {
          if (a !== "input" && a !== "textarea" && a !== "select")
            return;
          o != null && o.value === null && !bm && (bm = !0, a === "select" && o.multiple ? s("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", a) : s("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", a));
        }
      }
      var _l = function() {
      };
      {
        var mi = {}, wm = /^on./, rh = /^on[^A-Z]/, yb = new RegExp("^(aria)-[" + Ge + "]*$"), gb = new RegExp("^(aria)[A-Z][" + Ge + "]*$");
        _l = function(a, o, d, m) {
          if (de.call(mi, o) && mi[o])
            return !0;
          var b = o.toLowerCase();
          if (b === "onfocusin" || b === "onfocusout")
            return s("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), mi[o] = !0, !0;
          if (m != null) {
            var O = m.registrationNameDependencies, N = m.possibleRegistrationNames;
            if (O.hasOwnProperty(o))
              return !0;
            var I = N.hasOwnProperty(b) ? N[b] : null;
            if (I != null)
              return s("Invalid event handler property `%s`. Did you mean `%s`?", o, I), mi[o] = !0, !0;
            if (wm.test(o))
              return s("Unknown event handler property `%s`. It will be ignored.", o), mi[o] = !0, !0;
          } else if (wm.test(o))
            return rh.test(o) && s("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", o), mi[o] = !0, !0;
          if (yb.test(o) || gb.test(o))
            return !0;
          if (b === "innerhtml")
            return s("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), mi[o] = !0, !0;
          if (b === "aria")
            return s("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), mi[o] = !0, !0;
          if (b === "is" && d !== null && d !== void 0 && typeof d != "string")
            return s("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof d), mi[o] = !0, !0;
          if (typeof d == "number" && isNaN(d))
            return s("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", o), mi[o] = !0, !0;
          var L = Pr(o), G = L !== null && L.type === Ut;
          if (cd.hasOwnProperty(b)) {
            var K = cd[b];
            if (K !== o)
              return s("Invalid DOM property `%s`. Did you mean `%s`?", o, K), mi[o] = !0, !0;
          } else if (!G && o !== b)
            return s("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", o, b), mi[o] = !0, !0;
          return typeof d == "boolean" && Gr(o, d, L, !1) ? (d ? s('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', d, o, o, d, o) : s('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', d, o, o, d, o, o, o), mi[o] = !0, !0) : G ? !0 : Gr(o, d, L, !1) ? (mi[o] = !0, !1) : ((d === "false" || d === "true") && L !== null && L.type === Yr && (s("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", d, o, d === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', o, d), mi[o] = !0), !0);
        };
      }
      var xb = function(a, o, d) {
        {
          var m = [];
          for (var b in o) {
            var O = _l(a, b, o[b], d);
            O || m.push(b);
          }
          var N = m.map(function(I) {
            return "`" + I + "`";
          }).join(", ");
          m.length === 1 ? s("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", N, a) : m.length > 1 && s("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", N, a);
        }
      };
      function bb(a, o, d) {
        Ts(a, o) || xb(a, o, d);
      }
      var Em = 1, nh = 2, Ja = 4, Sm = Em | nh | Ja, Cl = null;
      function SC(a) {
        Cl !== null && s("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Cl = a;
      }
      function _C() {
        Cl === null && s("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Cl = null;
      }
      function dd(a) {
        return a === Cl;
      }
      function _m(a) {
        var o = a.target || a.srcElement || window;
        return o.correspondingUseElement && (o = o.correspondingUseElement), o.nodeType === Nu ? o.parentNode : o;
      }
      var ih = null, Ol = null, Cr = null;
      function ah(a) {
        var o = ff(a);
        if (o) {
          if (typeof ih != "function")
            throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
          var d = o.stateNode;
          if (d) {
            var m = D1(d);
            ih(o.stateNode, o.type, m);
          }
        }
      }
      function oh(a) {
        ih = a;
      }
      function Hc(a) {
        Ol ? Cr ? Cr.push(a) : Cr = [a] : Ol = a;
      }
      function wb() {
        return Ol !== null || Cr !== null;
      }
      function uh() {
        if (Ol) {
          var a = Ol, o = Cr;
          if (Ol = null, Cr = null, ah(a), o)
            for (var d = 0; d < o.length; d++)
              ah(o[d]);
        }
      }
      var Vc = function(a, o) {
        return a(o);
      }, pd = function() {
      }, As = !1;
      function Eb() {
        var a = wb();
        a && (pd(), uh());
      }
      function Sb(a, o, d) {
        if (As)
          return a(o, d);
        As = !0;
        try {
          return Vc(a, o, d);
        } finally {
          As = !1, Eb();
        }
      }
      function CC(a, o, d) {
        Vc = a, pd = d;
      }
      function _b(a) {
        return a === "button" || a === "input" || a === "select" || a === "textarea";
      }
      function sh(a, o, d) {
        switch (a) {
          case "onClick":
          case "onClickCapture":
          case "onDoubleClick":
          case "onDoubleClickCapture":
          case "onMouseDown":
          case "onMouseDownCapture":
          case "onMouseMove":
          case "onMouseMoveCapture":
          case "onMouseUp":
          case "onMouseUpCapture":
          case "onMouseEnter":
            return !!(d.disabled && _b(o));
          default:
            return !1;
        }
      }
      function Ds(a, o) {
        var d = a.stateNode;
        if (d === null)
          return null;
        var m = D1(d);
        if (m === null)
          return null;
        var b = m[o];
        if (sh(o, a.type, m))
          return null;
        if (b && typeof b != "function")
          throw new Error("Expected `" + o + "` listener to be a function, instead got a value of `" + typeof b + "` type.");
        return b;
      }
      var hd = !1;
      if (Ye)
        try {
          var Tl = {};
          Object.defineProperty(Tl, "passive", {
            get: function() {
              hd = !0;
            }
          }), window.addEventListener("test", Tl, Tl), window.removeEventListener("test", Tl, Tl);
        } catch {
          hd = !1;
        }
      function lh(a, o, d, m, b, O, N, I, L) {
        var G = Array.prototype.slice.call(arguments, 3);
        try {
          o.apply(d, G);
        } catch (K) {
          this.onError(K);
        }
      }
      var ch = lh;
      if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
        var Cm = document.createElement("react");
        ch = function(o, d, m, b, O, N, I, L, G) {
          if (typeof document > "u" || document === null)
            throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
          var K = document.createEvent("Event"), ve = !1, pe = !0, Se = window.event, Oe = Object.getOwnPropertyDescriptor(window, "event");
          function Pe() {
            Cm.removeEventListener(Me, Ct, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = Se);
          }
          var tt = Array.prototype.slice.call(arguments, 3);
          function Ct() {
            ve = !0, Pe(), d.apply(m, tt), pe = !1;
          }
          var bt, ar = !1, Zt = !1;
          function xe(be) {
            if (bt = be.error, ar = !0, bt === null && be.colno === 0 && be.lineno === 0 && (Zt = !0), be.defaultPrevented && bt != null && typeof bt == "object")
              try {
                bt._suppressLogging = !0;
              } catch {
              }
          }
          var Me = "react-" + (o || "invokeguardedcallback");
          if (window.addEventListener("error", xe), Cm.addEventListener(Me, Ct, !1), K.initEvent(Me, !1, !1), Cm.dispatchEvent(K), Oe && Object.defineProperty(window, "event", Oe), ve && pe && (ar ? Zt && (bt = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : bt = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(bt)), window.removeEventListener("error", xe), !ve)
            return Pe(), lh.apply(this, arguments);
        };
      }
      var Cb = ch, Wc = !1, fh = null, Yc = !1, tu = null, Ob = {
        onError: function(a) {
          Wc = !0, fh = a;
        }
      };
      function ks(a, o, d, m, b, O, N, I, L) {
        Wc = !1, fh = null, Cb.apply(Ob, arguments);
      }
      function ru(a, o, d, m, b, O, N, I, L) {
        if (ks.apply(this, arguments), Wc) {
          var G = md();
          Yc || (Yc = !0, tu = G);
        }
      }
      function vd() {
        if (Yc) {
          var a = tu;
          throw Yc = !1, tu = null, a;
        }
      }
      function Fu() {
        return Wc;
      }
      function md() {
        if (Wc) {
          var a = fh;
          return Wc = !1, fh = null, a;
        } else
          throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
      }
      function Gc(a) {
        return a._reactInternals;
      }
      function OC(a) {
        return a._reactInternals !== void 0;
      }
      function Al(a, o) {
        a._reactInternals = o;
      }
      var Et = (
        /*                      */
        0
      ), Do = (
        /*                */
        1
      ), Sn = (
        /*                    */
        2
      ), rr = (
        /*                       */
        4
      ), eo = (
        /*                */
        16
      ), ko = (
        /*                 */
        32
      ), nn = (
        /*                     */
        64
      ), wt = (
        /*                   */
        128
      ), fa = (
        /*            */
        256
      ), bn = (
        /*                          */
        512
      ), Kn = (
        /*                     */
        1024
      ), da = (
        /*                      */
        2048
      ), to = (
        /*                    */
        4096
      ), jn = (
        /*                   */
        8192
      ), Qc = (
        /*             */
        16384
      ), Tb = (
        /*               */
        32767
      ), yd = (
        /*                   */
        32768
      ), pa = (
        /*                */
        65536
      ), dh = (
        /* */
        131072
      ), nu = (
        /*                       */
        1048576
      ), Kc = (
        /*                    */
        2097152
      ), Iu = (
        /*                 */
        4194304
      ), ph = (
        /*                */
        8388608
      ), Rs = (
        /*               */
        16777216
      ), iu = (
        /*              */
        33554432
      ), Ps = (
        // TODO: Remove Update flag from before mutation phase by re-landing Visibility
        // flag logic (see #20043)
        rr | Kn | 0
      ), Ms = Sn | rr | eo | ko | bn | to | jn, Ns = rr | nn | bn | jn, Bu = da | eo, Fn = Iu | ph | Kc, ro = r.ReactCurrentOwner;
      function Ma(a) {
        var o = a, d = a;
        if (a.alternate)
          for (; o.return; )
            o = o.return;
        else {
          var m = o;
          do
            o = m, (o.flags & (Sn | to)) !== Et && (d = o.return), m = o.return;
          while (m);
        }
        return o.tag === y ? d : null;
      }
      function au(a) {
        if (a.tag === T) {
          var o = a.memoizedState;
          if (o === null) {
            var d = a.alternate;
            d !== null && (o = d.memoizedState);
          }
          if (o !== null)
            return o.dehydrated;
        }
        return null;
      }
      function ou(a) {
        return a.tag === y ? a.stateNode.containerInfo : null;
      }
      function Dl(a) {
        return Ma(a) === a;
      }
      function Ab(a) {
        {
          var o = ro.current;
          if (o !== null && o.tag === h) {
            var d = o, m = d.stateNode;
            m._warnedAboutRefsInRender || s("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Ft(d) || "A component"), m._warnedAboutRefsInRender = !0;
          }
        }
        var b = Gc(a);
        return b ? Ma(b) === b : !1;
      }
      function hh(a) {
        if (Ma(a) !== a)
          throw new Error("Unable to find node on an unmounted component.");
      }
      function vh(a) {
        var o = a.alternate;
        if (!o) {
          var d = Ma(a);
          if (d === null)
            throw new Error("Unable to find node on an unmounted component.");
          return d !== a ? null : a;
        }
        for (var m = a, b = o; ; ) {
          var O = m.return;
          if (O === null)
            break;
          var N = O.alternate;
          if (N === null) {
            var I = O.return;
            if (I !== null) {
              m = b = I;
              continue;
            }
            break;
          }
          if (O.child === N.child) {
            for (var L = O.child; L; ) {
              if (L === m)
                return hh(O), a;
              if (L === b)
                return hh(O), o;
              L = L.sibling;
            }
            throw new Error("Unable to find node on an unmounted component.");
          }
          if (m.return !== b.return)
            m = O, b = N;
          else {
            for (var G = !1, K = O.child; K; ) {
              if (K === m) {
                G = !0, m = O, b = N;
                break;
              }
              if (K === b) {
                G = !0, b = O, m = N;
                break;
              }
              K = K.sibling;
            }
            if (!G) {
              for (K = N.child; K; ) {
                if (K === m) {
                  G = !0, m = N, b = O;
                  break;
                }
                if (K === b) {
                  G = !0, b = N, m = O;
                  break;
                }
                K = K.sibling;
              }
              if (!G)
                throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
            }
          }
          if (m.alternate !== b)
            throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (m.tag !== y)
          throw new Error("Unable to find node on an unmounted component.");
        return m.stateNode.current === m ? a : o;
      }
      function ha(a) {
        var o = vh(a);
        return o !== null ? va(o) : null;
      }
      function va(a) {
        if (a.tag === w || a.tag === E)
          return a;
        for (var o = a.child; o !== null; ) {
          var d = va(o);
          if (d !== null)
            return d;
          o = o.sibling;
        }
        return null;
      }
      function cn(a) {
        var o = vh(a);
        return o !== null ? no(o) : null;
      }
      function no(a) {
        if (a.tag === w || a.tag === E)
          return a;
        for (var o = a.child; o !== null; ) {
          if (o.tag !== x) {
            var d = no(o);
            if (d !== null)
              return d;
          }
          o = o.sibling;
        }
        return null;
      }
      var Om = t.unstable_scheduleCallback, Db = t.unstable_cancelCallback, Tm = t.unstable_shouldYield, Am = t.unstable_requestPaint, Xn = t.unstable_now, mh = t.unstable_getCurrentPriorityLevel, gd = t.unstable_ImmediatePriority, js = t.unstable_UserBlockingPriority, Lu = t.unstable_NormalPriority, TC = t.unstable_LowPriority, kl = t.unstable_IdlePriority, yh = t.unstable_yieldValue, kb = t.unstable_setDisableYieldValue, Rl = null, _n = null, et = null, Na = !1, ma = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
      function Xc(a) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
          return !1;
        var o = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (o.isDisabled)
          return !0;
        if (!o.supportsFiber)
          return s("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
        try {
          te && (a = Ht({}, a, {
            getLaneLabelMap: Pl,
            injectProfilingHooks: io
          })), Rl = o.inject(a), _n = o;
        } catch (d) {
          s("React instrumentation encountered an error: %s.", d);
        }
        return !!o.checkDCE;
      }
      function Dm(a, o) {
        if (_n && typeof _n.onScheduleFiberRoot == "function")
          try {
            _n.onScheduleFiberRoot(Rl, a, o);
          } catch (d) {
            Na || (Na = !0, s("React instrumentation encountered an error: %s", d));
          }
      }
      function km(a, o) {
        if (_n && typeof _n.onCommitFiberRoot == "function")
          try {
            var d = (a.current.flags & wt) === wt;
            if (ae) {
              var m;
              switch (o) {
                case Hi:
                  m = gd;
                  break;
                case su:
                  m = js;
                  break;
                case ao:
                  m = Lu;
                  break;
                case oo:
                  m = kl;
                  break;
                default:
                  m = Lu;
                  break;
              }
              _n.onCommitFiberRoot(Rl, a, m, d);
            }
          } catch (b) {
            Na || (Na = !0, s("React instrumentation encountered an error: %s", b));
          }
      }
      function Rm(a) {
        if (_n && typeof _n.onPostCommitFiberRoot == "function")
          try {
            _n.onPostCommitFiberRoot(Rl, a);
          } catch (o) {
            Na || (Na = !0, s("React instrumentation encountered an error: %s", o));
          }
      }
      function Pm(a) {
        if (_n && typeof _n.onCommitFiberUnmount == "function")
          try {
            _n.onCommitFiberUnmount(Rl, a);
          } catch (o) {
            Na || (Na = !0, s("React instrumentation encountered an error: %s", o));
          }
      }
      function vn(a) {
        if (typeof yh == "function" && (kb(a), i(a)), _n && typeof _n.setStrictMode == "function")
          try {
            _n.setStrictMode(Rl, a);
          } catch (o) {
            Na || (Na = !0, s("React instrumentation encountered an error: %s", o));
          }
      }
      function io(a) {
        et = a;
      }
      function Pl() {
        {
          for (var a = /* @__PURE__ */ new Map(), o = 1, d = 0; d < jl; d++) {
            var m = Nb(o);
            a.set(o, m), o *= 2;
          }
          return a;
        }
      }
      function Mm(a) {
        et !== null && typeof et.markCommitStarted == "function" && et.markCommitStarted(a);
      }
      function Nm() {
        et !== null && typeof et.markCommitStopped == "function" && et.markCommitStopped();
      }
      function ja(a) {
        et !== null && typeof et.markComponentRenderStarted == "function" && et.markComponentRenderStarted(a);
      }
      function Fa() {
        et !== null && typeof et.markComponentRenderStopped == "function" && et.markComponentRenderStopped();
      }
      function jm(a) {
        et !== null && typeof et.markComponentPassiveEffectMountStarted == "function" && et.markComponentPassiveEffectMountStarted(a);
      }
      function Rb() {
        et !== null && typeof et.markComponentPassiveEffectMountStopped == "function" && et.markComponentPassiveEffectMountStopped();
      }
      function $u(a) {
        et !== null && typeof et.markComponentPassiveEffectUnmountStarted == "function" && et.markComponentPassiveEffectUnmountStarted(a);
      }
      function Fs() {
        et !== null && typeof et.markComponentPassiveEffectUnmountStopped == "function" && et.markComponentPassiveEffectUnmountStopped();
      }
      function gh(a) {
        et !== null && typeof et.markComponentLayoutEffectMountStarted == "function" && et.markComponentLayoutEffectMountStarted(a);
      }
      function Pb() {
        et !== null && typeof et.markComponentLayoutEffectMountStopped == "function" && et.markComponentLayoutEffectMountStopped();
      }
      function xd(a) {
        et !== null && typeof et.markComponentLayoutEffectUnmountStarted == "function" && et.markComponentLayoutEffectUnmountStarted(a);
      }
      function Fm() {
        et !== null && typeof et.markComponentLayoutEffectUnmountStopped == "function" && et.markComponentLayoutEffectUnmountStopped();
      }
      function bd(a, o, d) {
        et !== null && typeof et.markComponentErrored == "function" && et.markComponentErrored(a, o, d);
      }
      function uu(a, o, d) {
        et !== null && typeof et.markComponentSuspended == "function" && et.markComponentSuspended(a, o, d);
      }
      function wd(a) {
        et !== null && typeof et.markLayoutEffectsStarted == "function" && et.markLayoutEffectsStarted(a);
      }
      function Ed() {
        et !== null && typeof et.markLayoutEffectsStopped == "function" && et.markLayoutEffectsStopped();
      }
      function Ml(a) {
        et !== null && typeof et.markPassiveEffectsStarted == "function" && et.markPassiveEffectsStarted(a);
      }
      function Im() {
        et !== null && typeof et.markPassiveEffectsStopped == "function" && et.markPassiveEffectsStopped();
      }
      function Nl(a) {
        et !== null && typeof et.markRenderStarted == "function" && et.markRenderStarted(a);
      }
      function Mb() {
        et !== null && typeof et.markRenderYielded == "function" && et.markRenderYielded();
      }
      function xh() {
        et !== null && typeof et.markRenderStopped == "function" && et.markRenderStopped();
      }
      function mn(a) {
        et !== null && typeof et.markRenderScheduled == "function" && et.markRenderScheduled(a);
      }
      function bh(a, o) {
        et !== null && typeof et.markForceUpdateScheduled == "function" && et.markForceUpdateScheduled(a, o);
      }
      function Sd(a, o) {
        et !== null && typeof et.markStateUpdateScheduled == "function" && et.markStateUpdateScheduled(a, o);
      }
      var St = (
        /*                         */
        0
      ), Gt = (
        /*                 */
        1
      ), yr = (
        /*                    */
        2
      ), Ir = (
        /*               */
        8
      ), gr = (
        /*              */
        16
      ), In = Math.clz32 ? Math.clz32 : _d, ii = Math.log, wh = Math.LN2;
      function _d(a) {
        var o = a >>> 0;
        return o === 0 ? 32 : 31 - (ii(o) / wh | 0) | 0;
      }
      var jl = 31, $e = (
        /*                        */
        0
      ), fr = (
        /*                          */
        0
      ), Rt = (
        /*                        */
        1
      ), Is = (
        /*    */
        2
      ), Ro = (
        /*             */
        4
      ), Pi = (
        /*            */
        8
      ), Cn = (
        /*                     */
        16
      ), zu = (
        /*                */
        32
      ), Bs = (
        /*                       */
        4194240
      ), Fl = (
        /*                        */
        64
      ), Eh = (
        /*                        */
        128
      ), Sh = (
        /*                        */
        256
      ), _h = (
        /*                        */
        512
      ), Ch = (
        /*                        */
        1024
      ), Oh = (
        /*                        */
        2048
      ), Th = (
        /*                        */
        4096
      ), Ah = (
        /*                        */
        8192
      ), Dh = (
        /*                        */
        16384
      ), Il = (
        /*                       */
        32768
      ), kh = (
        /*                       */
        65536
      ), Zc = (
        /*                       */
        131072
      ), Jc = (
        /*                       */
        262144
      ), Rh = (
        /*                       */
        524288
      ), Cd = (
        /*                       */
        1048576
      ), Ph = (
        /*                       */
        2097152
      ), Od = (
        /*                            */
        130023424
      ), Bl = (
        /*                             */
        4194304
      ), Mh = (
        /*                             */
        8388608
      ), Td = (
        /*                             */
        16777216
      ), Nh = (
        /*                             */
        33554432
      ), jh = (
        /*                             */
        67108864
      ), Bm = Bl, Ad = (
        /*          */
        134217728
      ), Lm = (
        /*                          */
        268435455
      ), Dd = (
        /*               */
        268435456
      ), Ll = (
        /*                        */
        536870912
      ), Ia = (
        /*                   */
        1073741824
      );
      function Nb(a) {
        {
          if (a & Rt)
            return "Sync";
          if (a & Is)
            return "InputContinuousHydration";
          if (a & Ro)
            return "InputContinuous";
          if (a & Pi)
            return "DefaultHydration";
          if (a & Cn)
            return "Default";
          if (a & zu)
            return "TransitionHydration";
          if (a & Bs)
            return "Transition";
          if (a & Od)
            return "Retry";
          if (a & Ad)
            return "SelectiveHydration";
          if (a & Dd)
            return "IdleHydration";
          if (a & Ll)
            return "Idle";
          if (a & Ia)
            return "Offscreen";
        }
      }
      var Qr = -1, $l = Fl, Fh = Bl;
      function kd(a) {
        switch (Ls(a)) {
          case Rt:
            return Rt;
          case Is:
            return Is;
          case Ro:
            return Ro;
          case Pi:
            return Pi;
          case Cn:
            return Cn;
          case zu:
            return zu;
          case Fl:
          case Eh:
          case Sh:
          case _h:
          case Ch:
          case Oh:
          case Th:
          case Ah:
          case Dh:
          case Il:
          case kh:
          case Zc:
          case Jc:
          case Rh:
          case Cd:
          case Ph:
            return a & Bs;
          case Bl:
          case Mh:
          case Td:
          case Nh:
          case jh:
            return a & Od;
          case Ad:
            return Ad;
          case Dd:
            return Dd;
          case Ll:
            return Ll;
          case Ia:
            return Ia;
          default:
            return s("Should have found matching lanes. This is a bug in React."), a;
        }
      }
      function Ih(a, o) {
        var d = a.pendingLanes;
        if (d === $e)
          return $e;
        var m = $e, b = a.suspendedLanes, O = a.pingedLanes, N = d & Lm;
        if (N !== $e) {
          var I = N & ~b;
          if (I !== $e)
            m = kd(I);
          else {
            var L = N & O;
            L !== $e && (m = kd(L));
          }
        } else {
          var G = d & ~b;
          G !== $e ? m = kd(G) : O !== $e && (m = kd(O));
        }
        if (m === $e)
          return $e;
        if (o !== $e && o !== m && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (o & b) === $e) {
          var K = Ls(m), ve = Ls(o);
          if (
            // Tests whether the next lane is equal or lower priority than the wip
            // one. This works because the bits decrease in priority as you go left.
            K >= ve || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            K === Cn && (ve & Bs) !== $e
          )
            return o;
        }
        (m & Ro) !== $e && (m |= d & Cn);
        var pe = a.entangledLanes;
        if (pe !== $e)
          for (var Se = a.entanglements, Oe = m & pe; Oe > 0; ) {
            var Pe = Bn(Oe), tt = 1 << Pe;
            m |= Se[Pe], Oe &= ~tt;
          }
        return m;
      }
      function Po(a, o) {
        for (var d = a.eventTimes, m = Qr; o > 0; ) {
          var b = Bn(o), O = 1 << b, N = d[b];
          N > m && (m = N), o &= ~O;
        }
        return m;
      }
      function $m(a, o) {
        switch (a) {
          case Rt:
          case Is:
          case Ro:
            return o + 250;
          case Pi:
          case Cn:
          case zu:
          case Fl:
          case Eh:
          case Sh:
          case _h:
          case Ch:
          case Oh:
          case Th:
          case Ah:
          case Dh:
          case Il:
          case kh:
          case Zc:
          case Jc:
          case Rh:
          case Cd:
          case Ph:
            return o + 5e3;
          case Bl:
          case Mh:
          case Td:
          case Nh:
          case jh:
            return Qr;
          case Ad:
          case Dd:
          case Ll:
          case Ia:
            return Qr;
          default:
            return s("Should have found matching lanes. This is a bug in React."), Qr;
        }
      }
      function Bh(a, o) {
        for (var d = a.pendingLanes, m = a.suspendedLanes, b = a.pingedLanes, O = a.expirationTimes, N = d; N > 0; ) {
          var I = Bn(N), L = 1 << I, G = O[I];
          G === Qr ? ((L & m) === $e || (L & b) !== $e) && (O[I] = $m(L, o)) : G <= o && (a.expiredLanes |= L), N &= ~L;
        }
      }
      function jb(a) {
        return kd(a.pendingLanes);
      }
      function Lh(a) {
        var o = a.pendingLanes & -1073741825;
        return o !== $e ? o : o & Ia ? Ia : $e;
      }
      function Fb(a) {
        return (a & Rt) !== $e;
      }
      function Rd(a) {
        return (a & Lm) !== $e;
      }
      function zl(a) {
        return (a & Od) === a;
      }
      function zm(a) {
        var o = Rt | Ro | Cn;
        return (a & o) === $e;
      }
      function qm(a) {
        return (a & Bs) === a;
      }
      function $h(a, o) {
        var d = Is | Ro | Pi | Cn;
        return (o & d) !== $e;
      }
      function Ib(a, o) {
        return (o & a.expiredLanes) !== $e;
      }
      function Um(a) {
        return (a & Bs) !== $e;
      }
      function Hm() {
        var a = $l;
        return $l <<= 1, ($l & Bs) === $e && ($l = Fl), a;
      }
      function Bb() {
        var a = Fh;
        return Fh <<= 1, (Fh & Od) === $e && (Fh = Bl), a;
      }
      function Ls(a) {
        return a & -a;
      }
      function Pd(a) {
        return Ls(a);
      }
      function Bn(a) {
        return 31 - In(a);
      }
      function yi(a) {
        return Bn(a);
      }
      function ya(a, o) {
        return (a & o) !== $e;
      }
      function ql(a, o) {
        return (a & o) === o;
      }
      function qt(a, o) {
        return a | o;
      }
      function Md(a, o) {
        return a & ~o;
      }
      function Vm(a, o) {
        return a & o;
      }
      function Lb(a) {
        return a;
      }
      function $b(a, o) {
        return a !== fr && a < o ? a : o;
      }
      function Nd(a) {
        for (var o = [], d = 0; d < jl; d++)
          o.push(a);
        return o;
      }
      function ef(a, o, d) {
        a.pendingLanes |= o, o !== Ll && (a.suspendedLanes = $e, a.pingedLanes = $e);
        var m = a.eventTimes, b = yi(o);
        m[b] = d;
      }
      function zb(a, o) {
        a.suspendedLanes |= o, a.pingedLanes &= ~o;
        for (var d = a.expirationTimes, m = o; m > 0; ) {
          var b = Bn(m), O = 1 << b;
          d[b] = Qr, m &= ~O;
        }
      }
      function zh(a, o, d) {
        a.pingedLanes |= a.suspendedLanes & o;
      }
      function Wm(a, o) {
        var d = a.pendingLanes & ~o;
        a.pendingLanes = o, a.suspendedLanes = $e, a.pingedLanes = $e, a.expiredLanes &= o, a.mutableReadLanes &= o, a.entangledLanes &= o;
        for (var m = a.entanglements, b = a.eventTimes, O = a.expirationTimes, N = d; N > 0; ) {
          var I = Bn(N), L = 1 << I;
          m[I] = $e, b[I] = Qr, O[I] = Qr, N &= ~L;
        }
      }
      function qh(a, o) {
        for (var d = a.entangledLanes |= o, m = a.entanglements, b = d; b; ) {
          var O = Bn(b), N = 1 << O;
          // Is this one of the newly entangled lanes?
          N & o | // Is this lane transitively entangled with the newly entangled lanes?
          m[O] & o && (m[O] |= o), b &= ~N;
        }
      }
      function Ym(a, o) {
        var d = Ls(o), m;
        switch (d) {
          case Ro:
            m = Is;
            break;
          case Cn:
            m = Pi;
            break;
          case Fl:
          case Eh:
          case Sh:
          case _h:
          case Ch:
          case Oh:
          case Th:
          case Ah:
          case Dh:
          case Il:
          case kh:
          case Zc:
          case Jc:
          case Rh:
          case Cd:
          case Ph:
          case Bl:
          case Mh:
          case Td:
          case Nh:
          case jh:
            m = zu;
            break;
          case Ll:
            m = Dd;
            break;
          default:
            m = fr;
            break;
        }
        return (m & (a.suspendedLanes | o)) !== fr ? fr : m;
      }
      function jd(a, o, d) {
        if (ma)
          for (var m = a.pendingUpdatersLaneMap; d > 0; ) {
            var b = yi(d), O = 1 << b, N = m[b];
            N.add(o), d &= ~O;
          }
      }
      function qb(a, o) {
        if (ma)
          for (var d = a.pendingUpdatersLaneMap, m = a.memoizedUpdaters; o > 0; ) {
            var b = yi(o), O = 1 << b, N = d[b];
            N.size > 0 && (N.forEach(function(I) {
              var L = I.alternate;
              (L === null || !m.has(L)) && m.add(I);
            }), N.clear()), o &= ~O;
          }
      }
      function Gm(a, o) {
        return null;
      }
      var Hi = Rt, su = Ro, ao = Cn, oo = Ll, Fd = fr;
      function uo() {
        return Fd;
      }
      function Ln(a) {
        Fd = a;
      }
      function Ub(a, o) {
        var d = Fd;
        try {
          return Fd = a, o();
        } finally {
          Fd = d;
        }
      }
      function Hb(a, o) {
        return a !== 0 && a < o ? a : o;
      }
      function Id(a, o) {
        return a > o ? a : o;
      }
      function ai(a, o) {
        return a !== 0 && a < o;
      }
      function Vb(a) {
        var o = Ls(a);
        return ai(Hi, o) ? ai(su, o) ? Rd(o) ? ao : oo : su : Hi;
      }
      function Uh(a) {
        var o = a.current.memoizedState;
        return o.isDehydrated;
      }
      var Bd;
      function Mi(a) {
        Bd = a;
      }
      function AC(a) {
        Bd(a);
      }
      var ut;
      function tf(a) {
        ut = a;
      }
      var Hh;
      function Wb(a) {
        Hh = a;
      }
      var Yb;
      function Ld(a) {
        Yb = a;
      }
      var $d;
      function Qm(a) {
        $d = a;
      }
      var Vh = !1, zd = [], qu = null, lu = null, cu = null, On = /* @__PURE__ */ new Map(), Vi = /* @__PURE__ */ new Map(), Wi = [], Gb = [
        "mousedown",
        "mouseup",
        "touchcancel",
        "touchend",
        "touchstart",
        "auxclick",
        "dblclick",
        "pointercancel",
        "pointerdown",
        "pointerup",
        "dragend",
        "dragstart",
        "drop",
        "compositionend",
        "compositionstart",
        "keydown",
        "keypress",
        "keyup",
        "input",
        "textInput",
        // Intentionally camelCase
        "copy",
        "cut",
        "paste",
        "click",
        "change",
        "contextmenu",
        "reset",
        "submit"
      ];
      function Qb(a) {
        return Gb.indexOf(a) > -1;
      }
      function Mo(a, o, d, m, b) {
        return {
          blockedOn: a,
          domEventName: o,
          eventSystemFlags: d,
          nativeEvent: b,
          targetContainers: [m]
        };
      }
      function Km(a, o) {
        switch (a) {
          case "focusin":
          case "focusout":
            qu = null;
            break;
          case "dragenter":
          case "dragleave":
            lu = null;
            break;
          case "mouseover":
          case "mouseout":
            cu = null;
            break;
          case "pointerover":
          case "pointerout": {
            var d = o.pointerId;
            On.delete(d);
            break;
          }
          case "gotpointercapture":
          case "lostpointercapture": {
            var m = o.pointerId;
            Vi.delete(m);
            break;
          }
        }
      }
      function ga(a, o, d, m, b, O) {
        if (a === null || a.nativeEvent !== O) {
          var N = Mo(o, d, m, b, O);
          if (o !== null) {
            var I = ff(o);
            I !== null && ut(I);
          }
          return N;
        }
        a.eventSystemFlags |= m;
        var L = a.targetContainers;
        return b !== null && L.indexOf(b) === -1 && L.push(b), a;
      }
      function DC(a, o, d, m, b) {
        switch (o) {
          case "focusin": {
            var O = b;
            return qu = ga(qu, a, o, d, m, O), !0;
          }
          case "dragenter": {
            var N = b;
            return lu = ga(lu, a, o, d, m, N), !0;
          }
          case "mouseover": {
            var I = b;
            return cu = ga(cu, a, o, d, m, I), !0;
          }
          case "pointerover": {
            var L = b, G = L.pointerId;
            return On.set(G, ga(On.get(G) || null, a, o, d, m, L)), !0;
          }
          case "gotpointercapture": {
            var K = b, ve = K.pointerId;
            return Vi.set(ve, ga(Vi.get(ve) || null, a, o, d, m, K)), !0;
          }
        }
        return !1;
      }
      function Xm(a) {
        var o = Jd(a.target);
        if (o !== null) {
          var d = Ma(o);
          if (d !== null) {
            var m = d.tag;
            if (m === T) {
              var b = au(d);
              if (b !== null) {
                a.blockedOn = b, $d(a.priority, function() {
                  Hh(d);
                });
                return;
              }
            } else if (m === y) {
              var O = d.stateNode;
              if (Uh(O)) {
                a.blockedOn = ou(d);
                return;
              }
            }
          }
        }
        a.blockedOn = null;
      }
      function Kb(a) {
        for (var o = Yb(), d = {
          blockedOn: null,
          target: a,
          priority: o
        }, m = 0; m < Wi.length && ai(o, Wi[m].priority); m++)
          ;
        Wi.splice(m, 0, d), m === 0 && Xm(d);
      }
      function qd(a) {
        if (a.blockedOn !== null)
          return !1;
        for (var o = a.targetContainers; o.length > 0; ) {
          var d = o[0], m = nf(a.domEventName, a.eventSystemFlags, d, a.nativeEvent);
          if (m === null) {
            var b = a.nativeEvent, O = new b.constructor(b.type, b);
            SC(O), b.target.dispatchEvent(O), _C();
          } else {
            var N = ff(m);
            return N !== null && ut(N), a.blockedOn = m, !1;
          }
          o.shift();
        }
        return !0;
      }
      function Zm(a, o, d) {
        qd(a) && d.delete(o);
      }
      function kC() {
        Vh = !1, qu !== null && qd(qu) && (qu = null), lu !== null && qd(lu) && (lu = null), cu !== null && qd(cu) && (cu = null), On.forEach(Zm), Vi.forEach(Zm);
      }
      function $s(a, o) {
        a.blockedOn === o && (a.blockedOn = null, Vh || (Vh = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, kC)));
      }
      function Ul(a) {
        if (zd.length > 0) {
          $s(zd[0], a);
          for (var o = 1; o < zd.length; o++) {
            var d = zd[o];
            d.blockedOn === a && (d.blockedOn = null);
          }
        }
        qu !== null && $s(qu, a), lu !== null && $s(lu, a), cu !== null && $s(cu, a);
        var m = function(I) {
          return $s(I, a);
        };
        On.forEach(m), Vi.forEach(m);
        for (var b = 0; b < Wi.length; b++) {
          var O = Wi[b];
          O.blockedOn === a && (O.blockedOn = null);
        }
        for (; Wi.length > 0; ) {
          var N = Wi[0];
          if (N.blockedOn !== null)
            break;
          Xm(N), N.blockedOn === null && Wi.shift();
        }
      }
      var gi = r.ReactCurrentBatchConfig, nr = !0;
      function Zn(a) {
        nr = !!a;
      }
      function $n() {
        return nr;
      }
      function xi(a, o, d) {
        var m = Wh(o), b;
        switch (m) {
          case Hi:
            b = Ba;
            break;
          case su:
            b = rf;
            break;
          case ao:
          default:
            b = Tn;
            break;
        }
        return b.bind(null, o, d, a);
      }
      function Ba(a, o, d, m) {
        var b = uo(), O = gi.transition;
        gi.transition = null;
        try {
          Ln(Hi), Tn(a, o, d, m);
        } finally {
          Ln(b), gi.transition = O;
        }
      }
      function rf(a, o, d, m) {
        var b = uo(), O = gi.transition;
        gi.transition = null;
        try {
          Ln(su), Tn(a, o, d, m);
        } finally {
          Ln(b), gi.transition = O;
        }
      }
      function Tn(a, o, d, m) {
        nr && Ud(a, o, d, m);
      }
      function Ud(a, o, d, m) {
        var b = nf(a, o, d, m);
        if (b === null) {
          YC(a, o, m, fu, d), Km(a, m);
          return;
        }
        if (DC(b, a, o, d, m)) {
          m.stopPropagation();
          return;
        }
        if (Km(a, m), o & Ja && Qb(a)) {
          for (; b !== null; ) {
            var O = ff(b);
            O !== null && AC(O);
            var N = nf(a, o, d, m);
            if (N === null && YC(a, o, m, fu, d), N === b)
              break;
            b = N;
          }
          b !== null && m.stopPropagation();
          return;
        }
        YC(a, o, m, null, d);
      }
      var fu = null;
      function nf(a, o, d, m) {
        fu = null;
        var b = _m(m), O = Jd(b);
        if (O !== null) {
          var N = Ma(O);
          if (N === null)
            O = null;
          else {
            var I = N.tag;
            if (I === T) {
              var L = au(N);
              if (L !== null)
                return L;
              O = null;
            } else if (I === y) {
              var G = N.stateNode;
              if (Uh(G))
                return ou(N);
              O = null;
            } else N !== O && (O = null);
          }
        }
        return fu = O, null;
      }
      function Wh(a) {
        switch (a) {
          // Used by SimpleEventPlugin:
          case "cancel":
          case "click":
          case "close":
          case "contextmenu":
          case "copy":
          case "cut":
          case "auxclick":
          case "dblclick":
          case "dragend":
          case "dragstart":
          case "drop":
          case "focusin":
          case "focusout":
          case "input":
          case "invalid":
          case "keydown":
          case "keypress":
          case "keyup":
          case "mousedown":
          case "mouseup":
          case "paste":
          case "pause":
          case "play":
          case "pointercancel":
          case "pointerdown":
          case "pointerup":
          case "ratechange":
          case "reset":
          case "resize":
          case "seeked":
          case "submit":
          case "touchcancel":
          case "touchend":
          case "touchstart":
          case "volumechange":
          // Used by polyfills:
          // eslint-disable-next-line no-fallthrough
          case "change":
          case "selectionchange":
          case "textInput":
          case "compositionstart":
          case "compositionend":
          case "compositionupdate":
          // Only enableCreateEventHandleAPI:
          // eslint-disable-next-line no-fallthrough
          case "beforeblur":
          case "afterblur":
          // Not used by React but could be by user code:
          // eslint-disable-next-line no-fallthrough
          case "beforeinput":
          case "blur":
          case "fullscreenchange":
          case "focus":
          case "hashchange":
          case "popstate":
          case "select":
          case "selectstart":
            return Hi;
          case "drag":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "mousemove":
          case "mouseout":
          case "mouseover":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "scroll":
          case "toggle":
          case "touchmove":
          case "wheel":
          // Not used by React but could be by user code:
          // eslint-disable-next-line no-fallthrough
          case "mouseenter":
          case "mouseleave":
          case "pointerenter":
          case "pointerleave":
            return su;
          case "message": {
            var o = mh();
            switch (o) {
              case gd:
                return Hi;
              case js:
                return su;
              case Lu:
              case TC:
                return ao;
              case kl:
                return oo;
              default:
                return ao;
            }
          }
          default:
            return ao;
        }
      }
      function Hd(a, o, d) {
        return a.addEventListener(o, d, !1), d;
      }
      function xa(a, o, d) {
        return a.addEventListener(o, d, !0), d;
      }
      function Jm(a, o, d, m) {
        return a.addEventListener(o, d, {
          capture: !0,
          passive: m
        }), d;
      }
      function af(a, o, d, m) {
        return a.addEventListener(o, d, {
          passive: m
        }), d;
      }
      var La = null, of = null, Hl = null;
      function zs(a) {
        return La = a, of = Vd(), !0;
      }
      function Yh() {
        La = null, of = null, Hl = null;
      }
      function Uu() {
        if (Hl)
          return Hl;
        var a, o = of, d = o.length, m, b = Vd(), O = b.length;
        for (a = 0; a < d && o[a] === b[a]; a++)
          ;
        var N = d - a;
        for (m = 1; m <= N && o[d - m] === b[O - m]; m++)
          ;
        var I = m > 1 ? 1 - m : void 0;
        return Hl = b.slice(a, I), Hl;
      }
      function Vd() {
        return "value" in La ? La.value : La.textContent;
      }
      function qs(a) {
        var o, d = a.keyCode;
        return "charCode" in a ? (o = a.charCode, o === 0 && d === 13 && (o = 13)) : o = d, o === 10 && (o = 13), o >= 32 || o === 13 ? o : 0;
      }
      function uf() {
        return !0;
      }
      function Wd() {
        return !1;
      }
      function Ni(a) {
        function o(d, m, b, O, N) {
          this._reactName = d, this._targetInst = b, this.type = m, this.nativeEvent = O, this.target = N, this.currentTarget = null;
          for (var I in a)
            if (a.hasOwnProperty(I)) {
              var L = a[I];
              L ? this[I] = L(O) : this[I] = O[I];
            }
          var G = O.defaultPrevented != null ? O.defaultPrevented : O.returnValue === !1;
          return G ? this.isDefaultPrevented = uf : this.isDefaultPrevented = Wd, this.isPropagationStopped = Wd, this;
        }
        return Ht(o.prototype, {
          preventDefault: function() {
            this.defaultPrevented = !0;
            var d = this.nativeEvent;
            d && (d.preventDefault ? d.preventDefault() : typeof d.returnValue != "unknown" && (d.returnValue = !1), this.isDefaultPrevented = uf);
          },
          stopPropagation: function() {
            var d = this.nativeEvent;
            d && (d.stopPropagation ? d.stopPropagation() : typeof d.cancelBubble != "unknown" && (d.cancelBubble = !0), this.isPropagationStopped = uf);
          },
          /**
           * We release all dispatched `SyntheticEvent`s after each event loop, adding
           * them back into the pool. This allows a way to hold onto a reference that
           * won't be added back into the pool.
           */
          persist: function() {
          },
          /**
           * Checks if this event should be released back into the pool.
           *
           * @return {boolean} True if this should not be released, false otherwise.
           */
          isPersistent: uf
        }), o;
      }
      var zn = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(a) {
          return a.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
      }, du = Ni(zn), Yi = Ht({}, zn, {
        view: 0,
        detail: 0
      }), ba = Ni(Yi), Gh, Yd, Vl;
      function RC(a) {
        a !== Vl && (Vl && a.type === "mousemove" ? (Gh = a.screenX - Vl.screenX, Yd = a.screenY - Vl.screenY) : (Gh = 0, Yd = 0), Vl = a);
      }
      var No = Ht({}, Yi, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: fn,
        button: 0,
        buttons: 0,
        relatedTarget: function(a) {
          return a.relatedTarget === void 0 ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
        },
        movementX: function(a) {
          return "movementX" in a ? a.movementX : (RC(a), Gh);
        },
        movementY: function(a) {
          return "movementY" in a ? a.movementY : Yd;
        }
      }), ey = Ni(No), ty = Ht({}, No, {
        dataTransfer: 0
      }), Wl = Ni(ty), ry = Ht({}, Yi, {
        relatedTarget: 0
      }), Hu = Ni(ry), Xb = Ht({}, zn, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      }), Zb = Ni(Xb), ny = Ht({}, zn, {
        clipboardData: function(a) {
          return "clipboardData" in a ? a.clipboardData : window.clipboardData;
        }
      }), Qh = Ni(ny), PC = Ht({}, zn, {
        data: 0
      }), Jb = Ni(PC), e1 = Jb, t1 = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
      }, Yl = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
      };
      function MC(a) {
        if (a.key) {
          var o = t1[a.key] || a.key;
          if (o !== "Unidentified")
            return o;
        }
        if (a.type === "keypress") {
          var d = qs(a);
          return d === 13 ? "Enter" : String.fromCharCode(d);
        }
        return a.type === "keydown" || a.type === "keyup" ? Yl[a.keyCode] || "Unidentified" : "";
      }
      var sf = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
      };
      function r1(a) {
        var o = this, d = o.nativeEvent;
        if (d.getModifierState)
          return d.getModifierState(a);
        var m = sf[a];
        return m ? !!d[m] : !1;
      }
      function fn(a) {
        return r1;
      }
      var NC = Ht({}, Yi, {
        key: MC,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: fn,
        // Legacy Interface
        charCode: function(a) {
          return a.type === "keypress" ? qs(a) : 0;
        },
        keyCode: function(a) {
          return a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
        },
        which: function(a) {
          return a.type === "keypress" ? qs(a) : a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
        }
      }), n1 = Ni(NC), jC = Ht({}, No, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
      }), i1 = Ni(jC), a1 = Ht({}, Yi, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: fn
      }), o1 = Ni(a1), FC = Ht({}, zn, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      }), so = Ni(FC), iy = Ht({}, No, {
        deltaX: function(a) {
          return "deltaX" in a ? a.deltaX : (
            // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
            "wheelDeltaX" in a ? -a.wheelDeltaX : 0
          );
        },
        deltaY: function(a) {
          return "deltaY" in a ? a.deltaY : (
            // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
            "wheelDeltaY" in a ? -a.wheelDeltaY : (
              // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
              "wheelDelta" in a ? -a.wheelDelta : 0
            )
          );
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
      }), IC = Ni(iy), Us = [9, 13, 27, 32], Gd = 229, Vu = Ye && "CompositionEvent" in window, Hs = null;
      Ye && "documentMode" in document && (Hs = document.documentMode);
      var ay = Ye && "TextEvent" in window && !Hs, Kh = Ye && (!Vu || Hs && Hs > 8 && Hs <= 11), u1 = 32, Xh = String.fromCharCode(u1);
      function BC() {
        we("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), we("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), we("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), we("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
      }
      var oy = !1;
      function s1(a) {
        return (a.ctrlKey || a.altKey || a.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(a.ctrlKey && a.altKey);
      }
      function Zh(a) {
        switch (a) {
          case "compositionstart":
            return "onCompositionStart";
          case "compositionend":
            return "onCompositionEnd";
          case "compositionupdate":
            return "onCompositionUpdate";
        }
      }
      function Jh(a, o) {
        return a === "keydown" && o.keyCode === Gd;
      }
      function uy(a, o) {
        switch (a) {
          case "keyup":
            return Us.indexOf(o.keyCode) !== -1;
          case "keydown":
            return o.keyCode !== Gd;
          case "keypress":
          case "mousedown":
          case "focusout":
            return !0;
          default:
            return !1;
        }
      }
      function ev(a) {
        var o = a.detail;
        return typeof o == "object" && "data" in o ? o.data : null;
      }
      function l1(a) {
        return a.locale === "ko";
      }
      var Gl = !1;
      function sy(a, o, d, m, b) {
        var O, N;
        if (Vu ? O = Zh(o) : Gl ? uy(o, m) && (O = "onCompositionEnd") : Jh(o, m) && (O = "onCompositionStart"), !O)
          return null;
        Kh && !l1(m) && (!Gl && O === "onCompositionStart" ? Gl = zs(b) : O === "onCompositionEnd" && Gl && (N = Uu()));
        var I = m1(d, O);
        if (I.length > 0) {
          var L = new Jb(O, o, null, m, b);
          if (a.push({
            event: L,
            listeners: I
          }), N)
            L.data = N;
          else {
            var G = ev(m);
            G !== null && (L.data = G);
          }
        }
      }
      function tv(a, o) {
        switch (a) {
          case "compositionend":
            return ev(o);
          case "keypress":
            var d = o.which;
            return d !== u1 ? null : (oy = !0, Xh);
          case "textInput":
            var m = o.data;
            return m === Xh && oy ? null : m;
          default:
            return null;
        }
      }
      function ly(a, o) {
        if (Gl) {
          if (a === "compositionend" || !Vu && uy(a, o)) {
            var d = Uu();
            return Yh(), Gl = !1, d;
          }
          return null;
        }
        switch (a) {
          case "paste":
            return null;
          case "keypress":
            if (!s1(o)) {
              if (o.char && o.char.length > 1)
                return o.char;
              if (o.which)
                return String.fromCharCode(o.which);
            }
            return null;
          case "compositionend":
            return Kh && !l1(o) ? null : o.data;
          default:
            return null;
        }
      }
      function rv(a, o, d, m, b) {
        var O;
        if (ay ? O = tv(o, m) : O = ly(o, m), !O)
          return null;
        var N = m1(d, "onBeforeInput");
        if (N.length > 0) {
          var I = new e1("onBeforeInput", "beforeinput", null, m, b);
          a.push({
            event: I,
            listeners: N
          }), I.data = O;
        }
      }
      function c1(a, o, d, m, b, O, N) {
        sy(a, o, d, m, b), rv(a, o, d, m, b);
      }
      var LC = {
        color: !0,
        date: !0,
        datetime: !0,
        "datetime-local": !0,
        email: !0,
        month: !0,
        number: !0,
        password: !0,
        range: !0,
        search: !0,
        tel: !0,
        text: !0,
        time: !0,
        url: !0,
        week: !0
      };
      function Qd(a) {
        var o = a && a.nodeName && a.nodeName.toLowerCase();
        return o === "input" ? !!LC[a.type] : o === "textarea";
      }
      /**
       * Checks if an event is supported in the current execution environment.
       *
       * NOTE: This will not work correctly for non-generic events such as `change`,
       * `reset`, `load`, `error`, and `select`.
       *
       * Borrows from Modernizr.
       *
       * @param {string} eventNameSuffix Event name, e.g. "click".
       * @return {boolean} True if the event is supported.
       * @internal
       * @license Modernizr 3.0.0pre (Custom Build) | MIT
       */
      function $C(a) {
        if (!Ye)
          return !1;
        var o = "on" + a, d = o in document;
        if (!d) {
          var m = document.createElement("div");
          m.setAttribute(o, "return;"), d = typeof m[o] == "function";
        }
        return d;
      }
      function Kd() {
        we("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
      }
      function f1(a, o, d, m) {
        Hc(m);
        var b = m1(o, "onChange");
        if (b.length > 0) {
          var O = new du("onChange", "change", null, d, m);
          a.push({
            event: O,
            listeners: b
          });
        }
      }
      var Vs = null, l = null;
      function f(a) {
        var o = a.nodeName && a.nodeName.toLowerCase();
        return o === "select" || o === "input" && a.type === "file";
      }
      function g(a) {
        var o = [];
        f1(o, l, a, _m(a)), Sb(_, o);
      }
      function _(a) {
        xF(a, 0);
      }
      function P(a) {
        var o = sv(a);
        if (Jo(o))
          return a;
      }
      function j(a, o) {
        if (a === "change")
          return o;
      }
      var U = !1;
      Ye && (U = $C("input") && (!document.documentMode || document.documentMode > 9));
      function re(a, o) {
        Vs = a, l = o, Vs.attachEvent("onpropertychange", Ce);
      }
      function le() {
        Vs && (Vs.detachEvent("onpropertychange", Ce), Vs = null, l = null);
      }
      function Ce(a) {
        a.propertyName === "value" && P(l) && g(a);
      }
      function qe(a, o, d) {
        a === "focusin" ? (le(), re(o, d)) : a === "focusout" && le();
      }
      function He(a, o) {
        if (a === "selectionchange" || a === "keyup" || a === "keydown")
          return P(l);
      }
      function ze(a) {
        var o = a.nodeName;
        return o && o.toLowerCase() === "input" && (a.type === "checkbox" || a.type === "radio");
      }
      function nt(a, o) {
        if (a === "click")
          return P(o);
      }
      function dt(a, o) {
        if (a === "input" || a === "change")
          return P(o);
      }
      function mt(a) {
        var o = a._wrapperState;
        !o || !o.controlled || a.type !== "number" || _t(a, "number", a.value);
      }
      function An(a, o, d, m, b, O, N) {
        var I = d ? sv(d) : window, L, G;
        if (f(I) ? L = j : Qd(I) ? U ? L = dt : (L = He, G = qe) : ze(I) && (L = nt), L) {
          var K = L(o, d);
          if (K) {
            f1(a, K, m, b);
            return;
          }
        }
        G && G(o, I, d), o === "focusout" && mt(I);
      }
      function ge() {
        Fe("onMouseEnter", ["mouseout", "mouseover"]), Fe("onMouseLeave", ["mouseout", "mouseover"]), Fe("onPointerEnter", ["pointerout", "pointerover"]), Fe("onPointerLeave", ["pointerout", "pointerover"]);
      }
      function he(a, o, d, m, b, O, N) {
        var I = o === "mouseover" || o === "pointerover", L = o === "mouseout" || o === "pointerout";
        if (I && !dd(m)) {
          var G = m.relatedTarget || m.fromElement;
          if (G && (Jd(G) || Sy(G)))
            return;
        }
        if (!(!L && !I)) {
          var K;
          if (b.window === b)
            K = b;
          else {
            var ve = b.ownerDocument;
            ve ? K = ve.defaultView || ve.parentWindow : K = window;
          }
          var pe, Se;
          if (L) {
            var Oe = m.relatedTarget || m.toElement;
            if (pe = d, Se = Oe ? Jd(Oe) : null, Se !== null) {
              var Pe = Ma(Se);
              (Se !== Pe || Se.tag !== w && Se.tag !== E) && (Se = null);
            }
          } else
            pe = null, Se = d;
          if (pe !== Se) {
            var tt = ey, Ct = "onMouseLeave", bt = "onMouseEnter", ar = "mouse";
            (o === "pointerout" || o === "pointerover") && (tt = i1, Ct = "onPointerLeave", bt = "onPointerEnter", ar = "pointer");
            var Zt = pe == null ? K : sv(pe), xe = Se == null ? K : sv(Se), Me = new tt(Ct, ar + "leave", pe, m, b);
            Me.target = Zt, Me.relatedTarget = xe;
            var be = null, Ve = Jd(b);
            if (Ve === d) {
              var ot = new tt(bt, ar + "enter", Se, m, b);
              ot.target = xe, ot.relatedTarget = Zt, be = ot;
            }
            XG(a, Me, be, pe, Se);
          }
        }
      }
      function Ee(a, o) {
        return a === o && (a !== 0 || 1 / a === 1 / o) || a !== a && o !== o;
      }
      var Ue = typeof Object.is == "function" ? Object.is : Ee;
      function pt(a, o) {
        if (Ue(a, o))
          return !0;
        if (typeof a != "object" || a === null || typeof o != "object" || o === null)
          return !1;
        var d = Object.keys(a), m = Object.keys(o);
        if (d.length !== m.length)
          return !1;
        for (var b = 0; b < d.length; b++) {
          var O = d[b];
          if (!de.call(o, O) || !Ue(a[O], o[O]))
            return !1;
        }
        return !0;
      }
      function Tt(a) {
        for (; a && a.firstChild; )
          a = a.firstChild;
        return a;
      }
      function kt(a) {
        for (; a; ) {
          if (a.nextSibling)
            return a.nextSibling;
          a = a.parentNode;
        }
      }
      function Mt(a, o) {
        for (var d = Tt(a), m = 0, b = 0; d; ) {
          if (d.nodeType === Nu) {
            if (b = m + d.textContent.length, m <= o && b >= o)
              return {
                node: d,
                offset: o - m
              };
            m = b;
          }
          d = Tt(kt(d));
        }
      }
      function oi(a) {
        var o = a.ownerDocument, d = o && o.defaultView || window, m = d.getSelection && d.getSelection();
        if (!m || m.rangeCount === 0)
          return null;
        var b = m.anchorNode, O = m.anchorOffset, N = m.focusNode, I = m.focusOffset;
        try {
          b.nodeType, N.nodeType;
        } catch {
          return null;
        }
        return xr(a, b, O, N, I);
      }
      function xr(a, o, d, m, b) {
        var O = 0, N = -1, I = -1, L = 0, G = 0, K = a, ve = null;
        e: for (; ; ) {
          for (var pe = null; K === o && (d === 0 || K.nodeType === Nu) && (N = O + d), K === m && (b === 0 || K.nodeType === Nu) && (I = O + b), K.nodeType === Nu && (O += K.nodeValue.length), (pe = K.firstChild) !== null; )
            ve = K, K = pe;
          for (; ; ) {
            if (K === a)
              break e;
            if (ve === o && ++L === d && (N = O), ve === m && ++G === b && (I = O), (pe = K.nextSibling) !== null)
              break;
            K = ve, ve = K.parentNode;
          }
          K = pe;
        }
        return N === -1 || I === -1 ? null : {
          start: N,
          end: I
        };
      }
      function Ws(a, o) {
        var d = a.ownerDocument || document, m = d && d.defaultView || window;
        if (m.getSelection) {
          var b = m.getSelection(), O = a.textContent.length, N = Math.min(o.start, O), I = o.end === void 0 ? N : Math.min(o.end, O);
          if (!b.extend && N > I) {
            var L = I;
            I = N, N = L;
          }
          var G = Mt(a, N), K = Mt(a, I);
          if (G && K) {
            if (b.rangeCount === 1 && b.anchorNode === G.node && b.anchorOffset === G.offset && b.focusNode === K.node && b.focusOffset === K.offset)
              return;
            var ve = d.createRange();
            ve.setStart(G.node, G.offset), b.removeAllRanges(), N > I ? (b.addRange(ve), b.extend(K.node, K.offset)) : (ve.setEnd(K.node, K.offset), b.addRange(ve));
          }
        }
      }
      function d1(a) {
        return a && a.nodeType === Nu;
      }
      function sF(a, o) {
        return !a || !o ? !1 : a === o ? !0 : d1(a) ? !1 : d1(o) ? sF(a, o.parentNode) : "contains" in a ? a.contains(o) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(o) & 16) : !1;
      }
      function MG(a) {
        return a && a.ownerDocument && sF(a.ownerDocument.documentElement, a);
      }
      function NG(a) {
        try {
          return typeof a.contentWindow.location.href == "string";
        } catch {
          return !1;
        }
      }
      function lF() {
        for (var a = window, o = Za(); o instanceof a.HTMLIFrameElement; ) {
          if (NG(o))
            a = o.contentWindow;
          else
            return o;
          o = Za(a.document);
        }
        return o;
      }
      function zC(a) {
        var o = a && a.nodeName && a.nodeName.toLowerCase();
        return o && (o === "input" && (a.type === "text" || a.type === "search" || a.type === "tel" || a.type === "url" || a.type === "password") || o === "textarea" || a.contentEditable === "true");
      }
      function jG() {
        var a = lF();
        return {
          focusedElem: a,
          selectionRange: zC(a) ? IG(a) : null
        };
      }
      function FG(a) {
        var o = lF(), d = a.focusedElem, m = a.selectionRange;
        if (o !== d && MG(d)) {
          m !== null && zC(d) && BG(d, m);
          for (var b = [], O = d; O = O.parentNode; )
            O.nodeType === ca && b.push({
              element: O,
              left: O.scrollLeft,
              top: O.scrollTop
            });
          typeof d.focus == "function" && d.focus();
          for (var N = 0; N < b.length; N++) {
            var I = b[N];
            I.element.scrollLeft = I.left, I.element.scrollTop = I.top;
          }
        }
      }
      function IG(a) {
        var o;
        return "selectionStart" in a ? o = {
          start: a.selectionStart,
          end: a.selectionEnd
        } : o = oi(a), o || {
          start: 0,
          end: 0
        };
      }
      function BG(a, o) {
        var d = o.start, m = o.end;
        m === void 0 && (m = d), "selectionStart" in a ? (a.selectionStart = d, a.selectionEnd = Math.min(m, a.value.length)) : Ws(a, o);
      }
      var LG = Ye && "documentMode" in document && document.documentMode <= 11;
      function $G() {
        we("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
      }
      var nv = null, qC = null, cy = null, UC = !1;
      function zG(a) {
        if ("selectionStart" in a && zC(a))
          return {
            start: a.selectionStart,
            end: a.selectionEnd
          };
        var o = a.ownerDocument && a.ownerDocument.defaultView || window, d = o.getSelection();
        return {
          anchorNode: d.anchorNode,
          anchorOffset: d.anchorOffset,
          focusNode: d.focusNode,
          focusOffset: d.focusOffset
        };
      }
      function qG(a) {
        return a.window === a ? a.document : a.nodeType === ju ? a : a.ownerDocument;
      }
      function cF(a, o, d) {
        var m = qG(d);
        if (!(UC || nv == null || nv !== Za(m))) {
          var b = zG(nv);
          if (!cy || !pt(cy, b)) {
            cy = b;
            var O = m1(qC, "onSelect");
            if (O.length > 0) {
              var N = new du("onSelect", "select", null, o, d);
              a.push({
                event: N,
                listeners: O
              }), N.target = nv;
            }
          }
        }
      }
      function UG(a, o, d, m, b, O, N) {
        var I = d ? sv(d) : window;
        switch (o) {
          // Track the input node that has focus.
          case "focusin":
            (Qd(I) || I.contentEditable === "true") && (nv = I, qC = d, cy = null);
            break;
          case "focusout":
            nv = null, qC = null, cy = null;
            break;
          // Don't fire the event while the user is dragging. This matches the
          // semantics of the native select event.
          case "mousedown":
            UC = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            UC = !1, cF(a, m, b);
            break;
          // Chrome and IE fire non-standard event when selection is changed (and
          // sometimes when it hasn't). IE's event fires out of order with respect
          // to key and input events on deletion, so we discard it.
          //
          // Firefox doesn't support selectionchange, so check selection status
          // after each key entry. The selection changes after keydown and before
          // keyup, but we check on keydown as well in the case of holding down a
          // key, when multiple keydown events are fired but only one keyup is.
          // This is also our approach for IE handling, for the reason above.
          case "selectionchange":
            if (LG)
              break;
          // falls through
          case "keydown":
          case "keyup":
            cF(a, m, b);
        }
      }
      function p1(a, o) {
        var d = {};
        return d[a.toLowerCase()] = o.toLowerCase(), d["Webkit" + a] = "webkit" + o, d["Moz" + a] = "moz" + o, d;
      }
      var iv = {
        animationend: p1("Animation", "AnimationEnd"),
        animationiteration: p1("Animation", "AnimationIteration"),
        animationstart: p1("Animation", "AnimationStart"),
        transitionend: p1("Transition", "TransitionEnd")
      }, HC = {}, fF = {};
      Ye && (fF = document.createElement("div").style, "AnimationEvent" in window || (delete iv.animationend.animation, delete iv.animationiteration.animation, delete iv.animationstart.animation), "TransitionEvent" in window || delete iv.transitionend.transition);
      function h1(a) {
        if (HC[a])
          return HC[a];
        if (!iv[a])
          return a;
        var o = iv[a];
        for (var d in o)
          if (o.hasOwnProperty(d) && d in fF)
            return HC[a] = o[d];
        return a;
      }
      var dF = h1("animationend"), pF = h1("animationiteration"), hF = h1("animationstart"), vF = h1("transitionend"), mF = /* @__PURE__ */ new Map(), yF = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
      function lf(a, o) {
        mF.set(a, o), we(o, [a]);
      }
      function HG() {
        for (var a = 0; a < yF.length; a++) {
          var o = yF[a], d = o.toLowerCase(), m = o[0].toUpperCase() + o.slice(1);
          lf(d, "on" + m);
        }
        lf(dF, "onAnimationEnd"), lf(pF, "onAnimationIteration"), lf(hF, "onAnimationStart"), lf("dblclick", "onDoubleClick"), lf("focusin", "onFocus"), lf("focusout", "onBlur"), lf(vF, "onTransitionEnd");
      }
      function VG(a, o, d, m, b, O, N) {
        var I = mF.get(o);
        if (I !== void 0) {
          var L = du, G = o;
          switch (o) {
            case "keypress":
              if (qs(m) === 0)
                return;
            /* falls through */
            case "keydown":
            case "keyup":
              L = n1;
              break;
            case "focusin":
              G = "focus", L = Hu;
              break;
            case "focusout":
              G = "blur", L = Hu;
              break;
            case "beforeblur":
            case "afterblur":
              L = Hu;
              break;
            case "click":
              if (m.button === 2)
                return;
            /* falls through */
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            // TODO: Disabled elements should not respond to mouse events
            /* falls through */
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              L = ey;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              L = Wl;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              L = o1;
              break;
            case dF:
            case pF:
            case hF:
              L = Zb;
              break;
            case vF:
              L = so;
              break;
            case "scroll":
              L = ba;
              break;
            case "wheel":
              L = IC;
              break;
            case "copy":
            case "cut":
            case "paste":
              L = Qh;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              L = i1;
              break;
          }
          var K = (O & Ja) !== 0;
          {
            var ve = !K && // TODO: ideally, we'd eventually add all events from
            // nonDelegatedEvents list in DOMPluginEventSystem.
            // Then we can remove this special list.
            // This is a breaking change that can wait until React 18.
            o === "scroll", pe = QG(d, I, m.type, K, ve);
            if (pe.length > 0) {
              var Se = new L(I, G, null, m, b);
              a.push({
                event: Se,
                listeners: pe
              });
            }
          }
        }
      }
      HG(), ge(), Kd(), $G(), BC();
      function WG(a, o, d, m, b, O, N) {
        VG(a, o, d, m, b, O);
        var I = (O & Sm) === 0;
        I && (he(a, o, d, m, b), An(a, o, d, m, b), UG(a, o, d, m, b), c1(a, o, d, m, b));
      }
      var fy = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], VC = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(fy));
      function gF(a, o, d) {
        var m = a.type || "unknown-event";
        a.currentTarget = d, ru(m, o, void 0, a), a.currentTarget = null;
      }
      function YG(a, o, d) {
        var m;
        if (d)
          for (var b = o.length - 1; b >= 0; b--) {
            var O = o[b], N = O.instance, I = O.currentTarget, L = O.listener;
            if (N !== m && a.isPropagationStopped())
              return;
            gF(a, L, I), m = N;
          }
        else
          for (var G = 0; G < o.length; G++) {
            var K = o[G], ve = K.instance, pe = K.currentTarget, Se = K.listener;
            if (ve !== m && a.isPropagationStopped())
              return;
            gF(a, Se, pe), m = ve;
          }
      }
      function xF(a, o) {
        for (var d = (o & Ja) !== 0, m = 0; m < a.length; m++) {
          var b = a[m], O = b.event, N = b.listeners;
          YG(O, N, d);
        }
        vd();
      }
      function GG(a, o, d, m, b) {
        var O = _m(d), N = [];
        WG(N, a, m, d, O, o), xF(N, o);
      }
      function yn(a, o) {
        VC.has(a) || s('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', a);
        var d = !1, m = _K(o), b = ZG(a);
        m.has(b) || (bF(o, a, nh, d), m.add(b));
      }
      function WC(a, o, d) {
        VC.has(a) && !o && s('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', a);
        var m = 0;
        o && (m |= Ja), bF(d, a, m, o);
      }
      var v1 = "_reactListening" + Math.random().toString(36).slice(2);
      function dy(a) {
        if (!a[v1]) {
          a[v1] = !0, ke.forEach(function(d) {
            d !== "selectionchange" && (VC.has(d) || WC(d, !1, a), WC(d, !0, a));
          });
          var o = a.nodeType === ju ? a : a.ownerDocument;
          o !== null && (o[v1] || (o[v1] = !0, WC("selectionchange", !1, o)));
        }
      }
      function bF(a, o, d, m, b) {
        var O = xi(a, o, d), N = void 0;
        hd && (o === "touchstart" || o === "touchmove" || o === "wheel") && (N = !0), a = a, m ? N !== void 0 ? Jm(a, o, O, N) : xa(a, o, O) : N !== void 0 ? af(a, o, O, N) : Hd(a, o, O);
      }
      function wF(a, o) {
        return a === o || a.nodeType === Nn && a.parentNode === o;
      }
      function YC(a, o, d, m, b) {
        var O = m;
        if ((o & Em) === 0 && (o & nh) === 0) {
          var N = b;
          if (m !== null) {
            var I = m;
            e: for (; ; ) {
              if (I === null)
                return;
              var L = I.tag;
              if (L === y || L === x) {
                var G = I.stateNode.containerInfo;
                if (wF(G, N))
                  break;
                if (L === x)
                  for (var K = I.return; K !== null; ) {
                    var ve = K.tag;
                    if (ve === y || ve === x) {
                      var pe = K.stateNode.containerInfo;
                      if (wF(pe, N))
                        return;
                    }
                    K = K.return;
                  }
                for (; G !== null; ) {
                  var Se = Jd(G);
                  if (Se === null)
                    return;
                  var Oe = Se.tag;
                  if (Oe === w || Oe === E) {
                    I = O = Se;
                    continue e;
                  }
                  G = G.parentNode;
                }
              }
              I = I.return;
            }
          }
        }
        Sb(function() {
          return GG(a, o, d, O);
        });
      }
      function py(a, o, d) {
        return {
          instance: a,
          listener: o,
          currentTarget: d
        };
      }
      function QG(a, o, d, m, b, O) {
        for (var N = o !== null ? o + "Capture" : null, I = m ? N : o, L = [], G = a, K = null; G !== null; ) {
          var ve = G, pe = ve.stateNode, Se = ve.tag;
          if (Se === w && pe !== null && (K = pe, I !== null)) {
            var Oe = Ds(G, I);
            Oe != null && L.push(py(G, Oe, K));
          }
          if (b)
            break;
          G = G.return;
        }
        return L;
      }
      function m1(a, o) {
        for (var d = o + "Capture", m = [], b = a; b !== null; ) {
          var O = b, N = O.stateNode, I = O.tag;
          if (I === w && N !== null) {
            var L = N, G = Ds(b, d);
            G != null && m.unshift(py(b, G, L));
            var K = Ds(b, o);
            K != null && m.push(py(b, K, L));
          }
          b = b.return;
        }
        return m;
      }
      function av(a) {
        if (a === null)
          return null;
        do
          a = a.return;
        while (a && a.tag !== w);
        return a || null;
      }
      function KG(a, o) {
        for (var d = a, m = o, b = 0, O = d; O; O = av(O))
          b++;
        for (var N = 0, I = m; I; I = av(I))
          N++;
        for (; b - N > 0; )
          d = av(d), b--;
        for (; N - b > 0; )
          m = av(m), N--;
        for (var L = b; L--; ) {
          if (d === m || m !== null && d === m.alternate)
            return d;
          d = av(d), m = av(m);
        }
        return null;
      }
      function EF(a, o, d, m, b) {
        for (var O = o._reactName, N = [], I = d; I !== null && I !== m; ) {
          var L = I, G = L.alternate, K = L.stateNode, ve = L.tag;
          if (G !== null && G === m)
            break;
          if (ve === w && K !== null) {
            var pe = K;
            if (b) {
              var Se = Ds(I, O);
              Se != null && N.unshift(py(I, Se, pe));
            } else if (!b) {
              var Oe = Ds(I, O);
              Oe != null && N.push(py(I, Oe, pe));
            }
          }
          I = I.return;
        }
        N.length !== 0 && a.push({
          event: o,
          listeners: N
        });
      }
      function XG(a, o, d, m, b) {
        var O = m && b ? KG(m, b) : null;
        m !== null && EF(a, o, m, O, !1), b !== null && d !== null && EF(a, d, b, O, !0);
      }
      function ZG(a, o) {
        return a + "__bubble";
      }
      var lo = !1, hy = "dangerouslySetInnerHTML", y1 = "suppressContentEditableWarning", cf = "suppressHydrationWarning", SF = "autoFocus", Xd = "children", Zd = "style", g1 = "__html", GC, x1, vy, _F, b1, CF, OF;
      GC = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: !0,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: !0
      }, x1 = function(a, o) {
        xm(a, o), th(a, o), bb(a, o, {
          registrationNameDependencies: Re,
          possibleRegistrationNames: Te
        });
      }, CF = Ye && !document.documentMode, vy = function(a, o, d) {
        if (!lo) {
          var m = w1(d), b = w1(o);
          b !== m && (lo = !0, s("Prop `%s` did not match. Server: %s Client: %s", a, JSON.stringify(b), JSON.stringify(m)));
        }
      }, _F = function(a) {
        if (!lo) {
          lo = !0;
          var o = [];
          a.forEach(function(d) {
            o.push(d);
          }), s("Extra attributes from the server: %s", o);
        }
      }, b1 = function(a, o) {
        o === !1 ? s("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", a, a, a) : s("Expected `%s` listener to be a function, instead got a value of `%s` type.", a, typeof o);
      }, OF = function(a, o) {
        var d = a.namespaceURI === Mu ? a.ownerDocument.createElement(a.tagName) : a.ownerDocument.createElementNS(a.namespaceURI, a.tagName);
        return d.innerHTML = o, d.innerHTML;
      };
      var JG = /\r\n?/g, eQ = /\u0000|\uFFFD/g;
      function w1(a) {
        Dr(a);
        var o = typeof a == "string" ? a : "" + a;
        return o.replace(JG, `
`).replace(eQ, "");
      }
      function E1(a, o, d, m) {
        var b = w1(o), O = w1(a);
        if (O !== b && (m && (lo || (lo = !0, s('Text content did not match. Server: "%s" Client: "%s"', O, b))), d && se))
          throw new Error("Text content does not match server-rendered HTML.");
      }
      function TF(a) {
        return a.nodeType === ju ? a : a.ownerDocument;
      }
      function tQ() {
      }
      function S1(a) {
        a.onclick = tQ;
      }
      function rQ(a, o, d, m, b) {
        for (var O in m)
          if (m.hasOwnProperty(O)) {
            var N = m[O];
            if (O === Zd)
              N && Object.freeze(N), hb(o, N);
            else if (O === hy) {
              var I = N ? N[g1] : void 0;
              I != null && rb(o, I);
            } else if (O === Xd)
              if (typeof N == "string") {
                var L = a !== "textarea" || N !== "";
                L && $c(o, N);
              } else typeof N == "number" && $c(o, "" + N);
            else O === y1 || O === cf || O === SF || (Re.hasOwnProperty(O) ? N != null && (typeof N != "function" && b1(O, N), O === "onScroll" && yn("scroll", o)) : N != null && pi(o, O, N, b));
          }
      }
      function nQ(a, o, d, m) {
        for (var b = 0; b < o.length; b += 2) {
          var O = o[b], N = o[b + 1];
          O === Zd ? hb(a, N) : O === hy ? rb(a, N) : O === Xd ? $c(a, N) : pi(a, O, N, m);
        }
      }
      function iQ(a, o, d, m) {
        var b, O = TF(d), N, I = m;
        if (I === Mu && (I = dm(a)), I === Mu) {
          if (b = Ts(a, o), !b && a !== a.toLowerCase() && s("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", a), a === "script") {
            var L = O.createElement("div");
            L.innerHTML = "<script><\/script>";
            var G = L.firstChild;
            N = L.removeChild(G);
          } else if (typeof o.is == "string")
            N = O.createElement(a, {
              is: o.is
            });
          else if (N = O.createElement(a), a === "select") {
            var K = N;
            o.multiple ? K.multiple = !0 : o.size && (K.size = o.size);
          }
        } else
          N = O.createElementNS(I, a);
        return I === Mu && !b && Object.prototype.toString.call(N) === "[object HTMLUnknownElement]" && !de.call(GC, a) && (GC[a] = !0, s("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", a)), N;
      }
      function aQ(a, o) {
        return TF(o).createTextNode(a);
      }
      function oQ(a, o, d, m) {
        var b = Ts(o, d);
        x1(o, d);
        var O;
        switch (o) {
          case "dialog":
            yn("cancel", a), yn("close", a), O = d;
            break;
          case "iframe":
          case "object":
          case "embed":
            yn("load", a), O = d;
            break;
          case "video":
          case "audio":
            for (var N = 0; N < fy.length; N++)
              yn(fy[N], a);
            O = d;
            break;
          case "source":
            yn("error", a), O = d;
            break;
          case "img":
          case "image":
          case "link":
            yn("error", a), yn("load", a), O = d;
            break;
          case "details":
            yn("toggle", a), O = d;
            break;
          case "input":
            To(a, d), O = Lc(a, d), yn("invalid", a);
            break;
          case "option":
            ur(a, d), O = d;
            break;
          case "select":
            El(a, d), O = ad(a, d), yn("invalid", a);
            break;
          case "textarea":
            lm(a, d), O = sm(a, d), yn("invalid", a);
            break;
          default:
            O = d;
        }
        switch (Jp(o, O), rQ(o, a, m, O, b), o) {
          case "input":
            Oo(a), _e(a, d, !1);
            break;
          case "textarea":
            Oo(a), eb(a);
            break;
          case "option":
            rn(a, d);
            break;
          case "select":
            om(a, d);
            break;
          default:
            typeof O.onClick == "function" && S1(a);
            break;
        }
      }
      function uQ(a, o, d, m, b) {
        x1(o, m);
        var O = null, N, I;
        switch (o) {
          case "input":
            N = Lc(a, d), I = Lc(a, m), O = [];
            break;
          case "select":
            N = ad(a, d), I = ad(a, m), O = [];
            break;
          case "textarea":
            N = sm(a, d), I = sm(a, m), O = [];
            break;
          default:
            N = d, I = m, typeof N.onClick != "function" && typeof I.onClick == "function" && S1(a);
            break;
        }
        Jp(o, I);
        var L, G, K = null;
        for (L in N)
          if (!(I.hasOwnProperty(L) || !N.hasOwnProperty(L) || N[L] == null))
            if (L === Zd) {
              var ve = N[L];
              for (G in ve)
                ve.hasOwnProperty(G) && (K || (K = {}), K[G] = "");
            } else L === hy || L === Xd || L === y1 || L === cf || L === SF || (Re.hasOwnProperty(L) ? O || (O = []) : (O = O || []).push(L, null));
        for (L in I) {
          var pe = I[L], Se = N != null ? N[L] : void 0;
          if (!(!I.hasOwnProperty(L) || pe === Se || pe == null && Se == null))
            if (L === Zd)
              if (pe && Object.freeze(pe), Se) {
                for (G in Se)
                  Se.hasOwnProperty(G) && (!pe || !pe.hasOwnProperty(G)) && (K || (K = {}), K[G] = "");
                for (G in pe)
                  pe.hasOwnProperty(G) && Se[G] !== pe[G] && (K || (K = {}), K[G] = pe[G]);
              } else
                K || (O || (O = []), O.push(L, K)), K = pe;
            else if (L === hy) {
              var Oe = pe ? pe[g1] : void 0, Pe = Se ? Se[g1] : void 0;
              Oe != null && Pe !== Oe && (O = O || []).push(L, Oe);
            } else L === Xd ? (typeof pe == "string" || typeof pe == "number") && (O = O || []).push(L, "" + pe) : L === y1 || L === cf || (Re.hasOwnProperty(L) ? (pe != null && (typeof pe != "function" && b1(L, pe), L === "onScroll" && yn("scroll", a)), !O && Se !== pe && (O = [])) : (O = O || []).push(L, pe));
        }
        return K && (wC(K, I[Zd]), (O = O || []).push(Zd, K)), O;
      }
      function sQ(a, o, d, m, b) {
        d === "input" && b.type === "radio" && b.name != null && $(a, b);
        var O = Ts(d, m), N = Ts(d, b);
        switch (nQ(a, o, O, N), d) {
          case "input":
            oe(a, b);
            break;
          case "textarea":
            Jx(a, b);
            break;
          case "select":
            Kp(a, b);
            break;
        }
      }
      function lQ(a) {
        {
          var o = a.toLowerCase();
          return cd.hasOwnProperty(o) && cd[o] || null;
        }
      }
      function cQ(a, o, d, m, b, O, N) {
        var I, L;
        switch (I = Ts(o, d), x1(o, d), o) {
          case "dialog":
            yn("cancel", a), yn("close", a);
            break;
          case "iframe":
          case "object":
          case "embed":
            yn("load", a);
            break;
          case "video":
          case "audio":
            for (var G = 0; G < fy.length; G++)
              yn(fy[G], a);
            break;
          case "source":
            yn("error", a);
            break;
          case "img":
          case "image":
          case "link":
            yn("error", a), yn("load", a);
            break;
          case "details":
            yn("toggle", a);
            break;
          case "input":
            To(a, d), yn("invalid", a);
            break;
          case "option":
            ur(a, d);
            break;
          case "select":
            El(a, d), yn("invalid", a);
            break;
          case "textarea":
            lm(a, d), yn("invalid", a);
            break;
        }
        Jp(o, d);
        {
          L = /* @__PURE__ */ new Set();
          for (var K = a.attributes, ve = 0; ve < K.length; ve++) {
            var pe = K[ve].name.toLowerCase();
            switch (pe) {
              // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              case "value":
                break;
              case "checked":
                break;
              case "selected":
                break;
              default:
                L.add(K[ve].name);
            }
          }
        }
        var Se = null;
        for (var Oe in d)
          if (d.hasOwnProperty(Oe)) {
            var Pe = d[Oe];
            if (Oe === Xd)
              typeof Pe == "string" ? a.textContent !== Pe && (d[cf] !== !0 && E1(a.textContent, Pe, O, N), Se = [Xd, Pe]) : typeof Pe == "number" && a.textContent !== "" + Pe && (d[cf] !== !0 && E1(a.textContent, Pe, O, N), Se = [Xd, "" + Pe]);
            else if (Re.hasOwnProperty(Oe))
              Pe != null && (typeof Pe != "function" && b1(Oe, Pe), Oe === "onScroll" && yn("scroll", a));
            else if (N && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof I == "boolean") {
              var tt = void 0, Ct = Pr(Oe);
              if (d[cf] !== !0) {
                if (!(Oe === y1 || Oe === cf || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                Oe === "value" || Oe === "checked" || Oe === "selected")) {
                  if (Oe === hy) {
                    var bt = a.innerHTML, ar = Pe ? Pe[g1] : void 0;
                    if (ar != null) {
                      var Zt = OF(a, ar);
                      Zt !== bt && vy(Oe, bt, Zt);
                    }
                  } else if (Oe === Zd) {
                    if (L.delete(Oe), CF) {
                      var xe = xC(Pe);
                      tt = a.getAttribute("style"), xe !== tt && vy(Oe, tt, xe);
                    }
                  } else if (I)
                    L.delete(Oe.toLowerCase()), tt = Go(a, Oe, Pe), Pe !== tt && vy(Oe, tt, Pe);
                  else if (!en(Oe, Ct, I) && !Mn(Oe, Pe, Ct, I)) {
                    var Me = !1;
                    if (Ct !== null)
                      L.delete(Ct.attributeName), tt = Yo(a, Oe, Pe, Ct);
                    else {
                      var be = m;
                      if (be === Mu && (be = dm(o)), be === Mu)
                        L.delete(Oe.toLowerCase());
                      else {
                        var Ve = lQ(Oe);
                        Ve !== null && Ve !== Oe && (Me = !0, L.delete(Ve)), L.delete(Oe);
                      }
                      tt = Go(a, Oe, Pe);
                    }
                    var ot = z;
                    !ot && Pe !== tt && !Me && vy(Oe, tt, Pe);
                  }
                }
              }
            }
          }
        switch (N && // $FlowFixMe - Should be inferred as not undefined.
        L.size > 0 && d[cf] !== !0 && _F(L), o) {
          case "input":
            Oo(a), _e(a, d, !0);
            break;
          case "textarea":
            Oo(a), eb(a);
            break;
          case "select":
          case "option":
            break;
          default:
            typeof d.onClick == "function" && S1(a);
            break;
        }
        return Se;
      }
      function fQ(a, o, d) {
        var m = a.nodeValue !== o;
        return m;
      }
      function QC(a, o) {
        {
          if (lo)
            return;
          lo = !0, s("Did not expect server HTML to contain a <%s> in <%s>.", o.nodeName.toLowerCase(), a.nodeName.toLowerCase());
        }
      }
      function KC(a, o) {
        {
          if (lo)
            return;
          lo = !0, s('Did not expect server HTML to contain the text node "%s" in <%s>.', o.nodeValue, a.nodeName.toLowerCase());
        }
      }
      function XC(a, o, d) {
        {
          if (lo)
            return;
          lo = !0, s("Expected server HTML to contain a matching <%s> in <%s>.", o, a.nodeName.toLowerCase());
        }
      }
      function ZC(a, o) {
        {
          if (o === "" || lo)
            return;
          lo = !0, s('Expected server HTML to contain a matching text node for "%s" in <%s>.', o, a.nodeName.toLowerCase());
        }
      }
      function dQ(a, o, d) {
        switch (o) {
          case "input":
            Ae(a, d);
            return;
          case "textarea":
            vC(a, d);
            return;
          case "select":
            um(a, d);
            return;
        }
      }
      var my = function() {
      }, yy = function() {
      };
      {
        var pQ = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], AF = [
          "applet",
          "caption",
          "html",
          "table",
          "td",
          "th",
          "marquee",
          "object",
          "template",
          // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
          // TODO: Distinguish by namespace here -- for <title>, including it here
          // errs on the side of fewer warnings
          "foreignObject",
          "desc",
          "title"
        ], hQ = AF.concat(["button"]), vQ = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], DF = {
          current: null,
          formTag: null,
          aTagInScope: null,
          buttonTagInScope: null,
          nobrTagInScope: null,
          pTagInButtonScope: null,
          listItemTagAutoclosing: null,
          dlItemTagAutoclosing: null
        };
        yy = function(a, o) {
          var d = Ht({}, a || DF), m = {
            tag: o
          };
          return AF.indexOf(o) !== -1 && (d.aTagInScope = null, d.buttonTagInScope = null, d.nobrTagInScope = null), hQ.indexOf(o) !== -1 && (d.pTagInButtonScope = null), pQ.indexOf(o) !== -1 && o !== "address" && o !== "div" && o !== "p" && (d.listItemTagAutoclosing = null, d.dlItemTagAutoclosing = null), d.current = m, o === "form" && (d.formTag = m), o === "a" && (d.aTagInScope = m), o === "button" && (d.buttonTagInScope = m), o === "nobr" && (d.nobrTagInScope = m), o === "p" && (d.pTagInButtonScope = m), o === "li" && (d.listItemTagAutoclosing = m), (o === "dd" || o === "dt") && (d.dlItemTagAutoclosing = m), d;
        };
        var mQ = function(a, o) {
          switch (o) {
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
              return a === "option" || a === "optgroup" || a === "#text";
            case "optgroup":
              return a === "option" || a === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
              return a === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
              return a === "th" || a === "td" || a === "style" || a === "script" || a === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
              return a === "tr" || a === "style" || a === "script" || a === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
              return a === "col" || a === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
              return a === "caption" || a === "colgroup" || a === "tbody" || a === "tfoot" || a === "thead" || a === "style" || a === "script" || a === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
              return a === "base" || a === "basefont" || a === "bgsound" || a === "link" || a === "meta" || a === "title" || a === "noscript" || a === "noframes" || a === "style" || a === "script" || a === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
              return a === "head" || a === "body" || a === "frameset";
            case "frameset":
              return a === "frame";
            case "#document":
              return a === "html";
          }
          switch (a) {
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
              return o !== "h1" && o !== "h2" && o !== "h3" && o !== "h4" && o !== "h5" && o !== "h6";
            case "rp":
            case "rt":
              return vQ.indexOf(o) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
              return o == null;
          }
          return !0;
        }, yQ = function(a, o) {
          switch (a) {
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
              return o.pTagInButtonScope;
            case "form":
              return o.formTag || o.pTagInButtonScope;
            case "li":
              return o.listItemTagAutoclosing;
            case "dd":
            case "dt":
              return o.dlItemTagAutoclosing;
            case "button":
              return o.buttonTagInScope;
            case "a":
              return o.aTagInScope;
            case "nobr":
              return o.nobrTagInScope;
          }
          return null;
        }, kF = {};
        my = function(a, o, d) {
          d = d || DF;
          var m = d.current, b = m && m.tag;
          o != null && (a != null && s("validateDOMNesting: when childText is passed, childTag should be null"), a = "#text");
          var O = mQ(a, b) ? null : m, N = O ? null : yQ(a, d), I = O || N;
          if (I) {
            var L = I.tag, G = !!O + "|" + a + "|" + L;
            if (!kF[G]) {
              kF[G] = !0;
              var K = a, ve = "";
              if (a === "#text" ? /\S/.test(o) ? K = "Text nodes" : (K = "Whitespace text nodes", ve = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : K = "<" + a + ">", O) {
                var pe = "";
                L === "table" && a === "tr" && (pe += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), s("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", K, L, ve, pe);
              } else
                s("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", K, L);
            }
          }
        };
      }
      var _1 = "suppressHydrationWarning", C1 = "$", O1 = "/$", gy = "$?", xy = "$!", gQ = "style", JC = null, eO = null;
      function xQ(a) {
        var o, d, m = a.nodeType;
        switch (m) {
          case ju:
          case hm: {
            o = m === ju ? "#document" : "#fragment";
            var b = a.documentElement;
            d = b ? b.namespaceURI : pm(null, "");
            break;
          }
          default: {
            var O = m === Nn ? a.parentNode : a, N = O.namespaceURI || null;
            o = O.tagName, d = pm(N, o);
            break;
          }
        }
        {
          var I = o.toLowerCase(), L = yy(null, I);
          return {
            namespace: d,
            ancestorInfo: L
          };
        }
      }
      function bQ(a, o, d) {
        {
          var m = a, b = pm(m.namespace, o), O = yy(m.ancestorInfo, o);
          return {
            namespace: b,
            ancestorInfo: O
          };
        }
      }
      function UTe(a) {
        return a;
      }
      function wQ(a) {
        JC = $n(), eO = jG();
        var o = null;
        return Zn(!1), o;
      }
      function EQ(a) {
        FG(eO), Zn(JC), JC = null, eO = null;
      }
      function SQ(a, o, d, m, b) {
        var O;
        {
          var N = m;
          if (my(a, null, N.ancestorInfo), typeof o.children == "string" || typeof o.children == "number") {
            var I = "" + o.children, L = yy(N.ancestorInfo, a);
            my(null, I, L);
          }
          O = N.namespace;
        }
        var G = iQ(a, o, d, O);
        return Ey(b, G), sO(G, o), G;
      }
      function _Q(a, o) {
        a.appendChild(o);
      }
      function CQ(a, o, d, m, b) {
        switch (oQ(a, o, d, m), o) {
          case "button":
          case "input":
          case "select":
          case "textarea":
            return !!d.autoFocus;
          case "img":
            return !0;
          default:
            return !1;
        }
      }
      function OQ(a, o, d, m, b, O) {
        {
          var N = O;
          if (typeof m.children != typeof d.children && (typeof m.children == "string" || typeof m.children == "number")) {
            var I = "" + m.children, L = yy(N.ancestorInfo, o);
            my(null, I, L);
          }
        }
        return uQ(a, o, d, m);
      }
      function tO(a, o) {
        return a === "textarea" || a === "noscript" || typeof o.children == "string" || typeof o.children == "number" || typeof o.dangerouslySetInnerHTML == "object" && o.dangerouslySetInnerHTML !== null && o.dangerouslySetInnerHTML.__html != null;
      }
      function TQ(a, o, d, m) {
        {
          var b = d;
          my(null, a, b.ancestorInfo);
        }
        var O = aQ(a, o);
        return Ey(m, O), O;
      }
      function AQ() {
        var a = window.event;
        return a === void 0 ? ao : Wh(a.type);
      }
      var rO = typeof setTimeout == "function" ? setTimeout : void 0, DQ = typeof clearTimeout == "function" ? clearTimeout : void 0, nO = -1, RF = typeof Promise == "function" ? Promise : void 0, kQ = typeof queueMicrotask == "function" ? queueMicrotask : typeof RF < "u" ? function(a) {
        return RF.resolve(null).then(a).catch(RQ);
      } : rO;
      function RQ(a) {
        setTimeout(function() {
          throw a;
        });
      }
      function PQ(a, o, d, m) {
        switch (o) {
          case "button":
          case "input":
          case "select":
          case "textarea":
            d.autoFocus && a.focus();
            return;
          case "img": {
            d.src && (a.src = d.src);
            return;
          }
        }
      }
      function MQ(a, o, d, m, b, O) {
        sQ(a, o, d, m, b), sO(a, b);
      }
      function PF(a) {
        $c(a, "");
      }
      function NQ(a, o, d) {
        a.nodeValue = d;
      }
      function jQ(a, o) {
        a.appendChild(o);
      }
      function FQ(a, o) {
        var d;
        a.nodeType === Nn ? (d = a.parentNode, d.insertBefore(o, a)) : (d = a, d.appendChild(o));
        var m = a._reactRootContainer;
        m == null && d.onclick === null && S1(d);
      }
      function IQ(a, o, d) {
        a.insertBefore(o, d);
      }
      function BQ(a, o, d) {
        a.nodeType === Nn ? a.parentNode.insertBefore(o, d) : a.insertBefore(o, d);
      }
      function LQ(a, o) {
        a.removeChild(o);
      }
      function $Q(a, o) {
        a.nodeType === Nn ? a.parentNode.removeChild(o) : a.removeChild(o);
      }
      function iO(a, o) {
        var d = o, m = 0;
        do {
          var b = d.nextSibling;
          if (a.removeChild(d), b && b.nodeType === Nn) {
            var O = b.data;
            if (O === O1)
              if (m === 0) {
                a.removeChild(b), Ul(o);
                return;
              } else
                m--;
            else (O === C1 || O === gy || O === xy) && m++;
          }
          d = b;
        } while (d);
        Ul(o);
      }
      function zQ(a, o) {
        a.nodeType === Nn ? iO(a.parentNode, o) : a.nodeType === ca && iO(a, o), Ul(a);
      }
      function qQ(a) {
        a = a;
        var o = a.style;
        typeof o.setProperty == "function" ? o.setProperty("display", "none", "important") : o.display = "none";
      }
      function UQ(a) {
        a.nodeValue = "";
      }
      function HQ(a, o) {
        a = a;
        var d = o[gQ], m = d != null && d.hasOwnProperty("display") ? d.display : null;
        a.style.display = Zp("display", m);
      }
      function VQ(a, o) {
        a.nodeValue = o;
      }
      function WQ(a) {
        a.nodeType === ca ? a.textContent = "" : a.nodeType === ju && a.documentElement && a.removeChild(a.documentElement);
      }
      function YQ(a, o, d) {
        return a.nodeType !== ca || o.toLowerCase() !== a.nodeName.toLowerCase() ? null : a;
      }
      function GQ(a, o) {
        return o === "" || a.nodeType !== Nu ? null : a;
      }
      function QQ(a) {
        return a.nodeType !== Nn ? null : a;
      }
      function MF(a) {
        return a.data === gy;
      }
      function aO(a) {
        return a.data === xy;
      }
      function KQ(a) {
        var o = a.nextSibling && a.nextSibling.dataset, d, m, b;
        return o && (d = o.dgst, m = o.msg, b = o.stck), {
          message: m,
          digest: d,
          stack: b
        };
      }
      function XQ(a, o) {
        a._reactRetry = o;
      }
      function T1(a) {
        for (; a != null; a = a.nextSibling) {
          var o = a.nodeType;
          if (o === ca || o === Nu)
            break;
          if (o === Nn) {
            var d = a.data;
            if (d === C1 || d === xy || d === gy)
              break;
            if (d === O1)
              return null;
          }
        }
        return a;
      }
      function by(a) {
        return T1(a.nextSibling);
      }
      function ZQ(a) {
        return T1(a.firstChild);
      }
      function JQ(a) {
        return T1(a.firstChild);
      }
      function eK(a) {
        return T1(a.nextSibling);
      }
      function tK(a, o, d, m, b, O, N) {
        Ey(O, a), sO(a, d);
        var I;
        {
          var L = b;
          I = L.namespace;
        }
        var G = (O.mode & Gt) !== St;
        return cQ(a, o, d, I, m, G, N);
      }
      function rK(a, o, d, m) {
        return Ey(d, a), d.mode & Gt, fQ(a, o);
      }
      function nK(a, o) {
        Ey(o, a);
      }
      function iK(a) {
        for (var o = a.nextSibling, d = 0; o; ) {
          if (o.nodeType === Nn) {
            var m = o.data;
            if (m === O1) {
              if (d === 0)
                return by(o);
              d--;
            } else (m === C1 || m === xy || m === gy) && d++;
          }
          o = o.nextSibling;
        }
        return null;
      }
      function NF(a) {
        for (var o = a.previousSibling, d = 0; o; ) {
          if (o.nodeType === Nn) {
            var m = o.data;
            if (m === C1 || m === xy || m === gy) {
              if (d === 0)
                return o;
              d--;
            } else m === O1 && d++;
          }
          o = o.previousSibling;
        }
        return null;
      }
      function aK(a) {
        Ul(a);
      }
      function oK(a) {
        Ul(a);
      }
      function uK(a) {
        return a !== "head" && a !== "body";
      }
      function sK(a, o, d, m) {
        var b = !0;
        E1(o.nodeValue, d, m, b);
      }
      function lK(a, o, d, m, b, O) {
        if (o[_1] !== !0) {
          var N = !0;
          E1(m.nodeValue, b, O, N);
        }
      }
      function cK(a, o) {
        o.nodeType === ca ? QC(a, o) : o.nodeType === Nn || KC(a, o);
      }
      function fK(a, o) {
        {
          var d = a.parentNode;
          d !== null && (o.nodeType === ca ? QC(d, o) : o.nodeType === Nn || KC(d, o));
        }
      }
      function dK(a, o, d, m, b) {
        (b || o[_1] !== !0) && (m.nodeType === ca ? QC(d, m) : m.nodeType === Nn || KC(d, m));
      }
      function pK(a, o, d) {
        XC(a, o);
      }
      function hK(a, o) {
        ZC(a, o);
      }
      function vK(a, o, d) {
        {
          var m = a.parentNode;
          m !== null && XC(m, o);
        }
      }
      function mK(a, o) {
        {
          var d = a.parentNode;
          d !== null && ZC(d, o);
        }
      }
      function yK(a, o, d, m, b, O) {
        (O || o[_1] !== !0) && XC(d, m);
      }
      function gK(a, o, d, m, b) {
        (b || o[_1] !== !0) && ZC(d, m);
      }
      function xK(a) {
        s("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", a.nodeName.toLowerCase());
      }
      function bK(a) {
        dy(a);
      }
      var ov = Math.random().toString(36).slice(2), uv = "__reactFiber$" + ov, oO = "__reactProps$" + ov, wy = "__reactContainer$" + ov, uO = "__reactEvents$" + ov, wK = "__reactListeners$" + ov, EK = "__reactHandles$" + ov;
      function SK(a) {
        delete a[uv], delete a[oO], delete a[uO], delete a[wK], delete a[EK];
      }
      function Ey(a, o) {
        o[uv] = a;
      }
      function A1(a, o) {
        o[wy] = a;
      }
      function jF(a) {
        a[wy] = null;
      }
      function Sy(a) {
        return !!a[wy];
      }
      function Jd(a) {
        var o = a[uv];
        if (o)
          return o;
        for (var d = a.parentNode; d; ) {
          if (o = d[wy] || d[uv], o) {
            var m = o.alternate;
            if (o.child !== null || m !== null && m.child !== null)
              for (var b = NF(a); b !== null; ) {
                var O = b[uv];
                if (O)
                  return O;
                b = NF(b);
              }
            return o;
          }
          a = d, d = a.parentNode;
        }
        return null;
      }
      function ff(a) {
        var o = a[uv] || a[wy];
        return o && (o.tag === w || o.tag === E || o.tag === T || o.tag === y) ? o : null;
      }
      function sv(a) {
        if (a.tag === w || a.tag === E)
          return a.stateNode;
        throw new Error("getNodeFromInstance: Invalid argument.");
      }
      function D1(a) {
        return a[oO] || null;
      }
      function sO(a, o) {
        a[oO] = o;
      }
      function _K(a) {
        var o = a[uO];
        return o === void 0 && (o = a[uO] = /* @__PURE__ */ new Set()), o;
      }
      var FF = {}, IF = r.ReactDebugCurrentFrame;
      function k1(a) {
        if (a) {
          var o = a._owner, d = ku(a.type, a._source, o ? o.type : null);
          IF.setExtraStackFrame(d);
        } else
          IF.setExtraStackFrame(null);
      }
      function Wu(a, o, d, m, b) {
        {
          var O = Function.call.bind(de);
          for (var N in a)
            if (O(a, N)) {
              var I = void 0;
              try {
                if (typeof a[N] != "function") {
                  var L = Error((m || "React class") + ": " + d + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw L.name = "Invariant Violation", L;
                }
                I = a[N](o, N, m, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (G) {
                I = G;
              }
              I && !(I instanceof Error) && (k1(b), s("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", d, N, typeof I), k1(null)), I instanceof Error && !(I.message in FF) && (FF[I.message] = !0, k1(b), s("Failed %s type: %s", d, I.message), k1(null));
            }
        }
      }
      var lO = [], R1;
      R1 = [];
      var Ql = -1;
      function df(a) {
        return {
          current: a
        };
      }
      function wa(a, o) {
        if (Ql < 0) {
          s("Unexpected pop.");
          return;
        }
        o !== R1[Ql] && s("Unexpected Fiber popped."), a.current = lO[Ql], lO[Ql] = null, R1[Ql] = null, Ql--;
      }
      function Ea(a, o, d) {
        Ql++, lO[Ql] = a.current, R1[Ql] = d, a.current = o;
      }
      var cO;
      cO = {};
      var jo = {};
      Object.freeze(jo);
      var Kl = df(jo), Ys = df(!1), fO = jo;
      function lv(a, o, d) {
        return d && Gs(o) ? fO : Kl.current;
      }
      function BF(a, o, d) {
        {
          var m = a.stateNode;
          m.__reactInternalMemoizedUnmaskedChildContext = o, m.__reactInternalMemoizedMaskedChildContext = d;
        }
      }
      function cv(a, o) {
        {
          var d = a.type, m = d.contextTypes;
          if (!m)
            return jo;
          var b = a.stateNode;
          if (b && b.__reactInternalMemoizedUnmaskedChildContext === o)
            return b.__reactInternalMemoizedMaskedChildContext;
          var O = {};
          for (var N in m)
            O[N] = o[N];
          {
            var I = Ft(a) || "Unknown";
            Wu(m, O, "context", I);
          }
          return b && BF(a, o, O), O;
        }
      }
      function P1() {
        return Ys.current;
      }
      function Gs(a) {
        {
          var o = a.childContextTypes;
          return o != null;
        }
      }
      function M1(a) {
        wa(Ys, a), wa(Kl, a);
      }
      function dO(a) {
        wa(Ys, a), wa(Kl, a);
      }
      function LF(a, o, d) {
        {
          if (Kl.current !== jo)
            throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
          Ea(Kl, o, a), Ea(Ys, d, a);
        }
      }
      function $F(a, o, d) {
        {
          var m = a.stateNode, b = o.childContextTypes;
          if (typeof m.getChildContext != "function") {
            {
              var O = Ft(a) || "Unknown";
              cO[O] || (cO[O] = !0, s("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", O, O));
            }
            return d;
          }
          var N = m.getChildContext();
          for (var I in N)
            if (!(I in b))
              throw new Error((Ft(a) || "Unknown") + '.getChildContext(): key "' + I + '" is not defined in childContextTypes.');
          {
            var L = Ft(a) || "Unknown";
            Wu(b, N, "child context", L);
          }
          return Ht({}, d, N);
        }
      }
      function N1(a) {
        {
          var o = a.stateNode, d = o && o.__reactInternalMemoizedMergedChildContext || jo;
          return fO = Kl.current, Ea(Kl, d, a), Ea(Ys, Ys.current, a), !0;
        }
      }
      function zF(a, o, d) {
        {
          var m = a.stateNode;
          if (!m)
            throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
          if (d) {
            var b = $F(a, o, fO);
            m.__reactInternalMemoizedMergedChildContext = b, wa(Ys, a), wa(Kl, a), Ea(Kl, b, a), Ea(Ys, d, a);
          } else
            wa(Ys, a), Ea(Ys, d, a);
        }
      }
      function CK(a) {
        {
          if (!Dl(a) || a.tag !== h)
            throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
          var o = a;
          do {
            switch (o.tag) {
              case y:
                return o.stateNode.context;
              case h: {
                var d = o.type;
                if (Gs(d))
                  return o.stateNode.__reactInternalMemoizedMergedChildContext;
                break;
              }
            }
            o = o.return;
          } while (o !== null);
          throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
        }
      }
      var pf = 0, j1 = 1, Xl = null, pO = !1, hO = !1;
      function qF(a) {
        Xl === null ? Xl = [a] : Xl.push(a);
      }
      function OK(a) {
        pO = !0, qF(a);
      }
      function UF() {
        pO && hf();
      }
      function hf() {
        if (!hO && Xl !== null) {
          hO = !0;
          var a = 0, o = uo();
          try {
            var d = !0, m = Xl;
            for (Ln(Hi); a < m.length; a++) {
              var b = m[a];
              do
                b = b(d);
              while (b !== null);
            }
            Xl = null, pO = !1;
          } catch (O) {
            throw Xl !== null && (Xl = Xl.slice(a + 1)), Om(gd, hf), O;
          } finally {
            Ln(o), hO = !1;
          }
        }
        return null;
      }
      var fv = [], dv = 0, F1 = null, I1 = 0, pu = [], hu = 0, ep = null, Zl = 1, Jl = "";
      function TK(a) {
        return rp(), (a.flags & nu) !== Et;
      }
      function AK(a) {
        return rp(), I1;
      }
      function DK() {
        var a = Jl, o = Zl, d = o & ~kK(o);
        return d.toString(32) + a;
      }
      function tp(a, o) {
        rp(), fv[dv++] = I1, fv[dv++] = F1, F1 = a, I1 = o;
      }
      function HF(a, o, d) {
        rp(), pu[hu++] = Zl, pu[hu++] = Jl, pu[hu++] = ep, ep = a;
        var m = Zl, b = Jl, O = B1(m) - 1, N = m & ~(1 << O), I = d + 1, L = B1(o) + O;
        if (L > 30) {
          var G = O - O % 5, K = (1 << G) - 1, ve = (N & K).toString(32), pe = N >> G, Se = O - G, Oe = B1(o) + Se, Pe = I << Se, tt = Pe | pe, Ct = ve + b;
          Zl = 1 << Oe | tt, Jl = Ct;
        } else {
          var bt = I << O, ar = bt | N, Zt = b;
          Zl = 1 << L | ar, Jl = Zt;
        }
      }
      function vO(a) {
        rp();
        var o = a.return;
        if (o !== null) {
          var d = 1, m = 0;
          tp(a, d), HF(a, d, m);
        }
      }
      function B1(a) {
        return 32 - In(a);
      }
      function kK(a) {
        return 1 << B1(a) - 1;
      }
      function mO(a) {
        for (; a === F1; )
          F1 = fv[--dv], fv[dv] = null, I1 = fv[--dv], fv[dv] = null;
        for (; a === ep; )
          ep = pu[--hu], pu[hu] = null, Jl = pu[--hu], pu[hu] = null, Zl = pu[--hu], pu[hu] = null;
      }
      function RK() {
        return rp(), ep !== null ? {
          id: Zl,
          overflow: Jl
        } : null;
      }
      function PK(a, o) {
        rp(), pu[hu++] = Zl, pu[hu++] = Jl, pu[hu++] = ep, Zl = o.id, Jl = o.overflow, ep = a;
      }
      function rp() {
        Qi() || s("Expected to be hydrating. This is a bug in React. Please file an issue.");
      }
      var Gi = null, vu = null, Yu = !1, np = !1, vf = null;
      function MK() {
        Yu && s("We should not be hydrating here. This is a bug in React. Please file a bug.");
      }
      function VF() {
        np = !0;
      }
      function NK() {
        return np;
      }
      function jK(a) {
        var o = a.stateNode.containerInfo;
        return vu = JQ(o), Gi = a, Yu = !0, vf = null, np = !1, !0;
      }
      function FK(a, o, d) {
        return vu = eK(o), Gi = a, Yu = !0, vf = null, np = !1, d !== null && PK(a, d), !0;
      }
      function WF(a, o) {
        switch (a.tag) {
          case y: {
            cK(a.stateNode.containerInfo, o);
            break;
          }
          case w: {
            var d = (a.mode & Gt) !== St;
            dK(
              a.type,
              a.memoizedProps,
              a.stateNode,
              o,
              // TODO: Delete this argument when we remove the legacy root API.
              d
            );
            break;
          }
          case T: {
            var m = a.memoizedState;
            m.dehydrated !== null && fK(m.dehydrated, o);
            break;
          }
        }
      }
      function YF(a, o) {
        WF(a, o);
        var d = $J();
        d.stateNode = o, d.return = a;
        var m = a.deletions;
        m === null ? (a.deletions = [d], a.flags |= eo) : m.push(d);
      }
      function yO(a, o) {
        {
          if (np)
            return;
          switch (a.tag) {
            case y: {
              var d = a.stateNode.containerInfo;
              switch (o.tag) {
                case w:
                  var m = o.type;
                  o.pendingProps, pK(d, m);
                  break;
                case E:
                  var b = o.pendingProps;
                  hK(d, b);
                  break;
              }
              break;
            }
            case w: {
              var O = a.type, N = a.memoizedProps, I = a.stateNode;
              switch (o.tag) {
                case w: {
                  var L = o.type, G = o.pendingProps, K = (a.mode & Gt) !== St;
                  yK(
                    O,
                    N,
                    I,
                    L,
                    G,
                    // TODO: Delete this argument when we remove the legacy root API.
                    K
                  );
                  break;
                }
                case E: {
                  var ve = o.pendingProps, pe = (a.mode & Gt) !== St;
                  gK(
                    O,
                    N,
                    I,
                    ve,
                    // TODO: Delete this argument when we remove the legacy root API.
                    pe
                  );
                  break;
                }
              }
              break;
            }
            case T: {
              var Se = a.memoizedState, Oe = Se.dehydrated;
              if (Oe !== null) switch (o.tag) {
                case w:
                  var Pe = o.type;
                  o.pendingProps, vK(Oe, Pe);
                  break;
                case E:
                  var tt = o.pendingProps;
                  mK(Oe, tt);
                  break;
              }
              break;
            }
            default:
              return;
          }
        }
      }
      function GF(a, o) {
        o.flags = o.flags & -4097 | Sn, yO(a, o);
      }
      function QF(a, o) {
        switch (a.tag) {
          case w: {
            var d = a.type;
            a.pendingProps;
            var m = YQ(o, d);
            return m !== null ? (a.stateNode = m, Gi = a, vu = ZQ(m), !0) : !1;
          }
          case E: {
            var b = a.pendingProps, O = GQ(o, b);
            return O !== null ? (a.stateNode = O, Gi = a, vu = null, !0) : !1;
          }
          case T: {
            var N = QQ(o);
            if (N !== null) {
              var I = {
                dehydrated: N,
                treeContext: RK(),
                retryLane: Ia
              };
              a.memoizedState = I;
              var L = zJ(N);
              return L.return = a, a.child = L, Gi = a, vu = null, !0;
            }
            return !1;
          }
          default:
            return !1;
        }
      }
      function gO(a) {
        return (a.mode & Gt) !== St && (a.flags & wt) === Et;
      }
      function xO(a) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
      }
      function bO(a) {
        if (Yu) {
          var o = vu;
          if (!o) {
            gO(a) && (yO(Gi, a), xO()), GF(Gi, a), Yu = !1, Gi = a;
            return;
          }
          var d = o;
          if (!QF(a, o)) {
            gO(a) && (yO(Gi, a), xO()), o = by(d);
            var m = Gi;
            if (!o || !QF(a, o)) {
              GF(Gi, a), Yu = !1, Gi = a;
              return;
            }
            YF(m, d);
          }
        }
      }
      function IK(a, o, d) {
        var m = a.stateNode, b = !np, O = tK(m, a.type, a.memoizedProps, o, d, a, b);
        return a.updateQueue = O, O !== null;
      }
      function BK(a) {
        var o = a.stateNode, d = a.memoizedProps, m = rK(o, d, a);
        if (m) {
          var b = Gi;
          if (b !== null)
            switch (b.tag) {
              case y: {
                var O = b.stateNode.containerInfo, N = (b.mode & Gt) !== St;
                sK(
                  O,
                  o,
                  d,
                  // TODO: Delete this argument when we remove the legacy root API.
                  N
                );
                break;
              }
              case w: {
                var I = b.type, L = b.memoizedProps, G = b.stateNode, K = (b.mode & Gt) !== St;
                lK(
                  I,
                  L,
                  G,
                  o,
                  d,
                  // TODO: Delete this argument when we remove the legacy root API.
                  K
                );
                break;
              }
            }
        }
        return m;
      }
      function LK(a) {
        var o = a.memoizedState, d = o !== null ? o.dehydrated : null;
        if (!d)
          throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        nK(d, a);
      }
      function $K(a) {
        var o = a.memoizedState, d = o !== null ? o.dehydrated : null;
        if (!d)
          throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return iK(d);
      }
      function KF(a) {
        for (var o = a.return; o !== null && o.tag !== w && o.tag !== y && o.tag !== T; )
          o = o.return;
        Gi = o;
      }
      function L1(a) {
        if (a !== Gi)
          return !1;
        if (!Yu)
          return KF(a), Yu = !0, !1;
        if (a.tag !== y && (a.tag !== w || uK(a.type) && !tO(a.type, a.memoizedProps))) {
          var o = vu;
          if (o)
            if (gO(a))
              XF(a), xO();
            else
              for (; o; )
                YF(a, o), o = by(o);
        }
        return KF(a), a.tag === T ? vu = $K(a) : vu = Gi ? by(a.stateNode) : null, !0;
      }
      function zK() {
        return Yu && vu !== null;
      }
      function XF(a) {
        for (var o = vu; o; )
          WF(a, o), o = by(o);
      }
      function pv() {
        Gi = null, vu = null, Yu = !1, np = !1;
      }
      function ZF() {
        vf !== null && (VI(vf), vf = null);
      }
      function Qi() {
        return Yu;
      }
      function wO(a) {
        vf === null ? vf = [a] : vf.push(a);
      }
      var qK = r.ReactCurrentBatchConfig, UK = null;
      function HK() {
        return qK.transition;
      }
      var Gu = {
        recordUnsafeLifecycleWarnings: function(a, o) {
        },
        flushPendingUnsafeLifecycleWarnings: function() {
        },
        recordLegacyContextWarning: function(a, o) {
        },
        flushLegacyContextWarning: function() {
        },
        discardPendingWarnings: function() {
        }
      };
      {
        var VK = function(a) {
          for (var o = null, d = a; d !== null; )
            d.mode & Ir && (o = d), d = d.return;
          return o;
        }, ip = function(a) {
          var o = [];
          return a.forEach(function(d) {
            o.push(d);
          }), o.sort().join(", ");
        }, _y = [], Cy = [], Oy = [], Ty = [], Ay = [], Dy = [], ap = /* @__PURE__ */ new Set();
        Gu.recordUnsafeLifecycleWarnings = function(a, o) {
          ap.has(a.type) || (typeof o.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
          o.componentWillMount.__suppressDeprecationWarning !== !0 && _y.push(a), a.mode & Ir && typeof o.UNSAFE_componentWillMount == "function" && Cy.push(a), typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && Oy.push(a), a.mode & Ir && typeof o.UNSAFE_componentWillReceiveProps == "function" && Ty.push(a), typeof o.componentWillUpdate == "function" && o.componentWillUpdate.__suppressDeprecationWarning !== !0 && Ay.push(a), a.mode & Ir && typeof o.UNSAFE_componentWillUpdate == "function" && Dy.push(a));
        }, Gu.flushPendingUnsafeLifecycleWarnings = function() {
          var a = /* @__PURE__ */ new Set();
          _y.length > 0 && (_y.forEach(function(pe) {
            a.add(Ft(pe) || "Component"), ap.add(pe.type);
          }), _y = []);
          var o = /* @__PURE__ */ new Set();
          Cy.length > 0 && (Cy.forEach(function(pe) {
            o.add(Ft(pe) || "Component"), ap.add(pe.type);
          }), Cy = []);
          var d = /* @__PURE__ */ new Set();
          Oy.length > 0 && (Oy.forEach(function(pe) {
            d.add(Ft(pe) || "Component"), ap.add(pe.type);
          }), Oy = []);
          var m = /* @__PURE__ */ new Set();
          Ty.length > 0 && (Ty.forEach(function(pe) {
            m.add(Ft(pe) || "Component"), ap.add(pe.type);
          }), Ty = []);
          var b = /* @__PURE__ */ new Set();
          Ay.length > 0 && (Ay.forEach(function(pe) {
            b.add(Ft(pe) || "Component"), ap.add(pe.type);
          }), Ay = []);
          var O = /* @__PURE__ */ new Set();
          if (Dy.length > 0 && (Dy.forEach(function(pe) {
            O.add(Ft(pe) || "Component"), ap.add(pe.type);
          }), Dy = []), o.size > 0) {
            var N = ip(o);
            s(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, N);
          }
          if (m.size > 0) {
            var I = ip(m);
            s(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, I);
          }
          if (O.size > 0) {
            var L = ip(O);
            s(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, L);
          }
          if (a.size > 0) {
            var G = ip(a);
            u(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, G);
          }
          if (d.size > 0) {
            var K = ip(d);
            u(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, K);
          }
          if (b.size > 0) {
            var ve = ip(b);
            u(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, ve);
          }
        };
        var $1 = /* @__PURE__ */ new Map(), JF = /* @__PURE__ */ new Set();
        Gu.recordLegacyContextWarning = function(a, o) {
          var d = VK(a);
          if (d === null) {
            s("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
          }
          if (!JF.has(a.type)) {
            var m = $1.get(d);
            (a.type.contextTypes != null || a.type.childContextTypes != null || o !== null && typeof o.getChildContext == "function") && (m === void 0 && (m = [], $1.set(d, m)), m.push(a));
          }
        }, Gu.flushLegacyContextWarning = function() {
          $1.forEach(function(a, o) {
            if (a.length !== 0) {
              var d = a[0], m = /* @__PURE__ */ new Set();
              a.forEach(function(O) {
                m.add(Ft(O) || "Component"), JF.add(O.type);
              });
              var b = ip(m);
              try {
                Nr(d), s(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, b);
              } finally {
                un();
              }
            }
          });
        }, Gu.discardPendingWarnings = function() {
          _y = [], Cy = [], Oy = [], Ty = [], Ay = [], Dy = [], $1 = /* @__PURE__ */ new Map();
        };
      }
      var EO, SO, _O, CO, OO, e4 = function(a, o) {
      };
      EO = !1, SO = !1, _O = {}, CO = {}, OO = {}, e4 = function(a, o) {
        if (!(a === null || typeof a != "object") && !(!a._store || a._store.validated || a.key != null)) {
          if (typeof a._store != "object")
            throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
          a._store.validated = !0;
          var d = Ft(o) || "Component";
          CO[d] || (CO[d] = !0, s('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
        }
      };
      function WK(a) {
        return a.prototype && a.prototype.isReactComponent;
      }
      function ky(a, o, d) {
        var m = d.ref;
        if (m !== null && typeof m != "function" && typeof m != "object") {
          if ((a.mode & Ir || Y) && // We warn in ReactElement.js if owner and self are equal for string refs
          // because these cannot be automatically converted to an arrow function
          // using a codemod. Therefore, we don't have to warn about string refs again.
          !(d._owner && d._self && d._owner.stateNode !== d._self) && // Will already throw with "Function components cannot have string refs"
          !(d._owner && d._owner.tag !== h) && // Will already warn with "Function components cannot be given refs"
          !(typeof d.type == "function" && !WK(d.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
          d._owner) {
            var b = Ft(a) || "Component";
            _O[b] || (s('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', b, m), _O[b] = !0);
          }
          if (d._owner) {
            var O = d._owner, N;
            if (O) {
              var I = O;
              if (I.tag !== h)
                throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
              N = I.stateNode;
            }
            if (!N)
              throw new Error("Missing owner for string ref " + m + ". This error is likely caused by a bug in React. Please file an issue.");
            var L = N;
            Wr(m, "ref");
            var G = "" + m;
            if (o !== null && o.ref !== null && typeof o.ref == "function" && o.ref._stringRef === G)
              return o.ref;
            var K = function(ve) {
              var pe = L.refs;
              ve === null ? delete pe[G] : pe[G] = ve;
            };
            return K._stringRef = G, K;
          } else {
            if (typeof m != "string")
              throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
            if (!d._owner)
              throw new Error("Element ref was specified as a string (" + m + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
          }
        }
        return m;
      }
      function z1(a, o) {
        var d = Object.prototype.toString.call(o);
        throw new Error("Objects are not valid as a React child (found: " + (d === "[object Object]" ? "object with keys {" + Object.keys(o).join(", ") + "}" : d) + "). If you meant to render a collection of children, use an array instead.");
      }
      function q1(a) {
        {
          var o = Ft(a) || "Component";
          if (OO[o])
            return;
          OO[o] = !0, s("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
        }
      }
      function t4(a) {
        var o = a._payload, d = a._init;
        return d(o);
      }
      function r4(a) {
        function o(xe, Me) {
          if (a) {
            var be = xe.deletions;
            be === null ? (xe.deletions = [Me], xe.flags |= eo) : be.push(Me);
          }
        }
        function d(xe, Me) {
          if (!a)
            return null;
          for (var be = Me; be !== null; )
            o(xe, be), be = be.sibling;
          return null;
        }
        function m(xe, Me) {
          for (var be = /* @__PURE__ */ new Map(), Ve = Me; Ve !== null; )
            Ve.key !== null ? be.set(Ve.key, Ve) : be.set(Ve.index, Ve), Ve = Ve.sibling;
          return be;
        }
        function b(xe, Me) {
          var be = hp(xe, Me);
          return be.index = 0, be.sibling = null, be;
        }
        function O(xe, Me, be) {
          if (xe.index = be, !a)
            return xe.flags |= nu, Me;
          var Ve = xe.alternate;
          if (Ve !== null) {
            var ot = Ve.index;
            return ot < Me ? (xe.flags |= Sn, Me) : ot;
          } else
            return xe.flags |= Sn, Me;
        }
        function N(xe) {
          return a && xe.alternate === null && (xe.flags |= Sn), xe;
        }
        function I(xe, Me, be, Ve) {
          if (Me === null || Me.tag !== E) {
            var ot = wA(be, xe.mode, Ve);
            return ot.return = xe, ot;
          } else {
            var rt = b(Me, be);
            return rt.return = xe, rt;
          }
        }
        function L(xe, Me, be, Ve) {
          var ot = be.type;
          if (ot === Gn)
            return K(xe, Me, be.props.children, Ve, be.key);
          if (Me !== null && (Me.elementType === ot || // Keep this check inline so it only runs on the false path:
          u8(Me, be) || // Lazy types should reconcile their resolved type.
          // We need to do this after the Hot Reloading check above,
          // because hot reloading has different semantics than prod because
          // it doesn't resuspend. So we can't let the call below suspend.
          typeof ot == "object" && ot !== null && ot.$$typeof === It && t4(ot) === Me.type)) {
            var rt = b(Me, be.props);
            return rt.ref = ky(xe, Me, be), rt.return = xe, rt._debugSource = be._source, rt._debugOwner = be._owner, rt;
          }
          var Pt = bA(be, xe.mode, Ve);
          return Pt.ref = ky(xe, Me, be), Pt.return = xe, Pt;
        }
        function G(xe, Me, be, Ve) {
          if (Me === null || Me.tag !== x || Me.stateNode.containerInfo !== be.containerInfo || Me.stateNode.implementation !== be.implementation) {
            var ot = EA(be, xe.mode, Ve);
            return ot.return = xe, ot;
          } else {
            var rt = b(Me, be.children || []);
            return rt.return = xe, rt;
          }
        }
        function K(xe, Me, be, Ve, ot) {
          if (Me === null || Me.tag !== C) {
            var rt = Of(be, xe.mode, Ve, ot);
            return rt.return = xe, rt;
          } else {
            var Pt = b(Me, be);
            return Pt.return = xe, Pt;
          }
        }
        function ve(xe, Me, be) {
          if (typeof Me == "string" && Me !== "" || typeof Me == "number") {
            var Ve = wA("" + Me, xe.mode, be);
            return Ve.return = xe, Ve;
          }
          if (typeof Me == "object" && Me !== null) {
            switch (Me.$$typeof) {
              case ni: {
                var ot = bA(Me, xe.mode, be);
                return ot.ref = ky(xe, null, Me), ot.return = xe, ot;
              }
              case Sr: {
                var rt = EA(Me, xe.mode, be);
                return rt.return = xe, rt;
              }
              case It: {
                var Pt = Me._payload, Lt = Me._init;
                return ve(xe, Lt(Pt), be);
              }
            }
            if (Wt(Me) || zt(Me)) {
              var Lr = Of(Me, xe.mode, be, null);
              return Lr.return = xe, Lr;
            }
            z1(xe, Me);
          }
          return typeof Me == "function" && q1(xe), null;
        }
        function pe(xe, Me, be, Ve) {
          var ot = Me !== null ? Me.key : null;
          if (typeof be == "string" && be !== "" || typeof be == "number")
            return ot !== null ? null : I(xe, Me, "" + be, Ve);
          if (typeof be == "object" && be !== null) {
            switch (be.$$typeof) {
              case ni:
                return be.key === ot ? L(xe, Me, be, Ve) : null;
              case Sr:
                return be.key === ot ? G(xe, Me, be, Ve) : null;
              case It: {
                var rt = be._payload, Pt = be._init;
                return pe(xe, Me, Pt(rt), Ve);
              }
            }
            if (Wt(be) || zt(be))
              return ot !== null ? null : K(xe, Me, be, Ve, null);
            z1(xe, be);
          }
          return typeof be == "function" && q1(xe), null;
        }
        function Se(xe, Me, be, Ve, ot) {
          if (typeof Ve == "string" && Ve !== "" || typeof Ve == "number") {
            var rt = xe.get(be) || null;
            return I(Me, rt, "" + Ve, ot);
          }
          if (typeof Ve == "object" && Ve !== null) {
            switch (Ve.$$typeof) {
              case ni: {
                var Pt = xe.get(Ve.key === null ? be : Ve.key) || null;
                return L(Me, Pt, Ve, ot);
              }
              case Sr: {
                var Lt = xe.get(Ve.key === null ? be : Ve.key) || null;
                return G(Me, Lt, Ve, ot);
              }
              case It:
                var Lr = Ve._payload, br = Ve._init;
                return Se(xe, Me, be, br(Lr), ot);
            }
            if (Wt(Ve) || zt(Ve)) {
              var Jn = xe.get(be) || null;
              return K(Me, Jn, Ve, ot, null);
            }
            z1(Me, Ve);
          }
          return typeof Ve == "function" && q1(Me), null;
        }
        function Oe(xe, Me, be) {
          {
            if (typeof xe != "object" || xe === null)
              return Me;
            switch (xe.$$typeof) {
              case ni:
              case Sr:
                e4(xe, be);
                var Ve = xe.key;
                if (typeof Ve != "string")
                  break;
                if (Me === null) {
                  Me = /* @__PURE__ */ new Set(), Me.add(Ve);
                  break;
                }
                if (!Me.has(Ve)) {
                  Me.add(Ve);
                  break;
                }
                s("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", Ve);
                break;
              case It:
                var ot = xe._payload, rt = xe._init;
                Oe(rt(ot), Me, be);
                break;
            }
          }
          return Me;
        }
        function Pe(xe, Me, be, Ve) {
          for (var ot = null, rt = 0; rt < be.length; rt++) {
            var Pt = be[rt];
            ot = Oe(Pt, ot, xe);
          }
          for (var Lt = null, Lr = null, br = Me, Jn = 0, wr = 0, qn = null; br !== null && wr < be.length; wr++) {
            br.index > wr ? (qn = br, br = null) : qn = br.sibling;
            var _a = pe(xe, br, be[wr], Ve);
            if (_a === null) {
              br === null && (br = qn);
              break;
            }
            a && br && _a.alternate === null && o(xe, br), Jn = O(_a, Jn, wr), Lr === null ? Lt = _a : Lr.sibling = _a, Lr = _a, br = qn;
          }
          if (wr === be.length) {
            if (d(xe, br), Qi()) {
              var ra = wr;
              tp(xe, ra);
            }
            return Lt;
          }
          if (br === null) {
            for (; wr < be.length; wr++) {
              var Io = ve(xe, be[wr], Ve);
              Io !== null && (Jn = O(Io, Jn, wr), Lr === null ? Lt = Io : Lr.sibling = Io, Lr = Io);
            }
            if (Qi()) {
              var Ua = wr;
              tp(xe, Ua);
            }
            return Lt;
          }
          for (var Ha = m(xe, br); wr < be.length; wr++) {
            var Ca = Se(Ha, xe, wr, be[wr], Ve);
            Ca !== null && (a && Ca.alternate !== null && Ha.delete(Ca.key === null ? wr : Ca.key), Jn = O(Ca, Jn, wr), Lr === null ? Lt = Ca : Lr.sibling = Ca, Lr = Ca);
          }
          if (a && Ha.forEach(function(Pv) {
            return o(xe, Pv);
          }), Qi()) {
            var oc = wr;
            tp(xe, oc);
          }
          return Lt;
        }
        function tt(xe, Me, be, Ve) {
          var ot = zt(be);
          if (typeof ot != "function")
            throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
          {
            typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
            be[Symbol.toStringTag] === "Generator" && (SO || s("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), SO = !0), be.entries === ot && (EO || s("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), EO = !0);
            var rt = ot.call(be);
            if (rt)
              for (var Pt = null, Lt = rt.next(); !Lt.done; Lt = rt.next()) {
                var Lr = Lt.value;
                Pt = Oe(Lr, Pt, xe);
              }
          }
          var br = ot.call(be);
          if (br == null)
            throw new Error("An iterable object provided no iterator.");
          for (var Jn = null, wr = null, qn = Me, _a = 0, ra = 0, Io = null, Ua = br.next(); qn !== null && !Ua.done; ra++, Ua = br.next()) {
            qn.index > ra ? (Io = qn, qn = null) : Io = qn.sibling;
            var Ha = pe(xe, qn, Ua.value, Ve);
            if (Ha === null) {
              qn === null && (qn = Io);
              break;
            }
            a && qn && Ha.alternate === null && o(xe, qn), _a = O(Ha, _a, ra), wr === null ? Jn = Ha : wr.sibling = Ha, wr = Ha, qn = Io;
          }
          if (Ua.done) {
            if (d(xe, qn), Qi()) {
              var Ca = ra;
              tp(xe, Ca);
            }
            return Jn;
          }
          if (qn === null) {
            for (; !Ua.done; ra++, Ua = br.next()) {
              var oc = ve(xe, Ua.value, Ve);
              oc !== null && (_a = O(oc, _a, ra), wr === null ? Jn = oc : wr.sibling = oc, wr = oc);
            }
            if (Qi()) {
              var Pv = ra;
              tp(xe, Pv);
            }
            return Jn;
          }
          for (var sg = m(xe, qn); !Ua.done; ra++, Ua = br.next()) {
            var rl = Se(sg, xe, ra, Ua.value, Ve);
            rl !== null && (a && rl.alternate !== null && sg.delete(rl.key === null ? ra : rl.key), _a = O(rl, _a, ra), wr === null ? Jn = rl : wr.sibling = rl, wr = rl);
          }
          if (a && sg.forEach(function(gee) {
            return o(xe, gee);
          }), Qi()) {
            var yee = ra;
            tp(xe, yee);
          }
          return Jn;
        }
        function Ct(xe, Me, be, Ve) {
          if (Me !== null && Me.tag === E) {
            d(xe, Me.sibling);
            var ot = b(Me, be);
            return ot.return = xe, ot;
          }
          d(xe, Me);
          var rt = wA(be, xe.mode, Ve);
          return rt.return = xe, rt;
        }
        function bt(xe, Me, be, Ve) {
          for (var ot = be.key, rt = Me; rt !== null; ) {
            if (rt.key === ot) {
              var Pt = be.type;
              if (Pt === Gn) {
                if (rt.tag === C) {
                  d(xe, rt.sibling);
                  var Lt = b(rt, be.props.children);
                  return Lt.return = xe, Lt._debugSource = be._source, Lt._debugOwner = be._owner, Lt;
                }
              } else if (rt.elementType === Pt || // Keep this check inline so it only runs on the false path:
              u8(rt, be) || // Lazy types should reconcile their resolved type.
              // We need to do this after the Hot Reloading check above,
              // because hot reloading has different semantics than prod because
              // it doesn't resuspend. So we can't let the call below suspend.
              typeof Pt == "object" && Pt !== null && Pt.$$typeof === It && t4(Pt) === rt.type) {
                d(xe, rt.sibling);
                var Lr = b(rt, be.props);
                return Lr.ref = ky(xe, rt, be), Lr.return = xe, Lr._debugSource = be._source, Lr._debugOwner = be._owner, Lr;
              }
              d(xe, rt);
              break;
            } else
              o(xe, rt);
            rt = rt.sibling;
          }
          if (be.type === Gn) {
            var br = Of(be.props.children, xe.mode, Ve, be.key);
            return br.return = xe, br;
          } else {
            var Jn = bA(be, xe.mode, Ve);
            return Jn.ref = ky(xe, Me, be), Jn.return = xe, Jn;
          }
        }
        function ar(xe, Me, be, Ve) {
          for (var ot = be.key, rt = Me; rt !== null; ) {
            if (rt.key === ot)
              if (rt.tag === x && rt.stateNode.containerInfo === be.containerInfo && rt.stateNode.implementation === be.implementation) {
                d(xe, rt.sibling);
                var Pt = b(rt, be.children || []);
                return Pt.return = xe, Pt;
              } else {
                d(xe, rt);
                break;
              }
            else
              o(xe, rt);
            rt = rt.sibling;
          }
          var Lt = EA(be, xe.mode, Ve);
          return Lt.return = xe, Lt;
        }
        function Zt(xe, Me, be, Ve) {
          var ot = typeof be == "object" && be !== null && be.type === Gn && be.key === null;
          if (ot && (be = be.props.children), typeof be == "object" && be !== null) {
            switch (be.$$typeof) {
              case ni:
                return N(bt(xe, Me, be, Ve));
              case Sr:
                return N(ar(xe, Me, be, Ve));
              case It:
                var rt = be._payload, Pt = be._init;
                return Zt(xe, Me, Pt(rt), Ve);
            }
            if (Wt(be))
              return Pe(xe, Me, be, Ve);
            if (zt(be))
              return tt(xe, Me, be, Ve);
            z1(xe, be);
          }
          return typeof be == "string" && be !== "" || typeof be == "number" ? N(Ct(xe, Me, "" + be, Ve)) : (typeof be == "function" && q1(xe), d(xe, Me));
        }
        return Zt;
      }
      var hv = r4(!0), n4 = r4(!1);
      function YK(a, o) {
        if (a !== null && o.child !== a.child)
          throw new Error("Resuming work not yet implemented.");
        if (o.child !== null) {
          var d = o.child, m = hp(d, d.pendingProps);
          for (o.child = m, m.return = o; d.sibling !== null; )
            d = d.sibling, m = m.sibling = hp(d, d.pendingProps), m.return = o;
          m.sibling = null;
        }
      }
      function GK(a, o) {
        for (var d = a.child; d !== null; )
          jJ(d, o), d = d.sibling;
      }
      var TO = df(null), AO;
      AO = {};
      var U1 = null, vv = null, DO = null, H1 = !1;
      function V1() {
        U1 = null, vv = null, DO = null, H1 = !1;
      }
      function i4() {
        H1 = !0;
      }
      function a4() {
        H1 = !1;
      }
      function o4(a, o, d) {
        Ea(TO, o._currentValue, a), o._currentValue = d, o._currentRenderer !== void 0 && o._currentRenderer !== null && o._currentRenderer !== AO && s("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), o._currentRenderer = AO;
      }
      function kO(a, o) {
        var d = TO.current;
        wa(TO, o), a._currentValue = d;
      }
      function RO(a, o, d) {
        for (var m = a; m !== null; ) {
          var b = m.alternate;
          if (ql(m.childLanes, o) ? b !== null && !ql(b.childLanes, o) && (b.childLanes = qt(b.childLanes, o)) : (m.childLanes = qt(m.childLanes, o), b !== null && (b.childLanes = qt(b.childLanes, o))), m === d)
            break;
          m = m.return;
        }
        m !== d && s("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
      }
      function QK(a, o, d) {
        KK(a, o, d);
      }
      function KK(a, o, d) {
        var m = a.child;
        for (m !== null && (m.return = a); m !== null; ) {
          var b = void 0, O = m.dependencies;
          if (O !== null) {
            b = m.child;
            for (var N = O.firstContext; N !== null; ) {
              if (N.context === o) {
                if (m.tag === h) {
                  var I = Pd(d), L = ec(Qr, I);
                  L.tag = Y1;
                  var G = m.updateQueue;
                  if (G !== null) {
                    var K = G.shared, ve = K.pending;
                    ve === null ? L.next = L : (L.next = ve.next, ve.next = L), K.pending = L;
                  }
                }
                m.lanes = qt(m.lanes, d);
                var pe = m.alternate;
                pe !== null && (pe.lanes = qt(pe.lanes, d)), RO(m.return, d, a), O.lanes = qt(O.lanes, d);
                break;
              }
              N = N.next;
            }
          } else if (m.tag === D)
            b = m.type === a.type ? null : m.child;
          else if (m.tag === H) {
            var Se = m.return;
            if (Se === null)
              throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
            Se.lanes = qt(Se.lanes, d);
            var Oe = Se.alternate;
            Oe !== null && (Oe.lanes = qt(Oe.lanes, d)), RO(Se, d, a), b = m.sibling;
          } else
            b = m.child;
          if (b !== null)
            b.return = m;
          else
            for (b = m; b !== null; ) {
              if (b === a) {
                b = null;
                break;
              }
              var Pe = b.sibling;
              if (Pe !== null) {
                Pe.return = b.return, b = Pe;
                break;
              }
              b = b.return;
            }
          m = b;
        }
      }
      function mv(a, o) {
        U1 = a, vv = null, DO = null;
        var d = a.dependencies;
        if (d !== null) {
          var m = d.firstContext;
          m !== null && (ya(d.lanes, o) && Vy(), d.firstContext = null);
        }
      }
      function ui(a) {
        H1 && s("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var o = a._currentValue;
        if (DO !== a) {
          var d = {
            context: a,
            memoizedValue: o,
            next: null
          };
          if (vv === null) {
            if (U1 === null)
              throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
            vv = d, U1.dependencies = {
              lanes: $e,
              firstContext: d
            };
          } else
            vv = vv.next = d;
        }
        return o;
      }
      var op = null;
      function PO(a) {
        op === null ? op = [a] : op.push(a);
      }
      function XK() {
        if (op !== null) {
          for (var a = 0; a < op.length; a++) {
            var o = op[a], d = o.interleaved;
            if (d !== null) {
              o.interleaved = null;
              var m = d.next, b = o.pending;
              if (b !== null) {
                var O = b.next;
                b.next = m, d.next = O;
              }
              o.pending = d;
            }
          }
          op = null;
        }
      }
      function u4(a, o, d, m) {
        var b = o.interleaved;
        return b === null ? (d.next = d, PO(o)) : (d.next = b.next, b.next = d), o.interleaved = d, W1(a, m);
      }
      function ZK(a, o, d, m) {
        var b = o.interleaved;
        b === null ? (d.next = d, PO(o)) : (d.next = b.next, b.next = d), o.interleaved = d;
      }
      function JK(a, o, d, m) {
        var b = o.interleaved;
        return b === null ? (d.next = d, PO(o)) : (d.next = b.next, b.next = d), o.interleaved = d, W1(a, m);
      }
      function co(a, o) {
        return W1(a, o);
      }
      var eX = W1;
      function W1(a, o) {
        a.lanes = qt(a.lanes, o);
        var d = a.alternate;
        d !== null && (d.lanes = qt(d.lanes, o)), d === null && (a.flags & (Sn | to)) !== Et && n8(a);
        for (var m = a, b = a.return; b !== null; )
          b.childLanes = qt(b.childLanes, o), d = b.alternate, d !== null ? d.childLanes = qt(d.childLanes, o) : (b.flags & (Sn | to)) !== Et && n8(a), m = b, b = b.return;
        if (m.tag === y) {
          var O = m.stateNode;
          return O;
        } else
          return null;
      }
      var s4 = 0, l4 = 1, Y1 = 2, MO = 3, G1 = !1, NO, Q1;
      NO = !1, Q1 = null;
      function jO(a) {
        var o = {
          baseState: a.memoizedState,
          firstBaseUpdate: null,
          lastBaseUpdate: null,
          shared: {
            pending: null,
            interleaved: null,
            lanes: $e
          },
          effects: null
        };
        a.updateQueue = o;
      }
      function c4(a, o) {
        var d = o.updateQueue, m = a.updateQueue;
        if (d === m) {
          var b = {
            baseState: m.baseState,
            firstBaseUpdate: m.firstBaseUpdate,
            lastBaseUpdate: m.lastBaseUpdate,
            shared: m.shared,
            effects: m.effects
          };
          o.updateQueue = b;
        }
      }
      function ec(a, o) {
        var d = {
          eventTime: a,
          lane: o,
          tag: s4,
          payload: null,
          callback: null,
          next: null
        };
        return d;
      }
      function mf(a, o, d) {
        var m = a.updateQueue;
        if (m === null)
          return null;
        var b = m.shared;
        if (Q1 === b && !NO && (s("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), NO = !0), ZZ()) {
          var O = b.pending;
          return O === null ? o.next = o : (o.next = O.next, O.next = o), b.pending = o, eX(a, d);
        } else
          return JK(a, b, o, d);
      }
      function K1(a, o, d) {
        var m = o.updateQueue;
        if (m !== null) {
          var b = m.shared;
          if (Um(d)) {
            var O = b.lanes;
            O = Vm(O, a.pendingLanes);
            var N = qt(O, d);
            b.lanes = N, qh(a, N);
          }
        }
      }
      function FO(a, o) {
        var d = a.updateQueue, m = a.alternate;
        if (m !== null) {
          var b = m.updateQueue;
          if (d === b) {
            var O = null, N = null, I = d.firstBaseUpdate;
            if (I !== null) {
              var L = I;
              do {
                var G = {
                  eventTime: L.eventTime,
                  lane: L.lane,
                  tag: L.tag,
                  payload: L.payload,
                  callback: L.callback,
                  next: null
                };
                N === null ? O = N = G : (N.next = G, N = G), L = L.next;
              } while (L !== null);
              N === null ? O = N = o : (N.next = o, N = o);
            } else
              O = N = o;
            d = {
              baseState: b.baseState,
              firstBaseUpdate: O,
              lastBaseUpdate: N,
              shared: b.shared,
              effects: b.effects
            }, a.updateQueue = d;
            return;
          }
        }
        var K = d.lastBaseUpdate;
        K === null ? d.firstBaseUpdate = o : K.next = o, d.lastBaseUpdate = o;
      }
      function tX(a, o, d, m, b, O) {
        switch (d.tag) {
          case l4: {
            var N = d.payload;
            if (typeof N == "function") {
              i4();
              var I = N.call(O, m, b);
              {
                if (a.mode & Ir) {
                  vn(!0);
                  try {
                    N.call(O, m, b);
                  } finally {
                    vn(!1);
                  }
                }
                a4();
              }
              return I;
            }
            return N;
          }
          case MO:
            a.flags = a.flags & -65537 | wt;
          // Intentional fallthrough
          case s4: {
            var L = d.payload, G;
            if (typeof L == "function") {
              i4(), G = L.call(O, m, b);
              {
                if (a.mode & Ir) {
                  vn(!0);
                  try {
                    L.call(O, m, b);
                  } finally {
                    vn(!1);
                  }
                }
                a4();
              }
            } else
              G = L;
            return G == null ? m : Ht({}, m, G);
          }
          case Y1:
            return G1 = !0, m;
        }
        return m;
      }
      function X1(a, o, d, m) {
        var b = a.updateQueue;
        G1 = !1, Q1 = b.shared;
        var O = b.firstBaseUpdate, N = b.lastBaseUpdate, I = b.shared.pending;
        if (I !== null) {
          b.shared.pending = null;
          var L = I, G = L.next;
          L.next = null, N === null ? O = G : N.next = G, N = L;
          var K = a.alternate;
          if (K !== null) {
            var ve = K.updateQueue, pe = ve.lastBaseUpdate;
            pe !== N && (pe === null ? ve.firstBaseUpdate = G : pe.next = G, ve.lastBaseUpdate = L);
          }
        }
        if (O !== null) {
          var Se = b.baseState, Oe = $e, Pe = null, tt = null, Ct = null, bt = O;
          do {
            var ar = bt.lane, Zt = bt.eventTime;
            if (ql(m, ar)) {
              if (Ct !== null) {
                var Me = {
                  eventTime: Zt,
                  // This update is going to be committed so we never want uncommit
                  // it. Using NoLane works because 0 is a subset of all bitmasks, so
                  // this will never be skipped by the check above.
                  lane: fr,
                  tag: bt.tag,
                  payload: bt.payload,
                  callback: bt.callback,
                  next: null
                };
                Ct = Ct.next = Me;
              }
              Se = tX(a, b, bt, Se, o, d);
              var be = bt.callback;
              if (be !== null && // If the update was already committed, we should not queue its
              // callback again.
              bt.lane !== fr) {
                a.flags |= nn;
                var Ve = b.effects;
                Ve === null ? b.effects = [bt] : Ve.push(bt);
              }
            } else {
              var xe = {
                eventTime: Zt,
                lane: ar,
                tag: bt.tag,
                payload: bt.payload,
                callback: bt.callback,
                next: null
              };
              Ct === null ? (tt = Ct = xe, Pe = Se) : Ct = Ct.next = xe, Oe = qt(Oe, ar);
            }
            if (bt = bt.next, bt === null) {
              if (I = b.shared.pending, I === null)
                break;
              var ot = I, rt = ot.next;
              ot.next = null, bt = rt, b.lastBaseUpdate = ot, b.shared.pending = null;
            }
          } while (!0);
          Ct === null && (Pe = Se), b.baseState = Pe, b.firstBaseUpdate = tt, b.lastBaseUpdate = Ct;
          var Pt = b.shared.interleaved;
          if (Pt !== null) {
            var Lt = Pt;
            do
              Oe = qt(Oe, Lt.lane), Lt = Lt.next;
            while (Lt !== Pt);
          } else O === null && (b.shared.lanes = $e);
          ng(Oe), a.lanes = Oe, a.memoizedState = Se;
        }
        Q1 = null;
      }
      function rX(a, o) {
        if (typeof a != "function")
          throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + a));
        a.call(o);
      }
      function f4() {
        G1 = !1;
      }
      function Z1() {
        return G1;
      }
      function d4(a, o, d) {
        var m = o.effects;
        if (o.effects = null, m !== null)
          for (var b = 0; b < m.length; b++) {
            var O = m[b], N = O.callback;
            N !== null && (O.callback = null, rX(N, d));
          }
      }
      var Ry = {}, yf = df(Ry), Py = df(Ry), J1 = df(Ry);
      function ew(a) {
        if (a === Ry)
          throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return a;
      }
      function p4() {
        var a = ew(J1.current);
        return a;
      }
      function IO(a, o) {
        Ea(J1, o, a), Ea(Py, a, a), Ea(yf, Ry, a);
        var d = xQ(o);
        wa(yf, a), Ea(yf, d, a);
      }
      function yv(a) {
        wa(yf, a), wa(Py, a), wa(J1, a);
      }
      function BO() {
        var a = ew(yf.current);
        return a;
      }
      function h4(a) {
        ew(J1.current);
        var o = ew(yf.current), d = bQ(o, a.type);
        o !== d && (Ea(Py, a, a), Ea(yf, d, a));
      }
      function LO(a) {
        Py.current === a && (wa(yf, a), wa(Py, a));
      }
      var nX = 0, v4 = 1, m4 = 1, My = 2, Qu = df(nX);
      function $O(a, o) {
        return (a & o) !== 0;
      }
      function gv(a) {
        return a & v4;
      }
      function zO(a, o) {
        return a & v4 | o;
      }
      function iX(a, o) {
        return a | o;
      }
      function gf(a, o) {
        Ea(Qu, o, a);
      }
      function xv(a) {
        wa(Qu, a);
      }
      function aX(a, o) {
        var d = a.memoizedState;
        return d !== null ? d.dehydrated !== null : (a.memoizedProps, !0);
      }
      function tw(a) {
        for (var o = a; o !== null; ) {
          if (o.tag === T) {
            var d = o.memoizedState;
            if (d !== null) {
              var m = d.dehydrated;
              if (m === null || MF(m) || aO(m))
                return o;
            }
          } else if (o.tag === q && // revealOrder undefined can't be trusted because it don't
          // keep track of whether it suspended or not.
          o.memoizedProps.revealOrder !== void 0) {
            var b = (o.flags & wt) !== Et;
            if (b)
              return o;
          } else if (o.child !== null) {
            o.child.return = o, o = o.child;
            continue;
          }
          if (o === a)
            return null;
          for (; o.sibling === null; ) {
            if (o.return === null || o.return === a)
              return null;
            o = o.return;
          }
          o.sibling.return = o.return, o = o.sibling;
        }
        return null;
      }
      var fo = (
        /*   */
        0
      ), bi = (
        /* */
        1
      ), Qs = (
        /*  */
        2
      ), wi = (
        /*    */
        4
      ), Ki = (
        /*   */
        8
      ), qO = [];
      function UO() {
        for (var a = 0; a < qO.length; a++) {
          var o = qO[a];
          o._workInProgressVersionPrimary = null;
        }
        qO.length = 0;
      }
      function oX(a, o) {
        var d = o._getVersion, m = d(o._source);
        a.mutableSourceEagerHydrationData == null ? a.mutableSourceEagerHydrationData = [o, m] : a.mutableSourceEagerHydrationData.push(o, m);
      }
      var it = r.ReactCurrentDispatcher, Ny = r.ReactCurrentBatchConfig, HO, bv;
      HO = /* @__PURE__ */ new Set();
      var up = $e, Br = null, Ei = null, Si = null, rw = !1, jy = !1, Fy = 0, uX = 0, sX = 25, Ie = null, mu = null, xf = -1, VO = !1;
      function Or() {
        {
          var a = Ie;
          mu === null ? mu = [a] : mu.push(a);
        }
      }
      function Qe() {
        {
          var a = Ie;
          mu !== null && (xf++, mu[xf] !== a && lX(a));
        }
      }
      function wv(a) {
        a != null && !Wt(a) && s("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", Ie, typeof a);
      }
      function lX(a) {
        {
          var o = Ft(Br);
          if (!HO.has(o) && (HO.add(o), mu !== null)) {
            for (var d = "", m = 30, b = 0; b <= xf; b++) {
              for (var O = mu[b], N = b === xf ? a : O, I = b + 1 + ". " + O; I.length < m; )
                I += " ";
              I += N + `
`, d += I;
            }
            s(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, o, d);
          }
        }
      }
      function Sa() {
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      }
      function WO(a, o) {
        if (VO)
          return !1;
        if (o === null)
          return s("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", Ie), !1;
        a.length !== o.length && s(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, Ie, "[" + o.join(", ") + "]", "[" + a.join(", ") + "]");
        for (var d = 0; d < o.length && d < a.length; d++)
          if (!Ue(a[d], o[d]))
            return !1;
        return !0;
      }
      function Ev(a, o, d, m, b, O) {
        up = O, Br = o, mu = a !== null ? a._debugHookTypes : null, xf = -1, VO = a !== null && a.type !== o.type, o.memoizedState = null, o.updateQueue = null, o.lanes = $e, a !== null && a.memoizedState !== null ? it.current = B4 : mu !== null ? it.current = I4 : it.current = F4;
        var N = d(m, b);
        if (jy) {
          var I = 0;
          do {
            if (jy = !1, Fy = 0, I >= sX)
              throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
            I += 1, VO = !1, Ei = null, Si = null, o.updateQueue = null, xf = -1, it.current = L4, N = d(m, b);
          } while (jy);
        }
        it.current = vw, o._debugHookTypes = mu;
        var L = Ei !== null && Ei.next !== null;
        if (up = $e, Br = null, Ei = null, Si = null, Ie = null, mu = null, xf = -1, a !== null && (a.flags & Fn) !== (o.flags & Fn) && // Disable this warning in legacy mode, because legacy Suspense is weird
        // and creates false positives. To make this work in legacy mode, we'd
        // need to mark fibers that commit in an incomplete state, somehow. For
        // now I'll disable the warning that most of the bugs that would trigger
        // it are either exclusive to concurrent mode or exist in both.
        (a.mode & Gt) !== St && s("Internal React error: Expected static flag was missing. Please notify the React team."), rw = !1, L)
          throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return N;
      }
      function Sv() {
        var a = Fy !== 0;
        return Fy = 0, a;
      }
      function y4(a, o, d) {
        o.updateQueue = a.updateQueue, (o.mode & gr) !== St ? o.flags &= -50333701 : o.flags &= -2053, a.lanes = Md(a.lanes, d);
      }
      function g4() {
        if (it.current = vw, rw) {
          for (var a = Br.memoizedState; a !== null; ) {
            var o = a.queue;
            o !== null && (o.pending = null), a = a.next;
          }
          rw = !1;
        }
        up = $e, Br = null, Ei = null, Si = null, mu = null, xf = -1, Ie = null, R4 = !1, jy = !1, Fy = 0;
      }
      function Ks() {
        var a = {
          memoizedState: null,
          baseState: null,
          baseQueue: null,
          queue: null,
          next: null
        };
        return Si === null ? Br.memoizedState = Si = a : Si = Si.next = a, Si;
      }
      function yu() {
        var a;
        if (Ei === null) {
          var o = Br.alternate;
          o !== null ? a = o.memoizedState : a = null;
        } else
          a = Ei.next;
        var d;
        if (Si === null ? d = Br.memoizedState : d = Si.next, d !== null)
          Si = d, d = Si.next, Ei = a;
        else {
          if (a === null)
            throw new Error("Rendered more hooks than during the previous render.");
          Ei = a;
          var m = {
            memoizedState: Ei.memoizedState,
            baseState: Ei.baseState,
            baseQueue: Ei.baseQueue,
            queue: Ei.queue,
            next: null
          };
          Si === null ? Br.memoizedState = Si = m : Si = Si.next = m;
        }
        return Si;
      }
      function x4() {
        return {
          lastEffect: null,
          stores: null
        };
      }
      function YO(a, o) {
        return typeof o == "function" ? o(a) : o;
      }
      function GO(a, o, d) {
        var m = Ks(), b;
        d !== void 0 ? b = d(o) : b = o, m.memoizedState = m.baseState = b;
        var O = {
          pending: null,
          interleaved: null,
          lanes: $e,
          dispatch: null,
          lastRenderedReducer: a,
          lastRenderedState: b
        };
        m.queue = O;
        var N = O.dispatch = pX.bind(null, Br, O);
        return [m.memoizedState, N];
      }
      function QO(a, o, d) {
        var m = yu(), b = m.queue;
        if (b === null)
          throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        b.lastRenderedReducer = a;
        var O = Ei, N = O.baseQueue, I = b.pending;
        if (I !== null) {
          if (N !== null) {
            var L = N.next, G = I.next;
            N.next = G, I.next = L;
          }
          O.baseQueue !== N && s("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), O.baseQueue = N = I, b.pending = null;
        }
        if (N !== null) {
          var K = N.next, ve = O.baseState, pe = null, Se = null, Oe = null, Pe = K;
          do {
            var tt = Pe.lane;
            if (ql(up, tt)) {
              if (Oe !== null) {
                var bt = {
                  // This update is going to be committed so we never want uncommit
                  // it. Using NoLane works because 0 is a subset of all bitmasks, so
                  // this will never be skipped by the check above.
                  lane: fr,
                  action: Pe.action,
                  hasEagerState: Pe.hasEagerState,
                  eagerState: Pe.eagerState,
                  next: null
                };
                Oe = Oe.next = bt;
              }
              if (Pe.hasEagerState)
                ve = Pe.eagerState;
              else {
                var ar = Pe.action;
                ve = a(ve, ar);
              }
            } else {
              var Ct = {
                lane: tt,
                action: Pe.action,
                hasEagerState: Pe.hasEagerState,
                eagerState: Pe.eagerState,
                next: null
              };
              Oe === null ? (Se = Oe = Ct, pe = ve) : Oe = Oe.next = Ct, Br.lanes = qt(Br.lanes, tt), ng(tt);
            }
            Pe = Pe.next;
          } while (Pe !== null && Pe !== K);
          Oe === null ? pe = ve : Oe.next = Se, Ue(ve, m.memoizedState) || Vy(), m.memoizedState = ve, m.baseState = pe, m.baseQueue = Oe, b.lastRenderedState = ve;
        }
        var Zt = b.interleaved;
        if (Zt !== null) {
          var xe = Zt;
          do {
            var Me = xe.lane;
            Br.lanes = qt(Br.lanes, Me), ng(Me), xe = xe.next;
          } while (xe !== Zt);
        } else N === null && (b.lanes = $e);
        var be = b.dispatch;
        return [m.memoizedState, be];
      }
      function KO(a, o, d) {
        var m = yu(), b = m.queue;
        if (b === null)
          throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        b.lastRenderedReducer = a;
        var O = b.dispatch, N = b.pending, I = m.memoizedState;
        if (N !== null) {
          b.pending = null;
          var L = N.next, G = L;
          do {
            var K = G.action;
            I = a(I, K), G = G.next;
          } while (G !== L);
          Ue(I, m.memoizedState) || Vy(), m.memoizedState = I, m.baseQueue === null && (m.baseState = I), b.lastRenderedState = I;
        }
        return [I, O];
      }
      function HTe(a, o, d) {
      }
      function VTe(a, o, d) {
      }
      function XO(a, o, d) {
        var m = Br, b = Ks(), O, N = Qi();
        if (N) {
          if (d === void 0)
            throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
          O = d(), bv || O !== d() && (s("The result of getServerSnapshot should be cached to avoid an infinite loop"), bv = !0);
        } else {
          if (O = o(), !bv) {
            var I = o();
            Ue(O, I) || (s("The result of getSnapshot should be cached to avoid an infinite loop"), bv = !0);
          }
          var L = Nw();
          if (L === null)
            throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
          $h(L, up) || b4(m, o, O);
        }
        b.memoizedState = O;
        var G = {
          value: O,
          getSnapshot: o
        };
        return b.queue = G, uw(E4.bind(null, m, G, a), [a]), m.flags |= da, Iy(bi | Ki, w4.bind(null, m, G, O, o), void 0, null), O;
      }
      function nw(a, o, d) {
        var m = Br, b = yu(), O = o();
        if (!bv) {
          var N = o();
          Ue(O, N) || (s("The result of getSnapshot should be cached to avoid an infinite loop"), bv = !0);
        }
        var I = b.memoizedState, L = !Ue(I, O);
        L && (b.memoizedState = O, Vy());
        var G = b.queue;
        if (Ly(E4.bind(null, m, G, a), [a]), G.getSnapshot !== o || L || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        Si !== null && Si.memoizedState.tag & bi) {
          m.flags |= da, Iy(bi | Ki, w4.bind(null, m, G, O, o), void 0, null);
          var K = Nw();
          if (K === null)
            throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
          $h(K, up) || b4(m, o, O);
        }
        return O;
      }
      function b4(a, o, d) {
        a.flags |= Qc;
        var m = {
          getSnapshot: o,
          value: d
        }, b = Br.updateQueue;
        if (b === null)
          b = x4(), Br.updateQueue = b, b.stores = [m];
        else {
          var O = b.stores;
          O === null ? b.stores = [m] : O.push(m);
        }
      }
      function w4(a, o, d, m) {
        o.value = d, o.getSnapshot = m, S4(o) && _4(a);
      }
      function E4(a, o, d) {
        var m = function() {
          S4(o) && _4(a);
        };
        return d(m);
      }
      function S4(a) {
        var o = a.getSnapshot, d = a.value;
        try {
          var m = o();
          return !Ue(d, m);
        } catch {
          return !0;
        }
      }
      function _4(a) {
        var o = co(a, Rt);
        o !== null && Ti(o, a, Rt, Qr);
      }
      function iw(a) {
        var o = Ks();
        typeof a == "function" && (a = a()), o.memoizedState = o.baseState = a;
        var d = {
          pending: null,
          interleaved: null,
          lanes: $e,
          dispatch: null,
          lastRenderedReducer: YO,
          lastRenderedState: a
        };
        o.queue = d;
        var m = d.dispatch = hX.bind(null, Br, d);
        return [o.memoizedState, m];
      }
      function ZO(a) {
        return QO(YO);
      }
      function JO(a) {
        return KO(YO);
      }
      function Iy(a, o, d, m) {
        var b = {
          tag: a,
          create: o,
          destroy: d,
          deps: m,
          // Circular
          next: null
        }, O = Br.updateQueue;
        if (O === null)
          O = x4(), Br.updateQueue = O, O.lastEffect = b.next = b;
        else {
          var N = O.lastEffect;
          if (N === null)
            O.lastEffect = b.next = b;
          else {
            var I = N.next;
            N.next = b, b.next = I, O.lastEffect = b;
          }
        }
        return b;
      }
      function eT(a) {
        var o = Ks();
        {
          var d = {
            current: a
          };
          return o.memoizedState = d, d;
        }
      }
      function aw(a) {
        var o = yu();
        return o.memoizedState;
      }
      function By(a, o, d, m) {
        var b = Ks(), O = m === void 0 ? null : m;
        Br.flags |= a, b.memoizedState = Iy(bi | o, d, void 0, O);
      }
      function ow(a, o, d, m) {
        var b = yu(), O = m === void 0 ? null : m, N = void 0;
        if (Ei !== null) {
          var I = Ei.memoizedState;
          if (N = I.destroy, O !== null) {
            var L = I.deps;
            if (WO(O, L)) {
              b.memoizedState = Iy(o, d, N, O);
              return;
            }
          }
        }
        Br.flags |= a, b.memoizedState = Iy(bi | o, d, N, O);
      }
      function uw(a, o) {
        return (Br.mode & gr) !== St ? By(iu | da | ph, Ki, a, o) : By(da | ph, Ki, a, o);
      }
      function Ly(a, o) {
        return ow(da, Ki, a, o);
      }
      function tT(a, o) {
        return By(rr, Qs, a, o);
      }
      function sw(a, o) {
        return ow(rr, Qs, a, o);
      }
      function rT(a, o) {
        var d = rr;
        return d |= Iu, (Br.mode & gr) !== St && (d |= Rs), By(d, wi, a, o);
      }
      function lw(a, o) {
        return ow(rr, wi, a, o);
      }
      function C4(a, o) {
        if (typeof o == "function") {
          var d = o, m = a();
          return d(m), function() {
            d(null);
          };
        } else if (o != null) {
          var b = o;
          b.hasOwnProperty("current") || s("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(b).join(", ") + "}");
          var O = a();
          return b.current = O, function() {
            b.current = null;
          };
        }
      }
      function nT(a, o, d) {
        typeof o != "function" && s("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", o !== null ? typeof o : "null");
        var m = d != null ? d.concat([a]) : null, b = rr;
        return b |= Iu, (Br.mode & gr) !== St && (b |= Rs), By(b, wi, C4.bind(null, o, a), m);
      }
      function cw(a, o, d) {
        typeof o != "function" && s("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", o !== null ? typeof o : "null");
        var m = d != null ? d.concat([a]) : null;
        return ow(rr, wi, C4.bind(null, o, a), m);
      }
      function cX(a, o) {
      }
      var fw = cX;
      function iT(a, o) {
        var d = Ks(), m = o === void 0 ? null : o;
        return d.memoizedState = [a, m], a;
      }
      function dw(a, o) {
        var d = yu(), m = o === void 0 ? null : o, b = d.memoizedState;
        if (b !== null && m !== null) {
          var O = b[1];
          if (WO(m, O))
            return b[0];
        }
        return d.memoizedState = [a, m], a;
      }
      function aT(a, o) {
        var d = Ks(), m = o === void 0 ? null : o, b = a();
        return d.memoizedState = [b, m], b;
      }
      function pw(a, o) {
        var d = yu(), m = o === void 0 ? null : o, b = d.memoizedState;
        if (b !== null && m !== null) {
          var O = b[1];
          if (WO(m, O))
            return b[0];
        }
        var N = a();
        return d.memoizedState = [N, m], N;
      }
      function oT(a) {
        var o = Ks();
        return o.memoizedState = a, a;
      }
      function O4(a) {
        var o = yu(), d = Ei, m = d.memoizedState;
        return A4(o, m, a);
      }
      function T4(a) {
        var o = yu();
        if (Ei === null)
          return o.memoizedState = a, a;
        var d = Ei.memoizedState;
        return A4(o, d, a);
      }
      function A4(a, o, d) {
        var m = !zm(up);
        if (m) {
          if (!Ue(d, o)) {
            var b = Hm();
            Br.lanes = qt(Br.lanes, b), ng(b), a.baseState = !0;
          }
          return o;
        } else
          return a.baseState && (a.baseState = !1, Vy()), a.memoizedState = d, d;
      }
      function fX(a, o, d) {
        var m = uo();
        Ln(Hb(m, su)), a(!0);
        var b = Ny.transition;
        Ny.transition = {};
        var O = Ny.transition;
        Ny.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          a(!1), o();
        } finally {
          if (Ln(m), Ny.transition = b, b === null && O._updatedFibers) {
            var N = O._updatedFibers.size;
            N > 10 && u("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), O._updatedFibers.clear();
          }
        }
      }
      function uT() {
        var a = iw(!1), o = a[0], d = a[1], m = fX.bind(null, d), b = Ks();
        return b.memoizedState = m, [o, m];
      }
      function D4() {
        var a = ZO(), o = a[0], d = yu(), m = d.memoizedState;
        return [o, m];
      }
      function k4() {
        var a = JO(), o = a[0], d = yu(), m = d.memoizedState;
        return [o, m];
      }
      var R4 = !1;
      function dX() {
        return R4;
      }
      function sT() {
        var a = Ks(), o = Nw(), d = o.identifierPrefix, m;
        if (Qi()) {
          var b = DK();
          m = ":" + d + "R" + b;
          var O = Fy++;
          O > 0 && (m += "H" + O.toString(32)), m += ":";
        } else {
          var N = uX++;
          m = ":" + d + "r" + N.toString(32) + ":";
        }
        return a.memoizedState = m, m;
      }
      function hw() {
        var a = yu(), o = a.memoizedState;
        return o;
      }
      function pX(a, o, d) {
        typeof arguments[3] == "function" && s("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var m = _f(a), b = {
          lane: m,
          action: d,
          hasEagerState: !1,
          eagerState: null,
          next: null
        };
        if (P4(a))
          M4(o, b);
        else {
          var O = u4(a, o, b, m);
          if (O !== null) {
            var N = qa();
            Ti(O, a, m, N), N4(O, o, m);
          }
        }
        j4(a, m);
      }
      function hX(a, o, d) {
        typeof arguments[3] == "function" && s("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var m = _f(a), b = {
          lane: m,
          action: d,
          hasEagerState: !1,
          eagerState: null,
          next: null
        };
        if (P4(a))
          M4(o, b);
        else {
          var O = a.alternate;
          if (a.lanes === $e && (O === null || O.lanes === $e)) {
            var N = o.lastRenderedReducer;
            if (N !== null) {
              var I;
              I = it.current, it.current = Ku;
              try {
                var L = o.lastRenderedState, G = N(L, d);
                if (b.hasEagerState = !0, b.eagerState = G, Ue(G, L)) {
                  ZK(a, o, b, m);
                  return;
                }
              } catch {
              } finally {
                it.current = I;
              }
            }
          }
          var K = u4(a, o, b, m);
          if (K !== null) {
            var ve = qa();
            Ti(K, a, m, ve), N4(K, o, m);
          }
        }
        j4(a, m);
      }
      function P4(a) {
        var o = a.alternate;
        return a === Br || o !== null && o === Br;
      }
      function M4(a, o) {
        jy = rw = !0;
        var d = a.pending;
        d === null ? o.next = o : (o.next = d.next, d.next = o), a.pending = o;
      }
      function N4(a, o, d) {
        if (Um(d)) {
          var m = o.lanes;
          m = Vm(m, a.pendingLanes);
          var b = qt(m, d);
          o.lanes = b, qh(a, b);
        }
      }
      function j4(a, o, d) {
        Sd(a, o);
      }
      var vw = {
        readContext: ui,
        useCallback: Sa,
        useContext: Sa,
        useEffect: Sa,
        useImperativeHandle: Sa,
        useInsertionEffect: Sa,
        useLayoutEffect: Sa,
        useMemo: Sa,
        useReducer: Sa,
        useRef: Sa,
        useState: Sa,
        useDebugValue: Sa,
        useDeferredValue: Sa,
        useTransition: Sa,
        useMutableSource: Sa,
        useSyncExternalStore: Sa,
        useId: Sa,
        unstable_isNewReconciler: X
      }, F4 = null, I4 = null, B4 = null, L4 = null, Xs = null, Ku = null, mw = null;
      {
        var lT = function() {
          s("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        }, Bt = function() {
          s("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
        };
        F4 = {
          readContext: function(a) {
            return ui(a);
          },
          useCallback: function(a, o) {
            return Ie = "useCallback", Or(), wv(o), iT(a, o);
          },
          useContext: function(a) {
            return Ie = "useContext", Or(), ui(a);
          },
          useEffect: function(a, o) {
            return Ie = "useEffect", Or(), wv(o), uw(a, o);
          },
          useImperativeHandle: function(a, o, d) {
            return Ie = "useImperativeHandle", Or(), wv(d), nT(a, o, d);
          },
          useInsertionEffect: function(a, o) {
            return Ie = "useInsertionEffect", Or(), wv(o), tT(a, o);
          },
          useLayoutEffect: function(a, o) {
            return Ie = "useLayoutEffect", Or(), wv(o), rT(a, o);
          },
          useMemo: function(a, o) {
            Ie = "useMemo", Or(), wv(o);
            var d = it.current;
            it.current = Xs;
            try {
              return aT(a, o);
            } finally {
              it.current = d;
            }
          },
          useReducer: function(a, o, d) {
            Ie = "useReducer", Or();
            var m = it.current;
            it.current = Xs;
            try {
              return GO(a, o, d);
            } finally {
              it.current = m;
            }
          },
          useRef: function(a) {
            return Ie = "useRef", Or(), eT(a);
          },
          useState: function(a) {
            Ie = "useState", Or();
            var o = it.current;
            it.current = Xs;
            try {
              return iw(a);
            } finally {
              it.current = o;
            }
          },
          useDebugValue: function(a, o) {
            return Ie = "useDebugValue", Or(), void 0;
          },
          useDeferredValue: function(a) {
            return Ie = "useDeferredValue", Or(), oT(a);
          },
          useTransition: function() {
            return Ie = "useTransition", Or(), uT();
          },
          useMutableSource: function(a, o, d) {
            return Ie = "useMutableSource", Or(), void 0;
          },
          useSyncExternalStore: function(a, o, d) {
            return Ie = "useSyncExternalStore", Or(), XO(a, o, d);
          },
          useId: function() {
            return Ie = "useId", Or(), sT();
          },
          unstable_isNewReconciler: X
        }, I4 = {
          readContext: function(a) {
            return ui(a);
          },
          useCallback: function(a, o) {
            return Ie = "useCallback", Qe(), iT(a, o);
          },
          useContext: function(a) {
            return Ie = "useContext", Qe(), ui(a);
          },
          useEffect: function(a, o) {
            return Ie = "useEffect", Qe(), uw(a, o);
          },
          useImperativeHandle: function(a, o, d) {
            return Ie = "useImperativeHandle", Qe(), nT(a, o, d);
          },
          useInsertionEffect: function(a, o) {
            return Ie = "useInsertionEffect", Qe(), tT(a, o);
          },
          useLayoutEffect: function(a, o) {
            return Ie = "useLayoutEffect", Qe(), rT(a, o);
          },
          useMemo: function(a, o) {
            Ie = "useMemo", Qe();
            var d = it.current;
            it.current = Xs;
            try {
              return aT(a, o);
            } finally {
              it.current = d;
            }
          },
          useReducer: function(a, o, d) {
            Ie = "useReducer", Qe();
            var m = it.current;
            it.current = Xs;
            try {
              return GO(a, o, d);
            } finally {
              it.current = m;
            }
          },
          useRef: function(a) {
            return Ie = "useRef", Qe(), eT(a);
          },
          useState: function(a) {
            Ie = "useState", Qe();
            var o = it.current;
            it.current = Xs;
            try {
              return iw(a);
            } finally {
              it.current = o;
            }
          },
          useDebugValue: function(a, o) {
            return Ie = "useDebugValue", Qe(), void 0;
          },
          useDeferredValue: function(a) {
            return Ie = "useDeferredValue", Qe(), oT(a);
          },
          useTransition: function() {
            return Ie = "useTransition", Qe(), uT();
          },
          useMutableSource: function(a, o, d) {
            return Ie = "useMutableSource", Qe(), void 0;
          },
          useSyncExternalStore: function(a, o, d) {
            return Ie = "useSyncExternalStore", Qe(), XO(a, o, d);
          },
          useId: function() {
            return Ie = "useId", Qe(), sT();
          },
          unstable_isNewReconciler: X
        }, B4 = {
          readContext: function(a) {
            return ui(a);
          },
          useCallback: function(a, o) {
            return Ie = "useCallback", Qe(), dw(a, o);
          },
          useContext: function(a) {
            return Ie = "useContext", Qe(), ui(a);
          },
          useEffect: function(a, o) {
            return Ie = "useEffect", Qe(), Ly(a, o);
          },
          useImperativeHandle: function(a, o, d) {
            return Ie = "useImperativeHandle", Qe(), cw(a, o, d);
          },
          useInsertionEffect: function(a, o) {
            return Ie = "useInsertionEffect", Qe(), sw(a, o);
          },
          useLayoutEffect: function(a, o) {
            return Ie = "useLayoutEffect", Qe(), lw(a, o);
          },
          useMemo: function(a, o) {
            Ie = "useMemo", Qe();
            var d = it.current;
            it.current = Ku;
            try {
              return pw(a, o);
            } finally {
              it.current = d;
            }
          },
          useReducer: function(a, o, d) {
            Ie = "useReducer", Qe();
            var m = it.current;
            it.current = Ku;
            try {
              return QO(a, o, d);
            } finally {
              it.current = m;
            }
          },
          useRef: function(a) {
            return Ie = "useRef", Qe(), aw();
          },
          useState: function(a) {
            Ie = "useState", Qe();
            var o = it.current;
            it.current = Ku;
            try {
              return ZO(a);
            } finally {
              it.current = o;
            }
          },
          useDebugValue: function(a, o) {
            return Ie = "useDebugValue", Qe(), fw();
          },
          useDeferredValue: function(a) {
            return Ie = "useDeferredValue", Qe(), O4(a);
          },
          useTransition: function() {
            return Ie = "useTransition", Qe(), D4();
          },
          useMutableSource: function(a, o, d) {
            return Ie = "useMutableSource", Qe(), void 0;
          },
          useSyncExternalStore: function(a, o, d) {
            return Ie = "useSyncExternalStore", Qe(), nw(a, o);
          },
          useId: function() {
            return Ie = "useId", Qe(), hw();
          },
          unstable_isNewReconciler: X
        }, L4 = {
          readContext: function(a) {
            return ui(a);
          },
          useCallback: function(a, o) {
            return Ie = "useCallback", Qe(), dw(a, o);
          },
          useContext: function(a) {
            return Ie = "useContext", Qe(), ui(a);
          },
          useEffect: function(a, o) {
            return Ie = "useEffect", Qe(), Ly(a, o);
          },
          useImperativeHandle: function(a, o, d) {
            return Ie = "useImperativeHandle", Qe(), cw(a, o, d);
          },
          useInsertionEffect: function(a, o) {
            return Ie = "useInsertionEffect", Qe(), sw(a, o);
          },
          useLayoutEffect: function(a, o) {
            return Ie = "useLayoutEffect", Qe(), lw(a, o);
          },
          useMemo: function(a, o) {
            Ie = "useMemo", Qe();
            var d = it.current;
            it.current = mw;
            try {
              return pw(a, o);
            } finally {
              it.current = d;
            }
          },
          useReducer: function(a, o, d) {
            Ie = "useReducer", Qe();
            var m = it.current;
            it.current = mw;
            try {
              return KO(a, o, d);
            } finally {
              it.current = m;
            }
          },
          useRef: function(a) {
            return Ie = "useRef", Qe(), aw();
          },
          useState: function(a) {
            Ie = "useState", Qe();
            var o = it.current;
            it.current = mw;
            try {
              return JO(a);
            } finally {
              it.current = o;
            }
          },
          useDebugValue: function(a, o) {
            return Ie = "useDebugValue", Qe(), fw();
          },
          useDeferredValue: function(a) {
            return Ie = "useDeferredValue", Qe(), T4(a);
          },
          useTransition: function() {
            return Ie = "useTransition", Qe(), k4();
          },
          useMutableSource: function(a, o, d) {
            return Ie = "useMutableSource", Qe(), void 0;
          },
          useSyncExternalStore: function(a, o, d) {
            return Ie = "useSyncExternalStore", Qe(), nw(a, o);
          },
          useId: function() {
            return Ie = "useId", Qe(), hw();
          },
          unstable_isNewReconciler: X
        }, Xs = {
          readContext: function(a) {
            return lT(), ui(a);
          },
          useCallback: function(a, o) {
            return Ie = "useCallback", Bt(), Or(), iT(a, o);
          },
          useContext: function(a) {
            return Ie = "useContext", Bt(), Or(), ui(a);
          },
          useEffect: function(a, o) {
            return Ie = "useEffect", Bt(), Or(), uw(a, o);
          },
          useImperativeHandle: function(a, o, d) {
            return Ie = "useImperativeHandle", Bt(), Or(), nT(a, o, d);
          },
          useInsertionEffect: function(a, o) {
            return Ie = "useInsertionEffect", Bt(), Or(), tT(a, o);
          },
          useLayoutEffect: function(a, o) {
            return Ie = "useLayoutEffect", Bt(), Or(), rT(a, o);
          },
          useMemo: function(a, o) {
            Ie = "useMemo", Bt(), Or();
            var d = it.current;
            it.current = Xs;
            try {
              return aT(a, o);
            } finally {
              it.current = d;
            }
          },
          useReducer: function(a, o, d) {
            Ie = "useReducer", Bt(), Or();
            var m = it.current;
            it.current = Xs;
            try {
              return GO(a, o, d);
            } finally {
              it.current = m;
            }
          },
          useRef: function(a) {
            return Ie = "useRef", Bt(), Or(), eT(a);
          },
          useState: function(a) {
            Ie = "useState", Bt(), Or();
            var o = it.current;
            it.current = Xs;
            try {
              return iw(a);
            } finally {
              it.current = o;
            }
          },
          useDebugValue: function(a, o) {
            return Ie = "useDebugValue", Bt(), Or(), void 0;
          },
          useDeferredValue: function(a) {
            return Ie = "useDeferredValue", Bt(), Or(), oT(a);
          },
          useTransition: function() {
            return Ie = "useTransition", Bt(), Or(), uT();
          },
          useMutableSource: function(a, o, d) {
            return Ie = "useMutableSource", Bt(), Or(), void 0;
          },
          useSyncExternalStore: function(a, o, d) {
            return Ie = "useSyncExternalStore", Bt(), Or(), XO(a, o, d);
          },
          useId: function() {
            return Ie = "useId", Bt(), Or(), sT();
          },
          unstable_isNewReconciler: X
        }, Ku = {
          readContext: function(a) {
            return lT(), ui(a);
          },
          useCallback: function(a, o) {
            return Ie = "useCallback", Bt(), Qe(), dw(a, o);
          },
          useContext: function(a) {
            return Ie = "useContext", Bt(), Qe(), ui(a);
          },
          useEffect: function(a, o) {
            return Ie = "useEffect", Bt(), Qe(), Ly(a, o);
          },
          useImperativeHandle: function(a, o, d) {
            return Ie = "useImperativeHandle", Bt(), Qe(), cw(a, o, d);
          },
          useInsertionEffect: function(a, o) {
            return Ie = "useInsertionEffect", Bt(), Qe(), sw(a, o);
          },
          useLayoutEffect: function(a, o) {
            return Ie = "useLayoutEffect", Bt(), Qe(), lw(a, o);
          },
          useMemo: function(a, o) {
            Ie = "useMemo", Bt(), Qe();
            var d = it.current;
            it.current = Ku;
            try {
              return pw(a, o);
            } finally {
              it.current = d;
            }
          },
          useReducer: function(a, o, d) {
            Ie = "useReducer", Bt(), Qe();
            var m = it.current;
            it.current = Ku;
            try {
              return QO(a, o, d);
            } finally {
              it.current = m;
            }
          },
          useRef: function(a) {
            return Ie = "useRef", Bt(), Qe(), aw();
          },
          useState: function(a) {
            Ie = "useState", Bt(), Qe();
            var o = it.current;
            it.current = Ku;
            try {
              return ZO(a);
            } finally {
              it.current = o;
            }
          },
          useDebugValue: function(a, o) {
            return Ie = "useDebugValue", Bt(), Qe(), fw();
          },
          useDeferredValue: function(a) {
            return Ie = "useDeferredValue", Bt(), Qe(), O4(a);
          },
          useTransition: function() {
            return Ie = "useTransition", Bt(), Qe(), D4();
          },
          useMutableSource: function(a, o, d) {
            return Ie = "useMutableSource", Bt(), Qe(), void 0;
          },
          useSyncExternalStore: function(a, o, d) {
            return Ie = "useSyncExternalStore", Bt(), Qe(), nw(a, o);
          },
          useId: function() {
            return Ie = "useId", Bt(), Qe(), hw();
          },
          unstable_isNewReconciler: X
        }, mw = {
          readContext: function(a) {
            return lT(), ui(a);
          },
          useCallback: function(a, o) {
            return Ie = "useCallback", Bt(), Qe(), dw(a, o);
          },
          useContext: function(a) {
            return Ie = "useContext", Bt(), Qe(), ui(a);
          },
          useEffect: function(a, o) {
            return Ie = "useEffect", Bt(), Qe(), Ly(a, o);
          },
          useImperativeHandle: function(a, o, d) {
            return Ie = "useImperativeHandle", Bt(), Qe(), cw(a, o, d);
          },
          useInsertionEffect: function(a, o) {
            return Ie = "useInsertionEffect", Bt(), Qe(), sw(a, o);
          },
          useLayoutEffect: function(a, o) {
            return Ie = "useLayoutEffect", Bt(), Qe(), lw(a, o);
          },
          useMemo: function(a, o) {
            Ie = "useMemo", Bt(), Qe();
            var d = it.current;
            it.current = Ku;
            try {
              return pw(a, o);
            } finally {
              it.current = d;
            }
          },
          useReducer: function(a, o, d) {
            Ie = "useReducer", Bt(), Qe();
            var m = it.current;
            it.current = Ku;
            try {
              return KO(a, o, d);
            } finally {
              it.current = m;
            }
          },
          useRef: function(a) {
            return Ie = "useRef", Bt(), Qe(), aw();
          },
          useState: function(a) {
            Ie = "useState", Bt(), Qe();
            var o = it.current;
            it.current = Ku;
            try {
              return JO(a);
            } finally {
              it.current = o;
            }
          },
          useDebugValue: function(a, o) {
            return Ie = "useDebugValue", Bt(), Qe(), fw();
          },
          useDeferredValue: function(a) {
            return Ie = "useDeferredValue", Bt(), Qe(), T4(a);
          },
          useTransition: function() {
            return Ie = "useTransition", Bt(), Qe(), k4();
          },
          useMutableSource: function(a, o, d) {
            return Ie = "useMutableSource", Bt(), Qe(), void 0;
          },
          useSyncExternalStore: function(a, o, d) {
            return Ie = "useSyncExternalStore", Bt(), Qe(), nw(a, o);
          },
          useId: function() {
            return Ie = "useId", Bt(), Qe(), hw();
          },
          unstable_isNewReconciler: X
        };
      }
      var bf = t.unstable_now, $4 = 0, yw = -1, $y = -1, gw = -1, cT = !1, xw = !1;
      function z4() {
        return cT;
      }
      function vX() {
        xw = !0;
      }
      function mX() {
        cT = !1, xw = !1;
      }
      function yX() {
        cT = xw, xw = !1;
      }
      function q4() {
        return $4;
      }
      function U4() {
        $4 = bf();
      }
      function fT(a) {
        $y = bf(), a.actualStartTime < 0 && (a.actualStartTime = bf());
      }
      function H4(a) {
        $y = -1;
      }
      function bw(a, o) {
        if ($y >= 0) {
          var d = bf() - $y;
          a.actualDuration += d, o && (a.selfBaseDuration = d), $y = -1;
        }
      }
      function Zs(a) {
        if (yw >= 0) {
          var o = bf() - yw;
          yw = -1;
          for (var d = a.return; d !== null; ) {
            switch (d.tag) {
              case y:
                var m = d.stateNode;
                m.effectDuration += o;
                return;
              case R:
                var b = d.stateNode;
                b.effectDuration += o;
                return;
            }
            d = d.return;
          }
        }
      }
      function dT(a) {
        if (gw >= 0) {
          var o = bf() - gw;
          gw = -1;
          for (var d = a.return; d !== null; ) {
            switch (d.tag) {
              case y:
                var m = d.stateNode;
                m !== null && (m.passiveEffectDuration += o);
                return;
              case R:
                var b = d.stateNode;
                b !== null && (b.passiveEffectDuration += o);
                return;
            }
            d = d.return;
          }
        }
      }
      function Js() {
        yw = bf();
      }
      function pT() {
        gw = bf();
      }
      function hT(a) {
        for (var o = a.child; o; )
          a.actualDuration += o.actualDuration, o = o.sibling;
      }
      function Xu(a, o) {
        if (a && a.defaultProps) {
          var d = Ht({}, o), m = a.defaultProps;
          for (var b in m)
            d[b] === void 0 && (d[b] = m[b]);
          return d;
        }
        return o;
      }
      var vT = {}, mT, yT, gT, xT, bT, V4, ww, wT, ET, ST, zy;
      {
        mT = /* @__PURE__ */ new Set(), yT = /* @__PURE__ */ new Set(), gT = /* @__PURE__ */ new Set(), xT = /* @__PURE__ */ new Set(), wT = /* @__PURE__ */ new Set(), bT = /* @__PURE__ */ new Set(), ET = /* @__PURE__ */ new Set(), ST = /* @__PURE__ */ new Set(), zy = /* @__PURE__ */ new Set();
        var W4 = /* @__PURE__ */ new Set();
        ww = function(a, o) {
          if (!(a === null || typeof a == "function")) {
            var d = o + "_" + a;
            W4.has(d) || (W4.add(d), s("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", o, a));
          }
        }, V4 = function(a, o) {
          if (o === void 0) {
            var d = or(a) || "Component";
            bT.has(d) || (bT.add(d), s("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", d));
          }
        }, Object.defineProperty(vT, "_processChildContext", {
          enumerable: !1,
          value: function() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
          }
        }), Object.freeze(vT);
      }
      function _T(a, o, d, m) {
        var b = a.memoizedState, O = d(m, b);
        {
          if (a.mode & Ir) {
            vn(!0);
            try {
              O = d(m, b);
            } finally {
              vn(!1);
            }
          }
          V4(o, O);
        }
        var N = O == null ? b : Ht({}, b, O);
        if (a.memoizedState = N, a.lanes === $e) {
          var I = a.updateQueue;
          I.baseState = N;
        }
      }
      var CT = {
        isMounted: Ab,
        enqueueSetState: function(a, o, d) {
          var m = Gc(a), b = qa(), O = _f(m), N = ec(b, O);
          N.payload = o, d != null && (ww(d, "setState"), N.callback = d);
          var I = mf(m, N, O);
          I !== null && (Ti(I, m, O, b), K1(I, m, O)), Sd(m, O);
        },
        enqueueReplaceState: function(a, o, d) {
          var m = Gc(a), b = qa(), O = _f(m), N = ec(b, O);
          N.tag = l4, N.payload = o, d != null && (ww(d, "replaceState"), N.callback = d);
          var I = mf(m, N, O);
          I !== null && (Ti(I, m, O, b), K1(I, m, O)), Sd(m, O);
        },
        enqueueForceUpdate: function(a, o) {
          var d = Gc(a), m = qa(), b = _f(d), O = ec(m, b);
          O.tag = Y1, o != null && (ww(o, "forceUpdate"), O.callback = o);
          var N = mf(d, O, b);
          N !== null && (Ti(N, d, b, m), K1(N, d, b)), bh(d, b);
        }
      };
      function Y4(a, o, d, m, b, O, N) {
        var I = a.stateNode;
        if (typeof I.shouldComponentUpdate == "function") {
          var L = I.shouldComponentUpdate(m, O, N);
          {
            if (a.mode & Ir) {
              vn(!0);
              try {
                L = I.shouldComponentUpdate(m, O, N);
              } finally {
                vn(!1);
              }
            }
            L === void 0 && s("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", or(o) || "Component");
          }
          return L;
        }
        return o.prototype && o.prototype.isPureReactComponent ? !pt(d, m) || !pt(b, O) : !0;
      }
      function gX(a, o, d) {
        var m = a.stateNode;
        {
          var b = or(o) || "Component", O = m.render;
          O || (o.prototype && typeof o.prototype.render == "function" ? s("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", b) : s("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", b)), m.getInitialState && !m.getInitialState.isReactClassApproved && !m.state && s("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", b), m.getDefaultProps && !m.getDefaultProps.isReactClassApproved && s("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", b), m.propTypes && s("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", b), m.contextType && s("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", b), o.childContextTypes && !zy.has(o) && // Strict Mode has its own warning for legacy context, so we can skip
          // this one.
          (a.mode & Ir) === St && (zy.add(o), s(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, b)), o.contextTypes && !zy.has(o) && // Strict Mode has its own warning for legacy context, so we can skip
          // this one.
          (a.mode & Ir) === St && (zy.add(o), s(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, b)), m.contextTypes && s("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", b), o.contextType && o.contextTypes && !ET.has(o) && (ET.add(o), s("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", b)), typeof m.componentShouldUpdate == "function" && s("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", b), o.prototype && o.prototype.isPureReactComponent && typeof m.shouldComponentUpdate < "u" && s("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", or(o) || "A pure component"), typeof m.componentDidUnmount == "function" && s("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", b), typeof m.componentDidReceiveProps == "function" && s("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", b), typeof m.componentWillRecieveProps == "function" && s("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", b), typeof m.UNSAFE_componentWillRecieveProps == "function" && s("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", b);
          var N = m.props !== d;
          m.props !== void 0 && N && s("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", b, b), m.defaultProps && s("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", b, b), typeof m.getSnapshotBeforeUpdate == "function" && typeof m.componentDidUpdate != "function" && !gT.has(o) && (gT.add(o), s("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", or(o))), typeof m.getDerivedStateFromProps == "function" && s("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", b), typeof m.getDerivedStateFromError == "function" && s("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", b), typeof o.getSnapshotBeforeUpdate == "function" && s("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", b);
          var I = m.state;
          I && (typeof I != "object" || Wt(I)) && s("%s.state: must be set to an object or null", b), typeof m.getChildContext == "function" && typeof o.childContextTypes != "object" && s("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", b);
        }
      }
      function G4(a, o) {
        o.updater = CT, a.stateNode = o, Al(o, a), o._reactInternalInstance = vT;
      }
      function Q4(a, o, d) {
        var m = !1, b = jo, O = jo, N = o.contextType;
        if ("contextType" in o) {
          var I = (
            // Allow null for conditional declaration
            N === null || N !== void 0 && N.$$typeof === ue && N._context === void 0
          );
          if (!I && !ST.has(o)) {
            ST.add(o);
            var L = "";
            N === void 0 ? L = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof N != "object" ? L = " However, it is set to a " + typeof N + "." : N.$$typeof === Qo ? L = " Did you accidentally pass the Context.Provider instead?" : N._context !== void 0 ? L = " Did you accidentally pass the Context.Consumer instead?" : L = " However, it is set to an object with keys {" + Object.keys(N).join(", ") + "}.", s("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", or(o) || "Component", L);
          }
        }
        if (typeof N == "object" && N !== null)
          O = ui(N);
        else {
          b = lv(a, o, !0);
          var G = o.contextTypes;
          m = G != null, O = m ? cv(a, b) : jo;
        }
        var K = new o(d, O);
        if (a.mode & Ir) {
          vn(!0);
          try {
            K = new o(d, O);
          } finally {
            vn(!1);
          }
        }
        var ve = a.memoizedState = K.state !== null && K.state !== void 0 ? K.state : null;
        G4(a, K);
        {
          if (typeof o.getDerivedStateFromProps == "function" && ve === null) {
            var pe = or(o) || "Component";
            yT.has(pe) || (yT.add(pe), s("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", pe, K.state === null ? "null" : "undefined", pe));
          }
          if (typeof o.getDerivedStateFromProps == "function" || typeof K.getSnapshotBeforeUpdate == "function") {
            var Se = null, Oe = null, Pe = null;
            if (typeof K.componentWillMount == "function" && K.componentWillMount.__suppressDeprecationWarning !== !0 ? Se = "componentWillMount" : typeof K.UNSAFE_componentWillMount == "function" && (Se = "UNSAFE_componentWillMount"), typeof K.componentWillReceiveProps == "function" && K.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Oe = "componentWillReceiveProps" : typeof K.UNSAFE_componentWillReceiveProps == "function" && (Oe = "UNSAFE_componentWillReceiveProps"), typeof K.componentWillUpdate == "function" && K.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Pe = "componentWillUpdate" : typeof K.UNSAFE_componentWillUpdate == "function" && (Pe = "UNSAFE_componentWillUpdate"), Se !== null || Oe !== null || Pe !== null) {
              var tt = or(o) || "Component", Ct = typeof o.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
              xT.has(tt) || (xT.add(tt), s(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, tt, Ct, Se !== null ? `
  ` + Se : "", Oe !== null ? `
  ` + Oe : "", Pe !== null ? `
  ` + Pe : ""));
            }
          }
        }
        return m && BF(a, b, O), K;
      }
      function xX(a, o) {
        var d = o.state;
        typeof o.componentWillMount == "function" && o.componentWillMount(), typeof o.UNSAFE_componentWillMount == "function" && o.UNSAFE_componentWillMount(), d !== o.state && (s("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Ft(a) || "Component"), CT.enqueueReplaceState(o, o.state, null));
      }
      function K4(a, o, d, m) {
        var b = o.state;
        if (typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps(d, m), typeof o.UNSAFE_componentWillReceiveProps == "function" && o.UNSAFE_componentWillReceiveProps(d, m), o.state !== b) {
          {
            var O = Ft(a) || "Component";
            mT.has(O) || (mT.add(O), s("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", O));
          }
          CT.enqueueReplaceState(o, o.state, null);
        }
      }
      function OT(a, o, d, m) {
        gX(a, o, d);
        var b = a.stateNode;
        b.props = d, b.state = a.memoizedState, b.refs = {}, jO(a);
        var O = o.contextType;
        if (typeof O == "object" && O !== null)
          b.context = ui(O);
        else {
          var N = lv(a, o, !0);
          b.context = cv(a, N);
        }
        {
          if (b.state === d) {
            var I = or(o) || "Component";
            wT.has(I) || (wT.add(I), s("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", I));
          }
          a.mode & Ir && Gu.recordLegacyContextWarning(a, b), Gu.recordUnsafeLifecycleWarnings(a, b);
        }
        b.state = a.memoizedState;
        var L = o.getDerivedStateFromProps;
        if (typeof L == "function" && (_T(a, o, L, d), b.state = a.memoizedState), typeof o.getDerivedStateFromProps != "function" && typeof b.getSnapshotBeforeUpdate != "function" && (typeof b.UNSAFE_componentWillMount == "function" || typeof b.componentWillMount == "function") && (xX(a, b), X1(a, d, b, m), b.state = a.memoizedState), typeof b.componentDidMount == "function") {
          var G = rr;
          G |= Iu, (a.mode & gr) !== St && (G |= Rs), a.flags |= G;
        }
      }
      function bX(a, o, d, m) {
        var b = a.stateNode, O = a.memoizedProps;
        b.props = O;
        var N = b.context, I = o.contextType, L = jo;
        if (typeof I == "object" && I !== null)
          L = ui(I);
        else {
          var G = lv(a, o, !0);
          L = cv(a, G);
        }
        var K = o.getDerivedStateFromProps, ve = typeof K == "function" || typeof b.getSnapshotBeforeUpdate == "function";
        !ve && (typeof b.UNSAFE_componentWillReceiveProps == "function" || typeof b.componentWillReceiveProps == "function") && (O !== d || N !== L) && K4(a, b, d, L), f4();
        var pe = a.memoizedState, Se = b.state = pe;
        if (X1(a, d, b, m), Se = a.memoizedState, O === d && pe === Se && !P1() && !Z1()) {
          if (typeof b.componentDidMount == "function") {
            var Oe = rr;
            Oe |= Iu, (a.mode & gr) !== St && (Oe |= Rs), a.flags |= Oe;
          }
          return !1;
        }
        typeof K == "function" && (_T(a, o, K, d), Se = a.memoizedState);
        var Pe = Z1() || Y4(a, o, O, d, pe, Se, L);
        if (Pe) {
          if (!ve && (typeof b.UNSAFE_componentWillMount == "function" || typeof b.componentWillMount == "function") && (typeof b.componentWillMount == "function" && b.componentWillMount(), typeof b.UNSAFE_componentWillMount == "function" && b.UNSAFE_componentWillMount()), typeof b.componentDidMount == "function") {
            var tt = rr;
            tt |= Iu, (a.mode & gr) !== St && (tt |= Rs), a.flags |= tt;
          }
        } else {
          if (typeof b.componentDidMount == "function") {
            var Ct = rr;
            Ct |= Iu, (a.mode & gr) !== St && (Ct |= Rs), a.flags |= Ct;
          }
          a.memoizedProps = d, a.memoizedState = Se;
        }
        return b.props = d, b.state = Se, b.context = L, Pe;
      }
      function wX(a, o, d, m, b) {
        var O = o.stateNode;
        c4(a, o);
        var N = o.memoizedProps, I = o.type === o.elementType ? N : Xu(o.type, N);
        O.props = I;
        var L = o.pendingProps, G = O.context, K = d.contextType, ve = jo;
        if (typeof K == "object" && K !== null)
          ve = ui(K);
        else {
          var pe = lv(o, d, !0);
          ve = cv(o, pe);
        }
        var Se = d.getDerivedStateFromProps, Oe = typeof Se == "function" || typeof O.getSnapshotBeforeUpdate == "function";
        !Oe && (typeof O.UNSAFE_componentWillReceiveProps == "function" || typeof O.componentWillReceiveProps == "function") && (N !== L || G !== ve) && K4(o, O, m, ve), f4();
        var Pe = o.memoizedState, tt = O.state = Pe;
        if (X1(o, m, O, b), tt = o.memoizedState, N === L && Pe === tt && !P1() && !Z1())
          return typeof O.componentDidUpdate == "function" && (N !== a.memoizedProps || Pe !== a.memoizedState) && (o.flags |= rr), typeof O.getSnapshotBeforeUpdate == "function" && (N !== a.memoizedProps || Pe !== a.memoizedState) && (o.flags |= Kn), !1;
        typeof Se == "function" && (_T(o, d, Se, m), tt = o.memoizedState);
        var Ct = Z1() || Y4(o, d, I, m, Pe, tt, ve) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        fe;
        return Ct ? (!Oe && (typeof O.UNSAFE_componentWillUpdate == "function" || typeof O.componentWillUpdate == "function") && (typeof O.componentWillUpdate == "function" && O.componentWillUpdate(m, tt, ve), typeof O.UNSAFE_componentWillUpdate == "function" && O.UNSAFE_componentWillUpdate(m, tt, ve)), typeof O.componentDidUpdate == "function" && (o.flags |= rr), typeof O.getSnapshotBeforeUpdate == "function" && (o.flags |= Kn)) : (typeof O.componentDidUpdate == "function" && (N !== a.memoizedProps || Pe !== a.memoizedState) && (o.flags |= rr), typeof O.getSnapshotBeforeUpdate == "function" && (N !== a.memoizedProps || Pe !== a.memoizedState) && (o.flags |= Kn), o.memoizedProps = m, o.memoizedState = tt), O.props = m, O.state = tt, O.context = ve, Ct;
      }
      function sp(a, o) {
        return {
          value: a,
          source: o,
          stack: Ru(o),
          digest: null
        };
      }
      function TT(a, o, d) {
        return {
          value: a,
          source: null,
          stack: d ?? null,
          digest: o ?? null
        };
      }
      function EX(a, o) {
        return !0;
      }
      function AT(a, o) {
        try {
          var d = EX(a, o);
          if (d === !1)
            return;
          var m = o.value, b = o.source, O = o.stack, N = O !== null ? O : "";
          if (m != null && m._suppressLogging) {
            if (a.tag === h)
              return;
            console.error(m);
          }
          var I = b ? Ft(b) : null, L = I ? "The above error occurred in the <" + I + "> component:" : "The above error occurred in one of your React components:", G;
          if (a.tag === y)
            G = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
          else {
            var K = Ft(a) || "Anonymous";
            G = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + K + ".");
          }
          var ve = L + `
` + N + `

` + ("" + G);
          console.error(ve);
        } catch (pe) {
          setTimeout(function() {
            throw pe;
          });
        }
      }
      var SX = typeof WeakMap == "function" ? WeakMap : Map;
      function X4(a, o, d) {
        var m = ec(Qr, d);
        m.tag = MO, m.payload = {
          element: null
        };
        var b = o.value;
        return m.callback = function() {
          vJ(b), AT(a, o);
        }, m;
      }
      function DT(a, o, d) {
        var m = ec(Qr, d);
        m.tag = MO;
        var b = a.type.getDerivedStateFromError;
        if (typeof b == "function") {
          var O = o.value;
          m.payload = function() {
            return b(O);
          }, m.callback = function() {
            s8(a), AT(a, o);
          };
        }
        var N = a.stateNode;
        return N !== null && typeof N.componentDidCatch == "function" && (m.callback = function() {
          s8(a), AT(a, o), typeof b != "function" && pJ(this);
          var L = o.value, G = o.stack;
          this.componentDidCatch(L, {
            componentStack: G !== null ? G : ""
          }), typeof b != "function" && (ya(a.lanes, Rt) || s("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", Ft(a) || "Unknown"));
        }), m;
      }
      function Z4(a, o, d) {
        var m = a.pingCache, b;
        if (m === null ? (m = a.pingCache = new SX(), b = /* @__PURE__ */ new Set(), m.set(o, b)) : (b = m.get(o), b === void 0 && (b = /* @__PURE__ */ new Set(), m.set(o, b))), !b.has(d)) {
          b.add(d);
          var O = mJ.bind(null, a, o, d);
          ma && ig(a, d), o.then(O, O);
        }
      }
      function _X(a, o, d, m) {
        var b = a.updateQueue;
        if (b === null) {
          var O = /* @__PURE__ */ new Set();
          O.add(d), a.updateQueue = O;
        } else
          b.add(d);
      }
      function CX(a, o) {
        var d = a.tag;
        if ((a.mode & Gt) === St && (d === p || d === A || d === F)) {
          var m = a.alternate;
          m ? (a.updateQueue = m.updateQueue, a.memoizedState = m.memoizedState, a.lanes = m.lanes) : (a.updateQueue = null, a.memoizedState = null);
        }
      }
      function J4(a) {
        var o = a;
        do {
          if (o.tag === T && aX(o))
            return o;
          o = o.return;
        } while (o !== null);
        return null;
      }
      function eI(a, o, d, m, b) {
        if ((a.mode & Gt) === St) {
          if (a === o)
            a.flags |= pa;
          else {
            if (a.flags |= wt, d.flags |= dh, d.flags &= -52805, d.tag === h) {
              var O = d.alternate;
              if (O === null)
                d.tag = V;
              else {
                var N = ec(Qr, Rt);
                N.tag = Y1, mf(d, N, Rt);
              }
            }
            d.lanes = qt(d.lanes, Rt);
          }
          return a;
        }
        return a.flags |= pa, a.lanes = b, a;
      }
      function OX(a, o, d, m, b) {
        if (d.flags |= yd, ma && ig(a, b), m !== null && typeof m == "object" && typeof m.then == "function") {
          var O = m;
          CX(d), Qi() && d.mode & Gt && VF();
          var N = J4(o);
          if (N !== null) {
            N.flags &= -257, eI(N, o, d, a, b), N.mode & Gt && Z4(a, O, b), _X(N, a, O);
            return;
          } else {
            if (!Fb(b)) {
              Z4(a, O, b), sA();
              return;
            }
            var I = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
            m = I;
          }
        } else if (Qi() && d.mode & Gt) {
          VF();
          var L = J4(o);
          if (L !== null) {
            (L.flags & pa) === Et && (L.flags |= fa), eI(L, o, d, a, b), wO(sp(m, d));
            return;
          }
        }
        m = sp(m, d), aJ(m);
        var G = o;
        do {
          switch (G.tag) {
            case y: {
              var K = m;
              G.flags |= pa;
              var ve = Pd(b);
              G.lanes = qt(G.lanes, ve);
              var pe = X4(G, K, ve);
              FO(G, pe);
              return;
            }
            case h:
              var Se = m, Oe = G.type, Pe = G.stateNode;
              if ((G.flags & wt) === Et && (typeof Oe.getDerivedStateFromError == "function" || Pe !== null && typeof Pe.componentDidCatch == "function" && !JI(Pe))) {
                G.flags |= pa;
                var tt = Pd(b);
                G.lanes = qt(G.lanes, tt);
                var Ct = DT(G, Se, tt);
                FO(G, Ct);
                return;
              }
              break;
          }
          G = G.return;
        } while (G !== null);
      }
      function TX() {
        return null;
      }
      var qy = r.ReactCurrentOwner, Zu = !1, kT, Uy, RT, PT, MT, lp, NT, Ew, Hy;
      kT = {}, Uy = {}, RT = {}, PT = {}, MT = {}, lp = !1, NT = {}, Ew = {}, Hy = {};
      function $a(a, o, d, m) {
        a === null ? o.child = n4(o, null, d, m) : o.child = hv(o, a.child, d, m);
      }
      function AX(a, o, d, m) {
        o.child = hv(o, a.child, null, m), o.child = hv(o, null, d, m);
      }
      function tI(a, o, d, m, b) {
        if (o.type !== o.elementType) {
          var O = d.propTypes;
          O && Wu(
            O,
            m,
            // Resolved props
            "prop",
            or(d)
          );
        }
        var N = d.render, I = o.ref, L, G;
        mv(o, b), ja(o);
        {
          if (qy.current = o, Qn(!0), L = Ev(a, o, N, m, I, b), G = Sv(), o.mode & Ir) {
            vn(!0);
            try {
              L = Ev(a, o, N, m, I, b), G = Sv();
            } finally {
              vn(!1);
            }
          }
          Qn(!1);
        }
        return Fa(), a !== null && !Zu ? (y4(a, o, b), tc(a, o, b)) : (Qi() && G && vO(o), o.flags |= Do, $a(a, o, L, b), o.child);
      }
      function rI(a, o, d, m, b) {
        if (a === null) {
          var O = d.type;
          if (MJ(O) && d.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
          d.defaultProps === void 0) {
            var N = O;
            return N = Rv(O), o.tag = F, o.type = N, IT(o, O), nI(a, o, N, m, b);
          }
          {
            var I = O.propTypes;
            if (I && Wu(
              I,
              m,
              // Resolved props
              "prop",
              or(O)
            ), d.defaultProps !== void 0) {
              var L = or(O) || "Unknown";
              Hy[L] || (s("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", L), Hy[L] = !0);
            }
          }
          var G = xA(d.type, null, m, o, o.mode, b);
          return G.ref = o.ref, G.return = o, o.child = G, G;
        }
        {
          var K = d.type, ve = K.propTypes;
          ve && Wu(
            ve,
            m,
            // Resolved props
            "prop",
            or(K)
          );
        }
        var pe = a.child, Se = UT(a, b);
        if (!Se) {
          var Oe = pe.memoizedProps, Pe = d.compare;
          if (Pe = Pe !== null ? Pe : pt, Pe(Oe, m) && a.ref === o.ref)
            return tc(a, o, b);
        }
        o.flags |= Do;
        var tt = hp(pe, m);
        return tt.ref = o.ref, tt.return = o, o.child = tt, tt;
      }
      function nI(a, o, d, m, b) {
        if (o.type !== o.elementType) {
          var O = o.elementType;
          if (O.$$typeof === It) {
            var N = O, I = N._payload, L = N._init;
            try {
              O = L(I);
            } catch {
              O = null;
            }
            var G = O && O.propTypes;
            G && Wu(
              G,
              m,
              // Resolved (SimpleMemoComponent has no defaultProps)
              "prop",
              or(O)
            );
          }
        }
        if (a !== null) {
          var K = a.memoizedProps;
          if (pt(K, m) && a.ref === o.ref && // Prevent bailout if the implementation changed due to hot reload.
          o.type === a.type)
            if (Zu = !1, o.pendingProps = m = K, UT(a, b))
              (a.flags & dh) !== Et && (Zu = !0);
            else return o.lanes = a.lanes, tc(a, o, b);
        }
        return jT(a, o, d, m, b);
      }
      function iI(a, o, d) {
        var m = o.pendingProps, b = m.children, O = a !== null ? a.memoizedState : null;
        if (m.mode === "hidden" || Z)
          if ((o.mode & Gt) === St) {
            var N = {
              baseLanes: $e,
              cachePool: null,
              transitions: null
            };
            o.memoizedState = N, jw(o, d);
          } else if (ya(d, Ia)) {
            var ve = {
              baseLanes: $e,
              cachePool: null,
              transitions: null
            };
            o.memoizedState = ve;
            var pe = O !== null ? O.baseLanes : d;
            jw(o, pe);
          } else {
            var I = null, L;
            if (O !== null) {
              var G = O.baseLanes;
              L = qt(G, d);
            } else
              L = d;
            o.lanes = o.childLanes = Ia;
            var K = {
              baseLanes: L,
              cachePool: I,
              transitions: null
            };
            return o.memoizedState = K, o.updateQueue = null, jw(o, L), null;
          }
        else {
          var Se;
          O !== null ? (Se = qt(O.baseLanes, d), o.memoizedState = null) : Se = d, jw(o, Se);
        }
        return $a(a, o, b, d), o.child;
      }
      function DX(a, o, d) {
        var m = o.pendingProps;
        return $a(a, o, m, d), o.child;
      }
      function kX(a, o, d) {
        var m = o.pendingProps.children;
        return $a(a, o, m, d), o.child;
      }
      function RX(a, o, d) {
        {
          o.flags |= rr;
          {
            var m = o.stateNode;
            m.effectDuration = 0, m.passiveEffectDuration = 0;
          }
        }
        var b = o.pendingProps, O = b.children;
        return $a(a, o, O, d), o.child;
      }
      function aI(a, o) {
        var d = o.ref;
        (a === null && d !== null || a !== null && a.ref !== d) && (o.flags |= bn, o.flags |= Kc);
      }
      function jT(a, o, d, m, b) {
        if (o.type !== o.elementType) {
          var O = d.propTypes;
          O && Wu(
            O,
            m,
            // Resolved props
            "prop",
            or(d)
          );
        }
        var N;
        {
          var I = lv(o, d, !0);
          N = cv(o, I);
        }
        var L, G;
        mv(o, b), ja(o);
        {
          if (qy.current = o, Qn(!0), L = Ev(a, o, d, m, N, b), G = Sv(), o.mode & Ir) {
            vn(!0);
            try {
              L = Ev(a, o, d, m, N, b), G = Sv();
            } finally {
              vn(!1);
            }
          }
          Qn(!1);
        }
        return Fa(), a !== null && !Zu ? (y4(a, o, b), tc(a, o, b)) : (Qi() && G && vO(o), o.flags |= Do, $a(a, o, L, b), o.child);
      }
      function oI(a, o, d, m, b) {
        {
          switch (GJ(o)) {
            case !1: {
              var O = o.stateNode, N = o.type, I = new N(o.memoizedProps, O.context), L = I.state;
              O.updater.enqueueSetState(O, L, null);
              break;
            }
            case !0: {
              o.flags |= wt, o.flags |= pa;
              var G = new Error("Simulated error coming from DevTools"), K = Pd(b);
              o.lanes = qt(o.lanes, K);
              var ve = DT(o, sp(G, o), K);
              FO(o, ve);
              break;
            }
          }
          if (o.type !== o.elementType) {
            var pe = d.propTypes;
            pe && Wu(
              pe,
              m,
              // Resolved props
              "prop",
              or(d)
            );
          }
        }
        var Se;
        Gs(d) ? (Se = !0, N1(o)) : Se = !1, mv(o, b);
        var Oe = o.stateNode, Pe;
        Oe === null ? (_w(a, o), Q4(o, d, m), OT(o, d, m, b), Pe = !0) : a === null ? Pe = bX(o, d, m, b) : Pe = wX(a, o, d, m, b);
        var tt = FT(a, o, d, Pe, Se, b);
        {
          var Ct = o.stateNode;
          Pe && Ct.props !== m && (lp || s("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Ft(o) || "a component"), lp = !0);
        }
        return tt;
      }
      function FT(a, o, d, m, b, O) {
        aI(a, o);
        var N = (o.flags & wt) !== Et;
        if (!m && !N)
          return b && zF(o, d, !1), tc(a, o, O);
        var I = o.stateNode;
        qy.current = o;
        var L;
        if (N && typeof d.getDerivedStateFromError != "function")
          L = null, H4();
        else {
          ja(o);
          {
            if (Qn(!0), L = I.render(), o.mode & Ir) {
              vn(!0);
              try {
                I.render();
              } finally {
                vn(!1);
              }
            }
            Qn(!1);
          }
          Fa();
        }
        return o.flags |= Do, a !== null && N ? AX(a, o, L, O) : $a(a, o, L, O), o.memoizedState = I.state, b && zF(o, d, !0), o.child;
      }
      function uI(a) {
        var o = a.stateNode;
        o.pendingContext ? LF(a, o.pendingContext, o.pendingContext !== o.context) : o.context && LF(a, o.context, !1), IO(a, o.containerInfo);
      }
      function PX(a, o, d) {
        if (uI(o), a === null)
          throw new Error("Should have a current fiber. This is a bug in React.");
        var m = o.pendingProps, b = o.memoizedState, O = b.element;
        c4(a, o), X1(o, m, null, d);
        var N = o.memoizedState;
        o.stateNode;
        var I = N.element;
        if (b.isDehydrated) {
          var L = {
            element: I,
            isDehydrated: !1,
            cache: N.cache,
            pendingSuspenseBoundaries: N.pendingSuspenseBoundaries,
            transitions: N.transitions
          }, G = o.updateQueue;
          if (G.baseState = L, o.memoizedState = L, o.flags & fa) {
            var K = sp(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), o);
            return sI(a, o, I, d, K);
          } else if (I !== O) {
            var ve = sp(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), o);
            return sI(a, o, I, d, ve);
          } else {
            jK(o);
            var pe = n4(o, null, I, d);
            o.child = pe;
            for (var Se = pe; Se; )
              Se.flags = Se.flags & -3 | to, Se = Se.sibling;
          }
        } else {
          if (pv(), I === O)
            return tc(a, o, d);
          $a(a, o, I, d);
        }
        return o.child;
      }
      function sI(a, o, d, m, b) {
        return pv(), wO(b), o.flags |= fa, $a(a, o, d, m), o.child;
      }
      function MX(a, o, d) {
        h4(o), a === null && bO(o);
        var m = o.type, b = o.pendingProps, O = a !== null ? a.memoizedProps : null, N = b.children, I = tO(m, b);
        return I ? N = null : O !== null && tO(m, O) && (o.flags |= ko), aI(a, o), $a(a, o, N, d), o.child;
      }
      function NX(a, o) {
        return a === null && bO(o), null;
      }
      function jX(a, o, d, m) {
        _w(a, o);
        var b = o.pendingProps, O = d, N = O._payload, I = O._init, L = I(N);
        o.type = L;
        var G = o.tag = NJ(L), K = Xu(L, b), ve;
        switch (G) {
          case p:
            return IT(o, L), o.type = L = Rv(L), ve = jT(null, o, L, K, m), ve;
          case h:
            return o.type = L = pA(L), ve = oI(null, o, L, K, m), ve;
          case A:
            return o.type = L = hA(L), ve = tI(null, o, L, K, m), ve;
          case M: {
            if (o.type !== o.elementType) {
              var pe = L.propTypes;
              pe && Wu(
                pe,
                K,
                // Resolved for outer only
                "prop",
                or(L)
              );
            }
            return ve = rI(
              null,
              o,
              L,
              Xu(L.type, K),
              // The inner type can have defaults too
              m
            ), ve;
          }
        }
        var Se = "";
        throw L !== null && typeof L == "object" && L.$$typeof === It && (Se = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + L + ". " + ("Lazy element type must resolve to a class or function." + Se));
      }
      function FX(a, o, d, m, b) {
        _w(a, o), o.tag = h;
        var O;
        return Gs(d) ? (O = !0, N1(o)) : O = !1, mv(o, b), Q4(o, d, m), OT(o, d, m, b), FT(null, o, d, !0, O, b);
      }
      function IX(a, o, d, m) {
        _w(a, o);
        var b = o.pendingProps, O;
        {
          var N = lv(o, d, !1);
          O = cv(o, N);
        }
        mv(o, m);
        var I, L;
        ja(o);
        {
          if (d.prototype && typeof d.prototype.render == "function") {
            var G = or(d) || "Unknown";
            kT[G] || (s("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", G, G), kT[G] = !0);
          }
          o.mode & Ir && Gu.recordLegacyContextWarning(o, null), Qn(!0), qy.current = o, I = Ev(null, o, d, b, O, m), L = Sv(), Qn(!1);
        }
        if (Fa(), o.flags |= Do, typeof I == "object" && I !== null && typeof I.render == "function" && I.$$typeof === void 0) {
          var K = or(d) || "Unknown";
          Uy[K] || (s("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", K, K, K), Uy[K] = !0);
        }
        if (
          // Run these checks in production only if the flag is off.
          // Eventually we'll delete this branch altogether.
          typeof I == "object" && I !== null && typeof I.render == "function" && I.$$typeof === void 0
        ) {
          {
            var ve = or(d) || "Unknown";
            Uy[ve] || (s("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", ve, ve, ve), Uy[ve] = !0);
          }
          o.tag = h, o.memoizedState = null, o.updateQueue = null;
          var pe = !1;
          return Gs(d) ? (pe = !0, N1(o)) : pe = !1, o.memoizedState = I.state !== null && I.state !== void 0 ? I.state : null, jO(o), G4(o, I), OT(o, d, b, m), FT(null, o, d, !0, pe, m);
        } else {
          if (o.tag = p, o.mode & Ir) {
            vn(!0);
            try {
              I = Ev(null, o, d, b, O, m), L = Sv();
            } finally {
              vn(!1);
            }
          }
          return Qi() && L && vO(o), $a(null, o, I, m), IT(o, d), o.child;
        }
      }
      function IT(a, o) {
        {
          if (o && o.childContextTypes && s("%s(...): childContextTypes cannot be defined on a function component.", o.displayName || o.name || "Component"), a.ref !== null) {
            var d = "", m = qi();
            m && (d += `

Check the render method of \`` + m + "`.");
            var b = m || "", O = a._debugSource;
            O && (b = O.fileName + ":" + O.lineNumber), MT[b] || (MT[b] = !0, s("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", d));
          }
          if (o.defaultProps !== void 0) {
            var N = or(o) || "Unknown";
            Hy[N] || (s("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", N), Hy[N] = !0);
          }
          if (typeof o.getDerivedStateFromProps == "function") {
            var I = or(o) || "Unknown";
            PT[I] || (s("%s: Function components do not support getDerivedStateFromProps.", I), PT[I] = !0);
          }
          if (typeof o.contextType == "object" && o.contextType !== null) {
            var L = or(o) || "Unknown";
            RT[L] || (s("%s: Function components do not support contextType.", L), RT[L] = !0);
          }
        }
      }
      var BT = {
        dehydrated: null,
        treeContext: null,
        retryLane: fr
      };
      function LT(a) {
        return {
          baseLanes: a,
          cachePool: TX(),
          transitions: null
        };
      }
      function BX(a, o) {
        var d = null;
        return {
          baseLanes: qt(a.baseLanes, o),
          cachePool: d,
          transitions: a.transitions
        };
      }
      function LX(a, o, d, m) {
        if (o !== null) {
          var b = o.memoizedState;
          if (b === null)
            return !1;
        }
        return $O(a, My);
      }
      function $X(a, o) {
        return Md(a.childLanes, o);
      }
      function lI(a, o, d) {
        var m = o.pendingProps;
        QJ(o) && (o.flags |= wt);
        var b = Qu.current, O = !1, N = (o.flags & wt) !== Et;
        if (N || LX(b, a) ? (O = !0, o.flags &= -129) : (a === null || a.memoizedState !== null) && (b = iX(b, m4)), b = gv(b), gf(o, b), a === null) {
          bO(o);
          var I = o.memoizedState;
          if (I !== null) {
            var L = I.dehydrated;
            if (L !== null)
              return VX(o, L);
          }
          var G = m.children, K = m.fallback;
          if (O) {
            var ve = zX(o, G, K, d), pe = o.child;
            return pe.memoizedState = LT(d), o.memoizedState = BT, ve;
          } else
            return $T(o, G);
        } else {
          var Se = a.memoizedState;
          if (Se !== null) {
            var Oe = Se.dehydrated;
            if (Oe !== null)
              return WX(a, o, N, m, Oe, Se, d);
          }
          if (O) {
            var Pe = m.fallback, tt = m.children, Ct = UX(a, o, tt, Pe, d), bt = o.child, ar = a.child.memoizedState;
            return bt.memoizedState = ar === null ? LT(d) : BX(ar, d), bt.childLanes = $X(a, d), o.memoizedState = BT, Ct;
          } else {
            var Zt = m.children, xe = qX(a, o, Zt, d);
            return o.memoizedState = null, xe;
          }
        }
      }
      function $T(a, o, d) {
        var m = a.mode, b = {
          mode: "visible",
          children: o
        }, O = zT(b, m);
        return O.return = a, a.child = O, O;
      }
      function zX(a, o, d, m) {
        var b = a.mode, O = a.child, N = {
          mode: "hidden",
          children: o
        }, I, L;
        return (b & Gt) === St && O !== null ? (I = O, I.childLanes = $e, I.pendingProps = N, a.mode & yr && (I.actualDuration = 0, I.actualStartTime = -1, I.selfBaseDuration = 0, I.treeBaseDuration = 0), L = Of(d, b, m, null)) : (I = zT(N, b), L = Of(d, b, m, null)), I.return = a, L.return = a, I.sibling = L, a.child = I, L;
      }
      function zT(a, o, d) {
        return c8(a, o, $e, null);
      }
      function cI(a, o) {
        return hp(a, o);
      }
      function qX(a, o, d, m) {
        var b = a.child, O = b.sibling, N = cI(b, {
          mode: "visible",
          children: d
        });
        if ((o.mode & Gt) === St && (N.lanes = m), N.return = o, N.sibling = null, O !== null) {
          var I = o.deletions;
          I === null ? (o.deletions = [O], o.flags |= eo) : I.push(O);
        }
        return o.child = N, N;
      }
      function UX(a, o, d, m, b) {
        var O = o.mode, N = a.child, I = N.sibling, L = {
          mode: "hidden",
          children: d
        }, G;
        if (
          // In legacy mode, we commit the primary tree as if it successfully
          // completed, even though it's in an inconsistent state.
          (O & Gt) === St && // Make sure we're on the second pass, i.e. the primary child fragment was
          // already cloned. In legacy mode, the only case where this isn't true is
          // when DevTools forces us to display a fallback; we skip the first render
          // pass entirely and go straight to rendering the fallback. (In Concurrent
          // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
          // only codepath.)
          o.child !== N
        ) {
          var K = o.child;
          G = K, G.childLanes = $e, G.pendingProps = L, o.mode & yr && (G.actualDuration = 0, G.actualStartTime = -1, G.selfBaseDuration = N.selfBaseDuration, G.treeBaseDuration = N.treeBaseDuration), o.deletions = null;
        } else
          G = cI(N, L), G.subtreeFlags = N.subtreeFlags & Fn;
        var ve;
        return I !== null ? ve = hp(I, m) : (ve = Of(m, O, b, null), ve.flags |= Sn), ve.return = o, G.return = o, G.sibling = ve, o.child = G, ve;
      }
      function Sw(a, o, d, m) {
        m !== null && wO(m), hv(o, a.child, null, d);
        var b = o.pendingProps, O = b.children, N = $T(o, O);
        return N.flags |= Sn, o.memoizedState = null, N;
      }
      function HX(a, o, d, m, b) {
        var O = o.mode, N = {
          mode: "visible",
          children: d
        }, I = zT(N, O), L = Of(m, O, b, null);
        return L.flags |= Sn, I.return = o, L.return = o, I.sibling = L, o.child = I, (o.mode & Gt) !== St && hv(o, a.child, null, b), L;
      }
      function VX(a, o, d) {
        return (a.mode & Gt) === St ? (s("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), a.lanes = Rt) : aO(o) ? a.lanes = Pi : a.lanes = Ia, null;
      }
      function WX(a, o, d, m, b, O, N) {
        if (d)
          if (o.flags & fa) {
            o.flags &= -257;
            var xe = TT(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
            return Sw(a, o, N, xe);
          } else {
            if (o.memoizedState !== null)
              return o.child = a.child, o.flags |= wt, null;
            var Me = m.children, be = m.fallback, Ve = HX(a, o, Me, be, N), ot = o.child;
            return ot.memoizedState = LT(N), o.memoizedState = BT, Ve;
          }
        else {
          if (MK(), (o.mode & Gt) === St)
            return Sw(
              a,
              o,
              N,
              // TODO: When we delete legacy mode, we should make this error argument
              // required — every concurrent mode path that causes hydration to
              // de-opt to client rendering should have an error message.
              null
            );
          if (aO(b)) {
            var I, L, G;
            {
              var K = KQ(b);
              I = K.digest, L = K.message, G = K.stack;
            }
            var ve;
            L ? ve = new Error(L) : ve = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
            var pe = TT(ve, I, G);
            return Sw(a, o, N, pe);
          }
          var Se = ya(N, a.childLanes);
          if (Zu || Se) {
            var Oe = Nw();
            if (Oe !== null) {
              var Pe = Ym(Oe, N);
              if (Pe !== fr && Pe !== O.retryLane) {
                O.retryLane = Pe;
                var tt = Qr;
                co(a, Pe), Ti(Oe, a, Pe, tt);
              }
            }
            sA();
            var Ct = TT(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
            return Sw(a, o, N, Ct);
          } else if (MF(b)) {
            o.flags |= wt, o.child = a.child;
            var bt = yJ.bind(null, a);
            return XQ(b, bt), null;
          } else {
            FK(o, b, O.treeContext);
            var ar = m.children, Zt = $T(o, ar);
            return Zt.flags |= to, Zt;
          }
        }
      }
      function fI(a, o, d) {
        a.lanes = qt(a.lanes, o);
        var m = a.alternate;
        m !== null && (m.lanes = qt(m.lanes, o)), RO(a.return, o, d);
      }
      function YX(a, o, d) {
        for (var m = o; m !== null; ) {
          if (m.tag === T) {
            var b = m.memoizedState;
            b !== null && fI(m, d, a);
          } else if (m.tag === q)
            fI(m, d, a);
          else if (m.child !== null) {
            m.child.return = m, m = m.child;
            continue;
          }
          if (m === a)
            return;
          for (; m.sibling === null; ) {
            if (m.return === null || m.return === a)
              return;
            m = m.return;
          }
          m.sibling.return = m.return, m = m.sibling;
        }
      }
      function GX(a) {
        for (var o = a, d = null; o !== null; ) {
          var m = o.alternate;
          m !== null && tw(m) === null && (d = o), o = o.sibling;
        }
        return d;
      }
      function QX(a) {
        if (a !== void 0 && a !== "forwards" && a !== "backwards" && a !== "together" && !NT[a])
          if (NT[a] = !0, typeof a == "string")
            switch (a.toLowerCase()) {
              case "together":
              case "forwards":
              case "backwards": {
                s('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', a, a.toLowerCase());
                break;
              }
              case "forward":
              case "backward": {
                s('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', a, a.toLowerCase());
                break;
              }
              default:
                s('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', a);
                break;
            }
          else
            s('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', a);
      }
      function KX(a, o) {
        a !== void 0 && !Ew[a] && (a !== "collapsed" && a !== "hidden" ? (Ew[a] = !0, s('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', a)) : o !== "forwards" && o !== "backwards" && (Ew[a] = !0, s('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', a)));
      }
      function dI(a, o) {
        {
          var d = Wt(a), m = !d && typeof zt(a) == "function";
          if (d || m) {
            var b = d ? "array" : "iterable";
            return s("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", b, o, b), !1;
          }
        }
        return !0;
      }
      function XX(a, o) {
        if ((o === "forwards" || o === "backwards") && a !== void 0 && a !== null && a !== !1)
          if (Wt(a)) {
            for (var d = 0; d < a.length; d++)
              if (!dI(a[d], d))
                return;
          } else {
            var m = zt(a);
            if (typeof m == "function") {
              var b = m.call(a);
              if (b)
                for (var O = b.next(), N = 0; !O.done; O = b.next()) {
                  if (!dI(O.value, N))
                    return;
                  N++;
                }
            } else
              s('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', o);
          }
      }
      function qT(a, o, d, m, b) {
        var O = a.memoizedState;
        O === null ? a.memoizedState = {
          isBackwards: o,
          rendering: null,
          renderingStartTime: 0,
          last: m,
          tail: d,
          tailMode: b
        } : (O.isBackwards = o, O.rendering = null, O.renderingStartTime = 0, O.last = m, O.tail = d, O.tailMode = b);
      }
      function pI(a, o, d) {
        var m = o.pendingProps, b = m.revealOrder, O = m.tail, N = m.children;
        QX(b), KX(O, b), XX(N, b), $a(a, o, N, d);
        var I = Qu.current, L = $O(I, My);
        if (L)
          I = zO(I, My), o.flags |= wt;
        else {
          var G = a !== null && (a.flags & wt) !== Et;
          G && YX(o, o.child, d), I = gv(I);
        }
        if (gf(o, I), (o.mode & Gt) === St)
          o.memoizedState = null;
        else
          switch (b) {
            case "forwards": {
              var K = GX(o.child), ve;
              K === null ? (ve = o.child, o.child = null) : (ve = K.sibling, K.sibling = null), qT(
                o,
                !1,
                // isBackwards
                ve,
                K,
                O
              );
              break;
            }
            case "backwards": {
              var pe = null, Se = o.child;
              for (o.child = null; Se !== null; ) {
                var Oe = Se.alternate;
                if (Oe !== null && tw(Oe) === null) {
                  o.child = Se;
                  break;
                }
                var Pe = Se.sibling;
                Se.sibling = pe, pe = Se, Se = Pe;
              }
              qT(
                o,
                !0,
                // isBackwards
                pe,
                null,
                // last
                O
              );
              break;
            }
            case "together": {
              qT(
                o,
                !1,
                // isBackwards
                null,
                // tail
                null,
                // last
                void 0
              );
              break;
            }
            default:
              o.memoizedState = null;
          }
        return o.child;
      }
      function ZX(a, o, d) {
        IO(o, o.stateNode.containerInfo);
        var m = o.pendingProps;
        return a === null ? o.child = hv(o, null, m, d) : $a(a, o, m, d), o.child;
      }
      var hI = !1;
      function JX(a, o, d) {
        var m = o.type, b = m._context, O = o.pendingProps, N = o.memoizedProps, I = O.value;
        {
          "value" in O || hI || (hI = !0, s("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
          var L = o.type.propTypes;
          L && Wu(L, O, "prop", "Context.Provider");
        }
        if (o4(o, b, I), N !== null) {
          var G = N.value;
          if (Ue(G, I)) {
            if (N.children === O.children && !P1())
              return tc(a, o, d);
          } else
            QK(o, b, d);
        }
        var K = O.children;
        return $a(a, o, K, d), o.child;
      }
      var vI = !1;
      function eZ(a, o, d) {
        var m = o.type;
        m._context === void 0 ? m !== m.Consumer && (vI || (vI = !0, s("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : m = m._context;
        var b = o.pendingProps, O = b.children;
        typeof O != "function" && s("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), mv(o, d);
        var N = ui(m);
        ja(o);
        var I;
        return qy.current = o, Qn(!0), I = O(N), Qn(!1), Fa(), o.flags |= Do, $a(a, o, I, d), o.child;
      }
      function Vy() {
        Zu = !0;
      }
      function _w(a, o) {
        (o.mode & Gt) === St && a !== null && (a.alternate = null, o.alternate = null, o.flags |= Sn);
      }
      function tc(a, o, d) {
        return a !== null && (o.dependencies = a.dependencies), H4(), ng(o.lanes), ya(d, o.childLanes) ? (YK(a, o), o.child) : null;
      }
      function tZ(a, o, d) {
        {
          var m = o.return;
          if (m === null)
            throw new Error("Cannot swap the root fiber.");
          if (a.alternate = null, o.alternate = null, d.index = o.index, d.sibling = o.sibling, d.return = o.return, d.ref = o.ref, o === m.child)
            m.child = d;
          else {
            var b = m.child;
            if (b === null)
              throw new Error("Expected parent to have a child.");
            for (; b.sibling !== o; )
              if (b = b.sibling, b === null)
                throw new Error("Expected to find the previous sibling.");
            b.sibling = d;
          }
          var O = m.deletions;
          return O === null ? (m.deletions = [a], m.flags |= eo) : O.push(a), d.flags |= Sn, d;
        }
      }
      function UT(a, o) {
        var d = a.lanes;
        return !!ya(d, o);
      }
      function rZ(a, o, d) {
        switch (o.tag) {
          case y:
            uI(o), o.stateNode, pv();
            break;
          case w:
            h4(o);
            break;
          case h: {
            var m = o.type;
            Gs(m) && N1(o);
            break;
          }
          case x:
            IO(o, o.stateNode.containerInfo);
            break;
          case D: {
            var b = o.memoizedProps.value, O = o.type._context;
            o4(o, O, b);
            break;
          }
          case R:
            {
              var N = ya(d, o.childLanes);
              N && (o.flags |= rr);
              {
                var I = o.stateNode;
                I.effectDuration = 0, I.passiveEffectDuration = 0;
              }
            }
            break;
          case T: {
            var L = o.memoizedState;
            if (L !== null) {
              if (L.dehydrated !== null)
                return gf(o, gv(Qu.current)), o.flags |= wt, null;
              var G = o.child, K = G.childLanes;
              if (ya(d, K))
                return lI(a, o, d);
              gf(o, gv(Qu.current));
              var ve = tc(a, o, d);
              return ve !== null ? ve.sibling : null;
            } else
              gf(o, gv(Qu.current));
            break;
          }
          case q: {
            var pe = (a.flags & wt) !== Et, Se = ya(d, o.childLanes);
            if (pe) {
              if (Se)
                return pI(a, o, d);
              o.flags |= wt;
            }
            var Oe = o.memoizedState;
            if (Oe !== null && (Oe.rendering = null, Oe.tail = null, Oe.lastEffect = null), gf(o, Qu.current), Se)
              break;
            return null;
          }
          case W:
          case J:
            return o.lanes = $e, iI(a, o, d);
        }
        return tc(a, o, d);
      }
      function mI(a, o, d) {
        if (o._debugNeedsRemount && a !== null)
          return tZ(a, o, xA(o.type, o.key, o.pendingProps, o._debugOwner || null, o.mode, o.lanes));
        if (a !== null) {
          var m = a.memoizedProps, b = o.pendingProps;
          if (m !== b || P1() || // Force a re-render if the implementation changed due to hot reload:
          o.type !== a.type)
            Zu = !0;
          else {
            var O = UT(a, d);
            if (!O && // If this is the second pass of an error or suspense boundary, there
            // may not be work scheduled on `current`, so we check for this flag.
            (o.flags & wt) === Et)
              return Zu = !1, rZ(a, o, d);
            (a.flags & dh) !== Et ? Zu = !0 : Zu = !1;
          }
        } else if (Zu = !1, Qi() && TK(o)) {
          var N = o.index, I = AK();
          HF(o, I, N);
        }
        switch (o.lanes = $e, o.tag) {
          case v:
            return IX(a, o, o.type, d);
          case B: {
            var L = o.elementType;
            return jX(a, o, L, d);
          }
          case p: {
            var G = o.type, K = o.pendingProps, ve = o.elementType === G ? K : Xu(G, K);
            return jT(a, o, G, ve, d);
          }
          case h: {
            var pe = o.type, Se = o.pendingProps, Oe = o.elementType === pe ? Se : Xu(pe, Se);
            return oI(a, o, pe, Oe, d);
          }
          case y:
            return PX(a, o, d);
          case w:
            return MX(a, o, d);
          case E:
            return NX(a, o);
          case T:
            return lI(a, o, d);
          case x:
            return ZX(a, o, d);
          case A: {
            var Pe = o.type, tt = o.pendingProps, Ct = o.elementType === Pe ? tt : Xu(Pe, tt);
            return tI(a, o, Pe, Ct, d);
          }
          case C:
            return DX(a, o, d);
          case S:
            return kX(a, o, d);
          case R:
            return RX(a, o, d);
          case D:
            return JX(a, o, d);
          case k:
            return eZ(a, o, d);
          case M: {
            var bt = o.type, ar = o.pendingProps, Zt = Xu(bt, ar);
            if (o.type !== o.elementType) {
              var xe = bt.propTypes;
              xe && Wu(
                xe,
                Zt,
                // Resolved for outer only
                "prop",
                or(bt)
              );
            }
            return Zt = Xu(bt.type, Zt), rI(a, o, bt, Zt, d);
          }
          case F:
            return nI(a, o, o.type, o.pendingProps, d);
          case V: {
            var Me = o.type, be = o.pendingProps, Ve = o.elementType === Me ? be : Xu(Me, be);
            return FX(a, o, Me, Ve, d);
          }
          case q:
            return pI(a, o, d);
          case Q:
            break;
          case W:
            return iI(a, o, d);
        }
        throw new Error("Unknown unit of work tag (" + o.tag + "). This error is likely caused by a bug in React. Please file an issue.");
      }
      function _v(a) {
        a.flags |= rr;
      }
      function yI(a) {
        a.flags |= bn, a.flags |= Kc;
      }
      var gI, HT, xI, bI;
      gI = function(a, o, d, m) {
        for (var b = o.child; b !== null; ) {
          if (b.tag === w || b.tag === E)
            _Q(a, b.stateNode);
          else if (b.tag !== x) {
            if (b.child !== null) {
              b.child.return = b, b = b.child;
              continue;
            }
          }
          if (b === o)
            return;
          for (; b.sibling === null; ) {
            if (b.return === null || b.return === o)
              return;
            b = b.return;
          }
          b.sibling.return = b.return, b = b.sibling;
        }
      }, HT = function(a, o) {
      }, xI = function(a, o, d, m, b) {
        var O = a.memoizedProps;
        if (O !== m) {
          var N = o.stateNode, I = BO(), L = OQ(N, d, O, m, b, I);
          o.updateQueue = L, L && _v(o);
        }
      }, bI = function(a, o, d, m) {
        d !== m && _v(o);
      };
      function Wy(a, o) {
        if (!Qi())
          switch (a.tailMode) {
            case "hidden": {
              for (var d = a.tail, m = null; d !== null; )
                d.alternate !== null && (m = d), d = d.sibling;
              m === null ? a.tail = null : m.sibling = null;
              break;
            }
            case "collapsed": {
              for (var b = a.tail, O = null; b !== null; )
                b.alternate !== null && (O = b), b = b.sibling;
              O === null ? !o && a.tail !== null ? a.tail.sibling = null : a.tail = null : O.sibling = null;
              break;
            }
          }
      }
      function Xi(a) {
        var o = a.alternate !== null && a.alternate.child === a.child, d = $e, m = Et;
        if (o) {
          if ((a.mode & yr) !== St) {
            for (var L = a.selfBaseDuration, G = a.child; G !== null; )
              d = qt(d, qt(G.lanes, G.childLanes)), m |= G.subtreeFlags & Fn, m |= G.flags & Fn, L += G.treeBaseDuration, G = G.sibling;
            a.treeBaseDuration = L;
          } else
            for (var K = a.child; K !== null; )
              d = qt(d, qt(K.lanes, K.childLanes)), m |= K.subtreeFlags & Fn, m |= K.flags & Fn, K.return = a, K = K.sibling;
          a.subtreeFlags |= m;
        } else {
          if ((a.mode & yr) !== St) {
            for (var b = a.actualDuration, O = a.selfBaseDuration, N = a.child; N !== null; )
              d = qt(d, qt(N.lanes, N.childLanes)), m |= N.subtreeFlags, m |= N.flags, b += N.actualDuration, O += N.treeBaseDuration, N = N.sibling;
            a.actualDuration = b, a.treeBaseDuration = O;
          } else
            for (var I = a.child; I !== null; )
              d = qt(d, qt(I.lanes, I.childLanes)), m |= I.subtreeFlags, m |= I.flags, I.return = a, I = I.sibling;
          a.subtreeFlags |= m;
        }
        return a.childLanes = d, o;
      }
      function nZ(a, o, d) {
        if (zK() && (o.mode & Gt) !== St && (o.flags & wt) === Et)
          return XF(o), pv(), o.flags |= fa | yd | pa, !1;
        var m = L1(o);
        if (d !== null && d.dehydrated !== null)
          if (a === null) {
            if (!m)
              throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
            if (LK(o), Xi(o), (o.mode & yr) !== St) {
              var b = d !== null;
              if (b) {
                var O = o.child;
                O !== null && (o.treeBaseDuration -= O.treeBaseDuration);
              }
            }
            return !1;
          } else {
            if (pv(), (o.flags & wt) === Et && (o.memoizedState = null), o.flags |= rr, Xi(o), (o.mode & yr) !== St) {
              var N = d !== null;
              if (N) {
                var I = o.child;
                I !== null && (o.treeBaseDuration -= I.treeBaseDuration);
              }
            }
            return !1;
          }
        else
          return ZF(), !0;
      }
      function wI(a, o, d) {
        var m = o.pendingProps;
        switch (mO(o), o.tag) {
          case v:
          case B:
          case F:
          case p:
          case A:
          case C:
          case S:
          case R:
          case k:
          case M:
            return Xi(o), null;
          case h: {
            var b = o.type;
            return Gs(b) && M1(o), Xi(o), null;
          }
          case y: {
            var O = o.stateNode;
            if (yv(o), dO(o), UO(), O.pendingContext && (O.context = O.pendingContext, O.pendingContext = null), a === null || a.child === null) {
              var N = L1(o);
              if (N)
                _v(o);
              else if (a !== null) {
                var I = a.memoizedState;
                // Check if this is a client root
                (!I.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                (o.flags & fa) !== Et) && (o.flags |= Kn, ZF());
              }
            }
            return HT(a, o), Xi(o), null;
          }
          case w: {
            LO(o);
            var L = p4(), G = o.type;
            if (a !== null && o.stateNode != null)
              xI(a, o, G, m, L), a.ref !== o.ref && yI(o);
            else {
              if (!m) {
                if (o.stateNode === null)
                  throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                return Xi(o), null;
              }
              var K = BO(), ve = L1(o);
              if (ve)
                IK(o, L, K) && _v(o);
              else {
                var pe = SQ(G, m, L, K, o);
                gI(pe, o, !1, !1), o.stateNode = pe, CQ(pe, G, m, L) && _v(o);
              }
              o.ref !== null && yI(o);
            }
            return Xi(o), null;
          }
          case E: {
            var Se = m;
            if (a && o.stateNode != null) {
              var Oe = a.memoizedProps;
              bI(a, o, Oe, Se);
            } else {
              if (typeof Se != "string" && o.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              var Pe = p4(), tt = BO(), Ct = L1(o);
              Ct ? BK(o) && _v(o) : o.stateNode = TQ(Se, Pe, tt, o);
            }
            return Xi(o), null;
          }
          case T: {
            xv(o);
            var bt = o.memoizedState;
            if (a === null || a.memoizedState !== null && a.memoizedState.dehydrated !== null) {
              var ar = nZ(a, o, bt);
              if (!ar)
                return o.flags & pa ? o : null;
            }
            if ((o.flags & wt) !== Et)
              return o.lanes = d, (o.mode & yr) !== St && hT(o), o;
            var Zt = bt !== null, xe = a !== null && a.memoizedState !== null;
            if (Zt !== xe && Zt) {
              var Me = o.child;
              if (Me.flags |= jn, (o.mode & Gt) !== St) {
                var be = a === null && (o.memoizedProps.unstable_avoidThisFallback !== !0 || !0);
                be || $O(Qu.current, m4) ? iJ() : sA();
              }
            }
            var Ve = o.updateQueue;
            if (Ve !== null && (o.flags |= rr), Xi(o), (o.mode & yr) !== St && Zt) {
              var ot = o.child;
              ot !== null && (o.treeBaseDuration -= ot.treeBaseDuration);
            }
            return null;
          }
          case x:
            return yv(o), HT(a, o), a === null && bK(o.stateNode.containerInfo), Xi(o), null;
          case D:
            var rt = o.type._context;
            return kO(rt, o), Xi(o), null;
          case V: {
            var Pt = o.type;
            return Gs(Pt) && M1(o), Xi(o), null;
          }
          case q: {
            xv(o);
            var Lt = o.memoizedState;
            if (Lt === null)
              return Xi(o), null;
            var Lr = (o.flags & wt) !== Et, br = Lt.rendering;
            if (br === null)
              if (Lr)
                Wy(Lt, !1);
              else {
                var Jn = oJ() && (a === null || (a.flags & wt) === Et);
                if (!Jn)
                  for (var wr = o.child; wr !== null; ) {
                    var qn = tw(wr);
                    if (qn !== null) {
                      Lr = !0, o.flags |= wt, Wy(Lt, !1);
                      var _a = qn.updateQueue;
                      return _a !== null && (o.updateQueue = _a, o.flags |= rr), o.subtreeFlags = Et, GK(o, d), gf(o, zO(Qu.current, My)), o.child;
                    }
                    wr = wr.sibling;
                  }
                Lt.tail !== null && Xn() > qI() && (o.flags |= wt, Lr = !0, Wy(Lt, !1), o.lanes = Bm);
              }
            else {
              if (!Lr) {
                var ra = tw(br);
                if (ra !== null) {
                  o.flags |= wt, Lr = !0;
                  var Io = ra.updateQueue;
                  if (Io !== null && (o.updateQueue = Io, o.flags |= rr), Wy(Lt, !0), Lt.tail === null && Lt.tailMode === "hidden" && !br.alternate && !Qi())
                    return Xi(o), null;
                } else // The time it took to render last row is greater than the remaining
                // time we have to render. So rendering one more row would likely
                // exceed it.
                Xn() * 2 - Lt.renderingStartTime > qI() && d !== Ia && (o.flags |= wt, Lr = !0, Wy(Lt, !1), o.lanes = Bm);
              }
              if (Lt.isBackwards)
                br.sibling = o.child, o.child = br;
              else {
                var Ua = Lt.last;
                Ua !== null ? Ua.sibling = br : o.child = br, Lt.last = br;
              }
            }
            if (Lt.tail !== null) {
              var Ha = Lt.tail;
              Lt.rendering = Ha, Lt.tail = Ha.sibling, Lt.renderingStartTime = Xn(), Ha.sibling = null;
              var Ca = Qu.current;
              return Lr ? Ca = zO(Ca, My) : Ca = gv(Ca), gf(o, Ca), Ha;
            }
            return Xi(o), null;
          }
          case Q:
            break;
          case W:
          case J: {
            uA(o);
            var oc = o.memoizedState, Pv = oc !== null;
            if (a !== null) {
              var sg = a.memoizedState, rl = sg !== null;
              rl !== Pv && (o.flags |= jn);
            }
            return !Pv || (o.mode & Gt) === St ? Xi(o) : ya(tl, Ia) && (Xi(o), o.subtreeFlags & (Sn | rr) && (o.flags |= jn)), null;
          }
          case ne:
            return null;
          case ie:
            return null;
        }
        throw new Error("Unknown unit of work tag (" + o.tag + "). This error is likely caused by a bug in React. Please file an issue.");
      }
      function iZ(a, o, d) {
        switch (mO(o), o.tag) {
          case h: {
            var m = o.type;
            Gs(m) && M1(o);
            var b = o.flags;
            return b & pa ? (o.flags = b & -65537 | wt, (o.mode & yr) !== St && hT(o), o) : null;
          }
          case y: {
            o.stateNode, yv(o), dO(o), UO();
            var O = o.flags;
            return (O & pa) !== Et && (O & wt) === Et ? (o.flags = O & -65537 | wt, o) : null;
          }
          case w:
            return LO(o), null;
          case T: {
            xv(o);
            var N = o.memoizedState;
            if (N !== null && N.dehydrated !== null) {
              if (o.alternate === null)
                throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
              pv();
            }
            var I = o.flags;
            return I & pa ? (o.flags = I & -65537 | wt, (o.mode & yr) !== St && hT(o), o) : null;
          }
          case q:
            return xv(o), null;
          case x:
            return yv(o), null;
          case D:
            var L = o.type._context;
            return kO(L, o), null;
          case W:
          case J:
            return uA(o), null;
          case ne:
            return null;
          default:
            return null;
        }
      }
      function EI(a, o, d) {
        switch (mO(o), o.tag) {
          case h: {
            var m = o.type.childContextTypes;
            m != null && M1(o);
            break;
          }
          case y: {
            o.stateNode, yv(o), dO(o), UO();
            break;
          }
          case w: {
            LO(o);
            break;
          }
          case x:
            yv(o);
            break;
          case T:
            xv(o);
            break;
          case q:
            xv(o);
            break;
          case D:
            var b = o.type._context;
            kO(b, o);
            break;
          case W:
          case J:
            uA(o);
            break;
        }
      }
      var SI = null;
      SI = /* @__PURE__ */ new Set();
      var Cw = !1, Zi = !1, aZ = typeof WeakSet == "function" ? WeakSet : Set, ht = null, Cv = null, Ov = null;
      function oZ(a) {
        ks(null, function() {
          throw a;
        }), md();
      }
      var uZ = function(a, o) {
        if (o.props = a.memoizedProps, o.state = a.memoizedState, a.mode & yr)
          try {
            Js(), o.componentWillUnmount();
          } finally {
            Zs(a);
          }
        else
          o.componentWillUnmount();
      };
      function _I(a, o) {
        try {
          wf(wi, a);
        } catch (d) {
          sn(a, o, d);
        }
      }
      function VT(a, o, d) {
        try {
          uZ(a, d);
        } catch (m) {
          sn(a, o, m);
        }
      }
      function sZ(a, o, d) {
        try {
          d.componentDidMount();
        } catch (m) {
          sn(a, o, m);
        }
      }
      function CI(a, o) {
        try {
          TI(a);
        } catch (d) {
          sn(a, o, d);
        }
      }
      function Tv(a, o) {
        var d = a.ref;
        if (d !== null)
          if (typeof d == "function") {
            var m;
            try {
              if (ae && De && a.mode & yr)
                try {
                  Js(), m = d(null);
                } finally {
                  Zs(a);
                }
              else
                m = d(null);
            } catch (b) {
              sn(a, o, b);
            }
            typeof m == "function" && s("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Ft(a));
          } else
            d.current = null;
      }
      function Ow(a, o, d) {
        try {
          d();
        } catch (m) {
          sn(a, o, m);
        }
      }
      var OI = !1;
      function lZ(a, o) {
        wQ(a.containerInfo), ht = o, cZ();
        var d = OI;
        return OI = !1, d;
      }
      function cZ() {
        for (; ht !== null; ) {
          var a = ht, o = a.child;
          (a.subtreeFlags & Ps) !== Et && o !== null ? (o.return = a, ht = o) : fZ();
        }
      }
      function fZ() {
        for (; ht !== null; ) {
          var a = ht;
          Nr(a);
          try {
            dZ(a);
          } catch (d) {
            sn(a, a.return, d);
          }
          un();
          var o = a.sibling;
          if (o !== null) {
            o.return = a.return, ht = o;
            return;
          }
          ht = a.return;
        }
      }
      function dZ(a) {
        var o = a.alternate, d = a.flags;
        if ((d & Kn) !== Et) {
          switch (Nr(a), a.tag) {
            case p:
            case A:
            case F:
              break;
            case h: {
              if (o !== null) {
                var m = o.memoizedProps, b = o.memoizedState, O = a.stateNode;
                a.type === a.elementType && !lp && (O.props !== a.memoizedProps && s("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Ft(a) || "instance"), O.state !== a.memoizedState && s("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Ft(a) || "instance"));
                var N = O.getSnapshotBeforeUpdate(a.elementType === a.type ? m : Xu(a.type, m), b);
                {
                  var I = SI;
                  N === void 0 && !I.has(a.type) && (I.add(a.type), s("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", Ft(a)));
                }
                O.__reactInternalSnapshotBeforeUpdate = N;
              }
              break;
            }
            case y: {
              {
                var L = a.stateNode;
                WQ(L.containerInfo);
              }
              break;
            }
            case w:
            case E:
            case x:
            case V:
              break;
            default:
              throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
          }
          un();
        }
      }
      function Ju(a, o, d) {
        var m = o.updateQueue, b = m !== null ? m.lastEffect : null;
        if (b !== null) {
          var O = b.next, N = O;
          do {
            if ((N.tag & a) === a) {
              var I = N.destroy;
              N.destroy = void 0, I !== void 0 && ((a & Ki) !== fo ? $u(o) : (a & wi) !== fo && xd(o), (a & Qs) !== fo && ag(!0), Ow(o, d, I), (a & Qs) !== fo && ag(!1), (a & Ki) !== fo ? Fs() : (a & wi) !== fo && Fm());
            }
            N = N.next;
          } while (N !== O);
        }
      }
      function wf(a, o) {
        var d = o.updateQueue, m = d !== null ? d.lastEffect : null;
        if (m !== null) {
          var b = m.next, O = b;
          do {
            if ((O.tag & a) === a) {
              (a & Ki) !== fo ? jm(o) : (a & wi) !== fo && gh(o);
              var N = O.create;
              (a & Qs) !== fo && ag(!0), O.destroy = N(), (a & Qs) !== fo && ag(!1), (a & Ki) !== fo ? Rb() : (a & wi) !== fo && Pb();
              {
                var I = O.destroy;
                if (I !== void 0 && typeof I != "function") {
                  var L = void 0;
                  (O.tag & wi) !== Et ? L = "useLayoutEffect" : (O.tag & Qs) !== Et ? L = "useInsertionEffect" : L = "useEffect";
                  var G = void 0;
                  I === null ? G = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof I.then == "function" ? G = `

It looks like you wrote ` + L + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + L + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : G = " You returned: " + I, s("%s must not return anything besides a function, which is used for clean-up.%s", L, G);
                }
              }
            }
            O = O.next;
          } while (O !== b);
        }
      }
      function pZ(a, o) {
        if ((o.flags & rr) !== Et)
          switch (o.tag) {
            case R: {
              var d = o.stateNode.passiveEffectDuration, m = o.memoizedProps, b = m.id, O = m.onPostCommit, N = q4(), I = o.alternate === null ? "mount" : "update";
              z4() && (I = "nested-update"), typeof O == "function" && O(b, I, d, N);
              var L = o.return;
              e: for (; L !== null; ) {
                switch (L.tag) {
                  case y:
                    var G = L.stateNode;
                    G.passiveEffectDuration += d;
                    break e;
                  case R:
                    var K = L.stateNode;
                    K.passiveEffectDuration += d;
                    break e;
                }
                L = L.return;
              }
              break;
            }
          }
      }
      function hZ(a, o, d, m) {
        if ((d.flags & Ns) !== Et)
          switch (d.tag) {
            case p:
            case A:
            case F: {
              if (!Zi)
                if (d.mode & yr)
                  try {
                    Js(), wf(wi | bi, d);
                  } finally {
                    Zs(d);
                  }
                else
                  wf(wi | bi, d);
              break;
            }
            case h: {
              var b = d.stateNode;
              if (d.flags & rr && !Zi)
                if (o === null)
                  if (d.type === d.elementType && !lp && (b.props !== d.memoizedProps && s("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Ft(d) || "instance"), b.state !== d.memoizedState && s("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Ft(d) || "instance")), d.mode & yr)
                    try {
                      Js(), b.componentDidMount();
                    } finally {
                      Zs(d);
                    }
                  else
                    b.componentDidMount();
                else {
                  var O = d.elementType === d.type ? o.memoizedProps : Xu(d.type, o.memoizedProps), N = o.memoizedState;
                  if (d.type === d.elementType && !lp && (b.props !== d.memoizedProps && s("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Ft(d) || "instance"), b.state !== d.memoizedState && s("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Ft(d) || "instance")), d.mode & yr)
                    try {
                      Js(), b.componentDidUpdate(O, N, b.__reactInternalSnapshotBeforeUpdate);
                    } finally {
                      Zs(d);
                    }
                  else
                    b.componentDidUpdate(O, N, b.__reactInternalSnapshotBeforeUpdate);
                }
              var I = d.updateQueue;
              I !== null && (d.type === d.elementType && !lp && (b.props !== d.memoizedProps && s("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Ft(d) || "instance"), b.state !== d.memoizedState && s("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Ft(d) || "instance")), d4(d, I, b));
              break;
            }
            case y: {
              var L = d.updateQueue;
              if (L !== null) {
                var G = null;
                if (d.child !== null)
                  switch (d.child.tag) {
                    case w:
                      G = d.child.stateNode;
                      break;
                    case h:
                      G = d.child.stateNode;
                      break;
                  }
                d4(d, L, G);
              }
              break;
            }
            case w: {
              var K = d.stateNode;
              if (o === null && d.flags & rr) {
                var ve = d.type, pe = d.memoizedProps;
                PQ(K, ve, pe);
              }
              break;
            }
            case E:
              break;
            case x:
              break;
            case R: {
              {
                var Se = d.memoizedProps, Oe = Se.onCommit, Pe = Se.onRender, tt = d.stateNode.effectDuration, Ct = q4(), bt = o === null ? "mount" : "update";
                z4() && (bt = "nested-update"), typeof Pe == "function" && Pe(d.memoizedProps.id, bt, d.actualDuration, d.treeBaseDuration, d.actualStartTime, Ct);
                {
                  typeof Oe == "function" && Oe(d.memoizedProps.id, bt, tt, Ct), fJ(d);
                  var ar = d.return;
                  e: for (; ar !== null; ) {
                    switch (ar.tag) {
                      case y:
                        var Zt = ar.stateNode;
                        Zt.effectDuration += tt;
                        break e;
                      case R:
                        var xe = ar.stateNode;
                        xe.effectDuration += tt;
                        break e;
                    }
                    ar = ar.return;
                  }
                }
              }
              break;
            }
            case T: {
              EZ(a, d);
              break;
            }
            case q:
            case V:
            case Q:
            case W:
            case J:
            case ie:
              break;
            default:
              throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
          }
        Zi || d.flags & bn && TI(d);
      }
      function vZ(a) {
        switch (a.tag) {
          case p:
          case A:
          case F: {
            if (a.mode & yr)
              try {
                Js(), _I(a, a.return);
              } finally {
                Zs(a);
              }
            else
              _I(a, a.return);
            break;
          }
          case h: {
            var o = a.stateNode;
            typeof o.componentDidMount == "function" && sZ(a, a.return, o), CI(a, a.return);
            break;
          }
          case w: {
            CI(a, a.return);
            break;
          }
        }
      }
      function mZ(a, o) {
        for (var d = null, m = a; ; ) {
          if (m.tag === w) {
            if (d === null) {
              d = m;
              try {
                var b = m.stateNode;
                o ? qQ(b) : HQ(m.stateNode, m.memoizedProps);
              } catch (N) {
                sn(a, a.return, N);
              }
            }
          } else if (m.tag === E) {
            if (d === null)
              try {
                var O = m.stateNode;
                o ? UQ(O) : VQ(O, m.memoizedProps);
              } catch (N) {
                sn(a, a.return, N);
              }
          } else if (!((m.tag === W || m.tag === J) && m.memoizedState !== null && m !== a)) {
            if (m.child !== null) {
              m.child.return = m, m = m.child;
              continue;
            }
          }
          if (m === a)
            return;
          for (; m.sibling === null; ) {
            if (m.return === null || m.return === a)
              return;
            d === m && (d = null), m = m.return;
          }
          d === m && (d = null), m.sibling.return = m.return, m = m.sibling;
        }
      }
      function TI(a) {
        var o = a.ref;
        if (o !== null) {
          var d = a.stateNode, m;
          switch (a.tag) {
            case w:
              m = d;
              break;
            default:
              m = d;
          }
          if (typeof o == "function") {
            var b;
            if (a.mode & yr)
              try {
                Js(), b = o(m);
              } finally {
                Zs(a);
              }
            else
              b = o(m);
            typeof b == "function" && s("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Ft(a));
          } else
            o.hasOwnProperty("current") || s("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", Ft(a)), o.current = m;
        }
      }
      function yZ(a) {
        var o = a.alternate;
        o !== null && (o.return = null), a.return = null;
      }
      function AI(a) {
        var o = a.alternate;
        o !== null && (a.alternate = null, AI(o));
        {
          if (a.child = null, a.deletions = null, a.sibling = null, a.tag === w) {
            var d = a.stateNode;
            d !== null && SK(d);
          }
          a.stateNode = null, a._debugOwner = null, a.return = null, a.dependencies = null, a.memoizedProps = null, a.memoizedState = null, a.pendingProps = null, a.stateNode = null, a.updateQueue = null;
        }
      }
      function gZ(a) {
        for (var o = a.return; o !== null; ) {
          if (DI(o))
            return o;
          o = o.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
      }
      function DI(a) {
        return a.tag === w || a.tag === y || a.tag === x;
      }
      function kI(a) {
        var o = a;
        e: for (; ; ) {
          for (; o.sibling === null; ) {
            if (o.return === null || DI(o.return))
              return null;
            o = o.return;
          }
          for (o.sibling.return = o.return, o = o.sibling; o.tag !== w && o.tag !== E && o.tag !== H; ) {
            if (o.flags & Sn || o.child === null || o.tag === x)
              continue e;
            o.child.return = o, o = o.child;
          }
          if (!(o.flags & Sn))
            return o.stateNode;
        }
      }
      function xZ(a) {
        var o = gZ(a);
        switch (o.tag) {
          case w: {
            var d = o.stateNode;
            o.flags & ko && (PF(d), o.flags &= -33);
            var m = kI(a);
            YT(a, m, d);
            break;
          }
          case y:
          case x: {
            var b = o.stateNode.containerInfo, O = kI(a);
            WT(a, O, b);
            break;
          }
          // eslint-disable-next-line-no-fallthrough
          default:
            throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
      }
      function WT(a, o, d) {
        var m = a.tag, b = m === w || m === E;
        if (b) {
          var O = a.stateNode;
          o ? BQ(d, O, o) : FQ(d, O);
        } else if (m !== x) {
          var N = a.child;
          if (N !== null) {
            WT(N, o, d);
            for (var I = N.sibling; I !== null; )
              WT(I, o, d), I = I.sibling;
          }
        }
      }
      function YT(a, o, d) {
        var m = a.tag, b = m === w || m === E;
        if (b) {
          var O = a.stateNode;
          o ? IQ(d, O, o) : jQ(d, O);
        } else if (m !== x) {
          var N = a.child;
          if (N !== null) {
            YT(N, o, d);
            for (var I = N.sibling; I !== null; )
              YT(I, o, d), I = I.sibling;
          }
        }
      }
      var Ji = null, es = !1;
      function bZ(a, o, d) {
        {
          var m = o;
          e: for (; m !== null; ) {
            switch (m.tag) {
              case w: {
                Ji = m.stateNode, es = !1;
                break e;
              }
              case y: {
                Ji = m.stateNode.containerInfo, es = !0;
                break e;
              }
              case x: {
                Ji = m.stateNode.containerInfo, es = !0;
                break e;
              }
            }
            m = m.return;
          }
          if (Ji === null)
            throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
          RI(a, o, d), Ji = null, es = !1;
        }
        yZ(d);
      }
      function Ef(a, o, d) {
        for (var m = d.child; m !== null; )
          RI(a, o, m), m = m.sibling;
      }
      function RI(a, o, d) {
        switch (Pm(d), d.tag) {
          case w:
            Zi || Tv(d, o);
          // eslint-disable-next-line-no-fallthrough
          case E: {
            {
              var m = Ji, b = es;
              Ji = null, Ef(a, o, d), Ji = m, es = b, Ji !== null && (es ? $Q(Ji, d.stateNode) : LQ(Ji, d.stateNode));
            }
            return;
          }
          case H: {
            Ji !== null && (es ? zQ(Ji, d.stateNode) : iO(Ji, d.stateNode));
            return;
          }
          case x: {
            {
              var O = Ji, N = es;
              Ji = d.stateNode.containerInfo, es = !0, Ef(a, o, d), Ji = O, es = N;
            }
            return;
          }
          case p:
          case A:
          case M:
          case F: {
            if (!Zi) {
              var I = d.updateQueue;
              if (I !== null) {
                var L = I.lastEffect;
                if (L !== null) {
                  var G = L.next, K = G;
                  do {
                    var ve = K, pe = ve.destroy, Se = ve.tag;
                    pe !== void 0 && ((Se & Qs) !== fo ? Ow(d, o, pe) : (Se & wi) !== fo && (xd(d), d.mode & yr ? (Js(), Ow(d, o, pe), Zs(d)) : Ow(d, o, pe), Fm())), K = K.next;
                  } while (K !== G);
                }
              }
            }
            Ef(a, o, d);
            return;
          }
          case h: {
            if (!Zi) {
              Tv(d, o);
              var Oe = d.stateNode;
              typeof Oe.componentWillUnmount == "function" && VT(d, o, Oe);
            }
            Ef(a, o, d);
            return;
          }
          case Q: {
            Ef(a, o, d);
            return;
          }
          case W: {
            if (
              // TODO: Remove this dead flag
              d.mode & Gt
            ) {
              var Pe = Zi;
              Zi = Pe || d.memoizedState !== null, Ef(a, o, d), Zi = Pe;
            } else
              Ef(a, o, d);
            break;
          }
          default: {
            Ef(a, o, d);
            return;
          }
        }
      }
      function wZ(a) {
        a.memoizedState;
      }
      function EZ(a, o) {
        var d = o.memoizedState;
        if (d === null) {
          var m = o.alternate;
          if (m !== null) {
            var b = m.memoizedState;
            if (b !== null) {
              var O = b.dehydrated;
              O !== null && oK(O);
            }
          }
        }
      }
      function PI(a) {
        var o = a.updateQueue;
        if (o !== null) {
          a.updateQueue = null;
          var d = a.stateNode;
          d === null && (d = a.stateNode = new aZ()), o.forEach(function(m) {
            var b = gJ.bind(null, a, m);
            if (!d.has(m)) {
              if (d.add(m), ma)
                if (Cv !== null && Ov !== null)
                  ig(Ov, Cv);
                else
                  throw Error("Expected finished root and lanes to be set. This is a bug in React.");
              m.then(b, b);
            }
          });
        }
      }
      function SZ(a, o, d) {
        Cv = d, Ov = a, Nr(o), MI(o, a), Nr(o), Cv = null, Ov = null;
      }
      function ts(a, o, d) {
        var m = o.deletions;
        if (m !== null)
          for (var b = 0; b < m.length; b++) {
            var O = m[b];
            try {
              bZ(a, o, O);
            } catch (L) {
              sn(O, o, L);
            }
          }
        var N = Ss();
        if (o.subtreeFlags & Ms)
          for (var I = o.child; I !== null; )
            Nr(I), MI(I, a), I = I.sibling;
        Nr(N);
      }
      function MI(a, o, d) {
        var m = a.alternate, b = a.flags;
        switch (a.tag) {
          case p:
          case A:
          case M:
          case F: {
            if (ts(o, a), el(a), b & rr) {
              try {
                Ju(Qs | bi, a, a.return), wf(Qs | bi, a);
              } catch (Pt) {
                sn(a, a.return, Pt);
              }
              if (a.mode & yr) {
                try {
                  Js(), Ju(wi | bi, a, a.return);
                } catch (Pt) {
                  sn(a, a.return, Pt);
                }
                Zs(a);
              } else
                try {
                  Ju(wi | bi, a, a.return);
                } catch (Pt) {
                  sn(a, a.return, Pt);
                }
            }
            return;
          }
          case h: {
            ts(o, a), el(a), b & bn && m !== null && Tv(m, m.return);
            return;
          }
          case w: {
            ts(o, a), el(a), b & bn && m !== null && Tv(m, m.return);
            {
              if (a.flags & ko) {
                var O = a.stateNode;
                try {
                  PF(O);
                } catch (Pt) {
                  sn(a, a.return, Pt);
                }
              }
              if (b & rr) {
                var N = a.stateNode;
                if (N != null) {
                  var I = a.memoizedProps, L = m !== null ? m.memoizedProps : I, G = a.type, K = a.updateQueue;
                  if (a.updateQueue = null, K !== null)
                    try {
                      MQ(N, K, G, L, I, a);
                    } catch (Pt) {
                      sn(a, a.return, Pt);
                    }
                }
              }
            }
            return;
          }
          case E: {
            if (ts(o, a), el(a), b & rr) {
              if (a.stateNode === null)
                throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
              var ve = a.stateNode, pe = a.memoizedProps, Se = m !== null ? m.memoizedProps : pe;
              try {
                NQ(ve, Se, pe);
              } catch (Pt) {
                sn(a, a.return, Pt);
              }
            }
            return;
          }
          case y: {
            if (ts(o, a), el(a), b & rr && m !== null) {
              var Oe = m.memoizedState;
              if (Oe.isDehydrated)
                try {
                  aK(o.containerInfo);
                } catch (Pt) {
                  sn(a, a.return, Pt);
                }
            }
            return;
          }
          case x: {
            ts(o, a), el(a);
            return;
          }
          case T: {
            ts(o, a), el(a);
            var Pe = a.child;
            if (Pe.flags & jn) {
              var tt = Pe.stateNode, Ct = Pe.memoizedState, bt = Ct !== null;
              if (tt.isHidden = bt, bt) {
                var ar = Pe.alternate !== null && Pe.alternate.memoizedState !== null;
                ar || nJ();
              }
            }
            if (b & rr) {
              try {
                wZ(a);
              } catch (Pt) {
                sn(a, a.return, Pt);
              }
              PI(a);
            }
            return;
          }
          case W: {
            var Zt = m !== null && m.memoizedState !== null;
            if (
              // TODO: Remove this dead flag
              a.mode & Gt
            ) {
              var xe = Zi;
              Zi = xe || Zt, ts(o, a), Zi = xe;
            } else
              ts(o, a);
            if (el(a), b & jn) {
              var Me = a.stateNode, be = a.memoizedState, Ve = be !== null, ot = a;
              if (Me.isHidden = Ve, Ve && !Zt && (ot.mode & Gt) !== St) {
                ht = ot;
                for (var rt = ot.child; rt !== null; )
                  ht = rt, CZ(rt), rt = rt.sibling;
              }
              mZ(ot, Ve);
            }
            return;
          }
          case q: {
            ts(o, a), el(a), b & rr && PI(a);
            return;
          }
          case Q:
            return;
          default: {
            ts(o, a), el(a);
            return;
          }
        }
      }
      function el(a) {
        var o = a.flags;
        if (o & Sn) {
          try {
            xZ(a);
          } catch (d) {
            sn(a, a.return, d);
          }
          a.flags &= -3;
        }
        o & to && (a.flags &= -4097);
      }
      function _Z(a, o, d) {
        Cv = d, Ov = o, ht = a, NI(a, o, d), Cv = null, Ov = null;
      }
      function NI(a, o, d) {
        for (var m = (a.mode & Gt) !== St; ht !== null; ) {
          var b = ht, O = b.child;
          if (b.tag === W && m) {
            var N = b.memoizedState !== null, I = N || Cw;
            if (I) {
              GT(a, o, d);
              continue;
            } else {
              var L = b.alternate, G = L !== null && L.memoizedState !== null, K = G || Zi, ve = Cw, pe = Zi;
              Cw = I, Zi = K, Zi && !pe && (ht = b, OZ(b));
              for (var Se = O; Se !== null; )
                ht = Se, NI(
                  Se,
                  // New root; bubble back up to here and stop.
                  o,
                  d
                ), Se = Se.sibling;
              ht = b, Cw = ve, Zi = pe, GT(a, o, d);
              continue;
            }
          }
          (b.subtreeFlags & Ns) !== Et && O !== null ? (O.return = b, ht = O) : GT(a, o, d);
        }
      }
      function GT(a, o, d) {
        for (; ht !== null; ) {
          var m = ht;
          if ((m.flags & Ns) !== Et) {
            var b = m.alternate;
            Nr(m);
            try {
              hZ(o, b, m, d);
            } catch (N) {
              sn(m, m.return, N);
            }
            un();
          }
          if (m === a) {
            ht = null;
            return;
          }
          var O = m.sibling;
          if (O !== null) {
            O.return = m.return, ht = O;
            return;
          }
          ht = m.return;
        }
      }
      function CZ(a) {
        for (; ht !== null; ) {
          var o = ht, d = o.child;
          switch (o.tag) {
            case p:
            case A:
            case M:
            case F: {
              if (o.mode & yr)
                try {
                  Js(), Ju(wi, o, o.return);
                } finally {
                  Zs(o);
                }
              else
                Ju(wi, o, o.return);
              break;
            }
            case h: {
              Tv(o, o.return);
              var m = o.stateNode;
              typeof m.componentWillUnmount == "function" && VT(o, o.return, m);
              break;
            }
            case w: {
              Tv(o, o.return);
              break;
            }
            case W: {
              var b = o.memoizedState !== null;
              if (b) {
                jI(a);
                continue;
              }
              break;
            }
          }
          d !== null ? (d.return = o, ht = d) : jI(a);
        }
      }
      function jI(a) {
        for (; ht !== null; ) {
          var o = ht;
          if (o === a) {
            ht = null;
            return;
          }
          var d = o.sibling;
          if (d !== null) {
            d.return = o.return, ht = d;
            return;
          }
          ht = o.return;
        }
      }
      function OZ(a) {
        for (; ht !== null; ) {
          var o = ht, d = o.child;
          if (o.tag === W) {
            var m = o.memoizedState !== null;
            if (m) {
              FI(a);
              continue;
            }
          }
          d !== null ? (d.return = o, ht = d) : FI(a);
        }
      }
      function FI(a) {
        for (; ht !== null; ) {
          var o = ht;
          Nr(o);
          try {
            vZ(o);
          } catch (m) {
            sn(o, o.return, m);
          }
          if (un(), o === a) {
            ht = null;
            return;
          }
          var d = o.sibling;
          if (d !== null) {
            d.return = o.return, ht = d;
            return;
          }
          ht = o.return;
        }
      }
      function TZ(a, o, d, m) {
        ht = o, AZ(o, a, d, m);
      }
      function AZ(a, o, d, m) {
        for (; ht !== null; ) {
          var b = ht, O = b.child;
          (b.subtreeFlags & Bu) !== Et && O !== null ? (O.return = b, ht = O) : DZ(a, o, d, m);
        }
      }
      function DZ(a, o, d, m) {
        for (; ht !== null; ) {
          var b = ht;
          if ((b.flags & da) !== Et) {
            Nr(b);
            try {
              kZ(o, b, d, m);
            } catch (N) {
              sn(b, b.return, N);
            }
            un();
          }
          if (b === a) {
            ht = null;
            return;
          }
          var O = b.sibling;
          if (O !== null) {
            O.return = b.return, ht = O;
            return;
          }
          ht = b.return;
        }
      }
      function kZ(a, o, d, m) {
        switch (o.tag) {
          case p:
          case A:
          case F: {
            if (o.mode & yr) {
              pT();
              try {
                wf(Ki | bi, o);
              } finally {
                dT(o);
              }
            } else
              wf(Ki | bi, o);
            break;
          }
        }
      }
      function RZ(a) {
        ht = a, PZ();
      }
      function PZ() {
        for (; ht !== null; ) {
          var a = ht, o = a.child;
          if ((ht.flags & eo) !== Et) {
            var d = a.deletions;
            if (d !== null) {
              for (var m = 0; m < d.length; m++) {
                var b = d[m];
                ht = b, jZ(b, a);
              }
              {
                var O = a.alternate;
                if (O !== null) {
                  var N = O.child;
                  if (N !== null) {
                    O.child = null;
                    do {
                      var I = N.sibling;
                      N.sibling = null, N = I;
                    } while (N !== null);
                  }
                }
              }
              ht = a;
            }
          }
          (a.subtreeFlags & Bu) !== Et && o !== null ? (o.return = a, ht = o) : MZ();
        }
      }
      function MZ() {
        for (; ht !== null; ) {
          var a = ht;
          (a.flags & da) !== Et && (Nr(a), NZ(a), un());
          var o = a.sibling;
          if (o !== null) {
            o.return = a.return, ht = o;
            return;
          }
          ht = a.return;
        }
      }
      function NZ(a) {
        switch (a.tag) {
          case p:
          case A:
          case F: {
            a.mode & yr ? (pT(), Ju(Ki | bi, a, a.return), dT(a)) : Ju(Ki | bi, a, a.return);
            break;
          }
        }
      }
      function jZ(a, o) {
        for (; ht !== null; ) {
          var d = ht;
          Nr(d), IZ(d, o), un();
          var m = d.child;
          m !== null ? (m.return = d, ht = m) : FZ(a);
        }
      }
      function FZ(a) {
        for (; ht !== null; ) {
          var o = ht, d = o.sibling, m = o.return;
          if (AI(o), o === a) {
            ht = null;
            return;
          }
          if (d !== null) {
            d.return = m, ht = d;
            return;
          }
          ht = m;
        }
      }
      function IZ(a, o) {
        switch (a.tag) {
          case p:
          case A:
          case F: {
            a.mode & yr ? (pT(), Ju(Ki, a, o), dT(a)) : Ju(Ki, a, o);
            break;
          }
        }
      }
      function BZ(a) {
        switch (a.tag) {
          case p:
          case A:
          case F: {
            try {
              wf(wi | bi, a);
            } catch (d) {
              sn(a, a.return, d);
            }
            break;
          }
          case h: {
            var o = a.stateNode;
            try {
              o.componentDidMount();
            } catch (d) {
              sn(a, a.return, d);
            }
            break;
          }
        }
      }
      function LZ(a) {
        switch (a.tag) {
          case p:
          case A:
          case F: {
            try {
              wf(Ki | bi, a);
            } catch (o) {
              sn(a, a.return, o);
            }
            break;
          }
        }
      }
      function $Z(a) {
        switch (a.tag) {
          case p:
          case A:
          case F: {
            try {
              Ju(wi | bi, a, a.return);
            } catch (d) {
              sn(a, a.return, d);
            }
            break;
          }
          case h: {
            var o = a.stateNode;
            typeof o.componentWillUnmount == "function" && VT(a, a.return, o);
            break;
          }
        }
      }
      function zZ(a) {
        switch (a.tag) {
          case p:
          case A:
          case F:
            try {
              Ju(Ki | bi, a, a.return);
            } catch (o) {
              sn(a, a.return, o);
            }
        }
      }
      if (typeof Symbol == "function" && Symbol.for) {
        var Yy = Symbol.for;
        Yy("selector.component"), Yy("selector.has_pseudo_class"), Yy("selector.role"), Yy("selector.test_id"), Yy("selector.text");
      }
      var qZ = [];
      function UZ() {
        qZ.forEach(function(a) {
          return a();
        });
      }
      var HZ = r.ReactCurrentActQueue;
      function VZ(a) {
        {
          var o = (
            // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
            typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
          ), d = typeof jest < "u";
          return d && o !== !1;
        }
      }
      function II() {
        {
          var a = (
            // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
            typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
          );
          return !a && HZ.current !== null && s("The current testing environment is not configured to support act(...)"), a;
        }
      }
      var WZ = Math.ceil, QT = r.ReactCurrentDispatcher, KT = r.ReactCurrentOwner, ea = r.ReactCurrentBatchConfig, rs = r.ReactCurrentActQueue, _i = (
        /*             */
        0
      ), BI = (
        /*               */
        1
      ), ta = (
        /*                */
        2
      ), gu = (
        /*                */
        4
      ), rc = 0, Gy = 1, cp = 2, Tw = 3, Qy = 4, LI = 5, XT = 6, ir = _i, za = null, Dn = null, Ci = $e, tl = $e, ZT = df($e), Oi = rc, Ky = null, Aw = $e, Xy = $e, Dw = $e, Zy = null, po = null, JT = 0, $I = 500, zI = 1 / 0, YZ = 500, nc = null;
      function Jy() {
        zI = Xn() + YZ;
      }
      function qI() {
        return zI;
      }
      var kw = !1, eA = null, Av = null, fp = !1, Sf = null, eg = $e, tA = [], rA = null, GZ = 50, tg = 0, nA = null, iA = !1, Rw = !1, QZ = 50, Dv = 0, Pw = null, rg = Qr, Mw = $e, UI = !1;
      function Nw() {
        return za;
      }
      function qa() {
        return (ir & (ta | gu)) !== _i ? Xn() : (rg !== Qr || (rg = Xn()), rg);
      }
      function _f(a) {
        var o = a.mode;
        if ((o & Gt) === St)
          return Rt;
        if ((ir & ta) !== _i && Ci !== $e)
          return Pd(Ci);
        var d = HK() !== UK;
        if (d) {
          if (ea.transition !== null) {
            var m = ea.transition;
            m._updatedFibers || (m._updatedFibers = /* @__PURE__ */ new Set()), m._updatedFibers.add(a);
          }
          return Mw === fr && (Mw = Hm()), Mw;
        }
        var b = uo();
        if (b !== fr)
          return b;
        var O = AQ();
        return O;
      }
      function KZ(a) {
        var o = a.mode;
        return (o & Gt) === St ? Rt : Bb();
      }
      function Ti(a, o, d, m) {
        bJ(), UI && s("useInsertionEffect must not schedule updates."), iA && (Rw = !0), ef(a, d, m), (ir & ta) !== $e && a === za ? SJ(o) : (ma && jd(a, o, d), _J(o), a === za && ((ir & ta) === _i && (Xy = qt(Xy, d)), Oi === Qy && Cf(a, Ci)), ho(a, m), d === Rt && ir === _i && (o.mode & Gt) === St && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !rs.isBatchingLegacy && (Jy(), UF()));
      }
      function XZ(a, o, d) {
        var m = a.current;
        m.lanes = o, ef(a, o, d), ho(a, d);
      }
      function ZZ(a) {
        return (
          // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
          // decided not to enable it.
          (ir & ta) !== _i
        );
      }
      function ho(a, o) {
        var d = a.callbackNode;
        Bh(a, o);
        var m = Ih(a, a === za ? Ci : $e);
        if (m === $e) {
          d !== null && a8(d), a.callbackNode = null, a.callbackPriority = fr;
          return;
        }
        var b = Ls(m), O = a.callbackPriority;
        if (O === b && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(rs.current !== null && d !== fA)) {
          d == null && O !== Rt && s("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        d != null && a8(d);
        var N;
        if (b === Rt)
          a.tag === pf ? (rs.isBatchingLegacy !== null && (rs.didScheduleLegacyUpdate = !0), OK(WI.bind(null, a))) : qF(WI.bind(null, a)), rs.current !== null ? rs.current.push(hf) : kQ(function() {
            (ir & (ta | gu)) === _i && hf();
          }), N = null;
        else {
          var I;
          switch (Vb(m)) {
            case Hi:
              I = gd;
              break;
            case su:
              I = js;
              break;
            case ao:
              I = Lu;
              break;
            case oo:
              I = kl;
              break;
            default:
              I = Lu;
              break;
          }
          N = dA(I, HI.bind(null, a));
        }
        a.callbackPriority = b, a.callbackNode = N;
      }
      function HI(a, o) {
        if (mX(), rg = Qr, Mw = $e, (ir & (ta | gu)) !== _i)
          throw new Error("Should not already be working.");
        var d = a.callbackNode, m = ac();
        if (m && a.callbackNode !== d)
          return null;
        var b = Ih(a, a === za ? Ci : $e);
        if (b === $e)
          return null;
        var O = !$h(a, b) && !Ib(a, b) && !o, N = O ? sJ(a, b) : Fw(a, b);
        if (N !== rc) {
          if (N === cp) {
            var I = Lh(a);
            I !== $e && (b = I, N = aA(a, I));
          }
          if (N === Gy) {
            var L = Ky;
            throw dp(a, $e), Cf(a, b), ho(a, Xn()), L;
          }
          if (N === XT)
            Cf(a, b);
          else {
            var G = !$h(a, b), K = a.current.alternate;
            if (G && !eJ(K)) {
              if (N = Fw(a, b), N === cp) {
                var ve = Lh(a);
                ve !== $e && (b = ve, N = aA(a, ve));
              }
              if (N === Gy) {
                var pe = Ky;
                throw dp(a, $e), Cf(a, b), ho(a, Xn()), pe;
              }
            }
            a.finishedWork = K, a.finishedLanes = b, JZ(a, N, b);
          }
        }
        return ho(a, Xn()), a.callbackNode === d ? HI.bind(null, a) : null;
      }
      function aA(a, o) {
        var d = Zy;
        if (Uh(a)) {
          var m = dp(a, o);
          m.flags |= fa, xK(a.containerInfo);
        }
        var b = Fw(a, o);
        if (b !== cp) {
          var O = po;
          po = d, O !== null && VI(O);
        }
        return b;
      }
      function VI(a) {
        po === null ? po = a : po.push.apply(po, a);
      }
      function JZ(a, o, d) {
        switch (o) {
          case rc:
          case Gy:
            throw new Error("Root did not complete. This is a bug in React.");
          // Flow knows about invariant, so it complains if I add a break
          // statement, but eslint doesn't know about invariant, so it complains
          // if I do. eslint-disable-next-line no-fallthrough
          case cp: {
            pp(a, po, nc);
            break;
          }
          case Tw: {
            if (Cf(a, d), zl(d) && // do not delay if we're inside an act() scope
            !o8()) {
              var m = JT + $I - Xn();
              if (m > 10) {
                var b = Ih(a, $e);
                if (b !== $e)
                  break;
                var O = a.suspendedLanes;
                if (!ql(O, d)) {
                  qa(), zh(a, O);
                  break;
                }
                a.timeoutHandle = rO(pp.bind(null, a, po, nc), m);
                break;
              }
            }
            pp(a, po, nc);
            break;
          }
          case Qy: {
            if (Cf(a, d), qm(d))
              break;
            if (!o8()) {
              var N = Po(a, d), I = N, L = Xn() - I, G = xJ(L) - L;
              if (G > 10) {
                a.timeoutHandle = rO(pp.bind(null, a, po, nc), G);
                break;
              }
            }
            pp(a, po, nc);
            break;
          }
          case LI: {
            pp(a, po, nc);
            break;
          }
          default:
            throw new Error("Unknown root exit status.");
        }
      }
      function eJ(a) {
        for (var o = a; ; ) {
          if (o.flags & Qc) {
            var d = o.updateQueue;
            if (d !== null) {
              var m = d.stores;
              if (m !== null)
                for (var b = 0; b < m.length; b++) {
                  var O = m[b], N = O.getSnapshot, I = O.value;
                  try {
                    if (!Ue(N(), I))
                      return !1;
                  } catch {
                    return !1;
                  }
                }
            }
          }
          var L = o.child;
          if (o.subtreeFlags & Qc && L !== null) {
            L.return = o, o = L;
            continue;
          }
          if (o === a)
            return !0;
          for (; o.sibling === null; ) {
            if (o.return === null || o.return === a)
              return !0;
            o = o.return;
          }
          o.sibling.return = o.return, o = o.sibling;
        }
        return !0;
      }
      function Cf(a, o) {
        o = Md(o, Dw), o = Md(o, Xy), zb(a, o);
      }
      function WI(a) {
        if (yX(), (ir & (ta | gu)) !== _i)
          throw new Error("Should not already be working.");
        ac();
        var o = Ih(a, $e);
        if (!ya(o, Rt))
          return ho(a, Xn()), null;
        var d = Fw(a, o);
        if (a.tag !== pf && d === cp) {
          var m = Lh(a);
          m !== $e && (o = m, d = aA(a, m));
        }
        if (d === Gy) {
          var b = Ky;
          throw dp(a, $e), Cf(a, o), ho(a, Xn()), b;
        }
        if (d === XT)
          throw new Error("Root did not complete. This is a bug in React.");
        var O = a.current.alternate;
        return a.finishedWork = O, a.finishedLanes = o, pp(a, po, nc), ho(a, Xn()), null;
      }
      function tJ(a, o) {
        o !== $e && (qh(a, qt(o, Rt)), ho(a, Xn()), (ir & (ta | gu)) === _i && (Jy(), hf()));
      }
      function oA(a, o) {
        var d = ir;
        ir |= BI;
        try {
          return a(o);
        } finally {
          ir = d, ir === _i && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
          !rs.isBatchingLegacy && (Jy(), UF());
        }
      }
      function rJ(a, o, d, m, b) {
        var O = uo(), N = ea.transition;
        try {
          return ea.transition = null, Ln(Hi), a(o, d, m, b);
        } finally {
          Ln(O), ea.transition = N, ir === _i && Jy();
        }
      }
      function ic(a) {
        Sf !== null && Sf.tag === pf && (ir & (ta | gu)) === _i && ac();
        var o = ir;
        ir |= BI;
        var d = ea.transition, m = uo();
        try {
          return ea.transition = null, Ln(Hi), a ? a() : void 0;
        } finally {
          Ln(m), ea.transition = d, ir = o, (ir & (ta | gu)) === _i && hf();
        }
      }
      function YI() {
        return (ir & (ta | gu)) !== _i;
      }
      function jw(a, o) {
        Ea(ZT, tl, a), tl = qt(tl, o);
      }
      function uA(a) {
        tl = ZT.current, wa(ZT, a);
      }
      function dp(a, o) {
        a.finishedWork = null, a.finishedLanes = $e;
        var d = a.timeoutHandle;
        if (d !== nO && (a.timeoutHandle = nO, DQ(d)), Dn !== null)
          for (var m = Dn.return; m !== null; ) {
            var b = m.alternate;
            EI(b, m), m = m.return;
          }
        za = a;
        var O = hp(a.current, null);
        return Dn = O, Ci = tl = o, Oi = rc, Ky = null, Aw = $e, Xy = $e, Dw = $e, Zy = null, po = null, XK(), Gu.discardPendingWarnings(), O;
      }
      function GI(a, o) {
        do {
          var d = Dn;
          try {
            if (V1(), g4(), un(), KT.current = null, d === null || d.return === null) {
              Oi = Gy, Ky = o, Dn = null;
              return;
            }
            if (ae && d.mode & yr && bw(d, !0), te)
              if (Fa(), o !== null && typeof o == "object" && typeof o.then == "function") {
                var m = o;
                uu(d, m, Ci);
              } else
                bd(d, o, Ci);
            OX(a, d.return, d, o, Ci), ZI(d);
          } catch (b) {
            o = b, Dn === d && d !== null ? (d = d.return, Dn = d) : d = Dn;
            continue;
          }
          return;
        } while (!0);
      }
      function QI() {
        var a = QT.current;
        return QT.current = vw, a === null ? vw : a;
      }
      function KI(a) {
        QT.current = a;
      }
      function nJ() {
        JT = Xn();
      }
      function ng(a) {
        Aw = qt(a, Aw);
      }
      function iJ() {
        Oi === rc && (Oi = Tw);
      }
      function sA() {
        (Oi === rc || Oi === Tw || Oi === cp) && (Oi = Qy), za !== null && (Rd(Aw) || Rd(Xy)) && Cf(za, Ci);
      }
      function aJ(a) {
        Oi !== Qy && (Oi = cp), Zy === null ? Zy = [a] : Zy.push(a);
      }
      function oJ() {
        return Oi === rc;
      }
      function Fw(a, o) {
        var d = ir;
        ir |= ta;
        var m = QI();
        if (za !== a || Ci !== o) {
          if (ma) {
            var b = a.memoizedUpdaters;
            b.size > 0 && (ig(a, Ci), b.clear()), qb(a, o);
          }
          nc = Gm(), dp(a, o);
        }
        Nl(o);
        do
          try {
            uJ();
            break;
          } catch (O) {
            GI(a, O);
          }
        while (!0);
        if (V1(), ir = d, KI(m), Dn !== null)
          throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        return xh(), za = null, Ci = $e, Oi;
      }
      function uJ() {
        for (; Dn !== null; )
          XI(Dn);
      }
      function sJ(a, o) {
        var d = ir;
        ir |= ta;
        var m = QI();
        if (za !== a || Ci !== o) {
          if (ma) {
            var b = a.memoizedUpdaters;
            b.size > 0 && (ig(a, Ci), b.clear()), qb(a, o);
          }
          nc = Gm(), Jy(), dp(a, o);
        }
        Nl(o);
        do
          try {
            lJ();
            break;
          } catch (O) {
            GI(a, O);
          }
        while (!0);
        return V1(), KI(m), ir = d, Dn !== null ? (Mb(), rc) : (xh(), za = null, Ci = $e, Oi);
      }
      function lJ() {
        for (; Dn !== null && !Tm(); )
          XI(Dn);
      }
      function XI(a) {
        var o = a.alternate;
        Nr(a);
        var d;
        (a.mode & yr) !== St ? (fT(a), d = lA(o, a, tl), bw(a, !0)) : d = lA(o, a, tl), un(), a.memoizedProps = a.pendingProps, d === null ? ZI(a) : Dn = d, KT.current = null;
      }
      function ZI(a) {
        var o = a;
        do {
          var d = o.alternate, m = o.return;
          if ((o.flags & yd) === Et) {
            Nr(o);
            var b = void 0;
            if ((o.mode & yr) === St ? b = wI(d, o, tl) : (fT(o), b = wI(d, o, tl), bw(o, !1)), un(), b !== null) {
              Dn = b;
              return;
            }
          } else {
            var O = iZ(d, o);
            if (O !== null) {
              O.flags &= Tb, Dn = O;
              return;
            }
            if ((o.mode & yr) !== St) {
              bw(o, !1);
              for (var N = o.actualDuration, I = o.child; I !== null; )
                N += I.actualDuration, I = I.sibling;
              o.actualDuration = N;
            }
            if (m !== null)
              m.flags |= yd, m.subtreeFlags = Et, m.deletions = null;
            else {
              Oi = XT, Dn = null;
              return;
            }
          }
          var L = o.sibling;
          if (L !== null) {
            Dn = L;
            return;
          }
          o = m, Dn = o;
        } while (o !== null);
        Oi === rc && (Oi = LI);
      }
      function pp(a, o, d) {
        var m = uo(), b = ea.transition;
        try {
          ea.transition = null, Ln(Hi), cJ(a, o, d, m);
        } finally {
          ea.transition = b, Ln(m);
        }
        return null;
      }
      function cJ(a, o, d, m) {
        do
          ac();
        while (Sf !== null);
        if (wJ(), (ir & (ta | gu)) !== _i)
          throw new Error("Should not already be working.");
        var b = a.finishedWork, O = a.finishedLanes;
        if (Mm(O), b === null)
          return Nm(), null;
        if (O === $e && s("root.finishedLanes should not be empty during a commit. This is a bug in React."), a.finishedWork = null, a.finishedLanes = $e, b === a.current)
          throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
        a.callbackNode = null, a.callbackPriority = fr;
        var N = qt(b.lanes, b.childLanes);
        Wm(a, N), a === za && (za = null, Dn = null, Ci = $e), ((b.subtreeFlags & Bu) !== Et || (b.flags & Bu) !== Et) && (fp || (fp = !0, rA = d, dA(Lu, function() {
          return ac(), null;
        })));
        var I = (b.subtreeFlags & (Ps | Ms | Ns | Bu)) !== Et, L = (b.flags & (Ps | Ms | Ns | Bu)) !== Et;
        if (I || L) {
          var G = ea.transition;
          ea.transition = null;
          var K = uo();
          Ln(Hi);
          var ve = ir;
          ir |= gu, KT.current = null, lZ(a, b), U4(), SZ(a, b, O), EQ(a.containerInfo), a.current = b, wd(O), _Z(b, a, O), Ed(), Am(), ir = ve, Ln(K), ea.transition = G;
        } else
          a.current = b, U4();
        var pe = fp;
        if (fp ? (fp = !1, Sf = a, eg = O) : (Dv = 0, Pw = null), N = a.pendingLanes, N === $e && (Av = null), pe || r8(a.current, !1), km(b.stateNode, m), ma && a.memoizedUpdaters.clear(), UZ(), ho(a, Xn()), o !== null)
          for (var Se = a.onRecoverableError, Oe = 0; Oe < o.length; Oe++) {
            var Pe = o[Oe], tt = Pe.stack, Ct = Pe.digest;
            Se(Pe.value, {
              componentStack: tt,
              digest: Ct
            });
          }
        if (kw) {
          kw = !1;
          var bt = eA;
          throw eA = null, bt;
        }
        return ya(eg, Rt) && a.tag !== pf && ac(), N = a.pendingLanes, ya(N, Rt) ? (vX(), a === nA ? tg++ : (tg = 0, nA = a)) : tg = 0, hf(), Nm(), null;
      }
      function ac() {
        if (Sf !== null) {
          var a = Vb(eg), o = Id(ao, a), d = ea.transition, m = uo();
          try {
            return ea.transition = null, Ln(o), dJ();
          } finally {
            Ln(m), ea.transition = d;
          }
        }
        return !1;
      }
      function fJ(a) {
        tA.push(a), fp || (fp = !0, dA(Lu, function() {
          return ac(), null;
        }));
      }
      function dJ() {
        if (Sf === null)
          return !1;
        var a = rA;
        rA = null;
        var o = Sf, d = eg;
        if (Sf = null, eg = $e, (ir & (ta | gu)) !== _i)
          throw new Error("Cannot flush passive effects while already rendering.");
        iA = !0, Rw = !1, Ml(d);
        var m = ir;
        ir |= gu, RZ(o.current), TZ(o, o.current, d, a);
        {
          var b = tA;
          tA = [];
          for (var O = 0; O < b.length; O++) {
            var N = b[O];
            pZ(o, N);
          }
        }
        Im(), r8(o.current, !0), ir = m, hf(), Rw ? o === Pw ? Dv++ : (Dv = 0, Pw = o) : Dv = 0, iA = !1, Rw = !1, Rm(o);
        {
          var I = o.current.stateNode;
          I.effectDuration = 0, I.passiveEffectDuration = 0;
        }
        return !0;
      }
      function JI(a) {
        return Av !== null && Av.has(a);
      }
      function pJ(a) {
        Av === null ? Av = /* @__PURE__ */ new Set([a]) : Av.add(a);
      }
      function hJ(a) {
        kw || (kw = !0, eA = a);
      }
      var vJ = hJ;
      function e8(a, o, d) {
        var m = sp(d, o), b = X4(a, m, Rt), O = mf(a, b, Rt), N = qa();
        O !== null && (ef(O, Rt, N), ho(O, N));
      }
      function sn(a, o, d) {
        if (oZ(d), ag(!1), a.tag === y) {
          e8(a, a, d);
          return;
        }
        var m = null;
        for (m = o; m !== null; ) {
          if (m.tag === y) {
            e8(m, a, d);
            return;
          } else if (m.tag === h) {
            var b = m.type, O = m.stateNode;
            if (typeof b.getDerivedStateFromError == "function" || typeof O.componentDidCatch == "function" && !JI(O)) {
              var N = sp(d, a), I = DT(m, N, Rt), L = mf(m, I, Rt), G = qa();
              L !== null && (ef(L, Rt, G), ho(L, G));
              return;
            }
          }
          m = m.return;
        }
        s(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, d);
      }
      function mJ(a, o, d) {
        var m = a.pingCache;
        m !== null && m.delete(o);
        var b = qa();
        zh(a, d), CJ(a), za === a && ql(Ci, d) && (Oi === Qy || Oi === Tw && zl(Ci) && Xn() - JT < $I ? dp(a, $e) : Dw = qt(Dw, d)), ho(a, b);
      }
      function t8(a, o) {
        o === fr && (o = KZ(a));
        var d = qa(), m = co(a, o);
        m !== null && (ef(m, o, d), ho(m, d));
      }
      function yJ(a) {
        var o = a.memoizedState, d = fr;
        o !== null && (d = o.retryLane), t8(a, d);
      }
      function gJ(a, o) {
        var d = fr, m;
        switch (a.tag) {
          case T:
            m = a.stateNode;
            var b = a.memoizedState;
            b !== null && (d = b.retryLane);
            break;
          case q:
            m = a.stateNode;
            break;
          default:
            throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        m !== null && m.delete(o), t8(a, d);
      }
      function xJ(a) {
        return a < 120 ? 120 : a < 480 ? 480 : a < 1080 ? 1080 : a < 1920 ? 1920 : a < 3e3 ? 3e3 : a < 4320 ? 4320 : WZ(a / 1960) * 1960;
      }
      function bJ() {
        if (tg > GZ)
          throw tg = 0, nA = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        Dv > QZ && (Dv = 0, Pw = null, s("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
      }
      function wJ() {
        Gu.flushLegacyContextWarning(), Gu.flushPendingUnsafeLifecycleWarnings();
      }
      function r8(a, o) {
        Nr(a), Iw(a, Rs, $Z), o && Iw(a, iu, zZ), Iw(a, Rs, BZ), o && Iw(a, iu, LZ), un();
      }
      function Iw(a, o, d) {
        for (var m = a, b = null; m !== null; ) {
          var O = m.subtreeFlags & o;
          m !== b && m.child !== null && O !== Et ? m = m.child : ((m.flags & o) !== Et && d(m), m.sibling !== null ? m = m.sibling : m = b = m.return);
        }
      }
      var Bw = null;
      function n8(a) {
        {
          if ((ir & ta) !== _i || !(a.mode & Gt))
            return;
          var o = a.tag;
          if (o !== v && o !== y && o !== h && o !== p && o !== A && o !== M && o !== F)
            return;
          var d = Ft(a) || "ReactComponent";
          if (Bw !== null) {
            if (Bw.has(d))
              return;
            Bw.add(d);
          } else
            Bw = /* @__PURE__ */ new Set([d]);
          var m = vi;
          try {
            Nr(a), s("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
          } finally {
            m ? Nr(a) : un();
          }
        }
      }
      var lA;
      {
        var EJ = null;
        lA = function(a, o, d) {
          var m = f8(EJ, o);
          try {
            return mI(a, o, d);
          } catch (O) {
            if (NK() || O !== null && typeof O == "object" && typeof O.then == "function")
              throw O;
            if (V1(), g4(), EI(a, o), f8(o, m), o.mode & yr && fT(o), ks(null, mI, null, a, o, d), Fu()) {
              var b = md();
              typeof b == "object" && b !== null && b._suppressLogging && typeof O == "object" && O !== null && !O._suppressLogging && (O._suppressLogging = !0);
            }
            throw O;
          }
        };
      }
      var i8 = !1, cA;
      cA = /* @__PURE__ */ new Set();
      function SJ(a) {
        if (Xo && !dX())
          switch (a.tag) {
            case p:
            case A:
            case F: {
              var o = Dn && Ft(Dn) || "Unknown", d = o;
              if (!cA.has(d)) {
                cA.add(d);
                var m = Ft(a) || "Unknown";
                s("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", m, o, o);
              }
              break;
            }
            case h: {
              i8 || (s("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), i8 = !0);
              break;
            }
          }
      }
      function ig(a, o) {
        if (ma) {
          var d = a.memoizedUpdaters;
          d.forEach(function(m) {
            jd(a, m, o);
          });
        }
      }
      var fA = {};
      function dA(a, o) {
        {
          var d = rs.current;
          return d !== null ? (d.push(o), fA) : Om(a, o);
        }
      }
      function a8(a) {
        if (a !== fA)
          return Db(a);
      }
      function o8() {
        return rs.current !== null;
      }
      function _J(a) {
        {
          if (a.mode & Gt) {
            if (!II())
              return;
          } else if (!VZ() || ir !== _i || a.tag !== p && a.tag !== A && a.tag !== F)
            return;
          if (rs.current === null) {
            var o = vi;
            try {
              Nr(a), s(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, Ft(a));
            } finally {
              o ? Nr(a) : un();
            }
          }
        }
      }
      function CJ(a) {
        a.tag !== pf && II() && rs.current === null && s(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
      }
      function ag(a) {
        UI = a;
      }
      var xu = null, kv = null, OJ = function(a) {
        xu = a;
      };
      function Rv(a) {
        {
          if (xu === null)
            return a;
          var o = xu(a);
          return o === void 0 ? a : o.current;
        }
      }
      function pA(a) {
        return Rv(a);
      }
      function hA(a) {
        {
          if (xu === null)
            return a;
          var o = xu(a);
          if (o === void 0) {
            if (a != null && typeof a.render == "function") {
              var d = Rv(a.render);
              if (a.render !== d) {
                var m = {
                  $$typeof: Le,
                  render: d
                };
                return a.displayName !== void 0 && (m.displayName = a.displayName), m;
              }
            }
            return a;
          }
          return o.current;
        }
      }
      function u8(a, o) {
        {
          if (xu === null)
            return !1;
          var d = a.elementType, m = o.type, b = !1, O = typeof m == "object" && m !== null ? m.$$typeof : null;
          switch (a.tag) {
            case h: {
              typeof m == "function" && (b = !0);
              break;
            }
            case p: {
              (typeof m == "function" || O === It) && (b = !0);
              break;
            }
            case A: {
              (O === Le || O === It) && (b = !0);
              break;
            }
            case M:
            case F: {
              (O === $t || O === It) && (b = !0);
              break;
            }
            default:
              return !1;
          }
          if (b) {
            var N = xu(d);
            if (N !== void 0 && N === xu(m))
              return !0;
          }
          return !1;
        }
      }
      function s8(a) {
        {
          if (xu === null || typeof WeakSet != "function")
            return;
          kv === null && (kv = /* @__PURE__ */ new WeakSet()), kv.add(a);
        }
      }
      var TJ = function(a, o) {
        {
          if (xu === null)
            return;
          var d = o.staleFamilies, m = o.updatedFamilies;
          ac(), ic(function() {
            vA(a.current, m, d);
          });
        }
      }, AJ = function(a, o) {
        {
          if (a.context !== jo)
            return;
          ac(), ic(function() {
            og(o, a, null, null);
          });
        }
      };
      function vA(a, o, d) {
        {
          var m = a.alternate, b = a.child, O = a.sibling, N = a.tag, I = a.type, L = null;
          switch (N) {
            case p:
            case F:
            case h:
              L = I;
              break;
            case A:
              L = I.render;
              break;
          }
          if (xu === null)
            throw new Error("Expected resolveFamily to be set during hot reload.");
          var G = !1, K = !1;
          if (L !== null) {
            var ve = xu(L);
            ve !== void 0 && (d.has(ve) ? K = !0 : o.has(ve) && (N === h ? K = !0 : G = !0));
          }
          if (kv !== null && (kv.has(a) || m !== null && kv.has(m)) && (K = !0), K && (a._debugNeedsRemount = !0), K || G) {
            var pe = co(a, Rt);
            pe !== null && Ti(pe, a, Rt, Qr);
          }
          b !== null && !K && vA(b, o, d), O !== null && vA(O, o, d);
        }
      }
      var DJ = function(a, o) {
        {
          var d = /* @__PURE__ */ new Set(), m = new Set(o.map(function(b) {
            return b.current;
          }));
          return mA(a.current, m, d), d;
        }
      };
      function mA(a, o, d) {
        {
          var m = a.child, b = a.sibling, O = a.tag, N = a.type, I = null;
          switch (O) {
            case p:
            case F:
            case h:
              I = N;
              break;
            case A:
              I = N.render;
              break;
          }
          var L = !1;
          I !== null && o.has(I) && (L = !0), L ? kJ(a, d) : m !== null && mA(m, o, d), b !== null && mA(b, o, d);
        }
      }
      function kJ(a, o) {
        {
          var d = RJ(a, o);
          if (d)
            return;
          for (var m = a; ; ) {
            switch (m.tag) {
              case w:
                o.add(m.stateNode);
                return;
              case x:
                o.add(m.stateNode.containerInfo);
                return;
              case y:
                o.add(m.stateNode.containerInfo);
                return;
            }
            if (m.return === null)
              throw new Error("Expected to reach root first.");
            m = m.return;
          }
        }
      }
      function RJ(a, o) {
        for (var d = a, m = !1; ; ) {
          if (d.tag === w)
            m = !0, o.add(d.stateNode);
          else if (d.child !== null) {
            d.child.return = d, d = d.child;
            continue;
          }
          if (d === a)
            return m;
          for (; d.sibling === null; ) {
            if (d.return === null || d.return === a)
              return m;
            d = d.return;
          }
          d.sibling.return = d.return, d = d.sibling;
        }
        return !1;
      }
      var yA;
      {
        yA = !1;
        try {
          var l8 = Object.preventExtensions({});
        } catch {
          yA = !0;
        }
      }
      function PJ(a, o, d, m) {
        this.tag = a, this.key = d, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = o, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = m, this.flags = Et, this.subtreeFlags = Et, this.deletions = null, this.lanes = $e, this.childLanes = $e, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !yA && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
      }
      var Fo = function(a, o, d, m) {
        return new PJ(a, o, d, m);
      };
      function gA(a) {
        var o = a.prototype;
        return !!(o && o.isReactComponent);
      }
      function MJ(a) {
        return typeof a == "function" && !gA(a) && a.defaultProps === void 0;
      }
      function NJ(a) {
        if (typeof a == "function")
          return gA(a) ? h : p;
        if (a != null) {
          var o = a.$$typeof;
          if (o === Le)
            return A;
          if (o === $t)
            return M;
        }
        return v;
      }
      function hp(a, o) {
        var d = a.alternate;
        d === null ? (d = Fo(a.tag, o, a.key, a.mode), d.elementType = a.elementType, d.type = a.type, d.stateNode = a.stateNode, d._debugSource = a._debugSource, d._debugOwner = a._debugOwner, d._debugHookTypes = a._debugHookTypes, d.alternate = a, a.alternate = d) : (d.pendingProps = o, d.type = a.type, d.flags = Et, d.subtreeFlags = Et, d.deletions = null, d.actualDuration = 0, d.actualStartTime = -1), d.flags = a.flags & Fn, d.childLanes = a.childLanes, d.lanes = a.lanes, d.child = a.child, d.memoizedProps = a.memoizedProps, d.memoizedState = a.memoizedState, d.updateQueue = a.updateQueue;
        var m = a.dependencies;
        switch (d.dependencies = m === null ? null : {
          lanes: m.lanes,
          firstContext: m.firstContext
        }, d.sibling = a.sibling, d.index = a.index, d.ref = a.ref, d.selfBaseDuration = a.selfBaseDuration, d.treeBaseDuration = a.treeBaseDuration, d._debugNeedsRemount = a._debugNeedsRemount, d.tag) {
          case v:
          case p:
          case F:
            d.type = Rv(a.type);
            break;
          case h:
            d.type = pA(a.type);
            break;
          case A:
            d.type = hA(a.type);
            break;
        }
        return d;
      }
      function jJ(a, o) {
        a.flags &= Fn | Sn;
        var d = a.alternate;
        if (d === null)
          a.childLanes = $e, a.lanes = o, a.child = null, a.subtreeFlags = Et, a.memoizedProps = null, a.memoizedState = null, a.updateQueue = null, a.dependencies = null, a.stateNode = null, a.selfBaseDuration = 0, a.treeBaseDuration = 0;
        else {
          a.childLanes = d.childLanes, a.lanes = d.lanes, a.child = d.child, a.subtreeFlags = Et, a.deletions = null, a.memoizedProps = d.memoizedProps, a.memoizedState = d.memoizedState, a.updateQueue = d.updateQueue, a.type = d.type;
          var m = d.dependencies;
          a.dependencies = m === null ? null : {
            lanes: m.lanes,
            firstContext: m.firstContext
          }, a.selfBaseDuration = d.selfBaseDuration, a.treeBaseDuration = d.treeBaseDuration;
        }
        return a;
      }
      function FJ(a, o, d) {
        var m;
        return a === j1 ? (m = Gt, o === !0 && (m |= Ir, m |= gr)) : m = St, ma && (m |= yr), Fo(y, null, null, m);
      }
      function xA(a, o, d, m, b, O) {
        var N = v, I = a;
        if (typeof a == "function")
          gA(a) ? (N = h, I = pA(I)) : I = Rv(I);
        else if (typeof a == "string")
          N = w;
        else
          e: switch (a) {
            case Gn:
              return Of(d.children, b, O, o);
            case sa:
              N = S, b |= Ir, (b & Gt) !== St && (b |= gr);
              break;
            case Qa:
              return IJ(d, b, O, o);
            case Je:
              return BJ(d, b, O, o);
            case lt:
              return LJ(d, b, O, o);
            case En:
              return c8(d, b, O, o);
            case tn:
            // eslint-disable-next-line no-fallthrough
            case Kt:
            // eslint-disable-next-line no-fallthrough
            case on:
            // eslint-disable-next-line no-fallthrough
            case hi:
            // eslint-disable-next-line no-fallthrough
            case Yt:
            // eslint-disable-next-line no-fallthrough
            default: {
              if (typeof a == "object" && a !== null)
                switch (a.$$typeof) {
                  case Qo:
                    N = D;
                    break e;
                  case ue:
                    N = k;
                    break e;
                  case Le:
                    N = A, I = hA(I);
                    break e;
                  case $t:
                    N = M;
                    break e;
                  case It:
                    N = B, I = null;
                    break e;
                }
              var L = "";
              {
                (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (L += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
                var G = m ? Ft(m) : null;
                G && (L += `

Check the render method of \`` + G + "`.");
              }
              throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (a == null ? a : typeof a) + "." + L));
            }
          }
        var K = Fo(N, d, o, b);
        return K.elementType = a, K.type = I, K.lanes = O, K._debugOwner = m, K;
      }
      function bA(a, o, d) {
        var m = null;
        m = a._owner;
        var b = a.type, O = a.key, N = a.props, I = xA(b, O, N, m, o, d);
        return I._debugSource = a._source, I._debugOwner = a._owner, I;
      }
      function Of(a, o, d, m) {
        var b = Fo(C, a, m, o);
        return b.lanes = d, b;
      }
      function IJ(a, o, d, m) {
        typeof a.id != "string" && s('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof a.id);
        var b = Fo(R, a, m, o | yr);
        return b.elementType = Qa, b.lanes = d, b.stateNode = {
          effectDuration: 0,
          passiveEffectDuration: 0
        }, b;
      }
      function BJ(a, o, d, m) {
        var b = Fo(T, a, m, o);
        return b.elementType = Je, b.lanes = d, b;
      }
      function LJ(a, o, d, m) {
        var b = Fo(q, a, m, o);
        return b.elementType = lt, b.lanes = d, b;
      }
      function c8(a, o, d, m) {
        var b = Fo(W, a, m, o);
        b.elementType = En, b.lanes = d;
        var O = {
          isHidden: !1
        };
        return b.stateNode = O, b;
      }
      function wA(a, o, d) {
        var m = Fo(E, a, null, o);
        return m.lanes = d, m;
      }
      function $J() {
        var a = Fo(w, null, null, St);
        return a.elementType = "DELETED", a;
      }
      function zJ(a) {
        var o = Fo(H, null, null, St);
        return o.stateNode = a, o;
      }
      function EA(a, o, d) {
        var m = a.children !== null ? a.children : [], b = Fo(x, m, a.key, o);
        return b.lanes = d, b.stateNode = {
          containerInfo: a.containerInfo,
          pendingChildren: null,
          // Used by persistent updates
          implementation: a.implementation
        }, b;
      }
      function f8(a, o) {
        return a === null && (a = Fo(v, null, null, St)), a.tag = o.tag, a.key = o.key, a.elementType = o.elementType, a.type = o.type, a.stateNode = o.stateNode, a.return = o.return, a.child = o.child, a.sibling = o.sibling, a.index = o.index, a.ref = o.ref, a.pendingProps = o.pendingProps, a.memoizedProps = o.memoizedProps, a.updateQueue = o.updateQueue, a.memoizedState = o.memoizedState, a.dependencies = o.dependencies, a.mode = o.mode, a.flags = o.flags, a.subtreeFlags = o.subtreeFlags, a.deletions = o.deletions, a.lanes = o.lanes, a.childLanes = o.childLanes, a.alternate = o.alternate, a.actualDuration = o.actualDuration, a.actualStartTime = o.actualStartTime, a.selfBaseDuration = o.selfBaseDuration, a.treeBaseDuration = o.treeBaseDuration, a._debugSource = o._debugSource, a._debugOwner = o._debugOwner, a._debugNeedsRemount = o._debugNeedsRemount, a._debugHookTypes = o._debugHookTypes, a;
      }
      function qJ(a, o, d, m, b) {
        this.tag = o, this.containerInfo = a, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = nO, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = fr, this.eventTimes = Nd($e), this.expirationTimes = Nd(Qr), this.pendingLanes = $e, this.suspendedLanes = $e, this.pingedLanes = $e, this.expiredLanes = $e, this.mutableReadLanes = $e, this.finishedLanes = $e, this.entangledLanes = $e, this.entanglements = Nd($e), this.identifierPrefix = m, this.onRecoverableError = b, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
        {
          this.memoizedUpdaters = /* @__PURE__ */ new Set();
          for (var O = this.pendingUpdatersLaneMap = [], N = 0; N < jl; N++)
            O.push(/* @__PURE__ */ new Set());
        }
        switch (o) {
          case j1:
            this._debugRootType = d ? "hydrateRoot()" : "createRoot()";
            break;
          case pf:
            this._debugRootType = d ? "hydrate()" : "render()";
            break;
        }
      }
      function d8(a, o, d, m, b, O, N, I, L, G) {
        var K = new qJ(a, o, d, I, L), ve = FJ(o, O);
        K.current = ve, ve.stateNode = K;
        {
          var pe = {
            element: m,
            isDehydrated: d,
            cache: null,
            // not enabled yet
            transitions: null,
            pendingSuspenseBoundaries: null
          };
          ve.memoizedState = pe;
        }
        return jO(ve), K;
      }
      var SA = "18.3.1";
      function UJ(a, o, d) {
        var m = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        return Qt(m), {
          // This tag allow us to uniquely identify this as a React Portal
          $$typeof: Sr,
          key: m == null ? null : "" + m,
          children: a,
          containerInfo: o,
          implementation: d
        };
      }
      var _A, CA;
      _A = !1, CA = {};
      function p8(a) {
        if (!a)
          return jo;
        var o = Gc(a), d = CK(o);
        if (o.tag === h) {
          var m = o.type;
          if (Gs(m))
            return $F(o, m, d);
        }
        return d;
      }
      function HJ(a, o) {
        {
          var d = Gc(a);
          if (d === void 0) {
            if (typeof a.render == "function")
              throw new Error("Unable to find node on an unmounted component.");
            var m = Object.keys(a).join(",");
            throw new Error("Argument appears to not be a ReactComponent. Keys: " + m);
          }
          var b = ha(d);
          if (b === null)
            return null;
          if (b.mode & Ir) {
            var O = Ft(d) || "Component";
            if (!CA[O]) {
              CA[O] = !0;
              var N = vi;
              try {
                Nr(b), d.mode & Ir ? s("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", o, o, O) : s("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", o, o, O);
              } finally {
                N ? Nr(N) : un();
              }
            }
          }
          return b.stateNode;
        }
      }
      function h8(a, o, d, m, b, O, N, I) {
        var L = !1, G = null;
        return d8(a, o, L, G, d, m, b, O, N);
      }
      function v8(a, o, d, m, b, O, N, I, L, G) {
        var K = !0, ve = d8(d, m, K, a, b, O, N, I, L);
        ve.context = p8(null);
        var pe = ve.current, Se = qa(), Oe = _f(pe), Pe = ec(Se, Oe);
        return Pe.callback = o ?? null, mf(pe, Pe, Oe), XZ(ve, Oe, Se), ve;
      }
      function og(a, o, d, m) {
        Dm(o, a);
        var b = o.current, O = qa(), N = _f(b);
        mn(N);
        var I = p8(d);
        o.context === null ? o.context = I : o.pendingContext = I, Xo && vi !== null && !_A && (_A = !0, s(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, Ft(vi) || "Unknown"));
        var L = ec(O, N);
        L.payload = {
          element: a
        }, m = m === void 0 ? null : m, m !== null && (typeof m != "function" && s("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", m), L.callback = m);
        var G = mf(b, L, N);
        return G !== null && (Ti(G, b, N, O), K1(G, b, N)), N;
      }
      function Lw(a) {
        var o = a.current;
        if (!o.child)
          return null;
        switch (o.child.tag) {
          case w:
            return o.child.stateNode;
          default:
            return o.child.stateNode;
        }
      }
      function VJ(a) {
        switch (a.tag) {
          case y: {
            var o = a.stateNode;
            if (Uh(o)) {
              var d = jb(o);
              tJ(o, d);
            }
            break;
          }
          case T: {
            ic(function() {
              var b = co(a, Rt);
              if (b !== null) {
                var O = qa();
                Ti(b, a, Rt, O);
              }
            });
            var m = Rt;
            OA(a, m);
            break;
          }
        }
      }
      function m8(a, o) {
        var d = a.memoizedState;
        d !== null && d.dehydrated !== null && (d.retryLane = $b(d.retryLane, o));
      }
      function OA(a, o) {
        m8(a, o);
        var d = a.alternate;
        d && m8(d, o);
      }
      function WJ(a) {
        if (a.tag === T) {
          var o = Ad, d = co(a, o);
          if (d !== null) {
            var m = qa();
            Ti(d, a, o, m);
          }
          OA(a, o);
        }
      }
      function YJ(a) {
        if (a.tag === T) {
          var o = _f(a), d = co(a, o);
          if (d !== null) {
            var m = qa();
            Ti(d, a, o, m);
          }
          OA(a, o);
        }
      }
      function y8(a) {
        var o = cn(a);
        return o === null ? null : o.stateNode;
      }
      var g8 = function(a) {
        return null;
      };
      function GJ(a) {
        return g8(a);
      }
      var x8 = function(a) {
        return !1;
      };
      function QJ(a) {
        return x8(a);
      }
      var b8 = null, w8 = null, E8 = null, S8 = null, _8 = null, C8 = null, O8 = null, T8 = null, A8 = null;
      {
        var D8 = function(a, o, d) {
          var m = o[d], b = Wt(a) ? a.slice() : Ht({}, a);
          return d + 1 === o.length ? (Wt(b) ? b.splice(m, 1) : delete b[m], b) : (b[m] = D8(a[m], o, d + 1), b);
        }, k8 = function(a, o) {
          return D8(a, o, 0);
        }, R8 = function(a, o, d, m) {
          var b = o[m], O = Wt(a) ? a.slice() : Ht({}, a);
          if (m + 1 === o.length) {
            var N = d[m];
            O[N] = O[b], Wt(O) ? O.splice(b, 1) : delete O[b];
          } else
            O[b] = R8(
              // $FlowFixMe number or string is fine here
              a[b],
              o,
              d,
              m + 1
            );
          return O;
        }, P8 = function(a, o, d) {
          if (o.length !== d.length) {
            u("copyWithRename() expects paths of the same length");
            return;
          } else
            for (var m = 0; m < d.length - 1; m++)
              if (o[m] !== d[m]) {
                u("copyWithRename() expects paths to be the same except for the deepest key");
                return;
              }
          return R8(a, o, d, 0);
        }, M8 = function(a, o, d, m) {
          if (d >= o.length)
            return m;
          var b = o[d], O = Wt(a) ? a.slice() : Ht({}, a);
          return O[b] = M8(a[b], o, d + 1, m), O;
        }, N8 = function(a, o, d) {
          return M8(a, o, 0, d);
        }, TA = function(a, o) {
          for (var d = a.memoizedState; d !== null && o > 0; )
            d = d.next, o--;
          return d;
        };
        b8 = function(a, o, d, m) {
          var b = TA(a, o);
          if (b !== null) {
            var O = N8(b.memoizedState, d, m);
            b.memoizedState = O, b.baseState = O, a.memoizedProps = Ht({}, a.memoizedProps);
            var N = co(a, Rt);
            N !== null && Ti(N, a, Rt, Qr);
          }
        }, w8 = function(a, o, d) {
          var m = TA(a, o);
          if (m !== null) {
            var b = k8(m.memoizedState, d);
            m.memoizedState = b, m.baseState = b, a.memoizedProps = Ht({}, a.memoizedProps);
            var O = co(a, Rt);
            O !== null && Ti(O, a, Rt, Qr);
          }
        }, E8 = function(a, o, d, m) {
          var b = TA(a, o);
          if (b !== null) {
            var O = P8(b.memoizedState, d, m);
            b.memoizedState = O, b.baseState = O, a.memoizedProps = Ht({}, a.memoizedProps);
            var N = co(a, Rt);
            N !== null && Ti(N, a, Rt, Qr);
          }
        }, S8 = function(a, o, d) {
          a.pendingProps = N8(a.memoizedProps, o, d), a.alternate && (a.alternate.pendingProps = a.pendingProps);
          var m = co(a, Rt);
          m !== null && Ti(m, a, Rt, Qr);
        }, _8 = function(a, o) {
          a.pendingProps = k8(a.memoizedProps, o), a.alternate && (a.alternate.pendingProps = a.pendingProps);
          var d = co(a, Rt);
          d !== null && Ti(d, a, Rt, Qr);
        }, C8 = function(a, o, d) {
          a.pendingProps = P8(a.memoizedProps, o, d), a.alternate && (a.alternate.pendingProps = a.pendingProps);
          var m = co(a, Rt);
          m !== null && Ti(m, a, Rt, Qr);
        }, O8 = function(a) {
          var o = co(a, Rt);
          o !== null && Ti(o, a, Rt, Qr);
        }, T8 = function(a) {
          g8 = a;
        }, A8 = function(a) {
          x8 = a;
        };
      }
      function KJ(a) {
        var o = ha(a);
        return o === null ? null : o.stateNode;
      }
      function XJ(a) {
        return null;
      }
      function ZJ() {
        return vi;
      }
      function JJ(a) {
        var o = a.findFiberByHostInstance, d = r.ReactCurrentDispatcher;
        return Xc({
          bundleType: a.bundleType,
          version: a.version,
          rendererPackageName: a.rendererPackageName,
          rendererConfig: a.rendererConfig,
          overrideHookState: b8,
          overrideHookStateDeletePath: w8,
          overrideHookStateRenamePath: E8,
          overrideProps: S8,
          overridePropsDeletePath: _8,
          overridePropsRenamePath: C8,
          setErrorHandler: T8,
          setSuspenseHandler: A8,
          scheduleUpdate: O8,
          currentDispatcherRef: d,
          findHostInstanceByFiber: KJ,
          findFiberByHostInstance: o || XJ,
          // React Refresh
          findHostInstancesForRefresh: DJ,
          scheduleRefresh: TJ,
          scheduleRoot: AJ,
          setRefreshHandler: OJ,
          // Enables DevTools to append owner stacks to error messages in DEV mode.
          getCurrentFiber: ZJ,
          // Enables DevTools to detect reconciler version rather than renderer version
          // which may not match for third party renderers.
          reconcilerVersion: SA
        });
      }
      var j8 = typeof reportError == "function" ? (
        // In modern browsers, reportError will dispatch an error event,
        // emulating an uncaught JavaScript error.
        reportError
      ) : function(a) {
        console.error(a);
      };
      function AA(a) {
        this._internalRoot = a;
      }
      $w.prototype.render = AA.prototype.render = function(a) {
        var o = this._internalRoot;
        if (o === null)
          throw new Error("Cannot update an unmounted root.");
        {
          typeof arguments[1] == "function" ? s("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : zw(arguments[1]) ? s("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && s("You passed a second argument to root.render(...) but it only accepts one argument.");
          var d = o.containerInfo;
          if (d.nodeType !== Nn) {
            var m = y8(o.current);
            m && m.parentNode !== d && s("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
          }
        }
        og(a, o, null, null);
      }, $w.prototype.unmount = AA.prototype.unmount = function() {
        typeof arguments[0] == "function" && s("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var a = this._internalRoot;
        if (a !== null) {
          this._internalRoot = null;
          var o = a.containerInfo;
          YI() && s("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), ic(function() {
            og(null, a, null, null);
          }), jF(o);
        }
      };
      function eee(a, o) {
        if (!zw(a))
          throw new Error("createRoot(...): Target container is not a DOM element.");
        F8(a);
        var d = !1, m = !1, b = "", O = j8;
        o != null && (o.hydrate ? u("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof o == "object" && o !== null && o.$$typeof === ni && s(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), o.unstable_strictMode === !0 && (d = !0), o.identifierPrefix !== void 0 && (b = o.identifierPrefix), o.onRecoverableError !== void 0 && (O = o.onRecoverableError), o.transitionCallbacks !== void 0 && o.transitionCallbacks);
        var N = h8(a, j1, null, d, m, b, O);
        A1(N.current, a);
        var I = a.nodeType === Nn ? a.parentNode : a;
        return dy(I), new AA(N);
      }
      function $w(a) {
        this._internalRoot = a;
      }
      function tee(a) {
        a && Kb(a);
      }
      $w.prototype.unstable_scheduleHydration = tee;
      function ree(a, o, d) {
        if (!zw(a))
          throw new Error("hydrateRoot(...): Target container is not a DOM element.");
        F8(a), o === void 0 && s("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        var m = d ?? null, b = d != null && d.hydratedSources || null, O = !1, N = !1, I = "", L = j8;
        d != null && (d.unstable_strictMode === !0 && (O = !0), d.identifierPrefix !== void 0 && (I = d.identifierPrefix), d.onRecoverableError !== void 0 && (L = d.onRecoverableError));
        var G = v8(o, null, a, j1, m, O, N, I, L);
        if (A1(G.current, a), dy(a), b)
          for (var K = 0; K < b.length; K++) {
            var ve = b[K];
            oX(G, ve);
          }
        return new $w(G);
      }
      function zw(a) {
        return !!(a && (a.nodeType === ca || a.nodeType === ju || a.nodeType === hm));
      }
      function ug(a) {
        return !!(a && (a.nodeType === ca || a.nodeType === ju || a.nodeType === hm || a.nodeType === Nn && a.nodeValue === " react-mount-point-unstable "));
      }
      function F8(a) {
        a.nodeType === ca && a.tagName && a.tagName.toUpperCase() === "BODY" && s("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), Sy(a) && (a._reactRootContainer ? s("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : s("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
      }
      var nee = r.ReactCurrentOwner, I8;
      I8 = function(a) {
        if (a._reactRootContainer && a.nodeType !== Nn) {
          var o = y8(a._reactRootContainer.current);
          o && o.parentNode !== a && s("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
        }
        var d = !!a._reactRootContainer, m = DA(a), b = !!(m && ff(m));
        b && !d && s("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), a.nodeType === ca && a.tagName && a.tagName.toUpperCase() === "BODY" && s("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
      };
      function DA(a) {
        return a ? a.nodeType === ju ? a.documentElement : a.firstChild : null;
      }
      function B8() {
      }
      function iee(a, o, d, m, b) {
        if (b) {
          if (typeof m == "function") {
            var O = m;
            m = function() {
              var pe = Lw(N);
              O.call(pe);
            };
          }
          var N = v8(
            o,
            m,
            a,
            pf,
            null,
            // hydrationCallbacks
            !1,
            // isStrictMode
            !1,
            // concurrentUpdatesByDefaultOverride,
            "",
            // identifierPrefix
            B8
          );
          a._reactRootContainer = N, A1(N.current, a);
          var I = a.nodeType === Nn ? a.parentNode : a;
          return dy(I), ic(), N;
        } else {
          for (var L; L = a.lastChild; )
            a.removeChild(L);
          if (typeof m == "function") {
            var G = m;
            m = function() {
              var pe = Lw(K);
              G.call(pe);
            };
          }
          var K = h8(
            a,
            pf,
            null,
            // hydrationCallbacks
            !1,
            // isStrictMode
            !1,
            // concurrentUpdatesByDefaultOverride,
            "",
            // identifierPrefix
            B8
          );
          a._reactRootContainer = K, A1(K.current, a);
          var ve = a.nodeType === Nn ? a.parentNode : a;
          return dy(ve), ic(function() {
            og(o, K, d, m);
          }), K;
        }
      }
      function aee(a, o) {
        a !== null && typeof a != "function" && s("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", o, a);
      }
      function qw(a, o, d, m, b) {
        I8(d), aee(b === void 0 ? null : b, "render");
        var O = d._reactRootContainer, N;
        if (!O)
          N = iee(d, o, a, b, m);
        else {
          if (N = O, typeof b == "function") {
            var I = b;
            b = function() {
              var L = Lw(N);
              I.call(L);
            };
          }
          og(o, N, a, b);
        }
        return Lw(N);
      }
      var L8 = !1;
      function oee(a) {
        {
          L8 || (L8 = !0, s("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
          var o = nee.current;
          if (o !== null && o.stateNode !== null) {
            var d = o.stateNode._warnedAboutRefsInRender;
            d || s("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", or(o.type) || "A component"), o.stateNode._warnedAboutRefsInRender = !0;
          }
        }
        return a == null ? null : a.nodeType === ca ? a : HJ(a, "findDOMNode");
      }
      function uee(a, o, d) {
        if (s("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !ug(o))
          throw new Error("Target container is not a DOM element.");
        {
          var m = Sy(o) && o._reactRootContainer === void 0;
          m && s("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
        }
        return qw(null, a, o, !0, d);
      }
      function see(a, o, d) {
        if (s("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !ug(o))
          throw new Error("Target container is not a DOM element.");
        {
          var m = Sy(o) && o._reactRootContainer === void 0;
          m && s("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        }
        return qw(null, a, o, !1, d);
      }
      function lee(a, o, d, m) {
        if (s("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !ug(d))
          throw new Error("Target container is not a DOM element.");
        if (a == null || !OC(a))
          throw new Error("parentComponent must be a valid React Component");
        return qw(a, o, d, !1, m);
      }
      var $8 = !1;
      function cee(a) {
        if ($8 || ($8 = !0, s("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !ug(a))
          throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        {
          var o = Sy(a) && a._reactRootContainer === void 0;
          o && s("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        }
        if (a._reactRootContainer) {
          {
            var d = DA(a), m = d && !ff(d);
            m && s("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
          }
          return ic(function() {
            qw(null, null, a, !1, function() {
              a._reactRootContainer = null, jF(a);
            });
          }), !0;
        } else {
          {
            var b = DA(a), O = !!(b && ff(b)), N = a.nodeType === ca && ug(a.parentNode) && !!a.parentNode._reactRootContainer;
            O && s("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", N ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
          }
          return !1;
        }
      }
      Mi(VJ), tf(WJ), Wb(YJ), Ld(uo), Qm(Ub), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
      Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
      Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && s("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), oh(dQ), CC(oA, rJ, ic);
      function fee(a, o) {
        var d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        if (!zw(o))
          throw new Error("Target container is not a DOM element.");
        return UJ(a, o, null, d);
      }
      function dee(a, o, d, m) {
        return lee(a, o, d, m);
      }
      var kA = {
        usingClientEntryPoint: !1,
        // Keep in sync with ReactTestUtils.js.
        // This is an array for better minification.
        Events: [ff, sv, D1, Hc, uh, oA]
      };
      function pee(a, o) {
        return kA.usingClientEntryPoint || s('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), eee(a, o);
      }
      function hee(a, o, d) {
        return kA.usingClientEntryPoint || s('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), ree(a, o, d);
      }
      function vee(a) {
        return YI() && s("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), ic(a);
      }
      var mee = JJ({
        findFiberByHostInstance: Jd,
        bundleType: 1,
        version: SA,
        rendererPackageName: "react-dom"
      });
      if (!mee && Ye && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
        var z8 = window.location.protocol;
        /^(https?|file):$/.test(z8) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (z8 === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
      }
      mo.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = kA, mo.createPortal = fee, mo.createRoot = pee, mo.findDOMNode = oee, mo.flushSync = vee, mo.hydrate = uee, mo.hydrateRoot = hee, mo.render = see, mo.unmountComponentAtNode = cee, mo.unstable_batchedUpdates = oA, mo.unstable_renderSubtreeIntoContainer = dee, mo.version = SA, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }()), mo;
  }
  var K8;
  function hU() {
    if (K8) return Hw.exports;
    K8 = 1;
    function e() {
      if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
        if (process.env.NODE_ENV !== "production")
          throw new Error("^_^");
        try {
          __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
        } catch (t) {
          console.error(t);
        }
      }
    }
    return process.env.NODE_ENV === "production" ? (e(), Hw.exports = Tee()) : Hw.exports = Aee(), Hw.exports;
  }
  var X8;
  function Dee() {
    if (X8) return Mv;
    X8 = 1;
    var e = hU();
    if (process.env.NODE_ENV === "production")
      Mv.createRoot = e.createRoot, Mv.hydrateRoot = e.hydrateRoot;
    else {
      var t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      Mv.createRoot = function(r, n) {
        t.usingClientEntryPoint = !0;
        try {
          return e.createRoot(r, n);
        } finally {
          t.usingClientEntryPoint = !1;
        }
      }, Mv.hydrateRoot = function(r, n, i) {
        t.usingClientEntryPoint = !0;
        try {
          return e.hydrateRoot(r, n, i);
        } finally {
          t.usingClientEntryPoint = !1;
        }
      };
    }
    return Mv;
  }
  var kee = Dee(), Ree = Object.defineProperty, Pee = (e, t, r) => t in e ? Ree(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Ww = (e, t, r) => Pee(e, typeof t != "symbol" ? t + "" : t, r);
  const Mee = {
    stringify: (e) => e ? "true" : "false",
    parse: (e) => /^[ty1-9]/i.test(e)
  }, Nee = {
    stringify: (e) => e.name,
    parse: (e, t, r) => {
      const n = (() => {
        if (typeof window < "u" && e in window)
          return window[e];
        if (typeof global < "u" && e in global)
          return global[e];
      })();
      return typeof n == "function" ? n.bind(r) : void 0;
    }
  }, jee = {
    stringify: (e) => JSON.stringify(e),
    parse: (e) => JSON.parse(e)
  }, Fee = {
    stringify: (e) => `${e}`,
    parse: (e) => parseFloat(e)
  }, Iee = {
    stringify: (e) => e,
    parse: (e) => e
  }, MA = {
    string: Iee,
    number: Fee,
    boolean: Mee,
    function: Nee,
    json: jee
  };
  function Bee(e) {
    return e.replace(
      /([a-z0-9])([A-Z])/g,
      (t, r, n) => `${r}-${n.toLowerCase()}`
    );
  }
  const Yw = Symbol.for("r2wc.render"), Gw = Symbol.for("r2wc.connected"), vp = Symbol.for("r2wc.context"), uc = Symbol.for("r2wc.props");
  function Lee(e, t, r) {
    var n, i, u;
    t.props || (t.props = e.propTypes ? Object.keys(e.propTypes) : []), t.events || (t.events = []);
    const s = Array.isArray(t.props) ? t.props.slice() : Object.keys(t.props), c = Array.isArray(t.events) ? t.events.slice() : Object.keys(t.events), p = {}, h = {}, v = {}, y = {};
    for (const w of s) {
      p[w] = Array.isArray(t.props) ? "string" : t.props[w];
      const E = Bee(w);
      v[w] = E, y[E] = w;
    }
    for (const w of c)
      h[w] = Array.isArray(t.events) ? {} : t.events[w];
    class x extends HTMLElement {
      constructor() {
        super(), Ww(this, u, !0), Ww(this, i), Ww(this, n, {}), Ww(this, "container"), t.shadow ? this.container = this.attachShadow({
          mode: t.shadow
        }) : this.container = this, this[uc].container = this.container;
        for (const E of s) {
          const C = v[E], S = this.getAttribute(C), k = p[E], D = k ? MA[k] : null;
          D != null && D.parse && S && (this[uc][E] = D.parse(S, C, this));
        }
        for (const E of c)
          this[uc][E] = (C) => {
            const S = E.replace(/^on/, "").toLowerCase();
            this.dispatchEvent(
              new CustomEvent(S, { detail: C, ...h[E] })
            );
          };
      }
      static get observedAttributes() {
        return Object.keys(y);
      }
      connectedCallback() {
        this[Gw] = !0, this[Yw]();
      }
      disconnectedCallback() {
        this[Gw] = !1, this[vp] && r.unmount(this[vp]), delete this[vp];
      }
      attributeChangedCallback(E, C, S) {
        const k = y[E], D = p[k], A = D ? MA[D] : null;
        k in p && A != null && A.parse && S && (this[uc][k] = A.parse(S, E, this), this[Yw]());
      }
      [(u = Gw, i = vp, n = uc, Yw)]() {
        this[Gw] && (this[vp] ? r.update(this[vp], this[uc]) : this[vp] = r.mount(
          this.container,
          e,
          this[uc]
        ));
      }
    }
    for (const w of s) {
      const E = v[w], C = p[w];
      Object.defineProperty(x.prototype, w, {
        enumerable: !0,
        configurable: !0,
        get() {
          return this[uc][w];
        },
        set(S) {
          this[uc][w] = S;
          const k = C ? MA[C] : null;
          if (k != null && k.stringify) {
            const D = k.stringify(S, E, this);
            this.getAttribute(E) !== D && this.setAttribute(E, D);
          } else
            this[Yw]();
        }
      });
    }
    return x;
  }
  function $ee(e, t, r) {
    const n = kee.createRoot(e), i = ce.createElement(t, r);
    return n.render(i), {
      root: n,
      ReactComponent: t
    };
  }
  function zee({ root: e, ReactComponent: t }, r) {
    const n = ce.createElement(t, r);
    e.render(n);
  }
  function qee({ root: e }) {
    e.unmount();
  }
  function Uee(e, t = {}) {
    return Lee(e, t, { mount: $ee, update: zee, unmount: qee });
  }
  var Qw = { exports: {} }, lg = {};
  /**
   * @license React
   * react-jsx-runtime.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var Z8;
  function Hee() {
    if (Z8) return lg;
    Z8 = 1;
    var e = F0(), t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, u = { key: !0, ref: !0, __self: !0, __source: !0 };
    function s(c, p, h) {
      var v, y = {}, x = null, w = null;
      h !== void 0 && (x = "" + h), p.key !== void 0 && (x = "" + p.key), p.ref !== void 0 && (w = p.ref);
      for (v in p) n.call(p, v) && !u.hasOwnProperty(v) && (y[v] = p[v]);
      if (c && c.defaultProps) for (v in p = c.defaultProps, p) y[v] === void 0 && (y[v] = p[v]);
      return { $$typeof: t, type: c, key: x, ref: w, props: y, _owner: i.current };
    }
    return lg.Fragment = r, lg.jsx = s, lg.jsxs = s, lg;
  }
  var cg = {};
  /**
   * @license React
   * react-jsx-runtime.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var J8;
  function Vee() {
    return J8 || (J8 = 1, process.env.NODE_ENV !== "production" && function() {
      var e = F0(), t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), c = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), w = Symbol.for("react.offscreen"), E = Symbol.iterator, C = "@@iterator";
      function S(ue) {
        if (ue === null || typeof ue != "object")
          return null;
        var Le = E && ue[E] || ue[C];
        return typeof Le == "function" ? Le : null;
      }
      var k = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function D(ue) {
        {
          for (var Le = arguments.length, Je = new Array(Le > 1 ? Le - 1 : 0), lt = 1; lt < Le; lt++)
            Je[lt - 1] = arguments[lt];
          A("error", ue, Je);
        }
      }
      function A(ue, Le, Je) {
        {
          var lt = k.ReactDebugCurrentFrame, $t = lt.getStackAddendum();
          $t !== "" && (Le += "%s", Je = Je.concat([$t]));
          var It = Je.map(function(Kt) {
            return String(Kt);
          });
          It.unshift("Warning: " + Le), Function.prototype.apply.call(console[ue], console, It);
        }
      }
      var R = !1, T = !1, M = !1, F = !1, B = !1, V;
      V = Symbol.for("react.module.reference");
      function H(ue) {
        return !!(typeof ue == "string" || typeof ue == "function" || ue === n || ue === u || B || ue === i || ue === h || ue === v || F || ue === w || R || T || M || typeof ue == "object" && ue !== null && (ue.$$typeof === x || ue.$$typeof === y || ue.$$typeof === s || ue.$$typeof === c || ue.$$typeof === p || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        ue.$$typeof === V || ue.getModuleId !== void 0));
      }
      function q(ue, Le, Je) {
        var lt = ue.displayName;
        if (lt)
          return lt;
        var $t = Le.displayName || Le.name || "";
        return $t !== "" ? Je + "(" + $t + ")" : Je;
      }
      function Q(ue) {
        return ue.displayName || "Context";
      }
      function W(ue) {
        if (ue == null)
          return null;
        if (typeof ue.tag == "number" && D("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof ue == "function")
          return ue.displayName || ue.name || null;
        if (typeof ue == "string")
          return ue;
        switch (ue) {
          case n:
            return "Fragment";
          case r:
            return "Portal";
          case u:
            return "Profiler";
          case i:
            return "StrictMode";
          case h:
            return "Suspense";
          case v:
            return "SuspenseList";
        }
        if (typeof ue == "object")
          switch (ue.$$typeof) {
            case c:
              var Le = ue;
              return Q(Le) + ".Consumer";
            case s:
              var Je = ue;
              return Q(Je._context) + ".Provider";
            case p:
              return q(ue, ue.render, "ForwardRef");
            case y:
              var lt = ue.displayName || null;
              return lt !== null ? lt : W(ue.type) || "Memo";
            case x: {
              var $t = ue, It = $t._payload, Kt = $t._init;
              try {
                return W(Kt(It));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var J = Object.assign, ne = 0, ie, se, X, fe, Z, z, Y;
      function te() {
      }
      te.__reactDisabledLog = !0;
      function ae() {
        {
          if (ne === 0) {
            ie = console.log, se = console.info, X = console.warn, fe = console.error, Z = console.group, z = console.groupCollapsed, Y = console.groupEnd;
            var ue = {
              configurable: !0,
              enumerable: !0,
              value: te,
              writable: !0
            };
            Object.defineProperties(console, {
              info: ue,
              log: ue,
              warn: ue,
              error: ue,
              group: ue,
              groupCollapsed: ue,
              groupEnd: ue
            });
          }
          ne++;
        }
      }
      function De() {
        {
          if (ne--, ne === 0) {
            var ue = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: J({}, ue, {
                value: ie
              }),
              info: J({}, ue, {
                value: se
              }),
              warn: J({}, ue, {
                value: X
              }),
              error: J({}, ue, {
                value: fe
              }),
              group: J({}, ue, {
                value: Z
              }),
              groupCollapsed: J({}, ue, {
                value: z
              }),
              groupEnd: J({}, ue, {
                value: Y
              })
            });
          }
          ne < 0 && D("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var ke = k.ReactCurrentDispatcher, Re;
      function Te(ue, Le, Je) {
        {
          if (Re === void 0)
            try {
              throw Error();
            } catch ($t) {
              var lt = $t.stack.trim().match(/\n( *(at )?)/);
              Re = lt && lt[1] || "";
            }
          return `
` + Re + ue;
        }
      }
      var we = !1, Fe;
      {
        var Ye = typeof WeakMap == "function" ? WeakMap : Map;
        Fe = new Ye();
      }
      function de(ue, Le) {
        if (!ue || we)
          return "";
        {
          var Je = Fe.get(ue);
          if (Je !== void 0)
            return Je;
        }
        var lt;
        we = !0;
        var $t = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var It;
        It = ke.current, ke.current = null, ae();
        try {
          if (Le) {
            var Kt = function() {
              throw Error();
            };
            if (Object.defineProperty(Kt.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Kt, []);
              } catch (zt) {
                lt = zt;
              }
              Reflect.construct(ue, [], Kt);
            } else {
              try {
                Kt.call();
              } catch (zt) {
                lt = zt;
              }
              ue.call(Kt.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (zt) {
              lt = zt;
            }
            ue();
          }
        } catch (zt) {
          if (zt && lt && typeof zt.stack == "string") {
            for (var Yt = zt.stack.split(`
`), En = lt.stack.split(`
`), tn = Yt.length - 1, on = En.length - 1; tn >= 1 && on >= 0 && Yt[tn] !== En[on]; )
              on--;
            for (; tn >= 1 && on >= 0; tn--, on--)
              if (Yt[tn] !== En[on]) {
                if (tn !== 1 || on !== 1)
                  do
                    if (tn--, on--, on < 0 || Yt[tn] !== En[on]) {
                      var hi = `
` + Yt[tn].replace(" at new ", " at ");
                      return ue.displayName && hi.includes("<anonymous>") && (hi = hi.replace("<anonymous>", ue.displayName)), typeof ue == "function" && Fe.set(ue, hi), hi;
                    }
                  while (tn >= 1 && on >= 0);
                break;
              }
          }
        } finally {
          we = !1, ke.current = It, De(), Error.prepareStackTrace = $t;
        }
        var wo = ue ? ue.displayName || ue.name : "", Eo = wo ? Te(wo) : "";
        return typeof ue == "function" && Fe.set(ue, Eo), Eo;
      }
      function Ze(ue, Le, Je) {
        return de(ue, !1);
      }
      function Ne(ue) {
        var Le = ue.prototype;
        return !!(Le && Le.isReactComponent);
      }
      function Ot(ue, Le, Je) {
        if (ue == null)
          return "";
        if (typeof ue == "function")
          return de(ue, Ne(ue));
        if (typeof ue == "string")
          return Te(ue);
        switch (ue) {
          case h:
            return Te("Suspense");
          case v:
            return Te("SuspenseList");
        }
        if (typeof ue == "object")
          switch (ue.$$typeof) {
            case p:
              return Ze(ue.render);
            case y:
              return Ot(ue.type, Le, Je);
            case x: {
              var lt = ue, $t = lt._payload, It = lt._init;
              try {
                return Ot(It($t), Le, Je);
              } catch {
              }
            }
          }
        return "";
      }
      var At = Object.prototype.hasOwnProperty, Qt = {}, Wr = k.ReactDebugCurrentFrame;
      function Ar(ue) {
        if (ue) {
          var Le = ue._owner, Je = Ot(ue.type, ue._source, Le ? Le.type : null);
          Wr.setExtraStackFrame(Je);
        } else
          Wr.setExtraStackFrame(null);
      }
      function Dr(ue, Le, Je, lt, $t) {
        {
          var It = Function.call.bind(At);
          for (var Kt in ue)
            if (It(ue, Kt)) {
              var Yt = void 0;
              try {
                if (typeof ue[Kt] != "function") {
                  var En = Error((lt || "React class") + ": " + Je + " type `" + Kt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof ue[Kt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw En.name = "Invariant Violation", En;
                }
                Yt = ue[Kt](Le, Kt, lt, Je, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (tn) {
                Yt = tn;
              }
              Yt && !(Yt instanceof Error) && (Ar($t), D("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", lt || "React class", Je, Kt, typeof Yt), Ar(null)), Yt instanceof Error && !(Yt.message in Qt) && (Qt[Yt.message] = !0, Ar($t), D("Failed %s type: %s", Je, Yt.message), Ar(null));
            }
        }
      }
      var Vt = Array.isArray;
      function Ut(ue) {
        return Vt(ue);
      }
      function kr(ue) {
        {
          var Le = typeof Symbol == "function" && Symbol.toStringTag, Je = Le && ue[Symbol.toStringTag] || ue.constructor.name || "Object";
          return Je;
        }
      }
      function Pn(ue) {
        try {
          return Yr(ue), !1;
        } catch {
          return !0;
        }
      }
      function Yr(ue) {
        return "" + ue;
      }
      function Jr(ue) {
        if (Pn(ue))
          return D("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", kr(ue)), Yr(ue);
      }
      var xn = k.ReactCurrentOwner, ka = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ra, Ge;
      function ct(ue) {
        if (At.call(ue, "ref")) {
          var Le = Object.getOwnPropertyDescriptor(ue, "ref").get;
          if (Le && Le.isReactWarning)
            return !1;
        }
        return ue.ref !== void 0;
      }
      function jt(ue) {
        if (At.call(ue, "key")) {
          var Le = Object.getOwnPropertyDescriptor(ue, "key").get;
          if (Le && Le.isReactWarning)
            return !1;
        }
        return ue.key !== void 0;
      }
      function cr(ue, Le) {
        typeof ue.ref == "string" && xn.current;
      }
      function Rr(ue, Le) {
        {
          var Je = function() {
            Ra || (Ra = !0, D("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Le));
          };
          Je.isReactWarning = !0, Object.defineProperty(ue, "key", {
            get: Je,
            configurable: !0
          });
        }
      }
      function en(ue, Le) {
        {
          var Je = function() {
            Ge || (Ge = !0, D("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Le));
          };
          Je.isReactWarning = !0, Object.defineProperty(ue, "ref", {
            get: Je,
            configurable: !0
          });
        }
      }
      var Gr = function(ue, Le, Je, lt, $t, It, Kt) {
        var Yt = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: t,
          // Built-in properties that belong on the element
          type: ue,
          key: Le,
          ref: Je,
          props: Kt,
          // Record the component responsible for creating this element.
          _owner: It
        };
        return Yt._store = {}, Object.defineProperty(Yt._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Yt, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: lt
        }), Object.defineProperty(Yt, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: $t
        }), Object.freeze && (Object.freeze(Yt.props), Object.freeze(Yt)), Yt;
      };
      function Mn(ue, Le, Je, lt, $t) {
        {
          var It, Kt = {}, Yt = null, En = null;
          Je !== void 0 && (Jr(Je), Yt = "" + Je), jt(Le) && (Jr(Le.key), Yt = "" + Le.key), ct(Le) && (En = Le.ref, cr(Le, $t));
          for (It in Le)
            At.call(Le, It) && !ka.hasOwnProperty(It) && (Kt[It] = Le[It]);
          if (ue && ue.defaultProps) {
            var tn = ue.defaultProps;
            for (It in tn)
              Kt[It] === void 0 && (Kt[It] = tn[It]);
          }
          if (Yt || En) {
            var on = typeof ue == "function" ? ue.displayName || ue.name || "Unknown" : ue;
            Yt && Rr(Kt, on), En && en(Kt, on);
          }
          return Gr(ue, Yt, En, $t, lt, xn.current, Kt);
        }
      }
      var Pr = k.ReactCurrentOwner, _r = k.ReactDebugCurrentFrame;
      function Er(ue) {
        if (ue) {
          var Le = ue._owner, Je = Ot(ue.type, ue._source, Le ? Le.type : null);
          _r.setExtraStackFrame(Je);
        } else
          _r.setExtraStackFrame(null);
      }
      var $i;
      $i = !1;
      function Yn(ue) {
        return typeof ue == "object" && ue !== null && ue.$$typeof === t;
      }
      function ua() {
        {
          if (Pr.current) {
            var ue = W(Pr.current.type);
            if (ue)
              return `

Check the render method of \`` + ue + "`.";
          }
          return "";
        }
      }
      function bo(ue) {
        return "";
      }
      var Du = {};
      function Vo(ue) {
        {
          var Le = ua();
          if (!Le) {
            var Je = typeof ue == "string" ? ue : ue.displayName || ue.name;
            Je && (Le = `

Check the top-level render call using <` + Je + ">.");
          }
          return Le;
        }
      }
      function Wo(ue, Le) {
        {
          if (!ue._store || ue._store.validated || ue.key != null)
            return;
          ue._store.validated = !0;
          var Je = Vo(Le);
          if (Du[Je])
            return;
          Du[Je] = !0;
          var lt = "";
          ue && ue._owner && ue._owner !== Pr.current && (lt = " It was passed a child from " + W(ue._owner.type) + "."), Er(ue), D('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Je, lt), Er(null);
        }
      }
      function Yo(ue, Le) {
        {
          if (typeof ue != "object")
            return;
          if (Ut(ue))
            for (var Je = 0; Je < ue.length; Je++) {
              var lt = ue[Je];
              Yn(lt) && Wo(lt, Le);
            }
          else if (Yn(ue))
            ue._store && (ue._store.validated = !0);
          else if (ue) {
            var $t = S(ue);
            if (typeof $t == "function" && $t !== ue.entries)
              for (var It = $t.call(ue), Kt; !(Kt = It.next()).done; )
                Yn(Kt.value) && Wo(Kt.value, Le);
          }
        }
      }
      function Go(ue) {
        {
          var Le = ue.type;
          if (Le == null || typeof Le == "string")
            return;
          var Je;
          if (typeof Le == "function")
            Je = Le.propTypes;
          else if (typeof Le == "object" && (Le.$$typeof === p || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          Le.$$typeof === y))
            Je = Le.propTypes;
          else
            return;
          if (Je) {
            var lt = W(Le);
            Dr(Je, ue.props, "prop", lt, ue);
          } else if (Le.PropTypes !== void 0 && !$i) {
            $i = !0;
            var $t = W(Le);
            D("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $t || "Unknown");
          }
          typeof Le.getDefaultProps == "function" && !Le.getDefaultProps.isReactClassApproved && D("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function pi(ue) {
        {
          for (var Le = Object.keys(ue.props), Je = 0; Je < Le.length; Je++) {
            var lt = Le[Je];
            if (lt !== "children" && lt !== "key") {
              Er(ue), D("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", lt), Er(null);
              break;
            }
          }
          ue.ref !== null && (Er(ue), D("Invalid attribute `ref` supplied to `React.Fragment`."), Er(null));
        }
      }
      var ni = {};
      function Sr(ue, Le, Je, lt, $t, It) {
        {
          var Kt = H(ue);
          if (!Kt) {
            var Yt = "";
            (ue === void 0 || typeof ue == "object" && ue !== null && Object.keys(ue).length === 0) && (Yt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var En = bo();
            En ? Yt += En : Yt += ua();
            var tn;
            ue === null ? tn = "null" : Ut(ue) ? tn = "array" : ue !== void 0 && ue.$$typeof === t ? (tn = "<" + (W(ue.type) || "Unknown") + " />", Yt = " Did you accidentally export a JSX literal instead of a component?") : tn = typeof ue, D("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", tn, Yt);
          }
          var on = Mn(ue, Le, Je, $t, It);
          if (on == null)
            return on;
          if (Kt) {
            var hi = Le.children;
            if (hi !== void 0)
              if (lt)
                if (Ut(hi)) {
                  for (var wo = 0; wo < hi.length; wo++)
                    Yo(hi[wo], ue);
                  Object.freeze && Object.freeze(hi);
                } else
                  D("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Yo(hi, ue);
          }
          if (At.call(Le, "key")) {
            var Eo = W(ue), zt = Object.keys(Le).filter(function(ml) {
              return ml !== "key";
            }), Ht = zt.length > 0 ? "{key: someKey, " + zt.join(": ..., ") + ": ...}" : "{key: someKey}";
            if (!ni[Eo + Ht]) {
              var So = zt.length > 0 ? "{" + zt.join(": ..., ") + ": ...}" : "{}";
              D(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ht, Eo, So, Eo), ni[Eo + Ht] = !0;
            }
          }
          return ue === n ? pi(on) : Go(on), on;
        }
      }
      function Gn(ue, Le, Je) {
        return Sr(ue, Le, Je, !0);
      }
      function sa(ue, Le, Je) {
        return Sr(ue, Le, Je, !1);
      }
      var Qa = sa, Qo = Gn;
      cg.Fragment = n, cg.jsx = Qa, cg.jsxs = Qo;
    }()), cg;
  }
  var eB;
  function Wee() {
    return eB || (eB = 1, process.env.NODE_ENV === "production" ? Qw.exports = Hee() : Qw.exports = Vee()), Qw.exports;
  }
  var me = Wee(), aP = function(e, t) {
    return aP = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, aP(e, t);
  };
  function pl(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    aP(e, t);
    function r() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
  }
  var ye = function() {
    return ye = Object.assign || function(t) {
      for (var r, n = 1, i = arguments.length; n < i; n++) {
        r = arguments[n];
        for (var u in r) Object.prototype.hasOwnProperty.call(r, u) && (t[u] = r[u]);
      }
      return t;
    }, ye.apply(this, arguments);
  };
  function ps(e, t) {
    var r = {};
    for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
    if (e != null && typeof Object.getOwnPropertySymbols == "function")
      for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
        t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
    return r;
  }
  function kf(e, t, r, n) {
    function i(u) {
      return u instanceof r ? u : new r(function(s) {
        s(u);
      });
    }
    return new (r || (r = Promise))(function(u, s) {
      function c(v) {
        try {
          h(n.next(v));
        } catch (y) {
          s(y);
        }
      }
      function p(v) {
        try {
          h(n.throw(v));
        } catch (y) {
          s(y);
        }
      }
      function h(v) {
        v.done ? u(v.value) : i(v.value).then(c, p);
      }
      h((n = n.apply(e, t || [])).next());
    });
  }
  function Rf(e, t) {
    var r = { label: 0, sent: function() {
      if (u[0] & 1) throw u[1];
      return u[1];
    }, trys: [], ops: [] }, n, i, u, s = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
    return s.next = c(0), s.throw = c(1), s.return = c(2), typeof Symbol == "function" && (s[Symbol.iterator] = function() {
      return this;
    }), s;
    function c(h) {
      return function(v) {
        return p([h, v]);
      };
    }
    function p(h) {
      if (n) throw new TypeError("Generator is already executing.");
      for (; s && (s = 0, h[0] && (r = 0)), r; ) try {
        if (n = 1, i && (u = h[0] & 2 ? i.return : h[0] ? i.throw || ((u = i.return) && u.call(i), 0) : i.next) && !(u = u.call(i, h[1])).done) return u;
        switch (i = 0, u && (h = [h[0] & 2, u.value]), h[0]) {
          case 0:
          case 1:
            u = h;
            break;
          case 4:
            return r.label++, { value: h[1], done: !1 };
          case 5:
            r.label++, i = h[1], h = [0];
            continue;
          case 7:
            h = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (u = r.trys, !(u = u.length > 0 && u[u.length - 1]) && (h[0] === 6 || h[0] === 2)) {
              r = 0;
              continue;
            }
            if (h[0] === 3 && (!u || h[1] > u[0] && h[1] < u[3])) {
              r.label = h[1];
              break;
            }
            if (h[0] === 6 && r.label < u[1]) {
              r.label = u[1], u = h;
              break;
            }
            if (u && r.label < u[2]) {
              r.label = u[2], r.ops.push(h);
              break;
            }
            u[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        h = t.call(e, r);
      } catch (v) {
        h = [6, v], i = 0;
      } finally {
        n = u = 0;
      }
      if (h[0] & 5) throw h[1];
      return { value: h[0] ? h[1] : void 0, done: !0 };
    }
  }
  function Da(e, t, r) {
    if (r || arguments.length === 2) for (var n = 0, i = t.length, u; n < i; n++)
      (u || !(n in t)) && (u || (u = Array.prototype.slice.call(t, 0, n)), u[n] = t[n]);
    return e.concat(u || Array.prototype.slice.call(t));
  }
  var NA = "Invariant Violation", tB = Object.setPrototypeOf, Yee = tB === void 0 ? function(e, t) {
    return e.__proto__ = t, e;
  } : tB, vU = (
    /** @class */
    function(e) {
      pl(t, e);
      function t(r) {
        r === void 0 && (r = NA);
        var n = e.call(this, typeof r == "number" ? NA + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
        return n.framesToPop = 1, n.name = NA, Yee(n, t.prototype), n;
      }
      return t;
    }(Error)
  );
  function Ep(e, t) {
    if (!e)
      throw new vU(t);
  }
  var mU = ["debug", "log", "warn", "error", "silent"], Gee = mU.indexOf("log");
  function Kw(e) {
    return function() {
      if (mU.indexOf(e) >= Gee) {
        var t = console[e] || console.log;
        return t.apply(console, arguments);
      }
    };
  }
  (function(e) {
    e.debug = Kw("debug"), e.log = Kw("log"), e.warn = Kw("warn"), e.error = Kw("error");
  })(Ep || (Ep = {}));
  var sN = "3.13.8";
  function ls(e) {
    try {
      return e();
    } catch {
    }
  }
  const Vg = ls(function() {
    return globalThis;
  }) || ls(function() {
    return window;
  }) || ls(function() {
    return self;
  }) || ls(function() {
    return global;
  }) || // We don't expect the Function constructor ever to be invoked at runtime, as
  // long as at least one of globalThis, window, self, or global is defined, so
  // we are under no obligation to make it easy for static analysis tools to
  // detect syntactic usage of the Function constructor. If you think you can
  // improve your static analysis to detect this obfuscation, think again. This
  // is an arms race you cannot win, at least not in JavaScript.
  ls(function() {
    return ls.constructor("return this")();
  });
  var rB = /* @__PURE__ */ new Map();
  function oP(e) {
    var t = rB.get(e) || 1;
    return rB.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
  }
  function yU(e, t) {
    t === void 0 && (t = 0);
    var r = oP("stringifyForDisplay");
    return JSON.stringify(e, function(n, i) {
      return i === void 0 ? r : i;
    }, t).split(JSON.stringify(r)).join("<undefined>");
  }
  function Xw(e) {
    return function(t) {
      for (var r = [], n = 1; n < arguments.length; n++)
        r[n - 1] = arguments[n];
      if (typeof t == "number") {
        var i = t;
        t = lN(i), t || (t = cN(i, r), r = []);
      }
      e.apply(void 0, [t].concat(r));
    };
  }
  var st = Object.assign(function(t, r) {
    for (var n = [], i = 2; i < arguments.length; i++)
      n[i - 2] = arguments[i];
    t || Ep(t, lN(r, n) || cN(r, n));
  }, {
    debug: Xw(Ep.debug),
    log: Xw(Ep.log),
    warn: Xw(Ep.warn),
    error: Xw(Ep.error)
  });
  function Ya(e) {
    for (var t = [], r = 1; r < arguments.length; r++)
      t[r - 1] = arguments[r];
    return new vU(lN(e, t) || cN(e, t));
  }
  var dS = Symbol.for("ApolloErrorMessageHandler_" + sN);
  function gU(e) {
    if (typeof e == "string")
      return e;
    try {
      return yU(e, 2).slice(0, 1e3);
    } catch {
      return "<non-serializable>";
    }
  }
  function lN(e, t) {
    if (t === void 0 && (t = []), !!e)
      return Vg[dS] && Vg[dS](e, t.map(gU));
  }
  function cN(e, t) {
    if (t === void 0 && (t = []), !!e)
      return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: sN,
        message: e,
        args: t.map(gU)
      })));
  }
  const Qee = () => /* @__PURE__ */ Object.create(null), { forEach: Kee, slice: nB } = Array.prototype, { hasOwnProperty: Xee } = Object.prototype;
  class Cc {
    constructor(t = !0, r = Qee) {
      this.weakness = t, this.makeData = r;
    }
    lookup() {
      return this.lookupArray(arguments);
    }
    lookupArray(t) {
      let r = this;
      return Kee.call(t, (n) => r = r.getChildTrie(n)), Xee.call(r, "data") ? r.data : r.data = this.makeData(nB.call(t));
    }
    peek() {
      return this.peekArray(arguments);
    }
    peekArray(t) {
      let r = this;
      for (let n = 0, i = t.length; r && n < i; ++n) {
        const u = r.mapFor(t[n], !1);
        r = u && u.get(t[n]);
      }
      return r && r.data;
    }
    remove() {
      return this.removeArray(arguments);
    }
    removeArray(t) {
      let r;
      if (t.length) {
        const n = t[0], i = this.mapFor(n, !1), u = i && i.get(n);
        u && (r = u.removeArray(nB.call(t, 1)), !u.data && !u.weak && !(u.strong && u.strong.size) && i.delete(n));
      } else
        r = this.data, delete this.data;
      return r;
    }
    getChildTrie(t) {
      const r = this.mapFor(t, !0);
      let n = r.get(t);
      return n || r.set(t, n = new Cc(this.weakness, this.makeData)), n;
    }
    mapFor(t, r) {
      return this.weakness && Zee(t) ? this.weak || (r ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (r ? this.strong = /* @__PURE__ */ new Map() : void 0);
    }
  }
  function Zee(e) {
    switch (typeof e) {
      case "object":
        if (e === null)
          break;
      // Fall through to return true...
      case "function":
        return !0;
    }
    return !1;
  }
  function Jee() {
  }
  class uP {
    constructor(t = 1 / 0, r = Jee) {
      this.max = t, this.dispose = r, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
    }
    has(t) {
      return this.map.has(t);
    }
    get(t) {
      const r = this.getNode(t);
      return r && r.value;
    }
    get size() {
      return this.map.size;
    }
    getNode(t) {
      const r = this.map.get(t);
      if (r && r !== this.newest) {
        const { older: n, newer: i } = r;
        i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
      }
      return r;
    }
    set(t, r) {
      let n = this.getNode(t);
      return n ? n.value = r : (n = {
        key: t,
        value: r,
        newer: null,
        older: this.newest
      }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(t, n), n.value);
    }
    clean() {
      for (; this.oldest && this.map.size > this.max; )
        this.delete(this.oldest.key);
    }
    delete(t) {
      const r = this.map.get(t);
      return r ? (r === this.newest && (this.newest = r.older), r === this.oldest && (this.oldest = r.newer), r.newer && (r.newer.older = r.older), r.older && (r.older.newer = r.newer), this.map.delete(t), this.dispose(r.value, t), !0) : !1;
    }
  }
  function sP() {
  }
  const ete = sP, tte = typeof WeakRef < "u" ? WeakRef : function(e) {
    return { deref: () => e };
  }, rte = typeof WeakMap < "u" ? WeakMap : Map, nte = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
    return {
      register: sP,
      unregister: sP
    };
  }, ite = 10024;
  class pS {
    constructor(t = 1 / 0, r = ete) {
      this.max = t, this.dispose = r, this.map = new rte(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
        const n = this.unfinalizedNodes.values();
        for (let i = 0; i < ite; i++) {
          const u = n.next().value;
          if (!u)
            break;
          this.unfinalizedNodes.delete(u);
          const s = u.key;
          delete u.key, u.keyRef = new tte(s), this.registry.register(s, u, u);
        }
        this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
      }, this.registry = new nte(this.deleteNode.bind(this));
    }
    has(t) {
      return this.map.has(t);
    }
    get(t) {
      const r = this.getNode(t);
      return r && r.value;
    }
    getNode(t) {
      const r = this.map.get(t);
      if (r && r !== this.newest) {
        const { older: n, newer: i } = r;
        i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
      }
      return r;
    }
    set(t, r) {
      let n = this.getNode(t);
      return n ? n.value = r : (n = {
        key: t,
        value: r,
        newer: null,
        older: this.newest
      }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.scheduleFinalization(n), this.map.set(t, n), this.size++, n.value);
    }
    clean() {
      for (; this.oldest && this.size > this.max; )
        this.deleteNode(this.oldest);
    }
    deleteNode(t) {
      t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.size--;
      const r = t.key || t.keyRef && t.keyRef.deref();
      this.dispose(t.value, r), t.keyRef ? this.registry.unregister(t) : this.unfinalizedNodes.delete(t), r && this.map.delete(r);
    }
    delete(t) {
      const r = this.map.get(t);
      return r ? (this.deleteNode(r), !0) : !1;
    }
    scheduleFinalization(t) {
      this.unfinalizedNodes.add(t), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
    }
  }
  let na = null;
  const iB = {};
  let ate = 1;
  const ote = () => class {
    constructor() {
      this.id = [
        "slot",
        ate++,
        Date.now(),
        Math.random().toString(36).slice(2)
      ].join(":");
    }
    hasValue() {
      for (let t = na; t; t = t.parent)
        if (this.id in t.slots) {
          const r = t.slots[this.id];
          if (r === iB)
            break;
          return t !== na && (na.slots[this.id] = r), !0;
        }
      return na && (na.slots[this.id] = iB), !1;
    }
    getValue() {
      if (this.hasValue())
        return na.slots[this.id];
    }
    withValue(t, r, n, i) {
      const u = {
        __proto__: null,
        [this.id]: t
      }, s = na;
      na = { parent: s, slots: u };
      try {
        return r.apply(i, n);
      } finally {
        na = s;
      }
    }
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    static bind(t) {
      const r = na;
      return function() {
        const n = na;
        try {
          return na = r, t.apply(this, arguments);
        } finally {
          na = n;
        }
      };
    }
    // Immediately run a callback function without any captured context.
    static noContext(t, r, n) {
      if (na) {
        const i = na;
        try {
          return na = null, t.apply(n, r);
        } finally {
          na = i;
        }
      } else
        return t.apply(n, r);
    }
  };
  function aB(e) {
    try {
      return e();
    } catch {
    }
  }
  const jA = "@wry/context:Slot", ute = (
    // Prefer globalThis when available.
    // https://github.com/benjamn/wryware/issues/347
    aB(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
    // bundlers to the appropriate identifier (window, self, ...) depending on the
    // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
    aB(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
    // back to using the Array constructor as a namespace, but that was flagged in
    // https://github.com/benjamn/wryware/issues/347, and can be avoided.
    /* @__PURE__ */ Object.create(null)
  ), oB = ute, Nx = oB[jA] || // Earlier versions of this package stored the globalKey property on the Array
  // constructor, so we check there as well, to prevent Slot class duplication.
  Array[jA] || function(e) {
    try {
      Object.defineProperty(oB, jA, {
        value: e,
        enumerable: !1,
        writable: !1,
        // When it was possible for globalHost to be the Array constructor (a
        // legacy Slot dedup strategy), it was important for the property to be
        // configurable:true so it could be deleted. That does not seem to be as
        // important when globalHost is the global object, but I don't want to
        // cause similar problems again, and configurable:true seems safest.
        // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
        configurable: !0
      });
    } finally {
      return e;
    }
  }(ote()), { bind: GTe, noContext: QTe } = Nx, E_ = new Nx(), { hasOwnProperty: ste } = Object.prototype, fN = Array.from || function(e) {
    const t = [];
    return e.forEach((r) => t.push(r)), t;
  };
  function dN(e) {
    const { unsubscribe: t } = e;
    typeof t == "function" && (e.unsubscribe = void 0, t());
  }
  const Wg = [], lte = 100;
  function i0(e, t) {
    if (!e)
      throw new Error(t || "assertion failure");
  }
  function xU(e, t) {
    const r = e.length;
    return (
      // Unknown values are not equal to each other.
      r > 0 && // Both values must be ordinary (or both exceptional) to be equal.
      r === t.length && // The underlying value or exception must be the same.
      e[r - 1] === t[r - 1]
    );
  }
  function bU(e) {
    switch (e.length) {
      case 0:
        throw new Error("unknown value");
      case 1:
        return e[0];
      case 2:
        throw e[1];
    }
  }
  function wU(e) {
    return e.slice(0);
  }
  class S_ {
    constructor(t) {
      this.fn = t, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++S_.count;
    }
    peek() {
      if (this.value.length === 1 && !Lf(this))
        return uB(this), this.value[0];
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(t) {
      return i0(!this.recomputing, "already recomputing"), uB(this), Lf(this) ? cte(this, t) : bU(this.value);
    }
    setDirty() {
      this.dirty || (this.dirty = !0, EU(this), dN(this));
    }
    dispose() {
      this.setDirty(), TU(this), pN(this, (t, r) => {
        t.setDirty(), AU(t, this);
      });
    }
    forget() {
      this.dispose();
    }
    dependOn(t) {
      t.add(this), this.deps || (this.deps = Wg.pop() || /* @__PURE__ */ new Set()), this.deps.add(t);
    }
    forgetDeps() {
      this.deps && (fN(this.deps).forEach((t) => t.delete(this)), this.deps.clear(), Wg.push(this.deps), this.deps = null);
    }
  }
  S_.count = 0;
  function uB(e) {
    const t = E_.getValue();
    if (t)
      return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), Lf(e) ? _U(t, e) : CU(t, e), t;
  }
  function cte(e, t) {
    return TU(e), E_.withValue(e, fte, [e, t]), pte(e, t) && dte(e), bU(e.value);
  }
  function fte(e, t) {
    e.recomputing = !0;
    const { normalizeResult: r } = e;
    let n;
    r && e.value.length === 1 && (n = wU(e.value)), e.value.length = 0;
    try {
      if (e.value[0] = e.fn.apply(null, t), r && n && !xU(n, e.value))
        try {
          e.value[0] = r(e.value[0], n[0]);
        } catch {
        }
    } catch (i) {
      e.value[1] = i;
    }
    e.recomputing = !1;
  }
  function Lf(e) {
    return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
  }
  function dte(e) {
    e.dirty = !1, !Lf(e) && SU(e);
  }
  function EU(e) {
    pN(e, _U);
  }
  function SU(e) {
    pN(e, CU);
  }
  function pN(e, t) {
    const r = e.parents.size;
    if (r) {
      const n = fN(e.parents);
      for (let i = 0; i < r; ++i)
        t(n[i], e);
    }
  }
  function _U(e, t) {
    i0(e.childValues.has(t)), i0(Lf(t));
    const r = !Lf(e);
    if (!e.dirtyChildren)
      e.dirtyChildren = Wg.pop() || /* @__PURE__ */ new Set();
    else if (e.dirtyChildren.has(t))
      return;
    e.dirtyChildren.add(t), r && EU(e);
  }
  function CU(e, t) {
    i0(e.childValues.has(t)), i0(!Lf(t));
    const r = e.childValues.get(t);
    r.length === 0 ? e.childValues.set(t, wU(t.value)) : xU(r, t.value) || e.setDirty(), OU(e, t), !Lf(e) && SU(e);
  }
  function OU(e, t) {
    const r = e.dirtyChildren;
    r && (r.delete(t), r.size === 0 && (Wg.length < lte && Wg.push(r), e.dirtyChildren = null));
  }
  function TU(e) {
    e.childValues.size > 0 && e.childValues.forEach((t, r) => {
      AU(e, r);
    }), e.forgetDeps(), i0(e.dirtyChildren === null);
  }
  function AU(e, t) {
    t.parents.delete(e), e.childValues.delete(t), OU(e, t);
  }
  function pte(e, t) {
    if (typeof e.subscribe == "function")
      try {
        dN(e), e.unsubscribe = e.subscribe.apply(null, t);
      } catch {
        return e.setDirty(), !1;
      }
    return !0;
  }
  const hte = {
    setDirty: !0,
    dispose: !0,
    forget: !0
    // Fully remove parent Entry from LRU cache and computation graph
  };
  function DU(e) {
    const t = /* @__PURE__ */ new Map();
    function r(n) {
      const i = E_.getValue();
      if (i) {
        let u = t.get(n);
        u || t.set(n, u = /* @__PURE__ */ new Set()), i.dependOn(u);
      }
    }
    return r.dirty = function(i, u) {
      const s = t.get(i);
      if (s) {
        const c = u && ste.call(hte, u) ? u : "setDirty";
        fN(s).forEach((p) => p[c]()), t.delete(i), dN(s);
      }
    }, r;
  }
  let sB;
  function vte(...e) {
    return (sB || (sB = new Cc(typeof WeakMap == "function"))).lookupArray(e);
  }
  const FA = /* @__PURE__ */ new Set();
  function Yg(e, { max: t = Math.pow(2, 16), keyArgs: r, makeCacheKey: n = vte, normalizeResult: i, subscribe: u, cache: s = uP } = /* @__PURE__ */ Object.create(null)) {
    const c = typeof s == "function" ? new s(t, (x) => x.dispose()) : s, p = function() {
      const x = n.apply(null, r ? r.apply(null, arguments) : arguments);
      if (x === void 0)
        return e.apply(null, arguments);
      let w = c.get(x);
      w || (c.set(x, w = new S_(e)), w.normalizeResult = i, w.subscribe = u, w.forget = () => c.delete(x));
      const E = w.recompute(Array.prototype.slice.call(arguments));
      return c.set(x, w), FA.add(c), E_.hasValue() || (FA.forEach((C) => C.clean()), FA.clear()), E;
    };
    Object.defineProperty(p, "size", {
      get: () => c.size,
      configurable: !1,
      enumerable: !1
    }), Object.freeze(p.options = {
      max: t,
      keyArgs: r,
      makeCacheKey: n,
      normalizeResult: i,
      subscribe: u,
      cache: c
    });
    function h(x) {
      const w = x && c.get(x);
      w && w.setDirty();
    }
    p.dirtyKey = h, p.dirty = function() {
      h(n.apply(null, arguments));
    };
    function v(x) {
      const w = x && c.get(x);
      if (w)
        return w.peek();
    }
    p.peekKey = v, p.peek = function() {
      return v(n.apply(null, arguments));
    };
    function y(x) {
      return x ? c.delete(x) : !1;
    }
    return p.forgetKey = y, p.forget = function() {
      return y(n.apply(null, arguments));
    }, p.makeCacheKey = n, p.getKey = r ? function() {
      return n.apply(null, r.apply(null, arguments));
    } : n, Object.freeze(p);
  }
  function bE(e, t) {
    if (!!!e)
      throw new Error(t);
  }
  function mte(e) {
    return typeof e == "object" && e !== null;
  }
  function yte(e, t) {
    if (!!!e)
      throw new Error(
        "Unexpected invariant triggered."
      );
  }
  const gte = /\r\n|[\n\r]/g;
  function lP(e, t) {
    let r = 0, n = 1;
    for (const i of e.body.matchAll(gte)) {
      if (typeof i.index == "number" || yte(!1), i.index >= t)
        break;
      r = i.index + i[0].length, n += 1;
    }
    return {
      line: n,
      column: t + 1 - r
    };
  }
  function xte(e) {
    return kU(
      e.source,
      lP(e.source, e.start)
    );
  }
  function kU(e, t) {
    const r = e.locationOffset.column - 1, n = "".padStart(r) + e.body, i = t.line - 1, u = e.locationOffset.line - 1, s = t.line + u, c = t.line === 1 ? r : 0, p = t.column + c, h = `${e.name}:${s}:${p}
`, v = n.split(/\r\n|[\n\r]/g), y = v[i];
    if (y.length > 120) {
      const x = Math.floor(p / 80), w = p % 80, E = [];
      for (let C = 0; C < y.length; C += 80)
        E.push(y.slice(C, C + 80));
      return h + lB([
        [`${s} |`, E[0]],
        ...E.slice(1, x + 1).map((C) => ["|", C]),
        ["|", "^".padStart(w)],
        ["|", E[x + 1]]
      ]);
    }
    return h + lB([
      // Lines specified like this: ["prefix", "string"],
      [`${s - 1} |`, v[i - 1]],
      [`${s} |`, y],
      ["|", "^".padStart(p)],
      [`${s + 1} |`, v[i + 1]]
    ]);
  }
  function lB(e) {
    const t = e.filter(([n, i]) => i !== void 0), r = Math.max(...t.map(([n]) => n.length));
    return t.map(([n, i]) => n.padStart(r) + (i ? " " + i : "")).join(`
`);
  }
  function bte(e) {
    const t = e[0];
    return t == null || "kind" in t || "length" in t ? {
      nodes: t,
      source: e[1],
      positions: e[2],
      path: e[3],
      originalError: e[4],
      extensions: e[5]
    } : t;
  }
  class hN extends Error {
    /**
     * An array of `{ line, column }` locations within the source GraphQL document
     * which correspond to this error.
     *
     * Errors during validation often contain multiple locations, for example to
     * point out two things with the same name. Errors during execution include a
     * single location, the field which produced the error.
     *
     * Enumerable, and appears in the result of JSON.stringify().
     */
    /**
     * An array describing the JSON-path into the execution response which
     * corresponds to this error. Only included for errors during execution.
     *
     * Enumerable, and appears in the result of JSON.stringify().
     */
    /**
     * An array of GraphQL AST Nodes corresponding to this error.
     */
    /**
     * The source GraphQL document for the first location of this error.
     *
     * Note that if this Error represents more than one node, the source may not
     * represent nodes after the first node.
     */
    /**
     * An array of character offsets within the source GraphQL document
     * which correspond to this error.
     */
    /**
     * The original error thrown from a field resolver during execution.
     */
    /**
     * Extension fields to add to the formatted error.
     */
    /**
     * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
     */
    constructor(t, ...r) {
      var n, i, u;
      const { nodes: s, source: c, positions: p, path: h, originalError: v, extensions: y } = bte(r);
      super(t), this.name = "GraphQLError", this.path = h ?? void 0, this.originalError = v ?? void 0, this.nodes = cB(
        Array.isArray(s) ? s : s ? [s] : void 0
      );
      const x = cB(
        (n = this.nodes) === null || n === void 0 ? void 0 : n.map((E) => E.loc).filter((E) => E != null)
      );
      this.source = c ?? (x == null || (i = x[0]) === null || i === void 0 ? void 0 : i.source), this.positions = p ?? (x == null ? void 0 : x.map((E) => E.start)), this.locations = p && c ? p.map((E) => lP(c, E)) : x == null ? void 0 : x.map((E) => lP(E.source, E.start));
      const w = mte(
        v == null ? void 0 : v.extensions
      ) ? v == null ? void 0 : v.extensions : void 0;
      this.extensions = (u = y ?? w) !== null && u !== void 0 ? u : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
        message: {
          writable: !0,
          enumerable: !0
        },
        name: {
          enumerable: !1
        },
        nodes: {
          enumerable: !1
        },
        source: {
          enumerable: !1
        },
        positions: {
          enumerable: !1
        },
        originalError: {
          enumerable: !1
        }
      }), v != null && v.stack ? Object.defineProperty(this, "stack", {
        value: v.stack,
        writable: !0,
        configurable: !0
      }) : Error.captureStackTrace ? Error.captureStackTrace(this, hN) : Object.defineProperty(this, "stack", {
        value: Error().stack,
        writable: !0,
        configurable: !0
      });
    }
    get [Symbol.toStringTag]() {
      return "GraphQLError";
    }
    toString() {
      let t = this.message;
      if (this.nodes)
        for (const r of this.nodes)
          r.loc && (t += `

` + xte(r.loc));
      else if (this.source && this.locations)
        for (const r of this.locations)
          t += `

` + kU(this.source, r);
      return t;
    }
    toJSON() {
      const t = {
        message: this.message
      };
      return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
    }
  }
  function cB(e) {
    return e === void 0 || e.length === 0 ? void 0 : e;
  }
  function Ii(e, t, r) {
    return new hN(`Syntax Error: ${r}`, {
      source: e,
      positions: [t]
    });
  }
  class wte {
    /**
     * The character offset at which this Node begins.
     */
    /**
     * The character offset at which this Node ends.
     */
    /**
     * The Token at which this Node begins.
     */
    /**
     * The Token at which this Node ends.
     */
    /**
     * The Source document the AST represents.
     */
    constructor(t, r, n) {
      this.start = t.start, this.end = r.end, this.startToken = t, this.endToken = r, this.source = n;
    }
    get [Symbol.toStringTag]() {
      return "Location";
    }
    toJSON() {
      return {
        start: this.start,
        end: this.end
      };
    }
  }
  class RU {
    /**
     * The kind of Token.
     */
    /**
     * The character offset at which this Node begins.
     */
    /**
     * The character offset at which this Node ends.
     */
    /**
     * The 1-indexed line number on which this Token appears.
     */
    /**
     * The 1-indexed column number at which this Token begins.
     */
    /**
     * For non-punctuation tokens, represents the interpreted value of the token.
     *
     * Note: is undefined for punctuation tokens, but typed as string for
     * convenience in the parser.
     */
    /**
     * Tokens exist as nodes in a double-linked-list amongst all tokens
     * including ignored tokens. <SOF> is always the first node and <EOF>
     * the last.
     */
    constructor(t, r, n, i, u, s) {
      this.kind = t, this.start = r, this.end = n, this.line = i, this.column = u, this.value = s, this.prev = null, this.next = null;
    }
    get [Symbol.toStringTag]() {
      return "Token";
    }
    toJSON() {
      return {
        kind: this.kind,
        value: this.value,
        line: this.line,
        column: this.column
      };
    }
  }
  const PU = {
    Name: [],
    Document: ["definitions"],
    OperationDefinition: [
      "name",
      "variableDefinitions",
      "directives",
      "selectionSet"
    ],
    VariableDefinition: ["variable", "type", "defaultValue", "directives"],
    Variable: ["name"],
    SelectionSet: ["selections"],
    Field: ["alias", "name", "arguments", "directives", "selectionSet"],
    Argument: ["name", "value"],
    FragmentSpread: ["name", "directives"],
    InlineFragment: ["typeCondition", "directives", "selectionSet"],
    FragmentDefinition: [
      "name",
      // Note: fragment variable definitions are deprecated and will removed in v17.0.0
      "variableDefinitions",
      "typeCondition",
      "directives",
      "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: ["values"],
    ObjectValue: ["fields"],
    ObjectField: ["name", "value"],
    Directive: ["name", "arguments"],
    NamedType: ["name"],
    ListType: ["type"],
    NonNullType: ["type"],
    SchemaDefinition: ["description", "directives", "operationTypes"],
    OperationTypeDefinition: ["type"],
    ScalarTypeDefinition: ["description", "name", "directives"],
    ObjectTypeDefinition: [
      "description",
      "name",
      "interfaces",
      "directives",
      "fields"
    ],
    FieldDefinition: ["description", "name", "arguments", "type", "directives"],
    InputValueDefinition: [
      "description",
      "name",
      "type",
      "defaultValue",
      "directives"
    ],
    InterfaceTypeDefinition: [
      "description",
      "name",
      "interfaces",
      "directives",
      "fields"
    ],
    UnionTypeDefinition: ["description", "name", "directives", "types"],
    EnumTypeDefinition: ["description", "name", "directives", "values"],
    EnumValueDefinition: ["description", "name", "directives"],
    InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
    DirectiveDefinition: ["description", "name", "arguments", "locations"],
    SchemaExtension: ["directives", "operationTypes"],
    ScalarTypeExtension: ["name", "directives"],
    ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
    InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
    UnionTypeExtension: ["name", "directives", "types"],
    EnumTypeExtension: ["name", "directives", "values"],
    InputObjectTypeExtension: ["name", "directives", "fields"]
  }, Ete = new Set(Object.keys(PU));
  function fB(e) {
    const t = e == null ? void 0 : e.kind;
    return typeof t == "string" && Ete.has(t);
  }
  var qv;
  (function(e) {
    e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
  })(qv || (qv = {}));
  var cP;
  (function(e) {
    e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
  })(cP || (cP = {}));
  var at;
  (function(e) {
    e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
  })(at || (at = {}));
  function fP(e) {
    return e === 9 || e === 32;
  }
  function Gg(e) {
    return e >= 48 && e <= 57;
  }
  function MU(e) {
    return e >= 97 && e <= 122 || // A-Z
    e >= 65 && e <= 90;
  }
  function NU(e) {
    return MU(e) || e === 95;
  }
  function Ste(e) {
    return MU(e) || Gg(e) || e === 95;
  }
  function _te(e) {
    var t;
    let r = Number.MAX_SAFE_INTEGER, n = null, i = -1;
    for (let s = 0; s < e.length; ++s) {
      var u;
      const c = e[s], p = Cte(c);
      p !== c.length && (n = (u = n) !== null && u !== void 0 ? u : s, i = s, s !== 0 && p < r && (r = p));
    }
    return e.map((s, c) => c === 0 ? s : s.slice(r)).slice(
      (t = n) !== null && t !== void 0 ? t : 0,
      i + 1
    );
  }
  function Cte(e) {
    let t = 0;
    for (; t < e.length && fP(e.charCodeAt(t)); )
      ++t;
    return t;
  }
  function Ote(e, t) {
    const r = e.replace(/"""/g, '\\"""'), n = r.split(/\r\n|[\n\r]/g), i = n.length === 1, u = n.length > 1 && n.slice(1).every((w) => w.length === 0 || fP(w.charCodeAt(0))), s = r.endsWith('\\"""'), c = e.endsWith('"') && !s, p = e.endsWith("\\"), h = c || p, v = (
      // add leading and trailing new lines only if it improves readability
      !i || e.length > 70 || h || u || s
    );
    let y = "";
    const x = i && fP(e.charCodeAt(0));
    return (v && !x || u) && (y += `
`), y += r, (v || h) && (y += `
`), '"""' + y + '"""';
  }
  var Be;
  (function(e) {
    e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
  })(Be || (Be = {}));
  class Tte {
    /**
     * The previously focused non-ignored token.
     */
    /**
     * The currently focused non-ignored token.
     */
    /**
     * The (1-indexed) line containing the current token.
     */
    /**
     * The character offset at which the current line begins.
     */
    constructor(t) {
      const r = new RU(Be.SOF, 0, 0, 0, 0);
      this.source = t, this.lastToken = r, this.token = r, this.line = 1, this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
      return "Lexer";
    }
    /**
     * Advances the token stream to the next non-ignored token.
     */
    advance() {
      return this.lastToken = this.token, this.token = this.lookahead();
    }
    /**
     * Looks ahead and returns the next non-ignored token, but does not change
     * the state of Lexer.
     */
    lookahead() {
      let t = this.token;
      if (t.kind !== Be.EOF)
        do
          if (t.next)
            t = t.next;
          else {
            const r = Dte(this, t.end);
            t.next = r, r.prev = t, t = r;
          }
        while (t.kind === Be.COMMENT);
      return t;
    }
  }
  function Ate(e) {
    return e === Be.BANG || e === Be.DOLLAR || e === Be.AMP || e === Be.PAREN_L || e === Be.PAREN_R || e === Be.SPREAD || e === Be.COLON || e === Be.EQUALS || e === Be.AT || e === Be.BRACKET_L || e === Be.BRACKET_R || e === Be.BRACE_L || e === Be.PIPE || e === Be.BRACE_R;
  }
  function I0(e) {
    return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
  }
  function __(e, t) {
    return jU(e.charCodeAt(t)) && FU(e.charCodeAt(t + 1));
  }
  function jU(e) {
    return e >= 55296 && e <= 56319;
  }
  function FU(e) {
    return e >= 56320 && e <= 57343;
  }
  function Pp(e, t) {
    const r = e.source.body.codePointAt(t);
    if (r === void 0)
      return Be.EOF;
    if (r >= 32 && r <= 126) {
      const n = String.fromCodePoint(r);
      return n === '"' ? `'"'` : `"${n}"`;
    }
    return "U+" + r.toString(16).toUpperCase().padStart(4, "0");
  }
  function si(e, t, r, n, i) {
    const u = e.line, s = 1 + r - e.lineStart;
    return new RU(t, r, n, u, s, i);
  }
  function Dte(e, t) {
    const r = e.source.body, n = r.length;
    let i = t;
    for (; i < n; ) {
      const u = r.charCodeAt(i);
      switch (u) {
        // Ignored ::
        //   - UnicodeBOM
        //   - WhiteSpace
        //   - LineTerminator
        //   - Comment
        //   - Comma
        //
        // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
        //
        // WhiteSpace ::
        //   - "Horizontal Tab (U+0009)"
        //   - "Space (U+0020)"
        //
        // Comma :: ,
        case 65279:
        // <BOM>
        case 9:
        // \t
        case 32:
        // <space>
        case 44:
          ++i;
          continue;
        // LineTerminator ::
        //   - "New Line (U+000A)"
        //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
        //   - "Carriage Return (U+000D)" "New Line (U+000A)"
        case 10:
          ++i, ++e.line, e.lineStart = i;
          continue;
        case 13:
          r.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++e.line, e.lineStart = i;
          continue;
        // Comment
        case 35:
          return kte(e, i);
        // Token ::
        //   - Punctuator
        //   - Name
        //   - IntValue
        //   - FloatValue
        //   - StringValue
        //
        // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
        case 33:
          return si(e, Be.BANG, i, i + 1);
        case 36:
          return si(e, Be.DOLLAR, i, i + 1);
        case 38:
          return si(e, Be.AMP, i, i + 1);
        case 40:
          return si(e, Be.PAREN_L, i, i + 1);
        case 41:
          return si(e, Be.PAREN_R, i, i + 1);
        case 46:
          if (r.charCodeAt(i + 1) === 46 && r.charCodeAt(i + 2) === 46)
            return si(e, Be.SPREAD, i, i + 3);
          break;
        case 58:
          return si(e, Be.COLON, i, i + 1);
        case 61:
          return si(e, Be.EQUALS, i, i + 1);
        case 64:
          return si(e, Be.AT, i, i + 1);
        case 91:
          return si(e, Be.BRACKET_L, i, i + 1);
        case 93:
          return si(e, Be.BRACKET_R, i, i + 1);
        case 123:
          return si(e, Be.BRACE_L, i, i + 1);
        case 124:
          return si(e, Be.PIPE, i, i + 1);
        case 125:
          return si(e, Be.BRACE_R, i, i + 1);
        // StringValue
        case 34:
          return r.charCodeAt(i + 1) === 34 && r.charCodeAt(i + 2) === 34 ? Fte(e, i) : Pte(e, i);
      }
      if (Gg(u) || u === 45)
        return Rte(e, i, u);
      if (NU(u))
        return Ite(e, i);
      throw Ii(
        e.source,
        i,
        u === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : I0(u) || __(r, i) ? `Unexpected character: ${Pp(e, i)}.` : `Invalid character: ${Pp(e, i)}.`
      );
    }
    return si(e, Be.EOF, n, n);
  }
  function kte(e, t) {
    const r = e.source.body, n = r.length;
    let i = t + 1;
    for (; i < n; ) {
      const u = r.charCodeAt(i);
      if (u === 10 || u === 13)
        break;
      if (I0(u))
        ++i;
      else if (__(r, i))
        i += 2;
      else
        break;
    }
    return si(
      e,
      Be.COMMENT,
      t,
      i,
      r.slice(t + 1, i)
    );
  }
  function Rte(e, t, r) {
    const n = e.source.body;
    let i = t, u = r, s = !1;
    if (u === 45 && (u = n.charCodeAt(++i)), u === 48) {
      if (u = n.charCodeAt(++i), Gg(u))
        throw Ii(
          e.source,
          i,
          `Invalid number, unexpected digit after 0: ${Pp(
            e,
            i
          )}.`
        );
    } else
      i = IA(e, i, u), u = n.charCodeAt(i);
    if (u === 46 && (s = !0, u = n.charCodeAt(++i), i = IA(e, i, u), u = n.charCodeAt(i)), (u === 69 || u === 101) && (s = !0, u = n.charCodeAt(++i), (u === 43 || u === 45) && (u = n.charCodeAt(++i)), i = IA(e, i, u), u = n.charCodeAt(i)), u === 46 || NU(u))
      throw Ii(
        e.source,
        i,
        `Invalid number, expected digit but got: ${Pp(
          e,
          i
        )}.`
      );
    return si(
      e,
      s ? Be.FLOAT : Be.INT,
      t,
      i,
      n.slice(t, i)
    );
  }
  function IA(e, t, r) {
    if (!Gg(r))
      throw Ii(
        e.source,
        t,
        `Invalid number, expected digit but got: ${Pp(
          e,
          t
        )}.`
      );
    const n = e.source.body;
    let i = t + 1;
    for (; Gg(n.charCodeAt(i)); )
      ++i;
    return i;
  }
  function Pte(e, t) {
    const r = e.source.body, n = r.length;
    let i = t + 1, u = i, s = "";
    for (; i < n; ) {
      const c = r.charCodeAt(i);
      if (c === 34)
        return s += r.slice(u, i), si(e, Be.STRING, t, i + 1, s);
      if (c === 92) {
        s += r.slice(u, i);
        const p = r.charCodeAt(i + 1) === 117 ? r.charCodeAt(i + 2) === 123 ? Mte(e, i) : Nte(e, i) : jte(e, i);
        s += p.value, i += p.size, u = i;
        continue;
      }
      if (c === 10 || c === 13)
        break;
      if (I0(c))
        ++i;
      else if (__(r, i))
        i += 2;
      else
        throw Ii(
          e.source,
          i,
          `Invalid character within String: ${Pp(
            e,
            i
          )}.`
        );
    }
    throw Ii(e.source, i, "Unterminated string.");
  }
  function Mte(e, t) {
    const r = e.source.body;
    let n = 0, i = 3;
    for (; i < 12; ) {
      const u = r.charCodeAt(t + i++);
      if (u === 125) {
        if (i < 5 || !I0(n))
          break;
        return {
          value: String.fromCodePoint(n),
          size: i
        };
      }
      if (n = n << 4 | Dg(u), n < 0)
        break;
    }
    throw Ii(
      e.source,
      t,
      `Invalid Unicode escape sequence: "${r.slice(
        t,
        t + i
      )}".`
    );
  }
  function Nte(e, t) {
    const r = e.source.body, n = dB(r, t + 2);
    if (I0(n))
      return {
        value: String.fromCodePoint(n),
        size: 6
      };
    if (jU(n) && r.charCodeAt(t + 6) === 92 && r.charCodeAt(t + 7) === 117) {
      const i = dB(r, t + 8);
      if (FU(i))
        return {
          value: String.fromCodePoint(n, i),
          size: 12
        };
    }
    throw Ii(
      e.source,
      t,
      `Invalid Unicode escape sequence: "${r.slice(t, t + 6)}".`
    );
  }
  function dB(e, t) {
    return Dg(e.charCodeAt(t)) << 12 | Dg(e.charCodeAt(t + 1)) << 8 | Dg(e.charCodeAt(t + 2)) << 4 | Dg(e.charCodeAt(t + 3));
  }
  function Dg(e) {
    return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
  }
  function jte(e, t) {
    const r = e.source.body;
    switch (r.charCodeAt(t + 1)) {
      case 34:
        return {
          value: '"',
          size: 2
        };
      case 92:
        return {
          value: "\\",
          size: 2
        };
      case 47:
        return {
          value: "/",
          size: 2
        };
      case 98:
        return {
          value: "\b",
          size: 2
        };
      case 102:
        return {
          value: "\f",
          size: 2
        };
      case 110:
        return {
          value: `
`,
          size: 2
        };
      case 114:
        return {
          value: "\r",
          size: 2
        };
      case 116:
        return {
          value: "	",
          size: 2
        };
    }
    throw Ii(
      e.source,
      t,
      `Invalid character escape sequence: "${r.slice(
        t,
        t + 2
      )}".`
    );
  }
  function Fte(e, t) {
    const r = e.source.body, n = r.length;
    let i = e.lineStart, u = t + 3, s = u, c = "";
    const p = [];
    for (; u < n; ) {
      const h = r.charCodeAt(u);
      if (h === 34 && r.charCodeAt(u + 1) === 34 && r.charCodeAt(u + 2) === 34) {
        c += r.slice(s, u), p.push(c);
        const v = si(
          e,
          Be.BLOCK_STRING,
          t,
          u + 3,
          // Return a string of the lines joined with U+000A.
          _te(p).join(`
`)
        );
        return e.line += p.length - 1, e.lineStart = i, v;
      }
      if (h === 92 && r.charCodeAt(u + 1) === 34 && r.charCodeAt(u + 2) === 34 && r.charCodeAt(u + 3) === 34) {
        c += r.slice(s, u), s = u + 1, u += 4;
        continue;
      }
      if (h === 10 || h === 13) {
        c += r.slice(s, u), p.push(c), h === 13 && r.charCodeAt(u + 1) === 10 ? u += 2 : ++u, c = "", s = u, i = u;
        continue;
      }
      if (I0(h))
        ++u;
      else if (__(r, u))
        u += 2;
      else
        throw Ii(
          e.source,
          u,
          `Invalid character within String: ${Pp(
            e,
            u
          )}.`
        );
    }
    throw Ii(e.source, u, "Unterminated string.");
  }
  function Ite(e, t) {
    const r = e.source.body, n = r.length;
    let i = t + 1;
    for (; i < n; ) {
      const u = r.charCodeAt(i);
      if (Ste(u))
        ++i;
      else
        break;
    }
    return si(
      e,
      Be.NAME,
      t,
      i,
      r.slice(t, i)
    );
  }
  const Bte = 10, IU = 2;
  function vN(e) {
    return C_(e, []);
  }
  function C_(e, t) {
    switch (typeof e) {
      case "string":
        return JSON.stringify(e);
      case "function":
        return e.name ? `[function ${e.name}]` : "[function]";
      case "object":
        return Lte(e, t);
      default:
        return String(e);
    }
  }
  function Lte(e, t) {
    if (e === null)
      return "null";
    if (t.includes(e))
      return "[Circular]";
    const r = [...t, e];
    if ($te(e)) {
      const n = e.toJSON();
      if (n !== e)
        return typeof n == "string" ? n : C_(n, r);
    } else if (Array.isArray(e))
      return qte(e, r);
    return zte(e, r);
  }
  function $te(e) {
    return typeof e.toJSON == "function";
  }
  function zte(e, t) {
    const r = Object.entries(e);
    return r.length === 0 ? "{}" : t.length > IU ? "[" + Ute(e) + "]" : "{ " + r.map(
      ([i, u]) => i + ": " + C_(u, t)
    ).join(", ") + " }";
  }
  function qte(e, t) {
    if (e.length === 0)
      return "[]";
    if (t.length > IU)
      return "[Array]";
    const r = Math.min(Bte, e.length), n = e.length - r, i = [];
    for (let u = 0; u < r; ++u)
      i.push(C_(e[u], t));
    return n === 1 ? i.push("... 1 more item") : n > 1 && i.push(`... ${n} more items`), "[" + i.join(", ") + "]";
  }
  function Ute(e) {
    const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
    if (t === "Object" && typeof e.constructor == "function") {
      const r = e.constructor.name;
      if (typeof r == "string" && r !== "")
        return r;
    }
    return t;
  }
  const Hte = globalThis.process && // eslint-disable-next-line no-undef
  process.env.NODE_ENV === "production", Vte = (
    /* c8 ignore next 6 */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317
    Hte ? function(t, r) {
      return t instanceof r;
    } : function(t, r) {
      if (t instanceof r)
        return !0;
      if (typeof t == "object" && t !== null) {
        var n;
        const i = r.prototype[Symbol.toStringTag], u = (
          // We still need to support constructor's name to detect conflicts with older versions of this library.
          Symbol.toStringTag in t ? t[Symbol.toStringTag] : (n = t.constructor) === null || n === void 0 ? void 0 : n.name
        );
        if (i === u) {
          const s = vN(t);
          throw new Error(`Cannot use ${i} "${s}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
      }
      return !1;
    }
  );
  class BU {
    constructor(t, r = "GraphQL request", n = {
      line: 1,
      column: 1
    }) {
      typeof t == "string" || bE(!1, `Body must be a string. Received: ${vN(t)}.`), this.body = t, this.name = r, this.locationOffset = n, this.locationOffset.line > 0 || bE(
        !1,
        "line in locationOffset is 1-indexed and must be positive."
      ), this.locationOffset.column > 0 || bE(
        !1,
        "column in locationOffset is 1-indexed and must be positive."
      );
    }
    get [Symbol.toStringTag]() {
      return "Source";
    }
  }
  function Wte(e) {
    return Vte(e, BU);
  }
  function Yte(e, t) {
    const r = new Gte(e, t), n = r.parseDocument();
    return Object.defineProperty(n, "tokenCount", {
      enumerable: !1,
      value: r.tokenCount
    }), n;
  }
  let Gte = class {
    constructor(t, r = {}) {
      const n = Wte(t) ? t : new BU(t);
      this._lexer = new Tte(n), this._options = r, this._tokenCounter = 0;
    }
    get tokenCount() {
      return this._tokenCounter;
    }
    /**
     * Converts a name lex token into a name parse node.
     */
    parseName() {
      const t = this.expectToken(Be.NAME);
      return this.node(t, {
        kind: at.NAME,
        value: t.value
      });
    }
    // Implements the parsing rules in the Document section.
    /**
     * Document : Definition+
     */
    parseDocument() {
      return this.node(this._lexer.token, {
        kind: at.DOCUMENT,
        definitions: this.many(
          Be.SOF,
          this.parseDefinition,
          Be.EOF
        )
      });
    }
    /**
     * Definition :
     *   - ExecutableDefinition
     *   - TypeSystemDefinition
     *   - TypeSystemExtension
     *
     * ExecutableDefinition :
     *   - OperationDefinition
     *   - FragmentDefinition
     *
     * TypeSystemDefinition :
     *   - SchemaDefinition
     *   - TypeDefinition
     *   - DirectiveDefinition
     *
     * TypeDefinition :
     *   - ScalarTypeDefinition
     *   - ObjectTypeDefinition
     *   - InterfaceTypeDefinition
     *   - UnionTypeDefinition
     *   - EnumTypeDefinition
     *   - InputObjectTypeDefinition
     */
    parseDefinition() {
      if (this.peek(Be.BRACE_L))
        return this.parseOperationDefinition();
      const t = this.peekDescription(), r = t ? this._lexer.lookahead() : this._lexer.token;
      if (r.kind === Be.NAME) {
        switch (r.value) {
          case "schema":
            return this.parseSchemaDefinition();
          case "scalar":
            return this.parseScalarTypeDefinition();
          case "type":
            return this.parseObjectTypeDefinition();
          case "interface":
            return this.parseInterfaceTypeDefinition();
          case "union":
            return this.parseUnionTypeDefinition();
          case "enum":
            return this.parseEnumTypeDefinition();
          case "input":
            return this.parseInputObjectTypeDefinition();
          case "directive":
            return this.parseDirectiveDefinition();
        }
        if (t)
          throw Ii(
            this._lexer.source,
            this._lexer.token.start,
            "Unexpected description, descriptions are supported only on type definitions."
          );
        switch (r.value) {
          case "query":
          case "mutation":
          case "subscription":
            return this.parseOperationDefinition();
          case "fragment":
            return this.parseFragmentDefinition();
          case "extend":
            return this.parseTypeSystemExtension();
        }
      }
      throw this.unexpected(r);
    }
    // Implements the parsing rules in the Operations section.
    /**
     * OperationDefinition :
     *  - SelectionSet
     *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
     */
    parseOperationDefinition() {
      const t = this._lexer.token;
      if (this.peek(Be.BRACE_L))
        return this.node(t, {
          kind: at.OPERATION_DEFINITION,
          operation: qv.QUERY,
          name: void 0,
          variableDefinitions: [],
          directives: [],
          selectionSet: this.parseSelectionSet()
        });
      const r = this.parseOperationType();
      let n;
      return this.peek(Be.NAME) && (n = this.parseName()), this.node(t, {
        kind: at.OPERATION_DEFINITION,
        operation: r,
        name: n,
        variableDefinitions: this.parseVariableDefinitions(),
        directives: this.parseDirectives(!1),
        selectionSet: this.parseSelectionSet()
      });
    }
    /**
     * OperationType : one of query mutation subscription
     */
    parseOperationType() {
      const t = this.expectToken(Be.NAME);
      switch (t.value) {
        case "query":
          return qv.QUERY;
        case "mutation":
          return qv.MUTATION;
        case "subscription":
          return qv.SUBSCRIPTION;
      }
      throw this.unexpected(t);
    }
    /**
     * VariableDefinitions : ( VariableDefinition+ )
     */
    parseVariableDefinitions() {
      return this.optionalMany(
        Be.PAREN_L,
        this.parseVariableDefinition,
        Be.PAREN_R
      );
    }
    /**
     * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
     */
    parseVariableDefinition() {
      return this.node(this._lexer.token, {
        kind: at.VARIABLE_DEFINITION,
        variable: this.parseVariable(),
        type: (this.expectToken(Be.COLON), this.parseTypeReference()),
        defaultValue: this.expectOptionalToken(Be.EQUALS) ? this.parseConstValueLiteral() : void 0,
        directives: this.parseConstDirectives()
      });
    }
    /**
     * Variable : $ Name
     */
    parseVariable() {
      const t = this._lexer.token;
      return this.expectToken(Be.DOLLAR), this.node(t, {
        kind: at.VARIABLE,
        name: this.parseName()
      });
    }
    /**
     * ```
     * SelectionSet : { Selection+ }
     * ```
     */
    parseSelectionSet() {
      return this.node(this._lexer.token, {
        kind: at.SELECTION_SET,
        selections: this.many(
          Be.BRACE_L,
          this.parseSelection,
          Be.BRACE_R
        )
      });
    }
    /**
     * Selection :
     *   - Field
     *   - FragmentSpread
     *   - InlineFragment
     */
    parseSelection() {
      return this.peek(Be.SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
     * Field : Alias? Name Arguments? Directives? SelectionSet?
     *
     * Alias : Name :
     */
    parseField() {
      const t = this._lexer.token, r = this.parseName();
      let n, i;
      return this.expectOptionalToken(Be.COLON) ? (n = r, i = this.parseName()) : i = r, this.node(t, {
        kind: at.FIELD,
        alias: n,
        name: i,
        arguments: this.parseArguments(!1),
        directives: this.parseDirectives(!1),
        selectionSet: this.peek(Be.BRACE_L) ? this.parseSelectionSet() : void 0
      });
    }
    /**
     * Arguments[Const] : ( Argument[?Const]+ )
     */
    parseArguments(t) {
      const r = t ? this.parseConstArgument : this.parseArgument;
      return this.optionalMany(Be.PAREN_L, r, Be.PAREN_R);
    }
    /**
     * Argument[Const] : Name : Value[?Const]
     */
    parseArgument(t = !1) {
      const r = this._lexer.token, n = this.parseName();
      return this.expectToken(Be.COLON), this.node(r, {
        kind: at.ARGUMENT,
        name: n,
        value: this.parseValueLiteral(t)
      });
    }
    parseConstArgument() {
      return this.parseArgument(!0);
    }
    // Implements the parsing rules in the Fragments section.
    /**
     * Corresponds to both FragmentSpread and InlineFragment in the spec.
     *
     * FragmentSpread : ... FragmentName Directives?
     *
     * InlineFragment : ... TypeCondition? Directives? SelectionSet
     */
    parseFragment() {
      const t = this._lexer.token;
      this.expectToken(Be.SPREAD);
      const r = this.expectOptionalKeyword("on");
      return !r && this.peek(Be.NAME) ? this.node(t, {
        kind: at.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(!1)
      }) : this.node(t, {
        kind: at.INLINE_FRAGMENT,
        typeCondition: r ? this.parseNamedType() : void 0,
        directives: this.parseDirectives(!1),
        selectionSet: this.parseSelectionSet()
      });
    }
    /**
     * FragmentDefinition :
     *   - fragment FragmentName on TypeCondition Directives? SelectionSet
     *
     * TypeCondition : NamedType
     */
    parseFragmentDefinition() {
      const t = this._lexer.token;
      return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
        kind: at.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
        directives: this.parseDirectives(!1),
        selectionSet: this.parseSelectionSet()
      }) : this.node(t, {
        kind: at.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
        directives: this.parseDirectives(!1),
        selectionSet: this.parseSelectionSet()
      });
    }
    /**
     * FragmentName : Name but not `on`
     */
    parseFragmentName() {
      if (this._lexer.token.value === "on")
        throw this.unexpected();
      return this.parseName();
    }
    // Implements the parsing rules in the Values section.
    /**
     * Value[Const] :
     *   - [~Const] Variable
     *   - IntValue
     *   - FloatValue
     *   - StringValue
     *   - BooleanValue
     *   - NullValue
     *   - EnumValue
     *   - ListValue[?Const]
     *   - ObjectValue[?Const]
     *
     * BooleanValue : one of `true` `false`
     *
     * NullValue : `null`
     *
     * EnumValue : Name but not `true`, `false` or `null`
     */
    parseValueLiteral(t) {
      const r = this._lexer.token;
      switch (r.kind) {
        case Be.BRACKET_L:
          return this.parseList(t);
        case Be.BRACE_L:
          return this.parseObject(t);
        case Be.INT:
          return this.advanceLexer(), this.node(r, {
            kind: at.INT,
            value: r.value
          });
        case Be.FLOAT:
          return this.advanceLexer(), this.node(r, {
            kind: at.FLOAT,
            value: r.value
          });
        case Be.STRING:
        case Be.BLOCK_STRING:
          return this.parseStringLiteral();
        case Be.NAME:
          switch (this.advanceLexer(), r.value) {
            case "true":
              return this.node(r, {
                kind: at.BOOLEAN,
                value: !0
              });
            case "false":
              return this.node(r, {
                kind: at.BOOLEAN,
                value: !1
              });
            case "null":
              return this.node(r, {
                kind: at.NULL
              });
            default:
              return this.node(r, {
                kind: at.ENUM,
                value: r.value
              });
          }
        case Be.DOLLAR:
          if (t)
            if (this.expectToken(Be.DOLLAR), this._lexer.token.kind === Be.NAME) {
              const n = this._lexer.token.value;
              throw Ii(
                this._lexer.source,
                r.start,
                `Unexpected variable "$${n}" in constant value.`
              );
            } else
              throw this.unexpected(r);
          return this.parseVariable();
        default:
          throw this.unexpected();
      }
    }
    parseConstValueLiteral() {
      return this.parseValueLiteral(!0);
    }
    parseStringLiteral() {
      const t = this._lexer.token;
      return this.advanceLexer(), this.node(t, {
        kind: at.STRING,
        value: t.value,
        block: t.kind === Be.BLOCK_STRING
      });
    }
    /**
     * ListValue[Const] :
     *   - [ ]
     *   - [ Value[?Const]+ ]
     */
    parseList(t) {
      const r = () => this.parseValueLiteral(t);
      return this.node(this._lexer.token, {
        kind: at.LIST,
        values: this.any(Be.BRACKET_L, r, Be.BRACKET_R)
      });
    }
    /**
     * ```
     * ObjectValue[Const] :
     *   - { }
     *   - { ObjectField[?Const]+ }
     * ```
     */
    parseObject(t) {
      const r = () => this.parseObjectField(t);
      return this.node(this._lexer.token, {
        kind: at.OBJECT,
        fields: this.any(Be.BRACE_L, r, Be.BRACE_R)
      });
    }
    /**
     * ObjectField[Const] : Name : Value[?Const]
     */
    parseObjectField(t) {
      const r = this._lexer.token, n = this.parseName();
      return this.expectToken(Be.COLON), this.node(r, {
        kind: at.OBJECT_FIELD,
        name: n,
        value: this.parseValueLiteral(t)
      });
    }
    // Implements the parsing rules in the Directives section.
    /**
     * Directives[Const] : Directive[?Const]+
     */
    parseDirectives(t) {
      const r = [];
      for (; this.peek(Be.AT); )
        r.push(this.parseDirective(t));
      return r;
    }
    parseConstDirectives() {
      return this.parseDirectives(!0);
    }
    /**
     * ```
     * Directive[Const] : @ Name Arguments[?Const]?
     * ```
     */
    parseDirective(t) {
      const r = this._lexer.token;
      return this.expectToken(Be.AT), this.node(r, {
        kind: at.DIRECTIVE,
        name: this.parseName(),
        arguments: this.parseArguments(t)
      });
    }
    // Implements the parsing rules in the Types section.
    /**
     * Type :
     *   - NamedType
     *   - ListType
     *   - NonNullType
     */
    parseTypeReference() {
      const t = this._lexer.token;
      let r;
      if (this.expectOptionalToken(Be.BRACKET_L)) {
        const n = this.parseTypeReference();
        this.expectToken(Be.BRACKET_R), r = this.node(t, {
          kind: at.LIST_TYPE,
          type: n
        });
      } else
        r = this.parseNamedType();
      return this.expectOptionalToken(Be.BANG) ? this.node(t, {
        kind: at.NON_NULL_TYPE,
        type: r
      }) : r;
    }
    /**
     * NamedType : Name
     */
    parseNamedType() {
      return this.node(this._lexer.token, {
        kind: at.NAMED_TYPE,
        name: this.parseName()
      });
    }
    // Implements the parsing rules in the Type Definition section.
    peekDescription() {
      return this.peek(Be.STRING) || this.peek(Be.BLOCK_STRING);
    }
    /**
     * Description : StringValue
     */
    parseDescription() {
      if (this.peekDescription())
        return this.parseStringLiteral();
    }
    /**
     * ```
     * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
     * ```
     */
    parseSchemaDefinition() {
      const t = this._lexer.token, r = this.parseDescription();
      this.expectKeyword("schema");
      const n = this.parseConstDirectives(), i = this.many(
        Be.BRACE_L,
        this.parseOperationTypeDefinition,
        Be.BRACE_R
      );
      return this.node(t, {
        kind: at.SCHEMA_DEFINITION,
        description: r,
        directives: n,
        operationTypes: i
      });
    }
    /**
     * OperationTypeDefinition : OperationType : NamedType
     */
    parseOperationTypeDefinition() {
      const t = this._lexer.token, r = this.parseOperationType();
      this.expectToken(Be.COLON);
      const n = this.parseNamedType();
      return this.node(t, {
        kind: at.OPERATION_TYPE_DEFINITION,
        operation: r,
        type: n
      });
    }
    /**
     * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
     */
    parseScalarTypeDefinition() {
      const t = this._lexer.token, r = this.parseDescription();
      this.expectKeyword("scalar");
      const n = this.parseName(), i = this.parseConstDirectives();
      return this.node(t, {
        kind: at.SCALAR_TYPE_DEFINITION,
        description: r,
        name: n,
        directives: i
      });
    }
    /**
     * ObjectTypeDefinition :
     *   Description?
     *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
     */
    parseObjectTypeDefinition() {
      const t = this._lexer.token, r = this.parseDescription();
      this.expectKeyword("type");
      const n = this.parseName(), i = this.parseImplementsInterfaces(), u = this.parseConstDirectives(), s = this.parseFieldsDefinition();
      return this.node(t, {
        kind: at.OBJECT_TYPE_DEFINITION,
        description: r,
        name: n,
        interfaces: i,
        directives: u,
        fields: s
      });
    }
    /**
     * ImplementsInterfaces :
     *   - implements `&`? NamedType
     *   - ImplementsInterfaces & NamedType
     */
    parseImplementsInterfaces() {
      return this.expectOptionalKeyword("implements") ? this.delimitedMany(Be.AMP, this.parseNamedType) : [];
    }
    /**
     * ```
     * FieldsDefinition : { FieldDefinition+ }
     * ```
     */
    parseFieldsDefinition() {
      return this.optionalMany(
        Be.BRACE_L,
        this.parseFieldDefinition,
        Be.BRACE_R
      );
    }
    /**
     * FieldDefinition :
     *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
     */
    parseFieldDefinition() {
      const t = this._lexer.token, r = this.parseDescription(), n = this.parseName(), i = this.parseArgumentDefs();
      this.expectToken(Be.COLON);
      const u = this.parseTypeReference(), s = this.parseConstDirectives();
      return this.node(t, {
        kind: at.FIELD_DEFINITION,
        description: r,
        name: n,
        arguments: i,
        type: u,
        directives: s
      });
    }
    /**
     * ArgumentsDefinition : ( InputValueDefinition+ )
     */
    parseArgumentDefs() {
      return this.optionalMany(
        Be.PAREN_L,
        this.parseInputValueDef,
        Be.PAREN_R
      );
    }
    /**
     * InputValueDefinition :
     *   - Description? Name : Type DefaultValue? Directives[Const]?
     */
    parseInputValueDef() {
      const t = this._lexer.token, r = this.parseDescription(), n = this.parseName();
      this.expectToken(Be.COLON);
      const i = this.parseTypeReference();
      let u;
      this.expectOptionalToken(Be.EQUALS) && (u = this.parseConstValueLiteral());
      const s = this.parseConstDirectives();
      return this.node(t, {
        kind: at.INPUT_VALUE_DEFINITION,
        description: r,
        name: n,
        type: i,
        defaultValue: u,
        directives: s
      });
    }
    /**
     * InterfaceTypeDefinition :
     *   - Description? interface Name Directives[Const]? FieldsDefinition?
     */
    parseInterfaceTypeDefinition() {
      const t = this._lexer.token, r = this.parseDescription();
      this.expectKeyword("interface");
      const n = this.parseName(), i = this.parseImplementsInterfaces(), u = this.parseConstDirectives(), s = this.parseFieldsDefinition();
      return this.node(t, {
        kind: at.INTERFACE_TYPE_DEFINITION,
        description: r,
        name: n,
        interfaces: i,
        directives: u,
        fields: s
      });
    }
    /**
     * UnionTypeDefinition :
     *   - Description? union Name Directives[Const]? UnionMemberTypes?
     */
    parseUnionTypeDefinition() {
      const t = this._lexer.token, r = this.parseDescription();
      this.expectKeyword("union");
      const n = this.parseName(), i = this.parseConstDirectives(), u = this.parseUnionMemberTypes();
      return this.node(t, {
        kind: at.UNION_TYPE_DEFINITION,
        description: r,
        name: n,
        directives: i,
        types: u
      });
    }
    /**
     * UnionMemberTypes :
     *   - = `|`? NamedType
     *   - UnionMemberTypes | NamedType
     */
    parseUnionMemberTypes() {
      return this.expectOptionalToken(Be.EQUALS) ? this.delimitedMany(Be.PIPE, this.parseNamedType) : [];
    }
    /**
     * EnumTypeDefinition :
     *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
     */
    parseEnumTypeDefinition() {
      const t = this._lexer.token, r = this.parseDescription();
      this.expectKeyword("enum");
      const n = this.parseName(), i = this.parseConstDirectives(), u = this.parseEnumValuesDefinition();
      return this.node(t, {
        kind: at.ENUM_TYPE_DEFINITION,
        description: r,
        name: n,
        directives: i,
        values: u
      });
    }
    /**
     * ```
     * EnumValuesDefinition : { EnumValueDefinition+ }
     * ```
     */
    parseEnumValuesDefinition() {
      return this.optionalMany(
        Be.BRACE_L,
        this.parseEnumValueDefinition,
        Be.BRACE_R
      );
    }
    /**
     * EnumValueDefinition : Description? EnumValue Directives[Const]?
     */
    parseEnumValueDefinition() {
      const t = this._lexer.token, r = this.parseDescription(), n = this.parseEnumValueName(), i = this.parseConstDirectives();
      return this.node(t, {
        kind: at.ENUM_VALUE_DEFINITION,
        description: r,
        name: n,
        directives: i
      });
    }
    /**
     * EnumValue : Name but not `true`, `false` or `null`
     */
    parseEnumValueName() {
      if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
        throw Ii(
          this._lexer.source,
          this._lexer.token.start,
          `${Zw(
            this._lexer.token
          )} is reserved and cannot be used for an enum value.`
        );
      return this.parseName();
    }
    /**
     * InputObjectTypeDefinition :
     *   - Description? input Name Directives[Const]? InputFieldsDefinition?
     */
    parseInputObjectTypeDefinition() {
      const t = this._lexer.token, r = this.parseDescription();
      this.expectKeyword("input");
      const n = this.parseName(), i = this.parseConstDirectives(), u = this.parseInputFieldsDefinition();
      return this.node(t, {
        kind: at.INPUT_OBJECT_TYPE_DEFINITION,
        description: r,
        name: n,
        directives: i,
        fields: u
      });
    }
    /**
     * ```
     * InputFieldsDefinition : { InputValueDefinition+ }
     * ```
     */
    parseInputFieldsDefinition() {
      return this.optionalMany(
        Be.BRACE_L,
        this.parseInputValueDef,
        Be.BRACE_R
      );
    }
    /**
     * TypeSystemExtension :
     *   - SchemaExtension
     *   - TypeExtension
     *
     * TypeExtension :
     *   - ScalarTypeExtension
     *   - ObjectTypeExtension
     *   - InterfaceTypeExtension
     *   - UnionTypeExtension
     *   - EnumTypeExtension
     *   - InputObjectTypeDefinition
     */
    parseTypeSystemExtension() {
      const t = this._lexer.lookahead();
      if (t.kind === Be.NAME)
        switch (t.value) {
          case "schema":
            return this.parseSchemaExtension();
          case "scalar":
            return this.parseScalarTypeExtension();
          case "type":
            return this.parseObjectTypeExtension();
          case "interface":
            return this.parseInterfaceTypeExtension();
          case "union":
            return this.parseUnionTypeExtension();
          case "enum":
            return this.parseEnumTypeExtension();
          case "input":
            return this.parseInputObjectTypeExtension();
        }
      throw this.unexpected(t);
    }
    /**
     * ```
     * SchemaExtension :
     *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
     *  - extend schema Directives[Const]
     * ```
     */
    parseSchemaExtension() {
      const t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("schema");
      const r = this.parseConstDirectives(), n = this.optionalMany(
        Be.BRACE_L,
        this.parseOperationTypeDefinition,
        Be.BRACE_R
      );
      if (r.length === 0 && n.length === 0)
        throw this.unexpected();
      return this.node(t, {
        kind: at.SCHEMA_EXTENSION,
        directives: r,
        operationTypes: n
      });
    }
    /**
     * ScalarTypeExtension :
     *   - extend scalar Name Directives[Const]
     */
    parseScalarTypeExtension() {
      const t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("scalar");
      const r = this.parseName(), n = this.parseConstDirectives();
      if (n.length === 0)
        throw this.unexpected();
      return this.node(t, {
        kind: at.SCALAR_TYPE_EXTENSION,
        name: r,
        directives: n
      });
    }
    /**
     * ObjectTypeExtension :
     *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
     *  - extend type Name ImplementsInterfaces? Directives[Const]
     *  - extend type Name ImplementsInterfaces
     */
    parseObjectTypeExtension() {
      const t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("type");
      const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), u = this.parseFieldsDefinition();
      if (n.length === 0 && i.length === 0 && u.length === 0)
        throw this.unexpected();
      return this.node(t, {
        kind: at.OBJECT_TYPE_EXTENSION,
        name: r,
        interfaces: n,
        directives: i,
        fields: u
      });
    }
    /**
     * InterfaceTypeExtension :
     *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
     *  - extend interface Name ImplementsInterfaces? Directives[Const]
     *  - extend interface Name ImplementsInterfaces
     */
    parseInterfaceTypeExtension() {
      const t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("interface");
      const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), u = this.parseFieldsDefinition();
      if (n.length === 0 && i.length === 0 && u.length === 0)
        throw this.unexpected();
      return this.node(t, {
        kind: at.INTERFACE_TYPE_EXTENSION,
        name: r,
        interfaces: n,
        directives: i,
        fields: u
      });
    }
    /**
     * UnionTypeExtension :
     *   - extend union Name Directives[Const]? UnionMemberTypes
     *   - extend union Name Directives[Const]
     */
    parseUnionTypeExtension() {
      const t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("union");
      const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
      if (n.length === 0 && i.length === 0)
        throw this.unexpected();
      return this.node(t, {
        kind: at.UNION_TYPE_EXTENSION,
        name: r,
        directives: n,
        types: i
      });
    }
    /**
     * EnumTypeExtension :
     *   - extend enum Name Directives[Const]? EnumValuesDefinition
     *   - extend enum Name Directives[Const]
     */
    parseEnumTypeExtension() {
      const t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("enum");
      const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
      if (n.length === 0 && i.length === 0)
        throw this.unexpected();
      return this.node(t, {
        kind: at.ENUM_TYPE_EXTENSION,
        name: r,
        directives: n,
        values: i
      });
    }
    /**
     * InputObjectTypeExtension :
     *   - extend input Name Directives[Const]? InputFieldsDefinition
     *   - extend input Name Directives[Const]
     */
    parseInputObjectTypeExtension() {
      const t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("input");
      const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
      if (n.length === 0 && i.length === 0)
        throw this.unexpected();
      return this.node(t, {
        kind: at.INPUT_OBJECT_TYPE_EXTENSION,
        name: r,
        directives: n,
        fields: i
      });
    }
    /**
     * ```
     * DirectiveDefinition :
     *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
     * ```
     */
    parseDirectiveDefinition() {
      const t = this._lexer.token, r = this.parseDescription();
      this.expectKeyword("directive"), this.expectToken(Be.AT);
      const n = this.parseName(), i = this.parseArgumentDefs(), u = this.expectOptionalKeyword("repeatable");
      this.expectKeyword("on");
      const s = this.parseDirectiveLocations();
      return this.node(t, {
        kind: at.DIRECTIVE_DEFINITION,
        description: r,
        name: n,
        arguments: i,
        repeatable: u,
        locations: s
      });
    }
    /**
     * DirectiveLocations :
     *   - `|`? DirectiveLocation
     *   - DirectiveLocations | DirectiveLocation
     */
    parseDirectiveLocations() {
      return this.delimitedMany(Be.PIPE, this.parseDirectiveLocation);
    }
    /*
     * DirectiveLocation :
     *   - ExecutableDirectiveLocation
     *   - TypeSystemDirectiveLocation
     *
     * ExecutableDirectiveLocation : one of
     *   `QUERY`
     *   `MUTATION`
     *   `SUBSCRIPTION`
     *   `FIELD`
     *   `FRAGMENT_DEFINITION`
     *   `FRAGMENT_SPREAD`
     *   `INLINE_FRAGMENT`
     *
     * TypeSystemDirectiveLocation : one of
     *   `SCHEMA`
     *   `SCALAR`
     *   `OBJECT`
     *   `FIELD_DEFINITION`
     *   `ARGUMENT_DEFINITION`
     *   `INTERFACE`
     *   `UNION`
     *   `ENUM`
     *   `ENUM_VALUE`
     *   `INPUT_OBJECT`
     *   `INPUT_FIELD_DEFINITION`
     */
    parseDirectiveLocation() {
      const t = this._lexer.token, r = this.parseName();
      if (Object.prototype.hasOwnProperty.call(cP, r.value))
        return r;
      throw this.unexpected(t);
    }
    // Core parsing utility functions
    /**
     * Returns a node that, if configured to do so, sets a "loc" field as a
     * location object, used to identify the place in the source that created a
     * given parsed object.
     */
    node(t, r) {
      return this._options.noLocation !== !0 && (r.loc = new wte(
        t,
        this._lexer.lastToken,
        this._lexer.source
      )), r;
    }
    /**
     * Determines if the next token is of a given kind
     */
    peek(t) {
      return this._lexer.token.kind === t;
    }
    /**
     * If the next token is of the given kind, return that token after advancing the lexer.
     * Otherwise, do not change the parser state and throw an error.
     */
    expectToken(t) {
      const r = this._lexer.token;
      if (r.kind === t)
        return this.advanceLexer(), r;
      throw Ii(
        this._lexer.source,
        r.start,
        `Expected ${LU(t)}, found ${Zw(r)}.`
      );
    }
    /**
     * If the next token is of the given kind, return "true" after advancing the lexer.
     * Otherwise, do not change the parser state and return "false".
     */
    expectOptionalToken(t) {
      return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
    }
    /**
     * If the next token is a given keyword, advance the lexer.
     * Otherwise, do not change the parser state and throw an error.
     */
    expectKeyword(t) {
      const r = this._lexer.token;
      if (r.kind === Be.NAME && r.value === t)
        this.advanceLexer();
      else
        throw Ii(
          this._lexer.source,
          r.start,
          `Expected "${t}", found ${Zw(r)}.`
        );
    }
    /**
     * If the next token is a given keyword, return "true" after advancing the lexer.
     * Otherwise, do not change the parser state and return "false".
     */
    expectOptionalKeyword(t) {
      const r = this._lexer.token;
      return r.kind === Be.NAME && r.value === t ? (this.advanceLexer(), !0) : !1;
    }
    /**
     * Helper function for creating an error when an unexpected lexed token is encountered.
     */
    unexpected(t) {
      const r = t ?? this._lexer.token;
      return Ii(
        this._lexer.source,
        r.start,
        `Unexpected ${Zw(r)}.`
      );
    }
    /**
     * Returns a possibly empty list of parse nodes, determined by the parseFn.
     * This list begins with a lex token of openKind and ends with a lex token of closeKind.
     * Advances the parser to the next lex token after the closing token.
     */
    any(t, r, n) {
      this.expectToken(t);
      const i = [];
      for (; !this.expectOptionalToken(n); )
        i.push(r.call(this));
      return i;
    }
    /**
     * Returns a list of parse nodes, determined by the parseFn.
     * It can be empty only if open token is missing otherwise it will always return non-empty list
     * that begins with a lex token of openKind and ends with a lex token of closeKind.
     * Advances the parser to the next lex token after the closing token.
     */
    optionalMany(t, r, n) {
      if (this.expectOptionalToken(t)) {
        const i = [];
        do
          i.push(r.call(this));
        while (!this.expectOptionalToken(n));
        return i;
      }
      return [];
    }
    /**
     * Returns a non-empty list of parse nodes, determined by the parseFn.
     * This list begins with a lex token of openKind and ends with a lex token of closeKind.
     * Advances the parser to the next lex token after the closing token.
     */
    many(t, r, n) {
      this.expectToken(t);
      const i = [];
      do
        i.push(r.call(this));
      while (!this.expectOptionalToken(n));
      return i;
    }
    /**
     * Returns a non-empty list of parse nodes, determined by the parseFn.
     * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
     * Advances the parser to the next lex token after last item in the list.
     */
    delimitedMany(t, r) {
      this.expectOptionalToken(t);
      const n = [];
      do
        n.push(r.call(this));
      while (this.expectOptionalToken(t));
      return n;
    }
    advanceLexer() {
      const { maxTokens: t } = this._options, r = this._lexer.advance();
      if (r.kind !== Be.EOF && (++this._tokenCounter, t !== void 0 && this._tokenCounter > t))
        throw Ii(
          this._lexer.source,
          r.start,
          `Document contains more that ${t} tokens. Parsing aborted.`
        );
    }
  };
  function Zw(e) {
    const t = e.value;
    return LU(e.kind) + (t != null ? ` "${t}"` : "");
  }
  function LU(e) {
    return Ate(e) ? `"${e}"` : e;
  }
  function Qte(e) {
    return `"${e.replace(Kte, Xte)}"`;
  }
  const Kte = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
  function Xte(e) {
    return Zte[e.charCodeAt(0)];
  }
  const Zte = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    // 2F
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    // 3F
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    // 4F
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    // 5F
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    // 6F
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
  ], O_ = Object.freeze({});
  function hs(e, t, r = PU) {
    const n = /* @__PURE__ */ new Map();
    for (const k of Object.values(at))
      n.set(k, Jte(t, k));
    let i, u = Array.isArray(e), s = [e], c = -1, p = [], h = e, v, y;
    const x = [], w = [];
    do {
      c++;
      const k = c === s.length, D = k && p.length !== 0;
      if (k) {
        if (v = w.length === 0 ? void 0 : x[x.length - 1], h = y, y = w.pop(), D)
          if (u) {
            h = h.slice();
            let R = 0;
            for (const [T, M] of p) {
              const F = T - R;
              M === null ? (h.splice(F, 1), R++) : h[F] = M;
            }
          } else {
            h = { ...h };
            for (const [R, T] of p)
              h[R] = T;
          }
        c = i.index, s = i.keys, p = i.edits, u = i.inArray, i = i.prev;
      } else if (y) {
        if (v = u ? c : s[c], h = y[v], h == null)
          continue;
        x.push(v);
      }
      let A;
      if (!Array.isArray(h)) {
        var E, C;
        fB(h) || bE(!1, `Invalid AST Node: ${vN(h)}.`);
        const R = k ? (E = n.get(h.kind)) === null || E === void 0 ? void 0 : E.leave : (C = n.get(h.kind)) === null || C === void 0 ? void 0 : C.enter;
        if (A = R == null ? void 0 : R.call(t, h, v, y, x, w), A === O_)
          break;
        if (A === !1) {
          if (!k) {
            x.pop();
            continue;
          }
        } else if (A !== void 0 && (p.push([v, A]), !k))
          if (fB(A))
            h = A;
          else {
            x.pop();
            continue;
          }
      }
      if (A === void 0 && D && p.push([v, h]), k)
        x.pop();
      else {
        var S;
        i = {
          inArray: u,
          index: c,
          keys: s,
          edits: p,
          prev: i
        }, u = Array.isArray(h), s = u ? h : (S = r[h.kind]) !== null && S !== void 0 ? S : [], c = -1, p = [], y && w.push(y), y = h;
      }
    } while (i !== void 0);
    return p.length !== 0 ? p[p.length - 1][1] : e;
  }
  function Jte(e, t) {
    const r = e[t];
    return typeof r == "object" ? r : typeof r == "function" ? {
      enter: r,
      leave: void 0
    } : {
      enter: e.enter,
      leave: e.leave
    };
  }
  function ere(e) {
    return hs(e, rre);
  }
  const tre = 80, rre = {
    Name: {
      leave: (e) => e.value
    },
    Variable: {
      leave: (e) => "$" + e.name
    },
    // Document
    Document: {
      leave: (e) => xt(e.definitions, `

`)
    },
    OperationDefinition: {
      leave(e) {
        const t = sr("(", xt(e.variableDefinitions, ", "), ")"), r = xt(
          [
            e.operation,
            xt([e.name, t]),
            xt(e.directives, " ")
          ],
          " "
        );
        return (r === "query" ? "" : r + " ") + e.selectionSet;
      }
    },
    VariableDefinition: {
      leave: ({ variable: e, type: t, defaultValue: r, directives: n }) => e + ": " + t + sr(" = ", r) + sr(" ", xt(n, " "))
    },
    SelectionSet: {
      leave: ({ selections: e }) => ns(e)
    },
    Field: {
      leave({ alias: e, name: t, arguments: r, directives: n, selectionSet: i }) {
        const u = sr("", e, ": ") + t;
        let s = u + sr("(", xt(r, ", "), ")");
        return s.length > tre && (s = u + sr(`(
`, wE(xt(r, `
`)), `
)`)), xt([s, xt(n, " "), i], " ");
      }
    },
    Argument: {
      leave: ({ name: e, value: t }) => e + ": " + t
    },
    // Fragments
    FragmentSpread: {
      leave: ({ name: e, directives: t }) => "..." + e + sr(" ", xt(t, " "))
    },
    InlineFragment: {
      leave: ({ typeCondition: e, directives: t, selectionSet: r }) => xt(
        [
          "...",
          sr("on ", e),
          xt(t, " "),
          r
        ],
        " "
      )
    },
    FragmentDefinition: {
      leave: ({ name: e, typeCondition: t, variableDefinitions: r, directives: n, selectionSet: i }) => (
        // or removed in the future.
        `fragment ${e}${sr("(", xt(r, ", "), ")")} on ${t} ${sr("", xt(n, " "), " ")}` + i
      )
    },
    // Value
    IntValue: {
      leave: ({ value: e }) => e
    },
    FloatValue: {
      leave: ({ value: e }) => e
    },
    StringValue: {
      leave: ({ value: e, block: t }) => t ? Ote(e) : Qte(e)
    },
    BooleanValue: {
      leave: ({ value: e }) => e ? "true" : "false"
    },
    NullValue: {
      leave: () => "null"
    },
    EnumValue: {
      leave: ({ value: e }) => e
    },
    ListValue: {
      leave: ({ values: e }) => "[" + xt(e, ", ") + "]"
    },
    ObjectValue: {
      leave: ({ fields: e }) => "{" + xt(e, ", ") + "}"
    },
    ObjectField: {
      leave: ({ name: e, value: t }) => e + ": " + t
    },
    // Directive
    Directive: {
      leave: ({ name: e, arguments: t }) => "@" + e + sr("(", xt(t, ", "), ")")
    },
    // Type
    NamedType: {
      leave: ({ name: e }) => e
    },
    ListType: {
      leave: ({ type: e }) => "[" + e + "]"
    },
    NonNullType: {
      leave: ({ type: e }) => e + "!"
    },
    // Type System Definitions
    SchemaDefinition: {
      leave: ({ description: e, directives: t, operationTypes: r }) => sr("", e, `
`) + xt(["schema", xt(t, " "), ns(r)], " ")
    },
    OperationTypeDefinition: {
      leave: ({ operation: e, type: t }) => e + ": " + t
    },
    ScalarTypeDefinition: {
      leave: ({ description: e, name: t, directives: r }) => sr("", e, `
`) + xt(["scalar", t, xt(r, " ")], " ")
    },
    ObjectTypeDefinition: {
      leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => sr("", e, `
`) + xt(
        [
          "type",
          t,
          sr("implements ", xt(r, " & ")),
          xt(n, " "),
          ns(i)
        ],
        " "
      )
    },
    FieldDefinition: {
      leave: ({ description: e, name: t, arguments: r, type: n, directives: i }) => sr("", e, `
`) + t + (pB(r) ? sr(`(
`, wE(xt(r, `
`)), `
)`) : sr("(", xt(r, ", "), ")")) + ": " + n + sr(" ", xt(i, " "))
    },
    InputValueDefinition: {
      leave: ({ description: e, name: t, type: r, defaultValue: n, directives: i }) => sr("", e, `
`) + xt(
        [t + ": " + r, sr("= ", n), xt(i, " ")],
        " "
      )
    },
    InterfaceTypeDefinition: {
      leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => sr("", e, `
`) + xt(
        [
          "interface",
          t,
          sr("implements ", xt(r, " & ")),
          xt(n, " "),
          ns(i)
        ],
        " "
      )
    },
    UnionTypeDefinition: {
      leave: ({ description: e, name: t, directives: r, types: n }) => sr("", e, `
`) + xt(
        ["union", t, xt(r, " "), sr("= ", xt(n, " | "))],
        " "
      )
    },
    EnumTypeDefinition: {
      leave: ({ description: e, name: t, directives: r, values: n }) => sr("", e, `
`) + xt(["enum", t, xt(r, " "), ns(n)], " ")
    },
    EnumValueDefinition: {
      leave: ({ description: e, name: t, directives: r }) => sr("", e, `
`) + xt([t, xt(r, " ")], " ")
    },
    InputObjectTypeDefinition: {
      leave: ({ description: e, name: t, directives: r, fields: n }) => sr("", e, `
`) + xt(["input", t, xt(r, " "), ns(n)], " ")
    },
    DirectiveDefinition: {
      leave: ({ description: e, name: t, arguments: r, repeatable: n, locations: i }) => sr("", e, `
`) + "directive @" + t + (pB(r) ? sr(`(
`, wE(xt(r, `
`)), `
)`) : sr("(", xt(r, ", "), ")")) + (n ? " repeatable" : "") + " on " + xt(i, " | ")
    },
    SchemaExtension: {
      leave: ({ directives: e, operationTypes: t }) => xt(
        ["extend schema", xt(e, " "), ns(t)],
        " "
      )
    },
    ScalarTypeExtension: {
      leave: ({ name: e, directives: t }) => xt(["extend scalar", e, xt(t, " ")], " ")
    },
    ObjectTypeExtension: {
      leave: ({ name: e, interfaces: t, directives: r, fields: n }) => xt(
        [
          "extend type",
          e,
          sr("implements ", xt(t, " & ")),
          xt(r, " "),
          ns(n)
        ],
        " "
      )
    },
    InterfaceTypeExtension: {
      leave: ({ name: e, interfaces: t, directives: r, fields: n }) => xt(
        [
          "extend interface",
          e,
          sr("implements ", xt(t, " & ")),
          xt(r, " "),
          ns(n)
        ],
        " "
      )
    },
    UnionTypeExtension: {
      leave: ({ name: e, directives: t, types: r }) => xt(
        [
          "extend union",
          e,
          xt(t, " "),
          sr("= ", xt(r, " | "))
        ],
        " "
      )
    },
    EnumTypeExtension: {
      leave: ({ name: e, directives: t, values: r }) => xt(["extend enum", e, xt(t, " "), ns(r)], " ")
    },
    InputObjectTypeExtension: {
      leave: ({ name: e, directives: t, fields: r }) => xt(["extend input", e, xt(t, " "), ns(r)], " ")
    }
  };
  function xt(e, t = "") {
    var r;
    return (r = e == null ? void 0 : e.filter((n) => n).join(t)) !== null && r !== void 0 ? r : "";
  }
  function ns(e) {
    return sr(`{
`, wE(xt(e, `
`)), `
}`);
  }
  function sr(e, t, r = "") {
    return t != null && t !== "" ? e + t + r : "";
  }
  function wE(e) {
    return sr("  ", e.replace(/\n/g, `
  `));
  }
  function pB(e) {
    var t;
    return (t = e == null ? void 0 : e.some((r) => r.includes(`
`))) !== null && t !== void 0 ? t : !1;
  }
  function hB(e) {
    return e.kind === at.FIELD || e.kind === at.FRAGMENT_SPREAD || e.kind === at.INLINE_FRAGMENT;
  }
  function jx(e, t) {
    var r = e.directives;
    return !r || !r.length ? !0 : are(r).every(function(n) {
      var i = n.directive, u = n.ifArgument, s = !1;
      return u.value.kind === "Variable" ? (s = t && t[u.value.name.value], st(s !== void 0, 78, i.name.value)) : s = u.value.value, i.name.value === "skip" ? !s : s;
    });
  }
  function Qg(e, t, r) {
    var n = new Set(e), i = n.size;
    return hs(t, {
      Directive: function(u) {
        if (n.delete(u.name.value) && (!r || !n.size))
          return O_;
      }
    }), r ? !n.size : n.size < i;
  }
  function nre(e) {
    return e && Qg(["client", "export"], e, !0);
  }
  function ire(e) {
    var t = e.name.value;
    return t === "skip" || t === "include";
  }
  function are(e) {
    var t = [];
    return e && e.length && e.forEach(function(r) {
      if (ire(r)) {
        var n = r.arguments, i = r.name.value;
        st(n && n.length === 1, 79, i);
        var u = n[0];
        st(u.name && u.name.value === "if", 80, i);
        var s = u.value;
        st(s && (s.kind === "Variable" || s.kind === "BooleanValue"), 81, i), t.push({ directive: r, ifArgument: u });
      }
    }), t;
  }
  function ore(e) {
    var t, r, n = (t = e.directives) === null || t === void 0 ? void 0 : t.find(function(u) {
      var s = u.name;
      return s.value === "unmask";
    });
    if (!n)
      return "mask";
    var i = (r = n.arguments) === null || r === void 0 ? void 0 : r.find(function(u) {
      var s = u.name;
      return s.value === "mode";
    });
    return globalThis.__DEV__ !== !1 && i && (i.value.kind === at.VARIABLE ? globalThis.__DEV__ !== !1 && st.warn(82) : i.value.kind !== at.STRING ? globalThis.__DEV__ !== !1 && st.warn(83) : i.value.value !== "migrate" && globalThis.__DEV__ !== !1 && st.warn(84, i.value.value)), i && "value" in i.value && i.value.value === "migrate" ? "migrate" : "unmask";
  }
  var $U = ls(function() {
    return navigator.product;
  }) == "ReactNative", $p = typeof WeakMap == "function" && !($U && !global.HermesInternal), mN = typeof WeakSet == "function", yN = typeof Symbol == "function" && typeof Symbol.for == "function", T_ = yN && Symbol.asyncIterator, ure = typeof ls(function() {
    return window.document.createElement;
  }) == "function", sre = (
    // Following advice found in this comment from @domenic (maintainer of jsdom):
    // https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
    //
    // Since we control the version of Jest and jsdom used when running Apollo
    // Client tests, and that version is recent enought to include " jsdom/x.y.z"
    // at the end of the user agent string, I believe this case is all we need to
    // check. Testing for "Node.js" was recommended for backwards compatibility
    // with older version of jsdom, but we don't have that problem.
    ls(function() {
      return navigator.userAgent.indexOf("jsdom") >= 0;
    }) || !1
  ), lre = (ure || $U) && !sre;
  function Hn(e) {
    return e !== null && typeof e == "object";
  }
  function cre(e, t) {
    var r = t, n = [];
    e.definitions.forEach(function(u) {
      if (u.kind === "OperationDefinition")
        throw Ya(
          85,
          u.operation,
          u.name ? " named '".concat(u.name.value, "'") : ""
        );
      u.kind === "FragmentDefinition" && n.push(u);
    }), typeof r > "u" && (st(n.length === 1, 86, n.length), r = n[0].name.value);
    var i = ye(ye({}, e), { definitions: Da([
      {
        kind: "OperationDefinition",
        // OperationTypeNode is an enum
        operation: "query",
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            {
              kind: "FragmentSpread",
              name: {
                kind: "Name",
                value: r
              }
            }
          ]
        }
      }
    ], e.definitions, !0) });
    return i;
  }
  function B0(e) {
    e === void 0 && (e = []);
    var t = {};
    return e.forEach(function(r) {
      t[r.name.value] = r;
    }), t;
  }
  function A_(e, t) {
    switch (e.kind) {
      case "InlineFragment":
        return e;
      case "FragmentSpread": {
        var r = e.name.value;
        if (typeof t == "function")
          return t(r);
        var n = t && t[r];
        return st(n, 87, r), n || null;
      }
      default:
        return null;
    }
  }
  function fre(e) {
    var t = !0;
    return hs(e, {
      FragmentSpread: function(r) {
        if (t = !!r.directives && r.directives.some(function(n) {
          return n.name.value === "unmask";
        }), !t)
          return O_;
      }
    }), t;
  }
  var BA = /* @__PURE__ */ new WeakSet();
  function zU(e) {
    e.size <= (e.max || -1) || BA.has(e) || (BA.add(e), setTimeout(function() {
      e.clean(), BA.delete(e);
    }, 100));
  }
  var gN = function(e, t) {
    var r = new pS(e, t);
    return r.set = function(n, i) {
      var u = pS.prototype.set.call(this, n, i);
      return zU(this), u;
    }, r;
  }, dre = function(e, t) {
    var r = new uP(e, t);
    return r.set = function(n, i) {
      var u = uP.prototype.set.call(this, n, i);
      return zU(this), u;
    }, r;
  }, pre = Symbol.for("apollo.cacheSize"), cl = ye({}, Vg[pre]), gp = {};
  function xN(e, t) {
    gp[e] = t;
  }
  var hre = globalThis.__DEV__ !== !1 ? gre : void 0, vre = globalThis.__DEV__ !== !1 ? xre : void 0, mre = globalThis.__DEV__ !== !1 ? qU : void 0;
  function yre() {
    var e = {
      parser: 1e3,
      canonicalStringify: 1e3,
      print: 2e3,
      "documentTransform.cache": 2e3,
      "queryManager.getDocumentInfo": 2e3,
      "PersistedQueryLink.persistedQueryHashes": 2e3,
      "fragmentRegistry.transform": 2e3,
      "fragmentRegistry.lookup": 1e3,
      "fragmentRegistry.findFragmentSpreads": 4e3,
      "cache.fragmentQueryDocuments": 1e3,
      "removeTypenameFromVariables.getVariableDefinitions": 2e3,
      "inMemoryCache.maybeBroadcastWatch": 5e3,
      "inMemoryCache.executeSelectionSet": 5e4,
      "inMemoryCache.executeSubSelectedArray": 1e4
    };
    return Object.fromEntries(Object.entries(e).map(function(t) {
      var r = t[0], n = t[1];
      return [
        r,
        cl[r] || n
      ];
    }));
  }
  function gre() {
    var e, t, r, n, i;
    if (globalThis.__DEV__ === !1)
      throw new Error("only supported in development mode");
    return {
      limits: yre(),
      sizes: ye({ print: (e = gp.print) === null || e === void 0 ? void 0 : e.call(gp), parser: (t = gp.parser) === null || t === void 0 ? void 0 : t.call(gp), canonicalStringify: (r = gp.canonicalStringify) === null || r === void 0 ? void 0 : r.call(gp), links: pP(this.link), queryManager: {
        getDocumentInfo: this.queryManager.transformCache.size,
        documentTransforms: HU(this.queryManager.documentTransform)
      } }, (i = (n = this.cache).getMemoryInternals) === null || i === void 0 ? void 0 : i.call(n))
    };
  }
  function qU() {
    return {
      cache: {
        fragmentQueryDocuments: Pf(this.getFragmentDoc)
      }
    };
  }
  function xre() {
    var e = this.config.fragments;
    return ye(ye({}, qU.apply(this)), { addTypenameDocumentTransform: HU(this.addTypenameTransform), inMemoryCache: {
      executeSelectionSet: Pf(this.storeReader.executeSelectionSet),
      executeSubSelectedArray: Pf(this.storeReader.executeSubSelectedArray),
      maybeBroadcastWatch: Pf(this.maybeBroadcastWatch)
    }, fragmentRegistry: {
      findFragmentSpreads: Pf(e == null ? void 0 : e.findFragmentSpreads),
      lookup: Pf(e == null ? void 0 : e.lookup),
      transform: Pf(e == null ? void 0 : e.transform)
    } });
  }
  function bre(e) {
    return !!e && "dirtyKey" in e;
  }
  function Pf(e) {
    return bre(e) ? e.size : void 0;
  }
  function UU(e) {
    return e != null;
  }
  function HU(e) {
    return dP(e).map(function(t) {
      return { cache: t };
    });
  }
  function dP(e) {
    return e ? Da(Da([
      Pf(e == null ? void 0 : e.performWork)
    ], dP(e == null ? void 0 : e.left), !0), dP(e == null ? void 0 : e.right), !0).filter(UU) : [];
  }
  function pP(e) {
    var t;
    return e ? Da(Da([
      (t = e == null ? void 0 : e.getMemoryInternals) === null || t === void 0 ? void 0 : t.call(e)
    ], pP(e == null ? void 0 : e.left), !0), pP(e == null ? void 0 : e.right), !0).filter(UU) : [];
  }
  var Ff = Object.assign(function(t) {
    return JSON.stringify(t, wre);
  }, {
    reset: function() {
      Uv = new dre(
        cl.canonicalStringify || 1e3
        /* defaultCacheSizes.canonicalStringify */
      );
    }
  });
  globalThis.__DEV__ !== !1 && xN("canonicalStringify", function() {
    return Uv.size;
  });
  var Uv;
  Ff.reset();
  function wre(e, t) {
    if (t && typeof t == "object") {
      var r = Object.getPrototypeOf(t);
      if (r === Object.prototype || r === null) {
        var n = Object.keys(t);
        if (n.every(Ere))
          return t;
        var i = JSON.stringify(n), u = Uv.get(i);
        if (!u) {
          n.sort();
          var s = JSON.stringify(n);
          u = Uv.get(s) || n, Uv.set(i, u), Uv.set(s, u);
        }
        var c = Object.create(r);
        return u.forEach(function(p) {
          c[p] = t[p];
        }), c;
      }
    }
    return t;
  }
  function Ere(e, t, r) {
    return t === 0 || r[t - 1] <= e;
  }
  function Kv(e) {
    return { __ref: String(e) };
  }
  function Vr(e) {
    return !!(e && typeof e == "object" && typeof e.__ref == "string");
  }
  function Sre(e) {
    return Hn(e) && e.kind === "Document" && Array.isArray(e.definitions);
  }
  function _re(e) {
    return e.kind === "StringValue";
  }
  function Cre(e) {
    return e.kind === "BooleanValue";
  }
  function Ore(e) {
    return e.kind === "IntValue";
  }
  function Tre(e) {
    return e.kind === "FloatValue";
  }
  function Are(e) {
    return e.kind === "Variable";
  }
  function Dre(e) {
    return e.kind === "ObjectValue";
  }
  function kre(e) {
    return e.kind === "ListValue";
  }
  function Rre(e) {
    return e.kind === "EnumValue";
  }
  function Pre(e) {
    return e.kind === "NullValue";
  }
  function a0(e, t, r, n) {
    if (Ore(r) || Tre(r))
      e[t.value] = Number(r.value);
    else if (Cre(r) || _re(r))
      e[t.value] = r.value;
    else if (Dre(r)) {
      var i = {};
      r.fields.map(function(s) {
        return a0(i, s.name, s.value, n);
      }), e[t.value] = i;
    } else if (Are(r)) {
      var u = (n || {})[r.name.value];
      e[t.value] = u;
    } else if (kre(r))
      e[t.value] = r.values.map(function(s) {
        var c = {};
        return a0(c, t, s, n), c[t.value];
      });
    else if (Rre(r))
      e[t.value] = r.value;
    else if (Pre(r))
      e[t.value] = null;
    else
      throw Ya(96, t.value, r.kind);
  }
  function Mre(e, t) {
    var r = null;
    e.directives && (r = {}, e.directives.forEach(function(i) {
      r[i.name.value] = {}, i.arguments && i.arguments.forEach(function(u) {
        var s = u.name, c = u.value;
        return a0(r[i.name.value], s, c, t);
      });
    }));
    var n = null;
    return e.arguments && e.arguments.length && (n = {}, e.arguments.forEach(function(i) {
      var u = i.name, s = i.value;
      return a0(n, u, s, t);
    })), VU(e.name.value, n, r);
  }
  var Nre = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive"
  ], fg = Ff, VU = Object.assign(function(e, t, r) {
    if (t && r && r.connection && r.connection.key)
      if (r.connection.filter && r.connection.filter.length > 0) {
        var n = r.connection.filter ? r.connection.filter : [];
        n.sort();
        var i = {};
        return n.forEach(function(c) {
          i[c] = t[c];
        }), "".concat(r.connection.key, "(").concat(fg(i), ")");
      } else
        return r.connection.key;
    var u = e;
    if (t) {
      var s = fg(t);
      u += "(".concat(s, ")");
    }
    return r && Object.keys(r).forEach(function(c) {
      Nre.indexOf(c) === -1 && (r[c] && Object.keys(r[c]).length ? u += "@".concat(c, "(").concat(fg(r[c]), ")") : u += "@".concat(c));
    }), u;
  }, {
    setStringify: function(e) {
      var t = fg;
      return fg = e, t;
    }
  });
  function D_(e, t) {
    if (e.arguments && e.arguments.length) {
      var r = {};
      return e.arguments.forEach(function(n) {
        var i = n.name, u = n.value;
        return a0(r, i, u, t);
      }), r;
    }
    return null;
  }
  function gc(e) {
    return e.alias ? e.alias.value : e.name.value;
  }
  function hP(e, t, r) {
    for (var n, i = 0, u = t.selections; i < u.length; i++) {
      var s = u[i];
      if ($f(s)) {
        if (s.name.value === "__typename")
          return e[gc(s)];
      } else n ? n.push(s) : n = [s];
    }
    if (typeof e.__typename == "string")
      return e.__typename;
    if (n)
      for (var c = 0, p = n; c < p.length; c++) {
        var s = p[c], h = hP(e, A_(s, r).selectionSet, r);
        if (typeof h == "string")
          return h;
      }
  }
  function $f(e) {
    return e.kind === "Field";
  }
  function jre(e) {
    return e.kind === "InlineFragment";
  }
  function L0(e) {
    st(e && e.kind === "Document", 88);
    var t = e.definitions.filter(function(r) {
      return r.kind !== "FragmentDefinition";
    }).map(function(r) {
      if (r.kind !== "OperationDefinition")
        throw Ya(89, r.kind);
      return r;
    });
    return st(t.length <= 1, 90, t.length), e;
  }
  function Mp(e) {
    return L0(e), e.definitions.filter(function(t) {
      return t.kind === "OperationDefinition";
    })[0];
  }
  function kg(e) {
    return e.definitions.filter(function(t) {
      return t.kind === "OperationDefinition" && !!t.name;
    }).map(function(t) {
      return t.name.value;
    })[0] || null;
  }
  function $0(e) {
    return e.definitions.filter(function(t) {
      return t.kind === "FragmentDefinition";
    });
  }
  function WU(e) {
    var t = Mp(e);
    return st(t && t.operation === "query", 91), t;
  }
  function YU(e) {
    st(e.kind === "Document", 92), st(e.definitions.length <= 1, 93);
    var t = e.definitions[0];
    return st(t.kind === "FragmentDefinition", 94), t;
  }
  function Fx(e) {
    L0(e);
    for (var t, r = 0, n = e.definitions; r < n.length; r++) {
      var i = n[r];
      if (i.kind === "OperationDefinition") {
        var u = i.operation;
        if (u === "query" || u === "mutation" || u === "subscription")
          return i;
      }
      i.kind === "FragmentDefinition" && !t && (t = i);
    }
    if (t)
      return t;
    throw Ya(95);
  }
  function bN(e) {
    var t = /* @__PURE__ */ Object.create(null), r = e && e.variableDefinitions;
    return r && r.length && r.forEach(function(n) {
      n.defaultValue && a0(t, n.variable.name, n.defaultValue);
    }), t;
  }
  function Fre(e) {
    return e;
  }
  var GU = (
    /** @class */
    function() {
      function e(t, r) {
        r === void 0 && (r = /* @__PURE__ */ Object.create(null)), this.resultCache = mN ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = t, r.getCacheKey && (this.getCacheKey = r.getCacheKey), this.cached = r.cache !== !1, this.resetCache();
      }
      return e.prototype.getCacheKey = function(t) {
        return [t];
      }, e.identity = function() {
        return new e(Fre, { cache: !1 });
      }, e.split = function(t, r, n) {
        return n === void 0 && (n = e.identity()), Object.assign(new e(
          function(i) {
            var u = t(i) ? r : n;
            return u.transformDocument(i);
          },
          // Reasonably assume both `left` and `right` transforms handle their own caching
          { cache: !1 }
        ), { left: r, right: n });
      }, e.prototype.resetCache = function() {
        var t = this;
        if (this.cached) {
          var r = new Cc($p);
          this.performWork = Yg(e.prototype.performWork.bind(this), {
            makeCacheKey: function(n) {
              var i = t.getCacheKey(n);
              if (i)
                return st(Array.isArray(i), 77), r.lookupArray(i);
            },
            max: cl["documentTransform.cache"],
            cache: pS
          });
        }
      }, e.prototype.performWork = function(t) {
        return L0(t), this.transform(t);
      }, e.prototype.transformDocument = function(t) {
        if (this.resultCache.has(t))
          return t;
        var r = this.performWork(t);
        return this.resultCache.add(r), r;
      }, e.prototype.concat = function(t) {
        var r = this;
        return Object.assign(new e(
          function(n) {
            return t.transformDocument(r.transformDocument(n));
          },
          // Reasonably assume both transforms handle their own caching
          { cache: !1 }
        ), {
          left: this,
          right: t
        });
      }, e;
    }()
  ), jg, _p = Object.assign(function(e) {
    var t = jg.get(e);
    return t || (t = ere(e), jg.set(e, t)), t;
  }, {
    reset: function() {
      jg = new gN(
        cl.print || 2e3
        /* defaultCacheSizes.print */
      );
    }
  });
  _p.reset();
  globalThis.__DEV__ !== !1 && xN("print", function() {
    return jg ? jg.size : 0;
  });
  var Vn = Array.isArray;
  function Cu(e) {
    return Array.isArray(e) && e.length > 0;
  }
  var vB = {
    kind: at.FIELD,
    name: {
      kind: at.NAME,
      value: "__typename"
    }
  };
  function QU(e, t) {
    return !e || e.selectionSet.selections.every(function(r) {
      return r.kind === at.FRAGMENT_SPREAD && QU(t[r.name.value], t);
    });
  }
  function Ire(e) {
    return QU(Mp(e) || YU(e), B0($0(e))) ? null : e;
  }
  function Bre(e) {
    var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
    return e.forEach(function(n) {
      n && (n.name ? t.set(n.name, n) : n.test && r.set(n.test, n));
    }), function(n) {
      var i = t.get(n.name.value);
      return !i && r.size && r.forEach(function(u, s) {
        s(n) && (i = u);
      }), i;
    };
  }
  function mB(e) {
    var t = /* @__PURE__ */ new Map();
    return function(n) {
      n === void 0 && (n = e);
      var i = t.get(n);
      return i || t.set(n, i = {
        // Variable and fragment spread names used directly within this
        // operation or fragment definition, as identified by key. These sets
        // will be populated during the first traversal of the document in
        // removeDirectivesFromDocument below.
        variables: /* @__PURE__ */ new Set(),
        fragmentSpreads: /* @__PURE__ */ new Set()
      }), i;
    };
  }
  function KU(e, t) {
    L0(t);
    for (var r = mB(""), n = mB(""), i = function(k) {
      for (var D = 0, A = void 0; D < k.length && (A = k[D]); ++D)
        if (!Vn(A)) {
          if (A.kind === at.OPERATION_DEFINITION)
            return r(A.name && A.name.value);
          if (A.kind === at.FRAGMENT_DEFINITION)
            return n(A.name.value);
        }
      return globalThis.__DEV__ !== !1 && st.error(97), null;
    }, u = 0, s = t.definitions.length - 1; s >= 0; --s)
      t.definitions[s].kind === at.OPERATION_DEFINITION && ++u;
    var c = Bre(e), p = function(k) {
      return Cu(k) && k.map(c).some(function(D) {
        return D && D.remove;
      });
    }, h = /* @__PURE__ */ new Map(), v = !1, y = {
      enter: function(k) {
        if (p(k.directives))
          return v = !0, null;
      }
    }, x = hs(t, {
      // These two AST node types share the same implementation, defined above.
      Field: y,
      InlineFragment: y,
      VariableDefinition: {
        enter: function() {
          return !1;
        }
      },
      Variable: {
        enter: function(k, D, A, R, T) {
          var M = i(T);
          M && M.variables.add(k.name.value);
        }
      },
      FragmentSpread: {
        enter: function(k, D, A, R, T) {
          if (p(k.directives))
            return v = !0, null;
          var M = i(T);
          M && M.fragmentSpreads.add(k.name.value);
        }
      },
      FragmentDefinition: {
        enter: function(k, D, A, R) {
          h.set(JSON.stringify(R), k);
        },
        leave: function(k, D, A, R) {
          var T = h.get(JSON.stringify(R));
          if (k === T)
            return k;
          if (
            // This logic applies only if the document contains one or more
            // operations, since removing all fragments from a document containing
            // only fragments makes the document useless.
            u > 0 && k.selectionSet.selections.every(function(M) {
              return M.kind === at.FIELD && M.name.value === "__typename";
            })
          )
            return n(k.name.value).removed = !0, v = !0, null;
        }
      },
      Directive: {
        leave: function(k) {
          if (c(k))
            return v = !0, null;
        }
      }
    });
    if (!v)
      return t;
    var w = function(k) {
      return k.transitiveVars || (k.transitiveVars = new Set(k.variables), k.removed || k.fragmentSpreads.forEach(function(D) {
        w(n(D)).transitiveVars.forEach(function(A) {
          k.transitiveVars.add(A);
        });
      })), k;
    }, E = /* @__PURE__ */ new Set();
    x.definitions.forEach(function(k) {
      k.kind === at.OPERATION_DEFINITION ? w(r(k.name && k.name.value)).fragmentSpreads.forEach(function(D) {
        E.add(D);
      }) : k.kind === at.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
      // definitions count as usages of their own fragment names. This heuristic
      // prevents accidentally removing all fragment definitions from the
      // document just because it contains no operations that use the fragments.
      u === 0 && !n(k.name.value).removed && E.add(k.name.value);
    }), E.forEach(function(k) {
      w(n(k)).fragmentSpreads.forEach(function(D) {
        E.add(D);
      });
    });
    var C = function(k) {
      return !!// A fragment definition will be removed if there are no spreads that refer
      // to it, or the fragment was explicitly removed because it had no fields
      // other than __typename.
      (!E.has(k) || n(k).removed);
    }, S = {
      enter: function(k) {
        if (C(k.name.value))
          return null;
      }
    };
    return Ire(hs(x, {
      // If the fragment is going to be removed, then leaving any dangling
      // FragmentSpread nodes with the same name would be a mistake.
      FragmentSpread: S,
      // This is where the fragment definition is actually removed.
      FragmentDefinition: S,
      OperationDefinition: {
        leave: function(k) {
          if (k.variableDefinitions) {
            var D = w(
              // If an operation is anonymous, we use the empty string as its key.
              r(k.name && k.name.value)
            ).transitiveVars;
            if (D.size < k.variableDefinitions.length)
              return ye(ye({}, k), { variableDefinitions: k.variableDefinitions.filter(function(A) {
                return D.has(A.variable.name.value);
              }) });
          }
        }
      }
    }));
  }
  var wN = Object.assign(function(e) {
    return hs(e, {
      SelectionSet: {
        enter: function(t, r, n) {
          if (!(n && n.kind === at.OPERATION_DEFINITION)) {
            var i = t.selections;
            if (i) {
              var u = i.some(function(c) {
                return $f(c) && (c.name.value === "__typename" || c.name.value.lastIndexOf("__", 0) === 0);
              });
              if (!u) {
                var s = n;
                if (!($f(s) && s.directives && s.directives.some(function(c) {
                  return c.name.value === "export";
                })))
                  return ye(ye({}, t), { selections: Da(Da([], i, !0), [vB], !1) });
              }
            }
          }
        }
      }
    });
  }, {
    added: function(e) {
      return e === vB;
    }
  });
  function Lre(e) {
    var t = Fx(e), r = t.operation;
    if (r === "query")
      return e;
    var n = hs(e, {
      OperationDefinition: {
        enter: function(i) {
          return ye(ye({}, i), { operation: "query" });
        }
      }
    });
    return n;
  }
  function XU(e) {
    L0(e);
    var t = KU([
      {
        test: function(r) {
          return r.name.value === "client";
        },
        remove: !0
      }
    ], e);
    return t;
  }
  function $re(e) {
    return L0(e), hs(e, {
      FragmentSpread: function(t) {
        var r;
        if (!(!((r = t.directives) === null || r === void 0) && r.some(function(n) {
          return n.name.value === "unmask";
        })))
          return ye(ye({}, t), { directives: Da(Da([], t.directives || [], !0), [
            {
              kind: at.DIRECTIVE,
              name: { kind: at.NAME, value: "nonreactive" }
            }
          ], !1) });
      }
    });
  }
  var zre = Object.prototype.hasOwnProperty;
  function yB() {
    for (var e = [], t = 0; t < arguments.length; t++)
      e[t] = arguments[t];
    return k_(e);
  }
  function k_(e) {
    var t = e[0] || {}, r = e.length;
    if (r > 1)
      for (var n = new zf(), i = 1; i < r; ++i)
        t = n.merge(t, e[i]);
    return t;
  }
  var qre = function(e, t, r) {
    return this.merge(e[r], t[r]);
  }, zf = (
    /** @class */
    function() {
      function e(t) {
        t === void 0 && (t = qre), this.reconciler = t, this.isObject = Hn, this.pastCopies = /* @__PURE__ */ new Set();
      }
      return e.prototype.merge = function(t, r) {
        for (var n = this, i = [], u = 2; u < arguments.length; u++)
          i[u - 2] = arguments[u];
        return Hn(r) && Hn(t) ? (Object.keys(r).forEach(function(s) {
          if (zre.call(t, s)) {
            var c = t[s];
            if (r[s] !== c) {
              var p = n.reconciler.apply(n, Da([
                t,
                r,
                s
              ], i, !1));
              p !== c && (t = n.shallowCopyForMerge(t), t[s] = p);
            }
          } else
            t = n.shallowCopyForMerge(t), t[s] = r[s];
        }), t) : r;
      }, e.prototype.shallowCopyForMerge = function(t) {
        return Hn(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = ye({ __proto__: Object.getPrototypeOf(t) }, t), this.pastCopies.add(t))), t;
      }, e;
    }()
  );
  function Ure(e, t) {
    var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r) return (r = r.call(e)).next.bind(r);
    if (Array.isArray(e) || (r = Hre(e)) || t) {
      r && (e = r);
      var n = 0;
      return function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Hre(e, t) {
    if (e) {
      if (typeof e == "string") return gB(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return gB(e, t);
    }
  }
  function gB(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++)
      n[r] = e[r];
    return n;
  }
  function xB(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }
  function EN(e, t, r) {
    return t && xB(e.prototype, t), r && xB(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  var SN = function() {
    return typeof Symbol == "function";
  }, _N = function(e) {
    return SN() && !!Symbol[e];
  }, CN = function(e) {
    return _N(e) ? Symbol[e] : "@@" + e;
  };
  SN() && !_N("observable") && (Symbol.observable = Symbol("observable"));
  var Vre = CN("iterator"), vP = CN("observable"), ZU = CN("species");
  function hS(e, t) {
    var r = e[t];
    if (r != null) {
      if (typeof r != "function") throw new TypeError(r + " is not a function");
      return r;
    }
  }
  function dg(e) {
    var t = e.constructor;
    return t !== void 0 && (t = t[ZU], t === null && (t = void 0)), t !== void 0 ? t : pn;
  }
  function Wre(e) {
    return e instanceof pn;
  }
  function o0(e) {
    o0.log ? o0.log(e) : setTimeout(function() {
      throw e;
    });
  }
  function EE(e) {
    Promise.resolve().then(function() {
      try {
        e();
      } catch (t) {
        o0(t);
      }
    });
  }
  function JU(e) {
    var t = e._cleanup;
    if (t !== void 0 && (e._cleanup = void 0, !!t))
      try {
        if (typeof t == "function")
          t();
        else {
          var r = hS(t, "unsubscribe");
          r && r.call(t);
        }
      } catch (n) {
        o0(n);
      }
  }
  function mP(e) {
    e._observer = void 0, e._queue = void 0, e._state = "closed";
  }
  function Yre(e) {
    var t = e._queue;
    if (t) {
      e._queue = void 0, e._state = "ready";
      for (var r = 0; r < t.length && (e9(e, t[r].type, t[r].value), e._state !== "closed"); ++r)
        ;
    }
  }
  function e9(e, t, r) {
    e._state = "running";
    var n = e._observer;
    try {
      var i = hS(n, t);
      switch (t) {
        case "next":
          i && i.call(n, r);
          break;
        case "error":
          if (mP(e), i) i.call(n, r);
          else throw r;
          break;
        case "complete":
          mP(e), i && i.call(n);
          break;
      }
    } catch (u) {
      o0(u);
    }
    e._state === "closed" ? JU(e) : e._state === "running" && (e._state = "ready");
  }
  function LA(e, t, r) {
    if (e._state !== "closed") {
      if (e._state === "buffering") {
        e._queue.push({
          type: t,
          value: r
        });
        return;
      }
      if (e._state !== "ready") {
        e._state = "buffering", e._queue = [{
          type: t,
          value: r
        }], EE(function() {
          return Yre(e);
        });
        return;
      }
      e9(e, t, r);
    }
  }
  var Gre = /* @__PURE__ */ function() {
    function e(r, n) {
      this._cleanup = void 0, this._observer = r, this._queue = void 0, this._state = "initializing";
      var i = new Qre(this);
      try {
        this._cleanup = n.call(void 0, i);
      } catch (u) {
        i.error(u);
      }
      this._state === "initializing" && (this._state = "ready");
    }
    var t = e.prototype;
    return t.unsubscribe = function() {
      this._state !== "closed" && (mP(this), JU(this));
    }, EN(e, [{
      key: "closed",
      get: function() {
        return this._state === "closed";
      }
    }]), e;
  }(), Qre = /* @__PURE__ */ function() {
    function e(r) {
      this._subscription = r;
    }
    var t = e.prototype;
    return t.next = function(n) {
      LA(this._subscription, "next", n);
    }, t.error = function(n) {
      LA(this._subscription, "error", n);
    }, t.complete = function() {
      LA(this._subscription, "complete");
    }, EN(e, [{
      key: "closed",
      get: function() {
        return this._subscription._state === "closed";
      }
    }]), e;
  }(), pn = /* @__PURE__ */ function() {
    function e(r) {
      if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
      if (typeof r != "function") throw new TypeError("Observable initializer must be a function");
      this._subscriber = r;
    }
    var t = e.prototype;
    return t.subscribe = function(n) {
      return (typeof n != "object" || n === null) && (n = {
        next: n,
        error: arguments[1],
        complete: arguments[2]
      }), new Gre(n, this._subscriber);
    }, t.forEach = function(n) {
      var i = this;
      return new Promise(function(u, s) {
        if (typeof n != "function") {
          s(new TypeError(n + " is not a function"));
          return;
        }
        function c() {
          p.unsubscribe(), u();
        }
        var p = i.subscribe({
          next: function(h) {
            try {
              n(h, c);
            } catch (v) {
              s(v), p.unsubscribe();
            }
          },
          error: s,
          complete: u
        });
      });
    }, t.map = function(n) {
      var i = this;
      if (typeof n != "function") throw new TypeError(n + " is not a function");
      var u = dg(this);
      return new u(function(s) {
        return i.subscribe({
          next: function(c) {
            try {
              c = n(c);
            } catch (p) {
              return s.error(p);
            }
            s.next(c);
          },
          error: function(c) {
            s.error(c);
          },
          complete: function() {
            s.complete();
          }
        });
      });
    }, t.filter = function(n) {
      var i = this;
      if (typeof n != "function") throw new TypeError(n + " is not a function");
      var u = dg(this);
      return new u(function(s) {
        return i.subscribe({
          next: function(c) {
            try {
              if (!n(c)) return;
            } catch (p) {
              return s.error(p);
            }
            s.next(c);
          },
          error: function(c) {
            s.error(c);
          },
          complete: function() {
            s.complete();
          }
        });
      });
    }, t.reduce = function(n) {
      var i = this;
      if (typeof n != "function") throw new TypeError(n + " is not a function");
      var u = dg(this), s = arguments.length > 1, c = !1, p = arguments[1], h = p;
      return new u(function(v) {
        return i.subscribe({
          next: function(y) {
            var x = !c;
            if (c = !0, !x || s)
              try {
                h = n(h, y);
              } catch (w) {
                return v.error(w);
              }
            else
              h = y;
          },
          error: function(y) {
            v.error(y);
          },
          complete: function() {
            if (!c && !s) return v.error(new TypeError("Cannot reduce an empty sequence"));
            v.next(h), v.complete();
          }
        });
      });
    }, t.concat = function() {
      for (var n = this, i = arguments.length, u = new Array(i), s = 0; s < i; s++)
        u[s] = arguments[s];
      var c = dg(this);
      return new c(function(p) {
        var h, v = 0;
        function y(x) {
          h = x.subscribe({
            next: function(w) {
              p.next(w);
            },
            error: function(w) {
              p.error(w);
            },
            complete: function() {
              v === u.length ? (h = void 0, p.complete()) : y(c.from(u[v++]));
            }
          });
        }
        return y(n), function() {
          h && (h.unsubscribe(), h = void 0);
        };
      });
    }, t.flatMap = function(n) {
      var i = this;
      if (typeof n != "function") throw new TypeError(n + " is not a function");
      var u = dg(this);
      return new u(function(s) {
        var c = [], p = i.subscribe({
          next: function(v) {
            if (n)
              try {
                v = n(v);
              } catch (x) {
                return s.error(x);
              }
            var y = u.from(v).subscribe({
              next: function(x) {
                s.next(x);
              },
              error: function(x) {
                s.error(x);
              },
              complete: function() {
                var x = c.indexOf(y);
                x >= 0 && c.splice(x, 1), h();
              }
            });
            c.push(y);
          },
          error: function(v) {
            s.error(v);
          },
          complete: function() {
            h();
          }
        });
        function h() {
          p.closed && c.length === 0 && s.complete();
        }
        return function() {
          c.forEach(function(v) {
            return v.unsubscribe();
          }), p.unsubscribe();
        };
      });
    }, t[vP] = function() {
      return this;
    }, e.from = function(n) {
      var i = typeof this == "function" ? this : e;
      if (n == null) throw new TypeError(n + " is not an object");
      var u = hS(n, vP);
      if (u) {
        var s = u.call(n);
        if (Object(s) !== s) throw new TypeError(s + " is not an object");
        return Wre(s) && s.constructor === i ? s : new i(function(c) {
          return s.subscribe(c);
        });
      }
      if (_N("iterator") && (u = hS(n, Vre), u))
        return new i(function(c) {
          EE(function() {
            if (!c.closed) {
              for (var p = Ure(u.call(n)), h; !(h = p()).done; ) {
                var v = h.value;
                if (c.next(v), c.closed) return;
              }
              c.complete();
            }
          });
        });
      if (Array.isArray(n))
        return new i(function(c) {
          EE(function() {
            if (!c.closed) {
              for (var p = 0; p < n.length; ++p)
                if (c.next(n[p]), c.closed) return;
              c.complete();
            }
          });
        });
      throw new TypeError(n + " is not observable");
    }, e.of = function() {
      for (var n = arguments.length, i = new Array(n), u = 0; u < n; u++)
        i[u] = arguments[u];
      var s = typeof this == "function" ? this : e;
      return new s(function(c) {
        EE(function() {
          if (!c.closed) {
            for (var p = 0; p < i.length; ++p)
              if (c.next(i[p]), c.closed) return;
            c.complete();
          }
        });
      });
    }, EN(e, null, [{
      key: ZU,
      get: function() {
        return this;
      }
    }]), e;
  }();
  SN() && Object.defineProperty(pn, Symbol("extensions"), {
    value: {
      symbol: vP,
      hostReportError: o0
    },
    configurable: !0
  });
  function Kre(e) {
    var t, r = e.Symbol;
    if (typeof r == "function")
      if (r.observable)
        t = r.observable;
      else {
        typeof r.for == "function" ? t = r.for("https://github.com/benlesh/symbol-observable") : t = r("https://github.com/benlesh/symbol-observable");
        try {
          r.observable = t;
        } catch {
        }
      }
    else
      t = "@@observable";
    return t;
  }
  var $v;
  typeof self < "u" ? $v = self : typeof window < "u" ? $v = window : typeof global < "u" ? $v = global : typeof uN < "u" ? $v = uN : $v = Function("return this")();
  Kre($v);
  var bB = pn.prototype, wB = "@@observable";
  bB[wB] || (bB[wB] = function() {
    return this;
  });
  function Xre(e) {
    return e.catch(function() {
    }), e;
  }
  var Zre = Object.prototype.toString;
  function t9(e) {
    return yP(e);
  }
  function yP(e, t) {
    switch (Zre.call(e)) {
      case "[object Array]": {
        if (t = t || /* @__PURE__ */ new Map(), t.has(e))
          return t.get(e);
        var r = e.slice(0);
        return t.set(e, r), r.forEach(function(i, u) {
          r[u] = yP(i, t);
        }), r;
      }
      case "[object Object]": {
        if (t = t || /* @__PURE__ */ new Map(), t.has(e))
          return t.get(e);
        var n = Object.create(Object.getPrototypeOf(e));
        return t.set(e, n), Object.keys(e).forEach(function(i) {
          n[i] = yP(e[i], t);
        }), n;
      }
      default:
        return e;
    }
  }
  function Jre(e) {
    var t = /* @__PURE__ */ new Set([e]);
    return t.forEach(function(r) {
      Hn(r) && ene(r) === r && Object.getOwnPropertyNames(r).forEach(function(n) {
        Hn(r[n]) && t.add(r[n]);
      });
    }), e;
  }
  function ene(e) {
    if (globalThis.__DEV__ !== !1 && !Object.isFrozen(e))
      try {
        Object.freeze(e);
      } catch (t) {
        if (t instanceof TypeError)
          return null;
        throw t;
      }
    return e;
  }
  function u0(e) {
    return globalThis.__DEV__ !== !1 && Jre(e), e;
  }
  function Fg(e, t, r) {
    var n = [];
    e.forEach(function(i) {
      return i[t] && n.push(i);
    }), n.forEach(function(i) {
      return i[t](r);
    });
  }
  function $A(e, t, r) {
    return new pn(function(n) {
      var i = {
        // Normally we would initialize promiseQueue to Promise.resolve(), but
        // in this case, for backwards compatibility, we need to be careful to
        // invoke the first callback synchronously.
        then: function(p) {
          return new Promise(function(h) {
            return h(p());
          });
        }
      };
      function u(p, h) {
        return function(v) {
          if (p) {
            var y = function() {
              return n.closed ? (
                /* will be swallowed */
                0
              ) : p(v);
            };
            i = i.then(y, y).then(function(x) {
              return n.next(x);
            }, function(x) {
              return n.error(x);
            });
          } else
            n[h](v);
        };
      }
      var s = {
        next: u(t, "next"),
        error: u(r, "error"),
        complete: function() {
          i.then(function() {
            return n.complete();
          });
        }
      }, c = e.subscribe(s);
      return function() {
        return c.unsubscribe();
      };
    });
  }
  function r9(e) {
    function t(r) {
      Object.defineProperty(e, r, { value: pn });
    }
    return yN && Symbol.species && t(Symbol.species), t("@@species"), e;
  }
  function EB(e) {
    return e && typeof e.then == "function";
  }
  var zv = (
    /** @class */
    function(e) {
      pl(t, e);
      function t(r) {
        var n = e.call(this, function(i) {
          return n.addObserver(i), function() {
            return n.removeObserver(i);
          };
        }) || this;
        return n.observers = /* @__PURE__ */ new Set(), n.promise = new Promise(function(i, u) {
          n.resolve = i, n.reject = u;
        }), n.handlers = {
          next: function(i) {
            n.sub !== null && (n.latest = ["next", i], n.notify("next", i), Fg(n.observers, "next", i));
          },
          error: function(i) {
            var u = n.sub;
            u !== null && (u && setTimeout(function() {
              return u.unsubscribe();
            }), n.sub = null, n.latest = ["error", i], n.reject(i), n.notify("error", i), Fg(n.observers, "error", i));
          },
          complete: function() {
            var i = n, u = i.sub, s = i.sources, c = s === void 0 ? [] : s;
            if (u !== null) {
              var p = c.shift();
              p ? EB(p) ? p.then(function(h) {
                return n.sub = h.subscribe(n.handlers);
              }, n.handlers.error) : n.sub = p.subscribe(n.handlers) : (u && setTimeout(function() {
                return u.unsubscribe();
              }), n.sub = null, n.latest && n.latest[0] === "next" ? n.resolve(n.latest[1]) : n.resolve(), n.notify("complete"), Fg(n.observers, "complete"));
            }
          }
        }, n.nextResultListeners = /* @__PURE__ */ new Set(), n.cancel = function(i) {
          n.reject(i), n.sources = [], n.handlers.error(i);
        }, n.promise.catch(function(i) {
        }), typeof r == "function" && (r = [new pn(r)]), EB(r) ? r.then(function(i) {
          return n.start(i);
        }, n.handlers.error) : n.start(r), n;
      }
      return t.prototype.start = function(r) {
        this.sub === void 0 && (this.sources = Array.from(r), this.handlers.complete());
      }, t.prototype.deliverLastMessage = function(r) {
        if (this.latest) {
          var n = this.latest[0], i = r[n];
          i && i.call(r, this.latest[1]), this.sub === null && n === "next" && r.complete && r.complete();
        }
      }, t.prototype.addObserver = function(r) {
        this.observers.has(r) || (this.deliverLastMessage(r), this.observers.add(r));
      }, t.prototype.removeObserver = function(r) {
        this.observers.delete(r) && this.observers.size < 1 && this.handlers.complete();
      }, t.prototype.notify = function(r, n) {
        var i = this.nextResultListeners;
        i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(u) {
          return u(r, n);
        }));
      }, t.prototype.beforeNext = function(r) {
        var n = !1;
        this.nextResultListeners.add(function(i, u) {
          n || (n = !0, r(i, u));
        });
      }, t;
    }(pn)
  );
  r9(zv);
  function Xv(e) {
    return "incremental" in e;
  }
  function tne(e) {
    return "hasNext" in e && "data" in e;
  }
  function rne(e) {
    return Xv(e) || tne(e);
  }
  function nne(e) {
    return Hn(e) && "payload" in e;
  }
  function n9(e, t) {
    var r = e, n = new zf();
    return Xv(t) && Cu(t.incremental) && t.incremental.forEach(function(i) {
      for (var u = i.data, s = i.path, c = s.length - 1; c >= 0; --c) {
        var p = s[c], h = !isNaN(+p), v = h ? [] : {};
        v[p] = u, u = v;
      }
      r = n.merge(r, u);
    }), r;
  }
  function SE(e) {
    var t = gP(e);
    return Cu(t);
  }
  function gP(e) {
    var t = Cu(e.errors) ? e.errors.slice(0) : [];
    return Xv(e) && Cu(e.incremental) && e.incremental.forEach(function(r) {
      r.errors && t.push.apply(t, r.errors);
    }), t;
  }
  function Np() {
    for (var e = [], t = 0; t < arguments.length; t++)
      e[t] = arguments[t];
    var r = /* @__PURE__ */ Object.create(null);
    return e.forEach(function(n) {
      n && Object.keys(n).forEach(function(i) {
        var u = n[i];
        u !== void 0 && (r[i] = u);
      });
    }), r;
  }
  function _E(e, t) {
    return Np(e, t, t.variables && {
      variables: Np(ye(ye({}, e && e.variables), t.variables))
    });
  }
  const { toString: SB, hasOwnProperty: ine } = Object.prototype, _B = Function.prototype.toString, xP = /* @__PURE__ */ new Map();
  function Xr(e, t) {
    try {
      return bP(e, t);
    } finally {
      xP.clear();
    }
  }
  function bP(e, t) {
    if (e === t)
      return !0;
    const r = SB.call(e), n = SB.call(t);
    if (r !== n)
      return !1;
    switch (r) {
      case "[object Array]":
        if (e.length !== t.length)
          return !1;
      // Fall through to object case...
      case "[object Object]": {
        if (OB(e, t))
          return !0;
        const i = CB(e), u = CB(t), s = i.length;
        if (s !== u.length)
          return !1;
        for (let c = 0; c < s; ++c)
          if (!ine.call(t, i[c]))
            return !1;
        for (let c = 0; c < s; ++c) {
          const p = i[c];
          if (!bP(e[p], t[p]))
            return !1;
        }
        return !0;
      }
      case "[object Error]":
        return e.name === t.name && e.message === t.message;
      case "[object Number]":
        if (e !== e)
          return t !== t;
      // Fall through to shared +a === +b case...
      case "[object Boolean]":
      case "[object Date]":
        return +e == +t;
      case "[object RegExp]":
      case "[object String]":
        return e == `${t}`;
      case "[object Map]":
      case "[object Set]": {
        if (e.size !== t.size)
          return !1;
        if (OB(e, t))
          return !0;
        const i = e.entries(), u = r === "[object Map]";
        for (; ; ) {
          const s = i.next();
          if (s.done)
            break;
          const [c, p] = s.value;
          if (!t.has(c) || u && !bP(p, t.get(c)))
            return !1;
        }
        return !0;
      }
      case "[object Uint16Array]":
      case "[object Uint8Array]":
      // Buffer, in Node.js.
      case "[object Uint32Array]":
      case "[object Int32Array]":
      case "[object Int8Array]":
      case "[object Int16Array]":
      case "[object ArrayBuffer]":
        e = new Uint8Array(e), t = new Uint8Array(t);
      // Fall through...
      case "[object DataView]": {
        let i = e.byteLength;
        if (i === t.byteLength)
          for (; i-- && e[i] === t[i]; )
            ;
        return i === -1;
      }
      case "[object AsyncFunction]":
      case "[object GeneratorFunction]":
      case "[object AsyncGeneratorFunction]":
      case "[object Function]": {
        const i = _B.call(e);
        return i !== _B.call(t) ? !1 : !une(i, one);
      }
    }
    return !1;
  }
  function CB(e) {
    return Object.keys(e).filter(ane, e);
  }
  function ane(e) {
    return this[e] !== void 0;
  }
  const one = "{ [native code] }";
  function une(e, t) {
    const r = e.length - t.length;
    return r >= 0 && e.indexOf(t, r) === r;
  }
  function OB(e, t) {
    let r = xP.get(e);
    if (r) {
      if (r.has(t))
        return !0;
    } else
      xP.set(e, r = /* @__PURE__ */ new Set());
    return r.add(t), !1;
  }
  function i9(e, t, r, n) {
    var i = t.data, u = ps(t, ["data"]), s = r.data, c = ps(r, ["data"]);
    return Xr(u, c) && CE(Fx(e).selectionSet, i, s, {
      fragmentMap: B0($0(e)),
      variables: n
    });
  }
  function CE(e, t, r, n) {
    if (t === r)
      return !0;
    var i = /* @__PURE__ */ new Set();
    return e.selections.every(function(u) {
      if (i.has(u) || (i.add(u), !jx(u, n.variables)) || TB(u))
        return !0;
      if ($f(u)) {
        var s = gc(u), c = t && t[s], p = r && r[s], h = u.selectionSet;
        if (!h)
          return Xr(c, p);
        var v = Array.isArray(c), y = Array.isArray(p);
        if (v !== y)
          return !1;
        if (v && y) {
          var x = c.length;
          if (p.length !== x)
            return !1;
          for (var w = 0; w < x; ++w)
            if (!CE(h, c[w], p[w], n))
              return !1;
          return !0;
        }
        return CE(h, c, p, n);
      } else {
        var E = A_(u, n.fragmentMap);
        if (E)
          return TB(E) ? !0 : CE(
            E.selectionSet,
            // Notice that we reuse the same aResult and bResult values here,
            // since the fragment ...spread does not specify a field name, but
            // consists of multiple fields (within the fragment's selection set)
            // that should be applied to the current result value(s).
            t,
            r,
            n
          );
      }
    });
  }
  function TB(e) {
    return !!e.directives && e.directives.some(sne);
  }
  function sne(e) {
    return e.name.value === "nonreactive";
  }
  var a9 = $p ? WeakMap : Map, o9 = mN ? WeakSet : Set, ON = new Nx(), AB = !1;
  function u9() {
    AB || (AB = !0, globalThis.__DEV__ !== !1 && st.warn(52));
  }
  function s9(e, t, r) {
    return ON.withValue(!0, function() {
      var n = Rg(e, t, r, !1);
      return Object.isFrozen(e) && u0(n), n;
    });
  }
  function lne(e, t) {
    if (t.has(e))
      return t.get(e);
    var r = Array.isArray(e) ? [] : /* @__PURE__ */ Object.create(null);
    return t.set(e, r), r;
  }
  function Rg(e, t, r, n, i) {
    var u, s = r.knownChanged, c = lne(e, r.mutableTargets);
    if (Array.isArray(e)) {
      for (var p = 0, h = Array.from(e.entries()); p < h.length; p++) {
        var v = h[p], y = v[0], x = v[1];
        if (x === null) {
          c[y] = null;
          continue;
        }
        var w = Rg(x, t, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", "[").concat(y, "]") : void 0);
        s.has(w) && s.add(c), c[y] = w;
      }
      return s.has(c) ? c : e;
    }
    for (var E = 0, C = t.selections; E < C.length; E++) {
      var S = C[E], k = void 0;
      if (n && s.add(c), S.kind === at.FIELD) {
        var D = gc(S), A = S.selectionSet;
        if (k = c[D] || e[D], k === void 0)
          continue;
        if (A && k !== null) {
          var w = Rg(e[D], A, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", ".").concat(D) : void 0);
          s.has(w) && (k = w);
        }
        globalThis.__DEV__ === !1 && (c[D] = k), globalThis.__DEV__ !== !1 && (n && D !== "__typename" && // either the field is not present in the memo object
        // or it has a `get` descriptor, not a `value` descriptor
        // => it is a warning accessor and we can overwrite it
        // with another accessor
        !(!((u = Object.getOwnPropertyDescriptor(c, D)) === null || u === void 0) && u.value) ? Object.defineProperty(c, D, cne(D, k, i || "", r.operationName, r.operationType)) : (delete c[D], c[D] = k));
      }
      if (S.kind === at.INLINE_FRAGMENT && (!S.typeCondition || r.cache.fragmentMatches(S, e.__typename)) && (k = Rg(e, S.selectionSet, r, n, i)), S.kind === at.FRAGMENT_SPREAD) {
        var R = S.name.value, T = r.fragmentMap[R] || (r.fragmentMap[R] = r.cache.lookupFragment(R));
        st(T, 47, R);
        var M = ore(S);
        M !== "mask" && (k = Rg(e, T.selectionSet, r, M === "migrate", i));
      }
      s.has(k) && s.add(c);
    }
    return "__typename" in e && !("__typename" in c) && (c.__typename = e.__typename), Object.keys(c).length !== Object.keys(e).length && s.add(c), s.has(c) ? c : e;
  }
  function cne(e, t, r, n, i) {
    var u = function() {
      return ON.getValue() || (globalThis.__DEV__ !== !1 && st.warn(48, n ? "".concat(i, " '").concat(n, "'") : "anonymous ".concat(i), "".concat(r, ".").concat(e).replace(/^\./, "")), u = function() {
        return t;
      }), t;
    };
    return {
      get: function() {
        return u();
      },
      set: function(s) {
        u = function() {
          return s;
        };
      },
      enumerable: !0,
      configurable: !0
    };
  }
  function l9(e, t, r, n) {
    if (!r.fragmentMatches)
      return globalThis.__DEV__ !== !1 && u9(), e;
    var i = t.definitions.filter(function(s) {
      return s.kind === at.FRAGMENT_DEFINITION;
    });
    typeof n > "u" && (st(i.length === 1, 49, i.length), n = i[0].name.value);
    var u = i.find(function(s) {
      return s.name.value === n;
    });
    return st(!!u, 50, n), e == null || Xr(e, {}) ? e : s9(e, u.selectionSet, {
      operationType: "fragment",
      operationName: u.name.value,
      fragmentMap: B0($0(t)),
      cache: r,
      mutableTargets: new a9(),
      knownChanged: new o9()
    });
  }
  function fne(e, t, r) {
    var n;
    if (!r.fragmentMatches)
      return globalThis.__DEV__ !== !1 && u9(), e;
    var i = Mp(t);
    return st(i, 51), e == null ? e : s9(e, i.selectionSet, {
      operationType: i.operation,
      operationName: (n = i.name) === null || n === void 0 ? void 0 : n.value,
      fragmentMap: B0($0(t)),
      cache: r,
      mutableTargets: new a9(),
      knownChanged: new o9()
    });
  }
  var c9 = (
    /** @class */
    function() {
      function e() {
        this.assumeImmutableResults = !1, this.getFragmentDoc = Yg(cre, {
          max: cl["cache.fragmentQueryDocuments"] || 1e3,
          cache: pS
        });
      }
      return e.prototype.lookupFragment = function(t) {
        return null;
      }, e.prototype.batch = function(t) {
        var r = this, n = typeof t.optimistic == "string" ? t.optimistic : t.optimistic === !1 ? null : void 0, i;
        return this.performTransaction(function() {
          return i = t.update(r);
        }, n), i;
      }, e.prototype.recordOptimisticTransaction = function(t, r) {
        this.performTransaction(t, r);
      }, e.prototype.transformDocument = function(t) {
        return t;
      }, e.prototype.transformForLink = function(t) {
        return t;
      }, e.prototype.identify = function(t) {
      }, e.prototype.gc = function() {
        return [];
      }, e.prototype.modify = function(t) {
        return !1;
      }, e.prototype.readQuery = function(t, r) {
        return r === void 0 && (r = !!t.optimistic), this.read(ye(ye({}, t), { rootId: t.id || "ROOT_QUERY", optimistic: r }));
      }, e.prototype.watchFragment = function(t) {
        var r = this, n = t.fragment, i = t.fragmentName, u = t.from, s = t.optimistic, c = s === void 0 ? !0 : s, p = ps(t, ["fragment", "fragmentName", "from", "optimistic"]), h = this.getFragmentDoc(n, i), v = typeof u > "u" || typeof u == "string" ? u : this.identify(u), y = !!t[Symbol.for("apollo.dataMasking")];
        if (globalThis.__DEV__ !== !1) {
          var x = i || YU(n).name.value;
          v || globalThis.__DEV__ !== !1 && st.warn(1, x);
        }
        var w = ye(ye({}, p), { returnPartialData: !0, id: v, query: h, optimistic: c }), E;
        return new pn(function(C) {
          return r.watch(ye(ye({}, w), { immediate: !0, callback: function(S) {
            var k = y ? l9(S.result, n, r, i) : S.result;
            if (
              // Always ensure we deliver the first result
              !(E && i9(
                h,
                { data: E.result },
                { data: k },
                // TODO: Fix the type on WatchFragmentOptions so that TVars
                // extends OperationVariables
                t.variables
              ))
            ) {
              var D = {
                data: k,
                complete: !!S.complete
              };
              S.missing && (D.missing = k_(S.missing.map(function(A) {
                return A.missing;
              }))), E = ye(ye({}, S), { result: k }), C.next(D);
            }
          } }));
        });
      }, e.prototype.readFragment = function(t, r) {
        return r === void 0 && (r = !!t.optimistic), this.read(ye(ye({}, t), { query: this.getFragmentDoc(t.fragment, t.fragmentName), rootId: t.id, optimistic: r }));
      }, e.prototype.writeQuery = function(t) {
        var r = t.id, n = t.data, i = ps(t, ["id", "data"]);
        return this.write(Object.assign(i, {
          dataId: r || "ROOT_QUERY",
          result: n
        }));
      }, e.prototype.writeFragment = function(t) {
        var r = t.id, n = t.data, i = t.fragment, u = t.fragmentName, s = ps(t, ["id", "data", "fragment", "fragmentName"]);
        return this.write(Object.assign(s, {
          query: this.getFragmentDoc(i, u),
          dataId: r,
          result: n
        }));
      }, e.prototype.updateQuery = function(t, r) {
        return this.batch({
          update: function(n) {
            var i = n.readQuery(t), u = r(i);
            return u == null ? i : (n.writeQuery(ye(ye({}, t), { data: u })), u);
          }
        });
      }, e.prototype.updateFragment = function(t, r) {
        return this.batch({
          update: function(n) {
            var i = n.readFragment(t), u = r(i);
            return u == null ? i : (n.writeFragment(ye(ye({}, t), { data: u })), u);
          }
        });
      }, e;
    }()
  );
  globalThis.__DEV__ !== !1 && (c9.prototype.getMemoryInternals = mre);
  var f9 = (
    /** @class */
    function(e) {
      pl(t, e);
      function t(r, n, i, u) {
        var s, c = e.call(this, r) || this;
        if (c.message = r, c.path = n, c.query = i, c.variables = u, Array.isArray(c.path)) {
          c.missing = c.message;
          for (var p = c.path.length - 1; p >= 0; --p)
            c.missing = (s = {}, s[c.path[p]] = c.missing, s);
        } else
          c.missing = c.path;
        return c.__proto__ = t.prototype, c;
      }
      return t;
    }(Error)
  ), ji = Object.prototype.hasOwnProperty;
  function pg(e) {
    return e == null;
  }
  function d9(e, t) {
    var r = e.__typename, n = e.id, i = e._id;
    if (typeof r == "string" && (t && (t.keyObject = pg(n) ? pg(i) ? void 0 : { _id: i } : { id: n }), pg(n) && !pg(i) && (n = i), !pg(n)))
      return "".concat(r, ":").concat(typeof n == "number" || typeof n == "string" ? n : JSON.stringify(n));
  }
  var p9 = {
    dataIdFromObject: d9,
    addTypename: !0,
    resultCaching: !0,
    // Thanks to the shouldCanonizeResults helper, this should be the only line
    // you have to change to reenable canonization by default in the future.
    canonizeResults: !1
  };
  function dne(e) {
    return Np(p9, e);
  }
  function h9(e) {
    var t = e.canonizeResults;
    return t === void 0 ? p9.canonizeResults : t;
  }
  function pne(e, t) {
    return Vr(t) ? e.get(t.__ref, "__typename") : t && t.__typename;
  }
  var v9 = /^[_a-z][_0-9a-z]*/i;
  function qf(e) {
    var t = e.match(v9);
    return t ? t[0] : e;
  }
  function wP(e, t, r) {
    return Hn(t) ? Vn(t) ? t.every(function(n) {
      return wP(e, n, r);
    }) : e.selections.every(function(n) {
      if ($f(n) && jx(n, r)) {
        var i = gc(n);
        return ji.call(t, i) && (!n.selectionSet || wP(n.selectionSet, t[i], r));
      }
      return !0;
    }) : !1;
  }
  function Hv(e) {
    return Hn(e) && !Vr(e) && !Vn(e);
  }
  function hne() {
    return new zf();
  }
  function m9(e, t) {
    var r = B0($0(e));
    return {
      fragmentMap: r,
      lookupFragment: function(n) {
        var i = r[n];
        return !i && t && (i = t.lookup(n)), i || null;
      }
    };
  }
  var OE = /* @__PURE__ */ Object.create(null), zA = function() {
    return OE;
  }, DB = /* @__PURE__ */ Object.create(null), Kg = (
    /** @class */
    function() {
      function e(t, r) {
        var n = this;
        this.policies = t, this.group = r, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, u) {
          return u0(Vr(i) ? n.get(i.__ref, u) : i && i[u]);
        }, this.canRead = function(i) {
          return Vr(i) ? n.has(i.__ref) : typeof i == "object";
        }, this.toReference = function(i, u) {
          if (typeof i == "string")
            return Kv(i);
          if (Vr(i))
            return i;
          var s = n.policies.identify(i)[0];
          if (s) {
            var c = Kv(s);
            return u && n.merge(s, i), c;
          }
        };
      }
      return e.prototype.toObject = function() {
        return ye({}, this.data);
      }, e.prototype.has = function(t) {
        return this.lookup(t, !0) !== void 0;
      }, e.prototype.get = function(t, r) {
        if (this.group.depend(t, r), ji.call(this.data, t)) {
          var n = this.data[t];
          if (n && ji.call(n, r))
            return n[r];
        }
        if (r === "__typename" && ji.call(this.policies.rootTypenamesById, t))
          return this.policies.rootTypenamesById[t];
        if (this instanceof Df)
          return this.parent.get(t, r);
      }, e.prototype.lookup = function(t, r) {
        if (r && this.group.depend(t, "__exists"), ji.call(this.data, t))
          return this.data[t];
        if (this instanceof Df)
          return this.parent.lookup(t, r);
        if (this.policies.rootTypenamesById[t])
          return /* @__PURE__ */ Object.create(null);
      }, e.prototype.merge = function(t, r) {
        var n = this, i;
        Vr(t) && (t = t.__ref), Vr(r) && (r = r.__ref);
        var u = typeof t == "string" ? this.lookup(i = t) : t, s = typeof r == "string" ? this.lookup(i = r) : r;
        if (s) {
          st(typeof i == "string", 2);
          var c = new zf(mne).merge(u, s);
          if (this.data[i] = c, c !== u && (delete this.refs[i], this.group.caching)) {
            var p = /* @__PURE__ */ Object.create(null);
            u || (p.__exists = 1), Object.keys(s).forEach(function(h) {
              if (!u || u[h] !== c[h]) {
                p[h] = 1;
                var v = qf(h);
                v !== h && !n.policies.hasKeyArgs(c.__typename, v) && (p[v] = 1), c[h] === void 0 && !(n instanceof Df) && delete c[h];
              }
            }), p.__typename && !(u && u.__typename) && // Since we return default root __typename strings
            // automatically from store.get, we don't need to dirty the
            // ROOT_QUERY.__typename field if merged.__typename is equal
            // to the default string (usually "Query").
            this.policies.rootTypenamesById[i] === c.__typename && delete p.__typename, Object.keys(p).forEach(function(h) {
              return n.group.dirty(i, h);
            });
          }
        }
      }, e.prototype.modify = function(t, r) {
        var n = this, i = this.lookup(t);
        if (i) {
          var u = /* @__PURE__ */ Object.create(null), s = !1, c = !0, p = {
            DELETE: OE,
            INVALIDATE: DB,
            isReference: Vr,
            toReference: this.toReference,
            canRead: this.canRead,
            readField: function(h, v) {
              return n.policies.readField(typeof h == "string" ? {
                fieldName: h,
                from: v || Kv(t)
              } : h, { store: n });
            }
          };
          if (Object.keys(i).forEach(function(h) {
            var v = qf(h), y = i[h];
            if (y !== void 0) {
              var x = typeof r == "function" ? r : r[h] || r[v];
              if (x) {
                var w = x === zA ? OE : x(u0(y), ye(ye({}, p), { fieldName: v, storeFieldName: h, storage: n.getStorage(t, h) }));
                if (w === DB)
                  n.group.dirty(t, h);
                else if (w === OE && (w = void 0), w !== y && (u[h] = w, s = !0, y = w, globalThis.__DEV__ !== !1)) {
                  var E = function(T) {
                    if (n.lookup(T.__ref) === void 0)
                      return globalThis.__DEV__ !== !1 && st.warn(3, T), !0;
                  };
                  if (Vr(w))
                    E(w);
                  else if (Array.isArray(w))
                    for (var C = !1, S = void 0, k = 0, D = w; k < D.length; k++) {
                      var A = D[k];
                      if (Vr(A)) {
                        if (C = !0, E(A))
                          break;
                      } else if (typeof A == "object" && A) {
                        var R = n.policies.identify(A)[0];
                        R && (S = A);
                      }
                      if (C && S !== void 0) {
                        globalThis.__DEV__ !== !1 && st.warn(4, S);
                        break;
                      }
                    }
                }
              }
              y !== void 0 && (c = !1);
            }
          }), s)
            return this.merge(t, u), c && (this instanceof Df ? this.data[t] = void 0 : delete this.data[t], this.group.dirty(t, "__exists")), !0;
        }
        return !1;
      }, e.prototype.delete = function(t, r, n) {
        var i, u = this.lookup(t);
        if (u) {
          var s = this.getFieldValue(u, "__typename"), c = r && n ? this.policies.getStoreFieldName({ typename: s, fieldName: r, args: n }) : r;
          return this.modify(t, c ? (i = {}, i[c] = zA, i) : zA);
        }
        return !1;
      }, e.prototype.evict = function(t, r) {
        var n = !1;
        return t.id && (ji.call(this.data, t.id) && (n = this.delete(t.id, t.fieldName, t.args)), this instanceof Df && this !== r && (n = this.parent.evict(t, r) || n), (t.fieldName || n) && this.group.dirty(t.id, t.fieldName || "__exists")), n;
      }, e.prototype.clear = function() {
        this.replace(null);
      }, e.prototype.extract = function() {
        var t = this, r = this.toObject(), n = [];
        return this.getRootIdSet().forEach(function(i) {
          ji.call(t.policies.rootTypenamesById, i) || n.push(i);
        }), n.length && (r.__META = { extraRootIds: n.sort() }), r;
      }, e.prototype.replace = function(t) {
        var r = this;
        if (Object.keys(this.data).forEach(function(u) {
          t && ji.call(t, u) || r.delete(u);
        }), t) {
          var n = t.__META, i = ps(t, ["__META"]);
          Object.keys(i).forEach(function(u) {
            r.merge(u, i[u]);
          }), n && n.extraRootIds.forEach(this.retain, this);
        }
      }, e.prototype.retain = function(t) {
        return this.rootIds[t] = (this.rootIds[t] || 0) + 1;
      }, e.prototype.release = function(t) {
        if (this.rootIds[t] > 0) {
          var r = --this.rootIds[t];
          return r || delete this.rootIds[t], r;
        }
        return 0;
      }, e.prototype.getRootIdSet = function(t) {
        return t === void 0 && (t = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(t.add, t), this instanceof Df ? this.parent.getRootIdSet(t) : Object.keys(this.policies.rootTypenamesById).forEach(t.add, t), t;
      }, e.prototype.gc = function() {
        var t = this, r = this.getRootIdSet(), n = this.toObject();
        r.forEach(function(s) {
          ji.call(n, s) && (Object.keys(t.findChildRefIds(s)).forEach(r.add, r), delete n[s]);
        });
        var i = Object.keys(n);
        if (i.length) {
          for (var u = this; u instanceof Df; )
            u = u.parent;
          i.forEach(function(s) {
            return u.delete(s);
          });
        }
        return i;
      }, e.prototype.findChildRefIds = function(t) {
        if (!ji.call(this.refs, t)) {
          var r = this.refs[t] = /* @__PURE__ */ Object.create(null), n = this.data[t];
          if (!n)
            return r;
          var i = /* @__PURE__ */ new Set([n]);
          i.forEach(function(u) {
            Vr(u) && (r[u.__ref] = !0), Hn(u) && Object.keys(u).forEach(function(s) {
              var c = u[s];
              Hn(c) && i.add(c);
            });
          });
        }
        return this.refs[t];
      }, e.prototype.makeCacheKey = function() {
        return this.group.keyMaker.lookupArray(arguments);
      }, e;
    }()
  ), y9 = (
    /** @class */
    function() {
      function e(t, r) {
        r === void 0 && (r = null), this.caching = t, this.parent = r, this.d = null, this.resetCaching();
      }
      return e.prototype.resetCaching = function() {
        this.d = this.caching ? DU() : null, this.keyMaker = new Cc($p);
      }, e.prototype.depend = function(t, r) {
        if (this.d) {
          this.d(qA(t, r));
          var n = qf(r);
          n !== r && this.d(qA(t, n)), this.parent && this.parent.depend(t, r);
        }
      }, e.prototype.dirty = function(t, r) {
        this.d && this.d.dirty(
          qA(t, r),
          // When storeFieldName === "__exists", that means the entity identified
          // by dataId has either disappeared from the cache or was newly added,
          // so the result caching system would do well to "forget everything it
          // knows" about that object. To achieve that kind of invalidation, we
          // not only dirty the associated result cache entry, but also remove it
          // completely from the dependency graph. For the optimism implementation
          // details, see https://github.com/benjamn/optimism/pull/195.
          r === "__exists" ? "forget" : "setDirty"
        );
      }, e;
    }()
  );
  function qA(e, t) {
    return t + "#" + e;
  }
  function kB(e, t) {
    Ig(e) && e.group.depend(t, "__exists");
  }
  (function(e) {
    var t = (
      /** @class */
      function(r) {
        pl(n, r);
        function n(i) {
          var u = i.policies, s = i.resultCaching, c = s === void 0 ? !0 : s, p = i.seed, h = r.call(this, u, new y9(c)) || this;
          return h.stump = new vne(h), h.storageTrie = new Cc($p), p && h.replace(p), h;
        }
        return n.prototype.addLayer = function(i, u) {
          return this.stump.addLayer(i, u);
        }, n.prototype.removeLayer = function() {
          return this;
        }, n.prototype.getStorage = function() {
          return this.storageTrie.lookupArray(arguments);
        }, n;
      }(e)
    );
    e.Root = t;
  })(Kg || (Kg = {}));
  var Df = (
    /** @class */
    function(e) {
      pl(t, e);
      function t(r, n, i, u) {
        var s = e.call(this, n.policies, u) || this;
        return s.id = r, s.parent = n, s.replay = i, s.group = u, i(s), s;
      }
      return t.prototype.addLayer = function(r, n) {
        return new t(r, this, n, this.group);
      }, t.prototype.removeLayer = function(r) {
        var n = this, i = this.parent.removeLayer(r);
        return r === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(u) {
          var s = n.data[u], c = i.lookup(u);
          c ? s ? s !== c && Object.keys(s).forEach(function(p) {
            Xr(s[p], c[p]) || n.group.dirty(u, p);
          }) : (n.group.dirty(u, "__exists"), Object.keys(c).forEach(function(p) {
            n.group.dirty(u, p);
          })) : n.delete(u);
        }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
      }, t.prototype.toObject = function() {
        return ye(ye({}, this.parent.toObject()), this.data);
      }, t.prototype.findChildRefIds = function(r) {
        var n = this.parent.findChildRefIds(r);
        return ji.call(this.data, r) ? ye(ye({}, n), e.prototype.findChildRefIds.call(this, r)) : n;
      }, t.prototype.getStorage = function() {
        for (var r = this.parent; r.parent; )
          r = r.parent;
        return r.getStorage.apply(
          r,
          // @ts-expect-error
          arguments
        );
      }, t;
    }(Kg)
  ), vne = (
    /** @class */
    function(e) {
      pl(t, e);
      function t(r) {
        return e.call(this, "EntityStore.Stump", r, function() {
        }, new y9(r.group.caching, r.group)) || this;
      }
      return t.prototype.removeLayer = function() {
        return this;
      }, t.prototype.merge = function(r, n) {
        return this.parent.merge(r, n);
      }, t;
    }(Df)
  );
  function mne(e, t, r) {
    var n = e[r], i = t[r];
    return Xr(n, i) ? n : i;
  }
  function Ig(e) {
    return !!(e instanceof Kg && e.group.caching);
  }
  function yne(e) {
    return Hn(e) ? Vn(e) ? e.slice(0) : ye({ __proto__: Object.getPrototypeOf(e) }, e) : e;
  }
  var RB = (
    /** @class */
    function() {
      function e() {
        this.known = new (mN ? WeakSet : Set)(), this.pool = new Cc($p), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
      }
      return e.prototype.isKnown = function(t) {
        return Hn(t) && this.known.has(t);
      }, e.prototype.pass = function(t) {
        if (Hn(t)) {
          var r = yne(t);
          return this.passes.set(r, t), r;
        }
        return t;
      }, e.prototype.admit = function(t) {
        var r = this;
        if (Hn(t)) {
          var n = this.passes.get(t);
          if (n)
            return n;
          var i = Object.getPrototypeOf(t);
          switch (i) {
            case Array.prototype: {
              if (this.known.has(t))
                return t;
              var u = t.map(this.admit, this), s = this.pool.lookupArray(u);
              return s.array || (this.known.add(s.array = u), globalThis.__DEV__ !== !1 && Object.freeze(u)), s.array;
            }
            case null:
            case Object.prototype: {
              if (this.known.has(t))
                return t;
              var c = Object.getPrototypeOf(t), p = [c], h = this.sortedKeys(t);
              p.push(h.json);
              var v = p.length;
              h.sorted.forEach(function(w) {
                p.push(r.admit(t[w]));
              });
              var s = this.pool.lookupArray(p);
              if (!s.object) {
                var y = s.object = Object.create(c);
                this.known.add(y), h.sorted.forEach(function(w, E) {
                  y[w] = p[v + E];
                }), globalThis.__DEV__ !== !1 && Object.freeze(y);
              }
              return s.object;
            }
          }
        }
        return t;
      }, e.prototype.sortedKeys = function(t) {
        var r = Object.keys(t), n = this.pool.lookupArray(r);
        if (!n.keys) {
          r.sort();
          var i = JSON.stringify(r);
          (n.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, n.keys = { sorted: r, json: i });
        }
        return n.keys;
      }, e;
    }()
  );
  function PB(e) {
    return [
      e.selectionSet,
      e.objectOrReference,
      e.context,
      // We split out this property so we can pass different values
      // independently without modifying options.context itself.
      e.context.canonizeResults
    ];
  }
  var gne = (
    /** @class */
    function() {
      function e(t) {
        var r = this;
        this.knownResults = new ($p ? WeakMap : Map)(), this.config = Np(t, {
          addTypename: t.addTypename !== !1,
          canonizeResults: h9(t)
        }), this.canon = t.canon || new RB(), this.executeSelectionSet = Yg(function(n) {
          var i, u = n.context.canonizeResults, s = PB(n);
          s[3] = !u;
          var c = (i = r.executeSelectionSet).peek.apply(i, s);
          return c ? u ? ye(ye({}, c), {
            // If we previously read this result without canonizing it, we can
            // reuse that result simply by canonizing it now.
            result: r.canon.admit(c.result)
          }) : c : (kB(n.context.store, n.enclosingRef.__ref), r.execSelectionSetImpl(n));
        }, {
          max: this.config.resultCacheMaxSize || cl["inMemoryCache.executeSelectionSet"] || 5e4,
          keyArgs: PB,
          // Note that the parameters of makeCacheKey are determined by the
          // array returned by keyArgs.
          makeCacheKey: function(n, i, u, s) {
            if (Ig(u.store))
              return u.store.makeCacheKey(n, Vr(i) ? i.__ref : i, u.varString, s);
          }
        }), this.executeSubSelectedArray = Yg(function(n) {
          return kB(n.context.store, n.enclosingRef.__ref), r.execSubSelectedArrayImpl(n);
        }, {
          max: this.config.resultCacheMaxSize || cl["inMemoryCache.executeSubSelectedArray"] || 1e4,
          makeCacheKey: function(n) {
            var i = n.field, u = n.array, s = n.context;
            if (Ig(s.store))
              return s.store.makeCacheKey(i, u, s.varString);
          }
        });
      }
      return e.prototype.resetCanon = function() {
        this.canon = new RB();
      }, e.prototype.diffQueryAgainstStore = function(t) {
        var r = t.store, n = t.query, i = t.rootId, u = i === void 0 ? "ROOT_QUERY" : i, s = t.variables, c = t.returnPartialData, p = c === void 0 ? !0 : c, h = t.canonizeResults, v = h === void 0 ? this.config.canonizeResults : h, y = this.config.cache.policies;
        s = ye(ye({}, bN(WU(n))), s);
        var x = Kv(u), w = this.executeSelectionSet({
          selectionSet: Fx(n).selectionSet,
          objectOrReference: x,
          enclosingRef: x,
          context: ye({ store: r, query: n, policies: y, variables: s, varString: Ff(s), canonizeResults: v }, m9(n, this.config.fragments))
        }), E;
        if (w.missing && (E = [
          new f9(xne(w.missing), w.missing, n, s)
        ], !p))
          throw E[0];
        return {
          result: w.result,
          complete: !E,
          missing: E
        };
      }, e.prototype.isFresh = function(t, r, n, i) {
        if (Ig(i.store) && this.knownResults.get(t) === n) {
          var u = this.executeSelectionSet.peek(
            n,
            r,
            i,
            // If result is canonical, then it could only have been previously
            // cached by the canonizing version of executeSelectionSet, so we can
            // avoid checking both possibilities here.
            this.canon.isKnown(t)
          );
          if (u && t === u.result)
            return !0;
        }
        return !1;
      }, e.prototype.execSelectionSetImpl = function(t) {
        var r = this, n = t.selectionSet, i = t.objectOrReference, u = t.enclosingRef, s = t.context;
        if (Vr(i) && !s.policies.rootTypenamesById[i.__ref] && !s.store.has(i.__ref))
          return {
            result: this.canon.empty,
            missing: "Dangling reference to missing ".concat(i.__ref, " object")
          };
        var c = s.variables, p = s.policies, h = s.store, v = h.getFieldValue(i, "__typename"), y = [], x, w = new zf();
        this.config.addTypename && typeof v == "string" && !p.rootIdsByTypename[v] && y.push({ __typename: v });
        function E(A, R) {
          var T;
          return A.missing && (x = w.merge(x, (T = {}, T[R] = A.missing, T))), A.result;
        }
        var C = new Set(n.selections);
        C.forEach(function(A) {
          var R, T;
          if (jx(A, c))
            if ($f(A)) {
              var M = p.readField({
                fieldName: A.name.value,
                field: A,
                variables: s.variables,
                from: i
              }, s), F = gc(A);
              M === void 0 ? wN.added(A) || (x = w.merge(x, (R = {}, R[F] = "Can't find field '".concat(A.name.value, "' on ").concat(Vr(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), R))) : Vn(M) ? M.length > 0 && (M = E(r.executeSubSelectedArray({
                field: A,
                array: M,
                enclosingRef: u,
                context: s
              }), F)) : A.selectionSet ? M != null && (M = E(r.executeSelectionSet({
                selectionSet: A.selectionSet,
                objectOrReference: M,
                enclosingRef: Vr(M) ? M : u,
                context: s
              }), F)) : s.canonizeResults && (M = r.canon.pass(M)), M !== void 0 && y.push((T = {}, T[F] = M, T));
            } else {
              var B = A_(A, s.lookupFragment);
              if (!B && A.kind === at.FRAGMENT_SPREAD)
                throw Ya(10, A.name.value);
              B && p.fragmentMatches(B, v) && B.selectionSet.selections.forEach(C.add, C);
            }
        });
        var S = k_(y), k = { result: S, missing: x }, D = s.canonizeResults ? this.canon.admit(k) : u0(k);
        return D.result && this.knownResults.set(D.result, n), D;
      }, e.prototype.execSubSelectedArrayImpl = function(t) {
        var r = this, n = t.field, i = t.array, u = t.enclosingRef, s = t.context, c, p = new zf();
        function h(v, y) {
          var x;
          return v.missing && (c = p.merge(c, (x = {}, x[y] = v.missing, x))), v.result;
        }
        return n.selectionSet && (i = i.filter(s.store.canRead)), i = i.map(function(v, y) {
          return v === null ? null : Vn(v) ? h(r.executeSubSelectedArray({
            field: n,
            array: v,
            enclosingRef: u,
            context: s
          }), y) : n.selectionSet ? h(r.executeSelectionSet({
            selectionSet: n.selectionSet,
            objectOrReference: v,
            enclosingRef: Vr(v) ? v : u,
            context: s
          }), y) : (globalThis.__DEV__ !== !1 && bne(s.store, n, v), v);
        }), {
          result: s.canonizeResults ? this.canon.admit(i) : i,
          missing: c
        };
      }, e;
    }()
  );
  function xne(e) {
    try {
      JSON.stringify(e, function(t, r) {
        if (typeof r == "string")
          throw r;
        return r;
      });
    } catch (t) {
      return t;
    }
  }
  function bne(e, t, r) {
    if (!t.selectionSet) {
      var n = /* @__PURE__ */ new Set([r]);
      n.forEach(function(i) {
        Hn(i) && (st(
          !Vr(i),
          11,
          pne(e, i),
          t.name.value
        ), Object.values(i).forEach(n.add, n));
      });
    }
  }
  var TN = new Nx(), MB = /* @__PURE__ */ new WeakMap();
  function Bg(e) {
    var t = MB.get(e);
    return t || MB.set(e, t = {
      vars: /* @__PURE__ */ new Set(),
      dep: DU()
    }), t;
  }
  function NB(e) {
    Bg(e).vars.forEach(function(t) {
      return t.forgetCache(e);
    });
  }
  function wne(e) {
    Bg(e).vars.forEach(function(t) {
      return t.attachCache(e);
    });
  }
  function Ene(e) {
    var t = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), n = function(u) {
      if (arguments.length > 0) {
        if (e !== u) {
          e = u, t.forEach(function(p) {
            Bg(p).dep.dirty(n), Sne(p);
          });
          var s = Array.from(r);
          r.clear(), s.forEach(function(p) {
            return p(e);
          });
        }
      } else {
        var c = TN.getValue();
        c && (i(c), Bg(c).dep(n));
      }
      return e;
    };
    n.onNextChange = function(u) {
      return r.add(u), function() {
        r.delete(u);
      };
    };
    var i = n.attachCache = function(u) {
      return t.add(u), Bg(u).vars.add(n), n;
    };
    return n.forgetCache = function(u) {
      return t.delete(u);
    }, n;
  }
  function Sne(e) {
    e.broadcastWatches && e.broadcastWatches();
  }
  var jB = /* @__PURE__ */ Object.create(null);
  function AN(e) {
    var t = JSON.stringify(e);
    return jB[t] || (jB[t] = /* @__PURE__ */ Object.create(null));
  }
  function FB(e) {
    var t = AN(e);
    return t.keyFieldsFn || (t.keyFieldsFn = function(r, n) {
      var i = function(s, c) {
        return n.readField(c, s);
      }, u = n.keyObject = DN(e, function(s) {
        var c = Zv(
          n.storeObject,
          s,
          // Using context.readField to extract paths from context.storeObject
          // allows the extraction to see through Reference objects and respect
          // custom read functions.
          i
        );
        return c === void 0 && r !== n.storeObject && ji.call(r, s[0]) && (c = Zv(r, s, x9)), st(c !== void 0, 5, s.join("."), r), c;
      });
      return "".concat(n.typename, ":").concat(JSON.stringify(u));
    });
  }
  function IB(e) {
    var t = AN(e);
    return t.keyArgsFn || (t.keyArgsFn = function(r, n) {
      var i = n.field, u = n.variables, s = n.fieldName, c = DN(e, function(h) {
        var v = h[0], y = v.charAt(0);
        if (y === "@") {
          if (i && Cu(i.directives)) {
            var x = v.slice(1), w = i.directives.find(function(k) {
              return k.name.value === x;
            }), E = w && D_(w, u);
            return E && Zv(
              E,
              // If keyPath.length === 1, this code calls extractKeyPath with an
              // empty path, which works because it uses directiveArgs as the
              // extracted value.
              h.slice(1)
            );
          }
          return;
        }
        if (y === "$") {
          var C = v.slice(1);
          if (u && ji.call(u, C)) {
            var S = h.slice(0);
            return S[0] = C, Zv(u, S);
          }
          return;
        }
        if (r)
          return Zv(r, h);
      }), p = JSON.stringify(c);
      return (r || p !== "{}") && (s += ":" + p), s;
    });
  }
  function DN(e, t) {
    var r = new zf();
    return g9(e).reduce(function(n, i) {
      var u, s = t(i);
      if (s !== void 0) {
        for (var c = i.length - 1; c >= 0; --c)
          s = (u = {}, u[i[c]] = s, u);
        n = r.merge(n, s);
      }
      return n;
    }, /* @__PURE__ */ Object.create(null));
  }
  function g9(e) {
    var t = AN(e);
    if (!t.paths) {
      var r = t.paths = [], n = [];
      e.forEach(function(i, u) {
        Vn(i) ? (g9(i).forEach(function(s) {
          return r.push(n.concat(s));
        }), n.length = 0) : (n.push(i), Vn(e[u + 1]) || (r.push(n.slice(0)), n.length = 0));
      });
    }
    return t.paths;
  }
  function x9(e, t) {
    return e[t];
  }
  function Zv(e, t, r) {
    return r = r || x9, b9(t.reduce(function n(i, u) {
      return Vn(i) ? i.map(function(s) {
        return n(s, u);
      }) : i && r(i, u);
    }, e));
  }
  function b9(e) {
    return Hn(e) ? Vn(e) ? e.map(b9) : DN(Object.keys(e).sort(), function(t) {
      return Zv(e, t);
    }) : e;
  }
  function EP(e) {
    return e.args !== void 0 ? e.args : e.field ? D_(e.field, e.variables) : null;
  }
  var _ne = function() {
  }, BB = function(e, t) {
    return t.fieldName;
  }, LB = function(e, t, r) {
    var n = r.mergeObjects;
    return n(e, t);
  }, $B = function(e, t) {
    return t;
  }, Cne = (
    /** @class */
    function() {
      function e(t) {
        this.config = t, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = ye({ dataIdFromObject: d9 }, t), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), t.possibleTypes && this.addPossibleTypes(t.possibleTypes), t.typePolicies && this.addTypePolicies(t.typePolicies);
      }
      return e.prototype.identify = function(t, r) {
        var n, i = this, u = r && (r.typename || ((n = r.storeObject) === null || n === void 0 ? void 0 : n.__typename)) || t.__typename;
        if (u === this.rootTypenamesById.ROOT_QUERY)
          return ["ROOT_QUERY"];
        var s = r && r.storeObject || t, c = ye(ye({}, r), { typename: u, storeObject: s, readField: r && r.readField || function() {
          var y = kN(arguments, s);
          return i.readField(y, {
            store: i.cache.data,
            variables: y.variables
          });
        } }), p, h = u && this.getTypePolicy(u), v = h && h.keyFn || this.config.dataIdFromObject;
        return ON.withValue(!0, function() {
          for (; v; ) {
            var y = v(ye(ye({}, t), s), c);
            if (Vn(y))
              v = FB(y);
            else {
              p = y;
              break;
            }
          }
        }), p = p ? String(p) : void 0, c.keyObject ? [p, c.keyObject] : [p];
      }, e.prototype.addTypePolicies = function(t) {
        var r = this;
        Object.keys(t).forEach(function(n) {
          var i = t[n], u = i.queryType, s = i.mutationType, c = i.subscriptionType, p = ps(i, ["queryType", "mutationType", "subscriptionType"]);
          u && r.setRootTypename("Query", n), s && r.setRootTypename("Mutation", n), c && r.setRootTypename("Subscription", n), ji.call(r.toBeAdded, n) ? r.toBeAdded[n].push(p) : r.toBeAdded[n] = [p];
        });
      }, e.prototype.updateTypePolicy = function(t, r) {
        var n = this, i = this.getTypePolicy(t), u = r.keyFields, s = r.fields;
        function c(p, h) {
          p.merge = typeof h == "function" ? h : h === !0 ? LB : h === !1 ? $B : p.merge;
        }
        c(i, r.merge), i.keyFn = // Pass false to disable normalization for this typename.
        u === !1 ? _ne : Vn(u) ? FB(u) : typeof u == "function" ? u : i.keyFn, s && Object.keys(s).forEach(function(p) {
          var h = n.getFieldPolicy(t, p, !0), v = s[p];
          if (typeof v == "function")
            h.read = v;
          else {
            var y = v.keyArgs, x = v.read, w = v.merge;
            h.keyFn = // Pass false to disable argument-based differentiation of
            // field identities.
            y === !1 ? BB : Vn(y) ? IB(y) : typeof y == "function" ? y : h.keyFn, typeof x == "function" && (h.read = x), c(h, w);
          }
          h.read && h.merge && (h.keyFn = h.keyFn || BB);
        });
      }, e.prototype.setRootTypename = function(t, r) {
        r === void 0 && (r = t);
        var n = "ROOT_" + t.toUpperCase(), i = this.rootTypenamesById[n];
        r !== i && (st(!i || i === t, 6, t), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[r] = n, this.rootTypenamesById[n] = r);
      }, e.prototype.addPossibleTypes = function(t) {
        var r = this;
        this.usingPossibleTypes = !0, Object.keys(t).forEach(function(n) {
          r.getSupertypeSet(n, !0), t[n].forEach(function(i) {
            r.getSupertypeSet(i, !0).add(n);
            var u = i.match(v9);
            (!u || u[0] !== i) && r.fuzzySubtypes.set(i, new RegExp(i));
          });
        });
      }, e.prototype.getTypePolicy = function(t) {
        var r = this;
        if (!ji.call(this.typePolicies, t)) {
          var n = this.typePolicies[t] = /* @__PURE__ */ Object.create(null);
          n.fields = /* @__PURE__ */ Object.create(null);
          var i = this.supertypeMap.get(t);
          !i && this.fuzzySubtypes.size && (i = this.getSupertypeSet(t, !0), this.fuzzySubtypes.forEach(function(s, c) {
            if (s.test(t)) {
              var p = r.supertypeMap.get(c);
              p && p.forEach(function(h) {
                return i.add(h);
              });
            }
          })), i && i.size && i.forEach(function(s) {
            var c = r.getTypePolicy(s), p = c.fields, h = ps(c, ["fields"]);
            Object.assign(n, h), Object.assign(n.fields, p);
          });
        }
        var u = this.toBeAdded[t];
        return u && u.length && u.splice(0).forEach(function(s) {
          r.updateTypePolicy(t, s);
        }), this.typePolicies[t];
      }, e.prototype.getFieldPolicy = function(t, r, n) {
        if (t) {
          var i = this.getTypePolicy(t).fields;
          return i[r] || n && (i[r] = /* @__PURE__ */ Object.create(null));
        }
      }, e.prototype.getSupertypeSet = function(t, r) {
        var n = this.supertypeMap.get(t);
        return !n && r && this.supertypeMap.set(t, n = /* @__PURE__ */ new Set()), n;
      }, e.prototype.fragmentMatches = function(t, r, n, i) {
        var u = this;
        if (!t.typeCondition)
          return !0;
        if (!r)
          return !1;
        var s = t.typeCondition.name.value;
        if (r === s)
          return !0;
        if (this.usingPossibleTypes && this.supertypeMap.has(s))
          for (var c = this.getSupertypeSet(r, !0), p = [c], h = function(E) {
            var C = u.getSupertypeSet(E, !1);
            C && C.size && p.indexOf(C) < 0 && p.push(C);
          }, v = !!(n && this.fuzzySubtypes.size), y = !1, x = 0; x < p.length; ++x) {
            var w = p[x];
            if (w.has(s))
              return c.has(s) || (y && globalThis.__DEV__ !== !1 && st.warn(7, r, s), c.add(s)), !0;
            w.forEach(h), v && // Start checking fuzzy subtypes only after exhausting all
            // non-fuzzy subtypes (after the final iteration of the loop).
            x === p.length - 1 && // We could wait to compare fragment.selectionSet to result
            // after we verify the supertype, but this check is often less
            // expensive than that search, and we will have to do the
            // comparison anyway whenever we find a potential match.
            wP(t.selectionSet, n, i) && (v = !1, y = !0, this.fuzzySubtypes.forEach(function(E, C) {
              var S = r.match(E);
              S && S[0] === r && h(C);
            }));
          }
        return !1;
      }, e.prototype.hasKeyArgs = function(t, r) {
        var n = this.getFieldPolicy(t, r, !1);
        return !!(n && n.keyFn);
      }, e.prototype.getStoreFieldName = function(t) {
        var r = t.typename, n = t.fieldName, i = this.getFieldPolicy(r, n, !1), u, s = i && i.keyFn;
        if (s && r)
          for (var c = {
            typename: r,
            fieldName: n,
            field: t.field || null,
            variables: t.variables
          }, p = EP(t); s; ) {
            var h = s(p, c);
            if (Vn(h))
              s = IB(h);
            else {
              u = h || n;
              break;
            }
          }
        return u === void 0 && (u = t.field ? Mre(t.field, t.variables) : VU(n, EP(t))), u === !1 ? n : n === qf(u) ? u : n + ":" + u;
      }, e.prototype.readField = function(t, r) {
        var n = t.from;
        if (n) {
          var i = t.field || t.fieldName;
          if (i) {
            if (t.typename === void 0) {
              var u = r.store.getFieldValue(n, "__typename");
              u && (t.typename = u);
            }
            var s = this.getStoreFieldName(t), c = qf(s), p = r.store.getFieldValue(n, s), h = this.getFieldPolicy(t.typename, c, !1), v = h && h.read;
            if (v) {
              var y = zB(this, n, t, r, r.store.getStorage(Vr(n) ? n.__ref : n, s));
              return TN.withValue(this.cache, v, [
                p,
                y
              ]);
            }
            return p;
          }
        }
      }, e.prototype.getReadFunction = function(t, r) {
        var n = this.getFieldPolicy(t, r, !1);
        return n && n.read;
      }, e.prototype.getMergeFunction = function(t, r, n) {
        var i = this.getFieldPolicy(t, r, !1), u = i && i.merge;
        return !u && n && (i = this.getTypePolicy(n), u = i && i.merge), u;
      }, e.prototype.runMergeFunction = function(t, r, n, i, u) {
        var s = n.field, c = n.typename, p = n.merge;
        return p === LB ? w9(i.store)(t, r) : p === $B ? r : (i.overwrite && (t = void 0), p(t, r, zB(
          this,
          // Unlike options.readField for read functions, we do not fall
          // back to the current object if no foreignObjOrRef is provided,
          // because it's not clear what the current object should be for
          // merge functions: the (possibly undefined) existing object, or
          // the incoming object? If you think your merge function needs
          // to read sibling fields in order to produce a new value for
          // the current field, you might want to rethink your strategy,
          // because that's a recipe for making merge behavior sensitive
          // to the order in which fields are written into the cache.
          // However, readField(name, ref) is useful for merge functions
          // that need to deduplicate child objects and references.
          void 0,
          {
            typename: c,
            fieldName: s.name.value,
            field: s,
            variables: i.variables
          },
          i,
          u || /* @__PURE__ */ Object.create(null)
        )));
      }, e;
    }()
  );
  function zB(e, t, r, n, i) {
    var u = e.getStoreFieldName(r), s = qf(u), c = r.variables || n.variables, p = n.store, h = p.toReference, v = p.canRead;
    return {
      args: EP(r),
      field: r.field || null,
      fieldName: s,
      storeFieldName: u,
      variables: c,
      isReference: Vr,
      toReference: h,
      storage: i,
      cache: e.cache,
      canRead: v,
      readField: function() {
        return e.readField(kN(arguments, t, c), n);
      },
      mergeObjects: w9(n.store)
    };
  }
  function kN(e, t, r) {
    var n = e[0], i = e[1], u = e.length, s;
    return typeof n == "string" ? s = {
      fieldName: n,
      // Default to objectOrReference only when no second argument was
      // passed for the from parameter, not when undefined is explicitly
      // passed as the second argument.
      from: u > 1 ? i : t
    } : (s = ye({}, n), ji.call(s, "from") || (s.from = t)), globalThis.__DEV__ !== !1 && s.from === void 0 && globalThis.__DEV__ !== !1 && st.warn(8, yU(Array.from(e))), s.variables === void 0 && (s.variables = r), s;
  }
  function w9(e) {
    return function(r, n) {
      if (Vn(r) || Vn(n))
        throw Ya(9);
      if (Hn(r) && Hn(n)) {
        var i = e.getFieldValue(r, "__typename"), u = e.getFieldValue(n, "__typename"), s = i && u && i !== u;
        if (s)
          return n;
        if (Vr(r) && Hv(n))
          return e.merge(r.__ref, n), r;
        if (Hv(r) && Vr(n))
          return e.merge(r, n.__ref), n;
        if (Hv(r) && Hv(n))
          return ye(ye({}, r), n);
      }
      return n;
    };
  }
  function UA(e, t, r) {
    var n = "".concat(t).concat(r), i = e.flavors.get(n);
    return i || e.flavors.set(n, i = e.clientOnly === t && e.deferred === r ? e : ye(ye({}, e), { clientOnly: t, deferred: r })), i;
  }
  var One = (
    /** @class */
    function() {
      function e(t, r, n) {
        this.cache = t, this.reader = r, this.fragments = n;
      }
      return e.prototype.writeToStore = function(t, r) {
        var n = this, i = r.query, u = r.result, s = r.dataId, c = r.variables, p = r.overwrite, h = Mp(i), v = hne();
        c = ye(ye({}, bN(h)), c);
        var y = ye(ye({ store: t, written: /* @__PURE__ */ Object.create(null), merge: function(w, E) {
          return v.merge(w, E);
        }, variables: c, varString: Ff(c) }, m9(i, this.fragments)), { overwrite: !!p, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), x = this.processSelectionSet({
          result: u || /* @__PURE__ */ Object.create(null),
          dataId: s,
          selectionSet: h.selectionSet,
          mergeTree: { map: /* @__PURE__ */ new Map() },
          context: y
        });
        if (!Vr(x))
          throw Ya(12, u);
        return y.incomingById.forEach(function(w, E) {
          var C = w.storeObject, S = w.mergeTree, k = w.fieldNodeSet, D = Kv(E);
          if (S && S.map.size) {
            var A = n.applyMerges(S, D, C, y);
            if (Vr(A))
              return;
            C = A;
          }
          if (globalThis.__DEV__ !== !1 && !y.overwrite) {
            var R = /* @__PURE__ */ Object.create(null);
            k.forEach(function(F) {
              F.selectionSet && (R[F.name.value] = !0);
            });
            var T = function(F) {
              return R[qf(F)] === !0;
            }, M = function(F) {
              var B = S && S.map.get(F);
              return !!(B && B.info && B.info.merge);
            };
            Object.keys(C).forEach(function(F) {
              T(F) && !M(F) && Tne(D, C, F, y.store);
            });
          }
          t.merge(E, C);
        }), t.retain(x.__ref), x;
      }, e.prototype.processSelectionSet = function(t) {
        var r = this, n = t.dataId, i = t.result, u = t.selectionSet, s = t.context, c = t.mergeTree, p = this.cache.policies, h = /* @__PURE__ */ Object.create(null), v = n && p.rootTypenamesById[n] || hP(i, u, s.fragmentMap) || n && s.store.get(n, "__typename");
        typeof v == "string" && (h.__typename = v);
        var y = function() {
          var A = kN(arguments, h, s.variables);
          if (Vr(A.from)) {
            var R = s.incomingById.get(A.from.__ref);
            if (R) {
              var T = p.readField(ye(ye({}, A), { from: R.storeObject }), s);
              if (T !== void 0)
                return T;
            }
          }
          return p.readField(A, s);
        }, x = /* @__PURE__ */ new Set();
        this.flattenFields(
          u,
          i,
          // This WriteContext will be the default context value for fields returned
          // by the flattenFields method, but some fields may be assigned a modified
          // context, depending on the presence of @client and other directives.
          s,
          v
        ).forEach(function(A, R) {
          var T, M = gc(R), F = i[M];
          if (x.add(R), F !== void 0) {
            var B = p.getStoreFieldName({
              typename: v,
              fieldName: R.name.value,
              field: R,
              variables: A.variables
            }), V = qB(c, B), H = r.processFieldValue(
              F,
              R,
              // Reset context.clientOnly and context.deferred to their default
              // values before processing nested selection sets.
              R.selectionSet ? UA(A, !1, !1) : A,
              V
            ), q = void 0;
            R.selectionSet && (Vr(H) || Hv(H)) && (q = y("__typename", H));
            var Q = p.getMergeFunction(v, R.name.value, q);
            Q ? V.info = {
              // TODO Check compatibility against any existing childTree.field?
              field: R,
              typename: v,
              merge: Q
            } : UB(c, B), h = A.merge(h, (T = {}, T[B] = H, T));
          } else globalThis.__DEV__ !== !1 && !A.clientOnly && !A.deferred && !wN.added(R) && // If the field has a read function, it may be a synthetic field or
          // provide a default value, so its absence from the written data should
          // not be cause for alarm.
          !p.getReadFunction(v, R.name.value) && globalThis.__DEV__ !== !1 && st.error(13, gc(R), i);
        });
        try {
          var w = p.identify(i, {
            typename: v,
            selectionSet: u,
            fragmentMap: s.fragmentMap,
            storeObject: h,
            readField: y
          }), E = w[0], C = w[1];
          n = n || E, C && (h = s.merge(h, C));
        } catch (A) {
          if (!n)
            throw A;
        }
        if (typeof n == "string") {
          var S = Kv(n), k = s.written[n] || (s.written[n] = []);
          if (k.indexOf(u) >= 0 || (k.push(u), this.reader && this.reader.isFresh(i, S, u, s)))
            return S;
          var D = s.incomingById.get(n);
          return D ? (D.storeObject = s.merge(D.storeObject, h), D.mergeTree = SP(D.mergeTree, c), x.forEach(function(A) {
            return D.fieldNodeSet.add(A);
          })) : s.incomingById.set(n, {
            storeObject: h,
            // Save a reference to mergeTree only if it is not empty, because
            // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
            // reused for entirely different parts of the result tree.
            mergeTree: vS(c) ? void 0 : c,
            fieldNodeSet: x
          }), S;
        }
        return h;
      }, e.prototype.processFieldValue = function(t, r, n, i) {
        var u = this;
        return !r.selectionSet || t === null ? globalThis.__DEV__ !== !1 ? t9(t) : t : Vn(t) ? t.map(function(s, c) {
          var p = u.processFieldValue(s, r, n, qB(i, c));
          return UB(i, c), p;
        }) : this.processSelectionSet({
          result: t,
          selectionSet: r.selectionSet,
          context: n,
          mergeTree: i
        });
      }, e.prototype.flattenFields = function(t, r, n, i) {
        i === void 0 && (i = hP(r, t, n.fragmentMap));
        var u = /* @__PURE__ */ new Map(), s = this.cache.policies, c = new Cc(!1);
        return function p(h, v) {
          var y = c.lookup(
            h,
            // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            v.clientOnly,
            v.deferred
          );
          y.visited || (y.visited = !0, h.selections.forEach(function(x) {
            if (jx(x, n.variables)) {
              var w = v.clientOnly, E = v.deferred;
              if (
                // Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(w && E) && Cu(x.directives) && x.directives.forEach(function(k) {
                  var D = k.name.value;
                  if (D === "client" && (w = !0), D === "defer") {
                    var A = D_(k, n.variables);
                    (!A || A.if !== !1) && (E = !0);
                  }
                }), $f(x)
              ) {
                var C = u.get(x);
                C && (w = w && C.clientOnly, E = E && C.deferred), u.set(x, UA(n, w, E));
              } else {
                var S = A_(x, n.lookupFragment);
                if (!S && x.kind === at.FRAGMENT_SPREAD)
                  throw Ya(14, x.name.value);
                S && s.fragmentMatches(S, i, r, n.variables) && p(S.selectionSet, UA(n, w, E));
              }
            }
          }));
        }(t, n), u;
      }, e.prototype.applyMerges = function(t, r, n, i, u) {
        var s, c = this;
        if (t.map.size && !Vr(n)) {
          var p = (
            // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            !Vn(n) && // Likewise, existing must be either a Reference or a StoreObject
            // in order for its fields to be safe to merge with the fields of
            // the incoming object.
            (Vr(r) || Hv(r)) ? r : void 0
          ), h = n;
          p && !u && (u = [Vr(p) ? p.__ref : p]);
          var v, y = function(x, w) {
            return Vn(x) ? typeof w == "number" ? x[w] : void 0 : i.store.getFieldValue(x, String(w));
          };
          t.map.forEach(function(x, w) {
            var E = y(p, w), C = y(h, w);
            if (C !== void 0) {
              u && u.push(w);
              var S = c.applyMerges(x, E, C, i, u);
              S !== C && (v = v || /* @__PURE__ */ new Map(), v.set(w, S)), u && st(u.pop() === w);
            }
          }), v && (n = Vn(h) ? h.slice(0) : ye({}, h), v.forEach(function(x, w) {
            n[w] = x;
          }));
        }
        return t.info ? this.cache.policies.runMergeFunction(r, n, t.info, i, u && (s = i.store).getStorage.apply(s, u)) : n;
      }, e;
    }()
  ), E9 = [];
  function qB(e, t) {
    var r = e.map;
    return r.has(t) || r.set(t, E9.pop() || { map: /* @__PURE__ */ new Map() }), r.get(t);
  }
  function SP(e, t) {
    if (e === t || !t || vS(t))
      return e;
    if (!e || vS(e))
      return t;
    var r = e.info && t.info ? ye(ye({}, e.info), t.info) : e.info || t.info, n = e.map.size && t.map.size, i = n ? /* @__PURE__ */ new Map() : e.map.size ? e.map : t.map, u = { info: r, map: i };
    if (n) {
      var s = new Set(t.map.keys());
      e.map.forEach(function(c, p) {
        u.map.set(p, SP(c, t.map.get(p))), s.delete(p);
      }), s.forEach(function(c) {
        u.map.set(c, SP(t.map.get(c), e.map.get(c)));
      });
    }
    return u;
  }
  function vS(e) {
    return !e || !(e.info || e.map.size);
  }
  function UB(e, t) {
    var r = e.map, n = r.get(t);
    n && vS(n) && (E9.push(n), r.delete(t));
  }
  var HB = /* @__PURE__ */ new Set();
  function Tne(e, t, r, n) {
    var i = function(y) {
      var x = n.getFieldValue(y, r);
      return typeof x == "object" && x;
    }, u = i(e);
    if (u) {
      var s = i(t);
      if (s && !Vr(u) && !Xr(u, s) && !Object.keys(u).every(function(y) {
        return n.getFieldValue(s, y) !== void 0;
      })) {
        var c = n.getFieldValue(e, "__typename") || n.getFieldValue(t, "__typename"), p = qf(r), h = "".concat(c, ".").concat(p);
        if (!HB.has(h)) {
          HB.add(h);
          var v = [];
          !Vn(u) && !Vn(s) && [u, s].forEach(function(y) {
            var x = n.getFieldValue(y, "__typename");
            typeof x == "string" && !v.includes(x) && v.push(x);
          }), globalThis.__DEV__ !== !1 && st.warn(15, p, c, v.length ? "either ensure all objects of type " + v.join(" and ") + " have an ID or a custom merge function, or " : "", h, ye({}, u), ye({}, s));
        }
      }
    }
  }
  var S9 = (
    /** @class */
    function(e) {
      pl(t, e);
      function t(r) {
        r === void 0 && (r = {});
        var n = e.call(this) || this;
        return n.watches = /* @__PURE__ */ new Set(), n.addTypenameTransform = new GU(wN), n.assumeImmutableResults = !0, n.makeVar = Ene, n.txCount = 0, n.config = dne(r), n.addTypename = !!n.config.addTypename, n.policies = new Cne({
          cache: n,
          dataIdFromObject: n.config.dataIdFromObject,
          possibleTypes: n.config.possibleTypes,
          typePolicies: n.config.typePolicies
        }), n.init(), n;
      }
      return t.prototype.init = function() {
        var r = this.data = new Kg.Root({
          policies: this.policies,
          resultCaching: this.config.resultCaching
        });
        this.optimisticData = r.stump, this.resetResultCache();
      }, t.prototype.resetResultCache = function(r) {
        var n = this, i = this.storeReader, u = this.config.fragments;
        this.storeWriter = new One(this, this.storeReader = new gne({
          cache: this,
          addTypename: this.addTypename,
          resultCacheMaxSize: this.config.resultCacheMaxSize,
          canonizeResults: h9(this.config),
          canon: r ? void 0 : i && i.canon,
          fragments: u
        }), u), this.maybeBroadcastWatch = Yg(function(s, c) {
          return n.broadcastWatch(s, c);
        }, {
          max: this.config.resultCacheMaxSize || cl["inMemoryCache.maybeBroadcastWatch"] || 5e3,
          makeCacheKey: function(s) {
            var c = s.optimistic ? n.optimisticData : n.data;
            if (Ig(c)) {
              var p = s.optimistic, h = s.id, v = s.variables;
              return c.makeCacheKey(
                s.query,
                // Different watches can have the same query, optimistic
                // status, rootId, and variables, but if their callbacks are
                // different, the (identical) result needs to be delivered to
                // each distinct callback. The easiest way to achieve that
                // separation is to include c.callback in the cache key for
                // maybeBroadcastWatch calls. See issue #5733.
                s.callback,
                Ff({ optimistic: p, id: h, variables: v })
              );
            }
          }
        }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(s) {
          return s.resetCaching();
        });
      }, t.prototype.restore = function(r) {
        return this.init(), r && this.data.replace(r), this;
      }, t.prototype.extract = function(r) {
        return r === void 0 && (r = !1), (r ? this.optimisticData : this.data).extract();
      }, t.prototype.read = function(r) {
        var n = r.returnPartialData, i = n === void 0 ? !1 : n;
        try {
          return this.storeReader.diffQueryAgainstStore(ye(ye({}, r), { store: r.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
        } catch (u) {
          if (u instanceof f9)
            return null;
          throw u;
        }
      }, t.prototype.write = function(r) {
        try {
          return ++this.txCount, this.storeWriter.writeToStore(this.data, r);
        } finally {
          !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
        }
      }, t.prototype.modify = function(r) {
        if (ji.call(r, "id") && !r.id)
          return !1;
        var n = r.optimistic ? this.optimisticData : this.data;
        try {
          return ++this.txCount, n.modify(r.id || "ROOT_QUERY", r.fields);
        } finally {
          !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
        }
      }, t.prototype.diff = function(r) {
        return this.storeReader.diffQueryAgainstStore(ye(ye({}, r), { store: r.optimistic ? this.optimisticData : this.data, rootId: r.id || "ROOT_QUERY", config: this.config }));
      }, t.prototype.watch = function(r) {
        var n = this;
        return this.watches.size || wne(this), this.watches.add(r), r.immediate && this.maybeBroadcastWatch(r), function() {
          n.watches.delete(r) && !n.watches.size && NB(n), n.maybeBroadcastWatch.forget(r);
        };
      }, t.prototype.gc = function(r) {
        var n;
        Ff.reset(), _p.reset(), this.addTypenameTransform.resetCache(), (n = this.config.fragments) === null || n === void 0 || n.resetCaches();
        var i = this.optimisticData.gc();
        return r && !this.txCount && (r.resetResultCache ? this.resetResultCache(r.resetResultIdentities) : r.resetResultIdentities && this.storeReader.resetCanon()), i;
      }, t.prototype.retain = function(r, n) {
        return (n ? this.optimisticData : this.data).retain(r);
      }, t.prototype.release = function(r, n) {
        return (n ? this.optimisticData : this.data).release(r);
      }, t.prototype.identify = function(r) {
        if (Vr(r))
          return r.__ref;
        try {
          return this.policies.identify(r)[0];
        } catch (n) {
          globalThis.__DEV__ !== !1 && st.warn(n);
        }
      }, t.prototype.evict = function(r) {
        if (!r.id) {
          if (ji.call(r, "id"))
            return !1;
          r = ye(ye({}, r), { id: "ROOT_QUERY" });
        }
        try {
          return ++this.txCount, this.optimisticData.evict(r, this.data);
        } finally {
          !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
        }
      }, t.prototype.reset = function(r) {
        var n = this;
        return this.init(), Ff.reset(), r && r.discardWatches ? (this.watches.forEach(function(i) {
          return n.maybeBroadcastWatch.forget(i);
        }), this.watches.clear(), NB(this)) : this.broadcastWatches(), Promise.resolve();
      }, t.prototype.removeOptimistic = function(r) {
        var n = this.optimisticData.removeLayer(r);
        n !== this.optimisticData && (this.optimisticData = n, this.broadcastWatches());
      }, t.prototype.batch = function(r) {
        var n = this, i = r.update, u = r.optimistic, s = u === void 0 ? !0 : u, c = r.removeOptimistic, p = r.onWatchUpdated, h, v = function(x) {
          var w = n, E = w.data, C = w.optimisticData;
          ++n.txCount, x && (n.data = n.optimisticData = x);
          try {
            return h = i(n);
          } finally {
            --n.txCount, n.data = E, n.optimisticData = C;
          }
        }, y = /* @__PURE__ */ new Set();
        return p && !this.txCount && this.broadcastWatches(ye(ye({}, r), { onWatchUpdated: function(x) {
          return y.add(x), !1;
        } })), typeof s == "string" ? this.optimisticData = this.optimisticData.addLayer(s, v) : s === !1 ? v(this.data) : v(), typeof c == "string" && (this.optimisticData = this.optimisticData.removeLayer(c)), p && y.size ? (this.broadcastWatches(ye(ye({}, r), { onWatchUpdated: function(x, w) {
          var E = p.call(this, x, w);
          return E !== !1 && y.delete(x), E;
        } })), y.size && y.forEach(function(x) {
          return n.maybeBroadcastWatch.dirty(x);
        })) : this.broadcastWatches(r), h;
      }, t.prototype.performTransaction = function(r, n) {
        return this.batch({
          update: r,
          optimistic: n || n !== null
        });
      }, t.prototype.transformDocument = function(r) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(r));
      }, t.prototype.fragmentMatches = function(r, n) {
        return this.policies.fragmentMatches(r, n);
      }, t.prototype.lookupFragment = function(r) {
        var n;
        return ((n = this.config.fragments) === null || n === void 0 ? void 0 : n.lookup(r)) || null;
      }, t.prototype.broadcastWatches = function(r) {
        var n = this;
        this.txCount || this.watches.forEach(function(i) {
          return n.maybeBroadcastWatch(i, r);
        });
      }, t.prototype.addFragmentsToDocument = function(r) {
        var n = this.config.fragments;
        return n ? n.transform(r) : r;
      }, t.prototype.addTypenameToDocument = function(r) {
        return this.addTypename ? this.addTypenameTransform.transformDocument(r) : r;
      }, t.prototype.broadcastWatch = function(r, n) {
        var i = r.lastDiff, u = this.diff(r);
        n && (r.optimistic && typeof n.optimistic == "string" && (u.fromOptimisticTransaction = !0), n.onWatchUpdated && n.onWatchUpdated.call(this, r, u, i) === !1) || (!i || !Xr(i.result, u.result)) && r.callback(r.lastDiff = u, i);
      }, t;
    }(c9)
  );
  globalThis.__DEV__ !== !1 && (S9.prototype.getMemoryInternals = vre);
  function HA(e) {
    return new pn(function(t) {
      t.error(e);
    });
  }
  var _9 = function(e, t, r) {
    var n = new Error(r);
    throw n.name = "ServerError", n.response = e, n.statusCode = e.status, n.result = t, n;
  };
  function Ane(e) {
    for (var t = [
      "query",
      "operationName",
      "variables",
      "extensions",
      "context"
    ], r = 0, n = Object.keys(e); r < n.length; r++) {
      var i = n[r];
      if (t.indexOf(i) < 0)
        throw Ya(46, i);
    }
    return e;
  }
  function Dne(e, t) {
    var r = ye({}, e), n = function(u) {
      typeof u == "function" ? r = ye(ye({}, r), u(r)) : r = ye(ye({}, r), u);
    }, i = function() {
      return ye({}, r);
    };
    return Object.defineProperty(t, "setContext", {
      enumerable: !1,
      value: n
    }), Object.defineProperty(t, "getContext", {
      enumerable: !1,
      value: i
    }), t;
  }
  function kne(e) {
    var t = {
      variables: e.variables || {},
      extensions: e.extensions || {},
      operationName: e.operationName,
      query: e.query
    };
    return t.operationName || (t.operationName = typeof t.query != "string" ? kg(t.query) || void 0 : ""), t;
  }
  function Rne(e, t) {
    var r = ye({}, e), n = new Set(Object.keys(e));
    return hs(t, {
      Variable: function(i, u, s) {
        s && s.kind !== "VariableDefinition" && n.delete(i.name.value);
      }
    }), n.forEach(function(i) {
      delete r[i];
    }), r;
  }
  function VB(e, t) {
    return t ? t(e) : pn.of();
  }
  function hg(e) {
    return typeof e == "function" ? new Ix(e) : e;
  }
  function Jw(e) {
    return e.request.length <= 1;
  }
  var Ix = (
    /** @class */
    function() {
      function e(t) {
        t && (this.request = t);
      }
      return e.empty = function() {
        return new e(function() {
          return pn.of();
        });
      }, e.from = function(t) {
        return t.length === 0 ? e.empty() : t.map(hg).reduce(function(r, n) {
          return r.concat(n);
        });
      }, e.split = function(t, r, n) {
        var i = hg(r), u = hg(n || new e(VB)), s;
        return Jw(i) && Jw(u) ? s = new e(function(c) {
          return t(c) ? i.request(c) || pn.of() : u.request(c) || pn.of();
        }) : s = new e(function(c, p) {
          return t(c) ? i.request(c, p) || pn.of() : u.request(c, p) || pn.of();
        }), Object.assign(s, { left: i, right: u });
      }, e.execute = function(t, r) {
        return t.request(Dne(r.context, kne(Ane(r)))) || pn.of();
      }, e.concat = function(t, r) {
        var n = hg(t);
        if (Jw(n))
          return globalThis.__DEV__ !== !1 && st.warn(38, n), n;
        var i = hg(r), u;
        return Jw(i) ? u = new e(function(s) {
          return n.request(s, function(c) {
            return i.request(c) || pn.of();
          }) || pn.of();
        }) : u = new e(function(s, c) {
          return n.request(s, function(p) {
            return i.request(p, c) || pn.of();
          }) || pn.of();
        }), Object.assign(u, { left: n, right: i });
      }, e.prototype.split = function(t, r, n) {
        return this.concat(e.split(t, r, n || new e(VB)));
      }, e.prototype.concat = function(t) {
        return e.concat(this, t);
      }, e.prototype.request = function(t, r) {
        throw Ya(39);
      }, e.prototype.onError = function(t, r) {
        if (r && r.error)
          return r.error(t), !1;
        throw t;
      }, e.prototype.setOnError = function(t) {
        return this.onError = t, this;
      }, e;
    }()
  ), _P = Ix.execute;
  function Pne(e) {
    var t, r = e[Symbol.asyncIterator]();
    return t = {
      next: function() {
        return r.next();
      }
    }, t[Symbol.asyncIterator] = function() {
      return this;
    }, t;
  }
  function Mne(e) {
    var t = null, r = null, n = !1, i = [], u = [];
    function s(y) {
      if (!r) {
        if (u.length) {
          var x = u.shift();
          if (Array.isArray(x) && x[0])
            return x[0]({ value: y, done: !1 });
        }
        i.push(y);
      }
    }
    function c(y) {
      r = y;
      var x = u.slice();
      x.forEach(function(w) {
        w[1](y);
      }), !t || t();
    }
    function p() {
      n = !0;
      var y = u.slice();
      y.forEach(function(x) {
        x[0]({ value: void 0, done: !0 });
      }), !t || t();
    }
    t = function() {
      t = null, e.removeListener("data", s), e.removeListener("error", c), e.removeListener("end", p), e.removeListener("finish", p), e.removeListener("close", p);
    }, e.on("data", s), e.on("error", c), e.on("end", p), e.on("finish", p), e.on("close", p);
    function h() {
      return new Promise(function(y, x) {
        if (r)
          return x(r);
        if (i.length)
          return y({ value: i.shift(), done: !1 });
        if (n)
          return y({ value: void 0, done: !0 });
        u.push([y, x]);
      });
    }
    var v = {
      next: function() {
        return h();
      }
    };
    return T_ && (v[Symbol.asyncIterator] = function() {
      return this;
    }), v;
  }
  function Nne(e) {
    var t = !1, r = {
      next: function() {
        return t ? Promise.resolve({
          value: void 0,
          done: !0
        }) : (t = !0, new Promise(function(n, i) {
          e.then(function(u) {
            n({ value: u, done: !1 });
          }).catch(i);
        }));
      }
    };
    return T_ && (r[Symbol.asyncIterator] = function() {
      return this;
    }), r;
  }
  function WB(e) {
    var t = {
      next: function() {
        return e.read();
      }
    };
    return T_ && (t[Symbol.asyncIterator] = function() {
      return this;
    }), t;
  }
  function jne(e) {
    return !!e.body;
  }
  function Fne(e) {
    return !!e.getReader;
  }
  function Ine(e) {
    return !!(T_ && e[Symbol.asyncIterator]);
  }
  function Bne(e) {
    return !!e.stream;
  }
  function Lne(e) {
    return !!e.arrayBuffer;
  }
  function $ne(e) {
    return !!e.pipe;
  }
  function zne(e) {
    var t = e;
    if (jne(e) && (t = e.body), Ine(t))
      return Pne(t);
    if (Fne(t))
      return WB(t.getReader());
    if (Bne(t))
      return WB(t.stream().getReader());
    if (Lne(t))
      return Nne(t.arrayBuffer());
    if ($ne(t))
      return Mne(t);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
  }
  var RN = Symbol();
  function qne(e) {
    return e.extensions ? Array.isArray(e.extensions[RN]) : !1;
  }
  function C9(e) {
    return e.hasOwnProperty("graphQLErrors");
  }
  var Une = function(e) {
    var t = Da(Da(Da([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
    return e.networkError && t.push(e.networkError), t.map(function(r) {
      return Hn(r) && r.message || "Error message not found.";
    }).join(`
`);
  }, cc = (
    /** @class */
    function(e) {
      pl(t, e);
      function t(r) {
        var n = r.graphQLErrors, i = r.protocolErrors, u = r.clientErrors, s = r.networkError, c = r.errorMessage, p = r.extraInfo, h = e.call(this, c) || this;
        return h.name = "ApolloError", h.graphQLErrors = n || [], h.protocolErrors = i || [], h.clientErrors = u || [], h.networkError = s || null, h.message = c || Une(h), h.extraInfo = p, h.cause = Da(Da(Da([
          s
        ], n || [], !0), i || [], !0), u || [], !0).find(function(v) {
          return !!v;
        }) || null, h.__proto__ = t.prototype, h;
      }
      return t;
    }(Error)
  ), YB = Object.prototype.hasOwnProperty;
  function Hne(e, t) {
    return kf(this, void 0, void 0, function() {
      var r, n, i, u, s, c, p, h, v, y, x, w, E, C, S, k, D, A, R, T, M, F, B, V;
      return Rf(this, function(H) {
        switch (H.label) {
          case 0:
            if (TextDecoder === void 0)
              throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
            r = new TextDecoder("utf-8"), n = (V = e.headers) === null || V === void 0 ? void 0 : V.get("content-type"), i = "boundary=", u = n != null && n.includes(i) ? n == null ? void 0 : n.substring((n == null ? void 0 : n.indexOf(i)) + i.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", s = `\r
--`.concat(u), c = "", p = zne(e), h = !0, H.label = 1;
          case 1:
            return h ? [4, p.next()] : [3, 3];
          case 2:
            for (v = H.sent(), y = v.value, x = v.done, w = typeof y == "string" ? y : r.decode(y), E = c.length - s.length + 1, h = !x, c += w, C = c.indexOf(s, E); C > -1; ) {
              if (S = void 0, F = [
                c.slice(0, C),
                c.slice(C + s.length)
              ], S = F[0], c = F[1], k = S.indexOf(`\r
\r
`), D = Vne(S.slice(0, k)), A = D["content-type"], A && A.toLowerCase().indexOf("application/json") === -1)
                throw new Error("Unsupported patch content type: application/json is required.");
              if (R = S.slice(k), R) {
                if (T = O9(e, R), Object.keys(T).length > 1 || "data" in T || "incremental" in T || "errors" in T || "payload" in T)
                  if (nne(T)) {
                    if (M = {}, "payload" in T) {
                      if (Object.keys(T).length === 1 && T.payload === null)
                        return [
                          2
                          /*return*/
                        ];
                      M = ye({}, T.payload);
                    }
                    "errors" in T && (M = ye(ye({}, M), { extensions: ye(ye({}, "extensions" in M ? M.extensions : null), (B = {}, B[RN] = T.errors, B)) })), t(M);
                  } else
                    t(T);
                else if (
                  // If the chunk contains only a "hasNext: false", we can call
                  // observer.complete() immediately.
                  Object.keys(T).length === 1 && "hasNext" in T && !T.hasNext
                )
                  return [
                    2
                    /*return*/
                  ];
              }
              C = c.indexOf(s);
            }
            return [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }
  function Vne(e) {
    var t = {};
    return e.split(`
`).forEach(function(r) {
      var n = r.indexOf(":");
      if (n > -1) {
        var i = r.slice(0, n).trim().toLowerCase(), u = r.slice(n + 1).trim();
        t[i] = u;
      }
    }), t;
  }
  function O9(e, t) {
    if (e.status >= 300) {
      var r = function() {
        try {
          return JSON.parse(t);
        } catch {
          return t;
        }
      };
      _9(e, r(), "Response not successful: Received status code ".concat(e.status));
    }
    try {
      return JSON.parse(t);
    } catch (i) {
      var n = i;
      throw n.name = "ServerParseError", n.response = e, n.statusCode = e.status, n.bodyText = t, n;
    }
  }
  function Wne(e, t) {
    e.result && e.result.errors && e.result.data && t.next(e.result), t.error(e);
  }
  function Yne(e) {
    return function(t) {
      return t.text().then(function(r) {
        return O9(t, r);
      }).then(function(r) {
        return !Array.isArray(r) && !YB.call(r, "data") && !YB.call(r, "errors") && _9(t, r, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function(n) {
          return n.operationName;
        }) : e.operationName, "'.")), r;
      });
    };
  }
  var CP = function(e, t) {
    var r;
    try {
      r = JSON.stringify(e);
    } catch (i) {
      var n = Ya(42, t, i.message);
      throw n.parseError = i, n;
    }
    return r;
  }, Gne = {
    includeQuery: !0,
    includeExtensions: !1,
    preserveHeaderCase: !1
  }, Qne = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "*/*",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json"
  }, Kne = {
    method: "POST"
  }, Xne = {
    http: Gne,
    headers: Qne,
    options: Kne
  }, Zne = function(e, t) {
    return t(e);
  };
  function Jne(e, t) {
    for (var r = [], n = 2; n < arguments.length; n++)
      r[n - 2] = arguments[n];
    var i = {}, u = {};
    r.forEach(function(y) {
      i = ye(ye(ye({}, i), y.options), { headers: ye(ye({}, i.headers), y.headers) }), y.credentials && (i.credentials = y.credentials), u = ye(ye({}, u), y.http);
    }), i.headers && (i.headers = eie(i.headers, u.preserveHeaderCase));
    var s = e.operationName, c = e.extensions, p = e.variables, h = e.query, v = { operationName: s, variables: p };
    return u.includeExtensions && (v.extensions = c), u.includeQuery && (v.query = t(h, _p)), {
      options: i,
      body: v
    };
  }
  function eie(e, t) {
    if (!t) {
      var r = {};
      return Object.keys(Object(e)).forEach(function(u) {
        r[u.toLowerCase()] = e[u];
      }), r;
    }
    var n = {};
    Object.keys(Object(e)).forEach(function(u) {
      n[u.toLowerCase()] = {
        originalName: u,
        value: e[u]
      };
    });
    var i = {};
    return Object.keys(n).forEach(function(u) {
      i[n[u].originalName] = n[u].value;
    }), i;
  }
  var tie = function(e) {
    if (!e && typeof fetch > "u")
      throw Ya(40);
  }, rie = function(e, t) {
    var r = e.getContext(), n = r.uri;
    return n || (typeof t == "function" ? t(e) : t || "/graphql");
  };
  function nie(e, t) {
    var r = [], n = function(y, x) {
      r.push("".concat(y, "=").concat(encodeURIComponent(x)));
    };
    if ("query" in t && n("query", t.query), t.operationName && n("operationName", t.operationName), t.variables) {
      var i = void 0;
      try {
        i = CP(t.variables, "Variables map");
      } catch (y) {
        return { parseError: y };
      }
      n("variables", i);
    }
    if (t.extensions) {
      var u = void 0;
      try {
        u = CP(t.extensions, "Extensions map");
      } catch (y) {
        return { parseError: y };
      }
      n("extensions", u);
    }
    var s = "", c = e, p = e.indexOf("#");
    p !== -1 && (s = e.substr(p), c = e.substr(0, p));
    var h = c.indexOf("?") === -1 ? "?" : "&", v = c + h + r.join("&") + s;
    return { newURI: v };
  }
  var GB = ls(function() {
    return fetch;
  }), iie = function(e) {
    e === void 0 && (e = {});
    var t = e.uri, r = t === void 0 ? "/graphql" : t, n = e.fetch, i = e.print, u = i === void 0 ? Zne : i, s = e.includeExtensions, c = e.preserveHeaderCase, p = e.useGETForQueries, h = e.includeUnusedVariables, v = h === void 0 ? !1 : h, y = ps(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
    globalThis.__DEV__ !== !1 && tie(n || GB);
    var x = {
      http: { includeExtensions: s, preserveHeaderCase: c },
      options: y.fetchOptions,
      credentials: y.credentials,
      headers: y.headers
    };
    return new Ix(function(w) {
      var E = rie(w, r), C = w.getContext(), S = {};
      if (C.clientAwareness) {
        var k = C.clientAwareness, D = k.name, A = k.version;
        D && (S["apollographql-client-name"] = D), A && (S["apollographql-client-version"] = A);
      }
      var R = ye(ye({}, S), C.headers), T = {
        http: C.http,
        options: C.fetchOptions,
        credentials: C.credentials,
        headers: R
      };
      if (Qg(["client"], w.query)) {
        var M = XU(w.query);
        if (!M)
          return HA(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
        w.query = M;
      }
      var F = Jne(w, u, Xne, x, T), B = F.options, V = F.body;
      V.variables && !v && (V.variables = Rne(V.variables, w.query));
      var H;
      !B.signal && typeof AbortController < "u" && (H = new AbortController(), B.signal = H.signal);
      var q = function(fe) {
        return fe.kind === "OperationDefinition" && fe.operation === "mutation";
      }, Q = function(fe) {
        return fe.kind === "OperationDefinition" && fe.operation === "subscription";
      }, W = Q(Fx(w.query)), J = Qg(["defer"], w.query);
      if (p && !w.query.definitions.some(q) && (B.method = "GET"), J || W) {
        B.headers = B.headers || {};
        var ne = "multipart/mixed;";
        W && J && globalThis.__DEV__ !== !1 && st.warn(41), W ? ne += "boundary=graphql;subscriptionSpec=1.0,application/json" : J && (ne += "deferSpec=20220824,application/json"), B.headers.accept = ne;
      }
      if (B.method === "GET") {
        var ie = nie(E, V), se = ie.newURI, X = ie.parseError;
        if (X)
          return HA(X);
        E = se;
      } else
        try {
          B.body = CP(V, "Payload");
        } catch (fe) {
          return HA(fe);
        }
      return new pn(function(fe) {
        var Z = n || ls(function() {
          return fetch;
        }) || GB, z = fe.next.bind(fe);
        return Z(E, B).then(function(Y) {
          var te;
          w.setContext({ response: Y });
          var ae = (te = Y.headers) === null || te === void 0 ? void 0 : te.get("content-type");
          return ae !== null && /^multipart\/mixed/i.test(ae) ? Hne(Y, z) : Yne(w)(Y).then(z);
        }).then(function() {
          H = void 0, fe.complete();
        }).catch(function(Y) {
          H = void 0, Wne(Y, fe);
        }), function() {
          H && H.abort();
        };
      });
    });
  }, aie = (
    /** @class */
    function(e) {
      pl(t, e);
      function t(r) {
        r === void 0 && (r = {});
        var n = e.call(this, iie(r).request) || this;
        return n.options = r, n;
      }
      return t;
    }(Ix)
  ), dr;
  (function(e) {
    e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
  })(dr || (dr = {}));
  function Vv(e) {
    return e ? e < 7 : !1;
  }
  var QB = Object.assign, oie = Object.hasOwnProperty, Lg = (
    /** @class */
    function(e) {
      pl(t, e);
      function t(r) {
        var n = r.queryManager, i = r.queryInfo, u = r.options, s = this, c = t.inactiveOnCreation.getValue();
        s = e.call(this, function(k) {
          c && (n.queries.set(s.queryId, i), c = !1);
          try {
            var D = k._subscription._observer;
            D && !D.error && (D.error = uie);
          } catch {
          }
          var A = !s.observers.size;
          s.observers.add(k);
          var R = s.last;
          return R && R.error ? k.error && k.error(R.error) : R && R.result && k.next && k.next(s.maskResult(R.result)), A && s.reobserve().catch(function() {
          }), function() {
            s.observers.delete(k) && !s.observers.size && s.tearDownQuery();
          };
        }) || this, s.observers = /* @__PURE__ */ new Set(), s.subscriptions = /* @__PURE__ */ new Set(), s.dirty = !1, s.queryInfo = i, s.queryManager = n, s.waitForOwnResult = VA(u.fetchPolicy), s.isTornDown = !1, s.subscribeToMore = s.subscribeToMore.bind(s), s.maskResult = s.maskResult.bind(s);
        var p = n.defaultOptions.watchQuery, h = p === void 0 ? {} : p, v = h.fetchPolicy, y = v === void 0 ? "cache-first" : v, x = u.fetchPolicy, w = x === void 0 ? y : x, E = u.initialFetchPolicy, C = E === void 0 ? w === "standby" ? y : w : E;
        s.options = ye(ye({}, u), {
          // Remember the initial options.fetchPolicy so we can revert back to this
          // policy when variables change. This information can also be specified
          // (or overridden) by providing options.initialFetchPolicy explicitly.
          initialFetchPolicy: C,
          // This ensures this.options.fetchPolicy always has a string value, in
          // case options.fetchPolicy was not provided.
          fetchPolicy: w
        }), s.queryId = i.queryId || n.generateQueryId();
        var S = Mp(s.query);
        return s.queryName = S && S.name && S.name.value, s;
      }
      return Object.defineProperty(t.prototype, "query", {
        // The `query` computed property will always reflect the document transformed
        // by the last run query. `this.options.query` will always reflect the raw
        // untransformed query to ensure document transforms with runtime conditionals
        // are run on the original document.
        get: function() {
          return this.lastQuery || this.options.query;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "variables", {
        // Computed shorthand for this.options.variables, preserved for
        // backwards compatibility.
        /**
         * An object containing the variables that were provided for the query.
         */
        get: function() {
          return this.options.variables;
        },
        enumerable: !1,
        configurable: !0
      }), t.prototype.result = function() {
        var r = this;
        return new Promise(function(n, i) {
          var u = {
            next: function(c) {
              n(c), r.observers.delete(u), r.observers.size || r.queryManager.removeQuery(r.queryId), setTimeout(function() {
                s.unsubscribe();
              }, 0);
            },
            error: i
          }, s = r.subscribe(u);
        });
      }, t.prototype.resetDiff = function() {
        this.queryInfo.resetDiff();
      }, t.prototype.getCurrentFullResult = function(r) {
        r === void 0 && (r = !0);
        var n = this.getLastResult(!0), i = this.queryInfo.networkStatus || n && n.networkStatus || dr.ready, u = ye(ye({}, n), { loading: Vv(i), networkStatus: i }), s = this.options.fetchPolicy, c = s === void 0 ? "cache-first" : s;
        if (
          // These fetch policies should never deliver data from the cache, unless
          // redelivering a previously delivered result.
          !(VA(c) || // If this.options.query has @client(always: true) fields, we cannot
          // trust diff.result, since it was read from the cache without running
          // local resolvers (and it's too late to run resolvers now, since we must
          // return a result synchronously).
          this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
        ) if (this.waitForOwnResult)
          this.queryInfo.updateWatch();
        else {
          var p = this.queryInfo.getDiff();
          (p.complete || this.options.returnPartialData) && (u.data = p.result), Xr(u.data, {}) && (u.data = void 0), p.complete ? (delete u.partial, p.complete && u.networkStatus === dr.loading && (c === "cache-first" || c === "cache-only") && (u.networkStatus = dr.ready, u.loading = !1)) : u.partial = !0, u.networkStatus === dr.ready && (u.error || u.errors) && (u.networkStatus = dr.error), globalThis.__DEV__ !== !1 && !p.complete && !this.options.partialRefetch && !u.loading && !u.data && !u.error && T9(p.missing);
        }
        return r && this.updateLastResult(u), u;
      }, t.prototype.getCurrentResult = function(r) {
        return r === void 0 && (r = !0), this.maskResult(this.getCurrentFullResult(r));
      }, t.prototype.isDifferentFromLastResult = function(r, n) {
        if (!this.last)
          return !0;
        var i = this.queryManager.getDocumentInfo(this.query), u = this.queryManager.dataMasking, s = u ? i.nonReactiveQuery : this.query, c = u || i.hasNonreactiveDirective ? !i9(s, this.last.result, r, this.variables) : !Xr(this.last.result, r);
        return c || n && !Xr(this.last.variables, n);
      }, t.prototype.getLast = function(r, n) {
        var i = this.last;
        if (i && i[r] && (!n || Xr(i.variables, this.variables)))
          return i[r];
      }, t.prototype.getLastResult = function(r) {
        return this.getLast("result", r);
      }, t.prototype.getLastError = function(r) {
        return this.getLast("error", r);
      }, t.prototype.resetLastResults = function() {
        delete this.last, this.isTornDown = !1;
      }, t.prototype.resetQueryStoreErrors = function() {
        this.queryManager.resetErrors(this.queryId);
      }, t.prototype.refetch = function(r) {
        var n, i = {
          // Always disable polling for refetches.
          pollInterval: 0
        }, u = this.options.fetchPolicy;
        if (u === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && r && oie.call(r, "variables")) {
          var s = WU(this.query), c = s.variableDefinitions;
          (!c || !c.some(function(p) {
            return p.variable.name.value === "variables";
          })) && globalThis.__DEV__ !== !1 && st.warn(
            21,
            r,
            ((n = s.name) === null || n === void 0 ? void 0 : n.value) || s
          );
        }
        return r && !Xr(this.options.variables, r) && (i.variables = this.options.variables = ye(ye({}, this.options.variables), r)), this.queryInfo.resetLastWrite(), this.reobserve(i, dr.refetch);
      }, t.prototype.fetchMore = function(r) {
        var n = this, i = ye(ye({}, r.query ? r : ye(ye(ye(ye({}, this.options), { query: this.options.query }), r), { variables: ye(ye({}, this.options.variables), r.variables) })), {
          // The fetchMore request goes immediately to the network and does
          // not automatically write its result to the cache (hence no-cache
          // instead of network-only), because we allow the caller of
          // fetchMore to provide an updateQuery callback that determines how
          // the data gets written to the cache.
          fetchPolicy: "no-cache"
        });
        i.query = this.transformDocument(i.query);
        var u = this.queryManager.generateQueryId();
        this.lastQuery = r.query ? this.transformDocument(this.options.query) : i.query;
        var s = this.queryInfo, c = s.networkStatus;
        s.networkStatus = dr.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
        var p = /* @__PURE__ */ new Set(), h = r == null ? void 0 : r.updateQuery, v = this.options.fetchPolicy !== "no-cache";
        return v || st(h, 22), this.queryManager.fetchQuery(u, i, dr.fetchMore).then(function(y) {
          if (n.queryManager.removeQuery(u), s.networkStatus === dr.fetchMore && (s.networkStatus = c), v)
            n.queryManager.cache.batch({
              update: function(E) {
                var C = r.updateQuery;
                C ? E.updateQuery({
                  query: n.query,
                  variables: n.variables,
                  returnPartialData: !0,
                  optimistic: !1
                }, function(S) {
                  return C(S, {
                    fetchMoreResult: y.data,
                    variables: i.variables
                  });
                }) : E.writeQuery({
                  query: i.query,
                  variables: i.variables,
                  data: y.data
                });
              },
              onWatchUpdated: function(E) {
                p.add(E.query);
              }
            });
          else {
            var x = n.getLast("result"), w = h(x.data, {
              fetchMoreResult: y.data,
              variables: i.variables
            });
            n.reportResult(ye(ye({}, x), { networkStatus: c, loading: Vv(c), data: w }), n.variables);
          }
          return n.maskResult(y);
        }).finally(function() {
          v && !p.has(n.query) && n.reobserveCacheFirst();
        });
      }, t.prototype.subscribeToMore = function(r) {
        var n = this, i = this.queryManager.startGraphQLSubscription({
          query: r.document,
          variables: r.variables,
          context: r.context
        }).subscribe({
          next: function(u) {
            var s = r.updateQuery;
            s && n.updateQuery(function(c, p) {
              return s(c, ye({ subscriptionData: u }, p));
            });
          },
          error: function(u) {
            if (r.onError) {
              r.onError(u);
              return;
            }
            globalThis.__DEV__ !== !1 && st.error(23, u);
          }
        });
        return this.subscriptions.add(i), function() {
          n.subscriptions.delete(i) && i.unsubscribe();
        };
      }, t.prototype.setOptions = function(r) {
        return this.reobserve(r);
      }, t.prototype.silentSetOptions = function(r) {
        var n = Np(this.options, r || {});
        QB(this.options, n);
      }, t.prototype.setVariables = function(r) {
        return Xr(this.variables, r) ? this.observers.size ? this.result() : Promise.resolve() : (this.options.variables = r, this.observers.size ? this.reobserve({
          // Reset options.fetchPolicy to its original value.
          fetchPolicy: this.options.initialFetchPolicy,
          variables: r
        }, dr.setVariables) : Promise.resolve());
      }, t.prototype.updateQuery = function(r) {
        var n = this.queryManager, i = n.cache.diff({
          query: this.options.query,
          variables: this.variables,
          returnPartialData: !0,
          optimistic: !1
        }), u = i.result, s = i.complete, c = r(u, {
          variables: this.variables,
          complete: !!s,
          previousData: u
        });
        c && (n.cache.writeQuery({
          query: this.options.query,
          data: c,
          variables: this.variables
        }), n.broadcastQueries());
      }, t.prototype.startPolling = function(r) {
        this.options.pollInterval = r, this.updatePolling();
      }, t.prototype.stopPolling = function() {
        this.options.pollInterval = 0, this.updatePolling();
      }, t.prototype.applyNextFetchPolicy = function(r, n) {
        if (n.nextFetchPolicy) {
          var i = n.fetchPolicy, u = i === void 0 ? "cache-first" : i, s = n.initialFetchPolicy, c = s === void 0 ? u : s;
          u === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(u, {
            reason: r,
            options: n,
            observable: this,
            initialFetchPolicy: c
          }) : r === "variables-changed" ? n.fetchPolicy = c : n.fetchPolicy = n.nextFetchPolicy);
        }
        return n.fetchPolicy;
      }, t.prototype.fetch = function(r, n, i) {
        var u = this.queryManager.getOrCreateQuery(this.queryId);
        return u.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(u, r, n, i);
      }, t.prototype.updatePolling = function() {
        var r = this;
        if (!this.queryManager.ssrMode) {
          var n = this, i = n.pollingInfo, u = n.options.pollInterval;
          if (!u || !this.hasObservers()) {
            i && (clearTimeout(i.timeout), delete this.pollingInfo);
            return;
          }
          if (!(i && i.interval === u)) {
            st(u, 24);
            var s = i || (this.pollingInfo = {});
            s.interval = u;
            var c = function() {
              var h, v;
              r.pollingInfo && (!Vv(r.queryInfo.networkStatus) && !(!((v = (h = r.options).skipPollAttempt) === null || v === void 0) && v.call(h)) ? r.reobserve({
                // Most fetchPolicy options don't make sense to use in a polling context, as
                // users wouldn't want to be polling the cache directly. However, network-only and
                // no-cache are both useful for when the user wants to control whether or not the
                // polled results are written to the cache.
                fetchPolicy: r.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
              }, dr.poll).then(p, p) : p());
            }, p = function() {
              var h = r.pollingInfo;
              h && (clearTimeout(h.timeout), h.timeout = setTimeout(c, h.interval));
            };
            p();
          }
        }
      }, t.prototype.updateLastResult = function(r, n) {
        n === void 0 && (n = this.variables);
        var i = this.getLastError();
        return i && this.last && !Xr(n, this.last.variables) && (i = void 0), this.last = ye({ result: this.queryManager.assumeImmutableResults ? r : t9(r), variables: n }, i ? { error: i } : null);
      }, t.prototype.reobserveAsConcast = function(r, n) {
        var i = this;
        this.isTornDown = !1;
        var u = (
          // Refetching uses a disposable Concast to allow refetches using different
          // options/variables, without permanently altering the options of the
          // original ObservableQuery.
          n === dr.refetch || // The fetchMore method does not actually call the reobserve method, but,
          // if it did, it would definitely use a disposable Concast.
          n === dr.fetchMore || // Polling uses a disposable Concast so the polling options (which force
          // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
          n === dr.poll
        ), s = this.options.variables, c = this.options.fetchPolicy, p = Np(this.options, r || {}), h = u ? (
          // Disposable Concast fetches receive a shallow copy of this.options
          // (merged with newOptions), leaving this.options unmodified.
          p
        ) : QB(this.options, p), v = this.transformDocument(h.query);
        this.lastQuery = v, u || (this.updatePolling(), r && r.variables && !Xr(r.variables, s) && // Don't mess with the fetchPolicy if it's currently "standby".
        h.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
        // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
        (h.fetchPolicy === c || // A `nextFetchPolicy` function has even higher priority, though,
        // so in that case `applyNextFetchPolicy` must be called.
        typeof h.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", h), n === void 0 && (n = dr.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = VA(h.fetchPolicy));
        var y = function() {
          i.concast === E && (i.waitForOwnResult = !1);
        }, x = h.variables && ye({}, h.variables), w = this.fetch(h, n, v), E = w.concast, C = w.fromLink, S = {
          next: function(k) {
            Xr(i.variables, x) && (y(), i.reportResult(k, x));
          },
          error: function(k) {
            Xr(i.variables, x) && (C9(k) || (k = new cc({ networkError: k })), y(), i.reportError(k, x));
          }
        };
        return !u && (C || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = E, this.observer = S), E.addObserver(S), E;
      }, t.prototype.reobserve = function(r, n) {
        return Xre(this.reobserveAsConcast(r, n).promise.then(this.maskResult));
      }, t.prototype.resubscribeAfterError = function() {
        for (var r = [], n = 0; n < arguments.length; n++)
          r[n] = arguments[n];
        var i = this.last;
        this.resetLastResults();
        var u = this.subscribe.apply(this, r);
        return this.last = i, u;
      }, t.prototype.observe = function() {
        this.reportResult(
          // Passing false is important so that this.getCurrentResult doesn't
          // save the fetchMore result as this.lastResult, causing it to be
          // ignored due to the this.isDifferentFromLastResult check in
          // this.reportResult.
          this.getCurrentFullResult(!1),
          this.variables
        );
      }, t.prototype.reportResult = function(r, n) {
        var i = this.getLastError(), u = this.isDifferentFromLastResult(r, n);
        (i || !r.partial || this.options.returnPartialData) && this.updateLastResult(r, n), (i || u) && Fg(this.observers, "next", this.maskResult(r));
      }, t.prototype.reportError = function(r, n) {
        var i = ye(ye({}, this.getLastResult()), { error: r, errors: r.graphQLErrors, networkStatus: dr.error, loading: !1 });
        this.updateLastResult(i, n), Fg(this.observers, "error", this.last.error = r);
      }, t.prototype.hasObservers = function() {
        return this.observers.size > 0;
      }, t.prototype.tearDownQuery = function() {
        this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(r) {
          return r.unsubscribe();
        }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
      }, t.prototype.transformDocument = function(r) {
        return this.queryManager.transform(r);
      }, t.prototype.maskResult = function(r) {
        return r && "data" in r ? ye(ye({}, r), { data: this.queryManager.maskOperation({
          document: this.query,
          data: r.data,
          fetchPolicy: this.options.fetchPolicy,
          id: this.queryId
        }) }) : r;
      }, t.prototype.resetNotifications = function() {
        this.cancelNotifyTimeout(), this.dirty = !1;
      }, t.prototype.cancelNotifyTimeout = function() {
        this.notifyTimeout && (clearTimeout(this.notifyTimeout), this.notifyTimeout = void 0);
      }, t.prototype.scheduleNotify = function() {
        var r = this;
        this.dirty || (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
          return r.notify();
        }, 0)));
      }, t.prototype.notify = function() {
        if (this.cancelNotifyTimeout(), this.dirty && (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !Vv(this.queryInfo.networkStatus))) {
          var r = this.queryInfo.getDiff();
          r.fromOptimisticTransaction ? this.observe() : this.reobserveCacheFirst();
        }
        this.dirty = !1;
      }, t.prototype.reobserveCacheFirst = function() {
        var r = this.options, n = r.fetchPolicy, i = r.nextFetchPolicy;
        return n === "cache-and-network" || n === "network-only" ? this.reobserve({
          fetchPolicy: "cache-first",
          // Use a temporary nextFetchPolicy function that replaces itself with the
          // previous nextFetchPolicy value and returns the original fetchPolicy.
          nextFetchPolicy: function(u, s) {
            return this.nextFetchPolicy = i, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(u, s) : n;
          }
        }) : this.reobserve();
      }, t.inactiveOnCreation = new Nx(), t;
    }(pn)
  );
  r9(Lg);
  function uie(e) {
    globalThis.__DEV__ !== !1 && st.error(25, e.message, e.stack);
  }
  function T9(e) {
    globalThis.__DEV__ !== !1 && e && globalThis.__DEV__ !== !1 && st.debug(26, e);
  }
  function VA(e) {
    return e === "network-only" || e === "no-cache" || e === "standby";
  }
  var Wv = new ($p ? WeakMap : Map)();
  function WA(e, t) {
    var r = e[t];
    typeof r == "function" && (e[t] = function() {
      return Wv.set(
        e,
        // The %1e15 allows the count to wrap around to 0 safely every
        // quadrillion evictions, so there's no risk of overflow. To be
        // clear, this is more of a pedantic principle than something
        // that matters in any conceivable practical scenario.
        (Wv.get(e) + 1) % 1e15
      ), r.apply(this, arguments);
    });
  }
  var YA = (
    /** @class */
    function() {
      function e(t, r) {
        r === void 0 && (r = t.generateQueryId()), this.queryId = r, this.document = null, this.lastRequestId = 1, this.stopped = !1, this.observableQuery = null;
        var n = this.cache = t.cache;
        Wv.has(n) || (Wv.set(n, 0), WA(n, "evict"), WA(n, "modify"), WA(n, "reset"));
      }
      return e.prototype.init = function(t) {
        var r = t.networkStatus || dr.loading;
        return this.variables && this.networkStatus !== dr.loading && !Xr(this.variables, t.variables) && (r = dr.setVariables), Xr(t.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
          document: t.document,
          variables: t.variables,
          networkError: null,
          graphQLErrors: this.graphQLErrors || [],
          networkStatus: r
        }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
      }, e.prototype.resetDiff = function() {
        this.lastDiff = void 0;
      }, e.prototype.getDiff = function() {
        var t = this.getDiffOptions();
        if (this.lastDiff && Xr(t, this.lastDiff.options))
          return this.lastDiff.diff;
        this.updateWatch(this.variables);
        var r = this.observableQuery;
        if (r && r.options.fetchPolicy === "no-cache")
          return { complete: !1 };
        var n = this.cache.diff(t);
        return this.updateLastDiff(n, t), n;
      }, e.prototype.updateLastDiff = function(t, r) {
        this.lastDiff = t ? {
          diff: t,
          options: r || this.getDiffOptions()
        } : void 0;
      }, e.prototype.getDiffOptions = function(t) {
        var r;
        return t === void 0 && (t = this.variables), {
          query: this.document,
          variables: t,
          returnPartialData: !0,
          optimistic: !0,
          canonizeResults: (r = this.observableQuery) === null || r === void 0 ? void 0 : r.options.canonizeResults
        };
      }, e.prototype.setDiff = function(t) {
        var r, n, i = this.lastDiff && this.lastDiff.diff;
        t && !t.complete && (!((r = this.observableQuery) === null || r === void 0) && r.getLastError()) || (this.updateLastDiff(t), Xr(i && i.result, t && t.result) || (n = this.observableQuery) === null || n === void 0 || n.scheduleNotify());
      }, e.prototype.setObservableQuery = function(t) {
        t !== this.observableQuery && (this.observableQuery = t, t && (t.queryInfo = this));
      }, e.prototype.stop = function() {
        var t;
        if (!this.stopped) {
          this.stopped = !0, (t = this.observableQuery) === null || t === void 0 || t.resetNotifications(), this.cancel();
          var r = this.observableQuery;
          r && r.stopPolling();
        }
      }, e.prototype.cancel = function() {
        var t;
        (t = this.cancelWatch) === null || t === void 0 || t.call(this), this.cancelWatch = void 0;
      }, e.prototype.updateWatch = function(t) {
        var r = this;
        t === void 0 && (t = this.variables);
        var n = this.observableQuery;
        if (!(n && n.options.fetchPolicy === "no-cache")) {
          var i = ye(ye({}, this.getDiffOptions(t)), { watcher: this, callback: function(u) {
            return r.setDiff(u);
          } });
          (!this.lastWatch || !Xr(i, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = i));
        }
      }, e.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
      }, e.prototype.shouldWrite = function(t, r) {
        var n = this.lastWrite;
        return !(n && // If cache.evict has been called since the last time we wrote this
        // data into the cache, there's a chance writing this result into
        // the cache will repair what was evicted.
        n.dmCount === Wv.get(this.cache) && Xr(r, n.variables) && Xr(t.data, n.result.data));
      }, e.prototype.markResult = function(t, r, n, i) {
        var u = this, s, c = new zf(), p = Cu(t.errors) ? t.errors.slice(0) : [];
        if ((s = this.observableQuery) === null || s === void 0 || s.resetNotifications(), "incremental" in t && Cu(t.incremental)) {
          var h = n9(this.getDiff().result, t);
          t.data = h;
        } else if ("hasNext" in t && t.hasNext) {
          var v = this.getDiff();
          t.data = c.merge(v.result, t.data);
        }
        this.graphQLErrors = p, n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: t.data, complete: !0 }, this.getDiffOptions(n.variables)) : i !== 0 && (OP(t, n.errorPolicy) ? this.cache.performTransaction(function(y) {
          if (u.shouldWrite(t, n.variables))
            y.writeQuery({
              query: r,
              data: t.data,
              variables: n.variables,
              overwrite: i === 1
            }), u.lastWrite = {
              result: t,
              variables: n.variables,
              dmCount: Wv.get(u.cache)
            };
          else if (u.lastDiff && u.lastDiff.diff.complete) {
            t.data = u.lastDiff.diff.result;
            return;
          }
          var x = u.getDiffOptions(n.variables), w = y.diff(x);
          !u.stopped && Xr(u.variables, n.variables) && u.updateWatch(n.variables), u.updateLastDiff(w, x), w.complete && (t.data = w.result);
        }) : this.lastWrite = void 0);
      }, e.prototype.markReady = function() {
        return this.networkError = null, this.networkStatus = dr.ready;
      }, e.prototype.markError = function(t) {
        var r;
        return this.networkStatus = dr.error, this.lastWrite = void 0, (r = this.observableQuery) === null || r === void 0 || r.resetNotifications(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
      }, e;
    }()
  );
  function OP(e, t) {
    t === void 0 && (t = "none");
    var r = t === "ignore" || t === "all", n = !SE(e);
    return !n && r && e.data && (n = !0), n;
  }
  var sie = Object.prototype.hasOwnProperty, KB = /* @__PURE__ */ Object.create(null), lie = (
    /** @class */
    function() {
      function e(t) {
        var r = this;
        this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new gN(
          cl["queryManager.getDocumentInfo"] || 2e3
          /* defaultCacheSizes["queryManager.getDocumentInfo"] */
        ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new Cc(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
        var n = new GU(
          function(u) {
            return r.cache.transformDocument(u);
          },
          // Allow the apollo cache to manage its own transform caches
          { cache: !1 }
        );
        this.cache = t.cache, this.link = t.link, this.defaultOptions = t.defaultOptions, this.queryDeduplication = t.queryDeduplication, this.clientAwareness = t.clientAwareness, this.localState = t.localState, this.ssrMode = t.ssrMode, this.assumeImmutableResults = t.assumeImmutableResults, this.dataMasking = t.dataMasking;
        var i = t.documentTransform;
        this.documentTransform = i ? n.concat(i).concat(n) : n, this.defaultContext = t.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = t.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
      }
      return e.prototype.stop = function() {
        var t = this;
        this.queries.forEach(function(r, n) {
          t.stopQueryNoBroadcast(n);
        }), this.cancelPendingFetches(Ya(27));
      }, e.prototype.cancelPendingFetches = function(t) {
        this.fetchCancelFns.forEach(function(r) {
          return r(t);
        }), this.fetchCancelFns.clear();
      }, e.prototype.mutate = function(t) {
        return kf(this, arguments, void 0, function(r) {
          var n, i, u, s, c, p, h, v = r.mutation, y = r.variables, x = r.optimisticResponse, w = r.updateQueries, E = r.refetchQueries, C = E === void 0 ? [] : E, S = r.awaitRefetchQueries, k = S === void 0 ? !1 : S, D = r.update, A = r.onQueryUpdated, R = r.fetchPolicy, T = R === void 0 ? ((p = this.defaultOptions.mutate) === null || p === void 0 ? void 0 : p.fetchPolicy) || "network-only" : R, M = r.errorPolicy, F = M === void 0 ? ((h = this.defaultOptions.mutate) === null || h === void 0 ? void 0 : h.errorPolicy) || "none" : M, B = r.keepRootFields, V = r.context;
          return Rf(this, function(H) {
            switch (H.label) {
              case 0:
                return st(v, 28), st(T === "network-only" || T === "no-cache", 29), n = this.generateMutationId(), v = this.cache.transformForLink(this.transform(v)), i = this.getDocumentInfo(v).hasClientExports, y = this.getVariables(v, y), i ? [4, this.localState.addExportedVariables(v, y, V)] : [3, 2];
              case 1:
                y = H.sent(), H.label = 2;
              case 2:
                return u = this.mutationStore && (this.mutationStore[n] = {
                  mutation: v,
                  variables: y,
                  loading: !0,
                  error: null
                }), s = x && this.markMutationOptimistic(x, {
                  mutationId: n,
                  document: v,
                  variables: y,
                  fetchPolicy: T,
                  errorPolicy: F,
                  context: V,
                  updateQueries: w,
                  update: D,
                  keepRootFields: B
                }), this.broadcastQueries(), c = this, [2, new Promise(function(q, Q) {
                  return $A(c.getObservableFromLink(v, ye(ye({}, V), { optimisticResponse: s ? x : void 0 }), y, {}, !1), function(W) {
                    if (SE(W) && F === "none")
                      throw new cc({
                        graphQLErrors: gP(W)
                      });
                    u && (u.loading = !1, u.error = null);
                    var J = ye({}, W);
                    return typeof C == "function" && (C = C(J)), F === "ignore" && SE(J) && delete J.errors, c.markMutationResult({
                      mutationId: n,
                      result: J,
                      document: v,
                      variables: y,
                      fetchPolicy: T,
                      errorPolicy: F,
                      context: V,
                      update: D,
                      updateQueries: w,
                      awaitRefetchQueries: k,
                      refetchQueries: C,
                      removeOptimistic: s ? n : void 0,
                      onQueryUpdated: A,
                      keepRootFields: B
                    });
                  }).subscribe({
                    next: function(W) {
                      c.broadcastQueries(), (!("hasNext" in W) || W.hasNext === !1) && q(ye(ye({}, W), { data: c.maskOperation({
                        document: v,
                        data: W.data,
                        fetchPolicy: T,
                        id: n
                      }) }));
                    },
                    error: function(W) {
                      u && (u.loading = !1, u.error = W), s && c.cache.removeOptimistic(n), c.broadcastQueries(), Q(W instanceof cc ? W : new cc({
                        networkError: W
                      }));
                    }
                  });
                })];
            }
          });
        });
      }, e.prototype.markMutationResult = function(t, r) {
        var n = this;
        r === void 0 && (r = this.cache);
        var i = t.result, u = [], s = t.fetchPolicy === "no-cache";
        if (!s && OP(i, t.errorPolicy)) {
          if (Xv(i) || u.push({
            result: i.data,
            dataId: "ROOT_MUTATION",
            query: t.document,
            variables: t.variables
          }), Xv(i) && Cu(i.incremental)) {
            var c = r.diff({
              id: "ROOT_MUTATION",
              // The cache complains if passed a mutation where it expects a
              // query, so we transform mutations and subscriptions to queries
              // (only once, thanks to this.transformCache).
              query: this.getDocumentInfo(t.document).asQuery,
              variables: t.variables,
              optimistic: !1,
              returnPartialData: !0
            }), p = void 0;
            c.result && (p = n9(c.result, i)), typeof p < "u" && (i.data = p, u.push({
              result: p,
              dataId: "ROOT_MUTATION",
              query: t.document,
              variables: t.variables
            }));
          }
          var h = t.updateQueries;
          h && this.queries.forEach(function(y, x) {
            var w = y.observableQuery, E = w && w.queryName;
            if (!(!E || !sie.call(h, E))) {
              var C = h[E], S = n.queries.get(x), k = S.document, D = S.variables, A = r.diff({
                query: k,
                variables: D,
                returnPartialData: !0,
                optimistic: !1
              }), R = A.result, T = A.complete;
              if (T && R) {
                var M = C(R, {
                  mutationResult: i,
                  queryName: k && kg(k) || void 0,
                  queryVariables: D
                });
                M && u.push({
                  result: M,
                  dataId: "ROOT_QUERY",
                  query: k,
                  variables: D
                });
              }
            }
          });
        }
        if (u.length > 0 || (t.refetchQueries || "").length > 0 || t.update || t.onQueryUpdated || t.removeOptimistic) {
          var v = [];
          if (this.refetchQueries({
            updateCache: function(y) {
              s || u.forEach(function(C) {
                return y.write(C);
              });
              var x = t.update, w = !rne(i) || Xv(i) && !i.hasNext;
              if (x) {
                if (!s) {
                  var E = y.diff({
                    id: "ROOT_MUTATION",
                    // The cache complains if passed a mutation where it expects a
                    // query, so we transform mutations and subscriptions to queries
                    // (only once, thanks to this.transformCache).
                    query: n.getDocumentInfo(t.document).asQuery,
                    variables: t.variables,
                    optimistic: !1,
                    returnPartialData: !0
                  });
                  E.complete && (i = ye(ye({}, i), { data: E.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
                }
                w && x(y, i, {
                  context: t.context,
                  variables: t.variables
                });
              }
              !s && !t.keepRootFields && w && y.modify({
                id: "ROOT_MUTATION",
                fields: function(C, S) {
                  var k = S.fieldName, D = S.DELETE;
                  return k === "__typename" ? C : D;
                }
              });
            },
            include: t.refetchQueries,
            // Write the final mutation.result to the root layer of the cache.
            optimistic: !1,
            // Remove the corresponding optimistic layer at the same time as we
            // write the final non-optimistic result.
            removeOptimistic: t.removeOptimistic,
            // Let the caller of client.mutate optionally determine the refetching
            // behavior for watched queries after the mutation.update function runs.
            // If no onQueryUpdated function was provided for this mutation, pass
            // null instead of undefined to disable the default refetching behavior.
            onQueryUpdated: t.onQueryUpdated || null
          }).forEach(function(y) {
            return v.push(y);
          }), t.awaitRefetchQueries || t.onQueryUpdated)
            return Promise.all(v).then(function() {
              return i;
            });
        }
        return Promise.resolve(i);
      }, e.prototype.markMutationOptimistic = function(t, r) {
        var n = this, i = typeof t == "function" ? t(r.variables, { IGNORE: KB }) : t;
        return i === KB ? !1 : (this.cache.recordOptimisticTransaction(function(u) {
          try {
            n.markMutationResult(ye(ye({}, r), { result: { data: i } }), u);
          } catch (s) {
            globalThis.__DEV__ !== !1 && st.error(s);
          }
        }, r.mutationId), !0);
      }, e.prototype.fetchQuery = function(t, r, n) {
        return this.fetchConcastWithInfo(this.getOrCreateQuery(t), r, n).concast.promise;
      }, e.prototype.getQueryStore = function() {
        var t = /* @__PURE__ */ Object.create(null);
        return this.queries.forEach(function(r, n) {
          t[n] = {
            variables: r.variables,
            networkStatus: r.networkStatus,
            networkError: r.networkError,
            graphQLErrors: r.graphQLErrors
          };
        }), t;
      }, e.prototype.resetErrors = function(t) {
        var r = this.queries.get(t);
        r && (r.networkError = void 0, r.graphQLErrors = []);
      }, e.prototype.transform = function(t) {
        return this.documentTransform.transformDocument(t);
      }, e.prototype.getDocumentInfo = function(t) {
        var r = this.transformCache;
        if (!r.has(t)) {
          var n = {
            // TODO These three calls (hasClientExports, shouldForceResolvers, and
            // usesNonreactiveDirective) are performing independent full traversals
            // of the transformed document. We should consider merging these
            // traversals into a single pass in the future, though the work is
            // cached after the first time.
            hasClientExports: nre(t),
            hasForcedResolvers: this.localState.shouldForceResolvers(t),
            hasNonreactiveDirective: Qg(["nonreactive"], t),
            nonReactiveQuery: $re(t),
            clientQuery: this.localState.clientQuery(t),
            serverQuery: KU([
              { name: "client", remove: !0 },
              { name: "connection" },
              { name: "nonreactive" },
              { name: "unmask" }
            ], t),
            defaultVars: bN(Mp(t)),
            // Transform any mutation or subscription operations to query operations
            // so we can read/write them from/to the cache.
            asQuery: ye(ye({}, t), { definitions: t.definitions.map(function(i) {
              return i.kind === "OperationDefinition" && i.operation !== "query" ? ye(ye({}, i), { operation: "query" }) : i;
            }) })
          };
          r.set(t, n);
        }
        return r.get(t);
      }, e.prototype.getVariables = function(t, r) {
        return ye(ye({}, this.getDocumentInfo(t).defaultVars), r);
      }, e.prototype.watchQuery = function(t) {
        var r = this.transform(t.query);
        t = ye(ye({}, t), { variables: this.getVariables(r, t.variables) }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
        var n = new YA(this), i = new Lg({
          queryManager: this,
          queryInfo: n,
          options: t
        });
        return i.lastQuery = r, Lg.inactiveOnCreation.getValue() || this.queries.set(i.queryId, n), n.init({
          document: r,
          observableQuery: i,
          variables: i.variables
        }), i;
      }, e.prototype.query = function(t, r) {
        var n = this;
        r === void 0 && (r = this.generateQueryId()), st(t.query, 30), st(t.query.kind === "Document", 31), st(!t.returnPartialData, 32), st(!t.pollInterval, 33);
        var i = this.transform(t.query);
        return this.fetchQuery(r, ye(ye({}, t), { query: i })).then(function(u) {
          return u && ye(ye({}, u), { data: n.maskOperation({
            document: i,
            data: u.data,
            fetchPolicy: t.fetchPolicy,
            id: r
          }) });
        }).finally(function() {
          return n.stopQuery(r);
        });
      }, e.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
      }, e.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
      }, e.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
      }, e.prototype.stopQueryInStore = function(t) {
        this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
      }, e.prototype.stopQueryInStoreNoBroadcast = function(t) {
        var r = this.queries.get(t);
        r && r.stop();
      }, e.prototype.clearStore = function(t) {
        return t === void 0 && (t = {
          discardWatches: !0
        }), this.cancelPendingFetches(Ya(34)), this.queries.forEach(function(r) {
          r.observableQuery ? r.networkStatus = dr.loading : r.stop();
        }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(t);
      }, e.prototype.getObservableQueries = function(t) {
        var r = this;
        t === void 0 && (t = "active");
        var n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Set();
        return Array.isArray(t) && t.forEach(function(c) {
          if (typeof c == "string")
            i.set(c, c), u.set(c, !1);
          else if (Sre(c)) {
            var p = _p(r.transform(c));
            i.set(p, kg(c)), u.set(p, !1);
          } else Hn(c) && c.query && s.add(c);
        }), this.queries.forEach(function(c, p) {
          var h = c.observableQuery, v = c.document;
          if (h) {
            if (t === "all") {
              n.set(p, h);
              return;
            }
            var y = h.queryName, x = h.options.fetchPolicy;
            if (x === "standby" || t === "active" && !h.hasObservers())
              return;
            (t === "active" || y && u.has(y) || v && u.has(_p(v))) && (n.set(p, h), y && u.set(y, !0), v && u.set(_p(v), !0));
          }
        }), s.size && s.forEach(function(c) {
          var p = oP("legacyOneTimeQuery"), h = r.getOrCreateQuery(p).init({
            document: c.query,
            variables: c.variables
          }), v = new Lg({
            queryManager: r,
            queryInfo: h,
            options: ye(ye({}, c), { fetchPolicy: "network-only" })
          });
          st(v.queryId === p), h.setObservableQuery(v), n.set(p, v);
        }), globalThis.__DEV__ !== !1 && u.size && u.forEach(function(c, p) {
          if (!c) {
            var h = i.get(p);
            h ? globalThis.__DEV__ !== !1 && st.warn(35, h) : globalThis.__DEV__ !== !1 && st.warn(36);
          }
        }), n;
      }, e.prototype.reFetchObservableQueries = function(t) {
        var r = this;
        t === void 0 && (t = !1);
        var n = [];
        return this.getObservableQueries(t ? "all" : "active").forEach(function(i, u) {
          var s = i.options.fetchPolicy;
          i.resetLastResults(), (t || s !== "standby" && s !== "cache-only") && n.push(i.refetch()), (r.queries.get(u) || i.queryInfo).setDiff(null);
        }), this.broadcastQueries(), Promise.all(n);
      }, e.prototype.startGraphQLSubscription = function(t) {
        var r = this, n = t.query, i = t.variables, u = t.fetchPolicy, s = t.errorPolicy, c = s === void 0 ? "none" : s, p = t.context, h = p === void 0 ? {} : p, v = t.extensions, y = v === void 0 ? {} : v;
        n = this.transform(n), i = this.getVariables(n, i);
        var x = function(E) {
          return r.getObservableFromLink(n, h, E, y).map(function(C) {
            u !== "no-cache" && (OP(C, c) && r.cache.write({
              query: n,
              result: C.data,
              dataId: "ROOT_SUBSCRIPTION",
              variables: E
            }), r.broadcastQueries());
            var S = SE(C), k = qne(C);
            if (S || k) {
              var D = {};
              if (S && (D.graphQLErrors = C.errors), k && (D.protocolErrors = C.extensions[RN]), c === "none" || k)
                throw new cc(D);
            }
            return c === "ignore" && delete C.errors, C;
          });
        };
        if (this.getDocumentInfo(n).hasClientExports) {
          var w = this.localState.addExportedVariables(n, i, h).then(x);
          return new pn(function(E) {
            var C = null;
            return w.then(function(S) {
              return C = S.subscribe(E);
            }, E.error), function() {
              return C && C.unsubscribe();
            };
          });
        }
        return x(i);
      }, e.prototype.stopQuery = function(t) {
        this.stopQueryNoBroadcast(t), this.broadcastQueries();
      }, e.prototype.stopQueryNoBroadcast = function(t) {
        this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
      }, e.prototype.removeQuery = function(t) {
        var r;
        this.fetchCancelFns.delete(t), this.queries.has(t) && ((r = this.queries.get(t)) === null || r === void 0 || r.stop(), this.queries.delete(t));
      }, e.prototype.broadcastQueries = function() {
        this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(t) {
          var r;
          return (r = t.observableQuery) === null || r === void 0 ? void 0 : r.notify();
        });
      }, e.prototype.getLocalState = function() {
        return this.localState;
      }, e.prototype.getObservableFromLink = function(t, r, n, i, u) {
        var s = this, c;
        u === void 0 && (u = (c = r == null ? void 0 : r.queryDeduplication) !== null && c !== void 0 ? c : this.queryDeduplication);
        var p, h = this.getDocumentInfo(t), v = h.serverQuery, y = h.clientQuery;
        if (v) {
          var x = this, w = x.inFlightLinkObservables, E = x.link, C = {
            query: v,
            variables: n,
            operationName: kg(v) || void 0,
            context: this.prepareContext(ye(ye({}, r), { forceFetch: !u })),
            extensions: i
          };
          if (r = C.context, u) {
            var S = _p(v), k = Ff(n), D = w.lookup(S, k);
            if (p = D.observable, !p) {
              var A = new zv([
                _P(E, C)
              ]);
              p = D.observable = A, A.beforeNext(function R(T, M) {
                T === "next" && "hasNext" in M && M.hasNext ? A.beforeNext(R) : w.remove(S, k);
              });
            }
          } else
            p = new zv([
              _P(E, C)
            ]);
        } else
          p = new zv([pn.of({ data: {} })]), r = this.prepareContext(r);
        return y && (p = $A(p, function(R) {
          return s.localState.runResolvers({
            document: y,
            remoteResult: R,
            context: r,
            variables: n
          });
        })), p;
      }, e.prototype.getResultsFromLink = function(t, r, n) {
        var i = t.lastRequestId = this.generateRequestId(), u = this.cache.transformForLink(n.query);
        return $A(this.getObservableFromLink(u, n.context, n.variables), function(s) {
          var c = gP(s), p = c.length > 0, h = n.errorPolicy;
          if (i >= t.lastRequestId) {
            if (p && h === "none")
              throw t.markError(new cc({
                graphQLErrors: c
              }));
            t.markResult(s, u, n, r), t.markReady();
          }
          var v = {
            data: s.data,
            loading: !1,
            networkStatus: dr.ready
          };
          return p && h === "none" && (v.data = void 0), p && h !== "ignore" && (v.errors = c, v.networkStatus = dr.error), v;
        }, function(s) {
          var c = C9(s) ? s : new cc({ networkError: s });
          throw i >= t.lastRequestId && t.markError(c), c;
        });
      }, e.prototype.fetchConcastWithInfo = function(t, r, n, i) {
        var u = this;
        n === void 0 && (n = dr.loading), i === void 0 && (i = r.query);
        var s = this.getVariables(i, r.variables), c = this.defaultOptions.watchQuery, p = r.fetchPolicy, h = p === void 0 ? c && c.fetchPolicy || "cache-first" : p, v = r.errorPolicy, y = v === void 0 ? c && c.errorPolicy || "none" : v, x = r.returnPartialData, w = x === void 0 ? !1 : x, E = r.notifyOnNetworkStatusChange, C = E === void 0 ? !1 : E, S = r.context, k = S === void 0 ? {} : S, D = Object.assign({}, r, {
          query: i,
          variables: s,
          fetchPolicy: h,
          errorPolicy: y,
          returnPartialData: w,
          notifyOnNetworkStatusChange: C,
          context: k
        }), A = function(B) {
          D.variables = B;
          var V = u.fetchQueryByPolicy(t, D, n);
          return (
            // If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            D.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
            // this is another way to detect when nothing was done/fetched.
            V.sources.length > 0 && t.observableQuery && t.observableQuery.applyNextFetchPolicy("after-fetch", r), V
          );
        }, R = function() {
          return u.fetchCancelFns.delete(t.queryId);
        };
        this.fetchCancelFns.set(t.queryId, function(B) {
          R(), setTimeout(function() {
            return T.cancel(B);
          });
        });
        var T, M;
        if (this.getDocumentInfo(D.query).hasClientExports)
          T = new zv(this.localState.addExportedVariables(D.query, D.variables, D.context).then(A).then(function(B) {
            return B.sources;
          })), M = !0;
        else {
          var F = A(D.variables);
          M = F.fromLink, T = new zv(F.sources);
        }
        return T.promise.then(R, R), {
          concast: T,
          fromLink: M
        };
      }, e.prototype.refetchQueries = function(t) {
        var r = this, n = t.updateCache, i = t.include, u = t.optimistic, s = u === void 0 ? !1 : u, c = t.removeOptimistic, p = c === void 0 ? s ? oP("refetchQueries") : void 0 : c, h = t.onQueryUpdated, v = /* @__PURE__ */ new Map();
        i && this.getObservableQueries(i).forEach(function(x, w) {
          v.set(w, {
            oq: x,
            lastDiff: (r.queries.get(w) || x.queryInfo).getDiff()
          });
        });
        var y = /* @__PURE__ */ new Map();
        return n && this.cache.batch({
          update: n,
          // Since you can perform any combination of cache reads and/or writes in
          // the cache.batch update function, its optimistic option can be either
          // a boolean or a string, representing three distinct modes of
          // operation:
          //
          // * false: read/write only the root layer
          // * true: read/write the topmost layer
          // * string: read/write a fresh optimistic layer with that ID string
          //
          // When typeof optimistic === "string", a new optimistic layer will be
          // temporarily created within cache.batch with that string as its ID. If
          // we then pass that same string as the removeOptimistic option, we can
          // make cache.batch immediately remove the optimistic layer after
          // running the updateCache function, triggering only one broadcast.
          //
          // However, the refetchQueries method accepts only true or false for its
          // optimistic option (not string). We interpret true to mean a temporary
          // optimistic layer should be created, to allow efficiently rolling back
          // the effect of the updateCache function, which involves passing a
          // string instead of true as the optimistic option to cache.batch, when
          // refetchQueries receives optimistic: true.
          //
          // In other words, we are deliberately not supporting the use case of
          // writing to an *existing* optimistic layer (using the refetchQueries
          // updateCache function), since that would potentially interfere with
          // other optimistic updates in progress. Instead, you can read/write
          // only the root layer by passing optimistic: false to refetchQueries,
          // or you can read/write a brand new optimistic layer that will be
          // automatically removed by passing optimistic: true.
          optimistic: s && p || !1,
          // The removeOptimistic option can also be provided by itself, even if
          // optimistic === false, to remove some previously-added optimistic
          // layer safely and efficiently, like we do in markMutationResult.
          //
          // If an explicit removeOptimistic string is provided with optimistic:
          // true, the removeOptimistic string will determine the ID of the
          // temporary optimistic layer, in case that ever matters.
          removeOptimistic: p,
          onWatchUpdated: function(x, w, E) {
            var C = x.watcher instanceof YA && x.watcher.observableQuery;
            if (C) {
              if (h) {
                v.delete(C.queryId);
                var S = h(C, w, E);
                return S === !0 && (S = C.refetch()), S !== !1 && y.set(C, S), S;
              }
              h !== null && v.set(C.queryId, { oq: C, lastDiff: E, diff: w });
            }
          }
        }), v.size && v.forEach(function(x, w) {
          var E = x.oq, C = x.lastDiff, S = x.diff, k;
          h && (S || (S = r.cache.diff(E.queryInfo.getDiffOptions())), k = h(E, S, C)), (!h || k === !0) && (k = E.refetch()), k !== !1 && y.set(E, k), w.indexOf("legacyOneTimeQuery") >= 0 && r.stopQueryNoBroadcast(w);
        }), p && this.cache.removeOptimistic(p), y;
      }, e.prototype.maskOperation = function(t) {
        var r, n, i, u = t.document, s = t.data;
        if (globalThis.__DEV__ !== !1) {
          var c = t.fetchPolicy, p = t.id, h = (r = Mp(u)) === null || r === void 0 ? void 0 : r.operation, v = ((n = h == null ? void 0 : h[0]) !== null && n !== void 0 ? n : "o") + p;
          this.dataMasking && c === "no-cache" && !fre(u) && !this.noCacheWarningsByQueryId.has(v) && (this.noCacheWarningsByQueryId.add(v), globalThis.__DEV__ !== !1 && st.warn(
            37,
            (i = kg(u)) !== null && i !== void 0 ? i : "Unnamed ".concat(h ?? "operation")
          ));
        }
        return this.dataMasking ? fne(s, u, this.cache) : s;
      }, e.prototype.maskFragment = function(t) {
        var r = t.data, n = t.fragment, i = t.fragmentName;
        return this.dataMasking ? l9(r, n, this.cache, i) : r;
      }, e.prototype.fetchQueryByPolicy = function(t, r, n) {
        var i = this, u = r.query, s = r.variables, c = r.fetchPolicy, p = r.refetchWritePolicy, h = r.errorPolicy, v = r.returnPartialData, y = r.context, x = r.notifyOnNetworkStatusChange, w = t.networkStatus;
        t.init({
          document: u,
          variables: s,
          networkStatus: n
        });
        var E = function() {
          return t.getDiff();
        }, C = function(R, T) {
          T === void 0 && (T = t.networkStatus || dr.loading);
          var M = R.result;
          globalThis.__DEV__ !== !1 && !v && !Xr(M, {}) && T9(R.missing);
          var F = function(B) {
            return pn.of(ye({ data: B, loading: Vv(T), networkStatus: T }, R.complete ? null : { partial: !0 }));
          };
          return M && i.getDocumentInfo(u).hasForcedResolvers ? i.localState.runResolvers({
            document: u,
            remoteResult: { data: M },
            context: y,
            variables: s,
            onlyRunForcedResolvers: !0
          }).then(function(B) {
            return F(B.data || void 0);
          }) : h === "none" && T === dr.refetch && Array.isArray(R.missing) ? F(void 0) : F(M);
        }, S = c === "no-cache" ? 0 : n === dr.refetch && p !== "merge" ? 1 : 2, k = function() {
          return i.getResultsFromLink(t, S, {
            query: u,
            variables: s,
            context: y,
            fetchPolicy: c,
            errorPolicy: h
          });
        }, D = x && typeof w == "number" && w !== n && Vv(n);
        switch (c) {
          default:
          case "cache-first": {
            var A = E();
            return A.complete ? {
              fromLink: !1,
              sources: [C(A, t.markReady())]
            } : v || D ? {
              fromLink: !0,
              sources: [C(A), k()]
            } : { fromLink: !0, sources: [k()] };
          }
          case "cache-and-network": {
            var A = E();
            return A.complete || v || D ? {
              fromLink: !0,
              sources: [C(A), k()]
            } : { fromLink: !0, sources: [k()] };
          }
          case "cache-only":
            return {
              fromLink: !1,
              sources: [C(E(), t.markReady())]
            };
          case "network-only":
            return D ? {
              fromLink: !0,
              sources: [C(E()), k()]
            } : { fromLink: !0, sources: [k()] };
          case "no-cache":
            return D ? {
              fromLink: !0,
              // Note that queryInfo.getDiff() for no-cache queries does not call
              // cache.diff, but instead returns a { complete: false } stub result
              // when there is no queryInfo.diff already defined.
              sources: [C(t.getDiff()), k()]
            } : { fromLink: !0, sources: [k()] };
          case "standby":
            return { fromLink: !1, sources: [] };
        }
      }, e.prototype.getOrCreateQuery = function(t) {
        return t && !this.queries.has(t) && this.queries.set(t, new YA(this, t)), this.queries.get(t);
      }, e.prototype.prepareContext = function(t) {
        t === void 0 && (t = {});
        var r = this.localState.prepareContext(t);
        return ye(ye(ye({}, this.defaultContext), r), { clientAwareness: this.clientAwareness });
      }, e;
    }()
  ), cie = (
    /** @class */
    function() {
      function e(t) {
        var r = t.cache, n = t.client, i = t.resolvers, u = t.fragmentMatcher;
        this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = r, n && (this.client = n), i && this.addResolvers(i), u && this.setFragmentMatcher(u);
      }
      return e.prototype.addResolvers = function(t) {
        var r = this;
        this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function(n) {
          r.resolvers = yB(r.resolvers, n);
        }) : this.resolvers = yB(this.resolvers, t);
      }, e.prototype.setResolvers = function(t) {
        this.resolvers = {}, this.addResolvers(t);
      }, e.prototype.getResolvers = function() {
        return this.resolvers || {};
      }, e.prototype.runResolvers = function(t) {
        return kf(this, arguments, void 0, function(r) {
          var n = r.document, i = r.remoteResult, u = r.context, s = r.variables, c = r.onlyRunForcedResolvers, p = c === void 0 ? !1 : c;
          return Rf(this, function(h) {
            return n ? [2, this.resolveDocument(n, i.data, u, s, this.fragmentMatcher, p).then(function(v) {
              return ye(ye({}, i), { data: v.result });
            })] : [2, i];
          });
        });
      }, e.prototype.setFragmentMatcher = function(t) {
        this.fragmentMatcher = t;
      }, e.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
      }, e.prototype.clientQuery = function(t) {
        return Qg(["client"], t) && this.resolvers ? t : null;
      }, e.prototype.serverQuery = function(t) {
        return XU(t);
      }, e.prototype.prepareContext = function(t) {
        var r = this.cache;
        return ye(ye({}, t), {
          cache: r,
          // Getting an entry's cache key is useful for local state resolvers.
          getCacheKey: function(n) {
            return r.identify(n);
          }
        });
      }, e.prototype.addExportedVariables = function(t) {
        return kf(this, arguments, void 0, function(r, n, i) {
          return n === void 0 && (n = {}), i === void 0 && (i = {}), Rf(this, function(u) {
            return r ? [2, this.resolveDocument(r, this.buildRootValueFromCache(r, n) || {}, this.prepareContext(i), n).then(function(s) {
              return ye(ye({}, n), s.exportedVariables);
            })] : [2, ye({}, n)];
          });
        });
      }, e.prototype.shouldForceResolvers = function(t) {
        var r = !1;
        return hs(t, {
          Directive: {
            enter: function(n) {
              if (n.name.value === "client" && n.arguments && (r = n.arguments.some(function(i) {
                return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
              }), r))
                return O_;
            }
          }
        }), r;
      }, e.prototype.buildRootValueFromCache = function(t, r) {
        return this.cache.diff({
          query: Lre(t),
          variables: r,
          returnPartialData: !0,
          optimistic: !1
        }).result;
      }, e.prototype.resolveDocument = function(t, r) {
        return kf(this, arguments, void 0, function(n, i, u, s, c, p) {
          var h, v, y, x, w, E, C, S, k, D, A;
          return u === void 0 && (u = {}), s === void 0 && (s = {}), c === void 0 && (c = function() {
            return !0;
          }), p === void 0 && (p = !1), Rf(this, function(R) {
            return h = Fx(n), v = $0(n), y = B0(v), x = this.collectSelectionsToResolve(h, y), w = h.operation, E = w ? w.charAt(0).toUpperCase() + w.slice(1) : "Query", C = this, S = C.cache, k = C.client, D = {
              fragmentMap: y,
              context: ye(ye({}, u), { cache: S, client: k }),
              variables: s,
              fragmentMatcher: c,
              defaultOperationType: E,
              exportedVariables: {},
              selectionsToResolve: x,
              onlyRunForcedResolvers: p
            }, A = !1, [2, this.resolveSelectionSet(h.selectionSet, A, i, D).then(function(T) {
              return {
                result: T,
                exportedVariables: D.exportedVariables
              };
            })];
          });
        });
      }, e.prototype.resolveSelectionSet = function(t, r, n, i) {
        return kf(this, void 0, void 0, function() {
          var u, s, c, p, h, v = this;
          return Rf(this, function(y) {
            return u = i.fragmentMap, s = i.context, c = i.variables, p = [n], h = function(x) {
              return kf(v, void 0, void 0, function() {
                var w, E;
                return Rf(this, function(C) {
                  return !r && !i.selectionsToResolve.has(x) ? [
                    2
                    /*return*/
                  ] : jx(x, c) ? $f(x) ? [2, this.resolveField(x, r, n, i).then(function(S) {
                    var k;
                    typeof S < "u" && p.push((k = {}, k[gc(x)] = S, k));
                  })] : (jre(x) ? w = x : (w = u[x.name.value], st(w, 19, x.name.value)), w && w.typeCondition && (E = w.typeCondition.name.value, i.fragmentMatcher(n, E, s)) ? [2, this.resolveSelectionSet(w.selectionSet, r, n, i).then(function(S) {
                    p.push(S);
                  })] : [
                    2
                    /*return*/
                  ]) : [
                    2
                    /*return*/
                  ];
                });
              });
            }, [2, Promise.all(t.selections.map(h)).then(function() {
              return k_(p);
            })];
          });
        });
      }, e.prototype.resolveField = function(t, r, n, i) {
        return kf(this, void 0, void 0, function() {
          var u, s, c, p, h, v, y, x, w, E = this;
          return Rf(this, function(C) {
            return n ? (u = i.variables, s = t.name.value, c = gc(t), p = s !== c, h = n[c] || n[s], v = Promise.resolve(h), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (y = n.__typename || i.defaultOperationType, x = this.resolvers && this.resolvers[y], x && (w = x[p ? s : c], w && (v = Promise.resolve(
              // In case the resolve function accesses reactive variables,
              // set cacheSlot to the current cache instance.
              TN.withValue(this.cache, w, [
                n,
                D_(t, u),
                i.context,
                { field: t, fragmentMap: i.fragmentMap }
              ])
            )))), [2, v.then(function(S) {
              var k, D;
              if (S === void 0 && (S = h), t.directives && t.directives.forEach(function(R) {
                R.name.value === "export" && R.arguments && R.arguments.forEach(function(T) {
                  T.name.value === "as" && T.value.kind === "StringValue" && (i.exportedVariables[T.value.value] = S);
                });
              }), !t.selectionSet || S == null)
                return S;
              var A = (D = (k = t.directives) === null || k === void 0 ? void 0 : k.some(function(R) {
                return R.name.value === "client";
              })) !== null && D !== void 0 ? D : !1;
              if (Array.isArray(S))
                return E.resolveSubSelectedArray(t, r || A, S, i);
              if (t.selectionSet)
                return E.resolveSelectionSet(t.selectionSet, r || A, S, i);
            })]) : [2, null];
          });
        });
      }, e.prototype.resolveSubSelectedArray = function(t, r, n, i) {
        var u = this;
        return Promise.all(n.map(function(s) {
          if (s === null)
            return null;
          if (Array.isArray(s))
            return u.resolveSubSelectedArray(t, r, s, i);
          if (t.selectionSet)
            return u.resolveSelectionSet(t.selectionSet, r, s, i);
        }));
      }, e.prototype.collectSelectionsToResolve = function(t, r) {
        var n = function(s) {
          return !Array.isArray(s);
        }, i = this.selectionsToResolveCache;
        function u(s) {
          if (!i.has(s)) {
            var c = /* @__PURE__ */ new Set();
            i.set(s, c), hs(s, {
              Directive: function(p, h, v, y, x) {
                p.name.value === "client" && x.forEach(function(w) {
                  n(w) && hB(w) && c.add(w);
                });
              },
              FragmentSpread: function(p, h, v, y, x) {
                var w = r[p.name.value];
                st(w, 20, p.name.value);
                var E = u(w);
                E.size > 0 && (x.forEach(function(C) {
                  n(C) && hB(C) && c.add(C);
                }), c.add(p), E.forEach(function(C) {
                  c.add(C);
                }));
              }
            });
          }
          return i.get(s);
        }
        return u(t);
      }, e;
    }()
  ), XB = !1, A9 = (
    /** @class */
    function() {
      function e(t) {
        var r = this, n;
        if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !t.cache)
          throw Ya(16);
        var i = t.uri, u = t.credentials, s = t.headers, c = t.cache, p = t.documentTransform, h = t.ssrMode, v = h === void 0 ? !1 : h, y = t.ssrForceFetchDelay, x = y === void 0 ? 0 : y, w = t.connectToDevTools, E = t.queryDeduplication, C = E === void 0 ? !0 : E, S = t.defaultOptions, k = t.defaultContext, D = t.assumeImmutableResults, A = D === void 0 ? c.assumeImmutableResults : D, R = t.resolvers, T = t.typeDefs, M = t.fragmentMatcher, F = t.name, B = t.version, V = t.devtools, H = t.dataMasking, q = t.link;
        q || (q = i ? new aie({ uri: i, credentials: u, headers: s }) : Ix.empty()), this.link = q, this.cache = c, this.disableNetworkFetches = v || x > 0, this.queryDeduplication = C, this.defaultOptions = S || /* @__PURE__ */ Object.create(null), this.typeDefs = T, this.devtoolsConfig = ye(ye({}, V), { enabled: (n = V == null ? void 0 : V.enabled) !== null && n !== void 0 ? n : w }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = globalThis.__DEV__ !== !1), x && setTimeout(function() {
          return r.disableNetworkFetches = !1;
        }, x), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = sN, this.localState = new cie({
          cache: c,
          client: this,
          resolvers: R,
          fragmentMatcher: M
        }), this.queryManager = new lie({
          cache: this.cache,
          link: this.link,
          defaultOptions: this.defaultOptions,
          defaultContext: k,
          documentTransform: p,
          queryDeduplication: C,
          ssrMode: v,
          dataMasking: !!H,
          clientAwareness: {
            name: F,
            version: B
          },
          localState: this.localState,
          assumeImmutableResults: A,
          onBroadcast: this.devtoolsConfig.enabled ? function() {
            r.devToolsHookCb && r.devToolsHookCb({
              action: {},
              state: {
                queries: r.queryManager.getQueryStore(),
                mutations: r.queryManager.mutationStore || {}
              },
              dataWithOptimisticResults: r.cache.extract(!0)
            });
          } : void 0
        }), this.devtoolsConfig.enabled && this.connectToDevTools();
      }
      return e.prototype.connectToDevTools = function() {
        if (!(typeof window > "u")) {
          var t = window, r = Symbol.for("apollo.devtools");
          (t[r] = t[r] || []).push(this), t.__APOLLO_CLIENT__ = this, !XB && globalThis.__DEV__ !== !1 && (XB = !0, window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol) && setTimeout(function() {
            if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
              var n = window.navigator, i = n && n.userAgent, u = void 0;
              typeof i == "string" && (i.indexOf("Chrome/") > -1 ? u = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : i.indexOf("Firefox/") > -1 && (u = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), u && globalThis.__DEV__ !== !1 && st.log("Download the Apollo DevTools for a better development experience: %s", u);
            }
          }, 1e4));
        }
      }, Object.defineProperty(e.prototype, "documentTransform", {
        /**
         * The `DocumentTransform` used to modify GraphQL documents before a request
         * is made. If a custom `DocumentTransform` is not provided, this will be the
         * default document transform.
         */
        get: function() {
          return this.queryManager.documentTransform;
        },
        enumerable: !1,
        configurable: !0
      }), e.prototype.stop = function() {
        this.queryManager.stop();
      }, e.prototype.watchQuery = function(t) {
        return this.defaultOptions.watchQuery && (t = _E(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = ye(ye({}, t), { fetchPolicy: "cache-first" })), this.queryManager.watchQuery(t);
      }, e.prototype.query = function(t) {
        return this.defaultOptions.query && (t = _E(this.defaultOptions.query, t)), st(t.fetchPolicy !== "cache-and-network", 17), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = ye(ye({}, t), { fetchPolicy: "cache-first" })), this.queryManager.query(t);
      }, e.prototype.mutate = function(t) {
        return this.defaultOptions.mutate && (t = _E(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
      }, e.prototype.subscribe = function(t) {
        var r = this, n = this.queryManager.generateQueryId();
        return this.queryManager.startGraphQLSubscription(t).map(function(i) {
          return ye(ye({}, i), { data: r.queryManager.maskOperation({
            document: t.query,
            data: i.data,
            fetchPolicy: t.fetchPolicy,
            id: n
          }) });
        });
      }, e.prototype.readQuery = function(t, r) {
        return r === void 0 && (r = !1), this.cache.readQuery(t, r);
      }, e.prototype.watchFragment = function(t) {
        var r;
        return this.cache.watchFragment(ye(ye({}, t), (r = {}, r[Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, r)));
      }, e.prototype.readFragment = function(t, r) {
        return r === void 0 && (r = !1), this.cache.readFragment(t, r);
      }, e.prototype.writeQuery = function(t) {
        var r = this.cache.writeQuery(t);
        return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
      }, e.prototype.writeFragment = function(t) {
        var r = this.cache.writeFragment(t);
        return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
      }, e.prototype.__actionHookForDevTools = function(t) {
        this.devToolsHookCb = t;
      }, e.prototype.__requestRaw = function(t) {
        return _P(this.link, t);
      }, e.prototype.resetStore = function() {
        var t = this;
        return Promise.resolve().then(function() {
          return t.queryManager.clearStore({
            discardWatches: !1
          });
        }).then(function() {
          return Promise.all(t.resetStoreCallbacks.map(function(r) {
            return r();
          }));
        }).then(function() {
          return t.reFetchObservableQueries();
        });
      }, e.prototype.clearStore = function() {
        var t = this;
        return Promise.resolve().then(function() {
          return t.queryManager.clearStore({
            discardWatches: !0
          });
        }).then(function() {
          return Promise.all(t.clearStoreCallbacks.map(function(r) {
            return r();
          }));
        });
      }, e.prototype.onResetStore = function(t) {
        var r = this;
        return this.resetStoreCallbacks.push(t), function() {
          r.resetStoreCallbacks = r.resetStoreCallbacks.filter(function(n) {
            return n !== t;
          });
        };
      }, e.prototype.onClearStore = function(t) {
        var r = this;
        return this.clearStoreCallbacks.push(t), function() {
          r.clearStoreCallbacks = r.clearStoreCallbacks.filter(function(n) {
            return n !== t;
          });
        };
      }, e.prototype.reFetchObservableQueries = function(t) {
        return this.queryManager.reFetchObservableQueries(t);
      }, e.prototype.refetchQueries = function(t) {
        var r = this.queryManager.refetchQueries(t), n = [], i = [];
        r.forEach(function(s, c) {
          n.push(c), i.push(s);
        });
        var u = Promise.all(i);
        return u.queries = n, u.results = i, u.catch(function(s) {
          globalThis.__DEV__ !== !1 && st.debug(18, s);
        }), u;
      }, e.prototype.getObservableQueries = function(t) {
        return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
      }, e.prototype.extract = function(t) {
        return this.cache.extract(t);
      }, e.prototype.restore = function(t) {
        return this.cache.restore(t);
      }, e.prototype.addResolvers = function(t) {
        this.localState.addResolvers(t);
      }, e.prototype.setResolvers = function(t) {
        this.localState.setResolvers(t);
      }, e.prototype.getResolvers = function() {
        return this.localState.getResolvers();
      }, e.prototype.setLocalStateFragmentMatcher = function(t) {
        this.localState.setFragmentMatcher(t);
      }, e.prototype.setLink = function(t) {
        this.link = this.queryManager.link = t;
      }, Object.defineProperty(e.prototype, "defaultContext", {
        get: function() {
          return this.queryManager.defaultContext;
        },
        enumerable: !1,
        configurable: !0
      }), e;
    }()
  );
  globalThis.__DEV__ !== !1 && (A9.prototype.getMemoryInternals = hre);
  var TE = /* @__PURE__ */ new Map(), TP = /* @__PURE__ */ new Map(), D9 = !0, mS = !1;
  function k9(e) {
    return e.replace(/[\s,]+/g, " ").trim();
  }
  function fie(e) {
    return k9(e.source.body.substring(e.start, e.end));
  }
  function die(e) {
    var t = /* @__PURE__ */ new Set(), r = [];
    return e.definitions.forEach(function(n) {
      if (n.kind === "FragmentDefinition") {
        var i = n.name.value, u = fie(n.loc), s = TP.get(i);
        s && !s.has(u) ? D9 && console.warn("Warning: fragment with name " + i + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : s || TP.set(i, s = /* @__PURE__ */ new Set()), s.add(u), t.has(u) || (t.add(u), r.push(n));
      } else
        r.push(n);
    }), ye(ye({}, e), { definitions: r });
  }
  function pie(e) {
    var t = new Set(e.definitions);
    t.forEach(function(n) {
      n.loc && delete n.loc, Object.keys(n).forEach(function(i) {
        var u = n[i];
        u && typeof u == "object" && t.add(u);
      });
    });
    var r = e.loc;
    return r && (delete r.startToken, delete r.endToken), e;
  }
  function hie(e) {
    var t = k9(e);
    if (!TE.has(t)) {
      var r = Yte(e, {
        experimentalFragmentVariables: mS,
        allowLegacyFragmentVariables: mS
      });
      if (!r || r.kind !== "Document")
        throw new Error("Not a valid GraphQL document.");
      TE.set(t, pie(die(r)));
    }
    return TE.get(t);
  }
  function s0(e) {
    for (var t = [], r = 1; r < arguments.length; r++)
      t[r - 1] = arguments[r];
    typeof e == "string" && (e = [e]);
    var n = e[0];
    return t.forEach(function(i, u) {
      i && i.kind === "Document" ? n += i.loc.source.body : n += i, n += e[u + 1];
    }), hie(n);
  }
  function vie() {
    TE.clear(), TP.clear();
  }
  function mie() {
    D9 = !1;
  }
  function yie() {
    mS = !0;
  }
  function gie() {
    mS = !1;
  }
  var vg = {
    gql: s0,
    resetCaches: vie,
    disableFragmentWarnings: mie,
    enableExperimentalFragmentVariables: yie,
    disableExperimentalFragmentVariables: gie
  };
  (function(e) {
    e.gql = vg.gql, e.resetCaches = vg.resetCaches, e.disableFragmentWarnings = vg.disableFragmentWarnings, e.enableExperimentalFragmentVariables = vg.enableExperimentalFragmentVariables, e.disableExperimentalFragmentVariables = vg.disableExperimentalFragmentVariables;
  })(s0 || (s0 = {}));
  s0.default = s0;
  var GA = { exports: {} }, ZB;
  function xie() {
    return ZB || (ZB = 1, function(e) {
      e.exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = void 0, e.exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = void 0, e.exports.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = void 0, Object.assign(e.exports, F0());
    }(GA)), GA.exports;
  }
  var ci = xie();
  const bie = /* @__PURE__ */ Zr(ci), R9 = /* @__PURE__ */ fU({
    __proto__: null,
    default: bie
  }, [ci]);
  var JB = yN ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
  function PN() {
    st("createContext" in R9, 54);
    var e = ci.createContext[JB];
    return e || (Object.defineProperty(ci.createContext, JB, {
      value: e = ci.createContext({}),
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), e.displayName = "ApolloContext"), e;
  }
  var wie = function(e) {
    var t = e.client, r = e.children, n = PN(), i = ci.useContext(n), u = ci.useMemo(function() {
      return ye(ye({}, i), { client: t || i.client });
    }, [i, t]);
    return st(u.client, 55), ci.createElement(n.Provider, { value: u }, r);
  };
  function P9(e) {
    var t = ci.useContext(PN()), r = e || t.client;
    return st(!!r, 58), r;
  }
  var e3 = !1, Eie = "useSyncExternalStore", Sie = R9[Eie], _ie = Sie || function(e, t, r) {
    var n = t();
    // DEVIATION: Using __DEV__
    globalThis.__DEV__ !== !1 && !e3 && // DEVIATION: Not using Object.is because we know our snapshots will never
    // be exotic primitive values like NaN, which is !== itself.
    n !== t() && (e3 = !0, globalThis.__DEV__ !== !1 && st.error(68));
    var i = ci.useState({
      inst: { value: n, getSnapshot: t }
    }), u = i[0].inst, s = i[1];
    return lre ? ci.useLayoutEffect(function() {
      Object.assign(u, { value: n, getSnapshot: t }), QA(u) && s({ inst: u });
    }, [e, n, t]) : Object.assign(u, { value: n, getSnapshot: t }), ci.useEffect(function() {
      return QA(u) && s({ inst: u }), e(function() {
        QA(u) && s({ inst: u });
      });
    }, [e]), n;
  };
  function QA(e) {
    var t = e.value, r = e.getSnapshot;
    try {
      return t !== r();
    } catch {
      return !0;
    }
  }
  var hc;
  (function(e) {
    e[e.Query = 0] = "Query", e[e.Mutation = 1] = "Mutation", e[e.Subscription = 2] = "Subscription";
  })(hc || (hc = {}));
  var Cp;
  function t3(e) {
    var t;
    switch (e) {
      case hc.Query:
        t = "Query";
        break;
      case hc.Mutation:
        t = "Mutation";
        break;
      case hc.Subscription:
        t = "Subscription";
        break;
    }
    return t;
  }
  function M9(e) {
    Cp || (Cp = new gN(
      cl.parser || 1e3
      /* defaultCacheSizes.parser */
    ));
    var t = Cp.get(e);
    if (t)
      return t;
    var r, n, i;
    st(!!e && !!e.kind, 70, e);
    for (var u = [], s = [], c = [], p = [], h = 0, v = e.definitions; h < v.length; h++) {
      var y = v[h];
      if (y.kind === "FragmentDefinition") {
        u.push(y);
        continue;
      }
      if (y.kind === "OperationDefinition")
        switch (y.operation) {
          case "query":
            s.push(y);
            break;
          case "mutation":
            c.push(y);
            break;
          case "subscription":
            p.push(y);
            break;
        }
    }
    st(!u.length || s.length || c.length || p.length, 71), st(
      s.length + c.length + p.length <= 1,
      72,
      e,
      s.length,
      p.length,
      c.length
    ), n = s.length ? hc.Query : hc.Mutation, !s.length && !c.length && (n = hc.Subscription);
    var x = s.length ? s : c.length ? c : p;
    st(x.length === 1, 73, e, x.length);
    var w = x[0];
    r = w.variableDefinitions || [], w.name && w.name.kind === "Name" ? i = w.name.value : i = "data";
    var E = { name: i, type: n, variables: r };
    return Cp.set(e, E), E;
  }
  M9.resetCache = function() {
    Cp = void 0;
  };
  globalThis.__DEV__ !== !1 && xN("parser", function() {
    return Cp ? Cp.size : 0;
  });
  function Cie(e, t) {
    var r = M9(e), n = t3(t), i = t3(r.type);
    st(
      r.type === t,
      74,
      n,
      n,
      i
    );
  }
  var Oie = Symbol.for("apollo.hook.wrappers");
  function Tie(e, t, r) {
    var n = r.queryManager, i = n && n[Oie], u = i && i[e];
    return u ? u(t) : t;
  }
  var Aie = Object.prototype.hasOwnProperty;
  function r3() {
  }
  var AE = Symbol();
  function Die(e, t) {
    return t === void 0 && (t = /* @__PURE__ */ Object.create(null)), Tie(
      "useQuery",
      // eslint-disable-next-line react-compiler/react-compiler
      kie,
      P9(t && t.client)
    )(e, t);
  }
  function kie(e, t) {
    var r = Pie(e, t), n = r.result, i = r.obsQueryFields;
    return ci.useMemo(function() {
      return ye(ye({}, n), i);
    }, [n, i]);
  }
  function Rie(e, t, r, n, i) {
    function u(y) {
      var x;
      Cie(t, hc.Query);
      var w = {
        client: e,
        query: t,
        observable: (
          // See if there is an existing observable that was used to fetch the same
          // data and if so, use it instead since it will contain the proper queryId
          // to fetch the result set. This is used during SSR.
          n && n.getSSRObservable(i()) || Lg.inactiveOnCreation.withValue(!n, function() {
            return e.watchQuery(N9(void 0, e, r, i()));
          })
        ),
        resultData: {
          // Reuse previousData from previous InternalState (if any) to provide
          // continuity of previousData even if/when the query or client changes.
          previousData: (x = y == null ? void 0 : y.resultData.current) === null || x === void 0 ? void 0 : x.data
        }
      };
      return w;
    }
    var s = ci.useState(u), c = s[0], p = s[1];
    function h(y) {
      var x, w;
      Object.assign(c.observable, (x = {}, x[AE] = y, x));
      var E = c.resultData;
      p(ye(ye({}, c), {
        // might be a different query
        query: y.query,
        resultData: Object.assign(E, {
          // We need to modify the previous `resultData` object as we rely on the
          // object reference in other places
          previousData: ((w = E.current) === null || w === void 0 ? void 0 : w.data) || E.previousData,
          current: void 0
        })
      }));
    }
    if (e !== c.client || t !== c.query) {
      var v = u(c);
      return p(v), [v, h];
    }
    return [c, h];
  }
  function Pie(e, t) {
    var r = P9(t.client), n = ci.useContext(PN()).renderPromises, i = !!n, u = r.disableNetworkFetches, s = t.ssr !== !1 && !t.skip, c = t.partialRefetch, p = Fie(r, e, t, i), h = Rie(r, e, t, n, p), v = h[0], y = v.observable, x = v.resultData, w = h[1], E = p(y);
    jie(
      x,
      // might get mutated during render
      y,
      // might get mutated during render
      r,
      t,
      E
    );
    var C = ci.useMemo(function() {
      return $ie(y);
    }, [y]);
    Nie(y, n, s);
    var S = Mie(x, y, r, t, E, u, c, i, {
      onCompleted: t.onCompleted || r3,
      onError: t.onError || r3
    });
    return {
      result: S,
      obsQueryFields: C,
      observable: y,
      resultData: x,
      client: r,
      onQueryExecuted: w
    };
  }
  function Mie(e, t, r, n, i, u, s, c, p) {
    var h = ci.useRef(p);
    ci.useEffect(function() {
      h.current = p;
    });
    var v = (c || u) && n.ssr === !1 && !n.skip ? (
      // If SSR has been explicitly disabled, and this function has been called
      // on the server side, return the default loading state.
      F9
    ) : n.skip || i.fetchPolicy === "standby" ? (
      // When skipping a query (ie. we're not querying for data but still want to
      // render children), make sure the `data` is cleared out and `loading` is
      // set to `false` (since we aren't loading anything).
      //
      // NOTE: We no longer think this is the correct behavior. Skipping should
      // not automatically set `data` to `undefined`, but instead leave the
      // previous data in place. In other words, skipping should not mandate that
      // previously received data is all of a sudden removed. Unfortunately,
      // changing this is breaking, so we'll have to wait until Apollo Client 4.0
      // to address this.
      I9
    ) : void 0, y = e.previousData, x = ci.useMemo(function() {
      return v && j9(v, y, t, r);
    }, [r, t, v, y]);
    return _ie(ci.useCallback(function(w) {
      if (c)
        return function() {
        };
      var E = function() {
        var k = e.current, D = t.getCurrentResult();
        k && k.loading === D.loading && k.networkStatus === D.networkStatus && Xr(k.data, D.data) || AP(D, e, t, r, s, w, h.current);
      }, C = function(k) {
        if (S.current.unsubscribe(), S.current = t.resubscribeAfterError(E, C), !Aie.call(k, "graphQLErrors"))
          throw k;
        var D = e.current;
        (!D || D && D.loading || !Xr(k, D.error)) && AP({
          data: D && D.data,
          error: k,
          loading: !1,
          networkStatus: dr.error
        }, e, t, r, s, w, h.current);
      }, S = { current: t.subscribe(E, C) };
      return function() {
        setTimeout(function() {
          return S.current.unsubscribe();
        });
      };
    }, [
      u,
      c,
      t,
      e,
      s,
      r
    ]), function() {
      return x || n3(e, t, h.current, s, r);
    }, function() {
      return x || n3(e, t, h.current, s, r);
    });
  }
  function Nie(e, t, r) {
    t && r && (t.registerSSRObservable(e), e.getCurrentResult().loading && t.addObservableQueryPromise(e));
  }
  function jie(e, t, r, n, i) {
    var u;
    t[AE] && !Xr(t[AE], i) && (t.reobserve(N9(t, r, n, i)), e.previousData = ((u = e.current) === null || u === void 0 ? void 0 : u.data) || e.previousData, e.current = void 0), t[AE] = i;
  }
  function Fie(e, t, r, n) {
    r === void 0 && (r = {});
    var i = r.skip;
    r.ssr, r.onCompleted, r.onError;
    var u = r.defaultOptions, s = ps(r, ["skip", "ssr", "onCompleted", "onError", "defaultOptions"]);
    return function(c) {
      var p = Object.assign(s, { query: t });
      return n && (p.fetchPolicy === "network-only" || p.fetchPolicy === "cache-and-network") && (p.fetchPolicy = "cache-first"), p.variables || (p.variables = {}), i ? (p.initialFetchPolicy = p.initialFetchPolicy || p.fetchPolicy || i3(u, e.defaultOptions), p.fetchPolicy = "standby") : p.fetchPolicy || (p.fetchPolicy = (c == null ? void 0 : c.options.initialFetchPolicy) || i3(u, e.defaultOptions)), p;
    };
  }
  function N9(e, t, r, n) {
    var i = [], u = t.defaultOptions.watchQuery;
    return u && i.push(u), r.defaultOptions && i.push(r.defaultOptions), i.push(Np(e && e.options, n)), i.reduce(_E);
  }
  function AP(e, t, r, n, i, u, s) {
    var c = t.current;
    c && c.data && (t.previousData = c.data), !e.error && Cu(e.errors) && (e.error = new cc({ graphQLErrors: e.errors })), t.current = j9(Lie(e, r, i), t.previousData, r, n), u(), Iie(e, c == null ? void 0 : c.networkStatus, s);
  }
  function Iie(e, t, r) {
    if (!e.loading) {
      var n = Bie(e);
      Promise.resolve().then(function() {
        n ? r.onError(n) : e.data && t !== e.networkStatus && e.networkStatus === dr.ready && r.onCompleted(e.data);
      }).catch(function(i) {
        globalThis.__DEV__ !== !1 && st.warn(i);
      });
    }
  }
  function n3(e, t, r, n, i) {
    return e.current || AP(t.getCurrentResult(), e, t, i, n, function() {
    }, r), e.current;
  }
  function i3(e, t) {
    var r;
    return (e == null ? void 0 : e.fetchPolicy) || ((r = t == null ? void 0 : t.watchQuery) === null || r === void 0 ? void 0 : r.fetchPolicy) || "cache-first";
  }
  function Bie(e) {
    return Cu(e.errors) ? new cc({ graphQLErrors: e.errors }) : e.error;
  }
  function j9(e, t, r, n) {
    var i = e.data;
    e.partial;
    var u = ps(e, ["data", "partial"]), s = ye(ye({ data: i }, u), { client: n, observable: r, variables: r.variables, called: e !== F9 && e !== I9, previousData: t });
    return s;
  }
  function Lie(e, t, r) {
    return e.partial && r && !e.loading && (!e.data || Object.keys(e.data).length === 0) && t.options.fetchPolicy !== "cache-only" ? (t.refetch(), ye(ye({}, e), { loading: !0, networkStatus: dr.refetch })) : e;
  }
  var F9 = u0({
    loading: !0,
    data: void 0,
    error: void 0,
    networkStatus: dr.loading
  }), I9 = u0({
    loading: !1,
    data: void 0,
    error: void 0,
    networkStatus: dr.ready
  });
  function $ie(e) {
    return {
      refetch: e.refetch.bind(e),
      reobserve: e.reobserve.bind(e),
      fetchMore: e.fetchMore.bind(e),
      updateQuery: e.updateQuery.bind(e),
      startPolling: e.startPolling.bind(e),
      stopPolling: e.stopPolling.bind(e),
      subscribeToMore: e.subscribeToMore.bind(e)
    };
  }
  const zie = (
    // This file is used by the error message display website and the
    // @apollo/client/includeErrors entry point.
    // This file is not meant to be imported manually.
    {
      2: {
        file: "@apollo/client/cache/inmemory/entityStore.js",
        condition: 'typeof dataId === "string"',
        message: "store.merge expects a string ID"
      },
      5: {
        file: "@apollo/client/cache/inmemory/key-extractor.js",
        condition: "extracted !== void 0",
        message: "Missing field '%s' while extracting keyFields from %s"
      },
      6: {
        file: "@apollo/client/cache/inmemory/policies.js",
        condition: "!old || old === which",
        message: "Cannot change root %s __typename more than once"
      },
      9: {
        file: "@apollo/client/cache/inmemory/policies.js",
        message: "Cannot automatically merge arrays"
      },
      10: {
        file: "@apollo/client/cache/inmemory/readFromStore.js",
        message: "No fragment named %s"
      },
      11: {
        file: "@apollo/client/cache/inmemory/readFromStore.js",
        condition: "!isReference(value)",
        message: "Missing selection set for object of type %s returned for query field %s"
      },
      12: {
        file: "@apollo/client/cache/inmemory/writeToStore.js",
        message: "Could not identify object %s"
      },
      14: {
        file: "@apollo/client/cache/inmemory/writeToStore.js",
        message: "No fragment named %s"
      },
      16: {
        file: "@apollo/client/core/ApolloClient.js",
        message: `To initialize Apollo Client, you must specify a 'cache' property in the options object. 
For more information, please visit: https://go.apollo.dev/c/docs`
      },
      17: {
        file: "@apollo/client/core/ApolloClient.js",
        condition: 'options.fetchPolicy !== "cache-and-network"',
        message: "The cache-and-network fetchPolicy does not work with client.query, because client.query can only return a single result. Please use client.watchQuery to receive multiple results from the cache and the network, or consider using a different fetchPolicy, such as cache-first or network-only."
      },
      19: {
        file: "@apollo/client/core/LocalState.js",
        condition: "fragment",
        message: "No fragment named %s"
      },
      20: {
        file: "@apollo/client/core/LocalState.js",
        condition: "fragment",
        message: "No fragment named %s"
      },
      22: {
        file: "@apollo/client/core/ObservableQuery.js",
        condition: "updateQuery",
        message: "You must provide an `updateQuery` function when using `fetchMore` with a `no-cache` fetch policy."
      },
      24: {
        file: "@apollo/client/core/ObservableQuery.js",
        condition: "pollInterval",
        message: "Attempted to start a polling query without a polling interval."
      },
      27: {
        file: "@apollo/client/core/QueryManager.js",
        message: "QueryManager stopped while query was in flight"
      },
      28: {
        file: "@apollo/client/core/QueryManager.js",
        condition: "mutation",
        message: "mutation option is required. You must specify your GraphQL document in the mutation option."
      },
      29: {
        file: "@apollo/client/core/QueryManager.js",
        condition: 'fetchPolicy === "network-only" || fetchPolicy === "no-cache"',
        message: "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write."
      },
      30: {
        file: "@apollo/client/core/QueryManager.js",
        condition: "options.query",
        message: "query option is required. You must specify your GraphQL document in the query option."
      },
      31: {
        file: "@apollo/client/core/QueryManager.js",
        condition: 'options.query.kind === "Document"',
        message: 'You must wrap the query string in a "gql" tag.'
      },
      32: {
        file: "@apollo/client/core/QueryManager.js",
        condition: "!options.returnPartialData",
        message: "returnPartialData option only supported on watchQuery."
      },
      33: {
        file: "@apollo/client/core/QueryManager.js",
        condition: "!options.pollInterval",
        message: "pollInterval option only supported on watchQuery."
      },
      34: {
        file: "@apollo/client/core/QueryManager.js",
        message: "Store reset while query was in flight (not completed in link chain)"
      },
      39: {
        file: "@apollo/client/link/core/ApolloLink.js",
        message: "request is not implemented"
      },
      40: {
        file: "@apollo/client/link/http/checkFetcher.js",
        message: `
"fetch" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:

import fetch from 'cross-fetch';
import { ApolloClient, HttpLink } from '@apollo/client';
const client = new ApolloClient({
  link: new HttpLink({ uri: '/graphql', fetch })
});
    `
      },
      42: {
        file: "@apollo/client/link/http/serializeFetchParameter.js",
        message: "Network request failed. %s is not serializable: %s"
      },
      43: {
        file: "@apollo/client/link/persisted-queries/index.js",
        condition: `options &&
    (typeof options.sha256 === "function" ||
        typeof options.generateHash === "function")`,
        message: 'Missing/invalid "sha256" or "generateHash" function. Please configure one using the "createPersistedQueryLink(options)" options parameter.'
      },
      44: {
        file: "@apollo/client/link/persisted-queries/index.js",
        condition: "forward",
        message: "PersistedQueryLink cannot be the last link in the chain."
      },
      46: {
        file: "@apollo/client/link/utils/validateOperation.js",
        message: "illegal argument: %s"
      },
      47: {
        file: "@apollo/client/masking/maskDefinition.js",
        condition: "fragment",
        message: "Could not find fragment with name '%s'."
      },
      49: {
        file: "@apollo/client/masking/maskFragment.js",
        condition: "fragments.length === 1",
        message: "Found %s fragments. `fragmentName` must be provided when there is not exactly 1 fragment."
      },
      50: {
        file: "@apollo/client/masking/maskFragment.js",
        condition: "!!fragment",
        message: 'Could not find fragment with name "%s".'
      },
      51: {
        file: "@apollo/client/masking/maskOperation.js",
        condition: "definition",
        message: "Expected a parsed GraphQL document with a query, mutation, or subscription."
      },
      53: {
        file: "@apollo/client/react/context/ApolloConsumer.js",
        condition: "context && context.client",
        message: 'Could not find "client" in the context of ApolloConsumer. Wrap the root component in an <ApolloProvider>.'
      },
      54: {
        file: "@apollo/client/react/context/ApolloContext.js",
        condition: '"createContext" in React',
        message: 'Invoking `getApolloContext` in an environment where `React.createContext` is not available.\nThe Apollo Client functionality you are trying to use is only available in React Client Components.\nPlease make sure to add "use client" at the top of your file.\nFor more information, see https://nextjs.org/docs/getting-started/react-essentials#client-components'
      },
      55: {
        file: "@apollo/client/react/context/ApolloProvider.js",
        condition: "context.client",
        message: 'ApolloProvider was not passed a client instance. Make sure you pass in your client via the "client" prop.'
      },
      56: {
        file: "@apollo/client/react/hoc/hoc-utils.js",
        condition: "this.withRef",
        message: "To access the wrapped instance, you need to specify { withRef: true } in the options"
      },
      57: {
        file: "@apollo/client/react/hoc/withApollo.js",
        condition: "operationOptions.withRef",
        message: "To access the wrapped instance, you need to specify { withRef: true } in the options"
      },
      58: {
        file: "@apollo/client/react/hooks/useApolloClient.js",
        condition: "!!client",
        message: 'Could not find "client" in the context or passed in as an option. Wrap the root component in an <ApolloProvider>, or pass an ApolloClient instance in via options.'
      },
      59: {
        file: "@apollo/client/react/hooks/useLoadableQuery.js",
        condition: "!calledDuringRender()",
        message: "useLoadableQuery: 'loadQuery' should not be called during render. To start a query during render, use the 'useBackgroundQuery' hook."
      },
      60: {
        file: "@apollo/client/react/hooks/useLoadableQuery.js",
        condition: "internalQueryRef",
        message: "The query has not been loaded. Please load the query."
      },
      65: {
        file: "@apollo/client/react/hooks/useSubscription.js",
        condition: "!optionsRef.current.skip",
        message: "A subscription that is skipped cannot be restarted."
      },
      66: {
        file: "@apollo/client/react/hooks/useSuspenseQuery.js",
        condition: "supportedFetchPolicies.includes(fetchPolicy)",
        message: "The fetch policy `%s` is not supported with suspense."
      },
      69: {
        file: "@apollo/client/react/internal/cache/QueryReference.js",
        condition: "!queryRef || QUERY_REFERENCE_SYMBOL in queryRef",
        message: "Expected a QueryRef object, but got something else instead."
      },
      70: {
        file: "@apollo/client/react/parser/index.js",
        condition: "!!document && !!document.kind",
        message: "Argument of %s passed to parser was not a valid GraphQL DocumentNode. You may need to use 'graphql-tag' or another method to convert your operation into a document"
      },
      71: {
        file: "@apollo/client/react/parser/index.js",
        condition: `!fragments.length ||
    queries.length ||
    mutations.length ||
    subscriptions.length`,
        message: "Passing only a fragment to 'graphql' is not yet supported. You must include a query, subscription or mutation as well"
      },
      72: {
        file: "@apollo/client/react/parser/index.js",
        condition: "queries.length + mutations.length + subscriptions.length <= 1",
        message: "react-apollo only supports a query, subscription, or a mutation per HOC. %s had %s queries, %s subscriptions and %s mutations. You can use 'compose' to join multiple operation types to a component"
      },
      73: {
        file: "@apollo/client/react/parser/index.js",
        condition: "definitions.length === 1",
        message: "react-apollo only supports one definition per HOC. %s had %s definitions. You can use 'compose' to join multiple operation types to a component"
      },
      74: {
        file: "@apollo/client/react/parser/index.js",
        condition: "operation.type === type",
        message: "Running a %s requires a graphql %s, but a %s was used instead."
      },
      75: {
        file: "@apollo/client/testing/core/mocking/mockLink.js",
        condition: "queryWithoutClientOnlyDirectives",
        message: "query is required"
      },
      76: {
        file: "@apollo/client/testing/core/mocking/mockLink.js",
        condition: "mockedResponse.maxUsageCount > 0",
        message: "Mock response maxUsageCount must be greater than 0, %s given"
      },
      77: {
        file: "@apollo/client/utilities/graphql/DocumentTransform.js",
        condition: "Array.isArray(cacheKeys)",
        message: "`getCacheKey` must return an array or undefined"
      },
      78: {
        file: "@apollo/client/utilities/graphql/directives.js",
        condition: "evaledValue !== void 0",
        message: "Invalid variable referenced in @%s directive."
      },
      79: {
        file: "@apollo/client/utilities/graphql/directives.js",
        condition: "directiveArguments && directiveArguments.length === 1",
        message: "Incorrect number of arguments for the @%s directive."
      },
      80: {
        file: "@apollo/client/utilities/graphql/directives.js",
        condition: 'ifArgument.name && ifArgument.name.value === "if"',
        message: "Invalid argument for the @%s directive."
      },
      81: {
        file: "@apollo/client/utilities/graphql/directives.js",
        condition: `ifValue &&
    (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue")`,
        message: "Argument for the @%s directive must be a variable or a boolean value."
      },
      85: {
        file: "@apollo/client/utilities/graphql/fragments.js",
        message: "Found a %s operation%s. No operations are allowed when using a fragment as a query. Only fragments are allowed."
      },
      86: {
        file: "@apollo/client/utilities/graphql/fragments.js",
        condition: "fragments.length === 1",
        message: "Found %s fragments. `fragmentName` must be provided when there is not exactly 1 fragment."
      },
      87: {
        file: "@apollo/client/utilities/graphql/fragments.js",
        condition: "fragment",
        message: "No fragment named %s"
      },
      88: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: 'doc && doc.kind === "Document"',
        message: 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql'
      },
      89: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        message: 'Schema type definitions not allowed in queries. Found: "%s"'
      },
      90: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: "operations.length <= 1",
        message: "Ambiguous GraphQL document: contains %s operations"
      },
      91: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: 'queryDef && queryDef.operation === "query"',
        message: "Must contain a query definition."
      },
      92: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: 'doc.kind === "Document"',
        message: 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql'
      },
      93: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: "doc.definitions.length <= 1",
        message: "Fragment must have exactly one definition."
      },
      94: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: 'fragmentDef.kind === "FragmentDefinition"',
        message: "Must be a fragment definition."
      },
      95: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        message: "Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment."
      },
      96: {
        file: "@apollo/client/utilities/graphql/storeUtils.js",
        message: 'The inline argument "%s" of kind "%s"is not supported. Use variables instead of inline arguments to overcome this limitation.'
      }
    }
  ), qie = {
    18: {
      file: "@apollo/client/core/ApolloClient.js",
      message: "In client.refetchQueries, Promise.all promise rejected with error %o"
    },
    26: {
      file: "@apollo/client/core/ObservableQuery.js",
      message: "Missing cache result fields: %o"
    }
  }, Uie = {}, Hie = {
    1: {
      file: "@apollo/client/cache/core/cache.js",
      message: "Could not identify object passed to `from` for '%s' fragment, either because the object is non-normalized or the key fields are missing. If you are masking this object, please ensure the key fields are requested by the parent object."
    },
    3: {
      file: "@apollo/client/cache/inmemory/entityStore.js",
      message: "cache.modify: You are trying to write a Reference that is not part of the store: %o\nPlease make sure to set the `mergeIntoStore` parameter to `true` when creating a Reference that is not part of the store yet:\n`toReference(object, true)`"
    },
    4: {
      file: "@apollo/client/cache/inmemory/entityStore.js",
      message: "cache.modify: Writing an array with a mix of both References and Objects will not result in the Objects being normalized correctly.\nPlease convert the object instance %o to a Reference before writing it to the cache by calling `toReference(object, true)`."
    },
    7: {
      file: "@apollo/client/cache/inmemory/policies.js",
      message: "Inferring subtype %s of supertype %s"
    },
    8: {
      file: "@apollo/client/cache/inmemory/policies.js",
      message: "Undefined 'from' passed to readField with arguments %s"
    },
    15: {
      file: "@apollo/client/cache/inmemory/writeToStore.js",
      message: `Cache data may be lost when replacing the %s field of a %s object.

This could cause additional (usually avoidable) network requests to fetch data that were otherwise cached.

To address this problem (which is not a bug in Apollo Client), %sdefine a custom merge function for the %s field, so InMemoryCache can safely merge these objects:

  existing: %o
  incoming: %o

For more information about these options, please refer to the documentation:

  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers
  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects
`
    },
    21: {
      file: "@apollo/client/core/ObservableQuery.js",
      message: `Called refetch(%o) for query %o, which does not declare a $variables variable.
Did you mean to call refetch(variables) instead of refetch({ variables })?`
    },
    35: {
      file: "@apollo/client/core/QueryManager.js",
      message: 'Unknown query named "%s" requested in refetchQueries options.include array'
    },
    36: {
      file: "@apollo/client/core/QueryManager.js",
      message: "Unknown anonymous query requested in refetchQueries options.include array"
    },
    37: {
      file: "@apollo/client/core/QueryManager.js",
      message: '[%s]: Fragments masked by data masking are inaccessible when using fetch policy "no-cache". Please add `@unmask` to each fragment spread to access the data.'
    },
    38: {
      file: "@apollo/client/link/core/ApolloLink.js",
      message: "You are calling concat on a terminating link, which will have no effect %o"
    },
    41: {
      file: "@apollo/client/link/http/createHttpLink.js",
      message: "Multipart-subscriptions do not support @defer"
    },
    45: {
      file: "@apollo/client/link/utils/toPromise.js",
      message: "Promise Wrapper does not support multiple results from Observable"
    },
    48: {
      file: "@apollo/client/masking/maskDefinition.js",
      message: "Accessing unmasked field on %s at path '%s'. This field will not be available when masking is enabled. Please read the field from the fragment instead."
    },
    52: {
      file: "@apollo/client/masking/utils.js",
      message: "The configured cache does not support data masking which effectively disables it. Please use a cache that supports data masking or disable data masking to silence this warning."
    },
    61: {
      file: "@apollo/client/react/hooks/useSubscription.js",
      message: "'useSubscription' supports only the 'onSubscriptionData' or 'onData' option, but not both. Only the 'onData' option will be used."
    },
    62: {
      file: "@apollo/client/react/hooks/useSubscription.js",
      message: "'onSubscriptionData' is deprecated and will be removed in a future major version. Please use the 'onData' option instead."
    },
    63: {
      file: "@apollo/client/react/hooks/useSubscription.js",
      message: "'useSubscription' supports only the 'onSubscriptionComplete' or 'onComplete' option, but not both. Only the 'onComplete' option will be used."
    },
    64: {
      file: "@apollo/client/react/hooks/useSubscription.js",
      message: "'onSubscriptionComplete' is deprecated and will be removed in a future major version. Please use the 'onComplete' option instead."
    },
    67: {
      file: "@apollo/client/react/hooks/useSuspenseQuery.js",
      message: "Using `returnPartialData` with a `no-cache` fetch policy has no effect. To read partial data from the cache, consider using an alternate fetch policy."
    },
    82: {
      file: "@apollo/client/utilities/graphql/directives.js",
      message: "@unmask 'mode' argument does not support variables."
    },
    83: {
      file: "@apollo/client/utilities/graphql/directives.js",
      message: "@unmask 'mode' argument must be of type string."
    },
    84: {
      file: "@apollo/client/utilities/graphql/directives.js",
      message: "@unmask 'mode' argument does not recognize value '%s'."
    },
    98: {
      file: "@apollo/client/utilities/graphql/transform.js",
      message: "Removing an @connection directive even though it does not have a key. You may want to use the key parameter to specify a store key."
    }
  }, Vie = {
    13: {
      file: "@apollo/client/cache/inmemory/writeToStore.js",
      message: "Missing field '%s' while writing result %o"
    },
    23: {
      file: "@apollo/client/core/ObservableQuery.js",
      message: "Unhandled GraphQL subscription error"
    },
    25: {
      file: "@apollo/client/core/ObservableQuery.js",
      message: "Unhandled error"
    },
    68: {
      file: "@apollo/client/react/hooks/useSyncExternalStore.js",
      message: "The result of getSnapshot should be cached to avoid an infinite loop"
    },
    97: {
      file: "@apollo/client/utilities/graphql/transform.js",
      message: "Could not find operation or fragment"
    }
  };
  function Wie(e) {
    Vg[dS] = e;
  }
  function B9() {
    for (var e = [], t = 0; t < arguments.length; t++)
      e[t] = arguments[t];
    Wie(KA);
    for (var r = 0, n = e; r < n.length; r++) {
      var i = n[r];
      Object.assign(KA, i);
    }
    return KA;
  }
  var KA = function(e, t) {
    if (typeof e == "number") {
      var r = Vg[dS][e];
      if (!e || !(r != null && r.message))
        return;
      e = r.message;
    }
    return t.reduce(function(n, i) {
      return n.replace(/%[sdfo]/, String(i));
    }, String(e));
  };
  function Yie() {
    B9(qie, Vie, Uie, Hie);
  }
  function Gie() {
    B9(zie);
  }
  var DE = { exports: {} };
  function Qie(e) {
    throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
  }
  var kE = { exports: {} };
  const Kie = {}, Xie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: Kie
  }, Symbol.toStringTag, { value: "Module" })), Zie = /* @__PURE__ */ Eee(Xie);
  var Jie = kE.exports, a3;
  function vr() {
    return a3 || (a3 = 1, function(e, t) {
      (function(r, n) {
        e.exports = n();
      })(Jie, function() {
        var r = r || function(n, i) {
          var u;
          if (typeof window < "u" && window.crypto && (u = window.crypto), typeof self < "u" && self.crypto && (u = self.crypto), typeof globalThis < "u" && globalThis.crypto && (u = globalThis.crypto), !u && typeof window < "u" && window.msCrypto && (u = window.msCrypto), !u && typeof Sp < "u" && Sp.crypto && (u = Sp.crypto), !u && typeof Qie == "function")
            try {
              u = Zie;
            } catch {
            }
          var s = function() {
            if (u) {
              if (typeof u.getRandomValues == "function")
                try {
                  return u.getRandomValues(new Uint32Array(1))[0];
                } catch {
                }
              if (typeof u.randomBytes == "function")
                try {
                  return u.randomBytes(4).readInt32LE();
                } catch {
                }
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
          }, c = Object.create || /* @__PURE__ */ function() {
            function D() {
            }
            return function(A) {
              var R;
              return D.prototype = A, R = new D(), D.prototype = null, R;
            };
          }(), p = {}, h = p.lib = {}, v = h.Base = /* @__PURE__ */ function() {
            return {
              /**
               * Creates a new object that inherits from this object.
               *
               * @param {Object} overrides Properties to copy into the new object.
               *
               * @return {Object} The new object.
               *
               * @static
               *
               * @example
               *
               *     var MyType = CryptoJS.lib.Base.extend({
               *         field: 'value',
               *
               *         method: function () {
               *         }
               *     });
               */
              extend: function(D) {
                var A = c(this);
                return D && A.mixIn(D), (!A.hasOwnProperty("init") || this.init === A.init) && (A.init = function() {
                  A.$super.init.apply(this, arguments);
                }), A.init.prototype = A, A.$super = this, A;
              },
              /**
               * Extends this object and runs the init method.
               * Arguments to create() will be passed to init().
               *
               * @return {Object} The new object.
               *
               * @static
               *
               * @example
               *
               *     var instance = MyType.create();
               */
              create: function() {
                var D = this.extend();
                return D.init.apply(D, arguments), D;
              },
              /**
               * Initializes a newly created object.
               * Override this method to add some logic when your objects are created.
               *
               * @example
               *
               *     var MyType = CryptoJS.lib.Base.extend({
               *         init: function () {
               *             // ...
               *         }
               *     });
               */
              init: function() {
              },
              /**
               * Copies properties into this object.
               *
               * @param {Object} properties The properties to mix in.
               *
               * @example
               *
               *     MyType.mixIn({
               *         field: 'value'
               *     });
               */
              mixIn: function(D) {
                for (var A in D)
                  D.hasOwnProperty(A) && (this[A] = D[A]);
                D.hasOwnProperty("toString") && (this.toString = D.toString);
              },
              /**
               * Creates a copy of this object.
               *
               * @return {Object} The clone.
               *
               * @example
               *
               *     var clone = instance.clone();
               */
              clone: function() {
                return this.init.prototype.extend(this);
              }
            };
          }(), y = h.WordArray = v.extend({
            /**
             * Initializes a newly created word array.
             *
             * @param {Array} words (Optional) An array of 32-bit words.
             * @param {number} sigBytes (Optional) The number of significant bytes in the words.
             *
             * @example
             *
             *     var wordArray = CryptoJS.lib.WordArray.create();
             *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
             *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
             */
            init: function(D, A) {
              D = this.words = D || [], A != i ? this.sigBytes = A : this.sigBytes = D.length * 4;
            },
            /**
             * Converts this word array to a string.
             *
             * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
             *
             * @return {string} The stringified word array.
             *
             * @example
             *
             *     var string = wordArray + '';
             *     var string = wordArray.toString();
             *     var string = wordArray.toString(CryptoJS.enc.Utf8);
             */
            toString: function(D) {
              return (D || w).stringify(this);
            },
            /**
             * Concatenates a word array to this word array.
             *
             * @param {WordArray} wordArray The word array to append.
             *
             * @return {WordArray} This word array.
             *
             * @example
             *
             *     wordArray1.concat(wordArray2);
             */
            concat: function(D) {
              var A = this.words, R = D.words, T = this.sigBytes, M = D.sigBytes;
              if (this.clamp(), T % 4)
                for (var F = 0; F < M; F++) {
                  var B = R[F >>> 2] >>> 24 - F % 4 * 8 & 255;
                  A[T + F >>> 2] |= B << 24 - (T + F) % 4 * 8;
                }
              else
                for (var V = 0; V < M; V += 4)
                  A[T + V >>> 2] = R[V >>> 2];
              return this.sigBytes += M, this;
            },
            /**
             * Removes insignificant bits.
             *
             * @example
             *
             *     wordArray.clamp();
             */
            clamp: function() {
              var D = this.words, A = this.sigBytes;
              D[A >>> 2] &= 4294967295 << 32 - A % 4 * 8, D.length = n.ceil(A / 4);
            },
            /**
             * Creates a copy of this word array.
             *
             * @return {WordArray} The clone.
             *
             * @example
             *
             *     var clone = wordArray.clone();
             */
            clone: function() {
              var D = v.clone.call(this);
              return D.words = this.words.slice(0), D;
            },
            /**
             * Creates a word array filled with random bytes.
             *
             * @param {number} nBytes The number of random bytes to generate.
             *
             * @return {WordArray} The random word array.
             *
             * @static
             *
             * @example
             *
             *     var wordArray = CryptoJS.lib.WordArray.random(16);
             */
            random: function(D) {
              for (var A = [], R = 0; R < D; R += 4)
                A.push(s());
              return new y.init(A, D);
            }
          }), x = p.enc = {}, w = x.Hex = {
            /**
             * Converts a word array to a hex string.
             *
             * @param {WordArray} wordArray The word array.
             *
             * @return {string} The hex string.
             *
             * @static
             *
             * @example
             *
             *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
             */
            stringify: function(D) {
              for (var A = D.words, R = D.sigBytes, T = [], M = 0; M < R; M++) {
                var F = A[M >>> 2] >>> 24 - M % 4 * 8 & 255;
                T.push((F >>> 4).toString(16)), T.push((F & 15).toString(16));
              }
              return T.join("");
            },
            /**
             * Converts a hex string to a word array.
             *
             * @param {string} hexStr The hex string.
             *
             * @return {WordArray} The word array.
             *
             * @static
             *
             * @example
             *
             *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
             */
            parse: function(D) {
              for (var A = D.length, R = [], T = 0; T < A; T += 2)
                R[T >>> 3] |= parseInt(D.substr(T, 2), 16) << 24 - T % 8 * 4;
              return new y.init(R, A / 2);
            }
          }, E = x.Latin1 = {
            /**
             * Converts a word array to a Latin1 string.
             *
             * @param {WordArray} wordArray The word array.
             *
             * @return {string} The Latin1 string.
             *
             * @static
             *
             * @example
             *
             *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
             */
            stringify: function(D) {
              for (var A = D.words, R = D.sigBytes, T = [], M = 0; M < R; M++) {
                var F = A[M >>> 2] >>> 24 - M % 4 * 8 & 255;
                T.push(String.fromCharCode(F));
              }
              return T.join("");
            },
            /**
             * Converts a Latin1 string to a word array.
             *
             * @param {string} latin1Str The Latin1 string.
             *
             * @return {WordArray} The word array.
             *
             * @static
             *
             * @example
             *
             *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
             */
            parse: function(D) {
              for (var A = D.length, R = [], T = 0; T < A; T++)
                R[T >>> 2] |= (D.charCodeAt(T) & 255) << 24 - T % 4 * 8;
              return new y.init(R, A);
            }
          }, C = x.Utf8 = {
            /**
             * Converts a word array to a UTF-8 string.
             *
             * @param {WordArray} wordArray The word array.
             *
             * @return {string} The UTF-8 string.
             *
             * @static
             *
             * @example
             *
             *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
             */
            stringify: function(D) {
              try {
                return decodeURIComponent(escape(E.stringify(D)));
              } catch {
                throw new Error("Malformed UTF-8 data");
              }
            },
            /**
             * Converts a UTF-8 string to a word array.
             *
             * @param {string} utf8Str The UTF-8 string.
             *
             * @return {WordArray} The word array.
             *
             * @static
             *
             * @example
             *
             *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
             */
            parse: function(D) {
              return E.parse(unescape(encodeURIComponent(D)));
            }
          }, S = h.BufferedBlockAlgorithm = v.extend({
            /**
             * Resets this block algorithm's data buffer to its initial state.
             *
             * @example
             *
             *     bufferedBlockAlgorithm.reset();
             */
            reset: function() {
              this._data = new y.init(), this._nDataBytes = 0;
            },
            /**
             * Adds new data to this block algorithm's buffer.
             *
             * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
             *
             * @example
             *
             *     bufferedBlockAlgorithm._append('data');
             *     bufferedBlockAlgorithm._append(wordArray);
             */
            _append: function(D) {
              typeof D == "string" && (D = C.parse(D)), this._data.concat(D), this._nDataBytes += D.sigBytes;
            },
            /**
             * Processes available data blocks.
             *
             * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
             *
             * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
             *
             * @return {WordArray} The processed data.
             *
             * @example
             *
             *     var processedData = bufferedBlockAlgorithm._process();
             *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
             */
            _process: function(D) {
              var A, R = this._data, T = R.words, M = R.sigBytes, F = this.blockSize, B = F * 4, V = M / B;
              D ? V = n.ceil(V) : V = n.max((V | 0) - this._minBufferSize, 0);
              var H = V * F, q = n.min(H * 4, M);
              if (H) {
                for (var Q = 0; Q < H; Q += F)
                  this._doProcessBlock(T, Q);
                A = T.splice(0, H), R.sigBytes -= q;
              }
              return new y.init(A, q);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = bufferedBlockAlgorithm.clone();
             */
            clone: function() {
              var D = v.clone.call(this);
              return D._data = this._data.clone(), D;
            },
            _minBufferSize: 0
          });
          h.Hasher = S.extend({
            /**
             * Configuration options.
             */
            cfg: v.extend(),
            /**
             * Initializes a newly created hasher.
             *
             * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
             *
             * @example
             *
             *     var hasher = CryptoJS.algo.SHA256.create();
             */
            init: function(D) {
              this.cfg = this.cfg.extend(D), this.reset();
            },
            /**
             * Resets this hasher to its initial state.
             *
             * @example
             *
             *     hasher.reset();
             */
            reset: function() {
              S.reset.call(this), this._doReset();
            },
            /**
             * Updates this hasher with a message.
             *
             * @param {WordArray|string} messageUpdate The message to append.
             *
             * @return {Hasher} This hasher.
             *
             * @example
             *
             *     hasher.update('message');
             *     hasher.update(wordArray);
             */
            update: function(D) {
              return this._append(D), this._process(), this;
            },
            /**
             * Finalizes the hash computation.
             * Note that the finalize operation is effectively a destructive, read-once operation.
             *
             * @param {WordArray|string} messageUpdate (Optional) A final message update.
             *
             * @return {WordArray} The hash.
             *
             * @example
             *
             *     var hash = hasher.finalize();
             *     var hash = hasher.finalize('message');
             *     var hash = hasher.finalize(wordArray);
             */
            finalize: function(D) {
              D && this._append(D);
              var A = this._doFinalize();
              return A;
            },
            blockSize: 16,
            /**
             * Creates a shortcut function to a hasher's object interface.
             *
             * @param {Hasher} hasher The hasher to create a helper for.
             *
             * @return {Function} The shortcut function.
             *
             * @static
             *
             * @example
             *
             *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
             */
            _createHelper: function(D) {
              return function(A, R) {
                return new D.init(R).finalize(A);
              };
            },
            /**
             * Creates a shortcut function to the HMAC's object interface.
             *
             * @param {Hasher} hasher The hasher to use in this HMAC helper.
             *
             * @return {Function} The shortcut function.
             *
             * @static
             *
             * @example
             *
             *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
             */
            _createHmacHelper: function(D) {
              return function(A, R) {
                return new k.HMAC.init(D, R).finalize(A);
              };
            }
          });
          var k = p.algo = {};
          return p;
        }(Math);
        return r;
      });
    }(kE)), kE.exports;
  }
  var RE = { exports: {} }, eae = RE.exports, o3;
  function R_() {
    return o3 || (o3 = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(vr());
      })(eae, function(r) {
        return function(n) {
          var i = r, u = i.lib, s = u.Base, c = u.WordArray, p = i.x64 = {};
          p.Word = s.extend({
            /**
             * Initializes a newly created 64-bit word.
             *
             * @param {number} high The high 32 bits.
             * @param {number} low The low 32 bits.
             *
             * @example
             *
             *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
             */
            init: function(h, v) {
              this.high = h, this.low = v;
            }
            /**
             * Bitwise NOTs this word.
             *
             * @return {X64Word} A new x64-Word object after negating.
             *
             * @example
             *
             *     var negated = x64Word.not();
             */
            // not: function () {
            // var high = ~this.high;
            // var low = ~this.low;
            // return X64Word.create(high, low);
            // },
            /**
             * Bitwise ANDs this word with the passed word.
             *
             * @param {X64Word} word The x64-Word to AND with this word.
             *
             * @return {X64Word} A new x64-Word object after ANDing.
             *
             * @example
             *
             *     var anded = x64Word.and(anotherX64Word);
             */
            // and: function (word) {
            // var high = this.high & word.high;
            // var low = this.low & word.low;
            // return X64Word.create(high, low);
            // },
            /**
             * Bitwise ORs this word with the passed word.
             *
             * @param {X64Word} word The x64-Word to OR with this word.
             *
             * @return {X64Word} A new x64-Word object after ORing.
             *
             * @example
             *
             *     var ored = x64Word.or(anotherX64Word);
             */
            // or: function (word) {
            // var high = this.high | word.high;
            // var low = this.low | word.low;
            // return X64Word.create(high, low);
            // },
            /**
             * Bitwise XORs this word with the passed word.
             *
             * @param {X64Word} word The x64-Word to XOR with this word.
             *
             * @return {X64Word} A new x64-Word object after XORing.
             *
             * @example
             *
             *     var xored = x64Word.xor(anotherX64Word);
             */
            // xor: function (word) {
            // var high = this.high ^ word.high;
            // var low = this.low ^ word.low;
            // return X64Word.create(high, low);
            // },
            /**
             * Shifts this word n bits to the left.
             *
             * @param {number} n The number of bits to shift.
             *
             * @return {X64Word} A new x64-Word object after shifting.
             *
             * @example
             *
             *     var shifted = x64Word.shiftL(25);
             */
            // shiftL: function (n) {
            // if (n < 32) {
            // var high = (this.high << n) | (this.low >>> (32 - n));
            // var low = this.low << n;
            // } else {
            // var high = this.low << (n - 32);
            // var low = 0;
            // }
            // return X64Word.create(high, low);
            // },
            /**
             * Shifts this word n bits to the right.
             *
             * @param {number} n The number of bits to shift.
             *
             * @return {X64Word} A new x64-Word object after shifting.
             *
             * @example
             *
             *     var shifted = x64Word.shiftR(7);
             */
            // shiftR: function (n) {
            // if (n < 32) {
            // var low = (this.low >>> n) | (this.high << (32 - n));
            // var high = this.high >>> n;
            // } else {
            // var low = this.high >>> (n - 32);
            // var high = 0;
            // }
            // return X64Word.create(high, low);
            // },
            /**
             * Rotates this word n bits to the left.
             *
             * @param {number} n The number of bits to rotate.
             *
             * @return {X64Word} A new x64-Word object after rotating.
             *
             * @example
             *
             *     var rotated = x64Word.rotL(25);
             */
            // rotL: function (n) {
            // return this.shiftL(n).or(this.shiftR(64 - n));
            // },
            /**
             * Rotates this word n bits to the right.
             *
             * @param {number} n The number of bits to rotate.
             *
             * @return {X64Word} A new x64-Word object after rotating.
             *
             * @example
             *
             *     var rotated = x64Word.rotR(7);
             */
            // rotR: function (n) {
            // return this.shiftR(n).or(this.shiftL(64 - n));
            // },
            /**
             * Adds this word with the passed word.
             *
             * @param {X64Word} word The x64-Word to add with this word.
             *
             * @return {X64Word} A new x64-Word object after adding.
             *
             * @example
             *
             *     var added = x64Word.add(anotherX64Word);
             */
            // add: function (word) {
            // var low = (this.low + word.low) | 0;
            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
            // var high = (this.high + word.high + carry) | 0;
            // return X64Word.create(high, low);
            // }
          }), p.WordArray = s.extend({
            /**
             * Initializes a newly created word array.
             *
             * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
             * @param {number} sigBytes (Optional) The number of significant bytes in the words.
             *
             * @example
             *
             *     var wordArray = CryptoJS.x64.WordArray.create();
             *
             *     var wordArray = CryptoJS.x64.WordArray.create([
             *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
             *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
             *     ]);
             *
             *     var wordArray = CryptoJS.x64.WordArray.create([
             *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
             *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
             *     ], 10);
             */
            init: function(h, v) {
              h = this.words = h || [], v != n ? this.sigBytes = v : this.sigBytes = h.length * 8;
            },
            /**
             * Converts this 64-bit word array to a 32-bit word array.
             *
             * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
             *
             * @example
             *
             *     var x32WordArray = x64WordArray.toX32();
             */
            toX32: function() {
              for (var h = this.words, v = h.length, y = [], x = 0; x < v; x++) {
                var w = h[x];
                y.push(w.high), y.push(w.low);
              }
              return c.create(y, this.sigBytes);
            },
            /**
             * Creates a copy of this word array.
             *
             * @return {X64WordArray} The clone.
             *
             * @example
             *
             *     var clone = x64WordArray.clone();
             */
            clone: function() {
              for (var h = s.clone.call(this), v = h.words = this.words.slice(0), y = v.length, x = 0; x < y; x++)
                v[x] = v[x].clone();
              return h;
            }
          });
        }(), r;
      });
    }(RE)), RE.exports;
  }
  var PE = { exports: {} }, tae = PE.exports, u3;
  function rae() {
    return u3 || (u3 = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(vr());
      })(tae, function(r) {
        return function() {
          if (typeof ArrayBuffer == "function") {
            var n = r, i = n.lib, u = i.WordArray, s = u.init, c = u.init = function(p) {
              if (p instanceof ArrayBuffer && (p = new Uint8Array(p)), (p instanceof Int8Array || typeof Uint8ClampedArray < "u" && p instanceof Uint8ClampedArray || p instanceof Int16Array || p instanceof Uint16Array || p instanceof Int32Array || p instanceof Uint32Array || p instanceof Float32Array || p instanceof Float64Array) && (p = new Uint8Array(p.buffer, p.byteOffset, p.byteLength)), p instanceof Uint8Array) {
                for (var h = p.byteLength, v = [], y = 0; y < h; y++)
                  v[y >>> 2] |= p[y] << 24 - y % 4 * 8;
                s.call(this, v, h);
              } else
                s.apply(this, arguments);
            };
            c.prototype = u;
          }
        }(), r.lib.WordArray;
      });
    }(PE)), PE.exports;
  }
  var ME = { exports: {} }, nae = ME.exports, s3;
  function iae() {
    return s3 || (s3 = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(vr());
      })(nae, function(r) {
        return function() {
          var n = r, i = n.lib, u = i.WordArray, s = n.enc;
          s.Utf16 = s.Utf16BE = {
            /**
             * Converts a word array to a UTF-16 BE string.
             *
             * @param {WordArray} wordArray The word array.
             *
             * @return {string} The UTF-16 BE string.
             *
             * @static
             *
             * @example
             *
             *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
             */
            stringify: function(p) {
              for (var h = p.words, v = p.sigBytes, y = [], x = 0; x < v; x += 2) {
                var w = h[x >>> 2] >>> 16 - x % 4 * 8 & 65535;
                y.push(String.fromCharCode(w));
              }
              return y.join("");
            },
            /**
             * Converts a UTF-16 BE string to a word array.
             *
             * @param {string} utf16Str The UTF-16 BE string.
             *
             * @return {WordArray} The word array.
             *
             * @static
             *
             * @example
             *
             *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
             */
            parse: function(p) {
              for (var h = p.length, v = [], y = 0; y < h; y++)
                v[y >>> 1] |= p.charCodeAt(y) << 16 - y % 2 * 16;
              return u.create(v, h * 2);
            }
          }, s.Utf16LE = {
            /**
             * Converts a word array to a UTF-16 LE string.
             *
             * @param {WordArray} wordArray The word array.
             *
             * @return {string} The UTF-16 LE string.
             *
             * @static
             *
             * @example
             *
             *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
             */
            stringify: function(p) {
              for (var h = p.words, v = p.sigBytes, y = [], x = 0; x < v; x += 2) {
                var w = c(h[x >>> 2] >>> 16 - x % 4 * 8 & 65535);
                y.push(String.fromCharCode(w));
              }
              return y.join("");
            },
            /**
             * Converts a UTF-16 LE string to a word array.
             *
             * @param {string} utf16Str The UTF-16 LE string.
             *
             * @return {WordArray} The word array.
             *
             * @static
             *
             * @example
             *
             *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
             */
            parse: function(p) {
              for (var h = p.length, v = [], y = 0; y < h; y++)
                v[y >>> 1] |= c(p.charCodeAt(y) << 16 - y % 2 * 16);
              return u.create(v, h * 2);
            }
          };
          function c(p) {
            return p << 8 & 4278255360 | p >>> 8 & 16711935;
          }
        }(), r.enc.Utf16;
      });
    }(ME)), ME.exports;
  }
  var NE = { exports: {} }, aae = NE.exports, l3;
  function zp() {
    return l3 || (l3 = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(vr());
      })(aae, function(r) {
        return function() {
          var n = r, i = n.lib, u = i.WordArray, s = n.enc;
          s.Base64 = {
            /**
             * Converts a word array to a Base64 string.
             *
             * @param {WordArray} wordArray The word array.
             *
             * @return {string} The Base64 string.
             *
             * @static
             *
             * @example
             *
             *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
             */
            stringify: function(p) {
              var h = p.words, v = p.sigBytes, y = this._map;
              p.clamp();
              for (var x = [], w = 0; w < v; w += 3)
                for (var E = h[w >>> 2] >>> 24 - w % 4 * 8 & 255, C = h[w + 1 >>> 2] >>> 24 - (w + 1) % 4 * 8 & 255, S = h[w + 2 >>> 2] >>> 24 - (w + 2) % 4 * 8 & 255, k = E << 16 | C << 8 | S, D = 0; D < 4 && w + D * 0.75 < v; D++)
                  x.push(y.charAt(k >>> 6 * (3 - D) & 63));
              var A = y.charAt(64);
              if (A)
                for (; x.length % 4; )
                  x.push(A);
              return x.join("");
            },
            /**
             * Converts a Base64 string to a word array.
             *
             * @param {string} base64Str The Base64 string.
             *
             * @return {WordArray} The word array.
             *
             * @static
             *
             * @example
             *
             *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
             */
            parse: function(p) {
              var h = p.length, v = this._map, y = this._reverseMap;
              if (!y) {
                y = this._reverseMap = [];
                for (var x = 0; x < v.length; x++)
                  y[v.charCodeAt(x)] = x;
              }
              var w = v.charAt(64);
              if (w) {
                var E = p.indexOf(w);
                E !== -1 && (h = E);
              }
              return c(p, h, y);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
          };
          function c(p, h, v) {
            for (var y = [], x = 0, w = 0; w < h; w++)
              if (w % 4) {
                var E = v[p.charCodeAt(w - 1)] << w % 4 * 2, C = v[p.charCodeAt(w)] >>> 6 - w % 4 * 2, S = E | C;
                y[x >>> 2] |= S << 24 - x % 4 * 8, x++;
              }
            return u.create(y, x);
          }
        }(), r.enc.Base64;
      });
    }(NE)), NE.exports;
  }
  var jE = { exports: {} }, oae = jE.exports, c3;
  function uae() {
    return c3 || (c3 = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(vr());
      })(oae, function(r) {
        return function() {
          var n = r, i = n.lib, u = i.WordArray, s = n.enc;
          s.Base64url = {
            /**
             * Converts a word array to a Base64url string.
             *
             * @param {WordArray} wordArray The word array.
             *
             * @param {boolean} urlSafe Whether to use url safe
             *
             * @return {string} The Base64url string.
             *
             * @static
             *
             * @example
             *
             *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
             */
            stringify: function(p, h) {
              h === void 0 && (h = !0);
              var v = p.words, y = p.sigBytes, x = h ? this._safe_map : this._map;
              p.clamp();
              for (var w = [], E = 0; E < y; E += 3)
                for (var C = v[E >>> 2] >>> 24 - E % 4 * 8 & 255, S = v[E + 1 >>> 2] >>> 24 - (E + 1) % 4 * 8 & 255, k = v[E + 2 >>> 2] >>> 24 - (E + 2) % 4 * 8 & 255, D = C << 16 | S << 8 | k, A = 0; A < 4 && E + A * 0.75 < y; A++)
                  w.push(x.charAt(D >>> 6 * (3 - A) & 63));
              var R = x.charAt(64);
              if (R)
                for (; w.length % 4; )
                  w.push(R);
              return w.join("");
            },
            /**
             * Converts a Base64url string to a word array.
             *
             * @param {string} base64Str The Base64url string.
             *
             * @param {boolean} urlSafe Whether to use url safe
             *
             * @return {WordArray} The word array.
             *
             * @static
             *
             * @example
             *
             *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
             */
            parse: function(p, h) {
              h === void 0 && (h = !0);
              var v = p.length, y = h ? this._safe_map : this._map, x = this._reverseMap;
              if (!x) {
                x = this._reverseMap = [];
                for (var w = 0; w < y.length; w++)
                  x[y.charCodeAt(w)] = w;
              }
              var E = y.charAt(64);
              if (E) {
                var C = p.indexOf(E);
                C !== -1 && (v = C);
              }
              return c(p, v, x);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
            _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
          };
          function c(p, h, v) {
            for (var y = [], x = 0, w = 0; w < h; w++)
              if (w % 4) {
                var E = v[p.charCodeAt(w - 1)] << w % 4 * 2, C = v[p.charCodeAt(w)] >>> 6 - w % 4 * 2, S = E | C;
                y[x >>> 2] |= S << 24 - x % 4 * 8, x++;
              }
            return u.create(y, x);
          }
        }(), r.enc.Base64url;
      });
    }(jE)), jE.exports;
  }
  var FE = { exports: {} }, sae = FE.exports, f3;
  function qp() {
    return f3 || (f3 = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(vr());
      })(sae, function(r) {
        return function(n) {
          var i = r, u = i.lib, s = u.WordArray, c = u.Hasher, p = i.algo, h = [];
          (function() {
            for (var C = 0; C < 64; C++)
              h[C] = n.abs(n.sin(C + 1)) * 4294967296 | 0;
          })();
          var v = p.MD5 = c.extend({
            _doReset: function() {
              this._hash = new s.init([
                1732584193,
                4023233417,
                2562383102,
                271733878
              ]);
            },
            _doProcessBlock: function(C, S) {
              for (var k = 0; k < 16; k++) {
                var D = S + k, A = C[D];
                C[D] = (A << 8 | A >>> 24) & 16711935 | (A << 24 | A >>> 8) & 4278255360;
              }
              var R = this._hash.words, T = C[S + 0], M = C[S + 1], F = C[S + 2], B = C[S + 3], V = C[S + 4], H = C[S + 5], q = C[S + 6], Q = C[S + 7], W = C[S + 8], J = C[S + 9], ne = C[S + 10], ie = C[S + 11], se = C[S + 12], X = C[S + 13], fe = C[S + 14], Z = C[S + 15], z = R[0], Y = R[1], te = R[2], ae = R[3];
              z = y(z, Y, te, ae, T, 7, h[0]), ae = y(ae, z, Y, te, M, 12, h[1]), te = y(te, ae, z, Y, F, 17, h[2]), Y = y(Y, te, ae, z, B, 22, h[3]), z = y(z, Y, te, ae, V, 7, h[4]), ae = y(ae, z, Y, te, H, 12, h[5]), te = y(te, ae, z, Y, q, 17, h[6]), Y = y(Y, te, ae, z, Q, 22, h[7]), z = y(z, Y, te, ae, W, 7, h[8]), ae = y(ae, z, Y, te, J, 12, h[9]), te = y(te, ae, z, Y, ne, 17, h[10]), Y = y(Y, te, ae, z, ie, 22, h[11]), z = y(z, Y, te, ae, se, 7, h[12]), ae = y(ae, z, Y, te, X, 12, h[13]), te = y(te, ae, z, Y, fe, 17, h[14]), Y = y(Y, te, ae, z, Z, 22, h[15]), z = x(z, Y, te, ae, M, 5, h[16]), ae = x(ae, z, Y, te, q, 9, h[17]), te = x(te, ae, z, Y, ie, 14, h[18]), Y = x(Y, te, ae, z, T, 20, h[19]), z = x(z, Y, te, ae, H, 5, h[20]), ae = x(ae, z, Y, te, ne, 9, h[21]), te = x(te, ae, z, Y, Z, 14, h[22]), Y = x(Y, te, ae, z, V, 20, h[23]), z = x(z, Y, te, ae, J, 5, h[24]), ae = x(ae, z, Y, te, fe, 9, h[25]), te = x(te, ae, z, Y, B, 14, h[26]), Y = x(Y, te, ae, z, W, 20, h[27]), z = x(z, Y, te, ae, X, 5, h[28]), ae = x(ae, z, Y, te, F, 9, h[29]), te = x(te, ae, z, Y, Q, 14, h[30]), Y = x(Y, te, ae, z, se, 20, h[31]), z = w(z, Y, te, ae, H, 4, h[32]), ae = w(ae, z, Y, te, W, 11, h[33]), te = w(te, ae, z, Y, ie, 16, h[34]), Y = w(Y, te, ae, z, fe, 23, h[35]), z = w(z, Y, te, ae, M, 4, h[36]), ae = w(ae, z, Y, te, V, 11, h[37]), te = w(te, ae, z, Y, Q, 16, h[38]), Y = w(Y, te, ae, z, ne, 23, h[39]), z = w(z, Y, te, ae, X, 4, h[40]), ae = w(ae, z, Y, te, T, 11, h[41]), te = w(te, ae, z, Y, B, 16, h[42]), Y = w(Y, te, ae, z, q, 23, h[43]), z = w(z, Y, te, ae, J, 4, h[44]), ae = w(ae, z, Y, te, se, 11, h[45]), te = w(te, ae, z, Y, Z, 16, h[46]), Y = w(Y, te, ae, z, F, 23, h[47]), z = E(z, Y, te, ae, T, 6, h[48]), ae = E(ae, z, Y, te, Q, 10, h[49]), te = E(te, ae, z, Y, fe, 15, h[50]), Y = E(Y, te, ae, z, H, 21, h[51]), z = E(z, Y, te, ae, se, 6, h[52]), ae = E(ae, z, Y, te, B, 10, h[53]), te = E(te, ae, z, Y, ne, 15, h[54]), Y = E(Y, te, ae, z, M, 21, h[55]), z = E(z, Y, te, ae, W, 6, h[56]), ae = E(ae, z, Y, te, Z, 10, h[57]), te = E(te, ae, z, Y, q, 15, h[58]), Y = E(Y, te, ae, z, X, 21, h[59]), z = E(z, Y, te, ae, V, 6, h[60]), ae = E(ae, z, Y, te, ie, 10, h[61]), te = E(te, ae, z, Y, F, 15, h[62]), Y = E(Y, te, ae, z, J, 21, h[63]), R[0] = R[0] + z | 0, R[1] = R[1] + Y | 0, R[2] = R[2] + te | 0, R[3] = R[3] + ae | 0;
            },
            _doFinalize: function() {
              var C = this._data, S = C.words, k = this._nDataBytes * 8, D = C.sigBytes * 8;
              S[D >>> 5] |= 128 << 24 - D % 32;
              var A = n.floor(k / 4294967296), R = k;
              S[(D + 64 >>> 9 << 4) + 15] = (A << 8 | A >>> 24) & 16711935 | (A << 24 | A >>> 8) & 4278255360, S[(D + 64 >>> 9 << 4) + 14] = (R << 8 | R >>> 24) & 16711935 | (R << 24 | R >>> 8) & 4278255360, C.sigBytes = (S.length + 1) * 4, this._process();
              for (var T = this._hash, M = T.words, F = 0; F < 4; F++) {
                var B = M[F];
                M[F] = (B << 8 | B >>> 24) & 16711935 | (B << 24 | B >>> 8) & 4278255360;
              }
              return T;
            },
            clone: function() {
              var C = c.clone.call(this);
              return C._hash = this._hash.clone(), C;
            }
          });
          function y(C, S, k, D, A, R, T) {
            var M = C + (S & k | ~S & D) + A + T;
            return (M << R | M >>> 32 - R) + S;
          }
          function x(C, S, k, D, A, R, T) {
            var M = C + (S & D | k & ~D) + A + T;
            return (M << R | M >>> 32 - R) + S;
          }
          function w(C, S, k, D, A, R, T) {
            var M = C + (S ^ k ^ D) + A + T;
            return (M << R | M >>> 32 - R) + S;
          }
          function E(C, S, k, D, A, R, T) {
            var M = C + (k ^ (S | ~D)) + A + T;
            return (M << R | M >>> 32 - R) + S;
          }
          i.MD5 = c._createHelper(v), i.HmacMD5 = c._createHmacHelper(v);
        }(Math), r.MD5;
      });
    }(FE)), FE.exports;
  }
  var IE = { exports: {} }, lae = IE.exports, d3;
  function L9() {
    return d3 || (d3 = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(vr());
      })(lae, function(r) {
        return function() {
          var n = r, i = n.lib, u = i.WordArray, s = i.Hasher, c = n.algo, p = [], h = c.SHA1 = s.extend({
            _doReset: function() {
              this._hash = new u.init([
                1732584193,
                4023233417,
                2562383102,
                271733878,
                3285377520
              ]);
            },
            _doProcessBlock: function(v, y) {
              for (var x = this._hash.words, w = x[0], E = x[1], C = x[2], S = x[3], k = x[4], D = 0; D < 80; D++) {
                if (D < 16)
                  p[D] = v[y + D] | 0;
                else {
                  var A = p[D - 3] ^ p[D - 8] ^ p[D - 14] ^ p[D - 16];
                  p[D] = A << 1 | A >>> 31;
                }
                var R = (w << 5 | w >>> 27) + k + p[D];
                D < 20 ? R += (E & C | ~E & S) + 1518500249 : D < 40 ? R += (E ^ C ^ S) + 1859775393 : D < 60 ? R += (E & C | E & S | C & S) - 1894007588 : R += (E ^ C ^ S) - 899497514, k = S, S = C, C = E << 30 | E >>> 2, E = w, w = R;
              }
              x[0] = x[0] + w | 0, x[1] = x[1] + E | 0, x[2] = x[2] + C | 0, x[3] = x[3] + S | 0, x[4] = x[4] + k | 0;
            },
            _doFinalize: function() {
              var v = this._data, y = v.words, x = this._nDataBytes * 8, w = v.sigBytes * 8;
              return y[w >>> 5] |= 128 << 24 - w % 32, y[(w + 64 >>> 9 << 4) + 14] = Math.floor(x / 4294967296), y[(w + 64 >>> 9 << 4) + 15] = x, v.sigBytes = y.length * 4, this._process(), this._hash;
            },
            clone: function() {
              var v = s.clone.call(this);
              return v._hash = this._hash.clone(), v;
            }
          });
          n.SHA1 = s._createHelper(h), n.HmacSHA1 = s._createHmacHelper(h);
        }(), r.SHA1;
      });
    }(IE)), IE.exports;
  }
  var BE = { exports: {} }, cae = BE.exports, p3;
  function MN() {
    return p3 || (p3 = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(vr());
      })(cae, function(r) {
        return function(n) {
          var i = r, u = i.lib, s = u.WordArray, c = u.Hasher, p = i.algo, h = [], v = [];
          (function() {
            function w(k) {
              for (var D = n.sqrt(k), A = 2; A <= D; A++)
                if (!(k % A))
                  return !1;
              return !0;
            }
            function E(k) {
              return (k - (k | 0)) * 4294967296 | 0;
            }
            for (var C = 2, S = 0; S < 64; )
              w(C) && (S < 8 && (h[S] = E(n.pow(C, 1 / 2))), v[S] = E(n.pow(C, 1 / 3)), S++), C++;
          })();
          var y = [], x = p.SHA256 = c.extend({
            _doReset: function() {
              this._hash = new s.init(h.slice(0));
            },
            _doProcessBlock: function(w, E) {
              for (var C = this._hash.words, S = C[0], k = C[1], D = C[2], A = C[3], R = C[4], T = C[5], M = C[6], F = C[7], B = 0; B < 64; B++) {
                if (B < 16)
                  y[B] = w[E + B] | 0;
                else {
                  var V = y[B - 15], H = (V << 25 | V >>> 7) ^ (V << 14 | V >>> 18) ^ V >>> 3, q = y[B - 2], Q = (q << 15 | q >>> 17) ^ (q << 13 | q >>> 19) ^ q >>> 10;
                  y[B] = H + y[B - 7] + Q + y[B - 16];
                }
                var W = R & T ^ ~R & M, J = S & k ^ S & D ^ k & D, ne = (S << 30 | S >>> 2) ^ (S << 19 | S >>> 13) ^ (S << 10 | S >>> 22), ie = (R << 26 | R >>> 6) ^ (R << 21 | R >>> 11) ^ (R << 7 | R >>> 25), se = F + ie + W + v[B] + y[B], X = ne + J;
                F = M, M = T, T = R, R = A + se | 0, A = D, D = k, k = S, S = se + X | 0;
              }
              C[0] = C[0] + S | 0, C[1] = C[1] + k | 0, C[2] = C[2] + D | 0, C[3] = C[3] + A | 0, C[4] = C[4] + R | 0, C[5] = C[5] + T | 0, C[6] = C[6] + M | 0, C[7] = C[7] + F | 0;
            },
            _doFinalize: function() {
              var w = this._data, E = w.words, C = this._nDataBytes * 8, S = w.sigBytes * 8;
              return E[S >>> 5] |= 128 << 24 - S % 32, E[(S + 64 >>> 9 << 4) + 14] = n.floor(C / 4294967296), E[(S + 64 >>> 9 << 4) + 15] = C, w.sigBytes = E.length * 4, this._process(), this._hash;
            },
            clone: function() {
              var w = c.clone.call(this);
              return w._hash = this._hash.clone(), w;
            }
          });
          i.SHA256 = c._createHelper(x), i.HmacSHA256 = c._createHmacHelper(x);
        }(Math), r.SHA256;
      });
    }(BE)), BE.exports;
  }
  var LE = { exports: {} }, fae = LE.exports, h3;
  function dae() {
    return h3 || (h3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), MN());
      })(fae, function(r) {
        return function() {
          var n = r, i = n.lib, u = i.WordArray, s = n.algo, c = s.SHA256, p = s.SHA224 = c.extend({
            _doReset: function() {
              this._hash = new u.init([
                3238371032,
                914150663,
                812702999,
                4144912697,
                4290775857,
                1750603025,
                1694076839,
                3204075428
              ]);
            },
            _doFinalize: function() {
              var h = c._doFinalize.call(this);
              return h.sigBytes -= 4, h;
            }
          });
          n.SHA224 = c._createHelper(p), n.HmacSHA224 = c._createHmacHelper(p);
        }(), r.SHA224;
      });
    }(LE)), LE.exports;
  }
  var $E = { exports: {} }, pae = $E.exports, v3;
  function $9() {
    return v3 || (v3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), R_());
      })(pae, function(r) {
        return function() {
          var n = r, i = n.lib, u = i.Hasher, s = n.x64, c = s.Word, p = s.WordArray, h = n.algo;
          function v() {
            return c.create.apply(c, arguments);
          }
          var y = [
            v(1116352408, 3609767458),
            v(1899447441, 602891725),
            v(3049323471, 3964484399),
            v(3921009573, 2173295548),
            v(961987163, 4081628472),
            v(1508970993, 3053834265),
            v(2453635748, 2937671579),
            v(2870763221, 3664609560),
            v(3624381080, 2734883394),
            v(310598401, 1164996542),
            v(607225278, 1323610764),
            v(1426881987, 3590304994),
            v(1925078388, 4068182383),
            v(2162078206, 991336113),
            v(2614888103, 633803317),
            v(3248222580, 3479774868),
            v(3835390401, 2666613458),
            v(4022224774, 944711139),
            v(264347078, 2341262773),
            v(604807628, 2007800933),
            v(770255983, 1495990901),
            v(1249150122, 1856431235),
            v(1555081692, 3175218132),
            v(1996064986, 2198950837),
            v(2554220882, 3999719339),
            v(2821834349, 766784016),
            v(2952996808, 2566594879),
            v(3210313671, 3203337956),
            v(3336571891, 1034457026),
            v(3584528711, 2466948901),
            v(113926993, 3758326383),
            v(338241895, 168717936),
            v(666307205, 1188179964),
            v(773529912, 1546045734),
            v(1294757372, 1522805485),
            v(1396182291, 2643833823),
            v(1695183700, 2343527390),
            v(1986661051, 1014477480),
            v(2177026350, 1206759142),
            v(2456956037, 344077627),
            v(2730485921, 1290863460),
            v(2820302411, 3158454273),
            v(3259730800, 3505952657),
            v(3345764771, 106217008),
            v(3516065817, 3606008344),
            v(3600352804, 1432725776),
            v(4094571909, 1467031594),
            v(275423344, 851169720),
            v(430227734, 3100823752),
            v(506948616, 1363258195),
            v(659060556, 3750685593),
            v(883997877, 3785050280),
            v(958139571, 3318307427),
            v(1322822218, 3812723403),
            v(1537002063, 2003034995),
            v(1747873779, 3602036899),
            v(1955562222, 1575990012),
            v(2024104815, 1125592928),
            v(2227730452, 2716904306),
            v(2361852424, 442776044),
            v(2428436474, 593698344),
            v(2756734187, 3733110249),
            v(3204031479, 2999351573),
            v(3329325298, 3815920427),
            v(3391569614, 3928383900),
            v(3515267271, 566280711),
            v(3940187606, 3454069534),
            v(4118630271, 4000239992),
            v(116418474, 1914138554),
            v(174292421, 2731055270),
            v(289380356, 3203993006),
            v(460393269, 320620315),
            v(685471733, 587496836),
            v(852142971, 1086792851),
            v(1017036298, 365543100),
            v(1126000580, 2618297676),
            v(1288033470, 3409855158),
            v(1501505948, 4234509866),
            v(1607167915, 987167468),
            v(1816402316, 1246189591)
          ], x = [];
          (function() {
            for (var E = 0; E < 80; E++)
              x[E] = v();
          })();
          var w = h.SHA512 = u.extend({
            _doReset: function() {
              this._hash = new p.init([
                new c.init(1779033703, 4089235720),
                new c.init(3144134277, 2227873595),
                new c.init(1013904242, 4271175723),
                new c.init(2773480762, 1595750129),
                new c.init(1359893119, 2917565137),
                new c.init(2600822924, 725511199),
                new c.init(528734635, 4215389547),
                new c.init(1541459225, 327033209)
              ]);
            },
            _doProcessBlock: function(E, C) {
              for (var S = this._hash.words, k = S[0], D = S[1], A = S[2], R = S[3], T = S[4], M = S[5], F = S[6], B = S[7], V = k.high, H = k.low, q = D.high, Q = D.low, W = A.high, J = A.low, ne = R.high, ie = R.low, se = T.high, X = T.low, fe = M.high, Z = M.low, z = F.high, Y = F.low, te = B.high, ae = B.low, De = V, ke = H, Re = q, Te = Q, we = W, Fe = J, Ye = ne, de = ie, Ze = se, Ne = X, Ot = fe, At = Z, Qt = z, Wr = Y, Ar = te, Dr = ae, Vt = 0; Vt < 80; Vt++) {
                var Ut, kr, Pn = x[Vt];
                if (Vt < 16)
                  kr = Pn.high = E[C + Vt * 2] | 0, Ut = Pn.low = E[C + Vt * 2 + 1] | 0;
                else {
                  var Yr = x[Vt - 15], Jr = Yr.high, xn = Yr.low, ka = (Jr >>> 1 | xn << 31) ^ (Jr >>> 8 | xn << 24) ^ Jr >>> 7, Ra = (xn >>> 1 | Jr << 31) ^ (xn >>> 8 | Jr << 24) ^ (xn >>> 7 | Jr << 25), Ge = x[Vt - 2], ct = Ge.high, jt = Ge.low, cr = (ct >>> 19 | jt << 13) ^ (ct << 3 | jt >>> 29) ^ ct >>> 6, Rr = (jt >>> 19 | ct << 13) ^ (jt << 3 | ct >>> 29) ^ (jt >>> 6 | ct << 26), en = x[Vt - 7], Gr = en.high, Mn = en.low, Pr = x[Vt - 16], _r = Pr.high, Er = Pr.low;
                  Ut = Ra + Mn, kr = ka + Gr + (Ut >>> 0 < Ra >>> 0 ? 1 : 0), Ut = Ut + Rr, kr = kr + cr + (Ut >>> 0 < Rr >>> 0 ? 1 : 0), Ut = Ut + Er, kr = kr + _r + (Ut >>> 0 < Er >>> 0 ? 1 : 0), Pn.high = kr, Pn.low = Ut;
                }
                var $i = Ze & Ot ^ ~Ze & Qt, Yn = Ne & At ^ ~Ne & Wr, ua = De & Re ^ De & we ^ Re & we, bo = ke & Te ^ ke & Fe ^ Te & Fe, Du = (De >>> 28 | ke << 4) ^ (De << 30 | ke >>> 2) ^ (De << 25 | ke >>> 7), Vo = (ke >>> 28 | De << 4) ^ (ke << 30 | De >>> 2) ^ (ke << 25 | De >>> 7), Wo = (Ze >>> 14 | Ne << 18) ^ (Ze >>> 18 | Ne << 14) ^ (Ze << 23 | Ne >>> 9), Yo = (Ne >>> 14 | Ze << 18) ^ (Ne >>> 18 | Ze << 14) ^ (Ne << 23 | Ze >>> 9), Go = y[Vt], pi = Go.high, ni = Go.low, Sr = Dr + Yo, Gn = Ar + Wo + (Sr >>> 0 < Dr >>> 0 ? 1 : 0), Sr = Sr + Yn, Gn = Gn + $i + (Sr >>> 0 < Yn >>> 0 ? 1 : 0), Sr = Sr + ni, Gn = Gn + pi + (Sr >>> 0 < ni >>> 0 ? 1 : 0), Sr = Sr + Ut, Gn = Gn + kr + (Sr >>> 0 < Ut >>> 0 ? 1 : 0), sa = Vo + bo, Qa = Du + ua + (sa >>> 0 < Vo >>> 0 ? 1 : 0);
                Ar = Qt, Dr = Wr, Qt = Ot, Wr = At, Ot = Ze, At = Ne, Ne = de + Sr | 0, Ze = Ye + Gn + (Ne >>> 0 < de >>> 0 ? 1 : 0) | 0, Ye = we, de = Fe, we = Re, Fe = Te, Re = De, Te = ke, ke = Sr + sa | 0, De = Gn + Qa + (ke >>> 0 < Sr >>> 0 ? 1 : 0) | 0;
              }
              H = k.low = H + ke, k.high = V + De + (H >>> 0 < ke >>> 0 ? 1 : 0), Q = D.low = Q + Te, D.high = q + Re + (Q >>> 0 < Te >>> 0 ? 1 : 0), J = A.low = J + Fe, A.high = W + we + (J >>> 0 < Fe >>> 0 ? 1 : 0), ie = R.low = ie + de, R.high = ne + Ye + (ie >>> 0 < de >>> 0 ? 1 : 0), X = T.low = X + Ne, T.high = se + Ze + (X >>> 0 < Ne >>> 0 ? 1 : 0), Z = M.low = Z + At, M.high = fe + Ot + (Z >>> 0 < At >>> 0 ? 1 : 0), Y = F.low = Y + Wr, F.high = z + Qt + (Y >>> 0 < Wr >>> 0 ? 1 : 0), ae = B.low = ae + Dr, B.high = te + Ar + (ae >>> 0 < Dr >>> 0 ? 1 : 0);
            },
            _doFinalize: function() {
              var E = this._data, C = E.words, S = this._nDataBytes * 8, k = E.sigBytes * 8;
              C[k >>> 5] |= 128 << 24 - k % 32, C[(k + 128 >>> 10 << 5) + 30] = Math.floor(S / 4294967296), C[(k + 128 >>> 10 << 5) + 31] = S, E.sigBytes = C.length * 4, this._process();
              var D = this._hash.toX32();
              return D;
            },
            clone: function() {
              var E = u.clone.call(this);
              return E._hash = this._hash.clone(), E;
            },
            blockSize: 1024 / 32
          });
          n.SHA512 = u._createHelper(w), n.HmacSHA512 = u._createHmacHelper(w);
        }(), r.SHA512;
      });
    }($E)), $E.exports;
  }
  var zE = { exports: {} }, hae = zE.exports, m3;
  function vae() {
    return m3 || (m3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), R_(), $9());
      })(hae, function(r) {
        return function() {
          var n = r, i = n.x64, u = i.Word, s = i.WordArray, c = n.algo, p = c.SHA512, h = c.SHA384 = p.extend({
            _doReset: function() {
              this._hash = new s.init([
                new u.init(3418070365, 3238371032),
                new u.init(1654270250, 914150663),
                new u.init(2438529370, 812702999),
                new u.init(355462360, 4144912697),
                new u.init(1731405415, 4290775857),
                new u.init(2394180231, 1750603025),
                new u.init(3675008525, 1694076839),
                new u.init(1203062813, 3204075428)
              ]);
            },
            _doFinalize: function() {
              var v = p._doFinalize.call(this);
              return v.sigBytes -= 16, v;
            }
          });
          n.SHA384 = p._createHelper(h), n.HmacSHA384 = p._createHmacHelper(h);
        }(), r.SHA384;
      });
    }(zE)), zE.exports;
  }
  var qE = { exports: {} }, mae = qE.exports, y3;
  function yae() {
    return y3 || (y3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), R_());
      })(mae, function(r) {
        return function(n) {
          var i = r, u = i.lib, s = u.WordArray, c = u.Hasher, p = i.x64, h = p.Word, v = i.algo, y = [], x = [], w = [];
          (function() {
            for (var S = 1, k = 0, D = 0; D < 24; D++) {
              y[S + 5 * k] = (D + 1) * (D + 2) / 2 % 64;
              var A = k % 5, R = (2 * S + 3 * k) % 5;
              S = A, k = R;
            }
            for (var S = 0; S < 5; S++)
              for (var k = 0; k < 5; k++)
                x[S + 5 * k] = k + (2 * S + 3 * k) % 5 * 5;
            for (var T = 1, M = 0; M < 24; M++) {
              for (var F = 0, B = 0, V = 0; V < 7; V++) {
                if (T & 1) {
                  var H = (1 << V) - 1;
                  H < 32 ? B ^= 1 << H : F ^= 1 << H - 32;
                }
                T & 128 ? T = T << 1 ^ 113 : T <<= 1;
              }
              w[M] = h.create(F, B);
            }
          })();
          var E = [];
          (function() {
            for (var S = 0; S < 25; S++)
              E[S] = h.create();
          })();
          var C = v.SHA3 = c.extend({
            /**
             * Configuration options.
             *
             * @property {number} outputLength
             *   The desired number of bits in the output hash.
             *   Only values permitted are: 224, 256, 384, 512.
             *   Default: 512
             */
            cfg: c.cfg.extend({
              outputLength: 512
            }),
            _doReset: function() {
              for (var S = this._state = [], k = 0; k < 25; k++)
                S[k] = new h.init();
              this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(S, k) {
              for (var D = this._state, A = this.blockSize / 2, R = 0; R < A; R++) {
                var T = S[k + 2 * R], M = S[k + 2 * R + 1];
                T = (T << 8 | T >>> 24) & 16711935 | (T << 24 | T >>> 8) & 4278255360, M = (M << 8 | M >>> 24) & 16711935 | (M << 24 | M >>> 8) & 4278255360;
                var F = D[R];
                F.high ^= M, F.low ^= T;
              }
              for (var B = 0; B < 24; B++) {
                for (var V = 0; V < 5; V++) {
                  for (var H = 0, q = 0, Q = 0; Q < 5; Q++) {
                    var F = D[V + 5 * Q];
                    H ^= F.high, q ^= F.low;
                  }
                  var W = E[V];
                  W.high = H, W.low = q;
                }
                for (var V = 0; V < 5; V++)
                  for (var J = E[(V + 4) % 5], ne = E[(V + 1) % 5], ie = ne.high, se = ne.low, H = J.high ^ (ie << 1 | se >>> 31), q = J.low ^ (se << 1 | ie >>> 31), Q = 0; Q < 5; Q++) {
                    var F = D[V + 5 * Q];
                    F.high ^= H, F.low ^= q;
                  }
                for (var X = 1; X < 25; X++) {
                  var H, q, F = D[X], fe = F.high, Z = F.low, z = y[X];
                  z < 32 ? (H = fe << z | Z >>> 32 - z, q = Z << z | fe >>> 32 - z) : (H = Z << z - 32 | fe >>> 64 - z, q = fe << z - 32 | Z >>> 64 - z);
                  var Y = E[x[X]];
                  Y.high = H, Y.low = q;
                }
                var te = E[0], ae = D[0];
                te.high = ae.high, te.low = ae.low;
                for (var V = 0; V < 5; V++)
                  for (var Q = 0; Q < 5; Q++) {
                    var X = V + 5 * Q, F = D[X], De = E[X], ke = E[(V + 1) % 5 + 5 * Q], Re = E[(V + 2) % 5 + 5 * Q];
                    F.high = De.high ^ ~ke.high & Re.high, F.low = De.low ^ ~ke.low & Re.low;
                  }
                var F = D[0], Te = w[B];
                F.high ^= Te.high, F.low ^= Te.low;
              }
            },
            _doFinalize: function() {
              var S = this._data, k = S.words;
              this._nDataBytes * 8;
              var D = S.sigBytes * 8, A = this.blockSize * 32;
              k[D >>> 5] |= 1 << 24 - D % 32, k[(n.ceil((D + 1) / A) * A >>> 5) - 1] |= 128, S.sigBytes = k.length * 4, this._process();
              for (var R = this._state, T = this.cfg.outputLength / 8, M = T / 8, F = [], B = 0; B < M; B++) {
                var V = R[B], H = V.high, q = V.low;
                H = (H << 8 | H >>> 24) & 16711935 | (H << 24 | H >>> 8) & 4278255360, q = (q << 8 | q >>> 24) & 16711935 | (q << 24 | q >>> 8) & 4278255360, F.push(q), F.push(H);
              }
              return new s.init(F, T);
            },
            clone: function() {
              for (var S = c.clone.call(this), k = S._state = this._state.slice(0), D = 0; D < 25; D++)
                k[D] = k[D].clone();
              return S;
            }
          });
          i.SHA3 = c._createHelper(C), i.HmacSHA3 = c._createHmacHelper(C);
        }(Math), r.SHA3;
      });
    }(qE)), qE.exports;
  }
  var UE = { exports: {} }, gae = UE.exports, g3;
  function xae() {
    return g3 || (g3 = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(vr());
      })(gae, function(r) {
        /** @preserve
        			(c) 2012 by Cédric Mesnil. All rights reserved.
        
        			Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
        
        			    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
        			    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
        
        			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
        			*/
        return function(n) {
          var i = r, u = i.lib, s = u.WordArray, c = u.Hasher, p = i.algo, h = s.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
          ]), v = s.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
          ]), y = s.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
          ]), x = s.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
          ]), w = s.create([0, 1518500249, 1859775393, 2400959708, 2840853838]), E = s.create([1352829926, 1548603684, 1836072691, 2053994217, 0]), C = p.RIPEMD160 = c.extend({
            _doReset: function() {
              this._hash = s.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
            },
            _doProcessBlock: function(M, F) {
              for (var B = 0; B < 16; B++) {
                var V = F + B, H = M[V];
                M[V] = (H << 8 | H >>> 24) & 16711935 | (H << 24 | H >>> 8) & 4278255360;
              }
              var q = this._hash.words, Q = w.words, W = E.words, J = h.words, ne = v.words, ie = y.words, se = x.words, X, fe, Z, z, Y, te, ae, De, ke, Re;
              te = X = q[0], ae = fe = q[1], De = Z = q[2], ke = z = q[3], Re = Y = q[4];
              for (var Te, B = 0; B < 80; B += 1)
                Te = X + M[F + J[B]] | 0, B < 16 ? Te += S(fe, Z, z) + Q[0] : B < 32 ? Te += k(fe, Z, z) + Q[1] : B < 48 ? Te += D(fe, Z, z) + Q[2] : B < 64 ? Te += A(fe, Z, z) + Q[3] : Te += R(fe, Z, z) + Q[4], Te = Te | 0, Te = T(Te, ie[B]), Te = Te + Y | 0, X = Y, Y = z, z = T(Z, 10), Z = fe, fe = Te, Te = te + M[F + ne[B]] | 0, B < 16 ? Te += R(ae, De, ke) + W[0] : B < 32 ? Te += A(ae, De, ke) + W[1] : B < 48 ? Te += D(ae, De, ke) + W[2] : B < 64 ? Te += k(ae, De, ke) + W[3] : Te += S(ae, De, ke) + W[4], Te = Te | 0, Te = T(Te, se[B]), Te = Te + Re | 0, te = Re, Re = ke, ke = T(De, 10), De = ae, ae = Te;
              Te = q[1] + Z + ke | 0, q[1] = q[2] + z + Re | 0, q[2] = q[3] + Y + te | 0, q[3] = q[4] + X + ae | 0, q[4] = q[0] + fe + De | 0, q[0] = Te;
            },
            _doFinalize: function() {
              var M = this._data, F = M.words, B = this._nDataBytes * 8, V = M.sigBytes * 8;
              F[V >>> 5] |= 128 << 24 - V % 32, F[(V + 64 >>> 9 << 4) + 14] = (B << 8 | B >>> 24) & 16711935 | (B << 24 | B >>> 8) & 4278255360, M.sigBytes = (F.length + 1) * 4, this._process();
              for (var H = this._hash, q = H.words, Q = 0; Q < 5; Q++) {
                var W = q[Q];
                q[Q] = (W << 8 | W >>> 24) & 16711935 | (W << 24 | W >>> 8) & 4278255360;
              }
              return H;
            },
            clone: function() {
              var M = c.clone.call(this);
              return M._hash = this._hash.clone(), M;
            }
          });
          function S(M, F, B) {
            return M ^ F ^ B;
          }
          function k(M, F, B) {
            return M & F | ~M & B;
          }
          function D(M, F, B) {
            return (M | ~F) ^ B;
          }
          function A(M, F, B) {
            return M & B | F & ~B;
          }
          function R(M, F, B) {
            return M ^ (F | ~B);
          }
          function T(M, F) {
            return M << F | M >>> 32 - F;
          }
          i.RIPEMD160 = c._createHelper(C), i.HmacRIPEMD160 = c._createHmacHelper(C);
        }(), r.RIPEMD160;
      });
    }(UE)), UE.exports;
  }
  var HE = { exports: {} }, bae = HE.exports, x3;
  function NN() {
    return x3 || (x3 = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(vr());
      })(bae, function(r) {
        (function() {
          var n = r, i = n.lib, u = i.Base, s = n.enc, c = s.Utf8, p = n.algo;
          p.HMAC = u.extend({
            /**
             * Initializes a newly created HMAC.
             *
             * @param {Hasher} hasher The hash algorithm to use.
             * @param {WordArray|string} key The secret key.
             *
             * @example
             *
             *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
             */
            init: function(h, v) {
              h = this._hasher = new h.init(), typeof v == "string" && (v = c.parse(v));
              var y = h.blockSize, x = y * 4;
              v.sigBytes > x && (v = h.finalize(v)), v.clamp();
              for (var w = this._oKey = v.clone(), E = this._iKey = v.clone(), C = w.words, S = E.words, k = 0; k < y; k++)
                C[k] ^= 1549556828, S[k] ^= 909522486;
              w.sigBytes = E.sigBytes = x, this.reset();
            },
            /**
             * Resets this HMAC to its initial state.
             *
             * @example
             *
             *     hmacHasher.reset();
             */
            reset: function() {
              var h = this._hasher;
              h.reset(), h.update(this._iKey);
            },
            /**
             * Updates this HMAC with a message.
             *
             * @param {WordArray|string} messageUpdate The message to append.
             *
             * @return {HMAC} This HMAC instance.
             *
             * @example
             *
             *     hmacHasher.update('message');
             *     hmacHasher.update(wordArray);
             */
            update: function(h) {
              return this._hasher.update(h), this;
            },
            /**
             * Finalizes the HMAC computation.
             * Note that the finalize operation is effectively a destructive, read-once operation.
             *
             * @param {WordArray|string} messageUpdate (Optional) A final message update.
             *
             * @return {WordArray} The HMAC.
             *
             * @example
             *
             *     var hmac = hmacHasher.finalize();
             *     var hmac = hmacHasher.finalize('message');
             *     var hmac = hmacHasher.finalize(wordArray);
             */
            finalize: function(h) {
              var v = this._hasher, y = v.finalize(h);
              v.reset();
              var x = v.finalize(this._oKey.clone().concat(y));
              return x;
            }
          });
        })();
      });
    }(HE)), HE.exports;
  }
  var VE = { exports: {} }, wae = VE.exports, b3;
  function Eae() {
    return b3 || (b3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), MN(), NN());
      })(wae, function(r) {
        return function() {
          var n = r, i = n.lib, u = i.Base, s = i.WordArray, c = n.algo, p = c.SHA256, h = c.HMAC, v = c.PBKDF2 = u.extend({
            /**
             * Configuration options.
             *
             * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
             * @property {Hasher} hasher The hasher to use. Default: SHA256
             * @property {number} iterations The number of iterations to perform. Default: 250000
             */
            cfg: u.extend({
              keySize: 128 / 32,
              hasher: p,
              iterations: 25e4
            }),
            /**
             * Initializes a newly created key derivation function.
             *
             * @param {Object} cfg (Optional) The configuration options to use for the derivation.
             *
             * @example
             *
             *     var kdf = CryptoJS.algo.PBKDF2.create();
             *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
             *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
             */
            init: function(y) {
              this.cfg = this.cfg.extend(y);
            },
            /**
             * Computes the Password-Based Key Derivation Function 2.
             *
             * @param {WordArray|string} password The password.
             * @param {WordArray|string} salt A salt.
             *
             * @return {WordArray} The derived key.
             *
             * @example
             *
             *     var key = kdf.compute(password, salt);
             */
            compute: function(y, x) {
              for (var w = this.cfg, E = h.create(w.hasher, y), C = s.create(), S = s.create([1]), k = C.words, D = S.words, A = w.keySize, R = w.iterations; k.length < A; ) {
                var T = E.update(x).finalize(S);
                E.reset();
                for (var M = T.words, F = M.length, B = T, V = 1; V < R; V++) {
                  B = E.finalize(B), E.reset();
                  for (var H = B.words, q = 0; q < F; q++)
                    M[q] ^= H[q];
                }
                C.concat(T), D[0]++;
              }
              return C.sigBytes = A * 4, C;
            }
          });
          n.PBKDF2 = function(y, x, w) {
            return v.create(w).compute(y, x);
          };
        }(), r.PBKDF2;
      });
    }(VE)), VE.exports;
  }
  var WE = { exports: {} }, Sae = WE.exports, w3;
  function Yf() {
    return w3 || (w3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), L9(), NN());
      })(Sae, function(r) {
        return function() {
          var n = r, i = n.lib, u = i.Base, s = i.WordArray, c = n.algo, p = c.MD5, h = c.EvpKDF = u.extend({
            /**
             * Configuration options.
             *
             * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
             * @property {Hasher} hasher The hash algorithm to use. Default: MD5
             * @property {number} iterations The number of iterations to perform. Default: 1
             */
            cfg: u.extend({
              keySize: 128 / 32,
              hasher: p,
              iterations: 1
            }),
            /**
             * Initializes a newly created key derivation function.
             *
             * @param {Object} cfg (Optional) The configuration options to use for the derivation.
             *
             * @example
             *
             *     var kdf = CryptoJS.algo.EvpKDF.create();
             *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
             *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
             */
            init: function(v) {
              this.cfg = this.cfg.extend(v);
            },
            /**
             * Derives a key from a password.
             *
             * @param {WordArray|string} password The password.
             * @param {WordArray|string} salt A salt.
             *
             * @return {WordArray} The derived key.
             *
             * @example
             *
             *     var key = kdf.compute(password, salt);
             */
            compute: function(v, y) {
              for (var x, w = this.cfg, E = w.hasher.create(), C = s.create(), S = C.words, k = w.keySize, D = w.iterations; S.length < k; ) {
                x && E.update(x), x = E.update(v).finalize(y), E.reset();
                for (var A = 1; A < D; A++)
                  x = E.finalize(x), E.reset();
                C.concat(x);
              }
              return C.sigBytes = k * 4, C;
            }
          });
          n.EvpKDF = function(v, y, x) {
            return h.create(x).compute(v, y);
          };
        }(), r.EvpKDF;
      });
    }(WE)), WE.exports;
  }
  var YE = { exports: {} }, _ae = YE.exports, E3;
  function Bi() {
    return E3 || (E3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), Yf());
      })(_ae, function(r) {
        r.lib.Cipher || function(n) {
          var i = r, u = i.lib, s = u.Base, c = u.WordArray, p = u.BufferedBlockAlgorithm, h = i.enc;
          h.Utf8;
          var v = h.Base64, y = i.algo, x = y.EvpKDF, w = u.Cipher = p.extend({
            /**
             * Configuration options.
             *
             * @property {WordArray} iv The IV to use for this operation.
             */
            cfg: s.extend(),
            /**
             * Creates this cipher in encryption mode.
             *
             * @param {WordArray} key The key.
             * @param {Object} cfg (Optional) The configuration options to use for this operation.
             *
             * @return {Cipher} A cipher instance.
             *
             * @static
             *
             * @example
             *
             *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
             */
            createEncryptor: function(H, q) {
              return this.create(this._ENC_XFORM_MODE, H, q);
            },
            /**
             * Creates this cipher in decryption mode.
             *
             * @param {WordArray} key The key.
             * @param {Object} cfg (Optional) The configuration options to use for this operation.
             *
             * @return {Cipher} A cipher instance.
             *
             * @static
             *
             * @example
             *
             *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
             */
            createDecryptor: function(H, q) {
              return this.create(this._DEC_XFORM_MODE, H, q);
            },
            /**
             * Initializes a newly created cipher.
             *
             * @param {number} xformMode Either the encryption or decryption transormation mode constant.
             * @param {WordArray} key The key.
             * @param {Object} cfg (Optional) The configuration options to use for this operation.
             *
             * @example
             *
             *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
             */
            init: function(H, q, Q) {
              this.cfg = this.cfg.extend(Q), this._xformMode = H, this._key = q, this.reset();
            },
            /**
             * Resets this cipher to its initial state.
             *
             * @example
             *
             *     cipher.reset();
             */
            reset: function() {
              p.reset.call(this), this._doReset();
            },
            /**
             * Adds data to be encrypted or decrypted.
             *
             * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
             *
             * @return {WordArray} The data after processing.
             *
             * @example
             *
             *     var encrypted = cipher.process('data');
             *     var encrypted = cipher.process(wordArray);
             */
            process: function(H) {
              return this._append(H), this._process();
            },
            /**
             * Finalizes the encryption or decryption process.
             * Note that the finalize operation is effectively a destructive, read-once operation.
             *
             * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
             *
             * @return {WordArray} The data after final processing.
             *
             * @example
             *
             *     var encrypted = cipher.finalize();
             *     var encrypted = cipher.finalize('data');
             *     var encrypted = cipher.finalize(wordArray);
             */
            finalize: function(H) {
              H && this._append(H);
              var q = this._doFinalize();
              return q;
            },
            keySize: 128 / 32,
            ivSize: 128 / 32,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
             * Creates shortcut functions to a cipher's object interface.
             *
             * @param {Cipher} cipher The cipher to create a helper for.
             *
             * @return {Object} An object with encrypt and decrypt shortcut functions.
             *
             * @static
             *
             * @example
             *
             *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
             */
            _createHelper: /* @__PURE__ */ function() {
              function H(q) {
                return typeof q == "string" ? V : M;
              }
              return function(q) {
                return {
                  encrypt: function(Q, W, J) {
                    return H(W).encrypt(q, Q, W, J);
                  },
                  decrypt: function(Q, W, J) {
                    return H(W).decrypt(q, Q, W, J);
                  }
                };
              };
            }()
          });
          u.StreamCipher = w.extend({
            _doFinalize: function() {
              var H = this._process(!0);
              return H;
            },
            blockSize: 1
          });
          var E = i.mode = {}, C = u.BlockCipherMode = s.extend({
            /**
             * Creates this mode for encryption.
             *
             * @param {Cipher} cipher A block cipher instance.
             * @param {Array} iv The IV words.
             *
             * @static
             *
             * @example
             *
             *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
             */
            createEncryptor: function(H, q) {
              return this.Encryptor.create(H, q);
            },
            /**
             * Creates this mode for decryption.
             *
             * @param {Cipher} cipher A block cipher instance.
             * @param {Array} iv The IV words.
             *
             * @static
             *
             * @example
             *
             *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
             */
            createDecryptor: function(H, q) {
              return this.Decryptor.create(H, q);
            },
            /**
             * Initializes a newly created mode.
             *
             * @param {Cipher} cipher A block cipher instance.
             * @param {Array} iv The IV words.
             *
             * @example
             *
             *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
             */
            init: function(H, q) {
              this._cipher = H, this._iv = q;
            }
          }), S = E.CBC = function() {
            var H = C.extend();
            H.Encryptor = H.extend({
              /**
               * Processes the data block at offset.
               *
               * @param {Array} words The data words to operate on.
               * @param {number} offset The offset where the block starts.
               *
               * @example
               *
               *     mode.processBlock(data.words, offset);
               */
              processBlock: function(Q, W) {
                var J = this._cipher, ne = J.blockSize;
                q.call(this, Q, W, ne), J.encryptBlock(Q, W), this._prevBlock = Q.slice(W, W + ne);
              }
            }), H.Decryptor = H.extend({
              /**
               * Processes the data block at offset.
               *
               * @param {Array} words The data words to operate on.
               * @param {number} offset The offset where the block starts.
               *
               * @example
               *
               *     mode.processBlock(data.words, offset);
               */
              processBlock: function(Q, W) {
                var J = this._cipher, ne = J.blockSize, ie = Q.slice(W, W + ne);
                J.decryptBlock(Q, W), q.call(this, Q, W, ne), this._prevBlock = ie;
              }
            });
            function q(Q, W, J) {
              var ne, ie = this._iv;
              ie ? (ne = ie, this._iv = n) : ne = this._prevBlock;
              for (var se = 0; se < J; se++)
                Q[W + se] ^= ne[se];
            }
            return H;
          }(), k = i.pad = {}, D = k.Pkcs7 = {
            /**
             * Pads data using the algorithm defined in PKCS #5/7.
             *
             * @param {WordArray} data The data to pad.
             * @param {number} blockSize The multiple that the data should be padded to.
             *
             * @static
             *
             * @example
             *
             *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
             */
            pad: function(H, q) {
              for (var Q = q * 4, W = Q - H.sigBytes % Q, J = W << 24 | W << 16 | W << 8 | W, ne = [], ie = 0; ie < W; ie += 4)
                ne.push(J);
              var se = c.create(ne, W);
              H.concat(se);
            },
            /**
             * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
             *
             * @param {WordArray} data The data to unpad.
             *
             * @static
             *
             * @example
             *
             *     CryptoJS.pad.Pkcs7.unpad(wordArray);
             */
            unpad: function(H) {
              var q = H.words[H.sigBytes - 1 >>> 2] & 255;
              H.sigBytes -= q;
            }
          };
          u.BlockCipher = w.extend({
            /**
             * Configuration options.
             *
             * @property {Mode} mode The block mode to use. Default: CBC
             * @property {Padding} padding The padding strategy to use. Default: Pkcs7
             */
            cfg: w.cfg.extend({
              mode: S,
              padding: D
            }),
            reset: function() {
              var H;
              w.reset.call(this);
              var q = this.cfg, Q = q.iv, W = q.mode;
              this._xformMode == this._ENC_XFORM_MODE ? H = W.createEncryptor : (H = W.createDecryptor, this._minBufferSize = 1), this._mode && this._mode.__creator == H ? this._mode.init(this, Q && Q.words) : (this._mode = H.call(W, this, Q && Q.words), this._mode.__creator = H);
            },
            _doProcessBlock: function(H, q) {
              this._mode.processBlock(H, q);
            },
            _doFinalize: function() {
              var H, q = this.cfg.padding;
              return this._xformMode == this._ENC_XFORM_MODE ? (q.pad(this._data, this.blockSize), H = this._process(!0)) : (H = this._process(!0), q.unpad(H)), H;
            },
            blockSize: 128 / 32
          });
          var A = u.CipherParams = s.extend({
            /**
             * Initializes a newly created cipher params object.
             *
             * @param {Object} cipherParams An object with any of the possible cipher parameters.
             *
             * @example
             *
             *     var cipherParams = CryptoJS.lib.CipherParams.create({
             *         ciphertext: ciphertextWordArray,
             *         key: keyWordArray,
             *         iv: ivWordArray,
             *         salt: saltWordArray,
             *         algorithm: CryptoJS.algo.AES,
             *         mode: CryptoJS.mode.CBC,
             *         padding: CryptoJS.pad.PKCS7,
             *         blockSize: 4,
             *         formatter: CryptoJS.format.OpenSSL
             *     });
             */
            init: function(H) {
              this.mixIn(H);
            },
            /**
             * Converts this cipher params object to a string.
             *
             * @param {Format} formatter (Optional) The formatting strategy to use.
             *
             * @return {string} The stringified cipher params.
             *
             * @throws Error If neither the formatter nor the default formatter is set.
             *
             * @example
             *
             *     var string = cipherParams + '';
             *     var string = cipherParams.toString();
             *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
             */
            toString: function(H) {
              return (H || this.formatter).stringify(this);
            }
          }), R = i.format = {}, T = R.OpenSSL = {
            /**
             * Converts a cipher params object to an OpenSSL-compatible string.
             *
             * @param {CipherParams} cipherParams The cipher params object.
             *
             * @return {string} The OpenSSL-compatible string.
             *
             * @static
             *
             * @example
             *
             *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
             */
            stringify: function(H) {
              var q, Q = H.ciphertext, W = H.salt;
              return W ? q = c.create([1398893684, 1701076831]).concat(W).concat(Q) : q = Q, q.toString(v);
            },
            /**
             * Converts an OpenSSL-compatible string to a cipher params object.
             *
             * @param {string} openSSLStr The OpenSSL-compatible string.
             *
             * @return {CipherParams} The cipher params object.
             *
             * @static
             *
             * @example
             *
             *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
             */
            parse: function(H) {
              var q, Q = v.parse(H), W = Q.words;
              return W[0] == 1398893684 && W[1] == 1701076831 && (q = c.create(W.slice(2, 4)), W.splice(0, 4), Q.sigBytes -= 16), A.create({ ciphertext: Q, salt: q });
            }
          }, M = u.SerializableCipher = s.extend({
            /**
             * Configuration options.
             *
             * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
             */
            cfg: s.extend({
              format: T
            }),
            /**
             * Encrypts a message.
             *
             * @param {Cipher} cipher The cipher algorithm to use.
             * @param {WordArray|string} message The message to encrypt.
             * @param {WordArray} key The key.
             * @param {Object} cfg (Optional) The configuration options to use for this operation.
             *
             * @return {CipherParams} A cipher params object.
             *
             * @static
             *
             * @example
             *
             *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
             *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
             *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
             */
            encrypt: function(H, q, Q, W) {
              W = this.cfg.extend(W);
              var J = H.createEncryptor(Q, W), ne = J.finalize(q), ie = J.cfg;
              return A.create({
                ciphertext: ne,
                key: Q,
                iv: ie.iv,
                algorithm: H,
                mode: ie.mode,
                padding: ie.padding,
                blockSize: H.blockSize,
                formatter: W.format
              });
            },
            /**
             * Decrypts serialized ciphertext.
             *
             * @param {Cipher} cipher The cipher algorithm to use.
             * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
             * @param {WordArray} key The key.
             * @param {Object} cfg (Optional) The configuration options to use for this operation.
             *
             * @return {WordArray} The plaintext.
             *
             * @static
             *
             * @example
             *
             *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
             *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
             */
            decrypt: function(H, q, Q, W) {
              W = this.cfg.extend(W), q = this._parse(q, W.format);
              var J = H.createDecryptor(Q, W).finalize(q.ciphertext);
              return J;
            },
            /**
             * Converts serialized ciphertext to CipherParams,
             * else assumed CipherParams already and returns ciphertext unchanged.
             *
             * @param {CipherParams|string} ciphertext The ciphertext.
             * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
             *
             * @return {CipherParams} The unserialized ciphertext.
             *
             * @static
             *
             * @example
             *
             *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
             */
            _parse: function(H, q) {
              return typeof H == "string" ? q.parse(H, this) : H;
            }
          }), F = i.kdf = {}, B = F.OpenSSL = {
            /**
             * Derives a key and IV from a password.
             *
             * @param {string} password The password to derive from.
             * @param {number} keySize The size in words of the key to generate.
             * @param {number} ivSize The size in words of the IV to generate.
             * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
             *
             * @return {CipherParams} A cipher params object with the key, IV, and salt.
             *
             * @static
             *
             * @example
             *
             *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
             *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
             */
            execute: function(H, q, Q, W, J) {
              if (W || (W = c.random(64 / 8)), J)
                var ne = x.create({ keySize: q + Q, hasher: J }).compute(H, W);
              else
                var ne = x.create({ keySize: q + Q }).compute(H, W);
              var ie = c.create(ne.words.slice(q), Q * 4);
              return ne.sigBytes = q * 4, A.create({ key: ne, iv: ie, salt: W });
            }
          }, V = u.PasswordBasedCipher = M.extend({
            /**
             * Configuration options.
             *
             * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
             */
            cfg: M.cfg.extend({
              kdf: B
            }),
            /**
             * Encrypts a message using a password.
             *
             * @param {Cipher} cipher The cipher algorithm to use.
             * @param {WordArray|string} message The message to encrypt.
             * @param {string} password The password.
             * @param {Object} cfg (Optional) The configuration options to use for this operation.
             *
             * @return {CipherParams} A cipher params object.
             *
             * @static
             *
             * @example
             *
             *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
             *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
             */
            encrypt: function(H, q, Q, W) {
              W = this.cfg.extend(W);
              var J = W.kdf.execute(Q, H.keySize, H.ivSize, W.salt, W.hasher);
              W.iv = J.iv;
              var ne = M.encrypt.call(this, H, q, J.key, W);
              return ne.mixIn(J), ne;
            },
            /**
             * Decrypts serialized ciphertext using a password.
             *
             * @param {Cipher} cipher The cipher algorithm to use.
             * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
             * @param {string} password The password.
             * @param {Object} cfg (Optional) The configuration options to use for this operation.
             *
             * @return {WordArray} The plaintext.
             *
             * @static
             *
             * @example
             *
             *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
             *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
             */
            decrypt: function(H, q, Q, W) {
              W = this.cfg.extend(W), q = this._parse(q, W.format);
              var J = W.kdf.execute(Q, H.keySize, H.ivSize, q.salt, W.hasher);
              W.iv = J.iv;
              var ne = M.decrypt.call(this, H, q, J.key, W);
              return ne;
            }
          });
        }();
      });
    }(YE)), YE.exports;
  }
  var GE = { exports: {} }, Cae = GE.exports, S3;
  function Oae() {
    return S3 || (S3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), Bi());
      })(Cae, function(r) {
        return r.mode.CFB = function() {
          var n = r.lib.BlockCipherMode.extend();
          n.Encryptor = n.extend({
            processBlock: function(u, s) {
              var c = this._cipher, p = c.blockSize;
              i.call(this, u, s, p, c), this._prevBlock = u.slice(s, s + p);
            }
          }), n.Decryptor = n.extend({
            processBlock: function(u, s) {
              var c = this._cipher, p = c.blockSize, h = u.slice(s, s + p);
              i.call(this, u, s, p, c), this._prevBlock = h;
            }
          });
          function i(u, s, c, p) {
            var h, v = this._iv;
            v ? (h = v.slice(0), this._iv = void 0) : h = this._prevBlock, p.encryptBlock(h, 0);
            for (var y = 0; y < c; y++)
              u[s + y] ^= h[y];
          }
          return n;
        }(), r.mode.CFB;
      });
    }(GE)), GE.exports;
  }
  var QE = { exports: {} }, Tae = QE.exports, _3;
  function Aae() {
    return _3 || (_3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), Bi());
      })(Tae, function(r) {
        return r.mode.CTR = function() {
          var n = r.lib.BlockCipherMode.extend(), i = n.Encryptor = n.extend({
            processBlock: function(u, s) {
              var c = this._cipher, p = c.blockSize, h = this._iv, v = this._counter;
              h && (v = this._counter = h.slice(0), this._iv = void 0);
              var y = v.slice(0);
              c.encryptBlock(y, 0), v[p - 1] = v[p - 1] + 1 | 0;
              for (var x = 0; x < p; x++)
                u[s + x] ^= y[x];
            }
          });
          return n.Decryptor = i, n;
        }(), r.mode.CTR;
      });
    }(QE)), QE.exports;
  }
  var KE = { exports: {} }, Dae = KE.exports, C3;
  function kae() {
    return C3 || (C3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), Bi());
      })(Dae, function(r) {
        /** @preserve
         * Counter block mode compatible with  Dr Brian Gladman fileenc.c
         * derived from CryptoJS.mode.CTR
         * Jan Hruby jhruby.web@gmail.com
         */
        return r.mode.CTRGladman = function() {
          var n = r.lib.BlockCipherMode.extend();
          function i(c) {
            if ((c >> 24 & 255) === 255) {
              var p = c >> 16 & 255, h = c >> 8 & 255, v = c & 255;
              p === 255 ? (p = 0, h === 255 ? (h = 0, v === 255 ? v = 0 : ++v) : ++h) : ++p, c = 0, c += p << 16, c += h << 8, c += v;
            } else
              c += 1 << 24;
            return c;
          }
          function u(c) {
            return (c[0] = i(c[0])) === 0 && (c[1] = i(c[1])), c;
          }
          var s = n.Encryptor = n.extend({
            processBlock: function(c, p) {
              var h = this._cipher, v = h.blockSize, y = this._iv, x = this._counter;
              y && (x = this._counter = y.slice(0), this._iv = void 0), u(x);
              var w = x.slice(0);
              h.encryptBlock(w, 0);
              for (var E = 0; E < v; E++)
                c[p + E] ^= w[E];
            }
          });
          return n.Decryptor = s, n;
        }(), r.mode.CTRGladman;
      });
    }(KE)), KE.exports;
  }
  var XE = { exports: {} }, Rae = XE.exports, O3;
  function Pae() {
    return O3 || (O3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), Bi());
      })(Rae, function(r) {
        return r.mode.OFB = function() {
          var n = r.lib.BlockCipherMode.extend(), i = n.Encryptor = n.extend({
            processBlock: function(u, s) {
              var c = this._cipher, p = c.blockSize, h = this._iv, v = this._keystream;
              h && (v = this._keystream = h.slice(0), this._iv = void 0), c.encryptBlock(v, 0);
              for (var y = 0; y < p; y++)
                u[s + y] ^= v[y];
            }
          });
          return n.Decryptor = i, n;
        }(), r.mode.OFB;
      });
    }(XE)), XE.exports;
  }
  var ZE = { exports: {} }, Mae = ZE.exports, T3;
  function Nae() {
    return T3 || (T3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), Bi());
      })(Mae, function(r) {
        return r.mode.ECB = function() {
          var n = r.lib.BlockCipherMode.extend();
          return n.Encryptor = n.extend({
            processBlock: function(i, u) {
              this._cipher.encryptBlock(i, u);
            }
          }), n.Decryptor = n.extend({
            processBlock: function(i, u) {
              this._cipher.decryptBlock(i, u);
            }
          }), n;
        }(), r.mode.ECB;
      });
    }(ZE)), ZE.exports;
  }
  var JE = { exports: {} }, jae = JE.exports, A3;
  function Fae() {
    return A3 || (A3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), Bi());
      })(jae, function(r) {
        return r.pad.AnsiX923 = {
          pad: function(n, i) {
            var u = n.sigBytes, s = i * 4, c = s - u % s, p = u + c - 1;
            n.clamp(), n.words[p >>> 2] |= c << 24 - p % 4 * 8, n.sigBytes += c;
          },
          unpad: function(n) {
            var i = n.words[n.sigBytes - 1 >>> 2] & 255;
            n.sigBytes -= i;
          }
        }, r.pad.Ansix923;
      });
    }(JE)), JE.exports;
  }
  var eS = { exports: {} }, Iae = eS.exports, D3;
  function Bae() {
    return D3 || (D3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), Bi());
      })(Iae, function(r) {
        return r.pad.Iso10126 = {
          pad: function(n, i) {
            var u = i * 4, s = u - n.sigBytes % u;
            n.concat(r.lib.WordArray.random(s - 1)).concat(r.lib.WordArray.create([s << 24], 1));
          },
          unpad: function(n) {
            var i = n.words[n.sigBytes - 1 >>> 2] & 255;
            n.sigBytes -= i;
          }
        }, r.pad.Iso10126;
      });
    }(eS)), eS.exports;
  }
  var tS = { exports: {} }, Lae = tS.exports, k3;
  function $ae() {
    return k3 || (k3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), Bi());
      })(Lae, function(r) {
        return r.pad.Iso97971 = {
          pad: function(n, i) {
            n.concat(r.lib.WordArray.create([2147483648], 1)), r.pad.ZeroPadding.pad(n, i);
          },
          unpad: function(n) {
            r.pad.ZeroPadding.unpad(n), n.sigBytes--;
          }
        }, r.pad.Iso97971;
      });
    }(tS)), tS.exports;
  }
  var rS = { exports: {} }, zae = rS.exports, R3;
  function qae() {
    return R3 || (R3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), Bi());
      })(zae, function(r) {
        return r.pad.ZeroPadding = {
          pad: function(n, i) {
            var u = i * 4;
            n.clamp(), n.sigBytes += u - (n.sigBytes % u || u);
          },
          unpad: function(n) {
            for (var i = n.words, u = n.sigBytes - 1, u = n.sigBytes - 1; u >= 0; u--)
              if (i[u >>> 2] >>> 24 - u % 4 * 8 & 255) {
                n.sigBytes = u + 1;
                break;
              }
          }
        }, r.pad.ZeroPadding;
      });
    }(rS)), rS.exports;
  }
  var nS = { exports: {} }, Uae = nS.exports, P3;
  function Hae() {
    return P3 || (P3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), Bi());
      })(Uae, function(r) {
        return r.pad.NoPadding = {
          pad: function() {
          },
          unpad: function() {
          }
        }, r.pad.NoPadding;
      });
    }(nS)), nS.exports;
  }
  var iS = { exports: {} }, Vae = iS.exports, M3;
  function Wae() {
    return M3 || (M3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), Bi());
      })(Vae, function(r) {
        return function(n) {
          var i = r, u = i.lib, s = u.CipherParams, c = i.enc, p = c.Hex, h = i.format;
          h.Hex = {
            /**
             * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
             *
             * @param {CipherParams} cipherParams The cipher params object.
             *
             * @return {string} The hexadecimally encoded string.
             *
             * @static
             *
             * @example
             *
             *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
             */
            stringify: function(v) {
              return v.ciphertext.toString(p);
            },
            /**
             * Converts a hexadecimally encoded ciphertext string to a cipher params object.
             *
             * @param {string} input The hexadecimally encoded string.
             *
             * @return {CipherParams} The cipher params object.
             *
             * @static
             *
             * @example
             *
             *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
             */
            parse: function(v) {
              var y = p.parse(v);
              return s.create({ ciphertext: y });
            }
          };
        }(), r.format.Hex;
      });
    }(iS)), iS.exports;
  }
  var aS = { exports: {} }, Yae = aS.exports, N3;
  function Gae() {
    return N3 || (N3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), zp(), qp(), Yf(), Bi());
      })(Yae, function(r) {
        return function() {
          var n = r, i = n.lib, u = i.BlockCipher, s = n.algo, c = [], p = [], h = [], v = [], y = [], x = [], w = [], E = [], C = [], S = [];
          (function() {
            for (var A = [], R = 0; R < 256; R++)
              R < 128 ? A[R] = R << 1 : A[R] = R << 1 ^ 283;
            for (var T = 0, M = 0, R = 0; R < 256; R++) {
              var F = M ^ M << 1 ^ M << 2 ^ M << 3 ^ M << 4;
              F = F >>> 8 ^ F & 255 ^ 99, c[T] = F, p[F] = T;
              var B = A[T], V = A[B], H = A[V], q = A[F] * 257 ^ F * 16843008;
              h[T] = q << 24 | q >>> 8, v[T] = q << 16 | q >>> 16, y[T] = q << 8 | q >>> 24, x[T] = q;
              var q = H * 16843009 ^ V * 65537 ^ B * 257 ^ T * 16843008;
              w[F] = q << 24 | q >>> 8, E[F] = q << 16 | q >>> 16, C[F] = q << 8 | q >>> 24, S[F] = q, T ? (T = B ^ A[A[A[H ^ B]]], M ^= A[A[M]]) : T = M = 1;
            }
          })();
          var k = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], D = s.AES = u.extend({
            _doReset: function() {
              var A;
              if (!(this._nRounds && this._keyPriorReset === this._key)) {
                for (var R = this._keyPriorReset = this._key, T = R.words, M = R.sigBytes / 4, F = this._nRounds = M + 6, B = (F + 1) * 4, V = this._keySchedule = [], H = 0; H < B; H++)
                  H < M ? V[H] = T[H] : (A = V[H - 1], H % M ? M > 6 && H % M == 4 && (A = c[A >>> 24] << 24 | c[A >>> 16 & 255] << 16 | c[A >>> 8 & 255] << 8 | c[A & 255]) : (A = A << 8 | A >>> 24, A = c[A >>> 24] << 24 | c[A >>> 16 & 255] << 16 | c[A >>> 8 & 255] << 8 | c[A & 255], A ^= k[H / M | 0] << 24), V[H] = V[H - M] ^ A);
                for (var q = this._invKeySchedule = [], Q = 0; Q < B; Q++) {
                  var H = B - Q;
                  if (Q % 4)
                    var A = V[H];
                  else
                    var A = V[H - 4];
                  Q < 4 || H <= 4 ? q[Q] = A : q[Q] = w[c[A >>> 24]] ^ E[c[A >>> 16 & 255]] ^ C[c[A >>> 8 & 255]] ^ S[c[A & 255]];
                }
              }
            },
            encryptBlock: function(A, R) {
              this._doCryptBlock(A, R, this._keySchedule, h, v, y, x, c);
            },
            decryptBlock: function(A, R) {
              var T = A[R + 1];
              A[R + 1] = A[R + 3], A[R + 3] = T, this._doCryptBlock(A, R, this._invKeySchedule, w, E, C, S, p);
              var T = A[R + 1];
              A[R + 1] = A[R + 3], A[R + 3] = T;
            },
            _doCryptBlock: function(A, R, T, M, F, B, V, H) {
              for (var q = this._nRounds, Q = A[R] ^ T[0], W = A[R + 1] ^ T[1], J = A[R + 2] ^ T[2], ne = A[R + 3] ^ T[3], ie = 4, se = 1; se < q; se++) {
                var X = M[Q >>> 24] ^ F[W >>> 16 & 255] ^ B[J >>> 8 & 255] ^ V[ne & 255] ^ T[ie++], fe = M[W >>> 24] ^ F[J >>> 16 & 255] ^ B[ne >>> 8 & 255] ^ V[Q & 255] ^ T[ie++], Z = M[J >>> 24] ^ F[ne >>> 16 & 255] ^ B[Q >>> 8 & 255] ^ V[W & 255] ^ T[ie++], z = M[ne >>> 24] ^ F[Q >>> 16 & 255] ^ B[W >>> 8 & 255] ^ V[J & 255] ^ T[ie++];
                Q = X, W = fe, J = Z, ne = z;
              }
              var X = (H[Q >>> 24] << 24 | H[W >>> 16 & 255] << 16 | H[J >>> 8 & 255] << 8 | H[ne & 255]) ^ T[ie++], fe = (H[W >>> 24] << 24 | H[J >>> 16 & 255] << 16 | H[ne >>> 8 & 255] << 8 | H[Q & 255]) ^ T[ie++], Z = (H[J >>> 24] << 24 | H[ne >>> 16 & 255] << 16 | H[Q >>> 8 & 255] << 8 | H[W & 255]) ^ T[ie++], z = (H[ne >>> 24] << 24 | H[Q >>> 16 & 255] << 16 | H[W >>> 8 & 255] << 8 | H[J & 255]) ^ T[ie++];
              A[R] = X, A[R + 1] = fe, A[R + 2] = Z, A[R + 3] = z;
            },
            keySize: 256 / 32
          });
          n.AES = u._createHelper(D);
        }(), r.AES;
      });
    }(aS)), aS.exports;
  }
  var oS = { exports: {} }, Qae = oS.exports, j3;
  function Kae() {
    return j3 || (j3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), zp(), qp(), Yf(), Bi());
      })(Qae, function(r) {
        return function() {
          var n = r, i = n.lib, u = i.WordArray, s = i.BlockCipher, c = n.algo, p = [
            57,
            49,
            41,
            33,
            25,
            17,
            9,
            1,
            58,
            50,
            42,
            34,
            26,
            18,
            10,
            2,
            59,
            51,
            43,
            35,
            27,
            19,
            11,
            3,
            60,
            52,
            44,
            36,
            63,
            55,
            47,
            39,
            31,
            23,
            15,
            7,
            62,
            54,
            46,
            38,
            30,
            22,
            14,
            6,
            61,
            53,
            45,
            37,
            29,
            21,
            13,
            5,
            28,
            20,
            12,
            4
          ], h = [
            14,
            17,
            11,
            24,
            1,
            5,
            3,
            28,
            15,
            6,
            21,
            10,
            23,
            19,
            12,
            4,
            26,
            8,
            16,
            7,
            27,
            20,
            13,
            2,
            41,
            52,
            31,
            37,
            47,
            55,
            30,
            40,
            51,
            45,
            33,
            48,
            44,
            49,
            39,
            56,
            34,
            53,
            46,
            42,
            50,
            36,
            29,
            32
          ], v = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], y = [
            {
              0: 8421888,
              268435456: 32768,
              536870912: 8421378,
              805306368: 2,
              1073741824: 512,
              1342177280: 8421890,
              1610612736: 8389122,
              1879048192: 8388608,
              2147483648: 514,
              2415919104: 8389120,
              2684354560: 33280,
              2952790016: 8421376,
              3221225472: 32770,
              3489660928: 8388610,
              3758096384: 0,
              4026531840: 33282,
              134217728: 0,
              402653184: 8421890,
              671088640: 33282,
              939524096: 32768,
              1207959552: 8421888,
              1476395008: 512,
              1744830464: 8421378,
              2013265920: 2,
              2281701376: 8389120,
              2550136832: 33280,
              2818572288: 8421376,
              3087007744: 8389122,
              3355443200: 8388610,
              3623878656: 32770,
              3892314112: 514,
              4160749568: 8388608,
              1: 32768,
              268435457: 2,
              536870913: 8421888,
              805306369: 8388608,
              1073741825: 8421378,
              1342177281: 33280,
              1610612737: 512,
              1879048193: 8389122,
              2147483649: 8421890,
              2415919105: 8421376,
              2684354561: 8388610,
              2952790017: 33282,
              3221225473: 514,
              3489660929: 8389120,
              3758096385: 32770,
              4026531841: 0,
              134217729: 8421890,
              402653185: 8421376,
              671088641: 8388608,
              939524097: 512,
              1207959553: 32768,
              1476395009: 8388610,
              1744830465: 2,
              2013265921: 33282,
              2281701377: 32770,
              2550136833: 8389122,
              2818572289: 514,
              3087007745: 8421888,
              3355443201: 8389120,
              3623878657: 0,
              3892314113: 33280,
              4160749569: 8421378
            },
            {
              0: 1074282512,
              16777216: 16384,
              33554432: 524288,
              50331648: 1074266128,
              67108864: 1073741840,
              83886080: 1074282496,
              100663296: 1073758208,
              117440512: 16,
              134217728: 540672,
              150994944: 1073758224,
              167772160: 1073741824,
              184549376: 540688,
              201326592: 524304,
              218103808: 0,
              234881024: 16400,
              251658240: 1074266112,
              8388608: 1073758208,
              25165824: 540688,
              41943040: 16,
              58720256: 1073758224,
              75497472: 1074282512,
              92274688: 1073741824,
              109051904: 524288,
              125829120: 1074266128,
              142606336: 524304,
              159383552: 0,
              176160768: 16384,
              192937984: 1074266112,
              209715200: 1073741840,
              226492416: 540672,
              243269632: 1074282496,
              260046848: 16400,
              268435456: 0,
              285212672: 1074266128,
              301989888: 1073758224,
              318767104: 1074282496,
              335544320: 1074266112,
              352321536: 16,
              369098752: 540688,
              385875968: 16384,
              402653184: 16400,
              419430400: 524288,
              436207616: 524304,
              452984832: 1073741840,
              469762048: 540672,
              486539264: 1073758208,
              503316480: 1073741824,
              520093696: 1074282512,
              276824064: 540688,
              293601280: 524288,
              310378496: 1074266112,
              327155712: 16384,
              343932928: 1073758208,
              360710144: 1074282512,
              377487360: 16,
              394264576: 1073741824,
              411041792: 1074282496,
              427819008: 1073741840,
              444596224: 1073758224,
              461373440: 524304,
              478150656: 0,
              494927872: 16400,
              511705088: 1074266128,
              528482304: 540672
            },
            {
              0: 260,
              1048576: 0,
              2097152: 67109120,
              3145728: 65796,
              4194304: 65540,
              5242880: 67108868,
              6291456: 67174660,
              7340032: 67174400,
              8388608: 67108864,
              9437184: 67174656,
              10485760: 65792,
              11534336: 67174404,
              12582912: 67109124,
              13631488: 65536,
              14680064: 4,
              15728640: 256,
              524288: 67174656,
              1572864: 67174404,
              2621440: 0,
              3670016: 67109120,
              4718592: 67108868,
              5767168: 65536,
              6815744: 65540,
              7864320: 260,
              8912896: 4,
              9961472: 256,
              11010048: 67174400,
              12058624: 65796,
              13107200: 65792,
              14155776: 67109124,
              15204352: 67174660,
              16252928: 67108864,
              16777216: 67174656,
              17825792: 65540,
              18874368: 65536,
              19922944: 67109120,
              20971520: 256,
              22020096: 67174660,
              23068672: 67108868,
              24117248: 0,
              25165824: 67109124,
              26214400: 67108864,
              27262976: 4,
              28311552: 65792,
              29360128: 67174400,
              30408704: 260,
              31457280: 65796,
              32505856: 67174404,
              17301504: 67108864,
              18350080: 260,
              19398656: 67174656,
              20447232: 0,
              21495808: 65540,
              22544384: 67109120,
              23592960: 256,
              24641536: 67174404,
              25690112: 65536,
              26738688: 67174660,
              27787264: 65796,
              28835840: 67108868,
              29884416: 67109124,
              30932992: 67174400,
              31981568: 4,
              33030144: 65792
            },
            {
              0: 2151682048,
              65536: 2147487808,
              131072: 4198464,
              196608: 2151677952,
              262144: 0,
              327680: 4198400,
              393216: 2147483712,
              458752: 4194368,
              524288: 2147483648,
              589824: 4194304,
              655360: 64,
              720896: 2147487744,
              786432: 2151678016,
              851968: 4160,
              917504: 4096,
              983040: 2151682112,
              32768: 2147487808,
              98304: 64,
              163840: 2151678016,
              229376: 2147487744,
              294912: 4198400,
              360448: 2151682112,
              425984: 0,
              491520: 2151677952,
              557056: 4096,
              622592: 2151682048,
              688128: 4194304,
              753664: 4160,
              819200: 2147483648,
              884736: 4194368,
              950272: 4198464,
              1015808: 2147483712,
              1048576: 4194368,
              1114112: 4198400,
              1179648: 2147483712,
              1245184: 0,
              1310720: 4160,
              1376256: 2151678016,
              1441792: 2151682048,
              1507328: 2147487808,
              1572864: 2151682112,
              1638400: 2147483648,
              1703936: 2151677952,
              1769472: 4198464,
              1835008: 2147487744,
              1900544: 4194304,
              1966080: 64,
              2031616: 4096,
              1081344: 2151677952,
              1146880: 2151682112,
              1212416: 0,
              1277952: 4198400,
              1343488: 4194368,
              1409024: 2147483648,
              1474560: 2147487808,
              1540096: 64,
              1605632: 2147483712,
              1671168: 4096,
              1736704: 2147487744,
              1802240: 2151678016,
              1867776: 4160,
              1933312: 2151682048,
              1998848: 4194304,
              2064384: 4198464
            },
            {
              0: 128,
              4096: 17039360,
              8192: 262144,
              12288: 536870912,
              16384: 537133184,
              20480: 16777344,
              24576: 553648256,
              28672: 262272,
              32768: 16777216,
              36864: 537133056,
              40960: 536871040,
              45056: 553910400,
              49152: 553910272,
              53248: 0,
              57344: 17039488,
              61440: 553648128,
              2048: 17039488,
              6144: 553648256,
              10240: 128,
              14336: 17039360,
              18432: 262144,
              22528: 537133184,
              26624: 553910272,
              30720: 536870912,
              34816: 537133056,
              38912: 0,
              43008: 553910400,
              47104: 16777344,
              51200: 536871040,
              55296: 553648128,
              59392: 16777216,
              63488: 262272,
              65536: 262144,
              69632: 128,
              73728: 536870912,
              77824: 553648256,
              81920: 16777344,
              86016: 553910272,
              90112: 537133184,
              94208: 16777216,
              98304: 553910400,
              102400: 553648128,
              106496: 17039360,
              110592: 537133056,
              114688: 262272,
              118784: 536871040,
              122880: 0,
              126976: 17039488,
              67584: 553648256,
              71680: 16777216,
              75776: 17039360,
              79872: 537133184,
              83968: 536870912,
              88064: 17039488,
              92160: 128,
              96256: 553910272,
              100352: 262272,
              104448: 553910400,
              108544: 0,
              112640: 553648128,
              116736: 16777344,
              120832: 262144,
              124928: 537133056,
              129024: 536871040
            },
            {
              0: 268435464,
              256: 8192,
              512: 270532608,
              768: 270540808,
              1024: 268443648,
              1280: 2097152,
              1536: 2097160,
              1792: 268435456,
              2048: 0,
              2304: 268443656,
              2560: 2105344,
              2816: 8,
              3072: 270532616,
              3328: 2105352,
              3584: 8200,
              3840: 270540800,
              128: 270532608,
              384: 270540808,
              640: 8,
              896: 2097152,
              1152: 2105352,
              1408: 268435464,
              1664: 268443648,
              1920: 8200,
              2176: 2097160,
              2432: 8192,
              2688: 268443656,
              2944: 270532616,
              3200: 0,
              3456: 270540800,
              3712: 2105344,
              3968: 268435456,
              4096: 268443648,
              4352: 270532616,
              4608: 270540808,
              4864: 8200,
              5120: 2097152,
              5376: 268435456,
              5632: 268435464,
              5888: 2105344,
              6144: 2105352,
              6400: 0,
              6656: 8,
              6912: 270532608,
              7168: 8192,
              7424: 268443656,
              7680: 270540800,
              7936: 2097160,
              4224: 8,
              4480: 2105344,
              4736: 2097152,
              4992: 268435464,
              5248: 268443648,
              5504: 8200,
              5760: 270540808,
              6016: 270532608,
              6272: 270540800,
              6528: 270532616,
              6784: 8192,
              7040: 2105352,
              7296: 2097160,
              7552: 0,
              7808: 268435456,
              8064: 268443656
            },
            {
              0: 1048576,
              16: 33555457,
              32: 1024,
              48: 1049601,
              64: 34604033,
              80: 0,
              96: 1,
              112: 34603009,
              128: 33555456,
              144: 1048577,
              160: 33554433,
              176: 34604032,
              192: 34603008,
              208: 1025,
              224: 1049600,
              240: 33554432,
              8: 34603009,
              24: 0,
              40: 33555457,
              56: 34604032,
              72: 1048576,
              88: 33554433,
              104: 33554432,
              120: 1025,
              136: 1049601,
              152: 33555456,
              168: 34603008,
              184: 1048577,
              200: 1024,
              216: 34604033,
              232: 1,
              248: 1049600,
              256: 33554432,
              272: 1048576,
              288: 33555457,
              304: 34603009,
              320: 1048577,
              336: 33555456,
              352: 34604032,
              368: 1049601,
              384: 1025,
              400: 34604033,
              416: 1049600,
              432: 1,
              448: 0,
              464: 34603008,
              480: 33554433,
              496: 1024,
              264: 1049600,
              280: 33555457,
              296: 34603009,
              312: 1,
              328: 33554432,
              344: 1048576,
              360: 1025,
              376: 34604032,
              392: 33554433,
              408: 34603008,
              424: 0,
              440: 34604033,
              456: 1049601,
              472: 1024,
              488: 33555456,
              504: 1048577
            },
            {
              0: 134219808,
              1: 131072,
              2: 134217728,
              3: 32,
              4: 131104,
              5: 134350880,
              6: 134350848,
              7: 2048,
              8: 134348800,
              9: 134219776,
              10: 133120,
              11: 134348832,
              12: 2080,
              13: 0,
              14: 134217760,
              15: 133152,
              2147483648: 2048,
              2147483649: 134350880,
              2147483650: 134219808,
              2147483651: 134217728,
              2147483652: 134348800,
              2147483653: 133120,
              2147483654: 133152,
              2147483655: 32,
              2147483656: 134217760,
              2147483657: 2080,
              2147483658: 131104,
              2147483659: 134350848,
              2147483660: 0,
              2147483661: 134348832,
              2147483662: 134219776,
              2147483663: 131072,
              16: 133152,
              17: 134350848,
              18: 32,
              19: 2048,
              20: 134219776,
              21: 134217760,
              22: 134348832,
              23: 131072,
              24: 0,
              25: 131104,
              26: 134348800,
              27: 134219808,
              28: 134350880,
              29: 133120,
              30: 2080,
              31: 134217728,
              2147483664: 131072,
              2147483665: 2048,
              2147483666: 134348832,
              2147483667: 133152,
              2147483668: 32,
              2147483669: 134348800,
              2147483670: 134217728,
              2147483671: 134219808,
              2147483672: 134350880,
              2147483673: 134217760,
              2147483674: 134219776,
              2147483675: 0,
              2147483676: 133120,
              2147483677: 2080,
              2147483678: 131104,
              2147483679: 134350848
            }
          ], x = [
            4160749569,
            528482304,
            33030144,
            2064384,
            129024,
            8064,
            504,
            2147483679
          ], w = c.DES = s.extend({
            _doReset: function() {
              for (var k = this._key, D = k.words, A = [], R = 0; R < 56; R++) {
                var T = p[R] - 1;
                A[R] = D[T >>> 5] >>> 31 - T % 32 & 1;
              }
              for (var M = this._subKeys = [], F = 0; F < 16; F++) {
                for (var B = M[F] = [], V = v[F], R = 0; R < 24; R++)
                  B[R / 6 | 0] |= A[(h[R] - 1 + V) % 28] << 31 - R % 6, B[4 + (R / 6 | 0)] |= A[28 + (h[R + 24] - 1 + V) % 28] << 31 - R % 6;
                B[0] = B[0] << 1 | B[0] >>> 31;
                for (var R = 1; R < 7; R++)
                  B[R] = B[R] >>> (R - 1) * 4 + 3;
                B[7] = B[7] << 5 | B[7] >>> 27;
              }
              for (var H = this._invSubKeys = [], R = 0; R < 16; R++)
                H[R] = M[15 - R];
            },
            encryptBlock: function(k, D) {
              this._doCryptBlock(k, D, this._subKeys);
            },
            decryptBlock: function(k, D) {
              this._doCryptBlock(k, D, this._invSubKeys);
            },
            _doCryptBlock: function(k, D, A) {
              this._lBlock = k[D], this._rBlock = k[D + 1], E.call(this, 4, 252645135), E.call(this, 16, 65535), C.call(this, 2, 858993459), C.call(this, 8, 16711935), E.call(this, 1, 1431655765);
              for (var R = 0; R < 16; R++) {
                for (var T = A[R], M = this._lBlock, F = this._rBlock, B = 0, V = 0; V < 8; V++)
                  B |= y[V][((F ^ T[V]) & x[V]) >>> 0];
                this._lBlock = F, this._rBlock = M ^ B;
              }
              var H = this._lBlock;
              this._lBlock = this._rBlock, this._rBlock = H, E.call(this, 1, 1431655765), C.call(this, 8, 16711935), C.call(this, 2, 858993459), E.call(this, 16, 65535), E.call(this, 4, 252645135), k[D] = this._lBlock, k[D + 1] = this._rBlock;
            },
            keySize: 64 / 32,
            ivSize: 64 / 32,
            blockSize: 64 / 32
          });
          function E(k, D) {
            var A = (this._lBlock >>> k ^ this._rBlock) & D;
            this._rBlock ^= A, this._lBlock ^= A << k;
          }
          function C(k, D) {
            var A = (this._rBlock >>> k ^ this._lBlock) & D;
            this._lBlock ^= A, this._rBlock ^= A << k;
          }
          n.DES = s._createHelper(w);
          var S = c.TripleDES = s.extend({
            _doReset: function() {
              var k = this._key, D = k.words;
              if (D.length !== 2 && D.length !== 4 && D.length < 6)
                throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
              var A = D.slice(0, 2), R = D.length < 4 ? D.slice(0, 2) : D.slice(2, 4), T = D.length < 6 ? D.slice(0, 2) : D.slice(4, 6);
              this._des1 = w.createEncryptor(u.create(A)), this._des2 = w.createEncryptor(u.create(R)), this._des3 = w.createEncryptor(u.create(T));
            },
            encryptBlock: function(k, D) {
              this._des1.encryptBlock(k, D), this._des2.decryptBlock(k, D), this._des3.encryptBlock(k, D);
            },
            decryptBlock: function(k, D) {
              this._des3.decryptBlock(k, D), this._des2.encryptBlock(k, D), this._des1.decryptBlock(k, D);
            },
            keySize: 192 / 32,
            ivSize: 64 / 32,
            blockSize: 64 / 32
          });
          n.TripleDES = s._createHelper(S);
        }(), r.TripleDES;
      });
    }(oS)), oS.exports;
  }
  var uS = { exports: {} }, Xae = uS.exports, F3;
  function Zae() {
    return F3 || (F3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), zp(), qp(), Yf(), Bi());
      })(Xae, function(r) {
        return function() {
          var n = r, i = n.lib, u = i.StreamCipher, s = n.algo, c = s.RC4 = u.extend({
            _doReset: function() {
              for (var v = this._key, y = v.words, x = v.sigBytes, w = this._S = [], E = 0; E < 256; E++)
                w[E] = E;
              for (var E = 0, C = 0; E < 256; E++) {
                var S = E % x, k = y[S >>> 2] >>> 24 - S % 4 * 8 & 255;
                C = (C + w[E] + k) % 256;
                var D = w[E];
                w[E] = w[C], w[C] = D;
              }
              this._i = this._j = 0;
            },
            _doProcessBlock: function(v, y) {
              v[y] ^= p.call(this);
            },
            keySize: 256 / 32,
            ivSize: 0
          });
          function p() {
            for (var v = this._S, y = this._i, x = this._j, w = 0, E = 0; E < 4; E++) {
              y = (y + 1) % 256, x = (x + v[y]) % 256;
              var C = v[y];
              v[y] = v[x], v[x] = C, w |= v[(v[y] + v[x]) % 256] << 24 - E * 8;
            }
            return this._i = y, this._j = x, w;
          }
          n.RC4 = u._createHelper(c);
          var h = s.RC4Drop = c.extend({
            /**
             * Configuration options.
             *
             * @property {number} drop The number of keystream words to drop. Default 192
             */
            cfg: c.cfg.extend({
              drop: 192
            }),
            _doReset: function() {
              c._doReset.call(this);
              for (var v = this.cfg.drop; v > 0; v--)
                p.call(this);
            }
          });
          n.RC4Drop = u._createHelper(h);
        }(), r.RC4;
      });
    }(uS)), uS.exports;
  }
  var sS = { exports: {} }, Jae = sS.exports, I3;
  function eoe() {
    return I3 || (I3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), zp(), qp(), Yf(), Bi());
      })(Jae, function(r) {
        return function() {
          var n = r, i = n.lib, u = i.StreamCipher, s = n.algo, c = [], p = [], h = [], v = s.Rabbit = u.extend({
            _doReset: function() {
              for (var x = this._key.words, w = this.cfg.iv, E = 0; E < 4; E++)
                x[E] = (x[E] << 8 | x[E] >>> 24) & 16711935 | (x[E] << 24 | x[E] >>> 8) & 4278255360;
              var C = this._X = [
                x[0],
                x[3] << 16 | x[2] >>> 16,
                x[1],
                x[0] << 16 | x[3] >>> 16,
                x[2],
                x[1] << 16 | x[0] >>> 16,
                x[3],
                x[2] << 16 | x[1] >>> 16
              ], S = this._C = [
                x[2] << 16 | x[2] >>> 16,
                x[0] & 4294901760 | x[1] & 65535,
                x[3] << 16 | x[3] >>> 16,
                x[1] & 4294901760 | x[2] & 65535,
                x[0] << 16 | x[0] >>> 16,
                x[2] & 4294901760 | x[3] & 65535,
                x[1] << 16 | x[1] >>> 16,
                x[3] & 4294901760 | x[0] & 65535
              ];
              this._b = 0;
              for (var E = 0; E < 4; E++)
                y.call(this);
              for (var E = 0; E < 8; E++)
                S[E] ^= C[E + 4 & 7];
              if (w) {
                var k = w.words, D = k[0], A = k[1], R = (D << 8 | D >>> 24) & 16711935 | (D << 24 | D >>> 8) & 4278255360, T = (A << 8 | A >>> 24) & 16711935 | (A << 24 | A >>> 8) & 4278255360, M = R >>> 16 | T & 4294901760, F = T << 16 | R & 65535;
                S[0] ^= R, S[1] ^= M, S[2] ^= T, S[3] ^= F, S[4] ^= R, S[5] ^= M, S[6] ^= T, S[7] ^= F;
                for (var E = 0; E < 4; E++)
                  y.call(this);
              }
            },
            _doProcessBlock: function(x, w) {
              var E = this._X;
              y.call(this), c[0] = E[0] ^ E[5] >>> 16 ^ E[3] << 16, c[1] = E[2] ^ E[7] >>> 16 ^ E[5] << 16, c[2] = E[4] ^ E[1] >>> 16 ^ E[7] << 16, c[3] = E[6] ^ E[3] >>> 16 ^ E[1] << 16;
              for (var C = 0; C < 4; C++)
                c[C] = (c[C] << 8 | c[C] >>> 24) & 16711935 | (c[C] << 24 | c[C] >>> 8) & 4278255360, x[w + C] ^= c[C];
            },
            blockSize: 128 / 32,
            ivSize: 64 / 32
          });
          function y() {
            for (var x = this._X, w = this._C, E = 0; E < 8; E++)
              p[E] = w[E];
            w[0] = w[0] + 1295307597 + this._b | 0, w[1] = w[1] + 3545052371 + (w[0] >>> 0 < p[0] >>> 0 ? 1 : 0) | 0, w[2] = w[2] + 886263092 + (w[1] >>> 0 < p[1] >>> 0 ? 1 : 0) | 0, w[3] = w[3] + 1295307597 + (w[2] >>> 0 < p[2] >>> 0 ? 1 : 0) | 0, w[4] = w[4] + 3545052371 + (w[3] >>> 0 < p[3] >>> 0 ? 1 : 0) | 0, w[5] = w[5] + 886263092 + (w[4] >>> 0 < p[4] >>> 0 ? 1 : 0) | 0, w[6] = w[6] + 1295307597 + (w[5] >>> 0 < p[5] >>> 0 ? 1 : 0) | 0, w[7] = w[7] + 3545052371 + (w[6] >>> 0 < p[6] >>> 0 ? 1 : 0) | 0, this._b = w[7] >>> 0 < p[7] >>> 0 ? 1 : 0;
            for (var E = 0; E < 8; E++) {
              var C = x[E] + w[E], S = C & 65535, k = C >>> 16, D = ((S * S >>> 17) + S * k >>> 15) + k * k, A = ((C & 4294901760) * C | 0) + ((C & 65535) * C | 0);
              h[E] = D ^ A;
            }
            x[0] = h[0] + (h[7] << 16 | h[7] >>> 16) + (h[6] << 16 | h[6] >>> 16) | 0, x[1] = h[1] + (h[0] << 8 | h[0] >>> 24) + h[7] | 0, x[2] = h[2] + (h[1] << 16 | h[1] >>> 16) + (h[0] << 16 | h[0] >>> 16) | 0, x[3] = h[3] + (h[2] << 8 | h[2] >>> 24) + h[1] | 0, x[4] = h[4] + (h[3] << 16 | h[3] >>> 16) + (h[2] << 16 | h[2] >>> 16) | 0, x[5] = h[5] + (h[4] << 8 | h[4] >>> 24) + h[3] | 0, x[6] = h[6] + (h[5] << 16 | h[5] >>> 16) + (h[4] << 16 | h[4] >>> 16) | 0, x[7] = h[7] + (h[6] << 8 | h[6] >>> 24) + h[5] | 0;
          }
          n.Rabbit = u._createHelper(v);
        }(), r.Rabbit;
      });
    }(sS)), sS.exports;
  }
  var lS = { exports: {} }, toe = lS.exports, B3;
  function roe() {
    return B3 || (B3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), zp(), qp(), Yf(), Bi());
      })(toe, function(r) {
        return function() {
          var n = r, i = n.lib, u = i.StreamCipher, s = n.algo, c = [], p = [], h = [], v = s.RabbitLegacy = u.extend({
            _doReset: function() {
              var x = this._key.words, w = this.cfg.iv, E = this._X = [
                x[0],
                x[3] << 16 | x[2] >>> 16,
                x[1],
                x[0] << 16 | x[3] >>> 16,
                x[2],
                x[1] << 16 | x[0] >>> 16,
                x[3],
                x[2] << 16 | x[1] >>> 16
              ], C = this._C = [
                x[2] << 16 | x[2] >>> 16,
                x[0] & 4294901760 | x[1] & 65535,
                x[3] << 16 | x[3] >>> 16,
                x[1] & 4294901760 | x[2] & 65535,
                x[0] << 16 | x[0] >>> 16,
                x[2] & 4294901760 | x[3] & 65535,
                x[1] << 16 | x[1] >>> 16,
                x[3] & 4294901760 | x[0] & 65535
              ];
              this._b = 0;
              for (var S = 0; S < 4; S++)
                y.call(this);
              for (var S = 0; S < 8; S++)
                C[S] ^= E[S + 4 & 7];
              if (w) {
                var k = w.words, D = k[0], A = k[1], R = (D << 8 | D >>> 24) & 16711935 | (D << 24 | D >>> 8) & 4278255360, T = (A << 8 | A >>> 24) & 16711935 | (A << 24 | A >>> 8) & 4278255360, M = R >>> 16 | T & 4294901760, F = T << 16 | R & 65535;
                C[0] ^= R, C[1] ^= M, C[2] ^= T, C[3] ^= F, C[4] ^= R, C[5] ^= M, C[6] ^= T, C[7] ^= F;
                for (var S = 0; S < 4; S++)
                  y.call(this);
              }
            },
            _doProcessBlock: function(x, w) {
              var E = this._X;
              y.call(this), c[0] = E[0] ^ E[5] >>> 16 ^ E[3] << 16, c[1] = E[2] ^ E[7] >>> 16 ^ E[5] << 16, c[2] = E[4] ^ E[1] >>> 16 ^ E[7] << 16, c[3] = E[6] ^ E[3] >>> 16 ^ E[1] << 16;
              for (var C = 0; C < 4; C++)
                c[C] = (c[C] << 8 | c[C] >>> 24) & 16711935 | (c[C] << 24 | c[C] >>> 8) & 4278255360, x[w + C] ^= c[C];
            },
            blockSize: 128 / 32,
            ivSize: 64 / 32
          });
          function y() {
            for (var x = this._X, w = this._C, E = 0; E < 8; E++)
              p[E] = w[E];
            w[0] = w[0] + 1295307597 + this._b | 0, w[1] = w[1] + 3545052371 + (w[0] >>> 0 < p[0] >>> 0 ? 1 : 0) | 0, w[2] = w[2] + 886263092 + (w[1] >>> 0 < p[1] >>> 0 ? 1 : 0) | 0, w[3] = w[3] + 1295307597 + (w[2] >>> 0 < p[2] >>> 0 ? 1 : 0) | 0, w[4] = w[4] + 3545052371 + (w[3] >>> 0 < p[3] >>> 0 ? 1 : 0) | 0, w[5] = w[5] + 886263092 + (w[4] >>> 0 < p[4] >>> 0 ? 1 : 0) | 0, w[6] = w[6] + 1295307597 + (w[5] >>> 0 < p[5] >>> 0 ? 1 : 0) | 0, w[7] = w[7] + 3545052371 + (w[6] >>> 0 < p[6] >>> 0 ? 1 : 0) | 0, this._b = w[7] >>> 0 < p[7] >>> 0 ? 1 : 0;
            for (var E = 0; E < 8; E++) {
              var C = x[E] + w[E], S = C & 65535, k = C >>> 16, D = ((S * S >>> 17) + S * k >>> 15) + k * k, A = ((C & 4294901760) * C | 0) + ((C & 65535) * C | 0);
              h[E] = D ^ A;
            }
            x[0] = h[0] + (h[7] << 16 | h[7] >>> 16) + (h[6] << 16 | h[6] >>> 16) | 0, x[1] = h[1] + (h[0] << 8 | h[0] >>> 24) + h[7] | 0, x[2] = h[2] + (h[1] << 16 | h[1] >>> 16) + (h[0] << 16 | h[0] >>> 16) | 0, x[3] = h[3] + (h[2] << 8 | h[2] >>> 24) + h[1] | 0, x[4] = h[4] + (h[3] << 16 | h[3] >>> 16) + (h[2] << 16 | h[2] >>> 16) | 0, x[5] = h[5] + (h[4] << 8 | h[4] >>> 24) + h[3] | 0, x[6] = h[6] + (h[5] << 16 | h[5] >>> 16) + (h[4] << 16 | h[4] >>> 16) | 0, x[7] = h[7] + (h[6] << 8 | h[6] >>> 24) + h[5] | 0;
          }
          n.RabbitLegacy = u._createHelper(v);
        }(), r.RabbitLegacy;
      });
    }(lS)), lS.exports;
  }
  var cS = { exports: {} }, noe = cS.exports, L3;
  function ioe() {
    return L3 || (L3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), zp(), qp(), Yf(), Bi());
      })(noe, function(r) {
        return function() {
          var n = r, i = n.lib, u = i.BlockCipher, s = n.algo;
          const c = 16, p = [
            608135816,
            2242054355,
            320440878,
            57701188,
            2752067618,
            698298832,
            137296536,
            3964562569,
            1160258022,
            953160567,
            3193202383,
            887688300,
            3232508343,
            3380367581,
            1065670069,
            3041331479,
            2450970073,
            2306472731
          ], h = [
            [
              3509652390,
              2564797868,
              805139163,
              3491422135,
              3101798381,
              1780907670,
              3128725573,
              4046225305,
              614570311,
              3012652279,
              134345442,
              2240740374,
              1667834072,
              1901547113,
              2757295779,
              4103290238,
              227898511,
              1921955416,
              1904987480,
              2182433518,
              2069144605,
              3260701109,
              2620446009,
              720527379,
              3318853667,
              677414384,
              3393288472,
              3101374703,
              2390351024,
              1614419982,
              1822297739,
              2954791486,
              3608508353,
              3174124327,
              2024746970,
              1432378464,
              3864339955,
              2857741204,
              1464375394,
              1676153920,
              1439316330,
              715854006,
              3033291828,
              289532110,
              2706671279,
              2087905683,
              3018724369,
              1668267050,
              732546397,
              1947742710,
              3462151702,
              2609353502,
              2950085171,
              1814351708,
              2050118529,
              680887927,
              999245976,
              1800124847,
              3300911131,
              1713906067,
              1641548236,
              4213287313,
              1216130144,
              1575780402,
              4018429277,
              3917837745,
              3693486850,
              3949271944,
              596196993,
              3549867205,
              258830323,
              2213823033,
              772490370,
              2760122372,
              1774776394,
              2652871518,
              566650946,
              4142492826,
              1728879713,
              2882767088,
              1783734482,
              3629395816,
              2517608232,
              2874225571,
              1861159788,
              326777828,
              3124490320,
              2130389656,
              2716951837,
              967770486,
              1724537150,
              2185432712,
              2364442137,
              1164943284,
              2105845187,
              998989502,
              3765401048,
              2244026483,
              1075463327,
              1455516326,
              1322494562,
              910128902,
              469688178,
              1117454909,
              936433444,
              3490320968,
              3675253459,
              1240580251,
              122909385,
              2157517691,
              634681816,
              4142456567,
              3825094682,
              3061402683,
              2540495037,
              79693498,
              3249098678,
              1084186820,
              1583128258,
              426386531,
              1761308591,
              1047286709,
              322548459,
              995290223,
              1845252383,
              2603652396,
              3431023940,
              2942221577,
              3202600964,
              3727903485,
              1712269319,
              422464435,
              3234572375,
              1170764815,
              3523960633,
              3117677531,
              1434042557,
              442511882,
              3600875718,
              1076654713,
              1738483198,
              4213154764,
              2393238008,
              3677496056,
              1014306527,
              4251020053,
              793779912,
              2902807211,
              842905082,
              4246964064,
              1395751752,
              1040244610,
              2656851899,
              3396308128,
              445077038,
              3742853595,
              3577915638,
              679411651,
              2892444358,
              2354009459,
              1767581616,
              3150600392,
              3791627101,
              3102740896,
              284835224,
              4246832056,
              1258075500,
              768725851,
              2589189241,
              3069724005,
              3532540348,
              1274779536,
              3789419226,
              2764799539,
              1660621633,
              3471099624,
              4011903706,
              913787905,
              3497959166,
              737222580,
              2514213453,
              2928710040,
              3937242737,
              1804850592,
              3499020752,
              2949064160,
              2386320175,
              2390070455,
              2415321851,
              4061277028,
              2290661394,
              2416832540,
              1336762016,
              1754252060,
              3520065937,
              3014181293,
              791618072,
              3188594551,
              3933548030,
              2332172193,
              3852520463,
              3043980520,
              413987798,
              3465142937,
              3030929376,
              4245938359,
              2093235073,
              3534596313,
              375366246,
              2157278981,
              2479649556,
              555357303,
              3870105701,
              2008414854,
              3344188149,
              4221384143,
              3956125452,
              2067696032,
              3594591187,
              2921233993,
              2428461,
              544322398,
              577241275,
              1471733935,
              610547355,
              4027169054,
              1432588573,
              1507829418,
              2025931657,
              3646575487,
              545086370,
              48609733,
              2200306550,
              1653985193,
              298326376,
              1316178497,
              3007786442,
              2064951626,
              458293330,
              2589141269,
              3591329599,
              3164325604,
              727753846,
              2179363840,
              146436021,
              1461446943,
              4069977195,
              705550613,
              3059967265,
              3887724982,
              4281599278,
              3313849956,
              1404054877,
              2845806497,
              146425753,
              1854211946
            ],
            [
              1266315497,
              3048417604,
              3681880366,
              3289982499,
              290971e4,
              1235738493,
              2632868024,
              2414719590,
              3970600049,
              1771706367,
              1449415276,
              3266420449,
              422970021,
              1963543593,
              2690192192,
              3826793022,
              1062508698,
              1531092325,
              1804592342,
              2583117782,
              2714934279,
              4024971509,
              1294809318,
              4028980673,
              1289560198,
              2221992742,
              1669523910,
              35572830,
              157838143,
              1052438473,
              1016535060,
              1802137761,
              1753167236,
              1386275462,
              3080475397,
              2857371447,
              1040679964,
              2145300060,
              2390574316,
              1461121720,
              2956646967,
              4031777805,
              4028374788,
              33600511,
              2920084762,
              1018524850,
              629373528,
              3691585981,
              3515945977,
              2091462646,
              2486323059,
              586499841,
              988145025,
              935516892,
              3367335476,
              2599673255,
              2839830854,
              265290510,
              3972581182,
              2759138881,
              3795373465,
              1005194799,
              847297441,
              406762289,
              1314163512,
              1332590856,
              1866599683,
              4127851711,
              750260880,
              613907577,
              1450815602,
              3165620655,
              3734664991,
              3650291728,
              3012275730,
              3704569646,
              1427272223,
              778793252,
              1343938022,
              2676280711,
              2052605720,
              1946737175,
              3164576444,
              3914038668,
              3967478842,
              3682934266,
              1661551462,
              3294938066,
              4011595847,
              840292616,
              3712170807,
              616741398,
              312560963,
              711312465,
              1351876610,
              322626781,
              1910503582,
              271666773,
              2175563734,
              1594956187,
              70604529,
              3617834859,
              1007753275,
              1495573769,
              4069517037,
              2549218298,
              2663038764,
              504708206,
              2263041392,
              3941167025,
              2249088522,
              1514023603,
              1998579484,
              1312622330,
              694541497,
              2582060303,
              2151582166,
              1382467621,
              776784248,
              2618340202,
              3323268794,
              2497899128,
              2784771155,
              503983604,
              4076293799,
              907881277,
              423175695,
              432175456,
              1378068232,
              4145222326,
              3954048622,
              3938656102,
              3820766613,
              2793130115,
              2977904593,
              26017576,
              3274890735,
              3194772133,
              1700274565,
              1756076034,
              4006520079,
              3677328699,
              720338349,
              1533947780,
              354530856,
              688349552,
              3973924725,
              1637815568,
              332179504,
              3949051286,
              53804574,
              2852348879,
              3044236432,
              1282449977,
              3583942155,
              3416972820,
              4006381244,
              1617046695,
              2628476075,
              3002303598,
              1686838959,
              431878346,
              2686675385,
              1700445008,
              1080580658,
              1009431731,
              832498133,
              3223435511,
              2605976345,
              2271191193,
              2516031870,
              1648197032,
              4164389018,
              2548247927,
              300782431,
              375919233,
              238389289,
              3353747414,
              2531188641,
              2019080857,
              1475708069,
              455242339,
              2609103871,
              448939670,
              3451063019,
              1395535956,
              2413381860,
              1841049896,
              1491858159,
              885456874,
              4264095073,
              4001119347,
              1565136089,
              3898914787,
              1108368660,
              540939232,
              1173283510,
              2745871338,
              3681308437,
              4207628240,
              3343053890,
              4016749493,
              1699691293,
              1103962373,
              3625875870,
              2256883143,
              3830138730,
              1031889488,
              3479347698,
              1535977030,
              4236805024,
              3251091107,
              2132092099,
              1774941330,
              1199868427,
              1452454533,
              157007616,
              2904115357,
              342012276,
              595725824,
              1480756522,
              206960106,
              497939518,
              591360097,
              863170706,
              2375253569,
              3596610801,
              1814182875,
              2094937945,
              3421402208,
              1082520231,
              3463918190,
              2785509508,
              435703966,
              3908032597,
              1641649973,
              2842273706,
              3305899714,
              1510255612,
              2148256476,
              2655287854,
              3276092548,
              4258621189,
              236887753,
              3681803219,
              274041037,
              1734335097,
              3815195456,
              3317970021,
              1899903192,
              1026095262,
              4050517792,
              356393447,
              2410691914,
              3873677099,
              3682840055
            ],
            [
              3913112168,
              2491498743,
              4132185628,
              2489919796,
              1091903735,
              1979897079,
              3170134830,
              3567386728,
              3557303409,
              857797738,
              1136121015,
              1342202287,
              507115054,
              2535736646,
              337727348,
              3213592640,
              1301675037,
              2528481711,
              1895095763,
              1721773893,
              3216771564,
              62756741,
              2142006736,
              835421444,
              2531993523,
              1442658625,
              3659876326,
              2882144922,
              676362277,
              1392781812,
              170690266,
              3921047035,
              1759253602,
              3611846912,
              1745797284,
              664899054,
              1329594018,
              3901205900,
              3045908486,
              2062866102,
              2865634940,
              3543621612,
              3464012697,
              1080764994,
              553557557,
              3656615353,
              3996768171,
              991055499,
              499776247,
              1265440854,
              648242737,
              3940784050,
              980351604,
              3713745714,
              1749149687,
              3396870395,
              4211799374,
              3640570775,
              1161844396,
              3125318951,
              1431517754,
              545492359,
              4268468663,
              3499529547,
              1437099964,
              2702547544,
              3433638243,
              2581715763,
              2787789398,
              1060185593,
              1593081372,
              2418618748,
              4260947970,
              69676912,
              2159744348,
              86519011,
              2512459080,
              3838209314,
              1220612927,
              3339683548,
              133810670,
              1090789135,
              1078426020,
              1569222167,
              845107691,
              3583754449,
              4072456591,
              1091646820,
              628848692,
              1613405280,
              3757631651,
              526609435,
              236106946,
              48312990,
              2942717905,
              3402727701,
              1797494240,
              859738849,
              992217954,
              4005476642,
              2243076622,
              3870952857,
              3732016268,
              765654824,
              3490871365,
              2511836413,
              1685915746,
              3888969200,
              1414112111,
              2273134842,
              3281911079,
              4080962846,
              172450625,
              2569994100,
              980381355,
              4109958455,
              2819808352,
              2716589560,
              2568741196,
              3681446669,
              3329971472,
              1835478071,
              660984891,
              3704678404,
              4045999559,
              3422617507,
              3040415634,
              1762651403,
              1719377915,
              3470491036,
              2693910283,
              3642056355,
              3138596744,
              1364962596,
              2073328063,
              1983633131,
              926494387,
              3423689081,
              2150032023,
              4096667949,
              1749200295,
              3328846651,
              309677260,
              2016342300,
              1779581495,
              3079819751,
              111262694,
              1274766160,
              443224088,
              298511866,
              1025883608,
              3806446537,
              1145181785,
              168956806,
              3641502830,
              3584813610,
              1689216846,
              3666258015,
              3200248200,
              1692713982,
              2646376535,
              4042768518,
              1618508792,
              1610833997,
              3523052358,
              4130873264,
              2001055236,
              3610705100,
              2202168115,
              4028541809,
              2961195399,
              1006657119,
              2006996926,
              3186142756,
              1430667929,
              3210227297,
              1314452623,
              4074634658,
              4101304120,
              2273951170,
              1399257539,
              3367210612,
              3027628629,
              1190975929,
              2062231137,
              2333990788,
              2221543033,
              2438960610,
              1181637006,
              548689776,
              2362791313,
              3372408396,
              3104550113,
              3145860560,
              296247880,
              1970579870,
              3078560182,
              3769228297,
              1714227617,
              3291629107,
              3898220290,
              166772364,
              1251581989,
              493813264,
              448347421,
              195405023,
              2709975567,
              677966185,
              3703036547,
              1463355134,
              2715995803,
              1338867538,
              1343315457,
              2802222074,
              2684532164,
              233230375,
              2599980071,
              2000651841,
              3277868038,
              1638401717,
              4028070440,
              3237316320,
              6314154,
              819756386,
              300326615,
              590932579,
              1405279636,
              3267499572,
              3150704214,
              2428286686,
              3959192993,
              3461946742,
              1862657033,
              1266418056,
              963775037,
              2089974820,
              2263052895,
              1917689273,
              448879540,
              3550394620,
              3981727096,
              150775221,
              3627908307,
              1303187396,
              508620638,
              2975983352,
              2726630617,
              1817252668,
              1876281319,
              1457606340,
              908771278,
              3720792119,
              3617206836,
              2455994898,
              1729034894,
              1080033504
            ],
            [
              976866871,
              3556439503,
              2881648439,
              1522871579,
              1555064734,
              1336096578,
              3548522304,
              2579274686,
              3574697629,
              3205460757,
              3593280638,
              3338716283,
              3079412587,
              564236357,
              2993598910,
              1781952180,
              1464380207,
              3163844217,
              3332601554,
              1699332808,
              1393555694,
              1183702653,
              3581086237,
              1288719814,
              691649499,
              2847557200,
              2895455976,
              3193889540,
              2717570544,
              1781354906,
              1676643554,
              2592534050,
              3230253752,
              1126444790,
              2770207658,
              2633158820,
              2210423226,
              2615765581,
              2414155088,
              3127139286,
              673620729,
              2805611233,
              1269405062,
              4015350505,
              3341807571,
              4149409754,
              1057255273,
              2012875353,
              2162469141,
              2276492801,
              2601117357,
              993977747,
              3918593370,
              2654263191,
              753973209,
              36408145,
              2530585658,
              25011837,
              3520020182,
              2088578344,
              530523599,
              2918365339,
              1524020338,
              1518925132,
              3760827505,
              3759777254,
              1202760957,
              3985898139,
              3906192525,
              674977740,
              4174734889,
              2031300136,
              2019492241,
              3983892565,
              4153806404,
              3822280332,
              352677332,
              2297720250,
              60907813,
              90501309,
              3286998549,
              1016092578,
              2535922412,
              2839152426,
              457141659,
              509813237,
              4120667899,
              652014361,
              1966332200,
              2975202805,
              55981186,
              2327461051,
              676427537,
              3255491064,
              2882294119,
              3433927263,
              1307055953,
              942726286,
              933058658,
              2468411793,
              3933900994,
              4215176142,
              1361170020,
              2001714738,
              2830558078,
              3274259782,
              1222529897,
              1679025792,
              2729314320,
              3714953764,
              1770335741,
              151462246,
              3013232138,
              1682292957,
              1483529935,
              471910574,
              1539241949,
              458788160,
              3436315007,
              1807016891,
              3718408830,
              978976581,
              1043663428,
              3165965781,
              1927990952,
              4200891579,
              2372276910,
              3208408903,
              3533431907,
              1412390302,
              2931980059,
              4132332400,
              1947078029,
              3881505623,
              4168226417,
              2941484381,
              1077988104,
              1320477388,
              886195818,
              18198404,
              3786409e3,
              2509781533,
              112762804,
              3463356488,
              1866414978,
              891333506,
              18488651,
              661792760,
              1628790961,
              3885187036,
              3141171499,
              876946877,
              2693282273,
              1372485963,
              791857591,
              2686433993,
              3759982718,
              3167212022,
              3472953795,
              2716379847,
              445679433,
              3561995674,
              3504004811,
              3574258232,
              54117162,
              3331405415,
              2381918588,
              3769707343,
              4154350007,
              1140177722,
              4074052095,
              668550556,
              3214352940,
              367459370,
              261225585,
              2610173221,
              4209349473,
              3468074219,
              3265815641,
              314222801,
              3066103646,
              3808782860,
              282218597,
              3406013506,
              3773591054,
              379116347,
              1285071038,
              846784868,
              2669647154,
              3771962079,
              3550491691,
              2305946142,
              453669953,
              1268987020,
              3317592352,
              3279303384,
              3744833421,
              2610507566,
              3859509063,
              266596637,
              3847019092,
              517658769,
              3462560207,
              3443424879,
              370717030,
              4247526661,
              2224018117,
              4143653529,
              4112773975,
              2788324899,
              2477274417,
              1456262402,
              2901442914,
              1517677493,
              1846949527,
              2295493580,
              3734397586,
              2176403920,
              1280348187,
              1908823572,
              3871786941,
              846861322,
              1172426758,
              3287448474,
              3383383037,
              1655181056,
              3139813346,
              901632758,
              1897031941,
              2986607138,
              3066810236,
              3447102507,
              1393639104,
              373351379,
              950779232,
              625454576,
              3124240540,
              4148612726,
              2007998917,
              544563296,
              2244738638,
              2330496472,
              2058025392,
              1291430526,
              424198748,
              50039436,
              29584100,
              3605783033,
              2429876329,
              2791104160,
              1057563949,
              3255363231,
              3075367218,
              3463963227,
              1469046755,
              985887462
            ]
          ];
          var v = {
            pbox: [],
            sbox: []
          };
          function y(S, k) {
            let D = k >> 24 & 255, A = k >> 16 & 255, R = k >> 8 & 255, T = k & 255, M = S.sbox[0][D] + S.sbox[1][A];
            return M = M ^ S.sbox[2][R], M = M + S.sbox[3][T], M;
          }
          function x(S, k, D) {
            let A = k, R = D, T;
            for (let M = 0; M < c; ++M)
              A = A ^ S.pbox[M], R = y(S, A) ^ R, T = A, A = R, R = T;
            return T = A, A = R, R = T, R = R ^ S.pbox[c], A = A ^ S.pbox[c + 1], { left: A, right: R };
          }
          function w(S, k, D) {
            let A = k, R = D, T;
            for (let M = c + 1; M > 1; --M)
              A = A ^ S.pbox[M], R = y(S, A) ^ R, T = A, A = R, R = T;
            return T = A, A = R, R = T, R = R ^ S.pbox[1], A = A ^ S.pbox[0], { left: A, right: R };
          }
          function E(S, k, D) {
            for (let F = 0; F < 4; F++) {
              S.sbox[F] = [];
              for (let B = 0; B < 256; B++)
                S.sbox[F][B] = h[F][B];
            }
            let A = 0;
            for (let F = 0; F < c + 2; F++)
              S.pbox[F] = p[F] ^ k[A], A++, A >= D && (A = 0);
            let R = 0, T = 0, M = 0;
            for (let F = 0; F < c + 2; F += 2)
              M = x(S, R, T), R = M.left, T = M.right, S.pbox[F] = R, S.pbox[F + 1] = T;
            for (let F = 0; F < 4; F++)
              for (let B = 0; B < 256; B += 2)
                M = x(S, R, T), R = M.left, T = M.right, S.sbox[F][B] = R, S.sbox[F][B + 1] = T;
            return !0;
          }
          var C = s.Blowfish = u.extend({
            _doReset: function() {
              if (this._keyPriorReset !== this._key) {
                var S = this._keyPriorReset = this._key, k = S.words, D = S.sigBytes / 4;
                E(v, k, D);
              }
            },
            encryptBlock: function(S, k) {
              var D = x(v, S[k], S[k + 1]);
              S[k] = D.left, S[k + 1] = D.right;
            },
            decryptBlock: function(S, k) {
              var D = w(v, S[k], S[k + 1]);
              S[k] = D.left, S[k + 1] = D.right;
            },
            blockSize: 64 / 32,
            keySize: 128 / 32,
            ivSize: 64 / 32
          });
          n.Blowfish = u._createHelper(C);
        }(), r.Blowfish;
      });
    }(cS)), cS.exports;
  }
  var aoe = DE.exports, $3;
  function ooe() {
    return $3 || ($3 = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(vr(), R_(), rae(), iae(), zp(), uae(), qp(), L9(), MN(), dae(), $9(), vae(), yae(), xae(), NN(), Eae(), Yf(), Bi(), Oae(), Aae(), kae(), Pae(), Nae(), Fae(), Bae(), $ae(), qae(), Hae(), Wae(), Gae(), Kae(), Zae(), eoe(), roe(), ioe());
      })(aoe, function(r) {
        return r;
      });
    }(DE)), DE.exports;
  }
  var z3 = ooe();
  const uoe = "1950277964321", soe = () => {
    const e = localStorage.getItem("accessToken");
    if (e === null)
      return null;
    try {
      const t = z3.AES.decrypt(e, uoe).toString(z3.enc.Utf8);
      if (t === null && t === void 0) {
        const r = "Unexpected null or undefined return from CryptoJS.AES.decrypt when attempting to decrypt access token from localStorage";
        throw console.error(r), new Error(r);
      }
      return t;
    } catch (t) {
      throw console.error(t), new Error(
        "Unexpected exception when attempting to decrypt access token from localStorage using CryptoJS.AES.decrypt"
      );
    }
  };
  function z9(e) {
    var t, r, n = "";
    if (typeof e == "string" || typeof e == "number") n += e;
    else if (typeof e == "object") if (Array.isArray(e)) {
      var i = e.length;
      for (t = 0; t < i; t++) e[t] && (r = z9(e[t])) && (n && (n += " "), n += r);
    } else for (r in e) e[r] && (n && (n += " "), n += r);
    return n;
  }
  function hr() {
    for (var e, t, r = 0, n = "", i = arguments.length; r < i; r++) (e = arguments[r]) && (t = z9(e)) && (n && (n += " "), n += t);
    return n;
  }
  const jN = "-", loe = (e) => {
    const t = foe(e), {
      conflictingClassGroups: r,
      conflictingClassGroupModifiers: n
    } = e;
    return {
      getClassGroupId: (s) => {
        const c = s.split(jN);
        return c[0] === "" && c.length !== 1 && c.shift(), q9(c, t) || coe(s);
      },
      getConflictingClassGroupIds: (s, c) => {
        const p = r[s] || [];
        return c && n[s] ? [...p, ...n[s]] : p;
      }
    };
  }, q9 = (e, t) => {
    var s;
    if (e.length === 0)
      return t.classGroupId;
    const r = e[0], n = t.nextPart.get(r), i = n ? q9(e.slice(1), n) : void 0;
    if (i)
      return i;
    if (t.validators.length === 0)
      return;
    const u = e.join(jN);
    return (s = t.validators.find(({
      validator: c
    }) => c(u))) == null ? void 0 : s.classGroupId;
  }, q3 = /^\[(.+)\]$/, coe = (e) => {
    if (q3.test(e)) {
      const t = q3.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
      if (r)
        return "arbitrary.." + r;
    }
  }, foe = (e) => {
    const {
      theme: t,
      classGroups: r
    } = e, n = {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    };
    for (const i in r)
      DP(r[i], n, i, t);
    return n;
  }, DP = (e, t, r, n) => {
    e.forEach((i) => {
      if (typeof i == "string") {
        const u = i === "" ? t : U3(t, i);
        u.classGroupId = r;
        return;
      }
      if (typeof i == "function") {
        if (doe(i)) {
          DP(i(n), t, r, n);
          return;
        }
        t.validators.push({
          validator: i,
          classGroupId: r
        });
        return;
      }
      Object.entries(i).forEach(([u, s]) => {
        DP(s, U3(t, u), r, n);
      });
    });
  }, U3 = (e, t) => {
    let r = e;
    return t.split(jN).forEach((n) => {
      r.nextPart.has(n) || r.nextPart.set(n, {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
      }), r = r.nextPart.get(n);
    }), r;
  }, doe = (e) => e.isThemeGetter, poe = (e) => {
    if (e < 1)
      return {
        get: () => {
        },
        set: () => {
        }
      };
    let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
    const i = (u, s) => {
      r.set(u, s), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
    };
    return {
      get(u) {
        let s = r.get(u);
        if (s !== void 0)
          return s;
        if ((s = n.get(u)) !== void 0)
          return i(u, s), s;
      },
      set(u, s) {
        r.has(u) ? r.set(u, s) : i(u, s);
      }
    };
  }, kP = "!", RP = ":", hoe = RP.length, voe = (e) => {
    const {
      prefix: t,
      experimentalParseClassName: r
    } = e;
    let n = (i) => {
      const u = [];
      let s = 0, c = 0, p = 0, h;
      for (let E = 0; E < i.length; E++) {
        let C = i[E];
        if (s === 0 && c === 0) {
          if (C === RP) {
            u.push(i.slice(p, E)), p = E + hoe;
            continue;
          }
          if (C === "/") {
            h = E;
            continue;
          }
        }
        C === "[" ? s++ : C === "]" ? s-- : C === "(" ? c++ : C === ")" && c--;
      }
      const v = u.length === 0 ? i : i.substring(p), y = moe(v), x = y !== v, w = h && h > p ? h - p : void 0;
      return {
        modifiers: u,
        hasImportantModifier: x,
        baseClassName: y,
        maybePostfixModifierPosition: w
      };
    };
    if (t) {
      const i = t + RP, u = n;
      n = (s) => s.startsWith(i) ? u(s.substring(i.length)) : {
        isExternal: !0,
        modifiers: [],
        hasImportantModifier: !1,
        baseClassName: s,
        maybePostfixModifierPosition: void 0
      };
    }
    if (r) {
      const i = n;
      n = (u) => r({
        className: u,
        parseClassName: i
      });
    }
    return n;
  }, moe = (e) => e.endsWith(kP) ? e.substring(0, e.length - 1) : e.startsWith(kP) ? e.substring(1) : e, yoe = (e) => {
    const t = Object.fromEntries(e.orderSensitiveModifiers.map((n) => [n, !0]));
    return (n) => {
      if (n.length <= 1)
        return n;
      const i = [];
      let u = [];
      return n.forEach((s) => {
        s[0] === "[" || t[s] ? (i.push(...u.sort(), s), u = []) : u.push(s);
      }), i.push(...u.sort()), i;
    };
  }, goe = (e) => ({
    cache: poe(e.cacheSize),
    parseClassName: voe(e),
    sortModifiers: yoe(e),
    ...loe(e)
  }), xoe = /\s+/, boe = (e, t) => {
    const {
      parseClassName: r,
      getClassGroupId: n,
      getConflictingClassGroupIds: i,
      sortModifiers: u
    } = t, s = [], c = e.trim().split(xoe);
    let p = "";
    for (let h = c.length - 1; h >= 0; h -= 1) {
      const v = c[h], {
        isExternal: y,
        modifiers: x,
        hasImportantModifier: w,
        baseClassName: E,
        maybePostfixModifierPosition: C
      } = r(v);
      if (y) {
        p = v + (p.length > 0 ? " " + p : p);
        continue;
      }
      let S = !!C, k = n(S ? E.substring(0, C) : E);
      if (!k) {
        if (!S) {
          p = v + (p.length > 0 ? " " + p : p);
          continue;
        }
        if (k = n(E), !k) {
          p = v + (p.length > 0 ? " " + p : p);
          continue;
        }
        S = !1;
      }
      const D = u(x).join(":"), A = w ? D + kP : D, R = A + k;
      if (s.includes(R))
        continue;
      s.push(R);
      const T = i(k, S);
      for (let M = 0; M < T.length; ++M) {
        const F = T[M];
        s.push(A + F);
      }
      p = v + (p.length > 0 ? " " + p : p);
    }
    return p;
  };
  function woe() {
    let e = 0, t, r, n = "";
    for (; e < arguments.length; )
      (t = arguments[e++]) && (r = U9(t)) && (n && (n += " "), n += r);
    return n;
  }
  const U9 = (e) => {
    if (typeof e == "string")
      return e;
    let t, r = "";
    for (let n = 0; n < e.length; n++)
      e[n] && (t = U9(e[n])) && (r && (r += " "), r += t);
    return r;
  };
  function Eoe(e, ...t) {
    let r, n, i, u = s;
    function s(p) {
      const h = t.reduce((v, y) => y(v), e());
      return r = goe(h), n = r.cache.get, i = r.cache.set, u = c, c(p);
    }
    function c(p) {
      const h = n(p);
      if (h)
        return h;
      const v = boe(p, r);
      return i(p, v), v;
    }
    return function() {
      return u(woe.apply(null, arguments));
    };
  }
  const Ai = (e) => {
    const t = (r) => r[e] || [];
    return t.isThemeGetter = !0, t;
  }, H9 = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, V9 = /^\((?:(\w[\w-]*):)?(.+)\)$/i, Soe = /^\d+\/\d+$/, _oe = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Coe = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Ooe = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Toe = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Aoe = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Nv = (e) => Soe.test(e), Jt = (e) => !!e && !Number.isNaN(Number(e)), Tf = (e) => !!e && Number.isInteger(Number(e)), XA = (e) => e.endsWith("%") && Jt(e.slice(0, -1)), sc = (e) => _oe.test(e), Doe = () => !0, koe = (e) => (
    // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    Coe.test(e) && !Ooe.test(e)
  ), W9 = () => !1, Roe = (e) => Toe.test(e), Poe = (e) => Aoe.test(e), Moe = (e) => !yt(e) && !gt(e), Noe = (e) => z0(e, Q9, W9), yt = (e) => H9.test(e), mp = (e) => z0(e, K9, koe), ZA = (e) => z0(e, Loe, Jt), H3 = (e) => z0(e, Y9, W9), joe = (e) => z0(e, G9, Poe), eE = (e) => z0(e, X9, Roe), gt = (e) => V9.test(e), mg = (e) => q0(e, K9), Foe = (e) => q0(e, $oe), V3 = (e) => q0(e, Y9), Ioe = (e) => q0(e, Q9), Boe = (e) => q0(e, G9), tE = (e) => q0(e, X9, !0), z0 = (e, t, r) => {
    const n = H9.exec(e);
    return n ? n[1] ? t(n[1]) : r(n[2]) : !1;
  }, q0 = (e, t, r = !1) => {
    const n = V9.exec(e);
    return n ? n[1] ? t(n[1]) : r : !1;
  }, Y9 = (e) => e === "position" || e === "percentage", G9 = (e) => e === "image" || e === "url", Q9 = (e) => e === "length" || e === "size" || e === "bg-size", K9 = (e) => e === "length", Loe = (e) => e === "number", $oe = (e) => e === "family-name", X9 = (e) => e === "shadow", zoe = () => {
    const e = Ai("color"), t = Ai("font"), r = Ai("text"), n = Ai("font-weight"), i = Ai("tracking"), u = Ai("leading"), s = Ai("breakpoint"), c = Ai("container"), p = Ai("spacing"), h = Ai("radius"), v = Ai("shadow"), y = Ai("inset-shadow"), x = Ai("text-shadow"), w = Ai("drop-shadow"), E = Ai("blur"), C = Ai("perspective"), S = Ai("aspect"), k = Ai("ease"), D = Ai("animate"), A = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], R = () => [
      "center",
      "top",
      "bottom",
      "left",
      "right",
      "top-left",
      // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
      "left-top",
      "top-right",
      // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
      "right-top",
      "bottom-right",
      // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
      "right-bottom",
      "bottom-left",
      // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
      "left-bottom"
    ], T = () => [...R(), gt, yt], M = () => ["auto", "hidden", "clip", "visible", "scroll"], F = () => ["auto", "contain", "none"], B = () => [gt, yt, p], V = () => [Nv, "full", "auto", ...B()], H = () => [Tf, "none", "subgrid", gt, yt], q = () => ["auto", {
      span: ["full", Tf, gt, yt]
    }, Tf, gt, yt], Q = () => [Tf, "auto", gt, yt], W = () => ["auto", "min", "max", "fr", gt, yt], J = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], ne = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], ie = () => ["auto", ...B()], se = () => [Nv, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...B()], X = () => [e, gt, yt], fe = () => [...R(), V3, H3, {
      position: [gt, yt]
    }], Z = () => ["no-repeat", {
      repeat: ["", "x", "y", "space", "round"]
    }], z = () => ["auto", "cover", "contain", Ioe, Noe, {
      size: [gt, yt]
    }], Y = () => [XA, mg, mp], te = () => [
      // Deprecated since Tailwind CSS v4.0.0
      "",
      "none",
      "full",
      h,
      gt,
      yt
    ], ae = () => ["", Jt, mg, mp], De = () => ["solid", "dashed", "dotted", "double"], ke = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], Re = () => [Jt, XA, V3, H3], Te = () => [
      // Deprecated since Tailwind CSS v4.0.0
      "",
      "none",
      E,
      gt,
      yt
    ], we = () => ["none", Jt, gt, yt], Fe = () => ["none", Jt, gt, yt], Ye = () => [Jt, gt, yt], de = () => [Nv, "full", ...B()];
    return {
      cacheSize: 500,
      theme: {
        animate: ["spin", "ping", "pulse", "bounce"],
        aspect: ["video"],
        blur: [sc],
        breakpoint: [sc],
        color: [Doe],
        container: [sc],
        "drop-shadow": [sc],
        ease: ["in", "out", "in-out"],
        font: [Moe],
        "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
        "inset-shadow": [sc],
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
        perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
        radius: [sc],
        shadow: [sc],
        spacing: ["px", Jt],
        text: [sc],
        "text-shadow": [sc],
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
      },
      classGroups: {
        // --------------
        // --- Layout ---
        // --------------
        /**
         * Aspect Ratio
         * @see https://tailwindcss.com/docs/aspect-ratio
         */
        aspect: [{
          aspect: ["auto", "square", Nv, yt, gt, S]
        }],
        /**
         * Container
         * @see https://tailwindcss.com/docs/container
         * @deprecated since Tailwind CSS v4.0.0
         */
        container: ["container"],
        /**
         * Columns
         * @see https://tailwindcss.com/docs/columns
         */
        columns: [{
          columns: [Jt, yt, gt, c]
        }],
        /**
         * Break After
         * @see https://tailwindcss.com/docs/break-after
         */
        "break-after": [{
          "break-after": A()
        }],
        /**
         * Break Before
         * @see https://tailwindcss.com/docs/break-before
         */
        "break-before": [{
          "break-before": A()
        }],
        /**
         * Break Inside
         * @see https://tailwindcss.com/docs/break-inside
         */
        "break-inside": [{
          "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
        }],
        /**
         * Box Decoration Break
         * @see https://tailwindcss.com/docs/box-decoration-break
         */
        "box-decoration": [{
          "box-decoration": ["slice", "clone"]
        }],
        /**
         * Box Sizing
         * @see https://tailwindcss.com/docs/box-sizing
         */
        box: [{
          box: ["border", "content"]
        }],
        /**
         * Display
         * @see https://tailwindcss.com/docs/display
         */
        display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
        /**
         * Screen Reader Only
         * @see https://tailwindcss.com/docs/display#screen-reader-only
         */
        sr: ["sr-only", "not-sr-only"],
        /**
         * Floats
         * @see https://tailwindcss.com/docs/float
         */
        float: [{
          float: ["right", "left", "none", "start", "end"]
        }],
        /**
         * Clear
         * @see https://tailwindcss.com/docs/clear
         */
        clear: [{
          clear: ["left", "right", "both", "none", "start", "end"]
        }],
        /**
         * Isolation
         * @see https://tailwindcss.com/docs/isolation
         */
        isolation: ["isolate", "isolation-auto"],
        /**
         * Object Fit
         * @see https://tailwindcss.com/docs/object-fit
         */
        "object-fit": [{
          object: ["contain", "cover", "fill", "none", "scale-down"]
        }],
        /**
         * Object Position
         * @see https://tailwindcss.com/docs/object-position
         */
        "object-position": [{
          object: T()
        }],
        /**
         * Overflow
         * @see https://tailwindcss.com/docs/overflow
         */
        overflow: [{
          overflow: M()
        }],
        /**
         * Overflow X
         * @see https://tailwindcss.com/docs/overflow
         */
        "overflow-x": [{
          "overflow-x": M()
        }],
        /**
         * Overflow Y
         * @see https://tailwindcss.com/docs/overflow
         */
        "overflow-y": [{
          "overflow-y": M()
        }],
        /**
         * Overscroll Behavior
         * @see https://tailwindcss.com/docs/overscroll-behavior
         */
        overscroll: [{
          overscroll: F()
        }],
        /**
         * Overscroll Behavior X
         * @see https://tailwindcss.com/docs/overscroll-behavior
         */
        "overscroll-x": [{
          "overscroll-x": F()
        }],
        /**
         * Overscroll Behavior Y
         * @see https://tailwindcss.com/docs/overscroll-behavior
         */
        "overscroll-y": [{
          "overscroll-y": F()
        }],
        /**
         * Position
         * @see https://tailwindcss.com/docs/position
         */
        position: ["static", "fixed", "absolute", "relative", "sticky"],
        /**
         * Top / Right / Bottom / Left
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        inset: [{
          inset: V()
        }],
        /**
         * Right / Left
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        "inset-x": [{
          "inset-x": V()
        }],
        /**
         * Top / Bottom
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        "inset-y": [{
          "inset-y": V()
        }],
        /**
         * Start
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        start: [{
          start: V()
        }],
        /**
         * End
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        end: [{
          end: V()
        }],
        /**
         * Top
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        top: [{
          top: V()
        }],
        /**
         * Right
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        right: [{
          right: V()
        }],
        /**
         * Bottom
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        bottom: [{
          bottom: V()
        }],
        /**
         * Left
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        left: [{
          left: V()
        }],
        /**
         * Visibility
         * @see https://tailwindcss.com/docs/visibility
         */
        visibility: ["visible", "invisible", "collapse"],
        /**
         * Z-Index
         * @see https://tailwindcss.com/docs/z-index
         */
        z: [{
          z: [Tf, "auto", gt, yt]
        }],
        // ------------------------
        // --- Flexbox and Grid ---
        // ------------------------
        /**
         * Flex Basis
         * @see https://tailwindcss.com/docs/flex-basis
         */
        basis: [{
          basis: [Nv, "full", "auto", c, ...B()]
        }],
        /**
         * Flex Direction
         * @see https://tailwindcss.com/docs/flex-direction
         */
        "flex-direction": [{
          flex: ["row", "row-reverse", "col", "col-reverse"]
        }],
        /**
         * Flex Wrap
         * @see https://tailwindcss.com/docs/flex-wrap
         */
        "flex-wrap": [{
          flex: ["nowrap", "wrap", "wrap-reverse"]
        }],
        /**
         * Flex
         * @see https://tailwindcss.com/docs/flex
         */
        flex: [{
          flex: [Jt, Nv, "auto", "initial", "none", yt]
        }],
        /**
         * Flex Grow
         * @see https://tailwindcss.com/docs/flex-grow
         */
        grow: [{
          grow: ["", Jt, gt, yt]
        }],
        /**
         * Flex Shrink
         * @see https://tailwindcss.com/docs/flex-shrink
         */
        shrink: [{
          shrink: ["", Jt, gt, yt]
        }],
        /**
         * Order
         * @see https://tailwindcss.com/docs/order
         */
        order: [{
          order: [Tf, "first", "last", "none", gt, yt]
        }],
        /**
         * Grid Template Columns
         * @see https://tailwindcss.com/docs/grid-template-columns
         */
        "grid-cols": [{
          "grid-cols": H()
        }],
        /**
         * Grid Column Start / End
         * @see https://tailwindcss.com/docs/grid-column
         */
        "col-start-end": [{
          col: q()
        }],
        /**
         * Grid Column Start
         * @see https://tailwindcss.com/docs/grid-column
         */
        "col-start": [{
          "col-start": Q()
        }],
        /**
         * Grid Column End
         * @see https://tailwindcss.com/docs/grid-column
         */
        "col-end": [{
          "col-end": Q()
        }],
        /**
         * Grid Template Rows
         * @see https://tailwindcss.com/docs/grid-template-rows
         */
        "grid-rows": [{
          "grid-rows": H()
        }],
        /**
         * Grid Row Start / End
         * @see https://tailwindcss.com/docs/grid-row
         */
        "row-start-end": [{
          row: q()
        }],
        /**
         * Grid Row Start
         * @see https://tailwindcss.com/docs/grid-row
         */
        "row-start": [{
          "row-start": Q()
        }],
        /**
         * Grid Row End
         * @see https://tailwindcss.com/docs/grid-row
         */
        "row-end": [{
          "row-end": Q()
        }],
        /**
         * Grid Auto Flow
         * @see https://tailwindcss.com/docs/grid-auto-flow
         */
        "grid-flow": [{
          "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
        }],
        /**
         * Grid Auto Columns
         * @see https://tailwindcss.com/docs/grid-auto-columns
         */
        "auto-cols": [{
          "auto-cols": W()
        }],
        /**
         * Grid Auto Rows
         * @see https://tailwindcss.com/docs/grid-auto-rows
         */
        "auto-rows": [{
          "auto-rows": W()
        }],
        /**
         * Gap
         * @see https://tailwindcss.com/docs/gap
         */
        gap: [{
          gap: B()
        }],
        /**
         * Gap X
         * @see https://tailwindcss.com/docs/gap
         */
        "gap-x": [{
          "gap-x": B()
        }],
        /**
         * Gap Y
         * @see https://tailwindcss.com/docs/gap
         */
        "gap-y": [{
          "gap-y": B()
        }],
        /**
         * Justify Content
         * @see https://tailwindcss.com/docs/justify-content
         */
        "justify-content": [{
          justify: [...J(), "normal"]
        }],
        /**
         * Justify Items
         * @see https://tailwindcss.com/docs/justify-items
         */
        "justify-items": [{
          "justify-items": [...ne(), "normal"]
        }],
        /**
         * Justify Self
         * @see https://tailwindcss.com/docs/justify-self
         */
        "justify-self": [{
          "justify-self": ["auto", ...ne()]
        }],
        /**
         * Align Content
         * @see https://tailwindcss.com/docs/align-content
         */
        "align-content": [{
          content: ["normal", ...J()]
        }],
        /**
         * Align Items
         * @see https://tailwindcss.com/docs/align-items
         */
        "align-items": [{
          items: [...ne(), {
            baseline: ["", "last"]
          }]
        }],
        /**
         * Align Self
         * @see https://tailwindcss.com/docs/align-self
         */
        "align-self": [{
          self: ["auto", ...ne(), {
            baseline: ["", "last"]
          }]
        }],
        /**
         * Place Content
         * @see https://tailwindcss.com/docs/place-content
         */
        "place-content": [{
          "place-content": J()
        }],
        /**
         * Place Items
         * @see https://tailwindcss.com/docs/place-items
         */
        "place-items": [{
          "place-items": [...ne(), "baseline"]
        }],
        /**
         * Place Self
         * @see https://tailwindcss.com/docs/place-self
         */
        "place-self": [{
          "place-self": ["auto", ...ne()]
        }],
        // Spacing
        /**
         * Padding
         * @see https://tailwindcss.com/docs/padding
         */
        p: [{
          p: B()
        }],
        /**
         * Padding X
         * @see https://tailwindcss.com/docs/padding
         */
        px: [{
          px: B()
        }],
        /**
         * Padding Y
         * @see https://tailwindcss.com/docs/padding
         */
        py: [{
          py: B()
        }],
        /**
         * Padding Start
         * @see https://tailwindcss.com/docs/padding
         */
        ps: [{
          ps: B()
        }],
        /**
         * Padding End
         * @see https://tailwindcss.com/docs/padding
         */
        pe: [{
          pe: B()
        }],
        /**
         * Padding Top
         * @see https://tailwindcss.com/docs/padding
         */
        pt: [{
          pt: B()
        }],
        /**
         * Padding Right
         * @see https://tailwindcss.com/docs/padding
         */
        pr: [{
          pr: B()
        }],
        /**
         * Padding Bottom
         * @see https://tailwindcss.com/docs/padding
         */
        pb: [{
          pb: B()
        }],
        /**
         * Padding Left
         * @see https://tailwindcss.com/docs/padding
         */
        pl: [{
          pl: B()
        }],
        /**
         * Margin
         * @see https://tailwindcss.com/docs/margin
         */
        m: [{
          m: ie()
        }],
        /**
         * Margin X
         * @see https://tailwindcss.com/docs/margin
         */
        mx: [{
          mx: ie()
        }],
        /**
         * Margin Y
         * @see https://tailwindcss.com/docs/margin
         */
        my: [{
          my: ie()
        }],
        /**
         * Margin Start
         * @see https://tailwindcss.com/docs/margin
         */
        ms: [{
          ms: ie()
        }],
        /**
         * Margin End
         * @see https://tailwindcss.com/docs/margin
         */
        me: [{
          me: ie()
        }],
        /**
         * Margin Top
         * @see https://tailwindcss.com/docs/margin
         */
        mt: [{
          mt: ie()
        }],
        /**
         * Margin Right
         * @see https://tailwindcss.com/docs/margin
         */
        mr: [{
          mr: ie()
        }],
        /**
         * Margin Bottom
         * @see https://tailwindcss.com/docs/margin
         */
        mb: [{
          mb: ie()
        }],
        /**
         * Margin Left
         * @see https://tailwindcss.com/docs/margin
         */
        ml: [{
          ml: ie()
        }],
        /**
         * Space Between X
         * @see https://tailwindcss.com/docs/margin#adding-space-between-children
         */
        "space-x": [{
          "space-x": B()
        }],
        /**
         * Space Between X Reverse
         * @see https://tailwindcss.com/docs/margin#adding-space-between-children
         */
        "space-x-reverse": ["space-x-reverse"],
        /**
         * Space Between Y
         * @see https://tailwindcss.com/docs/margin#adding-space-between-children
         */
        "space-y": [{
          "space-y": B()
        }],
        /**
         * Space Between Y Reverse
         * @see https://tailwindcss.com/docs/margin#adding-space-between-children
         */
        "space-y-reverse": ["space-y-reverse"],
        // --------------
        // --- Sizing ---
        // --------------
        /**
         * Size
         * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
         */
        size: [{
          size: se()
        }],
        /**
         * Width
         * @see https://tailwindcss.com/docs/width
         */
        w: [{
          w: [c, "screen", ...se()]
        }],
        /**
         * Min-Width
         * @see https://tailwindcss.com/docs/min-width
         */
        "min-w": [{
          "min-w": [
            c,
            "screen",
            /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
            "none",
            ...se()
          ]
        }],
        /**
         * Max-Width
         * @see https://tailwindcss.com/docs/max-width
         */
        "max-w": [{
          "max-w": [
            c,
            "screen",
            "none",
            /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
            "prose",
            /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
            {
              screen: [s]
            },
            ...se()
          ]
        }],
        /**
         * Height
         * @see https://tailwindcss.com/docs/height
         */
        h: [{
          h: ["screen", "lh", ...se()]
        }],
        /**
         * Min-Height
         * @see https://tailwindcss.com/docs/min-height
         */
        "min-h": [{
          "min-h": ["screen", "lh", "none", ...se()]
        }],
        /**
         * Max-Height
         * @see https://tailwindcss.com/docs/max-height
         */
        "max-h": [{
          "max-h": ["screen", "lh", ...se()]
        }],
        // ------------------
        // --- Typography ---
        // ------------------
        /**
         * Font Size
         * @see https://tailwindcss.com/docs/font-size
         */
        "font-size": [{
          text: ["base", r, mg, mp]
        }],
        /**
         * Font Smoothing
         * @see https://tailwindcss.com/docs/font-smoothing
         */
        "font-smoothing": ["antialiased", "subpixel-antialiased"],
        /**
         * Font Style
         * @see https://tailwindcss.com/docs/font-style
         */
        "font-style": ["italic", "not-italic"],
        /**
         * Font Weight
         * @see https://tailwindcss.com/docs/font-weight
         */
        "font-weight": [{
          font: [n, gt, ZA]
        }],
        /**
         * Font Stretch
         * @see https://tailwindcss.com/docs/font-stretch
         */
        "font-stretch": [{
          "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", XA, yt]
        }],
        /**
         * Font Family
         * @see https://tailwindcss.com/docs/font-family
         */
        "font-family": [{
          font: [Foe, yt, t]
        }],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-normal": ["normal-nums"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-ordinal": ["ordinal"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-slashed-zero": ["slashed-zero"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-figure": ["lining-nums", "oldstyle-nums"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-spacing": ["proportional-nums", "tabular-nums"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
        /**
         * Letter Spacing
         * @see https://tailwindcss.com/docs/letter-spacing
         */
        tracking: [{
          tracking: [i, gt, yt]
        }],
        /**
         * Line Clamp
         * @see https://tailwindcss.com/docs/line-clamp
         */
        "line-clamp": [{
          "line-clamp": [Jt, "none", gt, ZA]
        }],
        /**
         * Line Height
         * @see https://tailwindcss.com/docs/line-height
         */
        leading: [{
          leading: [
            /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
            u,
            ...B()
          ]
        }],
        /**
         * List Style Image
         * @see https://tailwindcss.com/docs/list-style-image
         */
        "list-image": [{
          "list-image": ["none", gt, yt]
        }],
        /**
         * List Style Position
         * @see https://tailwindcss.com/docs/list-style-position
         */
        "list-style-position": [{
          list: ["inside", "outside"]
        }],
        /**
         * List Style Type
         * @see https://tailwindcss.com/docs/list-style-type
         */
        "list-style-type": [{
          list: ["disc", "decimal", "none", gt, yt]
        }],
        /**
         * Text Alignment
         * @see https://tailwindcss.com/docs/text-align
         */
        "text-alignment": [{
          text: ["left", "center", "right", "justify", "start", "end"]
        }],
        /**
         * Placeholder Color
         * @deprecated since Tailwind CSS v3.0.0
         * @see https://v3.tailwindcss.com/docs/placeholder-color
         */
        "placeholder-color": [{
          placeholder: X()
        }],
        /**
         * Text Color
         * @see https://tailwindcss.com/docs/text-color
         */
        "text-color": [{
          text: X()
        }],
        /**
         * Text Decoration
         * @see https://tailwindcss.com/docs/text-decoration
         */
        "text-decoration": ["underline", "overline", "line-through", "no-underline"],
        /**
         * Text Decoration Style
         * @see https://tailwindcss.com/docs/text-decoration-style
         */
        "text-decoration-style": [{
          decoration: [...De(), "wavy"]
        }],
        /**
         * Text Decoration Thickness
         * @see https://tailwindcss.com/docs/text-decoration-thickness
         */
        "text-decoration-thickness": [{
          decoration: [Jt, "from-font", "auto", gt, mp]
        }],
        /**
         * Text Decoration Color
         * @see https://tailwindcss.com/docs/text-decoration-color
         */
        "text-decoration-color": [{
          decoration: X()
        }],
        /**
         * Text Underline Offset
         * @see https://tailwindcss.com/docs/text-underline-offset
         */
        "underline-offset": [{
          "underline-offset": [Jt, "auto", gt, yt]
        }],
        /**
         * Text Transform
         * @see https://tailwindcss.com/docs/text-transform
         */
        "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
        /**
         * Text Overflow
         * @see https://tailwindcss.com/docs/text-overflow
         */
        "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
        /**
         * Text Wrap
         * @see https://tailwindcss.com/docs/text-wrap
         */
        "text-wrap": [{
          text: ["wrap", "nowrap", "balance", "pretty"]
        }],
        /**
         * Text Indent
         * @see https://tailwindcss.com/docs/text-indent
         */
        indent: [{
          indent: B()
        }],
        /**
         * Vertical Alignment
         * @see https://tailwindcss.com/docs/vertical-align
         */
        "vertical-align": [{
          align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", gt, yt]
        }],
        /**
         * Whitespace
         * @see https://tailwindcss.com/docs/whitespace
         */
        whitespace: [{
          whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
        }],
        /**
         * Word Break
         * @see https://tailwindcss.com/docs/word-break
         */
        break: [{
          break: ["normal", "words", "all", "keep"]
        }],
        /**
         * Overflow Wrap
         * @see https://tailwindcss.com/docs/overflow-wrap
         */
        wrap: [{
          wrap: ["break-word", "anywhere", "normal"]
        }],
        /**
         * Hyphens
         * @see https://tailwindcss.com/docs/hyphens
         */
        hyphens: [{
          hyphens: ["none", "manual", "auto"]
        }],
        /**
         * Content
         * @see https://tailwindcss.com/docs/content
         */
        content: [{
          content: ["none", gt, yt]
        }],
        // -------------------
        // --- Backgrounds ---
        // -------------------
        /**
         * Background Attachment
         * @see https://tailwindcss.com/docs/background-attachment
         */
        "bg-attachment": [{
          bg: ["fixed", "local", "scroll"]
        }],
        /**
         * Background Clip
         * @see https://tailwindcss.com/docs/background-clip
         */
        "bg-clip": [{
          "bg-clip": ["border", "padding", "content", "text"]
        }],
        /**
         * Background Origin
         * @see https://tailwindcss.com/docs/background-origin
         */
        "bg-origin": [{
          "bg-origin": ["border", "padding", "content"]
        }],
        /**
         * Background Position
         * @see https://tailwindcss.com/docs/background-position
         */
        "bg-position": [{
          bg: fe()
        }],
        /**
         * Background Repeat
         * @see https://tailwindcss.com/docs/background-repeat
         */
        "bg-repeat": [{
          bg: Z()
        }],
        /**
         * Background Size
         * @see https://tailwindcss.com/docs/background-size
         */
        "bg-size": [{
          bg: z()
        }],
        /**
         * Background Image
         * @see https://tailwindcss.com/docs/background-image
         */
        "bg-image": [{
          bg: ["none", {
            linear: [{
              to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
            }, Tf, gt, yt],
            radial: ["", gt, yt],
            conic: [Tf, gt, yt]
          }, Boe, joe]
        }],
        /**
         * Background Color
         * @see https://tailwindcss.com/docs/background-color
         */
        "bg-color": [{
          bg: X()
        }],
        /**
         * Gradient Color Stops From Position
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-from-pos": [{
          from: Y()
        }],
        /**
         * Gradient Color Stops Via Position
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-via-pos": [{
          via: Y()
        }],
        /**
         * Gradient Color Stops To Position
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-to-pos": [{
          to: Y()
        }],
        /**
         * Gradient Color Stops From
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-from": [{
          from: X()
        }],
        /**
         * Gradient Color Stops Via
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-via": [{
          via: X()
        }],
        /**
         * Gradient Color Stops To
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-to": [{
          to: X()
        }],
        // ---------------
        // --- Borders ---
        // ---------------
        /**
         * Border Radius
         * @see https://tailwindcss.com/docs/border-radius
         */
        rounded: [{
          rounded: te()
        }],
        /**
         * Border Radius Start
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-s": [{
          "rounded-s": te()
        }],
        /**
         * Border Radius End
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-e": [{
          "rounded-e": te()
        }],
        /**
         * Border Radius Top
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-t": [{
          "rounded-t": te()
        }],
        /**
         * Border Radius Right
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-r": [{
          "rounded-r": te()
        }],
        /**
         * Border Radius Bottom
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-b": [{
          "rounded-b": te()
        }],
        /**
         * Border Radius Left
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-l": [{
          "rounded-l": te()
        }],
        /**
         * Border Radius Start Start
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-ss": [{
          "rounded-ss": te()
        }],
        /**
         * Border Radius Start End
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-se": [{
          "rounded-se": te()
        }],
        /**
         * Border Radius End End
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-ee": [{
          "rounded-ee": te()
        }],
        /**
         * Border Radius End Start
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-es": [{
          "rounded-es": te()
        }],
        /**
         * Border Radius Top Left
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-tl": [{
          "rounded-tl": te()
        }],
        /**
         * Border Radius Top Right
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-tr": [{
          "rounded-tr": te()
        }],
        /**
         * Border Radius Bottom Right
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-br": [{
          "rounded-br": te()
        }],
        /**
         * Border Radius Bottom Left
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-bl": [{
          "rounded-bl": te()
        }],
        /**
         * Border Width
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w": [{
          border: ae()
        }],
        /**
         * Border Width X
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-x": [{
          "border-x": ae()
        }],
        /**
         * Border Width Y
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-y": [{
          "border-y": ae()
        }],
        /**
         * Border Width Start
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-s": [{
          "border-s": ae()
        }],
        /**
         * Border Width End
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-e": [{
          "border-e": ae()
        }],
        /**
         * Border Width Top
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-t": [{
          "border-t": ae()
        }],
        /**
         * Border Width Right
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-r": [{
          "border-r": ae()
        }],
        /**
         * Border Width Bottom
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-b": [{
          "border-b": ae()
        }],
        /**
         * Border Width Left
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-l": [{
          "border-l": ae()
        }],
        /**
         * Divide Width X
         * @see https://tailwindcss.com/docs/border-width#between-children
         */
        "divide-x": [{
          "divide-x": ae()
        }],
        /**
         * Divide Width X Reverse
         * @see https://tailwindcss.com/docs/border-width#between-children
         */
        "divide-x-reverse": ["divide-x-reverse"],
        /**
         * Divide Width Y
         * @see https://tailwindcss.com/docs/border-width#between-children
         */
        "divide-y": [{
          "divide-y": ae()
        }],
        /**
         * Divide Width Y Reverse
         * @see https://tailwindcss.com/docs/border-width#between-children
         */
        "divide-y-reverse": ["divide-y-reverse"],
        /**
         * Border Style
         * @see https://tailwindcss.com/docs/border-style
         */
        "border-style": [{
          border: [...De(), "hidden", "none"]
        }],
        /**
         * Divide Style
         * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
         */
        "divide-style": [{
          divide: [...De(), "hidden", "none"]
        }],
        /**
         * Border Color
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color": [{
          border: X()
        }],
        /**
         * Border Color X
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-x": [{
          "border-x": X()
        }],
        /**
         * Border Color Y
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-y": [{
          "border-y": X()
        }],
        /**
         * Border Color S
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-s": [{
          "border-s": X()
        }],
        /**
         * Border Color E
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-e": [{
          "border-e": X()
        }],
        /**
         * Border Color Top
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-t": [{
          "border-t": X()
        }],
        /**
         * Border Color Right
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-r": [{
          "border-r": X()
        }],
        /**
         * Border Color Bottom
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-b": [{
          "border-b": X()
        }],
        /**
         * Border Color Left
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-l": [{
          "border-l": X()
        }],
        /**
         * Divide Color
         * @see https://tailwindcss.com/docs/divide-color
         */
        "divide-color": [{
          divide: X()
        }],
        /**
         * Outline Style
         * @see https://tailwindcss.com/docs/outline-style
         */
        "outline-style": [{
          outline: [...De(), "none", "hidden"]
        }],
        /**
         * Outline Offset
         * @see https://tailwindcss.com/docs/outline-offset
         */
        "outline-offset": [{
          "outline-offset": [Jt, gt, yt]
        }],
        /**
         * Outline Width
         * @see https://tailwindcss.com/docs/outline-width
         */
        "outline-w": [{
          outline: ["", Jt, mg, mp]
        }],
        /**
         * Outline Color
         * @see https://tailwindcss.com/docs/outline-color
         */
        "outline-color": [{
          outline: X()
        }],
        // ---------------
        // --- Effects ---
        // ---------------
        /**
         * Box Shadow
         * @see https://tailwindcss.com/docs/box-shadow
         */
        shadow: [{
          shadow: [
            // Deprecated since Tailwind CSS v4.0.0
            "",
            "none",
            v,
            tE,
            eE
          ]
        }],
        /**
         * Box Shadow Color
         * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
         */
        "shadow-color": [{
          shadow: X()
        }],
        /**
         * Inset Box Shadow
         * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
         */
        "inset-shadow": [{
          "inset-shadow": ["none", y, tE, eE]
        }],
        /**
         * Inset Box Shadow Color
         * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
         */
        "inset-shadow-color": [{
          "inset-shadow": X()
        }],
        /**
         * Ring Width
         * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
         */
        "ring-w": [{
          ring: ae()
        }],
        /**
         * Ring Width Inset
         * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
         * @deprecated since Tailwind CSS v4.0.0
         * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
         */
        "ring-w-inset": ["ring-inset"],
        /**
         * Ring Color
         * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
         */
        "ring-color": [{
          ring: X()
        }],
        /**
         * Ring Offset Width
         * @see https://v3.tailwindcss.com/docs/ring-offset-width
         * @deprecated since Tailwind CSS v4.0.0
         * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
         */
        "ring-offset-w": [{
          "ring-offset": [Jt, mp]
        }],
        /**
         * Ring Offset Color
         * @see https://v3.tailwindcss.com/docs/ring-offset-color
         * @deprecated since Tailwind CSS v4.0.0
         * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
         */
        "ring-offset-color": [{
          "ring-offset": X()
        }],
        /**
         * Inset Ring Width
         * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
         */
        "inset-ring-w": [{
          "inset-ring": ae()
        }],
        /**
         * Inset Ring Color
         * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
         */
        "inset-ring-color": [{
          "inset-ring": X()
        }],
        /**
         * Text Shadow
         * @see https://tailwindcss.com/docs/text-shadow
         */
        "text-shadow": [{
          "text-shadow": ["none", x, tE, eE]
        }],
        /**
         * Text Shadow Color
         * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
         */
        "text-shadow-color": [{
          "text-shadow": X()
        }],
        /**
         * Opacity
         * @see https://tailwindcss.com/docs/opacity
         */
        opacity: [{
          opacity: [Jt, gt, yt]
        }],
        /**
         * Mix Blend Mode
         * @see https://tailwindcss.com/docs/mix-blend-mode
         */
        "mix-blend": [{
          "mix-blend": [...ke(), "plus-darker", "plus-lighter"]
        }],
        /**
         * Background Blend Mode
         * @see https://tailwindcss.com/docs/background-blend-mode
         */
        "bg-blend": [{
          "bg-blend": ke()
        }],
        /**
         * Mask Clip
         * @see https://tailwindcss.com/docs/mask-clip
         */
        "mask-clip": [{
          "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
        }, "mask-no-clip"],
        /**
         * Mask Composite
         * @see https://tailwindcss.com/docs/mask-composite
         */
        "mask-composite": [{
          mask: ["add", "subtract", "intersect", "exclude"]
        }],
        /**
         * Mask Image
         * @see https://tailwindcss.com/docs/mask-image
         */
        "mask-image-linear-pos": [{
          "mask-linear": [Jt]
        }],
        "mask-image-linear-from-pos": [{
          "mask-linear-from": Re()
        }],
        "mask-image-linear-to-pos": [{
          "mask-linear-to": Re()
        }],
        "mask-image-linear-from-color": [{
          "mask-linear-from": X()
        }],
        "mask-image-linear-to-color": [{
          "mask-linear-to": X()
        }],
        "mask-image-t-from-pos": [{
          "mask-t-from": Re()
        }],
        "mask-image-t-to-pos": [{
          "mask-t-to": Re()
        }],
        "mask-image-t-from-color": [{
          "mask-t-from": X()
        }],
        "mask-image-t-to-color": [{
          "mask-t-to": X()
        }],
        "mask-image-r-from-pos": [{
          "mask-r-from": Re()
        }],
        "mask-image-r-to-pos": [{
          "mask-r-to": Re()
        }],
        "mask-image-r-from-color": [{
          "mask-r-from": X()
        }],
        "mask-image-r-to-color": [{
          "mask-r-to": X()
        }],
        "mask-image-b-from-pos": [{
          "mask-b-from": Re()
        }],
        "mask-image-b-to-pos": [{
          "mask-b-to": Re()
        }],
        "mask-image-b-from-color": [{
          "mask-b-from": X()
        }],
        "mask-image-b-to-color": [{
          "mask-b-to": X()
        }],
        "mask-image-l-from-pos": [{
          "mask-l-from": Re()
        }],
        "mask-image-l-to-pos": [{
          "mask-l-to": Re()
        }],
        "mask-image-l-from-color": [{
          "mask-l-from": X()
        }],
        "mask-image-l-to-color": [{
          "mask-l-to": X()
        }],
        "mask-image-x-from-pos": [{
          "mask-x-from": Re()
        }],
        "mask-image-x-to-pos": [{
          "mask-x-to": Re()
        }],
        "mask-image-x-from-color": [{
          "mask-x-from": X()
        }],
        "mask-image-x-to-color": [{
          "mask-x-to": X()
        }],
        "mask-image-y-from-pos": [{
          "mask-y-from": Re()
        }],
        "mask-image-y-to-pos": [{
          "mask-y-to": Re()
        }],
        "mask-image-y-from-color": [{
          "mask-y-from": X()
        }],
        "mask-image-y-to-color": [{
          "mask-y-to": X()
        }],
        "mask-image-radial": [{
          "mask-radial": [gt, yt]
        }],
        "mask-image-radial-from-pos": [{
          "mask-radial-from": Re()
        }],
        "mask-image-radial-to-pos": [{
          "mask-radial-to": Re()
        }],
        "mask-image-radial-from-color": [{
          "mask-radial-from": X()
        }],
        "mask-image-radial-to-color": [{
          "mask-radial-to": X()
        }],
        "mask-image-radial-shape": [{
          "mask-radial": ["circle", "ellipse"]
        }],
        "mask-image-radial-size": [{
          "mask-radial": [{
            closest: ["side", "corner"],
            farthest: ["side", "corner"]
          }]
        }],
        "mask-image-radial-pos": [{
          "mask-radial-at": R()
        }],
        "mask-image-conic-pos": [{
          "mask-conic": [Jt]
        }],
        "mask-image-conic-from-pos": [{
          "mask-conic-from": Re()
        }],
        "mask-image-conic-to-pos": [{
          "mask-conic-to": Re()
        }],
        "mask-image-conic-from-color": [{
          "mask-conic-from": X()
        }],
        "mask-image-conic-to-color": [{
          "mask-conic-to": X()
        }],
        /**
         * Mask Mode
         * @see https://tailwindcss.com/docs/mask-mode
         */
        "mask-mode": [{
          mask: ["alpha", "luminance", "match"]
        }],
        /**
         * Mask Origin
         * @see https://tailwindcss.com/docs/mask-origin
         */
        "mask-origin": [{
          "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
        }],
        /**
         * Mask Position
         * @see https://tailwindcss.com/docs/mask-position
         */
        "mask-position": [{
          mask: fe()
        }],
        /**
         * Mask Repeat
         * @see https://tailwindcss.com/docs/mask-repeat
         */
        "mask-repeat": [{
          mask: Z()
        }],
        /**
         * Mask Size
         * @see https://tailwindcss.com/docs/mask-size
         */
        "mask-size": [{
          mask: z()
        }],
        /**
         * Mask Type
         * @see https://tailwindcss.com/docs/mask-type
         */
        "mask-type": [{
          "mask-type": ["alpha", "luminance"]
        }],
        /**
         * Mask Image
         * @see https://tailwindcss.com/docs/mask-image
         */
        "mask-image": [{
          mask: ["none", gt, yt]
        }],
        // ---------------
        // --- Filters ---
        // ---------------
        /**
         * Filter
         * @see https://tailwindcss.com/docs/filter
         */
        filter: [{
          filter: [
            // Deprecated since Tailwind CSS v3.0.0
            "",
            "none",
            gt,
            yt
          ]
        }],
        /**
         * Blur
         * @see https://tailwindcss.com/docs/blur
         */
        blur: [{
          blur: Te()
        }],
        /**
         * Brightness
         * @see https://tailwindcss.com/docs/brightness
         */
        brightness: [{
          brightness: [Jt, gt, yt]
        }],
        /**
         * Contrast
         * @see https://tailwindcss.com/docs/contrast
         */
        contrast: [{
          contrast: [Jt, gt, yt]
        }],
        /**
         * Drop Shadow
         * @see https://tailwindcss.com/docs/drop-shadow
         */
        "drop-shadow": [{
          "drop-shadow": [
            // Deprecated since Tailwind CSS v4.0.0
            "",
            "none",
            w,
            tE,
            eE
          ]
        }],
        /**
         * Drop Shadow Color
         * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
         */
        "drop-shadow-color": [{
          "drop-shadow": X()
        }],
        /**
         * Grayscale
         * @see https://tailwindcss.com/docs/grayscale
         */
        grayscale: [{
          grayscale: ["", Jt, gt, yt]
        }],
        /**
         * Hue Rotate
         * @see https://tailwindcss.com/docs/hue-rotate
         */
        "hue-rotate": [{
          "hue-rotate": [Jt, gt, yt]
        }],
        /**
         * Invert
         * @see https://tailwindcss.com/docs/invert
         */
        invert: [{
          invert: ["", Jt, gt, yt]
        }],
        /**
         * Saturate
         * @see https://tailwindcss.com/docs/saturate
         */
        saturate: [{
          saturate: [Jt, gt, yt]
        }],
        /**
         * Sepia
         * @see https://tailwindcss.com/docs/sepia
         */
        sepia: [{
          sepia: ["", Jt, gt, yt]
        }],
        /**
         * Backdrop Filter
         * @see https://tailwindcss.com/docs/backdrop-filter
         */
        "backdrop-filter": [{
          "backdrop-filter": [
            // Deprecated since Tailwind CSS v3.0.0
            "",
            "none",
            gt,
            yt
          ]
        }],
        /**
         * Backdrop Blur
         * @see https://tailwindcss.com/docs/backdrop-blur
         */
        "backdrop-blur": [{
          "backdrop-blur": Te()
        }],
        /**
         * Backdrop Brightness
         * @see https://tailwindcss.com/docs/backdrop-brightness
         */
        "backdrop-brightness": [{
          "backdrop-brightness": [Jt, gt, yt]
        }],
        /**
         * Backdrop Contrast
         * @see https://tailwindcss.com/docs/backdrop-contrast
         */
        "backdrop-contrast": [{
          "backdrop-contrast": [Jt, gt, yt]
        }],
        /**
         * Backdrop Grayscale
         * @see https://tailwindcss.com/docs/backdrop-grayscale
         */
        "backdrop-grayscale": [{
          "backdrop-grayscale": ["", Jt, gt, yt]
        }],
        /**
         * Backdrop Hue Rotate
         * @see https://tailwindcss.com/docs/backdrop-hue-rotate
         */
        "backdrop-hue-rotate": [{
          "backdrop-hue-rotate": [Jt, gt, yt]
        }],
        /**
         * Backdrop Invert
         * @see https://tailwindcss.com/docs/backdrop-invert
         */
        "backdrop-invert": [{
          "backdrop-invert": ["", Jt, gt, yt]
        }],
        /**
         * Backdrop Opacity
         * @see https://tailwindcss.com/docs/backdrop-opacity
         */
        "backdrop-opacity": [{
          "backdrop-opacity": [Jt, gt, yt]
        }],
        /**
         * Backdrop Saturate
         * @see https://tailwindcss.com/docs/backdrop-saturate
         */
        "backdrop-saturate": [{
          "backdrop-saturate": [Jt, gt, yt]
        }],
        /**
         * Backdrop Sepia
         * @see https://tailwindcss.com/docs/backdrop-sepia
         */
        "backdrop-sepia": [{
          "backdrop-sepia": ["", Jt, gt, yt]
        }],
        // --------------
        // --- Tables ---
        // --------------
        /**
         * Border Collapse
         * @see https://tailwindcss.com/docs/border-collapse
         */
        "border-collapse": [{
          border: ["collapse", "separate"]
        }],
        /**
         * Border Spacing
         * @see https://tailwindcss.com/docs/border-spacing
         */
        "border-spacing": [{
          "border-spacing": B()
        }],
        /**
         * Border Spacing X
         * @see https://tailwindcss.com/docs/border-spacing
         */
        "border-spacing-x": [{
          "border-spacing-x": B()
        }],
        /**
         * Border Spacing Y
         * @see https://tailwindcss.com/docs/border-spacing
         */
        "border-spacing-y": [{
          "border-spacing-y": B()
        }],
        /**
         * Table Layout
         * @see https://tailwindcss.com/docs/table-layout
         */
        "table-layout": [{
          table: ["auto", "fixed"]
        }],
        /**
         * Caption Side
         * @see https://tailwindcss.com/docs/caption-side
         */
        caption: [{
          caption: ["top", "bottom"]
        }],
        // ---------------------------------
        // --- Transitions and Animation ---
        // ---------------------------------
        /**
         * Transition Property
         * @see https://tailwindcss.com/docs/transition-property
         */
        transition: [{
          transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", gt, yt]
        }],
        /**
         * Transition Behavior
         * @see https://tailwindcss.com/docs/transition-behavior
         */
        "transition-behavior": [{
          transition: ["normal", "discrete"]
        }],
        /**
         * Transition Duration
         * @see https://tailwindcss.com/docs/transition-duration
         */
        duration: [{
          duration: [Jt, "initial", gt, yt]
        }],
        /**
         * Transition Timing Function
         * @see https://tailwindcss.com/docs/transition-timing-function
         */
        ease: [{
          ease: ["linear", "initial", k, gt, yt]
        }],
        /**
         * Transition Delay
         * @see https://tailwindcss.com/docs/transition-delay
         */
        delay: [{
          delay: [Jt, gt, yt]
        }],
        /**
         * Animation
         * @see https://tailwindcss.com/docs/animation
         */
        animate: [{
          animate: ["none", D, gt, yt]
        }],
        // ------------------
        // --- Transforms ---
        // ------------------
        /**
         * Backface Visibility
         * @see https://tailwindcss.com/docs/backface-visibility
         */
        backface: [{
          backface: ["hidden", "visible"]
        }],
        /**
         * Perspective
         * @see https://tailwindcss.com/docs/perspective
         */
        perspective: [{
          perspective: [C, gt, yt]
        }],
        /**
         * Perspective Origin
         * @see https://tailwindcss.com/docs/perspective-origin
         */
        "perspective-origin": [{
          "perspective-origin": T()
        }],
        /**
         * Rotate
         * @see https://tailwindcss.com/docs/rotate
         */
        rotate: [{
          rotate: we()
        }],
        /**
         * Rotate X
         * @see https://tailwindcss.com/docs/rotate
         */
        "rotate-x": [{
          "rotate-x": we()
        }],
        /**
         * Rotate Y
         * @see https://tailwindcss.com/docs/rotate
         */
        "rotate-y": [{
          "rotate-y": we()
        }],
        /**
         * Rotate Z
         * @see https://tailwindcss.com/docs/rotate
         */
        "rotate-z": [{
          "rotate-z": we()
        }],
        /**
         * Scale
         * @see https://tailwindcss.com/docs/scale
         */
        scale: [{
          scale: Fe()
        }],
        /**
         * Scale X
         * @see https://tailwindcss.com/docs/scale
         */
        "scale-x": [{
          "scale-x": Fe()
        }],
        /**
         * Scale Y
         * @see https://tailwindcss.com/docs/scale
         */
        "scale-y": [{
          "scale-y": Fe()
        }],
        /**
         * Scale Z
         * @see https://tailwindcss.com/docs/scale
         */
        "scale-z": [{
          "scale-z": Fe()
        }],
        /**
         * Scale 3D
         * @see https://tailwindcss.com/docs/scale
         */
        "scale-3d": ["scale-3d"],
        /**
         * Skew
         * @see https://tailwindcss.com/docs/skew
         */
        skew: [{
          skew: Ye()
        }],
        /**
         * Skew X
         * @see https://tailwindcss.com/docs/skew
         */
        "skew-x": [{
          "skew-x": Ye()
        }],
        /**
         * Skew Y
         * @see https://tailwindcss.com/docs/skew
         */
        "skew-y": [{
          "skew-y": Ye()
        }],
        /**
         * Transform
         * @see https://tailwindcss.com/docs/transform
         */
        transform: [{
          transform: [gt, yt, "", "none", "gpu", "cpu"]
        }],
        /**
         * Transform Origin
         * @see https://tailwindcss.com/docs/transform-origin
         */
        "transform-origin": [{
          origin: T()
        }],
        /**
         * Transform Style
         * @see https://tailwindcss.com/docs/transform-style
         */
        "transform-style": [{
          transform: ["3d", "flat"]
        }],
        /**
         * Translate
         * @see https://tailwindcss.com/docs/translate
         */
        translate: [{
          translate: de()
        }],
        /**
         * Translate X
         * @see https://tailwindcss.com/docs/translate
         */
        "translate-x": [{
          "translate-x": de()
        }],
        /**
         * Translate Y
         * @see https://tailwindcss.com/docs/translate
         */
        "translate-y": [{
          "translate-y": de()
        }],
        /**
         * Translate Z
         * @see https://tailwindcss.com/docs/translate
         */
        "translate-z": [{
          "translate-z": de()
        }],
        /**
         * Translate None
         * @see https://tailwindcss.com/docs/translate
         */
        "translate-none": ["translate-none"],
        // ---------------------
        // --- Interactivity ---
        // ---------------------
        /**
         * Accent Color
         * @see https://tailwindcss.com/docs/accent-color
         */
        accent: [{
          accent: X()
        }],
        /**
         * Appearance
         * @see https://tailwindcss.com/docs/appearance
         */
        appearance: [{
          appearance: ["none", "auto"]
        }],
        /**
         * Caret Color
         * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
         */
        "caret-color": [{
          caret: X()
        }],
        /**
         * Color Scheme
         * @see https://tailwindcss.com/docs/color-scheme
         */
        "color-scheme": [{
          scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
        }],
        /**
         * Cursor
         * @see https://tailwindcss.com/docs/cursor
         */
        cursor: [{
          cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", gt, yt]
        }],
        /**
         * Field Sizing
         * @see https://tailwindcss.com/docs/field-sizing
         */
        "field-sizing": [{
          "field-sizing": ["fixed", "content"]
        }],
        /**
         * Pointer Events
         * @see https://tailwindcss.com/docs/pointer-events
         */
        "pointer-events": [{
          "pointer-events": ["auto", "none"]
        }],
        /**
         * Resize
         * @see https://tailwindcss.com/docs/resize
         */
        resize: [{
          resize: ["none", "", "y", "x"]
        }],
        /**
         * Scroll Behavior
         * @see https://tailwindcss.com/docs/scroll-behavior
         */
        "scroll-behavior": [{
          scroll: ["auto", "smooth"]
        }],
        /**
         * Scroll Margin
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-m": [{
          "scroll-m": B()
        }],
        /**
         * Scroll Margin X
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mx": [{
          "scroll-mx": B()
        }],
        /**
         * Scroll Margin Y
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-my": [{
          "scroll-my": B()
        }],
        /**
         * Scroll Margin Start
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-ms": [{
          "scroll-ms": B()
        }],
        /**
         * Scroll Margin End
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-me": [{
          "scroll-me": B()
        }],
        /**
         * Scroll Margin Top
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mt": [{
          "scroll-mt": B()
        }],
        /**
         * Scroll Margin Right
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mr": [{
          "scroll-mr": B()
        }],
        /**
         * Scroll Margin Bottom
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mb": [{
          "scroll-mb": B()
        }],
        /**
         * Scroll Margin Left
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-ml": [{
          "scroll-ml": B()
        }],
        /**
         * Scroll Padding
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-p": [{
          "scroll-p": B()
        }],
        /**
         * Scroll Padding X
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-px": [{
          "scroll-px": B()
        }],
        /**
         * Scroll Padding Y
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-py": [{
          "scroll-py": B()
        }],
        /**
         * Scroll Padding Start
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-ps": [{
          "scroll-ps": B()
        }],
        /**
         * Scroll Padding End
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pe": [{
          "scroll-pe": B()
        }],
        /**
         * Scroll Padding Top
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pt": [{
          "scroll-pt": B()
        }],
        /**
         * Scroll Padding Right
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pr": [{
          "scroll-pr": B()
        }],
        /**
         * Scroll Padding Bottom
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pb": [{
          "scroll-pb": B()
        }],
        /**
         * Scroll Padding Left
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pl": [{
          "scroll-pl": B()
        }],
        /**
         * Scroll Snap Align
         * @see https://tailwindcss.com/docs/scroll-snap-align
         */
        "snap-align": [{
          snap: ["start", "end", "center", "align-none"]
        }],
        /**
         * Scroll Snap Stop
         * @see https://tailwindcss.com/docs/scroll-snap-stop
         */
        "snap-stop": [{
          snap: ["normal", "always"]
        }],
        /**
         * Scroll Snap Type
         * @see https://tailwindcss.com/docs/scroll-snap-type
         */
        "snap-type": [{
          snap: ["none", "x", "y", "both"]
        }],
        /**
         * Scroll Snap Type Strictness
         * @see https://tailwindcss.com/docs/scroll-snap-type
         */
        "snap-strictness": [{
          snap: ["mandatory", "proximity"]
        }],
        /**
         * Touch Action
         * @see https://tailwindcss.com/docs/touch-action
         */
        touch: [{
          touch: ["auto", "none", "manipulation"]
        }],
        /**
         * Touch Action X
         * @see https://tailwindcss.com/docs/touch-action
         */
        "touch-x": [{
          "touch-pan": ["x", "left", "right"]
        }],
        /**
         * Touch Action Y
         * @see https://tailwindcss.com/docs/touch-action
         */
        "touch-y": [{
          "touch-pan": ["y", "up", "down"]
        }],
        /**
         * Touch Action Pinch Zoom
         * @see https://tailwindcss.com/docs/touch-action
         */
        "touch-pz": ["touch-pinch-zoom"],
        /**
         * User Select
         * @see https://tailwindcss.com/docs/user-select
         */
        select: [{
          select: ["none", "text", "all", "auto"]
        }],
        /**
         * Will Change
         * @see https://tailwindcss.com/docs/will-change
         */
        "will-change": [{
          "will-change": ["auto", "scroll", "contents", "transform", gt, yt]
        }],
        // -----------
        // --- SVG ---
        // -----------
        /**
         * Fill
         * @see https://tailwindcss.com/docs/fill
         */
        fill: [{
          fill: ["none", ...X()]
        }],
        /**
         * Stroke Width
         * @see https://tailwindcss.com/docs/stroke-width
         */
        "stroke-w": [{
          stroke: [Jt, mg, mp, ZA]
        }],
        /**
         * Stroke
         * @see https://tailwindcss.com/docs/stroke
         */
        stroke: [{
          stroke: ["none", ...X()]
        }],
        // ---------------------
        // --- Accessibility ---
        // ---------------------
        /**
         * Forced Color Adjust
         * @see https://tailwindcss.com/docs/forced-color-adjust
         */
        "forced-color-adjust": [{
          "forced-color-adjust": ["auto", "none"]
        }]
      },
      conflictingClassGroups: {
        overflow: ["overflow-x", "overflow-y"],
        overscroll: ["overscroll-x", "overscroll-y"],
        inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
        "inset-x": ["right", "left"],
        "inset-y": ["top", "bottom"],
        flex: ["basis", "grow", "shrink"],
        gap: ["gap-x", "gap-y"],
        p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
        px: ["pr", "pl"],
        py: ["pt", "pb"],
        m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
        mx: ["mr", "ml"],
        my: ["mt", "mb"],
        size: ["w", "h"],
        "font-size": ["leading"],
        "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
        "fvn-ordinal": ["fvn-normal"],
        "fvn-slashed-zero": ["fvn-normal"],
        "fvn-figure": ["fvn-normal"],
        "fvn-spacing": ["fvn-normal"],
        "fvn-fraction": ["fvn-normal"],
        "line-clamp": ["display", "overflow"],
        rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
        "rounded-s": ["rounded-ss", "rounded-es"],
        "rounded-e": ["rounded-se", "rounded-ee"],
        "rounded-t": ["rounded-tl", "rounded-tr"],
        "rounded-r": ["rounded-tr", "rounded-br"],
        "rounded-b": ["rounded-br", "rounded-bl"],
        "rounded-l": ["rounded-tl", "rounded-bl"],
        "border-spacing": ["border-spacing-x", "border-spacing-y"],
        "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
        "border-w-x": ["border-w-r", "border-w-l"],
        "border-w-y": ["border-w-t", "border-w-b"],
        "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
        "border-color-x": ["border-color-r", "border-color-l"],
        "border-color-y": ["border-color-t", "border-color-b"],
        translate: ["translate-x", "translate-y", "translate-none"],
        "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
        "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
        "scroll-mx": ["scroll-mr", "scroll-ml"],
        "scroll-my": ["scroll-mt", "scroll-mb"],
        "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
        "scroll-px": ["scroll-pr", "scroll-pl"],
        "scroll-py": ["scroll-pt", "scroll-pb"],
        touch: ["touch-x", "touch-y", "touch-pz"],
        "touch-x": ["touch"],
        "touch-y": ["touch"],
        "touch-pz": ["touch"]
      },
      conflictingClassGroupModifiers: {
        "font-size": ["leading"]
      },
      orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
    };
  }, Z9 = /* @__PURE__ */ Eoe(zoe);
  function vs(...e) {
    return Z9(hr(e));
  }
  function qoe({ className: e, ...t }) {
    return /* @__PURE__ */ me.jsx(
      "div",
      {
        "data-slot": "card",
        className: vs("bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm", e),
        ...t
      }
    );
  }
  function Uoe({ className: e, ...t }) {
    return /* @__PURE__ */ me.jsx(
      "div",
      {
        "data-slot": "card-header",
        className: vs(
          "@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6",
          e
        ),
        ...t
      }
    );
  }
  function Hoe({ className: e, ...t }) {
    return /* @__PURE__ */ me.jsx("div", { "data-slot": "card-title", className: vs("leading-none font-semibold", e), ...t });
  }
  function Voe({ className: e, ...t }) {
    return /* @__PURE__ */ me.jsx("div", { "data-slot": "card-description", className: vs("text-muted-foreground text-sm", e), ...t });
  }
  function Woe({ className: e, ...t }) {
    return /* @__PURE__ */ me.jsx("div", { "data-slot": "card-content", className: vs("px-6", e), ...t });
  }
  const FN = ({ title: e, description: t, children: r }) => /* @__PURE__ */ me.jsxs(qoe, { className: "rounded-2xl border-neutral-300 p-6 gap-6 shadow-none", children: [
    /* @__PURE__ */ me.jsxs(Uoe, { className: "px-0 gap-1", children: [
      /* @__PURE__ */ me.jsx(Hoe, { className: "text-2xl font-normal text-neutral-900", "data-testid": "visits-card-title", children: e }),
      /* @__PURE__ */ me.jsx(Voe, { className: "text-base text-neutral-700", "data-testid": "visits-card-description", children: t })
    ] }),
    /* @__PURE__ */ me.jsx(Woe, { className: "px-0 flex flex-1 flex-column items-end", children: r })
  ] });
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const Yoe = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Goe = (e) => e.replace(
    /^([A-Z])|[\s-_]+(\w)/g,
    (t, r, n) => n ? n.toUpperCase() : r.toLowerCase()
  ), W3 = (e) => {
    const t = Goe(e);
    return t.charAt(0).toUpperCase() + t.slice(1);
  }, J9 = (...e) => e.filter((t, r, n) => !!t && t.trim() !== "" && n.indexOf(t) === r).join(" ").trim(), Qoe = (e) => {
    for (const t in e)
      if (t.startsWith("aria-") || t === "role" || t === "title")
        return !0;
  };
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  var Koe = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  };
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const Xoe = ee.forwardRef(
    ({
      color: e = "currentColor",
      size: t = 24,
      strokeWidth: r = 2,
      absoluteStrokeWidth: n,
      className: i = "",
      children: u,
      iconNode: s,
      ...c
    }, p) => ee.createElement(
      "svg",
      {
        ref: p,
        ...Koe,
        width: t,
        height: t,
        stroke: e,
        strokeWidth: n ? Number(r) * 24 / Number(t) : r,
        className: J9("lucide", i),
        ...!u && !Qoe(c) && { "aria-hidden": "true" },
        ...c
      },
      [
        ...s.map(([h, v]) => ee.createElement(h, v)),
        ...Array.isArray(u) ? u : [u]
      ]
    )
  );
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const Bx = (e, t) => {
    const r = ee.forwardRef(
      ({ className: n, ...i }, u) => ee.createElement(Xoe, {
        ref: u,
        iconNode: t,
        className: J9(
          `lucide-${Yoe(W3(e))}`,
          `lucide-${e}`,
          n
        ),
        ...i
      })
    );
    return r.displayName = W3(e), r;
  };
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const Zoe = [
    ["path", { d: "M12 5v14", key: "s699le" }],
    ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
  ], Joe = Bx("arrow-down", Zoe);
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const eue = [
    ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
    ["path", { d: "M12 19V5", key: "x0mq9r" }]
  ], tue = Bx("arrow-up", eue);
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const rue = [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
    ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
  ], nue = Bx("circle-alert", rue);
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const iue = [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 16v-4", key: "1dtifu" }],
    ["path", { d: "M12 8h.01", key: "e9boi3" }]
  ], aue = Bx("info", iue);
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const oue = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], uue = Bx("loader-circle", oue);
  function sue(...e) {
    return Z9(hr(e));
  }
  const lue = (e) => e.length === 0 ? "" : e.length === 1 ? e[0] : e.length === 2 ? e.join(" and ") : `${e.slice(0, -1).join(", ")} and ${e.at(-1)}`, cue = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday"
  };
  function fue(e) {
    return e.length > 0;
  }
  const due = (e) => e.slice().sort((t, r) => {
    const n = (i) => i === 0 ? 7 : i;
    return n(t.dayOfWeekNumber) - n(r.dayOfWeekNumber);
  }), pue = (e) => due(e).map(({ dayOfWeekNumber: r, visits: n }) => ({
    day: cue[r] ?? "",
    dayOfWeekNumber: r,
    visits: n
  }));
  function hue(e) {
    switch (e) {
      case "development":
        return "https://vlzugba46h.execute-api.ap-southeast-2.amazonaws.com/";
      case "uat":
        return "https://lb5bv643x5.execute-api.ap-southeast-2.amazonaws.com/";
      case "production":
        return "";
      // pending production endpoint to be available
      default:
        return "https://lb5bv643x5.execute-api.ap-southeast-2.amazonaws.com/";
    }
  }
  const vue = (e) => e === 0 || e === null ? {
    icon: null,
    textClass: "text-neutral-500",
    percentage: 0
  } : e > 0 ? {
    icon: /* @__PURE__ */ me.jsx(tue, { className: "w-5 h-5" }),
    textClass: "text-success-600",
    percentage: e
  } : {
    icon: /* @__PURE__ */ me.jsx(Joe, { className: "w-5 h-5" }),
    textClass: "text-destructive-600",
    percentage: Math.abs(e)
  }, mue = ({ percentChange: e }) => {
    const { icon: t, textClass: r, percentage: n } = vue(e);
    return /* @__PURE__ */ me.jsxs("div", { className: sue("flex flex-row items-end justify-start", r), children: [
      t,
      /* @__PURE__ */ me.jsxs("span", { className: "text-sm font-bold", "data-testid": "visits-count-percentage", children: [
        n,
        "% YoY"
      ] })
    ] });
  }, Y3 = ({ title: e, description: t, visitsCount: r, percentChangeYoY: n }) => /* @__PURE__ */ me.jsx(FN, { title: e, description: t, children: /* @__PURE__ */ me.jsxs("div", { className: "flex flex-row items-end justify-start gap-2", children: [
    /* @__PURE__ */ me.jsxs("span", { className: "text-4xl font-normal text-neutral-700", "data-testid": "visits-count-text", children: [
      r.toLocaleString(),
      " visits"
    ] }),
    /* @__PURE__ */ me.jsx(mue, { percentChange: n })
  ] }) });
  function aa(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
    return function(i) {
      if (e == null || e(i), r === !1 || !i.defaultPrevented)
        return t == null ? void 0 : t(i);
    };
  }
  function G3(e, t) {
    if (typeof e == "function")
      return e(t);
    e != null && (e.current = t);
  }
  function eH(...e) {
    return (t) => {
      let r = !1;
      const n = e.map((i) => {
        const u = G3(i, t);
        return !r && typeof u == "function" && (r = !0), u;
      });
      if (r)
        return () => {
          for (let i = 0; i < n.length; i++) {
            const u = n[i];
            typeof u == "function" ? u() : G3(e[i], null);
          }
        };
    };
  }
  function Ou(...e) {
    return ee.useCallback(eH(...e), e);
  }
  function U0(e, t = []) {
    let r = [];
    function n(u, s) {
      const c = ee.createContext(s), p = r.length;
      r = [...r, s];
      const h = (y) => {
        var k;
        const { scope: x, children: w, ...E } = y, C = ((k = x == null ? void 0 : x[e]) == null ? void 0 : k[p]) || c, S = ee.useMemo(() => E, Object.values(E));
        return /* @__PURE__ */ me.jsx(C.Provider, { value: S, children: w });
      };
      h.displayName = u + "Provider";
      function v(y, x) {
        var C;
        const w = ((C = x == null ? void 0 : x[e]) == null ? void 0 : C[p]) || c, E = ee.useContext(w);
        if (E) return E;
        if (s !== void 0) return s;
        throw new Error(`\`${y}\` must be used within \`${u}\``);
      }
      return [h, v];
    }
    const i = () => {
      const u = r.map((s) => ee.createContext(s));
      return function(c) {
        const p = (c == null ? void 0 : c[e]) || u;
        return ee.useMemo(
          () => ({ [`__scope${e}`]: { ...c, [e]: p } }),
          [c, p]
        );
      };
    };
    return i.scopeName = e, [n, yue(i, ...t)];
  }
  function yue(...e) {
    const t = e[0];
    if (e.length === 1) return t;
    const r = () => {
      const n = e.map((i) => ({
        useScope: i(),
        scopeName: i.scopeName
      }));
      return function(u) {
        const s = n.reduce((c, { useScope: p, scopeName: h }) => {
          const y = p(u)[`__scope${h}`];
          return { ...c, ...y };
        }, {});
        return ee.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
      };
    };
    return r.scopeName = t.scopeName, r;
  }
  var IN = hU();
  const gue = /* @__PURE__ */ Zr(IN);
  // @__NO_SIDE_EFFECTS__
  function PP(e) {
    const t = /* @__PURE__ */ xue(e), r = ee.forwardRef((n, i) => {
      const { children: u, ...s } = n, c = ee.Children.toArray(u), p = c.find(wue);
      if (p) {
        const h = p.props.children, v = c.map((y) => y === p ? ee.Children.count(h) > 1 ? ee.Children.only(null) : ee.isValidElement(h) ? h.props.children : null : y);
        return /* @__PURE__ */ me.jsx(t, { ...s, ref: i, children: ee.isValidElement(h) ? ee.cloneElement(h, void 0, v) : null });
      }
      return /* @__PURE__ */ me.jsx(t, { ...s, ref: i, children: u });
    });
    return r.displayName = `${e}.Slot`, r;
  }
  // @__NO_SIDE_EFFECTS__
  function xue(e) {
    const t = ee.forwardRef((r, n) => {
      const { children: i, ...u } = r;
      if (ee.isValidElement(i)) {
        const s = Sue(i), c = Eue(u, i.props);
        return i.type !== ee.Fragment && (c.ref = n ? eH(n, s) : s), ee.cloneElement(i, c);
      }
      return ee.Children.count(i) > 1 ? ee.Children.only(null) : null;
    });
    return t.displayName = `${e}.SlotClone`, t;
  }
  var tH = Symbol("radix.slottable");
  // @__NO_SIDE_EFFECTS__
  function bue(e) {
    const t = ({ children: r }) => /* @__PURE__ */ me.jsx(me.Fragment, { children: r });
    return t.displayName = `${e}.Slottable`, t.__radixId = tH, t;
  }
  function wue(e) {
    return ee.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === tH;
  }
  function Eue(e, t) {
    const r = { ...t };
    for (const n in t) {
      const i = e[n], u = t[n];
      /^on[A-Z]/.test(n) ? i && u ? r[n] = (...c) => {
        const p = u(...c);
        return i(...c), p;
      } : i && (r[n] = i) : n === "style" ? r[n] = { ...i, ...u } : n === "className" && (r[n] = [i, u].filter(Boolean).join(" "));
    }
    return { ...e, ...r };
  }
  function Sue(e) {
    var n, i;
    let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
    return r ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
  }
  var _ue = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
  ], Ga = _ue.reduce((e, t) => {
    const r = /* @__PURE__ */ PP(`Primitive.${t}`), n = ee.forwardRef((i, u) => {
      const { asChild: s, ...c } = i, p = s ? r : t;
      return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ me.jsx(p, { ...c, ref: u });
    });
    return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
  }, {});
  function Cue(e, t) {
    e && IN.flushSync(() => e.dispatchEvent(t));
  }
  function Lx(e) {
    const t = ee.useRef(e);
    return ee.useEffect(() => {
      t.current = e;
    }), ee.useMemo(() => (...r) => {
      var n;
      return (n = t.current) == null ? void 0 : n.call(t, ...r);
    }, []);
  }
  function Oue(e, t = globalThis == null ? void 0 : globalThis.document) {
    const r = Lx(e);
    ee.useEffect(() => {
      const n = (i) => {
        i.key === "Escape" && r(i);
      };
      return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
    }, [r, t]);
  }
  var Tue = "DismissableLayer", MP = "dismissableLayer.update", Aue = "dismissableLayer.pointerDownOutside", Due = "dismissableLayer.focusOutside", Q3, rH = ee.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
  }), nH = ee.forwardRef(
    (e, t) => {
      const {
        disableOutsidePointerEvents: r = !1,
        onEscapeKeyDown: n,
        onPointerDownOutside: i,
        onFocusOutside: u,
        onInteractOutside: s,
        onDismiss: c,
        ...p
      } = e, h = ee.useContext(rH), [v, y] = ee.useState(null), x = (v == null ? void 0 : v.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, w] = ee.useState({}), E = Ou(t, (F) => y(F)), C = Array.from(h.layers), [S] = [...h.layersWithOutsidePointerEventsDisabled].slice(-1), k = C.indexOf(S), D = v ? C.indexOf(v) : -1, A = h.layersWithOutsidePointerEventsDisabled.size > 0, R = D >= k, T = Pue((F) => {
        const B = F.target, V = [...h.branches].some((H) => H.contains(B));
        !R || V || (i == null || i(F), s == null || s(F), F.defaultPrevented || c == null || c());
      }, x), M = Mue((F) => {
        const B = F.target;
        [...h.branches].some((H) => H.contains(B)) || (u == null || u(F), s == null || s(F), F.defaultPrevented || c == null || c());
      }, x);
      return Oue((F) => {
        D === h.layers.size - 1 && (n == null || n(F), !F.defaultPrevented && c && (F.preventDefault(), c()));
      }, x), ee.useEffect(() => {
        if (v)
          return r && (h.layersWithOutsidePointerEventsDisabled.size === 0 && (Q3 = x.body.style.pointerEvents, x.body.style.pointerEvents = "none"), h.layersWithOutsidePointerEventsDisabled.add(v)), h.layers.add(v), K3(), () => {
            r && h.layersWithOutsidePointerEventsDisabled.size === 1 && (x.body.style.pointerEvents = Q3);
          };
      }, [v, x, r, h]), ee.useEffect(() => () => {
        v && (h.layers.delete(v), h.layersWithOutsidePointerEventsDisabled.delete(v), K3());
      }, [v, h]), ee.useEffect(() => {
        const F = () => w({});
        return document.addEventListener(MP, F), () => document.removeEventListener(MP, F);
      }, []), /* @__PURE__ */ me.jsx(
        Ga.div,
        {
          ...p,
          ref: E,
          style: {
            pointerEvents: A ? R ? "auto" : "none" : void 0,
            ...e.style
          },
          onFocusCapture: aa(e.onFocusCapture, M.onFocusCapture),
          onBlurCapture: aa(e.onBlurCapture, M.onBlurCapture),
          onPointerDownCapture: aa(
            e.onPointerDownCapture,
            T.onPointerDownCapture
          )
        }
      );
    }
  );
  nH.displayName = Tue;
  var kue = "DismissableLayerBranch", Rue = ee.forwardRef((e, t) => {
    const r = ee.useContext(rH), n = ee.useRef(null), i = Ou(t, n);
    return ee.useEffect(() => {
      const u = n.current;
      if (u)
        return r.branches.add(u), () => {
          r.branches.delete(u);
        };
    }, [r.branches]), /* @__PURE__ */ me.jsx(Ga.div, { ...e, ref: i });
  });
  Rue.displayName = kue;
  function Pue(e, t = globalThis == null ? void 0 : globalThis.document) {
    const r = Lx(e), n = ee.useRef(!1), i = ee.useRef(() => {
    });
    return ee.useEffect(() => {
      const u = (c) => {
        if (c.target && !n.current) {
          let p = function() {
            iH(
              Aue,
              r,
              h,
              { discrete: !0 }
            );
          };
          const h = { originalEvent: c };
          c.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = p, t.addEventListener("click", i.current, { once: !0 })) : p();
        } else
          t.removeEventListener("click", i.current);
        n.current = !1;
      }, s = window.setTimeout(() => {
        t.addEventListener("pointerdown", u);
      }, 0);
      return () => {
        window.clearTimeout(s), t.removeEventListener("pointerdown", u), t.removeEventListener("click", i.current);
      };
    }, [t, r]), {
      // ensures we check React component tree (not just DOM tree)
      onPointerDownCapture: () => n.current = !0
    };
  }
  function Mue(e, t = globalThis == null ? void 0 : globalThis.document) {
    const r = Lx(e), n = ee.useRef(!1);
    return ee.useEffect(() => {
      const i = (u) => {
        u.target && !n.current && iH(Due, r, { originalEvent: u }, {
          discrete: !1
        });
      };
      return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
    }, [t, r]), {
      onFocusCapture: () => n.current = !0,
      onBlurCapture: () => n.current = !1
    };
  }
  function K3() {
    const e = new CustomEvent(MP);
    document.dispatchEvent(e);
  }
  function iH(e, t, r, { discrete: n }) {
    const i = r.originalEvent.target, u = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
    t && i.addEventListener(e, t, { once: !0 }), n ? Cue(i, u) : i.dispatchEvent(u);
  }
  var Uf = globalThis != null && globalThis.document ? ee.useLayoutEffect : () => {
  }, Nue = dU[" useId ".trim().toString()] || (() => {
  }), jue = 0;
  function aH(e) {
    const [t, r] = ee.useState(Nue());
    return Uf(() => {
      r((n) => n ?? String(jue++));
    }, [e]), t ? `radix-${t}` : "";
  }
  const Fue = ["top", "right", "bottom", "left"], Hf = Math.min, zo = Math.max, yS = Math.round, rE = Math.floor, ul = (e) => ({
    x: e,
    y: e
  }), Iue = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
  }, Bue = {
    start: "end",
    end: "start"
  };
  function NP(e, t, r) {
    return zo(e, Hf(t, r));
  }
  function xc(e, t) {
    return typeof e == "function" ? e(t) : e;
  }
  function bc(e) {
    return e.split("-")[0];
  }
  function H0(e) {
    return e.split("-")[1];
  }
  function BN(e) {
    return e === "x" ? "y" : "x";
  }
  function LN(e) {
    return e === "y" ? "height" : "width";
  }
  function al(e) {
    return ["top", "bottom"].includes(bc(e)) ? "y" : "x";
  }
  function $N(e) {
    return BN(al(e));
  }
  function Lue(e, t, r) {
    r === void 0 && (r = !1);
    const n = H0(e), i = $N(e), u = LN(i);
    let s = i === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
    return t.reference[u] > t.floating[u] && (s = gS(s)), [s, gS(s)];
  }
  function $ue(e) {
    const t = gS(e);
    return [jP(e), t, jP(t)];
  }
  function jP(e) {
    return e.replace(/start|end/g, (t) => Bue[t]);
  }
  function zue(e, t, r) {
    const n = ["left", "right"], i = ["right", "left"], u = ["top", "bottom"], s = ["bottom", "top"];
    switch (e) {
      case "top":
      case "bottom":
        return r ? t ? i : n : t ? n : i;
      case "left":
      case "right":
        return t ? u : s;
      default:
        return [];
    }
  }
  function que(e, t, r, n) {
    const i = H0(e);
    let u = zue(bc(e), r === "start", n);
    return i && (u = u.map((s) => s + "-" + i), t && (u = u.concat(u.map(jP)))), u;
  }
  function gS(e) {
    return e.replace(/left|right|bottom|top/g, (t) => Iue[t]);
  }
  function Uue(e) {
    return {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...e
    };
  }
  function oH(e) {
    return typeof e != "number" ? Uue(e) : {
      top: e,
      right: e,
      bottom: e,
      left: e
    };
  }
  function xS(e) {
    const {
      x: t,
      y: r,
      width: n,
      height: i
    } = e;
    return {
      width: n,
      height: i,
      top: r,
      left: t,
      right: t + n,
      bottom: r + i,
      x: t,
      y: r
    };
  }
  function X3(e, t, r) {
    let {
      reference: n,
      floating: i
    } = e;
    const u = al(t), s = $N(t), c = LN(s), p = bc(t), h = u === "y", v = n.x + n.width / 2 - i.width / 2, y = n.y + n.height / 2 - i.height / 2, x = n[c] / 2 - i[c] / 2;
    let w;
    switch (p) {
      case "top":
        w = {
          x: v,
          y: n.y - i.height
        };
        break;
      case "bottom":
        w = {
          x: v,
          y: n.y + n.height
        };
        break;
      case "right":
        w = {
          x: n.x + n.width,
          y
        };
        break;
      case "left":
        w = {
          x: n.x - i.width,
          y
        };
        break;
      default:
        w = {
          x: n.x,
          y: n.y
        };
    }
    switch (H0(t)) {
      case "start":
        w[s] -= x * (r && h ? -1 : 1);
        break;
      case "end":
        w[s] += x * (r && h ? -1 : 1);
        break;
    }
    return w;
  }
  const Hue = async (e, t, r) => {
    const {
      placement: n = "bottom",
      strategy: i = "absolute",
      middleware: u = [],
      platform: s
    } = r, c = u.filter(Boolean), p = await (s.isRTL == null ? void 0 : s.isRTL(t));
    let h = await s.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }), {
      x: v,
      y
    } = X3(h, n, p), x = n, w = {}, E = 0;
    for (let C = 0; C < c.length; C++) {
      const {
        name: S,
        fn: k
      } = c[C], {
        x: D,
        y: A,
        data: R,
        reset: T
      } = await k({
        x: v,
        y,
        initialPlacement: n,
        placement: x,
        strategy: i,
        middlewareData: w,
        rects: h,
        platform: s,
        elements: {
          reference: e,
          floating: t
        }
      });
      v = D ?? v, y = A ?? y, w = {
        ...w,
        [S]: {
          ...w[S],
          ...R
        }
      }, T && E <= 50 && (E++, typeof T == "object" && (T.placement && (x = T.placement), T.rects && (h = T.rects === !0 ? await s.getElementRects({
        reference: e,
        floating: t,
        strategy: i
      }) : T.rects), {
        x: v,
        y
      } = X3(h, x, p)), C = -1);
    }
    return {
      x: v,
      y,
      placement: x,
      strategy: i,
      middlewareData: w
    };
  };
  async function Xg(e, t) {
    var r;
    t === void 0 && (t = {});
    const {
      x: n,
      y: i,
      platform: u,
      rects: s,
      elements: c,
      strategy: p
    } = e, {
      boundary: h = "clippingAncestors",
      rootBoundary: v = "viewport",
      elementContext: y = "floating",
      altBoundary: x = !1,
      padding: w = 0
    } = xc(t, e), E = oH(w), S = c[x ? y === "floating" ? "reference" : "floating" : y], k = xS(await u.getClippingRect({
      element: (r = await (u.isElement == null ? void 0 : u.isElement(S))) == null || r ? S : S.contextElement || await (u.getDocumentElement == null ? void 0 : u.getDocumentElement(c.floating)),
      boundary: h,
      rootBoundary: v,
      strategy: p
    })), D = y === "floating" ? {
      x: n,
      y: i,
      width: s.floating.width,
      height: s.floating.height
    } : s.reference, A = await (u.getOffsetParent == null ? void 0 : u.getOffsetParent(c.floating)), R = await (u.isElement == null ? void 0 : u.isElement(A)) ? await (u.getScale == null ? void 0 : u.getScale(A)) || {
      x: 1,
      y: 1
    } : {
      x: 1,
      y: 1
    }, T = xS(u.convertOffsetParentRelativeRectToViewportRelativeRect ? await u.convertOffsetParentRelativeRectToViewportRelativeRect({
      elements: c,
      rect: D,
      offsetParent: A,
      strategy: p
    }) : D);
    return {
      top: (k.top - T.top + E.top) / R.y,
      bottom: (T.bottom - k.bottom + E.bottom) / R.y,
      left: (k.left - T.left + E.left) / R.x,
      right: (T.right - k.right + E.right) / R.x
    };
  }
  const Vue = (e) => ({
    name: "arrow",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: i,
        rects: u,
        platform: s,
        elements: c,
        middlewareData: p
      } = t, {
        element: h,
        padding: v = 0
      } = xc(e, t) || {};
      if (h == null)
        return {};
      const y = oH(v), x = {
        x: r,
        y: n
      }, w = $N(i), E = LN(w), C = await s.getDimensions(h), S = w === "y", k = S ? "top" : "left", D = S ? "bottom" : "right", A = S ? "clientHeight" : "clientWidth", R = u.reference[E] + u.reference[w] - x[w] - u.floating[E], T = x[w] - u.reference[w], M = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(h));
      let F = M ? M[A] : 0;
      (!F || !await (s.isElement == null ? void 0 : s.isElement(M))) && (F = c.floating[A] || u.floating[E]);
      const B = R / 2 - T / 2, V = F / 2 - C[E] / 2 - 1, H = Hf(y[k], V), q = Hf(y[D], V), Q = H, W = F - C[E] - q, J = F / 2 - C[E] / 2 + B, ne = NP(Q, J, W), ie = !p.arrow && H0(i) != null && J !== ne && u.reference[E] / 2 - (J < Q ? H : q) - C[E] / 2 < 0, se = ie ? J < Q ? J - Q : J - W : 0;
      return {
        [w]: x[w] + se,
        data: {
          [w]: ne,
          centerOffset: J - ne - se,
          ...ie && {
            alignmentOffset: se
          }
        },
        reset: ie
      };
    }
  }), Wue = function(e) {
    return e === void 0 && (e = {}), {
      name: "flip",
      options: e,
      async fn(t) {
        var r, n;
        const {
          placement: i,
          middlewareData: u,
          rects: s,
          initialPlacement: c,
          platform: p,
          elements: h
        } = t, {
          mainAxis: v = !0,
          crossAxis: y = !0,
          fallbackPlacements: x,
          fallbackStrategy: w = "bestFit",
          fallbackAxisSideDirection: E = "none",
          flipAlignment: C = !0,
          ...S
        } = xc(e, t);
        if ((r = u.arrow) != null && r.alignmentOffset)
          return {};
        const k = bc(i), D = al(c), A = bc(c) === c, R = await (p.isRTL == null ? void 0 : p.isRTL(h.floating)), T = x || (A || !C ? [gS(c)] : $ue(c)), M = E !== "none";
        !x && M && T.push(...que(c, C, E, R));
        const F = [c, ...T], B = await Xg(t, S), V = [];
        let H = ((n = u.flip) == null ? void 0 : n.overflows) || [];
        if (v && V.push(B[k]), y) {
          const J = Lue(i, s, R);
          V.push(B[J[0]], B[J[1]]);
        }
        if (H = [...H, {
          placement: i,
          overflows: V
        }], !V.every((J) => J <= 0)) {
          var q, Q;
          const J = (((q = u.flip) == null ? void 0 : q.index) || 0) + 1, ne = F[J];
          if (ne && (!(y === "alignment" ? D !== al(ne) : !1) || // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          H.every((X) => X.overflows[0] > 0 && al(X.placement) === D)))
            return {
              data: {
                index: J,
                overflows: H
              },
              reset: {
                placement: ne
              }
            };
          let ie = (Q = H.filter((se) => se.overflows[0] <= 0).sort((se, X) => se.overflows[1] - X.overflows[1])[0]) == null ? void 0 : Q.placement;
          if (!ie)
            switch (w) {
              case "bestFit": {
                var W;
                const se = (W = H.filter((X) => {
                  if (M) {
                    const fe = al(X.placement);
                    return fe === D || // Create a bias to the `y` side axis due to horizontal
                    // reading directions favoring greater width.
                    fe === "y";
                  }
                  return !0;
                }).map((X) => [X.placement, X.overflows.filter((fe) => fe > 0).reduce((fe, Z) => fe + Z, 0)]).sort((X, fe) => X[1] - fe[1])[0]) == null ? void 0 : W[0];
                se && (ie = se);
                break;
              }
              case "initialPlacement":
                ie = c;
                break;
            }
          if (i !== ie)
            return {
              reset: {
                placement: ie
              }
            };
        }
        return {};
      }
    };
  };
  function Z3(e, t) {
    return {
      top: e.top - t.height,
      right: e.right - t.width,
      bottom: e.bottom - t.height,
      left: e.left - t.width
    };
  }
  function J3(e) {
    return Fue.some((t) => e[t] >= 0);
  }
  const Yue = function(e) {
    return e === void 0 && (e = {}), {
      name: "hide",
      options: e,
      async fn(t) {
        const {
          rects: r
        } = t, {
          strategy: n = "referenceHidden",
          ...i
        } = xc(e, t);
        switch (n) {
          case "referenceHidden": {
            const u = await Xg(t, {
              ...i,
              elementContext: "reference"
            }), s = Z3(u, r.reference);
            return {
              data: {
                referenceHiddenOffsets: s,
                referenceHidden: J3(s)
              }
            };
          }
          case "escaped": {
            const u = await Xg(t, {
              ...i,
              altBoundary: !0
            }), s = Z3(u, r.floating);
            return {
              data: {
                escapedOffsets: s,
                escaped: J3(s)
              }
            };
          }
          default:
            return {};
        }
      }
    };
  };
  async function Gue(e, t) {
    const {
      placement: r,
      platform: n,
      elements: i
    } = e, u = await (n.isRTL == null ? void 0 : n.isRTL(i.floating)), s = bc(r), c = H0(r), p = al(r) === "y", h = ["left", "top"].includes(s) ? -1 : 1, v = u && p ? -1 : 1, y = xc(t, e);
    let {
      mainAxis: x,
      crossAxis: w,
      alignmentAxis: E
    } = typeof y == "number" ? {
      mainAxis: y,
      crossAxis: 0,
      alignmentAxis: null
    } : {
      mainAxis: y.mainAxis || 0,
      crossAxis: y.crossAxis || 0,
      alignmentAxis: y.alignmentAxis
    };
    return c && typeof E == "number" && (w = c === "end" ? E * -1 : E), p ? {
      x: w * v,
      y: x * h
    } : {
      x: x * h,
      y: w * v
    };
  }
  const Que = function(e) {
    return e === void 0 && (e = 0), {
      name: "offset",
      options: e,
      async fn(t) {
        var r, n;
        const {
          x: i,
          y: u,
          placement: s,
          middlewareData: c
        } = t, p = await Gue(t, e);
        return s === ((r = c.offset) == null ? void 0 : r.placement) && (n = c.arrow) != null && n.alignmentOffset ? {} : {
          x: i + p.x,
          y: u + p.y,
          data: {
            ...p,
            placement: s
          }
        };
      }
    };
  }, Kue = function(e) {
    return e === void 0 && (e = {}), {
      name: "shift",
      options: e,
      async fn(t) {
        const {
          x: r,
          y: n,
          placement: i
        } = t, {
          mainAxis: u = !0,
          crossAxis: s = !1,
          limiter: c = {
            fn: (S) => {
              let {
                x: k,
                y: D
              } = S;
              return {
                x: k,
                y: D
              };
            }
          },
          ...p
        } = xc(e, t), h = {
          x: r,
          y: n
        }, v = await Xg(t, p), y = al(bc(i)), x = BN(y);
        let w = h[x], E = h[y];
        if (u) {
          const S = x === "y" ? "top" : "left", k = x === "y" ? "bottom" : "right", D = w + v[S], A = w - v[k];
          w = NP(D, w, A);
        }
        if (s) {
          const S = y === "y" ? "top" : "left", k = y === "y" ? "bottom" : "right", D = E + v[S], A = E - v[k];
          E = NP(D, E, A);
        }
        const C = c.fn({
          ...t,
          [x]: w,
          [y]: E
        });
        return {
          ...C,
          data: {
            x: C.x - r,
            y: C.y - n,
            enabled: {
              [x]: u,
              [y]: s
            }
          }
        };
      }
    };
  }, Xue = function(e) {
    return e === void 0 && (e = {}), {
      options: e,
      fn(t) {
        const {
          x: r,
          y: n,
          placement: i,
          rects: u,
          middlewareData: s
        } = t, {
          offset: c = 0,
          mainAxis: p = !0,
          crossAxis: h = !0
        } = xc(e, t), v = {
          x: r,
          y: n
        }, y = al(i), x = BN(y);
        let w = v[x], E = v[y];
        const C = xc(c, t), S = typeof C == "number" ? {
          mainAxis: C,
          crossAxis: 0
        } : {
          mainAxis: 0,
          crossAxis: 0,
          ...C
        };
        if (p) {
          const A = x === "y" ? "height" : "width", R = u.reference[x] - u.floating[A] + S.mainAxis, T = u.reference[x] + u.reference[A] - S.mainAxis;
          w < R ? w = R : w > T && (w = T);
        }
        if (h) {
          var k, D;
          const A = x === "y" ? "width" : "height", R = ["top", "left"].includes(bc(i)), T = u.reference[y] - u.floating[A] + (R && ((k = s.offset) == null ? void 0 : k[y]) || 0) + (R ? 0 : S.crossAxis), M = u.reference[y] + u.reference[A] + (R ? 0 : ((D = s.offset) == null ? void 0 : D[y]) || 0) - (R ? S.crossAxis : 0);
          E < T ? E = T : E > M && (E = M);
        }
        return {
          [x]: w,
          [y]: E
        };
      }
    };
  }, Zue = function(e) {
    return e === void 0 && (e = {}), {
      name: "size",
      options: e,
      async fn(t) {
        var r, n;
        const {
          placement: i,
          rects: u,
          platform: s,
          elements: c
        } = t, {
          apply: p = () => {
          },
          ...h
        } = xc(e, t), v = await Xg(t, h), y = bc(i), x = H0(i), w = al(i) === "y", {
          width: E,
          height: C
        } = u.floating;
        let S, k;
        y === "top" || y === "bottom" ? (S = y, k = x === (await (s.isRTL == null ? void 0 : s.isRTL(c.floating)) ? "start" : "end") ? "left" : "right") : (k = y, S = x === "end" ? "top" : "bottom");
        const D = C - v.top - v.bottom, A = E - v.left - v.right, R = Hf(C - v[S], D), T = Hf(E - v[k], A), M = !t.middlewareData.shift;
        let F = R, B = T;
        if ((r = t.middlewareData.shift) != null && r.enabled.x && (B = A), (n = t.middlewareData.shift) != null && n.enabled.y && (F = D), M && !x) {
          const H = zo(v.left, 0), q = zo(v.right, 0), Q = zo(v.top, 0), W = zo(v.bottom, 0);
          w ? B = E - 2 * (H !== 0 || q !== 0 ? H + q : zo(v.left, v.right)) : F = C - 2 * (Q !== 0 || W !== 0 ? Q + W : zo(v.top, v.bottom));
        }
        await p({
          ...t,
          availableWidth: B,
          availableHeight: F
        });
        const V = await s.getDimensions(c.floating);
        return E !== V.width || C !== V.height ? {
          reset: {
            rects: !0
          }
        } : {};
      }
    };
  };
  function P_() {
    return typeof window < "u";
  }
  function V0(e) {
    return uH(e) ? (e.nodeName || "").toLowerCase() : "#document";
  }
  function Uo(e) {
    var t;
    return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
  }
  function hl(e) {
    var t;
    return (t = (uH(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
  }
  function uH(e) {
    return P_() ? e instanceof Node || e instanceof Uo(e).Node : !1;
  }
  function ms(e) {
    return P_() ? e instanceof Element || e instanceof Uo(e).Element : !1;
  }
  function fl(e) {
    return P_() ? e instanceof HTMLElement || e instanceof Uo(e).HTMLElement : !1;
  }
  function eL(e) {
    return !P_() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Uo(e).ShadowRoot;
  }
  function $x(e) {
    const {
      overflow: t,
      overflowX: r,
      overflowY: n,
      display: i
    } = ys(e);
    return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(i);
  }
  function Jue(e) {
    return ["table", "td", "th"].includes(V0(e));
  }
  function M_(e) {
    return [":popover-open", ":modal"].some((t) => {
      try {
        return e.matches(t);
      } catch {
        return !1;
      }
    });
  }
  function zN(e) {
    const t = qN(), r = ms(e) ? ys(e) : e;
    return ["transform", "translate", "scale", "rotate", "perspective"].some((n) => r[n] ? r[n] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
  }
  function ese(e) {
    let t = Vf(e);
    for (; fl(t) && !l0(t); ) {
      if (zN(t))
        return t;
      if (M_(t))
        return null;
      t = Vf(t);
    }
    return null;
  }
  function qN() {
    return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
  }
  function l0(e) {
    return ["html", "body", "#document"].includes(V0(e));
  }
  function ys(e) {
    return Uo(e).getComputedStyle(e);
  }
  function N_(e) {
    return ms(e) ? {
      scrollLeft: e.scrollLeft,
      scrollTop: e.scrollTop
    } : {
      scrollLeft: e.scrollX,
      scrollTop: e.scrollY
    };
  }
  function Vf(e) {
    if (V0(e) === "html")
      return e;
    const t = (
      // Step into the shadow DOM of the parent of a slotted node.
      e.assignedSlot || // DOM Element detected.
      e.parentNode || // ShadowRoot detected.
      eL(e) && e.host || // Fallback.
      hl(e)
    );
    return eL(t) ? t.host : t;
  }
  function sH(e) {
    const t = Vf(e);
    return l0(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : fl(t) && $x(t) ? t : sH(t);
  }
  function Zg(e, t, r) {
    var n;
    t === void 0 && (t = []), r === void 0 && (r = !0);
    const i = sH(e), u = i === ((n = e.ownerDocument) == null ? void 0 : n.body), s = Uo(i);
    if (u) {
      const c = FP(s);
      return t.concat(s, s.visualViewport || [], $x(i) ? i : [], c && r ? Zg(c) : []);
    }
    return t.concat(i, Zg(i, [], r));
  }
  function FP(e) {
    return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
  }
  function lH(e) {
    const t = ys(e);
    let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
    const i = fl(e), u = i ? e.offsetWidth : r, s = i ? e.offsetHeight : n, c = yS(r) !== u || yS(n) !== s;
    return c && (r = u, n = s), {
      width: r,
      height: n,
      $: c
    };
  }
  function UN(e) {
    return ms(e) ? e : e.contextElement;
  }
  function Jv(e) {
    const t = UN(e);
    if (!fl(t))
      return ul(1);
    const r = t.getBoundingClientRect(), {
      width: n,
      height: i,
      $: u
    } = lH(t);
    let s = (u ? yS(r.width) : r.width) / n, c = (u ? yS(r.height) : r.height) / i;
    return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
      x: s,
      y: c
    };
  }
  const tse = /* @__PURE__ */ ul(0);
  function cH(e) {
    const t = Uo(e);
    return !qN() || !t.visualViewport ? tse : {
      x: t.visualViewport.offsetLeft,
      y: t.visualViewport.offsetTop
    };
  }
  function rse(e, t, r) {
    return t === void 0 && (t = !1), !r || t && r !== Uo(e) ? !1 : t;
  }
  function jp(e, t, r, n) {
    t === void 0 && (t = !1), r === void 0 && (r = !1);
    const i = e.getBoundingClientRect(), u = UN(e);
    let s = ul(1);
    t && (n ? ms(n) && (s = Jv(n)) : s = Jv(e));
    const c = rse(u, r, n) ? cH(u) : ul(0);
    let p = (i.left + c.x) / s.x, h = (i.top + c.y) / s.y, v = i.width / s.x, y = i.height / s.y;
    if (u) {
      const x = Uo(u), w = n && ms(n) ? Uo(n) : n;
      let E = x, C = FP(E);
      for (; C && n && w !== E; ) {
        const S = Jv(C), k = C.getBoundingClientRect(), D = ys(C), A = k.left + (C.clientLeft + parseFloat(D.paddingLeft)) * S.x, R = k.top + (C.clientTop + parseFloat(D.paddingTop)) * S.y;
        p *= S.x, h *= S.y, v *= S.x, y *= S.y, p += A, h += R, E = Uo(C), C = FP(E);
      }
    }
    return xS({
      width: v,
      height: y,
      x: p,
      y: h
    });
  }
  function HN(e, t) {
    const r = N_(e).scrollLeft;
    return t ? t.left + r : jp(hl(e)).left + r;
  }
  function fH(e, t, r) {
    r === void 0 && (r = !1);
    const n = e.getBoundingClientRect(), i = n.left + t.scrollLeft - (r ? 0 : (
      // RTL <body> scrollbar.
      HN(e, n)
    )), u = n.top + t.scrollTop;
    return {
      x: i,
      y: u
    };
  }
  function nse(e) {
    let {
      elements: t,
      rect: r,
      offsetParent: n,
      strategy: i
    } = e;
    const u = i === "fixed", s = hl(n), c = t ? M_(t.floating) : !1;
    if (n === s || c && u)
      return r;
    let p = {
      scrollLeft: 0,
      scrollTop: 0
    }, h = ul(1);
    const v = ul(0), y = fl(n);
    if ((y || !y && !u) && ((V0(n) !== "body" || $x(s)) && (p = N_(n)), fl(n))) {
      const w = jp(n);
      h = Jv(n), v.x = w.x + n.clientLeft, v.y = w.y + n.clientTop;
    }
    const x = s && !y && !u ? fH(s, p, !0) : ul(0);
    return {
      width: r.width * h.x,
      height: r.height * h.y,
      x: r.x * h.x - p.scrollLeft * h.x + v.x + x.x,
      y: r.y * h.y - p.scrollTop * h.y + v.y + x.y
    };
  }
  function ise(e) {
    return Array.from(e.getClientRects());
  }
  function ase(e) {
    const t = hl(e), r = N_(e), n = e.ownerDocument.body, i = zo(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), u = zo(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
    let s = -r.scrollLeft + HN(e);
    const c = -r.scrollTop;
    return ys(n).direction === "rtl" && (s += zo(t.clientWidth, n.clientWidth) - i), {
      width: i,
      height: u,
      x: s,
      y: c
    };
  }
  function ose(e, t) {
    const r = Uo(e), n = hl(e), i = r.visualViewport;
    let u = n.clientWidth, s = n.clientHeight, c = 0, p = 0;
    if (i) {
      u = i.width, s = i.height;
      const h = qN();
      (!h || h && t === "fixed") && (c = i.offsetLeft, p = i.offsetTop);
    }
    return {
      width: u,
      height: s,
      x: c,
      y: p
    };
  }
  function use(e, t) {
    const r = jp(e, !0, t === "fixed"), n = r.top + e.clientTop, i = r.left + e.clientLeft, u = fl(e) ? Jv(e) : ul(1), s = e.clientWidth * u.x, c = e.clientHeight * u.y, p = i * u.x, h = n * u.y;
    return {
      width: s,
      height: c,
      x: p,
      y: h
    };
  }
  function tL(e, t, r) {
    let n;
    if (t === "viewport")
      n = ose(e, r);
    else if (t === "document")
      n = ase(hl(e));
    else if (ms(t))
      n = use(t, r);
    else {
      const i = cH(e);
      n = {
        x: t.x - i.x,
        y: t.y - i.y,
        width: t.width,
        height: t.height
      };
    }
    return xS(n);
  }
  function dH(e, t) {
    const r = Vf(e);
    return r === t || !ms(r) || l0(r) ? !1 : ys(r).position === "fixed" || dH(r, t);
  }
  function sse(e, t) {
    const r = t.get(e);
    if (r)
      return r;
    let n = Zg(e, [], !1).filter((c) => ms(c) && V0(c) !== "body"), i = null;
    const u = ys(e).position === "fixed";
    let s = u ? Vf(e) : e;
    for (; ms(s) && !l0(s); ) {
      const c = ys(s), p = zN(s);
      !p && c.position === "fixed" && (i = null), (u ? !p && !i : !p && c.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || $x(s) && !p && dH(e, s)) ? n = n.filter((v) => v !== s) : i = c, s = Vf(s);
    }
    return t.set(e, n), n;
  }
  function lse(e) {
    let {
      element: t,
      boundary: r,
      rootBoundary: n,
      strategy: i
    } = e;
    const s = [...r === "clippingAncestors" ? M_(t) ? [] : sse(t, this._c) : [].concat(r), n], c = s[0], p = s.reduce((h, v) => {
      const y = tL(t, v, i);
      return h.top = zo(y.top, h.top), h.right = Hf(y.right, h.right), h.bottom = Hf(y.bottom, h.bottom), h.left = zo(y.left, h.left), h;
    }, tL(t, c, i));
    return {
      width: p.right - p.left,
      height: p.bottom - p.top,
      x: p.left,
      y: p.top
    };
  }
  function cse(e) {
    const {
      width: t,
      height: r
    } = lH(e);
    return {
      width: t,
      height: r
    };
  }
  function fse(e, t, r) {
    const n = fl(t), i = hl(t), u = r === "fixed", s = jp(e, !0, u, t);
    let c = {
      scrollLeft: 0,
      scrollTop: 0
    };
    const p = ul(0);
    function h() {
      p.x = HN(i);
    }
    if (n || !n && !u)
      if ((V0(t) !== "body" || $x(i)) && (c = N_(t)), n) {
        const w = jp(t, !0, u, t);
        p.x = w.x + t.clientLeft, p.y = w.y + t.clientTop;
      } else i && h();
    u && !n && i && h();
    const v = i && !n && !u ? fH(i, c) : ul(0), y = s.left + c.scrollLeft - p.x - v.x, x = s.top + c.scrollTop - p.y - v.y;
    return {
      x: y,
      y: x,
      width: s.width,
      height: s.height
    };
  }
  function JA(e) {
    return ys(e).position === "static";
  }
  function rL(e, t) {
    if (!fl(e) || ys(e).position === "fixed")
      return null;
    if (t)
      return t(e);
    let r = e.offsetParent;
    return hl(e) === r && (r = r.ownerDocument.body), r;
  }
  function pH(e, t) {
    const r = Uo(e);
    if (M_(e))
      return r;
    if (!fl(e)) {
      let i = Vf(e);
      for (; i && !l0(i); ) {
        if (ms(i) && !JA(i))
          return i;
        i = Vf(i);
      }
      return r;
    }
    let n = rL(e, t);
    for (; n && Jue(n) && JA(n); )
      n = rL(n, t);
    return n && l0(n) && JA(n) && !zN(n) ? r : n || ese(e) || r;
  }
  const dse = async function(e) {
    const t = this.getOffsetParent || pH, r = this.getDimensions, n = await r(e.floating);
    return {
      reference: fse(e.reference, await t(e.floating), e.strategy),
      floating: {
        x: 0,
        y: 0,
        width: n.width,
        height: n.height
      }
    };
  };
  function pse(e) {
    return ys(e).direction === "rtl";
  }
  const hse = {
    convertOffsetParentRelativeRectToViewportRelativeRect: nse,
    getDocumentElement: hl,
    getClippingRect: lse,
    getOffsetParent: pH,
    getElementRects: dse,
    getClientRects: ise,
    getDimensions: cse,
    getScale: Jv,
    isElement: ms,
    isRTL: pse
  };
  function hH(e, t) {
    return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
  }
  function vse(e, t) {
    let r = null, n;
    const i = hl(e);
    function u() {
      var c;
      clearTimeout(n), (c = r) == null || c.disconnect(), r = null;
    }
    function s(c, p) {
      c === void 0 && (c = !1), p === void 0 && (p = 1), u();
      const h = e.getBoundingClientRect(), {
        left: v,
        top: y,
        width: x,
        height: w
      } = h;
      if (c || t(), !x || !w)
        return;
      const E = rE(y), C = rE(i.clientWidth - (v + x)), S = rE(i.clientHeight - (y + w)), k = rE(v), A = {
        rootMargin: -E + "px " + -C + "px " + -S + "px " + -k + "px",
        threshold: zo(0, Hf(1, p)) || 1
      };
      let R = !0;
      function T(M) {
        const F = M[0].intersectionRatio;
        if (F !== p) {
          if (!R)
            return s();
          F ? s(!1, F) : n = setTimeout(() => {
            s(!1, 1e-7);
          }, 1e3);
        }
        F === 1 && !hH(h, e.getBoundingClientRect()) && s(), R = !1;
      }
      try {
        r = new IntersectionObserver(T, {
          ...A,
          // Handle <iframe>s
          root: i.ownerDocument
        });
      } catch {
        r = new IntersectionObserver(T, A);
      }
      r.observe(e);
    }
    return s(!0), u;
  }
  function mse(e, t, r, n) {
    n === void 0 && (n = {});
    const {
      ancestorScroll: i = !0,
      ancestorResize: u = !0,
      elementResize: s = typeof ResizeObserver == "function",
      layoutShift: c = typeof IntersectionObserver == "function",
      animationFrame: p = !1
    } = n, h = UN(e), v = i || u ? [...h ? Zg(h) : [], ...Zg(t)] : [];
    v.forEach((k) => {
      i && k.addEventListener("scroll", r, {
        passive: !0
      }), u && k.addEventListener("resize", r);
    });
    const y = h && c ? vse(h, r) : null;
    let x = -1, w = null;
    s && (w = new ResizeObserver((k) => {
      let [D] = k;
      D && D.target === h && w && (w.unobserve(t), cancelAnimationFrame(x), x = requestAnimationFrame(() => {
        var A;
        (A = w) == null || A.observe(t);
      })), r();
    }), h && !p && w.observe(h), w.observe(t));
    let E, C = p ? jp(e) : null;
    p && S();
    function S() {
      const k = jp(e);
      C && !hH(C, k) && r(), C = k, E = requestAnimationFrame(S);
    }
    return r(), () => {
      var k;
      v.forEach((D) => {
        i && D.removeEventListener("scroll", r), u && D.removeEventListener("resize", r);
      }), y == null || y(), (k = w) == null || k.disconnect(), w = null, p && cancelAnimationFrame(E);
    };
  }
  const yse = Que, gse = Kue, xse = Wue, bse = Zue, wse = Yue, nL = Vue, Ese = Xue, Sse = (e, t, r) => {
    const n = /* @__PURE__ */ new Map(), i = {
      platform: hse,
      ...r
    }, u = {
      ...i.platform,
      _c: n
    };
    return Hue(e, t, {
      ...i,
      platform: u
    });
  };
  var _se = typeof document < "u", Cse = function() {
  }, fS = _se ? ee.useLayoutEffect : Cse;
  function bS(e, t) {
    if (e === t)
      return !0;
    if (typeof e != typeof t)
      return !1;
    if (typeof e == "function" && e.toString() === t.toString())
      return !0;
    let r, n, i;
    if (e && t && typeof e == "object") {
      if (Array.isArray(e)) {
        if (r = e.length, r !== t.length) return !1;
        for (n = r; n-- !== 0; )
          if (!bS(e[n], t[n]))
            return !1;
        return !0;
      }
      if (i = Object.keys(e), r = i.length, r !== Object.keys(t).length)
        return !1;
      for (n = r; n-- !== 0; )
        if (!{}.hasOwnProperty.call(t, i[n]))
          return !1;
      for (n = r; n-- !== 0; ) {
        const u = i[n];
        if (!(u === "_owner" && e.$$typeof) && !bS(e[u], t[u]))
          return !1;
      }
      return !0;
    }
    return e !== e && t !== t;
  }
  function vH(e) {
    return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
  }
  function iL(e, t) {
    const r = vH(e);
    return Math.round(t * r) / r;
  }
  function eD(e) {
    const t = ee.useRef(e);
    return fS(() => {
      t.current = e;
    }), t;
  }
  function Ose(e) {
    e === void 0 && (e = {});
    const {
      placement: t = "bottom",
      strategy: r = "absolute",
      middleware: n = [],
      platform: i,
      elements: {
        reference: u,
        floating: s
      } = {},
      transform: c = !0,
      whileElementsMounted: p,
      open: h
    } = e, [v, y] = ee.useState({
      x: 0,
      y: 0,
      strategy: r,
      placement: t,
      middlewareData: {},
      isPositioned: !1
    }), [x, w] = ee.useState(n);
    bS(x, n) || w(n);
    const [E, C] = ee.useState(null), [S, k] = ee.useState(null), D = ee.useCallback((X) => {
      X !== M.current && (M.current = X, C(X));
    }, []), A = ee.useCallback((X) => {
      X !== F.current && (F.current = X, k(X));
    }, []), R = u || E, T = s || S, M = ee.useRef(null), F = ee.useRef(null), B = ee.useRef(v), V = p != null, H = eD(p), q = eD(i), Q = eD(h), W = ee.useCallback(() => {
      if (!M.current || !F.current)
        return;
      const X = {
        placement: t,
        strategy: r,
        middleware: x
      };
      q.current && (X.platform = q.current), Sse(M.current, F.current, X).then((fe) => {
        const Z = {
          ...fe,
          // The floating element's position may be recomputed while it's closed
          // but still mounted (such as when transitioning out). To ensure
          // `isPositioned` will be `false` initially on the next open, avoid
          // setting it to `true` when `open === false` (must be specified).
          isPositioned: Q.current !== !1
        };
        J.current && !bS(B.current, Z) && (B.current = Z, IN.flushSync(() => {
          y(Z);
        }));
      });
    }, [x, t, r, q, Q]);
    fS(() => {
      h === !1 && B.current.isPositioned && (B.current.isPositioned = !1, y((X) => ({
        ...X,
        isPositioned: !1
      })));
    }, [h]);
    const J = ee.useRef(!1);
    fS(() => (J.current = !0, () => {
      J.current = !1;
    }), []), fS(() => {
      if (R && (M.current = R), T && (F.current = T), R && T) {
        if (H.current)
          return H.current(R, T, W);
        W();
      }
    }, [R, T, W, H, V]);
    const ne = ee.useMemo(() => ({
      reference: M,
      floating: F,
      setReference: D,
      setFloating: A
    }), [D, A]), ie = ee.useMemo(() => ({
      reference: R,
      floating: T
    }), [R, T]), se = ee.useMemo(() => {
      const X = {
        position: r,
        left: 0,
        top: 0
      };
      if (!ie.floating)
        return X;
      const fe = iL(ie.floating, v.x), Z = iL(ie.floating, v.y);
      return c ? {
        ...X,
        transform: "translate(" + fe + "px, " + Z + "px)",
        ...vH(ie.floating) >= 1.5 && {
          willChange: "transform"
        }
      } : {
        position: r,
        left: fe,
        top: Z
      };
    }, [r, c, ie.floating, v.x, v.y]);
    return ee.useMemo(() => ({
      ...v,
      update: W,
      refs: ne,
      elements: ie,
      floatingStyles: se
    }), [v, W, ne, ie, se]);
  }
  const Tse = (e) => {
    function t(r) {
      return {}.hasOwnProperty.call(r, "current");
    }
    return {
      name: "arrow",
      options: e,
      fn(r) {
        const {
          element: n,
          padding: i
        } = typeof e == "function" ? e(r) : e;
        return n && t(n) ? n.current != null ? nL({
          element: n.current,
          padding: i
        }).fn(r) : {} : n ? nL({
          element: n,
          padding: i
        }).fn(r) : {};
      }
    };
  }, Ase = (e, t) => ({
    ...yse(e),
    options: [e, t]
  }), Dse = (e, t) => ({
    ...gse(e),
    options: [e, t]
  }), kse = (e, t) => ({
    ...Ese(e),
    options: [e, t]
  }), Rse = (e, t) => ({
    ...xse(e),
    options: [e, t]
  }), Pse = (e, t) => ({
    ...bse(e),
    options: [e, t]
  }), Mse = (e, t) => ({
    ...wse(e),
    options: [e, t]
  }), Nse = (e, t) => ({
    ...Tse(e),
    options: [e, t]
  });
  var jse = "Arrow", mH = ee.forwardRef((e, t) => {
    const { children: r, width: n = 10, height: i = 5, ...u } = e;
    return /* @__PURE__ */ me.jsx(
      Ga.svg,
      {
        ...u,
        ref: t,
        width: n,
        height: i,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: e.asChild ? r : /* @__PURE__ */ me.jsx("polygon", { points: "0,0 30,0 15,10" })
      }
    );
  });
  mH.displayName = jse;
  var Fse = mH;
  function yH(e) {
    const [t, r] = ee.useState(void 0);
    return Uf(() => {
      if (e) {
        r({ width: e.offsetWidth, height: e.offsetHeight });
        const n = new ResizeObserver((i) => {
          if (!Array.isArray(i) || !i.length)
            return;
          const u = i[0];
          let s, c;
          if ("borderBoxSize" in u) {
            const p = u.borderBoxSize, h = Array.isArray(p) ? p[0] : p;
            s = h.inlineSize, c = h.blockSize;
          } else
            s = e.offsetWidth, c = e.offsetHeight;
          r({ width: s, height: c });
        });
        return n.observe(e, { box: "border-box" }), () => n.unobserve(e);
      } else
        r(void 0);
    }, [e]), t;
  }
  var VN = "Popper", [gH, xH] = U0(VN), [Ise, bH] = gH(VN), wH = (e) => {
    const { __scopePopper: t, children: r } = e, [n, i] = ee.useState(null);
    return /* @__PURE__ */ me.jsx(Ise, { scope: t, anchor: n, onAnchorChange: i, children: r });
  };
  wH.displayName = VN;
  var EH = "PopperAnchor", SH = ee.forwardRef(
    (e, t) => {
      const { __scopePopper: r, virtualRef: n, ...i } = e, u = bH(EH, r), s = ee.useRef(null), c = Ou(t, s);
      return ee.useEffect(() => {
        u.onAnchorChange((n == null ? void 0 : n.current) || s.current);
      }), n ? null : /* @__PURE__ */ me.jsx(Ga.div, { ...i, ref: c });
    }
  );
  SH.displayName = EH;
  var WN = "PopperContent", [Bse, Lse] = gH(WN), _H = ee.forwardRef(
    (e, t) => {
      var Re, Te, we, Fe, Ye, de;
      const {
        __scopePopper: r,
        side: n = "bottom",
        sideOffset: i = 0,
        align: u = "center",
        alignOffset: s = 0,
        arrowPadding: c = 0,
        avoidCollisions: p = !0,
        collisionBoundary: h = [],
        collisionPadding: v = 0,
        sticky: y = "partial",
        hideWhenDetached: x = !1,
        updatePositionStrategy: w = "optimized",
        onPlaced: E,
        ...C
      } = e, S = bH(WN, r), [k, D] = ee.useState(null), A = Ou(t, (Ze) => D(Ze)), [R, T] = ee.useState(null), M = yH(R), F = (M == null ? void 0 : M.width) ?? 0, B = (M == null ? void 0 : M.height) ?? 0, V = n + (u !== "center" ? "-" + u : ""), H = typeof v == "number" ? v : { top: 0, right: 0, bottom: 0, left: 0, ...v }, q = Array.isArray(h) ? h : [h], Q = q.length > 0, W = {
        padding: H,
        boundary: q.filter(zse),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: Q
      }, { refs: J, floatingStyles: ne, placement: ie, isPositioned: se, middlewareData: X } = Ose({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: V,
        whileElementsMounted: (...Ze) => mse(...Ze, {
          animationFrame: w === "always"
        }),
        elements: {
          reference: S.anchor
        },
        middleware: [
          Ase({ mainAxis: i + B, alignmentAxis: s }),
          p && Dse({
            mainAxis: !0,
            crossAxis: !1,
            limiter: y === "partial" ? kse() : void 0,
            ...W
          }),
          p && Rse({ ...W }),
          Pse({
            ...W,
            apply: ({ elements: Ze, rects: Ne, availableWidth: Ot, availableHeight: At }) => {
              const { width: Qt, height: Wr } = Ne.reference, Ar = Ze.floating.style;
              Ar.setProperty("--radix-popper-available-width", `${Ot}px`), Ar.setProperty("--radix-popper-available-height", `${At}px`), Ar.setProperty("--radix-popper-anchor-width", `${Qt}px`), Ar.setProperty("--radix-popper-anchor-height", `${Wr}px`);
            }
          }),
          R && Nse({ element: R, padding: c }),
          qse({ arrowWidth: F, arrowHeight: B }),
          x && Mse({ strategy: "referenceHidden", ...W })
        ]
      }), [fe, Z] = TH(ie), z = Lx(E);
      Uf(() => {
        se && (z == null || z());
      }, [se, z]);
      const Y = (Re = X.arrow) == null ? void 0 : Re.x, te = (Te = X.arrow) == null ? void 0 : Te.y, ae = ((we = X.arrow) == null ? void 0 : we.centerOffset) !== 0, [De, ke] = ee.useState();
      return Uf(() => {
        k && ke(window.getComputedStyle(k).zIndex);
      }, [k]), /* @__PURE__ */ me.jsx(
        "div",
        {
          ref: J.setFloating,
          "data-radix-popper-content-wrapper": "",
          style: {
            ...ne,
            transform: se ? ne.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: De,
            "--radix-popper-transform-origin": [
              (Fe = X.transformOrigin) == null ? void 0 : Fe.x,
              (Ye = X.transformOrigin) == null ? void 0 : Ye.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...((de = X.hide) == null ? void 0 : de.referenceHidden) && {
              visibility: "hidden",
              pointerEvents: "none"
            }
          },
          dir: e.dir,
          children: /* @__PURE__ */ me.jsx(
            Bse,
            {
              scope: r,
              placedSide: fe,
              onArrowChange: T,
              arrowX: Y,
              arrowY: te,
              shouldHideArrow: ae,
              children: /* @__PURE__ */ me.jsx(
                Ga.div,
                {
                  "data-side": fe,
                  "data-align": Z,
                  ...C,
                  ref: A,
                  style: {
                    ...C.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: se ? void 0 : "none"
                  }
                }
              )
            }
          )
        }
      );
    }
  );
  _H.displayName = WN;
  var CH = "PopperArrow", $se = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  }, OH = ee.forwardRef(function(t, r) {
    const { __scopePopper: n, ...i } = t, u = Lse(CH, n), s = $se[u.placedSide];
    return (
      // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
      // doesn't report size as we'd expect on SVG elements.
      // it reports their bounding box which is effectively the largest path inside the SVG.
      /* @__PURE__ */ me.jsx(
        "span",
        {
          ref: u.onArrowChange,
          style: {
            position: "absolute",
            left: u.arrowX,
            top: u.arrowY,
            [s]: 0,
            transformOrigin: {
              top: "",
              right: "0 0",
              bottom: "center 0",
              left: "100% 0"
            }[u.placedSide],
            transform: {
              top: "translateY(100%)",
              right: "translateY(50%) rotate(90deg) translateX(-50%)",
              bottom: "rotate(180deg)",
              left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[u.placedSide],
            visibility: u.shouldHideArrow ? "hidden" : void 0
          },
          children: /* @__PURE__ */ me.jsx(
            Fse,
            {
              ...i,
              ref: r,
              style: {
                ...i.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
              }
            }
          )
        }
      )
    );
  });
  OH.displayName = CH;
  function zse(e) {
    return e !== null;
  }
  var qse = (e) => ({
    name: "transformOrigin",
    options: e,
    fn(t) {
      var S, k, D;
      const { placement: r, rects: n, middlewareData: i } = t, s = ((S = i.arrow) == null ? void 0 : S.centerOffset) !== 0, c = s ? 0 : e.arrowWidth, p = s ? 0 : e.arrowHeight, [h, v] = TH(r), y = { start: "0%", center: "50%", end: "100%" }[v], x = (((k = i.arrow) == null ? void 0 : k.x) ?? 0) + c / 2, w = (((D = i.arrow) == null ? void 0 : D.y) ?? 0) + p / 2;
      let E = "", C = "";
      return h === "bottom" ? (E = s ? y : `${x}px`, C = `${-p}px`) : h === "top" ? (E = s ? y : `${x}px`, C = `${n.floating.height + p}px`) : h === "right" ? (E = `${-p}px`, C = s ? y : `${w}px`) : h === "left" && (E = `${n.floating.width + p}px`, C = s ? y : `${w}px`), { data: { x: E, y: C } };
    }
  });
  function TH(e) {
    const [t, r = "center"] = e.split("-");
    return [t, r];
  }
  var Use = wH, Hse = SH, Vse = _H, Wse = OH, Yse = "Portal", AH = ee.forwardRef((e, t) => {
    var c;
    const { container: r, ...n } = e, [i, u] = ee.useState(!1);
    Uf(() => u(!0), []);
    const s = r || i && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
    return s ? gue.createPortal(/* @__PURE__ */ me.jsx(Ga.div, { ...n, ref: t }), s) : null;
  });
  AH.displayName = Yse;
  function Gse(e, t) {
    return ee.useReducer((r, n) => t[r][n] ?? r, e);
  }
  var YN = (e) => {
    const { present: t, children: r } = e, n = Qse(t), i = typeof r == "function" ? r({ present: n.isPresent }) : ee.Children.only(r), u = Ou(n.ref, Kse(i));
    return typeof r == "function" || n.isPresent ? ee.cloneElement(i, { ref: u }) : null;
  };
  YN.displayName = "Presence";
  function Qse(e) {
    const [t, r] = ee.useState(), n = ee.useRef(null), i = ee.useRef(e), u = ee.useRef("none"), s = e ? "mounted" : "unmounted", [c, p] = Gse(s, {
      mounted: {
        UNMOUNT: "unmounted",
        ANIMATION_OUT: "unmountSuspended"
      },
      unmountSuspended: {
        MOUNT: "mounted",
        ANIMATION_END: "unmounted"
      },
      unmounted: {
        MOUNT: "mounted"
      }
    });
    return ee.useEffect(() => {
      const h = nE(n.current);
      u.current = c === "mounted" ? h : "none";
    }, [c]), Uf(() => {
      const h = n.current, v = i.current;
      if (v !== e) {
        const x = u.current, w = nE(h);
        e ? p("MOUNT") : w === "none" || (h == null ? void 0 : h.display) === "none" ? p("UNMOUNT") : p(v && x !== w ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
      }
    }, [e, p]), Uf(() => {
      if (t) {
        let h;
        const v = t.ownerDocument.defaultView ?? window, y = (w) => {
          const C = nE(n.current).includes(w.animationName);
          if (w.target === t && C && (p("ANIMATION_END"), !i.current)) {
            const S = t.style.animationFillMode;
            t.style.animationFillMode = "forwards", h = v.setTimeout(() => {
              t.style.animationFillMode === "forwards" && (t.style.animationFillMode = S);
            });
          }
        }, x = (w) => {
          w.target === t && (u.current = nE(n.current));
        };
        return t.addEventListener("animationstart", x), t.addEventListener("animationcancel", y), t.addEventListener("animationend", y), () => {
          v.clearTimeout(h), t.removeEventListener("animationstart", x), t.removeEventListener("animationcancel", y), t.removeEventListener("animationend", y);
        };
      } else
        p("ANIMATION_END");
    }, [t, p]), {
      isPresent: ["mounted", "unmountSuspended"].includes(c),
      ref: ee.useCallback((h) => {
        n.current = h ? getComputedStyle(h) : null, r(h);
      }, [])
    };
  }
  function nE(e) {
    return (e == null ? void 0 : e.animationName) || "none";
  }
  function Kse(e) {
    var n, i;
    let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
    return r ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
  }
  var Xse = dU[" useInsertionEffect ".trim().toString()] || Uf;
  function W0({
    prop: e,
    defaultProp: t,
    onChange: r = () => {
    },
    caller: n
  }) {
    const [i, u, s] = Zse({
      defaultProp: t,
      onChange: r
    }), c = e !== void 0, p = c ? e : i;
    {
      const v = ee.useRef(e !== void 0);
      ee.useEffect(() => {
        const y = v.current;
        y !== c && console.warn(
          `${n} is changing from ${y ? "controlled" : "uncontrolled"} to ${c ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
        ), v.current = c;
      }, [c, n]);
    }
    const h = ee.useCallback(
      (v) => {
        var y;
        if (c) {
          const x = Jse(v) ? v(e) : v;
          x !== e && ((y = s.current) == null || y.call(s, x));
        } else
          u(v);
      },
      [c, e, u, s]
    );
    return [p, h];
  }
  function Zse({
    defaultProp: e,
    onChange: t
  }) {
    const [r, n] = ee.useState(e), i = ee.useRef(r), u = ee.useRef(t);
    return Xse(() => {
      u.current = t;
    }, [t]), ee.useEffect(() => {
      var s;
      i.current !== r && ((s = u.current) == null || s.call(u, r), i.current = r);
    }, [r, i]), [r, n, u];
  }
  function Jse(e) {
    return typeof e == "function";
  }
  var ele = Object.freeze({
    // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal"
  }), tle = "VisuallyHidden", DH = ee.forwardRef(
    (e, t) => /* @__PURE__ */ me.jsx(
      Ga.span,
      {
        ...e,
        ref: t,
        style: { ...ele, ...e.style }
      }
    )
  );
  DH.displayName = tle;
  var rle = DH, [j_, XTe] = U0("Tooltip", [
    xH
  ]), F_ = xH(), kH = "TooltipProvider", nle = 700, IP = "tooltip.open", [ile, GN] = j_(kH), RH = (e) => {
    const {
      __scopeTooltip: t,
      delayDuration: r = nle,
      skipDelayDuration: n = 300,
      disableHoverableContent: i = !1,
      children: u
    } = e, s = ee.useRef(!0), c = ee.useRef(!1), p = ee.useRef(0);
    return ee.useEffect(() => {
      const h = p.current;
      return () => window.clearTimeout(h);
    }, []), /* @__PURE__ */ me.jsx(
      ile,
      {
        scope: t,
        isOpenDelayedRef: s,
        delayDuration: r,
        onOpen: ee.useCallback(() => {
          window.clearTimeout(p.current), s.current = !1;
        }, []),
        onClose: ee.useCallback(() => {
          window.clearTimeout(p.current), p.current = window.setTimeout(
            () => s.current = !0,
            n
          );
        }, [n]),
        isPointerInTransitRef: c,
        onPointerInTransitChange: ee.useCallback((h) => {
          c.current = h;
        }, []),
        disableHoverableContent: i,
        children: u
      }
    );
  };
  RH.displayName = kH;
  var Jg = "Tooltip", [ale, zx] = j_(Jg), PH = (e) => {
    const {
      __scopeTooltip: t,
      children: r,
      open: n,
      defaultOpen: i,
      onOpenChange: u,
      disableHoverableContent: s,
      delayDuration: c
    } = e, p = GN(Jg, e.__scopeTooltip), h = F_(t), [v, y] = ee.useState(null), x = aH(), w = ee.useRef(0), E = s ?? p.disableHoverableContent, C = c ?? p.delayDuration, S = ee.useRef(!1), [k, D] = W0({
      prop: n,
      defaultProp: i ?? !1,
      onChange: (F) => {
        F ? (p.onOpen(), document.dispatchEvent(new CustomEvent(IP))) : p.onClose(), u == null || u(F);
      },
      caller: Jg
    }), A = ee.useMemo(() => k ? S.current ? "delayed-open" : "instant-open" : "closed", [k]), R = ee.useCallback(() => {
      window.clearTimeout(w.current), w.current = 0, S.current = !1, D(!0);
    }, [D]), T = ee.useCallback(() => {
      window.clearTimeout(w.current), w.current = 0, D(!1);
    }, [D]), M = ee.useCallback(() => {
      window.clearTimeout(w.current), w.current = window.setTimeout(() => {
        S.current = !0, D(!0), w.current = 0;
      }, C);
    }, [C, D]);
    return ee.useEffect(() => () => {
      w.current && (window.clearTimeout(w.current), w.current = 0);
    }, []), /* @__PURE__ */ me.jsx(Use, { ...h, children: /* @__PURE__ */ me.jsx(
      ale,
      {
        scope: t,
        contentId: x,
        open: k,
        stateAttribute: A,
        trigger: v,
        onTriggerChange: y,
        onTriggerEnter: ee.useCallback(() => {
          p.isOpenDelayedRef.current ? M() : R();
        }, [p.isOpenDelayedRef, M, R]),
        onTriggerLeave: ee.useCallback(() => {
          E ? T() : (window.clearTimeout(w.current), w.current = 0);
        }, [T, E]),
        onOpen: R,
        onClose: T,
        disableHoverableContent: E,
        children: r
      }
    ) });
  };
  PH.displayName = Jg;
  var BP = "TooltipTrigger", MH = ee.forwardRef(
    (e, t) => {
      const { __scopeTooltip: r, ...n } = e, i = zx(BP, r), u = GN(BP, r), s = F_(r), c = ee.useRef(null), p = Ou(t, c, i.onTriggerChange), h = ee.useRef(!1), v = ee.useRef(!1), y = ee.useCallback(() => h.current = !1, []);
      return ee.useEffect(() => () => document.removeEventListener("pointerup", y), [y]), /* @__PURE__ */ me.jsx(Hse, { asChild: !0, ...s, children: /* @__PURE__ */ me.jsx(
        Ga.button,
        {
          "aria-describedby": i.open ? i.contentId : void 0,
          "data-state": i.stateAttribute,
          ...n,
          ref: p,
          onPointerMove: aa(e.onPointerMove, (x) => {
            x.pointerType !== "touch" && !v.current && !u.isPointerInTransitRef.current && (i.onTriggerEnter(), v.current = !0);
          }),
          onPointerLeave: aa(e.onPointerLeave, () => {
            i.onTriggerLeave(), v.current = !1;
          }),
          onPointerDown: aa(e.onPointerDown, () => {
            i.open && i.onClose(), h.current = !0, document.addEventListener("pointerup", y, { once: !0 });
          }),
          onFocus: aa(e.onFocus, () => {
            h.current || i.onOpen();
          }),
          onBlur: aa(e.onBlur, i.onClose),
          onClick: aa(e.onClick, i.onClose)
        }
      ) });
    }
  );
  MH.displayName = BP;
  var QN = "TooltipPortal", [ole, ule] = j_(QN, {
    forceMount: void 0
  }), NH = (e) => {
    const { __scopeTooltip: t, forceMount: r, children: n, container: i } = e, u = zx(QN, t);
    return /* @__PURE__ */ me.jsx(ole, { scope: t, forceMount: r, children: /* @__PURE__ */ me.jsx(YN, { present: r || u.open, children: /* @__PURE__ */ me.jsx(AH, { asChild: !0, container: i, children: n }) }) });
  };
  NH.displayName = QN;
  var c0 = "TooltipContent", jH = ee.forwardRef(
    (e, t) => {
      const r = ule(c0, e.__scopeTooltip), { forceMount: n = r.forceMount, side: i = "top", ...u } = e, s = zx(c0, e.__scopeTooltip);
      return /* @__PURE__ */ me.jsx(YN, { present: n || s.open, children: s.disableHoverableContent ? /* @__PURE__ */ me.jsx(FH, { side: i, ...u, ref: t }) : /* @__PURE__ */ me.jsx(sle, { side: i, ...u, ref: t }) });
    }
  ), sle = ee.forwardRef((e, t) => {
    const r = zx(c0, e.__scopeTooltip), n = GN(c0, e.__scopeTooltip), i = ee.useRef(null), u = Ou(t, i), [s, c] = ee.useState(null), { trigger: p, onClose: h } = r, v = i.current, { onPointerInTransitChange: y } = n, x = ee.useCallback(() => {
      c(null), y(!1);
    }, [y]), w = ee.useCallback(
      (E, C) => {
        const S = E.currentTarget, k = { x: E.clientX, y: E.clientY }, D = ple(k, S.getBoundingClientRect()), A = hle(k, D), R = vle(C.getBoundingClientRect()), T = yle([...A, ...R]);
        c(T), y(!0);
      },
      [y]
    );
    return ee.useEffect(() => () => x(), [x]), ee.useEffect(() => {
      if (p && v) {
        const E = (S) => w(S, v), C = (S) => w(S, p);
        return p.addEventListener("pointerleave", E), v.addEventListener("pointerleave", C), () => {
          p.removeEventListener("pointerleave", E), v.removeEventListener("pointerleave", C);
        };
      }
    }, [p, v, w, x]), ee.useEffect(() => {
      if (s) {
        const E = (C) => {
          const S = C.target, k = { x: C.clientX, y: C.clientY }, D = (p == null ? void 0 : p.contains(S)) || (v == null ? void 0 : v.contains(S)), A = !mle(k, s);
          D ? x() : A && (x(), h());
        };
        return document.addEventListener("pointermove", E), () => document.removeEventListener("pointermove", E);
      }
    }, [p, v, s, h, x]), /* @__PURE__ */ me.jsx(FH, { ...e, ref: u });
  }), [lle, cle] = j_(Jg, { isInside: !1 }), fle = /* @__PURE__ */ bue("TooltipContent"), FH = ee.forwardRef(
    (e, t) => {
      const {
        __scopeTooltip: r,
        children: n,
        "aria-label": i,
        onEscapeKeyDown: u,
        onPointerDownOutside: s,
        ...c
      } = e, p = zx(c0, r), h = F_(r), { onClose: v } = p;
      return ee.useEffect(() => (document.addEventListener(IP, v), () => document.removeEventListener(IP, v)), [v]), ee.useEffect(() => {
        if (p.trigger) {
          const y = (x) => {
            const w = x.target;
            w != null && w.contains(p.trigger) && v();
          };
          return window.addEventListener("scroll", y, { capture: !0 }), () => window.removeEventListener("scroll", y, { capture: !0 });
        }
      }, [p.trigger, v]), /* @__PURE__ */ me.jsx(
        nH,
        {
          asChild: !0,
          disableOutsidePointerEvents: !1,
          onEscapeKeyDown: u,
          onPointerDownOutside: s,
          onFocusOutside: (y) => y.preventDefault(),
          onDismiss: v,
          children: /* @__PURE__ */ me.jsxs(
            Vse,
            {
              "data-state": p.stateAttribute,
              ...h,
              ...c,
              ref: t,
              style: {
                ...c.style,
                "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
                "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
                "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
                "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
                "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
              },
              children: [
                /* @__PURE__ */ me.jsx(fle, { children: n }),
                /* @__PURE__ */ me.jsx(lle, { scope: r, isInside: !0, children: /* @__PURE__ */ me.jsx(rle, { id: p.contentId, role: "tooltip", children: i || n }) })
              ]
            }
          )
        }
      );
    }
  );
  jH.displayName = c0;
  var IH = "TooltipArrow", dle = ee.forwardRef(
    (e, t) => {
      const { __scopeTooltip: r, ...n } = e, i = F_(r);
      return cle(
        IH,
        r
      ).isInside ? null : /* @__PURE__ */ me.jsx(Wse, { ...i, ...n, ref: t });
    }
  );
  dle.displayName = IH;
  function ple(e, t) {
    const r = Math.abs(t.top - e.y), n = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), u = Math.abs(t.left - e.x);
    switch (Math.min(r, n, i, u)) {
      case u:
        return "left";
      case i:
        return "right";
      case r:
        return "top";
      case n:
        return "bottom";
      default:
        throw new Error("unreachable");
    }
  }
  function hle(e, t, r = 5) {
    const n = [];
    switch (t) {
      case "top":
        n.push(
          { x: e.x - r, y: e.y + r },
          { x: e.x + r, y: e.y + r }
        );
        break;
      case "bottom":
        n.push(
          { x: e.x - r, y: e.y - r },
          { x: e.x + r, y: e.y - r }
        );
        break;
      case "left":
        n.push(
          { x: e.x + r, y: e.y - r },
          { x: e.x + r, y: e.y + r }
        );
        break;
      case "right":
        n.push(
          { x: e.x - r, y: e.y - r },
          { x: e.x - r, y: e.y + r }
        );
        break;
    }
    return n;
  }
  function vle(e) {
    const { top: t, right: r, bottom: n, left: i } = e;
    return [
      { x: i, y: t },
      { x: r, y: t },
      { x: r, y: n },
      { x: i, y: n }
    ];
  }
  function mle(e, t) {
    const { x: r, y: n } = e;
    let i = !1;
    for (let u = 0, s = t.length - 1; u < t.length; s = u++) {
      const c = t[u], p = t[s], h = c.x, v = c.y, y = p.x, x = p.y;
      v > n != x > n && r < (y - h) * (n - v) / (x - v) + h && (i = !i);
    }
    return i;
  }
  function yle(e) {
    const t = e.slice();
    return t.sort((r, n) => r.x < n.x ? -1 : r.x > n.x ? 1 : r.y < n.y ? -1 : r.y > n.y ? 1 : 0), gle(t);
  }
  function gle(e) {
    if (e.length <= 1) return e.slice();
    const t = [];
    for (let n = 0; n < e.length; n++) {
      const i = e[n];
      for (; t.length >= 2; ) {
        const u = t[t.length - 1], s = t[t.length - 2];
        if ((u.x - s.x) * (i.y - s.y) >= (u.y - s.y) * (i.x - s.x)) t.pop();
        else break;
      }
      t.push(i);
    }
    t.pop();
    const r = [];
    for (let n = e.length - 1; n >= 0; n--) {
      const i = e[n];
      for (; r.length >= 2; ) {
        const u = r[r.length - 1], s = r[r.length - 2];
        if ((u.x - s.x) * (i.y - s.y) >= (u.y - s.y) * (i.x - s.x)) r.pop();
        else break;
      }
      r.push(i);
    }
    return r.pop(), t.length === 1 && r.length === 1 && t[0].x === r[0].x && t[0].y === r[0].y ? t : t.concat(r);
  }
  var xle = RH, ble = PH, wle = MH, Ele = NH, Sle = jH;
  function _le({ delayDuration: e = 0, ...t }) {
    return /* @__PURE__ */ me.jsx(xle, { "data-slot": "tooltip-provider", delayDuration: e, ...t });
  }
  function Cle({ ...e }) {
    return /* @__PURE__ */ me.jsx(_le, { children: /* @__PURE__ */ me.jsx(ble, { "data-slot": "tooltip", ...e }) });
  }
  function Ole({ ...e }) {
    return /* @__PURE__ */ me.jsx(wle, { "data-slot": "tooltip-trigger", ...e });
  }
  function Tle({
    className: e,
    container: t,
    sideOffset: r = 0,
    children: n,
    ...i
  }) {
    return /* @__PURE__ */ me.jsx(Ele, { container: t, children: /* @__PURE__ */ me.jsx(
      Sle,
      {
        "data-slot": "tooltip-content",
        sideOffset: r,
        className: vs(
          "bg-primary text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-balance",
          e
        ),
        ...i,
        children: n
      }
    ) });
  }
  const Ale = ({ trigger: e, content: t }) => {
    const r = ee.useRef(null), [n, i] = ee.useState(null);
    return ee.useEffect(() => {
      if (r.current) {
        const u = r.current.getRootNode();
        u instanceof ShadowRoot ? i(u) : i(document.body);
      }
    }, []), /* @__PURE__ */ me.jsx("div", { ref: r, className: "contents", children: /* @__PURE__ */ me.jsxs(Cle, { children: [
      /* @__PURE__ */ me.jsx(Ole, { children: e }),
      /* @__PURE__ */ me.jsx(
        Tle,
        {
          container: n,
          sideOffset: 8,
          collisionPadding: 8,
          className: "max-w-80 rounded-[4px] bg-neutral-700 text-sm text-neutral-50 px-3 py-1 text-pretty",
          children: t
        }
      )
    ] }) });
  };
  var tD, aL;
  function xo() {
    if (aL) return tD;
    aL = 1;
    var e = Array.isArray;
    return tD = e, tD;
  }
  var rD, oL;
  function BH() {
    if (oL) return rD;
    oL = 1;
    var e = typeof Sp == "object" && Sp && Sp.Object === Object && Sp;
    return rD = e, rD;
  }
  var nD, uL;
  function vl() {
    if (uL) return nD;
    uL = 1;
    var e = BH(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
    return nD = r, nD;
  }
  var iD, sL;
  function qx() {
    if (sL) return iD;
    sL = 1;
    var e = vl(), t = e.Symbol;
    return iD = t, iD;
  }
  var aD, lL;
  function Dle() {
    if (lL) return aD;
    lL = 1;
    var e = qx(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, i = e ? e.toStringTag : void 0;
    function u(s) {
      var c = r.call(s, i), p = s[i];
      try {
        s[i] = void 0;
        var h = !0;
      } catch {
      }
      var v = n.call(s);
      return h && (c ? s[i] = p : delete s[i]), v;
    }
    return aD = u, aD;
  }
  var oD, cL;
  function kle() {
    if (cL) return oD;
    cL = 1;
    var e = Object.prototype, t = e.toString;
    function r(n) {
      return t.call(n);
    }
    return oD = r, oD;
  }
  var uD, fL;
  function Oc() {
    if (fL) return uD;
    fL = 1;
    var e = qx(), t = Dle(), r = kle(), n = "[object Null]", i = "[object Undefined]", u = e ? e.toStringTag : void 0;
    function s(c) {
      return c == null ? c === void 0 ? i : n : u && u in Object(c) ? t(c) : r(c);
    }
    return uD = s, uD;
  }
  var sD, dL;
  function Tc() {
    if (dL) return sD;
    dL = 1;
    function e(t) {
      return t != null && typeof t == "object";
    }
    return sD = e, sD;
  }
  var lD, pL;
  function Y0() {
    if (pL) return lD;
    pL = 1;
    var e = Oc(), t = Tc(), r = "[object Symbol]";
    function n(i) {
      return typeof i == "symbol" || t(i) && e(i) == r;
    }
    return lD = n, lD;
  }
  var cD, hL;
  function KN() {
    if (hL) return cD;
    hL = 1;
    var e = xo(), t = Y0(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
    function i(u, s) {
      if (e(u))
        return !1;
      var c = typeof u;
      return c == "number" || c == "symbol" || c == "boolean" || u == null || t(u) ? !0 : n.test(u) || !r.test(u) || s != null && u in Object(s);
    }
    return cD = i, cD;
  }
  var fD, vL;
  function Gf() {
    if (vL) return fD;
    vL = 1;
    function e(t) {
      var r = typeof t;
      return t != null && (r == "object" || r == "function");
    }
    return fD = e, fD;
  }
  var dD, mL;
  function XN() {
    if (mL) return dD;
    mL = 1;
    var e = Oc(), t = Gf(), r = "[object AsyncFunction]", n = "[object Function]", i = "[object GeneratorFunction]", u = "[object Proxy]";
    function s(c) {
      if (!t(c))
        return !1;
      var p = e(c);
      return p == n || p == i || p == r || p == u;
    }
    return dD = s, dD;
  }
  var pD, yL;
  function Rle() {
    if (yL) return pD;
    yL = 1;
    var e = vl(), t = e["__core-js_shared__"];
    return pD = t, pD;
  }
  var hD, gL;
  function Ple() {
    if (gL) return hD;
    gL = 1;
    var e = Rle(), t = function() {
      var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
      return n ? "Symbol(src)_1." + n : "";
    }();
    function r(n) {
      return !!t && t in n;
    }
    return hD = r, hD;
  }
  var vD, xL;
  function LH() {
    if (xL) return vD;
    xL = 1;
    var e = Function.prototype, t = e.toString;
    function r(n) {
      if (n != null) {
        try {
          return t.call(n);
        } catch {
        }
        try {
          return n + "";
        } catch {
        }
      }
      return "";
    }
    return vD = r, vD;
  }
  var mD, bL;
  function Mle() {
    if (bL) return mD;
    bL = 1;
    var e = XN(), t = Ple(), r = Gf(), n = LH(), i = /[\\^$.*+?()[\]{}|]/g, u = /^\[object .+?Constructor\]$/, s = Function.prototype, c = Object.prototype, p = s.toString, h = c.hasOwnProperty, v = RegExp(
      "^" + p.call(h).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    function y(x) {
      if (!r(x) || t(x))
        return !1;
      var w = e(x) ? v : u;
      return w.test(n(x));
    }
    return mD = y, mD;
  }
  var yD, wL;
  function Nle() {
    if (wL) return yD;
    wL = 1;
    function e(t, r) {
      return t == null ? void 0 : t[r];
    }
    return yD = e, yD;
  }
  var gD, EL;
  function Up() {
    if (EL) return gD;
    EL = 1;
    var e = Mle(), t = Nle();
    function r(n, i) {
      var u = t(n, i);
      return e(u) ? u : void 0;
    }
    return gD = r, gD;
  }
  var xD, SL;
  function I_() {
    if (SL) return xD;
    SL = 1;
    var e = Up(), t = e(Object, "create");
    return xD = t, xD;
  }
  var bD, _L;
  function jle() {
    if (_L) return bD;
    _L = 1;
    var e = I_();
    function t() {
      this.__data__ = e ? e(null) : {}, this.size = 0;
    }
    return bD = t, bD;
  }
  var wD, CL;
  function Fle() {
    if (CL) return wD;
    CL = 1;
    function e(t) {
      var r = this.has(t) && delete this.__data__[t];
      return this.size -= r ? 1 : 0, r;
    }
    return wD = e, wD;
  }
  var ED, OL;
  function Ile() {
    if (OL) return ED;
    OL = 1;
    var e = I_(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
    function i(u) {
      var s = this.__data__;
      if (e) {
        var c = s[u];
        return c === t ? void 0 : c;
      }
      return n.call(s, u) ? s[u] : void 0;
    }
    return ED = i, ED;
  }
  var SD, TL;
  function Ble() {
    if (TL) return SD;
    TL = 1;
    var e = I_(), t = Object.prototype, r = t.hasOwnProperty;
    function n(i) {
      var u = this.__data__;
      return e ? u[i] !== void 0 : r.call(u, i);
    }
    return SD = n, SD;
  }
  var _D, AL;
  function Lle() {
    if (AL) return _D;
    AL = 1;
    var e = I_(), t = "__lodash_hash_undefined__";
    function r(n, i) {
      var u = this.__data__;
      return this.size += this.has(n) ? 0 : 1, u[n] = e && i === void 0 ? t : i, this;
    }
    return _D = r, _D;
  }
  var CD, DL;
  function $le() {
    if (DL) return CD;
    DL = 1;
    var e = jle(), t = Fle(), r = Ile(), n = Ble(), i = Lle();
    function u(s) {
      var c = -1, p = s == null ? 0 : s.length;
      for (this.clear(); ++c < p; ) {
        var h = s[c];
        this.set(h[0], h[1]);
      }
    }
    return u.prototype.clear = e, u.prototype.delete = t, u.prototype.get = r, u.prototype.has = n, u.prototype.set = i, CD = u, CD;
  }
  var OD, kL;
  function zle() {
    if (kL) return OD;
    kL = 1;
    function e() {
      this.__data__ = [], this.size = 0;
    }
    return OD = e, OD;
  }
  var TD, RL;
  function ZN() {
    if (RL) return TD;
    RL = 1;
    function e(t, r) {
      return t === r || t !== t && r !== r;
    }
    return TD = e, TD;
  }
  var AD, PL;
  function B_() {
    if (PL) return AD;
    PL = 1;
    var e = ZN();
    function t(r, n) {
      for (var i = r.length; i--; )
        if (e(r[i][0], n))
          return i;
      return -1;
    }
    return AD = t, AD;
  }
  var DD, ML;
  function qle() {
    if (ML) return DD;
    ML = 1;
    var e = B_(), t = Array.prototype, r = t.splice;
    function n(i) {
      var u = this.__data__, s = e(u, i);
      if (s < 0)
        return !1;
      var c = u.length - 1;
      return s == c ? u.pop() : r.call(u, s, 1), --this.size, !0;
    }
    return DD = n, DD;
  }
  var kD, NL;
  function Ule() {
    if (NL) return kD;
    NL = 1;
    var e = B_();
    function t(r) {
      var n = this.__data__, i = e(n, r);
      return i < 0 ? void 0 : n[i][1];
    }
    return kD = t, kD;
  }
  var RD, jL;
  function Hle() {
    if (jL) return RD;
    jL = 1;
    var e = B_();
    function t(r) {
      return e(this.__data__, r) > -1;
    }
    return RD = t, RD;
  }
  var PD, FL;
  function Vle() {
    if (FL) return PD;
    FL = 1;
    var e = B_();
    function t(r, n) {
      var i = this.__data__, u = e(i, r);
      return u < 0 ? (++this.size, i.push([r, n])) : i[u][1] = n, this;
    }
    return PD = t, PD;
  }
  var MD, IL;
  function L_() {
    if (IL) return MD;
    IL = 1;
    var e = zle(), t = qle(), r = Ule(), n = Hle(), i = Vle();
    function u(s) {
      var c = -1, p = s == null ? 0 : s.length;
      for (this.clear(); ++c < p; ) {
        var h = s[c];
        this.set(h[0], h[1]);
      }
    }
    return u.prototype.clear = e, u.prototype.delete = t, u.prototype.get = r, u.prototype.has = n, u.prototype.set = i, MD = u, MD;
  }
  var ND, BL;
  function JN() {
    if (BL) return ND;
    BL = 1;
    var e = Up(), t = vl(), r = e(t, "Map");
    return ND = r, ND;
  }
  var jD, LL;
  function Wle() {
    if (LL) return jD;
    LL = 1;
    var e = $le(), t = L_(), r = JN();
    function n() {
      this.size = 0, this.__data__ = {
        hash: new e(),
        map: new (r || t)(),
        string: new e()
      };
    }
    return jD = n, jD;
  }
  var FD, $L;
  function Yle() {
    if ($L) return FD;
    $L = 1;
    function e(t) {
      var r = typeof t;
      return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
    }
    return FD = e, FD;
  }
  var ID, zL;
  function $_() {
    if (zL) return ID;
    zL = 1;
    var e = Yle();
    function t(r, n) {
      var i = r.__data__;
      return e(n) ? i[typeof n == "string" ? "string" : "hash"] : i.map;
    }
    return ID = t, ID;
  }
  var BD, qL;
  function Gle() {
    if (qL) return BD;
    qL = 1;
    var e = $_();
    function t(r) {
      var n = e(this, r).delete(r);
      return this.size -= n ? 1 : 0, n;
    }
    return BD = t, BD;
  }
  var LD, UL;
  function Qle() {
    if (UL) return LD;
    UL = 1;
    var e = $_();
    function t(r) {
      return e(this, r).get(r);
    }
    return LD = t, LD;
  }
  var $D, HL;
  function Kle() {
    if (HL) return $D;
    HL = 1;
    var e = $_();
    function t(r) {
      return e(this, r).has(r);
    }
    return $D = t, $D;
  }
  var zD, VL;
  function Xle() {
    if (VL) return zD;
    VL = 1;
    var e = $_();
    function t(r, n) {
      var i = e(this, r), u = i.size;
      return i.set(r, n), this.size += i.size == u ? 0 : 1, this;
    }
    return zD = t, zD;
  }
  var qD, WL;
  function ej() {
    if (WL) return qD;
    WL = 1;
    var e = Wle(), t = Gle(), r = Qle(), n = Kle(), i = Xle();
    function u(s) {
      var c = -1, p = s == null ? 0 : s.length;
      for (this.clear(); ++c < p; ) {
        var h = s[c];
        this.set(h[0], h[1]);
      }
    }
    return u.prototype.clear = e, u.prototype.delete = t, u.prototype.get = r, u.prototype.has = n, u.prototype.set = i, qD = u, qD;
  }
  var UD, YL;
  function $H() {
    if (YL) return UD;
    YL = 1;
    var e = ej(), t = "Expected a function";
    function r(n, i) {
      if (typeof n != "function" || i != null && typeof i != "function")
        throw new TypeError(t);
      var u = function() {
        var s = arguments, c = i ? i.apply(this, s) : s[0], p = u.cache;
        if (p.has(c))
          return p.get(c);
        var h = n.apply(this, s);
        return u.cache = p.set(c, h) || p, h;
      };
      return u.cache = new (r.Cache || e)(), u;
    }
    return r.Cache = e, UD = r, UD;
  }
  var HD, GL;
  function Zle() {
    if (GL) return HD;
    GL = 1;
    var e = $H(), t = 500;
    function r(n) {
      var i = e(n, function(s) {
        return u.size === t && u.clear(), s;
      }), u = i.cache;
      return i;
    }
    return HD = r, HD;
  }
  var VD, QL;
  function Jle() {
    if (QL) return VD;
    QL = 1;
    var e = Zle(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, n = e(function(i) {
      var u = [];
      return i.charCodeAt(0) === 46 && u.push(""), i.replace(t, function(s, c, p, h) {
        u.push(p ? h.replace(r, "$1") : c || s);
      }), u;
    });
    return VD = n, VD;
  }
  var WD, KL;
  function tj() {
    if (KL) return WD;
    KL = 1;
    function e(t, r) {
      for (var n = -1, i = t == null ? 0 : t.length, u = Array(i); ++n < i; )
        u[n] = r(t[n], n, t);
      return u;
    }
    return WD = e, WD;
  }
  var YD, XL;
  function ece() {
    if (XL) return YD;
    XL = 1;
    var e = qx(), t = tj(), r = xo(), n = Y0(), i = e ? e.prototype : void 0, u = i ? i.toString : void 0;
    function s(c) {
      if (typeof c == "string")
        return c;
      if (r(c))
        return t(c, s) + "";
      if (n(c))
        return u ? u.call(c) : "";
      var p = c + "";
      return p == "0" && 1 / c == -1 / 0 ? "-0" : p;
    }
    return YD = s, YD;
  }
  var GD, ZL;
  function zH() {
    if (ZL) return GD;
    ZL = 1;
    var e = ece();
    function t(r) {
      return r == null ? "" : e(r);
    }
    return GD = t, GD;
  }
  var QD, JL;
  function qH() {
    if (JL) return QD;
    JL = 1;
    var e = xo(), t = KN(), r = Jle(), n = zH();
    function i(u, s) {
      return e(u) ? u : t(u, s) ? [u] : r(n(u));
    }
    return QD = i, QD;
  }
  var KD, e6;
  function z_() {
    if (e6) return KD;
    e6 = 1;
    var e = Y0();
    function t(r) {
      if (typeof r == "string" || e(r))
        return r;
      var n = r + "";
      return n == "0" && 1 / r == -1 / 0 ? "-0" : n;
    }
    return KD = t, KD;
  }
  var XD, t6;
  function rj() {
    if (t6) return XD;
    t6 = 1;
    var e = qH(), t = z_();
    function r(n, i) {
      i = e(i, n);
      for (var u = 0, s = i.length; n != null && u < s; )
        n = n[t(i[u++])];
      return u && u == s ? n : void 0;
    }
    return XD = r, XD;
  }
  var ZD, r6;
  function UH() {
    if (r6) return ZD;
    r6 = 1;
    var e = rj();
    function t(r, n, i) {
      var u = r == null ? void 0 : e(r, n);
      return u === void 0 ? i : u;
    }
    return ZD = t, ZD;
  }
  var tce = UH();
  const Su = /* @__PURE__ */ Zr(tce);
  var JD, n6;
  function rce() {
    if (n6) return JD;
    n6 = 1;
    function e(t) {
      return t == null;
    }
    return JD = e, JD;
  }
  var nce = rce();
  const lr = /* @__PURE__ */ Zr(nce);
  var ek, i6;
  function ice() {
    if (i6) return ek;
    i6 = 1;
    var e = Oc(), t = xo(), r = Tc(), n = "[object String]";
    function i(u) {
      return typeof u == "string" || !t(u) && r(u) && e(u) == n;
    }
    return ek = i, ek;
  }
  var ace = ice();
  const Fp = /* @__PURE__ */ Zr(ace);
  var oce = XN();
  const er = /* @__PURE__ */ Zr(oce);
  var uce = Gf();
  const G0 = /* @__PURE__ */ Zr(uce);
  var iE = { exports: {} }, $r = {};
  /**
   * @license React
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var a6;
  function sce() {
    if (a6) return $r;
    a6 = 1;
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.server_context"), p = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), w = Symbol.for("react.offscreen"), E;
    E = Symbol.for("react.module.reference");
    function C(S) {
      if (typeof S == "object" && S !== null) {
        var k = S.$$typeof;
        switch (k) {
          case e:
            switch (S = S.type, S) {
              case r:
              case i:
              case n:
              case h:
              case v:
                return S;
              default:
                switch (S = S && S.$$typeof, S) {
                  case c:
                  case s:
                  case p:
                  case x:
                  case y:
                  case u:
                    return S;
                  default:
                    return k;
                }
            }
          case t:
            return k;
        }
      }
    }
    return $r.ContextConsumer = s, $r.ContextProvider = u, $r.Element = e, $r.ForwardRef = p, $r.Fragment = r, $r.Lazy = x, $r.Memo = y, $r.Portal = t, $r.Profiler = i, $r.StrictMode = n, $r.Suspense = h, $r.SuspenseList = v, $r.isAsyncMode = function() {
      return !1;
    }, $r.isConcurrentMode = function() {
      return !1;
    }, $r.isContextConsumer = function(S) {
      return C(S) === s;
    }, $r.isContextProvider = function(S) {
      return C(S) === u;
    }, $r.isElement = function(S) {
      return typeof S == "object" && S !== null && S.$$typeof === e;
    }, $r.isForwardRef = function(S) {
      return C(S) === p;
    }, $r.isFragment = function(S) {
      return C(S) === r;
    }, $r.isLazy = function(S) {
      return C(S) === x;
    }, $r.isMemo = function(S) {
      return C(S) === y;
    }, $r.isPortal = function(S) {
      return C(S) === t;
    }, $r.isProfiler = function(S) {
      return C(S) === i;
    }, $r.isStrictMode = function(S) {
      return C(S) === n;
    }, $r.isSuspense = function(S) {
      return C(S) === h;
    }, $r.isSuspenseList = function(S) {
      return C(S) === v;
    }, $r.isValidElementType = function(S) {
      return typeof S == "string" || typeof S == "function" || S === r || S === i || S === n || S === h || S === v || S === w || typeof S == "object" && S !== null && (S.$$typeof === x || S.$$typeof === y || S.$$typeof === u || S.$$typeof === s || S.$$typeof === p || S.$$typeof === E || S.getModuleId !== void 0);
    }, $r.typeOf = C, $r;
  }
  var zr = {};
  /**
   * @license React
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var o6;
  function lce() {
    return o6 || (o6 = 1, process.env.NODE_ENV !== "production" && function() {
      var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.server_context"), p = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), w = Symbol.for("react.offscreen"), E = !1, C = !1, S = !1, k = !1, D = !1, A;
      A = Symbol.for("react.module.reference");
      function R(Ne) {
        return !!(typeof Ne == "string" || typeof Ne == "function" || Ne === r || Ne === i || D || Ne === n || Ne === h || Ne === v || k || Ne === w || E || C || S || typeof Ne == "object" && Ne !== null && (Ne.$$typeof === x || Ne.$$typeof === y || Ne.$$typeof === u || Ne.$$typeof === s || Ne.$$typeof === p || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        Ne.$$typeof === A || Ne.getModuleId !== void 0));
      }
      function T(Ne) {
        if (typeof Ne == "object" && Ne !== null) {
          var Ot = Ne.$$typeof;
          switch (Ot) {
            case e:
              var At = Ne.type;
              switch (At) {
                case r:
                case i:
                case n:
                case h:
                case v:
                  return At;
                default:
                  var Qt = At && At.$$typeof;
                  switch (Qt) {
                    case c:
                    case s:
                    case p:
                    case x:
                    case y:
                    case u:
                      return Qt;
                    default:
                      return Ot;
                  }
              }
            case t:
              return Ot;
          }
        }
      }
      var M = s, F = u, B = e, V = p, H = r, q = x, Q = y, W = t, J = i, ne = n, ie = h, se = v, X = !1, fe = !1;
      function Z(Ne) {
        return X || (X = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
      }
      function z(Ne) {
        return fe || (fe = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
      }
      function Y(Ne) {
        return T(Ne) === s;
      }
      function te(Ne) {
        return T(Ne) === u;
      }
      function ae(Ne) {
        return typeof Ne == "object" && Ne !== null && Ne.$$typeof === e;
      }
      function De(Ne) {
        return T(Ne) === p;
      }
      function ke(Ne) {
        return T(Ne) === r;
      }
      function Re(Ne) {
        return T(Ne) === x;
      }
      function Te(Ne) {
        return T(Ne) === y;
      }
      function we(Ne) {
        return T(Ne) === t;
      }
      function Fe(Ne) {
        return T(Ne) === i;
      }
      function Ye(Ne) {
        return T(Ne) === n;
      }
      function de(Ne) {
        return T(Ne) === h;
      }
      function Ze(Ne) {
        return T(Ne) === v;
      }
      zr.ContextConsumer = M, zr.ContextProvider = F, zr.Element = B, zr.ForwardRef = V, zr.Fragment = H, zr.Lazy = q, zr.Memo = Q, zr.Portal = W, zr.Profiler = J, zr.StrictMode = ne, zr.Suspense = ie, zr.SuspenseList = se, zr.isAsyncMode = Z, zr.isConcurrentMode = z, zr.isContextConsumer = Y, zr.isContextProvider = te, zr.isElement = ae, zr.isForwardRef = De, zr.isFragment = ke, zr.isLazy = Re, zr.isMemo = Te, zr.isPortal = we, zr.isProfiler = Fe, zr.isStrictMode = Ye, zr.isSuspense = de, zr.isSuspenseList = Ze, zr.isValidElementType = R, zr.typeOf = T;
    }()), zr;
  }
  var u6;
  function cce() {
    return u6 || (u6 = 1, process.env.NODE_ENV === "production" ? iE.exports = sce() : iE.exports = lce()), iE.exports;
  }
  var fce = cce(), tk, s6;
  function HH() {
    if (s6) return tk;
    s6 = 1;
    var e = Oc(), t = Tc(), r = "[object Number]";
    function n(i) {
      return typeof i == "number" || t(i) && e(i) == r;
    }
    return tk = n, tk;
  }
  var rk, l6;
  function dce() {
    if (l6) return rk;
    l6 = 1;
    var e = HH();
    function t(r) {
      return e(r) && r != +r;
    }
    return rk = t, rk;
  }
  var pce = dce();
  const Ux = /* @__PURE__ */ Zr(pce);
  var hce = HH();
  const vce = /* @__PURE__ */ Zr(hce);
  var ds = function(t) {
    return t === 0 ? 0 : t > 0 ? 1 : -1;
  }, Op = function(t) {
    return Fp(t) && t.indexOf("%") === t.length - 1;
  }, Ke = function(t) {
    return vce(t) && !Ux(t);
  }, ki = function(t) {
    return Ke(t) || Fp(t);
  }, mce = 0, Hx = function(t) {
    var r = ++mce;
    return "".concat(t || "").concat(r);
  }, Ip = function(t, r) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
    if (!Ke(t) && !Fp(t))
      return n;
    var u;
    if (Op(t)) {
      var s = t.indexOf("%");
      u = r * parseFloat(t.slice(0, s)) / 100;
    } else
      u = +t;
    return Ux(u) && (u = n), i && u > r && (u = r), u;
  }, Nf = function(t) {
    if (!t)
      return null;
    var r = Object.keys(t);
    return r && r.length ? t[r[0]] : null;
  }, yce = function(t) {
    if (!Array.isArray(t))
      return !1;
    for (var r = t.length, n = {}, i = 0; i < r; i++)
      if (!n[t[i]])
        n[t[i]] = !0;
      else
        return !0;
    return !1;
  }, cs = function(t, r) {
    return Ke(t) && Ke(r) ? function(n) {
      return t + n * (r - t);
    } : function() {
      return r;
    };
  };
  function wS(e, t, r) {
    return !e || !e.length ? null : e.find(function(n) {
      return n && (typeof t == "function" ? t(n) : Su(n, t)) === r;
    });
  }
  var gce = function(t, r) {
    return Ke(t) && Ke(r) ? t - r : Fp(t) && Fp(r) ? t.localeCompare(r) : t instanceof Date && r instanceof Date ? t.getTime() - r.getTime() : String(t).localeCompare(String(r));
  };
  function e0(e, t) {
    for (var r in e)
      if ({}.hasOwnProperty.call(e, r) && (!{}.hasOwnProperty.call(t, r) || e[r] !== t[r]))
        return !1;
    for (var n in t)
      if ({}.hasOwnProperty.call(t, n) && !{}.hasOwnProperty.call(e, n))
        return !1;
    return !0;
  }
  function LP(e) {
    "@babel/helpers - typeof";
    return LP = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, LP(e);
  }
  var xce = ["viewBox", "children"], bce = [
    "aria-activedescendant",
    "aria-atomic",
    "aria-autocomplete",
    "aria-busy",
    "aria-checked",
    "aria-colcount",
    "aria-colindex",
    "aria-colspan",
    "aria-controls",
    "aria-current",
    "aria-describedby",
    "aria-details",
    "aria-disabled",
    "aria-errormessage",
    "aria-expanded",
    "aria-flowto",
    "aria-haspopup",
    "aria-hidden",
    "aria-invalid",
    "aria-keyshortcuts",
    "aria-label",
    "aria-labelledby",
    "aria-level",
    "aria-live",
    "aria-modal",
    "aria-multiline",
    "aria-multiselectable",
    "aria-orientation",
    "aria-owns",
    "aria-placeholder",
    "aria-posinset",
    "aria-pressed",
    "aria-readonly",
    "aria-relevant",
    "aria-required",
    "aria-roledescription",
    "aria-rowcount",
    "aria-rowindex",
    "aria-rowspan",
    "aria-selected",
    "aria-setsize",
    "aria-sort",
    "aria-valuemax",
    "aria-valuemin",
    "aria-valuenow",
    "aria-valuetext",
    "className",
    "color",
    "height",
    "id",
    "lang",
    "max",
    "media",
    "method",
    "min",
    "name",
    "style",
    /*
     * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
     * that can use it and it conflicts with the recharts prop 'type'
     * https://github.com/recharts/recharts/pull/3327
     * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
     */
    // 'type',
    "target",
    "width",
    "role",
    "tabIndex",
    "accentHeight",
    "accumulate",
    "additive",
    "alignmentBaseline",
    "allowReorder",
    "alphabetic",
    "amplitude",
    "arabicForm",
    "ascent",
    "attributeName",
    "attributeType",
    "autoReverse",
    "azimuth",
    "baseFrequency",
    "baselineShift",
    "baseProfile",
    "bbox",
    "begin",
    "bias",
    "by",
    "calcMode",
    "capHeight",
    "clip",
    "clipPath",
    "clipPathUnits",
    "clipRule",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorProfile",
    "colorRendering",
    "contentScriptType",
    "contentStyleType",
    "cursor",
    "cx",
    "cy",
    "d",
    "decelerate",
    "descent",
    "diffuseConstant",
    "direction",
    "display",
    "divisor",
    "dominantBaseline",
    "dur",
    "dx",
    "dy",
    "edgeMode",
    "elevation",
    "enableBackground",
    "end",
    "exponent",
    "externalResourcesRequired",
    "fill",
    "fillOpacity",
    "fillRule",
    "filter",
    "filterRes",
    "filterUnits",
    "floodColor",
    "floodOpacity",
    "focusable",
    "fontFamily",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "format",
    "from",
    "fx",
    "fy",
    "g1",
    "g2",
    "glyphName",
    "glyphOrientationHorizontal",
    "glyphOrientationVertical",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "hanging",
    "horizAdvX",
    "horizOriginX",
    "href",
    "ideographic",
    "imageRendering",
    "in2",
    "in",
    "intercept",
    "k1",
    "k2",
    "k3",
    "k4",
    "k",
    "kernelMatrix",
    "kernelUnitLength",
    "kerning",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "letterSpacing",
    "lightingColor",
    "limitingConeAngle",
    "local",
    "markerEnd",
    "markerHeight",
    "markerMid",
    "markerStart",
    "markerUnits",
    "markerWidth",
    "mask",
    "maskContentUnits",
    "maskUnits",
    "mathematical",
    "mode",
    "numOctaves",
    "offset",
    "opacity",
    "operator",
    "order",
    "orient",
    "orientation",
    "origin",
    "overflow",
    "overlinePosition",
    "overlineThickness",
    "paintOrder",
    "panose1",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointerEvents",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "r",
    "radius",
    "refX",
    "refY",
    "renderingIntent",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "restart",
    "result",
    "rotate",
    "rx",
    "ry",
    "seed",
    "shapeRendering",
    "slope",
    "spacing",
    "specularConstant",
    "specularExponent",
    "speed",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stemh",
    "stemv",
    "stitchTiles",
    "stopColor",
    "stopOpacity",
    "strikethroughPosition",
    "strikethroughThickness",
    "string",
    "stroke",
    "strokeDasharray",
    "strokeDashoffset",
    "strokeLinecap",
    "strokeLinejoin",
    "strokeMiterlimit",
    "strokeOpacity",
    "strokeWidth",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textAnchor",
    "textDecoration",
    "textLength",
    "textRendering",
    "to",
    "transform",
    "u1",
    "u2",
    "underlinePosition",
    "underlineThickness",
    "unicode",
    "unicodeBidi",
    "unicodeRange",
    "unitsPerEm",
    "vAlphabetic",
    "values",
    "vectorEffect",
    "version",
    "vertAdvY",
    "vertOriginX",
    "vertOriginY",
    "vHanging",
    "vIdeographic",
    "viewTarget",
    "visibility",
    "vMathematical",
    "widths",
    "wordSpacing",
    "writingMode",
    "x1",
    "x2",
    "x",
    "xChannelSelector",
    "xHeight",
    "xlinkActuate",
    "xlinkArcrole",
    "xlinkHref",
    "xlinkRole",
    "xlinkShow",
    "xlinkTitle",
    "xlinkType",
    "xmlBase",
    "xmlLang",
    "xmlns",
    "xmlnsXlink",
    "xmlSpace",
    "y1",
    "y2",
    "y",
    "yChannelSelector",
    "z",
    "zoomAndPan",
    "ref",
    "key",
    "angle"
  ], c6 = ["points", "pathLength"], nk = {
    svg: xce,
    polygon: c6,
    polyline: c6
  }, nj = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], ES = function(t, r) {
    if (!t || typeof t == "function" || typeof t == "boolean")
      return null;
    var n = t;
    if (/* @__PURE__ */ ee.isValidElement(t) && (n = t.props), !G0(n))
      return null;
    var i = {};
    return Object.keys(n).forEach(function(u) {
      nj.includes(u) && (i[u] = r || function(s) {
        return n[u](n, s);
      });
    }), i;
  }, wce = function(t, r, n) {
    return function(i) {
      return t(r, n, i), null;
    };
  }, SS = function(t, r, n) {
    if (!G0(t) || LP(t) !== "object")
      return null;
    var i = null;
    return Object.keys(t).forEach(function(u) {
      var s = t[u];
      nj.includes(u) && typeof s == "function" && (i || (i = {}), i[u] = wce(s, r, n));
    }), i;
  }, Ece = ["children"], Sce = ["children"];
  function f6(e, t) {
    if (e == null) return {};
    var r = _ce(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function _ce(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function $P(e) {
    "@babel/helpers - typeof";
    return $P = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, $P(e);
  }
  var d6 = {
    click: "onClick",
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    mouseover: "onMouseOver",
    mousemove: "onMouseMove",
    mouseout: "onMouseOut",
    mouseenter: "onMouseEnter",
    mouseleave: "onMouseLeave",
    touchcancel: "onTouchCancel",
    touchend: "onTouchEnd",
    touchmove: "onTouchMove",
    touchstart: "onTouchStart",
    contextmenu: "onContextMenu",
    dblclick: "onDoubleClick"
  }, vc = function(t) {
    return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
  }, p6 = null, ik = null, ij = function e(t) {
    if (t === p6 && Array.isArray(ik))
      return ik;
    var r = [];
    return ee.Children.forEach(t, function(n) {
      lr(n) || (fce.isFragment(n) ? r = r.concat(e(n.props.children)) : r.push(n));
    }), ik = r, p6 = t, r;
  };
  function _u(e, t) {
    var r = [], n = [];
    return Array.isArray(t) ? n = t.map(function(i) {
      return vc(i);
    }) : n = [vc(t)], ij(e).forEach(function(i) {
      var u = Su(i, "type.displayName") || Su(i, "type.name");
      n.indexOf(u) !== -1 && r.push(i);
    }), r;
  }
  function $o(e, t) {
    var r = _u(e, t);
    return r && r[0];
  }
  var h6 = function(t) {
    if (!t || !t.props)
      return !1;
    var r = t.props, n = r.width, i = r.height;
    return !(!Ke(n) || n <= 0 || !Ke(i) || i <= 0);
  }, Cce = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], Oce = function(t) {
    return t && t.type && Fp(t.type) && Cce.indexOf(t.type) >= 0;
  }, Tce = function(t) {
    return t && $P(t) === "object" && "clipDot" in t;
  }, Ace = function(t, r, n, i) {
    var u, s = (u = nk == null ? void 0 : nk[i]) !== null && u !== void 0 ? u : [];
    return r.startsWith("data-") || !er(t) && (i && s.includes(r) || bce.includes(r)) || n && nj.includes(r);
  }, pr = function(t, r, n) {
    if (!t || typeof t == "function" || typeof t == "boolean")
      return null;
    var i = t;
    if (/* @__PURE__ */ ee.isValidElement(t) && (i = t.props), !G0(i))
      return null;
    var u = {};
    return Object.keys(i).forEach(function(s) {
      var c;
      Ace((c = i) === null || c === void 0 ? void 0 : c[s], s, r, n) && (u[s] = i[s]);
    }), u;
  }, zP = function e(t, r) {
    if (t === r)
      return !0;
    var n = ee.Children.count(t);
    if (n !== ee.Children.count(r))
      return !1;
    if (n === 0)
      return !0;
    if (n === 1)
      return v6(Array.isArray(t) ? t[0] : t, Array.isArray(r) ? r[0] : r);
    for (var i = 0; i < n; i++) {
      var u = t[i], s = r[i];
      if (Array.isArray(u) || Array.isArray(s)) {
        if (!e(u, s))
          return !1;
      } else if (!v6(u, s))
        return !1;
    }
    return !0;
  }, v6 = function(t, r) {
    if (lr(t) && lr(r))
      return !0;
    if (!lr(t) && !lr(r)) {
      var n = t.props || {}, i = n.children, u = f6(n, Ece), s = r.props || {}, c = s.children, p = f6(s, Sce);
      return i && c ? e0(u, p) && zP(i, c) : !i && !c ? e0(u, p) : !1;
    }
    return !1;
  }, m6 = function(t, r) {
    var n = [], i = {};
    return ij(t).forEach(function(u, s) {
      if (Oce(u))
        n.push(u);
      else if (u) {
        var c = vc(u.type), p = r[c] || {}, h = p.handler, v = p.once;
        if (h && (!v || !i[c])) {
          var y = h(u, c, s);
          n.push(y), i[c] = !0;
        }
      }
    }), n;
  }, Dce = function(t) {
    var r = t && t.type;
    return r && d6[r] ? d6[r] : null;
  }, kce = function(t, r) {
    return ij(r).indexOf(t);
  }, Rce = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
  function qP() {
    return qP = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, qP.apply(this, arguments);
  }
  function Pce(e, t) {
    if (e == null) return {};
    var r = Mce(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function Mce(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function UP(e) {
    var t = e.children, r = e.width, n = e.height, i = e.viewBox, u = e.className, s = e.style, c = e.title, p = e.desc, h = Pce(e, Rce), v = i || {
      width: r,
      height: n,
      x: 0,
      y: 0
    }, y = hr("recharts-surface", u);
    return /* @__PURE__ */ ce.createElement("svg", qP({}, pr(h, !0, "svg"), {
      className: y,
      width: r,
      height: n,
      style: s,
      viewBox: "".concat(v.x, " ").concat(v.y, " ").concat(v.width, " ").concat(v.height)
    }), /* @__PURE__ */ ce.createElement("title", null, c), /* @__PURE__ */ ce.createElement("desc", null, p), t);
  }
  var Nce = ["children", "className"];
  function HP() {
    return HP = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, HP.apply(this, arguments);
  }
  function jce(e, t) {
    if (e == null) return {};
    var r = Fce(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function Fce(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  var ei = /* @__PURE__ */ ce.forwardRef(function(e, t) {
    var r = e.children, n = e.className, i = jce(e, Nce), u = hr("recharts-layer", n);
    return /* @__PURE__ */ ce.createElement("g", HP({
      className: u
    }, pr(i, !0), {
      ref: t
    }), r);
  }), Ice = process.env.NODE_ENV !== "production", mc = function(t, r) {
    for (var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), u = 2; u < n; u++)
      i[u - 2] = arguments[u];
    if (Ice && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
      if (r === void 0)
        console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      else {
        var s = 0;
        console.warn(r.replace(/%s/g, function() {
          return i[s++];
        }));
      }
  }, ak, y6;
  function Bce() {
    if (y6) return ak;
    y6 = 1;
    function e(t, r, n) {
      var i = -1, u = t.length;
      r < 0 && (r = -r > u ? 0 : u + r), n = n > u ? u : n, n < 0 && (n += u), u = r > n ? 0 : n - r >>> 0, r >>>= 0;
      for (var s = Array(u); ++i < u; )
        s[i] = t[i + r];
      return s;
    }
    return ak = e, ak;
  }
  var ok, g6;
  function Lce() {
    if (g6) return ok;
    g6 = 1;
    var e = Bce();
    function t(r, n, i) {
      var u = r.length;
      return i = i === void 0 ? u : i, !n && i >= u ? r : e(r, n, i);
    }
    return ok = t, ok;
  }
  var uk, x6;
  function VH() {
    if (x6) return uk;
    x6 = 1;
    var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", i = t + r + n, u = "\\ufe0e\\ufe0f", s = "\\u200d", c = RegExp("[" + s + e + i + u + "]");
    function p(h) {
      return c.test(h);
    }
    return uk = p, uk;
  }
  var sk, b6;
  function $ce() {
    if (b6) return sk;
    b6 = 1;
    function e(t) {
      return t.split("");
    }
    return sk = e, sk;
  }
  var lk, w6;
  function zce() {
    if (w6) return lk;
    w6 = 1;
    var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", i = t + r + n, u = "\\ufe0e\\ufe0f", s = "[" + e + "]", c = "[" + i + "]", p = "\\ud83c[\\udffb-\\udfff]", h = "(?:" + c + "|" + p + ")", v = "[^" + e + "]", y = "(?:\\ud83c[\\udde6-\\uddff]){2}", x = "[\\ud800-\\udbff][\\udc00-\\udfff]", w = "\\u200d", E = h + "?", C = "[" + u + "]?", S = "(?:" + w + "(?:" + [v, y, x].join("|") + ")" + C + E + ")*", k = C + E + S, D = "(?:" + [v + c + "?", c, y, x, s].join("|") + ")", A = RegExp(p + "(?=" + p + ")|" + D + k, "g");
    function R(T) {
      return T.match(A) || [];
    }
    return lk = R, lk;
  }
  var ck, E6;
  function qce() {
    if (E6) return ck;
    E6 = 1;
    var e = $ce(), t = VH(), r = zce();
    function n(i) {
      return t(i) ? r(i) : e(i);
    }
    return ck = n, ck;
  }
  var fk, S6;
  function Uce() {
    if (S6) return fk;
    S6 = 1;
    var e = Lce(), t = VH(), r = qce(), n = zH();
    function i(u) {
      return function(s) {
        s = n(s);
        var c = t(s) ? r(s) : void 0, p = c ? c[0] : s.charAt(0), h = c ? e(c, 1).join("") : s.slice(1);
        return p[u]() + h;
      };
    }
    return fk = i, fk;
  }
  var dk, _6;
  function Hce() {
    if (_6) return dk;
    _6 = 1;
    var e = Uce(), t = e("toUpperCase");
    return dk = t, dk;
  }
  var Vce = Hce();
  const q_ = /* @__PURE__ */ Zr(Vce);
  function dn(e) {
    return function() {
      return e;
    };
  }
  const WH = Math.cos, _S = Math.sin, gs = Math.sqrt, CS = Math.PI, U_ = 2 * CS, VP = Math.PI, WP = 2 * VP, xp = 1e-6, Wce = WP - xp;
  function YH(e) {
    this._ += e[0];
    for (let t = 1, r = e.length; t < r; ++t)
      this._ += arguments[t] + e[t];
  }
  function Yce(e) {
    let t = Math.floor(e);
    if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
    if (t > 15) return YH;
    const r = 10 ** t;
    return function(n) {
      this._ += n[0];
      for (let i = 1, u = n.length; i < u; ++i)
        this._ += Math.round(arguments[i] * r) / r + n[i];
    };
  }
  class Gce {
    constructor(t) {
      this._x0 = this._y0 = // start of current subpath
      this._x1 = this._y1 = null, this._ = "", this._append = t == null ? YH : Yce(t);
    }
    moveTo(t, r) {
      this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}`;
    }
    closePath() {
      this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
    }
    lineTo(t, r) {
      this._append`L${this._x1 = +t},${this._y1 = +r}`;
    }
    quadraticCurveTo(t, r, n, i) {
      this._append`Q${+t},${+r},${this._x1 = +n},${this._y1 = +i}`;
    }
    bezierCurveTo(t, r, n, i, u, s) {
      this._append`C${+t},${+r},${+n},${+i},${this._x1 = +u},${this._y1 = +s}`;
    }
    arcTo(t, r, n, i, u) {
      if (t = +t, r = +r, n = +n, i = +i, u = +u, u < 0) throw new Error(`negative radius: ${u}`);
      let s = this._x1, c = this._y1, p = n - t, h = i - r, v = s - t, y = c - r, x = v * v + y * y;
      if (this._x1 === null)
        this._append`M${this._x1 = t},${this._y1 = r}`;
      else if (x > xp) if (!(Math.abs(y * p - h * v) > xp) || !u)
        this._append`L${this._x1 = t},${this._y1 = r}`;
      else {
        let w = n - s, E = i - c, C = p * p + h * h, S = w * w + E * E, k = Math.sqrt(C), D = Math.sqrt(x), A = u * Math.tan((VP - Math.acos((C + x - S) / (2 * k * D))) / 2), R = A / D, T = A / k;
        Math.abs(R - 1) > xp && this._append`L${t + R * v},${r + R * y}`, this._append`A${u},${u},0,0,${+(y * w > v * E)},${this._x1 = t + T * p},${this._y1 = r + T * h}`;
      }
    }
    arc(t, r, n, i, u, s) {
      if (t = +t, r = +r, n = +n, s = !!s, n < 0) throw new Error(`negative radius: ${n}`);
      let c = n * Math.cos(i), p = n * Math.sin(i), h = t + c, v = r + p, y = 1 ^ s, x = s ? i - u : u - i;
      this._x1 === null ? this._append`M${h},${v}` : (Math.abs(this._x1 - h) > xp || Math.abs(this._y1 - v) > xp) && this._append`L${h},${v}`, n && (x < 0 && (x = x % WP + WP), x > Wce ? this._append`A${n},${n},0,1,${y},${t - c},${r - p}A${n},${n},0,1,${y},${this._x1 = h},${this._y1 = v}` : x > xp && this._append`A${n},${n},0,${+(x >= VP)},${y},${this._x1 = t + n * Math.cos(u)},${this._y1 = r + n * Math.sin(u)}`);
    }
    rect(t, r, n, i) {
      this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}h${n = +n}v${+i}h${-n}Z`;
    }
    toString() {
      return this._;
    }
  }
  function aj(e) {
    let t = 3;
    return e.digits = function(r) {
      if (!arguments.length) return t;
      if (r == null)
        t = null;
      else {
        const n = Math.floor(r);
        if (!(n >= 0)) throw new RangeError(`invalid digits: ${r}`);
        t = n;
      }
      return e;
    }, () => new Gce(t);
  }
  function oj(e) {
    return typeof e == "object" && "length" in e ? e : Array.from(e);
  }
  function GH(e) {
    this._context = e;
  }
  GH.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._point = 0;
    },
    lineEnd: function() {
      (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
    },
    point: function(e, t) {
      switch (e = +e, t = +t, this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
        // falls through
        default:
          this._context.lineTo(e, t);
          break;
      }
    }
  };
  function H_(e) {
    return new GH(e);
  }
  function QH(e) {
    return e[0];
  }
  function KH(e) {
    return e[1];
  }
  function XH(e, t) {
    var r = dn(!0), n = null, i = H_, u = null, s = aj(c);
    e = typeof e == "function" ? e : e === void 0 ? QH : dn(e), t = typeof t == "function" ? t : t === void 0 ? KH : dn(t);
    function c(p) {
      var h, v = (p = oj(p)).length, y, x = !1, w;
      for (n == null && (u = i(w = s())), h = 0; h <= v; ++h)
        !(h < v && r(y = p[h], h, p)) === x && ((x = !x) ? u.lineStart() : u.lineEnd()), x && u.point(+e(y, h, p), +t(y, h, p));
      if (w) return u = null, w + "" || null;
    }
    return c.x = function(p) {
      return arguments.length ? (e = typeof p == "function" ? p : dn(+p), c) : e;
    }, c.y = function(p) {
      return arguments.length ? (t = typeof p == "function" ? p : dn(+p), c) : t;
    }, c.defined = function(p) {
      return arguments.length ? (r = typeof p == "function" ? p : dn(!!p), c) : r;
    }, c.curve = function(p) {
      return arguments.length ? (i = p, n != null && (u = i(n)), c) : i;
    }, c.context = function(p) {
      return arguments.length ? (p == null ? n = u = null : u = i(n = p), c) : n;
    }, c;
  }
  function aE(e, t, r) {
    var n = null, i = dn(!0), u = null, s = H_, c = null, p = aj(h);
    e = typeof e == "function" ? e : e === void 0 ? QH : dn(+e), t = typeof t == "function" ? t : dn(t === void 0 ? 0 : +t), r = typeof r == "function" ? r : r === void 0 ? KH : dn(+r);
    function h(y) {
      var x, w, E, C = (y = oj(y)).length, S, k = !1, D, A = new Array(C), R = new Array(C);
      for (u == null && (c = s(D = p())), x = 0; x <= C; ++x) {
        if (!(x < C && i(S = y[x], x, y)) === k)
          if (k = !k)
            w = x, c.areaStart(), c.lineStart();
          else {
            for (c.lineEnd(), c.lineStart(), E = x - 1; E >= w; --E)
              c.point(A[E], R[E]);
            c.lineEnd(), c.areaEnd();
          }
        k && (A[x] = +e(S, x, y), R[x] = +t(S, x, y), c.point(n ? +n(S, x, y) : A[x], r ? +r(S, x, y) : R[x]));
      }
      if (D) return c = null, D + "" || null;
    }
    function v() {
      return XH().defined(i).curve(s).context(u);
    }
    return h.x = function(y) {
      return arguments.length ? (e = typeof y == "function" ? y : dn(+y), n = null, h) : e;
    }, h.x0 = function(y) {
      return arguments.length ? (e = typeof y == "function" ? y : dn(+y), h) : e;
    }, h.x1 = function(y) {
      return arguments.length ? (n = y == null ? null : typeof y == "function" ? y : dn(+y), h) : n;
    }, h.y = function(y) {
      return arguments.length ? (t = typeof y == "function" ? y : dn(+y), r = null, h) : t;
    }, h.y0 = function(y) {
      return arguments.length ? (t = typeof y == "function" ? y : dn(+y), h) : t;
    }, h.y1 = function(y) {
      return arguments.length ? (r = y == null ? null : typeof y == "function" ? y : dn(+y), h) : r;
    }, h.lineX0 = h.lineY0 = function() {
      return v().x(e).y(t);
    }, h.lineY1 = function() {
      return v().x(e).y(r);
    }, h.lineX1 = function() {
      return v().x(n).y(t);
    }, h.defined = function(y) {
      return arguments.length ? (i = typeof y == "function" ? y : dn(!!y), h) : i;
    }, h.curve = function(y) {
      return arguments.length ? (s = y, u != null && (c = s(u)), h) : s;
    }, h.context = function(y) {
      return arguments.length ? (y == null ? u = c = null : c = s(u = y), h) : u;
    }, h;
  }
  class ZH {
    constructor(t, r) {
      this._context = t, this._x = r;
    }
    areaStart() {
      this._line = 0;
    }
    areaEnd() {
      this._line = NaN;
    }
    lineStart() {
      this._point = 0;
    }
    lineEnd() {
      (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
    }
    point(t, r) {
      switch (t = +t, r = +r, this._point) {
        case 0: {
          this._point = 1, this._line ? this._context.lineTo(t, r) : this._context.moveTo(t, r);
          break;
        }
        case 1:
          this._point = 2;
        // falls through
        default: {
          this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, r, t, r) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + r) / 2, t, this._y0, t, r);
          break;
        }
      }
      this._x0 = t, this._y0 = r;
    }
  }
  function Qce(e) {
    return new ZH(e, !0);
  }
  function Kce(e) {
    return new ZH(e, !1);
  }
  const uj = {
    draw(e, t) {
      const r = gs(t / CS);
      e.moveTo(r, 0), e.arc(0, 0, r, 0, U_);
    }
  }, Xce = {
    draw(e, t) {
      const r = gs(t / 5) / 2;
      e.moveTo(-3 * r, -r), e.lineTo(-r, -r), e.lineTo(-r, -3 * r), e.lineTo(r, -3 * r), e.lineTo(r, -r), e.lineTo(3 * r, -r), e.lineTo(3 * r, r), e.lineTo(r, r), e.lineTo(r, 3 * r), e.lineTo(-r, 3 * r), e.lineTo(-r, r), e.lineTo(-3 * r, r), e.closePath();
    }
  }, JH = gs(1 / 3), Zce = JH * 2, Jce = {
    draw(e, t) {
      const r = gs(t / Zce), n = r * JH;
      e.moveTo(0, -r), e.lineTo(n, 0), e.lineTo(0, r), e.lineTo(-n, 0), e.closePath();
    }
  }, efe = {
    draw(e, t) {
      const r = gs(t), n = -r / 2;
      e.rect(n, n, r, r);
    }
  }, tfe = 0.8908130915292852, eV = _S(CS / 10) / _S(7 * CS / 10), rfe = _S(U_ / 10) * eV, nfe = -WH(U_ / 10) * eV, ife = {
    draw(e, t) {
      const r = gs(t * tfe), n = rfe * r, i = nfe * r;
      e.moveTo(0, -r), e.lineTo(n, i);
      for (let u = 1; u < 5; ++u) {
        const s = U_ * u / 5, c = WH(s), p = _S(s);
        e.lineTo(p * r, -c * r), e.lineTo(c * n - p * i, p * n + c * i);
      }
      e.closePath();
    }
  }, pk = gs(3), afe = {
    draw(e, t) {
      const r = -gs(t / (pk * 3));
      e.moveTo(0, r * 2), e.lineTo(-pk * r, -r), e.lineTo(pk * r, -r), e.closePath();
    }
  }, bu = -0.5, wu = gs(3) / 2, YP = 1 / gs(12), ofe = (YP / 2 + 1) * 3, ufe = {
    draw(e, t) {
      const r = gs(t / ofe), n = r / 2, i = r * YP, u = n, s = r * YP + r, c = -u, p = s;
      e.moveTo(n, i), e.lineTo(u, s), e.lineTo(c, p), e.lineTo(bu * n - wu * i, wu * n + bu * i), e.lineTo(bu * u - wu * s, wu * u + bu * s), e.lineTo(bu * c - wu * p, wu * c + bu * p), e.lineTo(bu * n + wu * i, bu * i - wu * n), e.lineTo(bu * u + wu * s, bu * s - wu * u), e.lineTo(bu * c + wu * p, bu * p - wu * c), e.closePath();
    }
  };
  function sfe(e, t) {
    let r = null, n = aj(i);
    e = typeof e == "function" ? e : dn(e || uj), t = typeof t == "function" ? t : dn(t === void 0 ? 64 : +t);
    function i() {
      let u;
      if (r || (r = u = n()), e.apply(this, arguments).draw(r, +t.apply(this, arguments)), u) return r = null, u + "" || null;
    }
    return i.type = function(u) {
      return arguments.length ? (e = typeof u == "function" ? u : dn(u), i) : e;
    }, i.size = function(u) {
      return arguments.length ? (t = typeof u == "function" ? u : dn(+u), i) : t;
    }, i.context = function(u) {
      return arguments.length ? (r = u ?? null, i) : r;
    }, i;
  }
  function OS() {
  }
  function TS(e, t, r) {
    e._context.bezierCurveTo(
      (2 * e._x0 + e._x1) / 3,
      (2 * e._y0 + e._y1) / 3,
      (e._x0 + 2 * e._x1) / 3,
      (e._y0 + 2 * e._y1) / 3,
      (e._x0 + 4 * e._x1 + t) / 6,
      (e._y0 + 4 * e._y1 + r) / 6
    );
  }
  function tV(e) {
    this._context = e;
  }
  tV.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
    },
    lineEnd: function() {
      switch (this._point) {
        case 3:
          TS(this, this._x1, this._y1);
        // falls through
        case 2:
          this._context.lineTo(this._x1, this._y1);
          break;
      }
      (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
    },
    point: function(e, t) {
      switch (e = +e, t = +t, this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
        // falls through
        default:
          TS(this, e, t);
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
    }
  };
  function lfe(e) {
    return new tV(e);
  }
  function rV(e) {
    this._context = e;
  }
  rV.prototype = {
    areaStart: OS,
    areaEnd: OS,
    lineStart: function() {
      this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
    },
    lineEnd: function() {
      switch (this._point) {
        case 1: {
          this._context.moveTo(this._x2, this._y2), this._context.closePath();
          break;
        }
        case 2: {
          this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
          break;
        }
        case 3: {
          this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
          break;
        }
      }
    },
    point: function(e, t) {
      switch (e = +e, t = +t, this._point) {
        case 0:
          this._point = 1, this._x2 = e, this._y2 = t;
          break;
        case 1:
          this._point = 2, this._x3 = e, this._y3 = t;
          break;
        case 2:
          this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
          break;
        default:
          TS(this, e, t);
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
    }
  };
  function cfe(e) {
    return new rV(e);
  }
  function nV(e) {
    this._context = e;
  }
  nV.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
    },
    lineEnd: function() {
      (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
    },
    point: function(e, t) {
      switch (e = +e, t = +t, this._point) {
        case 0:
          this._point = 1;
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3;
          var r = (this._x0 + 4 * this._x1 + e) / 6, n = (this._y0 + 4 * this._y1 + t) / 6;
          this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
          break;
        case 3:
          this._point = 4;
        // falls through
        default:
          TS(this, e, t);
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
    }
  };
  function ffe(e) {
    return new nV(e);
  }
  function iV(e) {
    this._context = e;
  }
  iV.prototype = {
    areaStart: OS,
    areaEnd: OS,
    lineStart: function() {
      this._point = 0;
    },
    lineEnd: function() {
      this._point && this._context.closePath();
    },
    point: function(e, t) {
      e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
    }
  };
  function dfe(e) {
    return new iV(e);
  }
  function C6(e) {
    return e < 0 ? -1 : 1;
  }
  function O6(e, t, r) {
    var n = e._x1 - e._x0, i = t - e._x1, u = (e._y1 - e._y0) / (n || i < 0 && -0), s = (r - e._y1) / (i || n < 0 && -0), c = (u * i + s * n) / (n + i);
    return (C6(u) + C6(s)) * Math.min(Math.abs(u), Math.abs(s), 0.5 * Math.abs(c)) || 0;
  }
  function T6(e, t) {
    var r = e._x1 - e._x0;
    return r ? (3 * (e._y1 - e._y0) / r - t) / 2 : t;
  }
  function hk(e, t, r) {
    var n = e._x0, i = e._y0, u = e._x1, s = e._y1, c = (u - n) / 3;
    e._context.bezierCurveTo(n + c, i + c * t, u - c, s - c * r, u, s);
  }
  function AS(e) {
    this._context = e;
  }
  AS.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
    },
    lineEnd: function() {
      switch (this._point) {
        case 2:
          this._context.lineTo(this._x1, this._y1);
          break;
        case 3:
          hk(this, this._t0, T6(this, this._t0));
          break;
      }
      (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
    },
    point: function(e, t) {
      var r = NaN;
      if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
        switch (this._point) {
          case 0:
            this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
            break;
          case 1:
            this._point = 2;
            break;
          case 2:
            this._point = 3, hk(this, T6(this, r = O6(this, e, t)), r);
            break;
          default:
            hk(this, this._t0, r = O6(this, e, t));
            break;
        }
        this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = r;
      }
    }
  };
  function aV(e) {
    this._context = new oV(e);
  }
  (aV.prototype = Object.create(AS.prototype)).point = function(e, t) {
    AS.prototype.point.call(this, t, e);
  };
  function oV(e) {
    this._context = e;
  }
  oV.prototype = {
    moveTo: function(e, t) {
      this._context.moveTo(t, e);
    },
    closePath: function() {
      this._context.closePath();
    },
    lineTo: function(e, t) {
      this._context.lineTo(t, e);
    },
    bezierCurveTo: function(e, t, r, n, i, u) {
      this._context.bezierCurveTo(t, e, n, r, u, i);
    }
  };
  function pfe(e) {
    return new AS(e);
  }
  function hfe(e) {
    return new aV(e);
  }
  function uV(e) {
    this._context = e;
  }
  uV.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x = [], this._y = [];
    },
    lineEnd: function() {
      var e = this._x, t = this._y, r = e.length;
      if (r)
        if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), r === 2)
          this._context.lineTo(e[1], t[1]);
        else
          for (var n = A6(e), i = A6(t), u = 0, s = 1; s < r; ++u, ++s)
            this._context.bezierCurveTo(n[0][u], i[0][u], n[1][u], i[1][u], e[s], t[s]);
      (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
    },
    point: function(e, t) {
      this._x.push(+e), this._y.push(+t);
    }
  };
  function A6(e) {
    var t, r = e.length - 1, n, i = new Array(r), u = new Array(r), s = new Array(r);
    for (i[0] = 0, u[0] = 2, s[0] = e[0] + 2 * e[1], t = 1; t < r - 1; ++t) i[t] = 1, u[t] = 4, s[t] = 4 * e[t] + 2 * e[t + 1];
    for (i[r - 1] = 2, u[r - 1] = 7, s[r - 1] = 8 * e[r - 1] + e[r], t = 1; t < r; ++t) n = i[t] / u[t - 1], u[t] -= n, s[t] -= n * s[t - 1];
    for (i[r - 1] = s[r - 1] / u[r - 1], t = r - 2; t >= 0; --t) i[t] = (s[t] - i[t + 1]) / u[t];
    for (u[r - 1] = (e[r] + i[r - 1]) / 2, t = 0; t < r - 1; ++t) u[t] = 2 * e[t + 1] - i[t + 1];
    return [i, u];
  }
  function vfe(e) {
    return new uV(e);
  }
  function V_(e, t) {
    this._context = e, this._t = t;
  }
  V_.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x = this._y = NaN, this._point = 0;
    },
    lineEnd: function() {
      0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
    },
    point: function(e, t) {
      switch (e = +e, t = +t, this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
        // falls through
        default: {
          if (this._t <= 0)
            this._context.lineTo(this._x, t), this._context.lineTo(e, t);
          else {
            var r = this._x * (1 - this._t) + e * this._t;
            this._context.lineTo(r, this._y), this._context.lineTo(r, t);
          }
          break;
        }
      }
      this._x = e, this._y = t;
    }
  };
  function mfe(e) {
    return new V_(e, 0.5);
  }
  function yfe(e) {
    return new V_(e, 0);
  }
  function gfe(e) {
    return new V_(e, 1);
  }
  function f0(e, t) {
    if ((s = e.length) > 1)
      for (var r = 1, n, i, u = e[t[0]], s, c = u.length; r < s; ++r)
        for (i = u, u = e[t[r]], n = 0; n < c; ++n)
          u[n][1] += u[n][0] = isNaN(i[n][1]) ? i[n][0] : i[n][1];
  }
  function GP(e) {
    for (var t = e.length, r = new Array(t); --t >= 0; ) r[t] = t;
    return r;
  }
  function xfe(e, t) {
    return e[t];
  }
  function bfe(e) {
    const t = [];
    return t.key = e, t;
  }
  function wfe() {
    var e = dn([]), t = GP, r = f0, n = xfe;
    function i(u) {
      var s = Array.from(e.apply(this, arguments), bfe), c, p = s.length, h = -1, v;
      for (const y of u)
        for (c = 0, ++h; c < p; ++c)
          (s[c][h] = [0, +n(y, s[c].key, h, u)]).data = y;
      for (c = 0, v = oj(t(s)); c < p; ++c)
        s[v[c]].index = c;
      return r(s, v), s;
    }
    return i.keys = function(u) {
      return arguments.length ? (e = typeof u == "function" ? u : dn(Array.from(u)), i) : e;
    }, i.value = function(u) {
      return arguments.length ? (n = typeof u == "function" ? u : dn(+u), i) : n;
    }, i.order = function(u) {
      return arguments.length ? (t = u == null ? GP : typeof u == "function" ? u : dn(Array.from(u)), i) : t;
    }, i.offset = function(u) {
      return arguments.length ? (r = u ?? f0, i) : r;
    }, i;
  }
  function Efe(e, t) {
    if ((n = e.length) > 0) {
      for (var r, n, i = 0, u = e[0].length, s; i < u; ++i) {
        for (s = r = 0; r < n; ++r) s += e[r][i][1] || 0;
        if (s) for (r = 0; r < n; ++r) e[r][i][1] /= s;
      }
      f0(e, t);
    }
  }
  function Sfe(e, t) {
    if ((i = e.length) > 0) {
      for (var r = 0, n = e[t[0]], i, u = n.length; r < u; ++r) {
        for (var s = 0, c = 0; s < i; ++s) c += e[s][r][1] || 0;
        n[r][1] += n[r][0] = -c / 2;
      }
      f0(e, t);
    }
  }
  function _fe(e, t) {
    if (!(!((s = e.length) > 0) || !((u = (i = e[t[0]]).length) > 0))) {
      for (var r = 0, n = 1, i, u, s; n < u; ++n) {
        for (var c = 0, p = 0, h = 0; c < s; ++c) {
          for (var v = e[t[c]], y = v[n][1] || 0, x = v[n - 1][1] || 0, w = (y - x) / 2, E = 0; E < c; ++E) {
            var C = e[t[E]], S = C[n][1] || 0, k = C[n - 1][1] || 0;
            w += S - k;
          }
          p += y, h += w * y;
        }
        i[n - 1][1] += i[n - 1][0] = r, p && (r -= h / p);
      }
      i[n - 1][1] += i[n - 1][0] = r, f0(e, t);
    }
  }
  function ex(e) {
    "@babel/helpers - typeof";
    return ex = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, ex(e);
  }
  var Cfe = ["type", "size", "sizeType"];
  function QP() {
    return QP = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, QP.apply(this, arguments);
  }
  function D6(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function k6(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? D6(Object(r), !0).forEach(function(n) {
        Ofe(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : D6(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Ofe(e, t, r) {
    return t = Tfe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Tfe(e) {
    var t = Afe(e, "string");
    return ex(t) == "symbol" ? t : t + "";
  }
  function Afe(e, t) {
    if (ex(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (ex(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Dfe(e, t) {
    if (e == null) return {};
    var r = kfe(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function kfe(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  var sV = {
    symbolCircle: uj,
    symbolCross: Xce,
    symbolDiamond: Jce,
    symbolSquare: efe,
    symbolStar: ife,
    symbolTriangle: afe,
    symbolWye: ufe
  }, Rfe = Math.PI / 180, Pfe = function(t) {
    var r = "symbol".concat(q_(t));
    return sV[r] || uj;
  }, Mfe = function(t, r, n) {
    if (r === "area")
      return t;
    switch (n) {
      case "cross":
        return 5 * t * t / 9;
      case "diamond":
        return 0.5 * t * t / Math.sqrt(3);
      case "square":
        return t * t;
      case "star": {
        var i = 18 * Rfe;
        return 1.25 * t * t * (Math.tan(i) - Math.tan(i * 2) * Math.pow(Math.tan(i), 2));
      }
      case "triangle":
        return Math.sqrt(3) * t * t / 4;
      case "wye":
        return (21 - 10 * Math.sqrt(3)) * t * t / 8;
      default:
        return Math.PI * t * t / 4;
    }
  }, Nfe = function(t, r) {
    sV["symbol".concat(q_(t))] = r;
  }, sj = function(t) {
    var r = t.type, n = r === void 0 ? "circle" : r, i = t.size, u = i === void 0 ? 64 : i, s = t.sizeType, c = s === void 0 ? "area" : s, p = Dfe(t, Cfe), h = k6(k6({}, p), {}, {
      type: n,
      size: u,
      sizeType: c
    }), v = function() {
      var S = Pfe(n), k = sfe().type(S).size(Mfe(u, c, n));
      return k();
    }, y = h.className, x = h.cx, w = h.cy, E = pr(h, !0);
    return x === +x && w === +w && u === +u ? /* @__PURE__ */ ce.createElement("path", QP({}, E, {
      className: hr("recharts-symbols", y),
      transform: "translate(".concat(x, ", ").concat(w, ")"),
      d: v()
    })) : null;
  };
  sj.registerSymbol = Nfe;
  function d0(e) {
    "@babel/helpers - typeof";
    return d0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, d0(e);
  }
  function KP() {
    return KP = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, KP.apply(this, arguments);
  }
  function R6(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function jfe(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? R6(Object(r), !0).forEach(function(n) {
        tx(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : R6(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Ffe(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function Ife(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, cV(n.key), n);
    }
  }
  function Bfe(e, t, r) {
    return t && Ife(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function Lfe(e, t, r) {
    return t = DS(t), $fe(e, lV() ? Reflect.construct(t, r || [], DS(e).constructor) : t.apply(e, r));
  }
  function $fe(e, t) {
    if (t && (d0(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return zfe(e);
  }
  function zfe(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function lV() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (lV = function() {
      return !!e;
    })();
  }
  function DS(e) {
    return DS = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, DS(e);
  }
  function qfe(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && XP(e, t);
  }
  function XP(e, t) {
    return XP = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, XP(e, t);
  }
  function tx(e, t, r) {
    return t = cV(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function cV(e) {
    var t = Ufe(e, "string");
    return d0(t) == "symbol" ? t : t + "";
  }
  function Ufe(e, t) {
    if (d0(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (d0(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var is = 32, lj = /* @__PURE__ */ function(e) {
    function t() {
      return Ffe(this, t), Lfe(this, t, arguments);
    }
    return qfe(t, e), Bfe(t, [{
      key: "renderIcon",
      value: (
        /**
         * Render the path of icon
         * @param {Object} data Data of each legend item
         * @return {String} Path element
         */
        function(n) {
          var i = this.props.inactiveColor, u = is / 2, s = is / 6, c = is / 3, p = n.inactive ? i : n.color;
          if (n.type === "plainline")
            return /* @__PURE__ */ ce.createElement("line", {
              strokeWidth: 4,
              fill: "none",
              stroke: p,
              strokeDasharray: n.payload.strokeDasharray,
              x1: 0,
              y1: u,
              x2: is,
              y2: u,
              className: "recharts-legend-icon"
            });
          if (n.type === "line")
            return /* @__PURE__ */ ce.createElement("path", {
              strokeWidth: 4,
              fill: "none",
              stroke: p,
              d: "M0,".concat(u, "h").concat(c, `
            A`).concat(s, ",").concat(s, ",0,1,1,").concat(2 * c, ",").concat(u, `
            H`).concat(is, "M").concat(2 * c, ",").concat(u, `
            A`).concat(s, ",").concat(s, ",0,1,1,").concat(c, ",").concat(u),
              className: "recharts-legend-icon"
            });
          if (n.type === "rect")
            return /* @__PURE__ */ ce.createElement("path", {
              stroke: "none",
              fill: p,
              d: "M0,".concat(is / 8, "h").concat(is, "v").concat(is * 3 / 4, "h").concat(-32, "z"),
              className: "recharts-legend-icon"
            });
          if (/* @__PURE__ */ ce.isValidElement(n.legendIcon)) {
            var h = jfe({}, n);
            return delete h.legendIcon, /* @__PURE__ */ ce.cloneElement(n.legendIcon, h);
          }
          return /* @__PURE__ */ ce.createElement(sj, {
            fill: p,
            cx: u,
            cy: u,
            size: is,
            sizeType: "diameter",
            type: n.type
          });
        }
      )
      /**
       * Draw items of legend
       * @return {ReactElement} Items
       */
    }, {
      key: "renderItems",
      value: function() {
        var n = this, i = this.props, u = i.payload, s = i.iconSize, c = i.layout, p = i.formatter, h = i.inactiveColor, v = {
          x: 0,
          y: 0,
          width: is,
          height: is
        }, y = {
          display: c === "horizontal" ? "inline-block" : "block",
          marginRight: 10
        }, x = {
          display: "inline-block",
          verticalAlign: "middle",
          marginRight: 4
        };
        return u.map(function(w, E) {
          var C = w.formatter || p, S = hr(tx(tx({
            "recharts-legend-item": !0
          }, "legend-item-".concat(E), !0), "inactive", w.inactive));
          if (w.type === "none")
            return null;
          var k = er(w.value) ? null : w.value;
          mc(
            !er(w.value),
            `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
            // eslint-disable-line max-len
          );
          var D = w.inactive ? h : w.color;
          return /* @__PURE__ */ ce.createElement("li", KP({
            className: S,
            style: y,
            key: "legend-item-".concat(E)
          }, SS(n.props, w, E)), /* @__PURE__ */ ce.createElement(UP, {
            width: s,
            height: s,
            viewBox: v,
            style: x
          }, n.renderIcon(w)), /* @__PURE__ */ ce.createElement("span", {
            className: "recharts-legend-item-text",
            style: {
              color: D
            }
          }, C ? C(k, w, E) : k));
        });
      }
    }, {
      key: "render",
      value: function() {
        var n = this.props, i = n.payload, u = n.layout, s = n.align;
        if (!i || !i.length)
          return null;
        var c = {
          padding: 0,
          margin: 0,
          textAlign: u === "horizontal" ? s : "left"
        };
        return /* @__PURE__ */ ce.createElement("ul", {
          className: "recharts-default-legend",
          style: c
        }, this.renderItems());
      }
    }]);
  }(ee.PureComponent);
  tx(lj, "displayName", "Legend");
  tx(lj, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "middle",
    inactiveColor: "#ccc"
  });
  var vk, P6;
  function Hfe() {
    if (P6) return vk;
    P6 = 1;
    var e = L_();
    function t() {
      this.__data__ = new e(), this.size = 0;
    }
    return vk = t, vk;
  }
  var mk, M6;
  function Vfe() {
    if (M6) return mk;
    M6 = 1;
    function e(t) {
      var r = this.__data__, n = r.delete(t);
      return this.size = r.size, n;
    }
    return mk = e, mk;
  }
  var yk, N6;
  function Wfe() {
    if (N6) return yk;
    N6 = 1;
    function e(t) {
      return this.__data__.get(t);
    }
    return yk = e, yk;
  }
  var gk, j6;
  function Yfe() {
    if (j6) return gk;
    j6 = 1;
    function e(t) {
      return this.__data__.has(t);
    }
    return gk = e, gk;
  }
  var xk, F6;
  function Gfe() {
    if (F6) return xk;
    F6 = 1;
    var e = L_(), t = JN(), r = ej(), n = 200;
    function i(u, s) {
      var c = this.__data__;
      if (c instanceof e) {
        var p = c.__data__;
        if (!t || p.length < n - 1)
          return p.push([u, s]), this.size = ++c.size, this;
        c = this.__data__ = new r(p);
      }
      return c.set(u, s), this.size = c.size, this;
    }
    return xk = i, xk;
  }
  var bk, I6;
  function fV() {
    if (I6) return bk;
    I6 = 1;
    var e = L_(), t = Hfe(), r = Vfe(), n = Wfe(), i = Yfe(), u = Gfe();
    function s(c) {
      var p = this.__data__ = new e(c);
      this.size = p.size;
    }
    return s.prototype.clear = t, s.prototype.delete = r, s.prototype.get = n, s.prototype.has = i, s.prototype.set = u, bk = s, bk;
  }
  var wk, B6;
  function Qfe() {
    if (B6) return wk;
    B6 = 1;
    var e = "__lodash_hash_undefined__";
    function t(r) {
      return this.__data__.set(r, e), this;
    }
    return wk = t, wk;
  }
  var Ek, L6;
  function Kfe() {
    if (L6) return Ek;
    L6 = 1;
    function e(t) {
      return this.__data__.has(t);
    }
    return Ek = e, Ek;
  }
  var Sk, $6;
  function dV() {
    if ($6) return Sk;
    $6 = 1;
    var e = ej(), t = Qfe(), r = Kfe();
    function n(i) {
      var u = -1, s = i == null ? 0 : i.length;
      for (this.__data__ = new e(); ++u < s; )
        this.add(i[u]);
    }
    return n.prototype.add = n.prototype.push = t, n.prototype.has = r, Sk = n, Sk;
  }
  var _k, z6;
  function pV() {
    if (z6) return _k;
    z6 = 1;
    function e(t, r) {
      for (var n = -1, i = t == null ? 0 : t.length; ++n < i; )
        if (r(t[n], n, t))
          return !0;
      return !1;
    }
    return _k = e, _k;
  }
  var Ck, q6;
  function hV() {
    if (q6) return Ck;
    q6 = 1;
    function e(t, r) {
      return t.has(r);
    }
    return Ck = e, Ck;
  }
  var Ok, U6;
  function vV() {
    if (U6) return Ok;
    U6 = 1;
    var e = dV(), t = pV(), r = hV(), n = 1, i = 2;
    function u(s, c, p, h, v, y) {
      var x = p & n, w = s.length, E = c.length;
      if (w != E && !(x && E > w))
        return !1;
      var C = y.get(s), S = y.get(c);
      if (C && S)
        return C == c && S == s;
      var k = -1, D = !0, A = p & i ? new e() : void 0;
      for (y.set(s, c), y.set(c, s); ++k < w; ) {
        var R = s[k], T = c[k];
        if (h)
          var M = x ? h(T, R, k, c, s, y) : h(R, T, k, s, c, y);
        if (M !== void 0) {
          if (M)
            continue;
          D = !1;
          break;
        }
        if (A) {
          if (!t(c, function(F, B) {
            if (!r(A, B) && (R === F || v(R, F, p, h, y)))
              return A.push(B);
          })) {
            D = !1;
            break;
          }
        } else if (!(R === T || v(R, T, p, h, y))) {
          D = !1;
          break;
        }
      }
      return y.delete(s), y.delete(c), D;
    }
    return Ok = u, Ok;
  }
  var Tk, H6;
  function Xfe() {
    if (H6) return Tk;
    H6 = 1;
    var e = vl(), t = e.Uint8Array;
    return Tk = t, Tk;
  }
  var Ak, V6;
  function Zfe() {
    if (V6) return Ak;
    V6 = 1;
    function e(t) {
      var r = -1, n = Array(t.size);
      return t.forEach(function(i, u) {
        n[++r] = [u, i];
      }), n;
    }
    return Ak = e, Ak;
  }
  var Dk, W6;
  function cj() {
    if (W6) return Dk;
    W6 = 1;
    function e(t) {
      var r = -1, n = Array(t.size);
      return t.forEach(function(i) {
        n[++r] = i;
      }), n;
    }
    return Dk = e, Dk;
  }
  var kk, Y6;
  function Jfe() {
    if (Y6) return kk;
    Y6 = 1;
    var e = qx(), t = Xfe(), r = ZN(), n = vV(), i = Zfe(), u = cj(), s = 1, c = 2, p = "[object Boolean]", h = "[object Date]", v = "[object Error]", y = "[object Map]", x = "[object Number]", w = "[object RegExp]", E = "[object Set]", C = "[object String]", S = "[object Symbol]", k = "[object ArrayBuffer]", D = "[object DataView]", A = e ? e.prototype : void 0, R = A ? A.valueOf : void 0;
    function T(M, F, B, V, H, q, Q) {
      switch (B) {
        case D:
          if (M.byteLength != F.byteLength || M.byteOffset != F.byteOffset)
            return !1;
          M = M.buffer, F = F.buffer;
        case k:
          return !(M.byteLength != F.byteLength || !q(new t(M), new t(F)));
        case p:
        case h:
        case x:
          return r(+M, +F);
        case v:
          return M.name == F.name && M.message == F.message;
        case w:
        case C:
          return M == F + "";
        case y:
          var W = i;
        case E:
          var J = V & s;
          if (W || (W = u), M.size != F.size && !J)
            return !1;
          var ne = Q.get(M);
          if (ne)
            return ne == F;
          V |= c, Q.set(M, F);
          var ie = n(W(M), W(F), V, H, q, Q);
          return Q.delete(M), ie;
        case S:
          if (R)
            return R.call(M) == R.call(F);
      }
      return !1;
    }
    return kk = T, kk;
  }
  var Rk, G6;
  function mV() {
    if (G6) return Rk;
    G6 = 1;
    function e(t, r) {
      for (var n = -1, i = r.length, u = t.length; ++n < i; )
        t[u + n] = r[n];
      return t;
    }
    return Rk = e, Rk;
  }
  var Pk, Q6;
  function ede() {
    if (Q6) return Pk;
    Q6 = 1;
    var e = mV(), t = xo();
    function r(n, i, u) {
      var s = i(n);
      return t(n) ? s : e(s, u(n));
    }
    return Pk = r, Pk;
  }
  var Mk, K6;
  function tde() {
    if (K6) return Mk;
    K6 = 1;
    function e(t, r) {
      for (var n = -1, i = t == null ? 0 : t.length, u = 0, s = []; ++n < i; ) {
        var c = t[n];
        r(c, n, t) && (s[u++] = c);
      }
      return s;
    }
    return Mk = e, Mk;
  }
  var Nk, X6;
  function rde() {
    if (X6) return Nk;
    X6 = 1;
    function e() {
      return [];
    }
    return Nk = e, Nk;
  }
  var jk, Z6;
  function nde() {
    if (Z6) return jk;
    Z6 = 1;
    var e = tde(), t = rde(), r = Object.prototype, n = r.propertyIsEnumerable, i = Object.getOwnPropertySymbols, u = i ? function(s) {
      return s == null ? [] : (s = Object(s), e(i(s), function(c) {
        return n.call(s, c);
      }));
    } : t;
    return jk = u, jk;
  }
  var Fk, J6;
  function ide() {
    if (J6) return Fk;
    J6 = 1;
    function e(t, r) {
      for (var n = -1, i = Array(t); ++n < t; )
        i[n] = r(n);
      return i;
    }
    return Fk = e, Fk;
  }
  var Ik, e5;
  function ade() {
    if (e5) return Ik;
    e5 = 1;
    var e = Oc(), t = Tc(), r = "[object Arguments]";
    function n(i) {
      return t(i) && e(i) == r;
    }
    return Ik = n, Ik;
  }
  var Bk, t5;
  function fj() {
    if (t5) return Bk;
    t5 = 1;
    var e = ade(), t = Tc(), r = Object.prototype, n = r.hasOwnProperty, i = r.propertyIsEnumerable, u = e(/* @__PURE__ */ function() {
      return arguments;
    }()) ? e : function(s) {
      return t(s) && n.call(s, "callee") && !i.call(s, "callee");
    };
    return Bk = u, Bk;
  }
  var Pg = { exports: {} }, Lk, r5;
  function ode() {
    if (r5) return Lk;
    r5 = 1;
    function e() {
      return !1;
    }
    return Lk = e, Lk;
  }
  Pg.exports;
  var n5;
  function yV() {
    return n5 || (n5 = 1, function(e, t) {
      var r = vl(), n = ode(), i = t && !t.nodeType && t, u = i && !0 && e && !e.nodeType && e, s = u && u.exports === i, c = s ? r.Buffer : void 0, p = c ? c.isBuffer : void 0, h = p || n;
      e.exports = h;
    }(Pg, Pg.exports)), Pg.exports;
  }
  var $k, i5;
  function dj() {
    if (i5) return $k;
    i5 = 1;
    var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
    function r(n, i) {
      var u = typeof n;
      return i = i ?? e, !!i && (u == "number" || u != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < i;
    }
    return $k = r, $k;
  }
  var zk, a5;
  function pj() {
    if (a5) return zk;
    a5 = 1;
    var e = 9007199254740991;
    function t(r) {
      return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
    }
    return zk = t, zk;
  }
  var qk, o5;
  function ude() {
    if (o5) return qk;
    o5 = 1;
    var e = Oc(), t = pj(), r = Tc(), n = "[object Arguments]", i = "[object Array]", u = "[object Boolean]", s = "[object Date]", c = "[object Error]", p = "[object Function]", h = "[object Map]", v = "[object Number]", y = "[object Object]", x = "[object RegExp]", w = "[object Set]", E = "[object String]", C = "[object WeakMap]", S = "[object ArrayBuffer]", k = "[object DataView]", D = "[object Float32Array]", A = "[object Float64Array]", R = "[object Int8Array]", T = "[object Int16Array]", M = "[object Int32Array]", F = "[object Uint8Array]", B = "[object Uint8ClampedArray]", V = "[object Uint16Array]", H = "[object Uint32Array]", q = {};
    q[D] = q[A] = q[R] = q[T] = q[M] = q[F] = q[B] = q[V] = q[H] = !0, q[n] = q[i] = q[S] = q[u] = q[k] = q[s] = q[c] = q[p] = q[h] = q[v] = q[y] = q[x] = q[w] = q[E] = q[C] = !1;
    function Q(W) {
      return r(W) && t(W.length) && !!q[e(W)];
    }
    return qk = Q, qk;
  }
  var Uk, u5;
  function gV() {
    if (u5) return Uk;
    u5 = 1;
    function e(t) {
      return function(r) {
        return t(r);
      };
    }
    return Uk = e, Uk;
  }
  var Mg = { exports: {} };
  Mg.exports;
  var s5;
  function sde() {
    return s5 || (s5 = 1, function(e, t) {
      var r = BH(), n = t && !t.nodeType && t, i = n && !0 && e && !e.nodeType && e, u = i && i.exports === n, s = u && r.process, c = function() {
        try {
          var p = i && i.require && i.require("util").types;
          return p || s && s.binding && s.binding("util");
        } catch {
        }
      }();
      e.exports = c;
    }(Mg, Mg.exports)), Mg.exports;
  }
  var Hk, l5;
  function xV() {
    if (l5) return Hk;
    l5 = 1;
    var e = ude(), t = gV(), r = sde(), n = r && r.isTypedArray, i = n ? t(n) : e;
    return Hk = i, Hk;
  }
  var Vk, c5;
  function lde() {
    if (c5) return Vk;
    c5 = 1;
    var e = ide(), t = fj(), r = xo(), n = yV(), i = dj(), u = xV(), s = Object.prototype, c = s.hasOwnProperty;
    function p(h, v) {
      var y = r(h), x = !y && t(h), w = !y && !x && n(h), E = !y && !x && !w && u(h), C = y || x || w || E, S = C ? e(h.length, String) : [], k = S.length;
      for (var D in h)
        (v || c.call(h, D)) && !(C && // Safari 9 has enumerable `arguments.length` in strict mode.
        (D == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        w && (D == "offset" || D == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        E && (D == "buffer" || D == "byteLength" || D == "byteOffset") || // Skip index properties.
        i(D, k))) && S.push(D);
      return S;
    }
    return Vk = p, Vk;
  }
  var Wk, f5;
  function cde() {
    if (f5) return Wk;
    f5 = 1;
    var e = Object.prototype;
    function t(r) {
      var n = r && r.constructor, i = typeof n == "function" && n.prototype || e;
      return r === i;
    }
    return Wk = t, Wk;
  }
  var Yk, d5;
  function bV() {
    if (d5) return Yk;
    d5 = 1;
    function e(t, r) {
      return function(n) {
        return t(r(n));
      };
    }
    return Yk = e, Yk;
  }
  var Gk, p5;
  function fde() {
    if (p5) return Gk;
    p5 = 1;
    var e = bV(), t = e(Object.keys, Object);
    return Gk = t, Gk;
  }
  var Qk, h5;
  function dde() {
    if (h5) return Qk;
    h5 = 1;
    var e = cde(), t = fde(), r = Object.prototype, n = r.hasOwnProperty;
    function i(u) {
      if (!e(u))
        return t(u);
      var s = [];
      for (var c in Object(u))
        n.call(u, c) && c != "constructor" && s.push(c);
      return s;
    }
    return Qk = i, Qk;
  }
  var Kk, v5;
  function Vx() {
    if (v5) return Kk;
    v5 = 1;
    var e = XN(), t = pj();
    function r(n) {
      return n != null && t(n.length) && !e(n);
    }
    return Kk = r, Kk;
  }
  var Xk, m5;
  function W_() {
    if (m5) return Xk;
    m5 = 1;
    var e = lde(), t = dde(), r = Vx();
    function n(i) {
      return r(i) ? e(i) : t(i);
    }
    return Xk = n, Xk;
  }
  var Zk, y5;
  function pde() {
    if (y5) return Zk;
    y5 = 1;
    var e = ede(), t = nde(), r = W_();
    function n(i) {
      return e(i, r, t);
    }
    return Zk = n, Zk;
  }
  var Jk, g5;
  function hde() {
    if (g5) return Jk;
    g5 = 1;
    var e = pde(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
    function i(u, s, c, p, h, v) {
      var y = c & t, x = e(u), w = x.length, E = e(s), C = E.length;
      if (w != C && !y)
        return !1;
      for (var S = w; S--; ) {
        var k = x[S];
        if (!(y ? k in s : n.call(s, k)))
          return !1;
      }
      var D = v.get(u), A = v.get(s);
      if (D && A)
        return D == s && A == u;
      var R = !0;
      v.set(u, s), v.set(s, u);
      for (var T = y; ++S < w; ) {
        k = x[S];
        var M = u[k], F = s[k];
        if (p)
          var B = y ? p(F, M, k, s, u, v) : p(M, F, k, u, s, v);
        if (!(B === void 0 ? M === F || h(M, F, c, p, v) : B)) {
          R = !1;
          break;
        }
        T || (T = k == "constructor");
      }
      if (R && !T) {
        var V = u.constructor, H = s.constructor;
        V != H && "constructor" in u && "constructor" in s && !(typeof V == "function" && V instanceof V && typeof H == "function" && H instanceof H) && (R = !1);
      }
      return v.delete(u), v.delete(s), R;
    }
    return Jk = i, Jk;
  }
  var eR, x5;
  function vde() {
    if (x5) return eR;
    x5 = 1;
    var e = Up(), t = vl(), r = e(t, "DataView");
    return eR = r, eR;
  }
  var tR, b5;
  function mde() {
    if (b5) return tR;
    b5 = 1;
    var e = Up(), t = vl(), r = e(t, "Promise");
    return tR = r, tR;
  }
  var rR, w5;
  function wV() {
    if (w5) return rR;
    w5 = 1;
    var e = Up(), t = vl(), r = e(t, "Set");
    return rR = r, rR;
  }
  var nR, E5;
  function yde() {
    if (E5) return nR;
    E5 = 1;
    var e = Up(), t = vl(), r = e(t, "WeakMap");
    return nR = r, nR;
  }
  var iR, S5;
  function gde() {
    if (S5) return iR;
    S5 = 1;
    var e = vde(), t = JN(), r = mde(), n = wV(), i = yde(), u = Oc(), s = LH(), c = "[object Map]", p = "[object Object]", h = "[object Promise]", v = "[object Set]", y = "[object WeakMap]", x = "[object DataView]", w = s(e), E = s(t), C = s(r), S = s(n), k = s(i), D = u;
    return (e && D(new e(new ArrayBuffer(1))) != x || t && D(new t()) != c || r && D(r.resolve()) != h || n && D(new n()) != v || i && D(new i()) != y) && (D = function(A) {
      var R = u(A), T = R == p ? A.constructor : void 0, M = T ? s(T) : "";
      if (M)
        switch (M) {
          case w:
            return x;
          case E:
            return c;
          case C:
            return h;
          case S:
            return v;
          case k:
            return y;
        }
      return R;
    }), iR = D, iR;
  }
  var aR, _5;
  function xde() {
    if (_5) return aR;
    _5 = 1;
    var e = fV(), t = vV(), r = Jfe(), n = hde(), i = gde(), u = xo(), s = yV(), c = xV(), p = 1, h = "[object Arguments]", v = "[object Array]", y = "[object Object]", x = Object.prototype, w = x.hasOwnProperty;
    function E(C, S, k, D, A, R) {
      var T = u(C), M = u(S), F = T ? v : i(C), B = M ? v : i(S);
      F = F == h ? y : F, B = B == h ? y : B;
      var V = F == y, H = B == y, q = F == B;
      if (q && s(C)) {
        if (!s(S))
          return !1;
        T = !0, V = !1;
      }
      if (q && !V)
        return R || (R = new e()), T || c(C) ? t(C, S, k, D, A, R) : r(C, S, F, k, D, A, R);
      if (!(k & p)) {
        var Q = V && w.call(C, "__wrapped__"), W = H && w.call(S, "__wrapped__");
        if (Q || W) {
          var J = Q ? C.value() : C, ne = W ? S.value() : S;
          return R || (R = new e()), A(J, ne, k, D, R);
        }
      }
      return q ? (R || (R = new e()), n(C, S, k, D, A, R)) : !1;
    }
    return aR = E, aR;
  }
  var oR, C5;
  function hj() {
    if (C5) return oR;
    C5 = 1;
    var e = xde(), t = Tc();
    function r(n, i, u, s, c) {
      return n === i ? !0 : n == null || i == null || !t(n) && !t(i) ? n !== n && i !== i : e(n, i, u, s, r, c);
    }
    return oR = r, oR;
  }
  var uR, O5;
  function bde() {
    if (O5) return uR;
    O5 = 1;
    var e = fV(), t = hj(), r = 1, n = 2;
    function i(u, s, c, p) {
      var h = c.length, v = h, y = !p;
      if (u == null)
        return !v;
      for (u = Object(u); h--; ) {
        var x = c[h];
        if (y && x[2] ? x[1] !== u[x[0]] : !(x[0] in u))
          return !1;
      }
      for (; ++h < v; ) {
        x = c[h];
        var w = x[0], E = u[w], C = x[1];
        if (y && x[2]) {
          if (E === void 0 && !(w in u))
            return !1;
        } else {
          var S = new e();
          if (p)
            var k = p(E, C, w, u, s, S);
          if (!(k === void 0 ? t(C, E, r | n, p, S) : k))
            return !1;
        }
      }
      return !0;
    }
    return uR = i, uR;
  }
  var sR, T5;
  function EV() {
    if (T5) return sR;
    T5 = 1;
    var e = Gf();
    function t(r) {
      return r === r && !e(r);
    }
    return sR = t, sR;
  }
  var lR, A5;
  function wde() {
    if (A5) return lR;
    A5 = 1;
    var e = EV(), t = W_();
    function r(n) {
      for (var i = t(n), u = i.length; u--; ) {
        var s = i[u], c = n[s];
        i[u] = [s, c, e(c)];
      }
      return i;
    }
    return lR = r, lR;
  }
  var cR, D5;
  function SV() {
    if (D5) return cR;
    D5 = 1;
    function e(t, r) {
      return function(n) {
        return n == null ? !1 : n[t] === r && (r !== void 0 || t in Object(n));
      };
    }
    return cR = e, cR;
  }
  var fR, k5;
  function Ede() {
    if (k5) return fR;
    k5 = 1;
    var e = bde(), t = wde(), r = SV();
    function n(i) {
      var u = t(i);
      return u.length == 1 && u[0][2] ? r(u[0][0], u[0][1]) : function(s) {
        return s === i || e(s, i, u);
      };
    }
    return fR = n, fR;
  }
  var dR, R5;
  function Sde() {
    if (R5) return dR;
    R5 = 1;
    function e(t, r) {
      return t != null && r in Object(t);
    }
    return dR = e, dR;
  }
  var pR, P5;
  function _de() {
    if (P5) return pR;
    P5 = 1;
    var e = qH(), t = fj(), r = xo(), n = dj(), i = pj(), u = z_();
    function s(c, p, h) {
      p = e(p, c);
      for (var v = -1, y = p.length, x = !1; ++v < y; ) {
        var w = u(p[v]);
        if (!(x = c != null && h(c, w)))
          break;
        c = c[w];
      }
      return x || ++v != y ? x : (y = c == null ? 0 : c.length, !!y && i(y) && n(w, y) && (r(c) || t(c)));
    }
    return pR = s, pR;
  }
  var hR, M5;
  function Cde() {
    if (M5) return hR;
    M5 = 1;
    var e = Sde(), t = _de();
    function r(n, i) {
      return n != null && t(n, i, e);
    }
    return hR = r, hR;
  }
  var vR, N5;
  function Ode() {
    if (N5) return vR;
    N5 = 1;
    var e = hj(), t = UH(), r = Cde(), n = KN(), i = EV(), u = SV(), s = z_(), c = 1, p = 2;
    function h(v, y) {
      return n(v) && i(y) ? u(s(v), y) : function(x) {
        var w = t(x, v);
        return w === void 0 && w === y ? r(x, v) : e(y, w, c | p);
      };
    }
    return vR = h, vR;
  }
  var mR, j5;
  function Q0() {
    if (j5) return mR;
    j5 = 1;
    function e(t) {
      return t;
    }
    return mR = e, mR;
  }
  var yR, F5;
  function Tde() {
    if (F5) return yR;
    F5 = 1;
    function e(t) {
      return function(r) {
        return r == null ? void 0 : r[t];
      };
    }
    return yR = e, yR;
  }
  var gR, I5;
  function Ade() {
    if (I5) return gR;
    I5 = 1;
    var e = rj();
    function t(r) {
      return function(n) {
        return e(n, r);
      };
    }
    return gR = t, gR;
  }
  var xR, B5;
  function Dde() {
    if (B5) return xR;
    B5 = 1;
    var e = Tde(), t = Ade(), r = KN(), n = z_();
    function i(u) {
      return r(u) ? e(n(u)) : t(u);
    }
    return xR = i, xR;
  }
  var bR, L5;
  function Qf() {
    if (L5) return bR;
    L5 = 1;
    var e = Ede(), t = Ode(), r = Q0(), n = xo(), i = Dde();
    function u(s) {
      return typeof s == "function" ? s : s == null ? r : typeof s == "object" ? n(s) ? t(s[0], s[1]) : e(s) : i(s);
    }
    return bR = u, bR;
  }
  var wR, $5;
  function _V() {
    if ($5) return wR;
    $5 = 1;
    function e(t, r, n, i) {
      for (var u = t.length, s = n + (i ? 1 : -1); i ? s-- : ++s < u; )
        if (r(t[s], s, t))
          return s;
      return -1;
    }
    return wR = e, wR;
  }
  var ER, z5;
  function kde() {
    if (z5) return ER;
    z5 = 1;
    function e(t) {
      return t !== t;
    }
    return ER = e, ER;
  }
  var SR, q5;
  function Rde() {
    if (q5) return SR;
    q5 = 1;
    function e(t, r, n) {
      for (var i = n - 1, u = t.length; ++i < u; )
        if (t[i] === r)
          return i;
      return -1;
    }
    return SR = e, SR;
  }
  var _R, U5;
  function Pde() {
    if (U5) return _R;
    U5 = 1;
    var e = _V(), t = kde(), r = Rde();
    function n(i, u, s) {
      return u === u ? r(i, u, s) : e(i, t, s);
    }
    return _R = n, _R;
  }
  var CR, H5;
  function Mde() {
    if (H5) return CR;
    H5 = 1;
    var e = Pde();
    function t(r, n) {
      var i = r == null ? 0 : r.length;
      return !!i && e(r, n, 0) > -1;
    }
    return CR = t, CR;
  }
  var OR, V5;
  function Nde() {
    if (V5) return OR;
    V5 = 1;
    function e(t, r, n) {
      for (var i = -1, u = t == null ? 0 : t.length; ++i < u; )
        if (n(r, t[i]))
          return !0;
      return !1;
    }
    return OR = e, OR;
  }
  var TR, W5;
  function jde() {
    if (W5) return TR;
    W5 = 1;
    function e() {
    }
    return TR = e, TR;
  }
  var AR, Y5;
  function Fde() {
    if (Y5) return AR;
    Y5 = 1;
    var e = wV(), t = jde(), r = cj(), n = 1 / 0, i = e && 1 / r(new e([, -0]))[1] == n ? function(u) {
      return new e(u);
    } : t;
    return AR = i, AR;
  }
  var DR, G5;
  function Ide() {
    if (G5) return DR;
    G5 = 1;
    var e = dV(), t = Mde(), r = Nde(), n = hV(), i = Fde(), u = cj(), s = 200;
    function c(p, h, v) {
      var y = -1, x = t, w = p.length, E = !0, C = [], S = C;
      if (v)
        E = !1, x = r;
      else if (w >= s) {
        var k = h ? null : i(p);
        if (k)
          return u(k);
        E = !1, x = n, S = new e();
      } else
        S = h ? [] : C;
      e:
        for (; ++y < w; ) {
          var D = p[y], A = h ? h(D) : D;
          if (D = v || D !== 0 ? D : 0, E && A === A) {
            for (var R = S.length; R--; )
              if (S[R] === A)
                continue e;
            h && S.push(A), C.push(D);
          } else x(S, A, v) || (S !== C && S.push(A), C.push(D));
        }
      return C;
    }
    return DR = c, DR;
  }
  var kR, Q5;
  function Bde() {
    if (Q5) return kR;
    Q5 = 1;
    var e = Qf(), t = Ide();
    function r(n, i) {
      return n && n.length ? t(n, e(i, 2)) : [];
    }
    return kR = r, kR;
  }
  var Lde = Bde();
  const K5 = /* @__PURE__ */ Zr(Lde);
  function CV(e, t, r) {
    return t === !0 ? K5(e, r) : er(t) ? K5(e, t) : e;
  }
  function p0(e) {
    "@babel/helpers - typeof";
    return p0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, p0(e);
  }
  var $de = ["ref"];
  function X5(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function lc(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? X5(Object(r), !0).forEach(function(n) {
        Y_(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : X5(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function zde(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function Z5(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, TV(n.key), n);
    }
  }
  function qde(e, t, r) {
    return t && Z5(e.prototype, t), r && Z5(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function Ude(e, t, r) {
    return t = kS(t), Hde(e, OV() ? Reflect.construct(t, r || [], kS(e).constructor) : t.apply(e, r));
  }
  function Hde(e, t) {
    if (t && (p0(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return Vde(e);
  }
  function Vde(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function OV() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (OV = function() {
      return !!e;
    })();
  }
  function kS(e) {
    return kS = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, kS(e);
  }
  function Wde(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && ZP(e, t);
  }
  function ZP(e, t) {
    return ZP = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, ZP(e, t);
  }
  function Y_(e, t, r) {
    return t = TV(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function TV(e) {
    var t = Yde(e, "string");
    return p0(t) == "symbol" ? t : t + "";
  }
  function Yde(e, t) {
    if (p0(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (p0(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  function Gde(e, t) {
    if (e == null) return {};
    var r = Qde(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function Qde(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function Kde(e) {
    return e.value;
  }
  function Xde(e, t) {
    if (/* @__PURE__ */ ce.isValidElement(e))
      return /* @__PURE__ */ ce.cloneElement(e, t);
    if (typeof e == "function")
      return /* @__PURE__ */ ce.createElement(e, t);
    t.ref;
    var r = Gde(t, $de);
    return /* @__PURE__ */ ce.createElement(lj, r);
  }
  var J5 = 1, t0 = /* @__PURE__ */ function(e) {
    function t() {
      var r;
      zde(this, t);
      for (var n = arguments.length, i = new Array(n), u = 0; u < n; u++)
        i[u] = arguments[u];
      return r = Ude(this, t, [].concat(i)), Y_(r, "lastBoundingBox", {
        width: -1,
        height: -1
      }), r;
    }
    return Wde(t, e), qde(t, [{
      key: "componentDidMount",
      value: function() {
        this.updateBBox();
      }
    }, {
      key: "componentDidUpdate",
      value: function() {
        this.updateBBox();
      }
    }, {
      key: "getBBox",
      value: function() {
        if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
          var n = this.wrapperNode.getBoundingClientRect();
          return n.height = this.wrapperNode.offsetHeight, n.width = this.wrapperNode.offsetWidth, n;
        }
        return null;
      }
    }, {
      key: "updateBBox",
      value: function() {
        var n = this.props.onBBoxUpdate, i = this.getBBox();
        i ? (Math.abs(i.width - this.lastBoundingBox.width) > J5 || Math.abs(i.height - this.lastBoundingBox.height) > J5) && (this.lastBoundingBox.width = i.width, this.lastBoundingBox.height = i.height, n && n(i)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, n && n(null));
      }
    }, {
      key: "getBBoxSnapshot",
      value: function() {
        return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? lc({}, this.lastBoundingBox) : {
          width: 0,
          height: 0
        };
      }
    }, {
      key: "getDefaultPosition",
      value: function(n) {
        var i = this.props, u = i.layout, s = i.align, c = i.verticalAlign, p = i.margin, h = i.chartWidth, v = i.chartHeight, y, x;
        if (!n || (n.left === void 0 || n.left === null) && (n.right === void 0 || n.right === null))
          if (s === "center" && u === "vertical") {
            var w = this.getBBoxSnapshot();
            y = {
              left: ((h || 0) - w.width) / 2
            };
          } else
            y = s === "right" ? {
              right: p && p.right || 0
            } : {
              left: p && p.left || 0
            };
        if (!n || (n.top === void 0 || n.top === null) && (n.bottom === void 0 || n.bottom === null))
          if (c === "middle") {
            var E = this.getBBoxSnapshot();
            x = {
              top: ((v || 0) - E.height) / 2
            };
          } else
            x = c === "bottom" ? {
              bottom: p && p.bottom || 0
            } : {
              top: p && p.top || 0
            };
        return lc(lc({}, y), x);
      }
    }, {
      key: "render",
      value: function() {
        var n = this, i = this.props, u = i.content, s = i.width, c = i.height, p = i.wrapperStyle, h = i.payloadUniqBy, v = i.payload, y = lc(lc({
          position: "absolute",
          width: s || "auto",
          height: c || "auto"
        }, this.getDefaultPosition(p)), p);
        return /* @__PURE__ */ ce.createElement("div", {
          className: "recharts-legend-wrapper",
          style: y,
          ref: function(w) {
            n.wrapperNode = w;
          }
        }, Xde(u, lc(lc({}, this.props), {}, {
          payload: CV(v, h, Kde)
        })));
      }
    }], [{
      key: "getWithHeight",
      value: function(n, i) {
        var u = lc(lc({}, this.defaultProps), n.props), s = u.layout;
        return s === "vertical" && Ke(n.props.height) ? {
          height: n.props.height
        } : s === "horizontal" ? {
          width: n.props.width || i
        } : null;
      }
    }]);
  }(ee.PureComponent);
  Y_(t0, "displayName", "Legend");
  Y_(t0, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom"
  });
  var RR, e$;
  function Zde() {
    if (e$) return RR;
    e$ = 1;
    var e = qx(), t = fj(), r = xo(), n = e ? e.isConcatSpreadable : void 0;
    function i(u) {
      return r(u) || t(u) || !!(n && u && u[n]);
    }
    return RR = i, RR;
  }
  var PR, t$;
  function AV() {
    if (t$) return PR;
    t$ = 1;
    var e = mV(), t = Zde();
    function r(n, i, u, s, c) {
      var p = -1, h = n.length;
      for (u || (u = t), c || (c = []); ++p < h; ) {
        var v = n[p];
        i > 0 && u(v) ? i > 1 ? r(v, i - 1, u, s, c) : e(c, v) : s || (c[c.length] = v);
      }
      return c;
    }
    return PR = r, PR;
  }
  var MR, r$;
  function Jde() {
    if (r$) return MR;
    r$ = 1;
    function e(t) {
      return function(r, n, i) {
        for (var u = -1, s = Object(r), c = i(r), p = c.length; p--; ) {
          var h = c[t ? p : ++u];
          if (n(s[h], h, s) === !1)
            break;
        }
        return r;
      };
    }
    return MR = e, MR;
  }
  var NR, n$;
  function epe() {
    if (n$) return NR;
    n$ = 1;
    var e = Jde(), t = e();
    return NR = t, NR;
  }
  var jR, i$;
  function DV() {
    if (i$) return jR;
    i$ = 1;
    var e = epe(), t = W_();
    function r(n, i) {
      return n && e(n, i, t);
    }
    return jR = r, jR;
  }
  var FR, a$;
  function tpe() {
    if (a$) return FR;
    a$ = 1;
    var e = Vx();
    function t(r, n) {
      return function(i, u) {
        if (i == null)
          return i;
        if (!e(i))
          return r(i, u);
        for (var s = i.length, c = n ? s : -1, p = Object(i); (n ? c-- : ++c < s) && u(p[c], c, p) !== !1; )
          ;
        return i;
      };
    }
    return FR = t, FR;
  }
  var IR, o$;
  function vj() {
    if (o$) return IR;
    o$ = 1;
    var e = DV(), t = tpe(), r = t(e);
    return IR = r, IR;
  }
  var BR, u$;
  function kV() {
    if (u$) return BR;
    u$ = 1;
    var e = vj(), t = Vx();
    function r(n, i) {
      var u = -1, s = t(n) ? Array(n.length) : [];
      return e(n, function(c, p, h) {
        s[++u] = i(c, p, h);
      }), s;
    }
    return BR = r, BR;
  }
  var LR, s$;
  function rpe() {
    if (s$) return LR;
    s$ = 1;
    function e(t, r) {
      var n = t.length;
      for (t.sort(r); n--; )
        t[n] = t[n].value;
      return t;
    }
    return LR = e, LR;
  }
  var $R, l$;
  function npe() {
    if (l$) return $R;
    l$ = 1;
    var e = Y0();
    function t(r, n) {
      if (r !== n) {
        var i = r !== void 0, u = r === null, s = r === r, c = e(r), p = n !== void 0, h = n === null, v = n === n, y = e(n);
        if (!h && !y && !c && r > n || c && p && v && !h && !y || u && p && v || !i && v || !s)
          return 1;
        if (!u && !c && !y && r < n || y && i && s && !u && !c || h && i && s || !p && s || !v)
          return -1;
      }
      return 0;
    }
    return $R = t, $R;
  }
  var zR, c$;
  function ipe() {
    if (c$) return zR;
    c$ = 1;
    var e = npe();
    function t(r, n, i) {
      for (var u = -1, s = r.criteria, c = n.criteria, p = s.length, h = i.length; ++u < p; ) {
        var v = e(s[u], c[u]);
        if (v) {
          if (u >= h)
            return v;
          var y = i[u];
          return v * (y == "desc" ? -1 : 1);
        }
      }
      return r.index - n.index;
    }
    return zR = t, zR;
  }
  var qR, f$;
  function ape() {
    if (f$) return qR;
    f$ = 1;
    var e = tj(), t = rj(), r = Qf(), n = kV(), i = rpe(), u = gV(), s = ipe(), c = Q0(), p = xo();
    function h(v, y, x) {
      y.length ? y = e(y, function(C) {
        return p(C) ? function(S) {
          return t(S, C.length === 1 ? C[0] : C);
        } : C;
      }) : y = [c];
      var w = -1;
      y = e(y, u(r));
      var E = n(v, function(C, S, k) {
        var D = e(y, function(A) {
          return A(C);
        });
        return { criteria: D, index: ++w, value: C };
      });
      return i(E, function(C, S) {
        return s(C, S, x);
      });
    }
    return qR = h, qR;
  }
  var UR, d$;
  function ope() {
    if (d$) return UR;
    d$ = 1;
    function e(t, r, n) {
      switch (n.length) {
        case 0:
          return t.call(r);
        case 1:
          return t.call(r, n[0]);
        case 2:
          return t.call(r, n[0], n[1]);
        case 3:
          return t.call(r, n[0], n[1], n[2]);
      }
      return t.apply(r, n);
    }
    return UR = e, UR;
  }
  var HR, p$;
  function upe() {
    if (p$) return HR;
    p$ = 1;
    var e = ope(), t = Math.max;
    function r(n, i, u) {
      return i = t(i === void 0 ? n.length - 1 : i, 0), function() {
        for (var s = arguments, c = -1, p = t(s.length - i, 0), h = Array(p); ++c < p; )
          h[c] = s[i + c];
        c = -1;
        for (var v = Array(i + 1); ++c < i; )
          v[c] = s[c];
        return v[i] = u(h), e(n, this, v);
      };
    }
    return HR = r, HR;
  }
  var VR, h$;
  function spe() {
    if (h$) return VR;
    h$ = 1;
    function e(t) {
      return function() {
        return t;
      };
    }
    return VR = e, VR;
  }
  var WR, v$;
  function RV() {
    if (v$) return WR;
    v$ = 1;
    var e = Up(), t = function() {
      try {
        var r = e(Object, "defineProperty");
        return r({}, "", {}), r;
      } catch {
      }
    }();
    return WR = t, WR;
  }
  var YR, m$;
  function lpe() {
    if (m$) return YR;
    m$ = 1;
    var e = spe(), t = RV(), r = Q0(), n = t ? function(i, u) {
      return t(i, "toString", {
        configurable: !0,
        enumerable: !1,
        value: e(u),
        writable: !0
      });
    } : r;
    return YR = n, YR;
  }
  var GR, y$;
  function cpe() {
    if (y$) return GR;
    y$ = 1;
    var e = 800, t = 16, r = Date.now;
    function n(i) {
      var u = 0, s = 0;
      return function() {
        var c = r(), p = t - (c - s);
        if (s = c, p > 0) {
          if (++u >= e)
            return arguments[0];
        } else
          u = 0;
        return i.apply(void 0, arguments);
      };
    }
    return GR = n, GR;
  }
  var QR, g$;
  function fpe() {
    if (g$) return QR;
    g$ = 1;
    var e = lpe(), t = cpe(), r = t(e);
    return QR = r, QR;
  }
  var KR, x$;
  function dpe() {
    if (x$) return KR;
    x$ = 1;
    var e = Q0(), t = upe(), r = fpe();
    function n(i, u) {
      return r(t(i, u, e), i + "");
    }
    return KR = n, KR;
  }
  var XR, b$;
  function G_() {
    if (b$) return XR;
    b$ = 1;
    var e = ZN(), t = Vx(), r = dj(), n = Gf();
    function i(u, s, c) {
      if (!n(c))
        return !1;
      var p = typeof s;
      return (p == "number" ? t(c) && r(s, c.length) : p == "string" && s in c) ? e(c[s], u) : !1;
    }
    return XR = i, XR;
  }
  var ZR, w$;
  function ppe() {
    if (w$) return ZR;
    w$ = 1;
    var e = AV(), t = ape(), r = dpe(), n = G_(), i = r(function(u, s) {
      if (u == null)
        return [];
      var c = s.length;
      return c > 1 && n(u, s[0], s[1]) ? s = [] : c > 2 && n(s[0], s[1], s[2]) && (s = [s[0]]), t(u, e(s, 1), []);
    });
    return ZR = i, ZR;
  }
  var hpe = ppe();
  const mj = /* @__PURE__ */ Zr(hpe);
  function rx(e) {
    "@babel/helpers - typeof";
    return rx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, rx(e);
  }
  function JP() {
    return JP = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, JP.apply(this, arguments);
  }
  function vpe(e, t) {
    return xpe(e) || gpe(e, t) || ype(e, t) || mpe();
  }
  function mpe() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function ype(e, t) {
    if (e) {
      if (typeof e == "string") return E$(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return E$(e, t);
    }
  }
  function E$(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function gpe(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, u, s, c = [], p = !0, h = !1;
      try {
        if (u = (r = r.call(e)).next, t !== 0) for (; !(p = (n = u.call(r)).done) && (c.push(n.value), c.length !== t); p = !0) ;
      } catch (v) {
        h = !0, i = v;
      } finally {
        try {
          if (!p && r.return != null && (s = r.return(), Object(s) !== s)) return;
        } finally {
          if (h) throw i;
        }
      }
      return c;
    }
  }
  function xpe(e) {
    if (Array.isArray(e)) return e;
  }
  function S$(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function JR(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? S$(Object(r), !0).forEach(function(n) {
        bpe(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : S$(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function bpe(e, t, r) {
    return t = wpe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function wpe(e) {
    var t = Epe(e, "string");
    return rx(t) == "symbol" ? t : t + "";
  }
  function Epe(e, t) {
    if (rx(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (rx(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Spe(e) {
    return Array.isArray(e) && ki(e[0]) && ki(e[1]) ? e.join(" ~ ") : e;
  }
  var _pe = function(t) {
    var r = t.separator, n = r === void 0 ? " : " : r, i = t.contentStyle, u = i === void 0 ? {} : i, s = t.itemStyle, c = s === void 0 ? {} : s, p = t.labelStyle, h = p === void 0 ? {} : p, v = t.payload, y = t.formatter, x = t.itemSorter, w = t.wrapperClassName, E = t.labelClassName, C = t.label, S = t.labelFormatter, k = t.accessibilityLayer, D = k === void 0 ? !1 : k, A = function() {
      if (v && v.length) {
        var Q = {
          padding: 0,
          margin: 0
        }, W = (x ? mj(v, x) : v).map(function(J, ne) {
          if (J.type === "none")
            return null;
          var ie = JR({
            display: "block",
            paddingTop: 4,
            paddingBottom: 4,
            color: J.color || "#000"
          }, c), se = J.formatter || y || Spe, X = J.value, fe = J.name, Z = X, z = fe;
          if (se && Z != null && z != null) {
            var Y = se(X, fe, J, ne, v);
            if (Array.isArray(Y)) {
              var te = vpe(Y, 2);
              Z = te[0], z = te[1];
            } else
              Z = Y;
          }
          return (
            // eslint-disable-next-line react/no-array-index-key
            /* @__PURE__ */ ce.createElement("li", {
              className: "recharts-tooltip-item",
              key: "tooltip-item-".concat(ne),
              style: ie
            }, ki(z) ? /* @__PURE__ */ ce.createElement("span", {
              className: "recharts-tooltip-item-name"
            }, z) : null, ki(z) ? /* @__PURE__ */ ce.createElement("span", {
              className: "recharts-tooltip-item-separator"
            }, n) : null, /* @__PURE__ */ ce.createElement("span", {
              className: "recharts-tooltip-item-value"
            }, Z), /* @__PURE__ */ ce.createElement("span", {
              className: "recharts-tooltip-item-unit"
            }, J.unit || ""))
          );
        });
        return /* @__PURE__ */ ce.createElement("ul", {
          className: "recharts-tooltip-item-list",
          style: Q
        }, W);
      }
      return null;
    }, R = JR({
      margin: 0,
      padding: 10,
      backgroundColor: "#fff",
      border: "1px solid #ccc",
      whiteSpace: "nowrap"
    }, u), T = JR({
      margin: 0
    }, h), M = !lr(C), F = M ? C : "", B = hr("recharts-default-tooltip", w), V = hr("recharts-tooltip-label", E);
    M && S && v !== void 0 && v !== null && (F = S(C, v));
    var H = D ? {
      role: "status",
      "aria-live": "assertive"
    } : {};
    return /* @__PURE__ */ ce.createElement("div", JP({
      className: B,
      style: R
    }, H), /* @__PURE__ */ ce.createElement("p", {
      className: V,
      style: T
    }, /* @__PURE__ */ ce.isValidElement(F) ? F : "".concat(F)), A());
  };
  function nx(e) {
    "@babel/helpers - typeof";
    return nx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, nx(e);
  }
  function oE(e, t, r) {
    return t = Cpe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Cpe(e) {
    var t = Ope(e, "string");
    return nx(t) == "symbol" ? t : t + "";
  }
  function Ope(e, t) {
    if (nx(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (nx(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var yg = "recharts-tooltip-wrapper", Tpe = {
    visibility: "hidden"
  };
  function Ape(e) {
    var t = e.coordinate, r = e.translateX, n = e.translateY;
    return hr(yg, oE(oE(oE(oE({}, "".concat(yg, "-right"), Ke(r) && t && Ke(t.x) && r >= t.x), "".concat(yg, "-left"), Ke(r) && t && Ke(t.x) && r < t.x), "".concat(yg, "-bottom"), Ke(n) && t && Ke(t.y) && n >= t.y), "".concat(yg, "-top"), Ke(n) && t && Ke(t.y) && n < t.y));
  }
  function _$(e) {
    var t = e.allowEscapeViewBox, r = e.coordinate, n = e.key, i = e.offsetTopLeft, u = e.position, s = e.reverseDirection, c = e.tooltipDimension, p = e.viewBox, h = e.viewBoxDimension;
    if (u && Ke(u[n]))
      return u[n];
    var v = r[n] - c - i, y = r[n] + i;
    if (t[n])
      return s[n] ? v : y;
    if (s[n]) {
      var x = v, w = p[n];
      return x < w ? Math.max(y, p[n]) : Math.max(v, p[n]);
    }
    var E = y + c, C = p[n] + h;
    return E > C ? Math.max(v, p[n]) : Math.max(y, p[n]);
  }
  function Dpe(e) {
    var t = e.translateX, r = e.translateY, n = e.useTranslate3d;
    return {
      transform: n ? "translate3d(".concat(t, "px, ").concat(r, "px, 0)") : "translate(".concat(t, "px, ").concat(r, "px)")
    };
  }
  function kpe(e) {
    var t = e.allowEscapeViewBox, r = e.coordinate, n = e.offsetTopLeft, i = e.position, u = e.reverseDirection, s = e.tooltipBox, c = e.useTranslate3d, p = e.viewBox, h, v, y;
    return s.height > 0 && s.width > 0 && r ? (v = _$({
      allowEscapeViewBox: t,
      coordinate: r,
      key: "x",
      offsetTopLeft: n,
      position: i,
      reverseDirection: u,
      tooltipDimension: s.width,
      viewBox: p,
      viewBoxDimension: p.width
    }), y = _$({
      allowEscapeViewBox: t,
      coordinate: r,
      key: "y",
      offsetTopLeft: n,
      position: i,
      reverseDirection: u,
      tooltipDimension: s.height,
      viewBox: p,
      viewBoxDimension: p.height
    }), h = Dpe({
      translateX: v,
      translateY: y,
      useTranslate3d: c
    })) : h = Tpe, {
      cssProperties: h,
      cssClasses: Ape({
        translateX: v,
        translateY: y,
        coordinate: r
      })
    };
  }
  function h0(e) {
    "@babel/helpers - typeof";
    return h0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, h0(e);
  }
  function C$(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function O$(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? C$(Object(r), !0).forEach(function(n) {
        tM(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : C$(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Rpe(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function Ppe(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, MV(n.key), n);
    }
  }
  function Mpe(e, t, r) {
    return t && Ppe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function Npe(e, t, r) {
    return t = RS(t), jpe(e, PV() ? Reflect.construct(t, r || [], RS(e).constructor) : t.apply(e, r));
  }
  function jpe(e, t) {
    if (t && (h0(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return Fpe(e);
  }
  function Fpe(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function PV() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (PV = function() {
      return !!e;
    })();
  }
  function RS(e) {
    return RS = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, RS(e);
  }
  function Ipe(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && eM(e, t);
  }
  function eM(e, t) {
    return eM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, eM(e, t);
  }
  function tM(e, t, r) {
    return t = MV(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function MV(e) {
    var t = Bpe(e, "string");
    return h0(t) == "symbol" ? t : t + "";
  }
  function Bpe(e, t) {
    if (h0(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (h0(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var T$ = 1, Lpe = /* @__PURE__ */ function(e) {
    function t() {
      var r;
      Rpe(this, t);
      for (var n = arguments.length, i = new Array(n), u = 0; u < n; u++)
        i[u] = arguments[u];
      return r = Npe(this, t, [].concat(i)), tM(r, "state", {
        dismissed: !1,
        dismissedAtCoordinate: {
          x: 0,
          y: 0
        },
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      }), tM(r, "handleKeyDown", function(s) {
        if (s.key === "Escape") {
          var c, p, h, v;
          r.setState({
            dismissed: !0,
            dismissedAtCoordinate: {
              x: (c = (p = r.props.coordinate) === null || p === void 0 ? void 0 : p.x) !== null && c !== void 0 ? c : 0,
              y: (h = (v = r.props.coordinate) === null || v === void 0 ? void 0 : v.y) !== null && h !== void 0 ? h : 0
            }
          });
        }
      }), r;
    }
    return Ipe(t, e), Mpe(t, [{
      key: "updateBBox",
      value: function() {
        if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
          var n = this.wrapperNode.getBoundingClientRect();
          (Math.abs(n.width - this.state.lastBoundingBox.width) > T$ || Math.abs(n.height - this.state.lastBoundingBox.height) > T$) && this.setState({
            lastBoundingBox: {
              width: n.width,
              height: n.height
            }
          });
        } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
          lastBoundingBox: {
            width: -1,
            height: -1
          }
        });
      }
    }, {
      key: "componentDidMount",
      value: function() {
        document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        document.removeEventListener("keydown", this.handleKeyDown);
      }
    }, {
      key: "componentDidUpdate",
      value: function() {
        var n, i;
        this.props.active && this.updateBBox(), this.state.dismissed && (((n = this.props.coordinate) === null || n === void 0 ? void 0 : n.x) !== this.state.dismissedAtCoordinate.x || ((i = this.props.coordinate) === null || i === void 0 ? void 0 : i.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
      }
    }, {
      key: "render",
      value: function() {
        var n = this, i = this.props, u = i.active, s = i.allowEscapeViewBox, c = i.animationDuration, p = i.animationEasing, h = i.children, v = i.coordinate, y = i.hasPayload, x = i.isAnimationActive, w = i.offset, E = i.position, C = i.reverseDirection, S = i.useTranslate3d, k = i.viewBox, D = i.wrapperStyle, A = kpe({
          allowEscapeViewBox: s,
          coordinate: v,
          offsetTopLeft: w,
          position: E,
          reverseDirection: C,
          tooltipBox: this.state.lastBoundingBox,
          useTranslate3d: S,
          viewBox: k
        }), R = A.cssClasses, T = A.cssProperties, M = O$(O$({
          transition: x && u ? "transform ".concat(c, "ms ").concat(p) : void 0
        }, T), {}, {
          pointerEvents: "none",
          visibility: !this.state.dismissed && u && y ? "visible" : "hidden",
          position: "absolute",
          top: 0,
          left: 0
        }, D);
        return (
          // This element allow listening to the `Escape` key.
          // See https://github.com/recharts/recharts/pull/2925
          /* @__PURE__ */ ce.createElement("div", {
            tabIndex: -1,
            className: R,
            style: M,
            ref: function(B) {
              n.wrapperNode = B;
            }
          }, h)
        );
      }
    }]);
  }(ee.PureComponent), $pe = function() {
    return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
  }, K0 = {
    isSsr: $pe()
  };
  function v0(e) {
    "@babel/helpers - typeof";
    return v0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, v0(e);
  }
  function A$(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function D$(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? A$(Object(r), !0).forEach(function(n) {
        yj(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : A$(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function zpe(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function qpe(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, jV(n.key), n);
    }
  }
  function Upe(e, t, r) {
    return t && qpe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function Hpe(e, t, r) {
    return t = PS(t), Vpe(e, NV() ? Reflect.construct(t, r || [], PS(e).constructor) : t.apply(e, r));
  }
  function Vpe(e, t) {
    if (t && (v0(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return Wpe(e);
  }
  function Wpe(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function NV() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (NV = function() {
      return !!e;
    })();
  }
  function PS(e) {
    return PS = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, PS(e);
  }
  function Ype(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && rM(e, t);
  }
  function rM(e, t) {
    return rM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, rM(e, t);
  }
  function yj(e, t, r) {
    return t = jV(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function jV(e) {
    var t = Gpe(e, "string");
    return v0(t) == "symbol" ? t : t + "";
  }
  function Gpe(e, t) {
    if (v0(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (v0(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  function Qpe(e) {
    return e.dataKey;
  }
  function Kpe(e, t) {
    return /* @__PURE__ */ ce.isValidElement(e) ? /* @__PURE__ */ ce.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ ce.createElement(e, t) : /* @__PURE__ */ ce.createElement(_pe, t);
  }
  var os = /* @__PURE__ */ function(e) {
    function t() {
      return zpe(this, t), Hpe(this, t, arguments);
    }
    return Ype(t, e), Upe(t, [{
      key: "render",
      value: function() {
        var n = this, i = this.props, u = i.active, s = i.allowEscapeViewBox, c = i.animationDuration, p = i.animationEasing, h = i.content, v = i.coordinate, y = i.filterNull, x = i.isAnimationActive, w = i.offset, E = i.payload, C = i.payloadUniqBy, S = i.position, k = i.reverseDirection, D = i.useTranslate3d, A = i.viewBox, R = i.wrapperStyle, T = E ?? [];
        y && T.length && (T = CV(E.filter(function(F) {
          return F.value != null && (F.hide !== !0 || n.props.includeHidden);
        }), C, Qpe));
        var M = T.length > 0;
        return /* @__PURE__ */ ce.createElement(Lpe, {
          allowEscapeViewBox: s,
          animationDuration: c,
          animationEasing: p,
          isAnimationActive: x,
          active: u,
          coordinate: v,
          hasPayload: M,
          offset: w,
          position: S,
          reverseDirection: k,
          useTranslate3d: D,
          viewBox: A,
          wrapperStyle: R
        }, Kpe(h, D$(D$({}, this.props), {}, {
          payload: T
        })));
      }
    }]);
  }(ee.PureComponent);
  yj(os, "displayName", "Tooltip");
  yj(os, "defaultProps", {
    accessibilityLayer: !1,
    allowEscapeViewBox: {
      x: !1,
      y: !1
    },
    animationDuration: 400,
    animationEasing: "ease",
    contentStyle: {},
    coordinate: {
      x: 0,
      y: 0
    },
    cursor: !0,
    cursorStyle: {},
    filterNull: !0,
    isAnimationActive: !K0.isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
      x: !1,
      y: !1
    },
    separator: " : ",
    trigger: "hover",
    useTranslate3d: !1,
    viewBox: {
      x: 0,
      y: 0,
      height: 0,
      width: 0
    },
    wrapperStyle: {}
  });
  var e2, k$;
  function Xpe() {
    if (k$) return e2;
    k$ = 1;
    var e = vl(), t = function() {
      return e.Date.now();
    };
    return e2 = t, e2;
  }
  var t2, R$;
  function Zpe() {
    if (R$) return t2;
    R$ = 1;
    var e = /\s/;
    function t(r) {
      for (var n = r.length; n-- && e.test(r.charAt(n)); )
        ;
      return n;
    }
    return t2 = t, t2;
  }
  var r2, P$;
  function Jpe() {
    if (P$) return r2;
    P$ = 1;
    var e = Zpe(), t = /^\s+/;
    function r(n) {
      return n && n.slice(0, e(n) + 1).replace(t, "");
    }
    return r2 = r, r2;
  }
  var n2, M$;
  function FV() {
    if (M$) return n2;
    M$ = 1;
    var e = Jpe(), t = Gf(), r = Y0(), n = NaN, i = /^[-+]0x[0-9a-f]+$/i, u = /^0b[01]+$/i, s = /^0o[0-7]+$/i, c = parseInt;
    function p(h) {
      if (typeof h == "number")
        return h;
      if (r(h))
        return n;
      if (t(h)) {
        var v = typeof h.valueOf == "function" ? h.valueOf() : h;
        h = t(v) ? v + "" : v;
      }
      if (typeof h != "string")
        return h === 0 ? h : +h;
      h = e(h);
      var y = u.test(h);
      return y || s.test(h) ? c(h.slice(2), y ? 2 : 8) : i.test(h) ? n : +h;
    }
    return n2 = p, n2;
  }
  var i2, N$;
  function ehe() {
    if (N$) return i2;
    N$ = 1;
    var e = Gf(), t = Xpe(), r = FV(), n = "Expected a function", i = Math.max, u = Math.min;
    function s(c, p, h) {
      var v, y, x, w, E, C, S = 0, k = !1, D = !1, A = !0;
      if (typeof c != "function")
        throw new TypeError(n);
      p = r(p) || 0, e(h) && (k = !!h.leading, D = "maxWait" in h, x = D ? i(r(h.maxWait) || 0, p) : x, A = "trailing" in h ? !!h.trailing : A);
      function R(W) {
        var J = v, ne = y;
        return v = y = void 0, S = W, w = c.apply(ne, J), w;
      }
      function T(W) {
        return S = W, E = setTimeout(B, p), k ? R(W) : w;
      }
      function M(W) {
        var J = W - C, ne = W - S, ie = p - J;
        return D ? u(ie, x - ne) : ie;
      }
      function F(W) {
        var J = W - C, ne = W - S;
        return C === void 0 || J >= p || J < 0 || D && ne >= x;
      }
      function B() {
        var W = t();
        if (F(W))
          return V(W);
        E = setTimeout(B, M(W));
      }
      function V(W) {
        return E = void 0, A && v ? R(W) : (v = y = void 0, w);
      }
      function H() {
        E !== void 0 && clearTimeout(E), S = 0, v = C = y = E = void 0;
      }
      function q() {
        return E === void 0 ? w : V(t());
      }
      function Q() {
        var W = t(), J = F(W);
        if (v = arguments, y = this, C = W, J) {
          if (E === void 0)
            return T(C);
          if (D)
            return clearTimeout(E), E = setTimeout(B, p), R(C);
        }
        return E === void 0 && (E = setTimeout(B, p)), w;
      }
      return Q.cancel = H, Q.flush = q, Q;
    }
    return i2 = s, i2;
  }
  var a2, j$;
  function the() {
    if (j$) return a2;
    j$ = 1;
    var e = ehe(), t = Gf(), r = "Expected a function";
    function n(i, u, s) {
      var c = !0, p = !0;
      if (typeof i != "function")
        throw new TypeError(r);
      return t(s) && (c = "leading" in s ? !!s.leading : c, p = "trailing" in s ? !!s.trailing : p), e(i, u, {
        leading: c,
        maxWait: u,
        trailing: p
      });
    }
    return a2 = n, a2;
  }
  var rhe = the();
  const IV = /* @__PURE__ */ Zr(rhe);
  function ix(e) {
    "@babel/helpers - typeof";
    return ix = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, ix(e);
  }
  function F$(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function uE(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? F$(Object(r), !0).forEach(function(n) {
        nhe(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : F$(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function nhe(e, t, r) {
    return t = ihe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function ihe(e) {
    var t = ahe(e, "string");
    return ix(t) == "symbol" ? t : t + "";
  }
  function ahe(e, t) {
    if (ix(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (ix(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function ohe(e, t) {
    return che(e) || lhe(e, t) || she(e, t) || uhe();
  }
  function uhe() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function she(e, t) {
    if (e) {
      if (typeof e == "string") return I$(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return I$(e, t);
    }
  }
  function I$(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function lhe(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, u, s, c = [], p = !0, h = !1;
      try {
        if (u = (r = r.call(e)).next, t !== 0) for (; !(p = (n = u.call(r)).done) && (c.push(n.value), c.length !== t); p = !0) ;
      } catch (v) {
        h = !0, i = v;
      } finally {
        try {
          if (!p && r.return != null && (s = r.return(), Object(s) !== s)) return;
        } finally {
          if (h) throw i;
        }
      }
      return c;
    }
  }
  function che(e) {
    if (Array.isArray(e)) return e;
  }
  var fhe = /* @__PURE__ */ ee.forwardRef(function(e, t) {
    var r = e.aspect, n = e.initialDimension, i = n === void 0 ? {
      width: -1,
      height: -1
    } : n, u = e.width, s = u === void 0 ? "100%" : u, c = e.height, p = c === void 0 ? "100%" : c, h = e.minWidth, v = h === void 0 ? 0 : h, y = e.minHeight, x = e.maxHeight, w = e.children, E = e.debounce, C = E === void 0 ? 0 : E, S = e.id, k = e.className, D = e.onResize, A = e.style, R = A === void 0 ? {} : A, T = ee.useRef(null), M = ee.useRef();
    M.current = D, ee.useImperativeHandle(t, function() {
      return Object.defineProperty(T.current, "current", {
        get: function() {
          return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), T.current;
        },
        configurable: !0
      });
    });
    var F = ee.useState({
      containerWidth: i.width,
      containerHeight: i.height
    }), B = ohe(F, 2), V = B[0], H = B[1], q = ee.useCallback(function(W, J) {
      H(function(ne) {
        var ie = Math.round(W), se = Math.round(J);
        return ne.containerWidth === ie && ne.containerHeight === se ? ne : {
          containerWidth: ie,
          containerHeight: se
        };
      });
    }, []);
    ee.useEffect(function() {
      var W = function(fe) {
        var Z, z = fe[0].contentRect, Y = z.width, te = z.height;
        q(Y, te), (Z = M.current) === null || Z === void 0 || Z.call(M, Y, te);
      };
      C > 0 && (W = IV(W, C, {
        trailing: !0,
        leading: !1
      }));
      var J = new ResizeObserver(W), ne = T.current.getBoundingClientRect(), ie = ne.width, se = ne.height;
      return q(ie, se), J.observe(T.current), function() {
        J.disconnect();
      };
    }, [q, C]);
    var Q = ee.useMemo(function() {
      var W = V.containerWidth, J = V.containerHeight;
      if (W < 0 || J < 0)
        return null;
      mc(Op(s) || Op(p), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, s, p), mc(!r || r > 0, "The aspect(%s) must be greater than zero.", r);
      var ne = Op(s) ? W : s, ie = Op(p) ? J : p;
      r && r > 0 && (ne ? ie = ne / r : ie && (ne = ie * r), x && ie > x && (ie = x)), mc(ne > 0 || ie > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, ne, ie, s, p, v, y, r);
      var se = !Array.isArray(w) && vc(w.type).endsWith("Chart");
      return ce.Children.map(w, function(X) {
        return /* @__PURE__ */ ce.isValidElement(X) ? /* @__PURE__ */ ee.cloneElement(X, uE({
          width: ne,
          height: ie
        }, se ? {
          style: uE({
            height: "100%",
            width: "100%",
            maxHeight: ie,
            maxWidth: ne
          }, X.props.style)
        } : {})) : X;
      });
    }, [r, w, p, x, y, v, V, s]);
    return /* @__PURE__ */ ce.createElement("div", {
      id: S ? "".concat(S) : void 0,
      className: hr("recharts-responsive-container", k),
      style: uE(uE({}, R), {}, {
        width: s,
        height: p,
        minWidth: v,
        minHeight: y,
        maxHeight: x
      }),
      ref: T
    }, Q);
  }), BV = function(t) {
    return null;
  };
  BV.displayName = "Cell";
  function ax(e) {
    "@babel/helpers - typeof";
    return ax = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, ax(e);
  }
  function B$(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function nM(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? B$(Object(r), !0).forEach(function(n) {
        dhe(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : B$(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function dhe(e, t, r) {
    return t = phe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function phe(e) {
    var t = hhe(e, "string");
    return ax(t) == "symbol" ? t : t + "";
  }
  function hhe(e, t) {
    if (ax(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (ax(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var jv = {
    widthCache: {},
    cacheCount: 0
  }, vhe = 2e3, mhe = {
    position: "absolute",
    top: "-20000px",
    left: 0,
    padding: 0,
    margin: 0,
    border: "none",
    whiteSpace: "pre"
  }, L$ = "recharts_measurement_span";
  function yhe(e) {
    var t = nM({}, e);
    return Object.keys(t).forEach(function(r) {
      t[r] || delete t[r];
    }), t;
  }
  var $g = function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (t == null || K0.isSsr)
      return {
        width: 0,
        height: 0
      };
    var n = yhe(r), i = JSON.stringify({
      text: t,
      copyStyle: n
    });
    if (jv.widthCache[i])
      return jv.widthCache[i];
    try {
      var u = document.getElementById(L$);
      u || (u = document.createElement("span"), u.setAttribute("id", L$), u.setAttribute("aria-hidden", "true"), document.body.appendChild(u));
      var s = nM(nM({}, mhe), n);
      Object.assign(u.style, s), u.textContent = "".concat(t);
      var c = u.getBoundingClientRect(), p = {
        width: c.width,
        height: c.height
      };
      return jv.widthCache[i] = p, ++jv.cacheCount > vhe && (jv.cacheCount = 0, jv.widthCache = {}), p;
    } catch {
      return {
        width: 0,
        height: 0
      };
    }
  }, ghe = function(t) {
    return {
      top: t.top + window.scrollY - document.documentElement.clientTop,
      left: t.left + window.scrollX - document.documentElement.clientLeft
    };
  };
  function ox(e) {
    "@babel/helpers - typeof";
    return ox = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, ox(e);
  }
  function MS(e, t) {
    return Ehe(e) || whe(e, t) || bhe(e, t) || xhe();
  }
  function xhe() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function bhe(e, t) {
    if (e) {
      if (typeof e == "string") return $$(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return $$(e, t);
    }
  }
  function $$(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function whe(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, u, s, c = [], p = !0, h = !1;
      try {
        if (u = (r = r.call(e)).next, t === 0) {
          if (Object(r) !== r) return;
          p = !1;
        } else for (; !(p = (n = u.call(r)).done) && (c.push(n.value), c.length !== t); p = !0) ;
      } catch (v) {
        h = !0, i = v;
      } finally {
        try {
          if (!p && r.return != null && (s = r.return(), Object(s) !== s)) return;
        } finally {
          if (h) throw i;
        }
      }
      return c;
    }
  }
  function Ehe(e) {
    if (Array.isArray(e)) return e;
  }
  function She(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function z$(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Che(n.key), n);
    }
  }
  function _he(e, t, r) {
    return t && z$(e.prototype, t), r && z$(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function Che(e) {
    var t = Ohe(e, "string");
    return ox(t) == "symbol" ? t : t + "";
  }
  function Ohe(e, t) {
    if (ox(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (ox(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var q$ = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, U$ = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, The = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, Ahe = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, LV = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 96 / 6,
    in: 96,
    Q: 96 / (2.54 * 40),
    px: 1
  }, Dhe = Object.keys(LV), Yv = "NaN";
  function khe(e, t) {
    return e * LV[t];
  }
  var sE = /* @__PURE__ */ function() {
    function e(t, r) {
      She(this, e), this.num = t, this.unit = r, this.num = t, this.unit = r, Number.isNaN(t) && (this.unit = ""), r !== "" && !The.test(r) && (this.num = NaN, this.unit = ""), Dhe.includes(r) && (this.num = khe(t, r), this.unit = "px");
    }
    return _he(e, [{
      key: "add",
      value: function(r) {
        return this.unit !== r.unit ? new e(NaN, "") : new e(this.num + r.num, this.unit);
      }
    }, {
      key: "subtract",
      value: function(r) {
        return this.unit !== r.unit ? new e(NaN, "") : new e(this.num - r.num, this.unit);
      }
    }, {
      key: "multiply",
      value: function(r) {
        return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num * r.num, this.unit || r.unit);
      }
    }, {
      key: "divide",
      value: function(r) {
        return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num / r.num, this.unit || r.unit);
      }
    }, {
      key: "toString",
      value: function() {
        return "".concat(this.num).concat(this.unit);
      }
    }, {
      key: "isNaN",
      value: function() {
        return Number.isNaN(this.num);
      }
    }], [{
      key: "parse",
      value: function(r) {
        var n, i = (n = Ahe.exec(r)) !== null && n !== void 0 ? n : [], u = MS(i, 3), s = u[1], c = u[2];
        return new e(parseFloat(s), c ?? "");
      }
    }]);
  }();
  function $V(e) {
    if (e.includes(Yv))
      return Yv;
    for (var t = e; t.includes("*") || t.includes("/"); ) {
      var r, n = (r = q$.exec(t)) !== null && r !== void 0 ? r : [], i = MS(n, 4), u = i[1], s = i[2], c = i[3], p = sE.parse(u ?? ""), h = sE.parse(c ?? ""), v = s === "*" ? p.multiply(h) : p.divide(h);
      if (v.isNaN())
        return Yv;
      t = t.replace(q$, v.toString());
    }
    for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
      var y, x = (y = U$.exec(t)) !== null && y !== void 0 ? y : [], w = MS(x, 4), E = w[1], C = w[2], S = w[3], k = sE.parse(E ?? ""), D = sE.parse(S ?? ""), A = C === "+" ? k.add(D) : k.subtract(D);
      if (A.isNaN())
        return Yv;
      t = t.replace(U$, A.toString());
    }
    return t;
  }
  var H$ = /\(([^()]*)\)/;
  function Rhe(e) {
    for (var t = e; t.includes("("); ) {
      var r = H$.exec(t), n = MS(r, 2), i = n[1];
      t = t.replace(H$, $V(i));
    }
    return t;
  }
  function Phe(e) {
    var t = e.replace(/\s+/g, "");
    return t = Rhe(t), t = $V(t), t;
  }
  function Mhe(e) {
    try {
      return Phe(e);
    } catch {
      return Yv;
    }
  }
  function o2(e) {
    var t = Mhe(e.slice(5, -1));
    return t === Yv ? "" : t;
  }
  var Nhe = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], jhe = ["dx", "dy", "angle", "className", "breakAll"];
  function iM() {
    return iM = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, iM.apply(this, arguments);
  }
  function V$(e, t) {
    if (e == null) return {};
    var r = Fhe(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function Fhe(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function W$(e, t) {
    return $he(e) || Lhe(e, t) || Bhe(e, t) || Ihe();
  }
  function Ihe() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Bhe(e, t) {
    if (e) {
      if (typeof e == "string") return Y$(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Y$(e, t);
    }
  }
  function Y$(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function Lhe(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, u, s, c = [], p = !0, h = !1;
      try {
        if (u = (r = r.call(e)).next, t === 0) {
          if (Object(r) !== r) return;
          p = !1;
        } else for (; !(p = (n = u.call(r)).done) && (c.push(n.value), c.length !== t); p = !0) ;
      } catch (v) {
        h = !0, i = v;
      } finally {
        try {
          if (!p && r.return != null && (s = r.return(), Object(s) !== s)) return;
        } finally {
          if (h) throw i;
        }
      }
      return c;
    }
  }
  function $he(e) {
    if (Array.isArray(e)) return e;
  }
  var zV = /[ \f\n\r\t\v\u2028\u2029]+/, qV = function(t) {
    var r = t.children, n = t.breakAll, i = t.style;
    try {
      var u = [];
      lr(r) || (n ? u = r.toString().split("") : u = r.toString().split(zV));
      var s = u.map(function(p) {
        return {
          word: p,
          width: $g(p, i).width
        };
      }), c = n ? 0 : $g(" ", i).width;
      return {
        wordsWithComputedWidth: s,
        spaceWidth: c
      };
    } catch {
      return null;
    }
  }, zhe = function(t, r, n, i, u) {
    var s = t.maxLines, c = t.children, p = t.style, h = t.breakAll, v = Ke(s), y = c, x = function() {
      var ne = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      return ne.reduce(function(ie, se) {
        var X = se.word, fe = se.width, Z = ie[ie.length - 1];
        if (Z && (i == null || u || Z.width + fe + n < Number(i)))
          Z.words.push(X), Z.width += fe + n;
        else {
          var z = {
            words: [X],
            width: fe
          };
          ie.push(z);
        }
        return ie;
      }, []);
    }, w = x(r), E = function(ne) {
      return ne.reduce(function(ie, se) {
        return ie.width > se.width ? ie : se;
      });
    };
    if (!v)
      return w;
    for (var C = "…", S = function(ne) {
      var ie = y.slice(0, ne), se = qV({
        breakAll: h,
        style: p,
        children: ie + C
      }).wordsWithComputedWidth, X = x(se), fe = X.length > s || E(X).width > Number(i);
      return [fe, X];
    }, k = 0, D = y.length - 1, A = 0, R; k <= D && A <= y.length - 1; ) {
      var T = Math.floor((k + D) / 2), M = T - 1, F = S(M), B = W$(F, 2), V = B[0], H = B[1], q = S(T), Q = W$(q, 1), W = Q[0];
      if (!V && !W && (k = T + 1), V && W && (D = T - 1), !V && W) {
        R = H;
        break;
      }
      A++;
    }
    return R || w;
  }, G$ = function(t) {
    var r = lr(t) ? [] : t.toString().split(zV);
    return [{
      words: r
    }];
  }, qhe = function(t) {
    var r = t.width, n = t.scaleToFit, i = t.children, u = t.style, s = t.breakAll, c = t.maxLines;
    if ((r || n) && !K0.isSsr) {
      var p, h, v = qV({
        breakAll: s,
        children: i,
        style: u
      });
      if (v) {
        var y = v.wordsWithComputedWidth, x = v.spaceWidth;
        p = y, h = x;
      } else
        return G$(i);
      return zhe({
        breakAll: s,
        children: i,
        maxLines: c,
        style: u
      }, p, h, r, n);
    }
    return G$(i);
  }, Q$ = "#808080", NS = function(t) {
    var r = t.x, n = r === void 0 ? 0 : r, i = t.y, u = i === void 0 ? 0 : i, s = t.lineHeight, c = s === void 0 ? "1em" : s, p = t.capHeight, h = p === void 0 ? "0.71em" : p, v = t.scaleToFit, y = v === void 0 ? !1 : v, x = t.textAnchor, w = x === void 0 ? "start" : x, E = t.verticalAnchor, C = E === void 0 ? "end" : E, S = t.fill, k = S === void 0 ? Q$ : S, D = V$(t, Nhe), A = ee.useMemo(function() {
      return qhe({
        breakAll: D.breakAll,
        children: D.children,
        maxLines: D.maxLines,
        scaleToFit: y,
        style: D.style,
        width: D.width
      });
    }, [D.breakAll, D.children, D.maxLines, y, D.style, D.width]), R = D.dx, T = D.dy, M = D.angle, F = D.className, B = D.breakAll, V = V$(D, jhe);
    if (!ki(n) || !ki(u))
      return null;
    var H = n + (Ke(R) ? R : 0), q = u + (Ke(T) ? T : 0), Q;
    switch (C) {
      case "start":
        Q = o2("calc(".concat(h, ")"));
        break;
      case "middle":
        Q = o2("calc(".concat((A.length - 1) / 2, " * -").concat(c, " + (").concat(h, " / 2))"));
        break;
      default:
        Q = o2("calc(".concat(A.length - 1, " * -").concat(c, ")"));
        break;
    }
    var W = [];
    if (y) {
      var J = A[0].width, ne = D.width;
      W.push("scale(".concat((Ke(ne) ? ne / J : 1) / J, ")"));
    }
    return M && W.push("rotate(".concat(M, ", ").concat(H, ", ").concat(q, ")")), W.length && (V.transform = W.join(" ")), /* @__PURE__ */ ce.createElement("text", iM({}, pr(V, !0), {
      x: H,
      y: q,
      className: hr("recharts-text", F),
      textAnchor: w,
      fill: k.includes("url") ? Q$ : k
    }), A.map(function(ie, se) {
      var X = ie.words.join(B ? "" : " ");
      return (
        // duplicate words will cause duplicate keys
        // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ ce.createElement("tspan", {
          x: H,
          dy: se === 0 ? Q : c,
          key: "".concat(X, "-").concat(se)
        }, X)
      );
    }));
  };
  function If(e, t) {
    return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
  }
  function Uhe(e, t) {
    return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
  }
  function gj(e) {
    let t, r, n;
    e.length !== 2 ? (t = If, r = (c, p) => If(e(c), p), n = (c, p) => e(c) - p) : (t = e === If || e === Uhe ? e : Hhe, r = e, n = e);
    function i(c, p, h = 0, v = c.length) {
      if (h < v) {
        if (t(p, p) !== 0) return v;
        do {
          const y = h + v >>> 1;
          r(c[y], p) < 0 ? h = y + 1 : v = y;
        } while (h < v);
      }
      return h;
    }
    function u(c, p, h = 0, v = c.length) {
      if (h < v) {
        if (t(p, p) !== 0) return v;
        do {
          const y = h + v >>> 1;
          r(c[y], p) <= 0 ? h = y + 1 : v = y;
        } while (h < v);
      }
      return h;
    }
    function s(c, p, h = 0, v = c.length) {
      const y = i(c, p, h, v - 1);
      return y > h && n(c[y - 1], p) > -n(c[y], p) ? y - 1 : y;
    }
    return { left: i, center: s, right: u };
  }
  function Hhe() {
    return 0;
  }
  function UV(e) {
    return e === null ? NaN : +e;
  }
  function* Vhe(e, t) {
    for (let r of e)
      r != null && (r = +r) >= r && (yield r);
  }
  const Whe = gj(If), Wx = Whe.right;
  gj(UV).center;
  class K$ extends Map {
    constructor(t, r = Qhe) {
      if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), t != null) for (const [n, i] of t) this.set(n, i);
    }
    get(t) {
      return super.get(X$(this, t));
    }
    has(t) {
      return super.has(X$(this, t));
    }
    set(t, r) {
      return super.set(Yhe(this, t), r);
    }
    delete(t) {
      return super.delete(Ghe(this, t));
    }
  }
  function X$({ _intern: e, _key: t }, r) {
    const n = t(r);
    return e.has(n) ? e.get(n) : r;
  }
  function Yhe({ _intern: e, _key: t }, r) {
    const n = t(r);
    return e.has(n) ? e.get(n) : (e.set(n, r), r);
  }
  function Ghe({ _intern: e, _key: t }, r) {
    const n = t(r);
    return e.has(n) && (r = e.get(n), e.delete(n)), r;
  }
  function Qhe(e) {
    return e !== null && typeof e == "object" ? e.valueOf() : e;
  }
  function Khe(e = If) {
    if (e === If) return HV;
    if (typeof e != "function") throw new TypeError("compare is not a function");
    return (t, r) => {
      const n = e(t, r);
      return n || n === 0 ? n : (e(r, r) === 0) - (e(t, t) === 0);
    };
  }
  function HV(e, t) {
    return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
  }
  const Xhe = Math.sqrt(50), Zhe = Math.sqrt(10), Jhe = Math.sqrt(2);
  function jS(e, t, r) {
    const n = (t - e) / Math.max(0, r), i = Math.floor(Math.log10(n)), u = n / Math.pow(10, i), s = u >= Xhe ? 10 : u >= Zhe ? 5 : u >= Jhe ? 2 : 1;
    let c, p, h;
    return i < 0 ? (h = Math.pow(10, -i) / s, c = Math.round(e * h), p = Math.round(t * h), c / h < e && ++c, p / h > t && --p, h = -h) : (h = Math.pow(10, i) * s, c = Math.round(e / h), p = Math.round(t / h), c * h < e && ++c, p * h > t && --p), p < c && 0.5 <= r && r < 2 ? jS(e, t, r * 2) : [c, p, h];
  }
  function aM(e, t, r) {
    if (t = +t, e = +e, r = +r, !(r > 0)) return [];
    if (e === t) return [e];
    const n = t < e, [i, u, s] = n ? jS(t, e, r) : jS(e, t, r);
    if (!(u >= i)) return [];
    const c = u - i + 1, p = new Array(c);
    if (n)
      if (s < 0) for (let h = 0; h < c; ++h) p[h] = (u - h) / -s;
      else for (let h = 0; h < c; ++h) p[h] = (u - h) * s;
    else if (s < 0) for (let h = 0; h < c; ++h) p[h] = (i + h) / -s;
    else for (let h = 0; h < c; ++h) p[h] = (i + h) * s;
    return p;
  }
  function oM(e, t, r) {
    return t = +t, e = +e, r = +r, jS(e, t, r)[2];
  }
  function uM(e, t, r) {
    t = +t, e = +e, r = +r;
    const n = t < e, i = n ? oM(t, e, r) : oM(e, t, r);
    return (n ? -1 : 1) * (i < 0 ? 1 / -i : i);
  }
  function Z$(e, t) {
    let r;
    for (const n of e)
      n != null && (r < n || r === void 0 && n >= n) && (r = n);
    return r;
  }
  function J$(e, t) {
    let r;
    for (const n of e)
      n != null && (r > n || r === void 0 && n >= n) && (r = n);
    return r;
  }
  function VV(e, t, r = 0, n = 1 / 0, i) {
    if (t = Math.floor(t), r = Math.floor(Math.max(0, r)), n = Math.floor(Math.min(e.length - 1, n)), !(r <= t && t <= n)) return e;
    for (i = i === void 0 ? HV : Khe(i); n > r; ) {
      if (n - r > 600) {
        const p = n - r + 1, h = t - r + 1, v = Math.log(p), y = 0.5 * Math.exp(2 * v / 3), x = 0.5 * Math.sqrt(v * y * (p - y) / p) * (h - p / 2 < 0 ? -1 : 1), w = Math.max(r, Math.floor(t - h * y / p + x)), E = Math.min(n, Math.floor(t + (p - h) * y / p + x));
        VV(e, t, w, E, i);
      }
      const u = e[t];
      let s = r, c = n;
      for (gg(e, r, t), i(e[n], u) > 0 && gg(e, r, n); s < c; ) {
        for (gg(e, s, c), ++s, --c; i(e[s], u) < 0; ) ++s;
        for (; i(e[c], u) > 0; ) --c;
      }
      i(e[r], u) === 0 ? gg(e, r, c) : (++c, gg(e, c, n)), c <= t && (r = c + 1), t <= c && (n = c - 1);
    }
    return e;
  }
  function gg(e, t, r) {
    const n = e[t];
    e[t] = e[r], e[r] = n;
  }
  function eve(e, t, r) {
    if (e = Float64Array.from(Vhe(e)), !(!(n = e.length) || isNaN(t = +t))) {
      if (t <= 0 || n < 2) return J$(e);
      if (t >= 1) return Z$(e);
      var n, i = (n - 1) * t, u = Math.floor(i), s = Z$(VV(e, u).subarray(0, u + 1)), c = J$(e.subarray(u + 1));
      return s + (c - s) * (i - u);
    }
  }
  function tve(e, t, r = UV) {
    if (!(!(n = e.length) || isNaN(t = +t))) {
      if (t <= 0 || n < 2) return +r(e[0], 0, e);
      if (t >= 1) return +r(e[n - 1], n - 1, e);
      var n, i = (n - 1) * t, u = Math.floor(i), s = +r(e[u], u, e), c = +r(e[u + 1], u + 1, e);
      return s + (c - s) * (i - u);
    }
  }
  function rve(e, t, r) {
    e = +e, t = +t, r = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +r;
    for (var n = -1, i = Math.max(0, Math.ceil((t - e) / r)) | 0, u = new Array(i); ++n < i; )
      u[n] = e + n * r;
    return u;
  }
  function Au(e, t) {
    switch (arguments.length) {
      case 0:
        break;
      case 1:
        this.range(e);
        break;
      default:
        this.range(t).domain(e);
        break;
    }
    return this;
  }
  function Ac(e, t) {
    switch (arguments.length) {
      case 0:
        break;
      case 1: {
        typeof e == "function" ? this.interpolator(e) : this.range(e);
        break;
      }
      default: {
        this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
        break;
      }
    }
    return this;
  }
  const sM = Symbol("implicit");
  function xj() {
    var e = new K$(), t = [], r = [], n = sM;
    function i(u) {
      let s = e.get(u);
      if (s === void 0) {
        if (n !== sM) return n;
        e.set(u, s = t.push(u) - 1);
      }
      return r[s % r.length];
    }
    return i.domain = function(u) {
      if (!arguments.length) return t.slice();
      t = [], e = new K$();
      for (const s of u)
        e.has(s) || e.set(s, t.push(s) - 1);
      return i;
    }, i.range = function(u) {
      return arguments.length ? (r = Array.from(u), i) : r.slice();
    }, i.unknown = function(u) {
      return arguments.length ? (n = u, i) : n;
    }, i.copy = function() {
      return xj(t, r).unknown(n);
    }, Au.apply(i, arguments), i;
  }
  function ux() {
    var e = xj().unknown(void 0), t = e.domain, r = e.range, n = 0, i = 1, u, s, c = !1, p = 0, h = 0, v = 0.5;
    delete e.unknown;
    function y() {
      var x = t().length, w = i < n, E = w ? i : n, C = w ? n : i;
      u = (C - E) / Math.max(1, x - p + h * 2), c && (u = Math.floor(u)), E += (C - E - u * (x - p)) * v, s = u * (1 - p), c && (E = Math.round(E), s = Math.round(s));
      var S = rve(x).map(function(k) {
        return E + u * k;
      });
      return r(w ? S.reverse() : S);
    }
    return e.domain = function(x) {
      return arguments.length ? (t(x), y()) : t();
    }, e.range = function(x) {
      return arguments.length ? ([n, i] = x, n = +n, i = +i, y()) : [n, i];
    }, e.rangeRound = function(x) {
      return [n, i] = x, n = +n, i = +i, c = !0, y();
    }, e.bandwidth = function() {
      return s;
    }, e.step = function() {
      return u;
    }, e.round = function(x) {
      return arguments.length ? (c = !!x, y()) : c;
    }, e.padding = function(x) {
      return arguments.length ? (p = Math.min(1, h = +x), y()) : p;
    }, e.paddingInner = function(x) {
      return arguments.length ? (p = Math.min(1, x), y()) : p;
    }, e.paddingOuter = function(x) {
      return arguments.length ? (h = +x, y()) : h;
    }, e.align = function(x) {
      return arguments.length ? (v = Math.max(0, Math.min(1, x)), y()) : v;
    }, e.copy = function() {
      return ux(t(), [n, i]).round(c).paddingInner(p).paddingOuter(h).align(v);
    }, Au.apply(y(), arguments);
  }
  function WV(e) {
    var t = e.copy;
    return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
      return WV(t());
    }, e;
  }
  function zg() {
    return WV(ux.apply(null, arguments).paddingInner(1));
  }
  function bj(e, t, r) {
    e.prototype = t.prototype = r, r.constructor = e;
  }
  function YV(e, t) {
    var r = Object.create(e.prototype);
    for (var n in t) r[n] = t[n];
    return r;
  }
  function Yx() {
  }
  var sx = 0.7, FS = 1 / sx, r0 = "\\s*([+-]?\\d+)\\s*", lx = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", sl = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", nve = /^#([0-9a-f]{3,8})$/, ive = new RegExp(`^rgb\\(${r0},${r0},${r0}\\)$`), ave = new RegExp(`^rgb\\(${sl},${sl},${sl}\\)$`), ove = new RegExp(`^rgba\\(${r0},${r0},${r0},${lx}\\)$`), uve = new RegExp(`^rgba\\(${sl},${sl},${sl},${lx}\\)$`), sve = new RegExp(`^hsl\\(${lx},${sl},${sl}\\)$`), lve = new RegExp(`^hsla\\(${lx},${sl},${sl},${lx}\\)$`), ez = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
  };
  bj(Yx, cx, {
    copy(e) {
      return Object.assign(new this.constructor(), this, e);
    },
    displayable() {
      return this.rgb().displayable();
    },
    hex: tz,
    // Deprecated! Use color.formatHex.
    formatHex: tz,
    formatHex8: cve,
    formatHsl: fve,
    formatRgb: rz,
    toString: rz
  });
  function tz() {
    return this.rgb().formatHex();
  }
  function cve() {
    return this.rgb().formatHex8();
  }
  function fve() {
    return GV(this).formatHsl();
  }
  function rz() {
    return this.rgb().formatRgb();
  }
  function cx(e) {
    var t, r;
    return e = (e + "").trim().toLowerCase(), (t = nve.exec(e)) ? (r = t[1].length, t = parseInt(t[1], 16), r === 6 ? nz(t) : r === 3 ? new yo(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : r === 8 ? lE(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : r === 4 ? lE(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = ive.exec(e)) ? new yo(t[1], t[2], t[3], 1) : (t = ave.exec(e)) ? new yo(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = ove.exec(e)) ? lE(t[1], t[2], t[3], t[4]) : (t = uve.exec(e)) ? lE(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = sve.exec(e)) ? oz(t[1], t[2] / 100, t[3] / 100, 1) : (t = lve.exec(e)) ? oz(t[1], t[2] / 100, t[3] / 100, t[4]) : ez.hasOwnProperty(e) ? nz(ez[e]) : e === "transparent" ? new yo(NaN, NaN, NaN, 0) : null;
  }
  function nz(e) {
    return new yo(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
  }
  function lE(e, t, r, n) {
    return n <= 0 && (e = t = r = NaN), new yo(e, t, r, n);
  }
  function dve(e) {
    return e instanceof Yx || (e = cx(e)), e ? (e = e.rgb(), new yo(e.r, e.g, e.b, e.opacity)) : new yo();
  }
  function lM(e, t, r, n) {
    return arguments.length === 1 ? dve(e) : new yo(e, t, r, n ?? 1);
  }
  function yo(e, t, r, n) {
    this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
  }
  bj(yo, lM, YV(Yx, {
    brighter(e) {
      return e = e == null ? FS : Math.pow(FS, e), new yo(this.r * e, this.g * e, this.b * e, this.opacity);
    },
    darker(e) {
      return e = e == null ? sx : Math.pow(sx, e), new yo(this.r * e, this.g * e, this.b * e, this.opacity);
    },
    rgb() {
      return this;
    },
    clamp() {
      return new yo(kp(this.r), kp(this.g), kp(this.b), IS(this.opacity));
    },
    displayable() {
      return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: iz,
    // Deprecated! Use color.formatHex.
    formatHex: iz,
    formatHex8: pve,
    formatRgb: az,
    toString: az
  }));
  function iz() {
    return `#${Tp(this.r)}${Tp(this.g)}${Tp(this.b)}`;
  }
  function pve() {
    return `#${Tp(this.r)}${Tp(this.g)}${Tp(this.b)}${Tp((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
  }
  function az() {
    const e = IS(this.opacity);
    return `${e === 1 ? "rgb(" : "rgba("}${kp(this.r)}, ${kp(this.g)}, ${kp(this.b)}${e === 1 ? ")" : `, ${e})`}`;
  }
  function IS(e) {
    return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
  }
  function kp(e) {
    return Math.max(0, Math.min(255, Math.round(e) || 0));
  }
  function Tp(e) {
    return e = kp(e), (e < 16 ? "0" : "") + e.toString(16);
  }
  function oz(e, t, r, n) {
    return n <= 0 ? e = t = r = NaN : r <= 0 || r >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new fs(e, t, r, n);
  }
  function GV(e) {
    if (e instanceof fs) return new fs(e.h, e.s, e.l, e.opacity);
    if (e instanceof Yx || (e = cx(e)), !e) return new fs();
    if (e instanceof fs) return e;
    e = e.rgb();
    var t = e.r / 255, r = e.g / 255, n = e.b / 255, i = Math.min(t, r, n), u = Math.max(t, r, n), s = NaN, c = u - i, p = (u + i) / 2;
    return c ? (t === u ? s = (r - n) / c + (r < n) * 6 : r === u ? s = (n - t) / c + 2 : s = (t - r) / c + 4, c /= p < 0.5 ? u + i : 2 - u - i, s *= 60) : c = p > 0 && p < 1 ? 0 : s, new fs(s, c, p, e.opacity);
  }
  function hve(e, t, r, n) {
    return arguments.length === 1 ? GV(e) : new fs(e, t, r, n ?? 1);
  }
  function fs(e, t, r, n) {
    this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
  }
  bj(fs, hve, YV(Yx, {
    brighter(e) {
      return e = e == null ? FS : Math.pow(FS, e), new fs(this.h, this.s, this.l * e, this.opacity);
    },
    darker(e) {
      return e = e == null ? sx : Math.pow(sx, e), new fs(this.h, this.s, this.l * e, this.opacity);
    },
    rgb() {
      var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * t, i = 2 * r - n;
      return new yo(
        u2(e >= 240 ? e - 240 : e + 120, i, n),
        u2(e, i, n),
        u2(e < 120 ? e + 240 : e - 120, i, n),
        this.opacity
      );
    },
    clamp() {
      return new fs(uz(this.h), cE(this.s), cE(this.l), IS(this.opacity));
    },
    displayable() {
      return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl() {
      const e = IS(this.opacity);
      return `${e === 1 ? "hsl(" : "hsla("}${uz(this.h)}, ${cE(this.s) * 100}%, ${cE(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
    }
  }));
  function uz(e) {
    return e = (e || 0) % 360, e < 0 ? e + 360 : e;
  }
  function cE(e) {
    return Math.max(0, Math.min(1, e || 0));
  }
  function u2(e, t, r) {
    return (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t) * 255;
  }
  const wj = (e) => () => e;
  function vve(e, t) {
    return function(r) {
      return e + r * t;
    };
  }
  function mve(e, t, r) {
    return e = Math.pow(e, r), t = Math.pow(t, r) - e, r = 1 / r, function(n) {
      return Math.pow(e + n * t, r);
    };
  }
  function yve(e) {
    return (e = +e) == 1 ? QV : function(t, r) {
      return r - t ? mve(t, r, e) : wj(isNaN(t) ? r : t);
    };
  }
  function QV(e, t) {
    var r = t - e;
    return r ? vve(e, r) : wj(isNaN(e) ? t : e);
  }
  const sz = function e(t) {
    var r = yve(t);
    function n(i, u) {
      var s = r((i = lM(i)).r, (u = lM(u)).r), c = r(i.g, u.g), p = r(i.b, u.b), h = QV(i.opacity, u.opacity);
      return function(v) {
        return i.r = s(v), i.g = c(v), i.b = p(v), i.opacity = h(v), i + "";
      };
    }
    return n.gamma = e, n;
  }(1);
  function gve(e, t) {
    t || (t = []);
    var r = e ? Math.min(t.length, e.length) : 0, n = t.slice(), i;
    return function(u) {
      for (i = 0; i < r; ++i) n[i] = e[i] * (1 - u) + t[i] * u;
      return n;
    };
  }
  function xve(e) {
    return ArrayBuffer.isView(e) && !(e instanceof DataView);
  }
  function bve(e, t) {
    var r = t ? t.length : 0, n = e ? Math.min(r, e.length) : 0, i = new Array(n), u = new Array(r), s;
    for (s = 0; s < n; ++s) i[s] = X0(e[s], t[s]);
    for (; s < r; ++s) u[s] = t[s];
    return function(c) {
      for (s = 0; s < n; ++s) u[s] = i[s](c);
      return u;
    };
  }
  function wve(e, t) {
    var r = /* @__PURE__ */ new Date();
    return e = +e, t = +t, function(n) {
      return r.setTime(e * (1 - n) + t * n), r;
    };
  }
  function BS(e, t) {
    return e = +e, t = +t, function(r) {
      return e * (1 - r) + t * r;
    };
  }
  function Eve(e, t) {
    var r = {}, n = {}, i;
    (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
    for (i in t)
      i in e ? r[i] = X0(e[i], t[i]) : n[i] = t[i];
    return function(u) {
      for (i in r) n[i] = r[i](u);
      return n;
    };
  }
  var cM = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, s2 = new RegExp(cM.source, "g");
  function Sve(e) {
    return function() {
      return e;
    };
  }
  function _ve(e) {
    return function(t) {
      return e(t) + "";
    };
  }
  function Cve(e, t) {
    var r = cM.lastIndex = s2.lastIndex = 0, n, i, u, s = -1, c = [], p = [];
    for (e = e + "", t = t + ""; (n = cM.exec(e)) && (i = s2.exec(t)); )
      (u = i.index) > r && (u = t.slice(r, u), c[s] ? c[s] += u : c[++s] = u), (n = n[0]) === (i = i[0]) ? c[s] ? c[s] += i : c[++s] = i : (c[++s] = null, p.push({ i: s, x: BS(n, i) })), r = s2.lastIndex;
    return r < t.length && (u = t.slice(r), c[s] ? c[s] += u : c[++s] = u), c.length < 2 ? p[0] ? _ve(p[0].x) : Sve(t) : (t = p.length, function(h) {
      for (var v = 0, y; v < t; ++v) c[(y = p[v]).i] = y.x(h);
      return c.join("");
    });
  }
  function X0(e, t) {
    var r = typeof t, n;
    return t == null || r === "boolean" ? wj(t) : (r === "number" ? BS : r === "string" ? (n = cx(t)) ? (t = n, sz) : Cve : t instanceof cx ? sz : t instanceof Date ? wve : xve(t) ? gve : Array.isArray(t) ? bve : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? Eve : BS)(e, t);
  }
  function Ej(e, t) {
    return e = +e, t = +t, function(r) {
      return Math.round(e * (1 - r) + t * r);
    };
  }
  function Ove(e, t) {
    t === void 0 && (t = e, e = X0);
    for (var r = 0, n = t.length - 1, i = t[0], u = new Array(n < 0 ? 0 : n); r < n; ) u[r] = e(i, i = t[++r]);
    return function(s) {
      var c = Math.max(0, Math.min(n - 1, Math.floor(s *= n)));
      return u[c](s - c);
    };
  }
  function Tve(e) {
    return function() {
      return e;
    };
  }
  function LS(e) {
    return +e;
  }
  var lz = [0, 1];
  function Wa(e) {
    return e;
  }
  function fM(e, t) {
    return (t -= e = +e) ? function(r) {
      return (r - e) / t;
    } : Tve(isNaN(t) ? NaN : 0.5);
  }
  function Ave(e, t) {
    var r;
    return e > t && (r = e, e = t, t = r), function(n) {
      return Math.max(e, Math.min(t, n));
    };
  }
  function Dve(e, t, r) {
    var n = e[0], i = e[1], u = t[0], s = t[1];
    return i < n ? (n = fM(i, n), u = r(s, u)) : (n = fM(n, i), u = r(u, s)), function(c) {
      return u(n(c));
    };
  }
  function kve(e, t, r) {
    var n = Math.min(e.length, t.length) - 1, i = new Array(n), u = new Array(n), s = -1;
    for (e[n] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++s < n; )
      i[s] = fM(e[s], e[s + 1]), u[s] = r(t[s], t[s + 1]);
    return function(c) {
      var p = Wx(e, c, 1, n) - 1;
      return u[p](i[p](c));
    };
  }
  function Gx(e, t) {
    return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
  }
  function Q_() {
    var e = lz, t = lz, r = X0, n, i, u, s = Wa, c, p, h;
    function v() {
      var x = Math.min(e.length, t.length);
      return s !== Wa && (s = Ave(e[0], e[x - 1])), c = x > 2 ? kve : Dve, p = h = null, y;
    }
    function y(x) {
      return x == null || isNaN(x = +x) ? u : (p || (p = c(e.map(n), t, r)))(n(s(x)));
    }
    return y.invert = function(x) {
      return s(i((h || (h = c(t, e.map(n), BS)))(x)));
    }, y.domain = function(x) {
      return arguments.length ? (e = Array.from(x, LS), v()) : e.slice();
    }, y.range = function(x) {
      return arguments.length ? (t = Array.from(x), v()) : t.slice();
    }, y.rangeRound = function(x) {
      return t = Array.from(x), r = Ej, v();
    }, y.clamp = function(x) {
      return arguments.length ? (s = x ? !0 : Wa, v()) : s !== Wa;
    }, y.interpolate = function(x) {
      return arguments.length ? (r = x, v()) : r;
    }, y.unknown = function(x) {
      return arguments.length ? (u = x, y) : u;
    }, function(x, w) {
      return n = x, i = w, v();
    };
  }
  function Sj() {
    return Q_()(Wa, Wa);
  }
  function Rve(e) {
    return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
  }
  function $S(e, t) {
    if ((r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
    var r, n = e.slice(0, r);
    return [
      n.length > 1 ? n[0] + n.slice(2) : n,
      +e.slice(r + 1)
    ];
  }
  function m0(e) {
    return e = $S(Math.abs(e)), e ? e[1] : NaN;
  }
  function Pve(e, t) {
    return function(r, n) {
      for (var i = r.length, u = [], s = 0, c = e[0], p = 0; i > 0 && c > 0 && (p + c + 1 > n && (c = Math.max(1, n - p)), u.push(r.substring(i -= c, i + c)), !((p += c + 1) > n)); )
        c = e[s = (s + 1) % e.length];
      return u.reverse().join(t);
    };
  }
  function Mve(e) {
    return function(t) {
      return t.replace(/[0-9]/g, function(r) {
        return e[+r];
      });
    };
  }
  var Nve = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
  function fx(e) {
    if (!(t = Nve.exec(e))) throw new Error("invalid format: " + e);
    var t;
    return new _j({
      fill: t[1],
      align: t[2],
      sign: t[3],
      symbol: t[4],
      zero: t[5],
      width: t[6],
      comma: t[7],
      precision: t[8] && t[8].slice(1),
      trim: t[9],
      type: t[10]
    });
  }
  fx.prototype = _j.prototype;
  function _j(e) {
    this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
  }
  _j.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
  };
  function jve(e) {
    e: for (var t = e.length, r = 1, n = -1, i; r < t; ++r)
      switch (e[r]) {
        case ".":
          n = i = r;
          break;
        case "0":
          n === 0 && (n = r), i = r;
          break;
        default:
          if (!+e[r]) break e;
          n > 0 && (n = 0);
          break;
      }
    return n > 0 ? e.slice(0, n) + e.slice(i + 1) : e;
  }
  var KV;
  function Fve(e, t) {
    var r = $S(e, t);
    if (!r) return e + "";
    var n = r[0], i = r[1], u = i - (KV = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, s = n.length;
    return u === s ? n : u > s ? n + new Array(u - s + 1).join("0") : u > 0 ? n.slice(0, u) + "." + n.slice(u) : "0." + new Array(1 - u).join("0") + $S(e, Math.max(0, t + u - 1))[0];
  }
  function cz(e, t) {
    var r = $S(e, t);
    if (!r) return e + "";
    var n = r[0], i = r[1];
    return i < 0 ? "0." + new Array(-i).join("0") + n : n.length > i + 1 ? n.slice(0, i + 1) + "." + n.slice(i + 1) : n + new Array(i - n.length + 2).join("0");
  }
  const fz = {
    "%": (e, t) => (e * 100).toFixed(t),
    b: (e) => Math.round(e).toString(2),
    c: (e) => e + "",
    d: Rve,
    e: (e, t) => e.toExponential(t),
    f: (e, t) => e.toFixed(t),
    g: (e, t) => e.toPrecision(t),
    o: (e) => Math.round(e).toString(8),
    p: (e, t) => cz(e * 100, t),
    r: cz,
    s: Fve,
    X: (e) => Math.round(e).toString(16).toUpperCase(),
    x: (e) => Math.round(e).toString(16)
  };
  function dz(e) {
    return e;
  }
  var pz = Array.prototype.map, hz = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
  function Ive(e) {
    var t = e.grouping === void 0 || e.thousands === void 0 ? dz : Pve(pz.call(e.grouping, Number), e.thousands + ""), r = e.currency === void 0 ? "" : e.currency[0] + "", n = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", u = e.numerals === void 0 ? dz : Mve(pz.call(e.numerals, String)), s = e.percent === void 0 ? "%" : e.percent + "", c = e.minus === void 0 ? "−" : e.minus + "", p = e.nan === void 0 ? "NaN" : e.nan + "";
    function h(y) {
      y = fx(y);
      var x = y.fill, w = y.align, E = y.sign, C = y.symbol, S = y.zero, k = y.width, D = y.comma, A = y.precision, R = y.trim, T = y.type;
      T === "n" ? (D = !0, T = "g") : fz[T] || (A === void 0 && (A = 12), R = !0, T = "g"), (S || x === "0" && w === "=") && (S = !0, x = "0", w = "=");
      var M = C === "$" ? r : C === "#" && /[boxX]/.test(T) ? "0" + T.toLowerCase() : "", F = C === "$" ? n : /[%p]/.test(T) ? s : "", B = fz[T], V = /[defgprs%]/.test(T);
      A = A === void 0 ? 6 : /[gprs]/.test(T) ? Math.max(1, Math.min(21, A)) : Math.max(0, Math.min(20, A));
      function H(q) {
        var Q = M, W = F, J, ne, ie;
        if (T === "c")
          W = B(q) + W, q = "";
        else {
          q = +q;
          var se = q < 0 || 1 / q < 0;
          if (q = isNaN(q) ? p : B(Math.abs(q), A), R && (q = jve(q)), se && +q == 0 && E !== "+" && (se = !1), Q = (se ? E === "(" ? E : c : E === "-" || E === "(" ? "" : E) + Q, W = (T === "s" ? hz[8 + KV / 3] : "") + W + (se && E === "(" ? ")" : ""), V) {
            for (J = -1, ne = q.length; ++J < ne; )
              if (ie = q.charCodeAt(J), 48 > ie || ie > 57) {
                W = (ie === 46 ? i + q.slice(J + 1) : q.slice(J)) + W, q = q.slice(0, J);
                break;
              }
          }
        }
        D && !S && (q = t(q, 1 / 0));
        var X = Q.length + q.length + W.length, fe = X < k ? new Array(k - X + 1).join(x) : "";
        switch (D && S && (q = t(fe + q, fe.length ? k - W.length : 1 / 0), fe = ""), w) {
          case "<":
            q = Q + q + W + fe;
            break;
          case "=":
            q = Q + fe + q + W;
            break;
          case "^":
            q = fe.slice(0, X = fe.length >> 1) + Q + q + W + fe.slice(X);
            break;
          default:
            q = fe + Q + q + W;
            break;
        }
        return u(q);
      }
      return H.toString = function() {
        return y + "";
      }, H;
    }
    function v(y, x) {
      var w = h((y = fx(y), y.type = "f", y)), E = Math.max(-8, Math.min(8, Math.floor(m0(x) / 3))) * 3, C = Math.pow(10, -E), S = hz[8 + E / 3];
      return function(k) {
        return w(C * k) + S;
      };
    }
    return {
      format: h,
      formatPrefix: v
    };
  }
  var fE, Cj, XV;
  Bve({
    thousands: ",",
    grouping: [3],
    currency: ["$", ""]
  });
  function Bve(e) {
    return fE = Ive(e), Cj = fE.format, XV = fE.formatPrefix, fE;
  }
  function Lve(e) {
    return Math.max(0, -m0(Math.abs(e)));
  }
  function $ve(e, t) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor(m0(t) / 3))) * 3 - m0(Math.abs(e)));
  }
  function zve(e, t) {
    return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, m0(t) - m0(e)) + 1;
  }
  function ZV(e, t, r, n) {
    var i = uM(e, t, r), u;
    switch (n = fx(n ?? ",f"), n.type) {
      case "s": {
        var s = Math.max(Math.abs(e), Math.abs(t));
        return n.precision == null && !isNaN(u = $ve(i, s)) && (n.precision = u), XV(n, s);
      }
      case "":
      case "e":
      case "g":
      case "p":
      case "r": {
        n.precision == null && !isNaN(u = zve(i, Math.max(Math.abs(e), Math.abs(t)))) && (n.precision = u - (n.type === "e"));
        break;
      }
      case "f":
      case "%": {
        n.precision == null && !isNaN(u = Lve(i)) && (n.precision = u - (n.type === "%") * 2);
        break;
      }
    }
    return Cj(n);
  }
  function Kf(e) {
    var t = e.domain;
    return e.ticks = function(r) {
      var n = t();
      return aM(n[0], n[n.length - 1], r ?? 10);
    }, e.tickFormat = function(r, n) {
      var i = t();
      return ZV(i[0], i[i.length - 1], r ?? 10, n);
    }, e.nice = function(r) {
      r == null && (r = 10);
      var n = t(), i = 0, u = n.length - 1, s = n[i], c = n[u], p, h, v = 10;
      for (c < s && (h = s, s = c, c = h, h = i, i = u, u = h); v-- > 0; ) {
        if (h = oM(s, c, r), h === p)
          return n[i] = s, n[u] = c, t(n);
        if (h > 0)
          s = Math.floor(s / h) * h, c = Math.ceil(c / h) * h;
        else if (h < 0)
          s = Math.ceil(s * h) / h, c = Math.floor(c * h) / h;
        else
          break;
        p = h;
      }
      return e;
    }, e;
  }
  function zS() {
    var e = Sj();
    return e.copy = function() {
      return Gx(e, zS());
    }, Au.apply(e, arguments), Kf(e);
  }
  function JV(e) {
    var t;
    function r(n) {
      return n == null || isNaN(n = +n) ? t : n;
    }
    return r.invert = r, r.domain = r.range = function(n) {
      return arguments.length ? (e = Array.from(n, LS), r) : e.slice();
    }, r.unknown = function(n) {
      return arguments.length ? (t = n, r) : t;
    }, r.copy = function() {
      return JV(e).unknown(t);
    }, e = arguments.length ? Array.from(e, LS) : [0, 1], Kf(r);
  }
  function eW(e, t) {
    e = e.slice();
    var r = 0, n = e.length - 1, i = e[r], u = e[n], s;
    return u < i && (s = r, r = n, n = s, s = i, i = u, u = s), e[r] = t.floor(i), e[n] = t.ceil(u), e;
  }
  function vz(e) {
    return Math.log(e);
  }
  function mz(e) {
    return Math.exp(e);
  }
  function qve(e) {
    return -Math.log(-e);
  }
  function Uve(e) {
    return -Math.exp(-e);
  }
  function Hve(e) {
    return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
  }
  function Vve(e) {
    return e === 10 ? Hve : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
  }
  function Wve(e) {
    return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
  }
  function yz(e) {
    return (t, r) => -e(-t, r);
  }
  function Oj(e) {
    const t = e(vz, mz), r = t.domain;
    let n = 10, i, u;
    function s() {
      return i = Wve(n), u = Vve(n), r()[0] < 0 ? (i = yz(i), u = yz(u), e(qve, Uve)) : e(vz, mz), t;
    }
    return t.base = function(c) {
      return arguments.length ? (n = +c, s()) : n;
    }, t.domain = function(c) {
      return arguments.length ? (r(c), s()) : r();
    }, t.ticks = (c) => {
      const p = r();
      let h = p[0], v = p[p.length - 1];
      const y = v < h;
      y && ([h, v] = [v, h]);
      let x = i(h), w = i(v), E, C;
      const S = c == null ? 10 : +c;
      let k = [];
      if (!(n % 1) && w - x < S) {
        if (x = Math.floor(x), w = Math.ceil(w), h > 0) {
          for (; x <= w; ++x)
            for (E = 1; E < n; ++E)
              if (C = x < 0 ? E / u(-x) : E * u(x), !(C < h)) {
                if (C > v) break;
                k.push(C);
              }
        } else for (; x <= w; ++x)
          for (E = n - 1; E >= 1; --E)
            if (C = x > 0 ? E / u(-x) : E * u(x), !(C < h)) {
              if (C > v) break;
              k.push(C);
            }
        k.length * 2 < S && (k = aM(h, v, S));
      } else
        k = aM(x, w, Math.min(w - x, S)).map(u);
      return y ? k.reverse() : k;
    }, t.tickFormat = (c, p) => {
      if (c == null && (c = 10), p == null && (p = n === 10 ? "s" : ","), typeof p != "function" && (!(n % 1) && (p = fx(p)).precision == null && (p.trim = !0), p = Cj(p)), c === 1 / 0) return p;
      const h = Math.max(1, n * c / t.ticks().length);
      return (v) => {
        let y = v / u(Math.round(i(v)));
        return y * n < n - 0.5 && (y *= n), y <= h ? p(v) : "";
      };
    }, t.nice = () => r(eW(r(), {
      floor: (c) => u(Math.floor(i(c))),
      ceil: (c) => u(Math.ceil(i(c)))
    })), t;
  }
  function tW() {
    const e = Oj(Q_()).domain([1, 10]);
    return e.copy = () => Gx(e, tW()).base(e.base()), Au.apply(e, arguments), e;
  }
  function gz(e) {
    return function(t) {
      return Math.sign(t) * Math.log1p(Math.abs(t / e));
    };
  }
  function xz(e) {
    return function(t) {
      return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
    };
  }
  function Tj(e) {
    var t = 1, r = e(gz(t), xz(t));
    return r.constant = function(n) {
      return arguments.length ? e(gz(t = +n), xz(t)) : t;
    }, Kf(r);
  }
  function rW() {
    var e = Tj(Q_());
    return e.copy = function() {
      return Gx(e, rW()).constant(e.constant());
    }, Au.apply(e, arguments);
  }
  function bz(e) {
    return function(t) {
      return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
    };
  }
  function Yve(e) {
    return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
  }
  function Gve(e) {
    return e < 0 ? -e * e : e * e;
  }
  function Aj(e) {
    var t = e(Wa, Wa), r = 1;
    function n() {
      return r === 1 ? e(Wa, Wa) : r === 0.5 ? e(Yve, Gve) : e(bz(r), bz(1 / r));
    }
    return t.exponent = function(i) {
      return arguments.length ? (r = +i, n()) : r;
    }, Kf(t);
  }
  function Dj() {
    var e = Aj(Q_());
    return e.copy = function() {
      return Gx(e, Dj()).exponent(e.exponent());
    }, Au.apply(e, arguments), e;
  }
  function Qve() {
    return Dj.apply(null, arguments).exponent(0.5);
  }
  function wz(e) {
    return Math.sign(e) * e * e;
  }
  function Kve(e) {
    return Math.sign(e) * Math.sqrt(Math.abs(e));
  }
  function nW() {
    var e = Sj(), t = [0, 1], r = !1, n;
    function i(u) {
      var s = Kve(e(u));
      return isNaN(s) ? n : r ? Math.round(s) : s;
    }
    return i.invert = function(u) {
      return e.invert(wz(u));
    }, i.domain = function(u) {
      return arguments.length ? (e.domain(u), i) : e.domain();
    }, i.range = function(u) {
      return arguments.length ? (e.range((t = Array.from(u, LS)).map(wz)), i) : t.slice();
    }, i.rangeRound = function(u) {
      return i.range(u).round(!0);
    }, i.round = function(u) {
      return arguments.length ? (r = !!u, i) : r;
    }, i.clamp = function(u) {
      return arguments.length ? (e.clamp(u), i) : e.clamp();
    }, i.unknown = function(u) {
      return arguments.length ? (n = u, i) : n;
    }, i.copy = function() {
      return nW(e.domain(), t).round(r).clamp(e.clamp()).unknown(n);
    }, Au.apply(i, arguments), Kf(i);
  }
  function iW() {
    var e = [], t = [], r = [], n;
    function i() {
      var s = 0, c = Math.max(1, t.length);
      for (r = new Array(c - 1); ++s < c; ) r[s - 1] = tve(e, s / c);
      return u;
    }
    function u(s) {
      return s == null || isNaN(s = +s) ? n : t[Wx(r, s)];
    }
    return u.invertExtent = function(s) {
      var c = t.indexOf(s);
      return c < 0 ? [NaN, NaN] : [
        c > 0 ? r[c - 1] : e[0],
        c < r.length ? r[c] : e[e.length - 1]
      ];
    }, u.domain = function(s) {
      if (!arguments.length) return e.slice();
      e = [];
      for (let c of s) c != null && !isNaN(c = +c) && e.push(c);
      return e.sort(If), i();
    }, u.range = function(s) {
      return arguments.length ? (t = Array.from(s), i()) : t.slice();
    }, u.unknown = function(s) {
      return arguments.length ? (n = s, u) : n;
    }, u.quantiles = function() {
      return r.slice();
    }, u.copy = function() {
      return iW().domain(e).range(t).unknown(n);
    }, Au.apply(u, arguments);
  }
  function aW() {
    var e = 0, t = 1, r = 1, n = [0.5], i = [0, 1], u;
    function s(p) {
      return p != null && p <= p ? i[Wx(n, p, 0, r)] : u;
    }
    function c() {
      var p = -1;
      for (n = new Array(r); ++p < r; ) n[p] = ((p + 1) * t - (p - r) * e) / (r + 1);
      return s;
    }
    return s.domain = function(p) {
      return arguments.length ? ([e, t] = p, e = +e, t = +t, c()) : [e, t];
    }, s.range = function(p) {
      return arguments.length ? (r = (i = Array.from(p)).length - 1, c()) : i.slice();
    }, s.invertExtent = function(p) {
      var h = i.indexOf(p);
      return h < 0 ? [NaN, NaN] : h < 1 ? [e, n[0]] : h >= r ? [n[r - 1], t] : [n[h - 1], n[h]];
    }, s.unknown = function(p) {
      return arguments.length && (u = p), s;
    }, s.thresholds = function() {
      return n.slice();
    }, s.copy = function() {
      return aW().domain([e, t]).range(i).unknown(u);
    }, Au.apply(Kf(s), arguments);
  }
  function oW() {
    var e = [0.5], t = [0, 1], r, n = 1;
    function i(u) {
      return u != null && u <= u ? t[Wx(e, u, 0, n)] : r;
    }
    return i.domain = function(u) {
      return arguments.length ? (e = Array.from(u), n = Math.min(e.length, t.length - 1), i) : e.slice();
    }, i.range = function(u) {
      return arguments.length ? (t = Array.from(u), n = Math.min(e.length, t.length - 1), i) : t.slice();
    }, i.invertExtent = function(u) {
      var s = t.indexOf(u);
      return [e[s - 1], e[s]];
    }, i.unknown = function(u) {
      return arguments.length ? (r = u, i) : r;
    }, i.copy = function() {
      return oW().domain(e).range(t).unknown(r);
    }, Au.apply(i, arguments);
  }
  const l2 = /* @__PURE__ */ new Date(), c2 = /* @__PURE__ */ new Date();
  function Ri(e, t, r, n) {
    function i(u) {
      return e(u = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+u)), u;
    }
    return i.floor = (u) => (e(u = /* @__PURE__ */ new Date(+u)), u), i.ceil = (u) => (e(u = new Date(u - 1)), t(u, 1), e(u), u), i.round = (u) => {
      const s = i(u), c = i.ceil(u);
      return u - s < c - u ? s : c;
    }, i.offset = (u, s) => (t(u = /* @__PURE__ */ new Date(+u), s == null ? 1 : Math.floor(s)), u), i.range = (u, s, c) => {
      const p = [];
      if (u = i.ceil(u), c = c == null ? 1 : Math.floor(c), !(u < s) || !(c > 0)) return p;
      let h;
      do
        p.push(h = /* @__PURE__ */ new Date(+u)), t(u, c), e(u);
      while (h < u && u < s);
      return p;
    }, i.filter = (u) => Ri((s) => {
      if (s >= s) for (; e(s), !u(s); ) s.setTime(s - 1);
    }, (s, c) => {
      if (s >= s)
        if (c < 0) for (; ++c <= 0; )
          for (; t(s, -1), !u(s); )
            ;
        else for (; --c >= 0; )
          for (; t(s, 1), !u(s); )
            ;
    }), r && (i.count = (u, s) => (l2.setTime(+u), c2.setTime(+s), e(l2), e(c2), Math.floor(r(l2, c2))), i.every = (u) => (u = Math.floor(u), !isFinite(u) || !(u > 0) ? null : u > 1 ? i.filter(n ? (s) => n(s) % u === 0 : (s) => i.count(0, s) % u === 0) : i)), i;
  }
  const qS = Ri(() => {
  }, (e, t) => {
    e.setTime(+e + t);
  }, (e, t) => t - e);
  qS.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Ri((t) => {
    t.setTime(Math.floor(t / e) * e);
  }, (t, r) => {
    t.setTime(+t + r * e);
  }, (t, r) => (r - t) / e) : qS);
  qS.range;
  const fc = 1e3, Eu = fc * 60, dc = Eu * 60, wc = dc * 24, kj = wc * 7, Ez = wc * 30, f2 = wc * 365, Ap = Ri((e) => {
    e.setTime(e - e.getMilliseconds());
  }, (e, t) => {
    e.setTime(+e + t * fc);
  }, (e, t) => (t - e) / fc, (e) => e.getUTCSeconds());
  Ap.range;
  const Rj = Ri((e) => {
    e.setTime(e - e.getMilliseconds() - e.getSeconds() * fc);
  }, (e, t) => {
    e.setTime(+e + t * Eu);
  }, (e, t) => (t - e) / Eu, (e) => e.getMinutes());
  Rj.range;
  const Pj = Ri((e) => {
    e.setUTCSeconds(0, 0);
  }, (e, t) => {
    e.setTime(+e + t * Eu);
  }, (e, t) => (t - e) / Eu, (e) => e.getUTCMinutes());
  Pj.range;
  const Mj = Ri((e) => {
    e.setTime(e - e.getMilliseconds() - e.getSeconds() * fc - e.getMinutes() * Eu);
  }, (e, t) => {
    e.setTime(+e + t * dc);
  }, (e, t) => (t - e) / dc, (e) => e.getHours());
  Mj.range;
  const Nj = Ri((e) => {
    e.setUTCMinutes(0, 0, 0);
  }, (e, t) => {
    e.setTime(+e + t * dc);
  }, (e, t) => (t - e) / dc, (e) => e.getUTCHours());
  Nj.range;
  const Qx = Ri(
    (e) => e.setHours(0, 0, 0, 0),
    (e, t) => e.setDate(e.getDate() + t),
    (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Eu) / wc,
    (e) => e.getDate() - 1
  );
  Qx.range;
  const K_ = Ri((e) => {
    e.setUTCHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setUTCDate(e.getUTCDate() + t);
  }, (e, t) => (t - e) / wc, (e) => e.getUTCDate() - 1);
  K_.range;
  const uW = Ri((e) => {
    e.setUTCHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setUTCDate(e.getUTCDate() + t);
  }, (e, t) => (t - e) / wc, (e) => Math.floor(e / wc));
  uW.range;
  function Hp(e) {
    return Ri((t) => {
      t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
    }, (t, r) => {
      t.setDate(t.getDate() + r * 7);
    }, (t, r) => (r - t - (r.getTimezoneOffset() - t.getTimezoneOffset()) * Eu) / kj);
  }
  const X_ = Hp(0), US = Hp(1), Xve = Hp(2), Zve = Hp(3), y0 = Hp(4), Jve = Hp(5), e0e = Hp(6);
  X_.range;
  US.range;
  Xve.range;
  Zve.range;
  y0.range;
  Jve.range;
  e0e.range;
  function Vp(e) {
    return Ri((t) => {
      t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
    }, (t, r) => {
      t.setUTCDate(t.getUTCDate() + r * 7);
    }, (t, r) => (r - t) / kj);
  }
  const Z_ = Vp(0), HS = Vp(1), t0e = Vp(2), r0e = Vp(3), g0 = Vp(4), n0e = Vp(5), i0e = Vp(6);
  Z_.range;
  HS.range;
  t0e.range;
  r0e.range;
  g0.range;
  n0e.range;
  i0e.range;
  const jj = Ri((e) => {
    e.setDate(1), e.setHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setMonth(e.getMonth() + t);
  }, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
  jj.range;
  const Fj = Ri((e) => {
    e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setUTCMonth(e.getUTCMonth() + t);
  }, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
  Fj.range;
  const Ec = Ri((e) => {
    e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setFullYear(e.getFullYear() + t);
  }, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
  Ec.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Ri((t) => {
    t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setFullYear(t.getFullYear() + r * e);
  });
  Ec.range;
  const Sc = Ri((e) => {
    e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setUTCFullYear(e.getUTCFullYear() + t);
  }, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
  Sc.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Ri((t) => {
    t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setUTCFullYear(t.getUTCFullYear() + r * e);
  });
  Sc.range;
  function sW(e, t, r, n, i, u) {
    const s = [
      [Ap, 1, fc],
      [Ap, 5, 5 * fc],
      [Ap, 15, 15 * fc],
      [Ap, 30, 30 * fc],
      [u, 1, Eu],
      [u, 5, 5 * Eu],
      [u, 15, 15 * Eu],
      [u, 30, 30 * Eu],
      [i, 1, dc],
      [i, 3, 3 * dc],
      [i, 6, 6 * dc],
      [i, 12, 12 * dc],
      [n, 1, wc],
      [n, 2, 2 * wc],
      [r, 1, kj],
      [t, 1, Ez],
      [t, 3, 3 * Ez],
      [e, 1, f2]
    ];
    function c(h, v, y) {
      const x = v < h;
      x && ([h, v] = [v, h]);
      const w = y && typeof y.range == "function" ? y : p(h, v, y), E = w ? w.range(h, +v + 1) : [];
      return x ? E.reverse() : E;
    }
    function p(h, v, y) {
      const x = Math.abs(v - h) / y, w = gj(([, , S]) => S).right(s, x);
      if (w === s.length) return e.every(uM(h / f2, v / f2, y));
      if (w === 0) return qS.every(Math.max(uM(h, v, y), 1));
      const [E, C] = s[x / s[w - 1][2] < s[w][2] / x ? w - 1 : w];
      return E.every(C);
    }
    return [c, p];
  }
  const [a0e, o0e] = sW(Sc, Fj, Z_, uW, Nj, Pj), [u0e, s0e] = sW(Ec, jj, X_, Qx, Mj, Rj);
  function d2(e) {
    if (0 <= e.y && e.y < 100) {
      var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
      return t.setFullYear(e.y), t;
    }
    return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
  }
  function p2(e) {
    if (0 <= e.y && e.y < 100) {
      var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
      return t.setUTCFullYear(e.y), t;
    }
    return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
  }
  function xg(e, t, r) {
    return { y: e, m: t, d: r, H: 0, M: 0, S: 0, L: 0 };
  }
  function l0e(e) {
    var t = e.dateTime, r = e.date, n = e.time, i = e.periods, u = e.days, s = e.shortDays, c = e.months, p = e.shortMonths, h = bg(i), v = wg(i), y = bg(u), x = wg(u), w = bg(s), E = wg(s), C = bg(c), S = wg(c), k = bg(p), D = wg(p), A = {
      a: se,
      A: X,
      b: fe,
      B: Z,
      c: null,
      d: Az,
      e: Az,
      f: P0e,
      g: q0e,
      G: H0e,
      H: D0e,
      I: k0e,
      j: R0e,
      L: lW,
      m: M0e,
      M: N0e,
      p: z,
      q: Y,
      Q: Rz,
      s: Pz,
      S: j0e,
      u: F0e,
      U: I0e,
      V: B0e,
      w: L0e,
      W: $0e,
      x: null,
      X: null,
      y: z0e,
      Y: U0e,
      Z: V0e,
      "%": kz
    }, R = {
      a: te,
      A: ae,
      b: De,
      B: ke,
      c: null,
      d: Dz,
      e: Dz,
      f: Q0e,
      g: ame,
      G: ume,
      H: W0e,
      I: Y0e,
      j: G0e,
      L: fW,
      m: K0e,
      M: X0e,
      p: Re,
      q: Te,
      Q: Rz,
      s: Pz,
      S: Z0e,
      u: J0e,
      U: eme,
      V: tme,
      w: rme,
      W: nme,
      x: null,
      X: null,
      y: ime,
      Y: ome,
      Z: sme,
      "%": kz
    }, T = {
      a: H,
      A: q,
      b: Q,
      B: W,
      c: J,
      d: Oz,
      e: Oz,
      f: C0e,
      g: Cz,
      G: _z,
      H: Tz,
      I: Tz,
      j: w0e,
      L: _0e,
      m: b0e,
      M: E0e,
      p: V,
      q: x0e,
      Q: T0e,
      s: A0e,
      S: S0e,
      u: h0e,
      U: v0e,
      V: m0e,
      w: p0e,
      W: y0e,
      x: ne,
      X: ie,
      y: Cz,
      Y: _z,
      Z: g0e,
      "%": O0e
    };
    A.x = M(r, A), A.X = M(n, A), A.c = M(t, A), R.x = M(r, R), R.X = M(n, R), R.c = M(t, R);
    function M(we, Fe) {
      return function(Ye) {
        var de = [], Ze = -1, Ne = 0, Ot = we.length, At, Qt, Wr;
        for (Ye instanceof Date || (Ye = /* @__PURE__ */ new Date(+Ye)); ++Ze < Ot; )
          we.charCodeAt(Ze) === 37 && (de.push(we.slice(Ne, Ze)), (Qt = Sz[At = we.charAt(++Ze)]) != null ? At = we.charAt(++Ze) : Qt = At === "e" ? " " : "0", (Wr = Fe[At]) && (At = Wr(Ye, Qt)), de.push(At), Ne = Ze + 1);
        return de.push(we.slice(Ne, Ze)), de.join("");
      };
    }
    function F(we, Fe) {
      return function(Ye) {
        var de = xg(1900, void 0, 1), Ze = B(de, we, Ye += "", 0), Ne, Ot;
        if (Ze != Ye.length) return null;
        if ("Q" in de) return new Date(de.Q);
        if ("s" in de) return new Date(de.s * 1e3 + ("L" in de ? de.L : 0));
        if (Fe && !("Z" in de) && (de.Z = 0), "p" in de && (de.H = de.H % 12 + de.p * 12), de.m === void 0 && (de.m = "q" in de ? de.q : 0), "V" in de) {
          if (de.V < 1 || de.V > 53) return null;
          "w" in de || (de.w = 1), "Z" in de ? (Ne = p2(xg(de.y, 0, 1)), Ot = Ne.getUTCDay(), Ne = Ot > 4 || Ot === 0 ? HS.ceil(Ne) : HS(Ne), Ne = K_.offset(Ne, (de.V - 1) * 7), de.y = Ne.getUTCFullYear(), de.m = Ne.getUTCMonth(), de.d = Ne.getUTCDate() + (de.w + 6) % 7) : (Ne = d2(xg(de.y, 0, 1)), Ot = Ne.getDay(), Ne = Ot > 4 || Ot === 0 ? US.ceil(Ne) : US(Ne), Ne = Qx.offset(Ne, (de.V - 1) * 7), de.y = Ne.getFullYear(), de.m = Ne.getMonth(), de.d = Ne.getDate() + (de.w + 6) % 7);
        } else ("W" in de || "U" in de) && ("w" in de || (de.w = "u" in de ? de.u % 7 : "W" in de ? 1 : 0), Ot = "Z" in de ? p2(xg(de.y, 0, 1)).getUTCDay() : d2(xg(de.y, 0, 1)).getDay(), de.m = 0, de.d = "W" in de ? (de.w + 6) % 7 + de.W * 7 - (Ot + 5) % 7 : de.w + de.U * 7 - (Ot + 6) % 7);
        return "Z" in de ? (de.H += de.Z / 100 | 0, de.M += de.Z % 100, p2(de)) : d2(de);
      };
    }
    function B(we, Fe, Ye, de) {
      for (var Ze = 0, Ne = Fe.length, Ot = Ye.length, At, Qt; Ze < Ne; ) {
        if (de >= Ot) return -1;
        if (At = Fe.charCodeAt(Ze++), At === 37) {
          if (At = Fe.charAt(Ze++), Qt = T[At in Sz ? Fe.charAt(Ze++) : At], !Qt || (de = Qt(we, Ye, de)) < 0) return -1;
        } else if (At != Ye.charCodeAt(de++))
          return -1;
      }
      return de;
    }
    function V(we, Fe, Ye) {
      var de = h.exec(Fe.slice(Ye));
      return de ? (we.p = v.get(de[0].toLowerCase()), Ye + de[0].length) : -1;
    }
    function H(we, Fe, Ye) {
      var de = w.exec(Fe.slice(Ye));
      return de ? (we.w = E.get(de[0].toLowerCase()), Ye + de[0].length) : -1;
    }
    function q(we, Fe, Ye) {
      var de = y.exec(Fe.slice(Ye));
      return de ? (we.w = x.get(de[0].toLowerCase()), Ye + de[0].length) : -1;
    }
    function Q(we, Fe, Ye) {
      var de = k.exec(Fe.slice(Ye));
      return de ? (we.m = D.get(de[0].toLowerCase()), Ye + de[0].length) : -1;
    }
    function W(we, Fe, Ye) {
      var de = C.exec(Fe.slice(Ye));
      return de ? (we.m = S.get(de[0].toLowerCase()), Ye + de[0].length) : -1;
    }
    function J(we, Fe, Ye) {
      return B(we, t, Fe, Ye);
    }
    function ne(we, Fe, Ye) {
      return B(we, r, Fe, Ye);
    }
    function ie(we, Fe, Ye) {
      return B(we, n, Fe, Ye);
    }
    function se(we) {
      return s[we.getDay()];
    }
    function X(we) {
      return u[we.getDay()];
    }
    function fe(we) {
      return p[we.getMonth()];
    }
    function Z(we) {
      return c[we.getMonth()];
    }
    function z(we) {
      return i[+(we.getHours() >= 12)];
    }
    function Y(we) {
      return 1 + ~~(we.getMonth() / 3);
    }
    function te(we) {
      return s[we.getUTCDay()];
    }
    function ae(we) {
      return u[we.getUTCDay()];
    }
    function De(we) {
      return p[we.getUTCMonth()];
    }
    function ke(we) {
      return c[we.getUTCMonth()];
    }
    function Re(we) {
      return i[+(we.getUTCHours() >= 12)];
    }
    function Te(we) {
      return 1 + ~~(we.getUTCMonth() / 3);
    }
    return {
      format: function(we) {
        var Fe = M(we += "", A);
        return Fe.toString = function() {
          return we;
        }, Fe;
      },
      parse: function(we) {
        var Fe = F(we += "", !1);
        return Fe.toString = function() {
          return we;
        }, Fe;
      },
      utcFormat: function(we) {
        var Fe = M(we += "", R);
        return Fe.toString = function() {
          return we;
        }, Fe;
      },
      utcParse: function(we) {
        var Fe = F(we += "", !0);
        return Fe.toString = function() {
          return we;
        }, Fe;
      }
    };
  }
  var Sz = { "-": "", _: " ", 0: "0" }, Li = /^\s*\d+/, c0e = /^%/, f0e = /[\\^$*+?|[\]().{}]/g;
  function Tr(e, t, r) {
    var n = e < 0 ? "-" : "", i = (n ? -e : e) + "", u = i.length;
    return n + (u < r ? new Array(r - u + 1).join(t) + i : i);
  }
  function d0e(e) {
    return e.replace(f0e, "\\$&");
  }
  function bg(e) {
    return new RegExp("^(?:" + e.map(d0e).join("|") + ")", "i");
  }
  function wg(e) {
    return new Map(e.map((t, r) => [t.toLowerCase(), r]));
  }
  function p0e(e, t, r) {
    var n = Li.exec(t.slice(r, r + 1));
    return n ? (e.w = +n[0], r + n[0].length) : -1;
  }
  function h0e(e, t, r) {
    var n = Li.exec(t.slice(r, r + 1));
    return n ? (e.u = +n[0], r + n[0].length) : -1;
  }
  function v0e(e, t, r) {
    var n = Li.exec(t.slice(r, r + 2));
    return n ? (e.U = +n[0], r + n[0].length) : -1;
  }
  function m0e(e, t, r) {
    var n = Li.exec(t.slice(r, r + 2));
    return n ? (e.V = +n[0], r + n[0].length) : -1;
  }
  function y0e(e, t, r) {
    var n = Li.exec(t.slice(r, r + 2));
    return n ? (e.W = +n[0], r + n[0].length) : -1;
  }
  function _z(e, t, r) {
    var n = Li.exec(t.slice(r, r + 4));
    return n ? (e.y = +n[0], r + n[0].length) : -1;
  }
  function Cz(e, t, r) {
    var n = Li.exec(t.slice(r, r + 2));
    return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
  }
  function g0e(e, t, r) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
    return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
  }
  function x0e(e, t, r) {
    var n = Li.exec(t.slice(r, r + 1));
    return n ? (e.q = n[0] * 3 - 3, r + n[0].length) : -1;
  }
  function b0e(e, t, r) {
    var n = Li.exec(t.slice(r, r + 2));
    return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
  }
  function Oz(e, t, r) {
    var n = Li.exec(t.slice(r, r + 2));
    return n ? (e.d = +n[0], r + n[0].length) : -1;
  }
  function w0e(e, t, r) {
    var n = Li.exec(t.slice(r, r + 3));
    return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
  }
  function Tz(e, t, r) {
    var n = Li.exec(t.slice(r, r + 2));
    return n ? (e.H = +n[0], r + n[0].length) : -1;
  }
  function E0e(e, t, r) {
    var n = Li.exec(t.slice(r, r + 2));
    return n ? (e.M = +n[0], r + n[0].length) : -1;
  }
  function S0e(e, t, r) {
    var n = Li.exec(t.slice(r, r + 2));
    return n ? (e.S = +n[0], r + n[0].length) : -1;
  }
  function _0e(e, t, r) {
    var n = Li.exec(t.slice(r, r + 3));
    return n ? (e.L = +n[0], r + n[0].length) : -1;
  }
  function C0e(e, t, r) {
    var n = Li.exec(t.slice(r, r + 6));
    return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
  }
  function O0e(e, t, r) {
    var n = c0e.exec(t.slice(r, r + 1));
    return n ? r + n[0].length : -1;
  }
  function T0e(e, t, r) {
    var n = Li.exec(t.slice(r));
    return n ? (e.Q = +n[0], r + n[0].length) : -1;
  }
  function A0e(e, t, r) {
    var n = Li.exec(t.slice(r));
    return n ? (e.s = +n[0], r + n[0].length) : -1;
  }
  function Az(e, t) {
    return Tr(e.getDate(), t, 2);
  }
  function D0e(e, t) {
    return Tr(e.getHours(), t, 2);
  }
  function k0e(e, t) {
    return Tr(e.getHours() % 12 || 12, t, 2);
  }
  function R0e(e, t) {
    return Tr(1 + Qx.count(Ec(e), e), t, 3);
  }
  function lW(e, t) {
    return Tr(e.getMilliseconds(), t, 3);
  }
  function P0e(e, t) {
    return lW(e, t) + "000";
  }
  function M0e(e, t) {
    return Tr(e.getMonth() + 1, t, 2);
  }
  function N0e(e, t) {
    return Tr(e.getMinutes(), t, 2);
  }
  function j0e(e, t) {
    return Tr(e.getSeconds(), t, 2);
  }
  function F0e(e) {
    var t = e.getDay();
    return t === 0 ? 7 : t;
  }
  function I0e(e, t) {
    return Tr(X_.count(Ec(e) - 1, e), t, 2);
  }
  function cW(e) {
    var t = e.getDay();
    return t >= 4 || t === 0 ? y0(e) : y0.ceil(e);
  }
  function B0e(e, t) {
    return e = cW(e), Tr(y0.count(Ec(e), e) + (Ec(e).getDay() === 4), t, 2);
  }
  function L0e(e) {
    return e.getDay();
  }
  function $0e(e, t) {
    return Tr(US.count(Ec(e) - 1, e), t, 2);
  }
  function z0e(e, t) {
    return Tr(e.getFullYear() % 100, t, 2);
  }
  function q0e(e, t) {
    return e = cW(e), Tr(e.getFullYear() % 100, t, 2);
  }
  function U0e(e, t) {
    return Tr(e.getFullYear() % 1e4, t, 4);
  }
  function H0e(e, t) {
    var r = e.getDay();
    return e = r >= 4 || r === 0 ? y0(e) : y0.ceil(e), Tr(e.getFullYear() % 1e4, t, 4);
  }
  function V0e(e) {
    var t = e.getTimezoneOffset();
    return (t > 0 ? "-" : (t *= -1, "+")) + Tr(t / 60 | 0, "0", 2) + Tr(t % 60, "0", 2);
  }
  function Dz(e, t) {
    return Tr(e.getUTCDate(), t, 2);
  }
  function W0e(e, t) {
    return Tr(e.getUTCHours(), t, 2);
  }
  function Y0e(e, t) {
    return Tr(e.getUTCHours() % 12 || 12, t, 2);
  }
  function G0e(e, t) {
    return Tr(1 + K_.count(Sc(e), e), t, 3);
  }
  function fW(e, t) {
    return Tr(e.getUTCMilliseconds(), t, 3);
  }
  function Q0e(e, t) {
    return fW(e, t) + "000";
  }
  function K0e(e, t) {
    return Tr(e.getUTCMonth() + 1, t, 2);
  }
  function X0e(e, t) {
    return Tr(e.getUTCMinutes(), t, 2);
  }
  function Z0e(e, t) {
    return Tr(e.getUTCSeconds(), t, 2);
  }
  function J0e(e) {
    var t = e.getUTCDay();
    return t === 0 ? 7 : t;
  }
  function eme(e, t) {
    return Tr(Z_.count(Sc(e) - 1, e), t, 2);
  }
  function dW(e) {
    var t = e.getUTCDay();
    return t >= 4 || t === 0 ? g0(e) : g0.ceil(e);
  }
  function tme(e, t) {
    return e = dW(e), Tr(g0.count(Sc(e), e) + (Sc(e).getUTCDay() === 4), t, 2);
  }
  function rme(e) {
    return e.getUTCDay();
  }
  function nme(e, t) {
    return Tr(HS.count(Sc(e) - 1, e), t, 2);
  }
  function ime(e, t) {
    return Tr(e.getUTCFullYear() % 100, t, 2);
  }
  function ame(e, t) {
    return e = dW(e), Tr(e.getUTCFullYear() % 100, t, 2);
  }
  function ome(e, t) {
    return Tr(e.getUTCFullYear() % 1e4, t, 4);
  }
  function ume(e, t) {
    var r = e.getUTCDay();
    return e = r >= 4 || r === 0 ? g0(e) : g0.ceil(e), Tr(e.getUTCFullYear() % 1e4, t, 4);
  }
  function sme() {
    return "+0000";
  }
  function kz() {
    return "%";
  }
  function Rz(e) {
    return +e;
  }
  function Pz(e) {
    return Math.floor(+e / 1e3);
  }
  var Fv, pW, hW;
  lme({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: ["AM", "PM"],
    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  });
  function lme(e) {
    return Fv = l0e(e), pW = Fv.format, Fv.parse, hW = Fv.utcFormat, Fv.utcParse, Fv;
  }
  function cme(e) {
    return new Date(e);
  }
  function fme(e) {
    return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
  }
  function Ij(e, t, r, n, i, u, s, c, p, h) {
    var v = Sj(), y = v.invert, x = v.domain, w = h(".%L"), E = h(":%S"), C = h("%I:%M"), S = h("%I %p"), k = h("%a %d"), D = h("%b %d"), A = h("%B"), R = h("%Y");
    function T(M) {
      return (p(M) < M ? w : c(M) < M ? E : s(M) < M ? C : u(M) < M ? S : n(M) < M ? i(M) < M ? k : D : r(M) < M ? A : R)(M);
    }
    return v.invert = function(M) {
      return new Date(y(M));
    }, v.domain = function(M) {
      return arguments.length ? x(Array.from(M, fme)) : x().map(cme);
    }, v.ticks = function(M) {
      var F = x();
      return e(F[0], F[F.length - 1], M ?? 10);
    }, v.tickFormat = function(M, F) {
      return F == null ? T : h(F);
    }, v.nice = function(M) {
      var F = x();
      return (!M || typeof M.range != "function") && (M = t(F[0], F[F.length - 1], M ?? 10)), M ? x(eW(F, M)) : v;
    }, v.copy = function() {
      return Gx(v, Ij(e, t, r, n, i, u, s, c, p, h));
    }, v;
  }
  function dme() {
    return Au.apply(Ij(u0e, s0e, Ec, jj, X_, Qx, Mj, Rj, Ap, pW).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
  }
  function pme() {
    return Au.apply(Ij(a0e, o0e, Sc, Fj, Z_, K_, Nj, Pj, Ap, hW).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
  }
  function J_() {
    var e = 0, t = 1, r, n, i, u, s = Wa, c = !1, p;
    function h(y) {
      return y == null || isNaN(y = +y) ? p : s(i === 0 ? 0.5 : (y = (u(y) - r) * i, c ? Math.max(0, Math.min(1, y)) : y));
    }
    h.domain = function(y) {
      return arguments.length ? ([e, t] = y, r = u(e = +e), n = u(t = +t), i = r === n ? 0 : 1 / (n - r), h) : [e, t];
    }, h.clamp = function(y) {
      return arguments.length ? (c = !!y, h) : c;
    }, h.interpolator = function(y) {
      return arguments.length ? (s = y, h) : s;
    };
    function v(y) {
      return function(x) {
        var w, E;
        return arguments.length ? ([w, E] = x, s = y(w, E), h) : [s(0), s(1)];
      };
    }
    return h.range = v(X0), h.rangeRound = v(Ej), h.unknown = function(y) {
      return arguments.length ? (p = y, h) : p;
    }, function(y) {
      return u = y, r = y(e), n = y(t), i = r === n ? 0 : 1 / (n - r), h;
    };
  }
  function Xf(e, t) {
    return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
  }
  function vW() {
    var e = Kf(J_()(Wa));
    return e.copy = function() {
      return Xf(e, vW());
    }, Ac.apply(e, arguments);
  }
  function mW() {
    var e = Oj(J_()).domain([1, 10]);
    return e.copy = function() {
      return Xf(e, mW()).base(e.base());
    }, Ac.apply(e, arguments);
  }
  function yW() {
    var e = Tj(J_());
    return e.copy = function() {
      return Xf(e, yW()).constant(e.constant());
    }, Ac.apply(e, arguments);
  }
  function Bj() {
    var e = Aj(J_());
    return e.copy = function() {
      return Xf(e, Bj()).exponent(e.exponent());
    }, Ac.apply(e, arguments);
  }
  function hme() {
    return Bj.apply(null, arguments).exponent(0.5);
  }
  function gW() {
    var e = [], t = Wa;
    function r(n) {
      if (n != null && !isNaN(n = +n)) return t((Wx(e, n, 1) - 1) / (e.length - 1));
    }
    return r.domain = function(n) {
      if (!arguments.length) return e.slice();
      e = [];
      for (let i of n) i != null && !isNaN(i = +i) && e.push(i);
      return e.sort(If), r;
    }, r.interpolator = function(n) {
      return arguments.length ? (t = n, r) : t;
    }, r.range = function() {
      return e.map((n, i) => t(i / (e.length - 1)));
    }, r.quantiles = function(n) {
      return Array.from({ length: n + 1 }, (i, u) => eve(e, u / n));
    }, r.copy = function() {
      return gW(t).domain(e);
    }, Ac.apply(r, arguments);
  }
  function eC() {
    var e = 0, t = 0.5, r = 1, n = 1, i, u, s, c, p, h = Wa, v, y = !1, x;
    function w(C) {
      return isNaN(C = +C) ? x : (C = 0.5 + ((C = +v(C)) - u) * (n * C < n * u ? c : p), h(y ? Math.max(0, Math.min(1, C)) : C));
    }
    w.domain = function(C) {
      return arguments.length ? ([e, t, r] = C, i = v(e = +e), u = v(t = +t), s = v(r = +r), c = i === u ? 0 : 0.5 / (u - i), p = u === s ? 0 : 0.5 / (s - u), n = u < i ? -1 : 1, w) : [e, t, r];
    }, w.clamp = function(C) {
      return arguments.length ? (y = !!C, w) : y;
    }, w.interpolator = function(C) {
      return arguments.length ? (h = C, w) : h;
    };
    function E(C) {
      return function(S) {
        var k, D, A;
        return arguments.length ? ([k, D, A] = S, h = Ove(C, [k, D, A]), w) : [h(0), h(0.5), h(1)];
      };
    }
    return w.range = E(X0), w.rangeRound = E(Ej), w.unknown = function(C) {
      return arguments.length ? (x = C, w) : x;
    }, function(C) {
      return v = C, i = C(e), u = C(t), s = C(r), c = i === u ? 0 : 0.5 / (u - i), p = u === s ? 0 : 0.5 / (s - u), n = u < i ? -1 : 1, w;
    };
  }
  function xW() {
    var e = Kf(eC()(Wa));
    return e.copy = function() {
      return Xf(e, xW());
    }, Ac.apply(e, arguments);
  }
  function bW() {
    var e = Oj(eC()).domain([0.1, 1, 10]);
    return e.copy = function() {
      return Xf(e, bW()).base(e.base());
    }, Ac.apply(e, arguments);
  }
  function wW() {
    var e = Tj(eC());
    return e.copy = function() {
      return Xf(e, wW()).constant(e.constant());
    }, Ac.apply(e, arguments);
  }
  function Lj() {
    var e = Aj(eC());
    return e.copy = function() {
      return Xf(e, Lj()).exponent(e.exponent());
    }, Ac.apply(e, arguments);
  }
  function vme() {
    return Lj.apply(null, arguments).exponent(0.5);
  }
  const Mz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    scaleBand: ux,
    scaleDiverging: xW,
    scaleDivergingLog: bW,
    scaleDivergingPow: Lj,
    scaleDivergingSqrt: vme,
    scaleDivergingSymlog: wW,
    scaleIdentity: JV,
    scaleImplicit: sM,
    scaleLinear: zS,
    scaleLog: tW,
    scaleOrdinal: xj,
    scalePoint: zg,
    scalePow: Dj,
    scaleQuantile: iW,
    scaleQuantize: aW,
    scaleRadial: nW,
    scaleSequential: vW,
    scaleSequentialLog: mW,
    scaleSequentialPow: Bj,
    scaleSequentialQuantile: gW,
    scaleSequentialSqrt: hme,
    scaleSequentialSymlog: yW,
    scaleSqrt: Qve,
    scaleSymlog: rW,
    scaleThreshold: oW,
    scaleTime: dme,
    scaleUtc: pme,
    tickFormat: ZV
  }, Symbol.toStringTag, { value: "Module" }));
  var h2, Nz;
  function EW() {
    if (Nz) return h2;
    Nz = 1;
    var e = Y0();
    function t(r, n, i) {
      for (var u = -1, s = r.length; ++u < s; ) {
        var c = r[u], p = n(c);
        if (p != null && (h === void 0 ? p === p && !e(p) : i(p, h)))
          var h = p, v = c;
      }
      return v;
    }
    return h2 = t, h2;
  }
  var v2, jz;
  function mme() {
    if (jz) return v2;
    jz = 1;
    function e(t, r) {
      return t > r;
    }
    return v2 = e, v2;
  }
  var m2, Fz;
  function yme() {
    if (Fz) return m2;
    Fz = 1;
    var e = EW(), t = mme(), r = Q0();
    function n(i) {
      return i && i.length ? e(i, r, t) : void 0;
    }
    return m2 = n, m2;
  }
  var gme = yme();
  const tC = /* @__PURE__ */ Zr(gme);
  var y2, Iz;
  function xme() {
    if (Iz) return y2;
    Iz = 1;
    function e(t, r) {
      return t < r;
    }
    return y2 = e, y2;
  }
  var g2, Bz;
  function bme() {
    if (Bz) return g2;
    Bz = 1;
    var e = EW(), t = xme(), r = Q0();
    function n(i) {
      return i && i.length ? e(i, r, t) : void 0;
    }
    return g2 = n, g2;
  }
  var wme = bme();
  const rC = /* @__PURE__ */ Zr(wme);
  var x2, Lz;
  function Eme() {
    if (Lz) return x2;
    Lz = 1;
    var e = tj(), t = Qf(), r = kV(), n = xo();
    function i(u, s) {
      var c = n(u) ? e : r;
      return c(u, t(s, 3));
    }
    return x2 = i, x2;
  }
  var b2, $z;
  function Sme() {
    if ($z) return b2;
    $z = 1;
    var e = AV(), t = Eme();
    function r(n, i) {
      return e(t(n, i), 1);
    }
    return b2 = r, b2;
  }
  var _me = Sme();
  const Cme = /* @__PURE__ */ Zr(_me);
  var w2, zz;
  function Ome() {
    if (zz) return w2;
    zz = 1;
    var e = hj();
    function t(r, n) {
      return e(r, n);
    }
    return w2 = t, w2;
  }
  var Tme = Ome();
  const nC = /* @__PURE__ */ Zr(Tme);
  var Z0 = 1e9, Ame = {
    // These values must be integers within the stated ranges (inclusive).
    // Most of these values can be changed during run-time using `Decimal.config`.
    // The maximum number of significant digits of the result of a calculation or base conversion.
    // E.g. `Decimal.config({ precision: 20 });`
    precision: 20,
    // 1 to MAX_DIGITS
    // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
    // `toFixed`, `toPrecision` and `toSignificantDigits`.
    //
    // ROUND_UP         0 Away from zero.
    // ROUND_DOWN       1 Towards zero.
    // ROUND_CEIL       2 Towards +Infinity.
    // ROUND_FLOOR      3 Towards -Infinity.
    // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    //
    // E.g.
    // `Decimal.rounding = 4;`
    // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
    rounding: 4,
    // 0 to 8
    // The exponent value at and beneath which `toString` returns exponential notation.
    // JavaScript numbers: -7
    toExpNeg: -7,
    // 0 to -MAX_E
    // The exponent value at and above which `toString` returns exponential notation.
    // JavaScript numbers: 21
    toExpPos: 21,
    // 0 to MAX_E
    // The natural logarithm of 10.
    // 115 digits
    LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
  }, zj, wn = !0, Tu = "[DecimalError] ", Rp = Tu + "Invalid argument: ", $j = Tu + "Exponent out of range: ", J0 = Math.floor, bp = Math.pow, Dme = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, qo, Fi = 1e7, gn = 7, SW = 9007199254740991, VS = J0(SW / gn), vt = {};
  vt.absoluteValue = vt.abs = function() {
    var e = new this.constructor(this);
    return e.s && (e.s = 1), e;
  };
  vt.comparedTo = vt.cmp = function(e) {
    var t, r, n, i, u = this;
    if (e = new u.constructor(e), u.s !== e.s) return u.s || -e.s;
    if (u.e !== e.e) return u.e > e.e ^ u.s < 0 ? 1 : -1;
    for (n = u.d.length, i = e.d.length, t = 0, r = n < i ? n : i; t < r; ++t)
      if (u.d[t] !== e.d[t]) return u.d[t] > e.d[t] ^ u.s < 0 ? 1 : -1;
    return n === i ? 0 : n > i ^ u.s < 0 ? 1 : -1;
  };
  vt.decimalPlaces = vt.dp = function() {
    var e = this, t = e.d.length - 1, r = (t - e.e) * gn;
    if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) r--;
    return r < 0 ? 0 : r;
  };
  vt.dividedBy = vt.div = function(e) {
    return yc(this, new this.constructor(e));
  };
  vt.dividedToIntegerBy = vt.idiv = function(e) {
    var t = this, r = t.constructor;
    return ln(yc(t, new r(e), 0, 1), r.precision);
  };
  vt.equals = vt.eq = function(e) {
    return !this.cmp(e);
  };
  vt.exponent = function() {
    return fi(this);
  };
  vt.greaterThan = vt.gt = function(e) {
    return this.cmp(e) > 0;
  };
  vt.greaterThanOrEqualTo = vt.gte = function(e) {
    return this.cmp(e) >= 0;
  };
  vt.isInteger = vt.isint = function() {
    return this.e > this.d.length - 2;
  };
  vt.isNegative = vt.isneg = function() {
    return this.s < 0;
  };
  vt.isPositive = vt.ispos = function() {
    return this.s > 0;
  };
  vt.isZero = function() {
    return this.s === 0;
  };
  vt.lessThan = vt.lt = function(e) {
    return this.cmp(e) < 0;
  };
  vt.lessThanOrEqualTo = vt.lte = function(e) {
    return this.cmp(e) < 1;
  };
  vt.logarithm = vt.log = function(e) {
    var t, r = this, n = r.constructor, i = n.precision, u = i + 5;
    if (e === void 0)
      e = new n(10);
    else if (e = new n(e), e.s < 1 || e.eq(qo)) throw Error(Tu + "NaN");
    if (r.s < 1) throw Error(Tu + (r.s ? "NaN" : "-Infinity"));
    return r.eq(qo) ? new n(0) : (wn = !1, t = yc(dx(r, u), dx(e, u), u), wn = !0, ln(t, i));
  };
  vt.minus = vt.sub = function(e) {
    var t = this;
    return e = new t.constructor(e), t.s == e.s ? OW(t, e) : _W(t, (e.s = -e.s, e));
  };
  vt.modulo = vt.mod = function(e) {
    var t, r = this, n = r.constructor, i = n.precision;
    if (e = new n(e), !e.s) throw Error(Tu + "NaN");
    return r.s ? (wn = !1, t = yc(r, e, 0, 1).times(e), wn = !0, r.minus(t)) : ln(new n(r), i);
  };
  vt.naturalExponential = vt.exp = function() {
    return CW(this);
  };
  vt.naturalLogarithm = vt.ln = function() {
    return dx(this);
  };
  vt.negated = vt.neg = function() {
    var e = new this.constructor(this);
    return e.s = -e.s || 0, e;
  };
  vt.plus = vt.add = function(e) {
    var t = this;
    return e = new t.constructor(e), t.s == e.s ? _W(t, e) : OW(t, (e.s = -e.s, e));
  };
  vt.precision = vt.sd = function(e) {
    var t, r, n, i = this;
    if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Rp + e);
    if (t = fi(i) + 1, n = i.d.length - 1, r = n * gn + 1, n = i.d[n], n) {
      for (; n % 10 == 0; n /= 10) r--;
      for (n = i.d[0]; n >= 10; n /= 10) r++;
    }
    return e && t > r ? t : r;
  };
  vt.squareRoot = vt.sqrt = function() {
    var e, t, r, n, i, u, s, c = this, p = c.constructor;
    if (c.s < 1) {
      if (!c.s) return new p(0);
      throw Error(Tu + "NaN");
    }
    for (e = fi(c), wn = !1, i = Math.sqrt(+c), i == 0 || i == 1 / 0 ? (t = ol(c.d), (t.length + e) % 2 == 0 && (t += "0"), i = Math.sqrt(t), e = J0((e + 1) / 2) - (e < 0 || e % 2), i == 1 / 0 ? t = "5e" + e : (t = i.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), n = new p(t)) : n = new p(i.toString()), r = p.precision, i = s = r + 3; ; )
      if (u = n, n = u.plus(yc(c, u, s + 2)).times(0.5), ol(u.d).slice(0, s) === (t = ol(n.d)).slice(0, s)) {
        if (t = t.slice(s - 3, s + 1), i == s && t == "4999") {
          if (ln(u, r + 1, 0), u.times(u).eq(c)) {
            n = u;
            break;
          }
        } else if (t != "9999")
          break;
        s += 4;
      }
    return wn = !0, ln(n, r);
  };
  vt.times = vt.mul = function(e) {
    var t, r, n, i, u, s, c, p, h, v = this, y = v.constructor, x = v.d, w = (e = new y(e)).d;
    if (!v.s || !e.s) return new y(0);
    for (e.s *= v.s, r = v.e + e.e, p = x.length, h = w.length, p < h && (u = x, x = w, w = u, s = p, p = h, h = s), u = [], s = p + h, n = s; n--; ) u.push(0);
    for (n = h; --n >= 0; ) {
      for (t = 0, i = p + n; i > n; )
        c = u[i] + w[n] * x[i - n - 1] + t, u[i--] = c % Fi | 0, t = c / Fi | 0;
      u[i] = (u[i] + t) % Fi | 0;
    }
    for (; !u[--s]; ) u.pop();
    return t ? ++r : u.shift(), e.d = u, e.e = r, wn ? ln(e, y.precision) : e;
  };
  vt.toDecimalPlaces = vt.todp = function(e, t) {
    var r = this, n = r.constructor;
    return r = new n(r), e === void 0 ? r : (dl(e, 0, Z0), t === void 0 ? t = n.rounding : dl(t, 0, 8), ln(r, e + fi(r) + 1, t));
  };
  vt.toExponential = function(e, t) {
    var r, n = this, i = n.constructor;
    return e === void 0 ? r = Bp(n, !0) : (dl(e, 0, Z0), t === void 0 ? t = i.rounding : dl(t, 0, 8), n = ln(new i(n), e + 1, t), r = Bp(n, !0, e + 1)), r;
  };
  vt.toFixed = function(e, t) {
    var r, n, i = this, u = i.constructor;
    return e === void 0 ? Bp(i) : (dl(e, 0, Z0), t === void 0 ? t = u.rounding : dl(t, 0, 8), n = ln(new u(i), e + fi(i) + 1, t), r = Bp(n.abs(), !1, e + fi(n) + 1), i.isneg() && !i.isZero() ? "-" + r : r);
  };
  vt.toInteger = vt.toint = function() {
    var e = this, t = e.constructor;
    return ln(new t(e), fi(e) + 1, t.rounding);
  };
  vt.toNumber = function() {
    return +this;
  };
  vt.toPower = vt.pow = function(e) {
    var t, r, n, i, u, s, c = this, p = c.constructor, h = 12, v = +(e = new p(e));
    if (!e.s) return new p(qo);
    if (c = new p(c), !c.s) {
      if (e.s < 1) throw Error(Tu + "Infinity");
      return c;
    }
    if (c.eq(qo)) return c;
    if (n = p.precision, e.eq(qo)) return ln(c, n);
    if (t = e.e, r = e.d.length - 1, s = t >= r, u = c.s, s) {
      if ((r = v < 0 ? -v : v) <= SW) {
        for (i = new p(qo), t = Math.ceil(n / gn + 4), wn = !1; r % 2 && (i = i.times(c), Uz(i.d, t)), r = J0(r / 2), r !== 0; )
          c = c.times(c), Uz(c.d, t);
        return wn = !0, e.s < 0 ? new p(qo).div(i) : ln(i, n);
      }
    } else if (u < 0) throw Error(Tu + "NaN");
    return u = u < 0 && e.d[Math.max(t, r)] & 1 ? -1 : 1, c.s = 1, wn = !1, i = e.times(dx(c, n + h)), wn = !0, i = CW(i), i.s = u, i;
  };
  vt.toPrecision = function(e, t) {
    var r, n, i = this, u = i.constructor;
    return e === void 0 ? (r = fi(i), n = Bp(i, r <= u.toExpNeg || r >= u.toExpPos)) : (dl(e, 1, Z0), t === void 0 ? t = u.rounding : dl(t, 0, 8), i = ln(new u(i), e, t), r = fi(i), n = Bp(i, e <= r || r <= u.toExpNeg, e)), n;
  };
  vt.toSignificantDigits = vt.tosd = function(e, t) {
    var r = this, n = r.constructor;
    return e === void 0 ? (e = n.precision, t = n.rounding) : (dl(e, 1, Z0), t === void 0 ? t = n.rounding : dl(t, 0, 8)), ln(new n(r), e, t);
  };
  vt.toString = vt.valueOf = vt.val = vt.toJSON = vt[Symbol.for("nodejs.util.inspect.custom")] = function() {
    var e = this, t = fi(e), r = e.constructor;
    return Bp(e, t <= r.toExpNeg || t >= r.toExpPos);
  };
  function _W(e, t) {
    var r, n, i, u, s, c, p, h, v = e.constructor, y = v.precision;
    if (!e.s || !t.s)
      return t.s || (t = new v(e)), wn ? ln(t, y) : t;
    if (p = e.d, h = t.d, s = e.e, i = t.e, p = p.slice(), u = s - i, u) {
      for (u < 0 ? (n = p, u = -u, c = h.length) : (n = h, i = s, c = p.length), s = Math.ceil(y / gn), c = s > c ? s + 1 : c + 1, u > c && (u = c, n.length = 1), n.reverse(); u--; ) n.push(0);
      n.reverse();
    }
    for (c = p.length, u = h.length, c - u < 0 && (u = c, n = h, h = p, p = n), r = 0; u; )
      r = (p[--u] = p[u] + h[u] + r) / Fi | 0, p[u] %= Fi;
    for (r && (p.unshift(r), ++i), c = p.length; p[--c] == 0; ) p.pop();
    return t.d = p, t.e = i, wn ? ln(t, y) : t;
  }
  function dl(e, t, r) {
    if (e !== ~~e || e < t || e > r)
      throw Error(Rp + e);
  }
  function ol(e) {
    var t, r, n, i = e.length - 1, u = "", s = e[0];
    if (i > 0) {
      for (u += s, t = 1; t < i; t++)
        n = e[t] + "", r = gn - n.length, r && (u += Mf(r)), u += n;
      s = e[t], n = s + "", r = gn - n.length, r && (u += Mf(r));
    } else if (s === 0)
      return "0";
    for (; s % 10 === 0; ) s /= 10;
    return u + s;
  }
  var yc = /* @__PURE__ */ function() {
    function e(n, i) {
      var u, s = 0, c = n.length;
      for (n = n.slice(); c--; )
        u = n[c] * i + s, n[c] = u % Fi | 0, s = u / Fi | 0;
      return s && n.unshift(s), n;
    }
    function t(n, i, u, s) {
      var c, p;
      if (u != s)
        p = u > s ? 1 : -1;
      else
        for (c = p = 0; c < u; c++)
          if (n[c] != i[c]) {
            p = n[c] > i[c] ? 1 : -1;
            break;
          }
      return p;
    }
    function r(n, i, u) {
      for (var s = 0; u--; )
        n[u] -= s, s = n[u] < i[u] ? 1 : 0, n[u] = s * Fi + n[u] - i[u];
      for (; !n[0] && n.length > 1; ) n.shift();
    }
    return function(n, i, u, s) {
      var c, p, h, v, y, x, w, E, C, S, k, D, A, R, T, M, F, B, V = n.constructor, H = n.s == i.s ? 1 : -1, q = n.d, Q = i.d;
      if (!n.s) return new V(n);
      if (!i.s) throw Error(Tu + "Division by zero");
      for (p = n.e - i.e, F = Q.length, T = q.length, w = new V(H), E = w.d = [], h = 0; Q[h] == (q[h] || 0); ) ++h;
      if (Q[h] > (q[h] || 0) && --p, u == null ? D = u = V.precision : s ? D = u + (fi(n) - fi(i)) + 1 : D = u, D < 0) return new V(0);
      if (D = D / gn + 2 | 0, h = 0, F == 1)
        for (v = 0, Q = Q[0], D++; (h < T || v) && D--; h++)
          A = v * Fi + (q[h] || 0), E[h] = A / Q | 0, v = A % Q | 0;
      else {
        for (v = Fi / (Q[0] + 1) | 0, v > 1 && (Q = e(Q, v), q = e(q, v), F = Q.length, T = q.length), R = F, C = q.slice(0, F), S = C.length; S < F; ) C[S++] = 0;
        B = Q.slice(), B.unshift(0), M = Q[0], Q[1] >= Fi / 2 && ++M;
        do
          v = 0, c = t(Q, C, F, S), c < 0 ? (k = C[0], F != S && (k = k * Fi + (C[1] || 0)), v = k / M | 0, v > 1 ? (v >= Fi && (v = Fi - 1), y = e(Q, v), x = y.length, S = C.length, c = t(y, C, x, S), c == 1 && (v--, r(y, F < x ? B : Q, x))) : (v == 0 && (c = v = 1), y = Q.slice()), x = y.length, x < S && y.unshift(0), r(C, y, S), c == -1 && (S = C.length, c = t(Q, C, F, S), c < 1 && (v++, r(C, F < S ? B : Q, S))), S = C.length) : c === 0 && (v++, C = [0]), E[h++] = v, c && C[0] ? C[S++] = q[R] || 0 : (C = [q[R]], S = 1);
        while ((R++ < T || C[0] !== void 0) && D--);
      }
      return E[0] || E.shift(), w.e = p, ln(w, s ? u + fi(w) + 1 : u);
    };
  }();
  function CW(e, t) {
    var r, n, i, u, s, c, p = 0, h = 0, v = e.constructor, y = v.precision;
    if (fi(e) > 16) throw Error($j + fi(e));
    if (!e.s) return new v(qo);
    for (wn = !1, c = y, s = new v(0.03125); e.abs().gte(0.1); )
      e = e.times(s), h += 5;
    for (n = Math.log(bp(2, h)) / Math.LN10 * 2 + 5 | 0, c += n, r = i = u = new v(qo), v.precision = c; ; ) {
      if (i = ln(i.times(e), c), r = r.times(++p), s = u.plus(yc(i, r, c)), ol(s.d).slice(0, c) === ol(u.d).slice(0, c)) {
        for (; h--; ) u = ln(u.times(u), c);
        return v.precision = y, t == null ? (wn = !0, ln(u, y)) : u;
      }
      u = s;
    }
  }
  function fi(e) {
    for (var t = e.e * gn, r = e.d[0]; r >= 10; r /= 10) t++;
    return t;
  }
  function E2(e, t, r) {
    if (t > e.LN10.sd())
      throw wn = !0, r && (e.precision = r), Error(Tu + "LN10 precision limit exceeded");
    return ln(new e(e.LN10), t);
  }
  function Mf(e) {
    for (var t = ""; e--; ) t += "0";
    return t;
  }
  function dx(e, t) {
    var r, n, i, u, s, c, p, h, v, y = 1, x = 10, w = e, E = w.d, C = w.constructor, S = C.precision;
    if (w.s < 1) throw Error(Tu + (w.s ? "NaN" : "-Infinity"));
    if (w.eq(qo)) return new C(0);
    if (t == null ? (wn = !1, h = S) : h = t, w.eq(10))
      return t == null && (wn = !0), E2(C, h);
    if (h += x, C.precision = h, r = ol(E), n = r.charAt(0), u = fi(w), Math.abs(u) < 15e14) {
      for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
        w = w.times(e), r = ol(w.d), n = r.charAt(0), y++;
      u = fi(w), n > 1 ? (w = new C("0." + r), u++) : w = new C(n + "." + r.slice(1));
    } else
      return p = E2(C, h + 2, S).times(u + ""), w = dx(new C(n + "." + r.slice(1)), h - x).plus(p), C.precision = S, t == null ? (wn = !0, ln(w, S)) : w;
    for (c = s = w = yc(w.minus(qo), w.plus(qo), h), v = ln(w.times(w), h), i = 3; ; ) {
      if (s = ln(s.times(v), h), p = c.plus(yc(s, new C(i), h)), ol(p.d).slice(0, h) === ol(c.d).slice(0, h))
        return c = c.times(2), u !== 0 && (c = c.plus(E2(C, h + 2, S).times(u + ""))), c = yc(c, new C(y), h), C.precision = S, t == null ? (wn = !0, ln(c, S)) : c;
      c = p, i += 2;
    }
  }
  function qz(e, t) {
    var r, n, i;
    for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; ) ++n;
    for (i = t.length; t.charCodeAt(i - 1) === 48; ) --i;
    if (t = t.slice(n, i), t) {
      if (i -= n, r = r - n - 1, e.e = J0(r / gn), e.d = [], n = (r + 1) % gn, r < 0 && (n += gn), n < i) {
        for (n && e.d.push(+t.slice(0, n)), i -= gn; n < i; ) e.d.push(+t.slice(n, n += gn));
        t = t.slice(n), n = gn - t.length;
      } else
        n -= i;
      for (; n--; ) t += "0";
      if (e.d.push(+t), wn && (e.e > VS || e.e < -VS)) throw Error($j + r);
    } else
      e.s = 0, e.e = 0, e.d = [0];
    return e;
  }
  function ln(e, t, r) {
    var n, i, u, s, c, p, h, v, y = e.d;
    for (s = 1, u = y[0]; u >= 10; u /= 10) s++;
    if (n = t - s, n < 0)
      n += gn, i = t, h = y[v = 0];
    else {
      if (v = Math.ceil((n + 1) / gn), u = y.length, v >= u) return e;
      for (h = u = y[v], s = 1; u >= 10; u /= 10) s++;
      n %= gn, i = n - gn + s;
    }
    if (r !== void 0 && (u = bp(10, s - i - 1), c = h / u % 10 | 0, p = t < 0 || y[v + 1] !== void 0 || h % u, p = r < 4 ? (c || p) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : c > 5 || c == 5 && (r == 4 || p || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
    (n > 0 ? i > 0 ? h / bp(10, s - i) : 0 : y[v - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), t < 1 || !y[0])
      return p ? (u = fi(e), y.length = 1, t = t - u - 1, y[0] = bp(10, (gn - t % gn) % gn), e.e = J0(-t / gn) || 0) : (y.length = 1, y[0] = e.e = e.s = 0), e;
    if (n == 0 ? (y.length = v, u = 1, v--) : (y.length = v + 1, u = bp(10, gn - n), y[v] = i > 0 ? (h / bp(10, s - i) % bp(10, i) | 0) * u : 0), p)
      for (; ; )
        if (v == 0) {
          (y[0] += u) == Fi && (y[0] = 1, ++e.e);
          break;
        } else {
          if (y[v] += u, y[v] != Fi) break;
          y[v--] = 0, u = 1;
        }
    for (n = y.length; y[--n] === 0; ) y.pop();
    if (wn && (e.e > VS || e.e < -VS))
      throw Error($j + fi(e));
    return e;
  }
  function OW(e, t) {
    var r, n, i, u, s, c, p, h, v, y, x = e.constructor, w = x.precision;
    if (!e.s || !t.s)
      return t.s ? t.s = -t.s : t = new x(e), wn ? ln(t, w) : t;
    if (p = e.d, y = t.d, n = t.e, h = e.e, p = p.slice(), s = h - n, s) {
      for (v = s < 0, v ? (r = p, s = -s, c = y.length) : (r = y, n = h, c = p.length), i = Math.max(Math.ceil(w / gn), c) + 2, s > i && (s = i, r.length = 1), r.reverse(), i = s; i--; ) r.push(0);
      r.reverse();
    } else {
      for (i = p.length, c = y.length, v = i < c, v && (c = i), i = 0; i < c; i++)
        if (p[i] != y[i]) {
          v = p[i] < y[i];
          break;
        }
      s = 0;
    }
    for (v && (r = p, p = y, y = r, t.s = -t.s), c = p.length, i = y.length - c; i > 0; --i) p[c++] = 0;
    for (i = y.length; i > s; ) {
      if (p[--i] < y[i]) {
        for (u = i; u && p[--u] === 0; ) p[u] = Fi - 1;
        --p[u], p[i] += Fi;
      }
      p[i] -= y[i];
    }
    for (; p[--c] === 0; ) p.pop();
    for (; p[0] === 0; p.shift()) --n;
    return p[0] ? (t.d = p, t.e = n, wn ? ln(t, w) : t) : new x(0);
  }
  function Bp(e, t, r) {
    var n, i = fi(e), u = ol(e.d), s = u.length;
    return t ? (r && (n = r - s) > 0 ? u = u.charAt(0) + "." + u.slice(1) + Mf(n) : s > 1 && (u = u.charAt(0) + "." + u.slice(1)), u = u + (i < 0 ? "e" : "e+") + i) : i < 0 ? (u = "0." + Mf(-i - 1) + u, r && (n = r - s) > 0 && (u += Mf(n))) : i >= s ? (u += Mf(i + 1 - s), r && (n = r - i - 1) > 0 && (u = u + "." + Mf(n))) : ((n = i + 1) < s && (u = u.slice(0, n) + "." + u.slice(n)), r && (n = r - s) > 0 && (i + 1 === s && (u += "."), u += Mf(n))), e.s < 0 ? "-" + u : u;
  }
  function Uz(e, t) {
    if (e.length > t)
      return e.length = t, !0;
  }
  function TW(e) {
    var t, r, n;
    function i(u) {
      var s = this;
      if (!(s instanceof i)) return new i(u);
      if (s.constructor = i, u instanceof i) {
        s.s = u.s, s.e = u.e, s.d = (u = u.d) ? u.slice() : u;
        return;
      }
      if (typeof u == "number") {
        if (u * 0 !== 0)
          throw Error(Rp + u);
        if (u > 0)
          s.s = 1;
        else if (u < 0)
          u = -u, s.s = -1;
        else {
          s.s = 0, s.e = 0, s.d = [0];
          return;
        }
        if (u === ~~u && u < 1e7) {
          s.e = 0, s.d = [u];
          return;
        }
        return qz(s, u.toString());
      } else if (typeof u != "string")
        throw Error(Rp + u);
      if (u.charCodeAt(0) === 45 ? (u = u.slice(1), s.s = -1) : s.s = 1, Dme.test(u)) qz(s, u);
      else throw Error(Rp + u);
    }
    if (i.prototype = vt, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.clone = TW, i.config = i.set = kme, e === void 0 && (e = {}), e)
      for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < n.length; ) e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
    return i.config(e), i;
  }
  function kme(e) {
    if (!e || typeof e != "object")
      throw Error(Tu + "Object expected");
    var t, r, n, i = [
      "precision",
      1,
      Z0,
      "rounding",
      0,
      8,
      "toExpNeg",
      -1 / 0,
      0,
      "toExpPos",
      0,
      1 / 0
    ];
    for (t = 0; t < i.length; t += 3)
      if ((n = e[r = i[t]]) !== void 0)
        if (J0(n) === n && n >= i[t + 1] && n <= i[t + 2]) this[r] = n;
        else throw Error(Rp + r + ": " + n);
    if ((n = e[r = "LN10"]) !== void 0)
      if (n == Math.LN10) this[r] = new this(n);
      else throw Error(Rp + r + ": " + n);
    return this;
  }
  var zj = TW(Ame);
  qo = new zj(1);
  const an = zj;
  function Rme(e) {
    return jme(e) || Nme(e) || Mme(e) || Pme();
  }
  function Pme() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Mme(e, t) {
    if (e) {
      if (typeof e == "string") return dM(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return dM(e, t);
    }
  }
  function Nme(e) {
    if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
  }
  function jme(e) {
    if (Array.isArray(e)) return dM(e);
  }
  function dM(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++)
      n[r] = e[r];
    return n;
  }
  var Fme = function(t) {
    return t;
  }, AW = {}, DW = function(t) {
    return t === AW;
  }, Hz = function(t) {
    return function r() {
      return arguments.length === 0 || arguments.length === 1 && DW(arguments.length <= 0 ? void 0 : arguments[0]) ? r : t.apply(void 0, arguments);
    };
  }, Ime = function e(t, r) {
    return t === 1 ? r : Hz(function() {
      for (var n = arguments.length, i = new Array(n), u = 0; u < n; u++)
        i[u] = arguments[u];
      var s = i.filter(function(c) {
        return c !== AW;
      }).length;
      return s >= t ? r.apply(void 0, i) : e(t - s, Hz(function() {
        for (var c = arguments.length, p = new Array(c), h = 0; h < c; h++)
          p[h] = arguments[h];
        var v = i.map(function(y) {
          return DW(y) ? p.shift() : y;
        });
        return r.apply(void 0, Rme(v).concat(p));
      }));
    });
  }, iC = function(t) {
    return Ime(t.length, t);
  }, pM = function(t, r) {
    for (var n = [], i = t; i < r; ++i)
      n[i - t] = i;
    return n;
  }, Bme = iC(function(e, t) {
    return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(r) {
      return t[r];
    }).map(e);
  }), Lme = function() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    if (!r.length)
      return Fme;
    var i = r.reverse(), u = i[0], s = i.slice(1);
    return function() {
      return s.reduce(function(c, p) {
        return p(c);
      }, u.apply(void 0, arguments));
    };
  }, hM = function(t) {
    return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
  }, kW = function(t) {
    var r = null, n = null;
    return function() {
      for (var i = arguments.length, u = new Array(i), s = 0; s < i; s++)
        u[s] = arguments[s];
      return r && u.every(function(c, p) {
        return c === r[p];
      }) || (r = u, n = t.apply(void 0, u)), n;
    };
  };
  function $me(e) {
    var t;
    return e === 0 ? t = 1 : t = Math.floor(new an(e).abs().log(10).toNumber()) + 1, t;
  }
  function zme(e, t, r) {
    for (var n = new an(e), i = 0, u = []; n.lt(t) && i < 1e5; )
      u.push(n.toNumber()), n = n.add(r), i++;
    return u;
  }
  var qme = iC(function(e, t, r) {
    var n = +e, i = +t;
    return n + r * (i - n);
  }), Ume = iC(function(e, t, r) {
    var n = t - +e;
    return n = n || 1 / 0, (r - e) / n;
  }), Hme = iC(function(e, t, r) {
    var n = t - +e;
    return n = n || 1 / 0, Math.max(0, Math.min(1, (r - e) / n));
  });
  const aC = {
    rangeStep: zme,
    getDigitCount: $me,
    interpolateNumber: qme,
    uninterpolateNumber: Ume,
    uninterpolateTruncation: Hme
  };
  function vM(e) {
    return Yme(e) || Wme(e) || RW(e) || Vme();
  }
  function Vme() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Wme(e) {
    if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
  }
  function Yme(e) {
    if (Array.isArray(e)) return mM(e);
  }
  function px(e, t) {
    return Kme(e) || Qme(e, t) || RW(e, t) || Gme();
  }
  function Gme() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function RW(e, t) {
    if (e) {
      if (typeof e == "string") return mM(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return mM(e, t);
    }
  }
  function mM(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++)
      n[r] = e[r];
    return n;
  }
  function Qme(e, t) {
    if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
      var r = [], n = !0, i = !1, u = void 0;
      try {
        for (var s = e[Symbol.iterator](), c; !(n = (c = s.next()).done) && (r.push(c.value), !(t && r.length === t)); n = !0)
          ;
      } catch (p) {
        i = !0, u = p;
      } finally {
        try {
          !n && s.return != null && s.return();
        } finally {
          if (i) throw u;
        }
      }
      return r;
    }
  }
  function Kme(e) {
    if (Array.isArray(e)) return e;
  }
  function PW(e) {
    var t = px(e, 2), r = t[0], n = t[1], i = r, u = n;
    return r > n && (i = n, u = r), [i, u];
  }
  function MW(e, t, r) {
    if (e.lte(0))
      return new an(0);
    var n = aC.getDigitCount(e.toNumber()), i = new an(10).pow(n), u = e.div(i), s = n !== 1 ? 0.05 : 0.1, c = new an(Math.ceil(u.div(s).toNumber())).add(r).mul(s), p = c.mul(i);
    return t ? p : new an(Math.ceil(p));
  }
  function Xme(e, t, r) {
    var n = 1, i = new an(e);
    if (!i.isint() && r) {
      var u = Math.abs(e);
      u < 1 ? (n = new an(10).pow(aC.getDigitCount(e) - 1), i = new an(Math.floor(i.div(n).toNumber())).mul(n)) : u > 1 && (i = new an(Math.floor(e)));
    } else e === 0 ? i = new an(Math.floor((t - 1) / 2)) : r || (i = new an(Math.floor(e)));
    var s = Math.floor((t - 1) / 2), c = Lme(Bme(function(p) {
      return i.add(new an(p - s).mul(n)).toNumber();
    }), pM);
    return c(0, t);
  }
  function NW(e, t, r, n) {
    var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
    if (!Number.isFinite((t - e) / (r - 1)))
      return {
        step: new an(0),
        tickMin: new an(0),
        tickMax: new an(0)
      };
    var u = MW(new an(t).sub(e).div(r - 1), n, i), s;
    e <= 0 && t >= 0 ? s = new an(0) : (s = new an(e).add(t).div(2), s = s.sub(new an(s).mod(u)));
    var c = Math.ceil(s.sub(e).div(u).toNumber()), p = Math.ceil(new an(t).sub(s).div(u).toNumber()), h = c + p + 1;
    return h > r ? NW(e, t, r, n, i + 1) : (h < r && (p = t > 0 ? p + (r - h) : p, c = t > 0 ? c : c + (r - h)), {
      step: u,
      tickMin: s.sub(new an(c).mul(u)),
      tickMax: s.add(new an(p).mul(u))
    });
  }
  function Zme(e) {
    var t = px(e, 2), r = t[0], n = t[1], i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, s = Math.max(i, 2), c = PW([r, n]), p = px(c, 2), h = p[0], v = p[1];
    if (h === -1 / 0 || v === 1 / 0) {
      var y = v === 1 / 0 ? [h].concat(vM(pM(0, i - 1).map(function() {
        return 1 / 0;
      }))) : [].concat(vM(pM(0, i - 1).map(function() {
        return -1 / 0;
      })), [v]);
      return r > n ? hM(y) : y;
    }
    if (h === v)
      return Xme(h, i, u);
    var x = NW(h, v, s, u), w = x.step, E = x.tickMin, C = x.tickMax, S = aC.rangeStep(E, C.add(new an(0.1).mul(w)), w);
    return r > n ? hM(S) : S;
  }
  function Jme(e, t) {
    var r = px(e, 2), n = r[0], i = r[1], u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, s = PW([n, i]), c = px(s, 2), p = c[0], h = c[1];
    if (p === -1 / 0 || h === 1 / 0)
      return [n, i];
    if (p === h)
      return [p];
    var v = Math.max(t, 2), y = MW(new an(h).sub(p).div(v - 1), u, 0), x = [].concat(vM(aC.rangeStep(new an(p), new an(h).sub(new an(0.99).mul(y)), y)), [h]);
    return n > i ? hM(x) : x;
  }
  var eye = kW(Zme), tye = kW(Jme), rye = process.env.NODE_ENV === "production", S2 = "Invariant failed";
  function go(e, t) {
    if (rye)
      throw new Error(S2);
    var r = typeof t == "function" ? t() : t, n = r ? "".concat(S2, ": ").concat(r) : S2;
    throw new Error(n);
  }
  var nye = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
  function x0(e) {
    "@babel/helpers - typeof";
    return x0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, x0(e);
  }
  function WS() {
    return WS = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, WS.apply(this, arguments);
  }
  function iye(e, t) {
    return sye(e) || uye(e, t) || oye(e, t) || aye();
  }
  function aye() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function oye(e, t) {
    if (e) {
      if (typeof e == "string") return Vz(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Vz(e, t);
    }
  }
  function Vz(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function uye(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, u, s, c = [], p = !0, h = !1;
      try {
        if (u = (r = r.call(e)).next, t !== 0) for (; !(p = (n = u.call(r)).done) && (c.push(n.value), c.length !== t); p = !0) ;
      } catch (v) {
        h = !0, i = v;
      } finally {
        try {
          if (!p && r.return != null && (s = r.return(), Object(s) !== s)) return;
        } finally {
          if (h) throw i;
        }
      }
      return c;
    }
  }
  function sye(e) {
    if (Array.isArray(e)) return e;
  }
  function lye(e, t) {
    if (e == null) return {};
    var r = cye(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function cye(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function fye(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function dye(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, IW(n.key), n);
    }
  }
  function pye(e, t, r) {
    return t && dye(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function hye(e, t, r) {
    return t = YS(t), vye(e, jW() ? Reflect.construct(t, r || [], YS(e).constructor) : t.apply(e, r));
  }
  function vye(e, t) {
    if (t && (x0(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return mye(e);
  }
  function mye(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function jW() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (jW = function() {
      return !!e;
    })();
  }
  function YS(e) {
    return YS = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, YS(e);
  }
  function yye(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && yM(e, t);
  }
  function yM(e, t) {
    return yM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, yM(e, t);
  }
  function FW(e, t, r) {
    return t = IW(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function IW(e) {
    var t = gye(e, "string");
    return x0(t) == "symbol" ? t : t + "";
  }
  function gye(e, t) {
    if (x0(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (x0(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var Kx = /* @__PURE__ */ function(e) {
    function t() {
      return fye(this, t), hye(this, t, arguments);
    }
    return yye(t, e), pye(t, [{
      key: "render",
      value: function() {
        var n = this.props, i = n.offset, u = n.layout, s = n.width, c = n.dataKey, p = n.data, h = n.dataPointFormatter, v = n.xAxis, y = n.yAxis, x = lye(n, nye), w = pr(x, !1);
        this.props.direction === "x" && v.type !== "number" && (process.env.NODE_ENV !== "production" ? go(!1, 'ErrorBar requires Axis type property to be "number".') : go());
        var E = p.map(function(C) {
          var S = h(C, c), k = S.x, D = S.y, A = S.value, R = S.errorVal;
          if (!R)
            return null;
          var T = [], M, F;
          if (Array.isArray(R)) {
            var B = iye(R, 2);
            M = B[0], F = B[1];
          } else
            M = F = R;
          if (u === "vertical") {
            var V = v.scale, H = D + i, q = H + s, Q = H - s, W = V(A - M), J = V(A + F);
            T.push({
              x1: J,
              y1: q,
              x2: J,
              y2: Q
            }), T.push({
              x1: W,
              y1: H,
              x2: J,
              y2: H
            }), T.push({
              x1: W,
              y1: q,
              x2: W,
              y2: Q
            });
          } else if (u === "horizontal") {
            var ne = y.scale, ie = k + i, se = ie - s, X = ie + s, fe = ne(A - M), Z = ne(A + F);
            T.push({
              x1: se,
              y1: Z,
              x2: X,
              y2: Z
            }), T.push({
              x1: ie,
              y1: fe,
              x2: ie,
              y2: Z
            }), T.push({
              x1: se,
              y1: fe,
              x2: X,
              y2: fe
            });
          }
          return /* @__PURE__ */ ce.createElement(ei, WS({
            className: "recharts-errorBar",
            key: "bar-".concat(T.map(function(z) {
              return "".concat(z.x1, "-").concat(z.x2, "-").concat(z.y1, "-").concat(z.y2);
            }))
          }, w), T.map(function(z) {
            return /* @__PURE__ */ ce.createElement("line", WS({}, z, {
              key: "line-".concat(z.x1, "-").concat(z.x2, "-").concat(z.y1, "-").concat(z.y2)
            }));
          }));
        });
        return /* @__PURE__ */ ce.createElement(ei, {
          className: "recharts-errorBars"
        }, E);
      }
    }]);
  }(ce.Component);
  FW(Kx, "defaultProps", {
    stroke: "black",
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: "horizontal"
  });
  FW(Kx, "displayName", "ErrorBar");
  function hx(e) {
    "@babel/helpers - typeof";
    return hx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, hx(e);
  }
  function Wz(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function yp(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? Wz(Object(r), !0).forEach(function(n) {
        xye(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Wz(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function xye(e, t, r) {
    return t = bye(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function bye(e) {
    var t = wye(e, "string");
    return hx(t) == "symbol" ? t : t + "";
  }
  function wye(e, t) {
    if (hx(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (hx(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var BW = function(t) {
    var r = t.children, n = t.formattedGraphicalItems, i = t.legendWidth, u = t.legendContent, s = $o(r, t0);
    if (!s)
      return null;
    var c = t0.defaultProps, p = c !== void 0 ? yp(yp({}, c), s.props) : {}, h;
    return s.props && s.props.payload ? h = s.props && s.props.payload : u === "children" ? h = (n || []).reduce(function(v, y) {
      var x = y.item, w = y.props, E = w.sectors || w.data || [];
      return v.concat(E.map(function(C) {
        return {
          type: s.props.iconType || x.props.legendType,
          value: C.name,
          color: C.fill,
          payload: C
        };
      }));
    }, []) : h = (n || []).map(function(v) {
      var y = v.item, x = y.type.defaultProps, w = x !== void 0 ? yp(yp({}, x), y.props) : {}, E = w.dataKey, C = w.name, S = w.legendType, k = w.hide;
      return {
        inactive: k,
        dataKey: E,
        type: p.iconType || S || "square",
        color: qj(y),
        value: C || E,
        // @ts-expect-error property strokeDasharray is required in Payload but optional in props
        payload: w
      };
    }), yp(yp(yp({}, p), t0.getWithHeight(s, i)), {}, {
      payload: h,
      item: s
    });
  };
  function vx(e) {
    "@babel/helpers - typeof";
    return vx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, vx(e);
  }
  function Yz(e) {
    return Cye(e) || _ye(e) || Sye(e) || Eye();
  }
  function Eye() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Sye(e, t) {
    if (e) {
      if (typeof e == "string") return gM(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return gM(e, t);
    }
  }
  function _ye(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function Cye(e) {
    if (Array.isArray(e)) return gM(e);
  }
  function gM(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function Gz(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Un(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? Gz(Object(r), !0).forEach(function(n) {
        n0(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Gz(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function n0(e, t, r) {
    return t = Oye(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Oye(e) {
    var t = Tye(e, "string");
    return vx(t) == "symbol" ? t : t + "";
  }
  function Tye(e, t) {
    if (vx(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (vx(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Ho(e, t, r) {
    return lr(e) || lr(t) ? r : ki(t) ? Su(e, t, r) : er(t) ? t(e) : r;
  }
  function qg(e, t, r, n) {
    var i = Cme(e, function(c) {
      return Ho(c, t);
    });
    if (r === "number") {
      var u = i.filter(function(c) {
        return Ke(c) || parseFloat(c);
      });
      return u.length ? [rC(u), tC(u)] : [1 / 0, -1 / 0];
    }
    var s = n ? i.filter(function(c) {
      return !lr(c);
    }) : i;
    return s.map(function(c) {
      return ki(c) || c instanceof Date ? c : "";
    });
  }
  var Aye = function(t) {
    var r, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = arguments.length > 2 ? arguments[2] : void 0, u = arguments.length > 3 ? arguments[3] : void 0, s = -1, c = (r = n == null ? void 0 : n.length) !== null && r !== void 0 ? r : 0;
    if (c <= 1)
      return 0;
    if (u && u.axisType === "angleAxis" && Math.abs(Math.abs(u.range[1] - u.range[0]) - 360) <= 1e-6)
      for (var p = u.range, h = 0; h < c; h++) {
        var v = h > 0 ? i[h - 1].coordinate : i[c - 1].coordinate, y = i[h].coordinate, x = h >= c - 1 ? i[0].coordinate : i[h + 1].coordinate, w = void 0;
        if (ds(y - v) !== ds(x - y)) {
          var E = [];
          if (ds(x - y) === ds(p[1] - p[0])) {
            w = x;
            var C = y + p[1] - p[0];
            E[0] = Math.min(C, (C + v) / 2), E[1] = Math.max(C, (C + v) / 2);
          } else {
            w = v;
            var S = x + p[1] - p[0];
            E[0] = Math.min(y, (S + y) / 2), E[1] = Math.max(y, (S + y) / 2);
          }
          var k = [Math.min(y, (w + y) / 2), Math.max(y, (w + y) / 2)];
          if (t > k[0] && t <= k[1] || t >= E[0] && t <= E[1]) {
            s = i[h].index;
            break;
          }
        } else {
          var D = Math.min(v, x), A = Math.max(v, x);
          if (t > (D + y) / 2 && t <= (A + y) / 2) {
            s = i[h].index;
            break;
          }
        }
      }
    else
      for (var R = 0; R < c; R++)
        if (R === 0 && t <= (n[R].coordinate + n[R + 1].coordinate) / 2 || R > 0 && R < c - 1 && t > (n[R].coordinate + n[R - 1].coordinate) / 2 && t <= (n[R].coordinate + n[R + 1].coordinate) / 2 || R === c - 1 && t > (n[R].coordinate + n[R - 1].coordinate) / 2) {
          s = n[R].index;
          break;
        }
    return s;
  }, qj = function(t) {
    var r, n = t, i = n.type.displayName, u = (r = t.type) !== null && r !== void 0 && r.defaultProps ? Un(Un({}, t.type.defaultProps), t.props) : t.props, s = u.stroke, c = u.fill, p;
    switch (i) {
      case "Line":
        p = s;
        break;
      case "Area":
      case "Radar":
        p = s && s !== "none" ? s : c;
        break;
      default:
        p = c;
        break;
    }
    return p;
  }, Dye = function(t) {
    var r = t.barSize, n = t.totalSize, i = t.stackGroups, u = i === void 0 ? {} : i;
    if (!u)
      return {};
    for (var s = {}, c = Object.keys(u), p = 0, h = c.length; p < h; p++)
      for (var v = u[c[p]].stackGroups, y = Object.keys(v), x = 0, w = y.length; x < w; x++) {
        var E = v[y[x]], C = E.items, S = E.cateAxisId, k = C.filter(function(F) {
          return vc(F.type).indexOf("Bar") >= 0;
        });
        if (k && k.length) {
          var D = k[0].type.defaultProps, A = D !== void 0 ? Un(Un({}, D), k[0].props) : k[0].props, R = A.barSize, T = A[S];
          s[T] || (s[T] = []);
          var M = lr(R) ? r : R;
          s[T].push({
            item: k[0],
            stackList: k.slice(1),
            barSize: lr(M) ? void 0 : Ip(M, n, 0)
          });
        }
      }
    return s;
  }, kye = function(t) {
    var r = t.barGap, n = t.barCategoryGap, i = t.bandSize, u = t.sizeList, s = u === void 0 ? [] : u, c = t.maxBarSize, p = s.length;
    if (p < 1) return null;
    var h = Ip(r, i, 0, !0), v, y = [];
    if (s[0].barSize === +s[0].barSize) {
      var x = !1, w = i / p, E = s.reduce(function(R, T) {
        return R + T.barSize || 0;
      }, 0);
      E += (p - 1) * h, E >= i && (E -= (p - 1) * h, h = 0), E >= i && w > 0 && (x = !0, w *= 0.9, E = p * w);
      var C = (i - E) / 2 >> 0, S = {
        offset: C - h,
        size: 0
      };
      v = s.reduce(function(R, T) {
        var M = {
          item: T.item,
          position: {
            offset: S.offset + S.size + h,
            // @ts-expect-error the type check above does not check for type number explicitly
            size: x ? w : T.barSize
          }
        }, F = [].concat(Yz(R), [M]);
        return S = F[F.length - 1].position, T.stackList && T.stackList.length && T.stackList.forEach(function(B) {
          F.push({
            item: B,
            position: S
          });
        }), F;
      }, y);
    } else {
      var k = Ip(n, i, 0, !0);
      i - 2 * k - (p - 1) * h <= 0 && (h = 0);
      var D = (i - 2 * k - (p - 1) * h) / p;
      D > 1 && (D >>= 0);
      var A = c === +c ? Math.min(D, c) : D;
      v = s.reduce(function(R, T, M) {
        var F = [].concat(Yz(R), [{
          item: T.item,
          position: {
            offset: k + (D + h) * M + (D - A) / 2,
            size: A
          }
        }]);
        return T.stackList && T.stackList.length && T.stackList.forEach(function(B) {
          F.push({
            item: B,
            position: F[F.length - 1].position
          });
        }), F;
      }, y);
    }
    return v;
  }, Rye = function(t, r, n, i) {
    var u = n.children, s = n.width, c = n.margin, p = s - (c.left || 0) - (c.right || 0), h = BW({
      children: u,
      legendWidth: p
    });
    if (h) {
      var v = i || {}, y = v.width, x = v.height, w = h.align, E = h.verticalAlign, C = h.layout;
      if ((C === "vertical" || C === "horizontal" && E === "middle") && w !== "center" && Ke(t[w]))
        return Un(Un({}, t), {}, n0({}, w, t[w] + (y || 0)));
      if ((C === "horizontal" || C === "vertical" && w === "center") && E !== "middle" && Ke(t[E]))
        return Un(Un({}, t), {}, n0({}, E, t[E] + (x || 0)));
    }
    return t;
  }, Pye = function(t, r, n) {
    return lr(r) ? !0 : t === "horizontal" ? r === "yAxis" : t === "vertical" || n === "x" ? r === "xAxis" : n === "y" ? r === "yAxis" : !0;
  }, LW = function(t, r, n, i, u) {
    var s = r.props.children, c = _u(s, Kx).filter(function(h) {
      return Pye(i, u, h.props.direction);
    });
    if (c && c.length) {
      var p = c.map(function(h) {
        return h.props.dataKey;
      });
      return t.reduce(function(h, v) {
        var y = Ho(v, n);
        if (lr(y)) return h;
        var x = Array.isArray(y) ? [rC(y), tC(y)] : [y, y], w = p.reduce(function(E, C) {
          var S = Ho(v, C, 0), k = x[0] - Math.abs(Array.isArray(S) ? S[0] : S), D = x[1] + Math.abs(Array.isArray(S) ? S[1] : S);
          return [Math.min(k, E[0]), Math.max(D, E[1])];
        }, [1 / 0, -1 / 0]);
        return [Math.min(w[0], h[0]), Math.max(w[1], h[1])];
      }, [1 / 0, -1 / 0]);
    }
    return null;
  }, Mye = function(t, r, n, i, u) {
    var s = r.map(function(c) {
      return LW(t, c, n, u, i);
    }).filter(function(c) {
      return !lr(c);
    });
    return s && s.length ? s.reduce(function(c, p) {
      return [Math.min(c[0], p[0]), Math.max(c[1], p[1])];
    }, [1 / 0, -1 / 0]) : null;
  }, $W = function(t, r, n, i, u) {
    var s = r.map(function(p) {
      var h = p.props.dataKey;
      return n === "number" && h && LW(t, p, h, i) || qg(t, h, n, u);
    });
    if (n === "number")
      return s.reduce(
        // @ts-expect-error if (type === number) means that the domain is numerical type
        // - but this link is missing in the type definition
        function(p, h) {
          return [Math.min(p[0], h[0]), Math.max(p[1], h[1])];
        },
        [1 / 0, -1 / 0]
      );
    var c = {};
    return s.reduce(function(p, h) {
      for (var v = 0, y = h.length; v < y; v++)
        c[h[v]] || (c[h[v]] = !0, p.push(h[v]));
      return p;
    }, []);
  }, zW = function(t, r) {
    return t === "horizontal" && r === "xAxis" || t === "vertical" && r === "yAxis" || t === "centric" && r === "angleAxis" || t === "radial" && r === "radiusAxis";
  }, qW = function(t, r, n, i) {
    if (i)
      return t.map(function(p) {
        return p.coordinate;
      });
    var u, s, c = t.map(function(p) {
      return p.coordinate === r && (u = !0), p.coordinate === n && (s = !0), p.coordinate;
    });
    return u || c.push(r), s || c.push(n), c;
  }, pc = function(t, r, n) {
    if (!t) return null;
    var i = t.scale, u = t.duplicateDomain, s = t.type, c = t.range, p = t.realScaleType === "scaleBand" ? i.bandwidth() / 2 : 2, h = (r || n) && s === "category" && i.bandwidth ? i.bandwidth() / p : 0;
    if (h = t.axisType === "angleAxis" && (c == null ? void 0 : c.length) >= 2 ? ds(c[0] - c[1]) * 2 * h : h, r && (t.ticks || t.niceTicks)) {
      var v = (t.ticks || t.niceTicks).map(function(y) {
        var x = u ? u.indexOf(y) : y;
        return {
          // If the scaleContent is not a number, the coordinate will be NaN.
          // That could be the case for example with a PointScale and a string as domain.
          coordinate: i(x) + h,
          value: y,
          offset: h
        };
      });
      return v.filter(function(y) {
        return !Ux(y.coordinate);
      });
    }
    return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(y, x) {
      return {
        coordinate: i(y) + h,
        value: y,
        index: x,
        offset: h
      };
    }) : i.ticks && !n ? i.ticks(t.tickCount).map(function(y) {
      return {
        coordinate: i(y) + h,
        value: y,
        offset: h
      };
    }) : i.domain().map(function(y, x) {
      return {
        coordinate: i(y) + h,
        value: u ? u[y] : y,
        index: x,
        offset: h
      };
    });
  }, _2 = /* @__PURE__ */ new WeakMap(), dE = function(t, r) {
    if (typeof r != "function")
      return t;
    _2.has(t) || _2.set(t, /* @__PURE__ */ new WeakMap());
    var n = _2.get(t);
    if (n.has(r))
      return n.get(r);
    var i = function() {
      t.apply(void 0, arguments), r.apply(void 0, arguments);
    };
    return n.set(r, i), i;
  }, Nye = function(t, r, n) {
    var i = t.scale, u = t.type, s = t.layout, c = t.axisType;
    if (i === "auto")
      return s === "radial" && c === "radiusAxis" ? {
        scale: ux(),
        realScaleType: "band"
      } : s === "radial" && c === "angleAxis" ? {
        scale: zS(),
        realScaleType: "linear"
      } : u === "category" && r && (r.indexOf("LineChart") >= 0 || r.indexOf("AreaChart") >= 0 || r.indexOf("ComposedChart") >= 0 && !n) ? {
        scale: zg(),
        realScaleType: "point"
      } : u === "category" ? {
        scale: ux(),
        realScaleType: "band"
      } : {
        scale: zS(),
        realScaleType: "linear"
      };
    if (Fp(i)) {
      var p = "scale".concat(q_(i));
      return {
        scale: (Mz[p] || zg)(),
        realScaleType: Mz[p] ? p : "point"
      };
    }
    return er(i) ? {
      scale: i
    } : {
      scale: zg(),
      realScaleType: "point"
    };
  }, Qz = 1e-4, jye = function(t) {
    var r = t.domain();
    if (!(!r || r.length <= 2)) {
      var n = r.length, i = t.range(), u = Math.min(i[0], i[1]) - Qz, s = Math.max(i[0], i[1]) + Qz, c = t(r[0]), p = t(r[n - 1]);
      (c < u || c > s || p < u || p > s) && t.domain([r[0], r[n - 1]]);
    }
  }, Fye = function(t, r) {
    if (!t)
      return null;
    for (var n = 0, i = t.length; n < i; n++)
      if (t[n].item === r)
        return t[n].position;
    return null;
  }, Iye = function(t, r) {
    if (!r || r.length !== 2 || !Ke(r[0]) || !Ke(r[1]))
      return t;
    var n = Math.min(r[0], r[1]), i = Math.max(r[0], r[1]), u = [t[0], t[1]];
    return (!Ke(t[0]) || t[0] < n) && (u[0] = n), (!Ke(t[1]) || t[1] > i) && (u[1] = i), u[0] > i && (u[0] = i), u[1] < n && (u[1] = n), u;
  }, Bye = function(t) {
    var r = t.length;
    if (!(r <= 0))
      for (var n = 0, i = t[0].length; n < i; ++n)
        for (var u = 0, s = 0, c = 0; c < r; ++c) {
          var p = Ux(t[c][n][1]) ? t[c][n][0] : t[c][n][1];
          p >= 0 ? (t[c][n][0] = u, t[c][n][1] = u + p, u = t[c][n][1]) : (t[c][n][0] = s, t[c][n][1] = s + p, s = t[c][n][1]);
        }
  }, Lye = function(t) {
    var r = t.length;
    if (!(r <= 0))
      for (var n = 0, i = t[0].length; n < i; ++n)
        for (var u = 0, s = 0; s < r; ++s) {
          var c = Ux(t[s][n][1]) ? t[s][n][0] : t[s][n][1];
          c >= 0 ? (t[s][n][0] = u, t[s][n][1] = u + c, u = t[s][n][1]) : (t[s][n][0] = 0, t[s][n][1] = 0);
        }
  }, $ye = {
    sign: Bye,
    // @ts-expect-error definitelytyped types are incorrect
    expand: Efe,
    // @ts-expect-error definitelytyped types are incorrect
    none: f0,
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: Sfe,
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: _fe,
    positive: Lye
  }, zye = function(t, r, n) {
    var i = r.map(function(c) {
      return c.props.dataKey;
    }), u = $ye[n], s = wfe().keys(i).value(function(c, p) {
      return +Ho(c, p, 0);
    }).order(GP).offset(u);
    return s(t);
  }, qye = function(t, r, n, i, u, s) {
    if (!t)
      return null;
    var c = s ? r.reverse() : r, p = {}, h = c.reduce(function(y, x) {
      var w, E = (w = x.type) !== null && w !== void 0 && w.defaultProps ? Un(Un({}, x.type.defaultProps), x.props) : x.props, C = E.stackId, S = E.hide;
      if (S)
        return y;
      var k = E[n], D = y[k] || {
        hasStack: !1,
        stackGroups: {}
      };
      if (ki(C)) {
        var A = D.stackGroups[C] || {
          numericAxisId: n,
          cateAxisId: i,
          items: []
        };
        A.items.push(x), D.hasStack = !0, D.stackGroups[C] = A;
      } else
        D.stackGroups[Hx("_stackId_")] = {
          numericAxisId: n,
          cateAxisId: i,
          items: [x]
        };
      return Un(Un({}, y), {}, n0({}, k, D));
    }, p), v = {};
    return Object.keys(h).reduce(function(y, x) {
      var w = h[x];
      if (w.hasStack) {
        var E = {};
        w.stackGroups = Object.keys(w.stackGroups).reduce(function(C, S) {
          var k = w.stackGroups[S];
          return Un(Un({}, C), {}, n0({}, S, {
            numericAxisId: n,
            cateAxisId: i,
            items: k.items,
            stackedData: zye(t, k.items, u)
          }));
        }, E);
      }
      return Un(Un({}, y), {}, n0({}, x, w));
    }, v);
  }, Uye = function(t, r) {
    var n = r.realScaleType, i = r.type, u = r.tickCount, s = r.originalDomain, c = r.allowDecimals, p = n || r.scale;
    if (p !== "auto" && p !== "linear")
      return null;
    if (u && i === "number" && s && (s[0] === "auto" || s[1] === "auto")) {
      var h = t.domain();
      if (!h.length)
        return null;
      var v = eye(h, u, c);
      return t.domain([rC(v), tC(v)]), {
        niceTicks: v
      };
    }
    if (u && i === "number") {
      var y = t.domain(), x = tye(y, u, c);
      return {
        niceTicks: x
      };
    }
    return null;
  };
  function Kz(e) {
    var t = e.axis, r = e.ticks, n = e.bandSize, i = e.entry, u = e.index, s = e.dataKey;
    if (t.type === "category") {
      if (!t.allowDuplicatedCategory && t.dataKey && !lr(i[t.dataKey])) {
        var c = wS(r, "value", i[t.dataKey]);
        if (c)
          return c.coordinate + n / 2;
      }
      return r[u] ? r[u].coordinate + n / 2 : null;
    }
    var p = Ho(i, lr(s) ? t.dataKey : s);
    return lr(p) ? null : t.scale(p);
  }
  var Xz = function(t) {
    var r = t.axis, n = t.ticks, i = t.offset, u = t.bandSize, s = t.entry, c = t.index;
    if (r.type === "category")
      return n[c] ? n[c].coordinate + i : null;
    var p = Ho(s, r.dataKey, r.domain[c]);
    return lr(p) ? null : r.scale(p) - u / 2 + i;
  }, Hye = function(t) {
    var r = t.numericAxis, n = r.scale.domain();
    if (r.type === "number") {
      var i = Math.min(n[0], n[1]), u = Math.max(n[0], n[1]);
      return i <= 0 && u >= 0 ? 0 : u < 0 ? u : i;
    }
    return n[0];
  }, Vye = function(t, r) {
    var n, i = (n = t.type) !== null && n !== void 0 && n.defaultProps ? Un(Un({}, t.type.defaultProps), t.props) : t.props, u = i.stackId;
    if (ki(u)) {
      var s = r[u];
      if (s) {
        var c = s.items.indexOf(t);
        return c >= 0 ? s.stackedData[c] : null;
      }
    }
    return null;
  }, Wye = function(t) {
    return t.reduce(function(r, n) {
      return [rC(n.concat([r[0]]).filter(Ke)), tC(n.concat([r[1]]).filter(Ke))];
    }, [1 / 0, -1 / 0]);
  }, UW = function(t, r, n) {
    return Object.keys(t).reduce(function(i, u) {
      var s = t[u], c = s.stackedData, p = c.reduce(function(h, v) {
        var y = Wye(v.slice(r, n + 1));
        return [Math.min(h[0], y[0]), Math.max(h[1], y[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(p[0], i[0]), Math.max(p[1], i[1])];
    }, [1 / 0, -1 / 0]).map(function(i) {
      return i === 1 / 0 || i === -1 / 0 ? 0 : i;
    });
  }, Zz = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, Jz = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, xM = function(t, r, n) {
    if (er(t))
      return t(r, n);
    if (!Array.isArray(t))
      return r;
    var i = [];
    if (Ke(t[0]))
      i[0] = n ? t[0] : Math.min(t[0], r[0]);
    else if (Zz.test(t[0])) {
      var u = +Zz.exec(t[0])[1];
      i[0] = r[0] - u;
    } else er(t[0]) ? i[0] = t[0](r[0]) : i[0] = r[0];
    if (Ke(t[1]))
      i[1] = n ? t[1] : Math.max(t[1], r[1]);
    else if (Jz.test(t[1])) {
      var s = +Jz.exec(t[1])[1];
      i[1] = r[1] + s;
    } else er(t[1]) ? i[1] = t[1](r[1]) : i[1] = r[1];
    return i;
  }, GS = function(t, r, n) {
    if (t && t.scale && t.scale.bandwidth) {
      var i = t.scale.bandwidth();
      if (!n || i > 0)
        return i;
    }
    if (t && r && r.length >= 2) {
      for (var u = mj(r, function(y) {
        return y.coordinate;
      }), s = 1 / 0, c = 1, p = u.length; c < p; c++) {
        var h = u[c], v = u[c - 1];
        s = Math.min((h.coordinate || 0) - (v.coordinate || 0), s);
      }
      return s === 1 / 0 ? 0 : s;
    }
    return n ? void 0 : 0;
  }, eq = function(t, r, n) {
    return !t || !t.length || nC(t, Su(n, "type.defaultProps.domain")) ? r : t;
  }, HW = function(t, r) {
    var n = t.type.defaultProps ? Un(Un({}, t.type.defaultProps), t.props) : t.props, i = n.dataKey, u = n.name, s = n.unit, c = n.formatter, p = n.tooltipType, h = n.chartType, v = n.hide;
    return Un(Un({}, pr(t, !1)), {}, {
      dataKey: i,
      unit: s,
      formatter: c,
      name: u || i,
      color: qj(t),
      value: Ho(r, i),
      type: p,
      payload: r,
      chartType: h,
      hide: v
    });
  };
  function mx(e) {
    "@babel/helpers - typeof";
    return mx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, mx(e);
  }
  function tq(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function rq(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? tq(Object(r), !0).forEach(function(n) {
        Yye(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : tq(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Yye(e, t, r) {
    return t = Gye(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Gye(e) {
    var t = Qye(e, "string");
    return mx(t) == "symbol" ? t : t + "";
  }
  function Qye(e, t) {
    if (mx(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (mx(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var QS = Math.PI / 180, Kye = function(t) {
    return t * 180 / Math.PI;
  }, oa = function(t, r, n, i) {
    return {
      x: t + Math.cos(-QS * i) * n,
      y: r + Math.sin(-QS * i) * n
    };
  }, Xye = function(t, r) {
    var n = t.x, i = t.y, u = r.x, s = r.y;
    return Math.sqrt(Math.pow(n - u, 2) + Math.pow(i - s, 2));
  }, Zye = function(t, r) {
    var n = t.x, i = t.y, u = r.cx, s = r.cy, c = Xye({
      x: n,
      y: i
    }, {
      x: u,
      y: s
    });
    if (c <= 0)
      return {
        radius: c
      };
    var p = (n - u) / c, h = Math.acos(p);
    return i > s && (h = 2 * Math.PI - h), {
      radius: c,
      angle: Kye(h),
      angleInRadian: h
    };
  }, Jye = function(t) {
    var r = t.startAngle, n = t.endAngle, i = Math.floor(r / 360), u = Math.floor(n / 360), s = Math.min(i, u);
    return {
      startAngle: r - s * 360,
      endAngle: n - s * 360
    };
  }, ege = function(t, r) {
    var n = r.startAngle, i = r.endAngle, u = Math.floor(n / 360), s = Math.floor(i / 360), c = Math.min(u, s);
    return t + c * 360;
  }, nq = function(t, r) {
    var n = t.x, i = t.y, u = Zye({
      x: n,
      y: i
    }, r), s = u.radius, c = u.angle, p = r.innerRadius, h = r.outerRadius;
    if (s < p || s > h)
      return !1;
    if (s === 0)
      return !0;
    var v = Jye(r), y = v.startAngle, x = v.endAngle, w = c, E;
    if (y <= x) {
      for (; w > x; )
        w -= 360;
      for (; w < y; )
        w += 360;
      E = w >= y && w <= x;
    } else {
      for (; w > y; )
        w -= 360;
      for (; w < x; )
        w += 360;
      E = w >= x && w <= y;
    }
    return E ? rq(rq({}, r), {}, {
      radius: s,
      angle: ege(w, r)
    }) : null;
  };
  function yx(e) {
    "@babel/helpers - typeof";
    return yx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, yx(e);
  }
  var tge = ["offset"];
  function rge(e) {
    return oge(e) || age(e) || ige(e) || nge();
  }
  function nge() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function ige(e, t) {
    if (e) {
      if (typeof e == "string") return bM(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return bM(e, t);
    }
  }
  function age(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function oge(e) {
    if (Array.isArray(e)) return bM(e);
  }
  function bM(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function uge(e, t) {
    if (e == null) return {};
    var r = sge(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function sge(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function iq(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Di(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? iq(Object(r), !0).forEach(function(n) {
        lge(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : iq(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function lge(e, t, r) {
    return t = cge(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function cge(e) {
    var t = fge(e, "string");
    return yx(t) == "symbol" ? t : t + "";
  }
  function fge(e, t) {
    if (yx(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (yx(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function gx() {
    return gx = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, gx.apply(this, arguments);
  }
  var dge = function(t) {
    var r = t.value, n = t.formatter, i = lr(t.children) ? r : t.children;
    return er(n) ? n(i) : i;
  }, pge = function(t, r) {
    var n = ds(r - t), i = Math.min(Math.abs(r - t), 360);
    return n * i;
  }, hge = function(t, r, n) {
    var i = t.position, u = t.viewBox, s = t.offset, c = t.className, p = u, h = p.cx, v = p.cy, y = p.innerRadius, x = p.outerRadius, w = p.startAngle, E = p.endAngle, C = p.clockWise, S = (y + x) / 2, k = pge(w, E), D = k >= 0 ? 1 : -1, A, R;
    i === "insideStart" ? (A = w + D * s, R = C) : i === "insideEnd" ? (A = E - D * s, R = !C) : i === "end" && (A = E + D * s, R = C), R = k <= 0 ? R : !R;
    var T = oa(h, v, S, A), M = oa(h, v, S, A + (R ? 1 : -1) * 359), F = "M".concat(T.x, ",").concat(T.y, `
    A`).concat(S, ",").concat(S, ",0,1,").concat(R ? 0 : 1, `,
    `).concat(M.x, ",").concat(M.y), B = lr(t.id) ? Hx("recharts-radial-line-") : t.id;
    return /* @__PURE__ */ ce.createElement("text", gx({}, n, {
      dominantBaseline: "central",
      className: hr("recharts-radial-bar-label", c)
    }), /* @__PURE__ */ ce.createElement("defs", null, /* @__PURE__ */ ce.createElement("path", {
      id: B,
      d: F
    })), /* @__PURE__ */ ce.createElement("textPath", {
      xlinkHref: "#".concat(B)
    }, r));
  }, vge = function(t) {
    var r = t.viewBox, n = t.offset, i = t.position, u = r, s = u.cx, c = u.cy, p = u.innerRadius, h = u.outerRadius, v = u.startAngle, y = u.endAngle, x = (v + y) / 2;
    if (i === "outside") {
      var w = oa(s, c, h + n, x), E = w.x, C = w.y;
      return {
        x: E,
        y: C,
        textAnchor: E >= s ? "start" : "end",
        verticalAnchor: "middle"
      };
    }
    if (i === "center")
      return {
        x: s,
        y: c,
        textAnchor: "middle",
        verticalAnchor: "middle"
      };
    if (i === "centerTop")
      return {
        x: s,
        y: c,
        textAnchor: "middle",
        verticalAnchor: "start"
      };
    if (i === "centerBottom")
      return {
        x: s,
        y: c,
        textAnchor: "middle",
        verticalAnchor: "end"
      };
    var S = (p + h) / 2, k = oa(s, c, S, x), D = k.x, A = k.y;
    return {
      x: D,
      y: A,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  }, mge = function(t) {
    var r = t.viewBox, n = t.parentViewBox, i = t.offset, u = t.position, s = r, c = s.x, p = s.y, h = s.width, v = s.height, y = v >= 0 ? 1 : -1, x = y * i, w = y > 0 ? "end" : "start", E = y > 0 ? "start" : "end", C = h >= 0 ? 1 : -1, S = C * i, k = C > 0 ? "end" : "start", D = C > 0 ? "start" : "end";
    if (u === "top") {
      var A = {
        x: c + h / 2,
        y: p - y * i,
        textAnchor: "middle",
        verticalAnchor: w
      };
      return Di(Di({}, A), n ? {
        height: Math.max(p - n.y, 0),
        width: h
      } : {});
    }
    if (u === "bottom") {
      var R = {
        x: c + h / 2,
        y: p + v + x,
        textAnchor: "middle",
        verticalAnchor: E
      };
      return Di(Di({}, R), n ? {
        height: Math.max(n.y + n.height - (p + v), 0),
        width: h
      } : {});
    }
    if (u === "left") {
      var T = {
        x: c - S,
        y: p + v / 2,
        textAnchor: k,
        verticalAnchor: "middle"
      };
      return Di(Di({}, T), n ? {
        width: Math.max(T.x - n.x, 0),
        height: v
      } : {});
    }
    if (u === "right") {
      var M = {
        x: c + h + S,
        y: p + v / 2,
        textAnchor: D,
        verticalAnchor: "middle"
      };
      return Di(Di({}, M), n ? {
        width: Math.max(n.x + n.width - M.x, 0),
        height: v
      } : {});
    }
    var F = n ? {
      width: h,
      height: v
    } : {};
    return u === "insideLeft" ? Di({
      x: c + S,
      y: p + v / 2,
      textAnchor: D,
      verticalAnchor: "middle"
    }, F) : u === "insideRight" ? Di({
      x: c + h - S,
      y: p + v / 2,
      textAnchor: k,
      verticalAnchor: "middle"
    }, F) : u === "insideTop" ? Di({
      x: c + h / 2,
      y: p + x,
      textAnchor: "middle",
      verticalAnchor: E
    }, F) : u === "insideBottom" ? Di({
      x: c + h / 2,
      y: p + v - x,
      textAnchor: "middle",
      verticalAnchor: w
    }, F) : u === "insideTopLeft" ? Di({
      x: c + S,
      y: p + x,
      textAnchor: D,
      verticalAnchor: E
    }, F) : u === "insideTopRight" ? Di({
      x: c + h - S,
      y: p + x,
      textAnchor: k,
      verticalAnchor: E
    }, F) : u === "insideBottomLeft" ? Di({
      x: c + S,
      y: p + v - x,
      textAnchor: D,
      verticalAnchor: w
    }, F) : u === "insideBottomRight" ? Di({
      x: c + h - S,
      y: p + v - x,
      textAnchor: k,
      verticalAnchor: w
    }, F) : G0(u) && (Ke(u.x) || Op(u.x)) && (Ke(u.y) || Op(u.y)) ? Di({
      x: c + Ip(u.x, h),
      y: p + Ip(u.y, v),
      textAnchor: "end",
      verticalAnchor: "end"
    }, F) : Di({
      x: c + h / 2,
      y: p + v / 2,
      textAnchor: "middle",
      verticalAnchor: "middle"
    }, F);
  }, yge = function(t) {
    return "cx" in t && Ke(t.cx);
  };
  function Ta(e) {
    var t = e.offset, r = t === void 0 ? 5 : t, n = uge(e, tge), i = Di({
      offset: r
    }, n), u = i.viewBox, s = i.position, c = i.value, p = i.children, h = i.content, v = i.className, y = v === void 0 ? "" : v, x = i.textBreakAll;
    if (!u || lr(c) && lr(p) && !/* @__PURE__ */ ee.isValidElement(h) && !er(h))
      return null;
    if (/* @__PURE__ */ ee.isValidElement(h))
      return /* @__PURE__ */ ee.cloneElement(h, i);
    var w;
    if (er(h)) {
      if (w = /* @__PURE__ */ ee.createElement(h, i), /* @__PURE__ */ ee.isValidElement(w))
        return w;
    } else
      w = dge(i);
    var E = yge(u), C = pr(i, !0);
    if (E && (s === "insideStart" || s === "insideEnd" || s === "end"))
      return hge(i, w, C);
    var S = E ? vge(i) : mge(i);
    return /* @__PURE__ */ ce.createElement(NS, gx({
      className: hr("recharts-label", y)
    }, C, S, {
      breakAll: x
    }), w);
  }
  Ta.displayName = "Label";
  var VW = function(t) {
    var r = t.cx, n = t.cy, i = t.angle, u = t.startAngle, s = t.endAngle, c = t.r, p = t.radius, h = t.innerRadius, v = t.outerRadius, y = t.x, x = t.y, w = t.top, E = t.left, C = t.width, S = t.height, k = t.clockWise, D = t.labelViewBox;
    if (D)
      return D;
    if (Ke(C) && Ke(S)) {
      if (Ke(y) && Ke(x))
        return {
          x: y,
          y: x,
          width: C,
          height: S
        };
      if (Ke(w) && Ke(E))
        return {
          x: w,
          y: E,
          width: C,
          height: S
        };
    }
    return Ke(y) && Ke(x) ? {
      x: y,
      y: x,
      width: 0,
      height: 0
    } : Ke(r) && Ke(n) ? {
      cx: r,
      cy: n,
      startAngle: u || i || 0,
      endAngle: s || i || 0,
      innerRadius: h || 0,
      outerRadius: v || p || c || 0,
      clockWise: k
    } : t.viewBox ? t.viewBox : {};
  }, gge = function(t, r) {
    return t ? t === !0 ? /* @__PURE__ */ ce.createElement(Ta, {
      key: "label-implicit",
      viewBox: r
    }) : ki(t) ? /* @__PURE__ */ ce.createElement(Ta, {
      key: "label-implicit",
      viewBox: r,
      value: t
    }) : /* @__PURE__ */ ee.isValidElement(t) ? t.type === Ta ? /* @__PURE__ */ ee.cloneElement(t, {
      key: "label-implicit",
      viewBox: r
    }) : /* @__PURE__ */ ce.createElement(Ta, {
      key: "label-implicit",
      content: t,
      viewBox: r
    }) : er(t) ? /* @__PURE__ */ ce.createElement(Ta, {
      key: "label-implicit",
      content: t,
      viewBox: r
    }) : G0(t) ? /* @__PURE__ */ ce.createElement(Ta, gx({
      viewBox: r
    }, t, {
      key: "label-implicit"
    })) : null : null;
  }, xge = function(t, r) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
    if (!t || !t.children && n && !t.label)
      return null;
    var i = t.children, u = VW(t), s = _u(i, Ta).map(function(p, h) {
      return /* @__PURE__ */ ee.cloneElement(p, {
        viewBox: r || u,
        // eslint-disable-next-line react/no-array-index-key
        key: "label-".concat(h)
      });
    });
    if (!n)
      return s;
    var c = gge(t.label, r || u);
    return [c].concat(rge(s));
  };
  Ta.parseViewBox = VW;
  Ta.renderCallByParent = xge;
  var C2, aq;
  function bge() {
    if (aq) return C2;
    aq = 1;
    function e(t) {
      var r = t == null ? 0 : t.length;
      return r ? t[r - 1] : void 0;
    }
    return C2 = e, C2;
  }
  var wge = bge();
  const Ege = /* @__PURE__ */ Zr(wge);
  function xx(e) {
    "@babel/helpers - typeof";
    return xx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, xx(e);
  }
  var Sge = ["valueAccessor"], _ge = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
  function Cge(e) {
    return Dge(e) || Age(e) || Tge(e) || Oge();
  }
  function Oge() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Tge(e, t) {
    if (e) {
      if (typeof e == "string") return wM(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return wM(e, t);
    }
  }
  function Age(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function Dge(e) {
    if (Array.isArray(e)) return wM(e);
  }
  function wM(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function KS() {
    return KS = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, KS.apply(this, arguments);
  }
  function oq(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function uq(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? oq(Object(r), !0).forEach(function(n) {
        kge(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : oq(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function kge(e, t, r) {
    return t = Rge(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Rge(e) {
    var t = Pge(e, "string");
    return xx(t) == "symbol" ? t : t + "";
  }
  function Pge(e, t) {
    if (xx(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (xx(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function sq(e, t) {
    if (e == null) return {};
    var r = Mge(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function Mge(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  var Nge = function(t) {
    return Array.isArray(t.value) ? Ege(t.value) : t.value;
  };
  function Bf(e) {
    var t = e.valueAccessor, r = t === void 0 ? Nge : t, n = sq(e, Sge), i = n.data, u = n.dataKey, s = n.clockWise, c = n.id, p = n.textBreakAll, h = sq(n, _ge);
    return !i || !i.length ? null : /* @__PURE__ */ ce.createElement(ei, {
      className: "recharts-label-list"
    }, i.map(function(v, y) {
      var x = lr(u) ? r(v, y) : Ho(v && v.payload, u), w = lr(c) ? {} : {
        id: "".concat(c, "-").concat(y)
      };
      return /* @__PURE__ */ ce.createElement(Ta, KS({}, pr(v, !0), h, w, {
        parentViewBox: v.parentViewBox,
        value: x,
        textBreakAll: p,
        viewBox: Ta.parseViewBox(lr(s) ? v : uq(uq({}, v), {}, {
          clockWise: s
        })),
        key: "label-".concat(y),
        index: y
      }));
    }));
  }
  Bf.displayName = "LabelList";
  function jge(e, t) {
    return e ? e === !0 ? /* @__PURE__ */ ce.createElement(Bf, {
      key: "labelList-implicit",
      data: t
    }) : /* @__PURE__ */ ce.isValidElement(e) || er(e) ? /* @__PURE__ */ ce.createElement(Bf, {
      key: "labelList-implicit",
      data: t,
      content: e
    }) : G0(e) ? /* @__PURE__ */ ce.createElement(Bf, KS({
      data: t
    }, e, {
      key: "labelList-implicit"
    })) : null : null;
  }
  function Fge(e, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
    if (!e || !e.children && r && !e.label)
      return null;
    var n = e.children, i = _u(n, Bf).map(function(s, c) {
      return /* @__PURE__ */ ee.cloneElement(s, {
        data: t,
        // eslint-disable-next-line react/no-array-index-key
        key: "labelList-".concat(c)
      });
    });
    if (!r)
      return i;
    var u = jge(e.label, t);
    return [u].concat(Cge(i));
  }
  Bf.renderCallByParent = Fge;
  function bx(e) {
    "@babel/helpers - typeof";
    return bx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, bx(e);
  }
  function EM() {
    return EM = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, EM.apply(this, arguments);
  }
  function lq(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function cq(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? lq(Object(r), !0).forEach(function(n) {
        Ige(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : lq(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Ige(e, t, r) {
    return t = Bge(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Bge(e) {
    var t = Lge(e, "string");
    return bx(t) == "symbol" ? t : t + "";
  }
  function Lge(e, t) {
    if (bx(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (bx(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var $ge = function(t, r) {
    var n = ds(r - t), i = Math.min(Math.abs(r - t), 359.999);
    return n * i;
  }, pE = function(t) {
    var r = t.cx, n = t.cy, i = t.radius, u = t.angle, s = t.sign, c = t.isExternal, p = t.cornerRadius, h = t.cornerIsExternal, v = p * (c ? 1 : -1) + i, y = Math.asin(p / v) / QS, x = h ? u : u + s * y, w = oa(r, n, v, x), E = oa(r, n, i, x), C = h ? u - s * y : u, S = oa(r, n, v * Math.cos(y * QS), C);
    return {
      center: w,
      circleTangency: E,
      lineTangency: S,
      theta: y
    };
  }, WW = function(t) {
    var r = t.cx, n = t.cy, i = t.innerRadius, u = t.outerRadius, s = t.startAngle, c = t.endAngle, p = $ge(s, c), h = s + p, v = oa(r, n, u, s), y = oa(r, n, u, h), x = "M ".concat(v.x, ",").concat(v.y, `
    A `).concat(u, ",").concat(u, `,0,
    `).concat(+(Math.abs(p) > 180), ",").concat(+(s > h), `,
    `).concat(y.x, ",").concat(y.y, `
  `);
    if (i > 0) {
      var w = oa(r, n, i, s), E = oa(r, n, i, h);
      x += "L ".concat(E.x, ",").concat(E.y, `
            A `).concat(i, ",").concat(i, `,0,
            `).concat(+(Math.abs(p) > 180), ",").concat(+(s <= h), `,
            `).concat(w.x, ",").concat(w.y, " Z");
    } else
      x += "L ".concat(r, ",").concat(n, " Z");
    return x;
  }, zge = function(t) {
    var r = t.cx, n = t.cy, i = t.innerRadius, u = t.outerRadius, s = t.cornerRadius, c = t.forceCornerRadius, p = t.cornerIsExternal, h = t.startAngle, v = t.endAngle, y = ds(v - h), x = pE({
      cx: r,
      cy: n,
      radius: u,
      angle: h,
      sign: y,
      cornerRadius: s,
      cornerIsExternal: p
    }), w = x.circleTangency, E = x.lineTangency, C = x.theta, S = pE({
      cx: r,
      cy: n,
      radius: u,
      angle: v,
      sign: -y,
      cornerRadius: s,
      cornerIsExternal: p
    }), k = S.circleTangency, D = S.lineTangency, A = S.theta, R = p ? Math.abs(h - v) : Math.abs(h - v) - C - A;
    if (R < 0)
      return c ? "M ".concat(E.x, ",").concat(E.y, `
        a`).concat(s, ",").concat(s, ",0,0,1,").concat(s * 2, `,0
        a`).concat(s, ",").concat(s, ",0,0,1,").concat(-s * 2, `,0
      `) : WW({
        cx: r,
        cy: n,
        innerRadius: i,
        outerRadius: u,
        startAngle: h,
        endAngle: v
      });
    var T = "M ".concat(E.x, ",").concat(E.y, `
    A`).concat(s, ",").concat(s, ",0,0,").concat(+(y < 0), ",").concat(w.x, ",").concat(w.y, `
    A`).concat(u, ",").concat(u, ",0,").concat(+(R > 180), ",").concat(+(y < 0), ",").concat(k.x, ",").concat(k.y, `
    A`).concat(s, ",").concat(s, ",0,0,").concat(+(y < 0), ",").concat(D.x, ",").concat(D.y, `
  `);
    if (i > 0) {
      var M = pE({
        cx: r,
        cy: n,
        radius: i,
        angle: h,
        sign: y,
        isExternal: !0,
        cornerRadius: s,
        cornerIsExternal: p
      }), F = M.circleTangency, B = M.lineTangency, V = M.theta, H = pE({
        cx: r,
        cy: n,
        radius: i,
        angle: v,
        sign: -y,
        isExternal: !0,
        cornerRadius: s,
        cornerIsExternal: p
      }), q = H.circleTangency, Q = H.lineTangency, W = H.theta, J = p ? Math.abs(h - v) : Math.abs(h - v) - V - W;
      if (J < 0 && s === 0)
        return "".concat(T, "L").concat(r, ",").concat(n, "Z");
      T += "L".concat(Q.x, ",").concat(Q.y, `
      A`).concat(s, ",").concat(s, ",0,0,").concat(+(y < 0), ",").concat(q.x, ",").concat(q.y, `
      A`).concat(i, ",").concat(i, ",0,").concat(+(J > 180), ",").concat(+(y > 0), ",").concat(F.x, ",").concat(F.y, `
      A`).concat(s, ",").concat(s, ",0,0,").concat(+(y < 0), ",").concat(B.x, ",").concat(B.y, "Z");
    } else
      T += "L".concat(r, ",").concat(n, "Z");
    return T;
  }, qge = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: !1,
    cornerIsExternal: !1
  }, YW = function(t) {
    var r = cq(cq({}, qge), t), n = r.cx, i = r.cy, u = r.innerRadius, s = r.outerRadius, c = r.cornerRadius, p = r.forceCornerRadius, h = r.cornerIsExternal, v = r.startAngle, y = r.endAngle, x = r.className;
    if (s < u || v === y)
      return null;
    var w = hr("recharts-sector", x), E = s - u, C = Ip(c, E, 0, !0), S;
    return C > 0 && Math.abs(v - y) < 360 ? S = zge({
      cx: n,
      cy: i,
      innerRadius: u,
      outerRadius: s,
      cornerRadius: Math.min(C, E / 2),
      forceCornerRadius: p,
      cornerIsExternal: h,
      startAngle: v,
      endAngle: y
    }) : S = WW({
      cx: n,
      cy: i,
      innerRadius: u,
      outerRadius: s,
      startAngle: v,
      endAngle: y
    }), /* @__PURE__ */ ce.createElement("path", EM({}, pr(r, !0), {
      className: w,
      d: S,
      role: "img"
    }));
  };
  function wx(e) {
    "@babel/helpers - typeof";
    return wx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, wx(e);
  }
  function SM() {
    return SM = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, SM.apply(this, arguments);
  }
  function fq(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function dq(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? fq(Object(r), !0).forEach(function(n) {
        Uge(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fq(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Uge(e, t, r) {
    return t = Hge(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Hge(e) {
    var t = Vge(e, "string");
    return wx(t) == "symbol" ? t : t + "";
  }
  function Vge(e, t) {
    if (wx(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (wx(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var pq = {
    curveBasisClosed: cfe,
    curveBasisOpen: ffe,
    curveBasis: lfe,
    curveBumpX: Qce,
    curveBumpY: Kce,
    curveLinearClosed: dfe,
    curveLinear: H_,
    curveMonotoneX: pfe,
    curveMonotoneY: hfe,
    curveNatural: vfe,
    curveStep: mfe,
    curveStepAfter: gfe,
    curveStepBefore: yfe
  }, hE = function(t) {
    return t.x === +t.x && t.y === +t.y;
  }, Eg = function(t) {
    return t.x;
  }, Sg = function(t) {
    return t.y;
  }, Wge = function(t, r) {
    if (er(t))
      return t;
    var n = "curve".concat(q_(t));
    return (n === "curveMonotone" || n === "curveBump") && r ? pq["".concat(n).concat(r === "vertical" ? "Y" : "X")] : pq[n] || H_;
  }, Yge = function(t) {
    var r = t.type, n = r === void 0 ? "linear" : r, i = t.points, u = i === void 0 ? [] : i, s = t.baseLine, c = t.layout, p = t.connectNulls, h = p === void 0 ? !1 : p, v = Wge(n, c), y = h ? u.filter(function(C) {
      return hE(C);
    }) : u, x;
    if (Array.isArray(s)) {
      var w = h ? s.filter(function(C) {
        return hE(C);
      }) : s, E = y.map(function(C, S) {
        return dq(dq({}, C), {}, {
          base: w[S]
        });
      });
      return c === "vertical" ? x = aE().y(Sg).x1(Eg).x0(function(C) {
        return C.base.x;
      }) : x = aE().x(Eg).y1(Sg).y0(function(C) {
        return C.base.y;
      }), x.defined(hE).curve(v), x(E);
    }
    return c === "vertical" && Ke(s) ? x = aE().y(Sg).x1(Eg).x0(s) : Ke(s) ? x = aE().x(Eg).y1(Sg).y0(s) : x = XH().x(Eg).y(Sg), x.defined(hE).curve(v), x(y);
  }, _M = function(t) {
    var r = t.className, n = t.points, i = t.path, u = t.pathRef;
    if ((!n || !n.length) && !i)
      return null;
    var s = n && n.length ? Yge(t) : i;
    return /* @__PURE__ */ ce.createElement("path", SM({}, pr(t, !1), ES(t), {
      className: hr("recharts-curve", r),
      d: s,
      ref: u
    }));
  }, vE = { exports: {} }, mE = { exports: {} }, qr = {};
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var hq;
  function Gge() {
    if (hq) return qr;
    hq = 1;
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, u = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, v = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, x = e ? Symbol.for("react.suspense_list") : 60120, w = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, S = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, D = e ? Symbol.for("react.scope") : 60119;
    function A(T) {
      if (typeof T == "object" && T !== null) {
        var M = T.$$typeof;
        switch (M) {
          case t:
            switch (T = T.type, T) {
              case p:
              case h:
              case n:
              case u:
              case i:
              case y:
                return T;
              default:
                switch (T = T && T.$$typeof, T) {
                  case c:
                  case v:
                  case E:
                  case w:
                  case s:
                    return T;
                  default:
                    return M;
                }
            }
          case r:
            return M;
        }
      }
    }
    function R(T) {
      return A(T) === h;
    }
    return qr.AsyncMode = p, qr.ConcurrentMode = h, qr.ContextConsumer = c, qr.ContextProvider = s, qr.Element = t, qr.ForwardRef = v, qr.Fragment = n, qr.Lazy = E, qr.Memo = w, qr.Portal = r, qr.Profiler = u, qr.StrictMode = i, qr.Suspense = y, qr.isAsyncMode = function(T) {
      return R(T) || A(T) === p;
    }, qr.isConcurrentMode = R, qr.isContextConsumer = function(T) {
      return A(T) === c;
    }, qr.isContextProvider = function(T) {
      return A(T) === s;
    }, qr.isElement = function(T) {
      return typeof T == "object" && T !== null && T.$$typeof === t;
    }, qr.isForwardRef = function(T) {
      return A(T) === v;
    }, qr.isFragment = function(T) {
      return A(T) === n;
    }, qr.isLazy = function(T) {
      return A(T) === E;
    }, qr.isMemo = function(T) {
      return A(T) === w;
    }, qr.isPortal = function(T) {
      return A(T) === r;
    }, qr.isProfiler = function(T) {
      return A(T) === u;
    }, qr.isStrictMode = function(T) {
      return A(T) === i;
    }, qr.isSuspense = function(T) {
      return A(T) === y;
    }, qr.isValidElementType = function(T) {
      return typeof T == "string" || typeof T == "function" || T === n || T === h || T === u || T === i || T === y || T === x || typeof T == "object" && T !== null && (T.$$typeof === E || T.$$typeof === w || T.$$typeof === s || T.$$typeof === c || T.$$typeof === v || T.$$typeof === S || T.$$typeof === k || T.$$typeof === D || T.$$typeof === C);
    }, qr.typeOf = A, qr;
  }
  var Ur = {};
  /** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var vq;
  function Qge() {
    return vq || (vq = 1, process.env.NODE_ENV !== "production" && function() {
      var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, u = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, v = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, x = e ? Symbol.for("react.suspense_list") : 60120, w = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, S = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, D = e ? Symbol.for("react.scope") : 60119;
      function A(de) {
        return typeof de == "string" || typeof de == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        de === n || de === h || de === u || de === i || de === y || de === x || typeof de == "object" && de !== null && (de.$$typeof === E || de.$$typeof === w || de.$$typeof === s || de.$$typeof === c || de.$$typeof === v || de.$$typeof === S || de.$$typeof === k || de.$$typeof === D || de.$$typeof === C);
      }
      function R(de) {
        if (typeof de == "object" && de !== null) {
          var Ze = de.$$typeof;
          switch (Ze) {
            case t:
              var Ne = de.type;
              switch (Ne) {
                case p:
                case h:
                case n:
                case u:
                case i:
                case y:
                  return Ne;
                default:
                  var Ot = Ne && Ne.$$typeof;
                  switch (Ot) {
                    case c:
                    case v:
                    case E:
                    case w:
                    case s:
                      return Ot;
                    default:
                      return Ze;
                  }
              }
            case r:
              return Ze;
          }
        }
      }
      var T = p, M = h, F = c, B = s, V = t, H = v, q = n, Q = E, W = w, J = r, ne = u, ie = i, se = y, X = !1;
      function fe(de) {
        return X || (X = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Z(de) || R(de) === p;
      }
      function Z(de) {
        return R(de) === h;
      }
      function z(de) {
        return R(de) === c;
      }
      function Y(de) {
        return R(de) === s;
      }
      function te(de) {
        return typeof de == "object" && de !== null && de.$$typeof === t;
      }
      function ae(de) {
        return R(de) === v;
      }
      function De(de) {
        return R(de) === n;
      }
      function ke(de) {
        return R(de) === E;
      }
      function Re(de) {
        return R(de) === w;
      }
      function Te(de) {
        return R(de) === r;
      }
      function we(de) {
        return R(de) === u;
      }
      function Fe(de) {
        return R(de) === i;
      }
      function Ye(de) {
        return R(de) === y;
      }
      Ur.AsyncMode = T, Ur.ConcurrentMode = M, Ur.ContextConsumer = F, Ur.ContextProvider = B, Ur.Element = V, Ur.ForwardRef = H, Ur.Fragment = q, Ur.Lazy = Q, Ur.Memo = W, Ur.Portal = J, Ur.Profiler = ne, Ur.StrictMode = ie, Ur.Suspense = se, Ur.isAsyncMode = fe, Ur.isConcurrentMode = Z, Ur.isContextConsumer = z, Ur.isContextProvider = Y, Ur.isElement = te, Ur.isForwardRef = ae, Ur.isFragment = De, Ur.isLazy = ke, Ur.isMemo = Re, Ur.isPortal = Te, Ur.isProfiler = we, Ur.isStrictMode = Fe, Ur.isSuspense = Ye, Ur.isValidElementType = A, Ur.typeOf = R;
    }()), Ur;
  }
  var mq;
  function GW() {
    return mq || (mq = 1, process.env.NODE_ENV === "production" ? mE.exports = Gge() : mE.exports = Qge()), mE.exports;
  }
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  var O2, yq;
  function Kge() {
    if (yq) return O2;
    yq = 1;
    var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
    function n(u) {
      if (u == null)
        throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(u);
    }
    function i() {
      try {
        if (!Object.assign)
          return !1;
        var u = new String("abc");
        if (u[5] = "de", Object.getOwnPropertyNames(u)[0] === "5")
          return !1;
        for (var s = {}, c = 0; c < 10; c++)
          s["_" + String.fromCharCode(c)] = c;
        var p = Object.getOwnPropertyNames(s).map(function(v) {
          return s[v];
        });
        if (p.join("") !== "0123456789")
          return !1;
        var h = {};
        return "abcdefghijklmnopqrst".split("").forEach(function(v) {
          h[v] = v;
        }), Object.keys(Object.assign({}, h)).join("") === "abcdefghijklmnopqrst";
      } catch {
        return !1;
      }
    }
    return O2 = i() ? Object.assign : function(u, s) {
      for (var c, p = n(u), h, v = 1; v < arguments.length; v++) {
        c = Object(arguments[v]);
        for (var y in c)
          t.call(c, y) && (p[y] = c[y]);
        if (e) {
          h = e(c);
          for (var x = 0; x < h.length; x++)
            r.call(c, h[x]) && (p[h[x]] = c[h[x]]);
        }
      }
      return p;
    }, O2;
  }
  var T2, gq;
  function Uj() {
    if (gq) return T2;
    gq = 1;
    var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    return T2 = e, T2;
  }
  var A2, xq;
  function QW() {
    return xq || (xq = 1, A2 = Function.call.bind(Object.prototype.hasOwnProperty)), A2;
  }
  var D2, bq;
  function Xge() {
    if (bq) return D2;
    bq = 1;
    var e = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      var t = /* @__PURE__ */ Uj(), r = {}, n = /* @__PURE__ */ QW();
      e = function(u) {
        var s = "Warning: " + u;
        typeof console < "u" && console.error(s);
        try {
          throw new Error(s);
        } catch {
        }
      };
    }
    function i(u, s, c, p, h) {
      if (process.env.NODE_ENV !== "production") {
        for (var v in u)
          if (n(u, v)) {
            var y;
            try {
              if (typeof u[v] != "function") {
                var x = Error(
                  (p || "React class") + ": " + c + " type `" + v + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof u[v] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                throw x.name = "Invariant Violation", x;
              }
              y = u[v](s, v, p, c, null, t);
            } catch (E) {
              y = E;
            }
            if (y && !(y instanceof Error) && e(
              (p || "React class") + ": type specification of " + c + " `" + v + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof y + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            ), y instanceof Error && !(y.message in r)) {
              r[y.message] = !0;
              var w = h ? h() : "";
              e(
                "Failed " + c + " type: " + y.message + (w ?? "")
              );
            }
          }
      }
    }
    return i.resetWarningCache = function() {
      process.env.NODE_ENV !== "production" && (r = {});
    }, D2 = i, D2;
  }
  var k2, wq;
  function Zge() {
    if (wq) return k2;
    wq = 1;
    var e = GW(), t = Kge(), r = /* @__PURE__ */ Uj(), n = /* @__PURE__ */ QW(), i = /* @__PURE__ */ Xge(), u = function() {
    };
    process.env.NODE_ENV !== "production" && (u = function(c) {
      var p = "Warning: " + c;
      typeof console < "u" && console.error(p);
      try {
        throw new Error(p);
      } catch {
      }
    });
    function s() {
      return null;
    }
    return k2 = function(c, p) {
      var h = typeof Symbol == "function" && Symbol.iterator, v = "@@iterator";
      function y(Z) {
        var z = Z && (h && Z[h] || Z[v]);
        if (typeof z == "function")
          return z;
      }
      var x = "<<anonymous>>", w = {
        array: k("array"),
        bigint: k("bigint"),
        bool: k("boolean"),
        func: k("function"),
        number: k("number"),
        object: k("object"),
        string: k("string"),
        symbol: k("symbol"),
        any: D(),
        arrayOf: A,
        element: R(),
        elementType: T(),
        instanceOf: M,
        node: H(),
        objectOf: B,
        oneOf: F,
        oneOfType: V,
        shape: Q,
        exact: W
      };
      function E(Z, z) {
        return Z === z ? Z !== 0 || 1 / Z === 1 / z : Z !== Z && z !== z;
      }
      function C(Z, z) {
        this.message = Z, this.data = z && typeof z == "object" ? z : {}, this.stack = "";
      }
      C.prototype = Error.prototype;
      function S(Z) {
        if (process.env.NODE_ENV !== "production")
          var z = {}, Y = 0;
        function te(De, ke, Re, Te, we, Fe, Ye) {
          if (Te = Te || x, Fe = Fe || Re, Ye !== r) {
            if (p) {
              var de = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              throw de.name = "Invariant Violation", de;
            } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
              var Ze = Te + ":" + Re;
              !z[Ze] && // Avoid spamming the console because they are often not actionable except for lib authors
              Y < 3 && (u(
                "You are manually calling a React.PropTypes validation function for the `" + Fe + "` prop on `" + Te + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              ), z[Ze] = !0, Y++);
            }
          }
          return ke[Re] == null ? De ? ke[Re] === null ? new C("The " + we + " `" + Fe + "` is marked as required " + ("in `" + Te + "`, but its value is `null`.")) : new C("The " + we + " `" + Fe + "` is marked as required in " + ("`" + Te + "`, but its value is `undefined`.")) : null : Z(ke, Re, Te, we, Fe);
        }
        var ae = te.bind(null, !1);
        return ae.isRequired = te.bind(null, !0), ae;
      }
      function k(Z) {
        function z(Y, te, ae, De, ke, Re) {
          var Te = Y[te], we = ie(Te);
          if (we !== Z) {
            var Fe = se(Te);
            return new C(
              "Invalid " + De + " `" + ke + "` of type " + ("`" + Fe + "` supplied to `" + ae + "`, expected ") + ("`" + Z + "`."),
              { expectedType: Z }
            );
          }
          return null;
        }
        return S(z);
      }
      function D() {
        return S(s);
      }
      function A(Z) {
        function z(Y, te, ae, De, ke) {
          if (typeof Z != "function")
            return new C("Property `" + ke + "` of component `" + ae + "` has invalid PropType notation inside arrayOf.");
          var Re = Y[te];
          if (!Array.isArray(Re)) {
            var Te = ie(Re);
            return new C("Invalid " + De + " `" + ke + "` of type " + ("`" + Te + "` supplied to `" + ae + "`, expected an array."));
          }
          for (var we = 0; we < Re.length; we++) {
            var Fe = Z(Re, we, ae, De, ke + "[" + we + "]", r);
            if (Fe instanceof Error)
              return Fe;
          }
          return null;
        }
        return S(z);
      }
      function R() {
        function Z(z, Y, te, ae, De) {
          var ke = z[Y];
          if (!c(ke)) {
            var Re = ie(ke);
            return new C("Invalid " + ae + " `" + De + "` of type " + ("`" + Re + "` supplied to `" + te + "`, expected a single ReactElement."));
          }
          return null;
        }
        return S(Z);
      }
      function T() {
        function Z(z, Y, te, ae, De) {
          var ke = z[Y];
          if (!e.isValidElementType(ke)) {
            var Re = ie(ke);
            return new C("Invalid " + ae + " `" + De + "` of type " + ("`" + Re + "` supplied to `" + te + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return S(Z);
      }
      function M(Z) {
        function z(Y, te, ae, De, ke) {
          if (!(Y[te] instanceof Z)) {
            var Re = Z.name || x, Te = fe(Y[te]);
            return new C("Invalid " + De + " `" + ke + "` of type " + ("`" + Te + "` supplied to `" + ae + "`, expected ") + ("instance of `" + Re + "`."));
          }
          return null;
        }
        return S(z);
      }
      function F(Z) {
        if (!Array.isArray(Z))
          return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? u(
            "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
          ) : u("Invalid argument supplied to oneOf, expected an array.")), s;
        function z(Y, te, ae, De, ke) {
          for (var Re = Y[te], Te = 0; Te < Z.length; Te++)
            if (E(Re, Z[Te]))
              return null;
          var we = JSON.stringify(Z, function(Ye, de) {
            var Ze = se(de);
            return Ze === "symbol" ? String(de) : de;
          });
          return new C("Invalid " + De + " `" + ke + "` of value `" + String(Re) + "` " + ("supplied to `" + ae + "`, expected one of " + we + "."));
        }
        return S(z);
      }
      function B(Z) {
        function z(Y, te, ae, De, ke) {
          if (typeof Z != "function")
            return new C("Property `" + ke + "` of component `" + ae + "` has invalid PropType notation inside objectOf.");
          var Re = Y[te], Te = ie(Re);
          if (Te !== "object")
            return new C("Invalid " + De + " `" + ke + "` of type " + ("`" + Te + "` supplied to `" + ae + "`, expected an object."));
          for (var we in Re)
            if (n(Re, we)) {
              var Fe = Z(Re, we, ae, De, ke + "." + we, r);
              if (Fe instanceof Error)
                return Fe;
            }
          return null;
        }
        return S(z);
      }
      function V(Z) {
        if (!Array.isArray(Z))
          return process.env.NODE_ENV !== "production" && u("Invalid argument supplied to oneOfType, expected an instance of array."), s;
        for (var z = 0; z < Z.length; z++) {
          var Y = Z[z];
          if (typeof Y != "function")
            return u(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + X(Y) + " at index " + z + "."
            ), s;
        }
        function te(ae, De, ke, Re, Te) {
          for (var we = [], Fe = 0; Fe < Z.length; Fe++) {
            var Ye = Z[Fe], de = Ye(ae, De, ke, Re, Te, r);
            if (de == null)
              return null;
            de.data && n(de.data, "expectedType") && we.push(de.data.expectedType);
          }
          var Ze = we.length > 0 ? ", expected one of type [" + we.join(", ") + "]" : "";
          return new C("Invalid " + Re + " `" + Te + "` supplied to " + ("`" + ke + "`" + Ze + "."));
        }
        return S(te);
      }
      function H() {
        function Z(z, Y, te, ae, De) {
          return J(z[Y]) ? null : new C("Invalid " + ae + " `" + De + "` supplied to " + ("`" + te + "`, expected a ReactNode."));
        }
        return S(Z);
      }
      function q(Z, z, Y, te, ae) {
        return new C(
          (Z || "React class") + ": " + z + " type `" + Y + "." + te + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ae + "`."
        );
      }
      function Q(Z) {
        function z(Y, te, ae, De, ke) {
          var Re = Y[te], Te = ie(Re);
          if (Te !== "object")
            return new C("Invalid " + De + " `" + ke + "` of type `" + Te + "` " + ("supplied to `" + ae + "`, expected `object`."));
          for (var we in Z) {
            var Fe = Z[we];
            if (typeof Fe != "function")
              return q(ae, De, ke, we, se(Fe));
            var Ye = Fe(Re, we, ae, De, ke + "." + we, r);
            if (Ye)
              return Ye;
          }
          return null;
        }
        return S(z);
      }
      function W(Z) {
        function z(Y, te, ae, De, ke) {
          var Re = Y[te], Te = ie(Re);
          if (Te !== "object")
            return new C("Invalid " + De + " `" + ke + "` of type `" + Te + "` " + ("supplied to `" + ae + "`, expected `object`."));
          var we = t({}, Y[te], Z);
          for (var Fe in we) {
            var Ye = Z[Fe];
            if (n(Z, Fe) && typeof Ye != "function")
              return q(ae, De, ke, Fe, se(Ye));
            if (!Ye)
              return new C(
                "Invalid " + De + " `" + ke + "` key `" + Fe + "` supplied to `" + ae + "`.\nBad object: " + JSON.stringify(Y[te], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(Z), null, "  ")
              );
            var de = Ye(Re, Fe, ae, De, ke + "." + Fe, r);
            if (de)
              return de;
          }
          return null;
        }
        return S(z);
      }
      function J(Z) {
        switch (typeof Z) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !Z;
          case "object":
            if (Array.isArray(Z))
              return Z.every(J);
            if (Z === null || c(Z))
              return !0;
            var z = y(Z);
            if (z) {
              var Y = z.call(Z), te;
              if (z !== Z.entries) {
                for (; !(te = Y.next()).done; )
                  if (!J(te.value))
                    return !1;
              } else
                for (; !(te = Y.next()).done; ) {
                  var ae = te.value;
                  if (ae && !J(ae[1]))
                    return !1;
                }
            } else
              return !1;
            return !0;
          default:
            return !1;
        }
      }
      function ne(Z, z) {
        return Z === "symbol" ? !0 : z ? z["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && z instanceof Symbol : !1;
      }
      function ie(Z) {
        var z = typeof Z;
        return Array.isArray(Z) ? "array" : Z instanceof RegExp ? "object" : ne(z, Z) ? "symbol" : z;
      }
      function se(Z) {
        if (typeof Z > "u" || Z === null)
          return "" + Z;
        var z = ie(Z);
        if (z === "object") {
          if (Z instanceof Date)
            return "date";
          if (Z instanceof RegExp)
            return "regexp";
        }
        return z;
      }
      function X(Z) {
        var z = se(Z);
        switch (z) {
          case "array":
          case "object":
            return "an " + z;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + z;
          default:
            return z;
        }
      }
      function fe(Z) {
        return !Z.constructor || !Z.constructor.name ? x : Z.constructor.name;
      }
      return w.checkPropTypes = i, w.resetWarningCache = i.resetWarningCache, w.PropTypes = w, w;
    }, k2;
  }
  var R2, Eq;
  function Jge() {
    if (Eq) return R2;
    Eq = 1;
    var e = /* @__PURE__ */ Uj();
    function t() {
    }
    function r() {
    }
    return r.resetWarningCache = t, R2 = function() {
      function n(s, c, p, h, v, y) {
        if (y !== e) {
          var x = new Error(
            "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
          );
          throw x.name = "Invariant Violation", x;
        }
      }
      n.isRequired = n;
      function i() {
        return n;
      }
      var u = {
        array: n,
        bigint: n,
        bool: n,
        func: n,
        number: n,
        object: n,
        string: n,
        symbol: n,
        any: n,
        arrayOf: i,
        element: n,
        elementType: n,
        instanceOf: i,
        node: n,
        objectOf: i,
        oneOf: i,
        oneOfType: i,
        shape: i,
        exact: i,
        checkPropTypes: r,
        resetWarningCache: t
      };
      return u.PropTypes = u, u;
    }, R2;
  }
  var Sq;
  function exe() {
    if (Sq) return vE.exports;
    if (Sq = 1, process.env.NODE_ENV !== "production") {
      var e = GW(), t = !0;
      vE.exports = /* @__PURE__ */ Zge()(e.isElement, t);
    } else
      vE.exports = /* @__PURE__ */ Jge()();
    return vE.exports;
  }
  var txe = /* @__PURE__ */ exe();
  const Hr = /* @__PURE__ */ Zr(txe);
  var rxe = Object.getOwnPropertyNames, nxe = Object.getOwnPropertySymbols, ixe = Object.prototype.hasOwnProperty;
  function _q(e, t) {
    return function(n, i, u) {
      return e(n, i, u) && t(n, i, u);
    };
  }
  function yE(e) {
    return function(r, n, i) {
      if (!r || !n || typeof r != "object" || typeof n != "object")
        return e(r, n, i);
      var u = i.cache, s = u.get(r), c = u.get(n);
      if (s && c)
        return s === n && c === r;
      u.set(r, n), u.set(n, r);
      var p = e(r, n, i);
      return u.delete(r), u.delete(n), p;
    };
  }
  function Cq(e) {
    return rxe(e).concat(nxe(e));
  }
  var axe = Object.hasOwn || function(e, t) {
    return ixe.call(e, t);
  };
  function Wp(e, t) {
    return e === t || !e && !t && e !== e && t !== t;
  }
  var oxe = "__v", uxe = "__o", sxe = "_owner", Oq = Object.getOwnPropertyDescriptor, Tq = Object.keys;
  function lxe(e, t, r) {
    var n = e.length;
    if (t.length !== n)
      return !1;
    for (; n-- > 0; )
      if (!r.equals(e[n], t[n], n, n, e, t, r))
        return !1;
    return !0;
  }
  function cxe(e, t) {
    return Wp(e.getTime(), t.getTime());
  }
  function fxe(e, t) {
    return e.name === t.name && e.message === t.message && e.cause === t.cause && e.stack === t.stack;
  }
  function dxe(e, t) {
    return e === t;
  }
  function Aq(e, t, r) {
    var n = e.size;
    if (n !== t.size)
      return !1;
    if (!n)
      return !0;
    for (var i = new Array(n), u = e.entries(), s, c, p = 0; (s = u.next()) && !s.done; ) {
      for (var h = t.entries(), v = !1, y = 0; (c = h.next()) && !c.done; ) {
        if (i[y]) {
          y++;
          continue;
        }
        var x = s.value, w = c.value;
        if (r.equals(x[0], w[0], p, y, e, t, r) && r.equals(x[1], w[1], x[0], w[0], e, t, r)) {
          v = i[y] = !0;
          break;
        }
        y++;
      }
      if (!v)
        return !1;
      p++;
    }
    return !0;
  }
  var pxe = Wp;
  function hxe(e, t, r) {
    var n = Tq(e), i = n.length;
    if (Tq(t).length !== i)
      return !1;
    for (; i-- > 0; )
      if (!KW(e, t, r, n[i]))
        return !1;
    return !0;
  }
  function _g(e, t, r) {
    var n = Cq(e), i = n.length;
    if (Cq(t).length !== i)
      return !1;
    for (var u, s, c; i-- > 0; )
      if (u = n[i], !KW(e, t, r, u) || (s = Oq(e, u), c = Oq(t, u), (s || c) && (!s || !c || s.configurable !== c.configurable || s.enumerable !== c.enumerable || s.writable !== c.writable)))
        return !1;
    return !0;
  }
  function vxe(e, t) {
    return Wp(e.valueOf(), t.valueOf());
  }
  function mxe(e, t) {
    return e.source === t.source && e.flags === t.flags;
  }
  function Dq(e, t, r) {
    var n = e.size;
    if (n !== t.size)
      return !1;
    if (!n)
      return !0;
    for (var i = new Array(n), u = e.values(), s, c; (s = u.next()) && !s.done; ) {
      for (var p = t.values(), h = !1, v = 0; (c = p.next()) && !c.done; ) {
        if (!i[v] && r.equals(s.value, c.value, s.value, c.value, e, t, r)) {
          h = i[v] = !0;
          break;
        }
        v++;
      }
      if (!h)
        return !1;
    }
    return !0;
  }
  function yxe(e, t) {
    var r = e.length;
    if (t.length !== r)
      return !1;
    for (; r-- > 0; )
      if (e[r] !== t[r])
        return !1;
    return !0;
  }
  function gxe(e, t) {
    return e.hostname === t.hostname && e.pathname === t.pathname && e.protocol === t.protocol && e.port === t.port && e.hash === t.hash && e.username === t.username && e.password === t.password;
  }
  function KW(e, t, r, n) {
    return (n === sxe || n === uxe || n === oxe) && (e.$$typeof || t.$$typeof) ? !0 : axe(t, n) && r.equals(e[n], t[n], n, n, e, t, r);
  }
  var xxe = "[object Arguments]", bxe = "[object Boolean]", wxe = "[object Date]", Exe = "[object Error]", Sxe = "[object Map]", _xe = "[object Number]", Cxe = "[object Object]", Oxe = "[object RegExp]", Txe = "[object Set]", Axe = "[object String]", Dxe = "[object URL]", kxe = Array.isArray, kq = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, Rq = Object.assign, Rxe = Object.prototype.toString.call.bind(Object.prototype.toString);
  function Pxe(e) {
    var t = e.areArraysEqual, r = e.areDatesEqual, n = e.areErrorsEqual, i = e.areFunctionsEqual, u = e.areMapsEqual, s = e.areNumbersEqual, c = e.areObjectsEqual, p = e.arePrimitiveWrappersEqual, h = e.areRegExpsEqual, v = e.areSetsEqual, y = e.areTypedArraysEqual, x = e.areUrlsEqual;
    return function(E, C, S) {
      if (E === C)
        return !0;
      if (E == null || C == null)
        return !1;
      var k = typeof E;
      if (k !== typeof C)
        return !1;
      if (k !== "object")
        return k === "number" ? s(E, C, S) : k === "function" ? i(E, C, S) : !1;
      var D = E.constructor;
      if (D !== C.constructor)
        return !1;
      if (D === Object)
        return c(E, C, S);
      if (kxe(E))
        return t(E, C, S);
      if (kq != null && kq(E))
        return y(E, C, S);
      if (D === Date)
        return r(E, C, S);
      if (D === RegExp)
        return h(E, C, S);
      if (D === Map)
        return u(E, C, S);
      if (D === Set)
        return v(E, C, S);
      var A = Rxe(E);
      return A === wxe ? r(E, C, S) : A === Oxe ? h(E, C, S) : A === Sxe ? u(E, C, S) : A === Txe ? v(E, C, S) : A === Cxe ? typeof E.then != "function" && typeof C.then != "function" && c(E, C, S) : A === Dxe ? x(E, C, S) : A === Exe ? n(E, C, S) : A === xxe ? c(E, C, S) : A === bxe || A === _xe || A === Axe ? p(E, C, S) : !1;
    };
  }
  function Mxe(e) {
    var t = e.circular, r = e.createCustomConfig, n = e.strict, i = {
      areArraysEqual: n ? _g : lxe,
      areDatesEqual: cxe,
      areErrorsEqual: fxe,
      areFunctionsEqual: dxe,
      areMapsEqual: n ? _q(Aq, _g) : Aq,
      areNumbersEqual: pxe,
      areObjectsEqual: n ? _g : hxe,
      arePrimitiveWrappersEqual: vxe,
      areRegExpsEqual: mxe,
      areSetsEqual: n ? _q(Dq, _g) : Dq,
      areTypedArraysEqual: n ? _g : yxe,
      areUrlsEqual: gxe
    };
    if (r && (i = Rq({}, i, r(i))), t) {
      var u = yE(i.areArraysEqual), s = yE(i.areMapsEqual), c = yE(i.areObjectsEqual), p = yE(i.areSetsEqual);
      i = Rq({}, i, {
        areArraysEqual: u,
        areMapsEqual: s,
        areObjectsEqual: c,
        areSetsEqual: p
      });
    }
    return i;
  }
  function Nxe(e) {
    return function(t, r, n, i, u, s, c) {
      return e(t, r, c);
    };
  }
  function jxe(e) {
    var t = e.circular, r = e.comparator, n = e.createState, i = e.equals, u = e.strict;
    if (n)
      return function(p, h) {
        var v = n(), y = v.cache, x = y === void 0 ? t ? /* @__PURE__ */ new WeakMap() : void 0 : y, w = v.meta;
        return r(p, h, {
          cache: x,
          equals: i,
          meta: w,
          strict: u
        });
      };
    if (t)
      return function(p, h) {
        return r(p, h, {
          cache: /* @__PURE__ */ new WeakMap(),
          equals: i,
          meta: void 0,
          strict: u
        });
      };
    var s = {
      cache: void 0,
      equals: i,
      meta: void 0,
      strict: u
    };
    return function(p, h) {
      return r(p, h, s);
    };
  }
  var Fxe = Zf();
  Zf({ strict: !0 });
  Zf({ circular: !0 });
  Zf({
    circular: !0,
    strict: !0
  });
  Zf({
    createInternalComparator: function() {
      return Wp;
    }
  });
  Zf({
    strict: !0,
    createInternalComparator: function() {
      return Wp;
    }
  });
  Zf({
    circular: !0,
    createInternalComparator: function() {
      return Wp;
    }
  });
  Zf({
    circular: !0,
    createInternalComparator: function() {
      return Wp;
    },
    strict: !0
  });
  function Zf(e) {
    e === void 0 && (e = {});
    var t = e.circular, r = t === void 0 ? !1 : t, n = e.createInternalComparator, i = e.createState, u = e.strict, s = u === void 0 ? !1 : u, c = Mxe(e), p = Pxe(c), h = n ? n(p) : Nxe(p);
    return jxe({ circular: r, comparator: p, createState: i, equals: h, strict: s });
  }
  function Ixe(e) {
    typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
  }
  function Pq(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = -1, n = function i(u) {
      r < 0 && (r = u), u - r > t ? (e(u), r = -1) : Ixe(i);
    };
    requestAnimationFrame(n);
  }
  function CM(e) {
    "@babel/helpers - typeof";
    return CM = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, CM(e);
  }
  function Bxe(e) {
    return qxe(e) || zxe(e) || $xe(e) || Lxe();
  }
  function Lxe() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function $xe(e, t) {
    if (e) {
      if (typeof e == "string") return Mq(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Mq(e, t);
    }
  }
  function Mq(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function zxe(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function qxe(e) {
    if (Array.isArray(e)) return e;
  }
  function Uxe() {
    var e = {}, t = function() {
      return null;
    }, r = !1, n = function i(u) {
      if (!r) {
        if (Array.isArray(u)) {
          if (!u.length)
            return;
          var s = u, c = Bxe(s), p = c[0], h = c.slice(1);
          if (typeof p == "number") {
            Pq(i.bind(null, h), p);
            return;
          }
          i(p), Pq(i.bind(null, h));
          return;
        }
        CM(u) === "object" && (e = u, t(e)), typeof u == "function" && u();
      }
    };
    return {
      stop: function() {
        r = !0;
      },
      start: function(u) {
        r = !1, n(u);
      },
      subscribe: function(u) {
        return t = u, function() {
          t = function() {
            return null;
          };
        };
      }
    };
  }
  function Ex(e) {
    "@babel/helpers - typeof";
    return Ex = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Ex(e);
  }
  function Nq(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function jq(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? Nq(Object(r), !0).forEach(function(n) {
        XW(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Nq(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function XW(e, t, r) {
    return t = Hxe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Hxe(e) {
    var t = Vxe(e, "string");
    return Ex(t) === "symbol" ? t : String(t);
  }
  function Vxe(e, t) {
    if (Ex(e) !== "object" || e === null) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Ex(n) !== "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var Wxe = function(t, r) {
    return [Object.keys(t), Object.keys(r)].reduce(function(n, i) {
      return n.filter(function(u) {
        return i.includes(u);
      });
    });
  }, Yxe = function(t) {
    return t;
  }, Gxe = function(t) {
    return t.replace(/([A-Z])/g, function(r) {
      return "-".concat(r.toLowerCase());
    });
  }, Ug = function(t, r) {
    return Object.keys(r).reduce(function(n, i) {
      return jq(jq({}, n), {}, XW({}, i, t(i, r[i])));
    }, {});
  }, Fq = function(t, r, n) {
    return t.map(function(i) {
      return "".concat(Gxe(i), " ").concat(r, "ms ").concat(n);
    }).join(",");
  }, Qxe = process.env.NODE_ENV !== "production", XS = function(t, r, n, i, u, s, c, p) {
    if (Qxe && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
      if (r === void 0)
        console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      else {
        var h = [n, i, u, s, c, p], v = 0;
        console.warn(r.replace(/%s/g, function() {
          return h[v++];
        }));
      }
  };
  function Kxe(e, t) {
    return Jxe(e) || Zxe(e, t) || ZW(e, t) || Xxe();
  }
  function Xxe() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Zxe(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, u, s, c = [], p = !0, h = !1;
      try {
        if (u = (r = r.call(e)).next, t !== 0) for (; !(p = (n = u.call(r)).done) && (c.push(n.value), c.length !== t); p = !0) ;
      } catch (v) {
        h = !0, i = v;
      } finally {
        try {
          if (!p && r.return != null && (s = r.return(), Object(s) !== s)) return;
        } finally {
          if (h) throw i;
        }
      }
      return c;
    }
  }
  function Jxe(e) {
    if (Array.isArray(e)) return e;
  }
  function ebe(e) {
    return nbe(e) || rbe(e) || ZW(e) || tbe();
  }
  function tbe() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function ZW(e, t) {
    if (e) {
      if (typeof e == "string") return OM(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return OM(e, t);
    }
  }
  function rbe(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function nbe(e) {
    if (Array.isArray(e)) return OM(e);
  }
  function OM(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  var ZS = 1e-4, JW = function(t, r) {
    return [0, 3 * t, 3 * r - 6 * t, 3 * t - 3 * r + 1];
  }, eY = function(t, r) {
    return t.map(function(n, i) {
      return n * Math.pow(r, i);
    }).reduce(function(n, i) {
      return n + i;
    });
  }, Iq = function(t, r) {
    return function(n) {
      var i = JW(t, r);
      return eY(i, n);
    };
  }, ibe = function(t, r) {
    return function(n) {
      var i = JW(t, r), u = [].concat(ebe(i.map(function(s, c) {
        return s * c;
      }).slice(1)), [0]);
      return eY(u, n);
    };
  }, Bq = function() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    var i = r[0], u = r[1], s = r[2], c = r[3];
    if (r.length === 1)
      switch (r[0]) {
        case "linear":
          i = 0, u = 0, s = 1, c = 1;
          break;
        case "ease":
          i = 0.25, u = 0.1, s = 0.25, c = 1;
          break;
        case "ease-in":
          i = 0.42, u = 0, s = 1, c = 1;
          break;
        case "ease-out":
          i = 0.42, u = 0, s = 0.58, c = 1;
          break;
        case "ease-in-out":
          i = 0, u = 0, s = 0.58, c = 1;
          break;
        default: {
          var p = r[0].split("(");
          if (p[0] === "cubic-bezier" && p[1].split(")")[0].split(",").length === 4) {
            var h = p[1].split(")")[0].split(",").map(function(S) {
              return parseFloat(S);
            }), v = Kxe(h, 4);
            i = v[0], u = v[1], s = v[2], c = v[3];
          } else
            XS(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", r);
        }
      }
    XS([i, s, u, c].every(function(S) {
      return typeof S == "number" && S >= 0 && S <= 1;
    }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", r);
    var y = Iq(i, s), x = Iq(u, c), w = ibe(i, s), E = function(k) {
      return k > 1 ? 1 : k < 0 ? 0 : k;
    }, C = function(k) {
      for (var D = k > 1 ? 1 : k, A = D, R = 0; R < 8; ++R) {
        var T = y(A) - D, M = w(A);
        if (Math.abs(T - D) < ZS || M < ZS)
          return x(A);
        A = E(A - T / M);
      }
      return x(A);
    };
    return C.isStepper = !1, C;
  }, abe = function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.stiff, n = r === void 0 ? 100 : r, i = t.damping, u = i === void 0 ? 8 : i, s = t.dt, c = s === void 0 ? 17 : s, p = function(v, y, x) {
      var w = -(v - y) * n, E = x * u, C = x + (w - E) * c / 1e3, S = x * c / 1e3 + v;
      return Math.abs(S - y) < ZS && Math.abs(C) < ZS ? [y, 0] : [S, C];
    };
    return p.isStepper = !0, p.dt = c, p;
  }, obe = function() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    var i = r[0];
    if (typeof i == "string")
      switch (i) {
        case "ease":
        case "ease-in-out":
        case "ease-out":
        case "ease-in":
        case "linear":
          return Bq(i);
        case "spring":
          return abe();
        default:
          if (i.split("(")[0] === "cubic-bezier")
            return Bq(i);
          XS(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", r);
      }
    return typeof i == "function" ? i : (XS(!1, "[configEasing]: first argument type should be function or string, instead received %s", r), null);
  };
  function Sx(e) {
    "@babel/helpers - typeof";
    return Sx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Sx(e);
  }
  function Lq(e) {
    return lbe(e) || sbe(e) || tY(e) || ube();
  }
  function ube() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function sbe(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function lbe(e) {
    if (Array.isArray(e)) return AM(e);
  }
  function $q(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function ia(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? $q(Object(r), !0).forEach(function(n) {
        TM(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : $q(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function TM(e, t, r) {
    return t = cbe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function cbe(e) {
    var t = fbe(e, "string");
    return Sx(t) === "symbol" ? t : String(t);
  }
  function fbe(e, t) {
    if (Sx(e) !== "object" || e === null) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Sx(n) !== "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function dbe(e, t) {
    return vbe(e) || hbe(e, t) || tY(e, t) || pbe();
  }
  function pbe() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function tY(e, t) {
    if (e) {
      if (typeof e == "string") return AM(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return AM(e, t);
    }
  }
  function AM(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function hbe(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, u, s, c = [], p = !0, h = !1;
      try {
        if (u = (r = r.call(e)).next, t !== 0) for (; !(p = (n = u.call(r)).done) && (c.push(n.value), c.length !== t); p = !0) ;
      } catch (v) {
        h = !0, i = v;
      } finally {
        try {
          if (!p && r.return != null && (s = r.return(), Object(s) !== s)) return;
        } finally {
          if (h) throw i;
        }
      }
      return c;
    }
  }
  function vbe(e) {
    if (Array.isArray(e)) return e;
  }
  var JS = function(t, r, n) {
    return t + (r - t) * n;
  }, DM = function(t) {
    var r = t.from, n = t.to;
    return r !== n;
  }, mbe = function e(t, r, n) {
    var i = Ug(function(u, s) {
      if (DM(s)) {
        var c = t(s.from, s.to, s.velocity), p = dbe(c, 2), h = p[0], v = p[1];
        return ia(ia({}, s), {}, {
          from: h,
          velocity: v
        });
      }
      return s;
    }, r);
    return n < 1 ? Ug(function(u, s) {
      return DM(s) ? ia(ia({}, s), {}, {
        velocity: JS(s.velocity, i[u].velocity, n),
        from: JS(s.from, i[u].from, n)
      }) : s;
    }, r) : e(t, i, n - 1);
  };
  const ybe = function(e, t, r, n, i) {
    var u = Wxe(e, t), s = u.reduce(function(S, k) {
      return ia(ia({}, S), {}, TM({}, k, [e[k], t[k]]));
    }, {}), c = u.reduce(function(S, k) {
      return ia(ia({}, S), {}, TM({}, k, {
        from: e[k],
        velocity: 0,
        to: t[k]
      }));
    }, {}), p = -1, h, v, y = function() {
      return null;
    }, x = function() {
      return Ug(function(k, D) {
        return D.from;
      }, c);
    }, w = function() {
      return !Object.values(c).filter(DM).length;
    }, E = function(k) {
      h || (h = k);
      var D = k - h, A = D / r.dt;
      c = mbe(r, c, A), i(ia(ia(ia({}, e), t), x())), h = k, w() || (p = requestAnimationFrame(y));
    }, C = function(k) {
      v || (v = k);
      var D = (k - v) / n, A = Ug(function(T, M) {
        return JS.apply(void 0, Lq(M).concat([r(D)]));
      }, s);
      if (i(ia(ia(ia({}, e), t), A)), D < 1)
        p = requestAnimationFrame(y);
      else {
        var R = Ug(function(T, M) {
          return JS.apply(void 0, Lq(M).concat([r(1)]));
        }, s);
        i(ia(ia(ia({}, e), t), R));
      }
    };
    return y = r.isStepper ? E : C, function() {
      return requestAnimationFrame(y), function() {
        cancelAnimationFrame(p);
      };
    };
  };
  function b0(e) {
    "@babel/helpers - typeof";
    return b0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, b0(e);
  }
  var gbe = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
  function xbe(e, t) {
    if (e == null) return {};
    var r = bbe(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function bbe(e, t) {
    if (e == null) return {};
    var r = {}, n = Object.keys(e), i, u;
    for (u = 0; u < n.length; u++)
      i = n[u], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
    return r;
  }
  function P2(e) {
    return _be(e) || Sbe(e) || Ebe(e) || wbe();
  }
  function wbe() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Ebe(e, t) {
    if (e) {
      if (typeof e == "string") return kM(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return kM(e, t);
    }
  }
  function Sbe(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function _be(e) {
    if (Array.isArray(e)) return kM(e);
  }
  function kM(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function zq(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function as(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? zq(Object(r), !0).forEach(function(n) {
        Ng(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : zq(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Ng(e, t, r) {
    return t = rY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Cbe(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function Obe(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, rY(n.key), n);
    }
  }
  function Tbe(e, t, r) {
    return t && Obe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function rY(e) {
    var t = Abe(e, "string");
    return b0(t) === "symbol" ? t : String(t);
  }
  function Abe(e, t) {
    if (b0(e) !== "object" || e === null) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (b0(n) !== "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Dbe(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && RM(e, t);
  }
  function RM(e, t) {
    return RM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, RM(e, t);
  }
  function kbe(e) {
    var t = Rbe();
    return function() {
      var n = e_(e), i;
      if (t) {
        var u = e_(this).constructor;
        i = Reflect.construct(n, arguments, u);
      } else
        i = n.apply(this, arguments);
      return PM(this, i);
    };
  }
  function PM(e, t) {
    if (t && (b0(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return MM(e);
  }
  function MM(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function Rbe() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function e_(e) {
    return e_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, e_(e);
  }
  var _c = /* @__PURE__ */ function(e) {
    Dbe(r, e);
    var t = kbe(r);
    function r(n, i) {
      var u;
      Cbe(this, r), u = t.call(this, n, i);
      var s = u.props, c = s.isActive, p = s.attributeName, h = s.from, v = s.to, y = s.steps, x = s.children, w = s.duration;
      if (u.handleStyleChange = u.handleStyleChange.bind(MM(u)), u.changeStyle = u.changeStyle.bind(MM(u)), !c || w <= 0)
        return u.state = {
          style: {}
        }, typeof x == "function" && (u.state = {
          style: v
        }), PM(u);
      if (y && y.length)
        u.state = {
          style: y[0].style
        };
      else if (h) {
        if (typeof x == "function")
          return u.state = {
            style: h
          }, PM(u);
        u.state = {
          style: p ? Ng({}, p, h) : h
        };
      } else
        u.state = {
          style: {}
        };
      return u;
    }
    return Tbe(r, [{
      key: "componentDidMount",
      value: function() {
        var i = this.props, u = i.isActive, s = i.canBegin;
        this.mounted = !0, !(!u || !s) && this.runAnimation(this.props);
      }
    }, {
      key: "componentDidUpdate",
      value: function(i) {
        var u = this.props, s = u.isActive, c = u.canBegin, p = u.attributeName, h = u.shouldReAnimate, v = u.to, y = u.from, x = this.state.style;
        if (c) {
          if (!s) {
            var w = {
              style: p ? Ng({}, p, v) : v
            };
            this.state && x && (p && x[p] !== v || !p && x !== v) && this.setState(w);
            return;
          }
          if (!(Fxe(i.to, v) && i.canBegin && i.isActive)) {
            var E = !i.canBegin || !i.isActive;
            this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
            var C = E || h ? y : i.to;
            if (this.state && x) {
              var S = {
                style: p ? Ng({}, p, C) : C
              };
              (p && x[p] !== C || !p && x !== C) && this.setState(S);
            }
            this.runAnimation(as(as({}, this.props), {}, {
              from: C,
              begin: 0
            }));
          }
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.mounted = !1;
        var i = this.props.onAnimationEnd;
        this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), i && i();
      }
    }, {
      key: "handleStyleChange",
      value: function(i) {
        this.changeStyle(i);
      }
    }, {
      key: "changeStyle",
      value: function(i) {
        this.mounted && this.setState({
          style: i
        });
      }
    }, {
      key: "runJSAnimation",
      value: function(i) {
        var u = this, s = i.from, c = i.to, p = i.duration, h = i.easing, v = i.begin, y = i.onAnimationEnd, x = i.onAnimationStart, w = ybe(s, c, obe(h), p, this.changeStyle), E = function() {
          u.stopJSAnimation = w();
        };
        this.manager.start([x, v, E, p, y]);
      }
    }, {
      key: "runStepAnimation",
      value: function(i) {
        var u = this, s = i.steps, c = i.begin, p = i.onAnimationStart, h = s[0], v = h.style, y = h.duration, x = y === void 0 ? 0 : y, w = function(C, S, k) {
          if (k === 0)
            return C;
          var D = S.duration, A = S.easing, R = A === void 0 ? "ease" : A, T = S.style, M = S.properties, F = S.onAnimationEnd, B = k > 0 ? s[k - 1] : S, V = M || Object.keys(T);
          if (typeof R == "function" || R === "spring")
            return [].concat(P2(C), [u.runJSAnimation.bind(u, {
              from: B.style,
              to: T,
              duration: D,
              easing: R
            }), D]);
          var H = Fq(V, D, R), q = as(as(as({}, B.style), T), {}, {
            transition: H
          });
          return [].concat(P2(C), [q, D, F]).filter(Yxe);
        };
        return this.manager.start([p].concat(P2(s.reduce(w, [v, Math.max(x, c)])), [i.onAnimationEnd]));
      }
    }, {
      key: "runAnimation",
      value: function(i) {
        this.manager || (this.manager = Uxe());
        var u = i.begin, s = i.duration, c = i.attributeName, p = i.to, h = i.easing, v = i.onAnimationStart, y = i.onAnimationEnd, x = i.steps, w = i.children, E = this.manager;
        if (this.unSubscribe = E.subscribe(this.handleStyleChange), typeof h == "function" || typeof w == "function" || h === "spring") {
          this.runJSAnimation(i);
          return;
        }
        if (x.length > 1) {
          this.runStepAnimation(i);
          return;
        }
        var C = c ? Ng({}, c, p) : p, S = Fq(Object.keys(C), s, h);
        E.start([v, u, as(as({}, C), {}, {
          transition: S
        }), s, y]);
      }
    }, {
      key: "render",
      value: function() {
        var i = this.props, u = i.children;
        i.begin;
        var s = i.duration;
        i.attributeName, i.easing;
        var c = i.isActive;
        i.steps, i.from, i.to, i.canBegin, i.onAnimationEnd, i.shouldReAnimate, i.onAnimationReStart;
        var p = xbe(i, gbe), h = ee.Children.count(u), v = this.state.style;
        if (typeof u == "function")
          return u(v);
        if (!c || h === 0 || s <= 0)
          return u;
        var y = function(w) {
          var E = w.props, C = E.style, S = C === void 0 ? {} : C, k = E.className, D = /* @__PURE__ */ ee.cloneElement(w, as(as({}, p), {}, {
            style: as(as({}, S), v),
            className: k
          }));
          return D;
        };
        return h === 1 ? y(ee.Children.only(u)) : /* @__PURE__ */ ce.createElement("div", null, ee.Children.map(u, function(x) {
          return y(x);
        }));
      }
    }]), r;
  }(ee.PureComponent);
  _c.displayName = "Animate";
  _c.defaultProps = {
    begin: 0,
    duration: 1e3,
    from: "",
    to: "",
    attributeName: "",
    easing: "ease",
    isActive: !0,
    canBegin: !0,
    steps: [],
    onAnimationEnd: function() {
    },
    onAnimationStart: function() {
    }
  };
  _c.propTypes = {
    from: Hr.oneOfType([Hr.object, Hr.string]),
    to: Hr.oneOfType([Hr.object, Hr.string]),
    attributeName: Hr.string,
    // animation duration
    duration: Hr.number,
    begin: Hr.number,
    easing: Hr.oneOfType([Hr.string, Hr.func]),
    steps: Hr.arrayOf(Hr.shape({
      duration: Hr.number.isRequired,
      style: Hr.object.isRequired,
      easing: Hr.oneOfType([Hr.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), Hr.func]),
      // transition css properties(dash case), optional
      properties: Hr.arrayOf("string"),
      onAnimationEnd: Hr.func
    })),
    children: Hr.oneOfType([Hr.node, Hr.func]),
    isActive: Hr.bool,
    canBegin: Hr.bool,
    onAnimationEnd: Hr.func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: Hr.bool,
    onAnimationStart: Hr.func,
    onAnimationReStart: Hr.func
  };
  function _x(e) {
    "@babel/helpers - typeof";
    return _x = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, _x(e);
  }
  function t_() {
    return t_ = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, t_.apply(this, arguments);
  }
  function Pbe(e, t) {
    return Fbe(e) || jbe(e, t) || Nbe(e, t) || Mbe();
  }
  function Mbe() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Nbe(e, t) {
    if (e) {
      if (typeof e == "string") return qq(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return qq(e, t);
    }
  }
  function qq(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function jbe(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, u, s, c = [], p = !0, h = !1;
      try {
        if (u = (r = r.call(e)).next, t !== 0) for (; !(p = (n = u.call(r)).done) && (c.push(n.value), c.length !== t); p = !0) ;
      } catch (v) {
        h = !0, i = v;
      } finally {
        try {
          if (!p && r.return != null && (s = r.return(), Object(s) !== s)) return;
        } finally {
          if (h) throw i;
        }
      }
      return c;
    }
  }
  function Fbe(e) {
    if (Array.isArray(e)) return e;
  }
  function Uq(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Hq(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? Uq(Object(r), !0).forEach(function(n) {
        Ibe(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Uq(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Ibe(e, t, r) {
    return t = Bbe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Bbe(e) {
    var t = Lbe(e, "string");
    return _x(t) == "symbol" ? t : t + "";
  }
  function Lbe(e, t) {
    if (_x(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (_x(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var Vq = function(t, r, n, i, u) {
    var s = Math.min(Math.abs(n) / 2, Math.abs(i) / 2), c = i >= 0 ? 1 : -1, p = n >= 0 ? 1 : -1, h = i >= 0 && n >= 0 || i < 0 && n < 0 ? 1 : 0, v;
    if (s > 0 && u instanceof Array) {
      for (var y = [0, 0, 0, 0], x = 0, w = 4; x < w; x++)
        y[x] = u[x] > s ? s : u[x];
      v = "M".concat(t, ",").concat(r + c * y[0]), y[0] > 0 && (v += "A ".concat(y[0], ",").concat(y[0], ",0,0,").concat(h, ",").concat(t + p * y[0], ",").concat(r)), v += "L ".concat(t + n - p * y[1], ",").concat(r), y[1] > 0 && (v += "A ".concat(y[1], ",").concat(y[1], ",0,0,").concat(h, `,
        `).concat(t + n, ",").concat(r + c * y[1])), v += "L ".concat(t + n, ",").concat(r + i - c * y[2]), y[2] > 0 && (v += "A ".concat(y[2], ",").concat(y[2], ",0,0,").concat(h, `,
        `).concat(t + n - p * y[2], ",").concat(r + i)), v += "L ".concat(t + p * y[3], ",").concat(r + i), y[3] > 0 && (v += "A ".concat(y[3], ",").concat(y[3], ",0,0,").concat(h, `,
        `).concat(t, ",").concat(r + i - c * y[3])), v += "Z";
    } else if (s > 0 && u === +u && u > 0) {
      var E = Math.min(s, u);
      v = "M ".concat(t, ",").concat(r + c * E, `
            A `).concat(E, ",").concat(E, ",0,0,").concat(h, ",").concat(t + p * E, ",").concat(r, `
            L `).concat(t + n - p * E, ",").concat(r, `
            A `).concat(E, ",").concat(E, ",0,0,").concat(h, ",").concat(t + n, ",").concat(r + c * E, `
            L `).concat(t + n, ",").concat(r + i - c * E, `
            A `).concat(E, ",").concat(E, ",0,0,").concat(h, ",").concat(t + n - p * E, ",").concat(r + i, `
            L `).concat(t + p * E, ",").concat(r + i, `
            A `).concat(E, ",").concat(E, ",0,0,").concat(h, ",").concat(t, ",").concat(r + i - c * E, " Z");
    } else
      v = "M ".concat(t, ",").concat(r, " h ").concat(n, " v ").concat(i, " h ").concat(-n, " Z");
    return v;
  }, $be = function(t, r) {
    if (!t || !r)
      return !1;
    var n = t.x, i = t.y, u = r.x, s = r.y, c = r.width, p = r.height;
    if (Math.abs(c) > 0 && Math.abs(p) > 0) {
      var h = Math.min(u, u + c), v = Math.max(u, u + c), y = Math.min(s, s + p), x = Math.max(s, s + p);
      return n >= h && n <= v && i >= y && i <= x;
    }
    return !1;
  }, zbe = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: !1,
    isUpdateAnimationActive: !1,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
  }, Hj = function(t) {
    var r = Hq(Hq({}, zbe), t), n = ee.useRef(), i = ee.useState(-1), u = Pbe(i, 2), s = u[0], c = u[1];
    ee.useEffect(function() {
      if (n.current && n.current.getTotalLength)
        try {
          var R = n.current.getTotalLength();
          R && c(R);
        } catch {
        }
    }, []);
    var p = r.x, h = r.y, v = r.width, y = r.height, x = r.radius, w = r.className, E = r.animationEasing, C = r.animationDuration, S = r.animationBegin, k = r.isAnimationActive, D = r.isUpdateAnimationActive;
    if (p !== +p || h !== +h || v !== +v || y !== +y || v === 0 || y === 0)
      return null;
    var A = hr("recharts-rectangle", w);
    return D ? /* @__PURE__ */ ce.createElement(_c, {
      canBegin: s > 0,
      from: {
        width: v,
        height: y,
        x: p,
        y: h
      },
      to: {
        width: v,
        height: y,
        x: p,
        y: h
      },
      duration: C,
      animationEasing: E,
      isActive: D
    }, function(R) {
      var T = R.width, M = R.height, F = R.x, B = R.y;
      return /* @__PURE__ */ ce.createElement(_c, {
        canBegin: s > 0,
        from: "0px ".concat(s === -1 ? 1 : s, "px"),
        to: "".concat(s, "px 0px"),
        attributeName: "strokeDasharray",
        begin: S,
        duration: C,
        isActive: k,
        easing: E
      }, /* @__PURE__ */ ce.createElement("path", t_({}, pr(r, !0), {
        className: A,
        d: Vq(F, B, T, M, x),
        ref: n
      })));
    }) : /* @__PURE__ */ ce.createElement("path", t_({}, pr(r, !0), {
      className: A,
      d: Vq(p, h, v, y, x)
    }));
  };
  function NM() {
    return NM = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, NM.apply(this, arguments);
  }
  var Vj = function(t) {
    var r = t.cx, n = t.cy, i = t.r, u = t.className, s = hr("recharts-dot", u);
    return r === +r && n === +n && i === +i ? /* @__PURE__ */ ce.createElement("circle", NM({}, pr(t, !1), ES(t), {
      className: s,
      cx: r,
      cy: n,
      r: i
    })) : null;
  };
  function Cx(e) {
    "@babel/helpers - typeof";
    return Cx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Cx(e);
  }
  var qbe = ["x", "y", "top", "left", "width", "height", "className"];
  function jM() {
    return jM = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, jM.apply(this, arguments);
  }
  function Wq(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Ube(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? Wq(Object(r), !0).forEach(function(n) {
        Hbe(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Wq(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Hbe(e, t, r) {
    return t = Vbe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Vbe(e) {
    var t = Wbe(e, "string");
    return Cx(t) == "symbol" ? t : t + "";
  }
  function Wbe(e, t) {
    if (Cx(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Cx(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Ybe(e, t) {
    if (e == null) return {};
    var r = Gbe(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function Gbe(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  var Qbe = function(t, r, n, i, u, s) {
    return "M".concat(t, ",").concat(u, "v").concat(i, "M").concat(s, ",").concat(r, "h").concat(n);
  }, Kbe = function(t) {
    var r = t.x, n = r === void 0 ? 0 : r, i = t.y, u = i === void 0 ? 0 : i, s = t.top, c = s === void 0 ? 0 : s, p = t.left, h = p === void 0 ? 0 : p, v = t.width, y = v === void 0 ? 0 : v, x = t.height, w = x === void 0 ? 0 : x, E = t.className, C = Ybe(t, qbe), S = Ube({
      x: n,
      y: u,
      top: c,
      left: h,
      width: y,
      height: w
    }, C);
    return !Ke(n) || !Ke(u) || !Ke(y) || !Ke(w) || !Ke(c) || !Ke(h) ? null : /* @__PURE__ */ ce.createElement("path", jM({}, pr(S, !0), {
      className: hr("recharts-cross", E),
      d: Qbe(n, u, y, w, c, h)
    }));
  }, M2, Yq;
  function Xbe() {
    if (Yq) return M2;
    Yq = 1;
    var e = bV(), t = e(Object.getPrototypeOf, Object);
    return M2 = t, M2;
  }
  var N2, Gq;
  function Zbe() {
    if (Gq) return N2;
    Gq = 1;
    var e = Oc(), t = Xbe(), r = Tc(), n = "[object Object]", i = Function.prototype, u = Object.prototype, s = i.toString, c = u.hasOwnProperty, p = s.call(Object);
    function h(v) {
      if (!r(v) || e(v) != n)
        return !1;
      var y = t(v);
      if (y === null)
        return !0;
      var x = c.call(y, "constructor") && y.constructor;
      return typeof x == "function" && x instanceof x && s.call(x) == p;
    }
    return N2 = h, N2;
  }
  var Jbe = Zbe();
  const e1e = /* @__PURE__ */ Zr(Jbe);
  var j2, Qq;
  function t1e() {
    if (Qq) return j2;
    Qq = 1;
    var e = Oc(), t = Tc(), r = "[object Boolean]";
    function n(i) {
      return i === !0 || i === !1 || t(i) && e(i) == r;
    }
    return j2 = n, j2;
  }
  var r1e = t1e();
  const n1e = /* @__PURE__ */ Zr(r1e);
  function Ox(e) {
    "@babel/helpers - typeof";
    return Ox = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Ox(e);
  }
  function r_() {
    return r_ = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, r_.apply(this, arguments);
  }
  function i1e(e, t) {
    return s1e(e) || u1e(e, t) || o1e(e, t) || a1e();
  }
  function a1e() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function o1e(e, t) {
    if (e) {
      if (typeof e == "string") return Kq(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Kq(e, t);
    }
  }
  function Kq(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function u1e(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, u, s, c = [], p = !0, h = !1;
      try {
        if (u = (r = r.call(e)).next, t !== 0) for (; !(p = (n = u.call(r)).done) && (c.push(n.value), c.length !== t); p = !0) ;
      } catch (v) {
        h = !0, i = v;
      } finally {
        try {
          if (!p && r.return != null && (s = r.return(), Object(s) !== s)) return;
        } finally {
          if (h) throw i;
        }
      }
      return c;
    }
  }
  function s1e(e) {
    if (Array.isArray(e)) return e;
  }
  function Xq(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Zq(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? Xq(Object(r), !0).forEach(function(n) {
        l1e(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Xq(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function l1e(e, t, r) {
    return t = c1e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function c1e(e) {
    var t = f1e(e, "string");
    return Ox(t) == "symbol" ? t : t + "";
  }
  function f1e(e, t) {
    if (Ox(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Ox(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var Jq = function(t, r, n, i, u) {
    var s = n - i, c;
    return c = "M ".concat(t, ",").concat(r), c += "L ".concat(t + n, ",").concat(r), c += "L ".concat(t + n - s / 2, ",").concat(r + u), c += "L ".concat(t + n - s / 2 - i, ",").concat(r + u), c += "L ".concat(t, ",").concat(r, " Z"), c;
  }, d1e = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: !1,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
  }, p1e = function(t) {
    var r = Zq(Zq({}, d1e), t), n = ee.useRef(), i = ee.useState(-1), u = i1e(i, 2), s = u[0], c = u[1];
    ee.useEffect(function() {
      if (n.current && n.current.getTotalLength)
        try {
          var A = n.current.getTotalLength();
          A && c(A);
        } catch {
        }
    }, []);
    var p = r.x, h = r.y, v = r.upperWidth, y = r.lowerWidth, x = r.height, w = r.className, E = r.animationEasing, C = r.animationDuration, S = r.animationBegin, k = r.isUpdateAnimationActive;
    if (p !== +p || h !== +h || v !== +v || y !== +y || x !== +x || v === 0 && y === 0 || x === 0)
      return null;
    var D = hr("recharts-trapezoid", w);
    return k ? /* @__PURE__ */ ce.createElement(_c, {
      canBegin: s > 0,
      from: {
        upperWidth: 0,
        lowerWidth: 0,
        height: x,
        x: p,
        y: h
      },
      to: {
        upperWidth: v,
        lowerWidth: y,
        height: x,
        x: p,
        y: h
      },
      duration: C,
      animationEasing: E,
      isActive: k
    }, function(A) {
      var R = A.upperWidth, T = A.lowerWidth, M = A.height, F = A.x, B = A.y;
      return /* @__PURE__ */ ce.createElement(_c, {
        canBegin: s > 0,
        from: "0px ".concat(s === -1 ? 1 : s, "px"),
        to: "".concat(s, "px 0px"),
        attributeName: "strokeDasharray",
        begin: S,
        duration: C,
        easing: E
      }, /* @__PURE__ */ ce.createElement("path", r_({}, pr(r, !0), {
        className: D,
        d: Jq(F, B, R, T, M),
        ref: n
      })));
    }) : /* @__PURE__ */ ce.createElement("g", null, /* @__PURE__ */ ce.createElement("path", r_({}, pr(r, !0), {
      className: D,
      d: Jq(p, h, v, y, x)
    })));
  }, h1e = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
  function Tx(e) {
    "@babel/helpers - typeof";
    return Tx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Tx(e);
  }
  function v1e(e, t) {
    if (e == null) return {};
    var r = m1e(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function m1e(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function e7(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function n_(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? e7(Object(r), !0).forEach(function(n) {
        y1e(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : e7(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function y1e(e, t, r) {
    return t = g1e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function g1e(e) {
    var t = x1e(e, "string");
    return Tx(t) == "symbol" ? t : t + "";
  }
  function x1e(e, t) {
    if (Tx(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Tx(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function b1e(e, t) {
    return n_(n_({}, t), e);
  }
  function w1e(e, t) {
    return e === "symbols";
  }
  function t7(e) {
    var t = e.shapeType, r = e.elementProps;
    switch (t) {
      case "rectangle":
        return /* @__PURE__ */ ce.createElement(Hj, r);
      case "trapezoid":
        return /* @__PURE__ */ ce.createElement(p1e, r);
      case "sector":
        return /* @__PURE__ */ ce.createElement(YW, r);
      case "symbols":
        if (w1e(t))
          return /* @__PURE__ */ ce.createElement(sj, r);
        break;
      default:
        return null;
    }
  }
  function E1e(e) {
    return /* @__PURE__ */ ee.isValidElement(e) ? e.props : e;
  }
  function S1e(e) {
    var t = e.option, r = e.shapeType, n = e.propTransformer, i = n === void 0 ? b1e : n, u = e.activeClassName, s = u === void 0 ? "recharts-active-shape" : u, c = e.isActive, p = v1e(e, h1e), h;
    if (/* @__PURE__ */ ee.isValidElement(t))
      h = /* @__PURE__ */ ee.cloneElement(t, n_(n_({}, p), E1e(t)));
    else if (er(t))
      h = t(p);
    else if (e1e(t) && !n1e(t)) {
      var v = i(t, p);
      h = /* @__PURE__ */ ce.createElement(t7, {
        shapeType: r,
        elementProps: v
      });
    } else {
      var y = p;
      h = /* @__PURE__ */ ce.createElement(t7, {
        shapeType: r,
        elementProps: y
      });
    }
    return c ? /* @__PURE__ */ ce.createElement(ei, {
      className: s
    }, h) : h;
  }
  function oC(e, t) {
    return t != null && "trapezoids" in e.props;
  }
  function uC(e, t) {
    return t != null && "sectors" in e.props;
  }
  function Ax(e, t) {
    return t != null && "points" in e.props;
  }
  function _1e(e, t) {
    var r, n, i = e.x === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.x) || e.x === t.x, u = e.y === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.y) || e.y === t.y;
    return i && u;
  }
  function C1e(e, t) {
    var r = e.endAngle === t.endAngle, n = e.startAngle === t.startAngle;
    return r && n;
  }
  function O1e(e, t) {
    var r = e.x === t.x, n = e.y === t.y, i = e.z === t.z;
    return r && n && i;
  }
  function T1e(e, t) {
    var r;
    return oC(e, t) ? r = _1e : uC(e, t) ? r = C1e : Ax(e, t) && (r = O1e), r;
  }
  function A1e(e, t) {
    var r;
    return oC(e, t) ? r = "trapezoids" : uC(e, t) ? r = "sectors" : Ax(e, t) && (r = "points"), r;
  }
  function D1e(e, t) {
    if (oC(e, t)) {
      var r;
      return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
    }
    if (uC(e, t)) {
      var n;
      return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
    }
    return Ax(e, t) ? t.payload : {};
  }
  function k1e(e) {
    var t = e.activeTooltipItem, r = e.graphicalItem, n = e.itemData, i = A1e(r, t), u = D1e(r, t), s = n.filter(function(p, h) {
      var v = nC(u, p), y = r.props[i].filter(function(E) {
        var C = T1e(r, t);
        return C(E, t);
      }), x = r.props[i].indexOf(y[y.length - 1]), w = h === x;
      return v && w;
    }), c = n.indexOf(s[s.length - 1]);
    return c;
  }
  var F2, r7;
  function R1e() {
    if (r7) return F2;
    r7 = 1;
    var e = Math.ceil, t = Math.max;
    function r(n, i, u, s) {
      for (var c = -1, p = t(e((i - n) / (u || 1)), 0), h = Array(p); p--; )
        h[s ? p : ++c] = n, n += u;
      return h;
    }
    return F2 = r, F2;
  }
  var I2, n7;
  function nY() {
    if (n7) return I2;
    n7 = 1;
    var e = FV(), t = 1 / 0, r = 17976931348623157e292;
    function n(i) {
      if (!i)
        return i === 0 ? i : 0;
      if (i = e(i), i === t || i === -1 / 0) {
        var u = i < 0 ? -1 : 1;
        return u * r;
      }
      return i === i ? i : 0;
    }
    return I2 = n, I2;
  }
  var B2, i7;
  function P1e() {
    if (i7) return B2;
    i7 = 1;
    var e = R1e(), t = G_(), r = nY();
    function n(i) {
      return function(u, s, c) {
        return c && typeof c != "number" && t(u, s, c) && (s = c = void 0), u = r(u), s === void 0 ? (s = u, u = 0) : s = r(s), c = c === void 0 ? u < s ? 1 : -1 : r(c), e(u, s, c, i);
      };
    }
    return B2 = n, B2;
  }
  var L2, a7;
  function M1e() {
    if (a7) return L2;
    a7 = 1;
    var e = P1e(), t = e();
    return L2 = t, L2;
  }
  var N1e = M1e();
  const i_ = /* @__PURE__ */ Zr(N1e);
  function Dx(e) {
    "@babel/helpers - typeof";
    return Dx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Dx(e);
  }
  function o7(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function u7(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? o7(Object(r), !0).forEach(function(n) {
        iY(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : o7(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function iY(e, t, r) {
    return t = j1e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function j1e(e) {
    var t = F1e(e, "string");
    return Dx(t) == "symbol" ? t : t + "";
  }
  function F1e(e, t) {
    if (Dx(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Dx(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var I1e = ["Webkit", "Moz", "O", "ms"], B1e = function(t, r) {
    var n = t.replace(/(\w)/, function(u) {
      return u.toUpperCase();
    }), i = I1e.reduce(function(u, s) {
      return u7(u7({}, u), {}, iY({}, s + n, r));
    }, {});
    return i[t] = r, i;
  };
  function w0(e) {
    "@babel/helpers - typeof";
    return w0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, w0(e);
  }
  function a_() {
    return a_ = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, a_.apply(this, arguments);
  }
  function s7(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function $2(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? s7(Object(r), !0).forEach(function(n) {
        Lo(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s7(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function L1e(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function l7(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, oY(n.key), n);
    }
  }
  function $1e(e, t, r) {
    return t && l7(e.prototype, t), r && l7(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function z1e(e, t, r) {
    return t = o_(t), q1e(e, aY() ? Reflect.construct(t, r || [], o_(e).constructor) : t.apply(e, r));
  }
  function q1e(e, t) {
    if (t && (w0(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return U1e(e);
  }
  function U1e(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function aY() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (aY = function() {
      return !!e;
    })();
  }
  function o_(e) {
    return o_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, o_(e);
  }
  function H1e(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && FM(e, t);
  }
  function FM(e, t) {
    return FM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, FM(e, t);
  }
  function Lo(e, t, r) {
    return t = oY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function oY(e) {
    var t = V1e(e, "string");
    return w0(t) == "symbol" ? t : t + "";
  }
  function V1e(e, t) {
    if (w0(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (w0(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var W1e = function(t) {
    var r = t.data, n = t.startIndex, i = t.endIndex, u = t.x, s = t.width, c = t.travellerWidth;
    if (!r || !r.length)
      return {};
    var p = r.length, h = zg().domain(i_(0, p)).range([u, u + s - c]), v = h.domain().map(function(y) {
      return h(y);
    });
    return {
      isTextActive: !1,
      isSlideMoving: !1,
      isTravellerMoving: !1,
      isTravellerFocused: !1,
      startX: h(n),
      endX: h(i),
      scale: h,
      scaleValues: v
    };
  }, c7 = function(t) {
    return t.changedTouches && !!t.changedTouches.length;
  }, E0 = /* @__PURE__ */ function(e) {
    function t(r) {
      var n;
      return L1e(this, t), n = z1e(this, t, [r]), Lo(n, "handleDrag", function(i) {
        n.leaveTimer && (clearTimeout(n.leaveTimer), n.leaveTimer = null), n.state.isTravellerMoving ? n.handleTravellerMove(i) : n.state.isSlideMoving && n.handleSlideDrag(i);
      }), Lo(n, "handleTouchMove", function(i) {
        i.changedTouches != null && i.changedTouches.length > 0 && n.handleDrag(i.changedTouches[0]);
      }), Lo(n, "handleDragEnd", function() {
        n.setState({
          isTravellerMoving: !1,
          isSlideMoving: !1
        }, function() {
          var i = n.props, u = i.endIndex, s = i.onDragEnd, c = i.startIndex;
          s == null || s({
            endIndex: u,
            startIndex: c
          });
        }), n.detachDragEndListener();
      }), Lo(n, "handleLeaveWrapper", function() {
        (n.state.isTravellerMoving || n.state.isSlideMoving) && (n.leaveTimer = window.setTimeout(n.handleDragEnd, n.props.leaveTimeOut));
      }), Lo(n, "handleEnterSlideOrTraveller", function() {
        n.setState({
          isTextActive: !0
        });
      }), Lo(n, "handleLeaveSlideOrTraveller", function() {
        n.setState({
          isTextActive: !1
        });
      }), Lo(n, "handleSlideDragStart", function(i) {
        var u = c7(i) ? i.changedTouches[0] : i;
        n.setState({
          isTravellerMoving: !1,
          isSlideMoving: !0,
          slideMoveStartX: u.pageX
        }), n.attachDragEndListener();
      }), n.travellerDragStartHandlers = {
        startX: n.handleTravellerDragStart.bind(n, "startX"),
        endX: n.handleTravellerDragStart.bind(n, "endX")
      }, n.state = {}, n;
    }
    return H1e(t, e), $1e(t, [{
      key: "componentWillUnmount",
      value: function() {
        this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
      }
    }, {
      key: "getIndex",
      value: function(n) {
        var i = n.startX, u = n.endX, s = this.state.scaleValues, c = this.props, p = c.gap, h = c.data, v = h.length - 1, y = Math.min(i, u), x = Math.max(i, u), w = t.getIndexInRange(s, y), E = t.getIndexInRange(s, x);
        return {
          startIndex: w - w % p,
          endIndex: E === v ? v : E - E % p
        };
      }
    }, {
      key: "getTextOfTick",
      value: function(n) {
        var i = this.props, u = i.data, s = i.tickFormatter, c = i.dataKey, p = Ho(u[n], c, n);
        return er(s) ? s(p, n) : p;
      }
    }, {
      key: "attachDragEndListener",
      value: function() {
        window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
      }
    }, {
      key: "detachDragEndListener",
      value: function() {
        window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
      }
    }, {
      key: "handleSlideDrag",
      value: function(n) {
        var i = this.state, u = i.slideMoveStartX, s = i.startX, c = i.endX, p = this.props, h = p.x, v = p.width, y = p.travellerWidth, x = p.startIndex, w = p.endIndex, E = p.onChange, C = n.pageX - u;
        C > 0 ? C = Math.min(C, h + v - y - c, h + v - y - s) : C < 0 && (C = Math.max(C, h - s, h - c));
        var S = this.getIndex({
          startX: s + C,
          endX: c + C
        });
        (S.startIndex !== x || S.endIndex !== w) && E && E(S), this.setState({
          startX: s + C,
          endX: c + C,
          slideMoveStartX: n.pageX
        });
      }
    }, {
      key: "handleTravellerDragStart",
      value: function(n, i) {
        var u = c7(i) ? i.changedTouches[0] : i;
        this.setState({
          isSlideMoving: !1,
          isTravellerMoving: !0,
          movingTravellerId: n,
          brushMoveStartX: u.pageX
        }), this.attachDragEndListener();
      }
    }, {
      key: "handleTravellerMove",
      value: function(n) {
        var i = this.state, u = i.brushMoveStartX, s = i.movingTravellerId, c = i.endX, p = i.startX, h = this.state[s], v = this.props, y = v.x, x = v.width, w = v.travellerWidth, E = v.onChange, C = v.gap, S = v.data, k = {
          startX: this.state.startX,
          endX: this.state.endX
        }, D = n.pageX - u;
        D > 0 ? D = Math.min(D, y + x - w - h) : D < 0 && (D = Math.max(D, y - h)), k[s] = h + D;
        var A = this.getIndex(k), R = A.startIndex, T = A.endIndex, M = function() {
          var B = S.length - 1;
          return s === "startX" && (c > p ? R % C === 0 : T % C === 0) || c < p && T === B || s === "endX" && (c > p ? T % C === 0 : R % C === 0) || c > p && T === B;
        };
        this.setState(Lo(Lo({}, s, h + D), "brushMoveStartX", n.pageX), function() {
          E && M() && E(A);
        });
      }
    }, {
      key: "handleTravellerMoveKeyboard",
      value: function(n, i) {
        var u = this, s = this.state, c = s.scaleValues, p = s.startX, h = s.endX, v = this.state[i], y = c.indexOf(v);
        if (y !== -1) {
          var x = y + n;
          if (!(x === -1 || x >= c.length)) {
            var w = c[x];
            i === "startX" && w >= h || i === "endX" && w <= p || this.setState(Lo({}, i, w), function() {
              u.props.onChange(u.getIndex({
                startX: u.state.startX,
                endX: u.state.endX
              }));
            });
          }
        }
      }
    }, {
      key: "renderBackground",
      value: function() {
        var n = this.props, i = n.x, u = n.y, s = n.width, c = n.height, p = n.fill, h = n.stroke;
        return /* @__PURE__ */ ce.createElement("rect", {
          stroke: h,
          fill: p,
          x: i,
          y: u,
          width: s,
          height: c
        });
      }
    }, {
      key: "renderPanorama",
      value: function() {
        var n = this.props, i = n.x, u = n.y, s = n.width, c = n.height, p = n.data, h = n.children, v = n.padding, y = ee.Children.only(h);
        return y ? /* @__PURE__ */ ce.cloneElement(y, {
          x: i,
          y: u,
          width: s,
          height: c,
          margin: v,
          compact: !0,
          data: p
        }) : null;
      }
    }, {
      key: "renderTravellerLayer",
      value: function(n, i) {
        var u, s, c = this, p = this.props, h = p.y, v = p.travellerWidth, y = p.height, x = p.traveller, w = p.ariaLabel, E = p.data, C = p.startIndex, S = p.endIndex, k = Math.max(n, this.props.x), D = $2($2({}, pr(this.props, !1)), {}, {
          x: k,
          y: h,
          width: v,
          height: y
        }), A = w || "Min value: ".concat((u = E[C]) === null || u === void 0 ? void 0 : u.name, ", Max value: ").concat((s = E[S]) === null || s === void 0 ? void 0 : s.name);
        return /* @__PURE__ */ ce.createElement(ei, {
          tabIndex: 0,
          role: "slider",
          "aria-label": A,
          "aria-valuenow": n,
          className: "recharts-brush-traveller",
          onMouseEnter: this.handleEnterSlideOrTraveller,
          onMouseLeave: this.handleLeaveSlideOrTraveller,
          onMouseDown: this.travellerDragStartHandlers[i],
          onTouchStart: this.travellerDragStartHandlers[i],
          onKeyDown: function(T) {
            ["ArrowLeft", "ArrowRight"].includes(T.key) && (T.preventDefault(), T.stopPropagation(), c.handleTravellerMoveKeyboard(T.key === "ArrowRight" ? 1 : -1, i));
          },
          onFocus: function() {
            c.setState({
              isTravellerFocused: !0
            });
          },
          onBlur: function() {
            c.setState({
              isTravellerFocused: !1
            });
          },
          style: {
            cursor: "col-resize"
          }
        }, t.renderTraveller(x, D));
      }
    }, {
      key: "renderSlide",
      value: function(n, i) {
        var u = this.props, s = u.y, c = u.height, p = u.stroke, h = u.travellerWidth, v = Math.min(n, i) + h, y = Math.max(Math.abs(i - n) - h, 0);
        return /* @__PURE__ */ ce.createElement("rect", {
          className: "recharts-brush-slide",
          onMouseEnter: this.handleEnterSlideOrTraveller,
          onMouseLeave: this.handleLeaveSlideOrTraveller,
          onMouseDown: this.handleSlideDragStart,
          onTouchStart: this.handleSlideDragStart,
          style: {
            cursor: "move"
          },
          stroke: "none",
          fill: p,
          fillOpacity: 0.2,
          x: v,
          y: s,
          width: y,
          height: c
        });
      }
    }, {
      key: "renderText",
      value: function() {
        var n = this.props, i = n.startIndex, u = n.endIndex, s = n.y, c = n.height, p = n.travellerWidth, h = n.stroke, v = this.state, y = v.startX, x = v.endX, w = 5, E = {
          pointerEvents: "none",
          fill: h
        };
        return /* @__PURE__ */ ce.createElement(ei, {
          className: "recharts-brush-texts"
        }, /* @__PURE__ */ ce.createElement(NS, a_({
          textAnchor: "end",
          verticalAnchor: "middle",
          x: Math.min(y, x) - w,
          y: s + c / 2
        }, E), this.getTextOfTick(i)), /* @__PURE__ */ ce.createElement(NS, a_({
          textAnchor: "start",
          verticalAnchor: "middle",
          x: Math.max(y, x) + p + w,
          y: s + c / 2
        }, E), this.getTextOfTick(u)));
      }
    }, {
      key: "render",
      value: function() {
        var n = this.props, i = n.data, u = n.className, s = n.children, c = n.x, p = n.y, h = n.width, v = n.height, y = n.alwaysShowText, x = this.state, w = x.startX, E = x.endX, C = x.isTextActive, S = x.isSlideMoving, k = x.isTravellerMoving, D = x.isTravellerFocused;
        if (!i || !i.length || !Ke(c) || !Ke(p) || !Ke(h) || !Ke(v) || h <= 0 || v <= 0)
          return null;
        var A = hr("recharts-brush", u), R = ce.Children.count(s) === 1, T = B1e("userSelect", "none");
        return /* @__PURE__ */ ce.createElement(ei, {
          className: A,
          onMouseLeave: this.handleLeaveWrapper,
          onTouchMove: this.handleTouchMove,
          style: T
        }, this.renderBackground(), R && this.renderPanorama(), this.renderSlide(w, E), this.renderTravellerLayer(w, "startX"), this.renderTravellerLayer(E, "endX"), (C || S || k || D || y) && this.renderText());
      }
    }], [{
      key: "renderDefaultTraveller",
      value: function(n) {
        var i = n.x, u = n.y, s = n.width, c = n.height, p = n.stroke, h = Math.floor(u + c / 2) - 1;
        return /* @__PURE__ */ ce.createElement(ce.Fragment, null, /* @__PURE__ */ ce.createElement("rect", {
          x: i,
          y: u,
          width: s,
          height: c,
          fill: p,
          stroke: "none"
        }), /* @__PURE__ */ ce.createElement("line", {
          x1: i + 1,
          y1: h,
          x2: i + s - 1,
          y2: h,
          fill: "none",
          stroke: "#fff"
        }), /* @__PURE__ */ ce.createElement("line", {
          x1: i + 1,
          y1: h + 2,
          x2: i + s - 1,
          y2: h + 2,
          fill: "none",
          stroke: "#fff"
        }));
      }
    }, {
      key: "renderTraveller",
      value: function(n, i) {
        var u;
        return /* @__PURE__ */ ce.isValidElement(n) ? u = /* @__PURE__ */ ce.cloneElement(n, i) : er(n) ? u = n(i) : u = t.renderDefaultTraveller(i), u;
      }
    }, {
      key: "getDerivedStateFromProps",
      value: function(n, i) {
        var u = n.data, s = n.width, c = n.x, p = n.travellerWidth, h = n.updateId, v = n.startIndex, y = n.endIndex;
        if (u !== i.prevData || h !== i.prevUpdateId)
          return $2({
            prevData: u,
            prevTravellerWidth: p,
            prevUpdateId: h,
            prevX: c,
            prevWidth: s
          }, u && u.length ? W1e({
            data: u,
            width: s,
            x: c,
            travellerWidth: p,
            startIndex: v,
            endIndex: y
          }) : {
            scale: null,
            scaleValues: null
          });
        if (i.scale && (s !== i.prevWidth || c !== i.prevX || p !== i.prevTravellerWidth)) {
          i.scale.range([c, c + s - p]);
          var x = i.scale.domain().map(function(w) {
            return i.scale(w);
          });
          return {
            prevData: u,
            prevTravellerWidth: p,
            prevUpdateId: h,
            prevX: c,
            prevWidth: s,
            startX: i.scale(n.startIndex),
            endX: i.scale(n.endIndex),
            scaleValues: x
          };
        }
        return null;
      }
    }, {
      key: "getIndexInRange",
      value: function(n, i) {
        for (var u = n.length, s = 0, c = u - 1; c - s > 1; ) {
          var p = Math.floor((s + c) / 2);
          n[p] > i ? c = p : s = p;
        }
        return i >= n[c] ? c : s;
      }
    }]);
  }(ee.PureComponent);
  Lo(E0, "displayName", "Brush");
  Lo(E0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: "#fff",
    stroke: "#666",
    padding: {
      top: 1,
      right: 1,
      bottom: 1,
      left: 1
    },
    leaveTimeOut: 1e3,
    alwaysShowText: !1
  });
  var z2, f7;
  function Y1e() {
    if (f7) return z2;
    f7 = 1;
    var e = vj();
    function t(r, n) {
      var i;
      return e(r, function(u, s, c) {
        return i = n(u, s, c), !i;
      }), !!i;
    }
    return z2 = t, z2;
  }
  var q2, d7;
  function G1e() {
    if (d7) return q2;
    d7 = 1;
    var e = pV(), t = Qf(), r = Y1e(), n = xo(), i = G_();
    function u(s, c, p) {
      var h = n(s) ? e : r;
      return p && i(s, c, p) && (c = void 0), h(s, t(c, 3));
    }
    return q2 = u, q2;
  }
  var Q1e = G1e();
  const K1e = /* @__PURE__ */ Zr(Q1e);
  var ll = function(t, r) {
    var n = t.alwaysShow, i = t.ifOverflow;
    return n && (i = "extendDomain"), i === r;
  }, U2, p7;
  function X1e() {
    if (p7) return U2;
    p7 = 1;
    var e = RV();
    function t(r, n, i) {
      n == "__proto__" && e ? e(r, n, {
        configurable: !0,
        enumerable: !0,
        value: i,
        writable: !0
      }) : r[n] = i;
    }
    return U2 = t, U2;
  }
  var H2, h7;
  function Z1e() {
    if (h7) return H2;
    h7 = 1;
    var e = X1e(), t = DV(), r = Qf();
    function n(i, u) {
      var s = {};
      return u = r(u, 3), t(i, function(c, p, h) {
        e(s, p, u(c, p, h));
      }), s;
    }
    return H2 = n, H2;
  }
  var J1e = Z1e();
  const ewe = /* @__PURE__ */ Zr(J1e);
  var V2, v7;
  function twe() {
    if (v7) return V2;
    v7 = 1;
    function e(t, r) {
      for (var n = -1, i = t == null ? 0 : t.length; ++n < i; )
        if (!r(t[n], n, t))
          return !1;
      return !0;
    }
    return V2 = e, V2;
  }
  var W2, m7;
  function rwe() {
    if (m7) return W2;
    m7 = 1;
    var e = vj();
    function t(r, n) {
      var i = !0;
      return e(r, function(u, s, c) {
        return i = !!n(u, s, c), i;
      }), i;
    }
    return W2 = t, W2;
  }
  var Y2, y7;
  function nwe() {
    if (y7) return Y2;
    y7 = 1;
    var e = twe(), t = rwe(), r = Qf(), n = xo(), i = G_();
    function u(s, c, p) {
      var h = n(s) ? e : t;
      return p && i(s, c, p) && (c = void 0), h(s, r(c, 3));
    }
    return Y2 = u, Y2;
  }
  var iwe = nwe();
  const uY = /* @__PURE__ */ Zr(iwe);
  var awe = ["x", "y"];
  function S0(e) {
    "@babel/helpers - typeof";
    return S0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, S0(e);
  }
  function IM() {
    return IM = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, IM.apply(this, arguments);
  }
  function g7(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Cg(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? g7(Object(r), !0).forEach(function(n) {
        owe(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : g7(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function owe(e, t, r) {
    return t = uwe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function uwe(e) {
    var t = swe(e, "string");
    return S0(t) == "symbol" ? t : t + "";
  }
  function swe(e, t) {
    if (S0(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (S0(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function lwe(e, t) {
    if (e == null) return {};
    var r = cwe(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function cwe(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function fwe(e, t) {
    var r = e.x, n = e.y, i = lwe(e, awe), u = "".concat(r), s = parseInt(u, 10), c = "".concat(n), p = parseInt(c, 10), h = "".concat(t.height || i.height), v = parseInt(h, 10), y = "".concat(t.width || i.width), x = parseInt(y, 10);
    return Cg(Cg(Cg(Cg(Cg({}, t), i), s ? {
      x: s
    } : {}), p ? {
      y: p
    } : {}), {}, {
      height: v,
      width: x,
      name: t.name,
      radius: t.radius
    });
  }
  function x7(e) {
    return /* @__PURE__ */ ce.createElement(S1e, IM({
      shapeType: "rectangle",
      propTransformer: fwe,
      activeClassName: "recharts-active-bar"
    }, e));
  }
  var dwe = function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return function(n, i) {
      if (typeof t == "number") return t;
      var u = typeof n == "number";
      return u ? t(n, i) : (u || (process.env.NODE_ENV !== "production" ? go(!1, "minPointSize callback function received a value with type of ".concat(S0(n), ". Currently only numbers are supported.")) : go()), r);
    };
  }, pwe = ["value", "background"], sY;
  function _0(e) {
    "@babel/helpers - typeof";
    return _0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, _0(e);
  }
  function hwe(e, t) {
    if (e == null) return {};
    var r = vwe(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function vwe(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function u_() {
    return u_ = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, u_.apply(this, arguments);
  }
  function b7(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function li(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? b7(Object(r), !0).forEach(function(n) {
        jf(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : b7(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function mwe(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function w7(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, cY(n.key), n);
    }
  }
  function ywe(e, t, r) {
    return t && w7(e.prototype, t), r && w7(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function gwe(e, t, r) {
    return t = s_(t), xwe(e, lY() ? Reflect.construct(t, r || [], s_(e).constructor) : t.apply(e, r));
  }
  function xwe(e, t) {
    if (t && (_0(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return bwe(e);
  }
  function bwe(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function lY() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (lY = function() {
      return !!e;
    })();
  }
  function s_(e) {
    return s_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, s_(e);
  }
  function wwe(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && BM(e, t);
  }
  function BM(e, t) {
    return BM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, BM(e, t);
  }
  function jf(e, t, r) {
    return t = cY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function cY(e) {
    var t = Ewe(e, "string");
    return _0(t) == "symbol" ? t : t + "";
  }
  function Ewe(e, t) {
    if (_0(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (_0(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var Yp = /* @__PURE__ */ function(e) {
    function t() {
      var r;
      mwe(this, t);
      for (var n = arguments.length, i = new Array(n), u = 0; u < n; u++)
        i[u] = arguments[u];
      return r = gwe(this, t, [].concat(i)), jf(r, "state", {
        isAnimationFinished: !1
      }), jf(r, "id", Hx("recharts-bar-")), jf(r, "handleAnimationEnd", function() {
        var s = r.props.onAnimationEnd;
        r.setState({
          isAnimationFinished: !0
        }), s && s();
      }), jf(r, "handleAnimationStart", function() {
        var s = r.props.onAnimationStart;
        r.setState({
          isAnimationFinished: !1
        }), s && s();
      }), r;
    }
    return wwe(t, e), ywe(t, [{
      key: "renderRectanglesStatically",
      value: function(n) {
        var i = this, u = this.props, s = u.shape, c = u.dataKey, p = u.activeIndex, h = u.activeBar, v = pr(this.props, !1);
        return n && n.map(function(y, x) {
          var w = x === p, E = w ? h : s, C = li(li(li({}, v), y), {}, {
            isActive: w,
            option: E,
            index: x,
            dataKey: c,
            onAnimationStart: i.handleAnimationStart,
            onAnimationEnd: i.handleAnimationEnd
          });
          return /* @__PURE__ */ ce.createElement(ei, u_({
            className: "recharts-bar-rectangle"
          }, SS(i.props, y, x), {
            // https://github.com/recharts/recharts/issues/5415
            // eslint-disable-next-line react/no-array-index-key
            key: "rectangle-".concat(y == null ? void 0 : y.x, "-").concat(y == null ? void 0 : y.y, "-").concat(y == null ? void 0 : y.value, "-").concat(x)
          }), /* @__PURE__ */ ce.createElement(x7, C));
        });
      }
    }, {
      key: "renderRectanglesWithAnimation",
      value: function() {
        var n = this, i = this.props, u = i.data, s = i.layout, c = i.isAnimationActive, p = i.animationBegin, h = i.animationDuration, v = i.animationEasing, y = i.animationId, x = this.state.prevData;
        return /* @__PURE__ */ ce.createElement(_c, {
          begin: p,
          duration: h,
          isActive: c,
          easing: v,
          from: {
            t: 0
          },
          to: {
            t: 1
          },
          key: "bar-".concat(y),
          onAnimationEnd: this.handleAnimationEnd,
          onAnimationStart: this.handleAnimationStart
        }, function(w) {
          var E = w.t, C = u.map(function(S, k) {
            var D = x && x[k];
            if (D) {
              var A = cs(D.x, S.x), R = cs(D.y, S.y), T = cs(D.width, S.width), M = cs(D.height, S.height);
              return li(li({}, S), {}, {
                x: A(E),
                y: R(E),
                width: T(E),
                height: M(E)
              });
            }
            if (s === "horizontal") {
              var F = cs(0, S.height), B = F(E);
              return li(li({}, S), {}, {
                y: S.y + S.height - B,
                height: B
              });
            }
            var V = cs(0, S.width), H = V(E);
            return li(li({}, S), {}, {
              width: H
            });
          });
          return /* @__PURE__ */ ce.createElement(ei, null, n.renderRectanglesStatically(C));
        });
      }
    }, {
      key: "renderRectangles",
      value: function() {
        var n = this.props, i = n.data, u = n.isAnimationActive, s = this.state.prevData;
        return u && i && i.length && (!s || !nC(s, i)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(i);
      }
    }, {
      key: "renderBackground",
      value: function() {
        var n = this, i = this.props, u = i.data, s = i.dataKey, c = i.activeIndex, p = pr(this.props.background, !1);
        return u.map(function(h, v) {
          h.value;
          var y = h.background, x = hwe(h, pwe);
          if (!y)
            return null;
          var w = li(li(li(li(li({}, x), {}, {
            fill: "#eee"
          }, y), p), SS(n.props, h, v)), {}, {
            onAnimationStart: n.handleAnimationStart,
            onAnimationEnd: n.handleAnimationEnd,
            dataKey: s,
            index: v,
            className: "recharts-bar-background-rectangle"
          });
          return /* @__PURE__ */ ce.createElement(x7, u_({
            key: "background-bar-".concat(v),
            option: n.props.background,
            isActive: v === c
          }, w));
        });
      }
    }, {
      key: "renderErrorBar",
      value: function(n, i) {
        if (this.props.isAnimationActive && !this.state.isAnimationFinished)
          return null;
        var u = this.props, s = u.data, c = u.xAxis, p = u.yAxis, h = u.layout, v = u.children, y = _u(v, Kx);
        if (!y)
          return null;
        var x = h === "vertical" ? s[0].height / 2 : s[0].width / 2, w = function(S, k) {
          var D = Array.isArray(S.value) ? S.value[1] : S.value;
          return {
            x: S.x,
            y: S.y,
            value: D,
            errorVal: Ho(S, k)
          };
        }, E = {
          clipPath: n ? "url(#clipPath-".concat(i, ")") : null
        };
        return /* @__PURE__ */ ce.createElement(ei, E, y.map(function(C) {
          return /* @__PURE__ */ ce.cloneElement(C, {
            key: "error-bar-".concat(i, "-").concat(C.props.dataKey),
            data: s,
            xAxis: c,
            yAxis: p,
            layout: h,
            offset: x,
            dataPointFormatter: w
          });
        }));
      }
    }, {
      key: "render",
      value: function() {
        var n = this.props, i = n.hide, u = n.data, s = n.className, c = n.xAxis, p = n.yAxis, h = n.left, v = n.top, y = n.width, x = n.height, w = n.isAnimationActive, E = n.background, C = n.id;
        if (i || !u || !u.length)
          return null;
        var S = this.state.isAnimationFinished, k = hr("recharts-bar", s), D = c && c.allowDataOverflow, A = p && p.allowDataOverflow, R = D || A, T = lr(C) ? this.id : C;
        return /* @__PURE__ */ ce.createElement(ei, {
          className: k
        }, D || A ? /* @__PURE__ */ ce.createElement("defs", null, /* @__PURE__ */ ce.createElement("clipPath", {
          id: "clipPath-".concat(T)
        }, /* @__PURE__ */ ce.createElement("rect", {
          x: D ? h : h - y / 2,
          y: A ? v : v - x / 2,
          width: D ? y : y * 2,
          height: A ? x : x * 2
        }))) : null, /* @__PURE__ */ ce.createElement(ei, {
          className: "recharts-bar-rectangles",
          clipPath: R ? "url(#clipPath-".concat(T, ")") : null
        }, E ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(R, T), (!w || S) && Bf.renderCallByParent(this.props, u));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(n, i) {
        return n.animationId !== i.prevAnimationId ? {
          prevAnimationId: n.animationId,
          curData: n.data,
          prevData: i.curData
        } : n.data !== i.curData ? {
          curData: n.data
        } : null;
      }
    }]);
  }(ee.PureComponent);
  sY = Yp;
  jf(Yp, "displayName", "Bar");
  jf(Yp, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: "rect",
    minPointSize: 0,
    hide: !1,
    data: [],
    layout: "vertical",
    activeBar: !1,
    isAnimationActive: !K0.isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: "ease"
  });
  jf(Yp, "getComposedData", function(e) {
    var t = e.props, r = e.item, n = e.barPosition, i = e.bandSize, u = e.xAxis, s = e.yAxis, c = e.xAxisTicks, p = e.yAxisTicks, h = e.stackedData, v = e.dataStartIndex, y = e.displayedData, x = e.offset, w = Fye(n, r);
    if (!w)
      return null;
    var E = t.layout, C = r.type.defaultProps, S = C !== void 0 ? li(li({}, C), r.props) : r.props, k = S.dataKey, D = S.children, A = S.minPointSize, R = E === "horizontal" ? s : u, T = h ? R.scale.domain() : null, M = Hye({
      numericAxis: R
    }), F = _u(D, BV), B = y.map(function(V, H) {
      var q, Q, W, J, ne, ie;
      h ? q = Iye(h[v + H], T) : (q = Ho(V, k), Array.isArray(q) || (q = [M, q]));
      var se = dwe(A, sY.defaultProps.minPointSize)(q[1], H);
      if (E === "horizontal") {
        var X, fe = [s.scale(q[0]), s.scale(q[1])], Z = fe[0], z = fe[1];
        Q = Xz({
          axis: u,
          ticks: c,
          bandSize: i,
          offset: w.offset,
          entry: V,
          index: H
        }), W = (X = z ?? Z) !== null && X !== void 0 ? X : void 0, J = w.size;
        var Y = Z - z;
        if (ne = Number.isNaN(Y) ? 0 : Y, ie = {
          x: Q,
          y: s.y,
          width: J,
          height: s.height
        }, Math.abs(se) > 0 && Math.abs(ne) < Math.abs(se)) {
          var te = ds(ne || se) * (Math.abs(se) - Math.abs(ne));
          W -= te, ne += te;
        }
      } else {
        var ae = [u.scale(q[0]), u.scale(q[1])], De = ae[0], ke = ae[1];
        if (Q = De, W = Xz({
          axis: s,
          ticks: p,
          bandSize: i,
          offset: w.offset,
          entry: V,
          index: H
        }), J = ke - De, ne = w.size, ie = {
          x: u.x,
          y: W,
          width: u.width,
          height: ne
        }, Math.abs(se) > 0 && Math.abs(J) < Math.abs(se)) {
          var Re = ds(J || se) * (Math.abs(se) - Math.abs(J));
          J += Re;
        }
      }
      return li(li(li({}, V), {}, {
        x: Q,
        y: W,
        width: J,
        height: ne,
        value: h ? q : q[1],
        payload: V,
        background: ie
      }, F && F[H] && F[H].props), {}, {
        tooltipPayload: [HW(r, V)],
        tooltipPosition: {
          x: Q + J / 2,
          y: W + ne / 2
        }
      });
    });
    return li({
      data: B,
      layout: E
    }, x);
  });
  function kx(e) {
    "@babel/helpers - typeof";
    return kx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, kx(e);
  }
  function Swe(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function E7(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, fY(n.key), n);
    }
  }
  function _we(e, t, r) {
    return t && E7(e.prototype, t), r && E7(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function S7(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function us(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? S7(Object(r), !0).forEach(function(n) {
        sC(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : S7(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function sC(e, t, r) {
    return t = fY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function fY(e) {
    var t = Cwe(e, "string");
    return kx(t) == "symbol" ? t : t + "";
  }
  function Cwe(e, t) {
    if (kx(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (kx(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var dY = function(t, r, n, i, u) {
    var s = t.width, c = t.height, p = t.layout, h = t.children, v = Object.keys(r), y = {
      left: n.left,
      leftMirror: n.left,
      right: s - n.right,
      rightMirror: s - n.right,
      top: n.top,
      topMirror: n.top,
      bottom: c - n.bottom,
      bottomMirror: c - n.bottom
    }, x = !!$o(h, Yp);
    return v.reduce(function(w, E) {
      var C = r[E], S = C.orientation, k = C.domain, D = C.padding, A = D === void 0 ? {} : D, R = C.mirror, T = C.reversed, M = "".concat(S).concat(R ? "Mirror" : ""), F, B, V, H, q;
      if (C.type === "number" && (C.padding === "gap" || C.padding === "no-gap")) {
        var Q = k[1] - k[0], W = 1 / 0, J = C.categoricalDomain.sort(gce);
        if (J.forEach(function(ae, De) {
          De > 0 && (W = Math.min((ae || 0) - (J[De - 1] || 0), W));
        }), Number.isFinite(W)) {
          var ne = W / Q, ie = C.layout === "vertical" ? n.height : n.width;
          if (C.padding === "gap" && (F = ne * ie / 2), C.padding === "no-gap") {
            var se = Ip(t.barCategoryGap, ne * ie), X = ne * ie / 2;
            F = X - se - (X - se) / ie * se;
          }
        }
      }
      i === "xAxis" ? B = [n.left + (A.left || 0) + (F || 0), n.left + n.width - (A.right || 0) - (F || 0)] : i === "yAxis" ? B = p === "horizontal" ? [n.top + n.height - (A.bottom || 0), n.top + (A.top || 0)] : [n.top + (A.top || 0) + (F || 0), n.top + n.height - (A.bottom || 0) - (F || 0)] : B = C.range, T && (B = [B[1], B[0]]);
      var fe = Nye(C, u, x), Z = fe.scale, z = fe.realScaleType;
      Z.domain(k).range(B), jye(Z);
      var Y = Uye(Z, us(us({}, C), {}, {
        realScaleType: z
      }));
      i === "xAxis" ? (q = S === "top" && !R || S === "bottom" && R, V = n.left, H = y[M] - q * C.height) : i === "yAxis" && (q = S === "left" && !R || S === "right" && R, V = y[M] - q * C.width, H = n.top);
      var te = us(us(us({}, C), Y), {}, {
        realScaleType: z,
        x: V,
        y: H,
        scale: Z,
        width: i === "xAxis" ? n.width : C.width,
        height: i === "yAxis" ? n.height : C.height
      });
      return te.bandSize = GS(te, Y), !C.hide && i === "xAxis" ? y[M] += (q ? -1 : 1) * te.height : C.hide || (y[M] += (q ? -1 : 1) * te.width), us(us({}, w), {}, sC({}, E, te));
    }, {});
  }, pY = function(t, r) {
    var n = t.x, i = t.y, u = r.x, s = r.y;
    return {
      x: Math.min(n, u),
      y: Math.min(i, s),
      width: Math.abs(u - n),
      height: Math.abs(s - i)
    };
  }, Owe = function(t) {
    var r = t.x1, n = t.y1, i = t.x2, u = t.y2;
    return pY({
      x: r,
      y: n
    }, {
      x: i,
      y: u
    });
  }, hY = /* @__PURE__ */ function() {
    function e(t) {
      Swe(this, e), this.scale = t;
    }
    return _we(e, [{
      key: "domain",
      get: function() {
        return this.scale.domain;
      }
    }, {
      key: "range",
      get: function() {
        return this.scale.range;
      }
    }, {
      key: "rangeMin",
      get: function() {
        return this.range()[0];
      }
    }, {
      key: "rangeMax",
      get: function() {
        return this.range()[1];
      }
    }, {
      key: "bandwidth",
      get: function() {
        return this.scale.bandwidth;
      }
    }, {
      key: "apply",
      value: function(r) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = n.bandAware, u = n.position;
        if (r !== void 0) {
          if (u)
            switch (u) {
              case "start":
                return this.scale(r);
              case "middle": {
                var s = this.bandwidth ? this.bandwidth() / 2 : 0;
                return this.scale(r) + s;
              }
              case "end": {
                var c = this.bandwidth ? this.bandwidth() : 0;
                return this.scale(r) + c;
              }
              default:
                return this.scale(r);
            }
          if (i) {
            var p = this.bandwidth ? this.bandwidth() / 2 : 0;
            return this.scale(r) + p;
          }
          return this.scale(r);
        }
      }
    }, {
      key: "isInRange",
      value: function(r) {
        var n = this.range(), i = n[0], u = n[n.length - 1];
        return i <= u ? r >= i && r <= u : r >= u && r <= i;
      }
    }], [{
      key: "create",
      value: function(r) {
        return new e(r);
      }
    }]);
  }();
  sC(hY, "EPS", 1e-4);
  var Wj = function(t) {
    var r = Object.keys(t).reduce(function(n, i) {
      return us(us({}, n), {}, sC({}, i, hY.create(t[i])));
    }, {});
    return us(us({}, r), {}, {
      apply: function(i) {
        var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = u.bandAware, c = u.position;
        return ewe(i, function(p, h) {
          return r[h].apply(p, {
            bandAware: s,
            position: c
          });
        });
      },
      isInRange: function(i) {
        return uY(i, function(u, s) {
          return r[s].isInRange(u);
        });
      }
    });
  };
  function Twe(e) {
    return (e % 180 + 180) % 180;
  }
  var Awe = function(t) {
    var r = t.width, n = t.height, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, u = Twe(i), s = u * Math.PI / 180, c = Math.atan(n / r), p = s > c && s < Math.PI - c ? n / Math.sin(s) : r / Math.cos(s);
    return Math.abs(p);
  }, G2, _7;
  function Dwe() {
    if (_7) return G2;
    _7 = 1;
    var e = Qf(), t = Vx(), r = W_();
    function n(i) {
      return function(u, s, c) {
        var p = Object(u);
        if (!t(u)) {
          var h = e(s, 3);
          u = r(u), s = function(y) {
            return h(p[y], y, p);
          };
        }
        var v = i(u, s, c);
        return v > -1 ? p[h ? u[v] : v] : void 0;
      };
    }
    return G2 = n, G2;
  }
  var Q2, C7;
  function kwe() {
    if (C7) return Q2;
    C7 = 1;
    var e = nY();
    function t(r) {
      var n = e(r), i = n % 1;
      return n === n ? i ? n - i : n : 0;
    }
    return Q2 = t, Q2;
  }
  var K2, O7;
  function Rwe() {
    if (O7) return K2;
    O7 = 1;
    var e = _V(), t = Qf(), r = kwe(), n = Math.max;
    function i(u, s, c) {
      var p = u == null ? 0 : u.length;
      if (!p)
        return -1;
      var h = c == null ? 0 : r(c);
      return h < 0 && (h = n(p + h, 0)), e(u, t(s, 3), h);
    }
    return K2 = i, K2;
  }
  var X2, T7;
  function Pwe() {
    if (T7) return X2;
    T7 = 1;
    var e = Dwe(), t = Rwe(), r = e(t);
    return X2 = r, X2;
  }
  var Mwe = Pwe();
  const Nwe = /* @__PURE__ */ Zr(Mwe);
  var jwe = $H();
  const Fwe = /* @__PURE__ */ Zr(jwe);
  var Iwe = Fwe(function(e) {
    return {
      x: e.left,
      y: e.top,
      width: e.width,
      height: e.height
    };
  }, function(e) {
    return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
  });
  function l_(e) {
    "@babel/helpers - typeof";
    return l_ = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, l_(e);
  }
  var Yj = /* @__PURE__ */ ee.createContext(void 0), Gj = /* @__PURE__ */ ee.createContext(void 0), vY = /* @__PURE__ */ ee.createContext(void 0), mY = /* @__PURE__ */ ee.createContext({}), yY = /* @__PURE__ */ ee.createContext(void 0), gY = /* @__PURE__ */ ee.createContext(0), xY = /* @__PURE__ */ ee.createContext(0), A7 = function(t) {
    var r = t.state, n = r.xAxisMap, i = r.yAxisMap, u = r.offset, s = t.clipPathId, c = t.children, p = t.width, h = t.height, v = Iwe(u);
    return /* @__PURE__ */ ce.createElement(Yj.Provider, {
      value: n
    }, /* @__PURE__ */ ce.createElement(Gj.Provider, {
      value: i
    }, /* @__PURE__ */ ce.createElement(mY.Provider, {
      value: u
    }, /* @__PURE__ */ ce.createElement(vY.Provider, {
      value: v
    }, /* @__PURE__ */ ce.createElement(yY.Provider, {
      value: s
    }, /* @__PURE__ */ ce.createElement(gY.Provider, {
      value: h
    }, /* @__PURE__ */ ce.createElement(xY.Provider, {
      value: p
    }, c)))))));
  }, Bwe = function() {
    return ee.useContext(yY);
  };
  function bY(e) {
    var t = Object.keys(e);
    return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
  }
  var wY = function(t) {
    var r = ee.useContext(Yj);
    r == null && (process.env.NODE_ENV !== "production" ? go(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : go());
    var n = r[t];
    return n == null && (process.env.NODE_ENV !== "production" ? go(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(l_(t), "]. ").concat(bY(r))) : go()), n;
  }, Lwe = function() {
    var t = ee.useContext(Yj);
    return Nf(t);
  }, $we = function() {
    var t = ee.useContext(Gj), r = Nwe(t, function(n) {
      return uY(n.domain, Number.isFinite);
    });
    return r || Nf(t);
  }, EY = function(t) {
    var r = ee.useContext(Gj);
    r == null && (process.env.NODE_ENV !== "production" ? go(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : go());
    var n = r[t];
    return n == null && (process.env.NODE_ENV !== "production" ? go(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(l_(t), "]. ").concat(bY(r))) : go()), n;
  }, zwe = function() {
    var t = ee.useContext(vY);
    return t;
  }, qwe = function() {
    return ee.useContext(mY);
  }, Qj = function() {
    return ee.useContext(xY);
  }, Kj = function() {
    return ee.useContext(gY);
  };
  function C0(e) {
    "@babel/helpers - typeof";
    return C0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, C0(e);
  }
  function Uwe(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function Hwe(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, _Y(n.key), n);
    }
  }
  function Vwe(e, t, r) {
    return t && Hwe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function Wwe(e, t, r) {
    return t = c_(t), Ywe(e, SY() ? Reflect.construct(t, r || [], c_(e).constructor) : t.apply(e, r));
  }
  function Ywe(e, t) {
    if (t && (C0(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return Gwe(e);
  }
  function Gwe(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function SY() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (SY = function() {
      return !!e;
    })();
  }
  function c_(e) {
    return c_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, c_(e);
  }
  function Qwe(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && LM(e, t);
  }
  function LM(e, t) {
    return LM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, LM(e, t);
  }
  function D7(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function k7(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? D7(Object(r), !0).forEach(function(n) {
        Xj(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : D7(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Xj(e, t, r) {
    return t = _Y(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function _Y(e) {
    var t = Kwe(e, "string");
    return C0(t) == "symbol" ? t : t + "";
  }
  function Kwe(e, t) {
    if (C0(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (C0(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  function Xwe(e, t) {
    return tEe(e) || eEe(e, t) || Jwe(e, t) || Zwe();
  }
  function Zwe() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Jwe(e, t) {
    if (e) {
      if (typeof e == "string") return R7(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return R7(e, t);
    }
  }
  function R7(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function eEe(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, u, s, c = [], p = !0, h = !1;
      try {
        if (u = (r = r.call(e)).next, t !== 0) for (; !(p = (n = u.call(r)).done) && (c.push(n.value), c.length !== t); p = !0) ;
      } catch (v) {
        h = !0, i = v;
      } finally {
        try {
          if (!p && r.return != null && (s = r.return(), Object(s) !== s)) return;
        } finally {
          if (h) throw i;
        }
      }
      return c;
    }
  }
  function tEe(e) {
    if (Array.isArray(e)) return e;
  }
  function $M() {
    return $M = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, $M.apply(this, arguments);
  }
  var rEe = function(t, r) {
    var n;
    return /* @__PURE__ */ ce.isValidElement(t) ? n = /* @__PURE__ */ ce.cloneElement(t, r) : er(t) ? n = t(r) : n = /* @__PURE__ */ ce.createElement("line", $M({}, r, {
      className: "recharts-reference-line-line"
    })), n;
  }, nEe = function(t, r, n, i, u, s, c, p, h) {
    var v = u.x, y = u.y, x = u.width, w = u.height;
    if (n) {
      var E = h.y, C = t.y.apply(E, {
        position: s
      });
      if (ll(h, "discard") && !t.y.isInRange(C))
        return null;
      var S = [{
        x: v + x,
        y: C
      }, {
        x: v,
        y: C
      }];
      return p === "left" ? S.reverse() : S;
    }
    if (r) {
      var k = h.x, D = t.x.apply(k, {
        position: s
      });
      if (ll(h, "discard") && !t.x.isInRange(D))
        return null;
      var A = [{
        x: D,
        y: y + w
      }, {
        x: D,
        y
      }];
      return c === "top" ? A.reverse() : A;
    }
    if (i) {
      var R = h.segment, T = R.map(function(M) {
        return t.apply(M, {
          position: s
        });
      });
      return ll(h, "discard") && K1e(T, function(M) {
        return !t.isInRange(M);
      }) ? null : T;
    }
    return null;
  };
  function iEe(e) {
    var t = e.x, r = e.y, n = e.segment, i = e.xAxisId, u = e.yAxisId, s = e.shape, c = e.className, p = e.alwaysShow, h = Bwe(), v = wY(i), y = EY(u), x = zwe();
    if (!h || !x)
      return null;
    mc(p === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var w = Wj({
      x: v.scale,
      y: y.scale
    }), E = ki(t), C = ki(r), S = n && n.length === 2, k = nEe(w, E, C, S, x, e.position, v.orientation, y.orientation, e);
    if (!k)
      return null;
    var D = Xwe(k, 2), A = D[0], R = A.x, T = A.y, M = D[1], F = M.x, B = M.y, V = ll(e, "hidden") ? "url(#".concat(h, ")") : void 0, H = k7(k7({
      clipPath: V
    }, pr(e, !0)), {}, {
      x1: R,
      y1: T,
      x2: F,
      y2: B
    });
    return /* @__PURE__ */ ce.createElement(ei, {
      className: hr("recharts-reference-line", c)
    }, rEe(s, H), Ta.renderCallByParent(e, Owe({
      x1: R,
      y1: T,
      x2: F,
      y2: B
    })));
  }
  var Zj = /* @__PURE__ */ function(e) {
    function t() {
      return Uwe(this, t), Wwe(this, t, arguments);
    }
    return Qwe(t, e), Vwe(t, [{
      key: "render",
      value: function() {
        return /* @__PURE__ */ ce.createElement(iEe, this.props);
      }
    }]);
  }(ce.Component);
  Xj(Zj, "displayName", "ReferenceLine");
  Xj(Zj, "defaultProps", {
    isFront: !1,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    fill: "none",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1,
    position: "middle"
  });
  function zM() {
    return zM = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, zM.apply(this, arguments);
  }
  function O0(e) {
    "@babel/helpers - typeof";
    return O0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, O0(e);
  }
  function P7(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function M7(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? P7(Object(r), !0).forEach(function(n) {
        lC(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : P7(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function aEe(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function oEe(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, OY(n.key), n);
    }
  }
  function uEe(e, t, r) {
    return t && oEe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function sEe(e, t, r) {
    return t = f_(t), lEe(e, CY() ? Reflect.construct(t, r || [], f_(e).constructor) : t.apply(e, r));
  }
  function lEe(e, t) {
    if (t && (O0(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return cEe(e);
  }
  function cEe(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function CY() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (CY = function() {
      return !!e;
    })();
  }
  function f_(e) {
    return f_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, f_(e);
  }
  function fEe(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && qM(e, t);
  }
  function qM(e, t) {
    return qM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, qM(e, t);
  }
  function lC(e, t, r) {
    return t = OY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function OY(e) {
    var t = dEe(e, "string");
    return O0(t) == "symbol" ? t : t + "";
  }
  function dEe(e, t) {
    if (O0(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (O0(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var pEe = function(t) {
    var r = t.x, n = t.y, i = t.xAxis, u = t.yAxis, s = Wj({
      x: i.scale,
      y: u.scale
    }), c = s.apply({
      x: r,
      y: n
    }, {
      bandAware: !0
    });
    return ll(t, "discard") && !s.isInRange(c) ? null : c;
  }, cC = /* @__PURE__ */ function(e) {
    function t() {
      return aEe(this, t), sEe(this, t, arguments);
    }
    return fEe(t, e), uEe(t, [{
      key: "render",
      value: function() {
        var n = this.props, i = n.x, u = n.y, s = n.r, c = n.alwaysShow, p = n.clipPathId, h = ki(i), v = ki(u);
        if (mc(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !h || !v)
          return null;
        var y = pEe(this.props);
        if (!y)
          return null;
        var x = y.x, w = y.y, E = this.props, C = E.shape, S = E.className, k = ll(this.props, "hidden") ? "url(#".concat(p, ")") : void 0, D = M7(M7({
          clipPath: k
        }, pr(this.props, !0)), {}, {
          cx: x,
          cy: w
        });
        return /* @__PURE__ */ ce.createElement(ei, {
          className: hr("recharts-reference-dot", S)
        }, t.renderDot(C, D), Ta.renderCallByParent(this.props, {
          x: x - s,
          y: w - s,
          width: 2 * s,
          height: 2 * s
        }));
      }
    }]);
  }(ce.Component);
  lC(cC, "displayName", "ReferenceDot");
  lC(cC, "defaultProps", {
    isFront: !1,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#fff",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1
  });
  lC(cC, "renderDot", function(e, t) {
    var r;
    return /* @__PURE__ */ ce.isValidElement(e) ? r = /* @__PURE__ */ ce.cloneElement(e, t) : er(e) ? r = e(t) : r = /* @__PURE__ */ ce.createElement(Vj, zM({}, t, {
      cx: t.cx,
      cy: t.cy,
      className: "recharts-reference-dot-dot"
    })), r;
  });
  function UM() {
    return UM = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, UM.apply(this, arguments);
  }
  function T0(e) {
    "@babel/helpers - typeof";
    return T0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, T0(e);
  }
  function N7(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function j7(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? N7(Object(r), !0).forEach(function(n) {
        fC(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : N7(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function hEe(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function vEe(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, AY(n.key), n);
    }
  }
  function mEe(e, t, r) {
    return t && vEe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function yEe(e, t, r) {
    return t = d_(t), gEe(e, TY() ? Reflect.construct(t, r || [], d_(e).constructor) : t.apply(e, r));
  }
  function gEe(e, t) {
    if (t && (T0(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return xEe(e);
  }
  function xEe(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function TY() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (TY = function() {
      return !!e;
    })();
  }
  function d_(e) {
    return d_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, d_(e);
  }
  function bEe(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && HM(e, t);
  }
  function HM(e, t) {
    return HM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, HM(e, t);
  }
  function fC(e, t, r) {
    return t = AY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function AY(e) {
    var t = wEe(e, "string");
    return T0(t) == "symbol" ? t : t + "";
  }
  function wEe(e, t) {
    if (T0(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (T0(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var EEe = function(t, r, n, i, u) {
    var s = u.x1, c = u.x2, p = u.y1, h = u.y2, v = u.xAxis, y = u.yAxis;
    if (!v || !y) return null;
    var x = Wj({
      x: v.scale,
      y: y.scale
    }), w = {
      x: t ? x.x.apply(s, {
        position: "start"
      }) : x.x.rangeMin,
      y: n ? x.y.apply(p, {
        position: "start"
      }) : x.y.rangeMin
    }, E = {
      x: r ? x.x.apply(c, {
        position: "end"
      }) : x.x.rangeMax,
      y: i ? x.y.apply(h, {
        position: "end"
      }) : x.y.rangeMax
    };
    return ll(u, "discard") && (!x.isInRange(w) || !x.isInRange(E)) ? null : pY(w, E);
  }, dC = /* @__PURE__ */ function(e) {
    function t() {
      return hEe(this, t), yEe(this, t, arguments);
    }
    return bEe(t, e), mEe(t, [{
      key: "render",
      value: function() {
        var n = this.props, i = n.x1, u = n.x2, s = n.y1, c = n.y2, p = n.className, h = n.alwaysShow, v = n.clipPathId;
        mc(h === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
        var y = ki(i), x = ki(u), w = ki(s), E = ki(c), C = this.props.shape;
        if (!y && !x && !w && !E && !C)
          return null;
        var S = EEe(y, x, w, E, this.props);
        if (!S && !C)
          return null;
        var k = ll(this.props, "hidden") ? "url(#".concat(v, ")") : void 0;
        return /* @__PURE__ */ ce.createElement(ei, {
          className: hr("recharts-reference-area", p)
        }, t.renderRect(C, j7(j7({
          clipPath: k
        }, pr(this.props, !0)), S)), Ta.renderCallByParent(this.props, S));
      }
    }]);
  }(ce.Component);
  fC(dC, "displayName", "ReferenceArea");
  fC(dC, "defaultProps", {
    isFront: !1,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#ccc",
    fillOpacity: 0.5,
    stroke: "none",
    strokeWidth: 1
  });
  fC(dC, "renderRect", function(e, t) {
    var r;
    return /* @__PURE__ */ ce.isValidElement(e) ? r = /* @__PURE__ */ ce.cloneElement(e, t) : er(e) ? r = e(t) : r = /* @__PURE__ */ ce.createElement(Hj, UM({}, t, {
      className: "recharts-reference-area-rect"
    })), r;
  });
  function DY(e, t, r) {
    if (t < 1)
      return [];
    if (t === 1 && r === void 0)
      return e;
    for (var n = [], i = 0; i < e.length; i += t)
      n.push(e[i]);
    return n;
  }
  function SEe(e, t, r) {
    var n = {
      width: e.width + t.width,
      height: e.height + t.height
    };
    return Awe(n, r);
  }
  function _Ee(e, t, r) {
    var n = r === "width", i = e.x, u = e.y, s = e.width, c = e.height;
    return t === 1 ? {
      start: n ? i : u,
      end: n ? i + s : u + c
    } : {
      start: n ? i + s : u + c,
      end: n ? i : u
    };
  }
  function p_(e, t, r, n, i) {
    if (e * t < e * n || e * t > e * i)
      return !1;
    var u = r();
    return e * (t - e * u / 2 - n) >= 0 && e * (t + e * u / 2 - i) <= 0;
  }
  function CEe(e, t) {
    return DY(e, t + 1);
  }
  function OEe(e, t, r, n, i) {
    for (var u = (n || []).slice(), s = t.start, c = t.end, p = 0, h = 1, v = s, y = function() {
      var E = n == null ? void 0 : n[p];
      if (E === void 0)
        return {
          v: DY(n, h)
        };
      var C = p, S, k = function() {
        return S === void 0 && (S = r(E, C)), S;
      }, D = E.coordinate, A = p === 0 || p_(e, D, k, v, c);
      A || (p = 0, v = s, h += 1), A && (v = D + e * (k() / 2 + i), p += h);
    }, x; h <= u.length; )
      if (x = y(), x) return x.v;
    return [];
  }
  function Rx(e) {
    "@babel/helpers - typeof";
    return Rx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Rx(e);
  }
  function F7(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Oa(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? F7(Object(r), !0).forEach(function(n) {
        TEe(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : F7(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function TEe(e, t, r) {
    return t = AEe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function AEe(e) {
    var t = DEe(e, "string");
    return Rx(t) == "symbol" ? t : t + "";
  }
  function DEe(e, t) {
    if (Rx(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Rx(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function kEe(e, t, r, n, i) {
    for (var u = (n || []).slice(), s = u.length, c = t.start, p = t.end, h = function(x) {
      var w = u[x], E, C = function() {
        return E === void 0 && (E = r(w, x)), E;
      };
      if (x === s - 1) {
        var S = e * (w.coordinate + e * C() / 2 - p);
        u[x] = w = Oa(Oa({}, w), {}, {
          tickCoord: S > 0 ? w.coordinate - S * e : w.coordinate
        });
      } else
        u[x] = w = Oa(Oa({}, w), {}, {
          tickCoord: w.coordinate
        });
      var k = p_(e, w.tickCoord, C, c, p);
      k && (p = w.tickCoord - e * (C() / 2 + i), u[x] = Oa(Oa({}, w), {}, {
        isShow: !0
      }));
    }, v = s - 1; v >= 0; v--)
      h(v);
    return u;
  }
  function REe(e, t, r, n, i, u) {
    var s = (n || []).slice(), c = s.length, p = t.start, h = t.end;
    if (u) {
      var v = n[c - 1], y = r(v, c - 1), x = e * (v.coordinate + e * y / 2 - h);
      s[c - 1] = v = Oa(Oa({}, v), {}, {
        tickCoord: x > 0 ? v.coordinate - x * e : v.coordinate
      });
      var w = p_(e, v.tickCoord, function() {
        return y;
      }, p, h);
      w && (h = v.tickCoord - e * (y / 2 + i), s[c - 1] = Oa(Oa({}, v), {}, {
        isShow: !0
      }));
    }
    for (var E = u ? c - 1 : c, C = function(D) {
      var A = s[D], R, T = function() {
        return R === void 0 && (R = r(A, D)), R;
      };
      if (D === 0) {
        var M = e * (A.coordinate - e * T() / 2 - p);
        s[D] = A = Oa(Oa({}, A), {}, {
          tickCoord: M < 0 ? A.coordinate - M * e : A.coordinate
        });
      } else
        s[D] = A = Oa(Oa({}, A), {}, {
          tickCoord: A.coordinate
        });
      var F = p_(e, A.tickCoord, T, p, h);
      F && (p = A.tickCoord + e * (T() / 2 + i), s[D] = Oa(Oa({}, A), {}, {
        isShow: !0
      }));
    }, S = 0; S < E; S++)
      C(S);
    return s;
  }
  function Jj(e, t, r) {
    var n = e.tick, i = e.ticks, u = e.viewBox, s = e.minTickGap, c = e.orientation, p = e.interval, h = e.tickFormatter, v = e.unit, y = e.angle;
    if (!i || !i.length || !n)
      return [];
    if (Ke(p) || K0.isSsr)
      return CEe(i, typeof p == "number" && Ke(p) ? p : 0);
    var x = [], w = c === "top" || c === "bottom" ? "width" : "height", E = v && w === "width" ? $g(v, {
      fontSize: t,
      letterSpacing: r
    }) : {
      width: 0,
      height: 0
    }, C = function(A, R) {
      var T = er(h) ? h(A.value, R) : A.value;
      return w === "width" ? SEe($g(T, {
        fontSize: t,
        letterSpacing: r
      }), E, y) : $g(T, {
        fontSize: t,
        letterSpacing: r
      })[w];
    }, S = i.length >= 2 ? ds(i[1].coordinate - i[0].coordinate) : 1, k = _Ee(u, S, w);
    return p === "equidistantPreserveStart" ? OEe(S, k, C, i, s) : (p === "preserveStart" || p === "preserveStartEnd" ? x = REe(S, k, C, i, s, p === "preserveStartEnd") : x = kEe(S, k, C, i, s), x.filter(function(D) {
      return D.isShow;
    }));
  }
  var PEe = ["viewBox"], MEe = ["viewBox"], NEe = ["ticks"];
  function A0(e) {
    "@babel/helpers - typeof";
    return A0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, A0(e);
  }
  function Gv() {
    return Gv = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Gv.apply(this, arguments);
  }
  function I7(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Va(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? I7(Object(r), !0).forEach(function(n) {
        eF(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : I7(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Z2(e, t) {
    if (e == null) return {};
    var r = jEe(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function jEe(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function FEe(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function B7(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, RY(n.key), n);
    }
  }
  function IEe(e, t, r) {
    return t && B7(e.prototype, t), r && B7(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function BEe(e, t, r) {
    return t = h_(t), LEe(e, kY() ? Reflect.construct(t, r || [], h_(e).constructor) : t.apply(e, r));
  }
  function LEe(e, t) {
    if (t && (A0(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return $Ee(e);
  }
  function $Ee(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function kY() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (kY = function() {
      return !!e;
    })();
  }
  function h_(e) {
    return h_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, h_(e);
  }
  function zEe(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && VM(e, t);
  }
  function VM(e, t) {
    return VM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, VM(e, t);
  }
  function eF(e, t, r) {
    return t = RY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function RY(e) {
    var t = qEe(e, "string");
    return A0(t) == "symbol" ? t : t + "";
  }
  function qEe(e, t) {
    if (A0(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (A0(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var em = /* @__PURE__ */ function(e) {
    function t(r) {
      var n;
      return FEe(this, t), n = BEe(this, t, [r]), n.state = {
        fontSize: "",
        letterSpacing: ""
      }, n;
    }
    return zEe(t, e), IEe(t, [{
      key: "shouldComponentUpdate",
      value: function(n, i) {
        var u = n.viewBox, s = Z2(n, PEe), c = this.props, p = c.viewBox, h = Z2(c, MEe);
        return !e0(u, p) || !e0(s, h) || !e0(i, this.state);
      }
    }, {
      key: "componentDidMount",
      value: function() {
        var n = this.layerReference;
        if (n) {
          var i = n.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
          i && this.setState({
            fontSize: window.getComputedStyle(i).fontSize,
            letterSpacing: window.getComputedStyle(i).letterSpacing
          });
        }
      }
      /**
       * Calculate the coordinates of endpoints in ticks
       * @param  {Object} data The data of a simple tick
       * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
       *  (x2, y2): The coordinate of endpoint close to axis
       */
    }, {
      key: "getTickLineCoord",
      value: function(n) {
        var i = this.props, u = i.x, s = i.y, c = i.width, p = i.height, h = i.orientation, v = i.tickSize, y = i.mirror, x = i.tickMargin, w, E, C, S, k, D, A = y ? -1 : 1, R = n.tickSize || v, T = Ke(n.tickCoord) ? n.tickCoord : n.coordinate;
        switch (h) {
          case "top":
            w = E = n.coordinate, S = s + +!y * p, C = S - A * R, D = C - A * x, k = T;
            break;
          case "left":
            C = S = n.coordinate, E = u + +!y * c, w = E - A * R, k = w - A * x, D = T;
            break;
          case "right":
            C = S = n.coordinate, E = u + +y * c, w = E + A * R, k = w + A * x, D = T;
            break;
          default:
            w = E = n.coordinate, S = s + +y * p, C = S + A * R, D = C + A * x, k = T;
            break;
        }
        return {
          line: {
            x1: w,
            y1: C,
            x2: E,
            y2: S
          },
          tick: {
            x: k,
            y: D
          }
        };
      }
    }, {
      key: "getTickTextAnchor",
      value: function() {
        var n = this.props, i = n.orientation, u = n.mirror, s;
        switch (i) {
          case "left":
            s = u ? "start" : "end";
            break;
          case "right":
            s = u ? "end" : "start";
            break;
          default:
            s = "middle";
            break;
        }
        return s;
      }
    }, {
      key: "getTickVerticalAnchor",
      value: function() {
        var n = this.props, i = n.orientation, u = n.mirror, s = "end";
        switch (i) {
          case "left":
          case "right":
            s = "middle";
            break;
          case "top":
            s = u ? "start" : "end";
            break;
          default:
            s = u ? "end" : "start";
            break;
        }
        return s;
      }
    }, {
      key: "renderAxisLine",
      value: function() {
        var n = this.props, i = n.x, u = n.y, s = n.width, c = n.height, p = n.orientation, h = n.mirror, v = n.axisLine, y = Va(Va(Va({}, pr(this.props, !1)), pr(v, !1)), {}, {
          fill: "none"
        });
        if (p === "top" || p === "bottom") {
          var x = +(p === "top" && !h || p === "bottom" && h);
          y = Va(Va({}, y), {}, {
            x1: i,
            y1: u + x * c,
            x2: i + s,
            y2: u + x * c
          });
        } else {
          var w = +(p === "left" && !h || p === "right" && h);
          y = Va(Va({}, y), {}, {
            x1: i + w * s,
            y1: u,
            x2: i + w * s,
            y2: u + c
          });
        }
        return /* @__PURE__ */ ce.createElement("line", Gv({}, y, {
          className: hr("recharts-cartesian-axis-line", Su(v, "className"))
        }));
      }
    }, {
      key: "renderTicks",
      value: (
        /**
         * render the ticks
         * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
         * @param {string} fontSize Fontsize to consider for tick spacing
         * @param {string} letterSpacing Letterspacing to consider for tick spacing
         * @return {ReactComponent} renderedTicks
         */
        function(n, i, u) {
          var s = this, c = this.props, p = c.tickLine, h = c.stroke, v = c.tick, y = c.tickFormatter, x = c.unit, w = Jj(Va(Va({}, this.props), {}, {
            ticks: n
          }), i, u), E = this.getTickTextAnchor(), C = this.getTickVerticalAnchor(), S = pr(this.props, !1), k = pr(v, !1), D = Va(Va({}, S), {}, {
            fill: "none"
          }, pr(p, !1)), A = w.map(function(R, T) {
            var M = s.getTickLineCoord(R), F = M.line, B = M.tick, V = Va(Va(Va(Va({
              textAnchor: E,
              verticalAnchor: C
            }, S), {}, {
              stroke: "none",
              fill: h
            }, k), B), {}, {
              index: T,
              payload: R,
              visibleTicksCount: w.length,
              tickFormatter: y
            });
            return /* @__PURE__ */ ce.createElement(ei, Gv({
              className: "recharts-cartesian-axis-tick",
              key: "tick-".concat(R.value, "-").concat(R.coordinate, "-").concat(R.tickCoord)
            }, SS(s.props, R, T)), p && /* @__PURE__ */ ce.createElement("line", Gv({}, D, F, {
              className: hr("recharts-cartesian-axis-tick-line", Su(p, "className"))
            })), v && t.renderTickItem(v, V, "".concat(er(y) ? y(R.value, T) : R.value).concat(x || "")));
          });
          return /* @__PURE__ */ ce.createElement("g", {
            className: "recharts-cartesian-axis-ticks"
          }, A);
        }
      )
    }, {
      key: "render",
      value: function() {
        var n = this, i = this.props, u = i.axisLine, s = i.width, c = i.height, p = i.ticksGenerator, h = i.className, v = i.hide;
        if (v)
          return null;
        var y = this.props, x = y.ticks, w = Z2(y, NEe), E = x;
        return er(p) && (E = x && x.length > 0 ? p(this.props) : p(w)), s <= 0 || c <= 0 || !E || !E.length ? null : /* @__PURE__ */ ce.createElement(ei, {
          className: hr("recharts-cartesian-axis", h),
          ref: function(S) {
            n.layerReference = S;
          }
        }, u && this.renderAxisLine(), this.renderTicks(E, this.state.fontSize, this.state.letterSpacing), Ta.renderCallByParent(this.props));
      }
    }], [{
      key: "renderTickItem",
      value: function(n, i, u) {
        var s;
        return /* @__PURE__ */ ce.isValidElement(n) ? s = /* @__PURE__ */ ce.cloneElement(n, i) : er(n) ? s = n(i) : s = /* @__PURE__ */ ce.createElement(NS, Gv({}, i, {
          className: "recharts-cartesian-axis-tick-value"
        }), u), s;
      }
    }]);
  }(ee.Component);
  eF(em, "displayName", "CartesianAxis");
  eF(em, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    },
    // The orientation of axis
    orientation: "bottom",
    // The ticks
    ticks: [],
    stroke: "#666",
    tickLine: !0,
    axisLine: !0,
    tick: !0,
    mirror: !1,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: "preserveEnd"
  });
  var UEe = ["x1", "y1", "x2", "y2", "key"], HEe = ["offset"];
  function Lp(e) {
    "@babel/helpers - typeof";
    return Lp = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Lp(e);
  }
  function L7(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Aa(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? L7(Object(r), !0).forEach(function(n) {
        VEe(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : L7(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function VEe(e, t, r) {
    return t = WEe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function WEe(e) {
    var t = YEe(e, "string");
    return Lp(t) == "symbol" ? t : t + "";
  }
  function YEe(e, t) {
    if (Lp(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Lp(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Dp() {
    return Dp = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Dp.apply(this, arguments);
  }
  function $7(e, t) {
    if (e == null) return {};
    var r = GEe(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function GEe(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  var QEe = function(t) {
    var r = t.fill;
    if (!r || r === "none")
      return null;
    var n = t.fillOpacity, i = t.x, u = t.y, s = t.width, c = t.height, p = t.ry;
    return /* @__PURE__ */ ce.createElement("rect", {
      x: i,
      y: u,
      ry: p,
      width: s,
      height: c,
      stroke: "none",
      fill: r,
      fillOpacity: n,
      className: "recharts-cartesian-grid-bg"
    });
  };
  function PY(e, t) {
    var r;
    if (/* @__PURE__ */ ce.isValidElement(e))
      r = /* @__PURE__ */ ce.cloneElement(e, t);
    else if (er(e))
      r = e(t);
    else {
      var n = t.x1, i = t.y1, u = t.x2, s = t.y2, c = t.key, p = $7(t, UEe), h = pr(p, !1);
      h.offset;
      var v = $7(h, HEe);
      r = /* @__PURE__ */ ce.createElement("line", Dp({}, v, {
        x1: n,
        y1: i,
        x2: u,
        y2: s,
        fill: "none",
        key: c
      }));
    }
    return r;
  }
  function KEe(e) {
    var t = e.x, r = e.width, n = e.horizontal, i = n === void 0 ? !0 : n, u = e.horizontalPoints;
    if (!i || !u || !u.length)
      return null;
    var s = u.map(function(c, p) {
      var h = Aa(Aa({}, e), {}, {
        x1: t,
        y1: c,
        x2: t + r,
        y2: c,
        key: "line-".concat(p),
        index: p
      });
      return PY(i, h);
    });
    return /* @__PURE__ */ ce.createElement("g", {
      className: "recharts-cartesian-grid-horizontal"
    }, s);
  }
  function XEe(e) {
    var t = e.y, r = e.height, n = e.vertical, i = n === void 0 ? !0 : n, u = e.verticalPoints;
    if (!i || !u || !u.length)
      return null;
    var s = u.map(function(c, p) {
      var h = Aa(Aa({}, e), {}, {
        x1: c,
        y1: t,
        x2: c,
        y2: t + r,
        key: "line-".concat(p),
        index: p
      });
      return PY(i, h);
    });
    return /* @__PURE__ */ ce.createElement("g", {
      className: "recharts-cartesian-grid-vertical"
    }, s);
  }
  function ZEe(e) {
    var t = e.horizontalFill, r = e.fillOpacity, n = e.x, i = e.y, u = e.width, s = e.height, c = e.horizontalPoints, p = e.horizontal, h = p === void 0 ? !0 : p;
    if (!h || !t || !t.length)
      return null;
    var v = c.map(function(x) {
      return Math.round(x + i - i);
    }).sort(function(x, w) {
      return x - w;
    });
    i !== v[0] && v.unshift(0);
    var y = v.map(function(x, w) {
      var E = !v[w + 1], C = E ? i + s - x : v[w + 1] - x;
      if (C <= 0)
        return null;
      var S = w % t.length;
      return /* @__PURE__ */ ce.createElement("rect", {
        key: "react-".concat(w),
        y: x,
        x: n,
        height: C,
        width: u,
        stroke: "none",
        fill: t[S],
        fillOpacity: r,
        className: "recharts-cartesian-grid-bg"
      });
    });
    return /* @__PURE__ */ ce.createElement("g", {
      className: "recharts-cartesian-gridstripes-horizontal"
    }, y);
  }
  function JEe(e) {
    var t = e.vertical, r = t === void 0 ? !0 : t, n = e.verticalFill, i = e.fillOpacity, u = e.x, s = e.y, c = e.width, p = e.height, h = e.verticalPoints;
    if (!r || !n || !n.length)
      return null;
    var v = h.map(function(x) {
      return Math.round(x + u - u);
    }).sort(function(x, w) {
      return x - w;
    });
    u !== v[0] && v.unshift(0);
    var y = v.map(function(x, w) {
      var E = !v[w + 1], C = E ? u + c - x : v[w + 1] - x;
      if (C <= 0)
        return null;
      var S = w % n.length;
      return /* @__PURE__ */ ce.createElement("rect", {
        key: "react-".concat(w),
        x,
        y: s,
        width: C,
        height: p,
        stroke: "none",
        fill: n[S],
        fillOpacity: i,
        className: "recharts-cartesian-grid-bg"
      });
    });
    return /* @__PURE__ */ ce.createElement("g", {
      className: "recharts-cartesian-gridstripes-vertical"
    }, y);
  }
  var eSe = function(t, r) {
    var n = t.xAxis, i = t.width, u = t.height, s = t.offset;
    return qW(Jj(Aa(Aa(Aa({}, em.defaultProps), n), {}, {
      ticks: pc(n, !0),
      viewBox: {
        x: 0,
        y: 0,
        width: i,
        height: u
      }
    })), s.left, s.left + s.width, r);
  }, tSe = function(t, r) {
    var n = t.yAxis, i = t.width, u = t.height, s = t.offset;
    return qW(Jj(Aa(Aa(Aa({}, em.defaultProps), n), {}, {
      ticks: pc(n, !0),
      viewBox: {
        x: 0,
        y: 0,
        width: i,
        height: u
      }
    })), s.top, s.top + s.height, r);
  }, Iv = {
    horizontal: !0,
    vertical: !0,
    stroke: "#ccc",
    fill: "none",
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
  };
  function MY(e) {
    var t, r, n, i, u, s, c = Qj(), p = Kj(), h = qwe(), v = Aa(Aa({}, e), {}, {
      stroke: (t = e.stroke) !== null && t !== void 0 ? t : Iv.stroke,
      fill: (r = e.fill) !== null && r !== void 0 ? r : Iv.fill,
      horizontal: (n = e.horizontal) !== null && n !== void 0 ? n : Iv.horizontal,
      horizontalFill: (i = e.horizontalFill) !== null && i !== void 0 ? i : Iv.horizontalFill,
      vertical: (u = e.vertical) !== null && u !== void 0 ? u : Iv.vertical,
      verticalFill: (s = e.verticalFill) !== null && s !== void 0 ? s : Iv.verticalFill,
      x: Ke(e.x) ? e.x : h.left,
      y: Ke(e.y) ? e.y : h.top,
      width: Ke(e.width) ? e.width : h.width,
      height: Ke(e.height) ? e.height : h.height
    }), y = v.x, x = v.y, w = v.width, E = v.height, C = v.syncWithTicks, S = v.horizontalValues, k = v.verticalValues, D = Lwe(), A = $we();
    if (!Ke(w) || w <= 0 || !Ke(E) || E <= 0 || !Ke(y) || y !== +y || !Ke(x) || x !== +x)
      return null;
    var R = v.verticalCoordinatesGenerator || eSe, T = v.horizontalCoordinatesGenerator || tSe, M = v.horizontalPoints, F = v.verticalPoints;
    if ((!M || !M.length) && er(T)) {
      var B = S && S.length, V = T({
        yAxis: A ? Aa(Aa({}, A), {}, {
          ticks: B ? S : A.ticks
        }) : void 0,
        width: c,
        height: p,
        offset: h
      }, B ? !0 : C);
      mc(Array.isArray(V), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(Lp(V), "]")), Array.isArray(V) && (M = V);
    }
    if ((!F || !F.length) && er(R)) {
      var H = k && k.length, q = R({
        xAxis: D ? Aa(Aa({}, D), {}, {
          ticks: H ? k : D.ticks
        }) : void 0,
        width: c,
        height: p,
        offset: h
      }, H ? !0 : C);
      mc(Array.isArray(q), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(Lp(q), "]")), Array.isArray(q) && (F = q);
    }
    return /* @__PURE__ */ ce.createElement("g", {
      className: "recharts-cartesian-grid"
    }, /* @__PURE__ */ ce.createElement(QEe, {
      fill: v.fill,
      fillOpacity: v.fillOpacity,
      x: v.x,
      y: v.y,
      width: v.width,
      height: v.height,
      ry: v.ry
    }), /* @__PURE__ */ ce.createElement(KEe, Dp({}, v, {
      offset: h,
      horizontalPoints: M,
      xAxis: D,
      yAxis: A
    })), /* @__PURE__ */ ce.createElement(XEe, Dp({}, v, {
      offset: h,
      verticalPoints: F,
      xAxis: D,
      yAxis: A
    })), /* @__PURE__ */ ce.createElement(ZEe, Dp({}, v, {
      horizontalPoints: M
    })), /* @__PURE__ */ ce.createElement(JEe, Dp({}, v, {
      verticalPoints: F
    })));
  }
  MY.displayName = "CartesianGrid";
  var rSe = ["type", "layout", "connectNulls", "ref"], nSe = ["key"];
  function D0(e) {
    "@babel/helpers - typeof";
    return D0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, D0(e);
  }
  function z7(e, t) {
    if (e == null) return {};
    var r = iSe(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function iSe(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function Hg() {
    return Hg = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Hg.apply(this, arguments);
  }
  function q7(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Bo(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? q7(Object(r), !0).forEach(function(n) {
        ss(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : q7(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Bv(e) {
    return sSe(e) || uSe(e) || oSe(e) || aSe();
  }
  function aSe() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function oSe(e, t) {
    if (e) {
      if (typeof e == "string") return WM(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return WM(e, t);
    }
  }
  function uSe(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function sSe(e) {
    if (Array.isArray(e)) return WM(e);
  }
  function WM(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function lSe(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function U7(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, jY(n.key), n);
    }
  }
  function cSe(e, t, r) {
    return t && U7(e.prototype, t), r && U7(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function fSe(e, t, r) {
    return t = v_(t), dSe(e, NY() ? Reflect.construct(t, r || [], v_(e).constructor) : t.apply(e, r));
  }
  function dSe(e, t) {
    if (t && (D0(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return pSe(e);
  }
  function pSe(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function NY() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (NY = function() {
      return !!e;
    })();
  }
  function v_(e) {
    return v_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, v_(e);
  }
  function hSe(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && YM(e, t);
  }
  function YM(e, t) {
    return YM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, YM(e, t);
  }
  function ss(e, t, r) {
    return t = jY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function jY(e) {
    var t = vSe(e, "string");
    return D0(t) == "symbol" ? t : t + "";
  }
  function vSe(e, t) {
    if (D0(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (D0(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var k0 = /* @__PURE__ */ function(e) {
    function t() {
      var r;
      lSe(this, t);
      for (var n = arguments.length, i = new Array(n), u = 0; u < n; u++)
        i[u] = arguments[u];
      return r = fSe(this, t, [].concat(i)), ss(r, "state", {
        isAnimationFinished: !0,
        totalLength: 0
      }), ss(r, "generateSimpleStrokeDasharray", function(s, c) {
        return "".concat(c, "px ").concat(s - c, "px");
      }), ss(r, "getStrokeDasharray", function(s, c, p) {
        var h = p.reduce(function(k, D) {
          return k + D;
        });
        if (!h)
          return r.generateSimpleStrokeDasharray(c, s);
        for (var v = Math.floor(s / h), y = s % h, x = c - s, w = [], E = 0, C = 0; E < p.length; C += p[E], ++E)
          if (C + p[E] > y) {
            w = [].concat(Bv(p.slice(0, E)), [y - C]);
            break;
          }
        var S = w.length % 2 === 0 ? [0, x] : [x];
        return [].concat(Bv(t.repeat(p, v)), Bv(w), S).map(function(k) {
          return "".concat(k, "px");
        }).join(", ");
      }), ss(r, "id", Hx("recharts-line-")), ss(r, "pathRef", function(s) {
        r.mainCurve = s;
      }), ss(r, "handleAnimationEnd", function() {
        r.setState({
          isAnimationFinished: !0
        }), r.props.onAnimationEnd && r.props.onAnimationEnd();
      }), ss(r, "handleAnimationStart", function() {
        r.setState({
          isAnimationFinished: !1
        }), r.props.onAnimationStart && r.props.onAnimationStart();
      }), r;
    }
    return hSe(t, e), cSe(t, [{
      key: "componentDidMount",
      value: function() {
        if (this.props.isAnimationActive) {
          var n = this.getTotalLength();
          this.setState({
            totalLength: n
          });
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function() {
        if (this.props.isAnimationActive) {
          var n = this.getTotalLength();
          n !== this.state.totalLength && this.setState({
            totalLength: n
          });
        }
      }
    }, {
      key: "getTotalLength",
      value: function() {
        var n = this.mainCurve;
        try {
          return n && n.getTotalLength && n.getTotalLength() || 0;
        } catch {
          return 0;
        }
      }
    }, {
      key: "renderErrorBar",
      value: function(n, i) {
        if (this.props.isAnimationActive && !this.state.isAnimationFinished)
          return null;
        var u = this.props, s = u.points, c = u.xAxis, p = u.yAxis, h = u.layout, v = u.children, y = _u(v, Kx);
        if (!y)
          return null;
        var x = function(C, S) {
          return {
            x: C.x,
            y: C.y,
            value: C.value,
            errorVal: Ho(C.payload, S)
          };
        }, w = {
          clipPath: n ? "url(#clipPath-".concat(i, ")") : null
        };
        return /* @__PURE__ */ ce.createElement(ei, w, y.map(function(E) {
          return /* @__PURE__ */ ce.cloneElement(E, {
            key: "bar-".concat(E.props.dataKey),
            data: s,
            xAxis: c,
            yAxis: p,
            layout: h,
            dataPointFormatter: x
          });
        }));
      }
    }, {
      key: "renderDots",
      value: function(n, i, u) {
        var s = this.props.isAnimationActive;
        if (s && !this.state.isAnimationFinished)
          return null;
        var c = this.props, p = c.dot, h = c.points, v = c.dataKey, y = pr(this.props, !1), x = pr(p, !0), w = h.map(function(C, S) {
          var k = Bo(Bo(Bo({
            key: "dot-".concat(S),
            r: 3
          }, y), x), {}, {
            index: S,
            cx: C.x,
            cy: C.y,
            value: C.value,
            dataKey: v,
            payload: C.payload,
            points: h
          });
          return t.renderDotItem(p, k);
        }), E = {
          clipPath: n ? "url(#clipPath-".concat(i ? "" : "dots-").concat(u, ")") : null
        };
        return /* @__PURE__ */ ce.createElement(ei, Hg({
          className: "recharts-line-dots",
          key: "dots"
        }, E), w);
      }
    }, {
      key: "renderCurveStatically",
      value: function(n, i, u, s) {
        var c = this.props, p = c.type, h = c.layout, v = c.connectNulls;
        c.ref;
        var y = z7(c, rSe), x = Bo(Bo(Bo({}, pr(y, !0)), {}, {
          fill: "none",
          className: "recharts-line-curve",
          clipPath: i ? "url(#clipPath-".concat(u, ")") : null,
          points: n
        }, s), {}, {
          type: p,
          layout: h,
          connectNulls: v
        });
        return /* @__PURE__ */ ce.createElement(_M, Hg({}, x, {
          pathRef: this.pathRef
        }));
      }
    }, {
      key: "renderCurveWithAnimation",
      value: function(n, i) {
        var u = this, s = this.props, c = s.points, p = s.strokeDasharray, h = s.isAnimationActive, v = s.animationBegin, y = s.animationDuration, x = s.animationEasing, w = s.animationId, E = s.animateNewValues, C = s.width, S = s.height, k = this.state, D = k.prevPoints, A = k.totalLength;
        return /* @__PURE__ */ ce.createElement(_c, {
          begin: v,
          duration: y,
          isActive: h,
          easing: x,
          from: {
            t: 0
          },
          to: {
            t: 1
          },
          key: "line-".concat(w),
          onAnimationEnd: this.handleAnimationEnd,
          onAnimationStart: this.handleAnimationStart
        }, function(R) {
          var T = R.t;
          if (D) {
            var M = D.length / c.length, F = c.map(function(Q, W) {
              var J = Math.floor(W * M);
              if (D[J]) {
                var ne = D[J], ie = cs(ne.x, Q.x), se = cs(ne.y, Q.y);
                return Bo(Bo({}, Q), {}, {
                  x: ie(T),
                  y: se(T)
                });
              }
              if (E) {
                var X = cs(C * 2, Q.x), fe = cs(S / 2, Q.y);
                return Bo(Bo({}, Q), {}, {
                  x: X(T),
                  y: fe(T)
                });
              }
              return Bo(Bo({}, Q), {}, {
                x: Q.x,
                y: Q.y
              });
            });
            return u.renderCurveStatically(F, n, i);
          }
          var B = cs(0, A), V = B(T), H;
          if (p) {
            var q = "".concat(p).split(/[,\s]+/gim).map(function(Q) {
              return parseFloat(Q);
            });
            H = u.getStrokeDasharray(V, A, q);
          } else
            H = u.generateSimpleStrokeDasharray(A, V);
          return u.renderCurveStatically(c, n, i, {
            strokeDasharray: H
          });
        });
      }
    }, {
      key: "renderCurve",
      value: function(n, i) {
        var u = this.props, s = u.points, c = u.isAnimationActive, p = this.state, h = p.prevPoints, v = p.totalLength;
        return c && s && s.length && (!h && v > 0 || !nC(h, s)) ? this.renderCurveWithAnimation(n, i) : this.renderCurveStatically(s, n, i);
      }
    }, {
      key: "render",
      value: function() {
        var n, i = this.props, u = i.hide, s = i.dot, c = i.points, p = i.className, h = i.xAxis, v = i.yAxis, y = i.top, x = i.left, w = i.width, E = i.height, C = i.isAnimationActive, S = i.id;
        if (u || !c || !c.length)
          return null;
        var k = this.state.isAnimationFinished, D = c.length === 1, A = hr("recharts-line", p), R = h && h.allowDataOverflow, T = v && v.allowDataOverflow, M = R || T, F = lr(S) ? this.id : S, B = (n = pr(s, !1)) !== null && n !== void 0 ? n : {
          r: 3,
          strokeWidth: 2
        }, V = B.r, H = V === void 0 ? 3 : V, q = B.strokeWidth, Q = q === void 0 ? 2 : q, W = Tce(s) ? s : {}, J = W.clipDot, ne = J === void 0 ? !0 : J, ie = H * 2 + Q;
        return /* @__PURE__ */ ce.createElement(ei, {
          className: A
        }, R || T ? /* @__PURE__ */ ce.createElement("defs", null, /* @__PURE__ */ ce.createElement("clipPath", {
          id: "clipPath-".concat(F)
        }, /* @__PURE__ */ ce.createElement("rect", {
          x: R ? x : x - w / 2,
          y: T ? y : y - E / 2,
          width: R ? w : w * 2,
          height: T ? E : E * 2
        })), !ne && /* @__PURE__ */ ce.createElement("clipPath", {
          id: "clipPath-dots-".concat(F)
        }, /* @__PURE__ */ ce.createElement("rect", {
          x: x - ie / 2,
          y: y - ie / 2,
          width: w + ie,
          height: E + ie
        }))) : null, !D && this.renderCurve(M, F), this.renderErrorBar(M, F), (D || s) && this.renderDots(M, ne, F), (!C || k) && Bf.renderCallByParent(this.props, c));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(n, i) {
        return n.animationId !== i.prevAnimationId ? {
          prevAnimationId: n.animationId,
          curPoints: n.points,
          prevPoints: i.curPoints
        } : n.points !== i.curPoints ? {
          curPoints: n.points
        } : null;
      }
    }, {
      key: "repeat",
      value: function(n, i) {
        for (var u = n.length % 2 !== 0 ? [].concat(Bv(n), [0]) : n, s = [], c = 0; c < i; ++c)
          s = [].concat(Bv(s), Bv(u));
        return s;
      }
    }, {
      key: "renderDotItem",
      value: function(n, i) {
        var u;
        if (/* @__PURE__ */ ce.isValidElement(n))
          u = /* @__PURE__ */ ce.cloneElement(n, i);
        else if (er(n))
          u = n(i);
        else {
          var s = i.key, c = z7(i, nSe), p = hr("recharts-line-dot", typeof n != "boolean" ? n.className : "");
          u = /* @__PURE__ */ ce.createElement(Vj, Hg({
            key: s
          }, c, {
            className: p
          }));
        }
        return u;
      }
    }]);
  }(ee.PureComponent);
  ss(k0, "displayName", "Line");
  ss(k0, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    connectNulls: !1,
    activeDot: !0,
    dot: !0,
    legendType: "line",
    stroke: "#3182bd",
    strokeWidth: 1,
    fill: "#fff",
    points: [],
    isAnimationActive: !K0.isSsr,
    animateNewValues: !0,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease",
    hide: !1,
    label: !1
  });
  ss(k0, "getComposedData", function(e) {
    var t = e.props, r = e.xAxis, n = e.yAxis, i = e.xAxisTicks, u = e.yAxisTicks, s = e.dataKey, c = e.bandSize, p = e.displayedData, h = e.offset, v = t.layout, y = p.map(function(x, w) {
      var E = Ho(x, s);
      return v === "horizontal" ? {
        x: Kz({
          axis: r,
          ticks: i,
          bandSize: c,
          entry: x,
          index: w
        }),
        y: lr(E) ? null : n.scale(E),
        value: E,
        payload: x
      } : {
        x: lr(E) ? null : r.scale(E),
        y: Kz({
          axis: n,
          ticks: u,
          bandSize: c,
          entry: x,
          index: w
        }),
        value: E,
        payload: x
      };
    });
    return Bo({
      points: y,
      layout: v
    }, h);
  });
  function R0(e) {
    "@babel/helpers - typeof";
    return R0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, R0(e);
  }
  function mSe(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function ySe(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, BY(n.key), n);
    }
  }
  function gSe(e, t, r) {
    return t && ySe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function xSe(e, t, r) {
    return t = m_(t), bSe(e, FY() ? Reflect.construct(t, r || [], m_(e).constructor) : t.apply(e, r));
  }
  function bSe(e, t) {
    if (t && (R0(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return wSe(e);
  }
  function wSe(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function FY() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (FY = function() {
      return !!e;
    })();
  }
  function m_(e) {
    return m_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, m_(e);
  }
  function ESe(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && GM(e, t);
  }
  function GM(e, t) {
    return GM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, GM(e, t);
  }
  function IY(e, t, r) {
    return t = BY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function BY(e) {
    var t = SSe(e, "string");
    return R0(t) == "symbol" ? t : t + "";
  }
  function SSe(e, t) {
    if (R0(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (R0(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  function QM() {
    return QM = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, QM.apply(this, arguments);
  }
  function _Se(e) {
    var t = e.xAxisId, r = Qj(), n = Kj(), i = wY(t);
    return i == null ? null : (
      // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
      /* @__PURE__ */ ce.createElement(em, QM({}, i, {
        className: hr("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
        viewBox: {
          x: 0,
          y: 0,
          width: r,
          height: n
        },
        ticksGenerator: function(s) {
          return pc(s, !0);
        }
      }))
    );
  }
  var tm = /* @__PURE__ */ function(e) {
    function t() {
      return mSe(this, t), xSe(this, t, arguments);
    }
    return ESe(t, e), gSe(t, [{
      key: "render",
      value: function() {
        return /* @__PURE__ */ ce.createElement(_Se, this.props);
      }
    }]);
  }(ce.Component);
  IY(tm, "displayName", "XAxis");
  IY(tm, "defaultProps", {
    allowDecimals: !0,
    hide: !1,
    orientation: "bottom",
    width: 0,
    height: 30,
    mirror: !1,
    xAxisId: 0,
    tickCount: 5,
    type: "category",
    padding: {
      left: 0,
      right: 0
    },
    allowDataOverflow: !1,
    scale: "auto",
    reversed: !1,
    allowDuplicatedCategory: !0
  });
  function P0(e) {
    "@babel/helpers - typeof";
    return P0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, P0(e);
  }
  function CSe(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function OSe(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zY(n.key), n);
    }
  }
  function TSe(e, t, r) {
    return t && OSe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function ASe(e, t, r) {
    return t = y_(t), DSe(e, LY() ? Reflect.construct(t, r || [], y_(e).constructor) : t.apply(e, r));
  }
  function DSe(e, t) {
    if (t && (P0(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return kSe(e);
  }
  function kSe(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function LY() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (LY = function() {
      return !!e;
    })();
  }
  function y_(e) {
    return y_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, y_(e);
  }
  function RSe(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && KM(e, t);
  }
  function KM(e, t) {
    return KM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, KM(e, t);
  }
  function $Y(e, t, r) {
    return t = zY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function zY(e) {
    var t = PSe(e, "string");
    return P0(t) == "symbol" ? t : t + "";
  }
  function PSe(e, t) {
    if (P0(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (P0(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  function XM() {
    return XM = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, XM.apply(this, arguments);
  }
  var MSe = function(t) {
    var r = t.yAxisId, n = Qj(), i = Kj(), u = EY(r);
    return u == null ? null : (
      // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
      /* @__PURE__ */ ce.createElement(em, XM({}, u, {
        className: hr("recharts-".concat(u.axisType, " ").concat(u.axisType), u.className),
        viewBox: {
          x: 0,
          y: 0,
          width: n,
          height: i
        },
        ticksGenerator: function(c) {
          return pc(c, !0);
        }
      }))
    );
  }, rm = /* @__PURE__ */ function(e) {
    function t() {
      return CSe(this, t), ASe(this, t, arguments);
    }
    return RSe(t, e), TSe(t, [{
      key: "render",
      value: function() {
        return /* @__PURE__ */ ce.createElement(MSe, this.props);
      }
    }]);
  }(ce.Component);
  $Y(rm, "displayName", "YAxis");
  $Y(rm, "defaultProps", {
    allowDuplicatedCategory: !0,
    allowDecimals: !0,
    hide: !1,
    orientation: "left",
    width: 60,
    height: 0,
    mirror: !1,
    yAxisId: 0,
    tickCount: 5,
    type: "number",
    padding: {
      top: 0,
      bottom: 0
    },
    allowDataOverflow: !1,
    scale: "auto",
    reversed: !1
  });
  function H7(e) {
    return ISe(e) || FSe(e) || jSe(e) || NSe();
  }
  function NSe() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function jSe(e, t) {
    if (e) {
      if (typeof e == "string") return ZM(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ZM(e, t);
    }
  }
  function FSe(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function ISe(e) {
    if (Array.isArray(e)) return ZM(e);
  }
  function ZM(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  var JM = function(t, r, n, i, u) {
    var s = _u(t, Zj), c = _u(t, cC), p = [].concat(H7(s), H7(c)), h = _u(t, dC), v = "".concat(i, "Id"), y = i[0], x = r;
    if (p.length && (x = p.reduce(function(C, S) {
      if (S.props[v] === n && ll(S.props, "extendDomain") && Ke(S.props[y])) {
        var k = S.props[y];
        return [Math.min(C[0], k), Math.max(C[1], k)];
      }
      return C;
    }, x)), h.length) {
      var w = "".concat(y, "1"), E = "".concat(y, "2");
      x = h.reduce(function(C, S) {
        if (S.props[v] === n && ll(S.props, "extendDomain") && Ke(S.props[w]) && Ke(S.props[E])) {
          var k = S.props[w], D = S.props[E];
          return [Math.min(C[0], k, D), Math.max(C[1], k, D)];
        }
        return C;
      }, x);
    }
    return u && u.length && (x = u.reduce(function(C, S) {
      return Ke(S) ? [Math.min(C[0], S), Math.max(C[1], S)] : C;
    }, x)), x;
  }, J2 = { exports: {} }, V7;
  function BSe() {
    return V7 || (V7 = 1, function(e) {
      var t = Object.prototype.hasOwnProperty, r = "~";
      function n() {
      }
      Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
      function i(p, h, v) {
        this.fn = p, this.context = h, this.once = v || !1;
      }
      function u(p, h, v, y, x) {
        if (typeof v != "function")
          throw new TypeError("The listener must be a function");
        var w = new i(v, y || p, x), E = r ? r + h : h;
        return p._events[E] ? p._events[E].fn ? p._events[E] = [p._events[E], w] : p._events[E].push(w) : (p._events[E] = w, p._eventsCount++), p;
      }
      function s(p, h) {
        --p._eventsCount === 0 ? p._events = new n() : delete p._events[h];
      }
      function c() {
        this._events = new n(), this._eventsCount = 0;
      }
      c.prototype.eventNames = function() {
        var h = [], v, y;
        if (this._eventsCount === 0) return h;
        for (y in v = this._events)
          t.call(v, y) && h.push(r ? y.slice(1) : y);
        return Object.getOwnPropertySymbols ? h.concat(Object.getOwnPropertySymbols(v)) : h;
      }, c.prototype.listeners = function(h) {
        var v = r ? r + h : h, y = this._events[v];
        if (!y) return [];
        if (y.fn) return [y.fn];
        for (var x = 0, w = y.length, E = new Array(w); x < w; x++)
          E[x] = y[x].fn;
        return E;
      }, c.prototype.listenerCount = function(h) {
        var v = r ? r + h : h, y = this._events[v];
        return y ? y.fn ? 1 : y.length : 0;
      }, c.prototype.emit = function(h, v, y, x, w, E) {
        var C = r ? r + h : h;
        if (!this._events[C]) return !1;
        var S = this._events[C], k = arguments.length, D, A;
        if (S.fn) {
          switch (S.once && this.removeListener(h, S.fn, void 0, !0), k) {
            case 1:
              return S.fn.call(S.context), !0;
            case 2:
              return S.fn.call(S.context, v), !0;
            case 3:
              return S.fn.call(S.context, v, y), !0;
            case 4:
              return S.fn.call(S.context, v, y, x), !0;
            case 5:
              return S.fn.call(S.context, v, y, x, w), !0;
            case 6:
              return S.fn.call(S.context, v, y, x, w, E), !0;
          }
          for (A = 1, D = new Array(k - 1); A < k; A++)
            D[A - 1] = arguments[A];
          S.fn.apply(S.context, D);
        } else {
          var R = S.length, T;
          for (A = 0; A < R; A++)
            switch (S[A].once && this.removeListener(h, S[A].fn, void 0, !0), k) {
              case 1:
                S[A].fn.call(S[A].context);
                break;
              case 2:
                S[A].fn.call(S[A].context, v);
                break;
              case 3:
                S[A].fn.call(S[A].context, v, y);
                break;
              case 4:
                S[A].fn.call(S[A].context, v, y, x);
                break;
              default:
                if (!D) for (T = 1, D = new Array(k - 1); T < k; T++)
                  D[T - 1] = arguments[T];
                S[A].fn.apply(S[A].context, D);
            }
        }
        return !0;
      }, c.prototype.on = function(h, v, y) {
        return u(this, h, v, y, !1);
      }, c.prototype.once = function(h, v, y) {
        return u(this, h, v, y, !0);
      }, c.prototype.removeListener = function(h, v, y, x) {
        var w = r ? r + h : h;
        if (!this._events[w]) return this;
        if (!v)
          return s(this, w), this;
        var E = this._events[w];
        if (E.fn)
          E.fn === v && (!x || E.once) && (!y || E.context === y) && s(this, w);
        else {
          for (var C = 0, S = [], k = E.length; C < k; C++)
            (E[C].fn !== v || x && !E[C].once || y && E[C].context !== y) && S.push(E[C]);
          S.length ? this._events[w] = S.length === 1 ? S[0] : S : s(this, w);
        }
        return this;
      }, c.prototype.removeAllListeners = function(h) {
        var v;
        return h ? (v = r ? r + h : h, this._events[v] && s(this, v)) : (this._events = new n(), this._eventsCount = 0), this;
      }, c.prototype.off = c.prototype.removeListener, c.prototype.addListener = c.prototype.on, c.prefixed = r, c.EventEmitter = c, e.exports = c;
    }(J2)), J2.exports;
  }
  var LSe = BSe();
  const $Se = /* @__PURE__ */ Zr(LSe);
  var eP = new $Se(), tP = "recharts.syncMouseEvents";
  function Px(e) {
    "@babel/helpers - typeof";
    return Px = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Px(e);
  }
  function zSe(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function qSe(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, qY(n.key), n);
    }
  }
  function USe(e, t, r) {
    return t && qSe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function rP(e, t, r) {
    return t = qY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function qY(e) {
    var t = HSe(e, "string");
    return Px(t) == "symbol" ? t : t + "";
  }
  function HSe(e, t) {
    if (Px(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Px(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var VSe = /* @__PURE__ */ function() {
    function e() {
      zSe(this, e), rP(this, "activeIndex", 0), rP(this, "coordinateList", []), rP(this, "layout", "horizontal");
    }
    return USe(e, [{
      key: "setDetails",
      value: function(r) {
        var n, i = r.coordinateList, u = i === void 0 ? null : i, s = r.container, c = s === void 0 ? null : s, p = r.layout, h = p === void 0 ? null : p, v = r.offset, y = v === void 0 ? null : v, x = r.mouseHandlerCallback, w = x === void 0 ? null : x;
        this.coordinateList = (n = u ?? this.coordinateList) !== null && n !== void 0 ? n : [], this.container = c ?? this.container, this.layout = h ?? this.layout, this.offset = y ?? this.offset, this.mouseHandlerCallback = w ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
      }
    }, {
      key: "focus",
      value: function() {
        this.spoofMouse();
      }
    }, {
      key: "keyboardEvent",
      value: function(r) {
        if (this.coordinateList.length !== 0)
          switch (r.key) {
            case "ArrowRight": {
              if (this.layout !== "horizontal")
                return;
              this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
              break;
            }
            case "ArrowLeft": {
              if (this.layout !== "horizontal")
                return;
              this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
              break;
            }
          }
      }
    }, {
      key: "setIndex",
      value: function(r) {
        this.activeIndex = r;
      }
    }, {
      key: "spoofMouse",
      value: function() {
        var r, n;
        if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
          var i = this.container.getBoundingClientRect(), u = i.x, s = i.y, c = i.height, p = this.coordinateList[this.activeIndex].coordinate, h = ((r = window) === null || r === void 0 ? void 0 : r.scrollX) || 0, v = ((n = window) === null || n === void 0 ? void 0 : n.scrollY) || 0, y = u + p + h, x = s + this.offset.top + c / 2 + v;
          this.mouseHandlerCallback({
            pageX: y,
            pageY: x
          });
        }
      }
    }]);
  }();
  function WSe(e, t, r) {
    if (r === "number" && t === !0 && Array.isArray(e)) {
      var n = e == null ? void 0 : e[0], i = e == null ? void 0 : e[1];
      if (n && i && Ke(n) && Ke(i))
        return !0;
    }
    return !1;
  }
  function YSe(e, t, r, n) {
    var i = n / 2;
    return {
      stroke: "none",
      fill: "#ccc",
      x: e === "horizontal" ? t.x - i : r.left + 0.5,
      y: e === "horizontal" ? r.top + 0.5 : t.y - i,
      width: e === "horizontal" ? n : r.width - 1,
      height: e === "horizontal" ? r.height - 1 : n
    };
  }
  function UY(e) {
    var t = e.cx, r = e.cy, n = e.radius, i = e.startAngle, u = e.endAngle, s = oa(t, r, n, i), c = oa(t, r, n, u);
    return {
      points: [s, c],
      cx: t,
      cy: r,
      radius: n,
      startAngle: i,
      endAngle: u
    };
  }
  function GSe(e, t, r) {
    var n, i, u, s;
    if (e === "horizontal")
      n = t.x, u = n, i = r.top, s = r.top + r.height;
    else if (e === "vertical")
      i = t.y, s = i, n = r.left, u = r.left + r.width;
    else if (t.cx != null && t.cy != null)
      if (e === "centric") {
        var c = t.cx, p = t.cy, h = t.innerRadius, v = t.outerRadius, y = t.angle, x = oa(c, p, h, y), w = oa(c, p, v, y);
        n = x.x, i = x.y, u = w.x, s = w.y;
      } else
        return UY(t);
    return [{
      x: n,
      y: i
    }, {
      x: u,
      y: s
    }];
  }
  function Mx(e) {
    "@babel/helpers - typeof";
    return Mx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Mx(e);
  }
  function W7(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function gE(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? W7(Object(r), !0).forEach(function(n) {
        QSe(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : W7(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function QSe(e, t, r) {
    return t = KSe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function KSe(e) {
    var t = XSe(e, "string");
    return Mx(t) == "symbol" ? t : t + "";
  }
  function XSe(e, t) {
    if (Mx(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Mx(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function ZSe(e) {
    var t, r, n = e.element, i = e.tooltipEventType, u = e.isActive, s = e.activeCoordinate, c = e.activePayload, p = e.offset, h = e.activeTooltipIndex, v = e.tooltipAxisBandSize, y = e.layout, x = e.chartName, w = (t = n.props.cursor) !== null && t !== void 0 ? t : (r = n.type.defaultProps) === null || r === void 0 ? void 0 : r.cursor;
    if (!n || !w || !u || !s || x !== "ScatterChart" && i !== "axis")
      return null;
    var E, C = _M;
    if (x === "ScatterChart")
      E = s, C = Kbe;
    else if (x === "BarChart")
      E = YSe(y, s, p, v), C = Hj;
    else if (y === "radial") {
      var S = UY(s), k = S.cx, D = S.cy, A = S.radius, R = S.startAngle, T = S.endAngle;
      E = {
        cx: k,
        cy: D,
        startAngle: R,
        endAngle: T,
        innerRadius: A,
        outerRadius: A
      }, C = YW;
    } else
      E = {
        points: GSe(y, s, p)
      }, C = _M;
    var M = gE(gE(gE(gE({
      stroke: "#ccc",
      pointerEvents: "none"
    }, p), E), pr(w, !1)), {}, {
      payload: c,
      payloadIndex: h,
      className: hr("recharts-tooltip-cursor", w.className)
    });
    return /* @__PURE__ */ ee.isValidElement(w) ? /* @__PURE__ */ ee.cloneElement(w, M) : /* @__PURE__ */ ee.createElement(C, M);
  }
  var JSe = ["item"], e_e = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
  function M0(e) {
    "@babel/helpers - typeof";
    return M0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, M0(e);
  }
  function Qv() {
    return Qv = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Qv.apply(this, arguments);
  }
  function Y7(e, t) {
    return n_e(e) || r_e(e, t) || VY(e, t) || t_e();
  }
  function t_e() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function r_e(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, u, s, c = [], p = !0, h = !1;
      try {
        if (u = (r = r.call(e)).next, t !== 0) for (; !(p = (n = u.call(r)).done) && (c.push(n.value), c.length !== t); p = !0) ;
      } catch (v) {
        h = !0, i = v;
      } finally {
        try {
          if (!p && r.return != null && (s = r.return(), Object(s) !== s)) return;
        } finally {
          if (h) throw i;
        }
      }
      return c;
    }
  }
  function n_e(e) {
    if (Array.isArray(e)) return e;
  }
  function G7(e, t) {
    if (e == null) return {};
    var r = i_e(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);
      for (i = 0; i < u.length; i++)
        n = u[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function i_e(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function a_e(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function o_e(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, WY(n.key), n);
    }
  }
  function u_e(e, t, r) {
    return t && o_e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function s_e(e, t, r) {
    return t = g_(t), l_e(e, HY() ? Reflect.construct(t, r || [], g_(e).constructor) : t.apply(e, r));
  }
  function l_e(e, t) {
    if (t && (M0(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return c_e(e);
  }
  function c_e(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function HY() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (HY = function() {
      return !!e;
    })();
  }
  function g_(e) {
    return g_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, g_(e);
  }
  function f_e(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && eN(e, t);
  }
  function eN(e, t) {
    return eN = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, eN(e, t);
  }
  function N0(e) {
    return h_e(e) || p_e(e) || VY(e) || d_e();
  }
  function d_e() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function VY(e, t) {
    if (e) {
      if (typeof e == "string") return tN(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return tN(e, t);
    }
  }
  function p_e(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function h_e(e) {
    if (Array.isArray(e)) return tN(e);
  }
  function tN(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function Q7(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function je(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? Q7(Object(r), !0).forEach(function(n) {
        Nt(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Q7(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Nt(e, t, r) {
    return t = WY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function WY(e) {
    var t = v_e(e, "string");
    return M0(t) == "symbol" ? t : t + "";
  }
  function v_e(e, t) {
    if (M0(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (M0(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var m_e = {
    xAxis: ["bottom", "top"],
    yAxis: ["left", "right"]
  }, y_e = {
    width: "100%",
    height: "100%"
  }, YY = {
    x: 0,
    y: 0
  };
  function xE(e) {
    return e;
  }
  var g_e = function(t, r) {
    return r === "horizontal" ? t.x : r === "vertical" ? t.y : r === "centric" ? t.angle : t.radius;
  }, x_e = function(t, r, n, i) {
    var u = r.find(function(v) {
      return v && v.index === n;
    });
    if (u) {
      if (t === "horizontal")
        return {
          x: u.coordinate,
          y: i.y
        };
      if (t === "vertical")
        return {
          x: i.x,
          y: u.coordinate
        };
      if (t === "centric") {
        var s = u.coordinate, c = i.radius;
        return je(je(je({}, i), oa(i.cx, i.cy, c, s)), {}, {
          angle: s,
          radius: c
        });
      }
      var p = u.coordinate, h = i.angle;
      return je(je(je({}, i), oa(i.cx, i.cy, p, h)), {}, {
        angle: h,
        radius: p
      });
    }
    return YY;
  }, pC = function(t, r) {
    var n = r.graphicalItems, i = r.dataStartIndex, u = r.dataEndIndex, s = (n ?? []).reduce(function(c, p) {
      var h = p.props.data;
      return h && h.length ? [].concat(N0(c), N0(h)) : c;
    }, []);
    return s.length > 0 ? s : t && t.length && Ke(i) && Ke(u) ? t.slice(i, u + 1) : [];
  };
  function GY(e) {
    return e === "number" ? [0, "auto"] : void 0;
  }
  var rN = function(t, r, n, i) {
    var u = t.graphicalItems, s = t.tooltipAxis, c = pC(r, t);
    return n < 0 || !u || !u.length || n >= c.length ? null : u.reduce(function(p, h) {
      var v, y = (v = h.props.data) !== null && v !== void 0 ? v : r;
      y && t.dataStartIndex + t.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
      // The data is sliced only when the active index is within the start/end index range.
      t.dataEndIndex - t.dataStartIndex >= n && (y = y.slice(t.dataStartIndex, t.dataEndIndex + 1));
      var x;
      if (s.dataKey && !s.allowDuplicatedCategory) {
        var w = y === void 0 ? c : y;
        x = wS(w, s.dataKey, i);
      } else
        x = y && y[n] || c[n];
      return x ? [].concat(N0(p), [HW(h, x)]) : p;
    }, []);
  }, K7 = function(t, r, n, i) {
    var u = i || {
      x: t.chartX,
      y: t.chartY
    }, s = g_e(u, n), c = t.orderedTooltipTicks, p = t.tooltipAxis, h = t.tooltipTicks, v = Aye(s, c, h, p);
    if (v >= 0 && h) {
      var y = h[v] && h[v].value, x = rN(t, r, v, y), w = x_e(n, c, v, u);
      return {
        activeTooltipIndex: v,
        activeLabel: y,
        activePayload: x,
        activeCoordinate: w
      };
    }
    return null;
  }, b_e = function(t, r) {
    var n = r.axes, i = r.graphicalItems, u = r.axisType, s = r.axisIdKey, c = r.stackGroups, p = r.dataStartIndex, h = r.dataEndIndex, v = t.layout, y = t.children, x = t.stackOffset, w = zW(v, u);
    return n.reduce(function(E, C) {
      var S, k = C.type.defaultProps !== void 0 ? je(je({}, C.type.defaultProps), C.props) : C.props, D = k.type, A = k.dataKey, R = k.allowDataOverflow, T = k.allowDuplicatedCategory, M = k.scale, F = k.ticks, B = k.includeHidden, V = k[s];
      if (E[V])
        return E;
      var H = pC(t.data, {
        graphicalItems: i.filter(function(Y) {
          var te, ae = s in Y.props ? Y.props[s] : (te = Y.type.defaultProps) === null || te === void 0 ? void 0 : te[s];
          return ae === V;
        }),
        dataStartIndex: p,
        dataEndIndex: h
      }), q = H.length, Q, W, J;
      WSe(k.domain, R, D) && (Q = xM(k.domain, null, R), w && (D === "number" || M !== "auto") && (J = qg(H, A, "category")));
      var ne = GY(D);
      if (!Q || Q.length === 0) {
        var ie, se = (ie = k.domain) !== null && ie !== void 0 ? ie : ne;
        if (A) {
          if (Q = qg(H, A, D), D === "category" && w) {
            var X = yce(Q);
            T && X ? (W = Q, Q = i_(0, q)) : T || (Q = eq(se, Q, C).reduce(function(Y, te) {
              return Y.indexOf(te) >= 0 ? Y : [].concat(N0(Y), [te]);
            }, []));
          } else if (D === "category")
            T ? Q = Q.filter(function(Y) {
              return Y !== "" && !lr(Y);
            }) : Q = eq(se, Q, C).reduce(function(Y, te) {
              return Y.indexOf(te) >= 0 || te === "" || lr(te) ? Y : [].concat(N0(Y), [te]);
            }, []);
          else if (D === "number") {
            var fe = Mye(H, i.filter(function(Y) {
              var te, ae, De = s in Y.props ? Y.props[s] : (te = Y.type.defaultProps) === null || te === void 0 ? void 0 : te[s], ke = "hide" in Y.props ? Y.props.hide : (ae = Y.type.defaultProps) === null || ae === void 0 ? void 0 : ae.hide;
              return De === V && (B || !ke);
            }), A, u, v);
            fe && (Q = fe);
          }
          w && (D === "number" || M !== "auto") && (J = qg(H, A, "category"));
        } else w ? Q = i_(0, q) : c && c[V] && c[V].hasStack && D === "number" ? Q = x === "expand" ? [0, 1] : UW(c[V].stackGroups, p, h) : Q = $W(H, i.filter(function(Y) {
          var te = s in Y.props ? Y.props[s] : Y.type.defaultProps[s], ae = "hide" in Y.props ? Y.props.hide : Y.type.defaultProps.hide;
          return te === V && (B || !ae);
        }), D, v, !0);
        if (D === "number")
          Q = JM(y, Q, V, u, F), se && (Q = xM(se, Q, R));
        else if (D === "category" && se) {
          var Z = se, z = Q.every(function(Y) {
            return Z.indexOf(Y) >= 0;
          });
          z && (Q = Z);
        }
      }
      return je(je({}, E), {}, Nt({}, V, je(je({}, k), {}, {
        axisType: u,
        domain: Q,
        categoricalDomain: J,
        duplicateDomain: W,
        originalDomain: (S = k.domain) !== null && S !== void 0 ? S : ne,
        isCategorical: w,
        layout: v
      })));
    }, {});
  }, w_e = function(t, r) {
    var n = r.graphicalItems, i = r.Axis, u = r.axisType, s = r.axisIdKey, c = r.stackGroups, p = r.dataStartIndex, h = r.dataEndIndex, v = t.layout, y = t.children, x = pC(t.data, {
      graphicalItems: n,
      dataStartIndex: p,
      dataEndIndex: h
    }), w = x.length, E = zW(v, u), C = -1;
    return n.reduce(function(S, k) {
      var D = k.type.defaultProps !== void 0 ? je(je({}, k.type.defaultProps), k.props) : k.props, A = D[s], R = GY("number");
      if (!S[A]) {
        C++;
        var T;
        return E ? T = i_(0, w) : c && c[A] && c[A].hasStack ? (T = UW(c[A].stackGroups, p, h), T = JM(y, T, A, u)) : (T = xM(R, $W(x, n.filter(function(M) {
          var F, B, V = s in M.props ? M.props[s] : (F = M.type.defaultProps) === null || F === void 0 ? void 0 : F[s], H = "hide" in M.props ? M.props.hide : (B = M.type.defaultProps) === null || B === void 0 ? void 0 : B.hide;
          return V === A && !H;
        }), "number", v), i.defaultProps.allowDataOverflow), T = JM(y, T, A, u)), je(je({}, S), {}, Nt({}, A, je(je({
          axisType: u
        }, i.defaultProps), {}, {
          hide: !0,
          orientation: Su(m_e, "".concat(u, ".").concat(C % 2), null),
          domain: T,
          originalDomain: R,
          isCategorical: E,
          layout: v
          // specify scale when no Axis
          // scale: isCategorical ? 'band' : 'linear',
        })));
      }
      return S;
    }, {});
  }, E_e = function(t, r) {
    var n = r.axisType, i = n === void 0 ? "xAxis" : n, u = r.AxisComp, s = r.graphicalItems, c = r.stackGroups, p = r.dataStartIndex, h = r.dataEndIndex, v = t.children, y = "".concat(i, "Id"), x = _u(v, u), w = {};
    return x && x.length ? w = b_e(t, {
      axes: x,
      graphicalItems: s,
      axisType: i,
      axisIdKey: y,
      stackGroups: c,
      dataStartIndex: p,
      dataEndIndex: h
    }) : s && s.length && (w = w_e(t, {
      Axis: u,
      graphicalItems: s,
      axisType: i,
      axisIdKey: y,
      stackGroups: c,
      dataStartIndex: p,
      dataEndIndex: h
    })), w;
  }, S_e = function(t) {
    var r = Nf(t), n = pc(r, !1, !0);
    return {
      tooltipTicks: n,
      orderedTooltipTicks: mj(n, function(i) {
        return i.coordinate;
      }),
      tooltipAxis: r,
      tooltipAxisBandSize: GS(r, n)
    };
  }, X7 = function(t) {
    var r = t.children, n = t.defaultShowTooltip, i = $o(r, E0), u = 0, s = 0;
    return t.data && t.data.length !== 0 && (s = t.data.length - 1), i && i.props && (i.props.startIndex >= 0 && (u = i.props.startIndex), i.props.endIndex >= 0 && (s = i.props.endIndex)), {
      chartX: 0,
      chartY: 0,
      dataStartIndex: u,
      dataEndIndex: s,
      activeTooltipIndex: -1,
      isTooltipActive: !!n
    };
  }, __e = function(t) {
    return !t || !t.length ? !1 : t.some(function(r) {
      var n = vc(r && r.type);
      return n && n.indexOf("Bar") >= 0;
    });
  }, Z7 = function(t) {
    return t === "horizontal" ? {
      numericAxisName: "yAxis",
      cateAxisName: "xAxis"
    } : t === "vertical" ? {
      numericAxisName: "xAxis",
      cateAxisName: "yAxis"
    } : t === "centric" ? {
      numericAxisName: "radiusAxis",
      cateAxisName: "angleAxis"
    } : {
      numericAxisName: "angleAxis",
      cateAxisName: "radiusAxis"
    };
  }, C_e = function(t, r) {
    var n = t.props, i = t.graphicalItems, u = t.xAxisMap, s = u === void 0 ? {} : u, c = t.yAxisMap, p = c === void 0 ? {} : c, h = n.width, v = n.height, y = n.children, x = n.margin || {}, w = $o(y, E0), E = $o(y, t0), C = Object.keys(p).reduce(function(T, M) {
      var F = p[M], B = F.orientation;
      return !F.mirror && !F.hide ? je(je({}, T), {}, Nt({}, B, T[B] + F.width)) : T;
    }, {
      left: x.left || 0,
      right: x.right || 0
    }), S = Object.keys(s).reduce(function(T, M) {
      var F = s[M], B = F.orientation;
      return !F.mirror && !F.hide ? je(je({}, T), {}, Nt({}, B, Su(T, "".concat(B)) + F.height)) : T;
    }, {
      top: x.top || 0,
      bottom: x.bottom || 0
    }), k = je(je({}, S), C), D = k.bottom;
    w && (k.bottom += w.props.height || E0.defaultProps.height), E && r && (k = Rye(k, i, n, r));
    var A = h - k.left - k.right, R = v - k.top - k.bottom;
    return je(je({
      brushBottom: D
    }, k), {}, {
      // never return negative values for height and width
      width: Math.max(A, 0),
      height: Math.max(R, 0)
    });
  }, O_e = function(t, r) {
    if (r === "xAxis")
      return t[r].width;
    if (r === "yAxis")
      return t[r].height;
  }, QY = function(t) {
    var r = t.chartName, n = t.GraphicalChild, i = t.defaultTooltipEventType, u = i === void 0 ? "axis" : i, s = t.validateTooltipEventTypes, c = s === void 0 ? ["axis"] : s, p = t.axisComponents, h = t.legendContent, v = t.formatAxisMap, y = t.defaultProps, x = function(k, D) {
      var A = D.graphicalItems, R = D.stackGroups, T = D.offset, M = D.updateId, F = D.dataStartIndex, B = D.dataEndIndex, V = k.barSize, H = k.layout, q = k.barGap, Q = k.barCategoryGap, W = k.maxBarSize, J = Z7(H), ne = J.numericAxisName, ie = J.cateAxisName, se = __e(A), X = [];
      return A.forEach(function(fe, Z) {
        var z = pC(k.data, {
          graphicalItems: [fe],
          dataStartIndex: F,
          dataEndIndex: B
        }), Y = fe.type.defaultProps !== void 0 ? je(je({}, fe.type.defaultProps), fe.props) : fe.props, te = Y.dataKey, ae = Y.maxBarSize, De = Y["".concat(ne, "Id")], ke = Y["".concat(ie, "Id")], Re = {}, Te = p.reduce(function(Vt, Ut) {
          var kr, Pn, Yr = D["".concat(Ut.axisType, "Map")], Jr = Y["".concat(Ut.axisType, "Id")];
          Yr && Yr[Jr] || Ut.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? go(!1, "Specifying a(n) ".concat(Ut.axisType, "Id requires a corresponding ").concat(
            Ut.axisType,
            "Id on the targeted graphical component "
          ).concat((kr = fe == null || (Pn = fe.type) === null || Pn === void 0 ? void 0 : Pn.displayName) !== null && kr !== void 0 ? kr : "")) : go());
          var xn = Yr[Jr];
          return je(je({}, Vt), {}, Nt(Nt({}, Ut.axisType, xn), "".concat(Ut.axisType, "Ticks"), pc(xn)));
        }, Re), we = Te[ie], Fe = Te["".concat(ie, "Ticks")], Ye = R && R[De] && R[De].hasStack && Vye(fe, R[De].stackGroups), de = vc(fe.type).indexOf("Bar") >= 0, Ze = GS(we, Fe), Ne = [], Ot = se && Dye({
          barSize: V,
          stackGroups: R,
          totalSize: O_e(Te, ie)
        });
        if (de) {
          var At, Qt, Wr = lr(ae) ? W : ae, Ar = (At = (Qt = GS(we, Fe, !0)) !== null && Qt !== void 0 ? Qt : Wr) !== null && At !== void 0 ? At : 0;
          Ne = kye({
            barGap: q,
            barCategoryGap: Q,
            bandSize: Ar !== Ze ? Ar : Ze,
            sizeList: Ot[ke],
            maxBarSize: Wr
          }), Ar !== Ze && (Ne = Ne.map(function(Vt) {
            return je(je({}, Vt), {}, {
              position: je(je({}, Vt.position), {}, {
                offset: Vt.position.offset - Ar / 2
              })
            });
          }));
        }
        var Dr = fe && fe.type && fe.type.getComposedData;
        Dr && X.push({
          props: je(je({}, Dr(je(je({}, Te), {}, {
            displayedData: z,
            props: k,
            dataKey: te,
            item: fe,
            bandSize: Ze,
            barPosition: Ne,
            offset: T,
            stackedData: Ye,
            layout: H,
            dataStartIndex: F,
            dataEndIndex: B
          }))), {}, Nt(Nt(Nt({
            key: fe.key || "item-".concat(Z)
          }, ne, Te[ne]), ie, Te[ie]), "animationId", M)),
          childIndex: kce(fe, k.children),
          item: fe
        });
      }), X;
    }, w = function(k, D) {
      var A = k.props, R = k.dataStartIndex, T = k.dataEndIndex, M = k.updateId;
      if (!h6({
        props: A
      }))
        return null;
      var F = A.children, B = A.layout, V = A.stackOffset, H = A.data, q = A.reverseStackOrder, Q = Z7(B), W = Q.numericAxisName, J = Q.cateAxisName, ne = _u(F, n), ie = qye(H, ne, "".concat(W, "Id"), "".concat(J, "Id"), V, q), se = p.reduce(function(Y, te) {
        var ae = "".concat(te.axisType, "Map");
        return je(je({}, Y), {}, Nt({}, ae, E_e(A, je(je({}, te), {}, {
          graphicalItems: ne,
          stackGroups: te.axisType === W && ie,
          dataStartIndex: R,
          dataEndIndex: T
        }))));
      }, {}), X = C_e(je(je({}, se), {}, {
        props: A,
        graphicalItems: ne
      }), D == null ? void 0 : D.legendBBox);
      Object.keys(se).forEach(function(Y) {
        se[Y] = v(A, se[Y], X, Y.replace("Map", ""), r);
      });
      var fe = se["".concat(J, "Map")], Z = S_e(fe), z = x(A, je(je({}, se), {}, {
        dataStartIndex: R,
        dataEndIndex: T,
        updateId: M,
        graphicalItems: ne,
        stackGroups: ie,
        offset: X
      }));
      return je(je({
        formattedGraphicalItems: z,
        graphicalItems: ne,
        offset: X,
        stackGroups: ie
      }, Z), se);
    }, E = /* @__PURE__ */ function(S) {
      function k(D) {
        var A, R, T;
        return a_e(this, k), T = s_e(this, k, [D]), Nt(T, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), Nt(T, "accessibilityManager", new VSe()), Nt(T, "handleLegendBBoxUpdate", function(M) {
          if (M) {
            var F = T.state, B = F.dataStartIndex, V = F.dataEndIndex, H = F.updateId;
            T.setState(je({
              legendBBox: M
            }, w({
              props: T.props,
              dataStartIndex: B,
              dataEndIndex: V,
              updateId: H
            }, je(je({}, T.state), {}, {
              legendBBox: M
            }))));
          }
        }), Nt(T, "handleReceiveSyncEvent", function(M, F, B) {
          if (T.props.syncId === M) {
            if (B === T.eventEmitterSymbol && typeof T.props.syncMethod != "function")
              return;
            T.applySyncEvent(F);
          }
        }), Nt(T, "handleBrushChange", function(M) {
          var F = M.startIndex, B = M.endIndex;
          if (F !== T.state.dataStartIndex || B !== T.state.dataEndIndex) {
            var V = T.state.updateId;
            T.setState(function() {
              return je({
                dataStartIndex: F,
                dataEndIndex: B
              }, w({
                props: T.props,
                dataStartIndex: F,
                dataEndIndex: B,
                updateId: V
              }, T.state));
            }), T.triggerSyncEvent({
              dataStartIndex: F,
              dataEndIndex: B
            });
          }
        }), Nt(T, "handleMouseEnter", function(M) {
          var F = T.getMouseInfo(M);
          if (F) {
            var B = je(je({}, F), {}, {
              isTooltipActive: !0
            });
            T.setState(B), T.triggerSyncEvent(B);
            var V = T.props.onMouseEnter;
            er(V) && V(B, M);
          }
        }), Nt(T, "triggeredAfterMouseMove", function(M) {
          var F = T.getMouseInfo(M), B = F ? je(je({}, F), {}, {
            isTooltipActive: !0
          }) : {
            isTooltipActive: !1
          };
          T.setState(B), T.triggerSyncEvent(B);
          var V = T.props.onMouseMove;
          er(V) && V(B, M);
        }), Nt(T, "handleItemMouseEnter", function(M) {
          T.setState(function() {
            return {
              isTooltipActive: !0,
              activeItem: M,
              activePayload: M.tooltipPayload,
              activeCoordinate: M.tooltipPosition || {
                x: M.cx,
                y: M.cy
              }
            };
          });
        }), Nt(T, "handleItemMouseLeave", function() {
          T.setState(function() {
            return {
              isTooltipActive: !1
            };
          });
        }), Nt(T, "handleMouseMove", function(M) {
          M.persist(), T.throttleTriggeredAfterMouseMove(M);
        }), Nt(T, "handleMouseLeave", function(M) {
          T.throttleTriggeredAfterMouseMove.cancel();
          var F = {
            isTooltipActive: !1
          };
          T.setState(F), T.triggerSyncEvent(F);
          var B = T.props.onMouseLeave;
          er(B) && B(F, M);
        }), Nt(T, "handleOuterEvent", function(M) {
          var F = Dce(M), B = Su(T.props, "".concat(F));
          if (F && er(B)) {
            var V, H;
            /.*touch.*/i.test(F) ? H = T.getMouseInfo(M.changedTouches[0]) : H = T.getMouseInfo(M), B((V = H) !== null && V !== void 0 ? V : {}, M);
          }
        }), Nt(T, "handleClick", function(M) {
          var F = T.getMouseInfo(M);
          if (F) {
            var B = je(je({}, F), {}, {
              isTooltipActive: !0
            });
            T.setState(B), T.triggerSyncEvent(B);
            var V = T.props.onClick;
            er(V) && V(B, M);
          }
        }), Nt(T, "handleMouseDown", function(M) {
          var F = T.props.onMouseDown;
          if (er(F)) {
            var B = T.getMouseInfo(M);
            F(B, M);
          }
        }), Nt(T, "handleMouseUp", function(M) {
          var F = T.props.onMouseUp;
          if (er(F)) {
            var B = T.getMouseInfo(M);
            F(B, M);
          }
        }), Nt(T, "handleTouchMove", function(M) {
          M.changedTouches != null && M.changedTouches.length > 0 && T.throttleTriggeredAfterMouseMove(M.changedTouches[0]);
        }), Nt(T, "handleTouchStart", function(M) {
          M.changedTouches != null && M.changedTouches.length > 0 && T.handleMouseDown(M.changedTouches[0]);
        }), Nt(T, "handleTouchEnd", function(M) {
          M.changedTouches != null && M.changedTouches.length > 0 && T.handleMouseUp(M.changedTouches[0]);
        }), Nt(T, "handleDoubleClick", function(M) {
          var F = T.props.onDoubleClick;
          if (er(F)) {
            var B = T.getMouseInfo(M);
            F(B, M);
          }
        }), Nt(T, "handleContextMenu", function(M) {
          var F = T.props.onContextMenu;
          if (er(F)) {
            var B = T.getMouseInfo(M);
            F(B, M);
          }
        }), Nt(T, "triggerSyncEvent", function(M) {
          T.props.syncId !== void 0 && eP.emit(tP, T.props.syncId, M, T.eventEmitterSymbol);
        }), Nt(T, "applySyncEvent", function(M) {
          var F = T.props, B = F.layout, V = F.syncMethod, H = T.state.updateId, q = M.dataStartIndex, Q = M.dataEndIndex;
          if (M.dataStartIndex !== void 0 || M.dataEndIndex !== void 0)
            T.setState(je({
              dataStartIndex: q,
              dataEndIndex: Q
            }, w({
              props: T.props,
              dataStartIndex: q,
              dataEndIndex: Q,
              updateId: H
            }, T.state)));
          else if (M.activeTooltipIndex !== void 0) {
            var W = M.chartX, J = M.chartY, ne = M.activeTooltipIndex, ie = T.state, se = ie.offset, X = ie.tooltipTicks;
            if (!se)
              return;
            if (typeof V == "function")
              ne = V(X, M);
            else if (V === "value") {
              ne = -1;
              for (var fe = 0; fe < X.length; fe++)
                if (X[fe].value === M.activeLabel) {
                  ne = fe;
                  break;
                }
            }
            var Z = je(je({}, se), {}, {
              x: se.left,
              y: se.top
            }), z = Math.min(W, Z.x + Z.width), Y = Math.min(J, Z.y + Z.height), te = X[ne] && X[ne].value, ae = rN(T.state, T.props.data, ne), De = X[ne] ? {
              x: B === "horizontal" ? X[ne].coordinate : z,
              y: B === "horizontal" ? Y : X[ne].coordinate
            } : YY;
            T.setState(je(je({}, M), {}, {
              activeLabel: te,
              activeCoordinate: De,
              activePayload: ae,
              activeTooltipIndex: ne
            }));
          } else
            T.setState(M);
        }), Nt(T, "renderCursor", function(M) {
          var F, B = T.state, V = B.isTooltipActive, H = B.activeCoordinate, q = B.activePayload, Q = B.offset, W = B.activeTooltipIndex, J = B.tooltipAxisBandSize, ne = T.getTooltipEventType(), ie = (F = M.props.active) !== null && F !== void 0 ? F : V, se = T.props.layout, X = M.key || "_recharts-cursor";
          return /* @__PURE__ */ ce.createElement(ZSe, {
            key: X,
            activeCoordinate: H,
            activePayload: q,
            activeTooltipIndex: W,
            chartName: r,
            element: M,
            isActive: ie,
            layout: se,
            offset: Q,
            tooltipAxisBandSize: J,
            tooltipEventType: ne
          });
        }), Nt(T, "renderPolarAxis", function(M, F, B) {
          var V = Su(M, "type.axisType"), H = Su(T.state, "".concat(V, "Map")), q = M.type.defaultProps, Q = q !== void 0 ? je(je({}, q), M.props) : M.props, W = H && H[Q["".concat(V, "Id")]];
          return /* @__PURE__ */ ee.cloneElement(M, je(je({}, W), {}, {
            className: hr(V, W.className),
            key: M.key || "".concat(F, "-").concat(B),
            ticks: pc(W, !0)
          }));
        }), Nt(T, "renderPolarGrid", function(M) {
          var F = M.props, B = F.radialLines, V = F.polarAngles, H = F.polarRadius, q = T.state, Q = q.radiusAxisMap, W = q.angleAxisMap, J = Nf(Q), ne = Nf(W), ie = ne.cx, se = ne.cy, X = ne.innerRadius, fe = ne.outerRadius;
          return /* @__PURE__ */ ee.cloneElement(M, {
            polarAngles: Array.isArray(V) ? V : pc(ne, !0).map(function(Z) {
              return Z.coordinate;
            }),
            polarRadius: Array.isArray(H) ? H : pc(J, !0).map(function(Z) {
              return Z.coordinate;
            }),
            cx: ie,
            cy: se,
            innerRadius: X,
            outerRadius: fe,
            key: M.key || "polar-grid",
            radialLines: B
          });
        }), Nt(T, "renderLegend", function() {
          var M = T.state.formattedGraphicalItems, F = T.props, B = F.children, V = F.width, H = F.height, q = T.props.margin || {}, Q = V - (q.left || 0) - (q.right || 0), W = BW({
            children: B,
            formattedGraphicalItems: M,
            legendWidth: Q,
            legendContent: h
          });
          if (!W)
            return null;
          var J = W.item, ne = G7(W, JSe);
          return /* @__PURE__ */ ee.cloneElement(J, je(je({}, ne), {}, {
            chartWidth: V,
            chartHeight: H,
            margin: q,
            onBBoxUpdate: T.handleLegendBBoxUpdate
          }));
        }), Nt(T, "renderTooltip", function() {
          var M, F = T.props, B = F.children, V = F.accessibilityLayer, H = $o(B, os);
          if (!H)
            return null;
          var q = T.state, Q = q.isTooltipActive, W = q.activeCoordinate, J = q.activePayload, ne = q.activeLabel, ie = q.offset, se = (M = H.props.active) !== null && M !== void 0 ? M : Q;
          return /* @__PURE__ */ ee.cloneElement(H, {
            viewBox: je(je({}, ie), {}, {
              x: ie.left,
              y: ie.top
            }),
            active: se,
            label: ne,
            payload: se ? J : [],
            coordinate: W,
            accessibilityLayer: V
          });
        }), Nt(T, "renderBrush", function(M) {
          var F = T.props, B = F.margin, V = F.data, H = T.state, q = H.offset, Q = H.dataStartIndex, W = H.dataEndIndex, J = H.updateId;
          return /* @__PURE__ */ ee.cloneElement(M, {
            key: M.key || "_recharts-brush",
            onChange: dE(T.handleBrushChange, M.props.onChange),
            data: V,
            x: Ke(M.props.x) ? M.props.x : q.left,
            y: Ke(M.props.y) ? M.props.y : q.top + q.height + q.brushBottom - (B.bottom || 0),
            width: Ke(M.props.width) ? M.props.width : q.width,
            startIndex: Q,
            endIndex: W,
            updateId: "brush-".concat(J)
          });
        }), Nt(T, "renderReferenceElement", function(M, F, B) {
          if (!M)
            return null;
          var V = T, H = V.clipPathId, q = T.state, Q = q.xAxisMap, W = q.yAxisMap, J = q.offset, ne = M.type.defaultProps || {}, ie = M.props, se = ie.xAxisId, X = se === void 0 ? ne.xAxisId : se, fe = ie.yAxisId, Z = fe === void 0 ? ne.yAxisId : fe;
          return /* @__PURE__ */ ee.cloneElement(M, {
            key: M.key || "".concat(F, "-").concat(B),
            xAxis: Q[X],
            yAxis: W[Z],
            viewBox: {
              x: J.left,
              y: J.top,
              width: J.width,
              height: J.height
            },
            clipPathId: H
          });
        }), Nt(T, "renderActivePoints", function(M) {
          var F = M.item, B = M.activePoint, V = M.basePoint, H = M.childIndex, q = M.isRange, Q = [], W = F.props.key, J = F.item.type.defaultProps !== void 0 ? je(je({}, F.item.type.defaultProps), F.item.props) : F.item.props, ne = J.activeDot, ie = J.dataKey, se = je(je({
            index: H,
            dataKey: ie,
            cx: B.x,
            cy: B.y,
            r: 4,
            fill: qj(F.item),
            strokeWidth: 2,
            stroke: "#fff",
            payload: B.payload,
            value: B.value
          }, pr(ne, !1)), ES(ne));
          return Q.push(k.renderActiveDot(ne, se, "".concat(W, "-activePoint-").concat(H))), V ? Q.push(k.renderActiveDot(ne, je(je({}, se), {}, {
            cx: V.x,
            cy: V.y
          }), "".concat(W, "-basePoint-").concat(H))) : q && Q.push(null), Q;
        }), Nt(T, "renderGraphicChild", function(M, F, B) {
          var V = T.filterFormatItem(M, F, B);
          if (!V)
            return null;
          var H = T.getTooltipEventType(), q = T.state, Q = q.isTooltipActive, W = q.tooltipAxis, J = q.activeTooltipIndex, ne = q.activeLabel, ie = T.props.children, se = $o(ie, os), X = V.props, fe = X.points, Z = X.isRange, z = X.baseLine, Y = V.item.type.defaultProps !== void 0 ? je(je({}, V.item.type.defaultProps), V.item.props) : V.item.props, te = Y.activeDot, ae = Y.hide, De = Y.activeBar, ke = Y.activeShape, Re = !!(!ae && Q && se && (te || De || ke)), Te = {};
          H !== "axis" && se && se.props.trigger === "click" ? Te = {
            onClick: dE(T.handleItemMouseEnter, M.props.onClick)
          } : H !== "axis" && (Te = {
            onMouseLeave: dE(T.handleItemMouseLeave, M.props.onMouseLeave),
            onMouseEnter: dE(T.handleItemMouseEnter, M.props.onMouseEnter)
          });
          var we = /* @__PURE__ */ ee.cloneElement(M, je(je({}, V.props), Te));
          function Fe(Ut) {
            return typeof W.dataKey == "function" ? W.dataKey(Ut.payload) : null;
          }
          if (Re)
            if (J >= 0) {
              var Ye, de;
              if (W.dataKey && !W.allowDuplicatedCategory) {
                var Ze = typeof W.dataKey == "function" ? Fe : "payload.".concat(W.dataKey.toString());
                Ye = wS(fe, Ze, ne), de = Z && z && wS(z, Ze, ne);
              } else
                Ye = fe == null ? void 0 : fe[J], de = Z && z && z[J];
              if (ke || De) {
                var Ne = M.props.activeIndex !== void 0 ? M.props.activeIndex : J;
                return [/* @__PURE__ */ ee.cloneElement(M, je(je(je({}, V.props), Te), {}, {
                  activeIndex: Ne
                })), null, null];
              }
              if (!lr(Ye))
                return [we].concat(N0(T.renderActivePoints({
                  item: V,
                  activePoint: Ye,
                  basePoint: de,
                  childIndex: J,
                  isRange: Z
                })));
            } else {
              var Ot, At = (Ot = T.getItemByXY(T.state.activeCoordinate)) !== null && Ot !== void 0 ? Ot : {
                graphicalItem: we
              }, Qt = At.graphicalItem, Wr = Qt.item, Ar = Wr === void 0 ? M : Wr, Dr = Qt.childIndex, Vt = je(je(je({}, V.props), Te), {}, {
                activeIndex: Dr
              });
              return [/* @__PURE__ */ ee.cloneElement(Ar, Vt), null, null];
            }
          return Z ? [we, null, null] : [we, null];
        }), Nt(T, "renderCustomized", function(M, F, B) {
          return /* @__PURE__ */ ee.cloneElement(M, je(je({
            key: "recharts-customized-".concat(B)
          }, T.props), T.state));
        }), Nt(T, "renderMap", {
          CartesianGrid: {
            handler: xE,
            once: !0
          },
          ReferenceArea: {
            handler: T.renderReferenceElement
          },
          ReferenceLine: {
            handler: xE
          },
          ReferenceDot: {
            handler: T.renderReferenceElement
          },
          XAxis: {
            handler: xE
          },
          YAxis: {
            handler: xE
          },
          Brush: {
            handler: T.renderBrush,
            once: !0
          },
          Bar: {
            handler: T.renderGraphicChild
          },
          Line: {
            handler: T.renderGraphicChild
          },
          Area: {
            handler: T.renderGraphicChild
          },
          Radar: {
            handler: T.renderGraphicChild
          },
          RadialBar: {
            handler: T.renderGraphicChild
          },
          Scatter: {
            handler: T.renderGraphicChild
          },
          Pie: {
            handler: T.renderGraphicChild
          },
          Funnel: {
            handler: T.renderGraphicChild
          },
          Tooltip: {
            handler: T.renderCursor,
            once: !0
          },
          PolarGrid: {
            handler: T.renderPolarGrid,
            once: !0
          },
          PolarAngleAxis: {
            handler: T.renderPolarAxis
          },
          PolarRadiusAxis: {
            handler: T.renderPolarAxis
          },
          Customized: {
            handler: T.renderCustomized
          }
        }), T.clipPathId = "".concat((A = D.id) !== null && A !== void 0 ? A : Hx("recharts"), "-clip"), T.throttleTriggeredAfterMouseMove = IV(T.triggeredAfterMouseMove, (R = D.throttleDelay) !== null && R !== void 0 ? R : 1e3 / 60), T.state = {}, T;
      }
      return f_e(k, S), u_e(k, [{
        key: "componentDidMount",
        value: function() {
          var A, R;
          this.addListener(), this.accessibilityManager.setDetails({
            container: this.container,
            offset: {
              left: (A = this.props.margin.left) !== null && A !== void 0 ? A : 0,
              top: (R = this.props.margin.top) !== null && R !== void 0 ? R : 0
            },
            coordinateList: this.state.tooltipTicks,
            mouseHandlerCallback: this.triggeredAfterMouseMove,
            layout: this.props.layout
          }), this.displayDefaultTooltip();
        }
      }, {
        key: "displayDefaultTooltip",
        value: function() {
          var A = this.props, R = A.children, T = A.data, M = A.height, F = A.layout, B = $o(R, os);
          if (B) {
            var V = B.props.defaultIndex;
            if (!(typeof V != "number" || V < 0 || V > this.state.tooltipTicks.length - 1)) {
              var H = this.state.tooltipTicks[V] && this.state.tooltipTicks[V].value, q = rN(this.state, T, V, H), Q = this.state.tooltipTicks[V].coordinate, W = (this.state.offset.top + M) / 2, J = F === "horizontal", ne = J ? {
                x: Q,
                y: W
              } : {
                y: Q,
                x: W
              }, ie = this.state.formattedGraphicalItems.find(function(X) {
                var fe = X.item;
                return fe.type.name === "Scatter";
              });
              ie && (ne = je(je({}, ne), ie.props.points[V].tooltipPosition), q = ie.props.points[V].tooltipPayload);
              var se = {
                activeTooltipIndex: V,
                isTooltipActive: !0,
                activeLabel: H,
                activePayload: q,
                activeCoordinate: ne
              };
              this.setState(se), this.renderCursor(B), this.accessibilityManager.setIndex(V);
            }
          }
        }
      }, {
        key: "getSnapshotBeforeUpdate",
        value: function(A, R) {
          if (!this.props.accessibilityLayer)
            return null;
          if (this.state.tooltipTicks !== R.tooltipTicks && this.accessibilityManager.setDetails({
            coordinateList: this.state.tooltipTicks
          }), this.props.layout !== A.layout && this.accessibilityManager.setDetails({
            layout: this.props.layout
          }), this.props.margin !== A.margin) {
            var T, M;
            this.accessibilityManager.setDetails({
              offset: {
                left: (T = this.props.margin.left) !== null && T !== void 0 ? T : 0,
                top: (M = this.props.margin.top) !== null && M !== void 0 ? M : 0
              }
            });
          }
          return null;
        }
      }, {
        key: "componentDidUpdate",
        value: function(A) {
          zP([$o(A.children, os)], [$o(this.props.children, os)]) || this.displayDefaultTooltip();
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
        }
      }, {
        key: "getTooltipEventType",
        value: function() {
          var A = $o(this.props.children, os);
          if (A && typeof A.props.shared == "boolean") {
            var R = A.props.shared ? "axis" : "item";
            return c.indexOf(R) >= 0 ? R : u;
          }
          return u;
        }
        /**
         * Get the information of mouse in chart, return null when the mouse is not in the chart
         * @param  {MousePointer} event    The event object
         * @return {Object}          Mouse data
         */
      }, {
        key: "getMouseInfo",
        value: function(A) {
          if (!this.container)
            return null;
          var R = this.container, T = R.getBoundingClientRect(), M = ghe(T), F = {
            chartX: Math.round(A.pageX - M.left),
            chartY: Math.round(A.pageY - M.top)
          }, B = T.width / R.offsetWidth || 1, V = this.inRange(F.chartX, F.chartY, B);
          if (!V)
            return null;
          var H = this.state, q = H.xAxisMap, Q = H.yAxisMap, W = this.getTooltipEventType(), J = K7(this.state, this.props.data, this.props.layout, V);
          if (W !== "axis" && q && Q) {
            var ne = Nf(q).scale, ie = Nf(Q).scale, se = ne && ne.invert ? ne.invert(F.chartX) : null, X = ie && ie.invert ? ie.invert(F.chartY) : null;
            return je(je({}, F), {}, {
              xValue: se,
              yValue: X
            }, J);
          }
          return J ? je(je({}, F), J) : null;
        }
      }, {
        key: "inRange",
        value: function(A, R) {
          var T = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, M = this.props.layout, F = A / T, B = R / T;
          if (M === "horizontal" || M === "vertical") {
            var V = this.state.offset, H = F >= V.left && F <= V.left + V.width && B >= V.top && B <= V.top + V.height;
            return H ? {
              x: F,
              y: B
            } : null;
          }
          var q = this.state, Q = q.angleAxisMap, W = q.radiusAxisMap;
          if (Q && W) {
            var J = Nf(Q);
            return nq({
              x: F,
              y: B
            }, J);
          }
          return null;
        }
      }, {
        key: "parseEventsOfWrapper",
        value: function() {
          var A = this.props.children, R = this.getTooltipEventType(), T = $o(A, os), M = {};
          T && R === "axis" && (T.props.trigger === "click" ? M = {
            onClick: this.handleClick
          } : M = {
            onMouseEnter: this.handleMouseEnter,
            onDoubleClick: this.handleDoubleClick,
            onMouseMove: this.handleMouseMove,
            onMouseLeave: this.handleMouseLeave,
            onTouchMove: this.handleTouchMove,
            onTouchStart: this.handleTouchStart,
            onTouchEnd: this.handleTouchEnd,
            onContextMenu: this.handleContextMenu
          });
          var F = ES(this.props, this.handleOuterEvent);
          return je(je({}, F), M);
        }
      }, {
        key: "addListener",
        value: function() {
          eP.on(tP, this.handleReceiveSyncEvent);
        }
      }, {
        key: "removeListener",
        value: function() {
          eP.removeListener(tP, this.handleReceiveSyncEvent);
        }
      }, {
        key: "filterFormatItem",
        value: function(A, R, T) {
          for (var M = this.state.formattedGraphicalItems, F = 0, B = M.length; F < B; F++) {
            var V = M[F];
            if (V.item === A || V.props.key === A.key || R === vc(V.item.type) && T === V.childIndex)
              return V;
          }
          return null;
        }
      }, {
        key: "renderClipPath",
        value: function() {
          var A = this.clipPathId, R = this.state.offset, T = R.left, M = R.top, F = R.height, B = R.width;
          return /* @__PURE__ */ ce.createElement("defs", null, /* @__PURE__ */ ce.createElement("clipPath", {
            id: A
          }, /* @__PURE__ */ ce.createElement("rect", {
            x: T,
            y: M,
            height: F,
            width: B
          })));
        }
      }, {
        key: "getXScales",
        value: function() {
          var A = this.state.xAxisMap;
          return A ? Object.entries(A).reduce(function(R, T) {
            var M = Y7(T, 2), F = M[0], B = M[1];
            return je(je({}, R), {}, Nt({}, F, B.scale));
          }, {}) : null;
        }
      }, {
        key: "getYScales",
        value: function() {
          var A = this.state.yAxisMap;
          return A ? Object.entries(A).reduce(function(R, T) {
            var M = Y7(T, 2), F = M[0], B = M[1];
            return je(je({}, R), {}, Nt({}, F, B.scale));
          }, {}) : null;
        }
      }, {
        key: "getXScaleByAxisId",
        value: function(A) {
          var R;
          return (R = this.state.xAxisMap) === null || R === void 0 || (R = R[A]) === null || R === void 0 ? void 0 : R.scale;
        }
      }, {
        key: "getYScaleByAxisId",
        value: function(A) {
          var R;
          return (R = this.state.yAxisMap) === null || R === void 0 || (R = R[A]) === null || R === void 0 ? void 0 : R.scale;
        }
      }, {
        key: "getItemByXY",
        value: function(A) {
          var R = this.state, T = R.formattedGraphicalItems, M = R.activeItem;
          if (T && T.length)
            for (var F = 0, B = T.length; F < B; F++) {
              var V = T[F], H = V.props, q = V.item, Q = q.type.defaultProps !== void 0 ? je(je({}, q.type.defaultProps), q.props) : q.props, W = vc(q.type);
              if (W === "Bar") {
                var J = (H.data || []).find(function(X) {
                  return $be(A, X);
                });
                if (J)
                  return {
                    graphicalItem: V,
                    payload: J
                  };
              } else if (W === "RadialBar") {
                var ne = (H.data || []).find(function(X) {
                  return nq(A, X);
                });
                if (ne)
                  return {
                    graphicalItem: V,
                    payload: ne
                  };
              } else if (oC(V, M) || uC(V, M) || Ax(V, M)) {
                var ie = k1e({
                  graphicalItem: V,
                  activeTooltipItem: M,
                  itemData: Q.data
                }), se = Q.activeIndex === void 0 ? ie : Q.activeIndex;
                return {
                  graphicalItem: je(je({}, V), {}, {
                    childIndex: se
                  }),
                  payload: Ax(V, M) ? Q.data[ie] : V.props.data[ie]
                };
              }
            }
          return null;
        }
      }, {
        key: "render",
        value: function() {
          var A = this;
          if (!h6(this))
            return null;
          var R = this.props, T = R.children, M = R.className, F = R.width, B = R.height, V = R.style, H = R.compact, q = R.title, Q = R.desc, W = G7(R, e_e), J = pr(W, !1);
          if (H)
            return /* @__PURE__ */ ce.createElement(A7, {
              state: this.state,
              width: this.props.width,
              height: this.props.height,
              clipPathId: this.clipPathId
            }, /* @__PURE__ */ ce.createElement(UP, Qv({}, J, {
              width: F,
              height: B,
              title: q,
              desc: Q
            }), this.renderClipPath(), m6(T, this.renderMap)));
          if (this.props.accessibilityLayer) {
            var ne, ie;
            J.tabIndex = (ne = this.props.tabIndex) !== null && ne !== void 0 ? ne : 0, J.role = (ie = this.props.role) !== null && ie !== void 0 ? ie : "application", J.onKeyDown = function(X) {
              A.accessibilityManager.keyboardEvent(X);
            }, J.onFocus = function() {
              A.accessibilityManager.focus();
            };
          }
          var se = this.parseEventsOfWrapper();
          return /* @__PURE__ */ ce.createElement(A7, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ ce.createElement("div", Qv({
            className: hr("recharts-wrapper", M),
            style: je({
              position: "relative",
              cursor: "default",
              width: F,
              height: B
            }, V)
          }, se, {
            ref: function(fe) {
              A.container = fe;
            }
          }), /* @__PURE__ */ ce.createElement(UP, Qv({}, J, {
            width: F,
            height: B,
            title: q,
            desc: Q,
            style: y_e
          }), this.renderClipPath(), m6(T, this.renderMap)), this.renderLegend(), this.renderTooltip()));
        }
      }]);
    }(ee.Component);
    Nt(E, "displayName", r), Nt(E, "defaultProps", je({
      layout: "horizontal",
      stackOffset: "none",
      barCategoryGap: "10%",
      barGap: 4,
      margin: {
        top: 5,
        right: 5,
        bottom: 5,
        left: 5
      },
      reverseStackOrder: !1,
      syncMethod: "index"
    }, y)), Nt(E, "getDerivedStateFromProps", function(S, k) {
      var D = S.dataKey, A = S.data, R = S.children, T = S.width, M = S.height, F = S.layout, B = S.stackOffset, V = S.margin, H = k.dataStartIndex, q = k.dataEndIndex;
      if (k.updateId === void 0) {
        var Q = X7(S);
        return je(je(je({}, Q), {}, {
          updateId: 0
        }, w(je(je({
          props: S
        }, Q), {}, {
          updateId: 0
        }), k)), {}, {
          prevDataKey: D,
          prevData: A,
          prevWidth: T,
          prevHeight: M,
          prevLayout: F,
          prevStackOffset: B,
          prevMargin: V,
          prevChildren: R
        });
      }
      if (D !== k.prevDataKey || A !== k.prevData || T !== k.prevWidth || M !== k.prevHeight || F !== k.prevLayout || B !== k.prevStackOffset || !e0(V, k.prevMargin)) {
        var W = X7(S), J = {
          // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
          // any flickering
          chartX: k.chartX,
          chartY: k.chartY,
          // The tooltip should stay active when it was active in the previous render. If this is not
          // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
          isTooltipActive: k.isTooltipActive
        }, ne = je(je({}, K7(k, A, F)), {}, {
          updateId: k.updateId + 1
        }), ie = je(je(je({}, W), J), ne);
        return je(je(je({}, ie), w(je({
          props: S
        }, ie), k)), {}, {
          prevDataKey: D,
          prevData: A,
          prevWidth: T,
          prevHeight: M,
          prevLayout: F,
          prevStackOffset: B,
          prevMargin: V,
          prevChildren: R
        });
      }
      if (!zP(R, k.prevChildren)) {
        var se, X, fe, Z, z = $o(R, E0), Y = z && (se = (X = z.props) === null || X === void 0 ? void 0 : X.startIndex) !== null && se !== void 0 ? se : H, te = z && (fe = (Z = z.props) === null || Z === void 0 ? void 0 : Z.endIndex) !== null && fe !== void 0 ? fe : q, ae = Y !== H || te !== q, De = !lr(A), ke = De && !ae ? k.updateId : k.updateId + 1;
        return je(je({
          updateId: ke
        }, w(je(je({
          props: S
        }, k), {}, {
          updateId: ke,
          dataStartIndex: Y,
          dataEndIndex: te
        }), k)), {}, {
          prevChildren: R,
          dataStartIndex: Y,
          dataEndIndex: te
        });
      }
      return null;
    }), Nt(E, "renderActiveDot", function(S, k, D) {
      var A;
      return /* @__PURE__ */ ee.isValidElement(S) ? A = /* @__PURE__ */ ee.cloneElement(S, k) : er(S) ? A = S(k) : A = /* @__PURE__ */ ce.createElement(Vj, k), /* @__PURE__ */ ce.createElement(ei, {
        className: "recharts-active-dot",
        key: D
      }, A);
    });
    var C = /* @__PURE__ */ ee.forwardRef(function(k, D) {
      return /* @__PURE__ */ ce.createElement(E, Qv({}, k, {
        ref: D
      }));
    });
    return C.displayName = E.displayName, C;
  }, T_e = QY({
    chartName: "LineChart",
    GraphicalChild: k0,
    axisComponents: [{
      axisType: "xAxis",
      AxisComp: tm
    }, {
      axisType: "yAxis",
      AxisComp: rm
    }],
    formatAxisMap: dY
  }), A_e = QY({
    chartName: "BarChart",
    GraphicalChild: Yp,
    defaultTooltipEventType: "axis",
    validateTooltipEventTypes: ["axis", "item"],
    axisComponents: [{
      axisType: "xAxis",
      AxisComp: tm
    }, {
      axisType: "yAxis",
      AxisComp: rm
    }],
    formatAxisMap: dY
  });
  const D_e = { light: "", dark: ".dark" }, k_e = ee.createContext(null);
  function KY({
    id: e,
    className: t,
    children: r,
    config: n,
    ...i
  }) {
    const u = ee.useId(), s = `chart-${e || u.replace(/:/g, "")}`;
    return /* @__PURE__ */ me.jsx(k_e.Provider, { value: { config: n }, children: /* @__PURE__ */ me.jsxs(
      "div",
      {
        "data-slot": "chart",
        "data-chart": s,
        className: vs(
          "[&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border flex aspect-video justify-center text-xs [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-hidden [&_.recharts-sector]:outline-hidden [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-surface]:outline-hidden",
          t
        ),
        ...i,
        children: [
          /* @__PURE__ */ me.jsx(R_e, { id: s, config: n }),
          /* @__PURE__ */ me.jsx(fhe, { children: r })
        ]
      }
    ) });
  }
  const R_e = ({ id: e, config: t }) => {
    const r = Object.entries(t).filter(([, n]) => n.theme || n.color);
    return r.length ? /* @__PURE__ */ me.jsx(
      "style",
      {
        dangerouslySetInnerHTML: {
          __html: Object.entries(D_e).map(
            ([n, i]) => `
${i} [data-chart=${e}] {
${r.map(([u, s]) => {
              var p;
              const c = ((p = s.theme) == null ? void 0 : p[n]) || s.color;
              return c ? `  --color-${u}: ${c};` : null;
            }).join(`
`)}
}
`
          ).join(`
`)
        }
      }
    ) : null;
  }, P_e = (e) => ({ active: t, payload: r, label: n }) => !t || !r ? null : /* @__PURE__ */ me.jsx("div", { className: "bg-white rounded-md border-1 border-neutral-200 p-2 text-xs flex flex-col gap-4", children: r.map((i) => {
    var u;
    return /* @__PURE__ */ me.jsxs("div", { className: "flex flex-col items-start justify-start text-neutral-900", children: [
      /* @__PURE__ */ me.jsx("span", { className: "font-bold mb-1.5", children: e(n) }),
      /* @__PURE__ */ me.jsxs("div", { className: "flex flex-row items-center justify-start font-normal text-neutral-700", children: [
        /* @__PURE__ */ me.jsx("span", { className: "mr-2", children: "Visits" }),
        /* @__PURE__ */ me.jsx("span", { children: (u = i.value) == null ? void 0 : u.toLocaleString() })
      ] })
    ] }, i.dataKey);
  }) }), M_e = (e) => (t) => {
    const { x: r, y: n, width: i, height: u, value: s, background: c } = t, p = s === e, h = s === 0, v = 4, y = h ? v : v + u, x = c.y + c.height, w = h ? x - v : n - v, E = p && e !== 0 ? "fill-purple-600" : "fill-neutral-300";
    return /* @__PURE__ */ me.jsx("rect", { x: r, y: w, width: i, height: y, rx: h ? 2 : 4, className: E });
  }, N_e = (e) => ({ x: t, y: r, payload: n }) => {
    const i = e(n.value);
    return /* @__PURE__ */ me.jsx("g", { transform: `translate(${t},${r})`, children: /* @__PURE__ */ me.jsx("text", { x: 0, y: 0, dy: 8, textAnchor: "middle", className: "text-sm text-neutral-500", children: i }) });
  }, XY = ({
    xAxisKey: e,
    maxCount: t,
    xAxisTickInterval: r,
    data: n,
    xAxisTextHandler: i,
    tooltipTextHandler: u
  }) => /* @__PURE__ */ me.jsx(KY, { "aria-label": `Most popular ${e} chart`, className: "h-72 w-full", config: {}, children: /* @__PURE__ */ me.jsxs(A_e, { accessibilityLayer: !0, data: n, margin: { top: 5, right: 0, left: 10, bottom: 0 }, barCategoryGap: "16%", children: [
    /* @__PURE__ */ me.jsx(os, { content: P_e(u), cursor: !1 }),
    /* @__PURE__ */ me.jsx(
      tm,
      {
        dataKey: e,
        tickLine: !1,
        tickMargin: 8,
        axisLine: !1,
        tick: N_e(i),
        interval: r
      }
    ),
    /* @__PURE__ */ me.jsx(rm, { domain: [0, t], hide: !0 }),
    /* @__PURE__ */ me.jsx(Yp, { dataKey: "visits", shape: M_e(t) })
  ] }) }), ZY = () => /* @__PURE__ */ me.jsxs("div", { className: "flex flex-row items-center gap-1", children: [
    /* @__PURE__ */ me.jsxs("p", { children: [
      "Based on last 90 days of ",
      /* @__PURE__ */ me.jsx("u", { children: "live data" }),
      " received"
    ] }),
    /* @__PURE__ */ me.jsx(
      Ale,
      {
        trigger: /* @__PURE__ */ me.jsx(aue, { className: "stroke-current w-5 h-5" }),
        content: /* @__PURE__ */ me.jsx("p", { children: "Live data sources: QR code, manual check-in, and API-linked gym management software." })
      }
    )
  ] }), j_e = (e, t) => {
    if (e === 0)
      return "Popular day for visits: Unknown";
    const r = t.map((u) => `${u}s`), n = lue(r), i = t.length === 1 ? "day" : "days";
    return `${n} are the most popular ${i} for Fitness Passport visits.`;
  }, F_e = (e) => {
    let t = -1 / 0, r = [];
    for (const { day: n, visits: i } of e)
      i > t ? (t = i, r = [n]) : i === t && r.push(n);
    return { maxCount: t, daysWithMaxCount: r };
  }, I_e = ({ data: e }) => {
    const { maxCount: t, daysWithMaxCount: r } = ee.useMemo(() => F_e(e), [e]), n = ee.useMemo(() => j_e(t, r), [t, r]);
    return /* @__PURE__ */ me.jsx(FN, { title: n, description: /* @__PURE__ */ me.jsx(ZY, {}), children: /* @__PURE__ */ me.jsx(
      XY,
      {
        xAxisKey: "day",
        maxCount: t,
        xAxisTickInterval: 0,
        data: e,
        xAxisTextHandler: (i) => i.slice(0, 1).toUpperCase(),
        tooltipTextHandler: (i) => i
      }
    ) });
  }, B_e = (e, t) => e === 0 ? "Popular hour for visits: Unknown" : `Most popular ${t.length > 1 ? "hours" : "hour"} for Fitness Passport visits.`, L_e = (e) => {
    let t = -1 / 0, r = [];
    for (const { hour: n, visits: i } of e)
      i > t ? (t = i, r = [n]) : i === t && r.push(n);
    return { maxCount: t, hoursWithMaxCount: r };
  }, $_e = ({ data: e }) => {
    const { maxCount: t, hoursWithMaxCount: r } = ee.useMemo(() => L_e(e), [e]), n = ee.useMemo(() => B_e(t, r), [t, r]), i = (u) => `${u}:00`;
    return /* @__PURE__ */ me.jsx(FN, { title: n, description: /* @__PURE__ */ me.jsx(ZY, {}), children: /* @__PURE__ */ me.jsx(
      XY,
      {
        xAxisKey: "hour",
        maxCount: t,
        xAxisTickInterval: 5,
        data: e,
        xAxisTextHandler: i,
        tooltipTextHandler: i
      }
    ) });
  };
  function z_e(e) {
    const t = ee.useRef({ value: e, previous: e });
    return ee.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
  }
  var hC = "Switch", [q_e, ZTe] = U0(hC), [U_e, H_e] = q_e(hC), JY = ee.forwardRef(
    (e, t) => {
      const {
        __scopeSwitch: r,
        name: n,
        checked: i,
        defaultChecked: u,
        required: s,
        disabled: c,
        value: p = "on",
        onCheckedChange: h,
        form: v,
        ...y
      } = e, [x, w] = ee.useState(null), E = Ou(t, (A) => w(A)), C = ee.useRef(!1), S = x ? v || !!x.closest("form") : !0, [k, D] = W0({
        prop: i,
        defaultProp: u ?? !1,
        onChange: h,
        caller: hC
      });
      return /* @__PURE__ */ me.jsxs(U_e, { scope: r, checked: k, disabled: c, children: [
        /* @__PURE__ */ me.jsx(
          Ga.button,
          {
            type: "button",
            role: "switch",
            "aria-checked": k,
            "aria-required": s,
            "data-state": nG(k),
            "data-disabled": c ? "" : void 0,
            disabled: c,
            value: p,
            ...y,
            ref: E,
            onClick: aa(e.onClick, (A) => {
              D((R) => !R), S && (C.current = A.isPropagationStopped(), C.current || A.stopPropagation());
            })
          }
        ),
        S && /* @__PURE__ */ me.jsx(
          rG,
          {
            control: x,
            bubbles: !C.current,
            name: n,
            value: p,
            checked: k,
            required: s,
            disabled: c,
            form: v,
            style: { transform: "translateX(-100%)" }
          }
        )
      ] });
    }
  );
  JY.displayName = hC;
  var eG = "SwitchThumb", tG = ee.forwardRef(
    (e, t) => {
      const { __scopeSwitch: r, ...n } = e, i = H_e(eG, r);
      return /* @__PURE__ */ me.jsx(
        Ga.span,
        {
          "data-state": nG(i.checked),
          "data-disabled": i.disabled ? "" : void 0,
          ...n,
          ref: t
        }
      );
    }
  );
  tG.displayName = eG;
  var V_e = "SwitchBubbleInput", rG = ee.forwardRef(
    ({
      __scopeSwitch: e,
      control: t,
      checked: r,
      bubbles: n = !0,
      ...i
    }, u) => {
      const s = ee.useRef(null), c = Ou(s, u), p = z_e(r), h = yH(t);
      return ee.useEffect(() => {
        const v = s.current;
        if (!v) return;
        const y = window.HTMLInputElement.prototype, w = Object.getOwnPropertyDescriptor(
          y,
          "checked"
        ).set;
        if (p !== r && w) {
          const E = new Event("click", { bubbles: n });
          w.call(v, r), v.dispatchEvent(E);
        }
      }, [p, r, n]), /* @__PURE__ */ me.jsx(
        "input",
        {
          type: "checkbox",
          "aria-hidden": !0,
          defaultChecked: r,
          ...i,
          tabIndex: -1,
          ref: c,
          style: {
            ...i.style,
            ...h,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
          }
        }
      );
    }
  );
  rG.displayName = V_e;
  function nG(e) {
    return e ? "checked" : "unchecked";
  }
  var W_e = JY, Y_e = tG;
  function G_e({ className: e, ...t }) {
    return /* @__PURE__ */ me.jsx(
      W_e,
      {
        "data-slot": "switch",
        className: vs(
          "peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-input focus-visible:border-ring focus-visible:ring-ring/50 dark:data-[state=unchecked]:bg-input/80 inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
          e
        ),
        ...t,
        children: /* @__PURE__ */ me.jsx(
          Y_e,
          {
            "data-slot": "switch-thumb",
            className: vs(
              "bg-background dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0"
            )
          }
        )
      }
    );
  }
  const Q_e = ({ id: e, checked: t, onCheckedChange: r }) => /* @__PURE__ */ me.jsx(
    G_e,
    {
      id: e,
      checked: t,
      onCheckedChange: r,
      className: "bg-white h-6 w-11 p-0.5 data-[state=checked]:bg-primary-600 [&>span]:data-[state=unchecked]:bg-white [&>span]:h-5 [&>span]:w-5"
    }
  );
  function K_e(e) {
    const t = e + "CollectionProvider", [r, n] = U0(t), [i, u] = r(
      t,
      { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
    ), s = (C) => {
      const { scope: S, children: k } = C, D = ce.useRef(null), A = ce.useRef(/* @__PURE__ */ new Map()).current;
      return /* @__PURE__ */ me.jsx(i, { scope: S, itemMap: A, collectionRef: D, children: k });
    };
    s.displayName = t;
    const c = e + "CollectionSlot", p = /* @__PURE__ */ PP(c), h = ce.forwardRef(
      (C, S) => {
        const { scope: k, children: D } = C, A = u(c, k), R = Ou(S, A.collectionRef);
        return /* @__PURE__ */ me.jsx(p, { ref: R, children: D });
      }
    );
    h.displayName = c;
    const v = e + "CollectionItemSlot", y = "data-radix-collection-item", x = /* @__PURE__ */ PP(v), w = ce.forwardRef(
      (C, S) => {
        const { scope: k, children: D, ...A } = C, R = ce.useRef(null), T = Ou(S, R), M = u(v, k);
        return ce.useEffect(() => (M.itemMap.set(R, { ref: R, ...A }), () => void M.itemMap.delete(R))), /* @__PURE__ */ me.jsx(x, { [y]: "", ref: T, children: D });
      }
    );
    w.displayName = v;
    function E(C) {
      const S = u(e + "CollectionConsumer", C);
      return ce.useCallback(() => {
        const D = S.collectionRef.current;
        if (!D) return [];
        const A = Array.from(D.querySelectorAll(`[${y}]`));
        return Array.from(S.itemMap.values()).sort(
          (M, F) => A.indexOf(M.ref.current) - A.indexOf(F.ref.current)
        );
      }, [S.collectionRef, S.itemMap]);
    }
    return [
      { Provider: s, Slot: h, ItemSlot: w },
      E,
      n
    ];
  }
  var X_e = ee.createContext(void 0);
  function iG(e) {
    const t = ee.useContext(X_e);
    return e || t || "ltr";
  }
  var nP = "rovingFocusGroup.onEntryFocus", Z_e = { bubbles: !1, cancelable: !0 }, Xx = "RovingFocusGroup", [nN, aG, J_e] = K_e(Xx), [eCe, oG] = U0(
    Xx,
    [J_e]
  ), [tCe, rCe] = eCe(Xx), uG = ee.forwardRef(
    (e, t) => /* @__PURE__ */ me.jsx(nN.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ me.jsx(nN.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ me.jsx(nCe, { ...e, ref: t }) }) })
  );
  uG.displayName = Xx;
  var nCe = ee.forwardRef((e, t) => {
    const {
      __scopeRovingFocusGroup: r,
      orientation: n,
      loop: i = !1,
      dir: u,
      currentTabStopId: s,
      defaultCurrentTabStopId: c,
      onCurrentTabStopIdChange: p,
      onEntryFocus: h,
      preventScrollOnEntryFocus: v = !1,
      ...y
    } = e, x = ee.useRef(null), w = Ou(t, x), E = iG(u), [C, S] = W0({
      prop: s,
      defaultProp: c ?? null,
      onChange: p,
      caller: Xx
    }), [k, D] = ee.useState(!1), A = Lx(h), R = aG(r), T = ee.useRef(!1), [M, F] = ee.useState(0);
    return ee.useEffect(() => {
      const B = x.current;
      if (B)
        return B.addEventListener(nP, A), () => B.removeEventListener(nP, A);
    }, [A]), /* @__PURE__ */ me.jsx(
      tCe,
      {
        scope: r,
        orientation: n,
        dir: E,
        loop: i,
        currentTabStopId: C,
        onItemFocus: ee.useCallback(
          (B) => S(B),
          [S]
        ),
        onItemShiftTab: ee.useCallback(() => D(!0), []),
        onFocusableItemAdd: ee.useCallback(
          () => F((B) => B + 1),
          []
        ),
        onFocusableItemRemove: ee.useCallback(
          () => F((B) => B - 1),
          []
        ),
        children: /* @__PURE__ */ me.jsx(
          Ga.div,
          {
            tabIndex: k || M === 0 ? -1 : 0,
            "data-orientation": n,
            ...y,
            ref: w,
            style: { outline: "none", ...e.style },
            onMouseDown: aa(e.onMouseDown, () => {
              T.current = !0;
            }),
            onFocus: aa(e.onFocus, (B) => {
              const V = !T.current;
              if (B.target === B.currentTarget && V && !k) {
                const H = new CustomEvent(nP, Z_e);
                if (B.currentTarget.dispatchEvent(H), !H.defaultPrevented) {
                  const q = R().filter((ie) => ie.focusable), Q = q.find((ie) => ie.active), W = q.find((ie) => ie.id === C), ne = [Q, W, ...q].filter(
                    Boolean
                  ).map((ie) => ie.ref.current);
                  cG(ne, v);
                }
              }
              T.current = !1;
            }),
            onBlur: aa(e.onBlur, () => D(!1))
          }
        )
      }
    );
  }), sG = "RovingFocusGroupItem", lG = ee.forwardRef(
    (e, t) => {
      const {
        __scopeRovingFocusGroup: r,
        focusable: n = !0,
        active: i = !1,
        tabStopId: u,
        children: s,
        ...c
      } = e, p = aH(), h = u || p, v = rCe(sG, r), y = v.currentTabStopId === h, x = aG(r), { onFocusableItemAdd: w, onFocusableItemRemove: E, currentTabStopId: C } = v;
      return ee.useEffect(() => {
        if (n)
          return w(), () => E();
      }, [n, w, E]), /* @__PURE__ */ me.jsx(
        nN.ItemSlot,
        {
          scope: r,
          id: h,
          focusable: n,
          active: i,
          children: /* @__PURE__ */ me.jsx(
            Ga.span,
            {
              tabIndex: y ? 0 : -1,
              "data-orientation": v.orientation,
              ...c,
              ref: t,
              onMouseDown: aa(e.onMouseDown, (S) => {
                n ? v.onItemFocus(h) : S.preventDefault();
              }),
              onFocus: aa(e.onFocus, () => v.onItemFocus(h)),
              onKeyDown: aa(e.onKeyDown, (S) => {
                if (S.key === "Tab" && S.shiftKey) {
                  v.onItemShiftTab();
                  return;
                }
                if (S.target !== S.currentTarget) return;
                const k = oCe(S, v.orientation, v.dir);
                if (k !== void 0) {
                  if (S.metaKey || S.ctrlKey || S.altKey || S.shiftKey) return;
                  S.preventDefault();
                  let A = x().filter((R) => R.focusable).map((R) => R.ref.current);
                  if (k === "last") A.reverse();
                  else if (k === "prev" || k === "next") {
                    k === "prev" && A.reverse();
                    const R = A.indexOf(S.currentTarget);
                    A = v.loop ? uCe(A, R + 1) : A.slice(R + 1);
                  }
                  setTimeout(() => cG(A));
                }
              }),
              children: typeof s == "function" ? s({ isCurrentTabStop: y, hasTabStop: C != null }) : s
            }
          )
        }
      );
    }
  );
  lG.displayName = sG;
  var iCe = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
  };
  function aCe(e, t) {
    return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
  }
  function oCe(e, t, r) {
    const n = aCe(e.key, r);
    if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(n)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(n)))
      return iCe[n];
  }
  function cG(e, t = !1) {
    const r = document.activeElement;
    for (const n of e)
      if (n === r || (n.focus({ preventScroll: t }), document.activeElement !== r)) return;
  }
  function uCe(e, t) {
    return e.map((r, n) => e[(t + n) % e.length]);
  }
  var sCe = uG, lCe = lG, fG = "Toggle", dG = ee.forwardRef((e, t) => {
    const { pressed: r, defaultPressed: n, onPressedChange: i, ...u } = e, [s, c] = W0({
      prop: r,
      onChange: i,
      defaultProp: n ?? !1,
      caller: fG
    });
    return /* @__PURE__ */ me.jsx(
      Ga.button,
      {
        type: "button",
        "aria-pressed": s,
        "data-state": s ? "on" : "off",
        "data-disabled": e.disabled ? "" : void 0,
        ...u,
        ref: t,
        onClick: aa(e.onClick, () => {
          e.disabled || c(!s);
        })
      }
    );
  });
  dG.displayName = fG;
  var Jf = "ToggleGroup", [pG, JTe] = U0(Jf, [
    oG
  ]), hG = oG(), tF = ce.forwardRef((e, t) => {
    const { type: r, ...n } = e;
    if (r === "single") {
      const i = n;
      return /* @__PURE__ */ me.jsx(cCe, { ...i, ref: t });
    }
    if (r === "multiple") {
      const i = n;
      return /* @__PURE__ */ me.jsx(fCe, { ...i, ref: t });
    }
    throw new Error(`Missing prop \`type\` expected on \`${Jf}\``);
  });
  tF.displayName = Jf;
  var [vG, mG] = pG(Jf), cCe = ce.forwardRef((e, t) => {
    const {
      value: r,
      defaultValue: n,
      onValueChange: i = () => {
      },
      ...u
    } = e, [s, c] = W0({
      prop: r,
      defaultProp: n ?? "",
      onChange: i,
      caller: Jf
    });
    return /* @__PURE__ */ me.jsx(
      vG,
      {
        scope: e.__scopeToggleGroup,
        type: "single",
        value: ce.useMemo(() => s ? [s] : [], [s]),
        onItemActivate: c,
        onItemDeactivate: ce.useCallback(() => c(""), [c]),
        children: /* @__PURE__ */ me.jsx(yG, { ...u, ref: t })
      }
    );
  }), fCe = ce.forwardRef((e, t) => {
    const {
      value: r,
      defaultValue: n,
      onValueChange: i = () => {
      },
      ...u
    } = e, [s, c] = W0({
      prop: r,
      defaultProp: n ?? [],
      onChange: i,
      caller: Jf
    }), p = ce.useCallback(
      (v) => c((y = []) => [...y, v]),
      [c]
    ), h = ce.useCallback(
      (v) => c((y = []) => y.filter((x) => x !== v)),
      [c]
    );
    return /* @__PURE__ */ me.jsx(
      vG,
      {
        scope: e.__scopeToggleGroup,
        type: "multiple",
        value: s,
        onItemActivate: p,
        onItemDeactivate: h,
        children: /* @__PURE__ */ me.jsx(yG, { ...u, ref: t })
      }
    );
  });
  tF.displayName = Jf;
  var [dCe, pCe] = pG(Jf), yG = ce.forwardRef(
    (e, t) => {
      const {
        __scopeToggleGroup: r,
        disabled: n = !1,
        rovingFocus: i = !0,
        orientation: u,
        dir: s,
        loop: c = !0,
        ...p
      } = e, h = hG(r), v = iG(s), y = { role: "group", dir: v, ...p };
      return /* @__PURE__ */ me.jsx(dCe, { scope: r, rovingFocus: i, disabled: n, children: i ? /* @__PURE__ */ me.jsx(
        sCe,
        {
          asChild: !0,
          ...h,
          orientation: u,
          dir: v,
          loop: c,
          children: /* @__PURE__ */ me.jsx(Ga.div, { ...y, ref: t })
        }
      ) : /* @__PURE__ */ me.jsx(Ga.div, { ...y, ref: t }) });
    }
  ), x_ = "ToggleGroupItem", gG = ce.forwardRef(
    (e, t) => {
      const r = mG(x_, e.__scopeToggleGroup), n = pCe(x_, e.__scopeToggleGroup), i = hG(e.__scopeToggleGroup), u = r.value.includes(e.value), s = n.disabled || e.disabled, c = { ...e, pressed: u, disabled: s }, p = ce.useRef(null);
      return n.rovingFocus ? /* @__PURE__ */ me.jsx(
        lCe,
        {
          asChild: !0,
          ...i,
          focusable: !s,
          active: u,
          ref: p,
          children: /* @__PURE__ */ me.jsx(J7, { ...c, ref: t })
        }
      ) : /* @__PURE__ */ me.jsx(J7, { ...c, ref: t });
    }
  );
  gG.displayName = x_;
  var J7 = ce.forwardRef(
    (e, t) => {
      const { __scopeToggleGroup: r, value: n, ...i } = e, u = mG(x_, r), s = { role: "radio", "aria-checked": e.pressed, "aria-pressed": void 0 }, c = u.type === "single" ? s : void 0;
      return /* @__PURE__ */ me.jsx(
        dG,
        {
          ...c,
          ...i,
          ref: t,
          onPressedChange: (p) => {
            p ? u.onItemActivate(n) : u.onItemDeactivate(n);
          }
        }
      );
    }
  ), hCe = tF, vCe = gG;
  const eU = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, tU = hr, mCe = (e, t) => (r) => {
    var n;
    if ((t == null ? void 0 : t.variants) == null) return tU(e, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
    const { variants: i, defaultVariants: u } = t, s = Object.keys(i).map((h) => {
      const v = r == null ? void 0 : r[h], y = u == null ? void 0 : u[h];
      if (v === null) return null;
      const x = eU(v) || eU(y);
      return i[h][x];
    }), c = r && Object.entries(r).reduce((h, v) => {
      let [y, x] = v;
      return x === void 0 || (h[y] = x), h;
    }, {}), p = t == null || (n = t.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((h, v) => {
      let { class: y, className: x, ...w } = v;
      return Object.entries(w).every((E) => {
        let [C, S] = E;
        return Array.isArray(S) ? S.includes({
          ...u,
          ...c
        }[C]) : {
          ...u,
          ...c
        }[C] === S;
      }) ? [
        ...h,
        y,
        x
      ] : h;
    }, []);
    return tU(e, s, p, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
  }, yCe = mCe(
    "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium hover:bg-muted hover:text-muted-foreground disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] outline-none transition-[color,box-shadow] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive whitespace-nowrap",
    {
      variants: {
        variant: {
          default: "bg-transparent",
          outline: "border border-input bg-transparent shadow-xs hover:bg-accent hover:text-accent-foreground"
        },
        size: {
          default: "h-9 px-2 min-w-9",
          sm: "h-8 px-1.5 min-w-8",
          lg: "h-10 px-2.5 min-w-10"
        }
      },
      defaultVariants: {
        variant: "default",
        size: "default"
      }
    }
  ), xG = ee.createContext({
    size: "default",
    variant: "default"
  });
  function gCe({
    className: e,
    variant: t,
    size: r,
    children: n,
    ...i
  }) {
    return /* @__PURE__ */ me.jsx(
      hCe,
      {
        "data-slot": "toggle-group",
        "data-variant": t,
        "data-size": r,
        className: vs(
          "group/toggle-group flex w-fit items-center rounded-md data-[variant=outline]:shadow-xs",
          e
        ),
        ...i,
        children: /* @__PURE__ */ me.jsx(xG.Provider, { value: { variant: t, size: r }, children: n })
      }
    );
  }
  function xCe({
    className: e,
    children: t,
    variant: r,
    size: n,
    ...i
  }) {
    const u = ee.useContext(xG);
    return /* @__PURE__ */ me.jsx(
      vCe,
      {
        "data-slot": "toggle-group-item",
        "data-variant": u.variant || r,
        "data-size": u.size || n,
        className: vs(
          yCe({
            variant: u.variant || r,
            size: u.size || n
          }),
          "min-w-0 flex-1 shrink-0 rounded-none shadow-none first:rounded-l-md last:rounded-r-md focus:z-10 focus-visible:z-10 data-[variant=outline]:border-l-0 data-[variant=outline]:first:border-l",
          e
        ),
        ...i,
        children: t
      }
    );
  }
  const bCe = ({ value: e, items: t, onValueChange: r }) => /* @__PURE__ */ me.jsx(
    gCe,
    {
      variant: "outline",
      className: "border-neutral-300",
      type: "single",
      value: e,
      onValueChange: r,
      children: t.map(({ label: n, value: i }) => /* @__PURE__ */ me.jsx(
        xCe,
        {
          className: "text-sm font-normal px-4 py-2 data-[state=on]:border-primary-600 data-[state=on]:bg-white data-[state=on]:border-2 data-[variant=outline]:data-[state=on]:border-l-2",
          value: i,
          "aria-label": n,
          children: n
        },
        i
      ))
    }
  ), bG = 6048e5, wCe = 864e5, ECe = 6e4, SCe = 36e5, _Ce = 1e3, rU = Symbol.for("constructDateFrom");
  function di(e, t) {
    return typeof e == "function" ? e(t) : e && typeof e == "object" && rU in e ? e[rU](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
  }
  function Rn(e, t) {
    return di(t || e, e);
  }
  function rF(e, t, r) {
    const n = Rn(e, r == null ? void 0 : r.in);
    return isNaN(t) ? di((r == null ? void 0 : r.in) || e, NaN) : (t && n.setDate(n.getDate() + t), n);
  }
  function CCe(e, t, r) {
    const n = Rn(e, r == null ? void 0 : r.in);
    if (isNaN(t)) return di(e, NaN);
    const i = n.getDate(), u = di(e, n.getTime());
    u.setMonth(n.getMonth() + t + 1, 0);
    const s = u.getDate();
    return i >= s ? u : (n.setFullYear(
      u.getFullYear(),
      u.getMonth(),
      i
    ), n);
  }
  let OCe = {};
  function nm() {
    return OCe;
  }
  function Wf(e, t) {
    var c, p, h, v;
    const r = nm(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((p = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : p.weekStartsOn) ?? r.weekStartsOn ?? ((v = (h = r.locale) == null ? void 0 : h.options) == null ? void 0 : v.weekStartsOn) ?? 0, i = Rn(e, t == null ? void 0 : t.in), u = i.getDay(), s = (u < n ? 7 : 0) + u - n;
    return i.setDate(i.getDate() - s), i.setHours(0, 0, 0, 0), i;
  }
  function j0(e, t) {
    return Wf(e, { ...t, weekStartsOn: 1 });
  }
  function wG(e, t) {
    const r = Rn(e, t == null ? void 0 : t.in), n = r.getFullYear(), i = di(r, 0);
    i.setFullYear(n + 1, 0, 4), i.setHours(0, 0, 0, 0);
    const u = j0(i), s = di(r, 0);
    s.setFullYear(n, 0, 4), s.setHours(0, 0, 0, 0);
    const c = j0(s);
    return r.getTime() >= u.getTime() ? n + 1 : r.getTime() >= c.getTime() ? n : n - 1;
  }
  function b_(e) {
    const t = Rn(e), r = new Date(
      Date.UTC(
        t.getFullYear(),
        t.getMonth(),
        t.getDate(),
        t.getHours(),
        t.getMinutes(),
        t.getSeconds(),
        t.getMilliseconds()
      )
    );
    return r.setUTCFullYear(t.getFullYear()), +e - +r;
  }
  function TCe(e, ...t) {
    const r = di.bind(
      null,
      t.find((n) => typeof n == "object")
    );
    return t.map(r);
  }
  function nU(e, t) {
    const r = Rn(e, t == null ? void 0 : t.in);
    return r.setHours(0, 0, 0, 0), r;
  }
  function ACe(e, t, r) {
    const [n, i] = TCe(
      r == null ? void 0 : r.in,
      e,
      t
    ), u = nU(n), s = nU(i), c = +u - b_(u), p = +s - b_(s);
    return Math.round((c - p) / wCe);
  }
  function DCe(e, t) {
    const r = wG(e, t), n = di(e, 0);
    return n.setFullYear(r, 0, 4), n.setHours(0, 0, 0, 0), j0(n);
  }
  function kCe(e, t, r) {
    return CCe(e, t * 12, r);
  }
  function RCe(e) {
    return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
  }
  function PCe(e) {
    return !(!RCe(e) && typeof e != "number" || isNaN(+Rn(e)));
  }
  function MCe(e, t) {
    const r = Rn(e, t == null ? void 0 : t.in);
    return r.setFullYear(r.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
  }
  const NCe = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, jCe = (e, t, r) => {
    let n;
    const i = NCe[e];
    return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
  };
  function iP(e) {
    return (t = {}) => {
      const r = t.width ? String(t.width) : e.defaultWidth;
      return e.formats[r] || e.formats[e.defaultWidth];
    };
  }
  const FCe = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, ICe = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, BCe = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, LCe = {
    date: iP({
      formats: FCe,
      defaultWidth: "full"
    }),
    time: iP({
      formats: ICe,
      defaultWidth: "full"
    }),
    dateTime: iP({
      formats: BCe,
      defaultWidth: "full"
    })
  }, $Ce = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, zCe = (e, t, r, n) => $Ce[e];
  function Og(e) {
    return (t, r) => {
      const n = r != null && r.context ? String(r.context) : "standalone";
      let i;
      if (n === "formatting" && e.formattingValues) {
        const s = e.defaultFormattingWidth || e.defaultWidth, c = r != null && r.width ? String(r.width) : s;
        i = e.formattingValues[c] || e.formattingValues[s];
      } else {
        const s = e.defaultWidth, c = r != null && r.width ? String(r.width) : e.defaultWidth;
        i = e.values[c] || e.values[s];
      }
      const u = e.argumentCallback ? e.argumentCallback(t) : t;
      return i[u];
    };
  }
  const qCe = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, UCe = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, HCe = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    wide: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  }, VCe = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ]
  }, WCe = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, YCe = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, GCe = (e, t) => {
    const r = Number(e), n = r % 100;
    if (n > 20 || n < 10)
      switch (n % 10) {
        case 1:
          return r + "st";
        case 2:
          return r + "nd";
        case 3:
          return r + "rd";
      }
    return r + "th";
  }, QCe = {
    ordinalNumber: GCe,
    era: Og({
      values: qCe,
      defaultWidth: "wide"
    }),
    quarter: Og({
      values: UCe,
      defaultWidth: "wide",
      argumentCallback: (e) => e - 1
    }),
    month: Og({
      values: HCe,
      defaultWidth: "wide"
    }),
    day: Og({
      values: VCe,
      defaultWidth: "wide"
    }),
    dayPeriod: Og({
      values: WCe,
      defaultWidth: "wide",
      formattingValues: YCe,
      defaultFormattingWidth: "wide"
    })
  };
  function Tg(e) {
    return (t, r = {}) => {
      const n = r.width, i = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], u = t.match(i);
      if (!u)
        return null;
      const s = u[0], c = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], p = Array.isArray(c) ? XCe(c, (y) => y.test(s)) : (
        // [TODO] -- I challenge you to fix the type
        KCe(c, (y) => y.test(s))
      );
      let h;
      h = e.valueCallback ? e.valueCallback(p) : p, h = r.valueCallback ? (
        // [TODO] -- I challenge you to fix the type
        r.valueCallback(h)
      ) : h;
      const v = t.slice(s.length);
      return { value: h, rest: v };
    };
  }
  function KCe(e, t) {
    for (const r in e)
      if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
        return r;
  }
  function XCe(e, t) {
    for (let r = 0; r < e.length; r++)
      if (t(e[r]))
        return r;
  }
  function ZCe(e) {
    return (t, r = {}) => {
      const n = t.match(e.matchPattern);
      if (!n) return null;
      const i = n[0], u = t.match(e.parsePattern);
      if (!u) return null;
      let s = e.valueCallback ? e.valueCallback(u[0]) : u[0];
      s = r.valueCallback ? r.valueCallback(s) : s;
      const c = t.slice(i.length);
      return { value: s, rest: c };
    };
  }
  const JCe = /^(\d+)(th|st|nd|rd)?/i, eOe = /\d+/i, tOe = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, rOe = {
    any: [/^b/i, /^(a|c)/i]
  }, nOe = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, iOe = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, aOe = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, oOe = {
    narrow: [
      /^j/i,
      /^f/i,
      /^m/i,
      /^a/i,
      /^m/i,
      /^j/i,
      /^j/i,
      /^a/i,
      /^s/i,
      /^o/i,
      /^n/i,
      /^d/i
    ],
    any: [
      /^ja/i,
      /^f/i,
      /^mar/i,
      /^ap/i,
      /^may/i,
      /^jun/i,
      /^jul/i,
      /^au/i,
      /^s/i,
      /^o/i,
      /^n/i,
      /^d/i
    ]
  }, uOe = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, sOe = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, lOe = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, cOe = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, fOe = {
    ordinalNumber: ZCe({
      matchPattern: JCe,
      parsePattern: eOe,
      valueCallback: (e) => parseInt(e, 10)
    }),
    era: Tg({
      matchPatterns: tOe,
      defaultMatchWidth: "wide",
      parsePatterns: rOe,
      defaultParseWidth: "any"
    }),
    quarter: Tg({
      matchPatterns: nOe,
      defaultMatchWidth: "wide",
      parsePatterns: iOe,
      defaultParseWidth: "any",
      valueCallback: (e) => e + 1
    }),
    month: Tg({
      matchPatterns: aOe,
      defaultMatchWidth: "wide",
      parsePatterns: oOe,
      defaultParseWidth: "any"
    }),
    day: Tg({
      matchPatterns: uOe,
      defaultMatchWidth: "wide",
      parsePatterns: sOe,
      defaultParseWidth: "any"
    }),
    dayPeriod: Tg({
      matchPatterns: lOe,
      defaultMatchWidth: "any",
      parsePatterns: cOe,
      defaultParseWidth: "any"
    })
  }, EG = {
    code: "en-US",
    formatDistance: jCe,
    formatLong: LCe,
    formatRelative: zCe,
    localize: QCe,
    match: fOe,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  };
  function dOe(e, t) {
    const r = Rn(e, t == null ? void 0 : t.in);
    return ACe(r, MCe(r)) + 1;
  }
  function SG(e, t) {
    const r = Rn(e, t == null ? void 0 : t.in), n = +j0(r) - +DCe(r);
    return Math.round(n / bG) + 1;
  }
  function nF(e, t) {
    var v, y, x, w;
    const r = Rn(e, t == null ? void 0 : t.in), n = r.getFullYear(), i = nm(), u = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((y = (v = t == null ? void 0 : t.locale) == null ? void 0 : v.options) == null ? void 0 : y.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((w = (x = i.locale) == null ? void 0 : x.options) == null ? void 0 : w.firstWeekContainsDate) ?? 1, s = di((t == null ? void 0 : t.in) || e, 0);
    s.setFullYear(n + 1, 0, u), s.setHours(0, 0, 0, 0);
    const c = Wf(s, t), p = di((t == null ? void 0 : t.in) || e, 0);
    p.setFullYear(n, 0, u), p.setHours(0, 0, 0, 0);
    const h = Wf(p, t);
    return +r >= +c ? n + 1 : +r >= +h ? n : n - 1;
  }
  function pOe(e, t) {
    var c, p, h, v;
    const r = nm(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((p = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : p.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((v = (h = r.locale) == null ? void 0 : h.options) == null ? void 0 : v.firstWeekContainsDate) ?? 1, i = nF(e, t), u = di((t == null ? void 0 : t.in) || e, 0);
    return u.setFullYear(i, 0, n), u.setHours(0, 0, 0, 0), Wf(u, t);
  }
  function _G(e, t) {
    const r = Rn(e, t == null ? void 0 : t.in), n = +Wf(r, t) - +pOe(r, t);
    return Math.round(n / bG) + 1;
  }
  function Kr(e, t) {
    const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
    return r + n;
  }
  const Af = {
    // Year
    y(e, t) {
      const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
      return Kr(t === "yy" ? n % 100 : n, t.length);
    },
    // Month
    M(e, t) {
      const r = e.getMonth();
      return t === "M" ? String(r + 1) : Kr(r + 1, 2);
    },
    // Day of the month
    d(e, t) {
      return Kr(e.getDate(), t.length);
    },
    // AM or PM
    a(e, t) {
      const r = e.getHours() / 12 >= 1 ? "pm" : "am";
      switch (t) {
        case "a":
        case "aa":
          return r.toUpperCase();
        case "aaa":
          return r;
        case "aaaaa":
          return r[0];
        case "aaaa":
        default:
          return r === "am" ? "a.m." : "p.m.";
      }
    },
    // Hour [1-12]
    h(e, t) {
      return Kr(e.getHours() % 12 || 12, t.length);
    },
    // Hour [0-23]
    H(e, t) {
      return Kr(e.getHours(), t.length);
    },
    // Minute
    m(e, t) {
      return Kr(e.getMinutes(), t.length);
    },
    // Second
    s(e, t) {
      return Kr(e.getSeconds(), t.length);
    },
    // Fraction of second
    S(e, t) {
      const r = t.length, n = e.getMilliseconds(), i = Math.trunc(
        n * Math.pow(10, r - 3)
      );
      return Kr(i, t.length);
    }
  }, Lv = {
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }, iU = {
    // Era
    G: function(e, t, r) {
      const n = e.getFullYear() > 0 ? 1 : 0;
      switch (t) {
        // AD, BC
        case "G":
        case "GG":
        case "GGG":
          return r.era(n, { width: "abbreviated" });
        // A, B
        case "GGGGG":
          return r.era(n, { width: "narrow" });
        // Anno Domini, Before Christ
        case "GGGG":
        default:
          return r.era(n, { width: "wide" });
      }
    },
    // Year
    y: function(e, t, r) {
      if (t === "yo") {
        const n = e.getFullYear(), i = n > 0 ? n : 1 - n;
        return r.ordinalNumber(i, { unit: "year" });
      }
      return Af.y(e, t);
    },
    // Local week-numbering year
    Y: function(e, t, r, n) {
      const i = nF(e, n), u = i > 0 ? i : 1 - i;
      if (t === "YY") {
        const s = u % 100;
        return Kr(s, 2);
      }
      return t === "Yo" ? r.ordinalNumber(u, { unit: "year" }) : Kr(u, t.length);
    },
    // ISO week-numbering year
    R: function(e, t) {
      const r = wG(e);
      return Kr(r, t.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(e, t) {
      const r = e.getFullYear();
      return Kr(r, t.length);
    },
    // Quarter
    Q: function(e, t, r) {
      const n = Math.ceil((e.getMonth() + 1) / 3);
      switch (t) {
        // 1, 2, 3, 4
        case "Q":
          return String(n);
        // 01, 02, 03, 04
        case "QQ":
          return Kr(n, 2);
        // 1st, 2nd, 3rd, 4th
        case "Qo":
          return r.ordinalNumber(n, { unit: "quarter" });
        // Q1, Q2, Q3, Q4
        case "QQQ":
          return r.quarter(n, {
            width: "abbreviated",
            context: "formatting"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "QQQQQ":
          return r.quarter(n, {
            width: "narrow",
            context: "formatting"
          });
        // 1st quarter, 2nd quarter, ...
        case "QQQQ":
        default:
          return r.quarter(n, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function(e, t, r) {
      const n = Math.ceil((e.getMonth() + 1) / 3);
      switch (t) {
        // 1, 2, 3, 4
        case "q":
          return String(n);
        // 01, 02, 03, 04
        case "qq":
          return Kr(n, 2);
        // 1st, 2nd, 3rd, 4th
        case "qo":
          return r.ordinalNumber(n, { unit: "quarter" });
        // Q1, Q2, Q3, Q4
        case "qqq":
          return r.quarter(n, {
            width: "abbreviated",
            context: "standalone"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "qqqqq":
          return r.quarter(n, {
            width: "narrow",
            context: "standalone"
          });
        // 1st quarter, 2nd quarter, ...
        case "qqqq":
        default:
          return r.quarter(n, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function(e, t, r) {
      const n = e.getMonth();
      switch (t) {
        case "M":
        case "MM":
          return Af.M(e, t);
        // 1st, 2nd, ..., 12th
        case "Mo":
          return r.ordinalNumber(n + 1, { unit: "month" });
        // Jan, Feb, ..., Dec
        case "MMM":
          return r.month(n, {
            width: "abbreviated",
            context: "formatting"
          });
        // J, F, ..., D
        case "MMMMM":
          return r.month(n, {
            width: "narrow",
            context: "formatting"
          });
        // January, February, ..., December
        case "MMMM":
        default:
          return r.month(n, { width: "wide", context: "formatting" });
      }
    },
    // Stand-alone month
    L: function(e, t, r) {
      const n = e.getMonth();
      switch (t) {
        // 1, 2, ..., 12
        case "L":
          return String(n + 1);
        // 01, 02, ..., 12
        case "LL":
          return Kr(n + 1, 2);
        // 1st, 2nd, ..., 12th
        case "Lo":
          return r.ordinalNumber(n + 1, { unit: "month" });
        // Jan, Feb, ..., Dec
        case "LLL":
          return r.month(n, {
            width: "abbreviated",
            context: "standalone"
          });
        // J, F, ..., D
        case "LLLLL":
          return r.month(n, {
            width: "narrow",
            context: "standalone"
          });
        // January, February, ..., December
        case "LLLL":
        default:
          return r.month(n, { width: "wide", context: "standalone" });
      }
    },
    // Local week of year
    w: function(e, t, r, n) {
      const i = _G(e, n);
      return t === "wo" ? r.ordinalNumber(i, { unit: "week" }) : Kr(i, t.length);
    },
    // ISO week of year
    I: function(e, t, r) {
      const n = SG(e);
      return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : Kr(n, t.length);
    },
    // Day of the month
    d: function(e, t, r) {
      return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : Af.d(e, t);
    },
    // Day of year
    D: function(e, t, r) {
      const n = dOe(e);
      return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : Kr(n, t.length);
    },
    // Day of week
    E: function(e, t, r) {
      const n = e.getDay();
      switch (t) {
        // Tue
        case "E":
        case "EE":
        case "EEE":
          return r.day(n, {
            width: "abbreviated",
            context: "formatting"
          });
        // T
        case "EEEEE":
          return r.day(n, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "EEEEEE":
          return r.day(n, {
            width: "short",
            context: "formatting"
          });
        // Tuesday
        case "EEEE":
        default:
          return r.day(n, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function(e, t, r, n) {
      const i = e.getDay(), u = (i - n.weekStartsOn + 8) % 7 || 7;
      switch (t) {
        // Numerical value (Nth day of week with current locale or weekStartsOn)
        case "e":
          return String(u);
        // Padded numerical value
        case "ee":
          return Kr(u, 2);
        // 1st, 2nd, ..., 7th
        case "eo":
          return r.ordinalNumber(u, { unit: "day" });
        case "eee":
          return r.day(i, {
            width: "abbreviated",
            context: "formatting"
          });
        // T
        case "eeeee":
          return r.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "eeeeee":
          return r.day(i, {
            width: "short",
            context: "formatting"
          });
        // Tuesday
        case "eeee":
        default:
          return r.day(i, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function(e, t, r, n) {
      const i = e.getDay(), u = (i - n.weekStartsOn + 8) % 7 || 7;
      switch (t) {
        // Numerical value (same as in `e`)
        case "c":
          return String(u);
        // Padded numerical value
        case "cc":
          return Kr(u, t.length);
        // 1st, 2nd, ..., 7th
        case "co":
          return r.ordinalNumber(u, { unit: "day" });
        case "ccc":
          return r.day(i, {
            width: "abbreviated",
            context: "standalone"
          });
        // T
        case "ccccc":
          return r.day(i, {
            width: "narrow",
            context: "standalone"
          });
        // Tu
        case "cccccc":
          return r.day(i, {
            width: "short",
            context: "standalone"
          });
        // Tuesday
        case "cccc":
        default:
          return r.day(i, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function(e, t, r) {
      const n = e.getDay(), i = n === 0 ? 7 : n;
      switch (t) {
        // 2
        case "i":
          return String(i);
        // 02
        case "ii":
          return Kr(i, t.length);
        // 2nd
        case "io":
          return r.ordinalNumber(i, { unit: "day" });
        // Tue
        case "iii":
          return r.day(n, {
            width: "abbreviated",
            context: "formatting"
          });
        // T
        case "iiiii":
          return r.day(n, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "iiiiii":
          return r.day(n, {
            width: "short",
            context: "formatting"
          });
        // Tuesday
        case "iiii":
        default:
          return r.day(n, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function(e, t, r) {
      const i = e.getHours() / 12 >= 1 ? "pm" : "am";
      switch (t) {
        case "a":
        case "aa":
          return r.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return r.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return r.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return r.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function(e, t, r) {
      const n = e.getHours();
      let i;
      switch (n === 12 ? i = Lv.noon : n === 0 ? i = Lv.midnight : i = n / 12 >= 1 ? "pm" : "am", t) {
        case "b":
        case "bb":
          return r.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return r.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return r.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return r.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(e, t, r) {
      const n = e.getHours();
      let i;
      switch (n >= 17 ? i = Lv.evening : n >= 12 ? i = Lv.afternoon : n >= 4 ? i = Lv.morning : i = Lv.night, t) {
        case "B":
        case "BB":
        case "BBB":
          return r.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return r.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return r.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function(e, t, r) {
      if (t === "ho") {
        let n = e.getHours() % 12;
        return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
      }
      return Af.h(e, t);
    },
    // Hour [0-23]
    H: function(e, t, r) {
      return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : Af.H(e, t);
    },
    // Hour [0-11]
    K: function(e, t, r) {
      const n = e.getHours() % 12;
      return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : Kr(n, t.length);
    },
    // Hour [1-24]
    k: function(e, t, r) {
      let n = e.getHours();
      return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : Kr(n, t.length);
    },
    // Minute
    m: function(e, t, r) {
      return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Af.m(e, t);
    },
    // Second
    s: function(e, t, r) {
      return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : Af.s(e, t);
    },
    // Fraction of second
    S: function(e, t) {
      return Af.S(e, t);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(e, t, r) {
      const n = e.getTimezoneOffset();
      if (n === 0)
        return "Z";
      switch (t) {
        // Hours and optional minutes
        case "X":
          return oU(n);
        // Hours, minutes and optional seconds without `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `XX`
        case "XXXX":
        case "XX":
          return wp(n);
        // Hours, minutes and optional seconds with `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `XXX`
        case "XXXXX":
        case "XXX":
        // Hours and minutes with `:` delimiter
        default:
          return wp(n, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(e, t, r) {
      const n = e.getTimezoneOffset();
      switch (t) {
        // Hours and optional minutes
        case "x":
          return oU(n);
        // Hours, minutes and optional seconds without `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `xx`
        case "xxxx":
        case "xx":
          return wp(n);
        // Hours, minutes and optional seconds with `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `xxx`
        case "xxxxx":
        case "xxx":
        // Hours and minutes with `:` delimiter
        default:
          return wp(n, ":");
      }
    },
    // Timezone (GMT)
    O: function(e, t, r) {
      const n = e.getTimezoneOffset();
      switch (t) {
        // Short
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + aU(n, ":");
        // Long
        case "OOOO":
        default:
          return "GMT" + wp(n, ":");
      }
    },
    // Timezone (specific non-location)
    z: function(e, t, r) {
      const n = e.getTimezoneOffset();
      switch (t) {
        // Short
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + aU(n, ":");
        // Long
        case "zzzz":
        default:
          return "GMT" + wp(n, ":");
      }
    },
    // Seconds timestamp
    t: function(e, t, r) {
      const n = Math.trunc(+e / 1e3);
      return Kr(n, t.length);
    },
    // Milliseconds timestamp
    T: function(e, t, r) {
      return Kr(+e, t.length);
    }
  };
  function aU(e, t = "") {
    const r = e > 0 ? "-" : "+", n = Math.abs(e), i = Math.trunc(n / 60), u = n % 60;
    return u === 0 ? r + String(i) : r + String(i) + t + Kr(u, 2);
  }
  function oU(e, t) {
    return e % 60 === 0 ? (e > 0 ? "-" : "+") + Kr(Math.abs(e) / 60, 2) : wp(e, t);
  }
  function wp(e, t = "") {
    const r = e > 0 ? "-" : "+", n = Math.abs(e), i = Kr(Math.trunc(n / 60), 2), u = Kr(n % 60, 2);
    return r + i + t + u;
  }
  const uU = (e, t) => {
    switch (e) {
      case "P":
        return t.date({ width: "short" });
      case "PP":
        return t.date({ width: "medium" });
      case "PPP":
        return t.date({ width: "long" });
      case "PPPP":
      default:
        return t.date({ width: "full" });
    }
  }, CG = (e, t) => {
    switch (e) {
      case "p":
        return t.time({ width: "short" });
      case "pp":
        return t.time({ width: "medium" });
      case "ppp":
        return t.time({ width: "long" });
      case "pppp":
      default:
        return t.time({ width: "full" });
    }
  }, hOe = (e, t) => {
    const r = e.match(/(P+)(p+)?/) || [], n = r[1], i = r[2];
    if (!i)
      return uU(e, t);
    let u;
    switch (n) {
      case "P":
        u = t.dateTime({ width: "short" });
        break;
      case "PP":
        u = t.dateTime({ width: "medium" });
        break;
      case "PPP":
        u = t.dateTime({ width: "long" });
        break;
      case "PPPP":
      default:
        u = t.dateTime({ width: "full" });
        break;
    }
    return u.replace("{{date}}", uU(n, t)).replace("{{time}}", CG(i, t));
  }, iN = {
    p: CG,
    P: hOe
  }, vOe = /^D+$/, mOe = /^Y+$/, yOe = ["D", "DD", "YY", "YYYY"];
  function OG(e) {
    return vOe.test(e);
  }
  function TG(e) {
    return mOe.test(e);
  }
  function aN(e, t, r) {
    const n = gOe(e, t, r);
    if (console.warn(n), yOe.includes(e)) throw new RangeError(n);
  }
  function gOe(e, t, r) {
    const n = e[0] === "Y" ? "years" : "days of the month";
    return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
  }
  const xOe = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, bOe = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, wOe = /^'([^]*?)'?$/, EOe = /''/g, SOe = /[a-zA-Z]/;
  function iF(e, t, r) {
    var v, y, x, w;
    const n = nm(), i = n.locale ?? EG, u = n.firstWeekContainsDate ?? ((y = (v = n.locale) == null ? void 0 : v.options) == null ? void 0 : y.firstWeekContainsDate) ?? 1, s = n.weekStartsOn ?? ((w = (x = n.locale) == null ? void 0 : x.options) == null ? void 0 : w.weekStartsOn) ?? 0, c = Rn(e, r == null ? void 0 : r.in);
    if (!PCe(c))
      throw new RangeError("Invalid time value");
    let p = t.match(bOe).map((E) => {
      const C = E[0];
      if (C === "p" || C === "P") {
        const S = iN[C];
        return S(E, i.formatLong);
      }
      return E;
    }).join("").match(xOe).map((E) => {
      if (E === "''")
        return { isToken: !1, value: "'" };
      const C = E[0];
      if (C === "'")
        return { isToken: !1, value: _Oe(E) };
      if (iU[C])
        return { isToken: !0, value: E };
      if (C.match(SOe))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + C + "`"
        );
      return { isToken: !1, value: E };
    });
    i.localize.preprocessor && (p = i.localize.preprocessor(c, p));
    const h = {
      firstWeekContainsDate: u,
      weekStartsOn: s,
      locale: i
    };
    return p.map((E) => {
      if (!E.isToken) return E.value;
      const C = E.value;
      (TG(C) || OG(C)) && aN(C, t, String(e));
      const S = iU[C[0]];
      return S(c, C, i.localize, h);
    }).join("");
  }
  function _Oe(e) {
    const t = e.match(wOe);
    return t ? t[1].replace(EOe, "'") : e;
  }
  function COe() {
    return Object.assign({}, nm());
  }
  function OOe(e, t) {
    const r = Rn(e, t == null ? void 0 : t.in).getDay();
    return r === 0 ? 7 : r;
  }
  function TOe(e, t) {
    return +Rn(e) > +Rn(t);
  }
  function AOe(e, t) {
    const r = DOe(t) ? new t(0) : di(t, 0);
    return r.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), r.setHours(
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    ), r;
  }
  function DOe(e) {
    var t;
    return typeof e == "function" && ((t = e.prototype) == null ? void 0 : t.constructor) === e;
  }
  const kOe = 10;
  class AG {
    constructor() {
      ft(this, "subPriority", 0);
    }
    validate(t, r) {
      return !0;
    }
  }
  class ROe extends AG {
    constructor(t, r, n, i, u) {
      super(), this.value = t, this.validateValue = r, this.setValue = n, this.priority = i, u && (this.subPriority = u);
    }
    validate(t, r) {
      return this.validateValue(t, this.value, r);
    }
    set(t, r, n) {
      return this.setValue(t, r, this.value, n);
    }
  }
  class POe extends AG {
    constructor(r, n) {
      super();
      ft(this, "priority", kOe);
      ft(this, "subPriority", -1);
      this.context = r || ((i) => di(n, i));
    }
    set(r, n) {
      return n.timestampIsSet ? r : di(r, AOe(r, this.context));
    }
  }
  class Mr {
    run(t, r, n, i) {
      const u = this.parse(t, r, n, i);
      return u ? {
        setter: new ROe(
          u.value,
          this.validate,
          this.set,
          this.priority,
          this.subPriority
        ),
        rest: u.rest
      } : null;
    }
    validate(t, r, n) {
      return !0;
    }
  }
  class MOe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 140);
      ft(this, "incompatibleTokens", ["R", "u", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        // AD, BC
        case "G":
        case "GG":
        case "GGG":
          return i.era(r, { width: "abbreviated" }) || i.era(r, { width: "narrow" });
        // A, B
        case "GGGGG":
          return i.era(r, { width: "narrow" });
        // Anno Domini, Before Christ
        case "GGGG":
        default:
          return i.era(r, { width: "wide" }) || i.era(r, { width: "abbreviated" }) || i.era(r, { width: "narrow" });
      }
    }
    set(r, n, i) {
      return n.era = i, r.setFullYear(i, 0, 1), r.setHours(0, 0, 0, 0), r;
    }
  }
  const ti = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/
    // 0 to 9999, -0 to -9999
  }, nl = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
  };
  function ri(e, t) {
    return e && {
      value: t(e.value),
      rest: e.rest
    };
  }
  function kn(e, t) {
    const r = t.match(e);
    return r ? {
      value: parseInt(r[0], 10),
      rest: t.slice(r[0].length)
    } : null;
  }
  function il(e, t) {
    const r = t.match(e);
    if (!r)
      return null;
    if (r[0] === "Z")
      return {
        value: 0,
        rest: t.slice(1)
      };
    const n = r[1] === "+" ? 1 : -1, i = r[2] ? parseInt(r[2], 10) : 0, u = r[3] ? parseInt(r[3], 10) : 0, s = r[5] ? parseInt(r[5], 10) : 0;
    return {
      value: n * (i * SCe + u * ECe + s * _Ce),
      rest: t.slice(r[0].length)
    };
  }
  function DG(e) {
    return kn(ti.anyDigitsSigned, e);
  }
  function Wn(e, t) {
    switch (e) {
      case 1:
        return kn(ti.singleDigit, t);
      case 2:
        return kn(ti.twoDigits, t);
      case 3:
        return kn(ti.threeDigits, t);
      case 4:
        return kn(ti.fourDigits, t);
      default:
        return kn(new RegExp("^\\d{1," + e + "}"), t);
    }
  }
  function w_(e, t) {
    switch (e) {
      case 1:
        return kn(ti.singleDigitSigned, t);
      case 2:
        return kn(ti.twoDigitsSigned, t);
      case 3:
        return kn(ti.threeDigitsSigned, t);
      case 4:
        return kn(ti.fourDigitsSigned, t);
      default:
        return kn(new RegExp("^-?\\d{1," + e + "}"), t);
    }
  }
  function aF(e) {
    switch (e) {
      case "morning":
        return 4;
      case "evening":
        return 17;
      case "pm":
      case "noon":
      case "afternoon":
        return 12;
      case "am":
      case "midnight":
      case "night":
      default:
        return 0;
    }
  }
  function kG(e, t) {
    const r = t > 0, n = r ? t : 1 - t;
    let i;
    if (n <= 50)
      i = e || 100;
    else {
      const u = n + 50, s = Math.trunc(u / 100) * 100, c = e >= u % 100;
      i = e + s - (c ? 100 : 0);
    }
    return r ? i : 1 - i;
  }
  function RG(e) {
    return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
  }
  class NOe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 130);
      ft(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
    }
    parse(r, n, i) {
      const u = (s) => ({
        year: s,
        isTwoDigitYear: n === "yy"
      });
      switch (n) {
        case "y":
          return ri(Wn(4, r), u);
        case "yo":
          return ri(
            i.ordinalNumber(r, {
              unit: "year"
            }),
            u
          );
        default:
          return ri(Wn(n.length, r), u);
      }
    }
    validate(r, n) {
      return n.isTwoDigitYear || n.year > 0;
    }
    set(r, n, i) {
      const u = r.getFullYear();
      if (i.isTwoDigitYear) {
        const c = kG(
          i.year,
          u
        );
        return r.setFullYear(c, 0, 1), r.setHours(0, 0, 0, 0), r;
      }
      const s = !("era" in n) || n.era === 1 ? i.year : 1 - i.year;
      return r.setFullYear(s, 0, 1), r.setHours(0, 0, 0, 0), r;
    }
  }
  class jOe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 130);
      ft(this, "incompatibleTokens", [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      const u = (s) => ({
        year: s,
        isTwoDigitYear: n === "YY"
      });
      switch (n) {
        case "Y":
          return ri(Wn(4, r), u);
        case "Yo":
          return ri(
            i.ordinalNumber(r, {
              unit: "year"
            }),
            u
          );
        default:
          return ri(Wn(n.length, r), u);
      }
    }
    validate(r, n) {
      return n.isTwoDigitYear || n.year > 0;
    }
    set(r, n, i, u) {
      const s = nF(r, u);
      if (i.isTwoDigitYear) {
        const p = kG(
          i.year,
          s
        );
        return r.setFullYear(
          p,
          0,
          u.firstWeekContainsDate
        ), r.setHours(0, 0, 0, 0), Wf(r, u);
      }
      const c = !("era" in n) || n.era === 1 ? i.year : 1 - i.year;
      return r.setFullYear(c, 0, u.firstWeekContainsDate), r.setHours(0, 0, 0, 0), Wf(r, u);
    }
  }
  class FOe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 130);
      ft(this, "incompatibleTokens", [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n) {
      return w_(n === "R" ? 4 : n.length, r);
    }
    set(r, n, i) {
      const u = di(r, 0);
      return u.setFullYear(i, 0, 4), u.setHours(0, 0, 0, 0), j0(u);
    }
  }
  class IOe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 130);
      ft(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
    }
    parse(r, n) {
      return w_(n === "u" ? 4 : n.length, r);
    }
    set(r, n, i) {
      return r.setFullYear(i, 0, 1), r.setHours(0, 0, 0, 0), r;
    }
  }
  class BOe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 120);
      ft(this, "incompatibleTokens", [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      switch (n) {
        // 1, 2, 3, 4
        case "Q":
        case "QQ":
          return Wn(n.length, r);
        // 1st, 2nd, 3rd, 4th
        case "Qo":
          return i.ordinalNumber(r, { unit: "quarter" });
        // Q1, Q2, Q3, Q4
        case "QQQ":
          return i.quarter(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "QQQQQ":
          return i.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
        // 1st quarter, 2nd quarter, ...
        case "QQQQ":
        default:
          return i.quarter(r, {
            width: "wide",
            context: "formatting"
          }) || i.quarter(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
    validate(r, n) {
      return n >= 1 && n <= 4;
    }
    set(r, n, i) {
      return r.setMonth((i - 1) * 3, 1), r.setHours(0, 0, 0, 0), r;
    }
  }
  class LOe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 120);
      ft(this, "incompatibleTokens", [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      switch (n) {
        // 1, 2, 3, 4
        case "q":
        case "qq":
          return Wn(n.length, r);
        // 1st, 2nd, 3rd, 4th
        case "qo":
          return i.ordinalNumber(r, { unit: "quarter" });
        // Q1, Q2, Q3, Q4
        case "qqq":
          return i.quarter(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "qqqqq":
          return i.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
        // 1st quarter, 2nd quarter, ...
        case "qqqq":
        default:
          return i.quarter(r, {
            width: "wide",
            context: "standalone"
          }) || i.quarter(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
    validate(r, n) {
      return n >= 1 && n <= 4;
    }
    set(r, n, i) {
      return r.setMonth((i - 1) * 3, 1), r.setHours(0, 0, 0, 0), r;
    }
  }
  class $Oe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "incompatibleTokens", [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
      ]);
      ft(this, "priority", 110);
    }
    parse(r, n, i) {
      const u = (s) => s - 1;
      switch (n) {
        // 1, 2, ..., 12
        case "M":
          return ri(
            kn(ti.month, r),
            u
          );
        // 01, 02, ..., 12
        case "MM":
          return ri(Wn(2, r), u);
        // 1st, 2nd, ..., 12th
        case "Mo":
          return ri(
            i.ordinalNumber(r, {
              unit: "month"
            }),
            u
          );
        // Jan, Feb, ..., Dec
        case "MMM":
          return i.month(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(r, { width: "narrow", context: "formatting" });
        // J, F, ..., D
        case "MMMMM":
          return i.month(r, {
            width: "narrow",
            context: "formatting"
          });
        // January, February, ..., December
        case "MMMM":
        default:
          return i.month(r, { width: "wide", context: "formatting" }) || i.month(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(r, { width: "narrow", context: "formatting" });
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 11;
    }
    set(r, n, i) {
      return r.setMonth(i, 1), r.setHours(0, 0, 0, 0), r;
    }
  }
  class zOe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 110);
      ft(this, "incompatibleTokens", [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      const u = (s) => s - 1;
      switch (n) {
        // 1, 2, ..., 12
        case "L":
          return ri(
            kn(ti.month, r),
            u
          );
        // 01, 02, ..., 12
        case "LL":
          return ri(Wn(2, r), u);
        // 1st, 2nd, ..., 12th
        case "Lo":
          return ri(
            i.ordinalNumber(r, {
              unit: "month"
            }),
            u
          );
        // Jan, Feb, ..., Dec
        case "LLL":
          return i.month(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(r, { width: "narrow", context: "standalone" });
        // J, F, ..., D
        case "LLLLL":
          return i.month(r, {
            width: "narrow",
            context: "standalone"
          });
        // January, February, ..., December
        case "LLLL":
        default:
          return i.month(r, { width: "wide", context: "standalone" }) || i.month(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(r, { width: "narrow", context: "standalone" });
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 11;
    }
    set(r, n, i) {
      return r.setMonth(i, 1), r.setHours(0, 0, 0, 0), r;
    }
  }
  function qOe(e, t, r) {
    const n = Rn(e, r == null ? void 0 : r.in), i = _G(n, r) - t;
    return n.setDate(n.getDate() - i * 7), Rn(n, r == null ? void 0 : r.in);
  }
  class UOe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 100);
      ft(this, "incompatibleTokens", [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      switch (n) {
        case "w":
          return kn(ti.week, r);
        case "wo":
          return i.ordinalNumber(r, { unit: "week" });
        default:
          return Wn(n.length, r);
      }
    }
    validate(r, n) {
      return n >= 1 && n <= 53;
    }
    set(r, n, i, u) {
      return Wf(qOe(r, i, u), u);
    }
  }
  function HOe(e, t, r) {
    const n = Rn(e, r == null ? void 0 : r.in), i = SG(n, r) - t;
    return n.setDate(n.getDate() - i * 7), n;
  }
  class VOe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 100);
      ft(this, "incompatibleTokens", [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      switch (n) {
        case "I":
          return kn(ti.week, r);
        case "Io":
          return i.ordinalNumber(r, { unit: "week" });
        default:
          return Wn(n.length, r);
      }
    }
    validate(r, n) {
      return n >= 1 && n <= 53;
    }
    set(r, n, i) {
      return j0(HOe(r, i));
    }
  }
  const WOe = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], YOe = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ];
  class GOe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 90);
      ft(this, "subPriority", 1);
      ft(this, "incompatibleTokens", [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      switch (n) {
        case "d":
          return kn(ti.date, r);
        case "do":
          return i.ordinalNumber(r, { unit: "date" });
        default:
          return Wn(n.length, r);
      }
    }
    validate(r, n) {
      const i = r.getFullYear(), u = RG(i), s = r.getMonth();
      return u ? n >= 1 && n <= YOe[s] : n >= 1 && n <= WOe[s];
    }
    set(r, n, i) {
      return r.setDate(i), r.setHours(0, 0, 0, 0), r;
    }
  }
  class QOe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 90);
      ft(this, "subpriority", 1);
      ft(this, "incompatibleTokens", [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      switch (n) {
        case "D":
        case "DD":
          return kn(ti.dayOfYear, r);
        case "Do":
          return i.ordinalNumber(r, { unit: "date" });
        default:
          return Wn(n.length, r);
      }
    }
    validate(r, n) {
      const i = r.getFullYear();
      return RG(i) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
    }
    set(r, n, i) {
      return r.setMonth(0, i), r.setHours(0, 0, 0, 0), r;
    }
  }
  function oF(e, t, r) {
    var y, x, w, E;
    const n = nm(), i = (r == null ? void 0 : r.weekStartsOn) ?? ((x = (y = r == null ? void 0 : r.locale) == null ? void 0 : y.options) == null ? void 0 : x.weekStartsOn) ?? n.weekStartsOn ?? ((E = (w = n.locale) == null ? void 0 : w.options) == null ? void 0 : E.weekStartsOn) ?? 0, u = Rn(e, r == null ? void 0 : r.in), s = u.getDay(), p = (t % 7 + 7) % 7, h = 7 - i, v = t < 0 || t > 6 ? t - (s + h) % 7 : (p + h) % 7 - (s + h) % 7;
    return rF(u, v, r);
  }
  class KOe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 90);
      ft(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        // Tue
        case "E":
        case "EE":
        case "EEE":
          return i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, { width: "short", context: "formatting" }) || i.day(r, { width: "narrow", context: "formatting" });
        // T
        case "EEEEE":
          return i.day(r, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "EEEEEE":
          return i.day(r, { width: "short", context: "formatting" }) || i.day(r, { width: "narrow", context: "formatting" });
        // Tuesday
        case "EEEE":
        default:
          return i.day(r, { width: "wide", context: "formatting" }) || i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, { width: "short", context: "formatting" }) || i.day(r, { width: "narrow", context: "formatting" });
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 6;
    }
    set(r, n, i, u) {
      return r = oF(r, i, u), r.setHours(0, 0, 0, 0), r;
    }
  }
  class XOe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 90);
      ft(this, "incompatibleTokens", [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n, i, u) {
      const s = (c) => {
        const p = Math.floor((c - 1) / 7) * 7;
        return (c + u.weekStartsOn + 6) % 7 + p;
      };
      switch (n) {
        // 3
        case "e":
        case "ee":
          return ri(Wn(n.length, r), s);
        // 3rd
        case "eo":
          return ri(
            i.ordinalNumber(r, {
              unit: "day"
            }),
            s
          );
        // Tue
        case "eee":
          return i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, { width: "short", context: "formatting" }) || i.day(r, { width: "narrow", context: "formatting" });
        // T
        case "eeeee":
          return i.day(r, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "eeeeee":
          return i.day(r, { width: "short", context: "formatting" }) || i.day(r, { width: "narrow", context: "formatting" });
        // Tuesday
        case "eeee":
        default:
          return i.day(r, { width: "wide", context: "formatting" }) || i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, { width: "short", context: "formatting" }) || i.day(r, { width: "narrow", context: "formatting" });
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 6;
    }
    set(r, n, i, u) {
      return r = oF(r, i, u), r.setHours(0, 0, 0, 0), r;
    }
  }
  class ZOe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 90);
      ft(this, "incompatibleTokens", [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
      ]);
    }
    parse(r, n, i, u) {
      const s = (c) => {
        const p = Math.floor((c - 1) / 7) * 7;
        return (c + u.weekStartsOn + 6) % 7 + p;
      };
      switch (n) {
        // 3
        case "c":
        case "cc":
          return ri(Wn(n.length, r), s);
        // 3rd
        case "co":
          return ri(
            i.ordinalNumber(r, {
              unit: "day"
            }),
            s
          );
        // Tue
        case "ccc":
          return i.day(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(r, { width: "short", context: "standalone" }) || i.day(r, { width: "narrow", context: "standalone" });
        // T
        case "ccccc":
          return i.day(r, {
            width: "narrow",
            context: "standalone"
          });
        // Tu
        case "cccccc":
          return i.day(r, { width: "short", context: "standalone" }) || i.day(r, { width: "narrow", context: "standalone" });
        // Tuesday
        case "cccc":
        default:
          return i.day(r, { width: "wide", context: "standalone" }) || i.day(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(r, { width: "short", context: "standalone" }) || i.day(r, { width: "narrow", context: "standalone" });
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 6;
    }
    set(r, n, i, u) {
      return r = oF(r, i, u), r.setHours(0, 0, 0, 0), r;
    }
  }
  function JOe(e, t, r) {
    const n = Rn(e, r == null ? void 0 : r.in), i = OOe(n, r), u = t - i;
    return rF(n, u, r);
  }
  class eTe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 90);
      ft(this, "incompatibleTokens", [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      const u = (s) => s === 0 ? 7 : s;
      switch (n) {
        // 2
        case "i":
        case "ii":
          return Wn(n.length, r);
        // 2nd
        case "io":
          return i.ordinalNumber(r, { unit: "day" });
        // Tue
        case "iii":
          return ri(
            i.day(r, {
              width: "abbreviated",
              context: "formatting"
            }) || i.day(r, {
              width: "short",
              context: "formatting"
            }) || i.day(r, {
              width: "narrow",
              context: "formatting"
            }),
            u
          );
        // T
        case "iiiii":
          return ri(
            i.day(r, {
              width: "narrow",
              context: "formatting"
            }),
            u
          );
        // Tu
        case "iiiiii":
          return ri(
            i.day(r, {
              width: "short",
              context: "formatting"
            }) || i.day(r, {
              width: "narrow",
              context: "formatting"
            }),
            u
          );
        // Tuesday
        case "iiii":
        default:
          return ri(
            i.day(r, {
              width: "wide",
              context: "formatting"
            }) || i.day(r, {
              width: "abbreviated",
              context: "formatting"
            }) || i.day(r, {
              width: "short",
              context: "formatting"
            }) || i.day(r, {
              width: "narrow",
              context: "formatting"
            }),
            u
          );
      }
    }
    validate(r, n) {
      return n >= 1 && n <= 7;
    }
    set(r, n, i) {
      return r = JOe(r, i), r.setHours(0, 0, 0, 0), r;
    }
  }
  class tTe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 80);
      ft(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "a":
        case "aa":
        case "aaa":
          return i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return i.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
    set(r, n, i) {
      return r.setHours(aF(i), 0, 0, 0), r;
    }
  }
  class rTe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 80);
      ft(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "b":
        case "bb":
        case "bbb":
          return i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return i.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
    set(r, n, i) {
      return r.setHours(aF(i), 0, 0, 0), r;
    }
  }
  class nTe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 80);
      ft(this, "incompatibleTokens", ["a", "b", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "B":
        case "BB":
        case "BBB":
          return i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return i.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
    set(r, n, i) {
      return r.setHours(aF(i), 0, 0, 0), r;
    }
  }
  class iTe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 70);
      ft(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "h":
          return kn(ti.hour12h, r);
        case "ho":
          return i.ordinalNumber(r, { unit: "hour" });
        default:
          return Wn(n.length, r);
      }
    }
    validate(r, n) {
      return n >= 1 && n <= 12;
    }
    set(r, n, i) {
      const u = r.getHours() >= 12;
      return u && i < 12 ? r.setHours(i + 12, 0, 0, 0) : !u && i === 12 ? r.setHours(0, 0, 0, 0) : r.setHours(i, 0, 0, 0), r;
    }
  }
  class aTe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 70);
      ft(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "H":
          return kn(ti.hour23h, r);
        case "Ho":
          return i.ordinalNumber(r, { unit: "hour" });
        default:
          return Wn(n.length, r);
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 23;
    }
    set(r, n, i) {
      return r.setHours(i, 0, 0, 0), r;
    }
  }
  class oTe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 70);
      ft(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "K":
          return kn(ti.hour11h, r);
        case "Ko":
          return i.ordinalNumber(r, { unit: "hour" });
        default:
          return Wn(n.length, r);
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 11;
    }
    set(r, n, i) {
      return r.getHours() >= 12 && i < 12 ? r.setHours(i + 12, 0, 0, 0) : r.setHours(i, 0, 0, 0), r;
    }
  }
  class uTe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 70);
      ft(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "k":
          return kn(ti.hour24h, r);
        case "ko":
          return i.ordinalNumber(r, { unit: "hour" });
        default:
          return Wn(n.length, r);
      }
    }
    validate(r, n) {
      return n >= 1 && n <= 24;
    }
    set(r, n, i) {
      const u = i <= 24 ? i % 24 : i;
      return r.setHours(u, 0, 0, 0), r;
    }
  }
  class sTe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 60);
      ft(this, "incompatibleTokens", ["t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "m":
          return kn(ti.minute, r);
        case "mo":
          return i.ordinalNumber(r, { unit: "minute" });
        default:
          return Wn(n.length, r);
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 59;
    }
    set(r, n, i) {
      return r.setMinutes(i, 0, 0), r;
    }
  }
  class lTe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 50);
      ft(this, "incompatibleTokens", ["t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "s":
          return kn(ti.second, r);
        case "so":
          return i.ordinalNumber(r, { unit: "second" });
        default:
          return Wn(n.length, r);
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 59;
    }
    set(r, n, i) {
      return r.setSeconds(i, 0), r;
    }
  }
  class cTe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 30);
      ft(this, "incompatibleTokens", ["t", "T"]);
    }
    parse(r, n) {
      const i = (u) => Math.trunc(u * Math.pow(10, -n.length + 3));
      return ri(Wn(n.length, r), i);
    }
    set(r, n, i) {
      return r.setMilliseconds(i), r;
    }
  }
  class fTe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 10);
      ft(this, "incompatibleTokens", ["t", "T", "x"]);
    }
    parse(r, n) {
      switch (n) {
        case "X":
          return il(
            nl.basicOptionalMinutes,
            r
          );
        case "XX":
          return il(nl.basic, r);
        case "XXXX":
          return il(
            nl.basicOptionalSeconds,
            r
          );
        case "XXXXX":
          return il(
            nl.extendedOptionalSeconds,
            r
          );
        case "XXX":
        default:
          return il(nl.extended, r);
      }
    }
    set(r, n, i) {
      return n.timestampIsSet ? r : di(
        r,
        r.getTime() - b_(r) - i
      );
    }
  }
  class dTe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 10);
      ft(this, "incompatibleTokens", ["t", "T", "X"]);
    }
    parse(r, n) {
      switch (n) {
        case "x":
          return il(
            nl.basicOptionalMinutes,
            r
          );
        case "xx":
          return il(nl.basic, r);
        case "xxxx":
          return il(
            nl.basicOptionalSeconds,
            r
          );
        case "xxxxx":
          return il(
            nl.extendedOptionalSeconds,
            r
          );
        case "xxx":
        default:
          return il(nl.extended, r);
      }
    }
    set(r, n, i) {
      return n.timestampIsSet ? r : di(
        r,
        r.getTime() - b_(r) - i
      );
    }
  }
  class pTe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 40);
      ft(this, "incompatibleTokens", "*");
    }
    parse(r) {
      return DG(r);
    }
    set(r, n, i) {
      return [di(r, i * 1e3), { timestampIsSet: !0 }];
    }
  }
  class hTe extends Mr {
    constructor() {
      super(...arguments);
      ft(this, "priority", 20);
      ft(this, "incompatibleTokens", "*");
    }
    parse(r) {
      return DG(r);
    }
    set(r, n, i) {
      return [di(r, i), { timestampIsSet: !0 }];
    }
  }
  const vTe = {
    G: new MOe(),
    y: new NOe(),
    Y: new jOe(),
    R: new FOe(),
    u: new IOe(),
    Q: new BOe(),
    q: new LOe(),
    M: new $Oe(),
    L: new zOe(),
    w: new UOe(),
    I: new VOe(),
    d: new GOe(),
    D: new QOe(),
    E: new KOe(),
    e: new XOe(),
    c: new ZOe(),
    i: new eTe(),
    a: new tTe(),
    b: new rTe(),
    B: new nTe(),
    h: new iTe(),
    H: new aTe(),
    K: new oTe(),
    k: new uTe(),
    m: new sTe(),
    s: new lTe(),
    S: new cTe(),
    X: new fTe(),
    x: new dTe(),
    t: new pTe(),
    T: new hTe()
  }, mTe = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, yTe = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, gTe = /^'([^]*?)'?$/, xTe = /''/g, bTe = /\S/, wTe = /[a-zA-Z]/;
  function PG(e, t, r, n) {
    var S, k, D, A;
    const i = () => di(r, NaN), u = COe(), s = u.locale ?? EG, c = u.firstWeekContainsDate ?? ((k = (S = u.locale) == null ? void 0 : S.options) == null ? void 0 : k.firstWeekContainsDate) ?? 1, p = u.weekStartsOn ?? ((A = (D = u.locale) == null ? void 0 : D.options) == null ? void 0 : A.weekStartsOn) ?? 0;
    if (!t)
      return e ? i() : Rn(r, n == null ? void 0 : n.in);
    const h = {
      firstWeekContainsDate: c,
      weekStartsOn: p,
      locale: s
    }, v = [new POe(n == null ? void 0 : n.in, r)], y = t.match(yTe).map((R) => {
      const T = R[0];
      if (T in iN) {
        const M = iN[T];
        return M(R, s.formatLong);
      }
      return R;
    }).join("").match(mTe), x = [];
    for (let R of y) {
      TG(R) && aN(R, t, e), OG(R) && aN(R, t, e);
      const T = R[0], M = vTe[T];
      if (M) {
        const { incompatibleTokens: F } = M;
        if (Array.isArray(F)) {
          const V = x.find(
            (H) => F.includes(H.token) || H.token === T
          );
          if (V)
            throw new RangeError(
              `The format string mustn't contain \`${V.fullToken}\` and \`${R}\` at the same time`
            );
        } else if (M.incompatibleTokens === "*" && x.length > 0)
          throw new RangeError(
            `The format string mustn't contain \`${R}\` and any other token at the same time`
          );
        x.push({ token: T, fullToken: R });
        const B = M.run(
          e,
          R,
          s.match,
          h
        );
        if (!B)
          return i();
        v.push(B.setter), e = B.rest;
      } else {
        if (T.match(wTe))
          throw new RangeError(
            "Format string contains an unescaped latin alphabet character `" + T + "`"
          );
        if (R === "''" ? R = "'" : T === "'" && (R = ETe(R)), e.indexOf(R) === 0)
          e = e.slice(R.length);
        else
          return i();
      }
    }
    if (e.length > 0 && bTe.test(e))
      return i();
    const w = v.map((R) => R.priority).sort((R, T) => T - R).filter((R, T, M) => M.indexOf(R) === T).map(
      (R) => v.filter((T) => T.priority === R).sort((T, M) => M.subPriority - T.subPriority)
    ).map((R) => R[0]);
    let E = Rn(r, n == null ? void 0 : n.in);
    if (isNaN(+E)) return i();
    const C = {};
    for (const R of w) {
      if (!R.validate(E, h))
        return i();
      const T = R.set(E, C, h);
      Array.isArray(T) ? (E = T[0], Object.assign(C, T[1])) : E = T;
    }
    return E;
  }
  function ETe(e) {
    return e.match(gTe)[1].replace(xTe, "'");
  }
  function sU(e, t, r) {
    return rF(e, -7, r);
  }
  function STe(e, t, r) {
    return kCe(e, -1, r);
  }
  const lU = {
    yearly: {
      inputFormat: "yyyy-MM",
      tooltipFormat: "MMM yyyy",
      //'Feb 2024'
      xAxisFormat: "MMM"
    },
    monthly: {
      inputFormat: "yyyy-MM-dd",
      tooltipFormat: "dd MMM yyyy",
      // '12 Feb 2024'
      xAxisFormat: "d MMM"
    }
  }, uF = (e) => e === "year" ? lU.yearly : lU.monthly, _Te = (e, t, r) => {
    const { inputFormat: n, tooltipFormat: i } = uF(t), u = PG(e, n, /* @__PURE__ */ new Date()), s = r ? u : STe(u);
    return iF(s, i);
  }, CTe = (e, t) => {
    if (!fue(e)) return [];
    if (t === "year") {
      const p = [];
      for (const h of e)
        p.push(h.date);
      return p;
    }
    const r = e[e.length - 1];
    if (!r) return [];
    const n = new Date(e[0].date), i = new Date(r.date), u = [];
    u.push(i);
    let s = sU(i);
    for (; TOe(s, n); )
      u.unshift(s), s = sU(s);
    return u.unshift(n), u.map((p) => iF(p, uF(t).inputFormat));
  }, OTe = (e, t) => {
    const { inputFormat: r, xAxisFormat: n } = uF(t), i = PG(e, r, /* @__PURE__ */ new Date());
    return iF(i, n);
  }, cU = (e) => {
    const { currentPeriod: t, previousPeriod: r } = e, n = /* @__PURE__ */ new Map();
    for (const { year: i, month: u, visits: s } of r) {
      const c = `${i}-${u}`;
      n.set(c, s);
    }
    return t.map(({ year: i, month: u, visits: s }) => {
      const c = `${i - 1}-${u}`, p = `${i}-${String(u).padStart(2, "0")}`, h = n.get(c) ?? 0;
      return { date: p, visit: s, yearOnYearVisit: h };
    });
  }, TTe = (e) => {
    const { currentPeriod: t, previousPeriod: r } = e;
    return t.map(({ year: n, month: i, day: u, visits: s }, c) => {
      const p = r[c];
      return {
        date: `${n}-${String(i).padStart(2, "0")}-${String(u).padStart(2, "0")}`,
        visit: s,
        yearOnYearVisit: (p == null ? void 0 : p.visits) ?? 0
      };
    });
  }, ATe = () => {
    const e = [
      {
        label: "This year",
        color: oN.visit.color
      },
      {
        label: "YoY",
        color: oN.yearOnYearVisit.color
      }
    ];
    return /* @__PURE__ */ me.jsx("ul", { className: "mb-6 flex flex-row text-sm text-neutral-700 gap-9", children: e.map((t) => /* @__PURE__ */ me.jsxs("li", { className: "flex flex-row items-center gap-2", children: [
      /* @__PURE__ */ me.jsx(
        "span",
        {
          className: "inline-block w-3.5 h-3.5 rounded-[4px]",
          "data-testid": "visitation-report-legend-indicator",
          style: { backgroundColor: t.color }
        }
      ),
      /* @__PURE__ */ me.jsx("span", { className: "text-xs font-normal", "data-testid": "visitation-report-legend-label", children: t.label })
    ] }, t.label)) });
  }, DTe = (e, t) => (r) => {
    const { x: n, y: i, payload: u } = r, s = e(u.value, t);
    return /* @__PURE__ */ me.jsx("g", { transform: `translate(${n},${i})`, children: /* @__PURE__ */ me.jsx("text", { dy: 8, dx: -10, textAnchor: "start", className: "text-sm text-neutral-500", children: s }) });
  }, kTe = (e) => {
    const { x: t, y: r, payload: n } = e;
    return /* @__PURE__ */ me.jsx("g", { transform: `translate(${t},${r})`, children: /* @__PURE__ */ me.jsx("text", { dy: 0, textAnchor: "end", className: "text-sm text-neutral-500", children: n.value }) });
  }, RTe = (e) => ({ active: t, payload: r, label: n }) => !t || !r ? null : /* @__PURE__ */ me.jsx(
    "div",
    {
      className: "bg-white rounded-md border-1 border-neutral-200 p-2 text-xs flex flex-col gap-4",
      "data-testid": "visitation-report-tooltip-item",
      children: r.map((i) => {
        var u;
        return /* @__PURE__ */ me.jsxs("div", { className: "flex flex-col items-start justify-start text-neutral-900", children: [
          /* @__PURE__ */ me.jsx("p", { className: "font-bold mb-1.5", children: _Te(n, e, i.dataKey === "visit") }),
          /* @__PURE__ */ me.jsxs("div", { className: "flex flex-row items-center justify-start font-normal text-neutral-700", children: [
            /* @__PURE__ */ me.jsx("span", { className: "inline-block w-3.5 h-3.5 rounded-[4px] mr-2", style: { backgroundColor: i.color } }),
            /* @__PURE__ */ me.jsx("span", { className: "mr-8", children: "Visits" }),
            /* @__PURE__ */ me.jsx("span", { children: (u = i.value) == null ? void 0 : u.toLocaleString() })
          ] })
        ] }, i.dataKey);
      })
    }
  ), oN = {
    visit: {
      color: "var(--color-purple-600)"
    },
    yearOnYearVisit: {
      color: "var(--color-neutral-400)"
    },
    axis: {
      color: "var(--color-neutral-400)"
    },
    cartesian: {
      color: "var(--color-neutral-300)"
    },
    tooltipBorder: {
      color: "var(--color-neutral-200)"
    }
  }, PTe = ({ data: { chartData: e, range: t }, showYearOnYear: r }) => {
    const n = ee.useRef(!1), i = () => {
      n.current = !0;
    };
    return /* @__PURE__ */ me.jsxs(me.Fragment, { children: [
      /* @__PURE__ */ me.jsx(ATe, {}),
      /* @__PURE__ */ me.jsx(KY, { "aria-label": "visit trends line chart", config: oN, className: "h-85 w-full", children: /* @__PURE__ */ me.jsxs(
        T_e,
        {
          accessibilityLayer: !0,
          data: e,
          margin: {
            left: 0,
            right: 10,
            top: 5,
            bottom: 0
          },
          children: [
            /* @__PURE__ */ me.jsx(MY, { stroke: "var(--color-cartesian)", vertical: !1 }),
            /* @__PURE__ */ me.jsx(os, { content: RTe(t), cursor: !1 }),
            /* @__PURE__ */ me.jsx(
              tm,
              {
                dataKey: "date",
                tickLine: !1,
                tickMargin: 8,
                stroke: "var(--color-axis)",
                tick: DTe(OTe, t),
                ticks: CTe(e, t),
                interval: t === "year" ? 0 : void 0
              }
            ),
            /* @__PURE__ */ me.jsx(rm, { stroke: "var(--color-axis)", tickLine: !1, tickMargin: 8, tick: kTe }),
            r && /* @__PURE__ */ me.jsx(
              k0,
              {
                dataKey: "yearOnYearVisit",
                type: "monotone",
                stroke: "var(--color-yearOnYearVisit)",
                strokeWidth: 2,
                dot: !1,
                isAnimationActive: !n.current,
                onAnimationEnd: i,
                animationDuration: 1e3
              },
              "yearOnYearVisit"
            ),
            /* @__PURE__ */ me.jsx(
              k0,
              {
                dataKey: "visit",
                type: "monotone",
                stroke: "var(--color-visit)",
                strokeWidth: 2,
                dot: !1,
                z: 2,
                isAnimationActive: !n.current,
                onAnimationEnd: i,
                animationDuration: 1e3
              },
              "visit"
            )
          ]
        }
      ) })
    ] });
  }, MTe = ({ lastTwelveMonths: e, lastMonth: t }) => {
    const [r, n] = ee.useState(!0), [i, u] = ee.useState(() => ({
      range: "year",
      chartData: cU(e)
    })), s = (p) => {
      if (p === "" || p === i.range)
        return;
      const h = p === "year" ? cU(e) : TTe(t);
      u({
        range: p,
        chartData: h
      });
    }, c = (p) => {
      n(p);
    };
    return /* @__PURE__ */ me.jsxs(me.Fragment, { children: [
      /* @__PURE__ */ me.jsxs("div", { className: "flex flex-row items-center justify-start gap-x-5 mb-6", children: [
        /* @__PURE__ */ me.jsx(
          bCe,
          {
            value: i.range,
            items: [
              {
                value: "month",
                label: "Monthly"
              },
              {
                value: "year",
                label: "Yearly"
              }
            ],
            onValueChange: s
          }
        ),
        /* @__PURE__ */ me.jsxs("div", { className: "flex flex-row items-center justify-start gap-x-3", children: [
          /* @__PURE__ */ me.jsx(
            Q_e,
            {
              id: "visitation-report-year-on-year-switch",
              checked: r,
              onCheckedChange: c
            }
          ),
          /* @__PURE__ */ me.jsx("label", { htmlFor: "visitation-report-year-on-year-switch", className: "text-sm font-normal", children: "Year-on-year" })
        ] })
      ] }),
      /* @__PURE__ */ me.jsx(PTe, { showYearOnYear: r, data: i })
    ] });
  }, NTe = s0`
  query GET_FACILITY_VISITATIONS {
    currentUser {
      facilities {
        visitAggregates {
          averageVisitsPerDay {
            visits
            percentageChangeYearOnYear
          }
          lastMonth {
            currentPeriod {
              day
              month
              year
              visits
            }
            previousPeriod {
              day
              month
              year
              visits
            }
          }
          lastTwelveMonths {
            currentPeriod {
              month
              year
              visits
            }
            previousPeriod {
              month
              year
              visits
            }
          }
          mostPopularDay {
            day
            dayOfWeekNumber
            visits
          }
          mostPopularHour {
            hour
            visits
          }
          totalVisitsThisMonth {
            visits
            percentageChangeYearOnYear
          }
        }
      }
    }
  }
`, jTe = () => {
    var i, u, s;
    const { data: e, loading: t, error: r } = Die(NTe);
    return { visitAggregates: (s = (u = (i = e == null ? void 0 : e.currentUser) == null ? void 0 : i.facilities) == null ? void 0 : u[0]) == null ? void 0 : s.visitAggregates, loading: t, error: r };
  }, FTe = () => /* @__PURE__ */ me.jsxs(
    "div",
    {
      className: "flex flex-row justify-start items-center rounded-none border-0 border-l-4 border-destructive-500 p-4 w-full gap-3 rounded-tr-[8px] rounded-br-[8px] bg-destructive-50",
      "data-testid": "visitation-report-error",
      children: [
        /* @__PURE__ */ me.jsx(nue, { "data-testid": "alert-icon", className: "h-5 w-5 self-center stroke-destructive-500" }),
        /* @__PURE__ */ me.jsx("p", { className: "text-base font-medium tracking-[0px] text-destructive-600", children: "We're unable to fetch the facility visitation data, please try again." })
      ]
    }
  ), ITe = () => /* @__PURE__ */ me.jsxs("div", { className: "flex flex-col w-full items-center justify-center py-6", "data-testid": "visitation-report-loading", children: [
    /* @__PURE__ */ me.jsx(uue, { className: "h-12 w-12 text-neutral-500 animate-spin stroke-1 mb-4" }),
    /* @__PURE__ */ me.jsx("p", { className: "text-base tracking-[0px] font-medium text-neutral-600", children: "fetching facility data..." })
  ] }), BTe = ({ pastReportsUrl: e }) => {
    const { visitAggregates: t, loading: r, error: n } = jTe();
    if (r) return /* @__PURE__ */ me.jsx(ITe, {});
    if (n || !t)
      return console.error(
        "Failed to load visitation report data",
        n || {
          message: "Missing visitAggregates without Apollo error"
        }
      ), /* @__PURE__ */ me.jsx(FTe, {});
    const i = "Based on last 30 days of data received";
    return /* @__PURE__ */ me.jsxs("div", { className: "max-w-258 mx-auto pt-6 pb-24", children: [
      /* @__PURE__ */ me.jsx("h1", { className: "text-4xl text-neutral-900 mb-6", children: "Visits" }),
      /* @__PURE__ */ me.jsx("section", { className: "mb-24", children: /* @__PURE__ */ me.jsx(MTe, { lastTwelveMonths: t.lastTwelveMonths, lastMonth: t.lastMonth }) }),
      /* @__PURE__ */ me.jsxs("section", { className: "mb-24", children: [
        /* @__PURE__ */ me.jsx("h2", { className: "text-3xl text-neutral-900 mb-6", children: "Trends" }),
        /* @__PURE__ */ me.jsxs("div", { className: "grid grid-cols-2 gap-6", children: [
          /* @__PURE__ */ me.jsx(
            Y3,
            {
              title: "Average daily visits",
              description: i,
              visitsCount: t.averageVisitsPerDay.visits,
              percentChangeYoY: t.averageVisitsPerDay.percentageChangeYearOnYear
            }
          ),
          /* @__PURE__ */ me.jsx(
            Y3,
            {
              title: "Total visits this month",
              description: i,
              visitsCount: t.totalVisitsThisMonth.visits,
              percentChangeYoY: t.totalVisitsThisMonth.percentageChangeYearOnYear
            }
          ),
          /* @__PURE__ */ me.jsx(I_e, { data: pue(t.mostPopularDay) }),
          /* @__PURE__ */ me.jsx($_e, { data: t.mostPopularHour })
        ] })
      ] }),
      /* @__PURE__ */ me.jsxs("section", { children: [
        /* @__PURE__ */ me.jsx("h3", { className: "text-2xl text-neutral-900 mb-6", children: "Past visitation reports" }),
        /* @__PURE__ */ me.jsx(
          "a",
          {
            href: e,
            target: "_blank",
            className: "inline-block text-base font-bold text-primary-600 px-4 py-2 border-1 rounded-3xl border-primary-600 hover:text-primary-700 hover:border-primary-700",
            children: "View your past end-of-month visitation reports"
          }
        )
      ] })
    ] });
  }, LTe = (e, t = !1) => (t || (Yie(), Gie()), new A9({
    uri: e,
    cache: new S9(),
    headers: {
      Authorization: `Bearer ${soe()}`
    }
  })), $Te = ({ pastReportsUrl: e, environment: t = "development" }) => {
    const r = ee.useMemo(() => {
      const n = hue(t);
      return LTe(n, t === "prod");
    }, [t]);
    return /* @__PURE__ */ me.jsx(wie, { client: r, children: /* @__PURE__ */ me.jsx(BTe, { pastReportsUrl: e }) });
  }, zTe = Uee($Te, {
    props: {
      pastReportsUrl: "string",
      environment: "string"
    }
  });
  customElements.define("visitation-report", zTe);
});
export default qTe();
